import DateTimeInput from "../../atoms/Calendar/DateTimeInput";
import { ComboBoxItemTypeS } from "../../atoms/ComboBox/ItemComboBoxStr"
import dayjs from 'dayjs';

import { LogD } from "../../../function/LogLapper";

export const MAN_STAT = {
    /** 収集中 */
    Collection: 64,
    /** リトライ中 */
    Retry: 128,
}

export type ComboItem = {
    Key: number;
    Disp: string;
    Tag?: any; //付加情報
}

export type V_PARTIAL_DISCHARGE_STATUS_ITEM = {
    /**PLC NOを取得 */
    PLC_NO: number;

    /**SET_NOを取得 */
    SET_NO: number;

    /**機器 INDEX を取得 */
    DEV_INDEX: number;

    /**機器番号・名称を取得 */
    Dev_NoName: string;

    /**機器を取得または設定 */
    DEV_NAME: string;

    /**収集開始時刻を取得(自動or手動) */
    Coldate?: Date;

    /**手動収集開始時刻を取得 */
    MAN_COLDATE?: Date;

    /**次回収集開始時刻を取得 */
    AUTO_NEXTDATE?: Date;

    /**状態を取得 */
    StatNo: number;

    /**手動収集の状態を取得 */
    Man_ColStatNo: number;

    /**手動収集ボタンの状態 */
    manualButtonStat: number;
};

/**
 * 部分放電グラフアイテム
 */
export type PartialDischargeGraphXYDataModel = {
    /**X軸値 */
    XValue?: number;
    /**Y軸値 */
    YValue?: number;
    /**ドットサイズ */
    Size?: number;
}

/**
 * 部分放電グラフ画面　グラフアイテム
 */
export type PartialDischargeGraphDataModel = {
    /**位相特性グラフリスト */
    PhaseCharacteristicsGraphList: PartialDischargeGraphXYDataModel[];
    /**累積頻度グラフリスト */
    CumulativeFrequencyGraphList: PartialDischargeGraphXYDataModel[];
    /**PD 強度 */
    MeasureValue: number;
}

/** レスポンス情報 */
export type ResponceDataType = {
    ResponseCode: number;
    ErrorCode: number;
    ResponseMessage: string;
    ErrorMessage: string;
};

export type PartialDischargeStatusModel = {
    PartialDischargeStatusItems: V_PARTIAL_DISCHARGE_STATUS_ITEM[],
    ResponceData: ResponceDataType
}

/**
 * 部分放電グラフ画面　機器情報一覧
 */
export type PartialDischargeGraphDevItemsModel = {
    /**機器番号・機器名称のリスト */
    NameDevSetLists: ComboItem[];
    /**エラー情報 */
    ResponceData: ResponceDataType;
}

/**
 * 部分放電グラフ画面　計測日の時間リスト
 */
export type PartialDischargeGraphDateItemModel = {
    /**時間リスト取得 */
    DateTimeList: string[];
    /**エラー情報 */
    ResponceData: ResponceDataType;
}

export type SelectDataType = {
    /**選択機器番号 */
    devIndex: number;
    /**選択日時 */
    selectDate: string;
    /**選択時間 */
    selectTime: string;
    /**表示時間 */
    viwTime: number;
}

export type SeectViewTimeType = {
    itemNo: number;
    selectViwTime: string;
}

/**
 * 部分放電 情報一覧表示 データ取得
 * @returns 
 */
export const GetPartialDischargeStatusData = (): Promise<PartialDischargeStatusModel> => {
    return new Promise((resolve, reject) => {
        fetch("api/PartialDischargeStatus/")
            .then((res) => {
                console.debug(["res", res]);
                if (!res.ok) {
                    let message = `データが見つかりませんでした status:${res.status}`;
                    console.debug(["message", message]);
                    throw new Error(message);
                }
                else {
                    console.debug(["res.json", res]);
                    return res.json();
                }
            })
            .then((result: PartialDischargeStatusModel) => {
                console.debug(["then result", result]);
                if (result != null) {
                    if (result !== null) {
                        console.debug(["GetPartialDischargeStatusData - ok", result]);
                    }
                    resolve(result);
                }
                else {
                    console.debug(["Invalidate response", result]);
                    reject('Invalidate response');
                }
            })
            .catch((error) => {
                console.debug(["error", error]);
                console.error(error.status);
                console.error(error);
                reject(error);
            })
    })
};
/**
 * 部分放電 情報一覧表示 手動操作
 * @param statusItem 
 * @returns 
 */
export const PutPartialDischargeStatusData = (statusItem: V_PARTIAL_DISCHARGE_STATUS_ITEM): Promise<ResponceDataType> => {
    return new Promise((resolve, reject) => {
        fetch("api/PartialDischargeStatus", {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(statusItem),
        })
            .then((res) => {
                if (!res.ok) {
                    let message = `データが見つかりませんでした status:${res.status}`;
                    reject(message);
                }
                return res.json();
            })
            .then((result: ResponceDataType) => {
                console.debug(["PutPartialDischargeCollectionData - result ", result])
                resolve(result);
            })
            .catch((error) => {
                console.debug(["error", error]);
                console.error(error.status);
                console.error(error);
                reject(error);
            })
    });
}

/**
 * 部分放電グラフ 機器情報取得
 * @returns 
 */
export const GetPartialDischargeGraphDevListData = (): Promise<PartialDischargeGraphDevItemsModel> => {
    return new Promise((resolve, reject) => {
        fetch("api/PartialDischargeGraph/GetPartialDischargeGraphDevListData")  //GetPartialDischargeGraphDevListData
            .then((res) => {
                console.debug(["res", res]);
                if (!res.ok) {
                    let message = `データが見つかりませんでした status:${res.status}`;
                    console.debug(["message", message]);
                    throw new Error(message);
                }
                else {
                    console.debug(["res.json", res]);
                    return res.json();
                }
            })
            .then((result: PartialDischargeGraphDevItemsModel) => {
                console.debug(["then result", result]);
                if (result != null) {
                    if (result !== null) {
                        console.debug(["GetPartialDischargeGraphDevListData - ok", result]);
                    }
                    resolve(result);
                }
                else {
                    console.debug(["Invalidate response", result]);
                    reject('Invalidate response');
                }
            })
            .catch((error) => {
                console.debug(["error", error]);
                console.error(error.status);
                console.error(error);
                reject(error);
            })
    })

};

/**
 * 部分放電グラフ datファイルの存在する時間リストを取得
 * @param devIndex 
 * @param targetDay 
 * @returns 
 */
export const GetDataTimeList = (devIndex: number, targetDay: string): Promise<PartialDischargeGraphDateItemModel> => {
    return new Promise((resolve, reject) => {
        const url = "api/PartialDischargeGraph/GetDataTimeList";
        const param = `?devIndex=${devIndex}&targetTime=${targetDay}`;
        //console.debug(url + param);
        fetch(url + param)
            .then((res) => res.json())
            .then((result: PartialDischargeGraphDateItemModel) => {
                //console.debug(['result', result]);
                if (TimeListValidate(result.DateTimeList)) resolve(result);
                reject('Invalidate response');
            },
                (error) => {
                    console.debug(["error", error]);
                    console.error(error.status);
                    console.error(error);
                    reject(error);
                }
            );
    });
};

const TimeListValidate = (data: string[]) => {
    LogD(`GetTimeListValidate ckeck ${data}`, true);
    if (data == undefined) return false;
    LogD("GetTimeListValidate ckeck ok", true);
    return true;
};

/**
 * 部分放電グラフ datファイルの存在する時間リストを取得
 * @param devIndex 
 * @returns 
 */
export const GetLatesTime = (devIndex: number): Promise<PartialDischargeGraphDateItemModel> => {
    return new Promise((resolve, reject) => {
        const url = "api/PartialDischargeGraph/GetDataLatesTime";
        const param = `?devIndex=${devIndex}`;
        console.debug(url + param);
        fetch(url + param)
            .then((res) => res.json())
            .then((result: PartialDischargeGraphDateItemModel) => {
                console.debug(result);
                    if (LatesTimeValidate(result.DateTimeList)) resolve(result);
                
                reject('Invalidate response');
            },
                (error) => {
                    console.debug(["error", error]);
                    console.error(error.status);
                    console.error(error);
                    reject(error);
                }
            );
    });
};

const LatesTimeValidate = (data: string[]) => {
    console.debug("LatesTimeValidate ckeck");
    if (data == undefined) return false;
    LogD("LatesTimeValidate ckeck ok", true);
    return true;
};

/**
 * 部分放電グラフ グラフデータ取得
 * @param devIndex 
 * @param targetDay 
 * @param targetDate 
 * @returns 
 */
export const GetPartialDischargeGraphItemData = (devIndex: number, targetDay: string, measureTime: number): Promise<PartialDischargeGraphDataModel> => {
    return new Promise((resolve, reject) => {
        const url = "api/PartialDischargeGraph/GetPartialDischargeGraphItemData";
        const param = `?devIndex=${devIndex}&targetTime=${targetDay}&measureTime=${measureTime}`;
        console.debug(url + param);
        fetch(url + param)
            .then((res) => res.json())
            .then((result: PartialDischargeGraphDataModel) => {
                console.debug(result);
                if (result != null) {
                    if (result !== null) {
                        console.debug(["GetPartialDischargeGraphItemData - ok", result]);
                    }
                    resolve(result);
                }
                else {
                    console.debug(["Invalidate response", result]);
                    reject('Invalidate response');
                }
            },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
    });



};



/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param settings FileTimeリスト
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateTimeCombBoxItems = (fileTimes: Date[]): ComboBoxItemTypeS[] => {
    let comboItems: ComboBoxItemTypeS[] = [];

    fileTimes.forEach((r) => {
        const item: ComboBoxItemTypeS = {
            key: dayjs(r).format('HH:mm:ss'),
            name: dayjs(r).format('HH:mm:ss')
        }
        comboItems.push(item);
    });

    return comboItems;
};

/**
* 手動収集の状態を取得
* @param stat 
*/
export const GetManCollectionStat = (rowList: V_PARTIAL_DISCHARGE_STATUS_ITEM[], row: V_PARTIAL_DISCHARGE_STATUS_ITEM): number => {
    console.debug(["GetManCollectionStat1", row]);
    if(row.StatNo === -1){
        //不明
        return -1;
    }
    if (row.Man_ColStatNo === MAN_STAT.Collection || row.Man_ColStatNo === MAN_STAT.Retry) {
        //収集中
        return 0;
    }
    else {
        let tempList = rowList
            .filter((r) => r.SET_NO !== row.SET_NO)
            .filter((r) => r.Man_ColStatNo === MAN_STAT.Collection
                || r.Man_ColStatNo === MAN_STAT.Retry
                )
        if (tempList.length !== 0) {
            //開始(ラベル)
            return 2;
        }
        else {
            //開始(ボタン)
            return 3;
        }
    }
}

/**
 * ボタン押下した行以外を開始(ラベル)に変更
 * @param rowList 
 * @param row 
 * @returns 
 */
export const ChangeMancollectionStat = (rowList: V_PARTIAL_DISCHARGE_STATUS_ITEM[], row: V_PARTIAL_DISCHARGE_STATUS_ITEM): V_PARTIAL_DISCHARGE_STATUS_ITEM[] => {
    let retList: V_PARTIAL_DISCHARGE_STATUS_ITEM[] = [];
    rowList.forEach((r) => {
        if (r.SET_NO !== row.SET_NO) {
            r.manualButtonStat = 2;
        }
        retList.push(r);
    })
    return retList;
}

/**
* 手動収集要求日時チェック
* @param setNo 
* @param requestManualCollectionDateTime 
*/
export const CheckManualTime = (rowList: V_PARTIAL_DISCHARGE_STATUS_ITEM[], setNo: number, requestManualCollectionDateTime?: Date) => {
    if (requestManualCollectionDateTime !== undefined) {
        let rowData = rowList.find((r) => r.SET_NO === setNo);
        if (rowData !== undefined) {
            //MAN_CODATEがnullでないかつ、RequestManualCollectionDateTimeよりMAN_CODATEの方が後の時間の場合
            if (rowData.MAN_COLDATE !== undefined && requestManualCollectionDateTime !== undefined) {
                if (rowData.MAN_COLDATE > requestManualCollectionDateTime) {
                    requestManualCollectionDateTime = undefined;
                }
            }
            if (rowData.Man_ColStatNo === MAN_STAT.Retry) {
                requestManualCollectionDateTime = undefined;
            }
            if (requestManualCollectionDateTime !== undefined) {
                requestManualCollectionDateTime.setSeconds(requestManualCollectionDateTime.getSeconds() + 30)
                if (requestManualCollectionDateTime < new Date) {
                    requestManualCollectionDateTime = undefined;
                }
            }
        }
    }

}

/**
*  部分放電グラフ 時間コンボボックス更新
*/
export const upDateSelectTimeList = (selectTime: string): ComboBoxItemTypeS => {
    let selectDateList: ComboBoxItemTypeS;

    if (selectTime == "") {
        selectDateList = ({ key: "", name: "" })
    } else {
        selectDateList = ({
            key: dayjs(new Date(selectTime)).format('HH:mm:ss'),
            name: dayjs(new Date(selectTime)).format('HH:mm:ss')
        });
    }
    return selectDateList;
};

// export const graphTestData = [
    //     { x: 3.56862745098039, y: 27295 },
    //     { x: 3.72549019607843, y: 25873 },
    //     { x: 3.49019607843137, y: 19991 },
    //     { x: 3.64705882352941, y: 30124 },
    //     { x: 3.84313725490196, y: 10682 },
    //     { x: 3.92156862745098, y: 5265 },
    //     { x: 4, y: 2083 },
    //     { x: 3.68627450980392, y: 30096 },
    //     { x: 3.80392156862745, y: 13557 },
    //     { x: 3.76470588235294, y: 19702 },
    //     { x: 3.6078431372549, y: 31988 },
    //     { x: 3.29411764705882, y: 6234 },
    //     { x: 3.37254901960784, y: 10241 },
    //     { x: 3.33333333333333, y: 6816 },
    //     { x: 3.01960784313725, y: 1192 },
    //     { x: 3.09803921568627, y: 1952 },
    //     { x: 3.25490196078431, y: 3926 },
    //     { x: 3.45098039215686, y: 16863 },
    //     { x: 3.52941176470588, y: 26676 },
    //     { x: 2.70588235294118, y: 315 },
    //     { x: 2.82352941176471, y: 544 },
    //     { x: 2.94117647058824, y: 754 },
    //     { x: 3.41176470588235, y: 12044 },
    //     { x: 3.88235294117647, y: 7169 },
    //     { x: 3.96078431372549, y: 2964 },
    //     { x: 3.2156862745098, y: 3705 },
    //     { x: 4.11764705882353, y: 381 },
    //     { x: 4.03921568627451, y: 1225 },
    //     { x: 3.17647058823529, y: 2879 },
    //     { x: 2.50980392156863, y: 187 },
    //     { x: 1.92156862745098, y: 32 },
    //     { x: 2.19607843137255, y: 57 },
    //     { x: 2.07843137254902, y: 22 },
    //     { x: 3.05882352941176, y: 1535 },
    //     { x: 2.90196078431373, y: 731 },
    //     { x: 2.86274509803922, y: 545 },
    //     { x: 2.74509803921569, y: 356 },
    //     { x: 2.35294117647059, y: 115 },
    //     { x: 2.43137254901961, y: 142 },
    //     { x: 2.31372549019608, y: 69 },
    //     { x: 3.13725490196078, y: 2381 },
    //     { x: 2.66666666666667, y: 275 },
    //     { x: 2.3921568627451, y: 113 },
    //     { x: 2.47058823529412, y: 132 },
    //     { x: 2.98039215686275, y: 1168 },
    //     { x: 4.07843137254902, y: 743 },
    //     { x: 2.7843137254902, y: 432 },
    //     { x: 2.54901960784314, y: 179 },
    //     { x: 2.62745098039216, y: 247 },
    //     { x: 1.88235294117647, y: 30 },
    //     { x: 2.58823529411765, y: 210 },
    //     { x: 2.11764705882353, y: 60 },
    //     { x: 2.03921568627451, y: 35 },
    //     { x: 1.2156862745098, y: 10 },
    //     { x: 1.96078431372549, y: 36 },
    //     { x: 2.15686274509804, y: 65 },
    //     { x: 2.27450980392157, y: 62 },
    //     { x: 2.23529411764706, y: 46 },
    //     { x: 1.05882352941176, y: 3 },
    //     { x: 1.01960784313725, y: 9 },
    //     { x: 0.980392156862745, y: 4 },
    //     { x: 1.68627450980392, y: 15 },
    //     { x: 1.84313725490196, y: 23 },
    //     { x: 4.15686274509804, y: 228 },
    //     { x: 1.64705882352941, y: 15 },
    //     { x: 1.6078431372549, y: 7 },
    //     { x: 1.37254901960784, y: 11 },
    //     { x: 1.41176470588235, y: 13 },
    //     { x: 1.25490196078431, y: 7 },
    //     { x: 4.23529411764706, y: 89 },
    //     { x: 2, y: 26 },
    //     { x: 1.72549019607843, y: 16 },
    //     { x: 1.56862745098039, y: 12 },
    //     { x: 1.80392156862745, y: 14 },
    //     { x: 1.76470588235294, y: 16 },
    //     { x: 4.19607843137255, y: 124 },
    //     { x: 1.49019607843137, y: 18 },
    //     { x: 4.31372549019608, y: 14 },
    //     { x: 0.666666666666667, y: 2 },
    //     { x: 0.509803921568627, y: 1 },
    //     { x: 0.901960784313726, y: 3 },
    //     { x: 4.27450980392157, y: 37 },
    //     { x: 1.45098039215686, y: 8 },
    //     { x: 1.17647058823529, y: 7 },
    //     { x: 1.52941176470588, y: 8 },
    //     { x: 1.33333333333333, y: 6 },
    //     { x: 0.784313725490196, y: 4 },
    //     { x: 0.627450980392157, y: 2 },
    //     { x: 1.09803921568627, y: 4 },
    //     { x: 1.29411764705882, y: 5 },
    //     { x: 4.35294117647059, y: 10 },
    //     { x: 1.13725490196078, y: 7 },
    //     { x: 0.823529411764706, y: 2 },
    //     { x: 0.862745098039216, y: 3 },
    //     { x: 0.705882352941177, y: 1 },
    //     { x: 4.3921568627451, y: 4 },
    //     { x: 0.941176470588235, y: 3 },
    //     { x: 4.43137254901961, y: 1 },
    // ];


    // export  const graphTestData2 = [
    //     { x: 0, y: 3.64705882352941, size: 1 },
    //     { x: 0.647482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 1.29496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 1.94244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 2.58992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 3.23741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 3.88489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 4.53237410071942, y: 3.76470588235294, size: 1 },
    //     { x: 5.17985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 5.8273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 6.47482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 7.12230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 7.76978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 8.41726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 9.06474820143885, y: 3.84313725490196, size: 1 },
    //     { x: 9.71223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 10.3597122302158, y: 3.6078431372549, size: 1 },
    //     { x: 11.0071942446043, y: 3.29411764705882, size: 1 },
    //     { x: 11.6546762589928, y: 3.37254901960784, size: 1 },
    //     { x: 12.3021582733813, y: 3.33333333333333, size: 1 },
    //     { x: 12.9496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 13.5971223021583, y: 3.09803921568627, size: 1 },
    //     { x: 14.2446043165468, y: 3.64705882352941, size: 1 },
    //     { x: 14.8920863309353, y: 3.72549019607843, size: 1 },
    //     { x: 15.5395683453237, y: 3.49019607843137, size: 1 },
    //     { x: 16.1870503597122, y: 3.68627450980392, size: 1 },
    //     { x: 16.8345323741007, y: 3.25490196078431, size: 1 },
    //     { x: 17.4820143884892, y: 3.72549019607843, size: 1 },
    //     { x: 18.1294964028777, y: 3.68627450980392, size: 1 },
    //     { x: 18.7769784172662, y: 3.45098039215686, size: 1 },
    //     { x: 19.4244604316547, y: 3.6078431372549, size: 1 },
    //     { x: 20.0719424460432, y: 3.49019607843137, size: 1 },
    //     { x: 20.7194244604317, y: 3.64705882352941, size: 1 },
    //     { x: 21.3669064748201, y: 3.33333333333333, size: 1 },
    //     { x: 22.0143884892086, y: 3.68627450980392, size: 1 },
    //     { x: 22.6618705035971, y: 3.6078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 3.45098039215686, size: 1 },
    //     { x: 23.9568345323741, y: 3.33333333333333, size: 1 },
    //     { x: 24.6043165467626, y: 3.6078431372549, size: 1 },
    //     { x: 25.2517985611511, y: 3.45098039215686, size: 1 },
    //     { x: 25.8992805755396, y: 3.45098039215686, size: 1 },
    //     { x: 26.5467625899281, y: 3.64705882352941, size: 1 },
    //     { x: 27.1942446043165, y: 3.56862745098039, size: 1 },
    //     { x: 27.841726618705, y: 3.52941176470588, size: 1 },
    //     { x: 28.4892086330935, y: 3.72549019607843, size: 1 },
    //     { x: 29.136690647482, y: 3.68627450980392, size: 1 },
    //     { x: 29.7841726618705, y: 3.49019607843137, size: 1 },
    //     { x: 30.431654676259, y: 3.45098039215686, size: 1 },
    //     { x: 31.0791366906475, y: 3.45098039215686, size: 1 },
    //     { x: 31.726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 32.3741007194245, y: 3.52941176470588, size: 1 },
    //     { x: 33.0215827338129, y: 3.29411764705882, size: 1 },
    //     { x: 33.6690647482014, y: 3.49019607843137, size: 1 },
    //     { x: 34.3165467625899, y: 2.70588235294118, size: 1 },
    //     { x: 34.9640287769784, y: 2.82352941176471, size: 1 },
    //     { x: 35.6115107913669, y: 2.94117647058824, size: 1 },
    //     { x: 36.2589928057554, y: 2.94117647058824, size: 1 },
    //     { x: 36.9064748201439, y: 3.09803921568627, size: 1 },
    //     { x: 37.5539568345324, y: 3.76470588235294, size: 1 },
    //     { x: 38.2014388489209, y: 3.6078431372549, size: 1 },
    //     { x: 38.8489208633094, y: 3.52941176470588, size: 1 },
    //     { x: 39.4964028776978, y: 3.37254901960784, size: 1 },
    //     { x: 40.1438848920863, y: 3.52941176470588, size: 1 },
    //     { x: 40.7913669064748, y: 3.52941176470588, size: 1 },
    //     { x: 41.4388489208633, y: 3.37254901960784, size: 1 },
    //     { x: 42.0863309352518, y: 3.45098039215686, size: 1 },
    //     { x: 42.7338129496403, y: 3.45098039215686, size: 1 },
    //     { x: 43.3812949640288, y: 3.56862745098039, size: 1 },
    //     { x: 44.0287769784173, y: 3.6078431372549, size: 1 },
    //     { x: 44.6762589928058, y: 3.68627450980392, size: 1 },
    //     { x: 45.3237410071942, y: 3.68627450980392, size: 1 },
    //     { x: 45.9712230215827, y: 3.41176470588235, size: 1 },
    //     { x: 46.6187050359712, y: 3.49019607843137, size: 1 },
    //     { x: 47.2661870503597, y: 3.56862745098039, size: 1 },
    //     { x: 47.9136690647482, y: 3.37254901960784, size: 1 },
    //     { x: 48.5611510791367, y: 3.41176470588235, size: 1 },
    //     { x: 49.2086330935252, y: 3.45098039215686, size: 1 },
    //     { x: 49.8561151079137, y: 3.49019607843137, size: 1 },
    //     { x: 50.5035971223022, y: 3.56862745098039, size: 1 },
    //     { x: 51.1510791366906, y: 3.49019607843137, size: 1 },
    //     { x: 51.7985611510791, y: 3.52941176470588, size: 1 },
    //     { x: 52.4460431654676, y: 3.49019607843137, size: 1 },
    //     { x: 53.0935251798561, y: 3.72549019607843, size: 1 },
    //     { x: 53.7410071942446, y: 3.52941176470588, size: 1 },
    //     { x: 54.3884892086331, y: 3.92156862745098, size: 1 },
    //     { x: 55.0359712230216, y: 3.92156862745098, size: 1 },
    //     { x: 55.6834532374101, y: 3.88235294117647, size: 1 },
    //     { x: 56.3309352517986, y: 3.68627450980392, size: 1 },
    //     { x: 56.9784172661871, y: 3.76470588235294, size: 1 },
    //     { x: 57.6258992805755, y: 3.76470588235294, size: 1 },
    //     { x: 58.273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 58.9208633093525, y: 3.64705882352941, size: 1 },
    //     { x: 59.568345323741, y: 3.76470588235294, size: 1 },
    //     { x: 60.2158273381295, y: 3.80392156862745, size: 1 },
    //     { x: 60.863309352518, y: 3.76470588235294, size: 1 },
    //     { x: 61.5107913669065, y: 3.96078431372549, size: 1 },
    //     { x: 62.158273381295, y: 3.6078431372549, size: 1 },
    //     { x: 62.8057553956835, y: 3.6078431372549, size: 1 },
    //     { x: 63.4532374100719, y: 3.92156862745098, size: 1 },
    //     { x: 64.1007194244604, y: 3.92156862745098, size: 1 },
    //     { x: 64.7482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 65.3956834532374, y: 3.76470588235294, size: 1 },
    //     { x: 66.0431654676259, y: 3.96078431372549, size: 1 },
    //     { x: 66.6906474820144, y: 3.88235294117647, size: 1 },
    //     { x: 67.3381294964029, y: 3.56862745098039, size: 1 },
    //     { x: 67.9856115107914, y: 3.92156862745098, size: 1 },
    //     { x: 68.6330935251799, y: 3.88235294117647, size: 1 },
    //     { x: 69.2805755395683, y: 4, size: 1 },
    //     { x: 69.9280575539568, y: 3.64705882352941, size: 1 },
    //     { x: 70.5755395683453, y: 3.72549019607843, size: 1 },
    //     { x: 71.2230215827338, y: 3.68627450980392, size: 1 },
    //     { x: 71.8705035971223, y: 3.72549019607843, size: 1 },
    //     { x: 72.5179856115108, y: 4, size: 1 },
    //     { x: 73.1654676258993, y: 3.68627450980392, size: 1 },
    //     { x: 73.8129496402878, y: 3.76470588235294, size: 1 },
    //     { x: 74.4604316546763, y: 3.72549019607843, size: 1 },
    //     { x: 75.1079136690647, y: 3.76470588235294, size: 1 },
    //     { x: 75.7553956834532, y: 3.76470588235294, size: 1 },
    //     { x: 76.4028776978417, y: 3.84313725490196, size: 1 },
    //     { x: 77.0503597122302, y: 3.49019607843137, size: 1 },
    //     { x: 77.6978417266187, y: 3.37254901960784, size: 1 },
    //     { x: 78.3453237410072, y: 3.72549019607843, size: 1 },
    //     { x: 78.9928057553957, y: 3.68627450980392, size: 1 },
    //     { x: 79.6402877697842, y: 3.80392156862745, size: 1 },
    //     { x: 80.2877697841727, y: 3.88235294117647, size: 1 },
    //     { x: 80.9352517985612, y: 3.76470588235294, size: 1 },
    //     { x: 81.5827338129496, y: 3.72549019607843, size: 1 },
    //     { x: 82.2302158273381, y: 3.68627450980392, size: 1 },
    //     { x: 82.8776978417266, y: 3.76470588235294, size: 1 },
    //     { x: 83.5251798561151, y: 3.72549019607843, size: 1 },
    //     { x: 84.1726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 84.8201438848921, y: 3.72549019607843, size: 1 },
    //     { x: 85.4676258992806, y: 3.80392156862745, size: 1 },
    //     { x: 86.1151079136691, y: 3.64705882352941, size: 1 },
    //     { x: 86.7625899280576, y: 3.76470588235294, size: 1 },
    //     { x: 87.410071942446, y: 3.76470588235294, size: 1 },
    //     { x: 88.0575539568345, y: 3.68627450980392, size: 1 },
    //     { x: 88.705035971223, y: 3.72549019607843, size: 1 },
    //     { x: 89.3525179856115, y: 3.72549019607843, size: 1 },
    //     { x: 90, y: 3.80392156862745, size: 1 },
    //     { x: 90.6474820143885, y: 3.96078431372549, size: 1 },
    //     { x: 91.294964028777, y: 3.84313725490196, size: 1 },
    //     { x: 91.9424460431655, y: 3.56862745098039, size: 1 },
    //     { x: 92.589928057554, y: 3.88235294117647, size: 1 },
    //     { x: 93.2374100719424, y: 3.84313725490196, size: 1 },
    //     { x: 93.8848920863309, y: 3.80392156862745, size: 1 },
    //     { x: 94.5323741007194, y: 3.72549019607843, size: 1 },
    //     { x: 95.1798561151079, y: 3.76470588235294, size: 1 },
    //     { x: 95.8273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 96.4748201438849, y: 3.88235294117647, size: 1 },
    //     { x: 97.1223021582734, y: 3.56862745098039, size: 1 },
    //     { x: 97.7697841726619, y: 3.6078431372549, size: 1 },
    //     { x: 98.4172661870504, y: 3.52941176470588, size: 1 },
    //     { x: 99.0647482014388, y: 3.25490196078431, size: 1 },
    //     { x: 99.7122302158273, y: 3.2156862745098, size: 1 },
    //     { x: 100.359712230216, y: 3.64705882352941, size: 1 },
    //     { x: 101.007194244604, y: 3.88235294117647, size: 1 },
    //     { x: 101.654676258993, y: 3.68627450980392, size: 1 },
    //     { x: 102.302158273381, y: 3.92156862745098, size: 1 },
    //     { x: 102.94964028777, y: 3.76470588235294, size: 1 },
    //     { x: 103.597122302158, y: 3.80392156862745, size: 1 },
    //     { x: 104.244604316547, y: 3.64705882352941, size: 1 },
    //     { x: 104.892086330935, y: 3.68627450980392, size: 1 },
    //     { x: 105.539568345324, y: 3.80392156862745, size: 1 },
    //     { x: 106.187050359712, y: 3.88235294117647, size: 1 },
    //     { x: 106.834532374101, y: 3.6078431372549, size: 1 },
    //     { x: 107.482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 108.129496402878, y: 3.88235294117647, size: 1 },
    //     { x: 108.776978417266, y: 3.76470588235294, size: 1 },
    //     { x: 109.424460431655, y: 3.84313725490196, size: 1 },
    //     { x: 110.071942446043, y: 3.92156862745098, size: 1 },
    //     { x: 110.719424460432, y: 3.76470588235294, size: 1 },
    //     { x: 111.36690647482, y: 3.84313725490196, size: 1 },
    //     { x: 112.014388489209, y: 3.76470588235294, size: 1 },
    //     { x: 112.661870503597, y: 3.84313725490196, size: 1 },
    //     { x: 113.309352517986, y: 3.88235294117647, size: 1 },
    //     { x: 113.956834532374, y: 3.92156862745098, size: 1 },
    //     { x: 114.604316546763, y: 3.88235294117647, size: 1 },
    //     { x: 115.251798561151, y: 3.52941176470588, size: 1 },
    //     { x: 115.89928057554, y: 3.76470588235294, size: 1 },
    //     { x: 116.546762589928, y: 3.68627450980392, size: 1 },
    //     { x: 117.194244604317, y: 3.68627450980392, size: 1 },
    //     { x: 117.841726618705, y: 3.6078431372549, size: 1 },
    //     { x: 118.489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 119.136690647482, y: 3.25490196078431, size: 1 },
    //     { x: 119.784172661871, y: 3.52941176470588, size: 1 },
    //     { x: 120.431654676259, y: 3.49019607843137, size: 1 },
    //     { x: 121.079136690647, y: 3.45098039215686, size: 1 },
    //     { x: 121.726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 122.374100719424, y: 3.64705882352941, size: 1 },
    //     { x: 123.021582733813, y: 3.84313725490196, size: 1 },
    //     { x: 123.669064748201, y: 3.88235294117647, size: 1 },
    //     { x: 124.31654676259, y: 3.72549019607843, size: 1 },
    //     { x: 124.964028776978, y: 4.11764705882353, size: 1 },
    //     { x: 125.611510791367, y: 3.76470588235294, size: 1 },
    //     { x: 126.258992805755, y: 3.84313725490196, size: 1 },
    //     { x: 126.906474820144, y: 3.84313725490196, size: 1 },
    //     { x: 127.553956834532, y: 3.84313725490196, size: 1 },
    //     { x: 128.201438848921, y: 3.68627450980392, size: 1 },
    //     { x: 128.848920863309, y: 3.96078431372549, size: 1 },
    //     { x: 129.496402877698, y: 3.72549019607843, size: 1 },
    //     { x: 130.143884892086, y: 3.96078431372549, size: 1 },
    //     { x: 130.791366906475, y: 3.76470588235294, size: 1 },
    //     { x: 131.438848920863, y: 3.92156862745098, size: 1 },
    //     { x: 132.086330935252, y: 3.72549019607843, size: 1 },
    //     { x: 132.73381294964, y: 3.68627450980392, size: 1 },
    //     { x: 133.381294964029, y: 3.80392156862745, size: 1 },
    //     { x: 134.028776978417, y: 3.72549019607843, size: 1 },
    //     { x: 134.676258992806, y: 3.68627450980392, size: 1 },
    //     { x: 135.323741007194, y: 3.76470588235294, size: 1 },
    //     { x: 135.971223021583, y: 3.76470588235294, size: 1 },
    //     { x: 136.618705035971, y: 3.88235294117647, size: 1 },
    //     { x: 137.26618705036, y: 3.80392156862745, size: 1 },
    //     { x: 137.913669064748, y: 3.96078431372549, size: 1 },
    //     { x: 138.561151079137, y: 3.80392156862745, size: 1 },
    //     { x: 139.208633093525, y: 4.03921568627451, size: 1 },
    //     { x: 139.856115107914, y: 3.68627450980392, size: 1 },
    //     { x: 140.503597122302, y: 3.52941176470588, size: 1 },
    //     { x: 141.151079136691, y: 3.68627450980392, size: 1 },
    //     { x: 141.798561151079, y: 3.56862745098039, size: 1 },
    //     { x: 142.446043165468, y: 3.33333333333333, size: 1 },
    //     { x: 143.093525179856, y: 3.37254901960784, size: 1 },
    //     { x: 143.741007194245, y: 3.88235294117647, size: 1 },
    //     { x: 144.388489208633, y: 3.92156862745098, size: 1 },
    //     { x: 145.035971223022, y: 3.76470588235294, size: 1 },
    //     { x: 145.68345323741, y: 3.84313725490196, size: 1 },
    //     { x: 146.330935251799, y: 3.72549019607843, size: 1 },
    //     { x: 146.978417266187, y: 3.84313725490196, size: 1 },
    //     { x: 147.625899280576, y: 4, size: 1 },
    //     { x: 148.273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 148.920863309353, y: 3.92156862745098, size: 1 },
    //     { x: 149.568345323741, y: 3.68627450980392, size: 1 },
    //     { x: 150.215827338129, y: 3.84313725490196, size: 1 },
    //     { x: 150.863309352518, y: 3.6078431372549, size: 1 },
    //     { x: 151.510791366906, y: 3.68627450980392, size: 1 },
    //     { x: 152.158273381295, y: 3.68627450980392, size: 1 },
    //     { x: 152.805755395683, y: 3.68627450980392, size: 1 },
    //     { x: 153.453237410072, y: 3.64705882352941, size: 1 },
    //     { x: 154.10071942446, y: 3.72549019607843, size: 1 },
    //     { x: 154.748201438849, y: 3.76470588235294, size: 1 },
    //     { x: 155.395683453237, y: 3.84313725490196, size: 1 },
    //     { x: 156.043165467626, y: 3.84313725490196, size: 1 },
    //     { x: 156.690647482014, y: 3.72549019607843, size: 1 },
    //     { x: 157.338129496403, y: 3.80392156862745, size: 1 },
    //     { x: 157.985611510791, y: 3.64705882352941, size: 1 },
    //     { x: 158.63309352518, y: 3.72549019607843, size: 1 },
    //     { x: 159.280575539568, y: 3.76470588235294, size: 1 },
    //     { x: 159.928057553957, y: 3.68627450980392, size: 1 },
    //     { x: 160.575539568345, y: 3.88235294117647, size: 1 },
    //     { x: 161.223021582734, y: 3.76470588235294, size: 1 },
    //     { x: 161.870503597122, y: 3.80392156862745, size: 1 },
    //     { x: 162.517985611511, y: 3.72549019607843, size: 1 },
    //     { x: 163.165467625899, y: 3.17647058823529, size: 1 },
    //     { x: 163.812949640288, y: 2.50980392156863, size: 1 },
    //     { x: 164.460431654676, y: 1.92156862745098, size: 1 },
    //     { x: 165.107913669065, y: 2.19607843137255, size: 1 },
    //     { x: 165.755395683453, y: 2.07843137254902, size: 1 },
    //     { x: 166.402877697842, y: 3.05882352941176, size: 1 },
    //     { x: 167.05035971223, y: 3.49019607843137, size: 1 },
    //     { x: 167.697841726619, y: 3.45098039215686, size: 1 },
    //     { x: 168.345323741007, y: 3.09803921568627, size: 1 },
    //     { x: 168.992805755396, y: 2.90196078431373, size: 1 },
    //     { x: 169.640287769784, y: 3.56862745098039, size: 1 },
    //     { x: 170.287769784173, y: 3.68627450980392, size: 1 },
    //     { x: 170.935251798561, y: 3.52941176470588, size: 1 },
    //     { x: 171.58273381295, y: 3.68627450980392, size: 1 },
    //     { x: 172.230215827338, y: 3.76470588235294, size: 1 },
    //     { x: 172.877697841727, y: 3.56862745098039, size: 1 },
    //     { x: 173.525179856115, y: 2.86274509803922, size: 1 },
    //     { x: 174.172661870504, y: 3.76470588235294, size: 1 },
    //     { x: 174.820143884892, y: 3.72549019607843, size: 1 },
    //     { x: 175.467625899281, y: 3.64705882352941, size: 1 },
    //     { x: 176.115107913669, y: 3.68627450980392, size: 1 },
    //     { x: 176.762589928058, y: 3.76470588235294, size: 1 },
    //     { x: 177.410071942446, y: 3.76470588235294, size: 1 },
    //     { x: 178.057553956835, y: 3.6078431372549, size: 1 },
    //     { x: 178.705035971223, y: 3.6078431372549, size: 1 },
    //     { x: 179.352517985612, y: 2.74509803921569, size: 1 },
    //     { x: 180, y: 2.86274509803922, size: 1 },
    //     { x: 180.647482014388, y: 3.29411764705882, size: 1 },
    //     { x: 181.294964028777, y: 3.37254901960784, size: 1 },
    //     { x: 181.942446043165, y: 3.45098039215686, size: 1 },
    //     { x: 182.589928057554, y: 3.33333333333333, size: 1 },
    //     { x: 183.237410071942, y: 3.41176470588235, size: 1 },
    //     { x: 183.884892086331, y: 3.29411764705882, size: 1 },
    //     { x: 184.532374100719, y: 3.37254901960784, size: 1 },
    //     { x: 185.179856115108, y: 3.05882352941176, size: 1 },
    //     { x: 185.827338129496, y: 2.74509803921569, size: 1 },
    //     { x: 186.474820143885, y: 3.64705882352941, size: 1 },
    //     { x: 187.122302158273, y: 3.76470588235294, size: 1 },
    //     { x: 187.769784172662, y: 3.92156862745098, size: 1 },
    //     { x: 188.41726618705, y: 3.84313725490196, size: 1 },
    //     { x: 189.064748201439, y: 3.68627450980392, size: 1 },
    //     { x: 189.712230215827, y: 3.68627450980392, size: 1 },
    //     { x: 190.359712230216, y: 3.68627450980392, size: 1 },
    //     { x: 191.007194244604, y: 3.72549019607843, size: 1 },
    //     { x: 191.654676258993, y: 3.64705882352941, size: 1 },
    //     { x: 192.302158273381, y: 3.80392156862745, size: 1 },
    //     { x: 192.94964028777, y: 3.68627450980392, size: 1 },
    //     { x: 193.597122302158, y: 3.68627450980392, size: 1 },
    //     { x: 194.244604316547, y: 3.68627450980392, size: 1 },
    //     { x: 194.892086330935, y: 3.84313725490196, size: 1 },
    //     { x: 195.539568345324, y: 3.76470588235294, size: 1 },
    //     { x: 196.187050359712, y: 3.84313725490196, size: 1 },
    //     { x: 196.834532374101, y: 3.76470588235294, size: 1 },
    //     { x: 197.482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 198.129496402878, y: 3.64705882352941, size: 1 },
    //     { x: 198.776978417266, y: 3.84313725490196, size: 1 },
    //     { x: 199.424460431655, y: 3.84313725490196, size: 1 },
    //     { x: 200.071942446043, y: 3.68627450980392, size: 1 },
    //     { x: 200.719424460432, y: 3.72549019607843, size: 1 },
    //     { x: 201.36690647482, y: 3.76470588235294, size: 1 },
    //     { x: 202.014388489209, y: 3.68627450980392, size: 1 },
    //     { x: 202.661870503597, y: 3.76470588235294, size: 1 },
    //     { x: 203.309352517986, y: 3.76470588235294, size: 1 },
    //     { x: 203.956834532374, y: 3.72549019607843, size: 1 },
    //     { x: 204.604316546763, y: 3.76470588235294, size: 1 },
    //     { x: 205.251798561151, y: 3.49019607843137, size: 1 },
    //     { x: 205.89928057554, y: 3.88235294117647, size: 1 },
    //     { x: 206.546762589928, y: 3.41176470588235, size: 1 },
    //     { x: 207.194244604317, y: 2.94117647058824, size: 1 },
    //     { x: 207.841726618705, y: 3.37254901960784, size: 1 },
    //     { x: 208.489208633094, y: 3.52941176470588, size: 1 },
    //     { x: 209.136690647482, y: 3.37254901960784, size: 1 },
    //     { x: 209.784172661871, y: 3.29411764705882, size: 1 },
    //     { x: 210.431654676259, y: 3.52941176470588, size: 1 },
    //     { x: 211.079136690647, y: 3.6078431372549, size: 1 },
    //     { x: 211.726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 212.374100719424, y: 3.72549019607843, size: 1 },
    //     { x: 213.021582733813, y: 3.49019607843137, size: 1 },
    //     { x: 213.669064748201, y: 3.72549019607843, size: 1 },
    //     { x: 214.31654676259, y: 3.52941176470588, size: 1 },
    //     { x: 214.964028776978, y: 3.49019607843137, size: 1 },
    //     { x: 215.611510791367, y: 3.52941176470588, size: 1 },
    //     { x: 216.258992805755, y: 3.72549019607843, size: 1 },
    //     { x: 216.906474820144, y: 3.45098039215686, size: 1 },
    //     { x: 217.553956834532, y: 3.52941176470588, size: 1 },
    //     { x: 218.201438848921, y: 3.64705882352941, size: 1 },
    //     { x: 218.848920863309, y: 3.41176470588235, size: 1 },
    //     { x: 219.496402877698, y: 3.68627450980392, size: 1 },
    //     { x: 220.143884892086, y: 3.72549019607843, size: 1 },
    //     { x: 220.791366906475, y: 3.41176470588235, size: 1 },
    //     { x: 221.438848920863, y: 3.49019607843137, size: 1 },
    //     { x: 222.086330935252, y: 3.72549019607843, size: 1 },
    //     { x: 222.73381294964, y: 3.49019607843137, size: 1 },
    //     { x: 223.381294964029, y: 3.6078431372549, size: 1 },
    //     { x: 224.028776978417, y: 3.76470588235294, size: 1 },
    //     { x: 224.676258992806, y: 3.45098039215686, size: 1 },
    //     { x: 225.323741007194, y: 3.72549019607843, size: 1 },
    //     { x: 225.971223021583, y: 3.37254901960784, size: 1 },
    //     { x: 226.618705035971, y: 3.72549019607843, size: 1 },
    //     { x: 227.26618705036, y: 3.33333333333333, size: 1 },
    //     { x: 227.913669064748, y: 3.52941176470588, size: 1 },
    //     { x: 228.561151079137, y: 2.35294117647059, size: 1 },
    //     { x: 229.208633093525, y: 2.43137254901961, size: 1 },
    //     { x: 229.856115107914, y: 3.49019607843137, size: 1 },
    //     { x: 230.503597122302, y: 3.72549019607843, size: 1 },
    //     { x: 231.151079136691, y: 3.88235294117647, size: 1 },
    //     { x: 231.798561151079, y: 3.80392156862745, size: 1 },
    //     { x: 232.446043165468, y: 3.68627450980392, size: 1 },
    //     { x: 233.093525179856, y: 3.68627450980392, size: 1 },
    //     { x: 233.741007194245, y: 3.76470588235294, size: 1 },
    //     { x: 234.388489208633, y: 3.68627450980392, size: 1 },
    //     { x: 235.035971223022, y: 3.76470588235294, size: 1 },
    //     { x: 235.68345323741, y: 3.72549019607843, size: 1 },
    //     { x: 236.330935251799, y: 3.64705882352941, size: 1 },
    //     { x: 236.978417266187, y: 3.76470588235294, size: 1 },
    //     { x: 237.625899280576, y: 3.72549019607843, size: 1 },
    //     { x: 238.273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 238.920863309353, y: 3.80392156862745, size: 1 },
    //     { x: 239.568345323741, y: 3.84313725490196, size: 1 },
    //     { x: 240.215827338129, y: 3.80392156862745, size: 1 },
    //     { x: 240.863309352518, y: 4.03921568627451, size: 1 },
    //     { x: 241.510791366906, y: 3.72549019607843, size: 1 },
    //     { x: 242.158273381295, y: 4, size: 1 },
    //     { x: 242.805755395683, y: 3.64705882352941, size: 1 },
    //     { x: 243.453237410072, y: 3.84313725490196, size: 1 },
    //     { x: 244.10071942446, y: 3.84313725490196, size: 1 },
    //     { x: 244.748201438849, y: 3.80392156862745, size: 1 },
    //     { x: 245.395683453237, y: 3.68627450980392, size: 1 },
    //     { x: 246.043165467626, y: 3.68627450980392, size: 1 },
    //     { x: 246.690647482014, y: 3.72549019607843, size: 1 },
    //     { x: 247.338129496403, y: 3.84313725490196, size: 1 },
    //     { x: 247.985611510791, y: 4.11764705882353, size: 1 },
    //     { x: 248.63309352518, y: 3.25490196078431, size: 1 },
    //     { x: 249.280575539568, y: 3.25490196078431, size: 1 },
    //     { x: 249.928057553957, y: 3.2156862745098, size: 1 },
    //     { x: 250.575539568345, y: 2.31372549019608, size: 1 },
    //     { x: 251.223021582734, y: 3.37254901960784, size: 1 },
    //     { x: 251.870503597122, y: 3.80392156862745, size: 1 },
    //     { x: 252.517985611511, y: 3.72549019607843, size: 1 },
    //     { x: 253.165467625899, y: 3.84313725490196, size: 1 },
    //     { x: 253.812949640288, y: 4, size: 1 },
    //     { x: 254.460431654676, y: 3.76470588235294, size: 1 },
    //     { x: 255.107913669065, y: 3.72549019607843, size: 1 },
    //     { x: 255.755395683453, y: 3.84313725490196, size: 1 },
    //     { x: 256.402877697842, y: 3.80392156862745, size: 1 },
    //     { x: 257.05035971223, y: 3.68627450980392, size: 1 },
    //     { x: 257.697841726619, y: 3.84313725490196, size: 1 },
    //     { x: 258.345323741007, y: 3.84313725490196, size: 1 },
    //     { x: 258.992805755396, y: 3.6078431372549, size: 1 },
    //     { x: 259.640287769784, y: 3.72549019607843, size: 1 },
    //     { x: 260.287769784173, y: 3.68627450980392, size: 1 },
    //     { x: 260.935251798561, y: 3.92156862745098, size: 1 },
    //     { x: 261.58273381295, y: 3.96078431372549, size: 1 },
    //     { x: 262.230215827338, y: 3.68627450980392, size: 1 },
    //     { x: 262.877697841727, y: 3.80392156862745, size: 1 },
    //     { x: 263.525179856115, y: 3.72549019607843, size: 1 },
    //     { x: 264.172661870504, y: 4.03921568627451, size: 1 },
    //     { x: 264.820143884892, y: 3.68627450980392, size: 1 },
    //     { x: 265.467625899281, y: 3.84313725490196, size: 1 },
    //     { x: 266.115107913669, y: 3.6078431372549, size: 1 },
    //     { x: 266.762589928058, y: 3.68627450980392, size: 1 },
    //     { x: 267.410071942446, y: 3.72549019607843, size: 1 },
    //     { x: 268.057553956835, y: 3.76470588235294, size: 1 },
    //     { x: 268.705035971223, y: 3.72549019607843, size: 1 },
    //     { x: 269.352517985611, y: 3.76470588235294, size: 1 },
    //     { x: 270, y: 3.6078431372549, size: 1 },
    //     { x: 270.647482014389, y: 3.49019607843137, size: 1 },
    //     { x: 271.294964028777, y: 3.49019607843137, size: 1 },
    //     { x: 271.942446043165, y: 3.13725490196078, size: 1 },
    //     { x: 272.589928057554, y: 3.29411764705882, size: 1 },
    //     { x: 273.237410071942, y: 3.76470588235294, size: 1 },
    //     { x: 273.884892086331, y: 3.68627450980392, size: 1 },
    //     { x: 274.532374100719, y: 3.6078431372549, size: 1 },
    //     { x: 275.179856115108, y: 3.72549019607843, size: 1 },
    //     { x: 275.827338129496, y: 3.6078431372549, size: 1 },
    //     { x: 276.474820143885, y: 3.68627450980392, size: 1 },
    //     { x: 277.122302158273, y: 3.68627450980392, size: 1 },
    //     { x: 277.769784172662, y: 3.64705882352941, size: 1 },
    //     { x: 278.41726618705, y: 3.72549019607843, size: 1 },
    //     { x: 279.064748201439, y: 3.64705882352941, size: 1 },
    //     { x: 279.712230215827, y: 4, size: 1 },
    //     { x: 280.359712230216, y: 3.84313725490196, size: 1 },
    //     { x: 281.007194244604, y: 3.6078431372549, size: 1 },
    //     { x: 281.654676258993, y: 3.80392156862745, size: 1 },
    //     { x: 282.302158273381, y: 3.92156862745098, size: 1 },
    //     { x: 282.94964028777, y: 3.92156862745098, size: 1 },
    //     { x: 283.597122302158, y: 3.64705882352941, size: 1 },
    //     { x: 284.244604316547, y: 3.68627450980392, size: 1 },
    //     { x: 284.892086330935, y: 3.64705882352941, size: 1 },
    //     { x: 285.539568345324, y: 3.64705882352941, size: 1 },
    //     { x: 286.187050359712, y: 3.68627450980392, size: 1 },
    //     { x: 286.834532374101, y: 3.76470588235294, size: 1 },
    //     { x: 287.482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 288.129496402878, y: 3.80392156862745, size: 1 },
    //     { x: 288.776978417266, y: 3.76470588235294, size: 1 },
    //     { x: 289.424460431655, y: 3.68627450980392, size: 1 },
    //     { x: 290.071942446043, y: 3.68627450980392, size: 1 },
    //     { x: 290.719424460432, y: 3.6078431372549, size: 1 },
    //     { x: 291.36690647482, y: 3.52941176470588, size: 1 },
    //     { x: 292.014388489209, y: 3.41176470588235, size: 1 },
    //     { x: 292.661870503597, y: 3.37254901960784, size: 1 },
    //     { x: 293.309352517986, y: 2.66666666666667, size: 1 },
    //     { x: 293.956834532374, y: 2.50980392156863, size: 1 },
    //     { x: 294.604316546763, y: 3.64705882352941, size: 1 },
    //     { x: 295.251798561151, y: 3.68627450980392, size: 1 },
    //     { x: 295.89928057554, y: 3.64705882352941, size: 1 },
    //     { x: 296.546762589928, y: 3.68627450980392, size: 1 },
    //     { x: 297.194244604317, y: 3.49019607843137, size: 1 },
    //     { x: 297.841726618705, y: 3.76470588235294, size: 1 },
    //     { x: 298.489208633094, y: 3.64705882352941, size: 1 },
    //     { x: 299.136690647482, y: 3.84313725490196, size: 1 },
    //     { x: 299.784172661871, y: 3.80392156862745, size: 1 },
    //     { x: 300.431654676259, y: 3.6078431372549, size: 1 },
    //     { x: 301.079136690647, y: 3.76470588235294, size: 1 },
    //     { x: 301.726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 302.374100719424, y: 3.72549019607843, size: 1 },
    //     { x: 303.021582733813, y: 3.84313725490196, size: 1 },
    //     { x: 303.669064748201, y: 4, size: 1 },
    //     { x: 304.31654676259, y: 3.76470588235294, size: 1 },
    //     { x: 304.964028776978, y: 3.76470588235294, size: 1 },
    //     { x: 305.611510791367, y: 3.72549019607843, size: 1 },
    //     { x: 306.258992805755, y: 3.6078431372549, size: 1 },
    //     { x: 306.906474820144, y: 3.64705882352941, size: 1 },
    //     { x: 307.553956834532, y: 3.76470588235294, size: 1 },
    //     { x: 308.201438848921, y: 3.6078431372549, size: 1 },
    //     { x: 308.848920863309, y: 3.6078431372549, size: 1 },
    //     { x: 309.496402877698, y: 3.52941176470588, size: 1 },
    //     { x: 310.143884892086, y: 3.68627450980392, size: 1 },
    //     { x: 310.791366906475, y: 3.56862745098039, size: 1 },
    //     { x: 311.438848920863, y: 3.64705882352941, size: 1 },
    //     { x: 312.086330935252, y: 3.45098039215686, size: 1 },
    //     { x: 312.73381294964, y: 3.72549019607843, size: 1 },
    //     { x: 313.381294964029, y: 3.2156862745098, size: 1 },
    //     { x: 314.028776978417, y: 3.17647058823529, size: 1 },
    //     { x: 314.676258992806, y: 3.09803921568627, size: 1 },
    //     { x: 315.323741007194, y: 2.3921568627451, size: 1 },
    //     { x: 315.971223021583, y: 3.56862745098039, size: 1 },
    //     { x: 316.618705035971, y: 3.72549019607843, size: 1 },
    //     { x: 317.26618705036, y: 3.68627450980392, size: 1 },
    //     { x: 317.913669064748, y: 3.80392156862745, size: 1 },
    //     { x: 318.561151079137, y: 3.52941176470588, size: 1 },
    //     { x: 319.208633093525, y: 4, size: 1 },
    //     { x: 319.856115107914, y: 3.72549019607843, size: 1 },
    //     { x: 320.503597122302, y: 3.76470588235294, size: 1 },
    //     { x: 321.151079136691, y: 3.68627450980392, size: 1 },
    //     { x: 321.798561151079, y: 3.76470588235294, size: 1 },
    //     { x: 322.446043165468, y: 3.52941176470588, size: 1 },
    //     { x: 323.093525179856, y: 3.88235294117647, size: 1 },
    //     { x: 323.741007194245, y: 3.49019607843137, size: 1 },
    //     { x: 324.388489208633, y: 3.80392156862745, size: 1 },
    //     { x: 325.035971223022, y: 3.72549019607843, size: 1 },
    //     { x: 325.68345323741, y: 3.80392156862745, size: 1 },
    //     { x: 326.330935251799, y: 3.80392156862745, size: 1 },
    //     { x: 326.978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 327.625899280576, y: 3.68627450980392, size: 1 },
    //     { x: 328.273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 328.920863309353, y: 3.80392156862745, size: 1 },
    //     { x: 329.568345323741, y: 3.64705882352941, size: 1 },
    //     { x: 330.215827338129, y: 3.76470588235294, size: 1 },
    //     { x: 330.863309352518, y: 3.92156862745098, size: 1 },
    //     { x: 331.510791366906, y: 3.64705882352941, size: 1 },
    //     { x: 332.158273381295, y: 3.80392156862745, size: 1 },
    //     { x: 332.805755395683, y: 3.96078431372549, size: 1 },
    //     { x: 333.453237410072, y: 3.72549019607843, size: 1 },
    //     { x: 334.10071942446, y: 3.64705882352941, size: 1 },
    //     { x: 334.748201438849, y: 3.45098039215686, size: 1 },
    //     { x: 335.395683453237, y: 3.37254901960784, size: 1 },
    //     { x: 336.043165467626, y: 3.01960784313725, size: 1 },
    //     { x: 336.690647482014, y: 2.47058823529412, size: 1 },
    //     { x: 337.338129496403, y: 2.86274509803922, size: 1 },
    //     { x: 337.985611510791, y: 3.49019607843137, size: 1 },
    //     { x: 338.63309352518, y: 3.56862745098039, size: 1 },
    //     { x: 339.280575539568, y: 3.80392156862745, size: 1 },
    //     { x: 339.928057553957, y: 3.64705882352941, size: 1 },
    //     { x: 340.575539568345, y: 3.72549019607843, size: 1 },
    //     { x: 341.223021582734, y: 3.92156862745098, size: 1 },
    //     { x: 341.870503597122, y: 3.84313725490196, size: 1 },
    //     { x: 342.517985611511, y: 3.68627450980392, size: 1 },
    //     { x: 343.165467625899, y: 3.64705882352941, size: 1 },
    //     { x: 343.812949640288, y: 3.72549019607843, size: 1 },
    //     { x: 344.460431654676, y: 3.76470588235294, size: 1 },
    //     { x: 345.107913669065, y: 3.84313725490196, size: 1 },
    //     { x: 345.755395683453, y: 3.72549019607843, size: 1 },
    //     { x: 346.402877697842, y: 3.68627450980392, size: 1 },
    //     { x: 347.05035971223, y: 3.64705882352941, size: 1 },
    //     { x: 347.697841726619, y: 3.92156862745098, size: 1 },
    //     { x: 348.345323741007, y: 3.64705882352941, size: 1 },
    //     { x: 348.992805755396, y: 3.68627450980392, size: 1 },
    //     { x: 349.640287769784, y: 3.88235294117647, size: 1 },
    //     { x: 350.287769784173, y: 3.76470588235294, size: 1 },
    //     { x: 350.935251798561, y: 3.64705882352941, size: 1 },
    //     { x: 351.58273381295, y: 3.72549019607843, size: 1 },
    //     { x: 352.230215827338, y: 3.72549019607843, size: 1 },
    //     { x: 352.877697841727, y: 3.76470588235294, size: 1 },
    //     { x: 353.525179856115, y: 3.72549019607843, size: 1 },
    //     { x: 354.172661870504, y: 3.64705882352941, size: 1 },
    //     { x: 354.820143884892, y: 3.72549019607843, size: 1 },
    //     { x: 355.467625899281, y: 3.88235294117647, size: 1 },
    //     { x: 356.115107913669, y: 3.64705882352941, size: 1 },
    //     { x: 356.762589928058, y: 3.25490196078431, size: 1 },
    //     { x: 357.410071942446, y: 3.41176470588235, size: 1 },
    //     { x: 358.057553956835, y: 3.05882352941176, size: 1 },
    //     { x: 358.705035971223, y: 2.94117647058824, size: 1 },
    //     { x: 359.352517985611, y: 3.6078431372549, size: 1 },
    //     { x: 0, y: 3.68627450980392, size: 1 },
    //     { x: 0.647482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 1.29496402877698, y: 3.52941176470588, size: 1 },
    //     { x: 1.94244604316547, y: 3.68627450980392, size: 1 },
    //     { x: 2.58992805755396, y: 3.76470588235294, size: 1 },
    //     { x: 3.23741007194245, y: 3.76470588235294, size: 1 },
    //     { x: 3.88489208633094, y: 3.80392156862745, size: 1 },
    //     { x: 4.53237410071942, y: 3.80392156862745, size: 1 },
    //     { x: 5.17985611510791, y: 3.64705882352941, size: 1 },
    //     { x: 5.8273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 6.47482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 7.12230215827338, y: 3.72549019607843, size: 1 },
    //     { x: 7.76978417266187, y: 3.56862745098039, size: 1 },
    //     { x: 8.41726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 9.06474820143885, y: 3.72549019607843, size: 1 },
    //     { x: 9.71223021582734, y: 3.6078431372549, size: 1 },
    //     { x: 10.3597122302158, y: 3.80392156862745, size: 1 },
    //     { x: 11.0071942446043, y: 3.84313725490196, size: 1 },
    //     { x: 11.6546762589928, y: 3.56862745098039, size: 1 },
    //     { x: 12.3021582733813, y: 3.72549019607843, size: 1 },
    //     { x: 12.9496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 13.5971223021583, y: 3.6078431372549, size: 1 },
    //     { x: 14.2446043165468, y: 3.68627450980392, size: 1 },
    //     { x: 14.8920863309353, y: 3.68627450980392, size: 1 },
    //     { x: 15.5395683453237, y: 3.76470588235294, size: 1 },
    //     { x: 16.1870503597122, y: 3.76470588235294, size: 1 },
    //     { x: 16.8345323741007, y: 3.80392156862745, size: 1 },
    //     { x: 17.4820143884892, y: 3.84313725490196, size: 1 },
    //     { x: 18.1294964028777, y: 3.05882352941176, size: 1 },
    //     { x: 18.7769784172662, y: 3.2156862745098, size: 1 },
    //     { x: 19.4244604316547, y: 3.33333333333333, size: 1 },
    //     { x: 20.0719424460432, y: 2.66666666666667, size: 1 },
    //     { x: 20.7194244604317, y: 3.2156862745098, size: 1 },
    //     { x: 21.3669064748201, y: 3.76470588235294, size: 1 },
    //     { x: 22.6618705035971, y: 3.92156862745098, size: 1 },
    //     { x: 23.3093525179856, y: 3.56862745098039, size: 1 },
    //     { x: 23.9568345323741, y: 3.68627450980392, size: 1 },
    //     { x: 24.6043165467626, y: 3.68627450980392, size: 1 },
    //     { x: 25.2517985611511, y: 3.6078431372549, size: 1 },
    //     { x: 25.8992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 26.5467625899281, y: 3.56862745098039, size: 1 },
    //     { x: 27.1942446043165, y: 3.68627450980392, size: 1 },
    //     { x: 27.841726618705, y: 3.49019607843137, size: 1 },
    //     { x: 28.4892086330935, y: 3.68627450980392, size: 1 },
    //     { x: 29.136690647482, y: 3.6078431372549, size: 1 },
    //     { x: 29.7841726618705, y: 3.80392156862745, size: 1 },
    //     { x: 30.431654676259, y: 3.64705882352941, size: 1 },
    //     { x: 31.0791366906475, y: 3.84313725490196, size: 1 },
    //     { x: 31.726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 32.3741007194245, y: 3.72549019607843, size: 1 },
    //     { x: 33.0215827338129, y: 3.49019607843137, size: 1 },
    //     { x: 33.6690647482014, y: 3.64705882352941, size: 1 },
    //     { x: 34.3165467625899, y: 3.72549019607843, size: 1 },
    //     { x: 34.9640287769784, y: 3.56862745098039, size: 1 },
    //     { x: 35.6115107913669, y: 3.6078431372549, size: 1 },
    //     { x: 36.2589928057554, y: 3.6078431372549, size: 1 },
    //     { x: 36.9064748201439, y: 3.80392156862745, size: 1 },
    //     { x: 38.2014388489209, y: 3.64705882352941, size: 1 },
    //     { x: 38.8489208633094, y: 3.64705882352941, size: 1 },
    //     { x: 39.4964028776978, y: 3.41176470588235, size: 1 },
    //     { x: 40.1438848920863, y: 3.2156862745098, size: 1 },
    //     { x: 40.7913669064748, y: 3.2156862745098, size: 1 },
    //     { x: 41.4388489208633, y: 3.17647058823529, size: 1 },
    //     { x: 42.0863309352518, y: 2.98039215686275, size: 1 },
    //     { x: 42.7338129496403, y: 3.76470588235294, size: 1 },
    //     { x: 43.3812949640288, y: 4.03921568627451, size: 1 },
    //     { x: 44.0287769784173, y: 3.56862745098039, size: 1 },
    //     { x: 45.3237410071942, y: 3.72549019607843, size: 1 },
    //     { x: 45.9712230215827, y: 3.80392156862745, size: 1 },
    //     { x: 46.6187050359712, y: 3.68627450980392, size: 1 },
    //     { x: 47.2661870503597, y: 3.6078431372549, size: 1 },
    //     { x: 47.9136690647482, y: 3.64705882352941, size: 1 },
    //     { x: 48.5611510791367, y: 3.80392156862745, size: 1 },
    //     { x: 49.2086330935252, y: 3.76470588235294, size: 1 },
    //     { x: 49.8561151079137, y: 3.92156862745098, size: 1 },
    //     { x: 50.5035971223022, y: 3.80392156862745, size: 1 },
    //     { x: 51.1510791366906, y: 3.72549019607843, size: 1 },
    //     { x: 51.7985611510791, y: 3.68627450980392, size: 1 },
    //     { x: 52.4460431654676, y: 3.68627450980392, size: 1 },
    //     { x: 53.0935251798561, y: 3.76470588235294, size: 1 },
    //     { x: 53.7410071942446, y: 3.76470588235294, size: 1 },
    //     { x: 54.3884892086331, y: 3.76470588235294, size: 1 },
    //     { x: 55.0359712230216, y: 3.6078431372549, size: 1 },
    //     { x: 55.6834532374101, y: 3.72549019607843, size: 1 },
    //     { x: 56.3309352517986, y: 3.56862745098039, size: 1 },
    //     { x: 56.9784172661871, y: 3.68627450980392, size: 1 },
    //     { x: 57.6258992805755, y: 3.72549019607843, size: 1 },
    //     { x: 58.273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 58.9208633093525, y: 3.72549019607843, size: 1 },
    //     { x: 59.568345323741, y: 3.80392156862745, size: 1 },
    //     { x: 60.2158273381295, y: 3.88235294117647, size: 1 },
    //     { x: 61.5107913669065, y: 3.49019607843137, size: 1 },
    //     { x: 62.158273381295, y: 3.37254901960784, size: 1 },
    //     { x: 62.8057553956835, y: 3.76470588235294, size: 1 },
    //     { x: 63.4532374100719, y: 3.56862745098039, size: 1 },
    //     { x: 64.1007194244604, y: 3.64705882352941, size: 1 },
    //     { x: 64.7482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 66.0431654676259, y: 3.72549019607843, size: 1 },
    //     { x: 66.6906474820144, y: 3.72549019607843, size: 1 },
    //     { x: 67.3381294964029, y: 3.76470588235294, size: 1 },
    //     { x: 67.9856115107914, y: 3.84313725490196, size: 1 },
    //     { x: 68.6330935251799, y: 3.76470588235294, size: 1 },
    //     { x: 69.2805755395683, y: 3.80392156862745, size: 1 },
    //     { x: 69.9280575539568, y: 3.68627450980392, size: 1 },
    //     { x: 70.5755395683453, y: 3.96078431372549, size: 1 },
    //     { x: 71.2230215827338, y: 3.72549019607843, size: 1 },
    //     { x: 71.8705035971223, y: 3.76470588235294, size: 1 },
    //     { x: 72.5179856115108, y: 3.80392156862745, size: 1 },
    //     { x: 73.1654676258993, y: 3.72549019607843, size: 1 },
    //     { x: 73.8129496402878, y: 3.84313725490196, size: 1 },
    //     { x: 74.4604316546763, y: 3.64705882352941, size: 1 },
    //     { x: 75.7553956834532, y: 3.64705882352941, size: 1 },
    //     { x: 76.4028776978417, y: 3.64705882352941, size: 1 },
    //     { x: 77.0503597122302, y: 3.80392156862745, size: 1 },
    //     { x: 77.6978417266187, y: 3.64705882352941, size: 1 },
    //     { x: 78.3453237410072, y: 3.56862745098039, size: 1 },
    //     { x: 78.9928057553957, y: 3.76470588235294, size: 1 },
    //     { x: 79.6402877697842, y: 4.07843137254902, size: 1 },
    //     { x: 80.2877697841727, y: 3.92156862745098, size: 1 },
    //     { x: 80.9352517985612, y: 4.03921568627451, size: 1 },
    //     { x: 81.5827338129496, y: 3.88235294117647, size: 1 },
    //     { x: 82.2302158273381, y: 3.72549019607843, size: 1 },
    //     { x: 82.8776978417266, y: 3.45098039215686, size: 1 },
    //     { x: 83.5251798561151, y: 3.37254901960784, size: 1 },
    //     { x: 84.1726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 84.8201438848921, y: 3.49019607843137, size: 1 },
    //     { x: 85.4676258992806, y: 3.64705882352941, size: 1 },
    //     { x: 86.1151079136691, y: 3.76470588235294, size: 1 },
    //     { x: 86.7625899280576, y: 3.45098039215686, size: 1 },
    //     { x: 87.410071942446, y: 3.64705882352941, size: 1 },
    //     { x: 88.0575539568345, y: 3.64705882352941, size: 1 },
    //     { x: 88.705035971223, y: 3.52941176470588, size: 1 },
    //     { x: 89.3525179856115, y: 3.80392156862745, size: 1 },
    //     { x: 90, y: 3.76470588235294, size: 1 },
    //     { x: 90.6474820143885, y: 3.41176470588235, size: 1 },
    //     { x: 91.294964028777, y: 3.52941176470588, size: 1 },
    //     { x: 91.9424460431655, y: 3.6078431372549, size: 1 },
    //     { x: 92.589928057554, y: 3.72549019607843, size: 1 },
    //     { x: 93.2374100719424, y: 3.6078431372549, size: 1 },
    //     { x: 93.8848920863309, y: 3.88235294117647, size: 1 },
    //     { x: 94.5323741007194, y: 3.68627450980392, size: 1 },
    //     { x: 95.1798561151079, y: 3.56862745098039, size: 1 },
    //     { x: 95.8273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 96.4748201438849, y: 3.64705882352941, size: 1 },
    //     { x: 97.7697841726619, y: 4, size: 1 },
    //     { x: 98.4172661870504, y: 3.76470588235294, size: 1 },
    //     { x: 99.0647482014388, y: 3.84313725490196, size: 1 },
    //     { x: 99.7122302158273, y: 3.64705882352941, size: 1 },
    //     { x: 100.359712230216, y: 3.49019607843137, size: 1 },
    //     { x: 101.007194244604, y: 3.56862745098039, size: 1 },
    //     { x: 102.302158273381, y: 3.68627450980392, size: 1 },
    //     { x: 102.94964028777, y: 3.80392156862745, size: 1 },
    //     { x: 103.597122302158, y: 3.6078431372549, size: 1 },
    //     { x: 105.539568345324, y: 3.68627450980392, size: 1 },
    //     { x: 106.187050359712, y: 3.52941176470588, size: 1 },
    //     { x: 107.482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 108.129496402878, y: 3.6078431372549, size: 1 },
    //     { x: 108.776978417266, y: 3.49019607843137, size: 1 },
    //     { x: 109.424460431655, y: 3.56862745098039, size: 1 },
    //     { x: 110.071942446043, y: 3.76470588235294, size: 1 },
    //     { x: 110.719424460432, y: 3.56862745098039, size: 1 },
    //     { x: 111.36690647482, y: 3.88235294117647, size: 1 },
    //     { x: 112.014388489209, y: 3.64705882352941, size: 1 },
    //     { x: 112.661870503597, y: 3.6078431372549, size: 1 },
    //     { x: 113.309352517986, y: 3.45098039215686, size: 1 },
    //     { x: 113.956834532374, y: 3.41176470588235, size: 1 },
    //     { x: 114.604316546763, y: 3.68627450980392, size: 1 },
    //     { x: 115.89928057554, y: 3.6078431372549, size: 1 },
    //     { x: 116.546762589928, y: 3.49019607843137, size: 1 },
    //     { x: 117.194244604317, y: 3.45098039215686, size: 1 },
    //     { x: 117.841726618705, y: 3.80392156862745, size: 1 },
    //     { x: 118.489208633094, y: 3.72549019607843, size: 1 },
    //     { x: 119.136690647482, y: 3.37254901960784, size: 1 },
    //     { x: 119.784172661871, y: 3.76470588235294, size: 1 },
    //     { x: 121.726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 122.374100719424, y: 3.41176470588235, size: 1 },
    //     { x: 123.021582733813, y: 3.68627450980392, size: 1 },
    //     { x: 123.669064748201, y: 3.49019607843137, size: 1 },
    //     { x: 124.31654676259, y: 3.33333333333333, size: 1 },
    //     { x: 124.964028776978, y: 3.68627450980392, size: 1 },
    //     { x: 125.611510791367, y: 3.64705882352941, size: 1 },
    //     { x: 126.258992805755, y: 3.56862745098039, size: 1 },
    //     { x: 126.906474820144, y: 3.76470588235294, size: 1 },
    //     { x: 128.201438848921, y: 3.84313725490196, size: 1 },
    //     { x: 128.848920863309, y: 3.64705882352941, size: 1 },
    //     { x: 129.496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 130.143884892086, y: 3.68627450980392, size: 1 },
    //     { x: 130.791366906475, y: 3.68627450980392, size: 1 },
    //     { x: 131.438848920863, y: 3.68627450980392, size: 1 },
    //     { x: 132.086330935252, y: 3.80392156862745, size: 1 },
    //     { x: 132.73381294964, y: 3.64705882352941, size: 1 },
    //     { x: 133.381294964029, y: 3.56862745098039, size: 1 },
    //     { x: 134.028776978417, y: 3.68627450980392, size: 1 },
    //     { x: 134.676258992806, y: 3.6078431372549, size: 1 },
    //     { x: 135.323741007194, y: 3.64705882352941, size: 1 },
    //     { x: 135.971223021583, y: 3.6078431372549, size: 1 },
    //     { x: 137.26618705036, y: 3.84313725490196, size: 1 },
    //     { x: 137.913669064748, y: 3.52941176470588, size: 1 },
    //     { x: 138.561151079137, y: 3.52941176470588, size: 1 },
    //     { x: 139.208633093525, y: 3.76470588235294, size: 1 },
    //     { x: 139.856115107914, y: 3.56862745098039, size: 1 },
    //     { x: 141.798561151079, y: 3.84313725490196, size: 1 },
    //     { x: 142.446043165468, y: 3.49019607843137, size: 1 },
    //     { x: 143.093525179856, y: 3.72549019607843, size: 1 },
    //     { x: 143.741007194245, y: 3.64705882352941, size: 1 },
    //     { x: 144.388489208633, y: 3.68627450980392, size: 1 },
    //     { x: 145.035971223022, y: 3.49019607843137, size: 1 },
    //     { x: 145.68345323741, y: 3.72549019607843, size: 1 },
    //     { x: 146.330935251799, y: 3.49019607843137, size: 1 },
    //     { x: 146.978417266187, y: 3.72549019607843, size: 1 },
    //     { x: 147.625899280576, y: 3.68627450980392, size: 1 },
    //     { x: 148.273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 148.920863309353, y: 3.49019607843137, size: 1 },
    //     { x: 149.568345323741, y: 3.56862745098039, size: 1 },
    //     { x: 150.215827338129, y: 3.68627450980392, size: 1 },
    //     { x: 150.863309352518, y: 3.68627450980392, size: 1 },
    //     { x: 151.510791366906, y: 3.64705882352941, size: 1 },
    //     { x: 152.158273381295, y: 3.56862745098039, size: 1 },
    //     { x: 152.805755395683, y: 3.6078431372549, size: 1 },
    //     { x: 154.10071942446, y: 3.56862745098039, size: 1 },
    //     { x: 154.748201438849, y: 3.68627450980392, size: 1 },
    //     { x: 155.395683453237, y: 3.68627450980392, size: 1 },
    //     { x: 156.043165467626, y: 3.6078431372549, size: 1 },
    //     { x: 156.690647482014, y: 3.64705882352941, size: 1 },
    //     { x: 157.338129496403, y: 3.52941176470588, size: 1 },
    //     { x: 157.985611510791, y: 3.52941176470588, size: 1 },
    //     { x: 158.63309352518, y: 3.88235294117647, size: 1 },
    //     { x: 159.280575539568, y: 3.68627450980392, size: 1 },
    //     { x: 160.575539568345, y: 3.80392156862745, size: 1 },
    //     { x: 161.223021582734, y: 3.64705882352941, size: 1 },
    //     { x: 161.870503597122, y: 3.49019607843137, size: 1 },
    //     { x: 162.517985611511, y: 3.68627450980392, size: 1 },
    //     { x: 163.165467625899, y: 3.6078431372549, size: 1 },
    //     { x: 163.812949640288, y: 3.56862745098039, size: 1 },
    //     { x: 164.460431654676, y: 3.52941176470588, size: 1 },
    //     { x: 165.107913669065, y: 3.72549019607843, size: 1 },
    //     { x: 165.755395683453, y: 3.56862745098039, size: 1 },
    //     { x: 166.402877697842, y: 3.80392156862745, size: 1 },
    //     { x: 167.05035971223, y: 3.64705882352941, size: 1 },
    //     { x: 167.697841726619, y: 3.52941176470588, size: 1 },
    //     { x: 168.345323741007, y: 3.92156862745098, size: 1 },
    //     { x: 168.992805755396, y: 3.68627450980392, size: 1 },
    //     { x: 169.640287769784, y: 3.6078431372549, size: 1 },
    //     { x: 170.287769784173, y: 3.49019607843137, size: 1 },
    //     { x: 170.935251798561, y: 3.45098039215686, size: 1 },
    //     { x: 171.58273381295, y: 3.41176470588235, size: 1 },
    //     { x: 172.230215827338, y: 3.68627450980392, size: 1 },
    //     { x: 172.877697841727, y: 3.6078431372549, size: 1 },
    //     { x: 173.525179856115, y: 3.56862745098039, size: 1 },
    //     { x: 174.172661870504, y: 3.88235294117647, size: 1 },
    //     { x: 174.820143884892, y: 3.52941176470588, size: 1 },
    //     { x: 175.467625899281, y: 3.49019607843137, size: 1 },
    //     { x: 176.115107913669, y: 3.6078431372549, size: 1 },
    //     { x: 176.762589928058, y: 3.49019607843137, size: 1 },
    //     { x: 177.410071942446, y: 3.56862745098039, size: 1 },
    //     { x: 178.057553956835, y: 3.37254901960784, size: 1 },
    //     { x: 178.705035971223, y: 3.64705882352941, size: 1 },
    //     { x: 179.352517985612, y: 3.49019607843137, size: 1 },
    //     { x: 180, y: 3.76470588235294, size: 1 },
    //     { x: 180.647482014388, y: 3.72549019607843, size: 1 },
    //     { x: 181.294964028777, y: 3.52941176470588, size: 1 },
    //     { x: 181.942446043165, y: 3.37254901960784, size: 1 },
    //     { x: 182.589928057554, y: 3.52941176470588, size: 1 },
    //     { x: 183.237410071942, y: 3.49019607843137, size: 1 },
    //     { x: 183.884892086331, y: 3.6078431372549, size: 1 },
    //     { x: 184.532374100719, y: 3.56862745098039, size: 1 },
    //     { x: 185.179856115108, y: 3.49019607843137, size: 1 },
    //     { x: 185.827338129496, y: 3.6078431372549, size: 1 },
    //     { x: 186.474820143885, y: 3.68627450980392, size: 1 },
    //     { x: 187.122302158273, y: 3.37254901960784, size: 1 },
    //     { x: 187.769784172662, y: 3.49019607843137, size: 1 },
    //     { x: 188.41726618705, y: 3.68627450980392, size: 1 },
    //     { x: 189.064748201439, y: 3.45098039215686, size: 1 },
    //     { x: 189.712230215827, y: 3.45098039215686, size: 1 },
    //     { x: 190.359712230216, y: 3.52941176470588, size: 1 },
    //     { x: 191.007194244604, y: 3.6078431372549, size: 1 },
    //     { x: 191.654676258993, y: 3.68627450980392, size: 1 },
    //     { x: 192.302158273381, y: 3.29411764705882, size: 1 },
    //     { x: 192.94964028777, y: 3.37254901960784, size: 1 },
    //     { x: 193.597122302158, y: 3.45098039215686, size: 1 },
    //     { x: 194.244604316547, y: 3.56862745098039, size: 1 },
    //     { x: 194.892086330935, y: 3.64705882352941, size: 1 },
    //     { x: 195.539568345324, y: 3.49019607843137, size: 1 },
    //     { x: 196.187050359712, y: 3.64705882352941, size: 1 },
    //     { x: 196.834532374101, y: 3.92156862745098, size: 1 },
    //     { x: 197.482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 198.129496402878, y: 3.52941176470588, size: 1 },
    //     { x: 198.776978417266, y: 3.49019607843137, size: 1 },
    //     { x: 199.424460431655, y: 3.64705882352941, size: 1 },
    //     { x: 200.071942446043, y: 3.45098039215686, size: 1 },
    //     { x: 200.719424460432, y: 3.33333333333333, size: 1 },
    //     { x: 201.36690647482, y: 3.68627450980392, size: 1 },
    //     { x: 202.014388489209, y: 3.56862745098039, size: 1 },
    //     { x: 202.661870503597, y: 3.72549019607843, size: 1 },
    //     { x: 203.309352517986, y: 3.68627450980392, size: 1 },
    //     { x: 203.956834532374, y: 3.29411764705882, size: 1 },
    //     { x: 204.604316546763, y: 3.56862745098039, size: 1 },
    //     { x: 205.251798561151, y: 3.45098039215686, size: 1 },
    //     { x: 205.89928057554, y: 3.37254901960784, size: 1 },
    //     { x: 206.546762589928, y: 3.45098039215686, size: 1 },
    //     { x: 207.194244604317, y: 3.49019607843137, size: 1 },
    //     { x: 207.841726618705, y: 3.6078431372549, size: 1 },
    //     { x: 208.489208633094, y: 3.56862745098039, size: 1 },
    //     { x: 209.136690647482, y: 3.68627450980392, size: 1 },
    //     { x: 209.784172661871, y: 3.6078431372549, size: 1 },
    //     { x: 210.431654676259, y: 3.56862745098039, size: 1 },
    //     { x: 211.079136690647, y: 3.49019607843137, size: 1 },
    //     { x: 211.726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 212.374100719424, y: 3.52941176470588, size: 1 },
    //     { x: 213.021582733813, y: 3.29411764705882, size: 1 },
    //     { x: 213.669064748201, y: 3.37254901960784, size: 1 },
    //     { x: 214.31654676259, y: 3.37254901960784, size: 1 },
    //     { x: 214.964028776978, y: 3.33333333333333, size: 1 },
    //     { x: 215.611510791367, y: 3.09803921568627, size: 1 },
    //     { x: 216.258992805755, y: 2.90196078431373, size: 1 },
    //     { x: 217.553956834532, y: 3.68627450980392, size: 1 },
    //     { x: 218.201438848921, y: 3.56862745098039, size: 1 },
    //     { x: 218.848920863309, y: 3.52941176470588, size: 1 },
    //     { x: 219.496402877698, y: 3.6078431372549, size: 1 },
    //     { x: 220.143884892086, y: 3.49019607843137, size: 1 },
    //     { x: 220.791366906475, y: 3.68627450980392, size: 1 },
    //     { x: 221.438848920863, y: 3.45098039215686, size: 1 },
    //     { x: 222.086330935252, y: 3.33333333333333, size: 1 },
    //     { x: 224.028776978417, y: 3.68627450980392, size: 1 },
    //     { x: 224.676258992806, y: 3.64705882352941, size: 1 },
    //     { x: 225.323741007194, y: 3.37254901960784, size: 1 },
    //     { x: 225.971223021583, y: 3.45098039215686, size: 1 },
    //     { x: 226.618705035971, y: 3.37254901960784, size: 1 },
    //     { x: 227.26618705036, y: 3.56862745098039, size: 1 },
    //     { x: 227.913669064748, y: 3.56862745098039, size: 1 },
    //     { x: 228.561151079137, y: 3.41176470588235, size: 1 },
    //     { x: 229.208633093525, y: 3.64705882352941, size: 1 },
    //     { x: 229.856115107914, y: 3.6078431372549, size: 1 },
    //     { x: 230.503597122302, y: 3.6078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.6078431372549, size: 1 },
    //     { x: 231.798561151079, y: 3.49019607843137, size: 1 },
    //     { x: 232.446043165468, y: 3.37254901960784, size: 1 },
    //     { x: 233.093525179856, y: 3.33333333333333, size: 1 },
    //     { x: 233.741007194245, y: 3.41176470588235, size: 1 },
    //     { x: 234.388489208633, y: 3.72549019607843, size: 1 },
    //     { x: 235.035971223022, y: 3.29411764705882, size: 1 },
    //     { x: 235.68345323741, y: 3.13725490196078, size: 1 },
    //     { x: 236.330935251799, y: 3.45098039215686, size: 1 },
    //     { x: 236.978417266187, y: 3.45098039215686, size: 1 },
    //     { x: 237.625899280576, y: 3.45098039215686, size: 1 },
    //     { x: 238.273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 238.920863309353, y: 3.68627450980392, size: 1 },
    //     { x: 239.568345323741, y: 3.6078431372549, size: 1 },
    //     { x: 240.215827338129, y: 3.6078431372549, size: 1 },
    //     { x: 240.863309352518, y: 3.76470588235294, size: 1 },
    //     { x: 241.510791366906, y: 3.56862745098039, size: 1 },
    //     { x: 242.158273381295, y: 3.45098039215686, size: 1 },
    //     { x: 242.805755395683, y: 3.6078431372549, size: 1 },
    //     { x: 243.453237410072, y: 3.96078431372549, size: 1 },
    //     { x: 244.10071942446, y: 3.68627450980392, size: 1 },
    //     { x: 244.748201438849, y: 3.76470588235294, size: 1 },
    //     { x: 245.395683453237, y: 3.84313725490196, size: 1 },
    //     { x: 246.043165467626, y: 3.72549019607843, size: 1 },
    //     { x: 246.690647482014, y: 3.49019607843137, size: 1 },
    //     { x: 247.338129496403, y: 3.56862745098039, size: 1 },
    //     { x: 247.985611510791, y: 3.72549019607843, size: 1 },
    //     { x: 248.63309352518, y: 3.76470588235294, size: 1 },
    //     { x: 249.280575539568, y: 3.52941176470588, size: 1 },
    //     { x: 249.928057553957, y: 3.84313725490196, size: 1 },
    //     { x: 250.575539568345, y: 3.72549019607843, size: 1 },
    //     { x: 251.223021582734, y: 3.64705882352941, size: 1 },
    //     { x: 251.870503597122, y: 3.49019607843137, size: 1 },
    //     { x: 252.517985611511, y: 3.96078431372549, size: 1 },
    //     { x: 253.165467625899, y: 3.80392156862745, size: 1 },
    //     { x: 253.812949640288, y: 3.72549019607843, size: 1 },
    //     { x: 254.460431654676, y: 3.52941176470588, size: 1 },
    //     { x: 255.107913669065, y: 3.52941176470588, size: 1 },
    //     { x: 255.755395683453, y: 3.29411764705882, size: 1 },
    //     { x: 256.402877697842, y: 3.64705882352941, size: 1 },
    //     { x: 257.697841726619, y: 3.29411764705882, size: 1 },
    //     { x: 258.345323741007, y: 3.6078431372549, size: 1 },
    //     { x: 258.992805755396, y: 3.29411764705882, size: 1 },
    //     { x: 259.640287769784, y: 3.49019607843137, size: 1 },
    //     { x: 260.287769784173, y: 3.72549019607843, size: 1 },
    //     { x: 260.935251798561, y: 3.6078431372549, size: 1 },
    //     { x: 261.58273381295, y: 3.64705882352941, size: 1 },
    //     { x: 262.877697841727, y: 3.76470588235294, size: 1 },
    //     { x: 263.525179856115, y: 3.6078431372549, size: 1 },
    //     { x: 264.172661870504, y: 3.52941176470588, size: 1 },
    //     { x: 264.820143884892, y: 3.6078431372549, size: 1 },
    //     { x: 265.467625899281, y: 3.41176470588235, size: 1 },
    //     { x: 266.115107913669, y: 3.49019607843137, size: 1 },
    //     { x: 266.762589928058, y: 3.84313725490196, size: 1 },
    //     { x: 267.410071942446, y: 3.52941176470588, size: 1 },
    //     { x: 268.057553956835, y: 3.6078431372549, size: 1 },
    //     { x: 268.705035971223, y: 3.64705882352941, size: 1 },
    //     { x: 269.352517985611, y: 3.72549019607843, size: 1 },
    //     { x: 270.647482014389, y: 3.45098039215686, size: 1 },
    //     { x: 271.294964028777, y: 3.68627450980392, size: 1 },
    //     { x: 271.942446043165, y: 3.52941176470588, size: 1 },
    //     { x: 272.589928057554, y: 3.6078431372549, size: 1 },
    //     { x: 273.884892086331, y: 3.52941176470588, size: 1 },
    //     { x: 274.532374100719, y: 3.76470588235294, size: 1 },
    //     { x: 275.179856115108, y: 3.6078431372549, size: 1 },
    //     { x: 275.827338129496, y: 3.56862745098039, size: 1 },
    //     { x: 276.474820143885, y: 3.76470588235294, size: 1 },
    //     { x: 277.122302158273, y: 3.29411764705882, size: 1 },
    //     { x: 277.769784172662, y: 3.33333333333333, size: 1 },
    //     { x: 278.41726618705, y: 3.37254901960784, size: 1 },
    //     { x: 279.064748201439, y: 3.72549019607843, size: 1 },
    //     { x: 279.712230215827, y: 3.17647058823529, size: 1 },
    //     { x: 280.359712230216, y: 2.98039215686275, size: 1 },
    //     { x: 281.007194244604, y: 2.7843137254902, size: 1 },
    //     { x: 281.654676258993, y: 3.56862745098039, size: 1 },
    //     { x: 282.302158273381, y: 3.68627450980392, size: 1 },
    //     { x: 282.94964028777, y: 3.45098039215686, size: 1 },
    //     { x: 283.597122302158, y: 3.6078431372549, size: 1 },
    //     { x: 284.892086330935, y: 3.80392156862745, size: 1 },
    //     { x: 285.539568345324, y: 3.52941176470588, size: 1 },
    //     { x: 286.834532374101, y: 3.45098039215686, size: 1 },
    //     { x: 287.482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 288.129496402878, y: 3.52941176470588, size: 1 },
    //     { x: 288.776978417266, y: 3.68627450980392, size: 1 },
    //     { x: 289.424460431655, y: 3.72549019607843, size: 1 },
    //     { x: 290.071942446043, y: 3.64705882352941, size: 1 },
    //     { x: 290.719424460432, y: 3.52941176470588, size: 1 },
    //     { x: 291.36690647482, y: 3.56862745098039, size: 1 },
    //     { x: 292.014388489209, y: 3.56862745098039, size: 1 },
    //     { x: 292.661870503597, y: 3.68627450980392, size: 1 },
    //     { x: 293.309352517986, y: 3.64705882352941, size: 1 },
    //     { x: 293.956834532374, y: 3.76470588235294, size: 1 },
    //     { x: 294.604316546763, y: 3.6078431372549, size: 1 },
    //     { x: 295.251798561151, y: 3.56862745098039, size: 1 },
    //     { x: 295.89928057554, y: 3.68627450980392, size: 1 },
    //     { x: 296.546762589928, y: 3.80392156862745, size: 1 },
    //     { x: 297.194244604317, y: 3.84313725490196, size: 1 },
    //     { x: 297.841726618705, y: 3.80392156862745, size: 1 },
    //     { x: 298.489208633094, y: 3.6078431372549, size: 1 },
    //     { x: 299.136690647482, y: 3.45098039215686, size: 1 },
    //     { x: 299.784172661871, y: 3.6078431372549, size: 1 },
    //     { x: 300.431654676259, y: 3.01960784313725, size: 1 },
    //     { x: 301.079136690647, y: 3.17647058823529, size: 1 },
    //     { x: 301.726618705036, y: 3.05882352941176, size: 1 },
    //     { x: 302.374100719424, y: 2.98039215686275, size: 1 },
    //     { x: 303.021582733813, y: 3.6078431372549, size: 1 },
    //     { x: 303.669064748201, y: 3.76470588235294, size: 1 },
    //     { x: 304.31654676259, y: 3.49019607843137, size: 1 },
    //     { x: 304.964028776978, y: 3.72549019607843, size: 1 },
    //     { x: 305.611510791367, y: 3.76470588235294, size: 1 },
    //     { x: 306.906474820144, y: 3.6078431372549, size: 1 },
    //     { x: 307.553956834532, y: 3.56862745098039, size: 1 },
    //     { x: 308.201438848921, y: 3.68627450980392, size: 1 },
    //     { x: 308.848920863309, y: 3.72549019607843, size: 1 },
    //     { x: 310.143884892086, y: 3.76470588235294, size: 1 },
    //     { x: 310.791366906475, y: 3.76470588235294, size: 1 },
    //     { x: 311.438848920863, y: 3.56862745098039, size: 1 },
    //     { x: 312.086330935252, y: 3.72549019607843, size: 1 },
    //     { x: 312.73381294964, y: 3.6078431372549, size: 1 },
    //     { x: 313.381294964029, y: 3.68627450980392, size: 1 },
    //     { x: 314.028776978417, y: 3.6078431372549, size: 1 },
    //     { x: 314.676258992806, y: 3.6078431372549, size: 1 },
    //     { x: 315.323741007194, y: 3.6078431372549, size: 1 },
    //     { x: 315.971223021583, y: 3.52941176470588, size: 1 },
    //     { x: 316.618705035971, y: 3.6078431372549, size: 1 },
    //     { x: 317.913669064748, y: 3.52941176470588, size: 1 },
    //     { x: 318.561151079137, y: 3.56862745098039, size: 1 },
    //     { x: 319.208633093525, y: 3.6078431372549, size: 1 },
    //     { x: 319.856115107914, y: 3.52941176470588, size: 1 },
    //     { x: 321.151079136691, y: 3.56862745098039, size: 1 },
    //     { x: 321.798561151079, y: 3.29411764705882, size: 1 },
    //     { x: 322.446043165468, y: 3.25490196078431, size: 1 },
    //     { x: 323.093525179856, y: 3.05882352941176, size: 1 },
    //     { x: 323.741007194245, y: 3.17647058823529, size: 1 },
    //     { x: 324.388489208633, y: 3.68627450980392, size: 1 },
    //     { x: 325.035971223022, y: 3.45098039215686, size: 1 },
    //     { x: 325.68345323741, y: 3.72549019607843, size: 1 },
    //     { x: 326.330935251799, y: 3.72549019607843, size: 1 },
    //     { x: 326.978417266187, y: 3.72549019607843, size: 1 },
    //     { x: 327.625899280576, y: 3.6078431372549, size: 1 },
    //     { x: 328.273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 328.920863309353, y: 3.56862745098039, size: 1 },
    //     { x: 330.215827338129, y: 3.41176470588235, size: 1 },
    //     { x: 330.863309352518, y: 3.64705882352941, size: 1 },
    //     { x: 332.158273381295, y: 3.52941176470588, size: 1 },
    //     { x: 332.805755395683, y: 3.68627450980392, size: 1 },
    //     { x: 334.10071942446, y: 3.76470588235294, size: 1 },
    //     { x: 334.748201438849, y: 3.76470588235294, size: 1 },
    //     { x: 335.395683453237, y: 3.88235294117647, size: 1 },
    //     { x: 336.043165467626, y: 3.72549019607843, size: 1 },
    //     { x: 336.690647482014, y: 3.56862745098039, size: 1 },
    //     { x: 337.338129496403, y: 3.49019607843137, size: 1 },
    //     { x: 337.985611510791, y: 3.56862745098039, size: 1 },
    //     { x: 338.63309352518, y: 3.6078431372549, size: 1 },
    //     { x: 339.280575539568, y: 3.64705882352941, size: 1 },
    //     { x: 339.928057553957, y: 3.45098039215686, size: 1 },
    //     { x: 340.575539568345, y: 3.64705882352941, size: 1 },
    //     { x: 341.223021582734, y: 3.68627450980392, size: 1 },
    //     { x: 341.870503597122, y: 3.72549019607843, size: 1 },
    //     { x: 343.165467625899, y: 3.52941176470588, size: 1 },
    //     { x: 343.812949640288, y: 3.33333333333333, size: 1 },
    //     { x: 344.460431654676, y: 3.72549019607843, size: 1 },
    //     { x: 345.107913669065, y: 4, size: 1 },
    //     { x: 346.402877697842, y: 3.84313725490196, size: 1 },
    //     { x: 347.05035971223, y: 3.76470588235294, size: 1 },
    //     { x: 347.697841726619, y: 3.84313725490196, size: 1 },
    //     { x: 348.345323741007, y: 3.6078431372549, size: 1 },
    //     { x: 348.992805755396, y: 3.6078431372549, size: 1 },
    //     { x: 349.640287769784, y: 3.68627450980392, size: 1 },
    //     { x: 350.287769784173, y: 3.64705882352941, size: 1 },
    //     { x: 350.935251798561, y: 3.84313725490196, size: 1 },
    //     { x: 351.58273381295, y: 3.76470588235294, size: 1 },
    //     { x: 352.230215827338, y: 3.6078431372549, size: 1 },
    //     { x: 352.877697841727, y: 3.68627450980392, size: 1 },
    //     { x: 353.525179856115, y: 3.56862745098039, size: 1 },
    //     { x: 354.172661870504, y: 3.56862745098039, size: 1 },
    //     { x: 354.820143884892, y: 3.64705882352941, size: 1 },
    //     { x: 355.467625899281, y: 3.6078431372549, size: 1 },
    //     { x: 356.115107913669, y: 3.6078431372549, size: 1 },
    //     { x: 356.762589928058, y: 3.88235294117647, size: 1 },
    //     { x: 357.410071942446, y: 3.52941176470588, size: 1 },
    //     { x: 358.057553956835, y: 3.68627450980392, size: 1 },
    //     { x: 358.705035971223, y: 3.68627450980392, size: 1 },
    //     { x: 359.352517985611, y: 3.72549019607843, size: 1 },
    //     { x: 0.648648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 1.2972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 1.94594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 2.59459459459459, y: 4, size: 1 },
    //     { x: 3.24324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 3.89189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 4.54054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 5.18918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 5.83783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 6.48648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 7.13513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 7.78378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 8.43243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 9.08108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 9.72972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 10.3783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 11.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 11.6756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 12.3243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 12.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 13.6216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 14.2702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 14.9189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 15.5675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 16.2162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 16.8648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 17.5135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 18.1621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 18.8108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 19.4594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 20.1081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 20.7567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 21.4054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 22.0540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 22.7027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 23.3513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 24, y: 3.88235294117647, size: 1 },
    //     { x: 24.6486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 25.2972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 25.9459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 26.5945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 27.2432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 27.8918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 28.5405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 29.1891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 29.8378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 30.4864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 31.1351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 31.7837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 32.4324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 33.0810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 33.7297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 34.3783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 35.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 35.6756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 36.3243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 36.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 37.6216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 38.2702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 38.9189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 39.5675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 40.2162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 40.8648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 41.5135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 42.1621621621622, y: 4, size: 1 },
    //     { x: 42.8108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 43.4594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 44.1081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 44.7567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 45.4054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 46.0540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 46.7027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 47.3513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 48, y: 3.37254901960784, size: 1 },
    //     { x: 48.6486486486486, y: 2.94117647058824, size: 1 },
    //     { x: 49.2972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 49.9459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 50.5945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 51.2432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 51.8918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 52.5405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 53.1891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 53.8378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 54.4864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 55.1351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 55.7837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 56.4324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 57.0810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 57.7297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 58.3783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 59.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 59.6756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 60.3243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 60.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 61.6216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 62.2702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 62.9189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 63.5675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 64.2162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 64.8648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 65.5135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 66.1621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 66.8108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 67.4594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 68.1081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 68.7567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 69.4054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 70.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 70.7027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 71.3513513513514, y: 2.94117647058824, size: 1 },
    //     { x: 72, y: 3.33333333333333, size: 1 },
    //     { x: 72.6486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 73.2972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 73.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 74.5945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 75.2432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 75.8918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 76.5405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 77.1891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 77.8378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 78.4864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 79.1351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 79.7837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 80.4324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 81.0810810810811, y: 4, size: 1 },
    //     { x: 81.7297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 82.3783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 83.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 83.6756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 84.3243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 84.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 85.6216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 86.2702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 86.9189189189189, y: 4, size: 1 },
    //     { x: 87.5675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 88.2162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 88.8648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 89.5135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 90.1621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 90.8108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 91.4594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 92.1081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 92.7567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 93.4054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 94.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 94.7027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 95.3513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 96, y: 3.72549019607843, size: 1 },
    //     { x: 96.6486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 97.2972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 97.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 98.5945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 99.2432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 99.8918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 100.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 101.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 101.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 102.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 103.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 103.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 104.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 105.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 105.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 106.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 107.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 107.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 108.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 108.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 109.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 110.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 110.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 111.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 112.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 112.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 113.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 114.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 114.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 115.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 116.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 116.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 117.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 118.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 118.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 119.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 120, y: 3.68627450980392, size: 1 },
    //     { x: 120.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 121.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 121.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 122.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 123.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 123.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 124.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 125.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 125.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 126.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 127.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 127.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 128.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 129.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 129.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 130.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 131.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 131.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 132.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 132.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 133.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 134.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 134.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 135.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 136.216216216216, y: 2.90196078431373, size: 1 },
    //     { x: 136.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 137.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 138.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 138.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 139.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 140.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 140.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 141.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 142.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 142.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 143.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 144, y: 3.41176470588235, size: 1 },
    //     { x: 144.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 145.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 145.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 146.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 147.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 147.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 148.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 149.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 149.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 150.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 151.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 151.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 152.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 153.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 153.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 154.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 155.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 155.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 156.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 156.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 157.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 158.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 158.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 159.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 160.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 160.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 161.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 162.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 162.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 163.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 164.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 164.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 165.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 166.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 166.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 167.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 168, y: 3.64705882352941, size: 1 },
    //     { x: 168.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 169.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 169.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 170.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 171.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 171.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 172.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 173.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 173.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 174.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 175.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 175.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 176.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 177.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 177.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 178.378378378378, y: 2.90196078431373, size: 1 },
    //     { x: 179.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 179.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 180.324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 180.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 181.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 182.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 182.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 183.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 184.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 184.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 185.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 186.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 186.810810810811, y: 4.11764705882353, size: 1 },
    //     { x: 187.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 188.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 188.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 189.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 190.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 190.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 191.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 192, y: 3.64705882352941, size: 1 },
    //     { x: 192.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 193.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 193.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 194.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 195.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 195.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 196.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 197.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 197.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 198.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 199.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 199.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 200.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 201.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 201.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 202.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 203.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 203.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 204.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 204.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 205.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 206.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 206.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 207.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 208.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 208.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 209.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 210.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 210.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 211.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 212.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 212.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 213.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 214.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 214.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 215.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 216, y: 3.45098039215686, size: 1 },
    //     { x: 216.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 217.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 217.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 218.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 219.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 219.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 220.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 221.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 221.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 222.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 223.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 223.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 224.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 225.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 225.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 226.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 227.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 227.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 228.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 228.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 229.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 230.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 230.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 231.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 232.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 232.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 233.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 234.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 234.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 235.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 236.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 236.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 237.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 238.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 238.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 239.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 240, y: 3.52941176470588, size: 1 },
    //     { x: 240.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 241.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 241.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 242.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 243.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 243.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 244.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 245.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 245.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 246.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 247.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 247.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 248.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 249.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 249.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 250.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 251.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 251.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 252.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 252.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 253.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 254.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 254.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 255.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 256.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 256.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 257.513513513513, y: 3.6078431372549, size: 1 },
    //     { x: 258.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 258.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 259.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 260.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 260.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 261.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 262.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 262.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 263.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 264, y: 3.29411764705882, size: 1 },
    //     { x: 264.648648648649, y: 2.54901960784314, size: 1 },
    //     { x: 265.297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 265.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 266.594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 267.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 267.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 268.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 269.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 269.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 270.486486486487, y: 3.29411764705882, size: 1 },
    //     { x: 271.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 271.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 272.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 273.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 273.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 274.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 275.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 275.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 276.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 276.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 277.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 278.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 278.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 279.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 280.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 280.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 281.513513513513, y: 3.49019607843137, size: 1 },
    //     { x: 282.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 282.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 283.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 284.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 284.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 285.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 286.054054054054, y: 2.62745098039216, size: 1 },
    //     { x: 286.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 287.351351351351, y: 2.70588235294118, size: 1 },
    //     { x: 288, y: 2.90196078431373, size: 1 },
    //     { x: 288.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 289.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 289.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 290.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 291.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 291.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 292.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 293.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 293.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 294.486486486487, y: 3.80392156862745, size: 1 },
    //     { x: 295.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 295.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 296.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 297.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 297.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 298.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 299.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 299.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 300.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 300.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 301.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 302.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 302.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 303.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 304.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 304.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 305.513513513513, y: 3.37254901960784, size: 1 },
    //     { x: 306.162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 306.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 307.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 308.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 308.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 309.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 310.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 310.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 311.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 312, y: 3.64705882352941, size: 1 },
    //     { x: 312.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 313.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 313.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 314.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 315.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 315.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 316.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 317.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 317.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 318.486486486487, y: 3.56862745098039, size: 1 },
    //     { x: 319.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 319.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 320.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 321.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 321.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 322.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 323.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 323.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 324.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 324.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 325.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 326.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 326.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 327.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 328.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 328.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 329.513513513513, y: 3.56862745098039, size: 1 },
    //     { x: 330.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 330.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 331.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 332.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 332.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 333.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 334.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 334.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 335.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 336, y: 3.37254901960784, size: 1 },
    //     { x: 336.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 337.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 337.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 338.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 339.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 339.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 340.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 341.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 341.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 342.486486486487, y: 3.56862745098039, size: 1 },
    //     { x: 343.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 343.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 344.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 345.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 345.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 346.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 347.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 347.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 348.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 348.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 349.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 350.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 350.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 351.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 352.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 352.864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 353.513513513513, y: 3.6078431372549, size: 1 },
    //     { x: 354.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 354.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 355.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 356.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 356.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 357.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 358.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 358.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 359.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 0, y: 3.6078431372549, size: 1 },
    //     { x: 0.647482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 1.29496402877698, y: 3.68627450980392, size: 1 },
    //     { x: 1.94244604316547, y: 3.6078431372549, size: 1 },
    //     { x: 2.58992805755396, y: 3.68627450980392, size: 1 },
    //     { x: 3.23741007194245, y: 3.68627450980392, size: 1 },
    //     { x: 3.88489208633094, y: 3.52941176470588, size: 1 },
    //     { x: 4.53237410071942, y: 3.52941176470588, size: 1 },
    //     { x: 5.17985611510791, y: 3.52941176470588, size: 1 },
    //     { x: 5.8273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 6.47482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 7.12230215827338, y: 3.6078431372549, size: 1 },
    //     { x: 7.76978417266187, y: 3.6078431372549, size: 1 },
    //     { x: 8.41726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 9.06474820143885, y: 3.80392156862745, size: 1 },
    //     { x: 9.71223021582734, y: 3.45098039215686, size: 1 },
    //     { x: 10.3597122302158, y: 3.64705882352941, size: 1 },
    //     { x: 11.0071942446043, y: 3.76470588235294, size: 1 },
    //     { x: 11.6546762589928, y: 3.68627450980392, size: 1 },
    //     { x: 12.3021582733813, y: 4, size: 1 },
    //     { x: 12.9496402877698, y: 3.33333333333333, size: 1 },
    //     { x: 13.5971223021583, y: 3.33333333333333, size: 1 },
    //     { x: 14.8920863309353, y: 3.41176470588235, size: 1 },
    //     { x: 15.5395683453237, y: 3.29411764705882, size: 1 },
    //     { x: 16.1870503597122, y: 3.45098039215686, size: 1 },
    //     { x: 16.8345323741007, y: 3.52941176470588, size: 1 },
    //     { x: 17.4820143884892, y: 3.56862745098039, size: 1 },
    //     { x: 18.1294964028777, y: 3.41176470588235, size: 1 },
    //     { x: 18.7769784172662, y: 3.49019607843137, size: 1 },
    //     { x: 19.4244604316547, y: 3.49019607843137, size: 1 },
    //     { x: 20.0719424460432, y: 3.6078431372549, size: 1 },
    //     { x: 20.7194244604317, y: 3.29411764705882, size: 1 },
    //     { x: 21.3669064748201, y: 3.37254901960784, size: 1 },
    //     { x: 22.0143884892086, y: 3.52941176470588, size: 1 },
    //     { x: 22.6618705035971, y: 3.37254901960784, size: 1 },
    //     { x: 23.3093525179856, y: 3.41176470588235, size: 1 },
    //     { x: 23.9568345323741, y: 3.56862745098039, size: 1 },
    //     { x: 24.6043165467626, y: 3.37254901960784, size: 1 },
    //     { x: 25.8992805755396, y: 3.29411764705882, size: 1 },
    //     { x: 26.5467625899281, y: 3.25490196078431, size: 1 },
    //     { x: 27.1942446043165, y: 3.41176470588235, size: 1 },
    //     { x: 27.841726618705, y: 3.64705882352941, size: 1 },
    //     { x: 28.4892086330935, y: 3.6078431372549, size: 1 },
    //     { x: 29.136690647482, y: 3.76470588235294, size: 1 },
    //     { x: 29.7841726618705, y: 3.33333333333333, size: 1 },
    //     { x: 30.431654676259, y: 3.37254901960784, size: 1 },
    //     { x: 31.0791366906475, y: 3.72549019607843, size: 1 },
    //     { x: 31.726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 32.3741007194245, y: 3.45098039215686, size: 1 },
    //     { x: 33.0215827338129, y: 3.6078431372549, size: 1 },
    //     { x: 33.6690647482014, y: 3.33333333333333, size: 1 },
    //     { x: 34.3165467625899, y: 3.05882352941176, size: 1 },
    //     { x: 34.9640287769784, y: 2.74509803921569, size: 1 },
    //     { x: 35.6115107913669, y: 3.2156862745098, size: 1 },
    //     { x: 36.2589928057554, y: 3.09803921568627, size: 1 },
    //     { x: 36.9064748201439, y: 3.41176470588235, size: 1 },
    //     { x: 37.5539568345324, y: 3.52941176470588, size: 1 },
    //     { x: 39.4964028776978, y: 3.68627450980392, size: 1 },
    //     { x: 40.1438848920863, y: 3.37254901960784, size: 1 },
    //     { x: 40.7913669064748, y: 3.64705882352941, size: 1 },
    //     { x: 41.4388489208633, y: 3.41176470588235, size: 1 },
    //     { x: 42.0863309352518, y: 3.49019607843137, size: 1 },
    //     { x: 42.7338129496403, y: 3.52941176470588, size: 1 },
    //     { x: 43.3812949640288, y: 3.64705882352941, size: 1 },
    //     { x: 44.6762589928058, y: 3.88235294117647, size: 1 },
    //     { x: 45.3237410071942, y: 3.41176470588235, size: 1 },
    //     { x: 45.9712230215827, y: 3.45098039215686, size: 1 },
    //     { x: 46.6187050359712, y: 3.52941176470588, size: 1 },
    //     { x: 47.2661870503597, y: 3.76470588235294, size: 1 },
    //     { x: 47.9136690647482, y: 3.72549019607843, size: 1 },
    //     { x: 48.5611510791367, y: 3.56862745098039, size: 1 },
    //     { x: 49.2086330935252, y: 3.72549019607843, size: 1 },
    //     { x: 49.8561151079137, y: 3.76470588235294, size: 1 },
    //     { x: 50.5035971223022, y: 3.76470588235294, size: 1 },
    //     { x: 51.1510791366906, y: 3.6078431372549, size: 1 },
    //     { x: 52.4460431654676, y: 3.37254901960784, size: 1 },
    //     { x: 53.0935251798561, y: 3.45098039215686, size: 1 },
    //     { x: 53.7410071942446, y: 3.29411764705882, size: 1 },
    //     { x: 54.3884892086331, y: 3.45098039215686, size: 1 },
    //     { x: 55.0359712230216, y: 3.29411764705882, size: 1 },
    //     { x: 55.6834532374101, y: 3.37254901960784, size: 1 },
    //     { x: 56.3309352517986, y: 3.2156862745098, size: 1 },
    //     { x: 56.9784172661871, y: 3.2156862745098, size: 1 },
    //     { x: 57.6258992805755, y: 3.2156862745098, size: 1 },
    //     { x: 58.273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 58.9208633093525, y: 3.76470588235294, size: 1 },
    //     { x: 59.568345323741, y: 3.64705882352941, size: 1 },
    //     { x: 60.2158273381295, y: 3.56862745098039, size: 1 },
    //     { x: 60.863309352518, y: 4, size: 1 },
    //     { x: 61.5107913669065, y: 3.64705882352941, size: 1 },
    //     { x: 62.8057553956835, y: 3.72549019607843, size: 1 },
    //     { x: 63.4532374100719, y: 3.6078431372549, size: 1 },
    //     { x: 64.1007194244604, y: 3.76470588235294, size: 1 },
    //     { x: 64.7482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 65.3956834532374, y: 3.64705882352941, size: 1 },
    //     { x: 66.0431654676259, y: 3.64705882352941, size: 1 },
    //     { x: 66.6906474820144, y: 3.84313725490196, size: 1 },
    //     { x: 67.9856115107914, y: 3.49019607843137, size: 1 },
    //     { x: 68.6330935251799, y: 3.72549019607843, size: 1 },
    //     { x: 69.2805755395683, y: 3.76470588235294, size: 1 },
    //     { x: 69.9280575539568, y: 3.80392156862745, size: 1 },
    //     { x: 70.5755395683453, y: 3.84313725490196, size: 1 },
    //     { x: 71.2230215827338, y: 3.64705882352941, size: 1 },
    //     { x: 71.8705035971223, y: 3.6078431372549, size: 1 },
    //     { x: 72.5179856115108, y: 3.64705882352941, size: 1 },
    //     { x: 73.8129496402878, y: 3.68627450980392, size: 1 },
    //     { x: 74.4604316546763, y: 3.52941176470588, size: 1 },
    //     { x: 75.1079136690647, y: 3.64705882352941, size: 1 },
    //     { x: 75.7553956834532, y: 3.68627450980392, size: 1 },
    //     { x: 76.4028776978417, y: 3.45098039215686, size: 1 },
    //     { x: 77.0503597122302, y: 3.6078431372549, size: 1 },
    //     { x: 77.6978417266187, y: 3.25490196078431, size: 1 },
    //     { x: 78.3453237410072, y: 3.41176470588235, size: 1 },
    //     { x: 78.9928057553957, y: 3.64705882352941, size: 1 },
    //     { x: 79.6402877697842, y: 3.76470588235294, size: 1 },
    //     { x: 80.2877697841727, y: 3.6078431372549, size: 1 },
    //     { x: 80.9352517985612, y: 3.64705882352941, size: 1 },
    //     { x: 81.5827338129496, y: 3.68627450980392, size: 1 },
    //     { x: 82.2302158273381, y: 3.52941176470588, size: 1 },
    //     { x: 82.8776978417266, y: 3.68627450980392, size: 1 },
    //     { x: 83.5251798561151, y: 3.6078431372549, size: 1 },
    //     { x: 84.1726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 84.8201438848921, y: 3.52941176470588, size: 1 },
    //     { x: 85.4676258992806, y: 3.6078431372549, size: 1 },
    //     { x: 86.1151079136691, y: 3.6078431372549, size: 1 },
    //     { x: 86.7625899280576, y: 3.68627450980392, size: 1 },
    //     { x: 87.410071942446, y: 3.49019607843137, size: 1 },
    //     { x: 88.0575539568345, y: 3.49019607843137, size: 1 },
    //     { x: 88.705035971223, y: 3.56862745098039, size: 1 },
    //     { x: 89.3525179856115, y: 3.6078431372549, size: 1 },
    //     { x: 90, y: 3.52941176470588, size: 1 },
    //     { x: 90.6474820143885, y: 3.6078431372549, size: 1 },
    //     { x: 91.294964028777, y: 3.6078431372549, size: 1 },
    //     { x: 92.589928057554, y: 3.68627450980392, size: 1 },
    //     { x: 93.2374100719424, y: 3.52941176470588, size: 1 },
    //     { x: 93.8848920863309, y: 3.6078431372549, size: 1 },
    //     { x: 94.5323741007194, y: 3.52941176470588, size: 1 },
    //     { x: 96.4748201438849, y: 3.6078431372549, size: 1 },
    //     { x: 97.1223021582734, y: 3.52941176470588, size: 1 },
    //     { x: 97.7697841726619, y: 3.49019607843137, size: 1 },
    //     { x: 98.4172661870504, y: 3.45098039215686, size: 1 },
    //     { x: 99.0647482014388, y: 2.90196078431373, size: 1 },
    //     { x: 99.7122302158273, y: 2.86274509803922, size: 1 },
    //     { x: 100.359712230216, y: 3.56862745098039, size: 1 },
    //     { x: 101.007194244604, y: 3.45098039215686, size: 1 },
    //     { x: 101.654676258993, y: 3.49019607843137, size: 1 },
    //     { x: 102.302158273381, y: 3.49019607843137, size: 1 },
    //     { x: 102.94964028777, y: 3.52941176470588, size: 1 },
    //     { x: 103.597122302158, y: 3.56862745098039, size: 1 },
    //     { x: 104.244604316547, y: 3.68627450980392, size: 1 },
    //     { x: 104.892086330935, y: 3.45098039215686, size: 1 },
    //     { x: 105.539568345324, y: 3.49019607843137, size: 1 },
    //     { x: 106.187050359712, y: 3.56862745098039, size: 1 },
    //     { x: 106.834532374101, y: 3.41176470588235, size: 1 },
    //     { x: 108.129496402878, y: 3.72549019607843, size: 1 },
    //     { x: 108.776978417266, y: 3.72549019607843, size: 1 },
    //     { x: 109.424460431655, y: 3.68627450980392, size: 1 },
    //     { x: 110.071942446043, y: 3.64705882352941, size: 1 },
    //     { x: 110.719424460432, y: 3.49019607843137, size: 1 },
    //     { x: 111.36690647482, y: 3.56862745098039, size: 1 },
    //     { x: 112.014388489209, y: 3.52941176470588, size: 1 },
    //     { x: 113.309352517986, y: 3.56862745098039, size: 1 },
    //     { x: 113.956834532374, y: 3.64705882352941, size: 1 },
    //     { x: 114.604316546763, y: 3.64705882352941, size: 1 },
    //     { x: 115.251798561151, y: 3.76470588235294, size: 1 },
    //     { x: 115.89928057554, y: 3.52941176470588, size: 1 },
    //     { x: 116.546762589928, y: 3.52941176470588, size: 1 },
    //     { x: 117.194244604317, y: 3.52941176470588, size: 1 },
    //     { x: 117.841726618705, y: 3.37254901960784, size: 1 },
    //     { x: 118.489208633094, y: 3.49019607843137, size: 1 },
    //     { x: 119.136690647482, y: 3.64705882352941, size: 1 },
    //     { x: 119.784172661871, y: 3.6078431372549, size: 1 },
    //     { x: 120.431654676259, y: 3.68627450980392, size: 1 },
    //     { x: 121.079136690647, y: 3.41176470588235, size: 1 },
    //     { x: 121.726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 123.021582733813, y: 3.6078431372549, size: 1 },
    //     { x: 123.669064748201, y: 3.45098039215686, size: 1 },
    //     { x: 124.31654676259, y: 3.56862745098039, size: 1 },
    //     { x: 124.964028776978, y: 3.64705882352941, size: 1 },
    //     { x: 125.611510791367, y: 3.72549019607843, size: 1 },
    //     { x: 126.258992805755, y: 3.52941176470588, size: 1 },
    //     { x: 126.906474820144, y: 3.37254901960784, size: 1 },
    //     { x: 127.553956834532, y: 3.45098039215686, size: 1 },
    //     { x: 128.201438848921, y: 3.37254901960784, size: 1 },
    //     { x: 128.848920863309, y: 3.6078431372549, size: 1 },
    //     { x: 129.496402877698, y: 3.64705882352941, size: 1 },
    //     { x: 130.143884892086, y: 3.56862745098039, size: 1 },
    //     { x: 130.791366906475, y: 3.41176470588235, size: 1 },
    //     { x: 131.438848920863, y: 3.56862745098039, size: 1 },
    //     { x: 132.086330935252, y: 3.6078431372549, size: 1 },
    //     { x: 132.73381294964, y: 3.52941176470588, size: 1 },
    //     { x: 133.381294964029, y: 3.52941176470588, size: 1 },
    //     { x: 134.028776978417, y: 3.41176470588235, size: 1 },
    //     { x: 134.676258992806, y: 3.49019607843137, size: 1 },
    //     { x: 135.323741007194, y: 3.6078431372549, size: 1 },
    //     { x: 135.971223021583, y: 3.68627450980392, size: 1 },
    //     { x: 136.618705035971, y: 3.45098039215686, size: 1 },
    //     { x: 137.26618705036, y: 3.37254901960784, size: 1 },
    //     { x: 137.913669064748, y: 3.6078431372549, size: 1 },
    //     { x: 138.561151079137, y: 3.33333333333333, size: 1 },
    //     { x: 139.208633093525, y: 3.41176470588235, size: 1 },
    //     { x: 139.856115107914, y: 3.6078431372549, size: 1 },
    //     { x: 140.503597122302, y: 3.64705882352941, size: 1 },
    //     { x: 141.151079136691, y: 3.6078431372549, size: 1 },
    //     { x: 141.798561151079, y: 3.41176470588235, size: 1 },
    //     { x: 142.446043165468, y: 3.52941176470588, size: 1 },
    //     { x: 143.093525179856, y: 3.29411764705882, size: 1 },
    //     { x: 143.741007194245, y: 3.33333333333333, size: 1 },
    //     { x: 144.388489208633, y: 3.41176470588235, size: 1 },
    //     { x: 145.035971223022, y: 3.41176470588235, size: 1 },
    //     { x: 145.68345323741, y: 3.37254901960784, size: 1 },
    //     { x: 146.330935251799, y: 3.37254901960784, size: 1 },
    //     { x: 146.978417266187, y: 3.6078431372549, size: 1 },
    //     { x: 147.625899280576, y: 3.41176470588235, size: 1 },
    //     { x: 148.273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 148.920863309353, y: 3.33333333333333, size: 1 },
    //     { x: 149.568345323741, y: 3.41176470588235, size: 1 },
    //     { x: 150.215827338129, y: 3.41176470588235, size: 1 },
    //     { x: 151.510791366906, y: 3.52941176470588, size: 1 },
    //     { x: 152.158273381295, y: 3.49019607843137, size: 1 },
    //     { x: 152.805755395683, y: 3.25490196078431, size: 1 },
    //     { x: 153.453237410072, y: 3.49019607843137, size: 1 },
    //     { x: 154.10071942446, y: 3.29411764705882, size: 1 },
    //     { x: 154.748201438849, y: 3.6078431372549, size: 1 },
    //     { x: 155.395683453237, y: 3.37254901960784, size: 1 },
    //     { x: 156.043165467626, y: 3.41176470588235, size: 1 },
    //     { x: 156.690647482014, y: 3.56862745098039, size: 1 },
    //     { x: 157.338129496403, y: 3.25490196078431, size: 1 },
    //     { x: 157.985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 158.63309352518, y: 3.49019607843137, size: 1 },
    //     { x: 159.280575539568, y: 3.45098039215686, size: 1 },
    //     { x: 159.928057553957, y: 3.37254901960784, size: 1 },
    //     { x: 160.575539568345, y: 3.33333333333333, size: 1 },
    //     { x: 161.223021582734, y: 3.45098039215686, size: 1 },
    //     { x: 161.870503597122, y: 3.29411764705882, size: 1 },
    //     { x: 163.165467625899, y: 3.05882352941176, size: 1 },
    //     { x: 163.812949640288, y: 2.82352941176471, size: 1 },
    //     { x: 164.460431654676, y: 2.54901960784314, size: 1 },
    //     { x: 165.107913669065, y: 2.62745098039216, size: 1 },
    //     { x: 165.755395683453, y: 2.70588235294118, size: 1 },
    //     { x: 166.402877697842, y: 3.72549019607843, size: 1 },
    //     { x: 167.05035971223, y: 3.72549019607843, size: 1 },
    //     { x: 167.697841726619, y: 3.56862745098039, size: 1 },
    //     { x: 168.345323741007, y: 3.88235294117647, size: 1 },
    //     { x: 168.992805755396, y: 3.56862745098039, size: 1 },
    //     { x: 170.287769784173, y: 3.80392156862745, size: 1 },
    //     { x: 170.935251798561, y: 3.6078431372549, size: 1 },
    //     { x: 172.230215827338, y: 3.56862745098039, size: 1 },
    //     { x: 172.877697841727, y: 3.72549019607843, size: 1 },
    //     { x: 173.525179856115, y: 3.76470588235294, size: 1 },
    //     { x: 174.172661870504, y: 3.68627450980392, size: 1 },
    //     { x: 174.820143884892, y: 3.68627450980392, size: 1 },
    //     { x: 175.467625899281, y: 3.80392156862745, size: 1 },
    //     { x: 176.115107913669, y: 3.64705882352941, size: 1 },
    //     { x: 176.762589928058, y: 3.68627450980392, size: 1 },
    //     { x: 177.410071942446, y: 3.41176470588235, size: 1 },
    //     { x: 178.057553956835, y: 3.76470588235294, size: 1 },
    //     { x: 178.705035971223, y: 3.56862745098039, size: 1 },
    //     { x: 179.352517985612, y: 3.56862745098039, size: 1 },
    //     { x: 180, y: 3.64705882352941, size: 1 },
    //     { x: 181.942446043165, y: 3.52941176470588, size: 1 },
    //     { x: 182.589928057554, y: 3.72549019607843, size: 1 },
    //     { x: 183.884892086331, y: 3.09803921568627, size: 1 },
    //     { x: 184.532374100719, y: 3.41176470588235, size: 1 },
    //     { x: 185.179856115108, y: 3.17647058823529, size: 1 },
    //     { x: 185.827338129496, y: 3.2156862745098, size: 1 },
    //     { x: 186.474820143885, y: 3.13725490196078, size: 1 },
    //     { x: 187.122302158273, y: 2.98039215686275, size: 1 },
    //     { x: 187.769784172662, y: 3.41176470588235, size: 1 },
    //     { x: 188.41726618705, y: 3.56862745098039, size: 1 },
    //     { x: 189.712230215827, y: 3.37254901960784, size: 1 },
    //     { x: 190.359712230216, y: 3.6078431372549, size: 1 },
    //     { x: 191.007194244604, y: 3.56862745098039, size: 1 },
    //     { x: 191.654676258993, y: 3.49019607843137, size: 1 },
    //     { x: 192.302158273381, y: 3.64705882352941, size: 1 },
    //     { x: 192.94964028777, y: 3.56862745098039, size: 1 },
    //     { x: 194.244604316547, y: 3.52941176470588, size: 1 },
    //     { x: 194.892086330935, y: 3.52941176470588, size: 1 },
    //     { x: 195.539568345324, y: 3.6078431372549, size: 1 },
    //     { x: 196.187050359712, y: 3.52941176470588, size: 1 },
    //     { x: 196.834532374101, y: 3.49019607843137, size: 1 },
    //     { x: 197.482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 198.129496402878, y: 3.72549019607843, size: 1 },
    //     { x: 198.776978417266, y: 3.76470588235294, size: 1 },
    //     { x: 199.424460431655, y: 3.52941176470588, size: 1 },
    //     { x: 200.719424460432, y: 3.37254901960784, size: 1 },
    //     { x: 202.014388489209, y: 3.6078431372549, size: 1 },
    //     { x: 202.661870503597, y: 3.49019607843137, size: 1 },
    //     { x: 203.309352517986, y: 3.72549019607843, size: 1 },
    //     { x: 203.956834532374, y: 3.49019607843137, size: 1 },
    //     { x: 204.604316546763, y: 3.45098039215686, size: 1 },
    //     { x: 205.89928057554, y: 3.6078431372549, size: 1 },
    //     { x: 206.546762589928, y: 3.88235294117647, size: 1 },
    //     { x: 207.194244604317, y: 3.52941176470588, size: 1 },
    //     { x: 207.841726618705, y: 3.76470588235294, size: 1 },
    //     { x: 209.136690647482, y: 3.76470588235294, size: 1 },
    //     { x: 210.431654676259, y: 3.64705882352941, size: 1 },
    //     { x: 211.726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 212.374100719424, y: 3.49019607843137, size: 1 },
    //     { x: 213.021582733813, y: 3.41176470588235, size: 1 },
    //     { x: 213.669064748201, y: 3.6078431372549, size: 1 },
    //     { x: 214.31654676259, y: 3.72549019607843, size: 1 },
    //     { x: 214.964028776978, y: 3.68627450980392, size: 1 },
    //     { x: 215.611510791367, y: 3.76470588235294, size: 1 },
    //     { x: 216.258992805755, y: 3.6078431372549, size: 1 },
    //     { x: 216.906474820144, y: 3.6078431372549, size: 1 },
    //     { x: 217.553956834532, y: 3.72549019607843, size: 1 },
    //     { x: 218.848920863309, y: 3.72549019607843, size: 1 },
    //     { x: 219.496402877698, y: 3.64705882352941, size: 1 },
    //     { x: 220.143884892086, y: 3.45098039215686, size: 1 },
    //     { x: 220.791366906475, y: 3.52941176470588, size: 1 },
    //     { x: 221.438848920863, y: 3.68627450980392, size: 1 },
    //     { x: 222.086330935252, y: 3.84313725490196, size: 1 },
    //     { x: 222.73381294964, y: 3.92156862745098, size: 1 },
    //     { x: 223.381294964029, y: 3.68627450980392, size: 1 },
    //     { x: 224.028776978417, y: 3.56862745098039, size: 1 },
    //     { x: 224.676258992806, y: 3.88235294117647, size: 1 },
    //     { x: 225.323741007194, y: 3.64705882352941, size: 1 },
    //     { x: 225.971223021583, y: 3.76470588235294, size: 1 },
    //     { x: 226.618705035971, y: 3.6078431372549, size: 1 },
    //     { x: 227.26618705036, y: 3.52941176470588, size: 1 },
    //     { x: 227.913669064748, y: 3.41176470588235, size: 1 },
    //     { x: 228.561151079137, y: 3.13725490196078, size: 1 },
    //     { x: 229.208633093525, y: 3.17647058823529, size: 1 },
    //     { x: 229.856115107914, y: 3.80392156862745, size: 1 },
    //     { x: 230.503597122302, y: 3.64705882352941, size: 1 },
    //     { x: 231.151079136691, y: 3.72549019607843, size: 1 },
    //     { x: 231.798561151079, y: 3.64705882352941, size: 1 },
    //     { x: 232.446043165468, y: 3.64705882352941, size: 1 },
    //     { x: 233.093525179856, y: 3.6078431372549, size: 1 },
    //     { x: 233.741007194245, y: 3.72549019607843, size: 1 },
    //     { x: 235.035971223022, y: 3.72549019607843, size: 1 },
    //     { x: 235.68345323741, y: 3.64705882352941, size: 1 },
    //     { x: 236.330935251799, y: 3.72549019607843, size: 1 },
    //     { x: 236.978417266187, y: 3.88235294117647, size: 1 },
    //     { x: 237.625899280576, y: 3.64705882352941, size: 1 },
    //     { x: 238.273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 238.920863309353, y: 3.72549019607843, size: 1 },
    //     { x: 239.568345323741, y: 4, size: 1 },
    //     { x: 240.215827338129, y: 3.64705882352941, size: 1 },
    //     { x: 240.863309352518, y: 3.68627450980392, size: 1 },
    //     { x: 241.510791366906, y: 3.49019607843137, size: 1 },
    //     { x: 242.158273381295, y: 3.52941176470588, size: 1 },
    //     { x: 242.805755395683, y: 3.84313725490196, size: 1 },
    //     { x: 243.453237410072, y: 3.92156862745098, size: 1 },
    //     { x: 245.395683453237, y: 3.72549019607843, size: 1 },
    //     { x: 246.043165467626, y: 3.76470588235294, size: 1 },
    //     { x: 246.690647482014, y: 3.64705882352941, size: 1 },
    //     { x: 247.338129496403, y: 3.72549019607843, size: 1 },
    //     { x: 247.985611510791, y: 3.84313725490196, size: 1 },
    //     { x: 248.63309352518, y: 3.45098039215686, size: 1 },
    //     { x: 249.280575539568, y: 3.64705882352941, size: 1 },
    //     { x: 249.928057553957, y: 3.13725490196078, size: 1 },
    //     { x: 250.575539568345, y: 3.37254901960784, size: 1 },
    //     { x: 251.223021582734, y: 3.41176470588235, size: 1 },
    //     { x: 251.870503597122, y: 3.68627450980392, size: 1 },
    //     { x: 252.517985611511, y: 3.49019607843137, size: 1 },
    //     { x: 253.165467625899, y: 3.52941176470588, size: 1 },
    //     { x: 253.812949640288, y: 3.6078431372549, size: 1 },
    //     { x: 254.460431654676, y: 3.6078431372549, size: 1 },
    //     { x: 255.107913669065, y: 3.6078431372549, size: 1 },
    //     { x: 255.755395683453, y: 3.64705882352941, size: 1 },
    //     { x: 256.402877697842, y: 3.72549019607843, size: 1 },
    //     { x: 257.05035971223, y: 3.64705882352941, size: 1 },
    //     { x: 257.697841726619, y: 3.45098039215686, size: 1 },
    //     { x: 258.345323741007, y: 3.76470588235294, size: 1 },
    //     { x: 258.992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 259.640287769784, y: 3.76470588235294, size: 1 },
    //     { x: 260.287769784173, y: 3.52941176470588, size: 1 },
    //     { x: 260.935251798561, y: 3.64705882352941, size: 1 },
    //     { x: 261.58273381295, y: 3.49019607843137, size: 1 },
    //     { x: 262.230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 262.877697841727, y: 3.52941176470588, size: 1 },
    //     { x: 264.172661870504, y: 3.72549019607843, size: 1 },
    //     { x: 265.467625899281, y: 3.49019607843137, size: 1 },
    //     { x: 266.115107913669, y: 3.72549019607843, size: 1 },
    //     { x: 267.410071942446, y: 3.45098039215686, size: 1 },
    //     { x: 268.057553956835, y: 3.64705882352941, size: 1 },
    //     { x: 268.705035971223, y: 3.52941176470588, size: 1 },
    //     { x: 269.352517985611, y: 3.64705882352941, size: 1 },
    //     { x: 270, y: 3.56862745098039, size: 1 },
    //     { x: 270.647482014389, y: 3.41176470588235, size: 1 },
    //     { x: 271.294964028777, y: 3.56862745098039, size: 1 },
    //     { x: 271.942446043165, y: 3.45098039215686, size: 1 },
    //     { x: 272.589928057554, y: 3.64705882352941, size: 1 },
    //     { x: 273.237410071942, y: 3.64705882352941, size: 1 },
    //     { x: 273.884892086331, y: 3.6078431372549, size: 1 },
    //     { x: 275.179856115108, y: 3.64705882352941, size: 1 },
    //     { x: 275.827338129496, y: 3.72549019607843, size: 1 },
    //     { x: 276.474820143885, y: 3.6078431372549, size: 1 },
    //     { x: 277.122302158273, y: 3.72549019607843, size: 1 },
    //     { x: 277.769784172662, y: 3.56862745098039, size: 1 },
    //     { x: 278.41726618705, y: 3.6078431372549, size: 1 },
    //     { x: 279.064748201439, y: 3.52941176470588, size: 1 },
    //     { x: 279.712230215827, y: 3.6078431372549, size: 1 },
    //     { x: 280.359712230216, y: 3.45098039215686, size: 1 },
    //     { x: 281.007194244604, y: 3.76470588235294, size: 1 },
    //     { x: 281.654676258993, y: 3.64705882352941, size: 1 },
    //     { x: 282.302158273381, y: 3.6078431372549, size: 1 },
    //     { x: 282.94964028777, y: 3.72549019607843, size: 1 },
    //     { x: 284.244604316547, y: 3.6078431372549, size: 1 },
    //     { x: 284.892086330935, y: 3.56862745098039, size: 1 },
    //     { x: 285.539568345324, y: 3.84313725490196, size: 1 },
    //     { x: 286.187050359712, y: 3.64705882352941, size: 1 },
    //     { x: 286.834532374101, y: 3.6078431372549, size: 1 },
    //     { x: 287.482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 288.776978417266, y: 3.64705882352941, size: 1 },
    //     { x: 289.424460431655, y: 3.64705882352941, size: 1 },
    //     { x: 290.071942446043, y: 3.52941176470588, size: 1 },
    //     { x: 290.719424460432, y: 3.72549019607843, size: 1 },
    //     { x: 291.36690647482, y: 3.64705882352941, size: 1 },
    //     { x: 292.014388489209, y: 3.76470588235294, size: 1 },
    //     { x: 293.309352517986, y: 3.2156862745098, size: 1 },
    //     { x: 293.956834532374, y: 3.17647058823529, size: 1 },
    //     { x: 295.251798561151, y: 3.72549019607843, size: 1 },
    //     { x: 295.89928057554, y: 3.88235294117647, size: 1 },
    //     { x: 296.546762589928, y: 3.6078431372549, size: 1 },
    //     { x: 297.194244604317, y: 3.80392156862745, size: 1 },
    //     { x: 297.841726618705, y: 3.68627450980392, size: 1 },
    //     { x: 298.489208633094, y: 3.49019607843137, size: 1 },
    //     { x: 299.136690647482, y: 3.49019607843137, size: 1 },
    //     { x: 299.784172661871, y: 3.68627450980392, size: 1 },
    //     { x: 300.431654676259, y: 3.68627450980392, size: 1 },
    //     { x: 301.079136690647, y: 3.6078431372549, size: 1 },
    //     { x: 301.726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 303.669064748201, y: 3.45098039215686, size: 1 },
    //     { x: 304.964028776978, y: 3.49019607843137, size: 1 },
    //     { x: 305.611510791367, y: 3.52941176470588, size: 1 },
    //     { x: 306.258992805755, y: 3.64705882352941, size: 1 },
    //     { x: 306.906474820144, y: 3.33333333333333, size: 1 },
    //     { x: 308.201438848921, y: 3.52941176470588, size: 1 },
    //     { x: 308.848920863309, y: 3.52941176470588, size: 1 },
    //     { x: 309.496402877698, y: 3.64705882352941, size: 1 },
    //     { x: 310.143884892086, y: 3.56862745098039, size: 1 },
    //     { x: 310.791366906475, y: 3.52941176470588, size: 1 },
    //     { x: 312.73381294964, y: 3.52941176470588, size: 1 },
    //     { x: 313.381294964029, y: 3.25490196078431, size: 1 },
    //     { x: 314.028776978417, y: 3.37254901960784, size: 1 },
    //     { x: 314.676258992806, y: 2.70588235294118, size: 1 },
    //     { x: 315.323741007194, y: 2.54901960784314, size: 1 },
    //     { x: 315.971223021583, y: 3.64705882352941, size: 1 },
    //     { x: 317.26618705036, y: 3.64705882352941, size: 1 },
    //     { x: 317.913669064748, y: 3.41176470588235, size: 1 },
    //     { x: 318.561151079137, y: 3.49019607843137, size: 1 },
    //     { x: 319.208633093525, y: 3.64705882352941, size: 1 },
    //     { x: 319.856115107914, y: 3.88235294117647, size: 1 },
    //     { x: 320.503597122302, y: 3.80392156862745, size: 1 },
    //     { x: 321.151079136691, y: 3.52941176470588, size: 1 },
    //     { x: 321.798561151079, y: 3.45098039215686, size: 1 },
    //     { x: 322.446043165468, y: 3.68627450980392, size: 1 },
    //     { x: 323.093525179856, y: 3.37254901960784, size: 1 },
    //     { x: 323.741007194245, y: 3.80392156862745, size: 1 },
    //     { x: 324.388489208633, y: 3.64705882352941, size: 1 },
    //     { x: 325.035971223022, y: 3.76470588235294, size: 1 },
    //     { x: 325.68345323741, y: 3.56862745098039, size: 1 },
    //     { x: 326.330935251799, y: 3.41176470588235, size: 1 },
    //     { x: 327.625899280576, y: 3.56862745098039, size: 1 },
    //     { x: 328.920863309353, y: 3.52941176470588, size: 1 },
    //     { x: 329.568345323741, y: 3.80392156862745, size: 1 },
    //     { x: 330.215827338129, y: 3.80392156862745, size: 1 },
    //     { x: 330.863309352518, y: 3.56862745098039, size: 1 },
    //     { x: 331.510791366906, y: 3.37254901960784, size: 1 },
    //     { x: 332.805755395683, y: 3.52941176470588, size: 1 },
    //     { x: 333.453237410072, y: 3.49019607843137, size: 1 },
    //     { x: 334.10071942446, y: 3.49019607843137, size: 1 },
    //     { x: 334.748201438849, y: 3.25490196078431, size: 1 },
    //     { x: 335.395683453237, y: 3.17647058823529, size: 1 },
    //     { x: 336.043165467626, y: 3.33333333333333, size: 1 },
    //     { x: 336.690647482014, y: 2.86274509803922, size: 1 },
    //     { x: 337.338129496403, y: 3.37254901960784, size: 1 },
    //     { x: 337.985611510791, y: 3.80392156862745, size: 1 },
    //     { x: 339.280575539568, y: 3.49019607843137, size: 1 },
    //     { x: 339.928057553957, y: 3.52941176470588, size: 1 },
    //     { x: 340.575539568345, y: 3.56862745098039, size: 1 },
    //     { x: 341.223021582734, y: 3.41176470588235, size: 1 },
    //     { x: 341.870503597122, y: 3.64705882352941, size: 1 },
    //     { x: 342.517985611511, y: 3.37254901960784, size: 1 },
    //     { x: 343.165467625899, y: 3.72549019607843, size: 1 },
    //     { x: 343.812949640288, y: 3.76470588235294, size: 1 },
    //     { x: 344.460431654676, y: 3.68627450980392, size: 1 },
    //     { x: 345.107913669065, y: 3.6078431372549, size: 1 },
    //     { x: 345.755395683453, y: 3.6078431372549, size: 1 },
    //     { x: 346.402877697842, y: 3.76470588235294, size: 1 },
    //     { x: 347.05035971223, y: 3.49019607843137, size: 1 },
    //     { x: 347.697841726619, y: 3.45098039215686, size: 1 },
    //     { x: 348.345323741007, y: 3.56862745098039, size: 1 },
    //     { x: 348.992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 349.640287769784, y: 3.56862745098039, size: 1 },
    //     { x: 350.287769784173, y: 3.72549019607843, size: 1 },
    //     { x: 350.935251798561, y: 3.56862745098039, size: 1 },
    //     { x: 352.230215827338, y: 3.49019607843137, size: 1 },
    //     { x: 352.877697841727, y: 3.80392156862745, size: 1 },
    //     { x: 353.525179856115, y: 3.45098039215686, size: 1 },
    //     { x: 354.820143884892, y: 3.56862745098039, size: 1 },
    //     { x: 355.467625899281, y: 3.49019607843137, size: 1 },
    //     { x: 356.115107913669, y: 3.45098039215686, size: 1 },
    //     { x: 356.762589928058, y: 3.2156862745098, size: 1 },
    //     { x: 358.057553956835, y: 2.98039215686275, size: 1 },
    //     { x: 358.705035971223, y: 2.98039215686275, size: 1 },
    //     { x: 359.352517985611, y: 3.45098039215686, size: 1 },
    //     { x: 0, y: 3.56862745098039, size: 1 },
    //     { x: 1.29496402877698, y: 3.37254901960784, size: 1 },
    //     { x: 1.94244604316547, y: 3.49019607843137, size: 1 },
    //     { x: 2.58992805755396, y: 3.72549019607843, size: 1 },
    //     { x: 3.23741007194245, y: 3.45098039215686, size: 1 },
    //     { x: 4.53237410071942, y: 3.6078431372549, size: 1 },
    //     { x: 5.17985611510791, y: 3.33333333333333, size: 1 },
    //     { x: 5.8273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 6.47482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 7.12230215827338, y: 3.84313725490196, size: 1 },
    //     { x: 8.41726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 9.06474820143885, y: 3.49019607843137, size: 1 },
    //     { x: 9.71223021582734, y: 3.41176470588235, size: 1 },
    //     { x: 10.3597122302158, y: 3.41176470588235, size: 1 },
    //     { x: 11.0071942446043, y: 3.45098039215686, size: 1 },
    //     { x: 12.3021582733813, y: 3.49019607843137, size: 1 },
    //     { x: 12.9496402877698, y: 3.37254901960784, size: 1 },
    //     { x: 13.5971223021583, y: 3.49019607843137, size: 1 },
    //     { x: 14.2446043165468, y: 3.6078431372549, size: 1 },
    //     { x: 14.8920863309353, y: 3.52941176470588, size: 1 },
    //     { x: 16.1870503597122, y: 3.52941176470588, size: 1 },
    //     { x: 16.8345323741007, y: 3.45098039215686, size: 1 },
    //     { x: 17.4820143884892, y: 3.29411764705882, size: 1 },
    //     { x: 18.1294964028777, y: 3.6078431372549, size: 1 },
    //     { x: 18.7769784172662, y: 3.37254901960784, size: 1 },
    //     { x: 19.4244604316547, y: 2.98039215686275, size: 1 },
    //     { x: 20.0719424460432, y: 3.13725490196078, size: 1 },
    //     { x: 20.7194244604317, y: 3.56862745098039, size: 1 },
    //     { x: 21.3669064748201, y: 3.49019607843137, size: 1 },
    //     { x: 22.0143884892086, y: 3.76470588235294, size: 1 },
    //     { x: 22.6618705035971, y: 3.52941176470588, size: 1 },
    //     { x: 23.3093525179856, y: 3.64705882352941, size: 1 },
    //     { x: 23.9568345323741, y: 3.72549019607843, size: 1 },
    //     { x: 24.6043165467626, y: 3.52941176470588, size: 1 },
    //     { x: 25.2517985611511, y: 3.72549019607843, size: 1 },
    //     { x: 25.8992805755396, y: 3.49019607843137, size: 1 },
    //     { x: 27.1942446043165, y: 3.64705882352941, size: 1 },
    //     { x: 28.4892086330935, y: 3.49019607843137, size: 1 },
    //     { x: 29.136690647482, y: 3.41176470588235, size: 1 },
    //     { x: 29.7841726618705, y: 3.6078431372549, size: 1 },
    //     { x: 30.431654676259, y: 3.41176470588235, size: 1 },
    //     { x: 31.0791366906475, y: 3.68627450980392, size: 1 },
    //     { x: 31.726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 33.0215827338129, y: 3.76470588235294, size: 1 },
    //     { x: 34.3165467625899, y: 3.6078431372549, size: 1 },
    //     { x: 34.9640287769784, y: 3.52941176470588, size: 1 },
    //     { x: 35.6115107913669, y: 3.49019607843137, size: 1 },
    //     { x: 36.2589928057554, y: 3.45098039215686, size: 1 },
    //     { x: 36.9064748201439, y: 3.68627450980392, size: 1 },
    //     { x: 38.2014388489209, y: 3.45098039215686, size: 1 },
    //     { x: 38.8489208633094, y: 3.72549019607843, size: 1 },
    //     { x: 39.4964028776978, y: 3.05882352941176, size: 1 },
    //     { x: 40.1438848920863, y: 3.45098039215686, size: 1 },
    //     { x: 40.7913669064748, y: 3.17647058823529, size: 1 },
    //     { x: 41.4388489208633, y: 2.47058823529412, size: 1 },
    //     { x: 42.0863309352518, y: 3.25490196078431, size: 1 },
    //     { x: 42.7338129496403, y: 3.6078431372549, size: 1 },
    //     { x: 43.3812949640288, y: 3.6078431372549, size: 1 },
    //     { x: 44.0287769784173, y: 3.52941176470588, size: 1 },
    //     { x: 44.6762589928058, y: 3.6078431372549, size: 1 },
    //     { x: 45.9712230215827, y: 3.68627450980392, size: 1 },
    //     { x: 47.2661870503597, y: 3.68627450980392, size: 1 },
    //     { x: 47.9136690647482, y: 3.80392156862745, size: 1 },
    //     { x: 48.5611510791367, y: 3.84313725490196, size: 1 },
    //     { x: 51.1510791366906, y: 3.76470588235294, size: 1 },
    //     { x: 51.7985611510791, y: 3.45098039215686, size: 1 },
    //     { x: 52.4460431654676, y: 3.76470588235294, size: 1 },
    //     { x: 53.7410071942446, y: 3.72549019607843, size: 1 },
    //     { x: 54.3884892086331, y: 3.64705882352941, size: 1 },
    //     { x: 55.0359712230216, y: 3.49019607843137, size: 1 },
    //     { x: 56.3309352517986, y: 3.72549019607843, size: 1 },
    //     { x: 56.9784172661871, y: 3.52941176470588, size: 1 },
    //     { x: 57.6258992805755, y: 3.49019607843137, size: 1 },
    //     { x: 58.273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 58.9208633093525, y: 3.6078431372549, size: 1 },
    //     { x: 59.568345323741, y: 3.68627450980392, size: 1 },
    //     { x: 60.2158273381295, y: 3.84313725490196, size: 1 },
    //     { x: 60.863309352518, y: 3.68627450980392, size: 1 },
    //     { x: 61.5107913669065, y: 3.45098039215686, size: 1 },
    //     { x: 62.158273381295, y: 3.64705882352941, size: 1 },
    //     { x: 62.8057553956835, y: 3.52941176470588, size: 1 },
    //     { x: 63.4532374100719, y: 3.29411764705882, size: 1 },
    //     { x: 64.1007194244604, y: 3.56862745098039, size: 1 },
    //     { x: 64.7482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 65.3956834532374, y: 3.52941176470588, size: 1 },
    //     { x: 66.0431654676259, y: 3.49019607843137, size: 1 },
    //     { x: 66.6906474820144, y: 3.37254901960784, size: 1 },
    //     { x: 68.6330935251799, y: 3.84313725490196, size: 1 },
    //     { x: 69.2805755395683, y: 3.64705882352941, size: 1 },
    //     { x: 69.9280575539568, y: 3.92156862745098, size: 1 },
    //     { x: 70.5755395683453, y: 3.64705882352941, size: 1 },
    //     { x: 71.2230215827338, y: 3.56862745098039, size: 1 },
    //     { x: 72.5179856115108, y: 3.68627450980392, size: 1 },
    //     { x: 73.1654676258993, y: 3.64705882352941, size: 1 },
    //     { x: 73.8129496402878, y: 3.64705882352941, size: 1 },
    //     { x: 74.4604316546763, y: 3.80392156862745, size: 1 },
    //     { x: 75.1079136690647, y: 3.37254901960784, size: 1 },
    //     { x: 75.7553956834532, y: 3.45098039215686, size: 1 },
    //     { x: 77.0503597122302, y: 3.64705882352941, size: 1 },
    //     { x: 78.3453237410072, y: 3.6078431372549, size: 1 },
    //     { x: 78.9928057553957, y: 3.6078431372549, size: 1 },
    //     { x: 79.6402877697842, y: 3.52941176470588, size: 1 },
    //     { x: 80.9352517985612, y: 3.49019607843137, size: 1 },
    //     { x: 81.5827338129496, y: 3.6078431372549, size: 1 },
    //     { x: 82.2302158273381, y: 3.37254901960784, size: 1 },
    //     { x: 82.8776978417266, y: 3.33333333333333, size: 1 },
    //     { x: 83.5251798561151, y: 3.33333333333333, size: 1 },
    //     { x: 84.1726618705036, y: 3.05882352941176, size: 1 },
    //     { x: 84.8201438848921, y: 3.05882352941176, size: 1 },
    //     { x: 85.4676258992806, y: 3.49019607843137, size: 1 },
    //     { x: 86.1151079136691, y: 3.84313725490196, size: 1 },
    //     { x: 88.0575539568345, y: 3.80392156862745, size: 1 },
    //     { x: 88.705035971223, y: 3.76470588235294, size: 1 },
    //     { x: 90, y: 3.72549019607843, size: 1 },
    //     { x: 90.6474820143885, y: 3.92156862745098, size: 1 },
    //     { x: 91.294964028777, y: 3.72549019607843, size: 1 },
    //     { x: 91.9424460431655, y: 3.80392156862745, size: 1 },
    //     { x: 92.589928057554, y: 3.76470588235294, size: 1 },
    //     { x: 93.2374100719424, y: 3.92156862745098, size: 1 },
    //     { x: 94.5323741007194, y: 3.76470588235294, size: 1 },
    //     { x: 95.1798561151079, y: 3.72549019607843, size: 1 },
    //     { x: 95.8273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 97.1223021582734, y: 3.68627450980392, size: 1 },
    //     { x: 97.7697841726619, y: 3.80392156862745, size: 1 },
    //     { x: 98.4172661870504, y: 3.72549019607843, size: 1 },
    //     { x: 99.0647482014388, y: 3.45098039215686, size: 1 },
    //     { x: 99.7122302158273, y: 3.96078431372549, size: 1 },
    //     { x: 100.359712230216, y: 3.68627450980392, size: 1 },
    //     { x: 101.007194244604, y: 3.76470588235294, size: 1 },
    //     { x: 101.654676258993, y: 3.76470588235294, size: 1 },
    //     { x: 102.302158273381, y: 3.80392156862745, size: 1 },
    //     { x: 102.94964028777, y: 3.6078431372549, size: 1 },
    //     { x: 104.244604316547, y: 3.2156862745098, size: 1 },
    //     { x: 104.892086330935, y: 3.09803921568627, size: 1 },
    //     { x: 105.539568345324, y: 3.13725490196078, size: 1 },
    //     { x: 106.187050359712, y: 2.43137254901961, size: 1 },
    //     { x: 106.834532374101, y: 3.33333333333333, size: 1 },
    //     { x: 107.482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 108.129496402878, y: 3.64705882352941, size: 1 },
    //     { x: 108.776978417266, y: 3.64705882352941, size: 1 },
    //     { x: 109.424460431655, y: 3.64705882352941, size: 1 },
    //     { x: 110.071942446043, y: 3.68627450980392, size: 1 },
    //     { x: 111.36690647482, y: 3.52941176470588, size: 1 },
    //     { x: 113.309352517986, y: 3.64705882352941, size: 1 },
    //     { x: 117.194244604317, y: 3.56862745098039, size: 1 },
    //     { x: 117.841726618705, y: 3.64705882352941, size: 1 },
    //     { x: 118.489208633094, y: 3.52941176470588, size: 1 },
    //     { x: 119.136690647482, y: 3.56862745098039, size: 1 },
    //     { x: 120.431654676259, y: 3.56862745098039, size: 1 },
    //     { x: 122.374100719424, y: 3.45098039215686, size: 1 },
    //     { x: 123.669064748201, y: 3.52941176470588, size: 1 },
    //     { x: 126.258992805755, y: 3.80392156862745, size: 1 },
    //     { x: 126.906474820144, y: 3.56862745098039, size: 1 },
    //     { x: 127.553956834532, y: 3.37254901960784, size: 1 },
    //     { x: 128.201438848921, y: 3.52941176470588, size: 1 },
    //     { x: 130.143884892086, y: 3.88235294117647, size: 1 },
    //     { x: 130.791366906475, y: 3.64705882352941, size: 1 },
    //     { x: 131.438848920863, y: 3.76470588235294, size: 1 },
    //     { x: 132.73381294964, y: 3.76470588235294, size: 1 },
    //     { x: 133.381294964029, y: 3.76470588235294, size: 1 },
    //     { x: 134.676258992806, y: 3.72549019607843, size: 1 },
    //     { x: 136.618705035971, y: 3.92156862745098, size: 1 },
    //     { x: 137.26618705036, y: 3.52941176470588, size: 1 },
    //     { x: 138.561151079137, y: 3.72549019607843, size: 1 },
    //     { x: 139.208633093525, y: 3.72549019607843, size: 1 },
    //     { x: 139.856115107914, y: 3.84313725490196, size: 1 },
    //     { x: 140.503597122302, y: 3.72549019607843, size: 1 },
    //     { x: 141.151079136691, y: 3.84313725490196, size: 1 },
    //     { x: 141.798561151079, y: 3.80392156862745, size: 1 },
    //     { x: 143.093525179856, y: 3.64705882352941, size: 1 },
    //     { x: 143.741007194245, y: 3.6078431372549, size: 1 },
    //     { x: 144.388489208633, y: 3.76470588235294, size: 1 },
    //     { x: 145.035971223022, y: 3.68627450980392, size: 1 },
    //     { x: 145.68345323741, y: 3.64705882352941, size: 1 },
    //     { x: 147.625899280576, y: 3.17647058823529, size: 1 },
    //     { x: 148.273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 148.920863309353, y: 2.3921568627451, size: 1 },
    //     { x: 149.568345323741, y: 2.70588235294118, size: 1 },
    //     { x: 150.215827338129, y: 3.64705882352941, size: 1 },
    //     { x: 150.863309352518, y: 3.49019607843137, size: 1 },
    //     { x: 152.158273381295, y: 3.84313725490196, size: 1 },
    //     { x: 153.453237410072, y: 3.52941176470588, size: 1 },
    //     { x: 154.10071942446, y: 3.6078431372549, size: 1 },
    //     { x: 154.748201438849, y: 3.56862745098039, size: 1 },
    //     { x: 156.043165467626, y: 3.52941176470588, size: 1 },
    //     { x: 157.338129496403, y: 3.56862745098039, size: 1 },
    //     { x: 157.985611510791, y: 3.80392156862745, size: 1 },
    //     { x: 158.63309352518, y: 3.76470588235294, size: 1 },
    //     { x: 159.280575539568, y: 3.72549019607843, size: 1 },
    //     { x: 159.928057553957, y: 3.84313725490196, size: 1 },
    //     { x: 161.223021582734, y: 3.56862745098039, size: 1 },
    //     { x: 161.870503597122, y: 3.72549019607843, size: 1 },
    //     { x: 162.517985611511, y: 3.6078431372549, size: 1 },
    //     { x: 163.165467625899, y: 3.72549019607843, size: 1 },
    //     { x: 163.812949640288, y: 3.45098039215686, size: 1 },
    //     { x: 164.460431654676, y: 3.72549019607843, size: 1 },
    //     { x: 165.107913669065, y: 3.56862745098039, size: 1 },
    //     { x: 165.755395683453, y: 3.6078431372549, size: 1 },
    //     { x: 166.402877697842, y: 3.76470588235294, size: 1 },
    //     { x: 167.05035971223, y: 3.6078431372549, size: 1 },
    //     { x: 167.697841726619, y: 3.64705882352941, size: 1 },
    //     { x: 168.345323741007, y: 3.84313725490196, size: 1 },
    //     { x: 168.992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 169.640287769784, y: 3.72549019607843, size: 1 },
    //     { x: 170.287769784173, y: 3.56862745098039, size: 1 },
    //     { x: 170.935251798561, y: 3.29411764705882, size: 1 },
    //     { x: 171.58273381295, y: 3.33333333333333, size: 1 },
    //     { x: 172.230215827338, y: 3.6078431372549, size: 1 },
    //     { x: 172.877697841727, y: 3.76470588235294, size: 1 },
    //     { x: 173.525179856115, y: 3.68627450980392, size: 1 },
    //     { x: 174.820143884892, y: 3.64705882352941, size: 1 },
    //     { x: 175.467625899281, y: 3.92156862745098, size: 1 },
    //     { x: 176.115107913669, y: 3.72549019607843, size: 1 },
    //     { x: 177.410071942446, y: 3.72549019607843, size: 1 },
    //     { x: 178.057553956835, y: 3.92156862745098, size: 1 },
    //     { x: 178.705035971223, y: 3.68627450980392, size: 1 },
    //     { x: 180, y: 3.6078431372549, size: 1 },
    //     { x: 180.647482014388, y: 3.68627450980392, size: 1 },
    //     { x: 181.294964028777, y: 3.64705882352941, size: 1 },
    //     { x: 181.942446043165, y: 3.49019607843137, size: 1 },
    //     { x: 182.589928057554, y: 3.64705882352941, size: 1 },
    //     { x: 183.237410071942, y: 3.56862745098039, size: 1 },
    //     { x: 183.884892086331, y: 3.64705882352941, size: 1 },
    //     { x: 184.532374100719, y: 3.76470588235294, size: 1 },
    //     { x: 185.179856115108, y: 3.6078431372549, size: 1 },
    //     { x: 185.827338129496, y: 3.72549019607843, size: 1 },
    //     { x: 187.122302158273, y: 3.72549019607843, size: 1 },
    //     { x: 187.769784172662, y: 3.52941176470588, size: 1 },
    //     { x: 188.41726618705, y: 3.76470588235294, size: 1 },
    //     { x: 189.712230215827, y: 3.52941176470588, size: 1 },
    //     { x: 191.007194244604, y: 3.41176470588235, size: 1 },
    //     { x: 191.654676258993, y: 3.56862745098039, size: 1 },
    //     { x: 192.302158273381, y: 3.09803921568627, size: 1 },
    //     { x: 192.94964028777, y: 3.13725490196078, size: 1 },
    //     { x: 193.597122302158, y: 3.37254901960784, size: 1 },
    //     { x: 195.539568345324, y: 3.64705882352941, size: 1 },
    //     { x: 196.187050359712, y: 3.41176470588235, size: 1 },
    //     { x: 196.834532374101, y: 3.68627450980392, size: 1 },
    //     { x: 197.482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 198.129496402878, y: 3.45098039215686, size: 1 },
    //     { x: 198.776978417266, y: 3.41176470588235, size: 1 },
    //     { x: 200.071942446043, y: 3.41176470588235, size: 1 },
    //     { x: 201.36690647482, y: 3.64705882352941, size: 1 },
    //     { x: 202.661870503597, y: 3.6078431372549, size: 1 },
    //     { x: 203.309352517986, y: 3.52941176470588, size: 1 },
    //     { x: 204.604316546763, y: 3.64705882352941, size: 1 },
    //     { x: 205.89928057554, y: 3.45098039215686, size: 1 },
    //     { x: 207.194244604317, y: 3.25490196078431, size: 1 },
    //     { x: 207.841726618705, y: 3.29411764705882, size: 1 },
    //     { x: 208.489208633094, y: 3.6078431372549, size: 1 },
    //     { x: 209.136690647482, y: 3.33333333333333, size: 1 },
    //     { x: 209.784172661871, y: 3.41176470588235, size: 1 },
    //     { x: 210.431654676259, y: 3.6078431372549, size: 1 },
    //     { x: 211.079136690647, y: 3.84313725490196, size: 1 },
    //     { x: 212.374100719424, y: 3.13725490196078, size: 1 },
    //     { x: 213.021582733813, y: 3.25490196078431, size: 1 },
    //     { x: 213.669064748201, y: 2.43137254901961, size: 1 },
    //     { x: 214.31654676259, y: 1.88235294117647, size: 1 },
    //     { x: 214.964028776978, y: 3.29411764705882, size: 1 },
    //     { x: 215.611510791367, y: 3.41176470588235, size: 1 },
    //     { x: 216.258992805755, y: 3.41176470588235, size: 1 },
    //     { x: 216.906474820144, y: 3.29411764705882, size: 1 },
    //     { x: 217.553956834532, y: 3.37254901960784, size: 1 },
    //     { x: 218.201438848921, y: 3.37254901960784, size: 1 },
    //     { x: 218.848920863309, y: 3.56862745098039, size: 1 },
    //     { x: 219.496402877698, y: 3.56862745098039, size: 1 },
    //     { x: 220.143884892086, y: 3.56862745098039, size: 1 },
    //     { x: 220.791366906475, y: 3.29411764705882, size: 1 },
    //     { x: 221.438848920863, y: 3.52941176470588, size: 1 },
    //     { x: 222.086330935252, y: 3.52941176470588, size: 1 },
    //     { x: 222.73381294964, y: 3.45098039215686, size: 1 },
    //     { x: 224.028776978417, y: 3.45098039215686, size: 1 },
    //     { x: 224.676258992806, y: 3.49019607843137, size: 1 },
    //     { x: 225.323741007194, y: 3.49019607843137, size: 1 },
    //     { x: 225.971223021583, y: 3.41176470588235, size: 1 },
    //     { x: 226.618705035971, y: 3.45098039215686, size: 1 },
    //     { x: 227.26618705036, y: 3.41176470588235, size: 1 },
    //     { x: 227.913669064748, y: 3.37254901960784, size: 1 },
    //     { x: 228.561151079137, y: 3.29411764705882, size: 1 },
    //     { x: 229.208633093525, y: 3.45098039215686, size: 1 },
    //     { x: 230.503597122302, y: 3.29411764705882, size: 1 },
    //     { x: 231.151079136691, y: 3.41176470588235, size: 1 },
    //     { x: 232.446043165468, y: 3.33333333333333, size: 1 },
    //     { x: 233.093525179856, y: 3.49019607843137, size: 1 },
    //     { x: 233.741007194245, y: 3.64705882352941, size: 1 },
    //     { x: 234.388489208633, y: 3.37254901960784, size: 1 },
    //     { x: 235.035971223022, y: 3.25490196078431, size: 1 },
    //     { x: 235.68345323741, y: 2.86274509803922, size: 1 },
    //     { x: 236.330935251799, y: 3.37254901960784, size: 1 },
    //     { x: 236.978417266187, y: 3.6078431372549, size: 1 },
    //     { x: 237.625899280576, y: 3.52941176470588, size: 1 },
    //     { x: 238.273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 238.920863309353, y: 3.6078431372549, size: 1 },
    //     { x: 239.568345323741, y: 3.56862745098039, size: 1 },
    //     { x: 240.863309352518, y: 3.52941176470588, size: 1 },
    //     { x: 241.510791366906, y: 3.52941176470588, size: 1 },
    //     { x: 242.158273381295, y: 3.68627450980392, size: 1 },
    //     { x: 242.805755395683, y: 3.52941176470588, size: 1 },
    //     { x: 243.453237410072, y: 3.64705882352941, size: 1 },
    //     { x: 244.10071942446, y: 3.49019607843137, size: 1 },
    //     { x: 246.043165467626, y: 3.6078431372549, size: 1 },
    //     { x: 246.690647482014, y: 3.45098039215686, size: 1 },
    //     { x: 247.338129496403, y: 3.52941176470588, size: 1 },
    //     { x: 247.985611510791, y: 3.6078431372549, size: 1 },
    //     { x: 248.63309352518, y: 3.52941176470588, size: 1 },
    //     { x: 249.280575539568, y: 3.56862745098039, size: 1 },
    //     { x: 249.928057553957, y: 3.45098039215686, size: 1 },
    //     { x: 250.575539568345, y: 3.49019607843137, size: 1 },
    //     { x: 251.223021582734, y: 3.88235294117647, size: 1 },
    //     { x: 252.517985611511, y: 3.52941176470588, size: 1 },
    //     { x: 253.812949640288, y: 3.37254901960784, size: 1 },
    //     { x: 255.107913669065, y: 3.64705882352941, size: 1 },
    //     { x: 256.402877697842, y: 3.68627450980392, size: 1 },
    //     { x: 257.05035971223, y: 3.56862745098039, size: 1 },
    //     { x: 257.697841726619, y: 3.68627450980392, size: 1 },
    //     { x: 258.345323741007, y: 3.52941176470588, size: 1 },
    //     { x: 258.992805755396, y: 3.68627450980392, size: 1 },
    //     { x: 260.287769784173, y: 3.76470588235294, size: 1 },
    //     { x: 260.935251798561, y: 3.56862745098039, size: 1 },
    //     { x: 262.230215827338, y: 3.6078431372549, size: 1 },
    //     { x: 262.877697841727, y: 3.6078431372549, size: 1 },
    //     { x: 263.525179856115, y: 3.64705882352941, size: 1 },
    //     { x: 264.172661870504, y: 3.6078431372549, size: 1 },
    //     { x: 264.820143884892, y: 3.49019607843137, size: 1 },
    //     { x: 265.467625899281, y: 3.76470588235294, size: 1 },
    //     { x: 266.115107913669, y: 3.68627450980392, size: 1 },
    //     { x: 266.762589928058, y: 3.56862745098039, size: 1 },
    //     { x: 267.410071942446, y: 3.80392156862745, size: 1 },
    //     { x: 268.057553956835, y: 3.56862745098039, size: 1 },
    //     { x: 269.352517985611, y: 3.56862745098039, size: 1 },
    //     { x: 270, y: 3.52941176470588, size: 1 },
    //     { x: 270.647482014389, y: 3.76470588235294, size: 1 },
    //     { x: 271.942446043165, y: 3.68627450980392, size: 1 },
    //     { x: 272.589928057554, y: 4, size: 1 },
    //     { x: 273.237410071942, y: 3.56862745098039, size: 1 },
    //     { x: 273.884892086331, y: 3.56862745098039, size: 1 },
    //     { x: 274.532374100719, y: 3.88235294117647, size: 1 },
    //     { x: 275.179856115108, y: 3.84313725490196, size: 1 },
    //     { x: 277.769784172662, y: 3.2156862745098, size: 1 },
    //     { x: 278.41726618705, y: 2.70588235294118, size: 1 },
    //     { x: 279.064748201439, y: 2.58823529411765, size: 1 },
    //     { x: 280.359712230216, y: 3.76470588235294, size: 1 },
    //     { x: 281.654676258993, y: 3.84313725490196, size: 1 },
    //     { x: 282.302158273381, y: 3.96078431372549, size: 1 },
    //     { x: 282.94964028777, y: 3.76470588235294, size: 1 },
    //     { x: 283.597122302158, y: 3.68627450980392, size: 1 },
    //     { x: 284.244604316547, y: 3.80392156862745, size: 1 },
    //     { x: 284.892086330935, y: 3.52941176470588, size: 1 },
    //     { x: 285.539568345324, y: 3.80392156862745, size: 1 },
    //     { x: 286.187050359712, y: 3.72549019607843, size: 1 },
    //     { x: 287.482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 288.129496402878, y: 3.64705882352941, size: 1 },
    //     { x: 288.776978417266, y: 3.49019607843137, size: 1 },
    //     { x: 290.719424460432, y: 3.64705882352941, size: 1 },
    //     { x: 292.014388489209, y: 3.6078431372549, size: 1 },
    //     { x: 293.309352517986, y: 3.45098039215686, size: 1 },
    //     { x: 293.956834532374, y: 3.56862745098039, size: 1 },
    //     { x: 294.604316546763, y: 3.76470588235294, size: 1 },
    //     { x: 295.251798561151, y: 3.6078431372549, size: 1 },
    //     { x: 295.89928057554, y: 3.56862745098039, size: 1 },
    //     { x: 296.546762589928, y: 3.76470588235294, size: 1 },
    //     { x: 297.194244604317, y: 3.68627450980392, size: 1 },
    //     { x: 299.136690647482, y: 3.52941176470588, size: 1 },
    //     { x: 299.784172661871, y: 3.49019607843137, size: 1 },
    //     { x: 300.431654676259, y: 3.2156862745098, size: 1 },
    //     { x: 301.079136690647, y: 3.37254901960784, size: 1 },
    //     { x: 301.726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 302.374100719424, y: 3.49019607843137, size: 1 },
    //     { x: 303.669064748201, y: 3.56862745098039, size: 1 },
    //     { x: 304.964028776978, y: 3.56862745098039, size: 1 },
    //     { x: 305.611510791367, y: 3.80392156862745, size: 1 },
    //     { x: 306.258992805755, y: 3.52941176470588, size: 1 },
    //     { x: 307.553956834532, y: 3.45098039215686, size: 1 },
    //     { x: 308.848920863309, y: 3.37254901960784, size: 1 },
    //     { x: 309.496402877698, y: 3.56862745098039, size: 1 },
    //     { x: 310.791366906475, y: 3.88235294117647, size: 1 },
    //     { x: 311.438848920863, y: 3.76470588235294, size: 1 },
    //     { x: 312.086330935252, y: 3.6078431372549, size: 1 },
    //     { x: 314.028776978417, y: 3.80392156862745, size: 1 },
    //     { x: 314.676258992806, y: 3.76470588235294, size: 1 },
    //     { x: 315.323741007194, y: 3.64705882352941, size: 1 },
    //     { x: 315.971223021583, y: 3.68627450980392, size: 1 },
    //     { x: 317.913669064748, y: 3.68627450980392, size: 1 },
    //     { x: 318.561151079137, y: 3.64705882352941, size: 1 },
    //     { x: 319.208633093525, y: 3.56862745098039, size: 1 },
    //     { x: 319.856115107914, y: 3.37254901960784, size: 1 },
    //     { x: 320.503597122302, y: 3.88235294117647, size: 1 },
    //     { x: 321.151079136691, y: 3.41176470588235, size: 1 },
    //     { x: 321.798561151079, y: 3.17647058823529, size: 1 },
    //     { x: 323.093525179856, y: 3.56862745098039, size: 1 },
    //     { x: 323.741007194245, y: 3.68627450980392, size: 1 },
    //     { x: 325.035971223022, y: 3.49019607843137, size: 1 },
    //     { x: 325.68345323741, y: 3.68627450980392, size: 1 },
    //     { x: 326.330935251799, y: 3.56862745098039, size: 1 },
    //     { x: 326.978417266187, y: 3.37254901960784, size: 1 },
    //     { x: 327.625899280576, y: 3.72549019607843, size: 1 },
    //     { x: 328.273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 328.920863309353, y: 3.76470588235294, size: 1 },
    //     { x: 329.568345323741, y: 3.52941176470588, size: 1 },
    //     { x: 330.863309352518, y: 3.45098039215686, size: 1 },
    //     { x: 331.510791366906, y: 3.76470588235294, size: 1 },
    //     { x: 332.158273381295, y: 3.64705882352941, size: 1 },
    //     { x: 332.805755395683, y: 3.6078431372549, size: 1 },
    //     { x: 334.10071942446, y: 3.68627450980392, size: 1 },
    //     { x: 334.748201438849, y: 3.6078431372549, size: 1 },
    //     { x: 335.395683453237, y: 3.6078431372549, size: 1 },
    //     { x: 336.043165467626, y: 3.49019607843137, size: 1 },
    //     { x: 336.690647482014, y: 3.52941176470588, size: 1 },
    //     { x: 337.338129496403, y: 3.64705882352941, size: 1 },
    //     { x: 337.985611510791, y: 3.6078431372549, size: 1 },
    //     { x: 338.63309352518, y: 3.64705882352941, size: 1 },
    //     { x: 339.280575539568, y: 3.68627450980392, size: 1 },
    //     { x: 339.928057553957, y: 3.6078431372549, size: 1 },
    //     { x: 340.575539568345, y: 3.37254901960784, size: 1 },
    //     { x: 341.223021582734, y: 3.56862745098039, size: 1 },
    //     { x: 341.870503597122, y: 3.56862745098039, size: 1 },
    //     { x: 343.165467625899, y: 3.41176470588235, size: 1 },
    //     { x: 343.812949640288, y: 3.29411764705882, size: 1 },
    //     { x: 344.460431654676, y: 3.80392156862745, size: 1 },
    //     { x: 345.107913669065, y: 3.68627450980392, size: 1 },
    //     { x: 345.755395683453, y: 3.49019607843137, size: 1 },
    //     { x: 347.05035971223, y: 3.68627450980392, size: 1 },
    //     { x: 348.992805755396, y: 3.52941176470588, size: 1 },
    //     { x: 349.640287769784, y: 3.49019607843137, size: 1 },
    //     { x: 350.287769784173, y: 3.49019607843137, size: 1 },
    //     { x: 350.935251798561, y: 3.80392156862745, size: 1 },
    //     { x: 351.58273381295, y: 3.64705882352941, size: 1 },
    //     { x: 352.230215827338, y: 3.68627450980392, size: 1 },
    //     { x: 352.877697841727, y: 3.56862745098039, size: 1 },
    //     { x: 354.172661870504, y: 3.45098039215686, size: 1 },
    //     { x: 354.820143884892, y: 3.6078431372549, size: 1 },
    //     { x: 356.115107913669, y: 3.68627450980392, size: 1 },
    //     { x: 356.762589928058, y: 3.56862745098039, size: 1 },
    //     { x: 358.057553956835, y: 3.56862745098039, size: 1 },
    //     { x: 359.352517985611, y: 3.68627450980392, size: 1 },
    //     { x: 0, y: 3.76470588235294, size: 1 },
    //     { x: 0.647482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 1.29496402877698, y: 3.6078431372549, size: 1 },
    //     { x: 1.94244604316547, y: 3.56862745098039, size: 1 },
    //     { x: 2.58992805755396, y: 3.56862745098039, size: 1 },
    //     { x: 3.23741007194245, y: 3.64705882352941, size: 1 },
    //     { x: 3.88489208633094, y: 3.37254901960784, size: 1 },
    //     { x: 5.17985611510791, y: 3.37254901960784, size: 1 },
    //     { x: 5.8273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 6.47482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 7.12230215827338, y: 3.76470588235294, size: 1 },
    //     { x: 9.06474820143885, y: 3.52941176470588, size: 1 },
    //     { x: 11.0071942446043, y: 3.49019607843137, size: 1 },
    //     { x: 11.6546762589928, y: 3.64705882352941, size: 1 },
    //     { x: 12.3021582733813, y: 3.6078431372549, size: 1 },
    //     { x: 12.9496402877698, y: 3.76470588235294, size: 1 },
    //     { x: 13.5971223021583, y: 3.45098039215686, size: 1 },
    //     { x: 14.8920863309353, y: 3.6078431372549, size: 1 },
    //     { x: 15.5395683453237, y: 3.52941176470588, size: 1 },
    //     { x: 16.1870503597122, y: 3.6078431372549, size: 1 },
    //     { x: 17.4820143884892, y: 3.41176470588235, size: 1 },
    //     { x: 18.7769784172662, y: 3.80392156862745, size: 1 },
    //     { x: 19.4244604316547, y: 3.72549019607843, size: 1 },
    //     { x: 20.0719424460432, y: 3.52941176470588, size: 1 },
    //     { x: 20.7194244604317, y: 3.72549019607843, size: 1 },
    //     { x: 21.3669064748201, y: 3.45098039215686, size: 1 },
    //     { x: 22.0143884892086, y: 3.6078431372549, size: 1 },
    //     { x: 22.6618705035971, y: 3.56862745098039, size: 1 },
    //     { x: 23.3093525179856, y: 3.6078431372549, size: 1 },
    //     { x: 23.9568345323741, y: 3.52941176470588, size: 1 },
    //     { x: 25.8992805755396, y: 3.37254901960784, size: 1 },
    //     { x: 26.5467625899281, y: 3.2156862745098, size: 1 },
    //     { x: 27.1942446043165, y: 3.45098039215686, size: 1 },
    //     { x: 27.841726618705, y: 3.84313725490196, size: 1 },
    //     { x: 28.4892086330935, y: 3.88235294117647, size: 1 },
    //     { x: 29.7841726618705, y: 3.41176470588235, size: 1 },
    //     { x: 31.726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 32.3741007194245, y: 3.68627450980392, size: 1 },
    //     { x: 33.0215827338129, y: 3.64705882352941, size: 1 },
    //     { x: 34.9640287769784, y: 3.76470588235294, size: 1 },
    //     { x: 38.2014388489209, y: 3.84313725490196, size: 1 },
    //     { x: 38.8489208633094, y: 3.6078431372549, size: 1 },
    //     { x: 39.4964028776978, y: 3.76470588235294, size: 1 },
    //     { x: 40.1438848920863, y: 3.64705882352941, size: 1 },
    //     { x: 40.7913669064748, y: 3.56862745098039, size: 1 },
    //     { x: 41.4388489208633, y: 3.6078431372549, size: 1 },
    //     { x: 42.7338129496403, y: 3.88235294117647, size: 1 },
    //     { x: 44.0287769784173, y: 3.64705882352941, size: 1 },
    //     { x: 45.9712230215827, y: 3.49019607843137, size: 1 },
    //     { x: 46.6187050359712, y: 3.17647058823529, size: 1 },
    //     { x: 47.2661870503597, y: 3.2156862745098, size: 1 },
    //     { x: 47.9136690647482, y: 2.7843137254902, size: 1 },
    //     { x: 48.5611510791367, y: 2.90196078431373, size: 1 },
    //     { x: 49.8561151079137, y: 3.72549019607843, size: 1 },
    //     { x: 50.5035971223022, y: 3.52941176470588, size: 1 },
    //     { x: 52.4460431654676, y: 3.52941176470588, size: 1 },
    //     { x: 53.0935251798561, y: 3.52941176470588, size: 1 },
    //     { x: 53.7410071942446, y: 3.41176470588235, size: 1 },
    //     { x: 54.3884892086331, y: 3.49019607843137, size: 1 },
    //     { x: 55.0359712230216, y: 3.68627450980392, size: 1 },
    //     { x: 55.6834532374101, y: 3.56862745098039, size: 1 },
    //     { x: 56.3309352517986, y: 3.52941176470588, size: 1 },
    //     { x: 57.6258992805755, y: 3.64705882352941, size: 1 },
    //     { x: 59.568345323741, y: 3.49019607843137, size: 1 },
    //     { x: 60.2158273381295, y: 3.68627450980392, size: 1 },
    //     { x: 60.863309352518, y: 3.49019607843137, size: 1 },
    //     { x: 62.158273381295, y: 3.41176470588235, size: 1 },
    //     { x: 64.1007194244604, y: 3.68627450980392, size: 1 },
    //     { x: 64.7482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 65.3956834532374, y: 3.56862745098039, size: 1 },
    //     { x: 66.6906474820144, y: 3.52941176470588, size: 1 },
    //     { x: 67.9856115107914, y: 3.45098039215686, size: 1 },
    //     { x: 68.6330935251799, y: 3.37254901960784, size: 1 },
    //     { x: 69.2805755395683, y: 3.41176470588235, size: 1 },
    //     { x: 69.9280575539568, y: 2.98039215686275, size: 1 },
    //     { x: 70.5755395683453, y: 3.2156862745098, size: 1 },
    //     { x: 71.2230215827338, y: 3.49019607843137, size: 1 },
    //     { x: 71.8705035971223, y: 3.33333333333333, size: 1 },
    //     { x: 72.5179856115108, y: 3.37254901960784, size: 1 },
    //     { x: 73.1654676258993, y: 3.52941176470588, size: 1 },
    //     { x: 74.4604316546763, y: 3.49019607843137, size: 1 },
    //     { x: 75.1079136690647, y: 3.45098039215686, size: 1 },
    //     { x: 75.7553956834532, y: 3.29411764705882, size: 1 },
    //     { x: 76.4028776978417, y: 3.56862745098039, size: 1 },
    //     { x: 77.0503597122302, y: 3.52941176470588, size: 1 },
    //     { x: 77.6978417266187, y: 3.09803921568627, size: 1 },
    //     { x: 78.3453237410072, y: 3.52941176470588, size: 1 },
    //     { x: 78.9928057553957, y: 3.49019607843137, size: 1 },
    //     { x: 80.2877697841727, y: 3.45098039215686, size: 1 },
    //     { x: 80.9352517985612, y: 3.52941176470588, size: 1 },
    //     { x: 81.5827338129496, y: 3.49019607843137, size: 1 },
    //     { x: 82.2302158273381, y: 3.33333333333333, size: 1 },
    //     { x: 82.8776978417266, y: 3.49019607843137, size: 1 },
    //     { x: 84.1726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 84.8201438848921, y: 3.45098039215686, size: 1 },
    //     { x: 85.4676258992806, y: 3.52941176470588, size: 1 },
    //     { x: 86.1151079136691, y: 3.37254901960784, size: 1 },
    //     { x: 86.7625899280576, y: 3.52941176470588, size: 1 },
    //     { x: 87.410071942446, y: 3.2156862745098, size: 1 },
    //     { x: 88.0575539568345, y: 3.37254901960784, size: 1 },
    //     { x: 88.705035971223, y: 3.37254901960784, size: 1 },
    //     { x: 89.3525179856115, y: 3.37254901960784, size: 1 },
    //     { x: 90, y: 3.41176470588235, size: 1 },
    //     { x: 90.6474820143885, y: 2.90196078431373, size: 1 },
    //     { x: 91.294964028777, y: 2.54901960784314, size: 1 },
    //     { x: 91.9424460431655, y: 2.35294117647059, size: 1 },
    //     { x: 92.589928057554, y: 3.37254901960784, size: 1 },
    //     { x: 93.8848920863309, y: 3.72549019607843, size: 1 },
    //     { x: 95.1798561151079, y: 3.52941176470588, size: 1 },
    //     { x: 97.1223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 97.7697841726619, y: 3.37254901960784, size: 1 },
    //     { x: 98.4172661870504, y: 3.88235294117647, size: 1 },
    //     { x: 99.0647482014388, y: 3.41176470588235, size: 1 },
    //     { x: 99.7122302158273, y: 3.68627450980392, size: 1 },
    //     { x: 101.654676258993, y: 3.80392156862745, size: 1 },
    //     { x: 102.94964028777, y: 3.45098039215686, size: 1 },
    //     { x: 103.597122302158, y: 3.68627450980392, size: 1 },
    //     { x: 104.892086330935, y: 3.56862745098039, size: 1 },
    //     { x: 106.187050359712, y: 3.68627450980392, size: 1 },
    //     { x: 106.834532374101, y: 3.64705882352941, size: 1 },
    //     { x: 107.482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 108.129496402878, y: 3.56862745098039, size: 1 },
    //     { x: 108.776978417266, y: 3.45098039215686, size: 1 },
    //     { x: 109.424460431655, y: 3.6078431372549, size: 1 },
    //     { x: 110.071942446043, y: 3.49019607843137, size: 1 },
    //     { x: 110.719424460432, y: 3.41176470588235, size: 1 },
    //     { x: 111.36690647482, y: 3.25490196078431, size: 1 },
    //     { x: 112.014388489209, y: 3.25490196078431, size: 1 },
    //     { x: 112.661870503597, y: 3.25490196078431, size: 1 },
    //     { x: 113.309352517986, y: 3.01960784313725, size: 1 },
    //     { x: 113.956834532374, y: 3.29411764705882, size: 1 },
    //     { x: 114.604316546763, y: 3.41176470588235, size: 1 },
    //     { x: 115.251798561151, y: 3.68627450980392, size: 1 },
    //     { x: 115.89928057554, y: 3.37254901960784, size: 1 },
    //     { x: 116.546762589928, y: 3.72549019607843, size: 1 },
    //     { x: 117.841726618705, y: 3.52941176470588, size: 1 },
    //     { x: 118.489208633094, y: 3.80392156862745, size: 1 },
    //     { x: 119.784172661871, y: 3.29411764705882, size: 1 },
    //     { x: 120.431654676259, y: 3.52941176470588, size: 1 },
    //     { x: 121.079136690647, y: 3.52941176470588, size: 1 },
    //     { x: 121.726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 122.374100719424, y: 3.68627450980392, size: 1 },
    //     { x: 123.021582733813, y: 3.45098039215686, size: 1 },
    //     { x: 123.669064748201, y: 3.37254901960784, size: 1 },
    //     { x: 124.31654676259, y: 3.52941176470588, size: 1 },
    //     { x: 124.964028776978, y: 3.49019607843137, size: 1 },
    //     { x: 125.611510791367, y: 3.56862745098039, size: 1 },
    //     { x: 126.258992805755, y: 3.64705882352941, size: 1 },
    //     { x: 126.906474820144, y: 3.6078431372549, size: 1 },
    //     { x: 128.201438848921, y: 3.56862745098039, size: 1 },
    //     { x: 128.848920863309, y: 3.56862745098039, size: 1 },
    //     { x: 129.496402877698, y: 3.52941176470588, size: 1 },
    //     { x: 130.143884892086, y: 3.49019607843137, size: 1 },
    //     { x: 130.791366906475, y: 3.49019607843137, size: 1 },
    //     { x: 132.086330935252, y: 3.49019607843137, size: 1 },
    //     { x: 133.381294964029, y: 3.2156862745098, size: 1 },
    //     { x: 134.028776978417, y: 3.13725490196078, size: 1 },
    //     { x: 134.676258992806, y: 2.74509803921569, size: 1 },
    //     { x: 135.323741007194, y: 3.37254901960784, size: 1 },
    //     { x: 135.971223021583, y: 3.52941176470588, size: 1 },
    //     { x: 136.618705035971, y: 3.56862745098039, size: 1 },
    //     { x: 137.26618705036, y: 3.64705882352941, size: 1 },
    //     { x: 137.913669064748, y: 3.45098039215686, size: 1 },
    //     { x: 139.208633093525, y: 3.56862745098039, size: 1 },
    //     { x: 139.856115107914, y: 3.80392156862745, size: 1 },
    //     { x: 141.151079136691, y: 3.52941176470588, size: 1 },
    //     { x: 141.798561151079, y: 3.88235294117647, size: 1 },
    //     { x: 142.446043165468, y: 3.72549019607843, size: 1 },
    //     { x: 143.093525179856, y: 3.52941176470588, size: 1 },
    //     { x: 144.388489208633, y: 3.49019607843137, size: 1 },
    //     { x: 145.035971223022, y: 3.6078431372549, size: 1 },
    //     { x: 145.68345323741, y: 3.56862745098039, size: 1 },
    //     { x: 146.330935251799, y: 3.84313725490196, size: 1 },
    //     { x: 146.978417266187, y: 3.80392156862745, size: 1 },
    //     { x: 147.625899280576, y: 3.64705882352941, size: 1 },
    //     { x: 148.920863309353, y: 3.68627450980392, size: 1 },
    //     { x: 149.568345323741, y: 3.6078431372549, size: 1 },
    //     { x: 152.805755395683, y: 3.56862745098039, size: 1 },
    //     { x: 154.10071942446, y: 3.25490196078431, size: 1 },
    //     { x: 154.748201438849, y: 3.17647058823529, size: 1 },
    //     { x: 155.395683453237, y: 3.01960784313725, size: 1 },
    //     { x: 156.043165467626, y: 2.58823529411765, size: 1 },
    //     { x: 156.690647482014, y: 1.92156862745098, size: 1 },
    //     { x: 157.338129496403, y: 3.6078431372549, size: 1 },
    //     { x: 157.985611510791, y: 3.56862745098039, size: 1 },
    //     { x: 158.63309352518, y: 3.64705882352941, size: 1 },
    //     { x: 159.928057553957, y: 3.52941176470588, size: 1 },
    //     { x: 160.575539568345, y: 3.72549019607843, size: 1 },
    //     { x: 161.223021582734, y: 3.52941176470588, size: 1 },
    //     { x: 161.870503597122, y: 3.84313725490196, size: 1 },
    //     { x: 162.517985611511, y: 3.84313725490196, size: 1 },
    //     { x: 163.165467625899, y: 3.88235294117647, size: 1 },
    //     { x: 163.812949640288, y: 3.76470588235294, size: 1 },
    //     { x: 164.460431654676, y: 3.80392156862745, size: 1 },
    //     { x: 165.107913669065, y: 3.52941176470588, size: 1 },
    //     { x: 165.755395683453, y: 3.68627450980392, size: 1 },
    //     { x: 166.402877697842, y: 3.64705882352941, size: 1 },
    //     { x: 167.697841726619, y: 3.6078431372549, size: 1 },
    //     { x: 168.345323741007, y: 3.76470588235294, size: 1 },
    //     { x: 168.992805755396, y: 3.49019607843137, size: 1 },
    //     { x: 169.640287769784, y: 3.84313725490196, size: 1 },
    //     { x: 170.287769784173, y: 3.64705882352941, size: 1 },
    //     { x: 170.935251798561, y: 3.64705882352941, size: 1 },
    //     { x: 171.58273381295, y: 3.52941176470588, size: 1 },
    //     { x: 173.525179856115, y: 3.49019607843137, size: 1 },
    //     { x: 174.172661870504, y: 3.49019607843137, size: 1 },
    //     { x: 174.820143884892, y: 3.80392156862745, size: 1 },
    //     { x: 176.115107913669, y: 3.29411764705882, size: 1 },
    //     { x: 176.762589928058, y: 3.37254901960784, size: 1 },
    //     { x: 177.410071942446, y: 3.05882352941176, size: 1 },
    //     { x: 178.057553956835, y: 2.98039215686275, size: 1 },
    //     { x: 178.705035971223, y: 3.2156862745098, size: 1 },
    //     { x: 179.352517985612, y: 3.76470588235294, size: 1 },
    //     { x: 180, y: 3.49019607843137, size: 1 },
    //     { x: 181.294964028777, y: 3.49019607843137, size: 1 },
    //     { x: 181.942446043165, y: 3.80392156862745, size: 1 },
    //     { x: 183.884892086331, y: 3.52941176470588, size: 1 },
    //     { x: 184.532374100719, y: 3.33333333333333, size: 1 },
    //     { x: 185.179856115108, y: 3.64705882352941, size: 1 },
    //     { x: 186.474820143885, y: 3.37254901960784, size: 1 },
    //     { x: 187.122302158273, y: 3.64705882352941, size: 1 },
    //     { x: 188.41726618705, y: 3.37254901960784, size: 1 },
    //     { x: 189.064748201439, y: 3.56862745098039, size: 1 },
    //     { x: 189.712230215827, y: 3.6078431372549, size: 1 },
    //     { x: 190.359712230216, y: 3.41176470588235, size: 1 },
    //     { x: 191.007194244604, y: 3.52941176470588, size: 1 },
    //     { x: 191.654676258993, y: 3.37254901960784, size: 1 },
    //     { x: 192.302158273381, y: 3.49019607843137, size: 1 },
    //     { x: 192.94964028777, y: 3.80392156862745, size: 1 },
    //     { x: 194.244604316547, y: 3.41176470588235, size: 1 },
    //     { x: 194.892086330935, y: 3.41176470588235, size: 1 },
    //     { x: 196.187050359712, y: 3.45098039215686, size: 1 },
    //     { x: 196.834532374101, y: 3.37254901960784, size: 1 },
    //     { x: 197.482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 198.129496402878, y: 3.37254901960784, size: 1 },
    //     { x: 198.776978417266, y: 3.2156862745098, size: 1 },
    //     { x: 199.424460431655, y: 3.13725490196078, size: 1 },
    //     { x: 200.071942446043, y: 3.2156862745098, size: 1 },
    //     { x: 200.719424460432, y: 3.49019607843137, size: 1 },
    //     { x: 201.36690647482, y: 3.41176470588235, size: 1 },
    //     { x: 202.014388489209, y: 3.49019607843137, size: 1 },
    //     { x: 203.309352517986, y: 3.64705882352941, size: 1 },
    //     { x: 203.956834532374, y: 3.52941176470588, size: 1 },
    //     { x: 204.604316546763, y: 3.52941176470588, size: 1 },
    //     { x: 205.89928057554, y: 3.52941176470588, size: 1 },
    //     { x: 206.546762589928, y: 3.68627450980392, size: 1 },
    //     { x: 207.194244604317, y: 3.56862745098039, size: 1 },
    //     { x: 207.841726618705, y: 3.64705882352941, size: 1 },
    //     { x: 209.136690647482, y: 3.64705882352941, size: 1 },
    //     { x: 209.784172661871, y: 3.56862745098039, size: 1 },
    //     { x: 210.431654676259, y: 3.72549019607843, size: 1 },
    //     { x: 211.079136690647, y: 3.41176470588235, size: 1 },
    //     { x: 211.726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 212.374100719424, y: 3.6078431372549, size: 1 },
    //     { x: 213.021582733813, y: 3.6078431372549, size: 1 },
    //     { x: 214.31654676259, y: 3.56862745098039, size: 1 },
    //     { x: 215.611510791367, y: 3.49019607843137, size: 1 },
    //     { x: 216.258992805755, y: 3.45098039215686, size: 1 },
    //     { x: 217.553956834532, y: 3.64705882352941, size: 1 },
    //     { x: 218.848920863309, y: 3.25490196078431, size: 1 },
    //     { x: 219.496402877698, y: 3.37254901960784, size: 1 },
    //     { x: 220.143884892086, y: 3.17647058823529, size: 1 },
    //     { x: 220.791366906475, y: 2.07843137254902, size: 1 },
    //     { x: 221.438848920863, y: 2.11764705882353, size: 1 },
    //     { x: 222.086330935252, y: 3.68627450980392, size: 1 },
    //     { x: 222.73381294964, y: 3.56862745098039, size: 1 },
    //     { x: 224.028776978417, y: 3.64705882352941, size: 1 },
    //     { x: 224.676258992806, y: 3.56862745098039, size: 1 },
    //     { x: 225.971223021583, y: 3.72549019607843, size: 1 },
    //     { x: 227.26618705036, y: 3.6078431372549, size: 1 },
    //     { x: 227.913669064748, y: 3.68627450980392, size: 1 },
    //     { x: 228.561151079137, y: 3.72549019607843, size: 1 },
    //     { x: 229.208633093525, y: 3.76470588235294, size: 1 },
    //     { x: 229.856115107914, y: 3.72549019607843, size: 1 },
    //     { x: 231.151079136691, y: 3.76470588235294, size: 1 },
    //     { x: 231.798561151079, y: 3.52941176470588, size: 1 },
    //     { x: 232.446043165468, y: 3.72549019607843, size: 1 },
    //     { x: 233.093525179856, y: 3.64705882352941, size: 1 },
    //     { x: 234.388489208633, y: 3.76470588235294, size: 1 },
    //     { x: 235.035971223022, y: 3.68627450980392, size: 1 },
    //     { x: 235.68345323741, y: 3.52941176470588, size: 1 },
    //     { x: 236.330935251799, y: 3.88235294117647, size: 1 },
    //     { x: 236.978417266187, y: 3.56862745098039, size: 1 },
    //     { x: 238.920863309353, y: 3.64705882352941, size: 1 },
    //     { x: 239.568345323741, y: 3.64705882352941, size: 1 },
    //     { x: 240.215827338129, y: 3.56862745098039, size: 1 },
    //     { x: 240.863309352518, y: 3.6078431372549, size: 1 },
    //     { x: 241.510791366906, y: 3.41176470588235, size: 1 },
    //     { x: 242.805755395683, y: 3.45098039215686, size: 1 },
    //     { x: 243.453237410072, y: 3.33333333333333, size: 1 },
    //     { x: 244.10071942446, y: 3.25490196078431, size: 1 },
    //     { x: 244.748201438849, y: 3.45098039215686, size: 1 },
    //     { x: 245.395683453237, y: 3.6078431372549, size: 1 },
    //     { x: 246.043165467626, y: 3.33333333333333, size: 1 },
    //     { x: 247.338129496403, y: 3.49019607843137, size: 1 },
    //     { x: 247.985611510791, y: 3.41176470588235, size: 1 },
    //     { x: 248.63309352518, y: 3.41176470588235, size: 1 },
    //     { x: 249.280575539568, y: 3.37254901960784, size: 1 },
    //     { x: 250.575539568345, y: 3.6078431372549, size: 1 },
    //     { x: 251.223021582734, y: 3.56862745098039, size: 1 },
    //     { x: 251.870503597122, y: 3.76470588235294, size: 1 },
    //     { x: 253.165467625899, y: 3.33333333333333, size: 1 },
    //     { x: 254.460431654676, y: 3.56862745098039, size: 1 },
    //     { x: 255.107913669065, y: 3.49019607843137, size: 1 },
    //     { x: 256.402877697842, y: 3.45098039215686, size: 1 },
    //     { x: 257.05035971223, y: 3.33333333333333, size: 1 },
    //     { x: 257.697841726619, y: 3.56862745098039, size: 1 },
    //     { x: 258.345323741007, y: 3.64705882352941, size: 1 },
    //     { x: 259.640287769784, y: 3.2156862745098, size: 1 },
    //     { x: 260.287769784173, y: 3.37254901960784, size: 1 },
    //     { x: 260.935251798561, y: 3.49019607843137, size: 1 },
    //     { x: 261.58273381295, y: 3.56862745098039, size: 1 },
    //     { x: 262.230215827338, y: 3.09803921568627, size: 1 },
    //     { x: 262.877697841727, y: 3.29411764705882, size: 1 },
    //     { x: 264.172661870504, y: 3.64705882352941, size: 1 },
    //     { x: 264.820143884892, y: 3.80392156862745, size: 1 },
    //     { x: 265.467625899281, y: 3.68627450980392, size: 1 },
    //     { x: 268.057553956835, y: 3.72549019607843, size: 1 },
    //     { x: 268.705035971223, y: 3.6078431372549, size: 1 },
    //     { x: 269.352517985611, y: 3.52941176470588, size: 1 },
    //     { x: 270, y: 3.68627450980392, size: 1 },
    //     { x: 270.647482014389, y: 3.6078431372549, size: 1 },
    //     { x: 271.294964028777, y: 3.72549019607843, size: 1 },
    //     { x: 272.589928057554, y: 3.56862745098039, size: 1 },
    //     { x: 274.532374100719, y: 3.56862745098039, size: 1 },
    //     { x: 277.122302158273, y: 3.6078431372549, size: 1 },
    //     { x: 278.41726618705, y: 3.64705882352941, size: 1 },
    //     { x: 279.712230215827, y: 3.52941176470588, size: 1 },
    //     { x: 280.359712230216, y: 3.6078431372549, size: 1 },
    //     { x: 282.302158273381, y: 3.52941176470588, size: 1 },
    //     { x: 282.94964028777, y: 3.52941176470588, size: 1 },
    //     { x: 283.597122302158, y: 3.49019607843137, size: 1 },
    //     { x: 284.892086330935, y: 3.29411764705882, size: 1 },
    //     { x: 285.539568345324, y: 3.76470588235294, size: 1 },
    //     { x: 286.187050359712, y: 3.56862745098039, size: 1 },
    //     { x: 286.834532374101, y: 3.68627450980392, size: 1 },
    //     { x: 287.482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 288.129496402878, y: 3.76470588235294, size: 1 },
    //     { x: 288.776978417266, y: 3.56862745098039, size: 1 },
    //     { x: 289.424460431655, y: 3.49019607843137, size: 1 },
    //     { x: 290.071942446043, y: 3.6078431372549, size: 1 },
    //     { x: 290.719424460432, y: 3.80392156862745, size: 1 },
    //     { x: 291.36690647482, y: 3.45098039215686, size: 1 },
    //     { x: 292.014388489209, y: 3.68627450980392, size: 1 },
    //     { x: 292.661870503597, y: 3.45098039215686, size: 1 },
    //     { x: 293.956834532374, y: 3.6078431372549, size: 1 },
    //     { x: 296.546762589928, y: 3.64705882352941, size: 1 },
    //     { x: 297.194244604317, y: 3.64705882352941, size: 1 },
    //     { x: 297.841726618705, y: 3.56862745098039, size: 1 },
    //     { x: 299.136690647482, y: 3.76470588235294, size: 1 },
    //     { x: 300.431654676259, y: 3.56862745098039, size: 1 },
    //     { x: 301.079136690647, y: 3.49019607843137, size: 1 },
    //     { x: 302.374100719424, y: 3.96078431372549, size: 1 },
    //     { x: 304.31654676259, y: 3.68627450980392, size: 1 },
    //     { x: 305.611510791367, y: 3.33333333333333, size: 1 },
    //     { x: 306.258992805755, y: 3.37254901960784, size: 1 },
    //     { x: 307.553956834532, y: 3.49019607843137, size: 1 },
    //     { x: 308.201438848921, y: 3.56862745098039, size: 1 },
    //     { x: 308.848920863309, y: 3.68627450980392, size: 1 },
    //     { x: 309.496402877698, y: 3.6078431372549, size: 1 },
    //     { x: 310.143884892086, y: 3.72549019607843, size: 1 },
    //     { x: 310.791366906475, y: 3.92156862745098, size: 1 },
    //     { x: 312.086330935252, y: 3.80392156862745, size: 1 },
    //     { x: 312.73381294964, y: 3.49019607843137, size: 1 },
    //     { x: 314.676258992806, y: 3.45098039215686, size: 1 },
    //     { x: 315.971223021583, y: 3.45098039215686, size: 1 },
    //     { x: 316.618705035971, y: 3.68627450980392, size: 1 },
    //     { x: 317.26618705036, y: 3.76470588235294, size: 1 },
    //     { x: 318.561151079137, y: 3.76470588235294, size: 1 },
    //     { x: 319.856115107914, y: 3.64705882352941, size: 1 },
    //     { x: 320.503597122302, y: 3.68627450980392, size: 1 },
    //     { x: 321.151079136691, y: 3.64705882352941, size: 1 },
    //     { x: 321.798561151079, y: 3.64705882352941, size: 1 },
    //     { x: 322.446043165468, y: 3.72549019607843, size: 1 },
    //     { x: 323.093525179856, y: 3.80392156862745, size: 1 },
    //     { x: 323.741007194245, y: 3.52941176470588, size: 1 },
    //     { x: 324.388489208633, y: 3.72549019607843, size: 1 },
    //     { x: 326.330935251799, y: 3.84313725490196, size: 1 },
    //     { x: 326.978417266187, y: 3.45098039215686, size: 1 },
    //     { x: 327.625899280576, y: 3.13725490196078, size: 1 },
    //     { x: 328.273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 328.920863309353, y: 2.66666666666667, size: 1 },
    //     { x: 329.568345323741, y: 3.45098039215686, size: 1 },
    //     { x: 331.510791366906, y: 3.56862745098039, size: 1 },
    //     { x: 332.158273381295, y: 3.56862745098039, size: 1 },
    //     { x: 333.453237410072, y: 3.64705882352941, size: 1 },
    //     { x: 334.10071942446, y: 3.56862745098039, size: 1 },
    //     { x: 335.395683453237, y: 3.49019607843137, size: 1 },
    //     { x: 336.043165467626, y: 3.41176470588235, size: 1 },
    //     { x: 337.338129496403, y: 3.72549019607843, size: 1 },
    //     { x: 337.985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 338.63309352518, y: 3.88235294117647, size: 1 },
    //     { x: 339.280575539568, y: 3.41176470588235, size: 1 },
    //     { x: 339.928057553957, y: 3.56862745098039, size: 1 },
    //     { x: 340.575539568345, y: 3.49019607843137, size: 1 },
    //     { x: 341.223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 341.870503597122, y: 3.6078431372549, size: 1 },
    //     { x: 342.517985611511, y: 3.52941176470588, size: 1 },
    //     { x: 343.165467625899, y: 3.76470588235294, size: 1 },
    //     { x: 343.812949640288, y: 3.6078431372549, size: 1 },
    //     { x: 344.460431654676, y: 3.84313725490196, size: 1 },
    //     { x: 345.107913669065, y: 3.56862745098039, size: 1 },
    //     { x: 345.755395683453, y: 3.80392156862745, size: 1 },
    //     { x: 346.402877697842, y: 3.56862745098039, size: 1 },
    //     { x: 347.05035971223, y: 3.52941176470588, size: 1 },
    //     { x: 347.697841726619, y: 3.68627450980392, size: 1 },
    //     { x: 348.345323741007, y: 3.49019607843137, size: 1 },
    //     { x: 348.992805755396, y: 3.37254901960784, size: 1 },
    //     { x: 350.287769784173, y: 3.29411764705882, size: 1 },
    //     { x: 351.58273381295, y: 3.52941176470588, size: 1 },
    //     { x: 352.877697841727, y: 3.45098039215686, size: 1 },
    //     { x: 355.467625899281, y: 3.56862745098039, size: 1 },
    //     { x: 356.115107913669, y: 3.76470588235294, size: 1 },
    //     { x: 356.762589928058, y: 3.6078431372549, size: 1 },
    //     { x: 357.410071942446, y: 3.80392156862745, size: 1 },
    //     { x: 358.705035971223, y: 3.64705882352941, size: 1 },
    //     { x: 359.352517985611, y: 3.37254901960784, size: 1 },
    //     { x: 0, y: 3.49019607843137, size: 1 },
    //     { x: 0.648648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 1.2972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 2.59459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 3.24324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 3.89189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 4.54054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 5.18918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 5.83783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 6.48648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 7.13513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 7.78378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 8.43243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 9.08108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 9.72972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 10.3783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 11.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 11.6756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 12.3243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 12.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 13.6216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 14.2702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 14.9189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 15.5675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 16.2162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 16.8648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 17.5135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 18.1621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 18.8108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 19.4594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 20.1081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 20.7567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 21.4054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 22.0540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 22.7027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 23.3513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 24, y: 3.6078431372549, size: 1 },
    //     { x: 24.6486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 25.2972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 25.9459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 26.5945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 27.2432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 27.8918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 28.5405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 29.1891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 29.8378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 30.4864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 31.1351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 31.7837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 32.4324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 33.0810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 33.7297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 35.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 35.6756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 36.3243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 36.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 37.6216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 38.2702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 38.9189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 39.5675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 40.2162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 40.8648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 41.5135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 42.1621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 42.8108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 43.4594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 44.1081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 44.7567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 45.4054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 46.0540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 46.7027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 47.3513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 48, y: 3.41176470588235, size: 1 },
    //     { x: 48.6486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 49.2972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 49.9459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 50.5945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 51.2432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 51.8918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 52.5405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 53.8378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 54.4864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 55.1351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 55.7837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 56.4324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 57.0810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 57.7297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 58.3783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 59.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 60.3243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 60.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 62.2702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 62.9189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 63.5675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 64.2162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 64.8648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 65.5135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 66.1621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 66.8108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 67.4594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 68.1081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 68.7567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 70.7027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 71.3513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 72, y: 3.37254901960784, size: 1 },
    //     { x: 72.6486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 73.2972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 73.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 75.2432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 75.8918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 76.5405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 77.1891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 77.8378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 78.4864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 79.1351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 79.7837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 80.4324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 81.0810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 81.7297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 82.3783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 83.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 83.6756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 84.3243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 84.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 85.6216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 86.2702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 86.9189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 87.5675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 88.2162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 88.8648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 89.5135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 90.1621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 90.8108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 91.4594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 92.1081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 92.7567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 93.4054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 94.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 94.7027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 95.3513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 96, y: 3.37254901960784, size: 1 },
    //     { x: 96.6486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 97.2972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 97.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 98.5945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 99.8918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 100.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 101.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 101.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 102.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 103.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 103.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 104.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 105.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 105.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 106.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 107.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 107.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 108.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 108.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 109.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 110.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 110.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 111.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 112.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 112.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 113.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 114.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 114.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 115.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 116.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 116.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 117.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 118.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 118.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 120, y: 3.17647058823529, size: 1 },
    //     { x: 120.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 121.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 121.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 122.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 123.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 123.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 124.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 125.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 125.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 126.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 127.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 128.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 129.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 129.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 130.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 131.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 131.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 132.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 132.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 133.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 134.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 135.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 136.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 137.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 138.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 138.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 139.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 140.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 140.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 141.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 142.054054054054, y: 2.86274509803922, size: 1 },
    //     { x: 142.702702702703, y: 2.90196078431373, size: 1 },
    //     { x: 143.351351351351, y: 2.70588235294118, size: 1 },
    //     { x: 144, y: 3.37254901960784, size: 1 },
    //     { x: 144.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 145.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 146.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 147.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 147.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 148.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 149.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 149.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 150.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 151.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 153.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 153.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 154.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 155.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 155.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 156.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 156.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 157.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 158.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 158.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 159.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 160.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 160.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 161.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 162.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 162.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 163.459459459459, y: 2.74509803921569, size: 1 },
    //     { x: 164.108108108108, y: 2.54901960784314, size: 1 },
    //     { x: 164.756756756757, y: 2.66666666666667, size: 1 },
    //     { x: 165.405405405405, y: 2.82352941176471, size: 1 },
    //     { x: 166.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 166.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 167.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 168, y: 3.6078431372549, size: 1 },
    //     { x: 168.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 169.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 169.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 170.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 171.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 172.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 173.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 173.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 174.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 175.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 175.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 176.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 177.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 177.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 178.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 179.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 179.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 180.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 180.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 181.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 182.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 182.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 184.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 184.864864864865, y: 3.01960784313725, size: 1 },
    //     { x: 185.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 186.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 186.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 187.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 188.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 188.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 189.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 190.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 190.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 191.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 192, y: 3.76470588235294, size: 1 },
    //     { x: 192.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 193.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 193.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 195.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 196.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 197.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 197.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 198.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 199.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 199.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 200.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 201.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 201.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 203.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 203.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 204.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 204.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 205.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 206.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 207.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 208.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 208.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 209.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 210.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 210.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 211.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 212.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 212.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 213.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 214.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 214.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 216, y: 3.56862745098039, size: 1 },
    //     { x: 216.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 217.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 217.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 218.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 219.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 219.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 220.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 221.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 221.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 222.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 223.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 223.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 224.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 225.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 226.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 227.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 227.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 228.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 228.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 229.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 230.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 230.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 231.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 232.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 232.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 233.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 234.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 234.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 235.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 236.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 236.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 238.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 238.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 239.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 240, y: 3.49019607843137, size: 1 },
    //     { x: 240.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 241.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 241.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 242.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 243.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 243.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 244.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 245.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 245.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 246.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 247.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 249.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 249.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 250.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 251.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 251.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 252.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 253.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 254.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 254.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 255.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 256.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 256.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 257.513513513513, y: 3.56862745098039, size: 1 },
    //     { x: 258.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 259.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 260.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 260.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 261.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 262.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 263.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 264, y: 3.64705882352941, size: 1 },
    //     { x: 264.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 265.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 265.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 266.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 267.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 267.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 268.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 269.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 269.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 270.486486486487, y: 3.64705882352941, size: 1 },
    //     { x: 271.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 271.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 272.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 273.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 273.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 274.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 275.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 275.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 276.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 276.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 277.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 278.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 278.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 279.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 280.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 281.513513513513, y: 3.52941176470588, size: 1 },
    //     { x: 282.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 282.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 283.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 284.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 285.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 286.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 286.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 287.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 288, y: 3.52941176470588, size: 1 },
    //     { x: 288.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 289.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 289.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 290.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 291.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 291.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 292.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 293.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 293.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 294.486486486487, y: 3.52941176470588, size: 1 },
    //     { x: 295.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 295.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 296.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 297.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 297.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 298.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 299.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 300.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 300.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 301.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 302.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 303.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 304.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 304.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 305.513513513513, y: 3.64705882352941, size: 1 },
    //     { x: 306.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 306.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 307.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 308.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 308.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 309.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 310.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 310.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 311.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 312, y: 3.68627450980392, size: 1 },
    //     { x: 312.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 313.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 313.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 314.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 315.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 315.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 316.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 317.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 317.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 318.486486486487, y: 3.84313725490196, size: 1 },
    //     { x: 319.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 319.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 320.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 321.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 321.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 323.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 323.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 324.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 325.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 326.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 326.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 327.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 328.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 328.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 329.513513513513, y: 3.49019607843137, size: 1 },
    //     { x: 330.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 330.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 331.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 332.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 332.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 333.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 334.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 334.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 335.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 336, y: 3.6078431372549, size: 1 },
    //     { x: 336.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 337.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 337.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 338.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 339.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 339.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 340.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 341.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 341.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 343.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 343.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 345.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 345.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 346.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 347.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 347.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 348.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 348.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 349.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 350.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 350.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 351.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 352.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 352.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 353.513513513513, y: 3.56862745098039, size: 1 },
    //     { x: 354.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 354.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 355.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 356.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 357.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 358.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 358.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 359.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 0.647482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 1.29496402877698, y: 3.56862745098039, size: 1 },
    //     { x: 2.58992805755396, y: 3.49019607843137, size: 1 },
    //     { x: 3.23741007194245, y: 3.41176470588235, size: 1 },
    //     { x: 3.88489208633094, y: 3.45098039215686, size: 1 },
    //     { x: 4.53237410071942, y: 3.49019607843137, size: 1 },
    //     { x: 5.17985611510791, y: 3.45098039215686, size: 1 },
    //     { x: 6.47482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 7.76978417266187, y: 3.92156862745098, size: 1 },
    //     { x: 8.41726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 9.71223021582734, y: 3.52941176470588, size: 1 },
    //     { x: 10.3597122302158, y: 3.56862745098039, size: 1 },
    //     { x: 11.0071942446043, y: 3.68627450980392, size: 1 },
    //     { x: 12.3021582733813, y: 3.41176470588235, size: 1 },
    //     { x: 12.9496402877698, y: 3.56862745098039, size: 1 },
    //     { x: 14.2446043165468, y: 3.49019607843137, size: 1 },
    //     { x: 14.8920863309353, y: 3.56862745098039, size: 1 },
    //     { x: 16.1870503597122, y: 3.56862745098039, size: 1 },
    //     { x: 16.8345323741007, y: 3.6078431372549, size: 1 },
    //     { x: 17.4820143884892, y: 3.37254901960784, size: 1 },
    //     { x: 18.1294964028777, y: 3.49019607843137, size: 1 },
    //     { x: 18.7769784172662, y: 3.33333333333333, size: 1 },
    //     { x: 20.0719424460432, y: 3.37254901960784, size: 1 },
    //     { x: 20.7194244604317, y: 3.41176470588235, size: 1 },
    //     { x: 21.3669064748201, y: 3.68627450980392, size: 1 },
    //     { x: 23.3093525179856, y: 3.52941176470588, size: 1 },
    //     { x: 23.9568345323741, y: 3.64705882352941, size: 1 },
    //     { x: 25.2517985611511, y: 3.64705882352941, size: 1 },
    //     { x: 26.5467625899281, y: 3.68627450980392, size: 1 },
    //     { x: 27.841726618705, y: 3.68627450980392, size: 1 },
    //     { x: 29.136690647482, y: 3.49019607843137, size: 1 },
    //     { x: 29.7841726618705, y: 3.68627450980392, size: 1 },
    //     { x: 30.431654676259, y: 3.80392156862745, size: 1 },
    //     { x: 31.0791366906475, y: 3.64705882352941, size: 1 },
    //     { x: 33.6690647482014, y: 3.56862745098039, size: 1 },
    //     { x: 34.3165467625899, y: 3.56862745098039, size: 1 },
    //     { x: 35.6115107913669, y: 3.64705882352941, size: 1 },
    //     { x: 36.9064748201439, y: 3.6078431372549, size: 1 },
    //     { x: 37.5539568345324, y: 3.45098039215686, size: 1 },
    //     { x: 38.8489208633094, y: 3.49019607843137, size: 1 },
    //     { x: 39.4964028776978, y: 3.56862745098039, size: 1 },
    //     { x: 40.1438848920863, y: 3.68627450980392, size: 1 },
    //     { x: 42.0863309352518, y: 3.6078431372549, size: 1 },
    //     { x: 42.7338129496403, y: 3.64705882352941, size: 1 },
    //     { x: 43.3812949640288, y: 3.52941176470588, size: 1 },
    //     { x: 44.0287769784173, y: 3.68627450980392, size: 1 },
    //     { x: 44.6762589928058, y: 3.64705882352941, size: 1 },
    //     { x: 46.6187050359712, y: 3.56862745098039, size: 1 },
    //     { x: 49.2086330935252, y: 3.29411764705882, size: 1 },
    //     { x: 49.8561151079137, y: 3.52941176470588, size: 1 },
    //     { x: 50.5035971223022, y: 3.68627450980392, size: 1 },
    //     { x: 51.1510791366906, y: 3.52941176470588, size: 1 },
    //     { x: 51.7985611510791, y: 3.6078431372549, size: 1 },
    //     { x: 52.4460431654676, y: 3.56862745098039, size: 1 },
    //     { x: 54.3884892086331, y: 3.84313725490196, size: 1 },
    //     { x: 55.0359712230216, y: 3.52941176470588, size: 1 },
    //     { x: 55.6834532374101, y: 3.52941176470588, size: 1 },
    //     { x: 56.3309352517986, y: 3.64705882352941, size: 1 },
    //     { x: 56.9784172661871, y: 3.80392156862745, size: 1 },
    //     { x: 58.273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 58.9208633093525, y: 3.56862745098039, size: 1 },
    //     { x: 60.2158273381295, y: 3.52941176470588, size: 1 },
    //     { x: 60.863309352518, y: 3.56862745098039, size: 1 },
    //     { x: 61.5107913669065, y: 3.72549019607843, size: 1 },
    //     { x: 62.8057553956835, y: 3.49019607843137, size: 1 },
    //     { x: 63.4532374100719, y: 3.37254901960784, size: 1 },
    //     { x: 64.1007194244604, y: 3.29411764705882, size: 1 },
    //     { x: 64.7482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 65.3956834532374, y: 3.37254901960784, size: 1 },
    //     { x: 66.0431654676259, y: 3.25490196078431, size: 1 },
    //     { x: 66.6906474820144, y: 3.56862745098039, size: 1 },
    //     { x: 67.3381294964029, y: 3.52941176470588, size: 1 },
    //     { x: 67.9856115107914, y: 3.52941176470588, size: 1 },
    //     { x: 68.6330935251799, y: 3.68627450980392, size: 1 },
    //     { x: 69.2805755395683, y: 3.37254901960784, size: 1 },
    //     { x: 69.9280575539568, y: 3.45098039215686, size: 1 },
    //     { x: 70.5755395683453, y: 3.33333333333333, size: 1 },
    //     { x: 71.2230215827338, y: 3.33333333333333, size: 1 },
    //     { x: 71.8705035971223, y: 3.52941176470588, size: 1 },
    //     { x: 73.1654676258993, y: 3.45098039215686, size: 1 },
    //     { x: 73.8129496402878, y: 3.37254901960784, size: 1 },
    //     { x: 74.4604316546763, y: 3.45098039215686, size: 1 },
    //     { x: 75.7553956834532, y: 3.37254901960784, size: 1 },
    //     { x: 76.4028776978417, y: 3.37254901960784, size: 1 },
    //     { x: 77.0503597122302, y: 3.2156862745098, size: 1 },
    //     { x: 77.6978417266187, y: 3.6078431372549, size: 1 },
    //     { x: 78.9928057553957, y: 3.56862745098039, size: 1 },
    //     { x: 79.6402877697842, y: 3.45098039215686, size: 1 },
    //     { x: 80.2877697841727, y: 3.33333333333333, size: 1 },
    //     { x: 80.9352517985612, y: 3.41176470588235, size: 1 },
    //     { x: 81.5827338129496, y: 3.45098039215686, size: 1 },
    //     { x: 82.2302158273381, y: 3.29411764705882, size: 1 },
    //     { x: 82.8776978417266, y: 3.37254901960784, size: 1 },
    //     { x: 83.5251798561151, y: 3.2156862745098, size: 1 },
    //     { x: 84.1726618705036, y: 3.09803921568627, size: 1 },
    //     { x: 84.8201438848921, y: 2.82352941176471, size: 1 },
    //     { x: 86.1151079136691, y: 3.49019607843137, size: 1 },
    //     { x: 87.410071942446, y: 3.52941176470588, size: 1 },
    //     { x: 88.705035971223, y: 3.68627450980392, size: 1 },
    //     { x: 89.3525179856115, y: 3.64705882352941, size: 1 },
    //     { x: 90, y: 3.25490196078431, size: 1 },
    //     { x: 90.6474820143885, y: 3.52941176470588, size: 1 },
    //     { x: 91.294964028777, y: 3.17647058823529, size: 1 },
    //     { x: 91.9424460431655, y: 3.33333333333333, size: 1 },
    //     { x: 92.589928057554, y: 3.41176470588235, size: 1 },
    //     { x: 93.2374100719424, y: 3.41176470588235, size: 1 },
    //     { x: 93.8848920863309, y: 3.64705882352941, size: 1 },
    //     { x: 94.5323741007194, y: 3.56862745098039, size: 1 },
    //     { x: 95.1798561151079, y: 3.41176470588235, size: 1 },
    //     { x: 95.8273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 97.1223021582734, y: 3.41176470588235, size: 1 },
    //     { x: 97.7697841726619, y: 3.84313725490196, size: 1 },
    //     { x: 98.4172661870504, y: 3.33333333333333, size: 1 },
    //     { x: 99.0647482014388, y: 3.6078431372549, size: 1 },
    //     { x: 99.7122302158273, y: 3.72549019607843, size: 1 },
    //     { x: 100.359712230216, y: 3.6078431372549, size: 1 },
    //     { x: 101.007194244604, y: 3.68627450980392, size: 1 },
    //     { x: 101.654676258993, y: 3.52941176470588, size: 1 },
    //     { x: 102.302158273381, y: 3.37254901960784, size: 1 },
    //     { x: 103.597122302158, y: 3.29411764705882, size: 1 },
    //     { x: 104.244604316547, y: 3.41176470588235, size: 1 },
    //     { x: 104.892086330935, y: 3.33333333333333, size: 1 },
    //     { x: 105.539568345324, y: 3.29411764705882, size: 1 },
    //     { x: 106.187050359712, y: 2.94117647058824, size: 1 },
    //     { x: 106.834532374101, y: 3.37254901960784, size: 1 },
    //     { x: 107.482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 108.129496402878, y: 3.33333333333333, size: 1 },
    //     { x: 108.776978417266, y: 3.25490196078431, size: 1 },
    //     { x: 109.424460431655, y: 3.37254901960784, size: 1 },
    //     { x: 110.071942446043, y: 3.41176470588235, size: 1 },
    //     { x: 110.719424460432, y: 3.68627450980392, size: 1 },
    //     { x: 111.36690647482, y: 3.37254901960784, size: 1 },
    //     { x: 112.014388489209, y: 3.37254901960784, size: 1 },
    //     { x: 112.661870503597, y: 3.33333333333333, size: 1 },
    //     { x: 114.604316546763, y: 3.52941176470588, size: 1 },
    //     { x: 115.251798561151, y: 3.49019607843137, size: 1 },
    //     { x: 116.546762589928, y: 3.25490196078431, size: 1 },
    //     { x: 117.194244604317, y: 3.37254901960784, size: 1 },
    //     { x: 117.841726618705, y: 3.2156862745098, size: 1 },
    //     { x: 118.489208633094, y: 3.37254901960784, size: 1 },
    //     { x: 119.136690647482, y: 3.33333333333333, size: 1 },
    //     { x: 119.784172661871, y: 3.09803921568627, size: 1 },
    //     { x: 120.431654676259, y: 3.25490196078431, size: 1 },
    //     { x: 121.726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 122.374100719424, y: 3.2156862745098, size: 1 },
    //     { x: 123.021582733813, y: 3.49019607843137, size: 1 },
    //     { x: 124.31654676259, y: 3.25490196078431, size: 1 },
    //     { x: 124.964028776978, y: 3.29411764705882, size: 1 },
    //     { x: 126.258992805755, y: 3.49019607843137, size: 1 },
    //     { x: 126.906474820144, y: 3.17647058823529, size: 1 },
    //     { x: 127.553956834532, y: 3.29411764705882, size: 1 },
    //     { x: 128.201438848921, y: 3.13725490196078, size: 1 },
    //     { x: 128.848920863309, y: 3.52941176470588, size: 1 },
    //     { x: 130.143884892086, y: 3.37254901960784, size: 1 },
    //     { x: 130.791366906475, y: 3.33333333333333, size: 1 },
    //     { x: 131.438848920863, y: 3.41176470588235, size: 1 },
    //     { x: 132.086330935252, y: 3.56862745098039, size: 1 },
    //     { x: 134.028776978417, y: 3.45098039215686, size: 1 },
    //     { x: 134.676258992806, y: 3.45098039215686, size: 1 },
    //     { x: 135.323741007194, y: 3.52941176470588, size: 1 },
    //     { x: 135.971223021583, y: 3.56862745098039, size: 1 },
    //     { x: 136.618705035971, y: 3.6078431372549, size: 1 },
    //     { x: 137.26618705036, y: 3.45098039215686, size: 1 },
    //     { x: 138.561151079137, y: 3.29411764705882, size: 1 },
    //     { x: 139.208633093525, y: 3.29411764705882, size: 1 },
    //     { x: 140.503597122302, y: 3.45098039215686, size: 1 },
    //     { x: 141.151079136691, y: 3.41176470588235, size: 1 },
    //     { x: 141.798561151079, y: 3.52941176470588, size: 1 },
    //     { x: 142.446043165468, y: 3.56862745098039, size: 1 },
    //     { x: 143.093525179856, y: 3.41176470588235, size: 1 },
    //     { x: 143.741007194245, y: 3.68627450980392, size: 1 },
    //     { x: 144.388489208633, y: 3.6078431372549, size: 1 },
    //     { x: 146.330935251799, y: 3.56862745098039, size: 1 },
    //     { x: 146.978417266187, y: 3.37254901960784, size: 1 },
    //     { x: 147.625899280576, y: 3.88235294117647, size: 1 },
    //     { x: 148.273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 149.568345323741, y: 3.09803921568627, size: 1 },
    //     { x: 150.863309352518, y: 3.56862745098039, size: 1 },
    //     { x: 152.158273381295, y: 3.6078431372549, size: 1 },
    //     { x: 154.10071942446, y: 3.84313725490196, size: 1 },
    //     { x: 154.748201438849, y: 3.84313725490196, size: 1 },
    //     { x: 155.395683453237, y: 3.52941176470588, size: 1 },
    //     { x: 156.043165467626, y: 3.76470588235294, size: 1 },
    //     { x: 156.690647482014, y: 3.45098039215686, size: 1 },
    //     { x: 157.338129496403, y: 3.64705882352941, size: 1 },
    //     { x: 158.63309352518, y: 3.6078431372549, size: 1 },
    //     { x: 159.280575539568, y: 3.56862745098039, size: 1 },
    //     { x: 159.928057553957, y: 3.56862745098039, size: 1 },
    //     { x: 160.575539568345, y: 3.45098039215686, size: 1 },
    //     { x: 161.870503597122, y: 3.56862745098039, size: 1 },
    //     { x: 163.165467625899, y: 3.68627450980392, size: 1 },
    //     { x: 163.812949640288, y: 3.64705882352941, size: 1 },
    //     { x: 165.107913669065, y: 3.64705882352941, size: 1 },
    //     { x: 165.755395683453, y: 3.72549019607843, size: 1 },
    //     { x: 166.402877697842, y: 3.52941176470588, size: 1 },
    //     { x: 168.345323741007, y: 3.52941176470588, size: 1 },
    //     { x: 168.992805755396, y: 3.41176470588235, size: 1 },
    //     { x: 169.640287769784, y: 3.41176470588235, size: 1 },
    //     { x: 170.287769784173, y: 3.6078431372549, size: 1 },
    //     { x: 170.935251798561, y: 3.25490196078431, size: 1 },
    //     { x: 172.230215827338, y: 3.25490196078431, size: 1 },
    //     { x: 172.877697841727, y: 3.37254901960784, size: 1 },
    //     { x: 174.172661870504, y: 3.45098039215686, size: 1 },
    //     { x: 174.820143884892, y: 3.33333333333333, size: 1 },
    //     { x: 175.467625899281, y: 3.45098039215686, size: 1 },
    //     { x: 176.115107913669, y: 3.76470588235294, size: 1 },
    //     { x: 176.762589928058, y: 3.45098039215686, size: 1 },
    //     { x: 177.410071942446, y: 3.52941176470588, size: 1 },
    //     { x: 178.705035971223, y: 3.29411764705882, size: 1 },
    //     { x: 179.352517985612, y: 3.37254901960784, size: 1 },
    //     { x: 180.647482014388, y: 3.41176470588235, size: 1 },
    //     { x: 182.589928057554, y: 3.45098039215686, size: 1 },
    //     { x: 183.237410071942, y: 3.29411764705882, size: 1 },
    //     { x: 183.884892086331, y: 3.41176470588235, size: 1 },
    //     { x: 184.532374100719, y: 3.72549019607843, size: 1 },
    //     { x: 185.179856115108, y: 3.41176470588235, size: 1 },
    //     { x: 185.827338129496, y: 3.56862745098039, size: 1 },
    //     { x: 186.474820143885, y: 3.49019607843137, size: 1 },
    //     { x: 187.122302158273, y: 3.41176470588235, size: 1 },
    //     { x: 187.769784172662, y: 3.37254901960784, size: 1 },
    //     { x: 189.064748201439, y: 3.41176470588235, size: 1 },
    //     { x: 189.712230215827, y: 3.56862745098039, size: 1 },
    //     { x: 190.359712230216, y: 3.72549019607843, size: 1 },
    //     { x: 191.654676258993, y: 3.52941176470588, size: 1 },
    //     { x: 192.94964028777, y: 3.49019607843137, size: 1 },
    //     { x: 193.597122302158, y: 3.52941176470588, size: 1 },
    //     { x: 194.244604316547, y: 3.45098039215686, size: 1 },
    //     { x: 195.539568345324, y: 3.45098039215686, size: 1 },
    //     { x: 197.482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 198.776978417266, y: 3.80392156862745, size: 1 },
    //     { x: 199.424460431655, y: 3.56862745098039, size: 1 },
    //     { x: 200.071942446043, y: 3.29411764705882, size: 1 },
    //     { x: 200.719424460432, y: 3.84313725490196, size: 1 },
    //     { x: 201.36690647482, y: 3.45098039215686, size: 1 },
    //     { x: 203.956834532374, y: 3.68627450980392, size: 1 },
    //     { x: 205.251798561151, y: 3.56862745098039, size: 1 },
    //     { x: 205.89928057554, y: 3.64705882352941, size: 1 },
    //     { x: 206.546762589928, y: 3.72549019607843, size: 1 },
    //     { x: 209.784172661871, y: 3.33333333333333, size: 1 },
    //     { x: 211.726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 213.021582733813, y: 3.45098039215686, size: 1 },
    //     { x: 213.669064748201, y: 3.68627450980392, size: 1 },
    //     { x: 214.31654676259, y: 3.6078431372549, size: 1 },
    //     { x: 214.964028776978, y: 3.45098039215686, size: 1 },
    //     { x: 215.611510791367, y: 3.37254901960784, size: 1 },
    //     { x: 216.258992805755, y: 3.64705882352941, size: 1 },
    //     { x: 216.906474820144, y: 3.56862745098039, size: 1 },
    //     { x: 217.553956834532, y: 3.45098039215686, size: 1 },
    //     { x: 218.201438848921, y: 3.49019607843137, size: 1 },
    //     { x: 218.848920863309, y: 3.76470588235294, size: 1 },
    //     { x: 220.143884892086, y: 3.64705882352941, size: 1 },
    //     { x: 220.791366906475, y: 3.45098039215686, size: 1 },
    //     { x: 221.438848920863, y: 3.76470588235294, size: 1 },
    //     { x: 222.086330935252, y: 3.49019607843137, size: 1 },
    //     { x: 223.381294964029, y: 3.52941176470588, size: 1 },
    //     { x: 224.028776978417, y: 3.52941176470588, size: 1 },
    //     { x: 224.676258992806, y: 3.41176470588235, size: 1 },
    //     { x: 225.323741007194, y: 3.6078431372549, size: 1 },
    //     { x: 225.971223021583, y: 3.49019607843137, size: 1 },
    //     { x: 226.618705035971, y: 3.76470588235294, size: 1 },
    //     { x: 228.561151079137, y: 3.37254901960784, size: 1 },
    //     { x: 229.856115107914, y: 3.45098039215686, size: 1 },
    //     { x: 230.503597122302, y: 3.56862745098039, size: 1 },
    //     { x: 231.151079136691, y: 3.37254901960784, size: 1 },
    //     { x: 231.798561151079, y: 3.6078431372549, size: 1 },
    //     { x: 232.446043165468, y: 3.45098039215686, size: 1 },
    //     { x: 233.741007194245, y: 3.52941176470588, size: 1 },
    //     { x: 235.035971223022, y: 3.2156862745098, size: 1 },
    //     { x: 235.68345323741, y: 3.05882352941176, size: 1 },
    //     { x: 236.978417266187, y: 3.72549019607843, size: 1 },
    //     { x: 238.273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 239.568345323741, y: 3.72549019607843, size: 1 },
    //     { x: 240.863309352518, y: 4, size: 1 },
    //     { x: 241.510791366906, y: 3.68627450980392, size: 1 },
    //     { x: 242.805755395683, y: 3.56862745098039, size: 1 },
    //     { x: 243.453237410072, y: 3.49019607843137, size: 1 },
    //     { x: 244.748201438849, y: 3.84313725490196, size: 1 },
    //     { x: 245.395683453237, y: 3.56862745098039, size: 1 },
    //     { x: 246.690647482014, y: 3.68627450980392, size: 1 },
    //     { x: 247.338129496403, y: 3.6078431372549, size: 1 },
    //     { x: 247.985611510791, y: 3.92156862745098, size: 1 },
    //     { x: 248.63309352518, y: 3.72549019607843, size: 1 },
    //     { x: 249.928057553957, y: 3.49019607843137, size: 1 },
    //     { x: 251.870503597122, y: 3.41176470588235, size: 1 },
    //     { x: 252.517985611511, y: 3.68627450980392, size: 1 },
    //     { x: 253.165467625899, y: 3.76470588235294, size: 1 },
    //     { x: 253.812949640288, y: 3.64705882352941, size: 1 },
    //     { x: 255.755395683453, y: 3.56862745098039, size: 1 },
    //     { x: 257.05035971223, y: 3.80392156862745, size: 1 },
    //     { x: 257.697841726619, y: 3.52941176470588, size: 1 },
    //     { x: 258.992805755396, y: 3.72549019607843, size: 1 },
    //     { x: 259.640287769784, y: 3.52941176470588, size: 1 },
    //     { x: 260.287769784173, y: 3.80392156862745, size: 1 },
    //     { x: 260.935251798561, y: 3.68627450980392, size: 1 },
    //     { x: 261.58273381295, y: 3.33333333333333, size: 1 },
    //     { x: 262.877697841727, y: 3.56862745098039, size: 1 },
    //     { x: 264.172661870504, y: 3.56862745098039, size: 1 },
    //     { x: 264.820143884892, y: 3.64705882352941, size: 1 },
    //     { x: 265.467625899281, y: 3.52941176470588, size: 1 },
    //     { x: 266.115107913669, y: 3.45098039215686, size: 1 },
    //     { x: 266.762589928058, y: 3.76470588235294, size: 1 },
    //     { x: 268.705035971223, y: 3.49019607843137, size: 1 },
    //     { x: 269.352517985611, y: 3.49019607843137, size: 1 },
    //     { x: 270.647482014389, y: 3.56862745098039, size: 1 },
    //     { x: 271.294964028777, y: 3.76470588235294, size: 1 },
    //     { x: 271.942446043165, y: 3.6078431372549, size: 1 },
    //     { x: 272.589928057554, y: 3.72549019607843, size: 1 },
    //     { x: 273.237410071942, y: 3.41176470588235, size: 1 },
    //     { x: 273.884892086331, y: 3.76470588235294, size: 1 },
    //     { x: 274.532374100719, y: 3.72549019607843, size: 1 },
    //     { x: 275.827338129496, y: 3.96078431372549, size: 1 },
    //     { x: 277.769784172662, y: 3.45098039215686, size: 1 },
    //     { x: 278.41726618705, y: 3.29411764705882, size: 1 },
    //     { x: 279.064748201439, y: 3.29411764705882, size: 1 },
    //     { x: 279.712230215827, y: 3.64705882352941, size: 1 },
    //     { x: 280.359712230216, y: 3.80392156862745, size: 1 },
    //     { x: 282.94964028777, y: 3.6078431372549, size: 1 },
    //     { x: 284.244604316547, y: 3.52941176470588, size: 1 },
    //     { x: 285.539568345324, y: 4.07843137254902, size: 1 },
    //     { x: 286.187050359712, y: 3.76470588235294, size: 1 },
    //     { x: 286.834532374101, y: 3.64705882352941, size: 1 },
    //     { x: 287.482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 288.129496402878, y: 3.56862745098039, size: 1 },
    //     { x: 289.424460431655, y: 3.80392156862745, size: 1 },
    //     { x: 290.719424460432, y: 3.56862745098039, size: 1 },
    //     { x: 291.36690647482, y: 3.76470588235294, size: 1 },
    //     { x: 292.014388489209, y: 3.64705882352941, size: 1 },
    //     { x: 293.309352517986, y: 3.72549019607843, size: 1 },
    //     { x: 294.604316546763, y: 3.56862745098039, size: 1 },
    //     { x: 297.194244604317, y: 3.72549019607843, size: 1 },
    //     { x: 297.841726618705, y: 3.6078431372549, size: 1 },
    //     { x: 298.489208633094, y: 3.37254901960784, size: 1 },
    //     { x: 299.136690647482, y: 3.68627450980392, size: 1 },
    //     { x: 299.784172661871, y: 3.17647058823529, size: 1 },
    //     { x: 300.431654676259, y: 3.33333333333333, size: 1 },
    //     { x: 302.374100719424, y: 3.76470588235294, size: 1 },
    //     { x: 303.669064748201, y: 3.80392156862745, size: 1 },
    //     { x: 304.31654676259, y: 3.6078431372549, size: 1 },
    //     { x: 305.611510791367, y: 3.64705882352941, size: 1 },
    //     { x: 307.553956834532, y: 3.72549019607843, size: 1 },
    //     { x: 308.201438848921, y: 3.72549019607843, size: 1 },
    //     { x: 308.848920863309, y: 3.49019607843137, size: 1 },
    //     { x: 309.496402877698, y: 3.68627450980392, size: 1 },
    //     { x: 310.791366906475, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.68627450980392, size: 1 },
    //     { x: 312.086330935252, y: 3.64705882352941, size: 1 },
    //     { x: 312.73381294964, y: 3.80392156862745, size: 1 },
    //     { x: 313.381294964029, y: 3.64705882352941, size: 1 },
    //     { x: 314.028776978417, y: 3.52941176470588, size: 1 },
    //     { x: 314.676258992806, y: 3.88235294117647, size: 1 },
    //     { x: 315.971223021583, y: 3.72549019607843, size: 1 },
    //     { x: 316.618705035971, y: 3.80392156862745, size: 1 },
    //     { x: 317.26618705036, y: 3.92156862745098, size: 1 },
    //     { x: 317.913669064748, y: 3.49019607843137, size: 1 },
    //     { x: 320.503597122302, y: 3.45098039215686, size: 1 },
    //     { x: 321.151079136691, y: 3.45098039215686, size: 1 },
    //     { x: 321.798561151079, y: 3.72549019607843, size: 1 },
    //     { x: 322.446043165468, y: 3.45098039215686, size: 1 },
    //     { x: 323.093525179856, y: 3.52941176470588, size: 1 },
    //     { x: 325.035971223022, y: 3.56862745098039, size: 1 },
    //     { x: 326.330935251799, y: 3.6078431372549, size: 1 },
    //     { x: 326.978417266187, y: 3.56862745098039, size: 1 },
    //     { x: 327.625899280576, y: 3.41176470588235, size: 1 },
    //     { x: 328.273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 329.568345323741, y: 3.72549019607843, size: 1 },
    //     { x: 330.215827338129, y: 3.52941176470588, size: 1 },
    //     { x: 330.863309352518, y: 3.68627450980392, size: 1 },
    //     { x: 331.510791366906, y: 3.49019607843137, size: 1 },
    //     { x: 332.158273381295, y: 3.49019607843137, size: 1 },
    //     { x: 333.453237410072, y: 3.52941176470588, size: 1 },
    //     { x: 334.748201438849, y: 3.72549019607843, size: 1 },
    //     { x: 335.395683453237, y: 3.45098039215686, size: 1 },
    //     { x: 336.043165467626, y: 3.68627450980392, size: 1 },
    //     { x: 336.690647482014, y: 3.68627450980392, size: 1 },
    //     { x: 337.985611510791, y: 3.64705882352941, size: 1 },
    //     { x: 339.928057553957, y: 3.41176470588235, size: 1 },
    //     { x: 340.575539568345, y: 3.52941176470588, size: 1 },
    //     { x: 341.223021582734, y: 3.76470588235294, size: 1 },
    //     { x: 343.165467625899, y: 3.49019607843137, size: 1 },
    //     { x: 343.812949640288, y: 3.56862745098039, size: 1 },
    //     { x: 345.755395683453, y: 3.68627450980392, size: 1 },
    //     { x: 346.402877697842, y: 3.52941176470588, size: 1 },
    //     { x: 347.05035971223, y: 3.72549019607843, size: 1 },
    //     { x: 348.345323741007, y: 3.33333333333333, size: 1 },
    //     { x: 348.992805755396, y: 3.56862745098039, size: 1 },
    //     { x: 349.640287769784, y: 3.84313725490196, size: 1 },
    //     { x: 350.935251798561, y: 3.49019607843137, size: 1 },
    //     { x: 351.58273381295, y: 3.56862745098039, size: 1 },
    //     { x: 352.230215827338, y: 3.52941176470588, size: 1 },
    //     { x: 353.525179856115, y: 4, size: 1 },
    //     { x: 354.172661870504, y: 3.49019607843137, size: 1 },
    //     { x: 354.820143884892, y: 3.92156862745098, size: 1 },
    //     { x: 355.467625899281, y: 3.84313725490196, size: 1 },
    //     { x: 356.115107913669, y: 3.72549019607843, size: 1 },
    //     { x: 356.762589928058, y: 3.64705882352941, size: 1 },
    //     { x: 357.410071942446, y: 3.6078431372549, size: 1 },
    //     { x: 358.057553956835, y: 3.6078431372549, size: 1 },
    //     { x: 358.705035971223, y: 3.49019607843137, size: 1 },
    //     { x: 359.352517985611, y: 3.52941176470588, size: 1 },
    //     { x: 0.647482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 4.53237410071942, y: 3.56862745098039, size: 1 },
    //     { x: 5.8273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 6.47482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 7.12230215827338, y: 3.52941176470588, size: 1 },
    //     { x: 7.76978417266187, y: 3.64705882352941, size: 1 },
    //     { x: 8.41726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 9.06474820143885, y: 3.56862745098039, size: 1 },
    //     { x: 9.71223021582734, y: 3.49019607843137, size: 1 },
    //     { x: 10.3597122302158, y: 3.29411764705882, size: 1 },
    //     { x: 11.0071942446043, y: 3.6078431372549, size: 1 },
    //     { x: 13.5971223021583, y: 3.64705882352941, size: 1 },
    //     { x: 16.1870503597122, y: 3.80392156862745, size: 1 },
    //     { x: 16.8345323741007, y: 3.56862745098039, size: 1 },
    //     { x: 17.4820143884892, y: 3.68627450980392, size: 1 },
    //     { x: 19.4244604316547, y: 3.68627450980392, size: 1 },
    //     { x: 20.0719424460432, y: 3.64705882352941, size: 1 },
    //     { x: 20.7194244604317, y: 3.68627450980392, size: 1 },
    //     { x: 21.3669064748201, y: 3.41176470588235, size: 1 },
    //     { x: 22.0143884892086, y: 3.64705882352941, size: 1 },
    //     { x: 22.6618705035971, y: 3.41176470588235, size: 1 },
    //     { x: 23.3093525179856, y: 3.49019607843137, size: 1 },
    //     { x: 23.9568345323741, y: 3.96078431372549, size: 1 },
    //     { x: 24.6043165467626, y: 3.33333333333333, size: 1 },
    //     { x: 25.2517985611511, y: 3.37254901960784, size: 1 },
    //     { x: 25.8992805755396, y: 3.2156862745098, size: 1 },
    //     { x: 26.5467625899281, y: 3.17647058823529, size: 1 },
    //     { x: 27.1942446043165, y: 3.33333333333333, size: 1 },
    //     { x: 27.841726618705, y: 3.56862745098039, size: 1 },
    //     { x: 28.4892086330935, y: 3.64705882352941, size: 1 },
    //     { x: 29.136690647482, y: 3.56862745098039, size: 1 },
    //     { x: 29.7841726618705, y: 3.45098039215686, size: 1 },
    //     { x: 30.431654676259, y: 3.56862745098039, size: 1 },
    //     { x: 33.0215827338129, y: 3.52941176470588, size: 1 },
    //     { x: 34.3165467625899, y: 3.41176470588235, size: 1 },
    //     { x: 34.9640287769784, y: 3.41176470588235, size: 1 },
    //     { x: 35.6115107913669, y: 3.45098039215686, size: 1 },
    //     { x: 36.2589928057554, y: 3.52941176470588, size: 1 },
    //     { x: 37.5539568345324, y: 3.64705882352941, size: 1 },
    //     { x: 38.2014388489209, y: 3.56862745098039, size: 1 },
    //     { x: 39.4964028776978, y: 3.52941176470588, size: 1 },
    //     { x: 40.7913669064748, y: 3.45098039215686, size: 1 },
    //     { x: 42.7338129496403, y: 3.56862745098039, size: 1 },
    //     { x: 43.3812949640288, y: 3.37254901960784, size: 1 },
    //     { x: 44.6762589928058, y: 3.41176470588235, size: 1 },
    //     { x: 45.3237410071942, y: 3.52941176470588, size: 1 },
    //     { x: 47.2661870503597, y: 3.49019607843137, size: 1 },
    //     { x: 47.9136690647482, y: 2.90196078431373, size: 1 },
    //     { x: 48.5611510791367, y: 2.7843137254902, size: 1 },
    //     { x: 49.2086330935252, y: 2.98039215686275, size: 1 },
    //     { x: 49.8561151079137, y: 2.94117647058824, size: 1 },
    //     { x: 51.1510791366906, y: 3.68627450980392, size: 1 },
    //     { x: 51.7985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 52.4460431654676, y: 3.72549019607843, size: 1 },
    //     { x: 53.0935251798561, y: 3.56862745098039, size: 1 },
    //     { x: 53.7410071942446, y: 3.56862745098039, size: 1 },
    //     { x: 54.3884892086331, y: 3.80392156862745, size: 1 },
    //     { x: 55.6834532374101, y: 3.68627450980392, size: 1 },
    //     { x: 56.9784172661871, y: 3.6078431372549, size: 1 },
    //     { x: 57.6258992805755, y: 3.56862745098039, size: 1 },
    //     { x: 59.568345323741, y: 3.52941176470588, size: 1 },
    //     { x: 61.5107913669065, y: 3.56862745098039, size: 1 },
    //     { x: 62.158273381295, y: 3.76470588235294, size: 1 },
    //     { x: 63.4532374100719, y: 3.52941176470588, size: 1 },
    //     { x: 64.7482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 3.52941176470588, size: 1 },
    //     { x: 66.6906474820144, y: 3.68627450980392, size: 1 },
    //     { x: 67.9856115107914, y: 3.41176470588235, size: 1 },
    //     { x: 69.2805755395683, y: 3.2156862745098, size: 1 },
    //     { x: 69.9280575539568, y: 3.25490196078431, size: 1 },
    //     { x: 70.5755395683453, y: 3.52941176470588, size: 1 },
    //     { x: 71.2230215827338, y: 3.45098039215686, size: 1 },
    //     { x: 71.8705035971223, y: 3.41176470588235, size: 1 },
    //     { x: 72.5179856115108, y: 3.6078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 3.41176470588235, size: 1 },
    //     { x: 73.8129496402878, y: 3.56862745098039, size: 1 },
    //     { x: 75.1079136690647, y: 3.52941176470588, size: 1 },
    //     { x: 75.7553956834532, y: 3.41176470588235, size: 1 },
    //     { x: 76.4028776978417, y: 3.52941176470588, size: 1 },
    //     { x: 77.0503597122302, y: 3.68627450980392, size: 1 },
    //     { x: 78.3453237410072, y: 3.37254901960784, size: 1 },
    //     { x: 79.6402877697842, y: 3.6078431372549, size: 1 },
    //     { x: 80.2877697841727, y: 3.56862745098039, size: 1 },
    //     { x: 80.9352517985612, y: 3.45098039215686, size: 1 },
    //     { x: 81.5827338129496, y: 3.64705882352941, size: 1 },
    //     { x: 82.2302158273381, y: 3.45098039215686, size: 1 },
    //     { x: 83.5251798561151, y: 3.41176470588235, size: 1 },
    //     { x: 86.1151079136691, y: 3.33333333333333, size: 1 },
    //     { x: 86.7625899280576, y: 3.49019607843137, size: 1 },
    //     { x: 87.410071942446, y: 3.56862745098039, size: 1 },
    //     { x: 88.0575539568345, y: 3.56862745098039, size: 1 },
    //     { x: 90, y: 3.33333333333333, size: 1 },
    //     { x: 90.6474820143885, y: 3.2156862745098, size: 1 },
    //     { x: 91.294964028777, y: 2.86274509803922, size: 1 },
    //     { x: 91.9424460431655, y: 3.41176470588235, size: 1 },
    //     { x: 92.589928057554, y: 3.84313725490196, size: 1 },
    //     { x: 93.2374100719424, y: 3.37254901960784, size: 1 },
    //     { x: 93.8848920863309, y: 3.49019607843137, size: 1 },
    //     { x: 94.5323741007194, y: 3.88235294117647, size: 1 },
    //     { x: 95.1798561151079, y: 3.68627450980392, size: 1 },
    //     { x: 95.8273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 96.4748201438849, y: 3.80392156862745, size: 1 },
    //     { x: 97.1223021582734, y: 3.84313725490196, size: 1 },
    //     { x: 97.7697841726619, y: 3.56862745098039, size: 1 },
    //     { x: 98.4172661870504, y: 3.64705882352941, size: 1 },
    //     { x: 99.0647482014388, y: 3.64705882352941, size: 1 },
    //     { x: 99.7122302158273, y: 3.56862745098039, size: 1 },
    //     { x: 100.359712230216, y: 3.52941176470588, size: 1 },
    //     { x: 101.007194244604, y: 3.49019607843137, size: 1 },
    //     { x: 101.654676258993, y: 3.56862745098039, size: 1 },
    //     { x: 102.302158273381, y: 3.56862745098039, size: 1 },
    //     { x: 104.244604316547, y: 3.72549019607843, size: 1 },
    //     { x: 105.539568345324, y: 3.6078431372549, size: 1 },
    //     { x: 106.834532374101, y: 3.56862745098039, size: 1 },
    //     { x: 108.776978417266, y: 3.6078431372549, size: 1 },
    //     { x: 111.36690647482, y: 3.41176470588235, size: 1 },
    //     { x: 112.661870503597, y: 3.45098039215686, size: 1 },
    //     { x: 113.309352517986, y: 3.52941176470588, size: 1 },
    //     { x: 113.956834532374, y: 3.6078431372549, size: 1 },
    //     { x: 114.604316546763, y: 3.76470588235294, size: 1 },
    //     { x: 115.89928057554, y: 3.56862745098039, size: 1 },
    //     { x: 116.546762589928, y: 3.76470588235294, size: 1 },
    //     { x: 117.194244604317, y: 3.6078431372549, size: 1 },
    //     { x: 119.136690647482, y: 3.6078431372549, size: 1 },
    //     { x: 119.784172661871, y: 3.49019607843137, size: 1 },
    //     { x: 121.079136690647, y: 3.88235294117647, size: 1 },
    //     { x: 121.726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 122.374100719424, y: 3.6078431372549, size: 1 },
    //     { x: 123.021582733813, y: 3.56862745098039, size: 1 },
    //     { x: 123.669064748201, y: 3.72549019607843, size: 1 },
    //     { x: 124.31654676259, y: 3.68627450980392, size: 1 },
    //     { x: 125.611510791367, y: 3.52941176470588, size: 1 },
    //     { x: 126.906474820144, y: 3.49019607843137, size: 1 },
    //     { x: 127.553956834532, y: 3.64705882352941, size: 1 },
    //     { x: 128.848920863309, y: 3.41176470588235, size: 1 },
    //     { x: 129.496402877698, y: 3.45098039215686, size: 1 },
    //     { x: 130.791366906475, y: 3.6078431372549, size: 1 },
    //     { x: 131.438848920863, y: 3.6078431372549, size: 1 },
    //     { x: 133.381294964029, y: 3.49019607843137, size: 1 },
    //     { x: 134.028776978417, y: 3.2156862745098, size: 1 },
    //     { x: 134.676258992806, y: 3.01960784313725, size: 1 },
    //     { x: 135.971223021583, y: 3.64705882352941, size: 1 },
    //     { x: 136.618705035971, y: 3.72549019607843, size: 1 },
    //     { x: 137.26618705036, y: 3.68627450980392, size: 1 },
    //     { x: 137.913669064748, y: 3.72549019607843, size: 1 },
    //     { x: 138.561151079137, y: 3.76470588235294, size: 1 },
    //     { x: 139.856115107914, y: 3.72549019607843, size: 1 },
    //     { x: 140.503597122302, y: 3.76470588235294, size: 1 },
    //     { x: 141.151079136691, y: 3.88235294117647, size: 1 },
    //     { x: 141.798561151079, y: 3.6078431372549, size: 1 },
    //     { x: 142.446043165468, y: 3.68627450980392, size: 1 },
    //     { x: 143.093525179856, y: 3.6078431372549, size: 1 },
    //     { x: 144.388489208633, y: 3.84313725490196, size: 1 },
    //     { x: 145.035971223022, y: 3.56862745098039, size: 1 },
    //     { x: 145.68345323741, y: 3.6078431372549, size: 1 },
    //     { x: 146.330935251799, y: 3.68627450980392, size: 1 },
    //     { x: 146.978417266187, y: 3.56862745098039, size: 1 },
    //     { x: 147.625899280576, y: 3.76470588235294, size: 1 },
    //     { x: 149.568345323741, y: 3.76470588235294, size: 1 },
    //     { x: 150.215827338129, y: 3.72549019607843, size: 1 },
    //     { x: 151.510791366906, y: 3.56862745098039, size: 1 },
    //     { x: 152.805755395683, y: 3.52941176470588, size: 1 },
    //     { x: 155.395683453237, y: 3.56862745098039, size: 1 },
    //     { x: 156.043165467626, y: 3.29411764705882, size: 1 },
    //     { x: 157.338129496403, y: 3.37254901960784, size: 1 },
    //     { x: 158.63309352518, y: 3.68627450980392, size: 1 },
    //     { x: 159.280575539568, y: 3.80392156862745, size: 1 },
    //     { x: 159.928057553957, y: 3.72549019607843, size: 1 },
    //     { x: 160.575539568345, y: 3.52941176470588, size: 1 },
    //     { x: 161.870503597122, y: 3.41176470588235, size: 1 },
    //     { x: 163.165467625899, y: 3.56862745098039, size: 1 },
    //     { x: 163.812949640288, y: 3.68627450980392, size: 1 },
    //     { x: 164.460431654676, y: 3.64705882352941, size: 1 },
    //     { x: 165.107913669065, y: 3.68627450980392, size: 1 },
    //     { x: 165.755395683453, y: 3.76470588235294, size: 1 },
    //     { x: 166.402877697842, y: 3.6078431372549, size: 1 },
    //     { x: 167.697841726619, y: 3.49019607843137, size: 1 },
    //     { x: 168.345323741007, y: 3.68627450980392, size: 1 },
    //     { x: 169.640287769784, y: 3.76470588235294, size: 1 },
    //     { x: 170.287769784173, y: 3.76470588235294, size: 1 },
    //     { x: 170.935251798561, y: 3.68627450980392, size: 1 },
    //     { x: 171.58273381295, y: 3.49019607843137, size: 1 },
    //     { x: 172.230215827338, y: 3.49019607843137, size: 1 },
    //     { x: 172.877697841727, y: 3.84313725490196, size: 1 },
    //     { x: 173.525179856115, y: 3.37254901960784, size: 1 },
    //     { x: 177.410071942446, y: 3.49019607843137, size: 1 },
    //     { x: 178.057553956835, y: 3.64705882352941, size: 1 },
    //     { x: 179.352517985612, y: 3.84313725490196, size: 1 },
    //     { x: 180, y: 3.45098039215686, size: 1 },
    //     { x: 180.647482014388, y: 3.52941176470588, size: 1 },
    //     { x: 181.294964028777, y: 3.6078431372549, size: 1 },
    //     { x: 181.942446043165, y: 3.64705882352941, size: 1 },
    //     { x: 182.589928057554, y: 3.49019607843137, size: 1 },
    //     { x: 183.237410071942, y: 3.52941176470588, size: 1 },
    //     { x: 183.884892086331, y: 3.72549019607843, size: 1 },
    //     { x: 184.532374100719, y: 3.64705882352941, size: 1 },
    //     { x: 185.827338129496, y: 3.64705882352941, size: 1 },
    //     { x: 187.122302158273, y: 3.6078431372549, size: 1 },
    //     { x: 187.769784172662, y: 3.64705882352941, size: 1 },
    //     { x: 190.359712230216, y: 3.80392156862745, size: 1 },
    //     { x: 191.007194244604, y: 3.64705882352941, size: 1 },
    //     { x: 192.302158273381, y: 3.72549019607843, size: 1 },
    //     { x: 192.94964028777, y: 3.6078431372549, size: 1 },
    //     { x: 193.597122302158, y: 3.92156862745098, size: 1 },
    //     { x: 195.539568345324, y: 3.68627450980392, size: 1 },
    //     { x: 196.187050359712, y: 3.68627450980392, size: 1 },
    //     { x: 196.834532374101, y: 3.6078431372549, size: 1 },
    //     { x: 197.482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 198.129496402878, y: 3.25490196078431, size: 1 },
    //     { x: 198.776978417266, y: 3.05882352941176, size: 1 },
    //     { x: 200.719424460432, y: 3.64705882352941, size: 1 },
    //     { x: 202.661870503597, y: 3.68627450980392, size: 1 },
    //     { x: 203.956834532374, y: 3.6078431372549, size: 1 },
    //     { x: 204.604316546763, y: 3.37254901960784, size: 1 },
    //     { x: 205.251798561151, y: 3.41176470588235, size: 1 },
    //     { x: 209.784172661871, y: 3.68627450980392, size: 1 },
    //     { x: 211.079136690647, y: 3.72549019607843, size: 1 },
    //     { x: 211.726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 212.374100719424, y: 3.41176470588235, size: 1 },
    //     { x: 213.669064748201, y: 3.45098039215686, size: 1 },
    //     { x: 214.31654676259, y: 3.64705882352941, size: 1 },
    //     { x: 214.964028776978, y: 3.64705882352941, size: 1 },
    //     { x: 215.611510791367, y: 3.6078431372549, size: 1 },
    //     { x: 216.258992805755, y: 3.68627450980392, size: 1 },
    //     { x: 217.553956834532, y: 3.56862745098039, size: 1 },
    //     { x: 218.201438848921, y: 3.6078431372549, size: 1 },
    //     { x: 219.496402877698, y: 3.45098039215686, size: 1 },
    //     { x: 220.143884892086, y: 3.41176470588235, size: 1 },
    //     { x: 220.791366906475, y: 3.17647058823529, size: 1 },
    //     { x: 221.438848920863, y: 3.33333333333333, size: 1 },
    //     { x: 222.73381294964, y: 3.72549019607843, size: 1 },
    //     { x: 223.381294964029, y: 3.64705882352941, size: 1 },
    //     { x: 224.676258992806, y: 3.76470588235294, size: 1 },
    //     { x: 225.323741007194, y: 3.80392156862745, size: 1 },
    //     { x: 225.971223021583, y: 3.56862745098039, size: 1 },
    //     { x: 226.618705035971, y: 3.49019607843137, size: 1 },
    //     { x: 228.561151079137, y: 3.52941176470588, size: 1 },
    //     { x: 229.208633093525, y: 3.6078431372549, size: 1 },
    //     { x: 229.856115107914, y: 3.68627450980392, size: 1 },
    //     { x: 230.503597122302, y: 3.96078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.96078431372549, size: 1 },
    //     { x: 233.741007194245, y: 3.68627450980392, size: 1 },
    //     { x: 235.035971223022, y: 3.80392156862745, size: 1 },
    //     { x: 235.68345323741, y: 3.37254901960784, size: 1 },
    //     { x: 236.330935251799, y: 3.76470588235294, size: 1 },
    //     { x: 236.978417266187, y: 3.80392156862745, size: 1 },
    //     { x: 237.625899280576, y: 3.56862745098039, size: 1 },
    //     { x: 238.273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 238.920863309353, y: 3.52941176470588, size: 1 },
    //     { x: 239.568345323741, y: 4.03921568627451, size: 1 },
    //     { x: 240.863309352518, y: 3.80392156862745, size: 1 },
    //     { x: 242.158273381295, y: 3.37254901960784, size: 1 },
    //     { x: 244.10071942446, y: 3.6078431372549, size: 1 },
    //     { x: 244.748201438849, y: 3.6078431372549, size: 1 },
    //     { x: 245.395683453237, y: 3.76470588235294, size: 1 },
    //     { x: 246.043165467626, y: 3.64705882352941, size: 1 },
    //     { x: 246.690647482014, y: 3.80392156862745, size: 1 },
    //     { x: 247.338129496403, y: 3.64705882352941, size: 1 },
    //     { x: 247.985611510791, y: 3.56862745098039, size: 1 },
    //     { x: 248.63309352518, y: 3.56862745098039, size: 1 },
    //     { x: 249.928057553957, y: 3.56862745098039, size: 1 },
    //     { x: 250.575539568345, y: 3.52941176470588, size: 1 },
    //     { x: 251.870503597122, y: 3.72549019607843, size: 1 },
    //     { x: 252.517985611511, y: 3.64705882352941, size: 1 },
    //     { x: 253.165467625899, y: 3.72549019607843, size: 1 },
    //     { x: 253.812949640288, y: 3.56862745098039, size: 1 },
    //     { x: 254.460431654676, y: 3.92156862745098, size: 1 },
    //     { x: 255.107913669065, y: 3.76470588235294, size: 1 },
    //     { x: 257.697841726619, y: 3.64705882352941, size: 1 },
    //     { x: 258.345323741007, y: 3.68627450980392, size: 1 },
    //     { x: 258.992805755396, y: 3.76470588235294, size: 1 },
    //     { x: 259.640287769784, y: 3.68627450980392, size: 1 },
    //     { x: 262.230215827338, y: 3.37254901960784, size: 1 },
    //     { x: 263.525179856115, y: 3.33333333333333, size: 1 },
    //     { x: 264.172661870504, y: 3.17647058823529, size: 1 },
    //     { x: 264.820143884892, y: 3.37254901960784, size: 1 },
    //     { x: 266.115107913669, y: 3.64705882352941, size: 1 },
    //     { x: 267.410071942446, y: 3.56862745098039, size: 1 },
    //     { x: 268.705035971223, y: 3.96078431372549, size: 1 },
    //     { x: 269.352517985611, y: 3.68627450980392, size: 1 },
    //     { x: 270, y: 3.72549019607843, size: 1 },
    //     { x: 271.294964028777, y: 3.64705882352941, size: 1 },
    //     { x: 271.942446043165, y: 3.41176470588235, size: 1 },
    //     { x: 274.532374100719, y: 3.68627450980392, size: 1 },
    //     { x: 275.827338129496, y: 3.68627450980392, size: 1 },
    //     { x: 277.122302158273, y: 3.56862745098039, size: 1 },
    //     { x: 277.769784172662, y: 3.72549019607843, size: 1 },
    //     { x: 278.41726618705, y: 3.80392156862745, size: 1 },
    //     { x: 279.064748201439, y: 3.92156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.56862745098039, size: 1 },
    //     { x: 281.654676258993, y: 3.76470588235294, size: 1 },
    //     { x: 282.94964028777, y: 4, size: 1 },
    //     { x: 283.597122302158, y: 3.52941176470588, size: 1 },
    //     { x: 284.892086330935, y: 3.41176470588235, size: 1 },
    //     { x: 286.187050359712, y: 3.45098039215686, size: 1 },
    //     { x: 287.482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 289.424460431655, y: 3.6078431372549, size: 1 },
    //     { x: 290.719424460432, y: 3.76470588235294, size: 1 },
    //     { x: 291.36690647482, y: 3.92156862745098, size: 1 },
    //     { x: 292.014388489209, y: 3.72549019607843, size: 1 },
    //     { x: 293.309352517986, y: 3.88235294117647, size: 1 },
    //     { x: 293.956834532374, y: 3.68627450980392, size: 1 },
    //     { x: 295.89928057554, y: 3.80392156862745, size: 1 },
    //     { x: 297.194244604317, y: 3.76470588235294, size: 1 },
    //     { x: 298.489208633094, y: 3.76470588235294, size: 1 },
    //     { x: 299.784172661871, y: 3.64705882352941, size: 1 },
    //     { x: 301.079136690647, y: 3.84313725490196, size: 1 },
    //     { x: 302.374100719424, y: 3.80392156862745, size: 1 },
    //     { x: 303.021582733813, y: 3.80392156862745, size: 1 },
    //     { x: 303.669064748201, y: 3.72549019607843, size: 1 },
    //     { x: 304.31654676259, y: 3.88235294117647, size: 1 },
    //     { x: 305.611510791367, y: 3.96078431372549, size: 1 },
    //     { x: 306.906474820144, y: 3.56862745098039, size: 1 },
    //     { x: 307.553956834532, y: 3.80392156862745, size: 1 },
    //     { x: 308.201438848921, y: 3.49019607843137, size: 1 },
    //     { x: 310.143884892086, y: 3.29411764705882, size: 1 },
    //     { x: 310.791366906475, y: 3.64705882352941, size: 1 },
    //     { x: 311.438848920863, y: 3.72549019607843, size: 1 },
    //     { x: 312.73381294964, y: 3.56862745098039, size: 1 },
    //     { x: 313.381294964029, y: 3.6078431372549, size: 1 },
    //     { x: 314.028776978417, y: 3.49019607843137, size: 1 },
    //     { x: 314.676258992806, y: 3.56862745098039, size: 1 },
    //     { x: 315.323741007194, y: 3.49019607843137, size: 1 },
    //     { x: 317.26618705036, y: 3.56862745098039, size: 1 },
    //     { x: 317.913669064748, y: 3.6078431372549, size: 1 },
    //     { x: 319.208633093525, y: 3.49019607843137, size: 1 },
    //     { x: 319.856115107914, y: 3.6078431372549, size: 1 },
    //     { x: 321.798561151079, y: 3.49019607843137, size: 1 },
    //     { x: 323.093525179856, y: 3.49019607843137, size: 1 },
    //     { x: 325.035971223022, y: 3.41176470588235, size: 1 },
    //     { x: 325.68345323741, y: 3.45098039215686, size: 1 },
    //     { x: 326.330935251799, y: 3.76470588235294, size: 1 },
    //     { x: 326.978417266187, y: 3.33333333333333, size: 1 },
    //     { x: 327.625899280576, y: 3.52941176470588, size: 1 },
    //     { x: 328.273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 328.920863309353, y: 3.2156862745098, size: 1 },
    //     { x: 330.215827338129, y: 4.03921568627451, size: 1 },
    //     { x: 330.863309352518, y: 3.80392156862745, size: 1 },
    //     { x: 331.510791366906, y: 4.03921568627451, size: 1 },
    //     { x: 332.158273381295, y: 3.84313725490196, size: 1 },
    //     { x: 332.805755395683, y: 3.76470588235294, size: 1 },
    //     { x: 333.453237410072, y: 3.68627450980392, size: 1 },
    //     { x: 334.10071942446, y: 3.80392156862745, size: 1 },
    //     { x: 334.748201438849, y: 3.84313725490196, size: 1 },
    //     { x: 336.043165467626, y: 3.96078431372549, size: 1 },
    //     { x: 336.690647482014, y: 3.84313725490196, size: 1 },
    //     { x: 337.338129496403, y: 4, size: 1 },
    //     { x: 338.63309352518, y: 3.92156862745098, size: 1 },
    //     { x: 339.280575539568, y: 3.84313725490196, size: 1 },
    //     { x: 339.928057553957, y: 3.84313725490196, size: 1 },
    //     { x: 340.575539568345, y: 3.68627450980392, size: 1 },
    //     { x: 341.870503597122, y: 3.80392156862745, size: 1 },
    //     { x: 342.517985611511, y: 4, size: 1 },
    //     { x: 343.165467625899, y: 3.88235294117647, size: 1 },
    //     { x: 344.460431654676, y: 3.88235294117647, size: 1 },
    //     { x: 345.755395683453, y: 3.76470588235294, size: 1 },
    //     { x: 346.402877697842, y: 3.72549019607843, size: 1 },
    //     { x: 347.697841726619, y: 3.72549019607843, size: 1 },
    //     { x: 349.640287769784, y: 3.37254901960784, size: 1 },
    //     { x: 350.287769784173, y: 3.05882352941176, size: 1 },
    //     { x: 350.935251798561, y: 3.6078431372549, size: 1 },
    //     { x: 351.58273381295, y: 3.6078431372549, size: 1 },
    //     { x: 352.230215827338, y: 3.56862745098039, size: 1 },
    //     { x: 352.877697841727, y: 3.41176470588235, size: 1 },
    //     { x: 353.525179856115, y: 3.80392156862745, size: 1 },
    //     { x: 354.172661870504, y: 3.41176470588235, size: 1 },
    //     { x: 354.820143884892, y: 3.88235294117647, size: 1 },
    //     { x: 355.467625899281, y: 3.45098039215686, size: 1 },
    //     { x: 356.115107913669, y: 3.41176470588235, size: 1 },
    //     { x: 356.762589928058, y: 3.72549019607843, size: 1 },
    //     { x: 358.057553956835, y: 3.52941176470588, size: 1 },
    //     { x: 2.58992805755396, y: 3.52941176470588, size: 1 },
    //     { x: 3.23741007194245, y: 3.49019607843137, size: 1 },
    //     { x: 5.17985611510791, y: 3.6078431372549, size: 1 },
    //     { x: 7.76978417266187, y: 3.41176470588235, size: 1 },
    //     { x: 9.71223021582734, y: 3.56862745098039, size: 1 },
    //     { x: 11.0071942446043, y: 3.33333333333333, size: 1 },
    //     { x: 11.6546762589928, y: 3.13725490196078, size: 1 },
    //     { x: 12.3021582733813, y: 3.13725490196078, size: 1 },
    //     { x: 12.9496402877698, y: 3.64705882352941, size: 1 },
    //     { x: 14.8920863309353, y: 3.80392156862745, size: 1 },
    //     { x: 15.5395683453237, y: 3.72549019607843, size: 1 },
    //     { x: 16.1870503597122, y: 3.84313725490196, size: 1 },
    //     { x: 16.8345323741007, y: 4.03921568627451, size: 1 },
    //     { x: 18.1294964028777, y: 3.72549019607843, size: 1 },
    //     { x: 21.3669064748201, y: 3.80392156862745, size: 1 },
    //     { x: 22.0143884892086, y: 3.72549019607843, size: 1 },
    //     { x: 22.6618705035971, y: 3.68627450980392, size: 1 },
    //     { x: 23.3093525179856, y: 3.88235294117647, size: 1 },
    //     { x: 24.6043165467626, y: 4.03921568627451, size: 1 },
    //     { x: 25.2517985611511, y: 3.88235294117647, size: 1 },
    //     { x: 25.8992805755396, y: 3.6078431372549, size: 1 },
    //     { x: 30.431654676259, y: 3.72549019607843, size: 1 },
    //     { x: 31.726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 32.3741007194245, y: 3.25490196078431, size: 1 },
    //     { x: 33.0215827338129, y: 3.56862745098039, size: 1 },
    //     { x: 34.9640287769784, y: 3.68627450980392, size: 1 },
    //     { x: 35.6115107913669, y: 3.52941176470588, size: 1 },
    //     { x: 36.9064748201439, y: 3.56862745098039, size: 1 },
    //     { x: 37.5539568345324, y: 3.6078431372549, size: 1 },
    //     { x: 38.2014388489209, y: 3.68627450980392, size: 1 },
    //     { x: 39.4964028776978, y: 3.72549019607843, size: 1 },
    //     { x: 40.7913669064748, y: 3.68627450980392, size: 1 },
    //     { x: 41.4388489208633, y: 3.84313725490196, size: 1 },
    //     { x: 42.0863309352518, y: 3.64705882352941, size: 1 },
    //     { x: 44.6762589928058, y: 3.56862745098039, size: 1 },
    //     { x: 45.3237410071942, y: 3.45098039215686, size: 1 },
    //     { x: 45.9712230215827, y: 3.72549019607843, size: 1 },
    //     { x: 46.6187050359712, y: 3.64705882352941, size: 1 },
    //     { x: 47.2661870503597, y: 3.84313725490196, size: 1 },
    //     { x: 48.5611510791367, y: 3.52941176470588, size: 1 },
    //     { x: 49.2086330935252, y: 3.41176470588235, size: 1 },
    //     { x: 49.8561151079137, y: 3.56862745098039, size: 1 },
    //     { x: 50.5035971223022, y: 3.64705882352941, size: 1 },
    //     { x: 51.1510791366906, y: 3.64705882352941, size: 1 },
    //     { x: 52.4460431654676, y: 3.6078431372549, size: 1 },
    //     { x: 53.7410071942446, y: 3.49019607843137, size: 1 },
    //     { x: 54.3884892086331, y: 3.29411764705882, size: 1 },
    //     { x: 55.0359712230216, y: 3.37254901960784, size: 1 },
    //     { x: 56.3309352517986, y: 3.88235294117647, size: 1 },
    //     { x: 56.9784172661871, y: 3.84313725490196, size: 1 },
    //     { x: 57.6258992805755, y: 3.68627450980392, size: 1 },
    //     { x: 58.273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 63.4532374100719, y: 4, size: 1 },
    //     { x: 64.7482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 65.3956834532374, y: 3.72549019607843, size: 1 },
    //     { x: 67.9856115107914, y: 3.96078431372549, size: 1 },
    //     { x: 68.6330935251799, y: 3.45098039215686, size: 1 },
    //     { x: 69.2805755395683, y: 3.72549019607843, size: 1 },
    //     { x: 69.9280575539568, y: 3.84313725490196, size: 1 },
    //     { x: 72.5179856115108, y: 3.72549019607843, size: 1 },
    //     { x: 73.1654676258993, y: 3.80392156862745, size: 1 },
    //     { x: 73.8129496402878, y: 3.6078431372549, size: 1 },
    //     { x: 75.7553956834532, y: 3.33333333333333, size: 1 },
    //     { x: 76.4028776978417, y: 2.03921568627451, size: 1 },
    //     { x: 77.0503597122302, y: 1.88235294117647, size: 1 },
    //     { x: 77.6978417266187, y: 3.49019607843137, size: 1 },
    //     { x: 78.3453237410072, y: 3.45098039215686, size: 1 },
    //     { x: 79.6402877697842, y: 3.72549019607843, size: 1 },
    //     { x: 80.2877697841727, y: 3.52941176470588, size: 1 },
    //     { x: 82.8776978417266, y: 3.64705882352941, size: 1 },
    //     { x: 83.5251798561151, y: 3.64705882352941, size: 1 },
    //     { x: 84.1726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 84.8201438848921, y: 3.88235294117647, size: 1 },
    //     { x: 86.1151079136691, y: 3.52941176470588, size: 1 },
    //     { x: 88.0575539568345, y: 3.52941176470588, size: 1 },
    //     { x: 88.705035971223, y: 3.6078431372549, size: 1 },
    //     { x: 89.3525179856115, y: 3.56862745098039, size: 1 },
    //     { x: 90, y: 3.6078431372549, size: 1 },
    //     { x: 90.6474820143885, y: 3.84313725490196, size: 1 },
    //     { x: 91.294964028777, y: 3.41176470588235, size: 1 },
    //     { x: 91.9424460431655, y: 3.64705882352941, size: 1 },
    //     { x: 92.589928057554, y: 3.6078431372549, size: 1 },
    //     { x: 93.2374100719424, y: 3.56862745098039, size: 1 },
    //     { x: 93.8848920863309, y: 3.37254901960784, size: 1 },
    //     { x: 94.5323741007194, y: 3.49019607843137, size: 1 },
    //     { x: 95.1798561151079, y: 3.49019607843137, size: 1 },
    //     { x: 97.7697841726619, y: 3.13725490196078, size: 1 },
    //     { x: 98.4172661870504, y: 3.37254901960784, size: 1 },
    //     { x: 99.7122302158273, y: 3.6078431372549, size: 1 },
    //     { x: 102.302158273381, y: 3.6078431372549, size: 1 },
    //     { x: 104.892086330935, y: 3.72549019607843, size: 1 },
    //     { x: 105.539568345324, y: 3.76470588235294, size: 1 },
    //     { x: 106.834532374101, y: 3.52941176470588, size: 1 },
    //     { x: 107.482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 108.129496402878, y: 3.92156862745098, size: 1 },
    //     { x: 110.719424460432, y: 3.6078431372549, size: 1 },
    //     { x: 111.36690647482, y: 3.49019607843137, size: 1 },
    //     { x: 112.014388489209, y: 3.80392156862745, size: 1 },
    //     { x: 112.661870503597, y: 3.76470588235294, size: 1 },
    //     { x: 113.309352517986, y: 3.68627450980392, size: 1 },
    //     { x: 114.604316546763, y: 3.72549019607843, size: 1 },
    //     { x: 115.251798561151, y: 3.6078431372549, size: 1 },
    //     { x: 115.89928057554, y: 3.72549019607843, size: 1 },
    //     { x: 116.546762589928, y: 3.45098039215686, size: 1 },
    //     { x: 117.194244604317, y: 3.72549019607843, size: 1 },
    //     { x: 118.489208633094, y: 3.33333333333333, size: 1 },
    //     { x: 119.784172661871, y: 3.05882352941176, size: 1 },
    //     { x: 120.431654676259, y: 3.2156862745098, size: 1 },
    //     { x: 121.079136690647, y: 3.6078431372549, size: 1 },
    //     { x: 121.726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 124.31654676259, y: 3.49019607843137, size: 1 },
    //     { x: 124.964028776978, y: 3.45098039215686, size: 1 },
    //     { x: 125.611510791367, y: 3.6078431372549, size: 1 },
    //     { x: 127.553956834532, y: 3.72549019607843, size: 1 },
    //     { x: 128.848920863309, y: 3.80392156862745, size: 1 },
    //     { x: 130.791366906475, y: 3.45098039215686, size: 1 },
    //     { x: 131.438848920863, y: 3.72549019607843, size: 1 },
    //     { x: 132.086330935252, y: 3.64705882352941, size: 1 },
    //     { x: 133.381294964029, y: 3.68627450980392, size: 1 },
    //     { x: 134.028776978417, y: 3.80392156862745, size: 1 },
    //     { x: 134.676258992806, y: 3.64705882352941, size: 1 },
    //     { x: 138.561151079137, y: 3.84313725490196, size: 1 },
    //     { x: 139.208633093525, y: 3.37254901960784, size: 1 },
    //     { x: 139.856115107914, y: 3.29411764705882, size: 1 },
    //     { x: 140.503597122302, y: 3.25490196078431, size: 1 },
    //     { x: 141.151079136691, y: 2.62745098039216, size: 1 },
    //     { x: 141.798561151079, y: 2.74509803921569, size: 1 },
    //     { x: 142.446043165468, y: 3.76470588235294, size: 1 },
    //     { x: 143.093525179856, y: 3.84313725490196, size: 1 },
    //     { x: 144.388489208633, y: 3.52941176470588, size: 1 },
    //     { x: 145.68345323741, y: 3.49019607843137, size: 1 },
    //     { x: 146.330935251799, y: 3.76470588235294, size: 1 },
    //     { x: 146.978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 147.625899280576, y: 3.6078431372549, size: 1 },
    //     { x: 148.273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 148.920863309353, y: 3.76470588235294, size: 1 },
    //     { x: 149.568345323741, y: 3.52941176470588, size: 1 },
    //     { x: 150.215827338129, y: 3.80392156862745, size: 1 },
    //     { x: 151.510791366906, y: 3.49019607843137, size: 1 },
    //     { x: 152.158273381295, y: 3.92156862745098, size: 1 },
    //     { x: 152.805755395683, y: 3.45098039215686, size: 1 },
    //     { x: 153.453237410072, y: 3.80392156862745, size: 1 },
    //     { x: 154.748201438849, y: 3.72549019607843, size: 1 },
    //     { x: 155.395683453237, y: 3.80392156862745, size: 1 },
    //     { x: 156.690647482014, y: 3.6078431372549, size: 1 },
    //     { x: 160.575539568345, y: 3.56862745098039, size: 1 },
    //     { x: 161.870503597122, y: 3.52941176470588, size: 1 },
    //     { x: 162.517985611511, y: 3.17647058823529, size: 1 },
    //     { x: 163.812949640288, y: 3.80392156862745, size: 1 },
    //     { x: 164.460431654676, y: 3.88235294117647, size: 1 },
    //     { x: 165.107913669065, y: 3.88235294117647, size: 1 },
    //     { x: 166.402877697842, y: 3.84313725490196, size: 1 },
    //     { x: 167.05035971223, y: 3.92156862745098, size: 1 },
    //     { x: 168.992805755396, y: 3.72549019607843, size: 1 },
    //     { x: 170.935251798561, y: 3.88235294117647, size: 1 },
    //     { x: 171.58273381295, y: 3.64705882352941, size: 1 },
    //     { x: 172.230215827338, y: 3.64705882352941, size: 1 },
    //     { x: 173.525179856115, y: 3.72549019607843, size: 1 },
    //     { x: 174.172661870504, y: 3.56862745098039, size: 1 },
    //     { x: 174.820143884892, y: 3.84313725490196, size: 1 },
    //     { x: 176.115107913669, y: 3.96078431372549, size: 1 },
    //     { x: 177.410071942446, y: 3.84313725490196, size: 1 },
    //     { x: 178.705035971223, y: 3.80392156862745, size: 1 },
    //     { x: 181.294964028777, y: 3.92156862745098, size: 1 },
    //     { x: 181.942446043165, y: 3.76470588235294, size: 1 },
    //     { x: 184.532374100719, y: 3.49019607843137, size: 1 },
    //     { x: 185.179856115108, y: 3.68627450980392, size: 1 },
    //     { x: 185.827338129496, y: 3.76470588235294, size: 1 },
    //     { x: 187.122302158273, y: 3.84313725490196, size: 1 },
    //     { x: 187.769784172662, y: 3.56862745098039, size: 1 },
    //     { x: 188.41726618705, y: 3.52941176470588, size: 1 },
    //     { x: 189.712230215827, y: 3.72549019607843, size: 1 },
    //     { x: 191.654676258993, y: 3.84313725490196, size: 1 },
    //     { x: 192.302158273381, y: 3.45098039215686, size: 1 },
    //     { x: 192.94964028777, y: 3.96078431372549, size: 1 },
    //     { x: 193.597122302158, y: 3.6078431372549, size: 1 },
    //     { x: 194.244604316547, y: 4.07843137254902, size: 1 },
    //     { x: 194.892086330935, y: 3.56862745098039, size: 1 },
    //     { x: 197.482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 198.776978417266, y: 3.64705882352941, size: 1 },
    //     { x: 200.071942446043, y: 4, size: 1 },
    //     { x: 200.719424460432, y: 3.68627450980392, size: 1 },
    //     { x: 201.36690647482, y: 3.72549019607843, size: 1 },
    //     { x: 202.014388489209, y: 3.88235294117647, size: 1 },
    //     { x: 203.309352517986, y: 3.49019607843137, size: 1 },
    //     { x: 204.604316546763, y: 3.49019607843137, size: 1 },
    //     { x: 205.251798561151, y: 3.6078431372549, size: 1 },
    //     { x: 205.89928057554, y: 3.2156862745098, size: 1 },
    //     { x: 206.546762589928, y: 3.33333333333333, size: 1 },
    //     { x: 207.194244604317, y: 3.41176470588235, size: 1 },
    //     { x: 207.841726618705, y: 3.52941176470588, size: 1 },
    //     { x: 209.136690647482, y: 3.52941176470588, size: 1 },
    //     { x: 211.079136690647, y: 3.76470588235294, size: 1 },
    //     { x: 211.726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 212.374100719424, y: 3.45098039215686, size: 1 },
    //     { x: 213.669064748201, y: 3.52941176470588, size: 1 },
    //     { x: 214.964028776978, y: 3.52941176470588, size: 1 },
    //     { x: 215.611510791367, y: 3.64705882352941, size: 1 },
    //     { x: 216.906474820144, y: 3.64705882352941, size: 1 },
    //     { x: 218.201438848921, y: 3.68627450980392, size: 1 },
    //     { x: 218.848920863309, y: 3.68627450980392, size: 1 },
    //     { x: 219.496402877698, y: 3.49019607843137, size: 1 },
    //     { x: 220.143884892086, y: 3.6078431372549, size: 1 },
    //     { x: 222.086330935252, y: 3.6078431372549, size: 1 },
    //     { x: 222.73381294964, y: 3.64705882352941, size: 1 },
    //     { x: 225.323741007194, y: 3.41176470588235, size: 1 },
    //     { x: 226.618705035971, y: 3.64705882352941, size: 1 },
    //     { x: 227.26618705036, y: 2.90196078431373, size: 1 },
    //     { x: 227.913669064748, y: 3.05882352941176, size: 1 },
    //     { x: 230.503597122302, y: 3.76470588235294, size: 1 },
    //     { x: 231.798561151079, y: 3.84313725490196, size: 1 },
    //     { x: 233.093525179856, y: 3.80392156862745, size: 1 },
    //     { x: 233.741007194245, y: 3.80392156862745, size: 1 },
    //     { x: 235.035971223022, y: 3.64705882352941, size: 1 },
    //     { x: 236.330935251799, y: 3.68627450980392, size: 1 },
    //     { x: 237.625899280576, y: 3.68627450980392, size: 1 },
    //     { x: 240.215827338129, y: 3.84313725490196, size: 1 },
    //     { x: 240.863309352518, y: 3.72549019607843, size: 1 },
    //     { x: 241.510791366906, y: 3.6078431372549, size: 1 },
    //     { x: 242.158273381295, y: 3.76470588235294, size: 1 },
    //     { x: 242.805755395683, y: 3.68627450980392, size: 1 },
    //     { x: 243.453237410072, y: 3.72549019607843, size: 1 },
    //     { x: 244.10071942446, y: 3.64705882352941, size: 1 },
    //     { x: 246.043165467626, y: 3.49019607843137, size: 1 },
    //     { x: 247.985611510791, y: 3.45098039215686, size: 1 },
    //     { x: 248.63309352518, y: 3.84313725490196, size: 1 },
    //     { x: 251.223021582734, y: 3.80392156862745, size: 1 },
    //     { x: 251.870503597122, y: 3.88235294117647, size: 1 },
    //     { x: 255.107913669065, y: 3.88235294117647, size: 1 },
    //     { x: 255.755395683453, y: 3.6078431372549, size: 1 },
    //     { x: 256.402877697842, y: 3.76470588235294, size: 1 },
    //     { x: 258.345323741007, y: 3.37254901960784, size: 1 },
    //     { x: 258.992805755396, y: 3.84313725490196, size: 1 },
    //     { x: 259.640287769784, y: 3.64705882352941, size: 1 },
    //     { x: 260.287769784173, y: 3.56862745098039, size: 1 },
    //     { x: 261.58273381295, y: 3.45098039215686, size: 1 },
    //     { x: 262.230215827338, y: 3.52941176470588, size: 1 },
    //     { x: 262.877697841727, y: 3.84313725490196, size: 1 },
    //     { x: 263.525179856115, y: 3.49019607843137, size: 1 },
    //     { x: 264.820143884892, y: 3.88235294117647, size: 1 },
    //     { x: 265.467625899281, y: 3.37254901960784, size: 1 },
    //     { x: 268.057553956835, y: 3.96078431372549, size: 1 },
    //     { x: 268.705035971223, y: 3.45098039215686, size: 1 },
    //     { x: 269.352517985611, y: 3.6078431372549, size: 1 },
    //     { x: 270.647482014389, y: 3.64705882352941, size: 1 },
    //     { x: 271.294964028777, y: 3.41176470588235, size: 1 },
    //     { x: 275.827338129496, y: 3.52941176470588, size: 1 },
    //     { x: 276.474820143885, y: 3.41176470588235, size: 1 },
    //     { x: 277.122302158273, y: 3.64705882352941, size: 1 },
    //     { x: 277.769784172662, y: 3.80392156862745, size: 1 },
    //     { x: 278.41726618705, y: 3.52941176470588, size: 1 },
    //     { x: 279.064748201439, y: 3.56862745098039, size: 1 },
    //     { x: 280.359712230216, y: 3.56862745098039, size: 1 },
    //     { x: 281.654676258993, y: 3.45098039215686, size: 1 },
    //     { x: 282.302158273381, y: 3.64705882352941, size: 1 },
    //     { x: 283.597122302158, y: 3.76470588235294, size: 1 },
    //     { x: 285.539568345324, y: 3.49019607843137, size: 1 },
    //     { x: 288.776978417266, y: 3.6078431372549, size: 1 },
    //     { x: 289.424460431655, y: 3.56862745098039, size: 1 },
    //     { x: 290.071942446043, y: 3.49019607843137, size: 1 },
    //     { x: 292.014388489209, y: 3.45098039215686, size: 1 },
    //     { x: 292.661870503597, y: 3.2156862745098, size: 1 },
    //     { x: 293.309352517986, y: 3.52941176470588, size: 1 },
    //     { x: 293.956834532374, y: 3.72549019607843, size: 1 },
    //     { x: 294.604316546763, y: 3.52941176470588, size: 1 },
    //     { x: 295.251798561151, y: 3.49019607843137, size: 1 },
    //     { x: 295.89928057554, y: 3.92156862745098, size: 1 },
    //     { x: 296.546762589928, y: 3.56862745098039, size: 1 },
    //     { x: 297.841726618705, y: 3.41176470588235, size: 1 },
    //     { x: 298.489208633094, y: 3.52941176470588, size: 1 },
    //     { x: 299.784172661871, y: 3.76470588235294, size: 1 },
    //     { x: 300.431654676259, y: 3.49019607843137, size: 1 },
    //     { x: 301.726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 303.021582733813, y: 3.37254901960784, size: 1 },
    //     { x: 303.669064748201, y: 3.29411764705882, size: 1 },
    //     { x: 304.31654676259, y: 3.64705882352941, size: 1 },
    //     { x: 304.964028776978, y: 3.68627450980392, size: 1 },
    //     { x: 305.611510791367, y: 3.49019607843137, size: 1 },
    //     { x: 306.906474820144, y: 3.45098039215686, size: 1 },
    //     { x: 307.553956834532, y: 3.64705882352941, size: 1 },
    //     { x: 308.201438848921, y: 3.64705882352941, size: 1 },
    //     { x: 308.848920863309, y: 3.41176470588235, size: 1 },
    //     { x: 310.143884892086, y: 3.49019607843137, size: 1 },
    //     { x: 310.791366906475, y: 3.25490196078431, size: 1 },
    //     { x: 311.438848920863, y: 3.6078431372549, size: 1 },
    //     { x: 312.73381294964, y: 3.64705882352941, size: 1 },
    //     { x: 313.381294964029, y: 3.56862745098039, size: 1 },
    //     { x: 314.676258992806, y: 3.41176470588235, size: 1 },
    //     { x: 315.323741007194, y: 3.56862745098039, size: 1 },
    //     { x: 316.618705035971, y: 3.49019607843137, size: 1 },
    //     { x: 318.561151079137, y: 3.6078431372549, size: 1 },
    //     { x: 319.208633093525, y: 3.68627450980392, size: 1 },
    //     { x: 320.503597122302, y: 3.72549019607843, size: 1 },
    //     { x: 321.151079136691, y: 3.33333333333333, size: 1 },
    //     { x: 322.446043165468, y: 3.33333333333333, size: 1 },
    //     { x: 323.093525179856, y: 3.72549019607843, size: 1 },
    //     { x: 324.388489208633, y: 4.07843137254902, size: 1 },
    //     { x: 325.035971223022, y: 3.52941176470588, size: 1 },
    //     { x: 325.68345323741, y: 3.37254901960784, size: 1 },
    //     { x: 326.330935251799, y: 3.68627450980392, size: 1 },
    //     { x: 326.978417266187, y: 3.6078431372549, size: 1 },
    //     { x: 328.920863309353, y: 3.68627450980392, size: 1 },
    //     { x: 329.568345323741, y: 3.6078431372549, size: 1 },
    //     { x: 330.215827338129, y: 3.56862745098039, size: 1 },
    //     { x: 331.510791366906, y: 3.6078431372549, size: 1 },
    //     { x: 333.453237410072, y: 3.37254901960784, size: 1 },
    //     { x: 334.10071942446, y: 3.33333333333333, size: 1 },
    //     { x: 334.748201438849, y: 3.01960784313725, size: 1 },
    //     { x: 335.395683453237, y: 2.98039215686275, size: 1 },
    //     { x: 336.690647482014, y: 3.64705882352941, size: 1 },
    //     { x: 337.338129496403, y: 3.76470588235294, size: 1 },
    //     { x: 340.575539568345, y: 3.84313725490196, size: 1 },
    //     { x: 341.870503597122, y: 3.88235294117647, size: 1 },
    //     { x: 343.165467625899, y: 3.56862745098039, size: 1 },
    //     { x: 345.107913669065, y: 3.72549019607843, size: 1 },
    //     { x: 347.697841726619, y: 3.49019607843137, size: 1 },
    //     { x: 348.345323741007, y: 3.80392156862745, size: 1 },
    //     { x: 348.992805755396, y: 3.76470588235294, size: 1 },
    //     { x: 349.640287769784, y: 3.80392156862745, size: 1 },
    //     { x: 350.935251798561, y: 3.52941176470588, size: 1 },
    //     { x: 351.58273381295, y: 3.37254901960784, size: 1 },
    //     { x: 353.525179856115, y: 3.64705882352941, size: 1 },
    //     { x: 354.820143884892, y: 3.68627450980392, size: 1 },
    //     { x: 356.115107913669, y: 3.56862745098039, size: 1 },
    //     { x: 357.410071942446, y: 3.64705882352941, size: 1 },
    //     { x: 0, y: 3.45098039215686, size: 1 },
    //     { x: 0.647482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 1.29496402877698, y: 3.64705882352941, size: 1 },
    //     { x: 1.94244604316547, y: 3.88235294117647, size: 1 },
    //     { x: 3.88489208633094, y: 3.56862745098039, size: 1 },
    //     { x: 5.8273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 6.47482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 7.12230215827338, y: 3.92156862745098, size: 1 },
    //     { x: 9.06474820143885, y: 3.64705882352941, size: 1 },
    //     { x: 12.3021582733813, y: 3.56862745098039, size: 1 },
    //     { x: 12.9496402877698, y: 3.68627450980392, size: 1 },
    //     { x: 13.5971223021583, y: 3.68627450980392, size: 1 },
    //     { x: 15.5395683453237, y: 3.64705882352941, size: 1 },
    //     { x: 16.8345323741007, y: 3.33333333333333, size: 1 },
    //     { x: 17.4820143884892, y: 2.90196078431373, size: 1 },
    //     { x: 18.1294964028777, y: 2.82352941176471, size: 1 },
    //     { x: 18.7769784172662, y: 1.2156862745098, size: 1 },
    //     { x: 19.4244604316547, y: 1.96078431372549, size: 1 },
    //     { x: 20.0719424460432, y: 2.19607843137255, size: 1 },
    //     { x: 20.7194244604317, y: 2.54901960784314, size: 1 },
    //     { x: 22.0143884892086, y: 3.45098039215686, size: 1 },
    //     { x: 22.6618705035971, y: 3.49019607843137, size: 1 },
    //     { x: 23.3093525179856, y: 2.82352941176471, size: 1 },
    //     { x: 23.9568345323741, y: 3.29411764705882, size: 1 },
    //     { x: 25.2517985611511, y: 3.68627450980392, size: 1 },
    //     { x: 26.5467625899281, y: 3.84313725490196, size: 1 },
    //     { x: 27.1942446043165, y: 3.6078431372549, size: 1 },
    //     { x: 27.841726618705, y: 3.01960784313725, size: 1 },
    //     { x: 28.4892086330935, y: 2.98039215686275, size: 1 },
    //     { x: 29.7841726618705, y: 3.56862745098039, size: 1 },
    //     { x: 32.3741007194245, y: 3.6078431372549, size: 1 },
    //     { x: 33.6690647482014, y: 3.45098039215686, size: 1 },
    //     { x: 34.3165467625899, y: 2.82352941176471, size: 1 },
    //     { x: 34.9640287769784, y: 3.37254901960784, size: 1 },
    //     { x: 35.6115107913669, y: 3.29411764705882, size: 1 },
    //     { x: 36.2589928057554, y: 3.49019607843137, size: 1 },
    //     { x: 36.9064748201439, y: 3.33333333333333, size: 1 },
    //     { x: 37.5539568345324, y: 3.41176470588235, size: 1 },
    //     { x: 38.2014388489209, y: 3.37254901960784, size: 1 },
    //     { x: 38.8489208633094, y: 3.17647058823529, size: 1 },
    //     { x: 39.4964028776978, y: 3.2156862745098, size: 1 },
    //     { x: 40.1438848920863, y: 2.7843137254902, size: 1 },
    //     { x: 40.7913669064748, y: 2.62745098039216, size: 1 },
    //     { x: 44.0287769784173, y: 3.76470588235294, size: 1 },
    //     { x: 45.9712230215827, y: 3.6078431372549, size: 1 },
    //     { x: 46.6187050359712, y: 3.37254901960784, size: 1 },
    //     { x: 47.9136690647482, y: 3.49019607843137, size: 1 },
    //     { x: 48.5611510791367, y: 3.6078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 3.52941176470588, size: 1 },
    //     { x: 49.8561151079137, y: 3.37254901960784, size: 1 },
    //     { x: 51.7985611510791, y: 3.37254901960784, size: 1 },
    //     { x: 53.7410071942446, y: 3.6078431372549, size: 1 },
    //     { x: 54.3884892086331, y: 3.37254901960784, size: 1 },
    //     { x: 55.6834532374101, y: 3.6078431372549, size: 1 },
    //     { x: 58.273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 58.9208633093525, y: 3.68627450980392, size: 1 },
    //     { x: 59.568345323741, y: 3.37254901960784, size: 1 },
    //     { x: 60.2158273381295, y: 3.29411764705882, size: 1 },
    //     { x: 60.863309352518, y: 3.25490196078431, size: 1 },
    //     { x: 61.5107913669065, y: 3.13725490196078, size: 1 },
    //     { x: 62.158273381295, y: 2.70588235294118, size: 1 },
    //     { x: 62.8057553956835, y: 3.37254901960784, size: 1 },
    //     { x: 63.4532374100719, y: 3.72549019607843, size: 1 },
    //     { x: 64.1007194244604, y: 3.45098039215686, size: 1 },
    //     { x: 64.7482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 65.3956834532374, y: 3.6078431372549, size: 1 },
    //     { x: 66.6906474820144, y: 3.76470588235294, size: 1 },
    //     { x: 67.3381294964029, y: 3.72549019607843, size: 1 },
    //     { x: 67.9856115107914, y: 3.72549019607843, size: 1 },
    //     { x: 68.6330935251799, y: 3.56862745098039, size: 1 },
    //     { x: 69.2805755395683, y: 3.88235294117647, size: 1 },
    //     { x: 70.5755395683453, y: 3.6078431372549, size: 1 },
    //     { x: 72.5179856115108, y: 3.56862745098039, size: 1 },
    //     { x: 74.4604316546763, y: 3.68627450980392, size: 1 },
    //     { x: 75.1079136690647, y: 3.68627450980392, size: 1 },
    //     { x: 75.7553956834532, y: 3.52941176470588, size: 1 },
    //     { x: 78.3453237410072, y: 3.49019607843137, size: 1 },
    //     { x: 78.9928057553957, y: 3.84313725490196, size: 1 },
    //     { x: 80.2877697841727, y: 3.68627450980392, size: 1 },
    //     { x: 81.5827338129496, y: 3.13725490196078, size: 1 },
    //     { x: 82.2302158273381, y: 3.05882352941176, size: 1 },
    //     { x: 83.5251798561151, y: 2.11764705882353, size: 1 },
    //     { x: 84.1726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 84.8201438848921, y: 3.68627450980392, size: 1 },
    //     { x: 87.410071942446, y: 3.72549019607843, size: 1 },
    //     { x: 91.294964028777, y: 3.49019607843137, size: 1 },
    //     { x: 91.9424460431655, y: 3.72549019607843, size: 1 },
    //     { x: 92.589928057554, y: 3.64705882352941, size: 1 },
    //     { x: 93.2374100719424, y: 3.80392156862745, size: 1 },
    //     { x: 93.8848920863309, y: 3.68627450980392, size: 1 },
    //     { x: 94.5323741007194, y: 3.64705882352941, size: 1 },
    //     { x: 95.8273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 99.0647482014388, y: 3.56862745098039, size: 1 },
    //     { x: 99.7122302158273, y: 3.80392156862745, size: 1 },
    //     { x: 101.654676258993, y: 3.6078431372549, size: 1 },
    //     { x: 102.302158273381, y: 3.45098039215686, size: 1 },
    //     { x: 102.94964028777, y: 3.41176470588235, size: 1 },
    //     { x: 103.597122302158, y: 3.2156862745098, size: 1 },
    //     { x: 104.244604316547, y: 2.86274509803922, size: 1 },
    //     { x: 104.892086330935, y: 2.15686274509804, size: 1 },
    //     { x: 105.539568345324, y: 2.15686274509804, size: 1 },
    //     { x: 106.187050359712, y: 3.41176470588235, size: 1 },
    //     { x: 106.834532374101, y: 3.72549019607843, size: 1 },
    //     { x: 108.129496402878, y: 3.49019607843137, size: 1 },
    //     { x: 110.071942446043, y: 3.37254901960784, size: 1 },
    //     { x: 112.014388489209, y: 3.41176470588235, size: 1 },
    //     { x: 112.661870503597, y: 3.52941176470588, size: 1 },
    //     { x: 113.956834532374, y: 3.80392156862745, size: 1 },
    //     { x: 114.604316546763, y: 3.45098039215686, size: 1 },
    //     { x: 115.251798561151, y: 3.80392156862745, size: 1 },
    //     { x: 116.546762589928, y: 3.6078431372549, size: 1 },
    //     { x: 117.194244604317, y: 3.76470588235294, size: 1 },
    //     { x: 117.841726618705, y: 3.49019607843137, size: 1 },
    //     { x: 121.726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 122.374100719424, y: 3.49019607843137, size: 1 },
    //     { x: 124.31654676259, y: 3.41176470588235, size: 1 },
    //     { x: 124.964028776978, y: 2.98039215686275, size: 1 },
    //     { x: 125.611510791367, y: 3.05882352941176, size: 1 },
    //     { x: 126.258992805755, y: 3.6078431372549, size: 1 },
    //     { x: 126.906474820144, y: 3.52941176470588, size: 1 },
    //     { x: 127.553956834532, y: 3.6078431372549, size: 1 },
    //     { x: 128.848920863309, y: 3.76470588235294, size: 1 },
    //     { x: 130.143884892086, y: 3.76470588235294, size: 1 },
    //     { x: 130.791366906475, y: 3.72549019607843, size: 1 },
    //     { x: 132.086330935252, y: 3.84313725490196, size: 1 },
    //     { x: 133.381294964029, y: 3.6078431372549, size: 1 },
    //     { x: 134.028776978417, y: 3.6078431372549, size: 1 },
    //     { x: 135.323741007194, y: 3.84313725490196, size: 1 },
    //     { x: 137.26618705036, y: 3.49019607843137, size: 1 },
    //     { x: 139.208633093525, y: 3.52941176470588, size: 1 },
    //     { x: 140.503597122302, y: 3.88235294117647, size: 1 },
    //     { x: 143.093525179856, y: 3.49019607843137, size: 1 },
    //     { x: 143.741007194245, y: 3.52941176470588, size: 1 },
    //     { x: 146.978417266187, y: 3.52941176470588, size: 1 },
    //     { x: 148.920863309353, y: 3.6078431372549, size: 1 },
    //     { x: 149.568345323741, y: 3.96078431372549, size: 1 },
    //     { x: 150.215827338129, y: 3.76470588235294, size: 1 },
    //     { x: 152.158273381295, y: 3.80392156862745, size: 1 },
    //     { x: 154.10071942446, y: 3.49019607843137, size: 1 },
    //     { x: 154.748201438849, y: 3.52941176470588, size: 1 },
    //     { x: 155.395683453237, y: 3.76470588235294, size: 1 },
    //     { x: 156.043165467626, y: 3.64705882352941, size: 1 },
    //     { x: 156.690647482014, y: 3.41176470588235, size: 1 },
    //     { x: 159.280575539568, y: 3.6078431372549, size: 1 },
    //     { x: 159.928057553957, y: 3.49019607843137, size: 1 },
    //     { x: 160.575539568345, y: 3.41176470588235, size: 1 },
    //     { x: 162.517985611511, y: 3.45098039215686, size: 1 },
    //     { x: 163.165467625899, y: 3.52941176470588, size: 1 },
    //     { x: 163.812949640288, y: 3.72549019607843, size: 1 },
    //     { x: 164.460431654676, y: 3.56862745098039, size: 1 },
    //     { x: 165.107913669065, y: 3.6078431372549, size: 1 },
    //     { x: 165.755395683453, y: 3.64705882352941, size: 1 },
    //     { x: 167.05035971223, y: 3.45098039215686, size: 1 },
    //     { x: 168.345323741007, y: 3.41176470588235, size: 1 },
    //     { x: 168.992805755396, y: 3.92156862745098, size: 1 },
    //     { x: 169.640287769784, y: 3.64705882352941, size: 1 },
    //     { x: 170.287769784173, y: 3.52941176470588, size: 1 },
    //     { x: 170.935251798561, y: 3.96078431372549, size: 1 },
    //     { x: 171.58273381295, y: 3.72549019607843, size: 1 },
    //     { x: 173.525179856115, y: 3.92156862745098, size: 1 },
    //     { x: 175.467625899281, y: 3.52941176470588, size: 1 },
    //     { x: 176.762589928058, y: 3.52941176470588, size: 1 },
    //     { x: 180, y: 3.56862745098039, size: 1 },
    //     { x: 181.294964028777, y: 3.76470588235294, size: 1 },
    //     { x: 181.942446043165, y: 3.41176470588235, size: 1 },
    //     { x: 182.589928057554, y: 3.56862745098039, size: 1 },
    //     { x: 183.237410071942, y: 3.68627450980392, size: 1 },
    //     { x: 183.884892086331, y: 3.56862745098039, size: 1 },
    //     { x: 184.532374100719, y: 3.68627450980392, size: 1 },
    //     { x: 186.474820143885, y: 3.6078431372549, size: 1 },
    //     { x: 187.769784172662, y: 3.76470588235294, size: 1 },
    //     { x: 189.064748201439, y: 3.64705882352941, size: 1 },
    //     { x: 189.712230215827, y: 3.49019607843137, size: 1 },
    //     { x: 190.359712230216, y: 3.45098039215686, size: 1 },
    //     { x: 191.007194244604, y: 3.68627450980392, size: 1 },
    //     { x: 191.654676258993, y: 3.6078431372549, size: 1 },
    //     { x: 192.302158273381, y: 3.76470588235294, size: 1 },
    //     { x: 192.94964028777, y: 3.72549019607843, size: 1 },
    //     { x: 193.597122302158, y: 3.64705882352941, size: 1 },
    //     { x: 194.892086330935, y: 3.6078431372549, size: 1 },
    //     { x: 196.187050359712, y: 3.6078431372549, size: 1 },
    //     { x: 198.776978417266, y: 3.68627450980392, size: 1 },
    //     { x: 199.424460431655, y: 3.49019607843137, size: 1 },
    //     { x: 200.071942446043, y: 3.52941176470588, size: 1 },
    //     { x: 200.719424460432, y: 3.76470588235294, size: 1 },
    //     { x: 201.36690647482, y: 3.6078431372549, size: 1 },
    //     { x: 202.014388489209, y: 3.45098039215686, size: 1 },
    //     { x: 203.309352517986, y: 3.92156862745098, size: 1 },
    //     { x: 203.956834532374, y: 3.64705882352941, size: 1 },
    //     { x: 204.604316546763, y: 3.6078431372549, size: 1 },
    //     { x: 205.251798561151, y: 3.72549019607843, size: 1 },
    //     { x: 206.546762589928, y: 3.64705882352941, size: 1 },
    //     { x: 207.841726618705, y: 3.45098039215686, size: 1 },
    //     { x: 208.489208633094, y: 3.64705882352941, size: 1 },
    //     { x: 211.079136690647, y: 3.25490196078431, size: 1 },
    //     { x: 211.726618705036, y: 3.05882352941176, size: 1 },
    //     { x: 212.374100719424, y: 3.2156862745098, size: 1 },
    //     { x: 213.021582733813, y: 2.86274509803922, size: 1 },
    //     { x: 213.669064748201, y: 3.33333333333333, size: 1 },
    //     { x: 214.31654676259, y: 3.84313725490196, size: 1 },
    //     { x: 214.964028776978, y: 3.76470588235294, size: 1 },
    //     { x: 215.611510791367, y: 3.45098039215686, size: 1 },
    //     { x: 216.258992805755, y: 3.80392156862745, size: 1 },
    //     { x: 216.906474820144, y: 3.68627450980392, size: 1 },
    //     { x: 217.553956834532, y: 3.88235294117647, size: 1 },
    //     { x: 220.791366906475, y: 3.6078431372549, size: 1 },
    //     { x: 222.086330935252, y: 3.45098039215686, size: 1 },
    //     { x: 222.73381294964, y: 3.52941176470588, size: 1 },
    //     { x: 225.323741007194, y: 3.56862745098039, size: 1 },
    //     { x: 225.971223021583, y: 3.64705882352941, size: 1 },
    //     { x: 226.618705035971, y: 3.68627450980392, size: 1 },
    //     { x: 227.26618705036, y: 3.68627450980392, size: 1 },
    //     { x: 229.208633093525, y: 3.52941176470588, size: 1 },
    //     { x: 230.503597122302, y: 3.84313725490196, size: 1 },
    //     { x: 231.798561151079, y: 3.41176470588235, size: 1 },
    //     { x: 232.446043165468, y: 3.29411764705882, size: 1 },
    //     { x: 233.093525179856, y: 3.25490196078431, size: 1 },
    //     { x: 233.741007194245, y: 3.45098039215686, size: 1 },
    //     { x: 234.388489208633, y: 2.62745098039216, size: 1 },
    //     { x: 235.035971223022, y: 2.58823529411765, size: 1 },
    //     { x: 237.625899280576, y: 3.6078431372549, size: 1 },
    //     { x: 239.568345323741, y: 3.68627450980392, size: 1 },
    //     { x: 240.215827338129, y: 3.76470588235294, size: 1 },
    //     { x: 240.863309352518, y: 3.56862745098039, size: 1 },
    //     { x: 242.158273381295, y: 3.56862745098039, size: 1 },
    //     { x: 243.453237410072, y: 3.45098039215686, size: 1 },
    //     { x: 246.690647482014, y: 3.56862745098039, size: 1 },
    //     { x: 247.985611510791, y: 3.68627450980392, size: 1 },
    //     { x: 249.280575539568, y: 3.68627450980392, size: 1 },
    //     { x: 249.928057553957, y: 3.68627450980392, size: 1 },
    //     { x: 250.575539568345, y: 3.76470588235294, size: 1 },
    //     { x: 251.223021582734, y: 3.49019607843137, size: 1 },
    //     { x: 252.517985611511, y: 3.6078431372549, size: 1 },
    //     { x: 253.165467625899, y: 3.68627450980392, size: 1 },
    //     { x: 254.460431654676, y: 3.05882352941176, size: 1 },
    //     { x: 255.107913669065, y: 3.2156862745098, size: 1 },
    //     { x: 255.755395683453, y: 2.27450980392157, size: 1 },
    //     { x: 256.402877697842, y: 2.62745098039216, size: 1 },
    //     { x: 257.05035971223, y: 3.37254901960784, size: 1 },
    //     { x: 258.345323741007, y: 3.80392156862745, size: 1 },
    //     { x: 260.287769784173, y: 3.64705882352941, size: 1 },
    //     { x: 260.935251798561, y: 3.72549019607843, size: 1 },
    //     { x: 262.877697841727, y: 3.68627450980392, size: 1 },
    //     { x: 263.525179856115, y: 3.76470588235294, size: 1 },
    //     { x: 265.467625899281, y: 3.72549019607843, size: 1 },
    //     { x: 266.115107913669, y: 3.80392156862745, size: 1 },
    //     { x: 266.762589928058, y: 3.6078431372549, size: 1 },
    //     { x: 267.410071942446, y: 3.76470588235294, size: 1 },
    //     { x: 268.057553956835, y: 3.52941176470588, size: 1 },
    //     { x: 268.705035971223, y: 3.68627450980392, size: 1 },
    //     { x: 271.294964028777, y: 3.80392156862745, size: 1 },
    //     { x: 271.942446043165, y: 3.49019607843137, size: 1 },
    //     { x: 273.237410071942, y: 3.88235294117647, size: 1 },
    //     { x: 273.884892086331, y: 3.88235294117647, size: 1 },
    //     { x: 275.827338129496, y: 3.01960784313725, size: 1 },
    //     { x: 276.474820143885, y: 3.37254901960784, size: 1 },
    //     { x: 277.122302158273, y: 3.88235294117647, size: 1 },
    //     { x: 279.064748201439, y: 3.68627450980392, size: 1 },
    //     { x: 281.007194244604, y: 3.64705882352941, size: 1 },
    //     { x: 281.654676258993, y: 3.68627450980392, size: 1 },
    //     { x: 282.302158273381, y: 3.49019607843137, size: 1 },
    //     { x: 284.244604316547, y: 3.84313725490196, size: 1 },
    //     { x: 284.892086330935, y: 3.6078431372549, size: 1 },
    //     { x: 286.187050359712, y: 3.80392156862745, size: 1 },
    //     { x: 288.776978417266, y: 3.37254901960784, size: 1 },
    //     { x: 290.071942446043, y: 3.84313725490196, size: 1 },
    //     { x: 290.719424460432, y: 3.68627450980392, size: 1 },
    //     { x: 291.36690647482, y: 3.6078431372549, size: 1 },
    //     { x: 292.661870503597, y: 3.64705882352941, size: 1 },
    //     { x: 293.956834532374, y: 3.52941176470588, size: 1 },
    //     { x: 296.546762589928, y: 3.45098039215686, size: 1 },
    //     { x: 297.194244604317, y: 3.33333333333333, size: 1 },
    //     { x: 297.841726618705, y: 3.29411764705882, size: 1 },
    //     { x: 298.489208633094, y: 3.25490196078431, size: 1 },
    //     { x: 299.784172661871, y: 3.88235294117647, size: 1 },
    //     { x: 301.079136690647, y: 3.64705882352941, size: 1 },
    //     { x: 303.021582733813, y: 3.49019607843137, size: 1 },
    //     { x: 303.669064748201, y: 3.68627450980392, size: 1 },
    //     { x: 304.964028776978, y: 3.52941176470588, size: 1 },
    //     { x: 306.258992805755, y: 3.76470588235294, size: 1 },
    //     { x: 307.553956834532, y: 3.84313725490196, size: 1 },
    //     { x: 308.201438848921, y: 3.45098039215686, size: 1 },
    //     { x: 309.496402877698, y: 3.72549019607843, size: 1 },
    //     { x: 314.676258992806, y: 3.49019607843137, size: 1 },
    //     { x: 316.618705035971, y: 3.56862745098039, size: 1 },
    //     { x: 317.26618705036, y: 3.84313725490196, size: 1 },
    //     { x: 317.913669064748, y: 3.72549019607843, size: 1 },
    //     { x: 318.561151079137, y: 3.68627450980392, size: 1 },
    //     { x: 319.208633093525, y: 3.37254901960784, size: 1 },
    //     { x: 319.856115107914, y: 3.68627450980392, size: 1 },
    //     { x: 321.798561151079, y: 3.6078431372549, size: 1 },
    //     { x: 322.446043165468, y: 3.88235294117647, size: 1 },
    //     { x: 323.093525179856, y: 3.68627450980392, size: 1 },
    //     { x: 323.741007194245, y: 3.56862745098039, size: 1 },
    //     { x: 324.388489208633, y: 3.76470588235294, size: 1 },
    //     { x: 325.68345323741, y: 3.49019607843137, size: 1 },
    //     { x: 326.330935251799, y: 3.52941176470588, size: 1 },
    //     { x: 328.273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 328.920863309353, y: 4.03921568627451, size: 1 },
    //     { x: 329.568345323741, y: 3.76470588235294, size: 1 },
    //     { x: 330.863309352518, y: 3.84313725490196, size: 1 },
    //     { x: 331.510791366906, y: 3.68627450980392, size: 1 },
    //     { x: 332.158273381295, y: 3.72549019607843, size: 1 },
    //     { x: 334.748201438849, y: 3.64705882352941, size: 1 },
    //     { x: 336.690647482014, y: 3.6078431372549, size: 1 },
    //     { x: 337.338129496403, y: 3.45098039215686, size: 1 },
    //     { x: 338.63309352518, y: 3.49019607843137, size: 1 },
    //     { x: 339.280575539568, y: 3.52941176470588, size: 1 },
    //     { x: 341.223021582734, y: 3.52941176470588, size: 1 },
    //     { x: 341.870503597122, y: 3.52941176470588, size: 1 },
    //     { x: 342.517985611511, y: 3.45098039215686, size: 1 },
    //     { x: 343.165467625899, y: 3.45098039215686, size: 1 },
    //     { x: 344.460431654676, y: 3.52941176470588, size: 1 },
    //     { x: 345.755395683453, y: 3.52941176470588, size: 1 },
    //     { x: 346.402877697842, y: 3.64705882352941, size: 1 },
    //     { x: 347.697841726619, y: 3.52941176470588, size: 1 },
    //     { x: 348.345323741007, y: 3.45098039215686, size: 1 },
    //     { x: 349.640287769784, y: 3.45098039215686, size: 1 },
    //     { x: 350.935251798561, y: 3.45098039215686, size: 1 },
    //     { x: 352.877697841727, y: 3.72549019607843, size: 1 },
    //     { x: 353.525179856115, y: 3.52941176470588, size: 1 },
    //     { x: 354.172661870504, y: 3.68627450980392, size: 1 },
    //     { x: 354.820143884892, y: 3.45098039215686, size: 1 },
    //     { x: 355.467625899281, y: 3.52941176470588, size: 1 },
    //     { x: 356.115107913669, y: 3.49019607843137, size: 1 },
    //     { x: 357.410071942446, y: 3.68627450980392, size: 1 },
    //     { x: 358.705035971223, y: 3.52941176470588, size: 1 },
    //     { x: 359.352517985611, y: 3.49019607843137, size: 1 },
    //     { x: 0.648648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 1.2972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 1.94594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 2.59459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 3.24324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 3.89189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 4.54054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 5.18918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 5.83783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 6.48648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 7.13513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 7.78378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 9.08108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 10.3783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 11.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 11.6756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 12.3243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 12.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 13.6216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 15.5675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 16.2162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 16.8648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 17.5135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 18.1621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 20.1081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 20.7567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 21.4054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 22.0540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 22.7027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 23.3513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 24, y: 3.17647058823529, size: 1 },
    //     { x: 24.6486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 25.2972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 25.9459459459459, y: 2.86274509803922, size: 1 },
    //     { x: 26.5945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 27.2432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 27.8918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 29.1891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 29.8378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 30.4864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 31.1351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 31.7837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 32.4324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 33.0810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 33.7297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 34.3783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 35.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 35.6756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 36.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 37.6216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 38.9189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 39.5675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 40.2162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 40.8648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 41.5135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 42.8108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 43.4594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 44.1081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 44.7567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 45.4054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 46.0540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 46.7027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 47.3513513513514, y: 2.62745098039216, size: 1 },
    //     { x: 48, y: 2.62745098039216, size: 1 },
    //     { x: 48.6486486486486, y: 2.90196078431373, size: 1 },
    //     { x: 49.2972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 49.9459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 50.5945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 51.2432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 51.8918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 53.1891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 53.8378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 54.4864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 55.1351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 55.7837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 56.4324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 57.0810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 57.7297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 58.3783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 59.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 59.6756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 60.3243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 61.6216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 62.2702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 62.9189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 63.5675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 64.2162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 64.8648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 65.5135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 66.1621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 66.8108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 68.1081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 68.7567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 69.4054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 70.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 71.3513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 72, y: 3.49019607843137, size: 1 },
    //     { x: 73.2972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 73.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 74.5945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 75.2432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 75.8918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 76.5405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 77.8378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 78.4864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 79.7837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 80.4324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 81.7297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 83.6756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 84.3243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 85.6216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 86.2702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 86.9189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 88.2162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 88.8648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 89.5135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 90.1621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 90.8108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 91.4594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 92.1081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 92.7567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 93.4054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 94.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 94.7027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 95.3513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 96, y: 3.41176470588235, size: 1 },
    //     { x: 96.6486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 97.2972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 99.2432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 99.8918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 100.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 101.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 101.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 102.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 103.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 105.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 105.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 106.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 107.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 107.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 108.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 108.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 109.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 110.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 112.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 112.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 114.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 114.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 115.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 116.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 116.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 117.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 118.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 118.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 120, y: 3.64705882352941, size: 1 },
    //     { x: 121.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 121.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 122.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 123.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 123.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 124.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 125.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 125.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 127.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 130.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 131.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 131.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 132.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 132.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 133.621621621622, y: 2.86274509803922, size: 1 },
    //     { x: 134.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 134.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 135.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 136.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 136.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 137.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 138.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 138.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 139.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 140.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 140.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 141.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 142.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 142.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 143.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 144, y: 3.76470588235294, size: 1 },
    //     { x: 144.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 145.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 145.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 146.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 147.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 147.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 148.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 149.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 150.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 151.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 151.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 152.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 153.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 153.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 154.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 155.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 155.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 156.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 157.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 158.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 159.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 160.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 160.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 161.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 162.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 162.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 165.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 166.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 166.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 167.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 168, y: 3.49019607843137, size: 1 },
    //     { x: 168.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 169.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 170.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 171.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 171.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 172.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 173.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 173.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 174.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 175.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 175.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 177.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 177.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 178.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 179.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 179.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 180.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 180.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 182.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 183.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 184.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 184.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 185.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 186.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 187.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 188.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 188.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 190.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 190.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 192, y: 3.68627450980392, size: 1 },
    //     { x: 192.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 193.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 193.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 194.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 195.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 196.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 197.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 197.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 198.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 199.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 199.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 200.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 201.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 201.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 203.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 204.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 204.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 205.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 206.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 206.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 207.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 209.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 210.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 210.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 211.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 212.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 213.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 214.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 215.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 216, y: 3.64705882352941, size: 1 },
    //     { x: 217.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 217.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 218.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 219.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 219.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 221.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 221.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 222.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 223.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 223.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 224.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 225.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 225.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 226.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 227.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 227.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 228.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 229.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 230.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 230.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 231.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 232.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 233.513513513514, y: 4, size: 1 },
    //     { x: 234.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 234.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 235.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 236.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 236.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 237.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 238.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 238.702702702703, y: 4, size: 1 },
    //     { x: 239.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 240, y: 3.6078431372549, size: 1 },
    //     { x: 240.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 241.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 242.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 243.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 243.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 244.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 245.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 245.837837837838, y: 4, size: 1 },
    //     { x: 246.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 247.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 247.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 248.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 249.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 250.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 251.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 251.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 252.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 253.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 254.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 255.567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 256.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 256.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 257.513513513513, y: 3.72549019607843, size: 1 },
    //     { x: 258.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 258.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 259.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 260.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 260.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 262.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 262.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 263.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 264, y: 3.56862745098039, size: 1 },
    //     { x: 264.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 265.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 265.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 266.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 267.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 268.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 269.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 270.486486486487, y: 3.49019607843137, size: 1 },
    //     { x: 271.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 271.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 273.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 274.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 275.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 275.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 276.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 277.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 278.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 279.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 280.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 280.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 282.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 282.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 283.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 284.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 284.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 285.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 286.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 286.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 287.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 288, y: 3.56862745098039, size: 1 },
    //     { x: 288.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 289.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 289.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 290.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 291.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 292.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 293.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 294.486486486487, y: 3.6078431372549, size: 1 },
    //     { x: 295.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 295.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 297.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 297.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 298.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 299.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 299.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 300.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 300.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 301.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 302.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 302.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 303.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 304.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 305.513513513513, y: 3.05882352941176, size: 1 },
    //     { x: 306.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 306.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 307.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 308.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 308.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 309.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 310.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 310.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 312, y: 3.6078431372549, size: 1 },
    //     { x: 312.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 313.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 313.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 314.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 315.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 316.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 317.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 317.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 318.486486486487, y: 3.37254901960784, size: 1 },
    //     { x: 319.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 319.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 320.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 321.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 321.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 322.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 323.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 323.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 324.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 324.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 325.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 326.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 326.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 327.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 328.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 329.513513513513, y: 3.72549019607843, size: 1 },
    //     { x: 330.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 330.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 331.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 332.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 332.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 333.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 334.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 334.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 335.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 336, y: 3.72549019607843, size: 1 },
    //     { x: 336.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 337.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 338.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 339.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 340.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 341.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 341.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 342.486486486487, y: 3.6078431372549, size: 1 },
    //     { x: 343.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 343.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 344.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 345.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 345.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 347.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 348.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 348.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 349.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 350.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 350.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 351.567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 352.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 353.513513513513, y: 3.49019607843137, size: 1 },
    //     { x: 354.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 354.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 355.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 356.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 357.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 358.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 359.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 0, y: 3.52941176470588, size: 1 },
    //     { x: 0.647482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 1.94244604316547, y: 3.64705882352941, size: 1 },
    //     { x: 3.23741007194245, y: 3.56862745098039, size: 1 },
    //     { x: 3.88489208633094, y: 3.72549019607843, size: 1 },
    //     { x: 4.53237410071942, y: 3.45098039215686, size: 1 },
    //     { x: 5.17985611510791, y: 3.56862745098039, size: 1 },
    //     { x: 6.47482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 7.12230215827338, y: 3.68627450980392, size: 1 },
    //     { x: 7.76978417266187, y: 3.49019607843137, size: 1 },
    //     { x: 8.41726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 9.06474820143885, y: 3.6078431372549, size: 1 },
    //     { x: 11.0071942446043, y: 3.72549019607843, size: 1 },
    //     { x: 12.3021582733813, y: 2.82352941176471, size: 1 },
    //     { x: 12.9496402877698, y: 3.05882352941176, size: 1 },
    //     { x: 13.5971223021583, y: 3.25490196078431, size: 1 },
    //     { x: 14.2446043165468, y: 3.84313725490196, size: 1 },
    //     { x: 15.5395683453237, y: 3.84313725490196, size: 1 },
    //     { x: 16.8345323741007, y: 3.76470588235294, size: 1 },
    //     { x: 19.4244604316547, y: 3.56862745098039, size: 1 },
    //     { x: 20.7194244604317, y: 3.76470588235294, size: 1 },
    //     { x: 21.3669064748201, y: 3.72549019607843, size: 1 },
    //     { x: 22.0143884892086, y: 3.80392156862745, size: 1 },
    //     { x: 22.6618705035971, y: 3.76470588235294, size: 1 },
    //     { x: 23.3093525179856, y: 3.84313725490196, size: 1 },
    //     { x: 24.6043165467626, y: 3.64705882352941, size: 1 },
    //     { x: 25.8992805755396, y: 3.84313725490196, size: 1 },
    //     { x: 27.841726618705, y: 3.92156862745098, size: 1 },
    //     { x: 31.0791366906475, y: 3.49019607843137, size: 1 },
    //     { x: 33.0215827338129, y: 3.09803921568627, size: 1 },
    //     { x: 33.6690647482014, y: 2.98039215686275, size: 1 },
    //     { x: 36.9064748201439, y: 3.52941176470588, size: 1 },
    //     { x: 38.2014388489209, y: 3.76470588235294, size: 1 },
    //     { x: 38.8489208633094, y: 3.41176470588235, size: 1 },
    //     { x: 39.4964028776978, y: 3.49019607843137, size: 1 },
    //     { x: 40.7913669064748, y: 3.84313725490196, size: 1 },
    //     { x: 41.4388489208633, y: 3.52941176470588, size: 1 },
    //     { x: 42.0863309352518, y: 3.41176470588235, size: 1 },
    //     { x: 43.3812949640288, y: 3.76470588235294, size: 1 },
    //     { x: 44.0287769784173, y: 3.45098039215686, size: 1 },
    //     { x: 44.6762589928058, y: 3.49019607843137, size: 1 },
    //     { x: 45.9712230215827, y: 3.52941176470588, size: 1 },
    //     { x: 46.6187050359712, y: 3.45098039215686, size: 1 },
    //     { x: 47.2661870503597, y: 3.52941176470588, size: 1 },
    //     { x: 49.8561151079137, y: 3.45098039215686, size: 1 },
    //     { x: 50.5035971223022, y: 3.84313725490196, size: 1 },
    //     { x: 53.7410071942446, y: 3.64705882352941, size: 1 },
    //     { x: 55.0359712230216, y: 3.64705882352941, size: 1 },
    //     { x: 55.6834532374101, y: 3.49019607843137, size: 1 },
    //     { x: 56.3309352517986, y: 3.80392156862745, size: 1 },
    //     { x: 57.6258992805755, y: 3.88235294117647, size: 1 },
    //     { x: 60.2158273381295, y: 3.76470588235294, size: 1 },
    //     { x: 60.863309352518, y: 3.6078431372549, size: 1 },
    //     { x: 61.5107913669065, y: 3.80392156862745, size: 1 },
    //     { x: 65.3956834532374, y: 4.03921568627451, size: 1 },
    //     { x: 66.0431654676259, y: 3.76470588235294, size: 1 },
    //     { x: 67.3381294964029, y: 3.68627450980392, size: 1 },
    //     { x: 67.9856115107914, y: 3.6078431372549, size: 1 },
    //     { x: 70.5755395683453, y: 3.76470588235294, size: 1 },
    //     { x: 71.2230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 71.8705035971223, y: 3.64705882352941, size: 1 },
    //     { x: 74.4604316546763, y: 3.84313725490196, size: 1 },
    //     { x: 75.1079136690647, y: 3.92156862745098, size: 1 },
    //     { x: 75.7553956834532, y: 3.84313725490196, size: 1 },
    //     { x: 76.4028776978417, y: 3.33333333333333, size: 1 },
    //     { x: 78.3453237410072, y: 3.68627450980392, size: 1 },
    //     { x: 82.2302158273381, y: 3.6078431372549, size: 1 },
    //     { x: 83.5251798561151, y: 3.68627450980392, size: 1 },
    //     { x: 88.705035971223, y: 3.84313725490196, size: 1 },
    //     { x: 89.3525179856115, y: 3.84313725490196, size: 1 },
    //     { x: 90, y: 3.68627450980392, size: 1 },
    //     { x: 90.6474820143885, y: 3.72549019607843, size: 1 },
    //     { x: 91.9424460431655, y: 3.76470588235294, size: 1 },
    //     { x: 95.1798561151079, y: 3.45098039215686, size: 1 },
    //     { x: 96.4748201438849, y: 3.56862745098039, size: 1 },
    //     { x: 98.4172661870504, y: 3.49019607843137, size: 1 },
    //     { x: 99.0647482014388, y: 3.37254901960784, size: 1 },
    //     { x: 99.7122302158273, y: 3.49019607843137, size: 1 },
    //     { x: 102.302158273381, y: 3.76470588235294, size: 1 },
    //     { x: 104.244604316547, y: 3.56862745098039, size: 1 },
    //     { x: 105.539568345324, y: 3.72549019607843, size: 1 },
    //     { x: 106.187050359712, y: 3.49019607843137, size: 1 },
    //     { x: 107.482014388489, y: 3.6078431372549, size: 1 },
    //     { x: 110.071942446043, y: 3.56862745098039, size: 1 },
    //     { x: 110.719424460432, y: 3.37254901960784, size: 1 },
    //     { x: 111.36690647482, y: 3.6078431372549, size: 1 },
    //     { x: 112.661870503597, y: 3.68627450980392, size: 1 },
    //     { x: 116.546762589928, y: 3.56862745098039, size: 1 },
    //     { x: 119.136690647482, y: 2.94117647058824, size: 1 },
    //     { x: 119.784172661871, y: 2.74509803921569, size: 1 },
    //     { x: 120.431654676259, y: 3.05882352941176, size: 1 },
    //     { x: 121.079136690647, y: 3.09803921568627, size: 1 },
    //     { x: 121.726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 122.374100719424, y: 3.33333333333333, size: 1 },
    //     { x: 123.021582733813, y: 3.92156862745098, size: 1 },
    //     { x: 123.669064748201, y: 3.41176470588235, size: 1 },
    //     { x: 126.258992805755, y: 3.68627450980392, size: 1 },
    //     { x: 127.553956834532, y: 3.56862745098039, size: 1 },
    //     { x: 128.848920863309, y: 3.88235294117647, size: 1 },
    //     { x: 129.496402877698, y: 3.49019607843137, size: 1 },
    //     { x: 130.143884892086, y: 3.6078431372549, size: 1 },
    //     { x: 130.791366906475, y: 3.56862745098039, size: 1 },
    //     { x: 131.438848920863, y: 3.45098039215686, size: 1 },
    //     { x: 132.086330935252, y: 3.41176470588235, size: 1 },
    //     { x: 132.73381294964, y: 3.49019607843137, size: 1 },
    //     { x: 134.028776978417, y: 3.56862745098039, size: 1 },
    //     { x: 134.676258992806, y: 3.56862745098039, size: 1 },
    //     { x: 137.26618705036, y: 3.72549019607843, size: 1 },
    //     { x: 138.561151079137, y: 3.45098039215686, size: 1 },
    //     { x: 139.856115107914, y: 3.64705882352941, size: 1 },
    //     { x: 140.503597122302, y: 3.49019607843137, size: 1 },
    //     { x: 141.151079136691, y: 2.98039215686275, size: 1 },
    //     { x: 141.798561151079, y: 3.17647058823529, size: 1 },
    //     { x: 142.446043165468, y: 3.17647058823529, size: 1 },
    //     { x: 143.093525179856, y: 3.01960784313725, size: 1 },
    //     { x: 143.741007194245, y: 3.76470588235294, size: 1 },
    //     { x: 144.388489208633, y: 3.88235294117647, size: 1 },
    //     { x: 145.035971223022, y: 3.52941176470588, size: 1 },
    //     { x: 146.330935251799, y: 3.64705882352941, size: 1 },
    //     { x: 148.273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 148.920863309353, y: 3.80392156862745, size: 1 },
    //     { x: 149.568345323741, y: 3.84313725490196, size: 1 },
    //     { x: 150.863309352518, y: 4.03921568627451, size: 1 },
    //     { x: 151.510791366906, y: 3.72549019607843, size: 1 },
    //     { x: 153.453237410072, y: 3.76470588235294, size: 1 },
    //     { x: 154.10071942446, y: 3.52941176470588, size: 1 },
    //     { x: 155.395683453237, y: 3.64705882352941, size: 1 },
    //     { x: 156.690647482014, y: 3.76470588235294, size: 1 },
    //     { x: 157.985611510791, y: 3.6078431372549, size: 1 },
    //     { x: 159.928057553957, y: 3.64705882352941, size: 1 },
    //     { x: 160.575539568345, y: 3.76470588235294, size: 1 },
    //     { x: 161.870503597122, y: 3.37254901960784, size: 1 },
    //     { x: 162.517985611511, y: 2.94117647058824, size: 1 },
    //     { x: 163.165467625899, y: 2.66666666666667, size: 1 },
    //     { x: 163.812949640288, y: 2.98039215686275, size: 1 },
    //     { x: 164.460431654676, y: 2.94117647058824, size: 1 },
    //     { x: 165.107913669065, y: 3.37254901960784, size: 1 },
    //     { x: 166.402877697842, y: 3.45098039215686, size: 1 },
    //     { x: 168.992805755396, y: 3.6078431372549, size: 1 },
    //     { x: 171.58273381295, y: 3.80392156862745, size: 1 },
    //     { x: 172.230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 173.525179856115, y: 3.52941176470588, size: 1 },
    //     { x: 176.762589928058, y: 3.64705882352941, size: 1 },
    //     { x: 177.410071942446, y: 3.64705882352941, size: 1 },
    //     { x: 178.057553956835, y: 3.49019607843137, size: 1 },
    //     { x: 178.705035971223, y: 3.49019607843137, size: 1 },
    //     { x: 179.352517985612, y: 3.6078431372549, size: 1 },
    //     { x: 180.647482014388, y: 3.56862745098039, size: 1 },
    //     { x: 181.294964028777, y: 3.56862745098039, size: 1 },
    //     { x: 181.942446043165, y: 3.68627450980392, size: 1 },
    //     { x: 183.237410071942, y: 3.6078431372549, size: 1 },
    //     { x: 186.474820143885, y: 3.56862745098039, size: 1 },
    //     { x: 187.122302158273, y: 3.68627450980392, size: 1 },
    //     { x: 188.41726618705, y: 3.64705882352941, size: 1 },
    //     { x: 189.712230215827, y: 3.80392156862745, size: 1 },
    //     { x: 191.007194244604, y: 3.76470588235294, size: 1 },
    //     { x: 191.654676258993, y: 3.72549019607843, size: 1 },
    //     { x: 192.302158273381, y: 3.88235294117647, size: 1 },
    //     { x: 193.597122302158, y: 3.84313725490196, size: 1 },
    //     { x: 194.244604316547, y: 3.64705882352941, size: 1 },
    //     { x: 196.187050359712, y: 3.72549019607843, size: 1 },
    //     { x: 196.834532374101, y: 3.80392156862745, size: 1 },
    //     { x: 197.482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 198.129496402878, y: 3.68627450980392, size: 1 },
    //     { x: 199.424460431655, y: 3.80392156862745, size: 1 },
    //     { x: 202.014388489209, y: 3.80392156862745, size: 1 },
    //     { x: 202.661870503597, y: 3.88235294117647, size: 1 },
    //     { x: 203.309352517986, y: 3.6078431372549, size: 1 },
    //     { x: 205.251798561151, y: 3.37254901960784, size: 1 },
    //     { x: 205.89928057554, y: 3.41176470588235, size: 1 },
    //     { x: 206.546762589928, y: 3.6078431372549, size: 1 },
    //     { x: 207.841726618705, y: 3.56862745098039, size: 1 },
    //     { x: 208.489208633094, y: 3.72549019607843, size: 1 },
    //     { x: 209.136690647482, y: 3.6078431372549, size: 1 },
    //     { x: 210.431654676259, y: 3.76470588235294, size: 1 },
    //     { x: 211.079136690647, y: 3.33333333333333, size: 1 },
    //     { x: 213.021582733813, y: 3.72549019607843, size: 1 },
    //     { x: 213.669064748201, y: 3.80392156862745, size: 1 },
    //     { x: 214.31654676259, y: 3.68627450980392, size: 1 },
    //     { x: 216.258992805755, y: 3.96078431372549, size: 1 },
    //     { x: 216.906474820144, y: 3.52941176470588, size: 1 },
    //     { x: 217.553956834532, y: 3.92156862745098, size: 1 },
    //     { x: 218.848920863309, y: 3.64705882352941, size: 1 },
    //     { x: 220.143884892086, y: 3.52941176470588, size: 1 },
    //     { x: 220.791366906475, y: 3.76470588235294, size: 1 },
    //     { x: 221.438848920863, y: 3.56862745098039, size: 1 },
    //     { x: 222.73381294964, y: 3.76470588235294, size: 1 },
    //     { x: 224.028776978417, y: 3.49019607843137, size: 1 },
    //     { x: 225.323741007194, y: 3.45098039215686, size: 1 },
    //     { x: 227.913669064748, y: 3.45098039215686, size: 1 },
    //     { x: 228.561151079137, y: 3.49019607843137, size: 1 },
    //     { x: 229.856115107914, y: 3.64705882352941, size: 1 },
    //     { x: 231.151079136691, y: 3.56862745098039, size: 1 },
    //     { x: 231.798561151079, y: 3.72549019607843, size: 1 },
    //     { x: 232.446043165468, y: 3.52941176470588, size: 1 },
    //     { x: 233.741007194245, y: 3.56862745098039, size: 1 },
    //     { x: 236.978417266187, y: 3.49019607843137, size: 1 },
    //     { x: 237.625899280576, y: 3.76470588235294, size: 1 },
    //     { x: 238.920863309353, y: 3.76470588235294, size: 1 },
    //     { x: 240.863309352518, y: 3.64705882352941, size: 1 },
    //     { x: 243.453237410072, y: 3.52941176470588, size: 1 },
    //     { x: 244.748201438849, y: 3.56862745098039, size: 1 },
    //     { x: 245.395683453237, y: 3.80392156862745, size: 1 },
    //     { x: 246.043165467626, y: 3.52941176470588, size: 1 },
    //     { x: 247.985611510791, y: 3.52941176470588, size: 1 },
    //     { x: 252.517985611511, y: 3.88235294117647, size: 1 },
    //     { x: 254.460431654676, y: 3.68627450980392, size: 1 },
    //     { x: 255.755395683453, y: 3.68627450980392, size: 1 },
    //     { x: 256.402877697842, y: 3.49019607843137, size: 1 },
    //     { x: 257.05035971223, y: 3.52941176470588, size: 1 },
    //     { x: 257.697841726619, y: 3.41176470588235, size: 1 },
    //     { x: 258.345323741007, y: 3.49019607843137, size: 1 },
    //     { x: 258.992805755396, y: 3.88235294117647, size: 1 },
    //     { x: 260.935251798561, y: 3.76470588235294, size: 1 },
    //     { x: 261.58273381295, y: 3.6078431372549, size: 1 },
    //     { x: 262.230215827338, y: 3.64705882352941, size: 1 },
    //     { x: 264.172661870504, y: 3.68627450980392, size: 1 },
    //     { x: 264.820143884892, y: 3.52941176470588, size: 1 },
    //     { x: 265.467625899281, y: 3.64705882352941, size: 1 },
    //     { x: 266.115107913669, y: 3.52941176470588, size: 1 },
    //     { x: 266.762589928058, y: 3.64705882352941, size: 1 },
    //     { x: 267.410071942446, y: 3.6078431372549, size: 1 },
    //     { x: 268.705035971223, y: 3.37254901960784, size: 1 },
    //     { x: 269.352517985611, y: 3.29411764705882, size: 1 },
    //     { x: 270, y: 3.37254901960784, size: 1 },
    //     { x: 270.647482014389, y: 3.01960784313725, size: 1 },
    //     { x: 271.294964028777, y: 3.05882352941176, size: 1 },
    //     { x: 271.942446043165, y: 2.90196078431373, size: 1 },
    //     { x: 272.589928057554, y: 3.25490196078431, size: 1 },
    //     { x: 275.179856115108, y: 3.52941176470588, size: 1 },
    //     { x: 275.827338129496, y: 3.45098039215686, size: 1 },
    //     { x: 277.122302158273, y: 3.52941176470588, size: 1 },
    //     { x: 279.064748201439, y: 3.6078431372549, size: 1 },
    //     { x: 279.712230215827, y: 3.41176470588235, size: 1 },
    //     { x: 280.359712230216, y: 3.49019607843137, size: 1 },
    //     { x: 282.302158273381, y: 3.56862745098039, size: 1 },
    //     { x: 284.244604316547, y: 3.49019607843137, size: 1 },
    //     { x: 284.892086330935, y: 3.72549019607843, size: 1 },
    //     { x: 285.539568345324, y: 3.56862745098039, size: 1 },
    //     { x: 286.834532374101, y: 3.49019607843137, size: 1 },
    //     { x: 288.129496402878, y: 3.49019607843137, size: 1 },
    //     { x: 288.776978417266, y: 3.80392156862745, size: 1 },
    //     { x: 292.014388489209, y: 3.49019607843137, size: 1 },
    //     { x: 294.604316546763, y: 3.72549019607843, size: 1 },
    //     { x: 295.89928057554, y: 3.41176470588235, size: 1 },
    //     { x: 297.194244604317, y: 3.6078431372549, size: 1 },
    //     { x: 297.841726618705, y: 3.64705882352941, size: 1 },
    //     { x: 299.136690647482, y: 3.41176470588235, size: 1 },
    //     { x: 300.431654676259, y: 3.64705882352941, size: 1 },
    //     { x: 301.079136690647, y: 3.56862745098039, size: 1 },
    //     { x: 302.374100719424, y: 3.92156862745098, size: 1 },
    //     { x: 303.021582733813, y: 3.56862745098039, size: 1 },
    //     { x: 303.669064748201, y: 3.64705882352941, size: 1 },
    //     { x: 304.31654676259, y: 3.56862745098039, size: 1 },
    //     { x: 306.258992805755, y: 3.56862745098039, size: 1 },
    //     { x: 309.496402877698, y: 3.76470588235294, size: 1 },
    //     { x: 310.791366906475, y: 3.49019607843137, size: 1 },
    //     { x: 312.73381294964, y: 3.68627450980392, size: 1 },
    //     { x: 313.381294964029, y: 3.45098039215686, size: 1 },
    //     { x: 316.618705035971, y: 3.64705882352941, size: 1 },
    //     { x: 317.26618705036, y: 3.45098039215686, size: 1 },
    //     { x: 317.913669064748, y: 3.33333333333333, size: 1 },
    //     { x: 318.561151079137, y: 3.45098039215686, size: 1 },
    //     { x: 320.503597122302, y: 3.49019607843137, size: 1 },
    //     { x: 322.446043165468, y: 3.49019607843137, size: 1 },
    //     { x: 323.093525179856, y: 3.64705882352941, size: 1 },
    //     { x: 323.741007194245, y: 3.6078431372549, size: 1 },
    //     { x: 324.388489208633, y: 3.49019607843137, size: 1 },
    //     { x: 325.68345323741, y: 3.52941176470588, size: 1 },
    //     { x: 326.330935251799, y: 3.45098039215686, size: 1 },
    //     { x: 328.273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 328.920863309353, y: 3.64705882352941, size: 1 },
    //     { x: 329.568345323741, y: 3.56862745098039, size: 1 },
    //     { x: 330.863309352518, y: 3.52941176470588, size: 1 },
    //     { x: 333.453237410072, y: 3.6078431372549, size: 1 },
    //     { x: 334.10071942446, y: 3.29411764705882, size: 1 },
    //     { x: 334.748201438849, y: 3.33333333333333, size: 1 },
    //     { x: 336.043165467626, y: 3.52941176470588, size: 1 },
    //     { x: 338.63309352518, y: 3.68627450980392, size: 1 },
    //     { x: 342.517985611511, y: 3.56862745098039, size: 1 },
    //     { x: 343.165467625899, y: 3.6078431372549, size: 1 },
    //     { x: 343.812949640288, y: 3.52941176470588, size: 1 },
    //     { x: 347.697841726619, y: 3.76470588235294, size: 1 },
    //     { x: 348.992805755396, y: 3.80392156862745, size: 1 },
    //     { x: 349.640287769784, y: 3.64705882352941, size: 1 },
    //     { x: 350.287769784173, y: 3.80392156862745, size: 1 },
    //     { x: 350.935251798561, y: 3.41176470588235, size: 1 },
    //     { x: 351.58273381295, y: 3.84313725490196, size: 1 },
    //     { x: 352.877697841727, y: 3.64705882352941, size: 1 },
    //     { x: 353.525179856115, y: 3.76470588235294, size: 1 },
    //     { x: 354.172661870504, y: 3.6078431372549, size: 1 },
    //     { x: 355.467625899281, y: 3.64705882352941, size: 1 },
    //     { x: 357.410071942446, y: 3.25490196078431, size: 1 },
    //     { x: 358.705035971223, y: 3.6078431372549, size: 1 },
    //     { x: 0.647482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 1.29496402877698, y: 3.49019607843137, size: 1 },
    //     { x: 1.94244604316547, y: 3.76470588235294, size: 1 },
    //     { x: 3.88489208633094, y: 3.76470588235294, size: 1 },
    //     { x: 4.53237410071942, y: 3.68627450980392, size: 1 },
    //     { x: 5.17985611510791, y: 3.72549019607843, size: 1 },
    //     { x: 5.8273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 6.47482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 7.12230215827338, y: 3.64705882352941, size: 1 },
    //     { x: 7.76978417266187, y: 3.45098039215686, size: 1 },
    //     { x: 9.06474820143885, y: 3.37254901960784, size: 1 },
    //     { x: 12.9496402877698, y: 3.41176470588235, size: 1 },
    //     { x: 14.2446043165468, y: 3.52941176470588, size: 1 },
    //     { x: 14.8920863309353, y: 3.49019607843137, size: 1 },
    //     { x: 17.4820143884892, y: 3.33333333333333, size: 1 },
    //     { x: 18.1294964028777, y: 3.13725490196078, size: 1 },
    //     { x: 18.7769784172662, y: 3.13725490196078, size: 1 },
    //     { x: 20.0719424460432, y: 3.68627450980392, size: 1 },
    //     { x: 20.7194244604317, y: 3.52941176470588, size: 1 },
    //     { x: 22.0143884892086, y: 3.56862745098039, size: 1 },
    //     { x: 23.3093525179856, y: 3.76470588235294, size: 1 },
    //     { x: 23.9568345323741, y: 3.76470588235294, size: 1 },
    //     { x: 24.6043165467626, y: 3.56862745098039, size: 1 },
    //     { x: 28.4892086330935, y: 3.76470588235294, size: 1 },
    //     { x: 31.0791366906475, y: 3.6078431372549, size: 1 },
    //     { x: 31.726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 32.3741007194245, y: 3.56862745098039, size: 1 },
    //     { x: 33.6690647482014, y: 3.6078431372549, size: 1 },
    //     { x: 35.6115107913669, y: 3.80392156862745, size: 1 },
    //     { x: 36.9064748201439, y: 3.64705882352941, size: 1 },
    //     { x: 38.8489208633094, y: 3.37254901960784, size: 1 },
    //     { x: 40.7913669064748, y: 3.33333333333333, size: 1 },
    //     { x: 42.0863309352518, y: 3.52941176470588, size: 1 },
    //     { x: 42.7338129496403, y: 3.68627450980392, size: 1 },
    //     { x: 43.3812949640288, y: 3.80392156862745, size: 1 },
    //     { x: 44.0287769784173, y: 3.92156862745098, size: 1 },
    //     { x: 44.6762589928058, y: 3.72549019607843, size: 1 },
    //     { x: 45.3237410071942, y: 3.64705882352941, size: 1 },
    //     { x: 45.9712230215827, y: 3.64705882352941, size: 1 },
    //     { x: 48.5611510791367, y: 3.68627450980392, size: 1 },
    //     { x: 49.2086330935252, y: 3.56862745098039, size: 1 },
    //     { x: 49.8561151079137, y: 3.80392156862745, size: 1 },
    //     { x: 51.1510791366906, y: 3.80392156862745, size: 1 },
    //     { x: 51.7985611510791, y: 3.72549019607843, size: 1 },
    //     { x: 53.7410071942446, y: 3.80392156862745, size: 1 },
    //     { x: 54.3884892086331, y: 3.68627450980392, size: 1 },
    //     { x: 57.6258992805755, y: 3.6078431372549, size: 1 },
    //     { x: 60.2158273381295, y: 3.37254901960784, size: 1 },
    //     { x: 60.863309352518, y: 3.52941176470588, size: 1 },
    //     { x: 62.158273381295, y: 3.2156862745098, size: 1 },
    //     { x: 62.8057553956835, y: 3.56862745098039, size: 1 },
    //     { x: 66.6906474820144, y: 3.49019607843137, size: 1 },
    //     { x: 67.9856115107914, y: 3.37254901960784, size: 1 },
    //     { x: 68.6330935251799, y: 3.41176470588235, size: 1 },
    //     { x: 69.9280575539568, y: 3.72549019607843, size: 1 },
    //     { x: 70.5755395683453, y: 3.56862745098039, size: 1 },
    //     { x: 71.2230215827338, y: 3.41176470588235, size: 1 },
    //     { x: 72.5179856115108, y: 3.88235294117647, size: 1 },
    //     { x: 73.8129496402878, y: 3.52941176470588, size: 1 },
    //     { x: 74.4604316546763, y: 3.56862745098039, size: 1 },
    //     { x: 75.1079136690647, y: 3.6078431372549, size: 1 },
    //     { x: 77.0503597122302, y: 3.72549019607843, size: 1 },
    //     { x: 79.6402877697842, y: 3.49019607843137, size: 1 },
    //     { x: 80.2877697841727, y: 3.64705882352941, size: 1 },
    //     { x: 80.9352517985612, y: 4.11764705882353, size: 1 },
    //     { x: 81.5827338129496, y: 3.17647058823529, size: 1 },
    //     { x: 82.2302158273381, y: 3.56862745098039, size: 1 },
    //     { x: 82.8776978417266, y: 3.09803921568627, size: 1 },
    //     { x: 83.5251798561151, y: 3.29411764705882, size: 1 },
    //     { x: 84.8201438848921, y: 3.92156862745098, size: 1 },
    //     { x: 85.4676258992806, y: 3.68627450980392, size: 1 },
    //     { x: 87.410071942446, y: 3.68627450980392, size: 1 },
    //     { x: 88.0575539568345, y: 3.6078431372549, size: 1 },
    //     { x: 88.705035971223, y: 3.64705882352941, size: 1 },
    //     { x: 90.6474820143885, y: 3.45098039215686, size: 1 },
    //     { x: 93.2374100719424, y: 3.49019607843137, size: 1 },
    //     { x: 94.5323741007194, y: 3.6078431372549, size: 1 },
    //     { x: 95.1798561151079, y: 3.6078431372549, size: 1 },
    //     { x: 97.7697841726619, y: 3.72549019607843, size: 1 },
    //     { x: 99.0647482014388, y: 3.72549019607843, size: 1 },
    //     { x: 101.007194244604, y: 3.72549019607843, size: 1 },
    //     { x: 101.654676258993, y: 3.64705882352941, size: 1 },
    //     { x: 102.94964028777, y: 3.64705882352941, size: 1 },
    //     { x: 104.892086330935, y: 3.52941176470588, size: 1 },
    //     { x: 105.539568345324, y: 3.56862745098039, size: 1 },
    //     { x: 106.187050359712, y: 3.6078431372549, size: 1 },
    //     { x: 108.129496402878, y: 3.80392156862745, size: 1 },
    //     { x: 112.014388489209, y: 3.49019607843137, size: 1 },
    //     { x: 112.661870503597, y: 3.64705882352941, size: 1 },
    //     { x: 113.309352517986, y: 3.72549019607843, size: 1 },
    //     { x: 115.251798561151, y: 3.72549019607843, size: 1 },
    //     { x: 115.89928057554, y: 3.68627450980392, size: 1 },
    //     { x: 117.194244604317, y: 3.80392156862745, size: 1 },
    //     { x: 117.841726618705, y: 3.76470588235294, size: 1 },
    //     { x: 118.489208633094, y: 3.68627450980392, size: 1 },
    //     { x: 119.136690647482, y: 3.68627450980392, size: 1 },
    //     { x: 119.784172661871, y: 3.41176470588235, size: 1 },
    //     { x: 120.431654676259, y: 3.76470588235294, size: 1 },
    //     { x: 123.669064748201, y: 3.56862745098039, size: 1 },
    //     { x: 124.964028776978, y: 3.2156862745098, size: 1 },
    //     { x: 126.258992805755, y: 2.82352941176471, size: 1 },
    //     { x: 126.906474820144, y: 2.90196078431373, size: 1 },
    //     { x: 128.201438848921, y: 3.76470588235294, size: 1 },
    //     { x: 128.848920863309, y: 3.72549019607843, size: 1 },
    //     { x: 129.496402877698, y: 3.6078431372549, size: 1 },
    //     { x: 132.73381294964, y: 3.84313725490196, size: 1 },
    //     { x: 134.028776978417, y: 3.52941176470588, size: 1 },
    //     { x: 134.676258992806, y: 3.76470588235294, size: 1 },
    //     { x: 136.618705035971, y: 3.84313725490196, size: 1 },
    //     { x: 138.561151079137, y: 3.56862745098039, size: 1 },
    //     { x: 140.503597122302, y: 3.68627450980392, size: 1 },
    //     { x: 141.798561151079, y: 3.68627450980392, size: 1 },
    //     { x: 142.446043165468, y: 3.6078431372549, size: 1 },
    //     { x: 143.741007194245, y: 3.72549019607843, size: 1 },
    //     { x: 144.388489208633, y: 3.64705882352941, size: 1 },
    //     { x: 146.330935251799, y: 3.45098039215686, size: 1 },
    //     { x: 147.625899280576, y: 3.2156862745098, size: 1 },
    //     { x: 148.273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 148.920863309353, y: 4.03921568627451, size: 1 },
    //     { x: 150.215827338129, y: 3.96078431372549, size: 1 },
    //     { x: 150.863309352518, y: 3.64705882352941, size: 1 },
    //     { x: 152.158273381295, y: 3.64705882352941, size: 1 },
    //     { x: 152.805755395683, y: 3.72549019607843, size: 1 },
    //     { x: 153.453237410072, y: 3.56862745098039, size: 1 },
    //     { x: 154.10071942446, y: 3.68627450980392, size: 1 },
    //     { x: 160.575539568345, y: 3.64705882352941, size: 1 },
    //     { x: 162.517985611511, y: 3.76470588235294, size: 1 },
    //     { x: 163.165467625899, y: 3.64705882352941, size: 1 },
    //     { x: 163.812949640288, y: 3.6078431372549, size: 1 },
    //     { x: 165.107913669065, y: 3.45098039215686, size: 1 },
    //     { x: 165.755395683453, y: 3.49019607843137, size: 1 },
    //     { x: 166.402877697842, y: 3.49019607843137, size: 1 },
    //     { x: 167.05035971223, y: 3.88235294117647, size: 1 },
    //     { x: 167.697841726619, y: 3.25490196078431, size: 1 },
    //     { x: 168.992805755396, y: 3.17647058823529, size: 1 },
    //     { x: 169.640287769784, y: 3.01960784313725, size: 1 },
    //     { x: 170.287769784173, y: 3.29411764705882, size: 1 },
    //     { x: 170.935251798561, y: 3.41176470588235, size: 1 },
    //     { x: 171.58273381295, y: 3.56862745098039, size: 1 },
    //     { x: 172.230215827338, y: 3.52941176470588, size: 1 },
    //     { x: 173.525179856115, y: 3.64705882352941, size: 1 },
    //     { x: 175.467625899281, y: 3.56862745098039, size: 1 },
    //     { x: 176.762589928058, y: 3.56862745098039, size: 1 },
    //     { x: 177.410071942446, y: 3.45098039215686, size: 1 },
    //     { x: 178.057553956835, y: 3.52941176470588, size: 1 },
    //     { x: 178.705035971223, y: 3.52941176470588, size: 1 },
    //     { x: 180, y: 3.68627450980392, size: 1 },
    //     { x: 180.647482014388, y: 3.45098039215686, size: 1 },
    //     { x: 181.294964028777, y: 3.68627450980392, size: 1 },
    //     { x: 183.884892086331, y: 3.68627450980392, size: 1 },
    //     { x: 185.179856115108, y: 3.80392156862745, size: 1 },
    //     { x: 185.827338129496, y: 3.88235294117647, size: 1 },
    //     { x: 187.769784172662, y: 3.72549019607843, size: 1 },
    //     { x: 188.41726618705, y: 3.6078431372549, size: 1 },
    //     { x: 189.064748201439, y: 3.2156862745098, size: 1 },
    //     { x: 189.712230215827, y: 3.09803921568627, size: 1 },
    //     { x: 190.359712230216, y: 3.01960784313725, size: 1 },
    //     { x: 191.007194244604, y: 3.01960784313725, size: 1 },
    //     { x: 191.654676258993, y: 2.47058823529412, size: 1 },
    //     { x: 192.302158273381, y: 3.56862745098039, size: 1 },
    //     { x: 192.94964028777, y: 3.92156862745098, size: 1 },
    //     { x: 193.597122302158, y: 3.80392156862745, size: 1 },
    //     { x: 194.244604316547, y: 3.80392156862745, size: 1 },
    //     { x: 194.892086330935, y: 3.76470588235294, size: 1 },
    //     { x: 195.539568345324, y: 3.72549019607843, size: 1 },
    //     { x: 198.776978417266, y: 3.88235294117647, size: 1 },
    //     { x: 199.424460431655, y: 3.76470588235294, size: 1 },
    //     { x: 203.956834532374, y: 3.56862745098039, size: 1 },
    //     { x: 204.604316546763, y: 3.68627450980392, size: 1 },
    //     { x: 206.546762589928, y: 3.76470588235294, size: 1 },
    //     { x: 207.194244604317, y: 3.72549019607843, size: 1 },
    //     { x: 207.841726618705, y: 3.84313725490196, size: 1 },
    //     { x: 208.489208633094, y: 3.68627450980392, size: 1 },
    //     { x: 209.136690647482, y: 3.80392156862745, size: 1 },
    //     { x: 209.784172661871, y: 3.96078431372549, size: 1 },
    //     { x: 211.079136690647, y: 3.56862745098039, size: 1 },
    //     { x: 211.726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 213.669064748201, y: 3.56862745098039, size: 1 },
    //     { x: 216.906474820144, y: 3.76470588235294, size: 1 },
    //     { x: 218.848920863309, y: 3.49019607843137, size: 1 },
    //     { x: 222.086330935252, y: 3.80392156862745, size: 1 },
    //     { x: 222.73381294964, y: 3.68627450980392, size: 1 },
    //     { x: 223.381294964029, y: 3.76470588235294, size: 1 },
    //     { x: 227.26618705036, y: 3.64705882352941, size: 1 },
    //     { x: 227.913669064748, y: 3.76470588235294, size: 1 },
    //     { x: 229.856115107914, y: 3.52941176470588, size: 1 },
    //     { x: 232.446043165468, y: 3.17647058823529, size: 1 },
    //     { x: 233.093525179856, y: 3.45098039215686, size: 1 },
    //     { x: 233.741007194245, y: 3.37254901960784, size: 1 },
    //     { x: 234.388489208633, y: 2.82352941176471, size: 1 },
    //     { x: 235.035971223022, y: 3.05882352941176, size: 1 },
    //     { x: 235.68345323741, y: 3.45098039215686, size: 1 },
    //     { x: 236.330935251799, y: 3.56862745098039, size: 1 },
    //     { x: 236.978417266187, y: 3.64705882352941, size: 1 },
    //     { x: 242.805755395683, y: 3.88235294117647, size: 1 },
    //     { x: 243.453237410072, y: 3.68627450980392, size: 1 },
    //     { x: 244.10071942446, y: 3.56862745098039, size: 1 },
    //     { x: 244.748201438849, y: 3.72549019607843, size: 1 },
    //     { x: 246.043165467626, y: 3.56862745098039, size: 1 },
    //     { x: 246.690647482014, y: 3.33333333333333, size: 1 },
    //     { x: 251.223021582734, y: 3.76470588235294, size: 1 },
    //     { x: 253.812949640288, y: 3.41176470588235, size: 1 },
    //     { x: 254.460431654676, y: 3.64705882352941, size: 1 },
    //     { x: 255.755395683453, y: 3.33333333333333, size: 1 },
    //     { x: 256.402877697842, y: 3.17647058823529, size: 1 },
    //     { x: 257.05035971223, y: 3.84313725490196, size: 1 },
    //     { x: 257.697841726619, y: 3.49019607843137, size: 1 },
    //     { x: 258.345323741007, y: 3.56862745098039, size: 1 },
    //     { x: 260.287769784173, y: 3.6078431372549, size: 1 },
    //     { x: 261.58273381295, y: 3.76470588235294, size: 1 },
    //     { x: 270, y: 3.49019607843137, size: 1 },
    //     { x: 270.647482014389, y: 3.72549019607843, size: 1 },
    //     { x: 272.589928057554, y: 3.37254901960784, size: 1 },
    //     { x: 273.237410071942, y: 3.84313725490196, size: 1 },
    //     { x: 275.179856115108, y: 3.33333333333333, size: 1 },
    //     { x: 275.827338129496, y: 3.49019607843137, size: 1 },
    //     { x: 276.474820143885, y: 3.13725490196078, size: 1 },
    //     { x: 277.122302158273, y: 3.05882352941176, size: 1 },
    //     { x: 277.769784172662, y: 1.88235294117647, size: 1 },
    //     { x: 278.41726618705, y: 3.45098039215686, size: 1 },
    //     { x: 281.007194244604, y: 3.68627450980392, size: 1 },
    //     { x: 281.654676258993, y: 3.72549019607843, size: 1 },
    //     { x: 282.94964028777, y: 3.41176470588235, size: 1 },
    //     { x: 284.244604316547, y: 3.64705882352941, size: 1 },
    //     { x: 284.892086330935, y: 3.49019607843137, size: 1 },
    //     { x: 285.539568345324, y: 3.72549019607843, size: 1 },
    //     { x: 286.834532374101, y: 3.52941176470588, size: 1 },
    //     { x: 287.482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 288.776978417266, y: 3.72549019607843, size: 1 },
    //     { x: 289.424460431655, y: 3.52941176470588, size: 1 },
    //     { x: 290.071942446043, y: 3.45098039215686, size: 1 },
    //     { x: 292.661870503597, y: 3.72549019607843, size: 1 },
    //     { x: 293.309352517986, y: 3.56862745098039, size: 1 },
    //     { x: 293.956834532374, y: 3.64705882352941, size: 1 },
    //     { x: 295.251798561151, y: 3.76470588235294, size: 1 },
    //     { x: 296.546762589928, y: 3.49019607843137, size: 1 },
    //     { x: 297.194244604317, y: 3.52941176470588, size: 1 },
    //     { x: 297.841726618705, y: 3.52941176470588, size: 1 },
    //     { x: 298.489208633094, y: 3.41176470588235, size: 1 },
    //     { x: 299.136690647482, y: 3.29411764705882, size: 1 },
    //     { x: 310.143884892086, y: 3.37254901960784, size: 1 },
    //     { x: 312.086330935252, y: 3.88235294117647, size: 1 },
    //     { x: 312.73381294964, y: 3.45098039215686, size: 1 },
    //     { x: 314.028776978417, y: 3.72549019607843, size: 1 },
    //     { x: 314.676258992806, y: 3.68627450980392, size: 1 },
    //     { x: 315.323741007194, y: 3.80392156862745, size: 1 },
    //     { x: 315.971223021583, y: 3.41176470588235, size: 1 },
    //     { x: 319.208633093525, y: 3.72549019607843, size: 1 },
    //     { x: 320.503597122302, y: 3.01960784313725, size: 1 },
    //     { x: 321.151079136691, y: 3.09803921568627, size: 1 },
    //     { x: 323.093525179856, y: 3.84313725490196, size: 1 },
    //     { x: 323.741007194245, y: 3.45098039215686, size: 1 },
    //     { x: 324.388489208633, y: 3.6078431372549, size: 1 },
    //     { x: 325.68345323741, y: 3.64705882352941, size: 1 },
    //     { x: 326.330935251799, y: 3.64705882352941, size: 1 },
    //     { x: 326.978417266187, y: 3.52941176470588, size: 1 },
    //     { x: 328.273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 328.920863309353, y: 3.49019607843137, size: 1 },
    //     { x: 330.215827338129, y: 3.68627450980392, size: 1 },
    //     { x: 332.805755395683, y: 3.2156862745098, size: 1 },
    //     { x: 333.453237410072, y: 3.92156862745098, size: 1 },
    //     { x: 334.10071942446, y: 3.6078431372549, size: 1 },
    //     { x: 334.748201438849, y: 3.49019607843137, size: 1 },
    //     { x: 335.395683453237, y: 3.64705882352941, size: 1 },
    //     { x: 336.690647482014, y: 3.88235294117647, size: 1 },
    //     { x: 337.338129496403, y: 3.56862745098039, size: 1 },
    //     { x: 341.223021582734, y: 3.84313725490196, size: 1 },
    //     { x: 342.517985611511, y: 3.41176470588235, size: 1 },
    //     { x: 344.460431654676, y: 3.64705882352941, size: 1 },
    //     { x: 345.107913669065, y: 3.49019607843137, size: 1 },
    //     { x: 347.697841726619, y: 3.56862745098039, size: 1 },
    //     { x: 348.345323741007, y: 3.68627450980392, size: 1 },
    //     { x: 350.287769784173, y: 3.45098039215686, size: 1 },
    //     { x: 352.230215827338, y: 3.84313725490196, size: 1 },
    //     { x: 354.172661870504, y: 3.52941176470588, size: 1 },
    //     { x: 354.820143884892, y: 3.76470588235294, size: 1 },
    //     { x: 355.467625899281, y: 3.76470588235294, size: 1 },
    //     { x: 357.410071942446, y: 3.56862745098039, size: 1 },
    //     { x: 358.057553956835, y: 3.88235294117647, size: 1 },
    //     { x: 3.23741007194245, y: 3.05882352941176, size: 1 },
    //     { x: 3.88489208633094, y: 2.54901960784314, size: 1 },
    //     { x: 5.17985611510791, y: 3.49019607843137, size: 1 },
    //     { x: 8.41726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 9.71223021582734, y: 3.76470588235294, size: 1 },
    //     { x: 10.3597122302158, y: 3.72549019607843, size: 1 },
    //     { x: 11.0071942446043, y: 3.52941176470588, size: 1 },
    //     { x: 11.6546762589928, y: 3.52941176470588, size: 1 },
    //     { x: 12.9496402877698, y: 3.45098039215686, size: 1 },
    //     { x: 14.2446043165468, y: 3.76470588235294, size: 1 },
    //     { x: 18.1294964028777, y: 3.52941176470588, size: 1 },
    //     { x: 19.4244604316547, y: 3.76470588235294, size: 1 },
    //     { x: 24.6043165467626, y: 3.45098039215686, size: 1 },
    //     { x: 25.2517985611511, y: 3.41176470588235, size: 1 },
    //     { x: 26.5467625899281, y: 3.45098039215686, size: 1 },
    //     { x: 27.841726618705, y: 3.76470588235294, size: 1 },
    //     { x: 28.4892086330935, y: 3.84313725490196, size: 1 },
    //     { x: 29.136690647482, y: 3.64705882352941, size: 1 },
    //     { x: 30.431654676259, y: 3.68627450980392, size: 1 },
    //     { x: 33.0215827338129, y: 3.72549019607843, size: 1 },
    //     { x: 33.6690647482014, y: 3.52941176470588, size: 1 },
    //     { x: 34.3165467625899, y: 3.68627450980392, size: 1 },
    //     { x: 34.9640287769784, y: 3.72549019607843, size: 1 },
    //     { x: 36.2589928057554, y: 3.68627450980392, size: 1 },
    //     { x: 37.5539568345324, y: 3.56862745098039, size: 1 },
    //     { x: 38.8489208633094, y: 3.56862745098039, size: 1 },
    //     { x: 39.4964028776978, y: 3.88235294117647, size: 1 },
    //     { x: 42.0863309352518, y: 3.72549019607843, size: 1 },
    //     { x: 42.7338129496403, y: 3.92156862745098, size: 1 },
    //     { x: 43.3812949640288, y: 3.68627450980392, size: 1 },
    //     { x: 45.3237410071942, y: 3.25490196078431, size: 1 },
    //     { x: 45.9712230215827, y: 3.29411764705882, size: 1 },
    //     { x: 46.6187050359712, y: 2.70588235294118, size: 1 },
    //     { x: 47.2661870503597, y: 2.86274509803922, size: 1 },
    //     { x: 49.2086330935252, y: 3.6078431372549, size: 1 },
    //     { x: 49.8561151079137, y: 3.64705882352941, size: 1 },
    //     { x: 53.0935251798561, y: 3.33333333333333, size: 1 },
    //     { x: 55.0359712230216, y: 3.41176470588235, size: 1 },
    //     { x: 55.6834532374101, y: 3.33333333333333, size: 1 },
    //     { x: 56.9784172661871, y: 3.64705882352941, size: 1 },
    //     { x: 57.6258992805755, y: 3.41176470588235, size: 1 },
    //     { x: 59.568345323741, y: 3.56862745098039, size: 1 },
    //     { x: 61.5107913669065, y: 3.33333333333333, size: 1 },
    //     { x: 62.158273381295, y: 3.56862745098039, size: 1 },
    //     { x: 64.7482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 66.0431654676259, y: 3.56862745098039, size: 1 },
    //     { x: 67.3381294964029, y: 3.2156862745098, size: 1 },
    //     { x: 67.9856115107914, y: 3.01960784313725, size: 1 },
    //     { x: 68.6330935251799, y: 2.82352941176471, size: 1 },
    //     { x: 69.2805755395683, y: 3.49019607843137, size: 1 },
    //     { x: 69.9280575539568, y: 3.6078431372549, size: 1 },
    //     { x: 72.5179856115108, y: 3.84313725490196, size: 1 },
    //     { x: 76.4028776978417, y: 3.49019607843137, size: 1 },
    //     { x: 78.3453237410072, y: 3.80392156862745, size: 1 },
    //     { x: 79.6402877697842, y: 3.68627450980392, size: 1 },
    //     { x: 80.2877697841727, y: 3.72549019607843, size: 1 },
    //     { x: 82.8776978417266, y: 3.96078431372549, size: 1 },
    //     { x: 84.1726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 84.8201438848921, y: 3.56862745098039, size: 1 },
    //     { x: 86.1151079136691, y: 3.56862745098039, size: 1 },
    //     { x: 88.0575539568345, y: 4.03921568627451, size: 1 },
    //     { x: 89.3525179856115, y: 3.2156862745098, size: 1 },
    //     { x: 90, y: 2.58823529411765, size: 1 },
    //     { x: 90.6474820143885, y: 2.50980392156863, size: 1 },
    //     { x: 92.589928057554, y: 3.56862745098039, size: 1 },
    //     { x: 96.4748201438849, y: 3.52941176470588, size: 1 },
    //     { x: 98.4172661870504, y: 3.80392156862745, size: 1 },
    //     { x: 99.0647482014388, y: 3.80392156862745, size: 1 },
    //     { x: 99.7122302158273, y: 3.76470588235294, size: 1 },
    //     { x: 101.007194244604, y: 3.41176470588235, size: 1 },
    //     { x: 101.654676258993, y: 3.45098039215686, size: 1 },
    //     { x: 102.302158273381, y: 3.52941176470588, size: 1 },
    //     { x: 103.597122302158, y: 3.45098039215686, size: 1 },
    //     { x: 104.244604316547, y: 3.33333333333333, size: 1 },
    //     { x: 104.892086330935, y: 3.88235294117647, size: 1 },
    //     { x: 106.834532374101, y: 3.68627450980392, size: 1 },
    //     { x: 108.776978417266, y: 3.41176470588235, size: 1 },
    //     { x: 109.424460431655, y: 3.52941176470588, size: 1 },
    //     { x: 110.071942446043, y: 3.2156862745098, size: 1 },
    //     { x: 112.014388489209, y: 3.56862745098039, size: 1 },
    //     { x: 113.309352517986, y: 3.80392156862745, size: 1 },
    //     { x: 115.251798561151, y: 3.64705882352941, size: 1 },
    //     { x: 118.489208633094, y: 3.64705882352941, size: 1 },
    //     { x: 119.784172661871, y: 3.56862745098039, size: 1 },
    //     { x: 120.431654676259, y: 3.80392156862745, size: 1 },
    //     { x: 121.079136690647, y: 3.68627450980392, size: 1 },
    //     { x: 121.726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 123.021582733813, y: 3.76470588235294, size: 1 },
    //     { x: 124.964028776978, y: 3.52941176470588, size: 1 },
    //     { x: 126.906474820144, y: 3.80392156862745, size: 1 },
    //     { x: 127.553956834532, y: 3.76470588235294, size: 1 },
    //     { x: 128.201438848921, y: 3.45098039215686, size: 1 },
    //     { x: 129.496402877698, y: 3.76470588235294, size: 1 },
    //     { x: 130.143884892086, y: 3.72549019607843, size: 1 },
    //     { x: 130.791366906475, y: 3.88235294117647, size: 1 },
    //     { x: 132.73381294964, y: 3.6078431372549, size: 1 },
    //     { x: 133.381294964029, y: 3.37254901960784, size: 1 },
    //     { x: 136.618705035971, y: 3.41176470588235, size: 1 },
    //     { x: 137.913669064748, y: 3.64705882352941, size: 1 },
    //     { x: 138.561151079137, y: 3.64705882352941, size: 1 },
    //     { x: 140.503597122302, y: 3.29411764705882, size: 1 },
    //     { x: 141.151079136691, y: 3.64705882352941, size: 1 },
    //     { x: 143.741007194245, y: 3.49019607843137, size: 1 },
    //     { x: 145.68345323741, y: 3.45098039215686, size: 1 },
    //     { x: 146.978417266187, y: 3.92156862745098, size: 1 },
    //     { x: 148.273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 150.863309352518, y: 3.45098039215686, size: 1 },
    //     { x: 152.158273381295, y: 3.72549019607843, size: 1 },
    //     { x: 153.453237410072, y: 3.41176470588235, size: 1 },
    //     { x: 154.10071942446, y: 3.09803921568627, size: 1 },
    //     { x: 154.748201438849, y: 2.98039215686275, size: 1 },
    //     { x: 155.395683453237, y: 3.17647058823529, size: 1 },
    //     { x: 156.043165467626, y: 3.88235294117647, size: 1 },
    //     { x: 157.985611510791, y: 3.88235294117647, size: 1 },
    //     { x: 161.223021582734, y: 3.6078431372549, size: 1 },
    //     { x: 163.812949640288, y: 3.92156862745098, size: 1 },
    //     { x: 164.460431654676, y: 3.76470588235294, size: 1 },
    //     { x: 165.107913669065, y: 3.92156862745098, size: 1 },
    //     { x: 166.402877697842, y: 3.56862745098039, size: 1 },
    //     { x: 167.05035971223, y: 3.84313725490196, size: 1 },
    //     { x: 167.697841726619, y: 3.72549019607843, size: 1 },
    //     { x: 168.992805755396, y: 3.76470588235294, size: 1 },
    //     { x: 171.58273381295, y: 3.45098039215686, size: 1 },
    //     { x: 172.230215827338, y: 3.45098039215686, size: 1 },
    //     { x: 174.172661870504, y: 3.29411764705882, size: 1 },
    //     { x: 175.467625899281, y: 3.13725490196078, size: 1 },
    //     { x: 176.115107913669, y: 3.01960784313725, size: 1 },
    //     { x: 176.762589928058, y: 2.98039215686275, size: 1 },
    //     { x: 177.410071942446, y: 3.96078431372549, size: 1 },
    //     { x: 180, y: 3.72549019607843, size: 1 },
    //     { x: 183.237410071942, y: 3.72549019607843, size: 1 },
    //     { x: 185.179856115108, y: 3.56862745098039, size: 1 },
    //     { x: 185.827338129496, y: 3.49019607843137, size: 1 },
    //     { x: 187.769784172662, y: 3.68627450980392, size: 1 },
    //     { x: 189.064748201439, y: 3.80392156862745, size: 1 },
    //     { x: 189.712230215827, y: 3.88235294117647, size: 1 },
    //     { x: 190.359712230216, y: 3.56862745098039, size: 1 },
    //     { x: 192.302158273381, y: 3.52941176470588, size: 1 },
    //     { x: 192.94964028777, y: 3.64705882352941, size: 1 },
    //     { x: 198.129496402878, y: 3.33333333333333, size: 1 },
    //     { x: 198.776978417266, y: 3.52941176470588, size: 1 },
    //     { x: 199.424460431655, y: 3.6078431372549, size: 1 },
    //     { x: 200.071942446043, y: 3.64705882352941, size: 1 },
    //     { x: 205.251798561151, y: 3.68627450980392, size: 1 },
    //     { x: 207.841726618705, y: 3.72549019607843, size: 1 },
    //     { x: 209.784172661871, y: 3.72549019607843, size: 1 },
    //     { x: 213.021582733813, y: 3.52941176470588, size: 1 },
    //     { x: 213.669064748201, y: 3.76470588235294, size: 1 },
    //     { x: 214.31654676259, y: 3.76470588235294, size: 1 },
    //     { x: 216.258992805755, y: 3.84313725490196, size: 1 },
    //     { x: 218.201438848921, y: 3.52941176470588, size: 1 },
    //     { x: 220.143884892086, y: 3.80392156862745, size: 1 },
    //     { x: 221.438848920863, y: 3.41176470588235, size: 1 },
    //     { x: 223.381294964029, y: 3.80392156862745, size: 1 },
    //     { x: 224.676258992806, y: 3.6078431372549, size: 1 },
    //     { x: 225.971223021583, y: 3.52941176470588, size: 1 },
    //     { x: 228.561151079137, y: 3.56862745098039, size: 1 },
    //     { x: 229.208633093525, y: 3.80392156862745, size: 1 },
    //     { x: 230.503597122302, y: 3.52941176470588, size: 1 },
    //     { x: 231.151079136691, y: 3.52941176470588, size: 1 },
    //     { x: 233.741007194245, y: 3.33333333333333, size: 1 },
    //     { x: 234.388489208633, y: 3.49019607843137, size: 1 },
    //     { x: 235.035971223022, y: 3.45098039215686, size: 1 },
    //     { x: 235.68345323741, y: 3.56862745098039, size: 1 },
    //     { x: 236.330935251799, y: 3.41176470588235, size: 1 },
    //     { x: 236.978417266187, y: 3.52941176470588, size: 1 },
    //     { x: 243.453237410072, y: 3.56862745098039, size: 1 },
    //     { x: 247.338129496403, y: 3.37254901960784, size: 1 },
    //     { x: 248.63309352518, y: 3.6078431372549, size: 1 },
    //     { x: 249.280575539568, y: 3.41176470588235, size: 1 },
    //     { x: 249.928057553957, y: 3.6078431372549, size: 1 },
    //     { x: 250.575539568345, y: 3.84313725490196, size: 1 },
    //     { x: 251.223021582734, y: 3.52941176470588, size: 1 },
    //     { x: 253.165467625899, y: 3.45098039215686, size: 1 },
    //     { x: 255.755395683453, y: 3.37254901960784, size: 1 },
    //     { x: 258.345323741007, y: 3.41176470588235, size: 1 },
    //     { x: 258.992805755396, y: 3.41176470588235, size: 1 },
    //     { x: 259.640287769784, y: 3.37254901960784, size: 1 },
    //     { x: 260.935251798561, y: 3.33333333333333, size: 1 },
    //     { x: 261.58273381295, y: 3.37254901960784, size: 1 },
    //     { x: 262.230215827338, y: 3.41176470588235, size: 1 },
    //     { x: 262.877697841727, y: 3.13725490196078, size: 1 },
    //     { x: 263.525179856115, y: 3.52941176470588, size: 1 },
    //     { x: 264.172661870504, y: 3.37254901960784, size: 1 },
    //     { x: 264.820143884892, y: 3.41176470588235, size: 1 },
    //     { x: 265.467625899281, y: 3.45098039215686, size: 1 },
    //     { x: 270.647482014389, y: 3.68627450980392, size: 1 },
    //     { x: 272.589928057554, y: 3.52941176470588, size: 1 },
    //     { x: 274.532374100719, y: 3.80392156862745, size: 1 },
    //     { x: 275.179856115108, y: 3.56862745098039, size: 1 },
    //     { x: 276.474820143885, y: 3.72549019607843, size: 1 },
    //     { x: 277.122302158273, y: 3.76470588235294, size: 1 },
    //     { x: 277.769784172662, y: 3.6078431372549, size: 1 },
    //     { x: 278.41726618705, y: 3.41176470588235, size: 1 },
    //     { x: 280.359712230216, y: 3.68627450980392, size: 1 },
    //     { x: 281.007194244604, y: 3.72549019607843, size: 1 },
    //     { x: 282.302158273381, y: 3.45098039215686, size: 1 },
    //     { x: 282.94964028777, y: 3.68627450980392, size: 1 },
    //     { x: 283.597122302158, y: 3.56862745098039, size: 1 },
    //     { x: 284.244604316547, y: 3.25490196078431, size: 1 },
    //     { x: 284.892086330935, y: 3.13725490196078, size: 1 },
    //     { x: 288.129496402878, y: 3.6078431372549, size: 1 },
    //     { x: 288.776978417266, y: 3.84313725490196, size: 1 },
    //     { x: 294.604316546763, y: 3.68627450980392, size: 1 },
    //     { x: 295.89928057554, y: 3.52941176470588, size: 1 },
    //     { x: 298.489208633094, y: 3.56862745098039, size: 1 },
    //     { x: 299.784172661871, y: 4, size: 1 },
    //     { x: 300.431654676259, y: 3.80392156862745, size: 1 },
    //     { x: 301.079136690647, y: 3.68627450980392, size: 1 },
    //     { x: 301.726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 302.374100719424, y: 3.68627450980392, size: 1 },
    //     { x: 303.021582733813, y: 3.64705882352941, size: 1 },
    //     { x: 304.31654676259, y: 3.37254901960784, size: 1 },
    //     { x: 304.964028776978, y: 3.17647058823529, size: 1 },
    //     { x: 305.611510791367, y: 2.23529411764706, size: 1 },
    //     { x: 306.258992805755, y: 1.92156862745098, size: 1 },
    //     { x: 306.906474820144, y: 3.37254901960784, size: 1 },
    //     { x: 308.201438848921, y: 3.2156862745098, size: 1 },
    //     { x: 308.848920863309, y: 3.33333333333333, size: 1 },
    //     { x: 309.496402877698, y: 3.41176470588235, size: 1 },
    //     { x: 310.143884892086, y: 3.41176470588235, size: 1 },
    //     { x: 312.086330935252, y: 3.37254901960784, size: 1 },
    //     { x: 313.381294964029, y: 3.29411764705882, size: 1 },
    //     { x: 314.028776978417, y: 3.56862745098039, size: 1 },
    //     { x: 314.676258992806, y: 3.52941176470588, size: 1 },
    //     { x: 315.323741007194, y: 3.41176470588235, size: 1 },
    //     { x: 316.618705035971, y: 3.29411764705882, size: 1 },
    //     { x: 317.26618705036, y: 3.6078431372549, size: 1 },
    //     { x: 317.913669064748, y: 3.37254901960784, size: 1 },
    //     { x: 318.561151079137, y: 3.2156862745098, size: 1 },
    //     { x: 319.856115107914, y: 3.41176470588235, size: 1 },
    //     { x: 320.503597122302, y: 3.6078431372549, size: 1 },
    //     { x: 321.151079136691, y: 3.6078431372549, size: 1 },
    //     { x: 321.798561151079, y: 3.41176470588235, size: 1 },
    //     { x: 322.446043165468, y: 3.37254901960784, size: 1 },
    //     { x: 323.093525179856, y: 3.6078431372549, size: 1 },
    //     { x: 323.741007194245, y: 3.2156862745098, size: 1 },
    //     { x: 325.68345323741, y: 3.09803921568627, size: 1 },
    //     { x: 326.330935251799, y: 3.17647058823529, size: 1 },
    //     { x: 326.978417266187, y: 2.98039215686275, size: 1 },
    //     { x: 327.625899280576, y: 2.11764705882353, size: 1 },
    //     { x: 328.273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 328.920863309353, y: 3.6078431372549, size: 1 },
    //     { x: 330.215827338129, y: 3.49019607843137, size: 1 },
    //     { x: 330.863309352518, y: 3.6078431372549, size: 1 },
    //     { x: 332.158273381295, y: 3.45098039215686, size: 1 },
    //     { x: 332.805755395683, y: 3.56862745098039, size: 1 },
    //     { x: 335.395683453237, y: 3.56862745098039, size: 1 },
    //     { x: 336.043165467626, y: 3.64705882352941, size: 1 },
    //     { x: 337.985611510791, y: 3.52941176470588, size: 1 },
    //     { x: 338.63309352518, y: 3.37254901960784, size: 1 },
    //     { x: 339.280575539568, y: 3.56862745098039, size: 1 },
    //     { x: 340.575539568345, y: 3.41176470588235, size: 1 },
    //     { x: 341.223021582734, y: 3.6078431372549, size: 1 },
    //     { x: 341.870503597122, y: 3.33333333333333, size: 1 },
    //     { x: 344.460431654676, y: 3.6078431372549, size: 1 },
    //     { x: 346.402877697842, y: 3.41176470588235, size: 1 },
    //     { x: 347.05035971223, y: 3.33333333333333, size: 1 },
    //     { x: 348.345323741007, y: 3.37254901960784, size: 1 },
    //     { x: 348.992805755396, y: 3.09803921568627, size: 1 },
    //     { x: 349.640287769784, y: 3.01960784313725, size: 1 },
    //     { x: 350.287769784173, y: 3.68627450980392, size: 1 },
    //     { x: 350.935251798561, y: 3.72549019607843, size: 1 },
    //     { x: 353.525179856115, y: 3.6078431372549, size: 1 },
    //     { x: 354.172661870504, y: 3.76470588235294, size: 1 },
    //     { x: 355.467625899281, y: 3.68627450980392, size: 1 },
    //     { x: 356.115107913669, y: 3.52941176470588, size: 1 },
    //     { x: 356.762589928058, y: 3.45098039215686, size: 1 },
    //     { x: 357.410071942446, y: 3.45098039215686, size: 1 },
    //     { x: 358.057553956835, y: 3.49019607843137, size: 1 },
    //     { x: 358.705035971223, y: 3.41176470588235, size: 1 },
    //     { x: 1.29496402877698, y: 3.45098039215686, size: 1 },
    //     { x: 1.94244604316547, y: 3.84313725490196, size: 1 },
    //     { x: 3.23741007194245, y: 3.52941176470588, size: 1 },
    //     { x: 3.88489208633094, y: 3.6078431372549, size: 1 },
    //     { x: 8.41726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 9.71223021582734, y: 3.17647058823529, size: 1 },
    //     { x: 10.3597122302158, y: 2.66666666666667, size: 1 },
    //     { x: 11.0071942446043, y: 1.92156862745098, size: 1 },
    //     { x: 11.6546762589928, y: 3.76470588235294, size: 1 },
    //     { x: 14.2446043165468, y: 3.45098039215686, size: 1 },
    //     { x: 16.8345323741007, y: 3.49019607843137, size: 1 },
    //     { x: 18.7769784172662, y: 3.68627450980392, size: 1 },
    //     { x: 20.0719424460432, y: 3.80392156862745, size: 1 },
    //     { x: 22.6618705035971, y: 3.88235294117647, size: 1 },
    //     { x: 23.3093525179856, y: 3.80392156862745, size: 1 },
    //     { x: 23.9568345323741, y: 3.84313725490196, size: 1 },
    //     { x: 25.2517985611511, y: 3.84313725490196, size: 1 },
    //     { x: 28.4892086330935, y: 3.56862745098039, size: 1 },
    //     { x: 30.431654676259, y: 3.05882352941176, size: 1 },
    //     { x: 31.0791366906475, y: 2.98039215686275, size: 1 },
    //     { x: 31.726618705036, y: 2.90196078431373, size: 1 },
    //     { x: 32.3741007194245, y: 1.88235294117647, size: 1 },
    //     { x: 33.6690647482014, y: 3.72549019607843, size: 1 },
    //     { x: 34.3165467625899, y: 3.52941176470588, size: 1 },
    //     { x: 36.2589928057554, y: 3.56862745098039, size: 1 },
    //     { x: 37.5539568345324, y: 3.84313725490196, size: 1 },
    //     { x: 40.1438848920863, y: 3.56862745098039, size: 1 },
    //     { x: 41.4388489208633, y: 3.64705882352941, size: 1 },
    //     { x: 42.0863309352518, y: 3.80392156862745, size: 1 },
    //     { x: 42.7338129496403, y: 3.80392156862745, size: 1 },
    //     { x: 44.6762589928058, y: 3.45098039215686, size: 1 },
    //     { x: 48.5611510791367, y: 3.64705882352941, size: 1 },
    //     { x: 49.2086330935252, y: 3.49019607843137, size: 1 },
    //     { x: 49.8561151079137, y: 3.6078431372549, size: 1 },
    //     { x: 51.7985611510791, y: 3.33333333333333, size: 1 },
    //     { x: 52.4460431654676, y: 3.13725490196078, size: 1 },
    //     { x: 53.0935251798561, y: 3.2156862745098, size: 1 },
    //     { x: 53.7410071942446, y: 2.7843137254902, size: 1 },
    //     { x: 54.3884892086331, y: 2.70588235294118, size: 1 },
    //     { x: 55.6834532374101, y: 3.84313725490196, size: 1 },
    //     { x: 59.568345323741, y: 3.6078431372549, size: 1 },
    //     { x: 60.2158273381295, y: 3.6078431372549, size: 1 },
    //     { x: 62.158273381295, y: 3.52941176470588, size: 1 },
    //     { x: 62.8057553956835, y: 3.45098039215686, size: 1 },
    //     { x: 65.3956834532374, y: 3.45098039215686, size: 1 },
    //     { x: 66.6906474820144, y: 3.64705882352941, size: 1 },
    //     { x: 67.3381294964029, y: 3.49019607843137, size: 1 },
    //     { x: 67.9856115107914, y: 3.56862745098039, size: 1 },
    //     { x: 68.6330935251799, y: 3.6078431372549, size: 1 },
    //     { x: 69.2805755395683, y: 3.56862745098039, size: 1 },
    //     { x: 71.8705035971223, y: 3.68627450980392, size: 1 },
    //     { x: 73.1654676258993, y: 3.49019607843137, size: 1 },
    //     { x: 75.1079136690647, y: 3.33333333333333, size: 1 },
    //     { x: 77.6978417266187, y: 3.52941176470588, size: 1 },
    //     { x: 80.9352517985612, y: 3.72549019607843, size: 1 },
    //     { x: 86.7625899280576, y: 3.56862745098039, size: 1 },
    //     { x: 87.410071942446, y: 3.6078431372549, size: 1 },
    //     { x: 88.0575539568345, y: 3.72549019607843, size: 1 },
    //     { x: 89.3525179856115, y: 3.68627450980392, size: 1 },
    //     { x: 90, y: 3.64705882352941, size: 1 },
    //     { x: 92.589928057554, y: 3.52941176470588, size: 1 },
    //     { x: 93.2374100719424, y: 3.76470588235294, size: 1 },
    //     { x: 95.1798561151079, y: 3.64705882352941, size: 1 },
    //     { x: 95.8273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 97.1223021582734, y: 3.64705882352941, size: 1 },
    //     { x: 100.359712230216, y: 3.84313725490196, size: 1 },
    //     { x: 101.007194244604, y: 3.64705882352941, size: 1 },
    //     { x: 102.94964028777, y: 3.68627450980392, size: 1 },
    //     { x: 103.597122302158, y: 3.64705882352941, size: 1 },
    //     { x: 104.244604316547, y: 3.80392156862745, size: 1 },
    //     { x: 106.834532374101, y: 3.84313725490196, size: 1 },
    //     { x: 107.482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 110.719424460432, y: 3.80392156862745, size: 1 },
    //     { x: 111.36690647482, y: 3.76470588235294, size: 1 },
    //     { x: 112.014388489209, y: 3.6078431372549, size: 1 },
    //     { x: 112.661870503597, y: 3.80392156862745, size: 1 },
    //     { x: 113.309352517986, y: 3.6078431372549, size: 1 },
    //     { x: 113.956834532374, y: 3.68627450980392, size: 1 },
    //     { x: 114.604316546763, y: 3.84313725490196, size: 1 },
    //     { x: 115.251798561151, y: 3.56862745098039, size: 1 },
    //     { x: 117.194244604317, y: 3.09803921568627, size: 1 },
    //     { x: 117.841726618705, y: 3.41176470588235, size: 1 },
    //     { x: 119.136690647482, y: 3.52941176470588, size: 1 },
    //     { x: 119.784172661871, y: 3.84313725490196, size: 1 },
    //     { x: 121.079136690647, y: 3.80392156862745, size: 1 },
    //     { x: 123.021582733813, y: 3.72549019607843, size: 1 },
    //     { x: 126.906474820144, y: 3.68627450980392, size: 1 },
    //     { x: 130.143884892086, y: 3.80392156862745, size: 1 },
    //     { x: 134.028776978417, y: 3.64705882352941, size: 1 },
    //     { x: 134.676258992806, y: 3.52941176470588, size: 1 },
    //     { x: 138.561151079137, y: 3.17647058823529, size: 1 },
    //     { x: 139.208633093525, y: 3.09803921568627, size: 1 },
    //     { x: 139.856115107914, y: 3.49019607843137, size: 1 },
    //     { x: 143.093525179856, y: 3.45098039215686, size: 1 },
    //     { x: 147.625899280576, y: 3.49019607843137, size: 1 },
    //     { x: 148.273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 148.920863309353, y: 3.64705882352941, size: 1 },
    //     { x: 151.510791366906, y: 3.41176470588235, size: 1 },
    //     { x: 152.805755395683, y: 3.76470588235294, size: 1 },
    //     { x: 154.10071942446, y: 3.64705882352941, size: 1 },
    //     { x: 156.690647482014, y: 3.84313725490196, size: 1 },
    //     { x: 157.985611510791, y: 3.68627450980392, size: 1 },
    //     { x: 159.280575539568, y: 3.49019607843137, size: 1 },
    //     { x: 159.928057553957, y: 3.45098039215686, size: 1 },
    //     { x: 160.575539568345, y: 3.17647058823529, size: 1 },
    //     { x: 161.870503597122, y: 3.64705882352941, size: 1 },
    //     { x: 167.05035971223, y: 3.52941176470588, size: 1 },
    //     { x: 168.345323741007, y: 3.56862745098039, size: 1 },
    //     { x: 169.640287769784, y: 3.52941176470588, size: 1 },
    //     { x: 171.58273381295, y: 3.6078431372549, size: 1 },
    //     { x: 174.172661870504, y: 3.92156862745098, size: 1 },
    //     { x: 176.762589928058, y: 3.6078431372549, size: 1 },
    //     { x: 178.057553956835, y: 3.68627450980392, size: 1 },
    //     { x: 179.352517985612, y: 3.72549019607843, size: 1 },
    //     { x: 181.294964028777, y: 3.41176470588235, size: 1 },
    //     { x: 183.884892086331, y: 3.80392156862745, size: 1 },
    //     { x: 185.179856115108, y: 3.88235294117647, size: 1 },
    //     { x: 189.064748201439, y: 3.72549019607843, size: 1 },
    //     { x: 190.359712230216, y: 3.76470588235294, size: 1 },
    //     { x: 194.244604316547, y: 3.76470588235294, size: 1 },
    //     { x: 195.539568345324, y: 3.52941176470588, size: 1 },
    //     { x: 196.187050359712, y: 3.56862745098039, size: 1 },
    //     { x: 196.834532374101, y: 3.52941176470588, size: 1 },
    //     { x: 197.482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 198.129496402878, y: 3.76470588235294, size: 1 },
    //     { x: 198.776978417266, y: 3.72549019607843, size: 1 },
    //     { x: 200.719424460432, y: 3.80392156862745, size: 1 },
    //     { x: 202.014388489209, y: 3.64705882352941, size: 1 },
    //     { x: 202.661870503597, y: 3.56862745098039, size: 1 },
    //     { x: 203.309352517986, y: 3.45098039215686, size: 1 },
    //     { x: 204.604316546763, y: 3.84313725490196, size: 1 },
    //     { x: 205.89928057554, y: 3.76470588235294, size: 1 },
    //     { x: 206.546762589928, y: 3.84313725490196, size: 1 },
    //     { x: 207.194244604317, y: 3.68627450980392, size: 1 },
    //     { x: 207.841726618705, y: 3.68627450980392, size: 1 },
    //     { x: 209.784172661871, y: 3.64705882352941, size: 1 },
    //     { x: 211.079136690647, y: 3.80392156862745, size: 1 },
    //     { x: 211.726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 212.374100719424, y: 3.92156862745098, size: 1 },
    //     { x: 213.021582733813, y: 3.88235294117647, size: 1 },
    //     { x: 214.964028776978, y: 3.88235294117647, size: 1 },
    //     { x: 216.906474820144, y: 3.84313725490196, size: 1 },
    //     { x: 218.848920863309, y: 3.84313725490196, size: 1 },
    //     { x: 221.438848920863, y: 3.84313725490196, size: 1 },
    //     { x: 223.381294964029, y: 3.88235294117647, size: 1 },
    //     { x: 224.028776978417, y: 3.6078431372549, size: 1 },
    //     { x: 224.676258992806, y: 3.25490196078431, size: 1 },
    //     { x: 225.323741007194, y: 3.05882352941176, size: 1 },
    //     { x: 227.913669064748, y: 3.88235294117647, size: 1 },
    //     { x: 232.446043165468, y: 3.56862745098039, size: 1 },
    //     { x: 233.093525179856, y: 3.92156862745098, size: 1 },
    //     { x: 235.035971223022, y: 3.56862745098039, size: 1 },
    //     { x: 236.330935251799, y: 3.80392156862745, size: 1 },
    //     { x: 237.625899280576, y: 3.88235294117647, size: 1 },
    //     { x: 240.863309352518, y: 3.92156862745098, size: 1 },
    //     { x: 242.158273381295, y: 3.64705882352941, size: 1 },
    //     { x: 242.805755395683, y: 3.76470588235294, size: 1 },
    //     { x: 244.10071942446, y: 3.76470588235294, size: 1 },
    //     { x: 247.338129496403, y: 3.76470588235294, size: 1 },
    //     { x: 249.280575539568, y: 3.49019607843137, size: 1 },
    //     { x: 250.575539568345, y: 3.88235294117647, size: 1 },
    //     { x: 251.223021582734, y: 4, size: 1 },
    //     { x: 251.870503597122, y: 3.56862745098039, size: 1 },
    //     { x: 253.812949640288, y: 3.68627450980392, size: 1 },
    //     { x: 254.460431654676, y: 3.72549019607843, size: 1 },
    //     { x: 256.402877697842, y: 3.6078431372549, size: 1 },
    //     { x: 257.05035971223, y: 3.88235294117647, size: 1 },
    //     { x: 260.935251798561, y: 3.45098039215686, size: 1 },
    //     { x: 261.58273381295, y: 3.68627450980392, size: 1 },
    //     { x: 263.525179856115, y: 3.68627450980392, size: 1 },
    //     { x: 264.820143884892, y: 3.72549019607843, size: 1 },
    //     { x: 266.762589928058, y: 3.52941176470588, size: 1 },
    //     { x: 267.410071942446, y: 3.64705882352941, size: 1 },
    //     { x: 268.057553956835, y: 3.49019607843137, size: 1 },
    //     { x: 270.647482014389, y: 3.37254901960784, size: 1 },
    //     { x: 271.294964028777, y: 3.6078431372549, size: 1 },
    //     { x: 272.589928057554, y: 3.92156862745098, size: 1 },
    //     { x: 273.237410071942, y: 3.68627450980392, size: 1 },
    //     { x: 273.884892086331, y: 3.45098039215686, size: 1 },
    //     { x: 275.179856115108, y: 3.92156862745098, size: 1 },
    //     { x: 276.474820143885, y: 3.45098039215686, size: 1 },
    //     { x: 278.41726618705, y: 3.68627450980392, size: 1 },
    //     { x: 284.892086330935, y: 3.76470588235294, size: 1 },
    //     { x: 285.539568345324, y: 3.6078431372549, size: 1 },
    //     { x: 286.834532374101, y: 3.80392156862745, size: 1 },
    //     { x: 289.424460431655, y: 3.76470588235294, size: 1 },
    //     { x: 290.719424460432, y: 3.41176470588235, size: 1 },
    //     { x: 291.36690647482, y: 3.33333333333333, size: 1 },
    //     { x: 293.309352517986, y: 3.49019607843137, size: 1 },
    //     { x: 294.604316546763, y: 3.49019607843137, size: 1 },
    //     { x: 295.89928057554, y: 3.6078431372549, size: 1 },
    //     { x: 299.136690647482, y: 3.64705882352941, size: 1 },
    //     { x: 301.726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 302.374100719424, y: 3.84313725490196, size: 1 },
    //     { x: 303.021582733813, y: 3.88235294117647, size: 1 },
    //     { x: 303.669064748201, y: 3.52941176470588, size: 1 },
    //     { x: 305.611510791367, y: 3.68627450980392, size: 1 },
    //     { x: 308.848920863309, y: 3.56862745098039, size: 1 },
    //     { x: 309.496402877698, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.45098039215686, size: 1 },
    //     { x: 312.73381294964, y: 2.94117647058824, size: 1 },
    //     { x: 315.323741007194, y: 3.72549019607843, size: 1 },
    //     { x: 315.971223021583, y: 3.6078431372549, size: 1 },
    //     { x: 317.913669064748, y: 3.56862745098039, size: 1 },
    //     { x: 319.208633093525, y: 3.80392156862745, size: 1 },
    //     { x: 322.446043165468, y: 3.56862745098039, size: 1 },
    //     { x: 325.68345323741, y: 3.6078431372549, size: 1 },
    //     { x: 326.330935251799, y: 3.92156862745098, size: 1 },
    //     { x: 327.625899280576, y: 3.80392156862745, size: 1 },
    //     { x: 328.920863309353, y: 3.72549019607843, size: 1 },
    //     { x: 330.215827338129, y: 3.72549019607843, size: 1 },
    //     { x: 332.805755395683, y: 3.41176470588235, size: 1 },
    //     { x: 334.10071942446, y: 2.90196078431373, size: 1 },
    //     { x: 335.395683453237, y: 3.01960784313725, size: 1 },
    //     { x: 336.043165467626, y: 3.25490196078431, size: 1 },
    //     { x: 336.690647482014, y: 3.33333333333333, size: 1 },
    //     { x: 338.63309352518, y: 3.52941176470588, size: 1 },
    //     { x: 339.928057553957, y: 3.37254901960784, size: 1 },
    //     { x: 340.575539568345, y: 3.6078431372549, size: 1 },
    //     { x: 344.460431654676, y: 3.41176470588235, size: 1 },
    //     { x: 345.107913669065, y: 3.25490196078431, size: 1 },
    //     { x: 345.755395683453, y: 3.45098039215686, size: 1 },
    //     { x: 347.697841726619, y: 3.37254901960784, size: 1 },
    //     { x: 348.992805755396, y: 3.45098039215686, size: 1 },
    //     { x: 351.58273381295, y: 3.41176470588235, size: 1 },
    //     { x: 352.877697841727, y: 3.52941176470588, size: 1 },
    //     { x: 353.525179856115, y: 3.41176470588235, size: 1 },
    //     { x: 354.172661870504, y: 3.33333333333333, size: 1 },
    //     { x: 354.820143884892, y: 3.29411764705882, size: 1 },
    //     { x: 355.467625899281, y: 3.05882352941176, size: 1 },
    //     { x: 356.115107913669, y: 2.86274509803922, size: 1 },
    //     { x: 356.762589928058, y: 2.98039215686275, size: 1 },
    //     { x: 357.410071942446, y: 3.17647058823529, size: 1 },
    //     { x: 0.648648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 1.94594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 2.59459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 3.89189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 4.54054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 5.83783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 6.48648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 7.13513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 7.78378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 8.43243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 9.08108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 9.72972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 10.3783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 11.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 11.6756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 12.3243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 13.6216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 14.2702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 14.9189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 15.5675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 16.2162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 16.8648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 17.5135135135135, y: 2.82352941176471, size: 1 },
    //     { x: 18.1621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 18.8108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 19.4594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 20.7567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 21.4054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 23.3513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 24.6486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 25.2972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 25.9459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 26.5945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 27.8918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 28.5405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 29.1891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 30.4864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 31.1351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 31.7837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 33.0810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 33.7297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 34.3783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 35.6756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 36.3243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 36.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 37.6216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 38.2702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 38.9189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 39.5675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 40.2162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 40.8648648648649, y: 2.82352941176471, size: 1 },
    //     { x: 41.5135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 42.1621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 42.8108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 43.4594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 44.7567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 45.4054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 46.0540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 46.7027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 47.3513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 48, y: 3.64705882352941, size: 1 },
    //     { x: 48.6486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 49.2972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 49.9459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 50.5945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 51.8918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 53.1891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 53.8378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 54.4864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 55.1351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 56.4324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 57.0810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 57.7297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 58.3783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 59.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 59.6756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 60.3243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 60.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 61.6216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 62.2702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 63.5675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 64.2162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 64.8648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 65.5135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 66.1621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 66.8108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 68.7567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 69.4054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 70.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 70.7027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 71.3513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 72, y: 3.80392156862745, size: 1 },
    //     { x: 72.6486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 73.2972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 73.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 75.2432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 75.8918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 76.5405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 78.4864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 79.1351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 79.7837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 80.4324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 81.0810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 81.7297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 82.3783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 83.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 83.6756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 84.3243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 84.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 85.6216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 86.9189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 87.5675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 88.2162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 88.8648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 89.5135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 90.1621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 90.8108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 91.4594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 92.1081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 92.7567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 93.4054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 94.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 94.7027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 95.3513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 96, y: 3.49019607843137, size: 1 },
    //     { x: 96.6486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 97.2972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 97.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 98.5945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 99.2432432432432, y: 4, size: 1 },
    //     { x: 99.8918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 100.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 101.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 101.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 102.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 103.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 103.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 104.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 105.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 105.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 106.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 107.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 107.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 108.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 109.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 110.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 110.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 111.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 112.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 113.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 114.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 114.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 115.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 116.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 116.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 118.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 119.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 120, y: 3.6078431372549, size: 1 },
    //     { x: 120.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 121.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 121.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 122.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 123.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 124.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 125.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 125.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 126.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 127.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 127.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 128.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 129.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 129.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 130.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 131.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 131.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 132.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 132.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 133.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 134.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 135.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 136.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 137.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 138.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 138.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 139.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 141.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 142.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 143.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 144, y: 3.56862745098039, size: 1 },
    //     { x: 144.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 145.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 146.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 147.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 147.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 148.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 149.189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 149.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 150.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 151.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 151.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 152.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 153.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 153.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 154.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 155.027027027027, y: 4.07843137254902, size: 1 },
    //     { x: 155.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 156.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 156.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 157.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 158.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 159.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 161.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 162.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 162.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 163.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 164.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 164.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 167.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 168, y: 3.17647058823529, size: 1 },
    //     { x: 168.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 169.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 169.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 170.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 171.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 172.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 173.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 175.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 175.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 176.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 177.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 177.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 178.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 179.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 179.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 180.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 180.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 182.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 182.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 183.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 184.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 184.864864864865, y: 4, size: 1 },
    //     { x: 186.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 186.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 188.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 188.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 189.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 190.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 190.702702702703, y: 2.7843137254902, size: 1 },
    //     { x: 191.351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 192, y: 3.37254901960784, size: 1 },
    //     { x: 192.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 193.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 193.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 194.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 195.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 195.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 196.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 197.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 197.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 200.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 201.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 201.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 202.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 203.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 203.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 204.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 205.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 206.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 206.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 207.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 208.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 210.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 210.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 211.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 212.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 213.405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 214.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 214.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 216, y: 3.80392156862745, size: 1 },
    //     { x: 216.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 217.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 218.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 219.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 219.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 220.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 221.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 221.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 222.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 223.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 224.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 225.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 225.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 226.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 227.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 227.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 228.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 229.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 230.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 230.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 231.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 232.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 232.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 233.513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 234.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 234.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 236.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 236.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 237.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 238.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 238.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 240, y: 3.64705882352941, size: 1 },
    //     { x: 240.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 241.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 241.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 242.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 243.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 244.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 245.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 245.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 246.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 247.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 247.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 248.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 249.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 249.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 250.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 251.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 251.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 252.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 253.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 254.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 254.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 255.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 256.216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 256.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 257.513513513513, y: 3.13725490196078, size: 1 },
    //     { x: 258.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 259.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 260.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 260.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 262.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 262.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 263.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 264.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 265.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 265.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 266.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 267.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 268.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 269.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 269.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 271.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 272.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 273.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 274.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 275.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 276.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 276.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 278.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 278.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 279.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 280.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 280.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 281.513513513513, y: 3.68627450980392, size: 1 },
    //     { x: 282.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 282.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 283.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 284.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 284.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 285.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 286.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 286.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 287.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 288.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 289.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 289.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 291.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 291.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 292.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 293.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 293.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 294.486486486487, y: 3.68627450980392, size: 1 },
    //     { x: 295.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 296.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 297.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 298.378378378378, y: 2.94117647058824, size: 1 },
    //     { x: 299.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 299.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 300.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 300.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 301.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 302.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 303.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 304.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 304.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 305.513513513513, y: 3.76470588235294, size: 1 },
    //     { x: 306.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 306.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 307.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 308.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 309.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 310.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 310.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 311.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 312, y: 3.76470588235294, size: 1 },
    //     { x: 312.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 313.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 313.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 314.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 315.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 315.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 316.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 319.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 319.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 320.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 321.72972972973, y: 3.05882352941176, size: 1 },
    //     { x: 322.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 323.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 324.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 325.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 326.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 326.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 327.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 328.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 329.513513513513, y: 3.92156862745098, size: 1 },
    //     { x: 330.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 331.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 332.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 332.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 333.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 334.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 336.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 338.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 339.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 340.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 341.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 341.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 342.486486486487, y: 3.52941176470588, size: 1 },
    //     { x: 343.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 343.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 344.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 345.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 346.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 347.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 347.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 348.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 349.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 350.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 350.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 351.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 352.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 352.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 354.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 354.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 356.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 356.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 357.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 358.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 359.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 0.647482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 1.94244604316547, y: 3.52941176470588, size: 1 },
    //     { x: 2.58992805755396, y: 3.41176470588235, size: 1 },
    //     { x: 4.53237410071942, y: 3.37254901960784, size: 1 },
    //     { x: 5.17985611510791, y: 3.09803921568627, size: 1 },
    //     { x: 5.8273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 12.3021582733813, y: 3.84313725490196, size: 1 },
    //     { x: 12.9496402877698, y: 3.52941176470588, size: 1 },
    //     { x: 16.8345323741007, y: 3.72549019607843, size: 1 },
    //     { x: 18.1294964028777, y: 3.56862745098039, size: 1 },
    //     { x: 18.7769784172662, y: 3.52941176470588, size: 1 },
    //     { x: 20.0719424460432, y: 3.56862745098039, size: 1 },
    //     { x: 25.8992805755396, y: 3.52941176470588, size: 1 },
    //     { x: 27.1942446043165, y: 3.52941176470588, size: 1 },
    //     { x: 29.7841726618705, y: 3.52941176470588, size: 1 },
    //     { x: 30.431654676259, y: 3.52941176470588, size: 1 },
    //     { x: 31.0791366906475, y: 3.56862745098039, size: 1 },
    //     { x: 33.6690647482014, y: 3.76470588235294, size: 1 },
    //     { x: 34.9640287769784, y: 3.80392156862745, size: 1 },
    //     { x: 37.5539568345324, y: 3.68627450980392, size: 1 },
    //     { x: 38.8489208633094, y: 3.68627450980392, size: 1 },
    //     { x: 40.1438848920863, y: 3.76470588235294, size: 1 },
    //     { x: 45.9712230215827, y: 3.17647058823529, size: 1 },
    //     { x: 46.6187050359712, y: 2.66666666666667, size: 1 },
    //     { x: 47.2661870503597, y: 2.50980392156863, size: 1 },
    //     { x: 47.9136690647482, y: 3.05882352941176, size: 1 },
    //     { x: 48.5611510791367, y: 3.01960784313725, size: 1 },
    //     { x: 49.2086330935252, y: 3.37254901960784, size: 1 },
    //     { x: 50.5035971223022, y: 3.37254901960784, size: 1 },
    //     { x: 51.1510791366906, y: 3.45098039215686, size: 1 },
    //     { x: 51.7985611510791, y: 3.56862745098039, size: 1 },
    //     { x: 60.2158273381295, y: 3.49019607843137, size: 1 },
    //     { x: 62.158273381295, y: 3.45098039215686, size: 1 },
    //     { x: 64.1007194244604, y: 3.52941176470588, size: 1 },
    //     { x: 66.0431654676259, y: 3.6078431372549, size: 1 },
    //     { x: 67.9856115107914, y: 3.05882352941176, size: 1 },
    //     { x: 68.6330935251799, y: 3.09803921568627, size: 1 },
    //     { x: 69.2805755395683, y: 3.29411764705882, size: 1 },
    //     { x: 69.9280575539568, y: 3.09803921568627, size: 1 },
    //     { x: 71.8705035971223, y: 3.56862745098039, size: 1 },
    //     { x: 73.1654676258993, y: 3.6078431372549, size: 1 },
    //     { x: 73.8129496402878, y: 3.49019607843137, size: 1 },
    //     { x: 75.7553956834532, y: 3.92156862745098, size: 1 },
    //     { x: 76.4028776978417, y: 3.6078431372549, size: 1 },
    //     { x: 82.8776978417266, y: 3.72549019607843, size: 1 },
    //     { x: 84.1726618705036, y: 3.6078431372549, size: 1 },
    //     { x: 85.4676258992806, y: 3.56862745098039, size: 1 },
    //     { x: 90.6474820143885, y: 3.64705882352941, size: 1 },
    //     { x: 91.294964028777, y: 3.56862745098039, size: 1 },
    //     { x: 91.9424460431655, y: 3.68627450980392, size: 1 },
    //     { x: 93.2374100719424, y: 3.72549019607843, size: 1 },
    //     { x: 96.4748201438849, y: 3.76470588235294, size: 1 },
    //     { x: 97.1223021582734, y: 3.92156862745098, size: 1 },
    //     { x: 98.4172661870504, y: 3.68627450980392, size: 1 },
    //     { x: 99.0647482014388, y: 3.76470588235294, size: 1 },
    //     { x: 101.654676258993, y: 3.84313725490196, size: 1 },
    //     { x: 102.302158273381, y: 3.64705882352941, size: 1 },
    //     { x: 102.94964028777, y: 3.84313725490196, size: 1 },
    //     { x: 104.244604316547, y: 3.88235294117647, size: 1 },
    //     { x: 106.834532374101, y: 3.76470588235294, size: 1 },
    //     { x: 108.776978417266, y: 3.68627450980392, size: 1 },
    //     { x: 110.071942446043, y: 3.84313725490196, size: 1 },
    //     { x: 110.719424460432, y: 3.64705882352941, size: 1 },
    //     { x: 111.36690647482, y: 3.17647058823529, size: 1 },
    //     { x: 113.309352517986, y: 3.41176470588235, size: 1 },
    //     { x: 113.956834532374, y: 3.49019607843137, size: 1 },
    //     { x: 115.251798561151, y: 3.88235294117647, size: 1 },
    //     { x: 121.079136690647, y: 3.49019607843137, size: 1 },
    //     { x: 123.669064748201, y: 3.64705882352941, size: 1 },
    //     { x: 124.31654676259, y: 3.45098039215686, size: 1 },
    //     { x: 125.611510791367, y: 3.68627450980392, size: 1 },
    //     { x: 130.143884892086, y: 3.52941176470588, size: 1 },
    //     { x: 131.438848920863, y: 3.17647058823529, size: 1 },
    //     { x: 132.73381294964, y: 3.25490196078431, size: 1 },
    //     { x: 133.381294964029, y: 3.17647058823529, size: 1 },
    //     { x: 134.028776978417, y: 3.01960784313725, size: 1 },
    //     { x: 134.676258992806, y: 3.17647058823529, size: 1 },
    //     { x: 135.323741007194, y: 3.05882352941176, size: 1 },
    //     { x: 136.618705035971, y: 3.52941176470588, size: 1 },
    //     { x: 137.26618705036, y: 3.41176470588235, size: 1 },
    //     { x: 139.208633093525, y: 3.45098039215686, size: 1 },
    //     { x: 139.856115107914, y: 3.45098039215686, size: 1 },
    //     { x: 141.151079136691, y: 3.56862745098039, size: 1 },
    //     { x: 141.798561151079, y: 3.92156862745098, size: 1 },
    //     { x: 143.741007194245, y: 3.45098039215686, size: 1 },
    //     { x: 144.388489208633, y: 3.56862745098039, size: 1 },
    //     { x: 145.68345323741, y: 3.52941176470588, size: 1 },
    //     { x: 147.625899280576, y: 3.52941176470588, size: 1 },
    //     { x: 148.273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 149.568345323741, y: 3.49019607843137, size: 1 },
    //     { x: 150.215827338129, y: 3.56862745098039, size: 1 },
    //     { x: 151.510791366906, y: 3.80392156862745, size: 1 },
    //     { x: 152.158273381295, y: 3.37254901960784, size: 1 },
    //     { x: 154.10071942446, y: 3.13725490196078, size: 1 },
    //     { x: 154.748201438849, y: 3.13725490196078, size: 1 },
    //     { x: 155.395683453237, y: 2.86274509803922, size: 1 },
    //     { x: 156.043165467626, y: 3.09803921568627, size: 1 },
    //     { x: 156.690647482014, y: 3.2156862745098, size: 1 },
    //     { x: 160.575539568345, y: 3.6078431372549, size: 1 },
    //     { x: 161.223021582734, y: 3.92156862745098, size: 1 },
    //     { x: 161.870503597122, y: 3.76470588235294, size: 1 },
    //     { x: 162.517985611511, y: 3.52941176470588, size: 1 },
    //     { x: 163.165467625899, y: 3.76470588235294, size: 1 },
    //     { x: 167.05035971223, y: 3.37254901960784, size: 1 },
    //     { x: 172.877697841727, y: 3.52941176470588, size: 1 },
    //     { x: 173.525179856115, y: 3.80392156862745, size: 1 },
    //     { x: 174.172661870504, y: 3.2156862745098, size: 1 },
    //     { x: 174.820143884892, y: 3.76470588235294, size: 1 },
    //     { x: 175.467625899281, y: 3.6078431372549, size: 1 },
    //     { x: 176.115107913669, y: 3.49019607843137, size: 1 },
    //     { x: 178.057553956835, y: 3.80392156862745, size: 1 },
    //     { x: 179.352517985612, y: 3.45098039215686, size: 1 },
    //     { x: 181.294964028777, y: 3.45098039215686, size: 1 },
    //     { x: 181.942446043165, y: 3.72549019607843, size: 1 },
    //     { x: 182.589928057554, y: 3.6078431372549, size: 1 },
    //     { x: 185.827338129496, y: 3.52941176470588, size: 1 },
    //     { x: 188.41726618705, y: 3.49019607843137, size: 1 },
    //     { x: 189.064748201439, y: 3.6078431372549, size: 1 },
    //     { x: 189.712230215827, y: 3.64705882352941, size: 1 },
    //     { x: 191.007194244604, y: 3.45098039215686, size: 1 },
    //     { x: 194.892086330935, y: 3.68627450980392, size: 1 },
    //     { x: 199.424460431655, y: 3.72549019607843, size: 1 },
    //     { x: 200.719424460432, y: 3.52941176470588, size: 1 },
    //     { x: 201.36690647482, y: 4.11764705882353, size: 1 },
    //     { x: 202.661870503597, y: 3.64705882352941, size: 1 },
    //     { x: 203.309352517986, y: 3.56862745098039, size: 1 },
    //     { x: 204.604316546763, y: 3.41176470588235, size: 1 },
    //     { x: 209.136690647482, y: 3.49019607843137, size: 1 },
    //     { x: 212.374100719424, y: 3.56862745098039, size: 1 },
    //     { x: 213.021582733813, y: 3.64705882352941, size: 1 },
    //     { x: 214.31654676259, y: 3.80392156862745, size: 1 },
    //     { x: 214.964028776978, y: 3.56862745098039, size: 1 },
    //     { x: 216.258992805755, y: 3.92156862745098, size: 1 },
    //     { x: 216.906474820144, y: 3.49019607843137, size: 1 },
    //     { x: 220.143884892086, y: 3.37254901960784, size: 1 },
    //     { x: 222.73381294964, y: 3.6078431372549, size: 1 },
    //     { x: 223.381294964029, y: 3.45098039215686, size: 1 },
    //     { x: 226.618705035971, y: 3.80392156862745, size: 1 },
    //     { x: 227.26618705036, y: 3.49019607843137, size: 1 },
    //     { x: 227.913669064748, y: 3.84313725490196, size: 1 },
    //     { x: 229.208633093525, y: 3.84313725490196, size: 1 },
    //     { x: 231.798561151079, y: 3.68627450980392, size: 1 },
    //     { x: 232.446043165468, y: 3.6078431372549, size: 1 },
    //     { x: 233.093525179856, y: 3.56862745098039, size: 1 },
    //     { x: 234.388489208633, y: 3.64705882352941, size: 1 },
    //     { x: 235.035971223022, y: 3.84313725490196, size: 1 },
    //     { x: 236.330935251799, y: 3.84313725490196, size: 1 },
    //     { x: 238.273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 238.920863309353, y: 3.45098039215686, size: 1 },
    //     { x: 239.568345323741, y: 3.49019607843137, size: 1 },
    //     { x: 240.215827338129, y: 3.33333333333333, size: 1 },
    //     { x: 240.863309352518, y: 3.13725490196078, size: 1 },
    //     { x: 241.510791366906, y: 2.86274509803922, size: 1 },
    //     { x: 242.158273381295, y: 2.86274509803922, size: 1 },
    //     { x: 242.805755395683, y: 3.01960784313725, size: 1 },
    //     { x: 245.395683453237, y: 3.45098039215686, size: 1 },
    //     { x: 251.223021582734, y: 3.45098039215686, size: 1 },
    //     { x: 255.107913669065, y: 3.56862745098039, size: 1 },
    //     { x: 259.640287769784, y: 3.84313725490196, size: 1 },
    //     { x: 260.935251798561, y: 3.37254901960784, size: 1 },
    //     { x: 262.230215827338, y: 2.74509803921569, size: 1 },
    //     { x: 262.877697841727, y: 2.86274509803922, size: 1 },
    //     { x: 263.525179856115, y: 3.29411764705882, size: 1 },
    //     { x: 264.172661870504, y: 3.01960784313725, size: 1 },
    //     { x: 264.820143884892, y: 3.45098039215686, size: 1 },
    //     { x: 266.762589928058, y: 3.49019607843137, size: 1 },
    //     { x: 274.532374100719, y: 3.45098039215686, size: 1 },
    //     { x: 275.827338129496, y: 3.84313725490196, size: 1 },
    //     { x: 276.474820143885, y: 3.56862745098039, size: 1 },
    //     { x: 277.122302158273, y: 3.80392156862745, size: 1 },
    //     { x: 279.712230215827, y: 3.68627450980392, size: 1 },
    //     { x: 280.359712230216, y: 3.64705882352941, size: 1 },
    //     { x: 284.892086330935, y: 3.45098039215686, size: 1 },
    //     { x: 285.539568345324, y: 3.45098039215686, size: 1 },
    //     { x: 286.187050359712, y: 3.33333333333333, size: 1 },
    //     { x: 287.482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 288.776978417266, y: 3.52941176470588, size: 1 },
    //     { x: 290.071942446043, y: 3.41176470588235, size: 1 },
    //     { x: 290.719424460432, y: 3.49019607843137, size: 1 },
    //     { x: 292.661870503597, y: 3.49019607843137, size: 1 },
    //     { x: 293.309352517986, y: 3.6078431372549, size: 1 },
    //     { x: 294.604316546763, y: 3.45098039215686, size: 1 },
    //     { x: 295.251798561151, y: 3.52941176470588, size: 1 },
    //     { x: 296.546762589928, y: 3.37254901960784, size: 1 },
    //     { x: 297.194244604317, y: 3.56862745098039, size: 1 },
    //     { x: 299.136690647482, y: 3.72549019607843, size: 1 },
    //     { x: 300.431654676259, y: 3.37254901960784, size: 1 },
    //     { x: 301.726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 302.374100719424, y: 3.45098039215686, size: 1 },
    //     { x: 303.669064748201, y: 3.37254901960784, size: 1 },
    //     { x: 304.31654676259, y: 3.45098039215686, size: 1 },
    //     { x: 304.964028776978, y: 3.33333333333333, size: 1 },
    //     { x: 305.611510791367, y: 2.98039215686275, size: 1 },
    //     { x: 306.258992805755, y: 2.82352941176471, size: 1 },
    //     { x: 306.906474820144, y: 3.09803921568627, size: 1 },
    //     { x: 307.553956834532, y: 2.66666666666667, size: 1 },
    //     { x: 308.201438848921, y: 3.76470588235294, size: 1 },
    //     { x: 310.791366906475, y: 3.45098039215686, size: 1 },
    //     { x: 312.086330935252, y: 3.56862745098039, size: 1 },
    //     { x: 313.381294964029, y: 3.49019607843137, size: 1 },
    //     { x: 316.618705035971, y: 3.52941176470588, size: 1 },
    //     { x: 317.26618705036, y: 3.49019607843137, size: 1 },
    //     { x: 321.151079136691, y: 3.72549019607843, size: 1 },
    //     { x: 327.625899280576, y: 3.45098039215686, size: 1 },
    //     { x: 328.273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 328.920863309353, y: 3.17647058823529, size: 1 },
    //     { x: 329.568345323741, y: 3.33333333333333, size: 1 },
    //     { x: 331.510791366906, y: 3.52941176470588, size: 1 },
    //     { x: 332.158273381295, y: 3.6078431372549, size: 1 },
    //     { x: 332.805755395683, y: 3.72549019607843, size: 1 },
    //     { x: 334.748201438849, y: 3.56862745098039, size: 1 },
    //     { x: 336.690647482014, y: 3.80392156862745, size: 1 },
    //     { x: 337.985611510791, y: 3.72549019607843, size: 1 },
    //     { x: 341.223021582734, y: 3.49019607843137, size: 1 },
    //     { x: 341.870503597122, y: 3.68627450980392, size: 1 },
    //     { x: 343.165467625899, y: 3.84313725490196, size: 1 },
    //     { x: 343.812949640288, y: 3.45098039215686, size: 1 },
    //     { x: 344.460431654676, y: 3.45098039215686, size: 1 },
    //     { x: 345.755395683453, y: 3.56862745098039, size: 1 },
    //     { x: 346.402877697842, y: 3.6078431372549, size: 1 },
    //     { x: 347.05035971223, y: 3.37254901960784, size: 1 },
    //     { x: 348.345323741007, y: 3.52941176470588, size: 1 },
    //     { x: 348.992805755396, y: 3.17647058823529, size: 1 },
    //     { x: 349.640287769784, y: 3.72549019607843, size: 1 },
    //     { x: 350.287769784173, y: 3.92156862745098, size: 1 },
    //     { x: 350.935251798561, y: 3.68627450980392, size: 1 },
    //     { x: 351.58273381295, y: 3.68627450980392, size: 1 },
    //     { x: 352.230215827338, y: 3.64705882352941, size: 1 },
    //     { x: 352.877697841727, y: 3.84313725490196, size: 1 },
    //     { x: 356.762589928058, y: 3.68627450980392, size: 1 },
    //     { x: 359.352517985611, y: 3.76470588235294, size: 1 },
    //     { x: 2.58992805755396, y: 3.6078431372549, size: 1 },
    //     { x: 3.88489208633094, y: 3.64705882352941, size: 1 },
    //     { x: 5.17985611510791, y: 3.68627450980392, size: 1 },
    //     { x: 5.8273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 7.76978417266187, y: 3.72549019607843, size: 1 },
    //     { x: 9.06474820143885, y: 3.45098039215686, size: 1 },
    //     { x: 10.3597122302158, y: 3.52941176470588, size: 1 },
    //     { x: 11.0071942446043, y: 3.25490196078431, size: 1 },
    //     { x: 11.6546762589928, y: 3.6078431372549, size: 1 },
    //     { x: 12.3021582733813, y: 3.64705882352941, size: 1 },
    //     { x: 12.9496402877698, y: 3.72549019607843, size: 1 },
    //     { x: 13.5971223021583, y: 3.56862745098039, size: 1 },
    //     { x: 14.2446043165468, y: 3.41176470588235, size: 1 },
    //     { x: 14.8920863309353, y: 3.76470588235294, size: 1 },
    //     { x: 15.5395683453237, y: 3.68627450980392, size: 1 },
    //     { x: 16.1870503597122, y: 3.49019607843137, size: 1 },
    //     { x: 18.7769784172662, y: 3.64705882352941, size: 1 },
    //     { x: 20.0719424460432, y: 3.72549019607843, size: 1 },
    //     { x: 20.7194244604317, y: 3.80392156862745, size: 1 },
    //     { x: 22.6618705035971, y: 3.72549019607843, size: 1 },
    //     { x: 23.9568345323741, y: 3.6078431372549, size: 1 },
    //     { x: 24.6043165467626, y: 3.72549019607843, size: 1 },
    //     { x: 25.2517985611511, y: 3.80392156862745, size: 1 },
    //     { x: 26.5467625899281, y: 3.72549019607843, size: 1 },
    //     { x: 27.841726618705, y: 3.41176470588235, size: 1 },
    //     { x: 28.4892086330935, y: 3.52941176470588, size: 1 },
    //     { x: 30.431654676259, y: 3.49019607843137, size: 1 },
    //     { x: 31.726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 34.3165467625899, y: 3.76470588235294, size: 1 },
    //     { x: 36.9064748201439, y: 3.76470588235294, size: 1 },
    //     { x: 39.4964028776978, y: 3.45098039215686, size: 1 },
    //     { x: 40.7913669064748, y: 3.6078431372549, size: 1 },
    //     { x: 41.4388489208633, y: 3.72549019607843, size: 1 },
    //     { x: 44.6762589928058, y: 3.80392156862745, size: 1 },
    //     { x: 45.3237410071942, y: 3.49019607843137, size: 1 },
    //     { x: 46.6187050359712, y: 3.6078431372549, size: 1 },
    //     { x: 47.2661870503597, y: 3.64705882352941, size: 1 },
    //     { x: 47.9136690647482, y: 3.88235294117647, size: 1 },
    //     { x: 48.5611510791367, y: 3.72549019607843, size: 1 },
    //     { x: 49.2086330935252, y: 3.68627450980392, size: 1 },
    //     { x: 52.4460431654676, y: 3.64705882352941, size: 1 },
    //     { x: 53.7410071942446, y: 3.37254901960784, size: 1 },
    //     { x: 54.3884892086331, y: 3.52941176470588, size: 1 },
    //     { x: 55.0359712230216, y: 3.72549019607843, size: 1 },
    //     { x: 56.9784172661871, y: 3.56862745098039, size: 1 },
    //     { x: 57.6258992805755, y: 3.45098039215686, size: 1 },
    //     { x: 58.273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 61.5107913669065, y: 3.68627450980392, size: 1 },
    //     { x: 62.158273381295, y: 3.68627450980392, size: 1 },
    //     { x: 62.8057553956835, y: 3.64705882352941, size: 1 },
    //     { x: 63.4532374100719, y: 3.68627450980392, size: 1 },
    //     { x: 64.7482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 67.9856115107914, y: 3.80392156862745, size: 1 },
    //     { x: 72.5179856115108, y: 3.96078431372549, size: 1 },
    //     { x: 74.4604316546763, y: 3.41176470588235, size: 1 },
    //     { x: 75.1079136690647, y: 3.13725490196078, size: 1 },
    //     { x: 75.7553956834532, y: 3.13725490196078, size: 1 },
    //     { x: 76.4028776978417, y: 3.72549019607843, size: 1 },
    //     { x: 77.6978417266187, y: 3.72549019607843, size: 1 },
    //     { x: 78.3453237410072, y: 3.76470588235294, size: 1 },
    //     { x: 79.6402877697842, y: 3.64705882352941, size: 1 },
    //     { x: 82.2302158273381, y: 3.64705882352941, size: 1 },
    //     { x: 84.1726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 85.4676258992806, y: 3.72549019607843, size: 1 },
    //     { x: 90, y: 3.56862745098039, size: 1 },
    //     { x: 90.6474820143885, y: 3.56862745098039, size: 1 },
    //     { x: 91.294964028777, y: 3.88235294117647, size: 1 },
    //     { x: 95.1798561151079, y: 3.96078431372549, size: 1 },
    //     { x: 98.4172661870504, y: 3.6078431372549, size: 1 },
    //     { x: 100.359712230216, y: 3.37254901960784, size: 1 },
    //     { x: 102.302158273381, y: 3.84313725490196, size: 1 },
    //     { x: 104.892086330935, y: 3.64705882352941, size: 1 },
    //     { x: 105.539568345324, y: 3.45098039215686, size: 1 },
    //     { x: 109.424460431655, y: 3.49019607843137, size: 1 },
    //     { x: 110.719424460432, y: 3.72549019607843, size: 1 },
    //     { x: 111.36690647482, y: 3.45098039215686, size: 1 },
    //     { x: 112.014388489209, y: 3.72549019607843, size: 1 },
    //     { x: 115.89928057554, y: 3.64705882352941, size: 1 },
    //     { x: 117.841726618705, y: 3.56862745098039, size: 1 },
    //     { x: 118.489208633094, y: 3.6078431372549, size: 1 },
    //     { x: 119.784172661871, y: 3.80392156862745, size: 1 },
    //     { x: 120.431654676259, y: 3.6078431372549, size: 1 },
    //     { x: 121.079136690647, y: 3.56862745098039, size: 1 },
    //     { x: 121.726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 122.374100719424, y: 3.88235294117647, size: 1 },
    //     { x: 123.021582733813, y: 3.64705882352941, size: 1 },
    //     { x: 123.669064748201, y: 3.6078431372549, size: 1 },
    //     { x: 132.73381294964, y: 3.56862745098039, size: 1 },
    //     { x: 134.028776978417, y: 3.49019607843137, size: 1 },
    //     { x: 135.971223021583, y: 3.80392156862745, size: 1 },
    //     { x: 137.913669064748, y: 3.41176470588235, size: 1 },
    //     { x: 138.561151079137, y: 3.37254901960784, size: 1 },
    //     { x: 139.856115107914, y: 3.01960784313725, size: 1 },
    //     { x: 140.503597122302, y: 2.82352941176471, size: 1 },
    //     { x: 141.151079136691, y: 2.7843137254902, size: 1 },
    //     { x: 141.798561151079, y: 2.70588235294118, size: 1 },
    //     { x: 142.446043165468, y: 3.45098039215686, size: 1 },
    //     { x: 143.093525179856, y: 3.56862745098039, size: 1 },
    //     { x: 145.035971223022, y: 3.25490196078431, size: 1 },
    //     { x: 148.920863309353, y: 3.56862745098039, size: 1 },
    //     { x: 149.568345323741, y: 3.80392156862745, size: 1 },
    //     { x: 151.510791366906, y: 3.45098039215686, size: 1 },
    //     { x: 153.453237410072, y: 3.33333333333333, size: 1 },
    //     { x: 154.748201438849, y: 3.49019607843137, size: 1 },
    //     { x: 156.043165467626, y: 3.45098039215686, size: 1 },
    //     { x: 156.690647482014, y: 3.52941176470588, size: 1 },
    //     { x: 159.280575539568, y: 3.41176470588235, size: 1 },
    //     { x: 161.223021582734, y: 3.84313725490196, size: 1 },
    //     { x: 164.460431654676, y: 3.68627450980392, size: 1 },
    //     { x: 165.107913669065, y: 3.41176470588235, size: 1 },
    //     { x: 170.287769784173, y: 3.72549019607843, size: 1 },
    //     { x: 170.935251798561, y: 3.72549019607843, size: 1 },
    //     { x: 172.877697841727, y: 3.68627450980392, size: 1 },
    //     { x: 174.820143884892, y: 3.6078431372549, size: 1 },
    //     { x: 175.467625899281, y: 3.68627450980392, size: 1 },
    //     { x: 176.115107913669, y: 3.52941176470588, size: 1 },
    //     { x: 180, y: 3.41176470588235, size: 1 },
    //     { x: 181.942446043165, y: 3.29411764705882, size: 1 },
    //     { x: 187.769784172662, y: 3.80392156862745, size: 1 },
    //     { x: 189.064748201439, y: 3.52941176470588, size: 1 },
    //     { x: 190.359712230216, y: 3.64705882352941, size: 1 },
    //     { x: 194.892086330935, y: 3.72549019607843, size: 1 },
    //     { x: 196.187050359712, y: 3.88235294117647, size: 1 },
    //     { x: 196.834532374101, y: 3.56862745098039, size: 1 },
    //     { x: 198.129496402878, y: 3.41176470588235, size: 1 },
    //     { x: 199.424460431655, y: 3.45098039215686, size: 1 },
    //     { x: 200.071942446043, y: 3.72549019607843, size: 1 },
    //     { x: 201.36690647482, y: 3.52941176470588, size: 1 },
    //     { x: 202.014388489209, y: 3.72549019607843, size: 1 },
    //     { x: 202.661870503597, y: 3.45098039215686, size: 1 },
    //     { x: 205.251798561151, y: 3.33333333333333, size: 1 },
    //     { x: 207.194244604317, y: 3.45098039215686, size: 1 },
    //     { x: 213.669064748201, y: 3.64705882352941, size: 1 },
    //     { x: 216.258992805755, y: 3.33333333333333, size: 1 },
    //     { x: 217.553956834532, y: 3.49019607843137, size: 1 },
    //     { x: 220.791366906475, y: 3.72549019607843, size: 1 },
    //     { x: 222.086330935252, y: 3.37254901960784, size: 1 },
    //     { x: 225.323741007194, y: 3.84313725490196, size: 1 },
    //     { x: 227.913669064748, y: 3.49019607843137, size: 1 },
    //     { x: 229.856115107914, y: 3.84313725490196, size: 1 },
    //     { x: 231.151079136691, y: 3.84313725490196, size: 1 },
    //     { x: 234.388489208633, y: 3.6078431372549, size: 1 },
    //     { x: 236.330935251799, y: 3.6078431372549, size: 1 },
    //     { x: 238.273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 238.920863309353, y: 3.49019607843137, size: 1 },
    //     { x: 240.215827338129, y: 3.52941176470588, size: 1 },
    //     { x: 244.10071942446, y: 3.96078431372549, size: 1 },
    //     { x: 244.748201438849, y: 3.64705882352941, size: 1 },
    //     { x: 247.338129496403, y: 3.45098039215686, size: 1 },
    //     { x: 248.63309352518, y: 3.68627450980392, size: 1 },
    //     { x: 249.928057553957, y: 3.72549019607843, size: 1 },
    //     { x: 251.870503597122, y: 3.6078431372549, size: 1 },
    //     { x: 255.755395683453, y: 3.52941176470588, size: 1 },
    //     { x: 257.05035971223, y: 3.76470588235294, size: 1 },
    //     { x: 257.697841726619, y: 3.6078431372549, size: 1 },
    //     { x: 258.992805755396, y: 3.56862745098039, size: 1 },
    //     { x: 259.640287769784, y: 3.56862745098039, size: 1 },
    //     { x: 261.58273381295, y: 3.72549019607843, size: 1 },
    //     { x: 262.230215827338, y: 3.76470588235294, size: 1 },
    //     { x: 266.762589928058, y: 3.41176470588235, size: 1 },
    //     { x: 267.410071942446, y: 3.49019607843137, size: 1 },
    //     { x: 269.352517985611, y: 3.41176470588235, size: 1 },
    //     { x: 270, y: 3.41176470588235, size: 1 },
    //     { x: 270.647482014389, y: 3.29411764705882, size: 1 },
    //     { x: 272.589928057554, y: 3.80392156862745, size: 1 },
    //     { x: 273.237410071942, y: 3.6078431372549, size: 1 },
    //     { x: 273.884892086331, y: 3.84313725490196, size: 1 },
    //     { x: 275.179856115108, y: 3.49019607843137, size: 1 },
    //     { x: 276.474820143885, y: 3.52941176470588, size: 1 },
    //     { x: 277.122302158273, y: 3.41176470588235, size: 1 },
    //     { x: 277.769784172662, y: 3.76470588235294, size: 1 },
    //     { x: 281.007194244604, y: 3.84313725490196, size: 1 },
    //     { x: 282.302158273381, y: 3.72549019607843, size: 1 },
    //     { x: 282.94964028777, y: 3.56862745098039, size: 1 },
    //     { x: 284.892086330935, y: 3.68627450980392, size: 1 },
    //     { x: 290.071942446043, y: 3.37254901960784, size: 1 },
    //     { x: 290.719424460432, y: 3.37254901960784, size: 1 },
    //     { x: 291.36690647482, y: 3.37254901960784, size: 1 },
    //     { x: 292.014388489209, y: 3.37254901960784, size: 1 },
    //     { x: 293.309352517986, y: 3.68627450980392, size: 1 },
    //     { x: 293.956834532374, y: 3.33333333333333, size: 1 },
    //     { x: 295.251798561151, y: 3.45098039215686, size: 1 },
    //     { x: 297.841726618705, y: 3.49019607843137, size: 1 },
    //     { x: 298.489208633094, y: 3.72549019607843, size: 1 },
    //     { x: 300.431654676259, y: 3.72549019607843, size: 1 },
    //     { x: 303.021582733813, y: 3.45098039215686, size: 1 },
    //     { x: 304.964028776978, y: 3.6078431372549, size: 1 },
    //     { x: 306.906474820144, y: 3.52941176470588, size: 1 },
    //     { x: 310.791366906475, y: 3.37254901960784, size: 1 },
    //     { x: 311.438848920863, y: 3.33333333333333, size: 1 },
    //     { x: 312.73381294964, y: 3.2156862745098, size: 1 },
    //     { x: 313.381294964029, y: 3.13725490196078, size: 1 },
    //     { x: 314.028776978417, y: 2.98039215686275, size: 1 },
    //     { x: 314.676258992806, y: 3.17647058823529, size: 1 },
    //     { x: 316.618705035971, y: 3.84313725490196, size: 1 },
    //     { x: 317.913669064748, y: 3.64705882352941, size: 1 },
    //     { x: 319.208633093525, y: 3.76470588235294, size: 1 },
    //     { x: 320.503597122302, y: 3.56862745098039, size: 1 },
    //     { x: 321.798561151079, y: 3.56862745098039, size: 1 },
    //     { x: 322.446043165468, y: 3.76470588235294, size: 1 },
    //     { x: 323.741007194245, y: 3.76470588235294, size: 1 },
    //     { x: 326.978417266187, y: 3.41176470588235, size: 1 },
    //     { x: 330.863309352518, y: 3.41176470588235, size: 1 },
    //     { x: 334.10071942446, y: 3.13725490196078, size: 1 },
    //     { x: 334.748201438849, y: 2.74509803921569, size: 1 },
    //     { x: 335.395683453237, y: 3.09803921568627, size: 1 },
    //     { x: 336.043165467626, y: 3.05882352941176, size: 1 },
    //     { x: 339.280575539568, y: 3.6078431372549, size: 1 },
    //     { x: 341.223021582734, y: 3.96078431372549, size: 1 },
    //     { x: 342.517985611511, y: 3.6078431372549, size: 1 },
    //     { x: 343.165467625899, y: 3.68627450980392, size: 1 },
    //     { x: 345.107913669065, y: 3.45098039215686, size: 1 },
    //     { x: 354.820143884892, y: 3.96078431372549, size: 1 },
    //     { x: 359.352517985611, y: 4, size: 1 },
    //     { x: 0, y: 3.84313725490196, size: 1 },
    //     { x: 1.29496402877698, y: 3.84313725490196, size: 1 },
    //     { x: 1.94244604316547, y: 3.72549019607843, size: 1 },
    //     { x: 2.58992805755396, y: 3.88235294117647, size: 1 },
    //     { x: 3.23741007194245, y: 3.88235294117647, size: 1 },
    //     { x: 8.41726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 9.71223021582734, y: 3.68627450980392, size: 1 },
    //     { x: 11.0071942446043, y: 4, size: 1 },
    //     { x: 11.6546762589928, y: 3.49019607843137, size: 1 },
    //     { x: 12.3021582733813, y: 3.52941176470588, size: 1 },
    //     { x: 13.5971223021583, y: 3.84313725490196, size: 1 },
    //     { x: 14.2446043165468, y: 3.80392156862745, size: 1 },
    //     { x: 14.8920863309353, y: 3.64705882352941, size: 1 },
    //     { x: 16.1870503597122, y: 3.09803921568627, size: 1 },
    //     { x: 16.8345323741007, y: 3.64705882352941, size: 1 },
    //     { x: 17.4820143884892, y: 3.13725490196078, size: 1 },
    //     { x: 18.7769784172662, y: 3.41176470588235, size: 1 },
    //     { x: 19.4244604316547, y: 3.52941176470588, size: 1 },
    //     { x: 22.0143884892086, y: 3.88235294117647, size: 1 },
    //     { x: 22.6618705035971, y: 4, size: 1 },
    //     { x: 24.6043165467626, y: 3.80392156862745, size: 1 },
    //     { x: 29.136690647482, y: 3.72549019607843, size: 1 },
    //     { x: 31.726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 34.3165467625899, y: 3.64705882352941, size: 1 },
    //     { x: 35.6115107913669, y: 3.68627450980392, size: 1 },
    //     { x: 36.2589928057554, y: 3.72549019607843, size: 1 },
    //     { x: 36.9064748201439, y: 3.29411764705882, size: 1 },
    //     { x: 38.2014388489209, y: 3.72549019607843, size: 1 },
    //     { x: 38.8489208633094, y: 3.13725490196078, size: 1 },
    //     { x: 40.1438848920863, y: 3.01960784313725, size: 1 },
    //     { x: 40.7913669064748, y: 2.66666666666667, size: 1 },
    //     { x: 45.3237410071942, y: 3.6078431372549, size: 1 },
    //     { x: 45.9712230215827, y: 3.76470588235294, size: 1 },
    //     { x: 52.4460431654676, y: 3.84313725490196, size: 1 },
    //     { x: 54.3884892086331, y: 3.56862745098039, size: 1 },
    //     { x: 56.9784172661871, y: 3.72549019607843, size: 1 },
    //     { x: 58.9208633093525, y: 3.52941176470588, size: 1 },
    //     { x: 59.568345323741, y: 3.41176470588235, size: 1 },
    //     { x: 60.2158273381295, y: 3.17647058823529, size: 1 },
    //     { x: 60.863309352518, y: 3.13725490196078, size: 1 },
    //     { x: 66.0431654676259, y: 3.68627450980392, size: 1 },
    //     { x: 67.3381294964029, y: 3.6078431372549, size: 1 },
    //     { x: 67.9856115107914, y: 3.68627450980392, size: 1 },
    //     { x: 69.2805755395683, y: 3.68627450980392, size: 1 },
    //     { x: 73.1654676258993, y: 3.56862745098039, size: 1 },
    //     { x: 73.8129496402878, y: 3.72549019607843, size: 1 },
    //     { x: 74.4604316546763, y: 3.76470588235294, size: 1 },
    //     { x: 77.0503597122302, y: 3.45098039215686, size: 1 },
    //     { x: 77.6978417266187, y: 3.45098039215686, size: 1 },
    //     { x: 80.9352517985612, y: 3.56862745098039, size: 1 },
    //     { x: 83.5251798561151, y: 3.52941176470588, size: 1 },
    //     { x: 84.1726618705036, y: 3.56862745098039, size: 1 },
    //     { x: 84.8201438848921, y: 3.6078431372549, size: 1 },
    //     { x: 86.7625899280576, y: 3.80392156862745, size: 1 },
    //     { x: 88.705035971223, y: 3.45098039215686, size: 1 },
    //     { x: 93.2374100719424, y: 3.45098039215686, size: 1 },
    //     { x: 96.4748201438849, y: 3.37254901960784, size: 1 },
    //     { x: 97.7697841726619, y: 3.68627450980392, size: 1 },
    //     { x: 99.0647482014388, y: 3.49019607843137, size: 1 },
    //     { x: 99.7122302158273, y: 3.41176470588235, size: 1 },
    //     { x: 104.244604316547, y: 3.37254901960784, size: 1 },
    //     { x: 106.187050359712, y: 3.72549019607843, size: 1 },
    //     { x: 108.776978417266, y: 3.52941176470588, size: 1 },
    //     { x: 109.424460431655, y: 3.45098039215686, size: 1 },
    //     { x: 110.719424460432, y: 3.52941176470588, size: 1 },
    //     { x: 111.36690647482, y: 3.68627450980392, size: 1 },
    //     { x: 113.309352517986, y: 3.49019607843137, size: 1 },
    //     { x: 113.956834532374, y: 3.52941176470588, size: 1 },
    //     { x: 114.604316546763, y: 3.6078431372549, size: 1 },
    //     { x: 119.136690647482, y: 3.49019607843137, size: 1 },
    //     { x: 120.431654676259, y: 3.33333333333333, size: 1 },
    //     { x: 123.669064748201, y: 3.68627450980392, size: 1 },
    //     { x: 125.611510791367, y: 3.92156862745098, size: 1 },
    //     { x: 126.906474820144, y: 3.64705882352941, size: 1 },
    //     { x: 127.553956834532, y: 3.68627450980392, size: 1 },
    //     { x: 128.201438848921, y: 3.6078431372549, size: 1 },
    //     { x: 130.143884892086, y: 3.84313725490196, size: 1 },
    //     { x: 132.086330935252, y: 3.52941176470588, size: 1 },
    //     { x: 132.73381294964, y: 3.45098039215686, size: 1 },
    //     { x: 135.323741007194, y: 3.68627450980392, size: 1 },
    //     { x: 136.618705035971, y: 3.76470588235294, size: 1 },
    //     { x: 137.26618705036, y: 3.76470588235294, size: 1 },
    //     { x: 139.208633093525, y: 3.80392156862745, size: 1 },
    //     { x: 140.503597122302, y: 3.56862745098039, size: 1 },
    //     { x: 141.798561151079, y: 3.49019607843137, size: 1 },
    //     { x: 143.741007194245, y: 3.56862745098039, size: 1 },
    //     { x: 146.330935251799, y: 3.41176470588235, size: 1 },
    //     { x: 147.625899280576, y: 3.56862745098039, size: 1 },
    //     { x: 148.920863309353, y: 3.41176470588235, size: 1 },
    //     { x: 150.215827338129, y: 3.6078431372549, size: 1 },
    //     { x: 150.863309352518, y: 3.52941176470588, size: 1 },
    //     { x: 152.805755395683, y: 3.49019607843137, size: 1 },
    //     { x: 154.10071942446, y: 3.80392156862745, size: 1 },
    //     { x: 160.575539568345, y: 3.68627450980392, size: 1 },
    //     { x: 163.165467625899, y: 3.80392156862745, size: 1 },
    //     { x: 170.935251798561, y: 3.76470588235294, size: 1 },
    //     { x: 173.525179856115, y: 3.6078431372549, size: 1 },
    //     { x: 174.172661870504, y: 3.52941176470588, size: 1 },
    //     { x: 179.352517985612, y: 3.96078431372549, size: 1 },
    //     { x: 180.647482014388, y: 3.84313725490196, size: 1 },
    //     { x: 184.532374100719, y: 3.84313725490196, size: 1 },
    //     { x: 185.179856115108, y: 3.76470588235294, size: 1 },
    //     { x: 187.769784172662, y: 3.6078431372549, size: 1 },
    //     { x: 188.41726618705, y: 3.45098039215686, size: 1 },
    //     { x: 189.712230215827, y: 2.74509803921569, size: 1 },
    //     { x: 190.359712230216, y: 2.7843137254902, size: 1 },
    //     { x: 191.007194244604, y: 2.98039215686275, size: 1 },
    //     { x: 191.654676258993, y: 3.13725490196078, size: 1 },
    //     { x: 192.302158273381, y: 3.33333333333333, size: 1 },
    //     { x: 193.597122302158, y: 3.49019607843137, size: 1 },
    //     { x: 194.244604316547, y: 3.6078431372549, size: 1 },
    //     { x: 196.834532374101, y: 3.64705882352941, size: 1 },
    //     { x: 198.776978417266, y: 3.6078431372549, size: 1 },
    //     { x: 200.071942446043, y: 3.6078431372549, size: 1 },
    //     { x: 201.36690647482, y: 3.25490196078431, size: 1 },
    //     { x: 203.956834532374, y: 3.76470588235294, size: 1 },
    //     { x: 205.251798561151, y: 3.64705882352941, size: 1 },
    //     { x: 205.89928057554, y: 3.68627450980392, size: 1 },
    //     { x: 206.546762589928, y: 3.52941176470588, size: 1 },
    //     { x: 209.784172661871, y: 3.37254901960784, size: 1 },
    //     { x: 210.431654676259, y: 3.33333333333333, size: 1 },
    //     { x: 211.726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 212.374100719424, y: 3.29411764705882, size: 1 },
    //     { x: 213.021582733813, y: 2.90196078431373, size: 1 },
    //     { x: 213.669064748201, y: 2.90196078431373, size: 1 },
    //     { x: 214.964028776978, y: 3.84313725490196, size: 1 },
    //     { x: 220.791366906475, y: 3.64705882352941, size: 1 },
    //     { x: 224.028776978417, y: 3.84313725490196, size: 1 },
    //     { x: 228.561151079137, y: 3.88235294117647, size: 1 },
    //     { x: 229.208633093525, y: 3.56862745098039, size: 1 },
    //     { x: 229.856115107914, y: 3.88235294117647, size: 1 },
    //     { x: 231.151079136691, y: 3.68627450980392, size: 1 },
    //     { x: 231.798561151079, y: 3.37254901960784, size: 1 },
    //     { x: 232.446043165468, y: 2.94117647058824, size: 1 },
    //     { x: 233.093525179856, y: 1.2156862745098, size: 1 },
    //     { x: 233.741007194245, y: 1.05882352941176, size: 1 },
    //     { x: 234.388489208633, y: 1.01960784313725, size: 1 },
    //     { x: 235.035971223022, y: 0.980392156862745, size: 1 },
    //     { x: 236.330935251799, y: 3.52941176470588, size: 1 },
    //     { x: 237.625899280576, y: 3.09803921568627, size: 1 },
    //     { x: 238.273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 238.920863309353, y: 3.56862745098039, size: 1 },
    //     { x: 242.158273381295, y: 2.94117647058824, size: 1 },
    //     { x: 242.805755395683, y: 2.90196078431373, size: 1 },
    //     { x: 244.10071942446, y: 3.72549019607843, size: 1 },
    //     { x: 248.63309352518, y: 2.70588235294118, size: 1 },
    //     { x: 249.280575539568, y: 2.98039215686275, size: 1 },
    //     { x: 249.928057553957, y: 3.37254901960784, size: 1 },
    //     { x: 251.870503597122, y: 3.33333333333333, size: 1 },
    //     { x: 252.517985611511, y: 3.25490196078431, size: 1 },
    //     { x: 253.812949640288, y: 3.29411764705882, size: 1 },
    //     { x: 254.460431654676, y: 3.09803921568627, size: 1 },
    //     { x: 256.402877697842, y: 3.29411764705882, size: 1 },
    //     { x: 257.05035971223, y: 3.25490196078431, size: 1 },
    //     { x: 257.697841726619, y: 3.37254901960784, size: 1 },
    //     { x: 258.345323741007, y: 3.45098039215686, size: 1 },
    //     { x: 258.992805755396, y: 3.49019607843137, size: 1 },
    //     { x: 259.640287769784, y: 3.25490196078431, size: 1 },
    //     { x: 260.287769784173, y: 3.45098039215686, size: 1 },
    //     { x: 260.935251798561, y: 3.52941176470588, size: 1 },
    //     { x: 262.230215827338, y: 3.45098039215686, size: 1 },
    //     { x: 263.525179856115, y: 3.45098039215686, size: 1 },
    //     { x: 264.172661870504, y: 3.49019607843137, size: 1 },
    //     { x: 266.115107913669, y: 3.33333333333333, size: 1 },
    //     { x: 267.410071942446, y: 3.29411764705882, size: 1 },
    //     { x: 268.057553956835, y: 3.33333333333333, size: 1 },
    //     { x: 270, y: 3.45098039215686, size: 1 },
    //     { x: 271.942446043165, y: 3.29411764705882, size: 1 },
    //     { x: 272.589928057554, y: 3.45098039215686, size: 1 },
    //     { x: 273.237410071942, y: 3.2156862745098, size: 1 },
    //     { x: 273.884892086331, y: 3.25490196078431, size: 1 },
    //     { x: 274.532374100719, y: 3.29411764705882, size: 1 },
    //     { x: 275.179856115108, y: 3.29411764705882, size: 1 },
    //     { x: 275.827338129496, y: 3.17647058823529, size: 1 },
    //     { x: 276.474820143885, y: 2.62745098039216, size: 1 },
    //     { x: 277.122302158273, y: 3.09803921568627, size: 1 },
    //     { x: 278.41726618705, y: 3.49019607843137, size: 1 },
    //     { x: 281.007194244604, y: 3.33333333333333, size: 1 },
    //     { x: 282.302158273381, y: 3.37254901960784, size: 1 },
    //     { x: 284.244604316547, y: 3.29411764705882, size: 1 },
    //     { x: 289.424460431655, y: 3.37254901960784, size: 1 },
    //     { x: 291.36690647482, y: 3.49019607843137, size: 1 },
    //     { x: 293.309352517986, y: 3.41176470588235, size: 1 },
    //     { x: 293.956834532374, y: 3.49019607843137, size: 1 },
    //     { x: 295.89928057554, y: 3.17647058823529, size: 1 },
    //     { x: 296.546762589928, y: 3.17647058823529, size: 1 },
    //     { x: 297.194244604317, y: 3.09803921568627, size: 1 },
    //     { x: 297.841726618705, y: 2.3921568627451, size: 1 },
    //     { x: 298.489208633094, y: 2.54901960784314, size: 1 },
    //     { x: 299.784172661871, y: 3.52941176470588, size: 1 },
    //     { x: 302.374100719424, y: 3.64705882352941, size: 1 },
    //     { x: 304.964028776978, y: 3.84313725490196, size: 1 },
    //     { x: 306.906474820144, y: 3.68627450980392, size: 1 },
    //     { x: 307.553956834532, y: 3.68627450980392, size: 1 },
    //     { x: 308.848920863309, y: 3.76470588235294, size: 1 },
    //     { x: 312.086330935252, y: 3.84313725490196, size: 1 },
    //     { x: 314.028776978417, y: 4, size: 1 },
    //     { x: 317.26618705036, y: 3.37254901960784, size: 1 },
    //     { x: 317.913669064748, y: 3.13725490196078, size: 1 },
    //     { x: 319.208633093525, y: 2.47058823529412, size: 1 },
    //     { x: 319.856115107914, y: 2.70588235294118, size: 1 },
    //     { x: 321.151079136691, y: 3.49019607843137, size: 1 },
    //     { x: 321.798561151079, y: 3.68627450980392, size: 1 },
    //     { x: 322.446043165468, y: 3.80392156862745, size: 1 },
    //     { x: 325.68345323741, y: 3.41176470588235, size: 1 },
    //     { x: 326.330935251799, y: 3.88235294117647, size: 1 },
    //     { x: 327.625899280576, y: 3.49019607843137, size: 1 },
    //     { x: 330.215827338129, y: 3.64705882352941, size: 1 },
    //     { x: 332.158273381295, y: 3.33333333333333, size: 1 },
    //     { x: 332.805755395683, y: 3.64705882352941, size: 1 },
    //     { x: 333.453237410072, y: 3.56862745098039, size: 1 },
    //     { x: 335.395683453237, y: 3.52941176470588, size: 1 },
    //     { x: 336.043165467626, y: 3.45098039215686, size: 1 },
    //     { x: 336.690647482014, y: 3.49019607843137, size: 1 },
    //     { x: 339.280575539568, y: 3.2156862745098, size: 1 },
    //     { x: 340.575539568345, y: 3.17647058823529, size: 1 },
    //     { x: 341.223021582734, y: 2.7843137254902, size: 1 },
    //     { x: 341.870503597122, y: 3.45098039215686, size: 1 },
    //     { x: 342.517985611511, y: 3.76470588235294, size: 1 },
    //     { x: 343.812949640288, y: 3.49019607843137, size: 1 },
    //     { x: 347.05035971223, y: 3.88235294117647, size: 1 },
    //     { x: 348.345323741007, y: 3.72549019607843, size: 1 },
    //     { x: 348.992805755396, y: 3.72549019607843, size: 1 },
    //     { x: 350.287769784173, y: 3.56862745098039, size: 1 },
    //     { x: 356.762589928058, y: 3.52941176470588, size: 1 },
    //     { x: 358.057553956835, y: 3.64705882352941, size: 1 },
    //     { x: 1.2972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 1.94594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 2.59459459459459, y: 1.68627450980392, size: 1 },
    //     { x: 3.24324324324324, y: 1.84313725490196, size: 1 },
    //     { x: 3.89189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 4.54054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 5.18918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 5.83783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 6.48648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 7.13513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 8.43243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 9.08108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 9.72972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 10.3783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 12.3243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 12.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 15.5675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 16.2162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 16.8648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 17.5135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 18.1621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 18.8108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 19.4594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 20.7567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 22.0540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 22.7027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 23.3513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 24, y: 3.68627450980392, size: 1 },
    //     { x: 24.6486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 25.2972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 25.9459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 26.5945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 27.2432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 27.8918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 29.1891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 29.8378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 30.4864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 31.7837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 33.0810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 34.3783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 35.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 36.3243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 36.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 37.6216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 38.2702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 38.9189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 39.5675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 40.2162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 40.8648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 42.8108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 44.1081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 45.4054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 46.0540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 46.7027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 47.3513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 48, y: 3.45098039215686, size: 1 },
    //     { x: 48.6486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 49.2972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 49.9459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 51.2432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 52.5405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 53.8378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 54.4864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 57.7297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 58.3783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 59.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 60.3243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 61.6216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 62.2702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 62.9189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 63.5675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 64.2162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 65.5135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 66.1621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 66.8108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 67.4594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 68.1081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 68.7567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 69.4054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 70.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 70.7027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 71.3513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 72, y: 3.72549019607843, size: 1 },
    //     { x: 73.2972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 74.5945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 75.2432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 75.8918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 76.5405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 77.1891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 77.8378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 78.4864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 79.1351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 80.4324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 81.0810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 82.3783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 83.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 83.6756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 86.2702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 86.9189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 87.5675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 88.2162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 88.8648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 89.5135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 90.1621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 90.8108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 92.1081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 92.7567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 94.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 94.7027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 96, y: 3.6078431372549, size: 1 },
    //     { x: 97.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 98.5945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 99.2432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 99.8918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 100.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 101.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 101.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 102.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 103.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 104.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 105.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 106.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 108.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 109.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 110.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 110.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 111.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 112.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 112.864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 113.513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 114.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 114.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 116.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 117.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 118.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 118.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 119.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 120.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 121.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 122.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 123.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 123.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 124.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 125.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 126.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 127.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 127.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 128.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 129.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 129.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 130.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 131.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 131.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 132.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 132.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 133.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 134.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 134.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 135.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 136.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 138.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 139.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 140.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 141.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 142.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 142.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 144.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 145.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 145.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 146.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 147.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 147.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 148.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 149.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 151.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 152.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 153.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 153.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 154.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 156.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 158.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 158.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 159.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 160.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 162.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 162.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 163.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 164.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 166.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 167.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 168.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 169.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 171.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 171.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 172.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 173.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 173.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 174.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 175.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 176.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 177.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 178.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 179.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 179.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 180.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 180.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 181.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 182.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 182.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 183.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 184.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 184.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 185.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 186.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 187.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 188.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 188.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 189.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 190.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 190.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 191.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 192.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 193.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 193.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 195.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 196.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 197.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 199.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 199.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 200.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 201.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 201.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 202.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 204.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 204.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 206.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 206.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 207.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 208.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 208.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 209.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 210.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 210.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 211.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 212.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 212.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 213.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 214.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 214.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 215.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 216, y: 3.68627450980392, size: 1 },
    //     { x: 217.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 218.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 219.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 219.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 220.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 222.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 223.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 223.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 224.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 225.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 227.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 228.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 228.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 229.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 230.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 231.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 232.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 233.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 234.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 234.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 236.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 237.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 238.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 239.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 240, y: 3.25490196078431, size: 1 },
    //     { x: 240.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 241.297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 241.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 242.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 243.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 243.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 244.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 245.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 247.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 249.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 249.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 250.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 251.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 251.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 252.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 253.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 254.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 254.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 255.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 256.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 256.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 257.513513513513, y: 3.64705882352941, size: 1 },
    //     { x: 258.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 260.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 260.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 261.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 262.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 262.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 263.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 264, y: 3.13725490196078, size: 1 },
    //     { x: 264.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 265.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 265.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 267.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 268.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 269.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 270.486486486487, y: 3.56862745098039, size: 1 },
    //     { x: 271.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 271.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 273.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 274.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 275.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 276.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 278.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 279.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 280.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 281.513513513513, y: 3.45098039215686, size: 1 },
    //     { x: 282.162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 282.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 283.459459459459, y: 2.66666666666667, size: 1 },
    //     { x: 284.108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 284.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 285.405405405405, y: 2.54901960784314, size: 1 },
    //     { x: 286.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 286.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 288, y: 3.6078431372549, size: 1 },
    //     { x: 288.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 289.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 291.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 293.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 293.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 294.486486486487, y: 3.76470588235294, size: 1 },
    //     { x: 295.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 296.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 297.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 299.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 302.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 302.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 303.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 304.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 304.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 305.513513513513, y: 3.45098039215686, size: 1 },
    //     { x: 306.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 306.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 308.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 308.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 310.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 310.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 311.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 312, y: 3.33333333333333, size: 1 },
    //     { x: 312.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 313.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 313.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 315.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 315.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 316.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 317.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 317.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 318.486486486487, y: 3.52941176470588, size: 1 },
    //     { x: 319.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 319.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 320.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 321.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 321.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 322.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 323.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 324.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 324.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 325.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 326.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 327.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 328.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 330.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 331.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 332.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 332.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 333.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 335.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 336, y: 3.56862745098039, size: 1 },
    //     { x: 336.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 337.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 337.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 338.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 339.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 339.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 340.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 341.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 341.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 342.486486486487, y: 3.64705882352941, size: 1 },
    //     { x: 345.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 346.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 347.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 348.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 348.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 349.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 350.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 350.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 351.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 352.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 352.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 353.513513513513, y: 3.72549019607843, size: 1 },
    //     { x: 354.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 354.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 355.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 356.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 356.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 357.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 358.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 358.702702702703, y: 4, size: 1 },
    //     { x: 359.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 1.29496402877698, y: 3.72549019607843, size: 1 },
    //     { x: 1.94244604316547, y: 3.80392156862745, size: 1 },
    //     { x: 5.8273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 6.47482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 7.76978417266187, y: 3.84313725490196, size: 1 },
    //     { x: 10.3597122302158, y: 3.37254901960784, size: 1 },
    //     { x: 12.3021582733813, y: 3.80392156862745, size: 1 },
    //     { x: 13.5971223021583, y: 3.41176470588235, size: 1 },
    //     { x: 16.8345323741007, y: 3.88235294117647, size: 1 },
    //     { x: 18.1294964028777, y: 3.64705882352941, size: 1 },
    //     { x: 21.3669064748201, y: 3.88235294117647, size: 1 },
    //     { x: 23.9568345323741, y: 3.49019607843137, size: 1 },
    //     { x: 25.2517985611511, y: 3.56862745098039, size: 1 },
    //     { x: 25.8992805755396, y: 3.72549019607843, size: 1 },
    //     { x: 27.1942446043165, y: 3.80392156862745, size: 1 },
    //     { x: 31.0791366906475, y: 3.17647058823529, size: 1 },
    //     { x: 31.726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 32.3741007194245, y: 3.17647058823529, size: 1 },
    //     { x: 33.0215827338129, y: 3.68627450980392, size: 1 },
    //     { x: 33.6690647482014, y: 3.88235294117647, size: 1 },
    //     { x: 34.9640287769784, y: 3.6078431372549, size: 1 },
    //     { x: 36.2589928057554, y: 3.76470588235294, size: 1 },
    //     { x: 39.4964028776978, y: 3.92156862745098, size: 1 },
    //     { x: 41.4388489208633, y: 3.56862745098039, size: 1 },
    //     { x: 42.0863309352518, y: 3.76470588235294, size: 1 },
    //     { x: 42.7338129496403, y: 3.72549019607843, size: 1 },
    //     { x: 44.6762589928058, y: 3.92156862745098, size: 1 },
    //     { x: 45.3237410071942, y: 3.84313725490196, size: 1 },
    //     { x: 46.6187050359712, y: 3.72549019607843, size: 1 },
    //     { x: 48.5611510791367, y: 3.88235294117647, size: 1 },
    //     { x: 53.0935251798561, y: 3.49019607843137, size: 1 },
    //     { x: 53.7410071942446, y: 3.45098039215686, size: 1 },
    //     { x: 60.863309352518, y: 3.72549019607843, size: 1 },
    //     { x: 62.8057553956835, y: 3.80392156862745, size: 1 },
    //     { x: 63.4532374100719, y: 3.64705882352941, size: 1 },
    //     { x: 64.1007194244604, y: 3.41176470588235, size: 1 },
    //     { x: 65.3956834532374, y: 3.68627450980392, size: 1 },
    //     { x: 67.9856115107914, y: 3.76470588235294, size: 1 },
    //     { x: 69.9280575539568, y: 3.76470588235294, size: 1 },
    //     { x: 76.4028776978417, y: 3.41176470588235, size: 1 },
    //     { x: 77.6978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 80.9352517985612, y: 3.68627450980392, size: 1 },
    //     { x: 82.8776978417266, y: 3.80392156862745, size: 1 },
    //     { x: 84.8201438848921, y: 3.64705882352941, size: 1 },
    //     { x: 85.4676258992806, y: 3.45098039215686, size: 1 },
    //     { x: 86.7625899280576, y: 3.88235294117647, size: 1 },
    //     { x: 88.0575539568345, y: 3.76470588235294, size: 1 },
    //     { x: 91.294964028777, y: 3.64705882352941, size: 1 },
    //     { x: 91.9424460431655, y: 3.52941176470588, size: 1 },
    //     { x: 93.8848920863309, y: 3.56862745098039, size: 1 },
    //     { x: 94.5323741007194, y: 3.37254901960784, size: 1 },
    //     { x: 96.4748201438849, y: 3.45098039215686, size: 1 },
    //     { x: 97.7697841726619, y: 3.64705882352941, size: 1 },
    //     { x: 99.7122302158273, y: 3.52941176470588, size: 1 },
    //     { x: 101.007194244604, y: 3.52941176470588, size: 1 },
    //     { x: 102.94964028777, y: 3.56862745098039, size: 1 },
    //     { x: 103.597122302158, y: 3.52941176470588, size: 1 },
    //     { x: 104.244604316547, y: 3.6078431372549, size: 1 },
    //     { x: 104.892086330935, y: 3.49019607843137, size: 1 },
    //     { x: 107.482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 110.071942446043, y: 3.45098039215686, size: 1 },
    //     { x: 111.36690647482, y: 3.64705882352941, size: 1 },
    //     { x: 112.661870503597, y: 3.72549019607843, size: 1 },
    //     { x: 113.956834532374, y: 3.45098039215686, size: 1 },
    //     { x: 114.604316546763, y: 3.56862745098039, size: 1 },
    //     { x: 115.251798561151, y: 3.37254901960784, size: 1 },
    //     { x: 115.89928057554, y: 3.45098039215686, size: 1 },
    //     { x: 117.841726618705, y: 3.09803921568627, size: 1 },
    //     { x: 118.489208633094, y: 2.94117647058824, size: 1 },
    //     { x: 119.136690647482, y: 3.45098039215686, size: 1 },
    //     { x: 120.431654676259, y: 3.37254901960784, size: 1 },
    //     { x: 121.726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 123.669064748201, y: 3.76470588235294, size: 1 },
    //     { x: 124.31654676259, y: 3.6078431372549, size: 1 },
    //     { x: 126.258992805755, y: 3.37254901960784, size: 1 },
    //     { x: 128.201438848921, y: 3.72549019607843, size: 1 },
    //     { x: 128.848920863309, y: 3.33333333333333, size: 1 },
    //     { x: 130.791366906475, y: 3.52941176470588, size: 1 },
    //     { x: 132.73381294964, y: 3.72549019607843, size: 1 },
    //     { x: 133.381294964029, y: 3.45098039215686, size: 1 },
    //     { x: 136.618705035971, y: 3.64705882352941, size: 1 },
    //     { x: 137.26618705036, y: 3.56862745098039, size: 1 },
    //     { x: 139.208633093525, y: 3.49019607843137, size: 1 },
    //     { x: 139.856115107914, y: 3.13725490196078, size: 1 },
    //     { x: 140.503597122302, y: 3.09803921568627, size: 1 },
    //     { x: 141.151079136691, y: 2.94117647058824, size: 1 },
    //     { x: 141.798561151079, y: 2.86274509803922, size: 1 },
    //     { x: 142.446043165468, y: 3.80392156862745, size: 1 },
    //     { x: 147.625899280576, y: 3.84313725490196, size: 1 },
    //     { x: 150.215827338129, y: 3.49019607843137, size: 1 },
    //     { x: 150.863309352518, y: 3.72549019607843, size: 1 },
    //     { x: 155.395683453237, y: 3.72549019607843, size: 1 },
    //     { x: 156.043165467626, y: 3.68627450980392, size: 1 },
    //     { x: 157.338129496403, y: 3.84313725490196, size: 1 },
    //     { x: 160.575539568345, y: 3.49019607843137, size: 1 },
    //     { x: 161.870503597122, y: 3.6078431372549, size: 1 },
    //     { x: 162.517985611511, y: 3.64705882352941, size: 1 },
    //     { x: 165.107913669065, y: 3.80392156862745, size: 1 },
    //     { x: 167.05035971223, y: 3.56862745098039, size: 1 },
    //     { x: 167.697841726619, y: 3.68627450980392, size: 1 },
    //     { x: 168.345323741007, y: 3.6078431372549, size: 1 },
    //     { x: 170.287769784173, y: 3.92156862745098, size: 1 },
    //     { x: 174.172661870504, y: 3.64705882352941, size: 1 },
    //     { x: 175.467625899281, y: 3.84313725490196, size: 1 },
    //     { x: 176.115107913669, y: 4.03921568627451, size: 1 },
    //     { x: 177.410071942446, y: 3.80392156862745, size: 1 },
    //     { x: 178.057553956835, y: 4, size: 1 },
    //     { x: 180.647482014388, y: 3.6078431372549, size: 1 },
    //     { x: 181.294964028777, y: 3.33333333333333, size: 1 },
    //     { x: 181.942446043165, y: 3.6078431372549, size: 1 },
    //     { x: 184.532374100719, y: 3.17647058823529, size: 1 },
    //     { x: 185.179856115108, y: 3.25490196078431, size: 1 },
    //     { x: 187.122302158273, y: 3.33333333333333, size: 1 },
    //     { x: 189.064748201439, y: 3.76470588235294, size: 1 },
    //     { x: 191.654676258993, y: 3.41176470588235, size: 1 },
    //     { x: 192.94964028777, y: 3.52941176470588, size: 1 },
    //     { x: 197.482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 198.776978417266, y: 3.56862745098039, size: 1 },
    //     { x: 205.89928057554, y: 3.56862745098039, size: 1 },
    //     { x: 206.546762589928, y: 3.49019607843137, size: 1 },
    //     { x: 208.489208633094, y: 3.49019607843137, size: 1 },
    //     { x: 209.784172661871, y: 3.80392156862745, size: 1 },
    //     { x: 212.374100719424, y: 3.84313725490196, size: 1 },
    //     { x: 214.964028776978, y: 3.6078431372549, size: 1 },
    //     { x: 215.611510791367, y: 3.68627450980392, size: 1 },
    //     { x: 216.258992805755, y: 3.52941176470588, size: 1 },
    //     { x: 216.906474820144, y: 3.72549019607843, size: 1 },
    //     { x: 219.496402877698, y: 3.52941176470588, size: 1 },
    //     { x: 222.73381294964, y: 3.37254901960784, size: 1 },
    //     { x: 223.381294964029, y: 3.72549019607843, size: 1 },
    //     { x: 224.676258992806, y: 3.09803921568627, size: 1 },
    //     { x: 225.971223021583, y: 2.3921568627451, size: 1 },
    //     { x: 226.618705035971, y: 2.15686274509804, size: 1 },
    //     { x: 227.26618705036, y: 2.50980392156863, size: 1 },
    //     { x: 227.913669064748, y: 2.66666666666667, size: 1 },
    //     { x: 230.503597122302, y: 3.68627450980392, size: 1 },
    //     { x: 233.093525179856, y: 3.76470588235294, size: 1 },
    //     { x: 235.68345323741, y: 3.68627450980392, size: 1 },
    //     { x: 240.863309352518, y: 3.84313725490196, size: 1 },
    //     { x: 242.158273381295, y: 3.80392156862745, size: 1 },
    //     { x: 244.10071942446, y: 3.52941176470588, size: 1 },
    //     { x: 244.748201438849, y: 3.52941176470588, size: 1 },
    //     { x: 246.043165467626, y: 3.2156862745098, size: 1 },
    //     { x: 246.690647482014, y: 3.29411764705882, size: 1 },
    //     { x: 247.338129496403, y: 2.82352941176471, size: 1 },
    //     { x: 247.985611510791, y: 2.7843137254902, size: 1 },
    //     { x: 249.280575539568, y: 3.45098039215686, size: 1 },
    //     { x: 251.870503597122, y: 3.37254901960784, size: 1 },
    //     { x: 253.812949640288, y: 3.49019607843137, size: 1 },
    //     { x: 257.05035971223, y: 3.6078431372549, size: 1 },
    //     { x: 258.992805755396, y: 3.52941176470588, size: 1 },
    //     { x: 262.230215827338, y: 3.56862745098039, size: 1 },
    //     { x: 264.172661870504, y: 3.41176470588235, size: 1 },
    //     { x: 265.467625899281, y: 3.25490196078431, size: 1 },
    //     { x: 274.532374100719, y: 3.49019607843137, size: 1 },
    //     { x: 275.179856115108, y: 3.68627450980392, size: 1 },
    //     { x: 275.827338129496, y: 3.76470588235294, size: 1 },
    //     { x: 276.474820143885, y: 3.49019607843137, size: 1 },
    //     { x: 277.122302158273, y: 3.49019607843137, size: 1 },
    //     { x: 278.41726618705, y: 3.84313725490196, size: 1 },
    //     { x: 279.712230215827, y: 3.80392156862745, size: 1 },
    //     { x: 281.007194244604, y: 3.45098039215686, size: 1 },
    //     { x: 282.94964028777, y: 3.64705882352941, size: 1 },
    //     { x: 283.597122302158, y: 3.72549019607843, size: 1 },
    //     { x: 285.539568345324, y: 3.68627450980392, size: 1 },
    //     { x: 286.834532374101, y: 3.72549019607843, size: 1 },
    //     { x: 290.719424460432, y: 3.01960784313725, size: 1 },
    //     { x: 291.36690647482, y: 3.09803921568627, size: 1 },
    //     { x: 292.661870503597, y: 3.6078431372549, size: 1 },
    //     { x: 295.89928057554, y: 3.76470588235294, size: 1 },
    //     { x: 296.546762589928, y: 3.72549019607843, size: 1 },
    //     { x: 297.194244604317, y: 3.88235294117647, size: 1 },
    //     { x: 297.841726618705, y: 3.45098039215686, size: 1 },
    //     { x: 299.136690647482, y: 3.6078431372549, size: 1 },
    //     { x: 300.431654676259, y: 3.52941176470588, size: 1 },
    //     { x: 303.021582733813, y: 3.68627450980392, size: 1 },
    //     { x: 306.258992805755, y: 3.72549019607843, size: 1 },
    //     { x: 306.906474820144, y: 3.72549019607843, size: 1 },
    //     { x: 310.791366906475, y: 3.72549019607843, size: 1 },
    //     { x: 311.438848920863, y: 3.41176470588235, size: 1 },
    //     { x: 312.086330935252, y: 3.49019607843137, size: 1 },
    //     { x: 312.73381294964, y: 3.37254901960784, size: 1 },
    //     { x: 313.381294964029, y: 3.52941176470588, size: 1 },
    //     { x: 314.028776978417, y: 3.45098039215686, size: 1 },
    //     { x: 317.26618705036, y: 3.88235294117647, size: 1 },
    //     { x: 319.856115107914, y: 3.45098039215686, size: 1 },
    //     { x: 321.798561151079, y: 3.37254901960784, size: 1 },
    //     { x: 323.093525179856, y: 3.41176470588235, size: 1 },
    //     { x: 324.388489208633, y: 3.52941176470588, size: 1 },
    //     { x: 326.330935251799, y: 3.25490196078431, size: 1 },
    //     { x: 326.978417266187, y: 3.64705882352941, size: 1 },
    //     { x: 330.863309352518, y: 3.49019607843137, size: 1 },
    //     { x: 332.805755395683, y: 3.29411764705882, size: 1 },
    //     { x: 333.453237410072, y: 3.41176470588235, size: 1 },
    //     { x: 334.748201438849, y: 3.2156862745098, size: 1 },
    //     { x: 339.928057553957, y: 3.72549019607843, size: 1 },
    //     { x: 341.870503597122, y: 3.49019607843137, size: 1 },
    //     { x: 347.05035971223, y: 3.56862745098039, size: 1 },
    //     { x: 350.287769784173, y: 3.41176470588235, size: 1 },
    //     { x: 351.58273381295, y: 3.29411764705882, size: 1 },
    //     { x: 352.877697841727, y: 3.6078431372549, size: 1 },
    //     { x: 355.467625899281, y: 3.33333333333333, size: 1 },
    //     { x: 359.352517985611, y: 3.41176470588235, size: 1 },
    //     { x: 0, y: 3.80392156862745, size: 1 },
    //     { x: 3.23741007194245, y: 3.37254901960784, size: 1 },
    //     { x: 4.53237410071942, y: 3.41176470588235, size: 1 },
    //     { x: 7.12230215827338, y: 3.49019607843137, size: 1 },
    //     { x: 11.0071942446043, y: 3.41176470588235, size: 1 },
    //     { x: 14.8920863309353, y: 3.37254901960784, size: 1 },
    //     { x: 15.5395683453237, y: 3.6078431372549, size: 1 },
    //     { x: 16.8345323741007, y: 3.01960784313725, size: 1 },
    //     { x: 17.4820143884892, y: 3.05882352941176, size: 1 },
    //     { x: 18.1294964028777, y: 3.17647058823529, size: 1 },
    //     { x: 18.7769784172662, y: 3.25490196078431, size: 1 },
    //     { x: 20.0719424460432, y: 3.45098039215686, size: 1 },
    //     { x: 20.7194244604317, y: 3.45098039215686, size: 1 },
    //     { x: 22.6618705035971, y: 3.45098039215686, size: 1 },
    //     { x: 23.9568345323741, y: 3.41176470588235, size: 1 },
    //     { x: 26.5467625899281, y: 3.49019607843137, size: 1 },
    //     { x: 39.4964028776978, y: 3.29411764705882, size: 1 },
    //     { x: 40.1438848920863, y: 3.25490196078431, size: 1 },
    //     { x: 40.7913669064748, y: 3.25490196078431, size: 1 },
    //     { x: 42.0863309352518, y: 3.2156862745098, size: 1 },
    //     { x: 42.7338129496403, y: 3.2156862745098, size: 1 },
    //     { x: 44.6762589928058, y: 3.37254901960784, size: 1 },
    //     { x: 45.3237410071942, y: 3.2156862745098, size: 1 },
    //     { x: 47.2661870503597, y: 3.37254901960784, size: 1 },
    //     { x: 48.5611510791367, y: 3.29411764705882, size: 1 },
    //     { x: 49.8561151079137, y: 3.2156862745098, size: 1 },
    //     { x: 51.1510791366906, y: 3.13725490196078, size: 1 },
    //     { x: 51.7985611510791, y: 3.17647058823529, size: 1 },
    //     { x: 52.4460431654676, y: 3.41176470588235, size: 1 },
    //     { x: 53.0935251798561, y: 3.41176470588235, size: 1 },
    //     { x: 55.6834532374101, y: 3.41176470588235, size: 1 },
    //     { x: 56.3309352517986, y: 3.25490196078431, size: 1 },
    //     { x: 57.6258992805755, y: 3.29411764705882, size: 1 },
    //     { x: 60.863309352518, y: 3.41176470588235, size: 1 },
    //     { x: 64.7482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 66.0431654676259, y: 3.45098039215686, size: 1 },
    //     { x: 67.3381294964029, y: 3.25490196078431, size: 1 },
    //     { x: 68.6330935251799, y: 3.29411764705882, size: 1 },
    //     { x: 69.9280575539568, y: 3.49019607843137, size: 1 },
    //     { x: 70.5755395683453, y: 3.80392156862745, size: 1 },
    //     { x: 71.2230215827338, y: 3.52941176470588, size: 1 },
    //     { x: 72.5179856115108, y: 3.41176470588235, size: 1 },
    //     { x: 75.1079136690647, y: 3.49019607843137, size: 1 },
    //     { x: 76.4028776978417, y: 3.68627450980392, size: 1 },
    //     { x: 77.6978417266187, y: 3.41176470588235, size: 1 },
    //     { x: 79.6402877697842, y: 3.56862745098039, size: 1 },
    //     { x: 81.5827338129496, y: 3.29411764705882, size: 1 },
    //     { x: 82.2302158273381, y: 2.90196078431373, size: 1 },
    //     { x: 82.8776978417266, y: 3.25490196078431, size: 1 },
    //     { x: 86.1151079136691, y: 3.92156862745098, size: 1 },
    //     { x: 91.294964028777, y: 4.03921568627451, size: 1 },
    //     { x: 91.9424460431655, y: 3.92156862745098, size: 1 },
    //     { x: 93.8848920863309, y: 3.92156862745098, size: 1 },
    //     { x: 95.8273381294964, y: 3.68627450980392, size: 1 },
    //     { x: 96.4748201438849, y: 3.49019607843137, size: 1 },
    //     { x: 100.359712230216, y: 3.80392156862745, size: 1 },
    //     { x: 101.654676258993, y: 3.41176470588235, size: 1 },
    //     { x: 102.94964028777, y: 3.72549019607843, size: 1 },
    //     { x: 105.539568345324, y: 3.64705882352941, size: 1 },
    //     { x: 106.187050359712, y: 3.45098039215686, size: 1 },
    //     { x: 107.482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 108.129496402878, y: 3.41176470588235, size: 1 },
    //     { x: 110.071942446043, y: 3.52941176470588, size: 1 },
    //     { x: 110.719424460432, y: 3.45098039215686, size: 1 },
    //     { x: 117.841726618705, y: 3.72549019607843, size: 1 },
    //     { x: 118.489208633094, y: 3.56862745098039, size: 1 },
    //     { x: 120.431654676259, y: 3.64705882352941, size: 1 },
    //     { x: 121.079136690647, y: 3.64705882352941, size: 1 },
    //     { x: 122.374100719424, y: 3.84313725490196, size: 1 },
    //     { x: 125.611510791367, y: 3.29411764705882, size: 1 },
    //     { x: 133.381294964029, y: 3.72549019607843, size: 1 },
    //     { x: 137.913669064748, y: 3.56862745098039, size: 1 },
    //     { x: 139.208633093525, y: 3.68627450980392, size: 1 },
    //     { x: 140.503597122302, y: 3.6078431372549, size: 1 },
    //     { x: 141.151079136691, y: 3.33333333333333, size: 1 },
    //     { x: 142.446043165468, y: 3.41176470588235, size: 1 },
    //     { x: 146.330935251799, y: 3.25490196078431, size: 1 },
    //     { x: 146.978417266187, y: 3.33333333333333, size: 1 },
    //     { x: 147.625899280576, y: 3.37254901960784, size: 1 },
    //     { x: 148.273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 148.920863309353, y: 3.17647058823529, size: 1 },
    //     { x: 149.568345323741, y: 3.64705882352941, size: 1 },
    //     { x: 150.863309352518, y: 3.76470588235294, size: 1 },
    //     { x: 152.158273381295, y: 3.52941176470588, size: 1 },
    //     { x: 153.453237410072, y: 3.72549019607843, size: 1 },
    //     { x: 155.395683453237, y: 3.49019607843137, size: 1 },
    //     { x: 156.043165467626, y: 3.49019607843137, size: 1 },
    //     { x: 156.690647482014, y: 3.68627450980392, size: 1 },
    //     { x: 157.338129496403, y: 3.45098039215686, size: 1 },
    //     { x: 162.517985611511, y: 3.49019607843137, size: 1 },
    //     { x: 163.812949640288, y: 3.41176470588235, size: 1 },
    //     { x: 165.755395683453, y: 3.92156862745098, size: 1 },
    //     { x: 166.402877697842, y: 3.33333333333333, size: 1 },
    //     { x: 167.05035971223, y: 3.25490196078431, size: 1 },
    //     { x: 167.697841726619, y: 3.01960784313725, size: 1 },
    //     { x: 168.345323741007, y: 3.05882352941176, size: 1 },
    //     { x: 169.640287769784, y: 2.94117647058824, size: 1 },
    //     { x: 170.287769784173, y: 2.58823529411765, size: 1 },
    //     { x: 170.935251798561, y: 3.49019607843137, size: 1 },
    //     { x: 172.877697841727, y: 3.49019607843137, size: 1 },
    //     { x: 176.115107913669, y: 3.84313725490196, size: 1 },
    //     { x: 178.057553956835, y: 3.56862745098039, size: 1 },
    //     { x: 180.647482014388, y: 3.80392156862745, size: 1 },
    //     { x: 182.589928057554, y: 3.76470588235294, size: 1 },
    //     { x: 187.122302158273, y: 3.45098039215686, size: 1 },
    //     { x: 189.064748201439, y: 3.25490196078431, size: 1 },
    //     { x: 190.359712230216, y: 3.05882352941176, size: 1 },
    //     { x: 191.007194244604, y: 3.2156862745098, size: 1 },
    //     { x: 191.654676258993, y: 3.29411764705882, size: 1 },
    //     { x: 192.302158273381, y: 3.84313725490196, size: 1 },
    //     { x: 193.597122302158, y: 3.96078431372549, size: 1 },
    //     { x: 194.892086330935, y: 3.80392156862745, size: 1 },
    //     { x: 197.482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 200.071942446043, y: 3.88235294117647, size: 1 },
    //     { x: 203.956834532374, y: 3.96078431372549, size: 1 },
    //     { x: 209.784172661871, y: 3.13725490196078, size: 1 },
    //     { x: 210.431654676259, y: 3.41176470588235, size: 1 },
    //     { x: 211.726618705036, y: 2.82352941176471, size: 1 },
    //     { x: 212.374100719424, y: 2.90196078431373, size: 1 },
    //     { x: 213.021582733813, y: 2.94117647058824, size: 1 },
    //     { x: 216.258992805755, y: 3.76470588235294, size: 1 },
    //     { x: 217.553956834532, y: 3.41176470588235, size: 1 },
    //     { x: 218.848920863309, y: 3.6078431372549, size: 1 },
    //     { x: 221.438848920863, y: 3.6078431372549, size: 1 },
    //     { x: 224.676258992806, y: 3.52941176470588, size: 1 },
    //     { x: 225.323741007194, y: 3.68627450980392, size: 1 },
    //     { x: 228.561151079137, y: 3.6078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.64705882352941, size: 1 },
    //     { x: 233.741007194245, y: 3.2156862745098, size: 1 },
    //     { x: 234.388489208633, y: 3.56862745098039, size: 1 },
    //     { x: 235.68345323741, y: 3.49019607843137, size: 1 },
    //     { x: 236.978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 242.805755395683, y: 3.49019607843137, size: 1 },
    //     { x: 243.453237410072, y: 3.76470588235294, size: 1 },
    //     { x: 247.338129496403, y: 3.68627450980392, size: 1 },
    //     { x: 252.517985611511, y: 3.56862745098039, size: 1 },
    //     { x: 255.107913669065, y: 3.68627450980392, size: 1 },
    //     { x: 257.697841726619, y: 3.72549019607843, size: 1 },
    //     { x: 261.58273381295, y: 3.80392156862745, size: 1 },
    //     { x: 262.877697841727, y: 3.88235294117647, size: 1 },
    //     { x: 264.172661870504, y: 3.45098039215686, size: 1 },
    //     { x: 266.115107913669, y: 3.84313725490196, size: 1 },
    //     { x: 268.057553956835, y: 3.68627450980392, size: 1 },
    //     { x: 270, y: 3.84313725490196, size: 1 },
    //     { x: 271.294964028777, y: 3.88235294117647, size: 1 },
    //     { x: 273.884892086331, y: 3.49019607843137, size: 1 },
    //     { x: 274.532374100719, y: 3.41176470588235, size: 1 },
    //     { x: 275.179856115108, y: 3.41176470588235, size: 1 },
    //     { x: 275.827338129496, y: 3.37254901960784, size: 1 },
    //     { x: 277.122302158273, y: 3.37254901960784, size: 1 },
    //     { x: 279.064748201439, y: 3.2156862745098, size: 1 },
    //     { x: 279.712230215827, y: 3.49019607843137, size: 1 },
    //     { x: 280.359712230216, y: 3.33333333333333, size: 1 },
    //     { x: 281.007194244604, y: 3.41176470588235, size: 1 },
    //     { x: 283.597122302158, y: 3.37254901960784, size: 1 },
    //     { x: 284.244604316547, y: 3.41176470588235, size: 1 },
    //     { x: 286.187050359712, y: 3.49019607843137, size: 1 },
    //     { x: 286.834532374101, y: 3.41176470588235, size: 1 },
    //     { x: 292.661870503597, y: 3.52941176470588, size: 1 },
    //     { x: 293.956834532374, y: 3.41176470588235, size: 1 },
    //     { x: 294.604316546763, y: 3.29411764705882, size: 1 },
    //     { x: 297.194244604317, y: 3.92156862745098, size: 1 },
    //     { x: 298.489208633094, y: 3.80392156862745, size: 1 },
    //     { x: 301.079136690647, y: 3.72549019607843, size: 1 },
    //     { x: 305.611510791367, y: 3.56862745098039, size: 1 },
    //     { x: 307.553956834532, y: 3.6078431372549, size: 1 },
    //     { x: 308.848920863309, y: 4, size: 1 },
    //     { x: 312.73381294964, y: 3.76470588235294, size: 1 },
    //     { x: 313.381294964029, y: 3.84313725490196, size: 1 },
    //     { x: 314.676258992806, y: 3.72549019607843, size: 1 },
    //     { x: 315.323741007194, y: 3.52941176470588, size: 1 },
    //     { x: 317.26618705036, y: 3.52941176470588, size: 1 },
    //     { x: 319.208633093525, y: 3.29411764705882, size: 1 },
    //     { x: 320.503597122302, y: 3.33333333333333, size: 1 },
    //     { x: 322.446043165468, y: 3.41176470588235, size: 1 },
    //     { x: 325.035971223022, y: 3.33333333333333, size: 1 },
    //     { x: 332.158273381295, y: 3.41176470588235, size: 1 },
    //     { x: 333.453237410072, y: 3.45098039215686, size: 1 },
    //     { x: 334.10071942446, y: 3.41176470588235, size: 1 },
    //     { x: 335.395683453237, y: 3.68627450980392, size: 1 },
    //     { x: 337.985611510791, y: 3.68627450980392, size: 1 },
    //     { x: 341.223021582734, y: 3.29411764705882, size: 1 },
    //     { x: 341.870503597122, y: 3.76470588235294, size: 1 },
    //     { x: 342.517985611511, y: 3.80392156862745, size: 1 },
    //     { x: 343.165467625899, y: 3.80392156862745, size: 1 },
    //     { x: 343.812949640288, y: 3.64705882352941, size: 1 },
    //     { x: 345.107913669065, y: 3.64705882352941, size: 1 },
    //     { x: 347.697841726619, y: 3.6078431372549, size: 1 },
    //     { x: 348.345323741007, y: 3.92156862745098, size: 1 },
    //     { x: 348.992805755396, y: 4, size: 1 },
    //     { x: 353.525179856115, y: 3.84313725490196, size: 1 },
    //     { x: 357.410071942446, y: 3.72549019607843, size: 1 },
    //     { x: 0, y: 3.72549019607843, size: 1 },
    //     { x: 0.647482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 2.58992805755396, y: 3.37254901960784, size: 1 },
    //     { x: 3.23741007194245, y: 3.72549019607843, size: 1 },
    //     { x: 4.53237410071942, y: 3.64705882352941, size: 1 },
    //     { x: 5.17985611510791, y: 3.84313725490196, size: 1 },
    //     { x: 6.47482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 8.41726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 10.3597122302158, y: 3.45098039215686, size: 1 },
    //     { x: 11.0071942446043, y: 3.80392156862745, size: 1 },
    //     { x: 18.1294964028777, y: 3.88235294117647, size: 1 },
    //     { x: 18.7769784172662, y: 3.72549019607843, size: 1 },
    //     { x: 19.4244604316547, y: 3.80392156862745, size: 1 },
    //     { x: 25.2517985611511, y: 3.76470588235294, size: 1 },
    //     { x: 25.8992805755396, y: 3.80392156862745, size: 1 },
    //     { x: 26.5467625899281, y: 3.80392156862745, size: 1 },
    //     { x: 27.1942446043165, y: 3.76470588235294, size: 1 },
    //     { x: 30.431654676259, y: 3.6078431372549, size: 1 },
    //     { x: 32.3741007194245, y: 3.76470588235294, size: 1 },
    //     { x: 34.3165467625899, y: 3.84313725490196, size: 1 },
    //     { x: 35.6115107913669, y: 3.72549019607843, size: 1 },
    //     { x: 38.2014388489209, y: 3.88235294117647, size: 1 },
    //     { x: 38.8489208633094, y: 3.76470588235294, size: 1 },
    //     { x: 40.1438848920863, y: 3.72549019607843, size: 1 },
    //     { x: 43.3812949640288, y: 3.88235294117647, size: 1 },
    //     { x: 44.0287769784173, y: 3.72549019607843, size: 1 },
    //     { x: 45.3237410071942, y: 3.56862745098039, size: 1 },
    //     { x: 45.9712230215827, y: 3.25490196078431, size: 1 },
    //     { x: 47.2661870503597, y: 3.13725490196078, size: 1 },
    //     { x: 51.7985611510791, y: 3.64705882352941, size: 1 },
    //     { x: 53.0935251798561, y: 3.68627450980392, size: 1 },
    //     { x: 58.273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 58.9208633093525, y: 3.96078431372549, size: 1 },
    //     { x: 60.2158273381295, y: 3.92156862745098, size: 1 },
    //     { x: 61.5107913669065, y: 3.41176470588235, size: 1 },
    //     { x: 64.1007194244604, y: 3.80392156862745, size: 1 },
    //     { x: 67.3381294964029, y: 2.74509803921569, size: 1 },
    //     { x: 67.9856115107914, y: 2.74509803921569, size: 1 },
    //     { x: 69.2805755395683, y: 2.7843137254902, size: 1 },
    //     { x: 69.9280575539568, y: 3.33333333333333, size: 1 },
    //     { x: 78.9928057553957, y: 3.41176470588235, size: 1 },
    //     { x: 80.2877697841727, y: 3.49019607843137, size: 1 },
    //     { x: 81.5827338129496, y: 3.56862745098039, size: 1 },
    //     { x: 82.8776978417266, y: 3.56862745098039, size: 1 },
    //     { x: 83.5251798561151, y: 3.45098039215686, size: 1 },
    //     { x: 86.7625899280576, y: 3.29411764705882, size: 1 },
    //     { x: 88.0575539568345, y: 3.45098039215686, size: 1 },
    //     { x: 88.705035971223, y: 3.01960784313725, size: 1 },
    //     { x: 89.3525179856115, y: 2.98039215686275, size: 1 },
    //     { x: 90, y: 2.94117647058824, size: 1 },
    //     { x: 91.294964028777, y: 3.37254901960784, size: 1 },
    //     { x: 98.4172661870504, y: 3.56862745098039, size: 1 },
    //     { x: 104.244604316547, y: 3.49019607843137, size: 1 },
    //     { x: 105.539568345324, y: 3.37254901960784, size: 1 },
    //     { x: 108.129496402878, y: 3.68627450980392, size: 1 },
    //     { x: 112.014388489209, y: 3.33333333333333, size: 1 },
    //     { x: 113.309352517986, y: 3.33333333333333, size: 1 },
    //     { x: 115.89928057554, y: 3.25490196078431, size: 1 },
    //     { x: 116.546762589928, y: 3.2156862745098, size: 1 },
    //     { x: 117.194244604317, y: 3.17647058823529, size: 1 },
    //     { x: 118.489208633094, y: 3.29411764705882, size: 1 },
    //     { x: 121.726618705036, y: 3.17647058823529, size: 1 },
    //     { x: 123.021582733813, y: 3.41176470588235, size: 1 },
    //     { x: 123.669064748201, y: 3.25490196078431, size: 1 },
    //     { x: 124.31654676259, y: 3.2156862745098, size: 1 },
    //     { x: 128.201438848921, y: 3.49019607843137, size: 1 },
    //     { x: 128.848920863309, y: 3.37254901960784, size: 1 },
    //     { x: 129.496402877698, y: 3.29411764705882, size: 1 },
    //     { x: 135.323741007194, y: 3.45098039215686, size: 1 },
    //     { x: 135.971223021583, y: 3.45098039215686, size: 1 },
    //     { x: 136.618705035971, y: 3.49019607843137, size: 1 },
    //     { x: 137.913669064748, y: 3.49019607843137, size: 1 },
    //     { x: 141.151079136691, y: 3.72549019607843, size: 1 },
    //     { x: 151.510791366906, y: 3.33333333333333, size: 1 },
    //     { x: 152.805755395683, y: 3.33333333333333, size: 1 },
    //     { x: 153.453237410072, y: 2.54901960784314, size: 1 },
    //     { x: 154.10071942446, y: 2.50980392156863, size: 1 },
    //     { x: 154.748201438849, y: 2.86274509803922, size: 1 },
    //     { x: 155.395683453237, y: 2.43137254901961, size: 1 },
    //     { x: 156.043165467626, y: 3.56862745098039, size: 1 },
    //     { x: 161.223021582734, y: 3.68627450980392, size: 1 },
    //     { x: 162.517985611511, y: 3.56862745098039, size: 1 },
    //     { x: 163.812949640288, y: 3.84313725490196, size: 1 },
    //     { x: 169.640287769784, y: 3.80392156862745, size: 1 },
    //     { x: 171.58273381295, y: 3.76470588235294, size: 1 },
    //     { x: 173.525179856115, y: 3.33333333333333, size: 1 },
    //     { x: 174.820143884892, y: 3.56862745098039, size: 1 },
    //     { x: 176.115107913669, y: 3.2156862745098, size: 1 },
    //     { x: 176.762589928058, y: 3.17647058823529, size: 1 },
    //     { x: 177.410071942446, y: 3.68627450980392, size: 1 },
    //     { x: 179.352517985612, y: 3.64705882352941, size: 1 },
    //     { x: 181.294964028777, y: 3.84313725490196, size: 1 },
    //     { x: 181.942446043165, y: 3.33333333333333, size: 1 },
    //     { x: 182.589928057554, y: 3.68627450980392, size: 1 },
    //     { x: 187.122302158273, y: 3.49019607843137, size: 1 },
    //     { x: 188.41726618705, y: 3.80392156862745, size: 1 },
    //     { x: 190.359712230216, y: 3.84313725490196, size: 1 },
    //     { x: 191.654676258993, y: 3.76470588235294, size: 1 },
    //     { x: 194.892086330935, y: 3.49019607843137, size: 1 },
    //     { x: 195.539568345324, y: 3.56862745098039, size: 1 },
    //     { x: 196.187050359712, y: 3.37254901960784, size: 1 },
    //     { x: 196.834532374101, y: 2.86274509803922, size: 1 },
    //     { x: 197.482014388489, y: 3.09803921568627, size: 1 },
    //     { x: 198.129496402878, y: 3.09803921568627, size: 1 },
    //     { x: 198.776978417266, y: 3.09803921568627, size: 1 },
    //     { x: 200.071942446043, y: 3.56862745098039, size: 1 },
    //     { x: 202.661870503597, y: 3.41176470588235, size: 1 },
    //     { x: 209.136690647482, y: 3.72549019607843, size: 1 },
    //     { x: 210.431654676259, y: 3.49019607843137, size: 1 },
    //     { x: 211.079136690647, y: 3.68627450980392, size: 1 },
    //     { x: 213.021582733813, y: 3.56862745098039, size: 1 },
    //     { x: 215.611510791367, y: 3.72549019607843, size: 1 },
    //     { x: 218.201438848921, y: 3.17647058823529, size: 1 },
    //     { x: 218.848920863309, y: 3.2156862745098, size: 1 },
    //     { x: 220.143884892086, y: 3.2156862745098, size: 1 },
    //     { x: 220.791366906475, y: 3.49019607843137, size: 1 },
    //     { x: 224.028776978417, y: 3.72549019607843, size: 1 },
    //     { x: 225.323741007194, y: 3.76470588235294, size: 1 },
    //     { x: 227.26618705036, y: 3.80392156862745, size: 1 },
    //     { x: 228.561151079137, y: 3.68627450980392, size: 1 },
    //     { x: 233.741007194245, y: 3.49019607843137, size: 1 },
    //     { x: 234.388489208633, y: 3.52941176470588, size: 1 },
    //     { x: 235.68345323741, y: 3.88235294117647, size: 1 },
    //     { x: 237.625899280576, y: 3.49019607843137, size: 1 },
    //     { x: 238.920863309353, y: 3.33333333333333, size: 1 },
    //     { x: 239.568345323741, y: 3.33333333333333, size: 1 },
    //     { x: 241.510791366906, y: 3.45098039215686, size: 1 },
    //     { x: 242.158273381295, y: 3.49019607843137, size: 1 },
    //     { x: 244.748201438849, y: 3.49019607843137, size: 1 },
    //     { x: 245.395683453237, y: 3.52941176470588, size: 1 },
    //     { x: 251.223021582734, y: 3.6078431372549, size: 1 },
    //     { x: 255.755395683453, y: 3.72549019607843, size: 1 },
    //     { x: 257.05035971223, y: 3.45098039215686, size: 1 },
    //     { x: 259.640287769784, y: 3.41176470588235, size: 1 },
    //     { x: 260.287769784173, y: 3.41176470588235, size: 1 },
    //     { x: 260.935251798561, y: 3.2156862745098, size: 1 },
    //     { x: 261.58273381295, y: 2.62745098039216, size: 1 },
    //     { x: 262.877697841727, y: 2.94117647058824, size: 1 },
    //     { x: 263.525179856115, y: 3.01960784313725, size: 1 },
    //     { x: 264.820143884892, y: 3.56862745098039, size: 1 },
    //     { x: 265.467625899281, y: 3.6078431372549, size: 1 },
    //     { x: 266.115107913669, y: 3.56862745098039, size: 1 },
    //     { x: 267.410071942446, y: 3.68627450980392, size: 1 },
    //     { x: 271.942446043165, y: 3.56862745098039, size: 1 },
    //     { x: 272.589928057554, y: 3.76470588235294, size: 1 },
    //     { x: 273.884892086331, y: 3.80392156862745, size: 1 },
    //     { x: 278.41726618705, y: 3.76470588235294, size: 1 },
    //     { x: 279.064748201439, y: 3.49019607843137, size: 1 },
    //     { x: 281.654676258993, y: 3.49019607843137, size: 1 },
    //     { x: 284.244604316547, y: 3.76470588235294, size: 1 },
    //     { x: 286.187050359712, y: 3.88235294117647, size: 1 },
    //     { x: 288.129496402878, y: 3.72549019607843, size: 1 },
    //     { x: 290.071942446043, y: 3.72549019607843, size: 1 },
    //     { x: 290.719424460432, y: 3.45098039215686, size: 1 },
    //     { x: 292.661870503597, y: 3.56862745098039, size: 1 },
    //     { x: 293.309352517986, y: 3.76470588235294, size: 1 },
    //     { x: 295.89928057554, y: 3.72549019607843, size: 1 },
    //     { x: 299.136690647482, y: 3.56862745098039, size: 1 },
    //     { x: 299.784172661871, y: 3.72549019607843, size: 1 },
    //     { x: 302.374100719424, y: 3.6078431372549, size: 1 },
    //     { x: 303.021582733813, y: 3.72549019607843, size: 1 },
    //     { x: 304.31654676259, y: 3.52941176470588, size: 1 },
    //     { x: 308.848920863309, y: 3.64705882352941, size: 1 },
    //     { x: 309.496402877698, y: 3.45098039215686, size: 1 },
    //     { x: 312.086330935252, y: 3.76470588235294, size: 1 },
    //     { x: 315.323741007194, y: 3.88235294117647, size: 1 },
    //     { x: 318.561151079137, y: 3.41176470588235, size: 1 },
    //     { x: 321.798561151079, y: 3.52941176470588, size: 1 },
    //     { x: 323.741007194245, y: 3.72549019607843, size: 1 },
    //     { x: 324.388489208633, y: 3.37254901960784, size: 1 },
    //     { x: 325.035971223022, y: 3.29411764705882, size: 1 },
    //     { x: 325.68345323741, y: 3.33333333333333, size: 1 },
    //     { x: 326.978417266187, y: 3.17647058823529, size: 1 },
    //     { x: 327.625899280576, y: 3.29411764705882, size: 1 },
    //     { x: 328.273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 330.215827338129, y: 3.88235294117647, size: 1 },
    //     { x: 331.510791366906, y: 3.72549019607843, size: 1 },
    //     { x: 332.158273381295, y: 3.68627450980392, size: 1 },
    //     { x: 334.748201438849, y: 3.80392156862745, size: 1 },
    //     { x: 336.043165467626, y: 3.88235294117647, size: 1 },
    //     { x: 339.280575539568, y: 3.76470588235294, size: 1 },
    //     { x: 341.223021582734, y: 3.64705882352941, size: 1 },
    //     { x: 345.107913669065, y: 3.76470588235294, size: 1 },
    //     { x: 347.697841726619, y: 3.2156862745098, size: 1 },
    //     { x: 348.345323741007, y: 3.41176470588235, size: 1 },
    //     { x: 348.992805755396, y: 3.01960784313725, size: 1 },
    //     { x: 349.640287769784, y: 2.82352941176471, size: 1 },
    //     { x: 350.287769784173, y: 3.52941176470588, size: 1 },
    //     { x: 352.230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 352.877697841727, y: 3.49019607843137, size: 1 },
    //     { x: 356.762589928058, y: 3.76470588235294, size: 1 },
    //     { x: 358.057553956835, y: 3.76470588235294, size: 1 },
    //     { x: 0.647482014388489, y: 3.68627450980392, size: 1 },
    //     { x: 5.17985611510791, y: 3.80392156862745, size: 1 },
    //     { x: 7.12230215827338, y: 3.56862745098039, size: 1 },
    //     { x: 8.41726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 10.3597122302158, y: 3.84313725490196, size: 1 },
    //     { x: 11.6546762589928, y: 3.96078431372549, size: 1 },
    //     { x: 13.5971223021583, y: 3.72549019607843, size: 1 },
    //     { x: 14.2446043165468, y: 3.72549019607843, size: 1 },
    //     { x: 15.5395683453237, y: 3.56862745098039, size: 1 },
    //     { x: 16.1870503597122, y: 3.88235294117647, size: 1 },
    //     { x: 18.7769784172662, y: 3.84313725490196, size: 1 },
    //     { x: 19.4244604316547, y: 3.88235294117647, size: 1 },
    //     { x: 23.9568345323741, y: 3.80392156862745, size: 1 },
    //     { x: 25.8992805755396, y: 3.76470588235294, size: 1 },
    //     { x: 26.5467625899281, y: 3.76470588235294, size: 1 },
    //     { x: 29.136690647482, y: 3.13725490196078, size: 1 },
    //     { x: 29.7841726618705, y: 3.29411764705882, size: 1 },
    //     { x: 31.726618705036, y: 3.13725490196078, size: 1 },
    //     { x: 32.3741007194245, y: 2.98039215686275, size: 1 },
    //     { x: 36.2589928057554, y: 3.64705882352941, size: 1 },
    //     { x: 38.8489208633094, y: 3.92156862745098, size: 1 },
    //     { x: 39.4964028776978, y: 3.84313725490196, size: 1 },
    //     { x: 41.4388489208633, y: 3.76470588235294, size: 1 },
    //     { x: 42.7338129496403, y: 3.49019607843137, size: 1 },
    //     { x: 44.0287769784173, y: 3.80392156862745, size: 1 },
    //     { x: 47.9136690647482, y: 3.6078431372549, size: 1 },
    //     { x: 51.1510791366906, y: 3.56862745098039, size: 1 },
    //     { x: 53.0935251798561, y: 3.6078431372549, size: 1 },
    //     { x: 64.1007194244604, y: 3.84313725490196, size: 1 },
    //     { x: 69.2805755395683, y: 3.6078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 3.84313725490196, size: 1 },
    //     { x: 75.1079136690647, y: 3.29411764705882, size: 1 },
    //     { x: 75.7553956834532, y: 3.56862745098039, size: 1 },
    //     { x: 78.9928057553957, y: 3.72549019607843, size: 1 },
    //     { x: 82.2302158273381, y: 3.80392156862745, size: 1 },
    //     { x: 82.8776978417266, y: 3.52941176470588, size: 1 },
    //     { x: 83.5251798561151, y: 3.56862745098039, size: 1 },
    //     { x: 86.7625899280576, y: 3.6078431372549, size: 1 },
    //     { x: 88.0575539568345, y: 3.29411764705882, size: 1 },
    //     { x: 90, y: 3.45098039215686, size: 1 },
    //     { x: 90.6474820143885, y: 3.37254901960784, size: 1 },
    //     { x: 93.2374100719424, y: 3.68627450980392, size: 1 },
    //     { x: 95.8273381294964, y: 2.90196078431373, size: 1 },
    //     { x: 97.1223021582734, y: 3.2156862745098, size: 1 },
    //     { x: 97.7697841726619, y: 3.41176470588235, size: 1 },
    //     { x: 99.7122302158273, y: 3.88235294117647, size: 1 },
    //     { x: 100.359712230216, y: 3.92156862745098, size: 1 },
    //     { x: 102.94964028777, y: 3.88235294117647, size: 1 },
    //     { x: 103.597122302158, y: 3.88235294117647, size: 1 },
    //     { x: 104.244604316547, y: 4, size: 1 },
    //     { x: 104.892086330935, y: 4.07843137254902, size: 1 },
    //     { x: 105.539568345324, y: 3.84313725490196, size: 1 },
    //     { x: 106.187050359712, y: 4.11764705882353, size: 1 },
    //     { x: 106.834532374101, y: 3.92156862745098, size: 1 },
    //     { x: 107.482014388489, y: 4.03921568627451, size: 1 },
    //     { x: 108.129496402878, y: 4.11764705882353, size: 1 },
    //     { x: 109.424460431655, y: 3.80392156862745, size: 1 },
    //     { x: 110.071942446043, y: 4, size: 1 },
    //     { x: 111.36690647482, y: 3.92156862745098, size: 1 },
    //     { x: 112.014388489209, y: 3.92156862745098, size: 1 },
    //     { x: 112.661870503597, y: 3.96078431372549, size: 1 },
    //     { x: 113.309352517986, y: 4.15686274509804, size: 1 },
    //     { x: 114.604316546763, y: 3.92156862745098, size: 1 },
    //     { x: 117.194244604317, y: 3.01960784313725, size: 1 },
    //     { x: 117.841726618705, y: 2.86274509803922, size: 1 },
    //     { x: 118.489208633094, y: 3.25490196078431, size: 1 },
    //     { x: 119.136690647482, y: 3.29411764705882, size: 1 },
    //     { x: 124.964028776978, y: 3.56862745098039, size: 1 },
    //     { x: 125.611510791367, y: 3.45098039215686, size: 1 },
    //     { x: 128.848920863309, y: 3.45098039215686, size: 1 },
    //     { x: 130.143884892086, y: 3.64705882352941, size: 1 },
    //     { x: 131.438848920863, y: 3.64705882352941, size: 1 },
    //     { x: 135.323741007194, y: 3.41176470588235, size: 1 },
    //     { x: 136.618705035971, y: 3.80392156862745, size: 1 },
    //     { x: 137.26618705036, y: 3.29411764705882, size: 1 },
    //     { x: 137.913669064748, y: 3.37254901960784, size: 1 },
    //     { x: 138.561151079137, y: 3.2156862745098, size: 1 },
    //     { x: 139.208633093525, y: 3.13725490196078, size: 1 },
    //     { x: 139.856115107914, y: 3.05882352941176, size: 1 },
    //     { x: 140.503597122302, y: 3.2156862745098, size: 1 },
    //     { x: 141.151079136691, y: 3.37254901960784, size: 1 },
    //     { x: 141.798561151079, y: 3.37254901960784, size: 1 },
    //     { x: 146.978417266187, y: 3.45098039215686, size: 1 },
    //     { x: 148.920863309353, y: 3.29411764705882, size: 1 },
    //     { x: 149.568345323741, y: 3.45098039215686, size: 1 },
    //     { x: 151.510791366906, y: 3.6078431372549, size: 1 },
    //     { x: 152.158273381295, y: 3.45098039215686, size: 1 },
    //     { x: 153.453237410072, y: 3.37254901960784, size: 1 },
    //     { x: 157.985611510791, y: 3.49019607843137, size: 1 },
    //     { x: 158.63309352518, y: 3.33333333333333, size: 1 },
    //     { x: 159.280575539568, y: 3.17647058823529, size: 1 },
    //     { x: 159.928057553957, y: 3.01960784313725, size: 1 },
    //     { x: 160.575539568345, y: 2.03921568627451, size: 1 },
    //     { x: 161.223021582734, y: 1.84313725490196, size: 1 },
    //     { x: 161.870503597122, y: 1.64705882352941, size: 1 },
    //     { x: 162.517985611511, y: 1.64705882352941, size: 1 },
    //     { x: 164.460431654676, y: 3.6078431372549, size: 1 },
    //     { x: 166.402877697842, y: 3.68627450980392, size: 1 },
    //     { x: 167.05035971223, y: 3.68627450980392, size: 1 },
    //     { x: 173.525179856115, y: 3.41176470588235, size: 1 },
    //     { x: 174.172661870504, y: 3.6078431372549, size: 1 },
    //     { x: 175.467625899281, y: 3.76470588235294, size: 1 },
    //     { x: 176.762589928058, y: 3.80392156862745, size: 1 },
    //     { x: 178.705035971223, y: 3.76470588235294, size: 1 },
    //     { x: 180, y: 3.52941176470588, size: 1 },
    //     { x: 182.589928057554, y: 3.29411764705882, size: 1 },
    //     { x: 183.884892086331, y: 3.49019607843137, size: 1 },
    //     { x: 185.179856115108, y: 3.72549019607843, size: 1 },
    //     { x: 193.597122302158, y: 3.56862745098039, size: 1 },
    //     { x: 196.834532374101, y: 3.72549019607843, size: 1 },
    //     { x: 201.36690647482, y: 3.49019607843137, size: 1 },
    //     { x: 202.014388489209, y: 3.41176470588235, size: 1 },
    //     { x: 202.661870503597, y: 3.29411764705882, size: 1 },
    //     { x: 203.309352517986, y: 2.74509803921569, size: 1 },
    //     { x: 203.956834532374, y: 1.96078431372549, size: 1 },
    //     { x: 205.251798561151, y: 3.96078431372549, size: 1 },
    //     { x: 207.194244604317, y: 3.96078431372549, size: 1 },
    //     { x: 208.489208633094, y: 3.96078431372549, size: 1 },
    //     { x: 209.784172661871, y: 3.92156862745098, size: 1 },
    //     { x: 211.726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 212.374100719424, y: 3.76470588235294, size: 1 },
    //     { x: 214.31654676259, y: 3.45098039215686, size: 1 },
    //     { x: 217.553956834532, y: 3.84313725490196, size: 1 },
    //     { x: 218.201438848921, y: 4, size: 1 },
    //     { x: 220.143884892086, y: 3.92156862745098, size: 1 },
    //     { x: 220.791366906475, y: 3.56862745098039, size: 1 },
    //     { x: 223.381294964029, y: 3.33333333333333, size: 1 },
    //     { x: 225.323741007194, y: 2.66666666666667, size: 1 },
    //     { x: 226.618705035971, y: 3.52941176470588, size: 1 },
    //     { x: 227.913669064748, y: 3.6078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.49019607843137, size: 1 },
    //     { x: 233.093525179856, y: 3.72549019607843, size: 1 },
    //     { x: 234.388489208633, y: 3.84313725490196, size: 1 },
    //     { x: 235.68345323741, y: 3.6078431372549, size: 1 },
    //     { x: 236.330935251799, y: 3.49019607843137, size: 1 },
    //     { x: 239.568345323741, y: 3.52941176470588, size: 1 },
    //     { x: 240.215827338129, y: 3.49019607843137, size: 1 },
    //     { x: 240.863309352518, y: 3.49019607843137, size: 1 },
    //     { x: 241.510791366906, y: 3.76470588235294, size: 1 },
    //     { x: 243.453237410072, y: 3.6078431372549, size: 1 },
    //     { x: 244.748201438849, y: 3.29411764705882, size: 1 },
    //     { x: 245.395683453237, y: 3.17647058823529, size: 1 },
    //     { x: 246.043165467626, y: 2.82352941176471, size: 1 },
    //     { x: 246.690647482014, y: 1.84313725490196, size: 1 },
    //     { x: 247.338129496403, y: 1.92156862745098, size: 1 },
    //     { x: 250.575539568345, y: 3.45098039215686, size: 1 },
    //     { x: 252.517985611511, y: 3.80392156862745, size: 1 },
    //     { x: 253.812949640288, y: 3.45098039215686, size: 1 },
    //     { x: 258.992805755396, y: 3.45098039215686, size: 1 },
    //     { x: 259.640287769784, y: 3.33333333333333, size: 1 },
    //     { x: 262.877697841727, y: 3.45098039215686, size: 1 },
    //     { x: 266.762589928058, y: 3.01960784313725, size: 1 },
    //     { x: 267.410071942446, y: 3.09803921568627, size: 1 },
    //     { x: 268.057553956835, y: 2.27450980392157, size: 1 },
    //     { x: 268.705035971223, y: 1.6078431372549, size: 1 },
    //     { x: 271.942446043165, y: 3.72549019607843, size: 1 },
    //     { x: 273.237410071942, y: 3.49019607843137, size: 1 },
    //     { x: 273.884892086331, y: 3.37254901960784, size: 1 },
    //     { x: 279.064748201439, y: 3.45098039215686, size: 1 },
    //     { x: 286.187050359712, y: 3.37254901960784, size: 1 },
    //     { x: 286.834532374101, y: 3.29411764705882, size: 1 },
    //     { x: 287.482014388489, y: 3.52941176470588, size: 1 },
    //     { x: 288.776978417266, y: 3.41176470588235, size: 1 },
    //     { x: 292.661870503597, y: 3.29411764705882, size: 1 },
    //     { x: 295.251798561151, y: 3.41176470588235, size: 1 },
    //     { x: 295.89928057554, y: 3.37254901960784, size: 1 },
    //     { x: 298.489208633094, y: 3.29411764705882, size: 1 },
    //     { x: 299.784172661871, y: 3.37254901960784, size: 1 },
    //     { x: 302.374100719424, y: 3.29411764705882, size: 1 },
    //     { x: 304.31654676259, y: 3.29411764705882, size: 1 },
    //     { x: 304.964028776978, y: 3.45098039215686, size: 1 },
    //     { x: 307.553956834532, y: 3.37254901960784, size: 1 },
    //     { x: 308.201438848921, y: 3.37254901960784, size: 1 },
    //     { x: 308.848920863309, y: 3.17647058823529, size: 1 },
    //     { x: 309.496402877698, y: 3.29411764705882, size: 1 },
    //     { x: 310.791366906475, y: 3.29411764705882, size: 1 },
    //     { x: 315.323741007194, y: 3.45098039215686, size: 1 },
    //     { x: 315.971223021583, y: 3.76470588235294, size: 1 },
    //     { x: 319.208633093525, y: 3.41176470588235, size: 1 },
    //     { x: 320.503597122302, y: 3.64705882352941, size: 1 },
    //     { x: 325.68345323741, y: 3.29411764705882, size: 1 },
    //     { x: 330.215827338129, y: 3.45098039215686, size: 1 },
    //     { x: 330.863309352518, y: 3.17647058823529, size: 1 },
    //     { x: 331.510791366906, y: 3.29411764705882, size: 1 },
    //     { x: 333.453237410072, y: 3.76470588235294, size: 1 },
    //     { x: 337.338129496403, y: 3.6078431372549, size: 1 },
    //     { x: 343.165467625899, y: 3.92156862745098, size: 1 },
    //     { x: 347.697841726619, y: 3.96078431372549, size: 1 },
    //     { x: 352.877697841727, y: 3.29411764705882, size: 1 },
    //     { x: 353.525179856115, y: 3.05882352941176, size: 1 },
    //     { x: 355.467625899281, y: 3.41176470588235, size: 1 },
    //     { x: 356.762589928058, y: 3.33333333333333, size: 1 },
    //     { x: 357.410071942446, y: 3.37254901960784, size: 1 },
    //     { x: 358.057553956835, y: 3.45098039215686, size: 1 },
    //     { x: 0.648648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 1.2972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 1.94594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 2.59459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 3.24324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 3.89189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 5.83783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 7.13513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 7.78378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 9.08108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 9.72972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 10.3783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 11.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 11.6756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 12.3243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 12.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 13.6216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 14.2702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 14.9189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 15.5675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 16.2162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 16.8648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 17.5135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 18.1621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 18.8108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 21.4054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 22.0540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 22.7027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 23.3513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 24, y: 3.52941176470588, size: 1 },
    //     { x: 24.6486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 27.2432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 27.8918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 28.5405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 29.8378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 30.4864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 31.1351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 33.0810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 33.7297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 34.3783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 35.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 35.6756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 36.3243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 36.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 38.2702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 38.9189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 39.5675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 40.2162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 40.8648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 41.5135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 42.1621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 43.4594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 44.7567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 46.0540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 46.7027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 48, y: 3.6078431372549, size: 1 },
    //     { x: 48.6486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 49.9459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 50.5945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 51.2432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 51.8918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 52.5405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 53.1891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 53.8378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 54.4864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 55.1351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 55.7837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 57.0810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 57.7297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 59.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 60.3243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 60.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 61.6216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 62.2702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 62.9189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 63.5675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 64.2162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 64.8648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 65.5135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 66.1621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 66.8108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 68.1081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 68.7567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 69.4054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 70.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 70.7027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 72, y: 3.6078431372549, size: 1 },
    //     { x: 73.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 74.5945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 75.2432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 75.8918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 76.5405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 77.8378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 79.1351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 79.7837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 81.0810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 82.3783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 83.6756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 85.6216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 86.9189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 87.5675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 88.2162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 88.8648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 90.8108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 93.4054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 94.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 94.7027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 95.3513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 96, y: 3.76470588235294, size: 1 },
    //     { x: 96.6486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 97.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 98.5945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 99.2432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 101.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 102.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 103.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 103.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 104.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 105.081081081081, y: 2.54901960784314, size: 1 },
    //     { x: 105.72972972973, y: 2.7843137254902, size: 1 },
    //     { x: 106.378378378378, y: 2.74509803921569, size: 1 },
    //     { x: 107.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 107.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 108.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 108.972972972973, y: 2.70588235294118, size: 1 },
    //     { x: 109.621621621622, y: 2.66666666666667, size: 1 },
    //     { x: 110.27027027027, y: 2.62745098039216, size: 1 },
    //     { x: 110.918918918919, y: 2.74509803921569, size: 1 },
    //     { x: 111.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 112.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 113.513513513514, y: 2.7843137254902, size: 1 },
    //     { x: 114.162162162162, y: 2.7843137254902, size: 1 },
    //     { x: 114.810810810811, y: 2.82352941176471, size: 1 },
    //     { x: 115.459459459459, y: 2.62745098039216, size: 1 },
    //     { x: 116.108108108108, y: 2.86274509803922, size: 1 },
    //     { x: 116.756756756757, y: 2.74509803921569, size: 1 },
    //     { x: 117.405405405405, y: 2.90196078431373, size: 1 },
    //     { x: 118.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 118.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 119.351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 120, y: 2.43137254901961, size: 1 },
    //     { x: 120.648648648649, y: 2.7843137254902, size: 1 },
    //     { x: 121.297297297297, y: 2.7843137254902, size: 1 },
    //     { x: 121.945945945946, y: 2.7843137254902, size: 1 },
    //     { x: 122.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 124.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 125.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 127.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 128.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 129.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 129.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 130.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 131.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 132.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 133.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 135.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 136.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 136.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 138.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 139.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 140.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 140.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 141.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 142.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 142.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 143.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 144, y: 3.64705882352941, size: 1 },
    //     { x: 145.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 146.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 147.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 147.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 148.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 149.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 149.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 150.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 151.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 152.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 153.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 154.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 155.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 156.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 156.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 157.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 158.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 158.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 159.567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 160.864864864865, y: 4.07843137254902, size: 1 },
    //     { x: 161.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 162.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 163.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 164.108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 164.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 165.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 166.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 167.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 168, y: 3.33333333333333, size: 1 },
    //     { x: 168.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 169.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 173.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 174.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 175.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 176.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 177.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 177.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 178.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 179.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 179.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 180.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 181.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 182.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 182.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 184.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 184.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 186.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 186.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 187.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 188.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 189.405405405405, y: 2.90196078431373, size: 1 },
    //     { x: 190.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 190.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 191.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 192, y: 3.6078431372549, size: 1 },
    //     { x: 192.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 193.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 193.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 194.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 196.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 197.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 197.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 199.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 201.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 202.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 204.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 204.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 205.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 206.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 208.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 208.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 209.513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 210.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 211.459459459459, y: 2.94117647058824, size: 1 },
    //     { x: 212.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 212.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 213.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 214.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 214.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 215.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 216, y: 3.6078431372549, size: 1 },
    //     { x: 216.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 217.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 219.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 219.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 221.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 221.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 223.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 223.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 224.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 225.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 225.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 226.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 229.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 230.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 230.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 231.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 232.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 232.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 233.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 234.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 234.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 236.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 237.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 238.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 239.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 240, y: 3.76470588235294, size: 1 },
    //     { x: 241.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 241.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 243.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 243.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 245.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 246.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 247.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 247.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 248.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 249.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 250.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 251.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 252.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 252.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 253.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 254.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 254.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 255.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 256.216216216216, y: 2.90196078431373, size: 1 },
    //     { x: 256.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 259.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 260.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 260.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 263.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 264, y: 3.80392156862745, size: 1 },
    //     { x: 264.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 265.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 266.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 267.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 267.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 268.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 269.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 269.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 270.486486486487, y: 3.68627450980392, size: 1 },
    //     { x: 271.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 273.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 275.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 275.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 276.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 276.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 277.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 278.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 278.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 279.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 280.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 281.513513513513, y: 3.6078431372549, size: 1 },
    //     { x: 282.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 282.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 283.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 284.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 285.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 286.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 286.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 287.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 288.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 289.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 290.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 291.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 292.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 293.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 293.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 294.486486486487, y: 3.41176470588235, size: 1 },
    //     { x: 295.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 295.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 296.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 297.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 297.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 298.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 299.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 300.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 300.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 301.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 304.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 304.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 306.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 306.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 308.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 308.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 309.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 311.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 312, y: 3.88235294117647, size: 1 },
    //     { x: 313.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 313.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 314.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 315.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 317.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 318.486486486487, y: 3.49019607843137, size: 1 },
    //     { x: 319.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 320.432432432432, y: 2.90196078431373, size: 1 },
    //     { x: 321.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 321.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 322.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 323.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 324.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 325.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 326.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 326.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 329.513513513513, y: 3.76470588235294, size: 1 },
    //     { x: 330.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 330.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 331.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 333.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 335.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 336, y: 3.68627450980392, size: 1 },
    //     { x: 336.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 338.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 339.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 340.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 341.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 343.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 343.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 344.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 345.081081081081, y: 4.11764705882353, size: 1 },
    //     { x: 347.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 347.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 348.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 349.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 350.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 352.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 352.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 353.513513513513, y: 3.64705882352941, size: 1 },
    //     { x: 354.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 355.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 356.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 356.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 358.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 1.94244604316547, y: 3.17647058823529, size: 1 },
    //     { x: 2.58992805755396, y: 3.09803921568627, size: 1 },
    //     { x: 3.88489208633094, y: 3.25490196078431, size: 1 },
    //     { x: 8.41726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 11.6546762589928, y: 3.72549019607843, size: 1 },
    //     { x: 12.3021582733813, y: 3.45098039215686, size: 1 },
    //     { x: 14.2446043165468, y: 3.56862745098039, size: 1 },
    //     { x: 20.0719424460432, y: 3.41176470588235, size: 1 },
    //     { x: 21.3669064748201, y: 3.6078431372549, size: 1 },
    //     { x: 22.6618705035971, y: 3.33333333333333, size: 1 },
    //     { x: 27.841726618705, y: 3.6078431372549, size: 1 },
    //     { x: 28.4892086330935, y: 3.45098039215686, size: 1 },
    //     { x: 29.136690647482, y: 3.80392156862745, size: 1 },
    //     { x: 32.3741007194245, y: 3.41176470588235, size: 1 },
    //     { x: 33.0215827338129, y: 4, size: 1 },
    //     { x: 33.6690647482014, y: 3.41176470588235, size: 1 },
    //     { x: 34.3165467625899, y: 3.45098039215686, size: 1 },
    //     { x: 35.6115107913669, y: 3.41176470588235, size: 1 },
    //     { x: 40.1438848920863, y: 3.6078431372549, size: 1 },
    //     { x: 41.4388489208633, y: 3.68627450980392, size: 1 },
    //     { x: 45.3237410071942, y: 2.90196078431373, size: 1 },
    //     { x: 45.9712230215827, y: 2.90196078431373, size: 1 },
    //     { x: 46.6187050359712, y: 3.25490196078431, size: 1 },
    //     { x: 47.2661870503597, y: 3.09803921568627, size: 1 },
    //     { x: 47.9136690647482, y: 3.45098039215686, size: 1 },
    //     { x: 51.7985611510791, y: 3.84313725490196, size: 1 },
    //     { x: 53.7410071942446, y: 3.84313725490196, size: 1 },
    //     { x: 55.6834532374101, y: 3.80392156862745, size: 1 },
    //     { x: 58.273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 60.2158273381295, y: 3.64705882352941, size: 1 },
    //     { x: 62.158273381295, y: 3.72549019607843, size: 1 },
    //     { x: 65.3956834532374, y: 3.49019607843137, size: 1 },
    //     { x: 66.6906474820144, y: 3.25490196078431, size: 1 },
    //     { x: 67.3381294964029, y: 2.7843137254902, size: 1 },
    //     { x: 67.9856115107914, y: 3.33333333333333, size: 1 },
    //     { x: 71.8705035971223, y: 4.03921568627451, size: 1 },
    //     { x: 73.1654676258993, y: 3.76470588235294, size: 1 },
    //     { x: 75.1079136690647, y: 3.72549019607843, size: 1 },
    //     { x: 77.6978417266187, y: 3.56862745098039, size: 1 },
    //     { x: 78.3453237410072, y: 4.03921568627451, size: 1 },
    //     { x: 82.2302158273381, y: 3.92156862745098, size: 1 },
    //     { x: 83.5251798561151, y: 3.80392156862745, size: 1 },
    //     { x: 88.705035971223, y: 3.49019607843137, size: 1 },
    //     { x: 90.6474820143885, y: 3.49019607843137, size: 1 },
    //     { x: 97.7697841726619, y: 3.88235294117647, size: 1 },
    //     { x: 98.4172661870504, y: 3.84313725490196, size: 1 },
    //     { x: 99.0647482014388, y: 3.52941176470588, size: 1 },
    //     { x: 103.597122302158, y: 3.72549019607843, size: 1 },
    //     { x: 104.244604316547, y: 3.45098039215686, size: 1 },
    //     { x: 105.539568345324, y: 3.52941176470588, size: 1 },
    //     { x: 110.719424460432, y: 3.13725490196078, size: 1 },
    //     { x: 112.014388489209, y: 3.2156862745098, size: 1 },
    //     { x: 119.784172661871, y: 3.72549019607843, size: 1 },
    //     { x: 120.431654676259, y: 3.84313725490196, size: 1 },
    //     { x: 121.726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 123.021582733813, y: 3.80392156862745, size: 1 },
    //     { x: 123.669064748201, y: 4.03921568627451, size: 1 },
    //     { x: 124.31654676259, y: 3.64705882352941, size: 1 },
    //     { x: 124.964028776978, y: 3.96078431372549, size: 1 },
    //     { x: 126.258992805755, y: 3.72549019607843, size: 1 },
    //     { x: 127.553956834532, y: 3.49019607843137, size: 1 },
    //     { x: 128.848920863309, y: 3.68627450980392, size: 1 },
    //     { x: 129.496402877698, y: 3.56862745098039, size: 1 },
    //     { x: 130.143884892086, y: 3.41176470588235, size: 1 },
    //     { x: 130.791366906475, y: 3.29411764705882, size: 1 },
    //     { x: 131.438848920863, y: 3.29411764705882, size: 1 },
    //     { x: 132.086330935252, y: 3.37254901960784, size: 1 },
    //     { x: 132.73381294964, y: 3.13725490196078, size: 1 },
    //     { x: 134.028776978417, y: 3.25490196078431, size: 1 },
    //     { x: 144.388489208633, y: 3.72549019607843, size: 1 },
    //     { x: 146.330935251799, y: 3.80392156862745, size: 1 },
    //     { x: 152.158273381295, y: 3.33333333333333, size: 1 },
    //     { x: 152.805755395683, y: 3.05882352941176, size: 1 },
    //     { x: 153.453237410072, y: 3.17647058823529, size: 1 },
    //     { x: 154.748201438849, y: 3.2156862745098, size: 1 },
    //     { x: 167.697841726619, y: 3.76470588235294, size: 1 },
    //     { x: 174.172661870504, y: 3.41176470588235, size: 1 },
    //     { x: 174.820143884892, y: 3.09803921568627, size: 1 },
    //     { x: 176.115107913669, y: 2.90196078431373, size: 1 },
    //     { x: 176.762589928058, y: 3.05882352941176, size: 1 },
    //     { x: 180.647482014388, y: 3.64705882352941, size: 1 },
    //     { x: 183.237410071942, y: 3.84313725490196, size: 1 },
    //     { x: 184.532374100719, y: 3.52941176470588, size: 1 },
    //     { x: 196.187050359712, y: 3.09803921568627, size: 1 },
    //     { x: 196.834532374101, y: 2.62745098039216, size: 1 },
    //     { x: 197.482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 198.129496402878, y: 3.05882352941176, size: 1 },
    //     { x: 198.776978417266, y: 3.45098039215686, size: 1 },
    //     { x: 201.36690647482, y: 3.56862745098039, size: 1 },
    //     { x: 209.784172661871, y: 3.52941176470588, size: 1 },
    //     { x: 211.079136690647, y: 3.45098039215686, size: 1 },
    //     { x: 219.496402877698, y: 3.2156862745098, size: 1 },
    //     { x: 220.143884892086, y: 2.86274509803922, size: 1 },
    //     { x: 223.381294964029, y: 3.56862745098039, size: 1 },
    //     { x: 224.676258992806, y: 3.37254901960784, size: 1 },
    //     { x: 227.26618705036, y: 3.76470588235294, size: 1 },
    //     { x: 227.913669064748, y: 3.72549019607843, size: 1 },
    //     { x: 229.856115107914, y: 3.56862745098039, size: 1 },
    //     { x: 232.446043165468, y: 3.49019607843137, size: 1 },
    //     { x: 234.388489208633, y: 3.33333333333333, size: 1 },
    //     { x: 235.035971223022, y: 3.37254901960784, size: 1 },
    //     { x: 238.273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 238.920863309353, y: 3.05882352941176, size: 1 },
    //     { x: 239.568345323741, y: 3.2156862745098, size: 1 },
    //     { x: 240.215827338129, y: 2.90196078431373, size: 1 },
    //     { x: 240.863309352518, y: 2.7843137254902, size: 1 },
    //     { x: 241.510791366906, y: 2.58823529411765, size: 1 },
    //     { x: 242.805755395683, y: 3.80392156862745, size: 1 },
    //     { x: 245.395683453237, y: 3.64705882352941, size: 1 },
    //     { x: 251.870503597122, y: 3.52941176470588, size: 1 },
    //     { x: 253.812949640288, y: 3.76470588235294, size: 1 },
    //     { x: 254.460431654676, y: 3.49019607843137, size: 1 },
    //     { x: 256.402877697842, y: 3.56862745098039, size: 1 },
    //     { x: 257.697841726619, y: 3.76470588235294, size: 1 },
    //     { x: 258.345323741007, y: 4.07843137254902, size: 1 },
    //     { x: 262.230215827338, y: 3.49019607843137, size: 1 },
    //     { x: 268.057553956835, y: 3.80392156862745, size: 1 },
    //     { x: 270.647482014389, y: 3.84313725490196, size: 1 },
    //     { x: 271.942446043165, y: 3.64705882352941, size: 1 },
    //     { x: 276.474820143885, y: 3.64705882352941, size: 1 },
    //     { x: 277.122302158273, y: 3.84313725490196, size: 1 },
    //     { x: 281.654676258993, y: 3.17647058823529, size: 1 },
    //     { x: 282.94964028777, y: 3.09803921568627, size: 1 },
    //     { x: 283.597122302158, y: 3.29411764705882, size: 1 },
    //     { x: 284.244604316547, y: 3.09803921568627, size: 1 },
    //     { x: 284.892086330935, y: 3.09803921568627, size: 1 },
    //     { x: 287.482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 295.251798561151, y: 3.64705882352941, size: 1 },
    //     { x: 300.431654676259, y: 3.45098039215686, size: 1 },
    //     { x: 301.726618705036, y: 3.64705882352941, size: 1 },
    //     { x: 302.374100719424, y: 3.56862745098039, size: 1 },
    //     { x: 303.669064748201, y: 3.6078431372549, size: 1 },
    //     { x: 304.31654676259, y: 3.72549019607843, size: 1 },
    //     { x: 308.201438848921, y: 3.80392156862745, size: 1 },
    //     { x: 312.73381294964, y: 3.88235294117647, size: 1 },
    //     { x: 313.381294964029, y: 3.72549019607843, size: 1 },
    //     { x: 315.971223021583, y: 3.96078431372549, size: 1 },
    //     { x: 317.26618705036, y: 3.72549019607843, size: 1 },
    //     { x: 317.913669064748, y: 3.96078431372549, size: 1 },
    //     { x: 318.561151079137, y: 3.72549019607843, size: 1 },
    //     { x: 322.446043165468, y: 3.6078431372549, size: 1 },
    //     { x: 326.978417266187, y: 3.80392156862745, size: 1 },
    //     { x: 332.805755395683, y: 3.80392156862745, size: 1 },
    //     { x: 335.395683453237, y: 3.76470588235294, size: 1 },
    //     { x: 336.043165467626, y: 3.84313725490196, size: 1 },
    //     { x: 337.338129496403, y: 3.68627450980392, size: 1 },
    //     { x: 338.63309352518, y: 3.76470588235294, size: 1 },
    //     { x: 343.165467625899, y: 4, size: 1 },
    //     { x: 345.755395683453, y: 3.41176470588235, size: 1 },
    //     { x: 346.402877697842, y: 3.33333333333333, size: 1 },
    //     { x: 347.697841726619, y: 3.17647058823529, size: 1 },
    //     { x: 348.345323741007, y: 3.09803921568627, size: 1 },
    //     { x: 348.992805755396, y: 2.82352941176471, size: 1 },
    //     { x: 349.640287769784, y: 3.2156862745098, size: 1 },
    //     { x: 352.230215827338, y: 3.92156862745098, size: 1 },
    //     { x: 355.467625899281, y: 3.72549019607843, size: 1 },
    //     { x: 356.762589928058, y: 3.80392156862745, size: 1 },
    //     { x: 358.057553956835, y: 3.72549019607843, size: 1 },
    //     { x: 3.23741007194245, y: 4.03921568627451, size: 1 },
    //     { x: 9.06474820143885, y: 3.33333333333333, size: 1 },
    //     { x: 9.71223021582734, y: 3.37254901960784, size: 1 },
    //     { x: 10.3597122302158, y: 3.09803921568627, size: 1 },
    //     { x: 25.2517985611511, y: 3.52941176470588, size: 1 },
    //     { x: 26.5467625899281, y: 3.96078431372549, size: 1 },
    //     { x: 31.0791366906475, y: 3.80392156862745, size: 1 },
    //     { x: 33.0215827338129, y: 3.37254901960784, size: 1 },
    //     { x: 38.8489208633094, y: 3.45098039215686, size: 1 },
    //     { x: 39.4964028776978, y: 3.64705882352941, size: 1 },
    //     { x: 41.4388489208633, y: 3.45098039215686, size: 1 },
    //     { x: 42.0863309352518, y: 3.37254901960784, size: 1 },
    //     { x: 44.0287769784173, y: 3.84313725490196, size: 1 },
    //     { x: 44.6762589928058, y: 3.52941176470588, size: 1 },
    //     { x: 45.3237410071942, y: 3.80392156862745, size: 1 },
    //     { x: 47.9136690647482, y: 3.68627450980392, size: 1 },
    //     { x: 48.5611510791367, y: 3.76470588235294, size: 1 },
    //     { x: 52.4460431654676, y: 3.29411764705882, size: 1 },
    //     { x: 53.7410071942446, y: 3.17647058823529, size: 1 },
    //     { x: 54.3884892086331, y: 3.2156862745098, size: 1 },
    //     { x: 55.0359712230216, y: 3.80392156862745, size: 1 },
    //     { x: 57.6258992805755, y: 3.92156862745098, size: 1 },
    //     { x: 58.9208633093525, y: 3.84313725490196, size: 1 },
    //     { x: 59.568345323741, y: 3.96078431372549, size: 1 },
    //     { x: 60.863309352518, y: 3.92156862745098, size: 1 },
    //     { x: 62.158273381295, y: 3.88235294117647, size: 1 },
    //     { x: 62.8057553956835, y: 3.96078431372549, size: 1 },
    //     { x: 63.4532374100719, y: 4.03921568627451, size: 1 },
    //     { x: 64.1007194244604, y: 4.11764705882353, size: 1 },
    //     { x: 65.3956834532374, y: 3.92156862745098, size: 1 },
    //     { x: 66.0431654676259, y: 3.80392156862745, size: 1 },
    //     { x: 66.6906474820144, y: 3.92156862745098, size: 1 },
    //     { x: 67.3381294964029, y: 3.80392156862745, size: 1 },
    //     { x: 68.6330935251799, y: 3.96078431372549, size: 1 },
    //     { x: 69.2805755395683, y: 3.96078431372549, size: 1 },
    //     { x: 70.5755395683453, y: 4.03921568627451, size: 1 },
    //     { x: 71.8705035971223, y: 3.92156862745098, size: 1 },
    //     { x: 72.5179856115108, y: 3.52941176470588, size: 1 },
    //     { x: 73.1654676258993, y: 3.29411764705882, size: 1 },
    //     { x: 75.1079136690647, y: 3.2156862745098, size: 1 },
    //     { x: 77.0503597122302, y: 3.41176470588235, size: 1 },
    //     { x: 78.9928057553957, y: 3.88235294117647, size: 1 },
    //     { x: 80.2877697841727, y: 3.76470588235294, size: 1 },
    //     { x: 80.9352517985612, y: 3.37254901960784, size: 1 },
    //     { x: 86.7625899280576, y: 3.92156862745098, size: 1 },
    //     { x: 93.8848920863309, y: 3.52941176470588, size: 1 },
    //     { x: 95.1798561151079, y: 3.33333333333333, size: 1 },
    //     { x: 96.4748201438849, y: 2.94117647058824, size: 1 },
    //     { x: 97.1223021582734, y: 2.86274509803922, size: 1 },
    //     { x: 97.7697841726619, y: 3.52941176470588, size: 1 },
    //     { x: 106.187050359712, y: 3.80392156862745, size: 1 },
    //     { x: 107.482014388489, y: 3.56862745098039, size: 1 },
    //     { x: 108.129496402878, y: 4.03921568627451, size: 1 },
    //     { x: 110.071942446043, y: 3.6078431372549, size: 1 },
    //     { x: 111.36690647482, y: 3.80392156862745, size: 1 },
    //     { x: 116.546762589928, y: 3.37254901960784, size: 1 },
    //     { x: 117.194244604317, y: 2.47058823529412, size: 1 },
    //     { x: 117.841726618705, y: 2.70588235294118, size: 1 },
    //     { x: 118.489208633094, y: 2.74509803921569, size: 1 },
    //     { x: 119.136690647482, y: 2.50980392156863, size: 1 },
    //     { x: 123.021582733813, y: 3.37254901960784, size: 1 },
    //     { x: 123.669064748201, y: 3.13725490196078, size: 1 },
    //     { x: 126.258992805755, y: 3.33333333333333, size: 1 },
    //     { x: 127.553956834532, y: 3.52941176470588, size: 1 },
    //     { x: 129.496402877698, y: 3.37254901960784, size: 1 },
    //     { x: 130.143884892086, y: 3.29411764705882, size: 1 },
    //     { x: 130.791366906475, y: 3.37254901960784, size: 1 },
    //     { x: 131.438848920863, y: 3.52941176470588, size: 1 },
    //     { x: 132.086330935252, y: 3.76470588235294, size: 1 },
    //     { x: 133.381294964029, y: 3.41176470588235, size: 1 },
    //     { x: 135.971223021583, y: 3.37254901960784, size: 1 },
    //     { x: 139.208633093525, y: 3.6078431372549, size: 1 },
    //     { x: 141.151079136691, y: 3.45098039215686, size: 1 },
    //     { x: 145.035971223022, y: 3.72549019607843, size: 1 },
    //     { x: 145.68345323741, y: 3.76470588235294, size: 1 },
    //     { x: 146.978417266187, y: 3.49019607843137, size: 1 },
    //     { x: 157.985611510791, y: 3.72549019607843, size: 1 },
    //     { x: 159.928057553957, y: 3.6078431372549, size: 1 },
    //     { x: 162.517985611511, y: 3.88235294117647, size: 1 },
    //     { x: 163.165467625899, y: 3.45098039215686, size: 1 },
    //     { x: 165.755395683453, y: 3.52941176470588, size: 1 },
    //     { x: 167.697841726619, y: 3.41176470588235, size: 1 },
    //     { x: 174.820143884892, y: 3.49019607843137, size: 1 },
    //     { x: 178.705035971223, y: 3.41176470588235, size: 1 },
    //     { x: 179.352517985612, y: 3.52941176470588, size: 1 },
    //     { x: 182.589928057554, y: 3.25490196078431, size: 1 },
    //     { x: 183.884892086331, y: 3.45098039215686, size: 1 },
    //     { x: 184.532374100719, y: 3.45098039215686, size: 1 },
    //     { x: 186.474820143885, y: 3.52941176470588, size: 1 },
    //     { x: 194.244604316547, y: 3.72549019607843, size: 1 },
    //     { x: 196.187050359712, y: 3.76470588235294, size: 1 },
    //     { x: 202.014388489209, y: 3.29411764705882, size: 1 },
    //     { x: 203.309352517986, y: 3.13725490196078, size: 1 },
    //     { x: 203.956834532374, y: 3.13725490196078, size: 1 },
    //     { x: 207.194244604317, y: 3.64705882352941, size: 1 },
    //     { x: 217.553956834532, y: 3.29411764705882, size: 1 },
    //     { x: 219.496402877698, y: 3.72549019607843, size: 1 },
    //     { x: 224.028776978417, y: 3.37254901960784, size: 1 },
    //     { x: 225.323741007194, y: 3.17647058823529, size: 1 },
    //     { x: 226.618705035971, y: 3.56862745098039, size: 1 },
    //     { x: 240.215827338129, y: 3.72549019607843, size: 1 },
    //     { x: 242.158273381295, y: 3.6078431372549, size: 1 },
    //     { x: 244.10071942446, y: 3.80392156862745, size: 1 },
    //     { x: 247.985611510791, y: 4, size: 1 },
    //     { x: 249.280575539568, y: 3.6078431372549, size: 1 },
    //     { x: 249.928057553957, y: 3.76470588235294, size: 1 },
    //     { x: 250.575539568345, y: 3.56862745098039, size: 1 },
    //     { x: 255.107913669065, y: 3.84313725490196, size: 1 },
    //     { x: 256.402877697842, y: 3.96078431372549, size: 1 },
    //     { x: 257.05035971223, y: 3.49019607843137, size: 1 },
    //     { x: 260.287769784173, y: 3.49019607843137, size: 1 },
    //     { x: 260.935251798561, y: 3.84313725490196, size: 1 },
    //     { x: 262.230215827338, y: 3.72549019607843, size: 1 },
    //     { x: 263.525179856115, y: 3.56862745098039, size: 1 },
    //     { x: 265.467625899281, y: 3.80392156862745, size: 1 },
    //     { x: 269.352517985611, y: 3.80392156862745, size: 1 },
    //     { x: 270, y: 3.64705882352941, size: 1 },
    //     { x: 271.942446043165, y: 3.84313725490196, size: 1 },
    //     { x: 273.237410071942, y: 3.72549019607843, size: 1 },
    //     { x: 273.884892086331, y: 3.64705882352941, size: 1 },
    //     { x: 274.532374100719, y: 3.64705882352941, size: 1 },
    //     { x: 277.769784172662, y: 3.49019607843137, size: 1 },
    //     { x: 280.359712230216, y: 3.72549019607843, size: 1 },
    //     { x: 283.597122302158, y: 4.03921568627451, size: 1 },
    //     { x: 286.187050359712, y: 3.52941176470588, size: 1 },
    //     { x: 289.424460431655, y: 3.05882352941176, size: 1 },
    //     { x: 290.071942446043, y: 2.98039215686275, size: 1 },
    //     { x: 292.014388489209, y: 3.33333333333333, size: 1 },
    //     { x: 293.309352517986, y: 3.29411764705882, size: 1 },
    //     { x: 293.956834532374, y: 3.37254901960784, size: 1 },
    //     { x: 296.546762589928, y: 3.29411764705882, size: 1 },
    //     { x: 298.489208633094, y: 3.45098039215686, size: 1 },
    //     { x: 299.136690647482, y: 3.37254901960784, size: 1 },
    //     { x: 299.784172661871, y: 3.41176470588235, size: 1 },
    //     { x: 301.079136690647, y: 3.29411764705882, size: 1 },
    //     { x: 304.31654676259, y: 3.33333333333333, size: 1 },
    //     { x: 304.964028776978, y: 3.92156862745098, size: 1 },
    //     { x: 305.611510791367, y: 3.41176470588235, size: 1 },
    //     { x: 306.906474820144, y: 3.25490196078431, size: 1 },
    //     { x: 307.553956834532, y: 3.52941176470588, size: 1 },
    //     { x: 308.201438848921, y: 3.25490196078431, size: 1 },
    //     { x: 308.848920863309, y: 3.29411764705882, size: 1 },
    //     { x: 309.496402877698, y: 4, size: 1 },
    //     { x: 310.143884892086, y: 3.52941176470588, size: 1 },
    //     { x: 310.791366906475, y: 3.33333333333333, size: 1 },
    //     { x: 318.561151079137, y: 3.80392156862745, size: 1 },
    //     { x: 319.856115107914, y: 3.92156862745098, size: 1 },
    //     { x: 323.741007194245, y: 3.64705882352941, size: 1 },
    //     { x: 324.388489208633, y: 3.88235294117647, size: 1 },
    //     { x: 327.625899280576, y: 4, size: 1 },
    //     { x: 332.158273381295, y: 3.2156862745098, size: 1 },
    //     { x: 332.805755395683, y: 2.7843137254902, size: 1 },
    //     { x: 333.453237410072, y: 2.86274509803922, size: 1 },
    //     { x: 334.748201438849, y: 3.88235294117647, size: 1 },
    //     { x: 336.043165467626, y: 3.56862745098039, size: 1 },
    //     { x: 339.928057553957, y: 3.96078431372549, size: 1 },
    //     { x: 349.640287769784, y: 3.76470588235294, size: 1 },
    //     { x: 355.467625899281, y: 3.29411764705882, size: 1 },
    //     { x: 357.410071942446, y: 3.33333333333333, size: 1 },
    //     { x: 358.057553956835, y: 3.25490196078431, size: 1 },
    //     { x: 0, y: 3.37254901960784, size: 1 },
    //     { x: 0.647482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 2.58992805755396, y: 3.25490196078431, size: 1 },
    //     { x: 3.23741007194245, y: 3.25490196078431, size: 1 },
    //     { x: 3.88489208633094, y: 3.68627450980392, size: 1 },
    //     { x: 4.53237410071942, y: 3.33333333333333, size: 1 },
    //     { x: 5.17985611510791, y: 3.2156862745098, size: 1 },
    //     { x: 5.8273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 6.47482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 7.12230215827338, y: 3.41176470588235, size: 1 },
    //     { x: 8.41726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 9.06474820143885, y: 3.41176470588235, size: 1 },
    //     { x: 10.3597122302158, y: 3.49019607843137, size: 1 },
    //     { x: 11.6546762589928, y: 3.45098039215686, size: 1 },
    //     { x: 12.3021582733813, y: 3.25490196078431, size: 1 },
    //     { x: 12.9496402877698, y: 3.29411764705882, size: 1 },
    //     { x: 14.2446043165468, y: 4.07843137254902, size: 1 },
    //     { x: 17.4820143884892, y: 3.52941176470588, size: 1 },
    //     { x: 21.3669064748201, y: 3.52941176470588, size: 1 },
    //     { x: 23.9568345323741, y: 3.45098039215686, size: 1 },
    //     { x: 27.841726618705, y: 3.37254901960784, size: 1 },
    //     { x: 32.3741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 33.0215827338129, y: 3.84313725490196, size: 1 },
    //     { x: 37.5539568345324, y: 3.33333333333333, size: 1 },
    //     { x: 40.7913669064748, y: 3.72549019607843, size: 1 },
    //     { x: 43.3812949640288, y: 3.72549019607843, size: 1 },
    //     { x: 44.0287769784173, y: 3.96078431372549, size: 1 },
    //     { x: 46.6187050359712, y: 3.76470588235294, size: 1 },
    //     { x: 47.2661870503597, y: 3.72549019607843, size: 1 },
    //     { x: 54.3884892086331, y: 3.6078431372549, size: 1 },
    //     { x: 56.3309352517986, y: 3.84313725490196, size: 1 },
    //     { x: 58.9208633093525, y: 3.45098039215686, size: 1 },
    //     { x: 59.568345323741, y: 3.45098039215686, size: 1 },
    //     { x: 64.1007194244604, y: 3.72549019607843, size: 1 },
    //     { x: 67.3381294964029, y: 3.88235294117647, size: 1 },
    //     { x: 69.9280575539568, y: 3.56862745098039, size: 1 },
    //     { x: 71.2230215827338, y: 3.76470588235294, size: 1 },
    //     { x: 73.1654676258993, y: 3.88235294117647, size: 1 },
    //     { x: 75.7553956834532, y: 3.6078431372549, size: 1 },
    //     { x: 80.2877697841727, y: 3.37254901960784, size: 1 },
    //     { x: 80.9352517985612, y: 3.2156862745098, size: 1 },
    //     { x: 82.2302158273381, y: 3.25490196078431, size: 1 },
    //     { x: 84.8201438848921, y: 3.41176470588235, size: 1 },
    //     { x: 85.4676258992806, y: 3.41176470588235, size: 1 },
    //     { x: 86.1151079136691, y: 3.45098039215686, size: 1 },
    //     { x: 86.7625899280576, y: 3.41176470588235, size: 1 },
    //     { x: 87.410071942446, y: 3.13725490196078, size: 1 },
    //     { x: 89.3525179856115, y: 3.45098039215686, size: 1 },
    //     { x: 90, y: 3.49019607843137, size: 1 },
    //     { x: 91.294964028777, y: 3.29411764705882, size: 1 },
    //     { x: 91.9424460431655, y: 3.49019607843137, size: 1 },
    //     { x: 93.2374100719424, y: 3.25490196078431, size: 1 },
    //     { x: 93.8848920863309, y: 3.41176470588235, size: 1 },
    //     { x: 94.5323741007194, y: 3.41176470588235, size: 1 },
    //     { x: 98.4172661870504, y: 3.25490196078431, size: 1 },
    //     { x: 99.0647482014388, y: 3.2156862745098, size: 1 },
    //     { x: 99.7122302158273, y: 3.25490196078431, size: 1 },
    //     { x: 100.359712230216, y: 3.33333333333333, size: 1 },
    //     { x: 101.654676258993, y: 3.01960784313725, size: 1 },
    //     { x: 102.302158273381, y: 2.98039215686275, size: 1 },
    //     { x: 102.94964028777, y: 3.05882352941176, size: 1 },
    //     { x: 103.597122302158, y: 2.98039215686275, size: 1 },
    //     { x: 104.244604316547, y: 3.05882352941176, size: 1 },
    //     { x: 104.892086330935, y: 3.2156862745098, size: 1 },
    //     { x: 106.187050359712, y: 3.25490196078431, size: 1 },
    //     { x: 106.834532374101, y: 3.45098039215686, size: 1 },
    //     { x: 108.776978417266, y: 3.33333333333333, size: 1 },
    //     { x: 109.424460431655, y: 3.29411764705882, size: 1 },
    //     { x: 110.071942446043, y: 3.33333333333333, size: 1 },
    //     { x: 110.719424460432, y: 3.29411764705882, size: 1 },
    //     { x: 113.309352517986, y: 3.25490196078431, size: 1 },
    //     { x: 113.956834532374, y: 3.13725490196078, size: 1 },
    //     { x: 115.89928057554, y: 3.29411764705882, size: 1 },
    //     { x: 117.194244604317, y: 3.49019607843137, size: 1 },
    //     { x: 117.841726618705, y: 3.45098039215686, size: 1 },
    //     { x: 120.431654676259, y: 3.29411764705882, size: 1 },
    //     { x: 122.374100719424, y: 3.56862745098039, size: 1 },
    //     { x: 126.258992805755, y: 3.45098039215686, size: 1 },
    //     { x: 131.438848920863, y: 3.49019607843137, size: 1 },
    //     { x: 132.086330935252, y: 3.45098039215686, size: 1 },
    //     { x: 132.73381294964, y: 3.41176470588235, size: 1 },
    //     { x: 135.323741007194, y: 3.56862745098039, size: 1 },
    //     { x: 136.618705035971, y: 3.25490196078431, size: 1 },
    //     { x: 137.913669064748, y: 3.76470588235294, size: 1 },
    //     { x: 138.561151079137, y: 3.6078431372549, size: 1 },
    //     { x: 141.798561151079, y: 3.45098039215686, size: 1 },
    //     { x: 145.035971223022, y: 3.45098039215686, size: 1 },
    //     { x: 145.68345323741, y: 3.41176470588235, size: 1 },
    //     { x: 148.920863309353, y: 3.37254901960784, size: 1 },
    //     { x: 150.215827338129, y: 3.52941176470588, size: 1 },
    //     { x: 154.748201438849, y: 3.92156862745098, size: 1 },
    //     { x: 157.338129496403, y: 3.72549019607843, size: 1 },
    //     { x: 163.165467625899, y: 3.49019607843137, size: 1 },
    //     { x: 164.460431654676, y: 3.49019607843137, size: 1 },
    //     { x: 165.107913669065, y: 3.76470588235294, size: 1 },
    //     { x: 165.755395683453, y: 3.45098039215686, size: 1 },
    //     { x: 166.402877697842, y: 3.41176470588235, size: 1 },
    //     { x: 168.345323741007, y: 3.49019607843137, size: 1 },
    //     { x: 168.992805755396, y: 3.33333333333333, size: 1 },
    //     { x: 172.877697841727, y: 3.96078431372549, size: 1 },
    //     { x: 173.525179856115, y: 3.88235294117647, size: 1 },
    //     { x: 183.237410071942, y: 3.64705882352941, size: 1 },
    //     { x: 185.827338129496, y: 3.80392156862745, size: 1 },
    //     { x: 187.122302158273, y: 3.29411764705882, size: 1 },
    //     { x: 188.41726618705, y: 2.90196078431373, size: 1 },
    //     { x: 189.064748201439, y: 2.74509803921569, size: 1 },
    //     { x: 189.712230215827, y: 2.98039215686275, size: 1 },
    //     { x: 191.007194244604, y: 3.49019607843137, size: 1 },
    //     { x: 191.654676258993, y: 3.80392156862745, size: 1 },
    //     { x: 192.94964028777, y: 3.76470588235294, size: 1 },
    //     { x: 193.597122302158, y: 3.76470588235294, size: 1 },
    //     { x: 205.89928057554, y: 3.80392156862745, size: 1 },
    //     { x: 208.489208633094, y: 3.37254901960784, size: 1 },
    //     { x: 210.431654676259, y: 2.94117647058824, size: 1 },
    //     { x: 215.611510791367, y: 4.03921568627451, size: 1 },
    //     { x: 217.553956834532, y: 4.11764705882353, size: 1 },
    //     { x: 219.496402877698, y: 3.84313725490196, size: 1 },
    //     { x: 220.143884892086, y: 3.76470588235294, size: 1 },
    //     { x: 224.676258992806, y: 3.84313725490196, size: 1 },
    //     { x: 225.971223021583, y: 3.6078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.09803921568627, size: 1 },
    //     { x: 231.798561151079, y: 2.98039215686275, size: 1 },
    //     { x: 232.446043165468, y: 3.13725490196078, size: 1 },
    //     { x: 238.920863309353, y: 3.84313725490196, size: 1 },
    //     { x: 239.568345323741, y: 3.76470588235294, size: 1 },
    //     { x: 246.690647482014, y: 3.84313725490196, size: 1 },
    //     { x: 247.985611510791, y: 3.88235294117647, size: 1 },
    //     { x: 249.928057553957, y: 3.64705882352941, size: 1 },
    //     { x: 251.223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 252.517985611511, y: 3.84313725490196, size: 1 },
    //     { x: 255.107913669065, y: 3.45098039215686, size: 1 },
    //     { x: 262.877697841727, y: 3.64705882352941, size: 1 },
    //     { x: 263.525179856115, y: 3.80392156862745, size: 1 },
    //     { x: 273.237410071942, y: 3.80392156862745, size: 1 },
    //     { x: 279.064748201439, y: 3.76470588235294, size: 1 },
    //     { x: 279.712230215827, y: 3.76470588235294, size: 1 },
    //     { x: 281.654676258993, y: 3.6078431372549, size: 1 },
    //     { x: 286.834532374101, y: 3.56862745098039, size: 1 },
    //     { x: 288.129496402878, y: 3.45098039215686, size: 1 },
    //     { x: 295.89928057554, y: 3.25490196078431, size: 1 },
    //     { x: 296.546762589928, y: 2.82352941176471, size: 1 },
    //     { x: 297.194244604317, y: 2.94117647058824, size: 1 },
    //     { x: 303.669064748201, y: 3.41176470588235, size: 1 },
    //     { x: 304.964028776978, y: 3.64705882352941, size: 1 },
    //     { x: 306.258992805755, y: 3.68627450980392, size: 1 },
    //     { x: 310.143884892086, y: 3.64705882352941, size: 1 },
    //     { x: 310.791366906475, y: 3.68627450980392, size: 1 },
    //     { x: 314.028776978417, y: 3.68627450980392, size: 1 },
    //     { x: 316.618705035971, y: 3.45098039215686, size: 1 },
    //     { x: 319.856115107914, y: 3.76470588235294, size: 1 },
    //     { x: 326.330935251799, y: 3.49019607843137, size: 1 },
    //     { x: 328.920863309353, y: 3.37254901960784, size: 1 },
    //     { x: 329.568345323741, y: 3.49019607843137, size: 1 },
    //     { x: 330.863309352518, y: 3.37254901960784, size: 1 },
    //     { x: 331.510791366906, y: 3.45098039215686, size: 1 },
    //     { x: 334.10071942446, y: 3.37254901960784, size: 1 },
    //     { x: 334.748201438849, y: 3.37254901960784, size: 1 },
    //     { x: 336.043165467626, y: 3.80392156862745, size: 1 },
    //     { x: 337.338129496403, y: 3.41176470588235, size: 1 },
    //     { x: 338.63309352518, y: 3.72549019607843, size: 1 },
    //     { x: 341.870503597122, y: 3.37254901960784, size: 1 },
    //     { x: 344.460431654676, y: 3.33333333333333, size: 1 },
    //     { x: 354.820143884892, y: 3.84313725490196, size: 1 },
    //     { x: 357.410071942446, y: 3.49019607843137, size: 1 },
    //     { x: 5.8273381294964, y: 3.56862745098039, size: 1 },
    //     { x: 10.3597122302158, y: 3.68627450980392, size: 1 },
    //     { x: 12.3021582733813, y: 3.76470588235294, size: 1 },
    //     { x: 15.5395683453237, y: 3.88235294117647, size: 1 },
    //     { x: 16.8345323741007, y: 3.68627450980392, size: 1 },
    //     { x: 17.4820143884892, y: 3.76470588235294, size: 1 },
    //     { x: 22.6618705035971, y: 3.17647058823529, size: 1 },
    //     { x: 23.3093525179856, y: 3.37254901960784, size: 1 },
    //     { x: 24.6043165467626, y: 3.05882352941176, size: 1 },
    //     { x: 29.7841726618705, y: 3.64705882352941, size: 1 },
    //     { x: 32.3741007194245, y: 3.88235294117647, size: 1 },
    //     { x: 34.3165467625899, y: 3.80392156862745, size: 1 },
    //     { x: 38.2014388489209, y: 3.41176470588235, size: 1 },
    //     { x: 40.1438848920863, y: 3.84313725490196, size: 1 },
    //     { x: 41.4388489208633, y: 3.96078431372549, size: 1 },
    //     { x: 42.7338129496403, y: 3.29411764705882, size: 1 },
    //     { x: 43.3812949640288, y: 3.45098039215686, size: 1 },
    //     { x: 44.0287769784173, y: 3.17647058823529, size: 1 },
    //     { x: 44.6762589928058, y: 2.86274509803922, size: 1 },
    //     { x: 45.3237410071942, y: 2.86274509803922, size: 1 },
    //     { x: 45.9712230215827, y: 2.94117647058824, size: 1 },
    //     { x: 48.5611510791367, y: 3.45098039215686, size: 1 },
    //     { x: 49.8561151079137, y: 3.68627450980392, size: 1 },
    //     { x: 56.3309352517986, y: 3.6078431372549, size: 1 },
    //     { x: 58.273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 62.8057553956835, y: 3.68627450980392, size: 1 },
    //     { x: 66.0431654676259, y: 3.33333333333333, size: 1 },
    //     { x: 66.6906474820144, y: 3.13725490196078, size: 1 },
    //     { x: 69.2805755395683, y: 3.52941176470588, size: 1 },
    //     { x: 71.8705035971223, y: 3.45098039215686, size: 1 },
    //     { x: 73.8129496402878, y: 3.41176470588235, size: 1 },
    //     { x: 74.4604316546763, y: 3.33333333333333, size: 1 },
    //     { x: 79.6402877697842, y: 3.37254901960784, size: 1 },
    //     { x: 80.2877697841727, y: 3.41176470588235, size: 1 },
    //     { x: 81.5827338129496, y: 3.41176470588235, size: 1 },
    //     { x: 82.2302158273381, y: 3.76470588235294, size: 1 },
    //     { x: 86.1151079136691, y: 3.29411764705882, size: 1 },
    //     { x: 86.7625899280576, y: 3.17647058823529, size: 1 },
    //     { x: 87.410071942446, y: 2.03921568627451, size: 1 },
    //     { x: 88.0575539568345, y: 1.37254901960784, size: 1 },
    //     { x: 88.705035971223, y: 1.41176470588235, size: 1 },
    //     { x: 89.3525179856115, y: 1.25490196078431, size: 1 },
    //     { x: 90, y: 3.13725490196078, size: 1 },
    //     { x: 91.9424460431655, y: 3.13725490196078, size: 1 },
    //     { x: 92.589928057554, y: 2.90196078431373, size: 1 },
    //     { x: 93.2374100719424, y: 3.64705882352941, size: 1 },
    //     { x: 97.1223021582734, y: 2.90196078431373, size: 1 },
    //     { x: 102.94964028777, y: 2.82352941176471, size: 1 },
    //     { x: 103.597122302158, y: 2.94117647058824, size: 1 },
    //     { x: 104.892086330935, y: 3.41176470588235, size: 1 },
    //     { x: 106.834532374101, y: 3.49019607843137, size: 1 },
    //     { x: 107.482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 108.776978417266, y: 2.90196078431373, size: 1 },
    //     { x: 109.424460431655, y: 2.62745098039216, size: 1 },
    //     { x: 113.956834532374, y: 3.72549019607843, size: 1 },
    //     { x: 117.841726618705, y: 3.68627450980392, size: 1 },
    //     { x: 121.079136690647, y: 3.76470588235294, size: 1 },
    //     { x: 124.964028776978, y: 3.6078431372549, size: 1 },
    //     { x: 125.611510791367, y: 3.84313725490196, size: 1 },
    //     { x: 126.906474820144, y: 3.72549019607843, size: 1 },
    //     { x: 130.791366906475, y: 3.17647058823529, size: 1 },
    //     { x: 131.438848920863, y: 3.01960784313725, size: 1 },
    //     { x: 135.323741007194, y: 3.72549019607843, size: 1 },
    //     { x: 135.971223021583, y: 3.72549019607843, size: 1 },
    //     { x: 136.618705035971, y: 3.68627450980392, size: 1 },
    //     { x: 141.151079136691, y: 3.49019607843137, size: 1 },
    //     { x: 146.978417266187, y: 3.64705882352941, size: 1 },
    //     { x: 147.625899280576, y: 3.80392156862745, size: 1 },
    //     { x: 148.920863309353, y: 3.72549019607843, size: 1 },
    //     { x: 150.863309352518, y: 3.2156862745098, size: 1 },
    //     { x: 152.158273381295, y: 2.31372549019608, size: 1 },
    //     { x: 152.805755395683, y: 2.23529411764706, size: 1 },
    //     { x: 157.338129496403, y: 3.68627450980392, size: 1 },
    //     { x: 158.63309352518, y: 3.52941176470588, size: 1 },
    //     { x: 161.223021582734, y: 3.88235294117647, size: 1 },
    //     { x: 167.05035971223, y: 4, size: 1 },
    //     { x: 167.697841726619, y: 3.88235294117647, size: 1 },
    //     { x: 168.345323741007, y: 3.64705882352941, size: 1 },
    //     { x: 169.640287769784, y: 3.88235294117647, size: 1 },
    //     { x: 170.935251798561, y: 3.56862745098039, size: 1 },
    //     { x: 172.230215827338, y: 3.29411764705882, size: 1 },
    //     { x: 172.877697841727, y: 3.29411764705882, size: 1 },
    //     { x: 173.525179856115, y: 2.7843137254902, size: 1 },
    //     { x: 174.172661870504, y: 2.82352941176471, size: 1 },
    //     { x: 174.820143884892, y: 3.2156862745098, size: 1 },
    //     { x: 177.410071942446, y: 3.6078431372549, size: 1 },
    //     { x: 180, y: 3.88235294117647, size: 1 },
    //     { x: 182.589928057554, y: 3.37254901960784, size: 1 },
    //     { x: 186.474820143885, y: 3.72549019607843, size: 1 },
    //     { x: 187.122302158273, y: 3.52941176470588, size: 1 },
    //     { x: 190.359712230216, y: 3.49019607843137, size: 1 },
    //     { x: 192.302158273381, y: 3.6078431372549, size: 1 },
    //     { x: 196.834532374101, y: 3.25490196078431, size: 1 },
    //     { x: 200.719424460432, y: 3.56862745098039, size: 1 },
    //     { x: 208.489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 211.079136690647, y: 3.52941176470588, size: 1 },
    //     { x: 211.726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 213.669064748201, y: 3.41176470588235, size: 1 },
    //     { x: 216.258992805755, y: 3.37254901960784, size: 1 },
    //     { x: 216.906474820144, y: 2.86274509803922, size: 1 },
    //     { x: 217.553956834532, y: 2.66666666666667, size: 1 },
    //     { x: 224.676258992806, y: 3.80392156862745, size: 1 },
    //     { x: 229.856115107914, y: 3.76470588235294, size: 1 },
    //     { x: 235.035971223022, y: 3.6078431372549, size: 1 },
    //     { x: 235.68345323741, y: 3.84313725490196, size: 1 },
    //     { x: 236.978417266187, y: 3.37254901960784, size: 1 },
    //     { x: 237.625899280576, y: 3.29411764705882, size: 1 },
    //     { x: 238.273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 238.920863309353, y: 2.74509803921569, size: 1 },
    //     { x: 242.805755395683, y: 3.72549019607843, size: 1 },
    //     { x: 244.748201438849, y: 3.68627450980392, size: 1 },
    //     { x: 253.165467625899, y: 3.64705882352941, size: 1 },
    //     { x: 254.460431654676, y: 3.80392156862745, size: 1 },
    //     { x: 255.107913669065, y: 4.15686274509804, size: 1 },
    //     { x: 257.05035971223, y: 3.72549019607843, size: 1 },
    //     { x: 258.992805755396, y: 3.2156862745098, size: 1 },
    //     { x: 259.640287769784, y: 3.05882352941176, size: 1 },
    //     { x: 260.287769784173, y: 2.27450980392157, size: 1 },
    //     { x: 260.935251798561, y: 2.58823529411765, size: 1 },
    //     { x: 261.58273381295, y: 3.41176470588235, size: 1 },
    //     { x: 262.877697841727, y: 3.37254901960784, size: 1 },
    //     { x: 265.467625899281, y: 3.56862745098039, size: 1 },
    //     { x: 266.115107913669, y: 3.41176470588235, size: 1 },
    //     { x: 266.762589928058, y: 3.37254901960784, size: 1 },
    //     { x: 270, y: 3.33333333333333, size: 1 },
    //     { x: 271.294964028777, y: 3.29411764705882, size: 1 },
    //     { x: 271.942446043165, y: 3.80392156862745, size: 1 },
    //     { x: 272.589928057554, y: 3.41176470588235, size: 1 },
    //     { x: 273.237410071942, y: 3.37254901960784, size: 1 },
    //     { x: 274.532374100719, y: 3.33333333333333, size: 1 },
    //     { x: 279.712230215827, y: 3.33333333333333, size: 1 },
    //     { x: 280.359712230216, y: 3.05882352941176, size: 1 },
    //     { x: 281.654676258993, y: 2.47058823529412, size: 1 },
    //     { x: 282.302158273381, y: 2.19607843137255, size: 1 },
    //     { x: 282.94964028777, y: 3.49019607843137, size: 1 },
    //     { x: 286.187050359712, y: 3.6078431372549, size: 1 },
    //     { x: 291.36690647482, y: 3.72549019607843, size: 1 },
    //     { x: 292.661870503597, y: 3.76470588235294, size: 1 },
    //     { x: 294.604316546763, y: 3.80392156862745, size: 1 },
    //     { x: 302.374100719424, y: 3.05882352941176, size: 1 },
    //     { x: 306.906474820144, y: 3.80392156862745, size: 1 },
    //     { x: 310.791366906475, y: 3.80392156862745, size: 1 },
    //     { x: 311.438848920863, y: 3.84313725490196, size: 1 },
    //     { x: 313.381294964029, y: 3.80392156862745, size: 1 },
    //     { x: 314.028776978417, y: 3.64705882352941, size: 1 },
    //     { x: 314.676258992806, y: 3.84313725490196, size: 1 },
    //     { x: 316.618705035971, y: 3.76470588235294, size: 1 },
    //     { x: 317.913669064748, y: 3.76470588235294, size: 1 },
    //     { x: 323.093525179856, y: 3.76470588235294, size: 1 },
    //     { x: 323.741007194245, y: 3.29411764705882, size: 1 },
    //     { x: 324.388489208633, y: 3.17647058823529, size: 1 },
    //     { x: 325.035971223022, y: 2.47058823529412, size: 1 },
    //     { x: 325.68345323741, y: 2.66666666666667, size: 1 },
    //     { x: 326.978417266187, y: 3.84313725490196, size: 1 },
    //     { x: 327.625899280576, y: 3.84313725490196, size: 1 },
    //     { x: 328.920863309353, y: 3.84313725490196, size: 1 },
    //     { x: 334.10071942446, y: 3.72549019607843, size: 1 },
    //     { x: 335.395683453237, y: 3.72549019607843, size: 1 },
    //     { x: 336.690647482014, y: 3.76470588235294, size: 1 },
    //     { x: 337.338129496403, y: 3.84313725490196, size: 1 },
    //     { x: 338.63309352518, y: 3.45098039215686, size: 1 },
    //     { x: 343.812949640288, y: 3.68627450980392, size: 1 },
    //     { x: 345.107913669065, y: 3.52941176470588, size: 1 },
    //     { x: 347.697841726619, y: 3.80392156862745, size: 1 },
    //     { x: 359.352517985611, y: 3.92156862745098, size: 1 },
    //     { x: 1.2972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 1.94594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 2.59459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 5.83783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 6.48648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 7.13513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 7.78378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 8.43243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 9.08108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 9.72972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 10.3783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 11.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 11.6756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 12.3243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 12.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 13.6216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 14.2702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 15.5675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 16.8648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 17.5135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 18.1621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 19.4594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 20.1081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 20.7567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 22.0540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 22.7027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 23.3513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 25.2972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 25.9459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 26.5945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 27.2432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 27.8918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 28.5405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 29.8378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 30.4864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 31.1351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 31.7837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 32.4324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 33.0810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 33.7297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 34.3783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 36.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 38.2702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 39.5675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 42.1621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 42.8108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 43.4594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 44.1081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 44.7567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 45.4054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 46.7027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 47.3513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 48.6486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 49.2972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 49.9459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 50.5945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 52.5405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 53.1891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 57.0810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 57.7297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 58.3783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 59.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 60.3243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 61.6216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 62.2702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 62.9189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 63.5675675675676, y: 4, size: 1 },
    //     { x: 64.8648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 65.5135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 66.1621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 66.8108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 67.4594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 68.1081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 68.7567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 69.4054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 70.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 70.7027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 71.3513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 72.6486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 73.2972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 74.5945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 75.8918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 76.5405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 77.8378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 78.4864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 79.7837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 80.4324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 81.0810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 81.7297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 83.6756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 84.3243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 87.5675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 88.2162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 88.8648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 89.5135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 90.1621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 90.8108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 91.4594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 93.4054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 94.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 95.3513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 96.6486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 97.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 99.8918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 100.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 101.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 101.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 102.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 103.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 103.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 104.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 106.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 107.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 107.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 108.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 109.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 110.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 110.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 112.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 113.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 114.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 116.108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 116.756756756757, y: 2.70588235294118, size: 1 },
    //     { x: 117.405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 118.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 119.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 120, y: 3.76470588235294, size: 1 },
    //     { x: 120.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 121.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 122.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 123.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 124.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 125.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 126.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 127.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 128.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 129.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 129.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 130.378378378378, y: 4, size: 1 },
    //     { x: 131.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 131.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 132.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 132.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 133.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 134.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 134.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 136.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 137.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 138.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 138.810810810811, y: 2.90196078431373, size: 1 },
    //     { x: 139.459459459459, y: 2.86274509803922, size: 1 },
    //     { x: 140.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 140.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 142.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 143.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 144, y: 3.68627450980392, size: 1 },
    //     { x: 144.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 145.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 147.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 147.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 148.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 149.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 150.486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 151.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 151.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 152.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 153.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 153.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 154.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 155.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 156.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 157.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 158.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 158.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 159.567567567568, y: 2.66666666666667, size: 1 },
    //     { x: 160.216216216216, y: 2.86274509803922, size: 1 },
    //     { x: 160.864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 161.513513513514, y: 3.01960784313725, size: 1 },
    //     { x: 162.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 162.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 163.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 164.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 164.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 166.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 166.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 168, y: 3.76470588235294, size: 1 },
    //     { x: 169.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 169.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 170.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 172.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 174.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 175.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 175.783783783784, y: 4.07843137254902, size: 1 },
    //     { x: 176.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 177.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 177.72972972973, y: 4.03921568627451, size: 1 },
    //     { x: 179.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 180.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 182.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 184.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 184.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 185.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 186.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 187.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 188.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 189.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 191.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 192.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 193.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 193.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 194.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 195.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 196.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 197.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 197.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 198.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 199.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 200.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 201.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 202.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 203.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 203.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 204.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 208.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 209.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 212.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 212.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 214.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 214.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 217.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 219.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 219.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 220.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 221.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 223.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 225.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 225.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 227.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 227.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 228.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 230.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 231.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 232.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 232.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 233.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 234.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 235.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 237.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 238.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 239.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 240.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 241.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 241.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 242.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 243.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 244.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 245.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 246.486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 247.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 247.783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 248.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 249.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 249.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 250.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 251.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 251.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 252.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 253.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 254.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 254.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 255.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 256.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 257.513513513513, y: 3.84313725490196, size: 1 },
    //     { x: 260.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 260.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 261.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 262.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 262.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 263.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 264, y: 3.84313725490196, size: 1 },
    //     { x: 264.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 266.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 267.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 268.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 269.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 269.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 270.486486486487, y: 3.72549019607843, size: 1 },
    //     { x: 271.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 271.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 273.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 275.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 276.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 276.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 277.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 278.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 278.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 282.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 282.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 283.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 284.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 284.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 285.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 286.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 287.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 288, y: 3.68627450980392, size: 1 },
    //     { x: 288.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 289.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 290.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 291.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 291.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 293.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 297.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 297.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 298.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 299.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 300.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 301.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 302.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 302.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 304.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 305.513513513513, y: 3.6078431372549, size: 1 },
    //     { x: 306.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 308.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 310.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 311.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 312, y: 3.41176470588235, size: 1 },
    //     { x: 313.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 313.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 315.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 315.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 318.486486486487, y: 3.45098039215686, size: 1 },
    //     { x: 319.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 319.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 322.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 323.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 324.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 325.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 326.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 327.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 328.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 328.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 330.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 332.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 332.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 333.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 334.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 334.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 337.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 338.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 339.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 339.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 340.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 341.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 343.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 344.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 345.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 345.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 346.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 347.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 350.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 350.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 351.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 352.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 354.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 355.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 356.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 357.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 358.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 359.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 10.3597122302158, y: 3.76470588235294, size: 1 },
    //     { x: 15.5395683453237, y: 3.2156862745098, size: 1 },
    //     { x: 16.1870503597122, y: 3.2156862745098, size: 1 },
    //     { x: 16.8345323741007, y: 3.37254901960784, size: 1 },
    //     { x: 19.4244604316547, y: 3.64705882352941, size: 1 },
    //     { x: 20.7194244604317, y: 3.6078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 3.72549019607843, size: 1 },
    //     { x: 24.6043165467626, y: 3.76470588235294, size: 1 },
    //     { x: 29.7841726618705, y: 3.88235294117647, size: 1 },
    //     { x: 34.3165467625899, y: 3.92156862745098, size: 1 },
    //     { x: 34.9640287769784, y: 3.64705882352941, size: 1 },
    //     { x: 38.8489208633094, y: 4.03921568627451, size: 1 },
    //     { x: 40.1438848920863, y: 4, size: 1 },
    //     { x: 40.7913669064748, y: 3.76470588235294, size: 1 },
    //     { x: 44.6762589928058, y: 4.03921568627451, size: 1 },
    //     { x: 45.9712230215827, y: 3.88235294117647, size: 1 },
    //     { x: 46.6187050359712, y: 3.84313725490196, size: 1 },
    //     { x: 50.5035971223022, y: 3.88235294117647, size: 1 },
    //     { x: 52.4460431654676, y: 3.88235294117647, size: 1 },
    //     { x: 54.3884892086331, y: 3.72549019607843, size: 1 },
    //     { x: 60.863309352518, y: 3.33333333333333, size: 1 },
    //     { x: 63.4532374100719, y: 3.84313725490196, size: 1 },
    //     { x: 65.3956834532374, y: 4.15686274509804, size: 1 },
    //     { x: 67.3381294964029, y: 3.64705882352941, size: 1 },
    //     { x: 68.6330935251799, y: 3.52941176470588, size: 1 },
    //     { x: 80.2877697841727, y: 3.09803921568627, size: 1 },
    //     { x: 80.9352517985612, y: 3.05882352941176, size: 1 },
    //     { x: 81.5827338129496, y: 3.2156862745098, size: 1 },
    //     { x: 82.8776978417266, y: 3.6078431372549, size: 1 },
    //     { x: 84.8201438848921, y: 3.76470588235294, size: 1 },
    //     { x: 95.8273381294964, y: 3.76470588235294, size: 1 },
    //     { x: 101.654676258993, y: 3.37254901960784, size: 1 },
    //     { x: 104.244604316547, y: 3.09803921568627, size: 1 },
    //     { x: 104.892086330935, y: 3.37254901960784, size: 1 },
    //     { x: 108.129496402878, y: 3.45098039215686, size: 1 },
    //     { x: 112.014388489209, y: 3.88235294117647, size: 1 },
    //     { x: 124.31654676259, y: 3.80392156862745, size: 1 },
    //     { x: 125.611510791367, y: 3.37254901960784, size: 1 },
    //     { x: 126.906474820144, y: 3.45098039215686, size: 1 },
    //     { x: 142.446043165468, y: 3.37254901960784, size: 1 },
    //     { x: 143.093525179856, y: 3.68627450980392, size: 1 },
    //     { x: 144.388489208633, y: 3.37254901960784, size: 1 },
    //     { x: 153.453237410072, y: 3.84313725490196, size: 1 },
    //     { x: 156.043165467626, y: 3.96078431372549, size: 1 },
    //     { x: 159.280575539568, y: 3.64705882352941, size: 1 },
    //     { x: 162.517985611511, y: 3.80392156862745, size: 1 },
    //     { x: 165.755395683453, y: 3.41176470588235, size: 1 },
    //     { x: 168.345323741007, y: 3.45098039215686, size: 1 },
    //     { x: 169.640287769784, y: 3.68627450980392, size: 1 },
    //     { x: 172.877697841727, y: 3.64705882352941, size: 1 },
    //     { x: 173.525179856115, y: 3.45098039215686, size: 1 },
    //     { x: 175.467625899281, y: 3.72549019607843, size: 1 },
    //     { x: 178.705035971223, y: 3.45098039215686, size: 1 },
    //     { x: 186.474820143885, y: 3.2156862745098, size: 1 },
    //     { x: 187.769784172662, y: 3.25490196078431, size: 1 },
    //     { x: 188.41726618705, y: 2.7843137254902, size: 1 },
    //     { x: 189.064748201439, y: 2.90196078431373, size: 1 },
    //     { x: 189.712230215827, y: 3.05882352941176, size: 1 },
    //     { x: 190.359712230216, y: 2.82352941176471, size: 1 },
    //     { x: 199.424460431655, y: 3.41176470588235, size: 1 },
    //     { x: 204.604316546763, y: 3.72549019607843, size: 1 },
    //     { x: 205.251798561151, y: 3.76470588235294, size: 1 },
    //     { x: 208.489208633094, y: 3.41176470588235, size: 1 },
    //     { x: 210.431654676259, y: 3.05882352941176, size: 1 },
    //     { x: 211.079136690647, y: 2.90196078431373, size: 1 },
    //     { x: 211.726618705036, y: 2.7843137254902, size: 1 },
    //     { x: 221.438848920863, y: 3.64705882352941, size: 1 },
    //     { x: 223.381294964029, y: 3.41176470588235, size: 1 },
    //     { x: 224.028776978417, y: 3.41176470588235, size: 1 },
    //     { x: 225.971223021583, y: 3.68627450980392, size: 1 },
    //     { x: 229.208633093525, y: 3.37254901960784, size: 1 },
    //     { x: 235.035971223022, y: 3.49019607843137, size: 1 },
    //     { x: 237.625899280576, y: 4.07843137254902, size: 1 },
    //     { x: 238.273381294964, y: 3.49019607843137, size: 1 },
    //     { x: 243.453237410072, y: 3.80392156862745, size: 1 },
    //     { x: 244.10071942446, y: 3.45098039215686, size: 1 },
    //     { x: 246.043165467626, y: 3.41176470588235, size: 1 },
    //     { x: 249.928057553957, y: 3.80392156862745, size: 1 },
    //     { x: 250.575539568345, y: 3.41176470588235, size: 1 },
    //     { x: 262.230215827338, y: 3.84313725490196, size: 1 },
    //     { x: 266.762589928058, y: 3.45098039215686, size: 1 },
    //     { x: 268.057553956835, y: 3.45098039215686, size: 1 },
    //     { x: 268.705035971223, y: 3.56862745098039, size: 1 },
    //     { x: 275.827338129496, y: 3.64705882352941, size: 1 },
    //     { x: 277.769784172662, y: 3.52941176470588, size: 1 },
    //     { x: 282.302158273381, y: 3.76470588235294, size: 1 },
    //     { x: 289.424460431655, y: 3.29411764705882, size: 1 },
    //     { x: 290.071942446043, y: 3.56862745098039, size: 1 },
    //     { x: 295.251798561151, y: 3.33333333333333, size: 1 },
    //     { x: 296.546762589928, y: 2.94117647058824, size: 1 },
    //     { x: 297.194244604317, y: 2.74509803921569, size: 1 },
    //     { x: 297.841726618705, y: 2.82352941176471, size: 1 },
    //     { x: 298.489208633094, y: 2.50980392156863, size: 1 },
    //     { x: 301.726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 315.323741007194, y: 3.37254901960784, size: 1 },
    //     { x: 320.503597122302, y: 3.52941176470588, size: 1 },
    //     { x: 325.035971223022, y: 3.68627450980392, size: 1 },
    //     { x: 325.68345323741, y: 4.03921568627451, size: 1 },
    //     { x: 328.920863309353, y: 3.45098039215686, size: 1 },
    //     { x: 329.568345323741, y: 3.68627450980392, size: 1 },
    //     { x: 332.805755395683, y: 3.84313725490196, size: 1 },
    //     { x: 334.748201438849, y: 3.52941176470588, size: 1 },
    //     { x: 336.043165467626, y: 3.76470588235294, size: 1 },
    //     { x: 339.280575539568, y: 3.29411764705882, size: 1 },
    //     { x: 339.928057553957, y: 3.29411764705882, size: 1 },
    //     { x: 340.575539568345, y: 3.88235294117647, size: 1 },
    //     { x: 341.870503597122, y: 4.07843137254902, size: 1 },
    //     { x: 345.107913669065, y: 3.92156862745098, size: 1 },
    //     { x: 348.992805755396, y: 3.88235294117647, size: 1 },
    //     { x: 350.287769784173, y: 3.88235294117647, size: 1 },
    //     { x: 353.525179856115, y: 3.88235294117647, size: 1 },
    //     { x: 355.467625899281, y: 3.92156862745098, size: 1 },
    //     { x: 1.94244604316547, y: 3.45098039215686, size: 1 },
    //     { x: 3.88489208633094, y: 3.33333333333333, size: 1 },
    //     { x: 8.41726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 11.0071942446043, y: 3.56862745098039, size: 1 },
    //     { x: 12.9496402877698, y: 3.6078431372549, size: 1 },
    //     { x: 14.2446043165468, y: 3.29411764705882, size: 1 },
    //     { x: 15.5395683453237, y: 3.41176470588235, size: 1 },
    //     { x: 17.4820143884892, y: 3.49019607843137, size: 1 },
    //     { x: 18.1294964028777, y: 3.29411764705882, size: 1 },
    //     { x: 20.7194244604317, y: 3.49019607843137, size: 1 },
    //     { x: 22.0143884892086, y: 3.41176470588235, size: 1 },
    //     { x: 22.6618705035971, y: 3.01960784313725, size: 1 },
    //     { x: 23.9568345323741, y: 3.2156862745098, size: 1 },
    //     { x: 24.6043165467626, y: 3.17647058823529, size: 1 },
    //     { x: 26.5467625899281, y: 3.37254901960784, size: 1 },
    //     { x: 29.136690647482, y: 3.33333333333333, size: 1 },
    //     { x: 29.7841726618705, y: 3.72549019607843, size: 1 },
    //     { x: 30.431654676259, y: 3.33333333333333, size: 1 },
    //     { x: 33.6690647482014, y: 3.37254901960784, size: 1 },
    //     { x: 40.7913669064748, y: 3.49019607843137, size: 1 },
    //     { x: 44.0287769784173, y: 2.54901960784314, size: 1 },
    //     { x: 44.6762589928058, y: 2.82352941176471, size: 1 },
    //     { x: 45.3237410071942, y: 2.58823529411765, size: 1 },
    //     { x: 47.2661870503597, y: 3.88235294117647, size: 1 },
    //     { x: 47.9136690647482, y: 3.96078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 3.64705882352941, size: 1 },
    //     { x: 50.5035971223022, y: 3.92156862745098, size: 1 },
    //     { x: 55.6834532374101, y: 3.64705882352941, size: 1 },
    //     { x: 65.3956834532374, y: 3.41176470588235, size: 1 },
    //     { x: 66.0431654676259, y: 3.29411764705882, size: 1 },
    //     { x: 66.6906474820144, y: 3.01960784313725, size: 1 },
    //     { x: 69.9280575539568, y: 4.03921568627451, size: 1 },
    //     { x: 70.5755395683453, y: 3.68627450980392, size: 1 },
    //     { x: 71.2230215827338, y: 3.6078431372549, size: 1 },
    //     { x: 71.8705035971223, y: 3.84313725490196, size: 1 },
    //     { x: 74.4604316546763, y: 3.6078431372549, size: 1 },
    //     { x: 78.3453237410072, y: 3.64705882352941, size: 1 },
    //     { x: 80.2877697841727, y: 4, size: 1 },
    //     { x: 83.5251798561151, y: 3.88235294117647, size: 1 },
    //     { x: 87.410071942446, y: 3.41176470588235, size: 1 },
    //     { x: 88.0575539568345, y: 3.25490196078431, size: 1 },
    //     { x: 88.705035971223, y: 3.29411764705882, size: 1 },
    //     { x: 89.3525179856115, y: 3.29411764705882, size: 1 },
    //     { x: 90, y: 3.09803921568627, size: 1 },
    //     { x: 90.6474820143885, y: 3.29411764705882, size: 1 },
    //     { x: 91.294964028777, y: 3.33333333333333, size: 1 },
    //     { x: 93.8848920863309, y: 3.29411764705882, size: 1 },
    //     { x: 94.5323741007194, y: 3.29411764705882, size: 1 },
    //     { x: 95.8273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 96.4748201438849, y: 3.72549019607843, size: 1 },
    //     { x: 97.1223021582734, y: 3.49019607843137, size: 1 },
    //     { x: 98.4172661870504, y: 3.2156862745098, size: 1 },
    //     { x: 101.007194244604, y: 3.37254901960784, size: 1 },
    //     { x: 102.302158273381, y: 3.33333333333333, size: 1 },
    //     { x: 104.892086330935, y: 3.29411764705882, size: 1 },
    //     { x: 105.539568345324, y: 3.41176470588235, size: 1 },
    //     { x: 107.482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 108.129496402878, y: 3.76470588235294, size: 1 },
    //     { x: 108.776978417266, y: 3.2156862745098, size: 1 },
    //     { x: 109.424460431655, y: 3.01960784313725, size: 1 },
    //     { x: 110.719424460432, y: 2.94117647058824, size: 1 },
    //     { x: 111.36690647482, y: 3.33333333333333, size: 1 },
    //     { x: 112.661870503597, y: 4.07843137254902, size: 1 },
    //     { x: 116.546762589928, y: 3.80392156862745, size: 1 },
    //     { x: 117.194244604317, y: 3.64705882352941, size: 1 },
    //     { x: 117.841726618705, y: 3.29411764705882, size: 1 },
    //     { x: 118.489208633094, y: 3.76470588235294, size: 1 },
    //     { x: 122.374100719424, y: 3.72549019607843, size: 1 },
    //     { x: 124.964028776978, y: 3.76470588235294, size: 1 },
    //     { x: 126.906474820144, y: 4, size: 1 },
    //     { x: 130.143884892086, y: 3.25490196078431, size: 1 },
    //     { x: 130.791366906475, y: 2.94117647058824, size: 1 },
    //     { x: 131.438848920863, y: 3.09803921568627, size: 1 },
    //     { x: 132.086330935252, y: 3.25490196078431, size: 1 },
    //     { x: 133.381294964029, y: 3.25490196078431, size: 1 },
    //     { x: 134.676258992806, y: 3.33333333333333, size: 1 },
    //     { x: 135.971223021583, y: 3.49019607843137, size: 1 },
    //     { x: 137.913669064748, y: 3.29411764705882, size: 1 },
    //     { x: 139.208633093525, y: 3.17647058823529, size: 1 },
    //     { x: 139.856115107914, y: 3.52941176470588, size: 1 },
    //     { x: 143.741007194245, y: 3.41176470588235, size: 1 },
    //     { x: 144.388489208633, y: 3.13725490196078, size: 1 },
    //     { x: 148.273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 155.395683453237, y: 3.6078431372549, size: 1 },
    //     { x: 163.165467625899, y: 3.92156862745098, size: 1 },
    //     { x: 172.230215827338, y: 3.2156862745098, size: 1 },
    //     { x: 172.877697841727, y: 3.17647058823529, size: 1 },
    //     { x: 173.525179856115, y: 3.01960784313725, size: 1 },
    //     { x: 174.172661870504, y: 2.94117647058824, size: 1 },
    //     { x: 176.115107913669, y: 3.80392156862745, size: 1 },
    //     { x: 177.410071942446, y: 4.23529411764706, size: 1 },
    //     { x: 179.352517985612, y: 3.68627450980392, size: 1 },
    //     { x: 184.532374100719, y: 3.88235294117647, size: 1 },
    //     { x: 185.179856115108, y: 3.92156862745098, size: 1 },
    //     { x: 186.474820143885, y: 3.96078431372549, size: 1 },
    //     { x: 187.122302158273, y: 4.07843137254902, size: 1 },
    //     { x: 188.41726618705, y: 3.88235294117647, size: 1 },
    //     { x: 190.359712230216, y: 3.88235294117647, size: 1 },
    //     { x: 191.007194244604, y: 3.92156862745098, size: 1 },
    //     { x: 191.654676258993, y: 4, size: 1 },
    //     { x: 192.94964028777, y: 3.84313725490196, size: 1 },
    //     { x: 194.892086330935, y: 3.29411764705882, size: 1 },
    //     { x: 195.539568345324, y: 3.33333333333333, size: 1 },
    //     { x: 196.187050359712, y: 3.17647058823529, size: 1 },
    //     { x: 196.834532374101, y: 2.94117647058824, size: 1 },
    //     { x: 197.482014388489, y: 2.94117647058824, size: 1 },
    //     { x: 204.604316546763, y: 3.80392156862745, size: 1 },
    //     { x: 207.194244604317, y: 3.6078431372549, size: 1 },
    //     { x: 209.136690647482, y: 3.56862745098039, size: 1 },
    //     { x: 210.431654676259, y: 3.68627450980392, size: 1 },
    //     { x: 212.374100719424, y: 3.80392156862745, size: 1 },
    //     { x: 213.669064748201, y: 3.96078431372549, size: 1 },
    //     { x: 216.258992805755, y: 3.29411764705882, size: 1 },
    //     { x: 216.906474820144, y: 3.37254901960784, size: 1 },
    //     { x: 218.848920863309, y: 3.33333333333333, size: 1 },
    //     { x: 219.496402877698, y: 3.41176470588235, size: 1 },
    //     { x: 220.791366906475, y: 3.37254901960784, size: 1 },
    //     { x: 222.73381294964, y: 3.25490196078431, size: 1 },
    //     { x: 223.381294964029, y: 3.25490196078431, size: 1 },
    //     { x: 224.676258992806, y: 3.2156862745098, size: 1 },
    //     { x: 225.323741007194, y: 3.52941176470588, size: 1 },
    //     { x: 227.26618705036, y: 3.45098039215686, size: 1 },
    //     { x: 229.208633093525, y: 3.41176470588235, size: 1 },
    //     { x: 230.503597122302, y: 3.17647058823529, size: 1 },
    //     { x: 231.798561151079, y: 3.45098039215686, size: 1 },
    //     { x: 234.388489208633, y: 3.25490196078431, size: 1 },
    //     { x: 235.68345323741, y: 3.41176470588235, size: 1 },
    //     { x: 236.978417266187, y: 3.84313725490196, size: 1 },
    //     { x: 238.273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 240.215827338129, y: 3.41176470588235, size: 1 },
    //     { x: 240.863309352518, y: 3.41176470588235, size: 1 },
    //     { x: 242.158273381295, y: 3.33333333333333, size: 1 },
    //     { x: 249.280575539568, y: 3.33333333333333, size: 1 },
    //     { x: 252.517985611511, y: 3.45098039215686, size: 1 },
    //     { x: 253.165467625899, y: 3.25490196078431, size: 1 },
    //     { x: 257.05035971223, y: 3.29411764705882, size: 1 },
    //     { x: 260.287769784173, y: 3.25490196078431, size: 1 },
    //     { x: 264.172661870504, y: 3.80392156862745, size: 1 },
    //     { x: 267.410071942446, y: 3.96078431372549, size: 1 },
    //     { x: 268.705035971223, y: 3.92156862745098, size: 1 },
    //     { x: 269.352517985611, y: 3.92156862745098, size: 1 },
    //     { x: 272.589928057554, y: 3.49019607843137, size: 1 },
    //     { x: 274.532374100719, y: 3.52941176470588, size: 1 },
    //     { x: 275.827338129496, y: 3.80392156862745, size: 1 },
    //     { x: 281.007194244604, y: 3.52941176470588, size: 1 },
    //     { x: 281.654676258993, y: 3.29411764705882, size: 1 },
    //     { x: 282.302158273381, y: 3.17647058823529, size: 1 },
    //     { x: 282.94964028777, y: 3.80392156862745, size: 1 },
    //     { x: 284.244604316547, y: 3.72549019607843, size: 1 },
    //     { x: 295.251798561151, y: 3.92156862745098, size: 1 },
    //     { x: 300.431654676259, y: 3.92156862745098, size: 1 },
    //     { x: 303.021582733813, y: 3.01960784313725, size: 1 },
    //     { x: 303.669064748201, y: 2.82352941176471, size: 1 },
    //     { x: 304.31654676259, y: 4.07843137254902, size: 1 },
    //     { x: 305.611510791367, y: 4, size: 1 },
    //     { x: 306.906474820144, y: 3.76470588235294, size: 1 },
    //     { x: 309.496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 312.73381294964, y: 4.07843137254902, size: 1 },
    //     { x: 313.381294964029, y: 3.76470588235294, size: 1 },
    //     { x: 315.971223021583, y: 3.88235294117647, size: 1 },
    //     { x: 319.208633093525, y: 3.92156862745098, size: 1 },
    //     { x: 323.093525179856, y: 3.45098039215686, size: 1 },
    //     { x: 324.388489208633, y: 3.45098039215686, size: 1 },
    //     { x: 325.035971223022, y: 3.37254901960784, size: 1 },
    //     { x: 325.68345323741, y: 4, size: 1 },
    //     { x: 327.625899280576, y: 3.88235294117647, size: 1 },
    //     { x: 334.748201438849, y: 4.11764705882353, size: 1 },
    //     { x: 340.575539568345, y: 3.80392156862745, size: 1 },
    //     { x: 346.402877697842, y: 2.90196078431373, size: 1 },
    //     { x: 347.05035971223, y: 3.01960784313725, size: 1 },
    //     { x: 348.345323741007, y: 4, size: 1 },
    //     { x: 349.640287769784, y: 3.6078431372549, size: 1 },
    //     { x: 354.172661870504, y: 3.72549019607843, size: 1 },
    //     { x: 354.820143884892, y: 3.52941176470588, size: 1 },
    //     { x: 358.705035971223, y: 3.76470588235294, size: 1 },
    //     { x: 6.47482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 7.76978417266187, y: 2.90196078431373, size: 1 },
    //     { x: 8.41726618705036, y: 2.82352941176471, size: 1 },
    //     { x: 9.71223021582734, y: 4, size: 1 },
    //     { x: 12.9496402877698, y: 3.84313725490196, size: 1 },
    //     { x: 17.4820143884892, y: 3.80392156862745, size: 1 },
    //     { x: 18.7769784172662, y: 3.56862745098039, size: 1 },
    //     { x: 23.3093525179856, y: 3.68627450980392, size: 1 },
    //     { x: 27.841726618705, y: 3.09803921568627, size: 1 },
    //     { x: 28.4892086330935, y: 3.33333333333333, size: 1 },
    //     { x: 29.7841726618705, y: 2.82352941176471, size: 1 },
    //     { x: 33.6690647482014, y: 3.68627450980392, size: 1 },
    //     { x: 42.0863309352518, y: 3.68627450980392, size: 1 },
    //     { x: 45.3237410071942, y: 3.76470588235294, size: 1 },
    //     { x: 49.2086330935252, y: 3.88235294117647, size: 1 },
    //     { x: 53.0935251798561, y: 3.80392156862745, size: 1 },
    //     { x: 55.0359712230216, y: 3.45098039215686, size: 1 },
    //     { x: 55.6834532374101, y: 3.76470588235294, size: 1 },
    //     { x: 56.9784172661871, y: 3.49019607843137, size: 1 },
    //     { x: 60.863309352518, y: 3.45098039215686, size: 1 },
    //     { x: 62.158273381295, y: 3.80392156862745, size: 1 },
    //     { x: 64.1007194244604, y: 3.6078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 3.88235294117647, size: 1 },
    //     { x: 67.3381294964029, y: 3.84313725490196, size: 1 },
    //     { x: 68.6330935251799, y: 3.92156862745098, size: 1 },
    //     { x: 70.5755395683453, y: 3.49019607843137, size: 1 },
    //     { x: 75.7553956834532, y: 3.49019607843137, size: 1 },
    //     { x: 80.2877697841727, y: 3.84313725490196, size: 1 },
    //     { x: 82.2302158273381, y: 3.84313725490196, size: 1 },
    //     { x: 84.1726618705036, y: 3.52941176470588, size: 1 },
    //     { x: 85.4676258992806, y: 3.76470588235294, size: 1 },
    //     { x: 86.7625899280576, y: 3.64705882352941, size: 1 },
    //     { x: 88.705035971223, y: 3.80392156862745, size: 1 },
    //     { x: 89.3525179856115, y: 3.52941176470588, size: 1 },
    //     { x: 90.6474820143885, y: 3.68627450980392, size: 1 },
    //     { x: 97.1223021582734, y: 3.80392156862745, size: 1 },
    //     { x: 102.302158273381, y: 3.72549019607843, size: 1 },
    //     { x: 109.424460431655, y: 3.76470588235294, size: 1 },
    //     { x: 110.719424460432, y: 3.84313725490196, size: 1 },
    //     { x: 114.604316546763, y: 3.49019607843137, size: 1 },
    //     { x: 115.251798561151, y: 3.45098039215686, size: 1 },
    //     { x: 115.89928057554, y: 3.33333333333333, size: 1 },
    //     { x: 119.136690647482, y: 3.72549019607843, size: 1 },
    //     { x: 119.784172661871, y: 3.45098039215686, size: 1 },
    //     { x: 120.431654676259, y: 3.72549019607843, size: 1 },
    //     { x: 123.669064748201, y: 3.92156862745098, size: 1 },
    //     { x: 124.964028776978, y: 3.80392156862745, size: 1 },
    //     { x: 125.611510791367, y: 3.41176470588235, size: 1 },
    //     { x: 128.201438848921, y: 3.80392156862745, size: 1 },
    //     { x: 128.848920863309, y: 3.84313725490196, size: 1 },
    //     { x: 135.971223021583, y: 3.25490196078431, size: 1 },
    //     { x: 136.618705035971, y: 3.2156862745098, size: 1 },
    //     { x: 137.26618705036, y: 2.43137254901961, size: 1 },
    //     { x: 137.913669064748, y: 2.35294117647059, size: 1 },
    //     { x: 138.561151079137, y: 2.62745098039216, size: 1 },
    //     { x: 139.208633093525, y: 2.47058823529412, size: 1 },
    //     { x: 140.503597122302, y: 4.11764705882353, size: 1 },
    //     { x: 142.446043165468, y: 3.64705882352941, size: 1 },
    //     { x: 144.388489208633, y: 3.80392156862745, size: 1 },
    //     { x: 145.035971223022, y: 3.84313725490196, size: 1 },
    //     { x: 145.68345323741, y: 3.80392156862745, size: 1 },
    //     { x: 152.805755395683, y: 4, size: 1 },
    //     { x: 154.10071942446, y: 3.88235294117647, size: 1 },
    //     { x: 154.748201438849, y: 3.88235294117647, size: 1 },
    //     { x: 157.338129496403, y: 3.88235294117647, size: 1 },
    //     { x: 157.985611510791, y: 3.41176470588235, size: 1 },
    //     { x: 159.928057553957, y: 3.80392156862745, size: 1 },
    //     { x: 164.460431654676, y: 3.84313725490196, size: 1 },
    //     { x: 168.345323741007, y: 3.72549019607843, size: 1 },
    //     { x: 170.935251798561, y: 3.92156862745098, size: 1 },
    //     { x: 175.467625899281, y: 4.07843137254902, size: 1 },
    //     { x: 178.057553956835, y: 3.72549019607843, size: 1 },
    //     { x: 180, y: 4, size: 1 },
    //     { x: 180.647482014388, y: 3.49019607843137, size: 1 },
    //     { x: 185.827338129496, y: 3.68627450980392, size: 1 },
    //     { x: 187.122302158273, y: 3.80392156862745, size: 1 },
    //     { x: 191.007194244604, y: 3.80392156862745, size: 1 },
    //     { x: 196.187050359712, y: 3.80392156862745, size: 1 },
    //     { x: 202.014388489209, y: 3.52941176470588, size: 1 },
    //     { x: 202.661870503597, y: 3.80392156862745, size: 1 },
    //     { x: 203.309352517986, y: 3.29411764705882, size: 1 },
    //     { x: 203.956834532374, y: 3.25490196078431, size: 1 },
    //     { x: 204.604316546763, y: 3.33333333333333, size: 1 },
    //     { x: 205.251798561151, y: 3.2156862745098, size: 1 },
    //     { x: 206.546762589928, y: 3.37254901960784, size: 1 },
    //     { x: 207.841726618705, y: 3.33333333333333, size: 1 },
    //     { x: 208.489208633094, y: 3.29411764705882, size: 1 },
    //     { x: 209.136690647482, y: 3.25490196078431, size: 1 },
    //     { x: 210.431654676259, y: 3.45098039215686, size: 1 },
    //     { x: 211.079136690647, y: 3.29411764705882, size: 1 },
    //     { x: 213.021582733813, y: 3.37254901960784, size: 1 },
    //     { x: 216.258992805755, y: 3.25490196078431, size: 1 },
    //     { x: 218.848920863309, y: 3.09803921568627, size: 1 },
    //     { x: 219.496402877698, y: 3.25490196078431, size: 1 },
    //     { x: 220.143884892086, y: 3.29411764705882, size: 1 },
    //     { x: 220.791366906475, y: 3.13725490196078, size: 1 },
    //     { x: 221.438848920863, y: 3.17647058823529, size: 1 },
    //     { x: 222.086330935252, y: 3.56862745098039, size: 1 },
    //     { x: 224.028776978417, y: 3.13725490196078, size: 1 },
    //     { x: 230.503597122302, y: 3.45098039215686, size: 1 },
    //     { x: 237.625899280576, y: 3.37254901960784, size: 1 },
    //     { x: 238.273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 240.863309352518, y: 3.45098039215686, size: 1 },
    //     { x: 252.517985611511, y: 3.41176470588235, size: 1 },
    //     { x: 254.460431654676, y: 3.37254901960784, size: 1 },
    //     { x: 255.755395683453, y: 3.41176470588235, size: 1 },
    //     { x: 262.877697841727, y: 3.41176470588235, size: 1 },
    //     { x: 268.057553956835, y: 3.92156862745098, size: 1 },
    //     { x: 270.647482014389, y: 3.52941176470588, size: 1 },
    //     { x: 282.302158273381, y: 3.80392156862745, size: 1 },
    //     { x: 282.94964028777, y: 3.96078431372549, size: 1 },
    //     { x: 288.129496402878, y: 3.41176470588235, size: 1 },
    //     { x: 288.776978417266, y: 3.05882352941176, size: 1 },
    //     { x: 293.309352517986, y: 3.80392156862745, size: 1 },
    //     { x: 295.251798561151, y: 3.88235294117647, size: 1 },
    //     { x: 296.546762589928, y: 3.84313725490196, size: 1 },
    //     { x: 301.079136690647, y: 3.80392156862745, size: 1 },
    //     { x: 306.258992805755, y: 3.80392156862745, size: 1 },
    //     { x: 310.791366906475, y: 3.41176470588235, size: 1 },
    //     { x: 314.676258992806, y: 3.80392156862745, size: 1 },
    //     { x: 315.323741007194, y: 3.96078431372549, size: 1 },
    //     { x: 315.971223021583, y: 4.07843137254902, size: 1 },
    //     { x: 321.151079136691, y: 4, size: 1 },
    //     { x: 325.035971223022, y: 3.84313725490196, size: 1 },
    //     { x: 325.68345323741, y: 3.88235294117647, size: 1 },
    //     { x: 326.978417266187, y: 4, size: 1 },
    //     { x: 330.863309352518, y: 3.76470588235294, size: 1 },
    //     { x: 342.517985611511, y: 3.64705882352941, size: 1 },
    //     { x: 347.697841726619, y: 3.64705882352941, size: 1 },
    //     { x: 348.345323741007, y: 3.84313725490196, size: 1 },
    //     { x: 352.230215827338, y: 3.45098039215686, size: 1 },
    //     { x: 356.115107913669, y: 3.88235294117647, size: 1 },
    //     { x: 357.410071942446, y: 3.84313725490196, size: 1 },
    //     { x: 358.705035971223, y: 3.72549019607843, size: 1 },
    //     { x: 3.24324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 3.89189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 4.54054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 5.83783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 7.78378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 8.43243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 9.08108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 10.3783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 13.6216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 14.2702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 14.9189189189189, y: 2, size: 1 },
    //     { x: 15.5675675675676, y: 1.96078431372549, size: 1 },
    //     { x: 16.2162162162162, y: 2, size: 1 },
    //     { x: 16.8648648648649, y: 1.72549019607843, size: 1 },
    //     { x: 17.5135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 18.1621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 18.8108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 19.4594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 22.7027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 23.3513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 27.8918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 28.5405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 29.1891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 29.8378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 30.4864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 31.1351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 33.0810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 35.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 35.6756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 36.3243243243243, y: 2.19607843137255, size: 1 },
    //     { x: 36.972972972973, y: 2.23529411764706, size: 1 },
    //     { x: 37.6216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 38.2702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 38.9189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 39.5675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 40.8648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 41.5135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 42.1621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 43.4594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 44.7567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 46.0540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 47.3513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 48, y: 3.76470588235294, size: 1 },
    //     { x: 49.2972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 49.9459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 51.2432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 52.5405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 54.4864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 55.1351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 55.7837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 57.0810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 58.3783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 59.6756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 60.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 61.6216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 64.2162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 64.8648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 65.5135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 66.1621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 68.1081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 68.7567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 70.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 70.7027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 72, y: 3.68627450980392, size: 1 },
    //     { x: 72.6486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 73.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 75.8918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 78.4864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 79.1351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 79.7837837837838, y: 2.43137254901961, size: 1 },
    //     { x: 80.4324324324324, y: 2.90196078431373, size: 1 },
    //     { x: 81.0810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 81.7297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 83.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 84.3243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 84.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 86.2702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 86.9189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 88.2162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 88.8648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 90.8108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 91.4594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 92.7567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 94.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 94.7027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 96.6486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 97.2972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 97.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 98.5945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 99.2432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 99.8918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 100.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 101.189189189189, y: 2.66666666666667, size: 1 },
    //     { x: 101.837837837838, y: 1.96078431372549, size: 1 },
    //     { x: 102.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 103.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 104.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 105.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 107.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 107.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 108.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 110.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 110.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 111.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 112.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 113.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 114.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 114.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 115.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 116.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 117.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 118.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 118.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 119.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 120.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 122.594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 123.243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 125.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 127.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 128.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 130.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 131.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 132.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 133.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 134.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 135.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 137.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 138.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 138.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 140.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 140.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 143.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 144.648648648649, y: 2.11764705882353, size: 1 },
    //     { x: 145.297297297297, y: 2.31372549019608, size: 1 },
    //     { x: 145.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 147.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 149.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 151.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 152.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 153.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 153.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 154.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 155.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 156.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 156.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 157.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 158.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 159.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 162.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 164.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 165.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 166.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 167.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 168, y: 3.84313725490196, size: 1 },
    //     { x: 169.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 171.243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 172.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 173.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 175.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 176.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 178.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 179.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 180.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 180.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 182.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 183.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 185.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 186.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 186.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 188.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 189.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 190.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 190.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 192.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 196.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 198.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 199.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 200.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 201.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 202.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 203.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 204.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 204.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 205.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 206.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 208.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 210.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 211.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 212.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 212.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 213.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 214.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 218.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 219.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 219.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 220.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 221.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 221.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 222.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 223.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 224.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 225.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 226.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 227.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 228.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 229.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 230.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 230.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 231.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 232.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 232.864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 233.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 234.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 234.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 235.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 236.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 236.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 237.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 238.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 238.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 239.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 240, y: 3.41176470588235, size: 1 },
    //     { x: 240.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 241.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 243.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 243.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 244.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 245.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 245.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 246.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 247.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 248.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 249.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 250.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 251.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 251.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 252.324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 252.972972972973, y: 2.50980392156863, size: 1 },
    //     { x: 254.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 255.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 256.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 257.513513513513, y: 3.68627450980392, size: 1 },
    //     { x: 258.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 259.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 260.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 260.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 261.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 262.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 262.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 263.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 264.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 265.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 267.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 268.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 269.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 272.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 273.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 273.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 274.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 275.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 276.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 276.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 277.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 278.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 280.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 280.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 281.513513513513, y: 3.2156862745098, size: 1 },
    //     { x: 282.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 282.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 283.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 284.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 284.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 285.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 286.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 286.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 288, y: 3.2156862745098, size: 1 },
    //     { x: 288.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 289.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 289.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 291.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 292.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 293.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 294.486486486487, y: 3.84313725490196, size: 1 },
    //     { x: 295.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 297.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 298.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 300.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 301.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 302.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 305.513513513513, y: 3.88235294117647, size: 1 },
    //     { x: 306.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 307.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 308.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 309.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 310.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 312, y: 4, size: 1 },
    //     { x: 313.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 314.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 315.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 315.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 316.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 317.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 318.486486486487, y: 3.64705882352941, size: 1 },
    //     { x: 319.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 321.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 322.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 323.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 323.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 324.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 325.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 326.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 326.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 328.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 328.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 329.513513513513, y: 3.68627450980392, size: 1 },
    //     { x: 330.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 330.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 331.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 332.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 332.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 333.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 334.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 334.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 337.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 339.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 341.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 343.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 344.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 345.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 345.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 346.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 347.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 348.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 349.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 350.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 350.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 351.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 352.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 352.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 355.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 356.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 357.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 358.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 359.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 0, y: 3.33333333333333, size: 1 },
    //     { x: 0.647482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 1.94244604316547, y: 3.33333333333333, size: 1 },
    //     { x: 4.53237410071942, y: 3.88235294117647, size: 1 },
    //     { x: 7.76978417266187, y: 3.76470588235294, size: 1 },
    //     { x: 9.71223021582734, y: 3.88235294117647, size: 1 },
    //     { x: 16.1870503597122, y: 3.72549019607843, size: 1 },
    //     { x: 17.4820143884892, y: 3.64705882352941, size: 1 },
    //     { x: 20.7194244604317, y: 3.37254901960784, size: 1 },
    //     { x: 22.0143884892086, y: 3.2156862745098, size: 1 },
    //     { x: 22.6618705035971, y: 3.29411764705882, size: 1 },
    //     { x: 23.3093525179856, y: 3.25490196078431, size: 1 },
    //     { x: 27.1942446043165, y: 3.88235294117647, size: 1 },
    //     { x: 29.136690647482, y: 3.52941176470588, size: 1 },
    //     { x: 31.726618705036, y: 3.72549019607843, size: 1 },
    //     { x: 38.8489208633094, y: 3.88235294117647, size: 1 },
    //     { x: 40.7913669064748, y: 3.80392156862745, size: 1 },
    //     { x: 43.3812949640288, y: 3.13725490196078, size: 1 },
    //     { x: 44.0287769784173, y: 2.70588235294118, size: 1 },
    //     { x: 44.6762589928058, y: 3.2156862745098, size: 1 },
    //     { x: 45.3237410071942, y: 2.82352941176471, size: 1 },
    //     { x: 45.9712230215827, y: 3.13725490196078, size: 1 },
    //     { x: 46.6187050359712, y: 3.33333333333333, size: 1 },
    //     { x: 47.9136690647482, y: 3.56862745098039, size: 1 },
    //     { x: 48.5611510791367, y: 3.33333333333333, size: 1 },
    //     { x: 49.8561151079137, y: 3.29411764705882, size: 1 },
    //     { x: 50.5035971223022, y: 3.29411764705882, size: 1 },
    //     { x: 51.1510791366906, y: 3.33333333333333, size: 1 },
    //     { x: 55.0359712230216, y: 3.13725490196078, size: 1 },
    //     { x: 56.3309352517986, y: 3.29411764705882, size: 1 },
    //     { x: 56.9784172661871, y: 3.17647058823529, size: 1 },
    //     { x: 58.273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 58.9208633093525, y: 3.33333333333333, size: 1 },
    //     { x: 59.568345323741, y: 3.33333333333333, size: 1 },
    //     { x: 61.5107913669065, y: 3.29411764705882, size: 1 },
    //     { x: 62.158273381295, y: 3.49019607843137, size: 1 },
    //     { x: 62.8057553956835, y: 3.2156862745098, size: 1 },
    //     { x: 64.1007194244604, y: 3.09803921568627, size: 1 },
    //     { x: 65.3956834532374, y: 3.09803921568627, size: 1 },
    //     { x: 66.0431654676259, y: 2.90196078431373, size: 1 },
    //     { x: 66.6906474820144, y: 2.66666666666667, size: 1 },
    //     { x: 67.9856115107914, y: 3.13725490196078, size: 1 },
    //     { x: 73.1654676258993, y: 3.92156862745098, size: 1 },
    //     { x: 75.1079136690647, y: 3.88235294117647, size: 1 },
    //     { x: 75.7553956834532, y: 3.72549019607843, size: 1 },
    //     { x: 76.4028776978417, y: 3.76470588235294, size: 1 },
    //     { x: 77.0503597122302, y: 3.88235294117647, size: 1 },
    //     { x: 77.6978417266187, y: 3.76470588235294, size: 1 },
    //     { x: 78.3453237410072, y: 3.88235294117647, size: 1 },
    //     { x: 79.6402877697842, y: 3.84313725490196, size: 1 },
    //     { x: 80.9352517985612, y: 3.88235294117647, size: 1 },
    //     { x: 82.8776978417266, y: 3.88235294117647, size: 1 },
    //     { x: 84.1726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 84.8201438848921, y: 4.03921568627451, size: 1 },
    //     { x: 86.7625899280576, y: 3.37254901960784, size: 1 },
    //     { x: 89.3525179856115, y: 3.76470588235294, size: 1 },
    //     { x: 90.6474820143885, y: 3.76470588235294, size: 1 },
    //     { x: 91.294964028777, y: 3.68627450980392, size: 1 },
    //     { x: 92.589928057554, y: 4.15686274509804, size: 1 },
    //     { x: 94.5323741007194, y: 3.80392156862745, size: 1 },
    //     { x: 95.1798561151079, y: 3.88235294117647, size: 1 },
    //     { x: 95.8273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 97.7697841726619, y: 4.11764705882353, size: 1 },
    //     { x: 99.0647482014388, y: 4.07843137254902, size: 1 },
    //     { x: 100.359712230216, y: 3.72549019607843, size: 1 },
    //     { x: 101.654676258993, y: 3.72549019607843, size: 1 },
    //     { x: 103.597122302158, y: 3.92156862745098, size: 1 },
    //     { x: 104.892086330935, y: 3.84313725490196, size: 1 },
    //     { x: 106.187050359712, y: 3.84313725490196, size: 1 },
    //     { x: 111.36690647482, y: 3.72549019607843, size: 1 },
    //     { x: 115.89928057554, y: 3.88235294117647, size: 1 },
    //     { x: 120.431654676259, y: 3.92156862745098, size: 1 },
    //     { x: 121.079136690647, y: 3.72549019607843, size: 1 },
    //     { x: 124.964028776978, y: 3.92156862745098, size: 1 },
    //     { x: 126.906474820144, y: 3.88235294117647, size: 1 },
    //     { x: 127.553956834532, y: 3.88235294117647, size: 1 },
    //     { x: 129.496402877698, y: 3.68627450980392, size: 1 },
    //     { x: 132.73381294964, y: 3.80392156862745, size: 1 },
    //     { x: 134.028776978417, y: 3.84313725490196, size: 1 },
    //     { x: 137.26618705036, y: 4.11764705882353, size: 1 },
    //     { x: 137.913669064748, y: 3.68627450980392, size: 1 },
    //     { x: 138.561151079137, y: 3.49019607843137, size: 1 },
    //     { x: 139.208633093525, y: 3.84313725490196, size: 1 },
    //     { x: 139.856115107914, y: 3.76470588235294, size: 1 },
    //     { x: 145.68345323741, y: 3.68627450980392, size: 1 },
    //     { x: 149.568345323741, y: 3.92156862745098, size: 1 },
    //     { x: 150.863309352518, y: 3.25490196078431, size: 1 },
    //     { x: 151.510791366906, y: 3.25490196078431, size: 1 },
    //     { x: 152.158273381295, y: 2.90196078431373, size: 1 },
    //     { x: 153.453237410072, y: 3.68627450980392, size: 1 },
    //     { x: 162.517985611511, y: 4, size: 1 },
    //     { x: 163.812949640288, y: 3.96078431372549, size: 1 },
    //     { x: 176.115107913669, y: 3.56862745098039, size: 1 },
    //     { x: 181.294964028777, y: 3.29411764705882, size: 1 },
    //     { x: 183.237410071942, y: 3.80392156862745, size: 1 },
    //     { x: 185.179856115108, y: 3.37254901960784, size: 1 },
    //     { x: 187.769784172662, y: 3.45098039215686, size: 1 },
    //     { x: 188.41726618705, y: 3.41176470588235, size: 1 },
    //     { x: 191.654676258993, y: 3.45098039215686, size: 1 },
    //     { x: 194.892086330935, y: 3.88235294117647, size: 1 },
    //     { x: 205.251798561151, y: 3.84313725490196, size: 1 },
    //     { x: 208.489208633094, y: 3.88235294117647, size: 1 },
    //     { x: 210.431654676259, y: 3.96078431372549, size: 1 },
    //     { x: 215.611510791367, y: 3.84313725490196, size: 1 },
    //     { x: 216.258992805755, y: 3.56862745098039, size: 1 },
    //     { x: 218.201438848921, y: 3.45098039215686, size: 1 },
    //     { x: 238.273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 238.920863309353, y: 3.17647058823529, size: 1 },
    //     { x: 239.568345323741, y: 3.25490196078431, size: 1 },
    //     { x: 240.215827338129, y: 3.05882352941176, size: 1 },
    //     { x: 240.863309352518, y: 3.37254901960784, size: 1 },
    //     { x: 242.158273381295, y: 3.41176470588235, size: 1 },
    //     { x: 246.690647482014, y: 3.41176470588235, size: 1 },
    //     { x: 248.63309352518, y: 3.49019607843137, size: 1 },
    //     { x: 259.640287769784, y: 3.01960784313725, size: 1 },
    //     { x: 260.287769784173, y: 2.98039215686275, size: 1 },
    //     { x: 260.935251798561, y: 3.09803921568627, size: 1 },
    //     { x: 261.58273381295, y: 3.01960784313725, size: 1 },
    //     { x: 264.820143884892, y: 3.84313725490196, size: 1 },
    //     { x: 272.589928057554, y: 3.68627450980392, size: 1 },
    //     { x: 273.884892086331, y: 3.92156862745098, size: 1 },
    //     { x: 280.359712230216, y: 3.41176470588235, size: 1 },
    //     { x: 281.007194244604, y: 3.29411764705882, size: 1 },
    //     { x: 282.94964028777, y: 3.17647058823529, size: 1 },
    //     { x: 283.597122302158, y: 3.25490196078431, size: 1 },
    //     { x: 292.014388489209, y: 3.80392156862745, size: 1 },
    //     { x: 297.841726618705, y: 3.72549019607843, size: 1 },
    //     { x: 299.784172661871, y: 3.56862745098039, size: 1 },
    //     { x: 301.726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 302.374100719424, y: 3.33333333333333, size: 1 },
    //     { x: 303.021582733813, y: 2.50980392156863, size: 1 },
    //     { x: 303.669064748201, y: 2.50980392156863, size: 1 },
    //     { x: 304.31654676259, y: 2.98039215686275, size: 1 },
    //     { x: 314.028776978417, y: 3.92156862745098, size: 1 },
    //     { x: 316.618705035971, y: 3.92156862745098, size: 1 },
    //     { x: 319.208633093525, y: 4.03921568627451, size: 1 },
    //     { x: 320.503597122302, y: 3.92156862745098, size: 1 },
    //     { x: 324.388489208633, y: 3.41176470588235, size: 1 },
    //     { x: 326.330935251799, y: 3.33333333333333, size: 1 },
    //     { x: 331.510791366906, y: 3.88235294117647, size: 1 },
    //     { x: 345.755395683453, y: 3.37254901960784, size: 1 },
    //     { x: 346.402877697842, y: 3.17647058823529, size: 1 },
    //     { x: 349.640287769784, y: 3.41176470588235, size: 1 },
    //     { x: 351.58273381295, y: 3.49019607843137, size: 1 },
    //     { x: 353.525179856115, y: 3.29411764705882, size: 1 },
    //     { x: 359.352517985611, y: 3.64705882352941, size: 1 },
    //     { x: 5.8273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 6.47482014388489, y: 3.76470588235294, size: 1 },
    //     { x: 11.6546762589928, y: 3.29411764705882, size: 1 },
    //     { x: 14.8920863309353, y: 3.17647058823529, size: 1 },
    //     { x: 15.5395683453237, y: 3.37254901960784, size: 1 },
    //     { x: 16.1870503597122, y: 3.33333333333333, size: 1 },
    //     { x: 18.7769784172662, y: 3.29411764705882, size: 1 },
    //     { x: 19.4244604316547, y: 3.29411764705882, size: 1 },
    //     { x: 24.6043165467626, y: 3.25490196078431, size: 1 },
    //     { x: 25.2517985611511, y: 3.33333333333333, size: 1 },
    //     { x: 25.8992805755396, y: 3.33333333333333, size: 1 },
    //     { x: 26.5467625899281, y: 3.33333333333333, size: 1 },
    //     { x: 31.0791366906475, y: 3.29411764705882, size: 1 },
    //     { x: 32.3741007194245, y: 3.33333333333333, size: 1 },
    //     { x: 34.9640287769784, y: 3.25490196078431, size: 1 },
    //     { x: 35.6115107913669, y: 3.37254901960784, size: 1 },
    //     { x: 36.2589928057554, y: 3.17647058823529, size: 1 },
    //     { x: 36.9064748201439, y: 3.25490196078431, size: 1 },
    //     { x: 37.5539568345324, y: 3.37254901960784, size: 1 },
    //     { x: 43.3812949640288, y: 3.29411764705882, size: 1 },
    //     { x: 44.0287769784173, y: 3.33333333333333, size: 1 },
    //     { x: 45.9712230215827, y: 3.37254901960784, size: 1 },
    //     { x: 47.2661870503597, y: 3.33333333333333, size: 1 },
    //     { x: 47.9136690647482, y: 3.29411764705882, size: 1 },
    //     { x: 49.2086330935252, y: 3.33333333333333, size: 1 },
    //     { x: 51.1510791366906, y: 3.09803921568627, size: 1 },
    //     { x: 51.7985611510791, y: 3.49019607843137, size: 1 },
    //     { x: 55.0359712230216, y: 3.56862745098039, size: 1 },
    //     { x: 57.6258992805755, y: 3.84313725490196, size: 1 },
    //     { x: 61.5107913669065, y: 3.52941176470588, size: 1 },
    //     { x: 63.4532374100719, y: 3.45098039215686, size: 1 },
    //     { x: 64.7482014388489, y: 3.64705882352941, size: 1 },
    //     { x: 66.0431654676259, y: 3.84313725490196, size: 1 },
    //     { x: 72.5179856115108, y: 3.49019607843137, size: 1 },
    //     { x: 73.8129496402878, y: 3.25490196078431, size: 1 },
    //     { x: 74.4604316546763, y: 3.2156862745098, size: 1 },
    //     { x: 75.1079136690647, y: 3.41176470588235, size: 1 },
    //     { x: 75.7553956834532, y: 3.2156862745098, size: 1 },
    //     { x: 76.4028776978417, y: 3.09803921568627, size: 1 },
    //     { x: 78.3453237410072, y: 3.25490196078431, size: 1 },
    //     { x: 79.6402877697842, y: 3.29411764705882, size: 1 },
    //     { x: 80.2877697841727, y: 3.2156862745098, size: 1 },
    //     { x: 80.9352517985612, y: 3.29411764705882, size: 1 },
    //     { x: 82.8776978417266, y: 3.41176470588235, size: 1 },
    //     { x: 84.1726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 84.8201438848921, y: 3.33333333333333, size: 1 },
    //     { x: 85.4676258992806, y: 3.29411764705882, size: 1 },
    //     { x: 86.7625899280576, y: 3.09803921568627, size: 1 },
    //     { x: 87.410071942446, y: 3.37254901960784, size: 1 },
    //     { x: 88.0575539568345, y: 3.41176470588235, size: 1 },
    //     { x: 91.9424460431655, y: 3.45098039215686, size: 1 },
    //     { x: 95.8273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 97.1223021582734, y: 3.25490196078431, size: 1 },
    //     { x: 97.7697841726619, y: 3.29411764705882, size: 1 },
    //     { x: 100.359712230216, y: 3.45098039215686, size: 1 },
    //     { x: 102.302158273381, y: 3.01960784313725, size: 1 },
    //     { x: 104.244604316547, y: 3.84313725490196, size: 1 },
    //     { x: 105.539568345324, y: 3.33333333333333, size: 1 },
    //     { x: 106.187050359712, y: 3.17647058823529, size: 1 },
    //     { x: 106.834532374101, y: 3.29411764705882, size: 1 },
    //     { x: 107.482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 110.719424460432, y: 3.33333333333333, size: 1 },
    //     { x: 111.36690647482, y: 3.29411764705882, size: 1 },
    //     { x: 112.014388489209, y: 3.17647058823529, size: 1 },
    //     { x: 113.309352517986, y: 3.37254901960784, size: 1 },
    //     { x: 113.956834532374, y: 3.37254901960784, size: 1 },
    //     { x: 114.604316546763, y: 3.37254901960784, size: 1 },
    //     { x: 115.89928057554, y: 2.98039215686275, size: 1 },
    //     { x: 116.546762589928, y: 2.98039215686275, size: 1 },
    //     { x: 117.194244604317, y: 3.29411764705882, size: 1 },
    //     { x: 119.136690647482, y: 3.41176470588235, size: 1 },
    //     { x: 121.726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 122.374100719424, y: 3.37254901960784, size: 1 },
    //     { x: 123.021582733813, y: 3.17647058823529, size: 1 },
    //     { x: 123.669064748201, y: 3.29411764705882, size: 1 },
    //     { x: 125.611510791367, y: 3.49019607843137, size: 1 },
    //     { x: 126.258992805755, y: 3.41176470588235, size: 1 },
    //     { x: 127.553956834532, y: 3.17647058823529, size: 1 },
    //     { x: 128.201438848921, y: 3.17647058823529, size: 1 },
    //     { x: 130.143884892086, y: 3.2156862745098, size: 1 },
    //     { x: 131.438848920863, y: 3.2156862745098, size: 1 },
    //     { x: 132.73381294964, y: 3.29411764705882, size: 1 },
    //     { x: 134.028776978417, y: 3.29411764705882, size: 1 },
    //     { x: 134.676258992806, y: 3.41176470588235, size: 1 },
    //     { x: 138.561151079137, y: 3.41176470588235, size: 1 },
    //     { x: 140.503597122302, y: 3.37254901960784, size: 1 },
    //     { x: 141.798561151079, y: 3.76470588235294, size: 1 },
    //     { x: 144.388489208633, y: 3.2156862745098, size: 1 },
    //     { x: 149.568345323741, y: 3.29411764705882, size: 1 },
    //     { x: 150.863309352518, y: 3.37254901960784, size: 1 },
    //     { x: 152.158273381295, y: 3.41176470588235, size: 1 },
    //     { x: 153.453237410072, y: 3.45098039215686, size: 1 },
    //     { x: 155.395683453237, y: 3.41176470588235, size: 1 },
    //     { x: 156.043165467626, y: 3.33333333333333, size: 1 },
    //     { x: 156.690647482014, y: 3.33333333333333, size: 1 },
    //     { x: 157.338129496403, y: 3.49019607843137, size: 1 },
    //     { x: 157.985611510791, y: 3.45098039215686, size: 1 },
    //     { x: 158.63309352518, y: 3.45098039215686, size: 1 },
    //     { x: 159.928057553957, y: 3.88235294117647, size: 1 },
    //     { x: 161.870503597122, y: 3.68627450980392, size: 1 },
    //     { x: 168.992805755396, y: 3.80392156862745, size: 1 },
    //     { x: 170.935251798561, y: 3.37254901960784, size: 1 },
    //     { x: 180.647482014388, y: 3.13725490196078, size: 1 },
    //     { x: 182.589928057554, y: 3.80392156862745, size: 1 },
    //     { x: 183.884892086331, y: 3.88235294117647, size: 1 },
    //     { x: 188.41726618705, y: 3.72549019607843, size: 1 },
    //     { x: 189.064748201439, y: 3.92156862745098, size: 1 },
    //     { x: 198.129496402878, y: 3.88235294117647, size: 1 },
    //     { x: 201.36690647482, y: 3.09803921568627, size: 1 },
    //     { x: 202.014388489209, y: 3.25490196078431, size: 1 },
    //     { x: 202.661870503597, y: 2.94117647058824, size: 1 },
    //     { x: 203.309352517986, y: 3.41176470588235, size: 1 },
    //     { x: 203.956834532374, y: 3.45098039215686, size: 1 },
    //     { x: 204.604316546763, y: 3.2156862745098, size: 1 },
    //     { x: 207.194244604317, y: 3.33333333333333, size: 1 },
    //     { x: 207.841726618705, y: 3.41176470588235, size: 1 },
    //     { x: 209.784172661871, y: 3.25490196078431, size: 1 },
    //     { x: 212.374100719424, y: 3.64705882352941, size: 1 },
    //     { x: 213.021582733813, y: 3.2156862745098, size: 1 },
    //     { x: 214.31654676259, y: 3.17647058823529, size: 1 },
    //     { x: 215.611510791367, y: 3.25490196078431, size: 1 },
    //     { x: 218.848920863309, y: 3.29411764705882, size: 1 },
    //     { x: 220.143884892086, y: 3.33333333333333, size: 1 },
    //     { x: 220.791366906475, y: 3.25490196078431, size: 1 },
    //     { x: 222.086330935252, y: 3.88235294117647, size: 1 },
    //     { x: 227.913669064748, y: 3.64705882352941, size: 1 },
    //     { x: 229.856115107914, y: 3.41176470588235, size: 1 },
    //     { x: 231.798561151079, y: 3.76470588235294, size: 1 },
    //     { x: 233.093525179856, y: 3.84313725490196, size: 1 },
    //     { x: 235.68345323741, y: 3.33333333333333, size: 1 },
    //     { x: 238.920863309353, y: 4, size: 1 },
    //     { x: 243.453237410072, y: 3.41176470588235, size: 1 },
    //     { x: 244.748201438849, y: 3.25490196078431, size: 1 },
    //     { x: 245.395683453237, y: 3.2156862745098, size: 1 },
    //     { x: 246.043165467626, y: 3.45098039215686, size: 1 },
    //     { x: 254.460431654676, y: 3.84313725490196, size: 1 },
    //     { x: 259.640287769784, y: 3.45098039215686, size: 1 },
    //     { x: 265.467625899281, y: 3.29411764705882, size: 1 },
    //     { x: 266.762589928058, y: 3.25490196078431, size: 1 },
    //     { x: 267.410071942446, y: 3.37254901960784, size: 1 },
    //     { x: 268.705035971223, y: 3.33333333333333, size: 1 },
    //     { x: 271.294964028777, y: 3.52941176470588, size: 1 },
    //     { x: 271.942446043165, y: 3.33333333333333, size: 1 },
    //     { x: 273.237410071942, y: 3.17647058823529, size: 1 },
    //     { x: 274.532374100719, y: 3.25490196078431, size: 1 },
    //     { x: 275.827338129496, y: 3.41176470588235, size: 1 },
    //     { x: 279.712230215827, y: 3.37254901960784, size: 1 },
    //     { x: 283.597122302158, y: 3.45098039215686, size: 1 },
    //     { x: 284.892086330935, y: 3.33333333333333, size: 1 },
    //     { x: 285.539568345324, y: 3.41176470588235, size: 1 },
    //     { x: 292.661870503597, y: 3.92156862745098, size: 1 },
    //     { x: 301.726618705036, y: 4.07843137254902, size: 1 },
    //     { x: 304.31654676259, y: 4.15686274509804, size: 1 },
    //     { x: 305.611510791367, y: 3.6078431372549, size: 1 },
    //     { x: 309.496402877698, y: 3.25490196078431, size: 1 },
    //     { x: 310.791366906475, y: 2.98039215686275, size: 1 },
    //     { x: 312.086330935252, y: 3.13725490196078, size: 1 },
    //     { x: 312.73381294964, y: 3.25490196078431, size: 1 },
    //     { x: 314.676258992806, y: 3.64705882352941, size: 1 },
    //     { x: 315.323741007194, y: 3.33333333333333, size: 1 },
    //     { x: 317.26618705036, y: 3.2156862745098, size: 1 },
    //     { x: 321.151079136691, y: 3.29411764705882, size: 1 },
    //     { x: 323.741007194245, y: 3.09803921568627, size: 1 },
    //     { x: 326.978417266187, y: 3.29411764705882, size: 1 },
    //     { x: 327.625899280576, y: 3.2156862745098, size: 1 },
    //     { x: 329.568345323741, y: 3.29411764705882, size: 1 },
    //     { x: 330.863309352518, y: 3.2156862745098, size: 1 },
    //     { x: 331.510791366906, y: 2.94117647058824, size: 1 },
    //     { x: 332.158273381295, y: 3.17647058823529, size: 1 },
    //     { x: 332.805755395683, y: 3.49019607843137, size: 1 },
    //     { x: 334.10071942446, y: 3.84313725490196, size: 1 },
    //     { x: 350.287769784173, y: 3.6078431372549, size: 1 },
    //     { x: 356.762589928058, y: 3.49019607843137, size: 1 },
    //     { x: 6.47482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 13.5971223021583, y: 3.37254901960784, size: 1 },
    //     { x: 14.2446043165468, y: 3.13725490196078, size: 1 },
    //     { x: 14.8920863309353, y: 3.13725490196078, size: 1 },
    //     { x: 16.1870503597122, y: 3.64705882352941, size: 1 },
    //     { x: 22.6618705035971, y: 3.64705882352941, size: 1 },
    //     { x: 25.2517985611511, y: 3.49019607843137, size: 1 },
    //     { x: 25.8992805755396, y: 3.68627450980392, size: 1 },
    //     { x: 31.0791366906475, y: 3.37254901960784, size: 1 },
    //     { x: 34.3165467625899, y: 3.49019607843137, size: 1 },
    //     { x: 42.0863309352518, y: 3.56862745098039, size: 1 },
    //     { x: 50.5035971223022, y: 3.6078431372549, size: 1 },
    //     { x: 54.3884892086331, y: 3.88235294117647, size: 1 },
    //     { x: 58.273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 61.5107913669065, y: 3.37254901960784, size: 1 },
    //     { x: 64.1007194244604, y: 3.25490196078431, size: 1 },
    //     { x: 64.7482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 66.0431654676259, y: 3.2156862745098, size: 1 },
    //     { x: 67.3381294964029, y: 3.45098039215686, size: 1 },
    //     { x: 69.9280575539568, y: 3.37254901960784, size: 1 },
    //     { x: 71.8705035971223, y: 3.29411764705882, size: 1 },
    //     { x: 73.8129496402878, y: 3.45098039215686, size: 1 },
    //     { x: 82.2302158273381, y: 3.41176470588235, size: 1 },
    //     { x: 90, y: 3.96078431372549, size: 1 },
    //     { x: 93.8848920863309, y: 3.45098039215686, size: 1 },
    //     { x: 96.4748201438849, y: 3.41176470588235, size: 1 },
    //     { x: 99.7122302158273, y: 3.33333333333333, size: 1 },
    //     { x: 101.007194244604, y: 3.13725490196078, size: 1 },
    //     { x: 101.654676258993, y: 3.29411764705882, size: 1 },
    //     { x: 104.892086330935, y: 4.03921568627451, size: 1 },
    //     { x: 106.187050359712, y: 3.64705882352941, size: 1 },
    //     { x: 108.776978417266, y: 3.84313725490196, size: 1 },
    //     { x: 110.071942446043, y: 3.72549019607843, size: 1 },
    //     { x: 112.014388489209, y: 3.68627450980392, size: 1 },
    //     { x: 113.309352517986, y: 3.92156862745098, size: 1 },
    //     { x: 113.956834532374, y: 3.88235294117647, size: 1 },
    //     { x: 114.604316546763, y: 3.80392156862745, size: 1 },
    //     { x: 117.841726618705, y: 3.92156862745098, size: 1 },
    //     { x: 119.136690647482, y: 4, size: 1 },
    //     { x: 119.784172661871, y: 3.68627450980392, size: 1 },
    //     { x: 124.964028776978, y: 3.41176470588235, size: 1 },
    //     { x: 135.323741007194, y: 3.49019607843137, size: 1 },
    //     { x: 137.26618705036, y: 3.6078431372549, size: 1 },
    //     { x: 138.561151079137, y: 3.68627450980392, size: 1 },
    //     { x: 139.856115107914, y: 3.41176470588235, size: 1 },
    //     { x: 148.273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 150.215827338129, y: 3.92156862745098, size: 1 },
    //     { x: 151.510791366906, y: 3.76470588235294, size: 1 },
    //     { x: 159.280575539568, y: 3.84313725490196, size: 1 },
    //     { x: 163.812949640288, y: 3.37254901960784, size: 1 },
    //     { x: 164.460431654676, y: 3.37254901960784, size: 1 },
    //     { x: 165.755395683453, y: 3.05882352941176, size: 1 },
    //     { x: 166.402877697842, y: 3.29411764705882, size: 1 },
    //     { x: 170.287769784173, y: 3.88235294117647, size: 1 },
    //     { x: 181.294964028777, y: 3.80392156862745, size: 1 },
    //     { x: 185.827338129496, y: 3.17647058823529, size: 1 },
    //     { x: 186.474820143885, y: 3.17647058823529, size: 1 },
    //     { x: 187.122302158273, y: 2.50980392156863, size: 1 },
    //     { x: 187.769784172662, y: 2.27450980392157, size: 1 },
    //     { x: 188.41726618705, y: 3.17647058823529, size: 1 },
    //     { x: 189.064748201439, y: 3.37254901960784, size: 1 },
    //     { x: 194.244604316547, y: 3.49019607843137, size: 1 },
    //     { x: 196.187050359712, y: 3.49019607843137, size: 1 },
    //     { x: 198.776978417266, y: 3.37254901960784, size: 1 },
    //     { x: 199.424460431655, y: 3.68627450980392, size: 1 },
    //     { x: 200.071942446043, y: 3.49019607843137, size: 1 },
    //     { x: 203.956834532374, y: 3.33333333333333, size: 1 },
    //     { x: 207.194244604317, y: 3.84313725490196, size: 1 },
    //     { x: 208.489208633094, y: 3.76470588235294, size: 1 },
    //     { x: 218.848920863309, y: 3.96078431372549, size: 1 },
    //     { x: 221.438848920863, y: 3.72549019607843, size: 1 },
    //     { x: 226.618705035971, y: 3.84313725490196, size: 1 },
    //     { x: 230.503597122302, y: 3.41176470588235, size: 1 },
    //     { x: 233.741007194245, y: 3.6078431372549, size: 1 },
    //     { x: 246.690647482014, y: 3.52941176470588, size: 1 },
    //     { x: 248.63309352518, y: 3.64705882352941, size: 1 },
    //     { x: 249.928057553957, y: 3.52941176470588, size: 1 },
    //     { x: 250.575539568345, y: 3.68627450980392, size: 1 },
    //     { x: 251.223021582734, y: 3.68627450980392, size: 1 },
    //     { x: 256.402877697842, y: 4, size: 1 },
    //     { x: 261.58273381295, y: 3.92156862745098, size: 1 },
    //     { x: 273.884892086331, y: 3.33333333333333, size: 1 },
    //     { x: 277.769784172662, y: 3.88235294117647, size: 1 },
    //     { x: 278.41726618705, y: 3.56862745098039, size: 1 },
    //     { x: 279.712230215827, y: 4.03921568627451, size: 1 },
    //     { x: 283.597122302158, y: 3.80392156862745, size: 1 },
    //     { x: 288.776978417266, y: 3.45098039215686, size: 1 },
    //     { x: 289.424460431655, y: 4, size: 1 },
    //     { x: 294.604316546763, y: 3.37254901960784, size: 1 },
    //     { x: 295.251798561151, y: 3.37254901960784, size: 1 },
    //     { x: 297.194244604317, y: 3.45098039215686, size: 1 },
    //     { x: 306.906474820144, y: 3.49019607843137, size: 1 },
    //     { x: 308.848920863309, y: 3.45098039215686, size: 1 },
    //     { x: 312.086330935252, y: 3.68627450980392, size: 1 },
    //     { x: 326.978417266187, y: 3.76470588235294, size: 1 },
    //     { x: 337.338129496403, y: 3.52941176470588, size: 1 },
    //     { x: 339.280575539568, y: 3.33333333333333, size: 1 },
    //     { x: 345.107913669065, y: 3.80392156862745, size: 1 },
    //     { x: 357.410071942446, y: 3.88235294117647, size: 1 },
    //     { x: 0, y: 3.2156862745098, size: 1 },
    //     { x: 1.29496402877698, y: 3.76470588235294, size: 1 },
    //     { x: 12.3021582733813, y: 3.96078431372549, size: 1 },
    //     { x: 15.5395683453237, y: 3.92156862745098, size: 1 },
    //     { x: 20.0719424460432, y: 3.33333333333333, size: 1 },
    //     { x: 20.7194244604317, y: 3.33333333333333, size: 1 },
    //     { x: 21.3669064748201, y: 2.90196078431373, size: 1 },
    //     { x: 22.0143884892086, y: 3.13725490196078, size: 1 },
    //     { x: 22.6618705035971, y: 2.98039215686275, size: 1 },
    //     { x: 23.3093525179856, y: 2.66666666666667, size: 1 },
    //     { x: 26.5467625899281, y: 3.6078431372549, size: 1 },
    //     { x: 27.841726618705, y: 3.72549019607843, size: 1 },
    //     { x: 32.3741007194245, y: 3.64705882352941, size: 1 },
    //     { x: 33.0215827338129, y: 3.80392156862745, size: 1 },
    //     { x: 41.4388489208633, y: 3.49019607843137, size: 1 },
    //     { x: 42.7338129496403, y: 3.41176470588235, size: 1 },
    //     { x: 44.0287769784173, y: 3.49019607843137, size: 1 },
    //     { x: 50.5035971223022, y: 3.45098039215686, size: 1 },
    //     { x: 51.1510791366906, y: 3.37254901960784, size: 1 },
    //     { x: 55.6834532374101, y: 3.29411764705882, size: 1 },
    //     { x: 56.3309352517986, y: 3.41176470588235, size: 1 },
    //     { x: 56.9784172661871, y: 3.41176470588235, size: 1 },
    //     { x: 57.6258992805755, y: 3.25490196078431, size: 1 },
    //     { x: 58.273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 62.8057553956835, y: 3.29411764705882, size: 1 },
    //     { x: 64.1007194244604, y: 3.49019607843137, size: 1 },
    //     { x: 64.7482014388489, y: 2.7843137254902, size: 1 },
    //     { x: 65.3956834532374, y: 2.62745098039216, size: 1 },
    //     { x: 66.6906474820144, y: 3.80392156862745, size: 1 },
    //     { x: 69.9280575539568, y: 3.88235294117647, size: 1 },
    //     { x: 71.2230215827338, y: 3.88235294117647, size: 1 },
    //     { x: 71.8705035971223, y: 3.88235294117647, size: 1 },
    //     { x: 75.1079136690647, y: 3.84313725490196, size: 1 },
    //     { x: 75.7553956834532, y: 3.88235294117647, size: 1 },
    //     { x: 77.0503597122302, y: 4.03921568627451, size: 1 },
    //     { x: 77.6978417266187, y: 3.96078431372549, size: 1 },
    //     { x: 80.2877697841727, y: 3.80392156862745, size: 1 },
    //     { x: 97.1223021582734, y: 3.45098039215686, size: 1 },
    //     { x: 99.0647482014388, y: 3.68627450980392, size: 1 },
    //     { x: 106.834532374101, y: 3.96078431372549, size: 1 },
    //     { x: 123.669064748201, y: 3.84313725490196, size: 1 },
    //     { x: 130.791366906475, y: 3.25490196078431, size: 1 },
    //     { x: 131.438848920863, y: 3.13725490196078, size: 1 },
    //     { x: 132.73381294964, y: 3.33333333333333, size: 1 },
    //     { x: 133.381294964029, y: 3.33333333333333, size: 1 },
    //     { x: 135.971223021583, y: 3.41176470588235, size: 1 },
    //     { x: 136.618705035971, y: 3.29411764705882, size: 1 },
    //     { x: 138.561151079137, y: 3.25490196078431, size: 1 },
    //     { x: 139.208633093525, y: 3.64705882352941, size: 1 },
    //     { x: 141.151079136691, y: 3.2156862745098, size: 1 },
    //     { x: 143.093525179856, y: 3.2156862745098, size: 1 },
    //     { x: 143.741007194245, y: 3.29411764705882, size: 1 },
    //     { x: 146.330935251799, y: 3.33333333333333, size: 1 },
    //     { x: 146.978417266187, y: 3.29411764705882, size: 1 },
    //     { x: 147.625899280576, y: 3.45098039215686, size: 1 },
    //     { x: 150.863309352518, y: 3.33333333333333, size: 1 },
    //     { x: 159.928057553957, y: 3.76470588235294, size: 1 },
    //     { x: 168.992805755396, y: 3.84313725490196, size: 1 },
    //     { x: 171.58273381295, y: 3.2156862745098, size: 1 },
    //     { x: 172.230215827338, y: 3.17647058823529, size: 1 },
    //     { x: 172.877697841727, y: 2.90196078431373, size: 1 },
    //     { x: 173.525179856115, y: 3.25490196078431, size: 1 },
    //     { x: 175.467625899281, y: 3.37254901960784, size: 1 },
    //     { x: 176.762589928058, y: 3.29411764705882, size: 1 },
    //     { x: 183.237410071942, y: 3.45098039215686, size: 1 },
    //     { x: 184.532374100719, y: 3.29411764705882, size: 1 },
    //     { x: 185.179856115108, y: 3.52941176470588, size: 1 },
    //     { x: 187.122302158273, y: 3.13725490196078, size: 1 },
    //     { x: 189.712230215827, y: 3.29411764705882, size: 1 },
    //     { x: 191.007194244604, y: 3.96078431372549, size: 1 },
    //     { x: 192.302158273381, y: 3.92156862745098, size: 1 },
    //     { x: 193.597122302158, y: 3.09803921568627, size: 1 },
    //     { x: 194.244604316547, y: 2.54901960784314, size: 1 },
    //     { x: 194.892086330935, y: 2.94117647058824, size: 1 },
    //     { x: 198.776978417266, y: 4.03921568627451, size: 1 },
    //     { x: 212.374100719424, y: 3.96078431372549, size: 1 },
    //     { x: 213.021582733813, y: 3.68627450980392, size: 1 },
    //     { x: 214.31654676259, y: 3.49019607843137, size: 1 },
    //     { x: 217.553956834532, y: 3.2156862745098, size: 1 },
    //     { x: 222.086330935252, y: 3.13725490196078, size: 1 },
    //     { x: 222.73381294964, y: 3.05882352941176, size: 1 },
    //     { x: 224.028776978417, y: 3.29411764705882, size: 1 },
    //     { x: 224.676258992806, y: 3.33333333333333, size: 1 },
    //     { x: 226.618705035971, y: 3.33333333333333, size: 1 },
    //     { x: 228.561151079137, y: 3.33333333333333, size: 1 },
    //     { x: 229.856115107914, y: 3.37254901960784, size: 1 },
    //     { x: 233.093525179856, y: 3.41176470588235, size: 1 },
    //     { x: 234.388489208633, y: 3.13725490196078, size: 1 },
    //     { x: 236.330935251799, y: 3.17647058823529, size: 1 },
    //     { x: 236.978417266187, y: 3.25490196078431, size: 1 },
    //     { x: 237.625899280576, y: 3.41176470588235, size: 1 },
    //     { x: 241.510791366906, y: 3.88235294117647, size: 1 },
    //     { x: 242.158273381295, y: 3.72549019607843, size: 1 },
    //     { x: 251.870503597122, y: 3.84313725490196, size: 1 },
    //     { x: 253.165467625899, y: 3.56862745098039, size: 1 },
    //     { x: 258.345323741007, y: 3.33333333333333, size: 1 },
    //     { x: 258.992805755396, y: 3.25490196078431, size: 1 },
    //     { x: 259.640287769784, y: 3.29411764705882, size: 1 },
    //     { x: 260.287769784173, y: 3.96078431372549, size: 1 },
    //     { x: 264.172661870504, y: 3.76470588235294, size: 1 },
    //     { x: 267.410071942446, y: 3.84313725490196, size: 1 },
    //     { x: 270, y: 3.88235294117647, size: 1 },
    //     { x: 273.884892086331, y: 3.72549019607843, size: 1 },
    //     { x: 276.474820143885, y: 3.88235294117647, size: 1 },
    //     { x: 277.769784172662, y: 3.68627450980392, size: 1 },
    //     { x: 279.064748201439, y: 3.25490196078431, size: 1 },
    //     { x: 280.359712230216, y: 2.7843137254902, size: 1 },
    //     { x: 281.007194244604, y: 2.82352941176471, size: 1 },
    //     { x: 281.654676258993, y: 3.41176470588235, size: 1 },
    //     { x: 288.776978417266, y: 3.29411764705882, size: 1 },
    //     { x: 300.431654676259, y: 3.41176470588235, size: 1 },
    //     { x: 301.726618705036, y: 2.82352941176471, size: 1 },
    //     { x: 302.374100719424, y: 1.56862745098039, size: 1 },
    //     { x: 303.021582733813, y: 1.68627450980392, size: 1 },
    //     { x: 303.669064748201, y: 1.96078431372549, size: 1 },
    //     { x: 304.31654676259, y: 1.80392156862745, size: 1 },
    //     { x: 304.964028776978, y: 3.37254901960784, size: 1 },
    //     { x: 305.611510791367, y: 3.45098039215686, size: 1 },
    //     { x: 306.258992805755, y: 3.45098039215686, size: 1 },
    //     { x: 306.906474820144, y: 2.82352941176471, size: 1 },
    //     { x: 307.553956834532, y: 3.33333333333333, size: 1 },
    //     { x: 310.143884892086, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.09803921568627, size: 1 },
    //     { x: 312.086330935252, y: 3.01960784313725, size: 1 },
    //     { x: 317.26618705036, y: 3.41176470588235, size: 1 },
    //     { x: 317.913669064748, y: 2.7843137254902, size: 1 },
    //     { x: 318.561151079137, y: 3.29411764705882, size: 1 },
    //     { x: 319.856115107914, y: 3.49019607843137, size: 1 },
    //     { x: 320.503597122302, y: 3.37254901960784, size: 1 },
    //     { x: 321.151079136691, y: 3.37254901960784, size: 1 },
    //     { x: 321.798561151079, y: 3.33333333333333, size: 1 },
    //     { x: 323.093525179856, y: 3.09803921568627, size: 1 },
    //     { x: 323.741007194245, y: 2.43137254901961, size: 1 },
    //     { x: 324.388489208633, y: 2.35294117647059, size: 1 },
    //     { x: 325.035971223022, y: 3.64705882352941, size: 1 },
    //     { x: 325.68345323741, y: 3.84313725490196, size: 1 },
    //     { x: 330.215827338129, y: 3.6078431372549, size: 1 },
    //     { x: 336.690647482014, y: 3.45098039215686, size: 1 },
    //     { x: 338.63309352518, y: 3.80392156862745, size: 1 },
    //     { x: 342.517985611511, y: 3.72549019607843, size: 1 },
    //     { x: 345.755395683453, y: 3.25490196078431, size: 1 },
    //     { x: 358.705035971223, y: 3.80392156862745, size: 1 },
    //     { x: 4.54054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 5.18918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 5.83783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 7.13513513513514, y: 2.03921568627451, size: 1 },
    //     { x: 7.78378378378378, y: 2.11764705882353, size: 1 },
    //     { x: 8.43243243243243, y: 2.35294117647059, size: 1 },
    //     { x: 9.08108108108108, y: 2.58823529411765, size: 1 },
    //     { x: 9.72972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 11.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 14.2702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 17.5135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 18.8108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 19.4594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 20.1081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 20.7567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 21.4054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 22.0540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 24, y: 3.41176470588235, size: 1 },
    //     { x: 24.6486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 25.2972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 25.9459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 27.2432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 27.8918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 28.5405405405405, y: 2.66666666666667, size: 1 },
    //     { x: 29.1891891891892, y: 2.62745098039216, size: 1 },
    //     { x: 30.4864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 32.4324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 33.0810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 33.7297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 34.3783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 36.3243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 36.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 37.6216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 38.2702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 38.9189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 39.5675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 40.2162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 40.8648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 41.5135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 42.1621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 42.8108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 43.4594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 44.1081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 44.7567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 45.4054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 46.0540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 46.7027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 47.3513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 48, y: 3.29411764705882, size: 1 },
    //     { x: 49.2972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 49.9459459459459, y: 2.86274509803922, size: 1 },
    //     { x: 50.5945945945946, y: 2.47058823529412, size: 1 },
    //     { x: 51.2432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 51.8918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 52.5405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 54.4864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 55.1351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 56.4324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 57.0810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 57.7297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 59.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 59.6756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 62.2702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 62.9189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 63.5675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 64.2162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 65.5135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 67.4594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 70.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 70.7027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 71.3513513513514, y: 2.82352941176471, size: 1 },
    //     { x: 72, y: 2.11764705882353, size: 1 },
    //     { x: 72.6486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 73.2972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 74.5945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 75.2432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 76.5405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 77.1891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 77.8378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 79.1351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 79.7837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 80.4324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 81.0810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 81.7297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 83.6756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 84.3243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 84.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 85.6216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 86.2702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 86.9189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 87.5675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 88.8648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 90.1621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 90.8108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 91.4594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 92.1081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 92.7567567567568, y: 2.98039215686275, size: 1 },
    //     { x: 93.4054054054054, y: 1.76470588235294, size: 1 },
    //     { x: 94.054054054054, y: 2.07843137254902, size: 1 },
    //     { x: 94.7027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 96, y: 3.52941176470588, size: 1 },
    //     { x: 96.6486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 97.2972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 99.8918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 100.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 104.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 105.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 106.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 107.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 107.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 108.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 109.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 110.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 112.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 113.513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 114.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 115.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 116.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 117.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 118.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 120, y: 3.84313725490196, size: 1 },
    //     { x: 120.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 121.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 121.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 122.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 123.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 125.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 126.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 127.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 129.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 131.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 132.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 134.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 135.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 136.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 136.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 138.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 138.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 139.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 140.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 140.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 141.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 142.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 142.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 143.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 144.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 145.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 146.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 147.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 147.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 148.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 149.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 149.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 152.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 153.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 153.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 155.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 156.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 157.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 158.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 158.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 159.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 160.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 161.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 162.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 164.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 165.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 166.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 171.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 171.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 172.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 173.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 173.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 174.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 175.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 177.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 177.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 178.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 179.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 179.675675675676, y: 2.35294117647059, size: 1 },
    //     { x: 180.324324324324, y: 2.35294117647059, size: 1 },
    //     { x: 181.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 182.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 184.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 186.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 187.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 188.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 188.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 192, y: 3.52941176470588, size: 1 },
    //     { x: 193.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 193.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 196.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 197.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 197.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 199.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 199.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 201.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 202.378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 203.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 204.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 204.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 206.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 206.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 207.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 208.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 208.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 211.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 212.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 213.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 216.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 217.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 219.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 221.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 221.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 222.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 223.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 224.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 225.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 225.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 226.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 228.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 235.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 237.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 239.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 240.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 242.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 243.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 244.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 246.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 247.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 249.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 249.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 250.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 251.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 251.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 252.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 253.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 254.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 256.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 256.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 257.513513513513, y: 3.52941176470588, size: 1 },
    //     { x: 258.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 260.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 261.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 262.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 262.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 264, y: 3.41176470588235, size: 1 },
    //     { x: 264.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 266.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 269.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 270.486486486487, y: 3.52941176470588, size: 1 },
    //     { x: 271.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 273.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 275.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 276.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 276.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 277.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 280.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 282.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 284.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 284.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 285.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 286.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 290.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 294.486486486487, y: 3.56862745098039, size: 1 },
    //     { x: 295.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 295.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 296.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 298.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 299.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 299.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 300.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 301.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 302.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 304.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 305.513513513513, y: 3.68627450980392, size: 1 },
    //     { x: 306.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 307.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 309.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 310.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 310.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 311.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 312, y: 3.37254901960784, size: 1 },
    //     { x: 313.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 313.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 315.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 315.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 316.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 317.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 319.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 321.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 322.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 323.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 323.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 324.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 325.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 326.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 329.513513513513, y: 3.33333333333333, size: 1 },
    //     { x: 330.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 331.459459459459, y: 3.01960784313725, size: 1 },
    //     { x: 332.108108108108, y: 2.66666666666667, size: 1 },
    //     { x: 332.756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 333.405405405405, y: 3.01960784313725, size: 1 },
    //     { x: 334.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 334.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 336.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 337.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 337.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 339.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 340.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 342.486486486487, y: 3.68627450980392, size: 1 },
    //     { x: 343.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 343.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 345.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 346.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 347.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 347.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 348.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 348.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 350.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 351.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 352.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 352.864864864865, y: 2.74509803921569, size: 1 },
    //     { x: 353.513513513513, y: 2.98039215686275, size: 1 },
    //     { x: 354.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 354.810810810811, y: 2.82352941176471, size: 1 },
    //     { x: 355.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 356.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 356.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 357.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 358.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 12.3021582733813, y: 3.37254901960784, size: 1 },
    //     { x: 13.5971223021583, y: 3.80392156862745, size: 1 },
    //     { x: 14.2446043165468, y: 3.37254901960784, size: 1 },
    //     { x: 14.8920863309353, y: 3.29411764705882, size: 1 },
    //     { x: 18.7769784172662, y: 3.88235294117647, size: 1 },
    //     { x: 22.0143884892086, y: 3.84313725490196, size: 1 },
    //     { x: 23.9568345323741, y: 4, size: 1 },
    //     { x: 34.9640287769784, y: 3.29411764705882, size: 1 },
    //     { x: 35.6115107913669, y: 3.33333333333333, size: 1 },
    //     { x: 36.2589928057554, y: 3.2156862745098, size: 1 },
    //     { x: 36.9064748201439, y: 3.45098039215686, size: 1 },
    //     { x: 40.1438848920863, y: 3.49019607843137, size: 1 },
    //     { x: 47.9136690647482, y: 3.41176470588235, size: 1 },
    //     { x: 48.5611510791367, y: 3.49019607843137, size: 1 },
    //     { x: 51.1510791366906, y: 3.96078431372549, size: 1 },
    //     { x: 51.7985611510791, y: 3.41176470588235, size: 1 },
    //     { x: 61.5107913669065, y: 3.76470588235294, size: 1 },
    //     { x: 63.4532374100719, y: 3.76470588235294, size: 1 },
    //     { x: 71.8705035971223, y: 3.49019607843137, size: 1 },
    //     { x: 72.5179856115108, y: 3.76470588235294, size: 1 },
    //     { x: 73.8129496402878, y: 3.80392156862745, size: 1 },
    //     { x: 78.9928057553957, y: 3.33333333333333, size: 1 },
    //     { x: 82.8776978417266, y: 3.84313725490196, size: 1 },
    //     { x: 83.5251798561151, y: 3.92156862745098, size: 1 },
    //     { x: 91.294964028777, y: 3.76470588235294, size: 1 },
    //     { x: 94.5323741007194, y: 4, size: 1 },
    //     { x: 103.597122302158, y: 3.76470588235294, size: 1 },
    //     { x: 104.892086330935, y: 3.80392156862745, size: 1 },
    //     { x: 108.776978417266, y: 3.80392156862745, size: 1 },
    //     { x: 118.489208633094, y: 3.92156862745098, size: 1 },
    //     { x: 119.136690647482, y: 3.80392156862745, size: 1 },
    //     { x: 119.784172661871, y: 3.64705882352941, size: 1 },
    //     { x: 122.374100719424, y: 3.29411764705882, size: 1 },
    //     { x: 124.31654676259, y: 3.92156862745098, size: 1 },
    //     { x: 130.791366906475, y: 3.84313725490196, size: 1 },
    //     { x: 132.086330935252, y: 3.92156862745098, size: 1 },
    //     { x: 141.151079136691, y: 3.76470588235294, size: 1 },
    //     { x: 141.798561151079, y: 3.64705882352941, size: 1 },
    //     { x: 146.330935251799, y: 3.6078431372549, size: 1 },
    //     { x: 148.920863309353, y: 3.52941176470588, size: 1 },
    //     { x: 149.568345323741, y: 3.88235294117647, size: 1 },
    //     { x: 153.453237410072, y: 3.88235294117647, size: 1 },
    //     { x: 154.748201438849, y: 3.45098039215686, size: 1 },
    //     { x: 156.690647482014, y: 3.49019607843137, size: 1 },
    //     { x: 161.223021582734, y: 3.80392156862745, size: 1 },
    //     { x: 163.812949640288, y: 3.49019607843137, size: 1 },
    //     { x: 164.460431654676, y: 3.25490196078431, size: 1 },
    //     { x: 165.107913669065, y: 3.49019607843137, size: 1 },
    //     { x: 165.755395683453, y: 3.09803921568627, size: 1 },
    //     { x: 166.402877697842, y: 3.25490196078431, size: 1 },
    //     { x: 167.05035971223, y: 3.13725490196078, size: 1 },
    //     { x: 167.697841726619, y: 3.09803921568627, size: 1 },
    //     { x: 170.935251798561, y: 3.84313725490196, size: 1 },
    //     { x: 178.705035971223, y: 3.84313725490196, size: 1 },
    //     { x: 180.647482014388, y: 3.88235294117647, size: 1 },
    //     { x: 181.942446043165, y: 4, size: 1 },
    //     { x: 182.589928057554, y: 3.88235294117647, size: 1 },
    //     { x: 185.179856115108, y: 3.45098039215686, size: 1 },
    //     { x: 185.827338129496, y: 3.37254901960784, size: 1 },
    //     { x: 186.474820143885, y: 3.25490196078431, size: 1 },
    //     { x: 187.122302158273, y: 3.2156862745098, size: 1 },
    //     { x: 187.769784172662, y: 2.98039215686275, size: 1 },
    //     { x: 188.41726618705, y: 3.33333333333333, size: 1 },
    //     { x: 189.064748201439, y: 3.49019607843137, size: 1 },
    //     { x: 189.712230215827, y: 3.76470588235294, size: 1 },
    //     { x: 203.956834532374, y: 3.80392156862745, size: 1 },
    //     { x: 205.251798561151, y: 3.80392156862745, size: 1 },
    //     { x: 209.136690647482, y: 3.13725490196078, size: 1 },
    //     { x: 209.784172661871, y: 3.09803921568627, size: 1 },
    //     { x: 210.431654676259, y: 3.2156862745098, size: 1 },
    //     { x: 211.079136690647, y: 3.37254901960784, size: 1 },
    //     { x: 224.676258992806, y: 3.68627450980392, size: 1 },
    //     { x: 225.323741007194, y: 3.33333333333333, size: 1 },
    //     { x: 229.208633093525, y: 3.49019607843137, size: 1 },
    //     { x: 229.856115107914, y: 3.33333333333333, size: 1 },
    //     { x: 230.503597122302, y: 2.82352941176471, size: 1 },
    //     { x: 231.151079136691, y: 3.2156862745098, size: 1 },
    //     { x: 231.798561151079, y: 3.17647058823529, size: 1 },
    //     { x: 233.093525179856, y: 3.52941176470588, size: 1 },
    //     { x: 235.035971223022, y: 3.52941176470588, size: 1 },
    //     { x: 242.805755395683, y: 3.37254901960784, size: 1 },
    //     { x: 250.575539568345, y: 3.29411764705882, size: 1 },
    //     { x: 259.640287769784, y: 3.80392156862745, size: 1 },
    //     { x: 267.410071942446, y: 3.41176470588235, size: 1 },
    //     { x: 273.237410071942, y: 3.25490196078431, size: 1 },
    //     { x: 273.884892086331, y: 3.01960784313725, size: 1 },
    //     { x: 274.532374100719, y: 2.82352941176471, size: 1 },
    //     { x: 275.179856115108, y: 2.66666666666667, size: 1 },
    //     { x: 294.604316546763, y: 3.2156862745098, size: 1 },
    //     { x: 295.251798561151, y: 3.13725490196078, size: 1 },
    //     { x: 295.89928057554, y: 2.94117647058824, size: 1 },
    //     { x: 296.546762589928, y: 2.66666666666667, size: 1 },
    //     { x: 297.194244604317, y: 2.7843137254902, size: 1 },
    //     { x: 301.079136690647, y: 3.41176470588235, size: 1 },
    //     { x: 301.726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 313.381294964029, y: 3.37254901960784, size: 1 },
    //     { x: 315.971223021583, y: 3.37254901960784, size: 1 },
    //     { x: 316.618705035971, y: 3.13725490196078, size: 1 },
    //     { x: 321.798561151079, y: 3.88235294117647, size: 1 },
    //     { x: 328.273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 332.158273381295, y: 3.88235294117647, size: 1 },
    //     { x: 334.748201438849, y: 3.41176470588235, size: 1 },
    //     { x: 339.280575539568, y: 3.72549019607843, size: 1 },
    //     { x: 340.575539568345, y: 3.76470588235294, size: 1 },
    //     { x: 348.345323741007, y: 3.76470588235294, size: 1 },
    //     { x: 355.467625899281, y: 3.80392156862745, size: 1 },
    //     { x: 358.057553956835, y: 3.80392156862745, size: 1 },
    //     { x: 358.705035971223, y: 3.56862745098039, size: 1 },
    //     { x: 1.2972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 1.94594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 2.59459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 3.24324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 7.13513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 9.72972972972973, y: 4, size: 1 },
    //     { x: 10.3783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 11.6756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 12.3243243243243, y: 4, size: 1 },
    //     { x: 14.9189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 15.5675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 16.2162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 16.8648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 19.4594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 20.7567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 21.4054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 22.0540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 22.7027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 26.5945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 27.2432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 27.8918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 28.5405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 29.1891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 29.8378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 33.0810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 34.3783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 38.9189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 39.5675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 40.2162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 40.8648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 42.1621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 42.8108108108108, y: 2.74509803921569, size: 1 },
    //     { x: 43.4594594594595, y: 2.82352941176471, size: 1 },
    //     { x: 44.1081081081081, y: 2.82352941176471, size: 1 },
    //     { x: 44.7567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 45.4054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 46.7027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 48, y: 3.49019607843137, size: 1 },
    //     { x: 48.6486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 49.9459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 51.2432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 53.1891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 53.8378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 55.1351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 57.0810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 58.3783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 59.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 60.3243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 60.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 61.6216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 63.5675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 64.2162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 64.8648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 65.5135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 66.1621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 66.8108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 67.4594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 68.7567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 69.4054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 70.7027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 71.3513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 72, y: 3.64705882352941, size: 1 },
    //     { x: 72.6486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 73.2972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 73.945945945946, y: 4.23529411764706, size: 1 },
    //     { x: 74.5945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 75.2432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 76.5405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 77.1891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 78.4864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 79.1351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 80.4324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 81.0810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 83.6756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 84.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 87.5675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 89.5135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 90.1621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 95.3513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 96.6486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 98.5945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 101.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 103.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 104.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 105.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 108.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 110.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 111.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 112.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 113.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 114.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 115.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 120, y: 3.41176470588235, size: 1 },
    //     { x: 121.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 121.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 123.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 123.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 125.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 126.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 127.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 128.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 129.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 129.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 130.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 131.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 131.675675675676, y: 2.86274509803922, size: 1 },
    //     { x: 132.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 132.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 133.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 134.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 136.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 136.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 137.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 138.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 140.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 140.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 141.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 142.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 144, y: 3.52941176470588, size: 1 },
    //     { x: 147.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 149.189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 149.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 150.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 151.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 151.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 155.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 156.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 158.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 159.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 160.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 162.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 163.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 164.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 165.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 166.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 168, y: 3.68627450980392, size: 1 },
    //     { x: 168.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 169.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 169.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 170.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 171.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 173.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 173.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 174.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 175.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 177.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 177.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 180.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 181.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 182.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 182.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 185.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 186.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 188.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 188.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 189.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 190.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 190.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 191.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 192, y: 3.45098039215686, size: 1 },
    //     { x: 192.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 193.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 194.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 195.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 197.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 199.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 201.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 203.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 205.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 206.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 207.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 208.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 208.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 210.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 210.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 211.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 212.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 213.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 216, y: 3.25490196078431, size: 1 },
    //     { x: 216.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 219.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 221.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 222.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 223.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 223.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 225.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 226.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 227.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 228.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 228.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 229.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 231.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 232.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 234.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 235.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 237.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 238.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 238.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 240.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 241.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 242.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 243.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 244.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 245.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 246.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 247.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 249.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 250.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 251.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 252.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 254.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 255.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 256.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 257.513513513513, y: 3.41176470588235, size: 1 },
    //     { x: 258.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 258.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 259.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 260.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 260.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 261.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 262.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 264, y: 3.6078431372549, size: 1 },
    //     { x: 265.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 266.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 267.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 269.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 270.486486486487, y: 3.80392156862745, size: 1 },
    //     { x: 271.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 272.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 273.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 276.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 276.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 277.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 280.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 280.864864864865, y: 3.01960784313725, size: 1 },
    //     { x: 281.513513513513, y: 3.37254901960784, size: 1 },
    //     { x: 285.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 286.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 287.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 288, y: 3.49019607843137, size: 1 },
    //     { x: 288.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 292.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 293.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 294.486486486487, y: 3.72549019607843, size: 1 },
    //     { x: 295.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 296.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 297.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 299.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 300.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 300.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 302.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 302.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 303.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 306.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 308.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 308.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 310.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 310.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 312.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 314.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 315.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 315.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 317.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 318.486486486487, y: 3.68627450980392, size: 1 },
    //     { x: 319.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 319.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 320.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 321.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 321.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 322.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 323.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 324.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 324.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 329.513513513513, y: 3.6078431372549, size: 1 },
    //     { x: 331.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 332.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 332.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 333.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 334.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 334.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 335.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 336.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 337.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 337.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 339.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 341.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 343.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 344.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 345.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 345.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 346.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 347.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 348.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 349.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 352.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 352.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 353.513513513513, y: 3.37254901960784, size: 1 },
    //     { x: 354.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 354.810810810811, y: 4, size: 1 },
    //     { x: 356.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 356.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 357.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 358.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 358.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 359.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 0.646319569120287, y: 3.52941176470588, size: 1 },
    //     { x: 1.29263913824057, y: 3.64705882352941, size: 1 },
    //     { x: 1.93895870736086, y: 3.6078431372549, size: 1 },
    //     { x: 2.58527827648115, y: 3.6078431372549, size: 1 },
    //     { x: 3.23159784560144, y: 3.41176470588235, size: 1 },
    //     { x: 3.87791741472172, y: 3.49019607843137, size: 1 },
    //     { x: 4.52423698384201, y: 3.56862745098039, size: 1 },
    //     { x: 5.1705565529623, y: 3.41176470588235, size: 1 },
    //     { x: 5.81687612208259, y: 3.56862745098039, size: 1 },
    //     { x: 6.46319569120287, y: 3.52941176470588, size: 1 },
    //     { x: 7.10951526032316, y: 3.64705882352941, size: 1 },
    //     { x: 7.75583482944345, y: 3.45098039215686, size: 1 },
    //     { x: 8.40215439856373, y: 3.88235294117647, size: 1 },
    //     { x: 9.04847396768402, y: 3.56862745098039, size: 1 },
    //     { x: 9.69479353680431, y: 3.68627450980392, size: 1 },
    //     { x: 10.3411131059246, y: 3.49019607843137, size: 1 },
    //     { x: 10.9874326750449, y: 3.68627450980392, size: 1 },
    //     { x: 11.6337522441652, y: 3.84313725490196, size: 1 },
    //     { x: 12.2800718132855, y: 3.6078431372549, size: 1 },
    //     { x: 12.9263913824057, y: 3.68627450980392, size: 1 },
    //     { x: 13.572710951526, y: 3.88235294117647, size: 1 },
    //     { x: 14.2190305206463, y: 3.64705882352941, size: 1 },
    //     { x: 14.8653500897666, y: 3.64705882352941, size: 1 },
    //     { x: 15.5116696588869, y: 3.6078431372549, size: 1 },
    //     { x: 16.1579892280072, y: 3.68627450980392, size: 1 },
    //     { x: 16.8043087971275, y: 3.68627450980392, size: 1 },
    //     { x: 17.4506283662478, y: 3.68627450980392, size: 1 },
    //     { x: 18.096947935368, y: 3.72549019607843, size: 1 },
    //     { x: 18.7432675044883, y: 3.56862745098039, size: 1 },
    //     { x: 19.3895870736086, y: 3.56862745098039, size: 1 },
    //     { x: 20.0359066427289, y: 3.80392156862745, size: 1 },
    //     { x: 20.6822262118492, y: 3.64705882352941, size: 1 },
    //     { x: 21.3285457809695, y: 3.76470588235294, size: 1 },
    //     { x: 21.9748653500898, y: 3.72549019607843, size: 1 },
    //     { x: 22.6211849192101, y: 3.68627450980392, size: 1 },
    //     { x: 23.2675044883303, y: 3.56862745098039, size: 1 },
    //     { x: 23.9138240574506, y: 3.76470588235294, size: 1 },
    //     { x: 24.5601436265709, y: 3.6078431372549, size: 1 },
    //     { x: 25.2064631956912, y: 3.6078431372549, size: 1 },
    //     { x: 25.8527827648115, y: 3.68627450980392, size: 1 },
    //     { x: 26.4991023339318, y: 3.72549019607843, size: 1 },
    //     { x: 27.1454219030521, y: 3.52941176470588, size: 1 },
    //     { x: 27.7917414721724, y: 3.52941176470588, size: 1 },
    //     { x: 28.4380610412926, y: 3.37254901960784, size: 1 },
    //     { x: 29.0843806104129, y: 3.29411764705882, size: 1 },
    //     { x: 29.7307001795332, y: 3.64705882352941, size: 1 },
    //     { x: 30.3770197486535, y: 3.64705882352941, size: 1 },
    //     { x: 31.0233393177738, y: 3.76470588235294, size: 1 },
    //     { x: 31.6696588868941, y: 3.6078431372549, size: 1 },
    //     { x: 32.3159784560144, y: 3.6078431372549, size: 1 },
    //     { x: 32.9622980251347, y: 3.56862745098039, size: 1 },
    //     { x: 33.6086175942549, y: 3.72549019607843, size: 1 },
    //     { x: 34.2549371633752, y: 3.56862745098039, size: 1 },
    //     { x: 34.9012567324955, y: 3.68627450980392, size: 1 },
    //     { x: 35.5475763016158, y: 3.64705882352941, size: 1 },
    //     { x: 36.1938958707361, y: 3.68627450980392, size: 1 },
    //     { x: 36.8402154398564, y: 3.76470588235294, size: 1 },
    //     { x: 37.4865350089767, y: 3.64705882352941, size: 1 },
    //     { x: 38.1328545780969, y: 3.64705882352941, size: 1 },
    //     { x: 38.7791741472172, y: 3.80392156862745, size: 1 },
    //     { x: 39.4254937163375, y: 3.6078431372549, size: 1 },
    //     { x: 40.0718132854578, y: 3.76470588235294, size: 1 },
    //     { x: 40.7181328545781, y: 3.6078431372549, size: 1 },
    //     { x: 41.3644524236984, y: 3.6078431372549, size: 1 },
    //     { x: 42.0107719928187, y: 3.68627450980392, size: 1 },
    //     { x: 42.657091561939, y: 3.76470588235294, size: 1 },
    //     { x: 43.3034111310592, y: 3.6078431372549, size: 1 },
    //     { x: 43.9497307001795, y: 3.76470588235294, size: 1 },
    //     { x: 44.5960502692998, y: 3.6078431372549, size: 1 },
    //     { x: 45.2423698384201, y: 3.6078431372549, size: 1 },
    //     { x: 45.8886894075404, y: 3.52941176470588, size: 1 },
    //     { x: 46.5350089766607, y: 3.52941176470588, size: 1 },
    //     { x: 47.181328545781, y: 3.68627450980392, size: 1 },
    //     { x: 47.8276481149013, y: 3.72549019607843, size: 1 },
    //     { x: 48.4739676840215, y: 3.49019607843137, size: 1 },
    //     { x: 49.1202872531418, y: 3.6078431372549, size: 1 },
    //     { x: 49.7666068222621, y: 3.56862745098039, size: 1 },
    //     { x: 50.4129263913824, y: 3.45098039215686, size: 1 },
    //     { x: 51.0592459605027, y: 3.37254901960784, size: 1 },
    //     { x: 51.705565529623, y: 3.56862745098039, size: 1 },
    //     { x: 52.3518850987433, y: 3.6078431372549, size: 1 },
    //     { x: 52.9982046678636, y: 3.56862745098039, size: 1 },
    //     { x: 53.6445242369838, y: 3.52941176470588, size: 1 },
    //     { x: 54.2908438061041, y: 3.56862745098039, size: 1 },
    //     { x: 54.9371633752244, y: 3.64705882352941, size: 1 },
    //     { x: 55.5834829443447, y: 3.68627450980392, size: 1 },
    //     { x: 56.229802513465, y: 3.6078431372549, size: 1 },
    //     { x: 56.8761220825853, y: 3.68627450980392, size: 1 },
    //     { x: 57.5224416517056, y: 3.6078431372549, size: 1 },
    //     { x: 58.1687612208259, y: 3.76470588235294, size: 1 },
    //     { x: 58.8150807899461, y: 3.49019607843137, size: 1 },
    //     { x: 59.4614003590664, y: 3.76470588235294, size: 1 },
    //     { x: 60.1077199281867, y: 3.56862745098039, size: 1 },
    //     { x: 60.754039497307, y: 3.68627450980392, size: 1 },
    //     { x: 61.4003590664273, y: 3.56862745098039, size: 1 },
    //     { x: 62.0466786355476, y: 3.68627450980392, size: 1 },
    //     { x: 62.6929982046679, y: 3.64705882352941, size: 1 },
    //     { x: 63.3393177737882, y: 3.72549019607843, size: 1 },
    //     { x: 63.9856373429084, y: 3.52941176470588, size: 1 },
    //     { x: 64.6319569120287, y: 3.6078431372549, size: 1 },
    //     { x: 65.278276481149, y: 3.64705882352941, size: 1 },
    //     { x: 65.9245960502693, y: 3.64705882352941, size: 1 },
    //     { x: 66.5709156193896, y: 3.68627450980392, size: 1 },
    //     { x: 67.2172351885099, y: 3.6078431372549, size: 1 },
    //     { x: 67.8635547576302, y: 3.56862745098039, size: 1 },
    //     { x: 68.5098743267504, y: 3.68627450980392, size: 1 },
    //     { x: 69.1561938958707, y: 3.49019607843137, size: 1 },
    //     { x: 69.802513464991, y: 3.37254901960784, size: 1 },
    //     { x: 70.4488330341113, y: 3.41176470588235, size: 1 },
    //     { x: 71.0951526032316, y: 3.45098039215686, size: 1 },
    //     { x: 71.7414721723519, y: 2.98039215686275, size: 1 },
    //     { x: 72.3877917414722, y: 2.74509803921569, size: 1 },
    //     { x: 73.0341113105925, y: 3.37254901960784, size: 1 },
    //     { x: 73.6804308797127, y: 3.56862745098039, size: 1 },
    //     { x: 74.326750448833, y: 3.6078431372549, size: 1 },
    //     { x: 74.9730700179533, y: 3.52941176470588, size: 1 },
    //     { x: 75.6193895870736, y: 3.41176470588235, size: 1 },
    //     { x: 76.2657091561939, y: 3.45098039215686, size: 1 },
    //     { x: 76.9120287253142, y: 3.52941176470588, size: 1 },
    //     { x: 77.5583482944345, y: 3.56862745098039, size: 1 },
    //     { x: 78.2046678635548, y: 3.56862745098039, size: 1 },
    //     { x: 78.850987432675, y: 3.45098039215686, size: 1 },
    //     { x: 79.4973070017953, y: 3.56862745098039, size: 1 },
    //     { x: 80.1436265709156, y: 3.52941176470588, size: 1 },
    //     { x: 80.7899461400359, y: 3.88235294117647, size: 1 },
    //     { x: 81.4362657091562, y: 3.64705882352941, size: 1 },
    //     { x: 82.0825852782765, y: 3.56862745098039, size: 1 },
    //     { x: 82.7289048473968, y: 3.76470588235294, size: 1 },
    //     { x: 83.3752244165171, y: 3.52941176470588, size: 1 },
    //     { x: 84.0215439856373, y: 3.45098039215686, size: 1 },
    //     { x: 84.6678635547576, y: 3.56862745098039, size: 1 },
    //     { x: 85.3141831238779, y: 3.72549019607843, size: 1 },
    //     { x: 85.9605026929982, y: 3.52941176470588, size: 1 },
    //     { x: 86.6068222621185, y: 3.76470588235294, size: 1 },
    //     { x: 87.2531418312388, y: 3.52941176470588, size: 1 },
    //     { x: 87.8994614003591, y: 3.52941176470588, size: 1 },
    //     { x: 88.5457809694794, y: 3.49019607843137, size: 1 },
    //     { x: 89.1921005385996, y: 3.64705882352941, size: 1 },
    //     { x: 89.8384201077199, y: 3.45098039215686, size: 1 },
    //     { x: 90.4847396768402, y: 3.6078431372549, size: 1 },
    //     { x: 91.1310592459605, y: 3.68627450980392, size: 1 },
    //     { x: 91.7773788150808, y: 3.6078431372549, size: 1 },
    //     { x: 92.4236983842011, y: 3.45098039215686, size: 1 },
    //     { x: 93.0700179533214, y: 3.37254901960784, size: 1 },
    //     { x: 93.7163375224416, y: 3.2156862745098, size: 1 },
    //     { x: 94.3626570915619, y: 3.49019607843137, size: 1 },
    //     { x: 95.0089766606822, y: 3.88235294117647, size: 1 },
    //     { x: 95.6552962298025, y: 3.72549019607843, size: 1 },
    //     { x: 96.3016157989228, y: 3.6078431372549, size: 1 },
    //     { x: 96.9479353680431, y: 3.6078431372549, size: 1 },
    //     { x: 97.5942549371634, y: 3.68627450980392, size: 1 },
    //     { x: 98.2405745062837, y: 3.64705882352941, size: 1 },
    //     { x: 98.8868940754039, y: 3.72549019607843, size: 1 },
    //     { x: 99.5332136445242, y: 3.52941176470588, size: 1 },
    //     { x: 100.179533213645, y: 3.6078431372549, size: 1 },
    //     { x: 100.825852782765, y: 3.76470588235294, size: 1 },
    //     { x: 101.472172351885, y: 3.84313725490196, size: 1 },
    //     { x: 102.118491921005, y: 3.68627450980392, size: 1 },
    //     { x: 102.764811490126, y: 3.80392156862745, size: 1 },
    //     { x: 103.411131059246, y: 3.80392156862745, size: 1 },
    //     { x: 104.057450628366, y: 3.64705882352941, size: 1 },
    //     { x: 104.703770197487, y: 3.64705882352941, size: 1 },
    //     { x: 105.350089766607, y: 3.68627450980392, size: 1 },
    //     { x: 105.996409335727, y: 3.76470588235294, size: 1 },
    //     { x: 106.642728904847, y: 3.84313725490196, size: 1 },
    //     { x: 107.289048473968, y: 3.88235294117647, size: 1 },
    //     { x: 107.935368043088, y: 3.6078431372549, size: 1 },
    //     { x: 108.581687612208, y: 3.80392156862745, size: 1 },
    //     { x: 109.228007181329, y: 3.76470588235294, size: 1 },
    //     { x: 109.874326750449, y: 3.80392156862745, size: 1 },
    //     { x: 110.520646319569, y: 3.80392156862745, size: 1 },
    //     { x: 111.166965888689, y: 3.84313725490196, size: 1 },
    //     { x: 111.81328545781, y: 3.6078431372549, size: 1 },
    //     { x: 112.45960502693, y: 3.72549019607843, size: 1 },
    //     { x: 113.10592459605, y: 3.80392156862745, size: 1 },
    //     { x: 113.752244165171, y: 3.45098039215686, size: 1 },
    //     { x: 114.398563734291, y: 3.68627450980392, size: 1 },
    //     { x: 115.044883303411, y: 3.2156862745098, size: 1 },
    //     { x: 115.691202872531, y: 3.41176470588235, size: 1 },
    //     { x: 116.337522441652, y: 3.52941176470588, size: 1 },
    //     { x: 116.983842010772, y: 4, size: 1 },
    //     { x: 117.630161579892, y: 3.76470588235294, size: 1 },
    //     { x: 118.276481149013, y: 3.56862745098039, size: 1 },
    //     { x: 118.922800718133, y: 3.76470588235294, size: 1 },
    //     { x: 119.569120287253, y: 3.72549019607843, size: 1 },
    //     { x: 120.215439856373, y: 3.56862745098039, size: 1 },
    //     { x: 120.861759425494, y: 3.88235294117647, size: 1 },
    //     { x: 121.508078994614, y: 3.72549019607843, size: 1 },
    //     { x: 122.154398563734, y: 3.92156862745098, size: 1 },
    //     { x: 122.800718132855, y: 3.72549019607843, size: 1 },
    //     { x: 123.447037701975, y: 3.64705882352941, size: 1 },
    //     { x: 124.093357271095, y: 3.72549019607843, size: 1 },
    //     { x: 124.739676840215, y: 3.64705882352941, size: 1 },
    //     { x: 125.385996409336, y: 3.68627450980392, size: 1 },
    //     { x: 126.032315978456, y: 3.64705882352941, size: 1 },
    //     { x: 126.678635547576, y: 3.56862745098039, size: 1 },
    //     { x: 127.324955116697, y: 3.6078431372549, size: 1 },
    //     { x: 127.971274685817, y: 3.68627450980392, size: 1 },
    //     { x: 128.617594254937, y: 3.72549019607843, size: 1 },
    //     { x: 129.263913824057, y: 3.92156862745098, size: 1 },
    //     { x: 129.910233393178, y: 3.68627450980392, size: 1 },
    //     { x: 130.556552962298, y: 3.68627450980392, size: 1 },
    //     { x: 131.202872531418, y: 3.72549019607843, size: 1 },
    //     { x: 131.849192100539, y: 3.72549019607843, size: 1 },
    //     { x: 132.495511669659, y: 3.56862745098039, size: 1 },
    //     { x: 133.141831238779, y: 3.52941176470588, size: 1 },
    //     { x: 133.788150807899, y: 3.68627450980392, size: 1 },
    //     { x: 134.43447037702, y: 3.68627450980392, size: 1 },
    //     { x: 135.08078994614, y: 3.52941176470588, size: 1 },
    //     { x: 135.72710951526, y: 3.52941176470588, size: 1 },
    //     { x: 136.373429084381, y: 3.49019607843137, size: 1 },
    //     { x: 137.019748653501, y: 3.49019607843137, size: 1 },
    //     { x: 137.666068222621, y: 3.49019607843137, size: 1 },
    //     { x: 138.312387791741, y: 3.6078431372549, size: 1 },
    //     { x: 138.958707360862, y: 3.64705882352941, size: 1 },
    //     { x: 139.605026929982, y: 3.68627450980392, size: 1 },
    //     { x: 140.251346499102, y: 3.72549019607843, size: 1 },
    //     { x: 140.897666068223, y: 3.56862745098039, size: 1 },
    //     { x: 141.543985637343, y: 3.92156862745098, size: 1 },
    //     { x: 142.190305206463, y: 3.56862745098039, size: 1 },
    //     { x: 142.836624775583, y: 3.76470588235294, size: 1 },
    //     { x: 143.482944344704, y: 3.76470588235294, size: 1 },
    //     { x: 144.129263913824, y: 3.45098039215686, size: 1 },
    //     { x: 144.775583482944, y: 3.64705882352941, size: 1 },
    //     { x: 145.421903052065, y: 3.76470588235294, size: 1 },
    //     { x: 146.068222621185, y: 3.80392156862745, size: 1 },
    //     { x: 146.714542190305, y: 3.68627450980392, size: 1 },
    //     { x: 147.360861759425, y: 3.52941176470588, size: 1 },
    //     { x: 148.007181328546, y: 3.88235294117647, size: 1 },
    //     { x: 148.653500897666, y: 3.52941176470588, size: 1 },
    //     { x: 149.299820466786, y: 3.68627450980392, size: 1 },
    //     { x: 149.946140035907, y: 3.6078431372549, size: 1 },
    //     { x: 150.592459605027, y: 3.68627450980392, size: 1 },
    //     { x: 151.238779174147, y: 3.80392156862745, size: 1 },
    //     { x: 151.885098743267, y: 3.76470588235294, size: 1 },
    //     { x: 152.531418312388, y: 3.64705882352941, size: 1 },
    //     { x: 153.177737881508, y: 3.64705882352941, size: 1 },
    //     { x: 153.824057450628, y: 3.6078431372549, size: 1 },
    //     { x: 154.470377019749, y: 3.72549019607843, size: 1 },
    //     { x: 155.116696588869, y: 3.64705882352941, size: 1 },
    //     { x: 155.763016157989, y: 3.64705882352941, size: 1 },
    //     { x: 156.40933572711, y: 3.37254901960784, size: 1 },
    //     { x: 157.05565529623, y: 3.29411764705882, size: 1 },
    //     { x: 157.70197486535, y: 3.41176470588235, size: 1 },
    //     { x: 158.34829443447, y: 3.29411764705882, size: 1 },
    //     { x: 158.994614003591, y: 3.49019607843137, size: 1 },
    //     { x: 159.640933572711, y: 3.84313725490196, size: 1 },
    //     { x: 160.287253141831, y: 3.6078431372549, size: 1 },
    //     { x: 160.933572710952, y: 3.56862745098039, size: 1 },
    //     { x: 161.579892280072, y: 3.68627450980392, size: 1 },
    //     { x: 162.226211849192, y: 3.80392156862745, size: 1 },
    //     { x: 162.872531418312, y: 3.80392156862745, size: 1 },
    //     { x: 163.518850987433, y: 3.72549019607843, size: 1 },
    //     { x: 164.165170556553, y: 4.19607843137255, size: 1 },
    //     { x: 164.811490125673, y: 3.56862745098039, size: 1 },
    //     { x: 165.457809694794, y: 3.64705882352941, size: 1 },
    //     { x: 166.104129263914, y: 3.52941176470588, size: 1 },
    //     { x: 166.750448833034, y: 3.64705882352941, size: 1 },
    //     { x: 167.396768402154, y: 3.68627450980392, size: 1 },
    //     { x: 168.043087971275, y: 3.76470588235294, size: 1 },
    //     { x: 168.689407540395, y: 3.41176470588235, size: 1 },
    //     { x: 169.335727109515, y: 3.72549019607843, size: 1 },
    //     { x: 169.982046678636, y: 3.68627450980392, size: 1 },
    //     { x: 170.628366247756, y: 3.52941176470588, size: 1 },
    //     { x: 171.274685816876, y: 3.56862745098039, size: 1 },
    //     { x: 171.921005385996, y: 3.72549019607843, size: 1 },
    //     { x: 172.567324955117, y: 3.41176470588235, size: 1 },
    //     { x: 173.213644524237, y: 3.76470588235294, size: 1 },
    //     { x: 173.859964093357, y: 3.49019607843137, size: 1 },
    //     { x: 174.506283662478, y: 3.68627450980392, size: 1 },
    //     { x: 175.152603231598, y: 3.72549019607843, size: 1 },
    //     { x: 175.798922800718, y: 3.56862745098039, size: 1 },
    //     { x: 176.445242369838, y: 3.68627450980392, size: 1 },
    //     { x: 177.091561938959, y: 3.52941176470588, size: 1 },
    //     { x: 177.737881508079, y: 3.37254901960784, size: 1 },
    //     { x: 178.384201077199, y: 3.6078431372549, size: 1 },
    //     { x: 179.03052064632, y: 3.49019607843137, size: 1 },
    //     { x: 179.67684021544, y: 3.29411764705882, size: 1 },
    //     { x: 180.32315978456, y: 3.17647058823529, size: 1 },
    //     { x: 180.96947935368, y: 3.52941176470588, size: 1 },
    //     { x: 181.615798922801, y: 3.64705882352941, size: 1 },
    //     { x: 182.262118491921, y: 3.6078431372549, size: 1 },
    //     { x: 182.908438061041, y: 3.56862745098039, size: 1 },
    //     { x: 183.554757630162, y: 3.56862745098039, size: 1 },
    //     { x: 184.201077199282, y: 3.64705882352941, size: 1 },
    //     { x: 184.847396768402, y: 3.68627450980392, size: 1 },
    //     { x: 185.493716337522, y: 3.84313725490196, size: 1 },
    //     { x: 186.140035906643, y: 3.68627450980392, size: 1 },
    //     { x: 186.786355475763, y: 3.49019607843137, size: 1 },
    //     { x: 187.432675044883, y: 3.88235294117647, size: 1 },
    //     { x: 188.078994614004, y: 3.6078431372549, size: 1 },
    //     { x: 188.725314183124, y: 3.6078431372549, size: 1 },
    //     { x: 189.371633752244, y: 3.6078431372549, size: 1 },
    //     { x: 190.017953321364, y: 3.49019607843137, size: 1 },
    //     { x: 190.664272890485, y: 3.64705882352941, size: 1 },
    //     { x: 191.310592459605, y: 3.49019607843137, size: 1 },
    //     { x: 191.956912028725, y: 3.6078431372549, size: 1 },
    //     { x: 192.603231597846, y: 3.52941176470588, size: 1 },
    //     { x: 193.249551166966, y: 3.41176470588235, size: 1 },
    //     { x: 193.895870736086, y: 3.49019607843137, size: 1 },
    //     { x: 194.542190305206, y: 3.72549019607843, size: 1 },
    //     { x: 195.188509874327, y: 3.76470588235294, size: 1 },
    //     { x: 195.834829443447, y: 3.52941176470588, size: 1 },
    //     { x: 196.481149012567, y: 3.52941176470588, size: 1 },
    //     { x: 197.127468581688, y: 3.64705882352941, size: 1 },
    //     { x: 197.773788150808, y: 3.68627450980392, size: 1 },
    //     { x: 198.420107719928, y: 3.76470588235294, size: 1 },
    //     { x: 199.066427289048, y: 3.56862745098039, size: 1 },
    //     { x: 199.712746858169, y: 3.88235294117647, size: 1 },
    //     { x: 200.359066427289, y: 3.64705882352941, size: 1 },
    //     { x: 201.005385996409, y: 3.37254901960784, size: 1 },
    //     { x: 201.65170556553, y: 3.64705882352941, size: 1 },
    //     { x: 202.29802513465, y: 3.33333333333333, size: 1 },
    //     { x: 202.94434470377, y: 3.72549019607843, size: 1 },
    //     { x: 203.59066427289, y: 3.80392156862745, size: 1 },
    //     { x: 204.236983842011, y: 3.56862745098039, size: 1 },
    //     { x: 204.883303411131, y: 3.80392156862745, size: 1 },
    //     { x: 205.529622980251, y: 3.64705882352941, size: 1 },
    //     { x: 206.175942549372, y: 3.72549019607843, size: 1 },
    //     { x: 206.822262118492, y: 3.6078431372549, size: 1 },
    //     { x: 207.468581687612, y: 3.84313725490196, size: 1 },
    //     { x: 208.114901256733, y: 3.52941176470588, size: 1 },
    //     { x: 208.761220825853, y: 3.92156862745098, size: 1 },
    //     { x: 209.407540394973, y: 3.68627450980392, size: 1 },
    //     { x: 210.053859964093, y: 3.6078431372549, size: 1 },
    //     { x: 210.700179533214, y: 3.92156862745098, size: 1 },
    //     { x: 211.346499102334, y: 3.64705882352941, size: 1 },
    //     { x: 211.992818671454, y: 3.84313725490196, size: 1 },
    //     { x: 212.639138240575, y: 3.68627450980392, size: 1 },
    //     { x: 213.285457809695, y: 3.68627450980392, size: 1 },
    //     { x: 213.931777378815, y: 3.68627450980392, size: 1 },
    //     { x: 214.578096947935, y: 3.56862745098039, size: 1 },
    //     { x: 215.224416517056, y: 3.64705882352941, size: 1 },
    //     { x: 215.870736086176, y: 3.72549019607843, size: 1 },
    //     { x: 216.517055655296, y: 3.80392156862745, size: 1 },
    //     { x: 217.163375224417, y: 3.76470588235294, size: 1 },
    //     { x: 217.809694793537, y: 3.6078431372549, size: 1 },
    //     { x: 218.456014362657, y: 3.68627450980392, size: 1 },
    //     { x: 219.102333931777, y: 3.68627450980392, size: 1 },
    //     { x: 219.748653500898, y: 3.80392156862745, size: 1 },
    //     { x: 220.394973070018, y: 3.56862745098039, size: 1 },
    //     { x: 221.041292639138, y: 3.68627450980392, size: 1 },
    //     { x: 221.687612208259, y: 3.49019607843137, size: 1 },
    //     { x: 222.333931777379, y: 3.72549019607843, size: 1 },
    //     { x: 222.980251346499, y: 3.56862745098039, size: 1 },
    //     { x: 223.626570915619, y: 3.49019607843137, size: 1 },
    //     { x: 224.27289048474, y: 3.76470588235294, size: 1 },
    //     { x: 224.91921005386, y: 3.68627450980392, size: 1 },
    //     { x: 225.56552962298, y: 3.72549019607843, size: 1 },
    //     { x: 226.211849192101, y: 3.56862745098039, size: 1 },
    //     { x: 226.858168761221, y: 3.45098039215686, size: 1 },
    //     { x: 227.504488330341, y: 3.76470588235294, size: 1 },
    //     { x: 228.150807899461, y: 3.68627450980392, size: 1 },
    //     { x: 228.797127468582, y: 3.72549019607843, size: 1 },
    //     { x: 229.443447037702, y: 3.68627450980392, size: 1 },
    //     { x: 230.089766606822, y: 3.68627450980392, size: 1 },
    //     { x: 230.736086175943, y: 3.88235294117647, size: 1 },
    //     { x: 231.382405745063, y: 3.56862745098039, size: 1 },
    //     { x: 232.028725314183, y: 3.84313725490196, size: 1 },
    //     { x: 232.675044883303, y: 3.45098039215686, size: 1 },
    //     { x: 233.321364452424, y: 3.56862745098039, size: 1 },
    //     { x: 233.967684021544, y: 3.56862745098039, size: 1 },
    //     { x: 234.614003590664, y: 3.6078431372549, size: 1 },
    //     { x: 235.260323159785, y: 3.41176470588235, size: 1 },
    //     { x: 235.906642728905, y: 3.72549019607843, size: 1 },
    //     { x: 236.552962298025, y: 3.64705882352941, size: 1 },
    //     { x: 237.199281867145, y: 4, size: 1 },
    //     { x: 237.845601436266, y: 3.68627450980392, size: 1 },
    //     { x: 238.491921005386, y: 3.52941176470588, size: 1 },
    //     { x: 239.138240574506, y: 3.88235294117647, size: 1 },
    //     { x: 239.784560143627, y: 3.6078431372549, size: 1 },
    //     { x: 240.430879712747, y: 3.72549019607843, size: 1 },
    //     { x: 241.077199281867, y: 3.56862745098039, size: 1 },
    //     { x: 241.723518850987, y: 3.68627450980392, size: 1 },
    //     { x: 242.369838420108, y: 3.84313725490196, size: 1 },
    //     { x: 243.016157989228, y: 3.17647058823529, size: 1 },
    //     { x: 243.662477558348, y: 3.45098039215686, size: 1 },
    //     { x: 244.308797127469, y: 3.17647058823529, size: 1 },
    //     { x: 244.955116696589, y: 2.90196078431373, size: 1 },
    //     { x: 245.601436265709, y: 3.6078431372549, size: 1 },
    //     { x: 246.247755834829, y: 3.52941176470588, size: 1 },
    //     { x: 246.89407540395, y: 3.6078431372549, size: 1 },
    //     { x: 247.54039497307, y: 3.68627450980392, size: 1 },
    //     { x: 248.18671454219, y: 3.41176470588235, size: 1 },
    //     { x: 248.833034111311, y: 3.52941176470588, size: 1 },
    //     { x: 249.479353680431, y: 3.49019607843137, size: 1 },
    //     { x: 250.125673249551, y: 3.68627450980392, size: 1 },
    //     { x: 250.771992818671, y: 3.52941176470588, size: 1 },
    //     { x: 251.418312387792, y: 3.56862745098039, size: 1 },
    //     { x: 252.064631956912, y: 3.96078431372549, size: 1 },
    //     { x: 252.710951526032, y: 3.41176470588235, size: 1 },
    //     { x: 253.357271095153, y: 3.49019607843137, size: 1 },
    //     { x: 254.003590664273, y: 3.52941176470588, size: 1 },
    //     { x: 254.649910233393, y: 3.80392156862745, size: 1 },
    //     { x: 255.296229802513, y: 3.72549019607843, size: 1 },
    //     { x: 255.942549371634, y: 3.68627450980392, size: 1 },
    //     { x: 256.588868940754, y: 3.56862745098039, size: 1 },
    //     { x: 257.235188509874, y: 3.64705882352941, size: 1 },
    //     { x: 257.881508078995, y: 3.49019607843137, size: 1 },
    //     { x: 258.527827648115, y: 3.64705882352941, size: 1 },
    //     { x: 259.174147217235, y: 3.37254901960784, size: 1 },
    //     { x: 259.820466786356, y: 3.6078431372549, size: 1 },
    //     { x: 260.466786355476, y: 3.6078431372549, size: 1 },
    //     { x: 261.113105924596, y: 3.6078431372549, size: 1 },
    //     { x: 261.759425493716, y: 3.6078431372549, size: 1 },
    //     { x: 262.405745062837, y: 3.49019607843137, size: 1 },
    //     { x: 263.052064631957, y: 3.6078431372549, size: 1 },
    //     { x: 263.698384201077, y: 3.41176470588235, size: 1 },
    //     { x: 264.344703770198, y: 3.56862745098039, size: 1 },
    //     { x: 264.991023339318, y: 3.56862745098039, size: 1 },
    //     { x: 265.637342908438, y: 3.76470588235294, size: 1 },
    //     { x: 266.283662477558, y: 3.37254901960784, size: 1 },
    //     { x: 266.929982046679, y: 3.49019607843137, size: 1 },
    //     { x: 267.576301615799, y: 3.68627450980392, size: 1 },
    //     { x: 268.222621184919, y: 3.64705882352941, size: 1 },
    //     { x: 268.86894075404, y: 3.6078431372549, size: 1 },
    //     { x: 269.51526032316, y: 3.64705882352941, size: 1 },
    //     { x: 270.16157989228, y: 3.76470588235294, size: 1 },
    //     { x: 270.8078994614, y: 3.64705882352941, size: 1 },
    //     { x: 271.454219030521, y: 3.56862745098039, size: 1 },
    //     { x: 272.100538599641, y: 3.6078431372549, size: 1 },
    //     { x: 272.746858168761, y: 3.68627450980392, size: 1 },
    //     { x: 273.393177737882, y: 3.6078431372549, size: 1 },
    //     { x: 274.039497307002, y: 3.80392156862745, size: 1 },
    //     { x: 274.685816876122, y: 3.84313725490196, size: 1 },
    //     { x: 275.332136445242, y: 3.6078431372549, size: 1 },
    //     { x: 275.978456014363, y: 3.6078431372549, size: 1 },
    //     { x: 276.624775583483, y: 3.6078431372549, size: 1 },
    //     { x: 277.271095152603, y: 3.84313725490196, size: 1 },
    //     { x: 277.917414721724, y: 3.6078431372549, size: 1 },
    //     { x: 278.563734290844, y: 3.68627450980392, size: 1 },
    //     { x: 279.210053859964, y: 4.07843137254902, size: 1 },
    //     { x: 279.856373429084, y: 3.68627450980392, size: 1 },
    //     { x: 280.502692998205, y: 3.72549019607843, size: 1 },
    //     { x: 281.149012567325, y: 3.52941176470588, size: 1 },
    //     { x: 281.795332136445, y: 3.64705882352941, size: 1 },
    //     { x: 282.441651705566, y: 3.56862745098039, size: 1 },
    //     { x: 283.087971274686, y: 3.80392156862745, size: 1 },
    //     { x: 283.734290843806, y: 3.45098039215686, size: 1 },
    //     { x: 284.380610412926, y: 3.6078431372549, size: 1 },
    //     { x: 285.026929982047, y: 3.64705882352941, size: 1 },
    //     { x: 285.673249551167, y: 3.76470588235294, size: 1 },
    //     { x: 286.319569120287, y: 3.37254901960784, size: 1 },
    //     { x: 286.965888689408, y: 3.6078431372549, size: 1 },
    //     { x: 287.612208258528, y: 3.13725490196078, size: 1 },
    //     { x: 288.258527827648, y: 3.33333333333333, size: 1 },
    //     { x: 288.904847396768, y: 3.33333333333333, size: 1 },
    //     { x: 289.551166965889, y: 3.49019607843137, size: 1 },
    //     { x: 290.197486535009, y: 3.45098039215686, size: 1 },
    //     { x: 290.843806104129, y: 3.6078431372549, size: 1 },
    //     { x: 291.49012567325, y: 3.49019607843137, size: 1 },
    //     { x: 292.13644524237, y: 3.72549019607843, size: 1 },
    //     { x: 292.78276481149, y: 3.6078431372549, size: 1 },
    //     { x: 293.42908438061, y: 3.56862745098039, size: 1 },
    //     { x: 294.075403949731, y: 3.76470588235294, size: 1 },
    //     { x: 294.721723518851, y: 3.52941176470588, size: 1 },
    //     { x: 295.368043087971, y: 3.6078431372549, size: 1 },
    //     { x: 296.014362657092, y: 3.45098039215686, size: 1 },
    //     { x: 296.660682226212, y: 3.92156862745098, size: 1 },
    //     { x: 297.307001795332, y: 3.56862745098039, size: 1 },
    //     { x: 297.953321364452, y: 3.6078431372549, size: 1 },
    //     { x: 298.599640933573, y: 3.92156862745098, size: 1 },
    //     { x: 299.245960502693, y: 3.76470588235294, size: 1 },
    //     { x: 299.892280071813, y: 3.68627450980392, size: 1 },
    //     { x: 300.538599640934, y: 3.68627450980392, size: 1 },
    //     { x: 301.184919210054, y: 3.64705882352941, size: 1 },
    //     { x: 301.831238779174, y: 3.68627450980392, size: 1 },
    //     { x: 302.477558348294, y: 3.72549019607843, size: 1 },
    //     { x: 303.123877917415, y: 3.6078431372549, size: 1 },
    //     { x: 303.770197486535, y: 3.45098039215686, size: 1 },
    //     { x: 304.416517055655, y: 3.37254901960784, size: 1 },
    //     { x: 305.062836624776, y: 3.52941176470588, size: 1 },
    //     { x: 305.709156193896, y: 3.76470588235294, size: 1 },
    //     { x: 306.355475763016, y: 3.64705882352941, size: 1 },
    //     { x: 307.001795332136, y: 3.52941176470588, size: 1 },
    //     { x: 307.648114901257, y: 3.37254901960784, size: 1 },
    //     { x: 308.294434470377, y: 3.29411764705882, size: 1 },
    //     { x: 308.940754039497, y: 2.90196078431373, size: 1 },
    //     { x: 309.587073608618, y: 3.25490196078431, size: 1 },
    //     { x: 310.233393177738, y: 2.7843137254902, size: 1 },
    //     { x: 310.879712746858, y: 2.86274509803922, size: 1 },
    //     { x: 311.526032315978, y: 3.56862745098039, size: 1 },
    //     { x: 312.172351885099, y: 3.6078431372549, size: 1 },
    //     { x: 312.818671454219, y: 3.64705882352941, size: 1 },
    //     { x: 313.464991023339, y: 3.88235294117647, size: 1 },
    //     { x: 314.11131059246, y: 3.68627450980392, size: 1 },
    //     { x: 314.75763016158, y: 3.72549019607843, size: 1 },
    //     { x: 315.4039497307, y: 3.88235294117647, size: 1 },
    //     { x: 316.05026929982, y: 3.49019607843137, size: 1 },
    //     { x: 316.696588868941, y: 3.64705882352941, size: 1 },
    //     { x: 317.342908438061, y: 3.76470588235294, size: 1 },
    //     { x: 317.989228007181, y: 3.80392156862745, size: 1 },
    //     { x: 318.635547576302, y: 3.6078431372549, size: 1 },
    //     { x: 319.281867145422, y: 3.72549019607843, size: 1 },
    //     { x: 319.928186714542, y: 3.72549019607843, size: 1 },
    //     { x: 320.574506283662, y: 3.80392156862745, size: 1 },
    //     { x: 321.220825852783, y: 3.56862745098039, size: 1 },
    //     { x: 321.867145421903, y: 3.6078431372549, size: 1 },
    //     { x: 322.513464991023, y: 3.72549019607843, size: 1 },
    //     { x: 323.159784560144, y: 3.6078431372549, size: 1 },
    //     { x: 323.806104129264, y: 3.52941176470588, size: 1 },
    //     { x: 324.452423698384, y: 3.68627450980392, size: 1 },
    //     { x: 325.098743267504, y: 3.72549019607843, size: 1 },
    //     { x: 325.745062836625, y: 3.68627450980392, size: 1 },
    //     { x: 326.391382405745, y: 3.72549019607843, size: 1 },
    //     { x: 327.037701974865, y: 3.6078431372549, size: 1 },
    //     { x: 327.684021543986, y: 3.76470588235294, size: 1 },
    //     { x: 328.330341113106, y: 3.6078431372549, size: 1 },
    //     { x: 328.976660682226, y: 3.68627450980392, size: 1 },
    //     { x: 329.622980251347, y: 3.41176470588235, size: 1 },
    //     { x: 330.269299820467, y: 3.2156862745098, size: 1 },
    //     { x: 330.915619389587, y: 3.33333333333333, size: 1 },
    //     { x: 331.561938958707, y: 3.52941176470588, size: 1 },
    //     { x: 332.208258527828, y: 3.64705882352941, size: 1 },
    //     { x: 332.854578096948, y: 3.33333333333333, size: 1 },
    //     { x: 333.500897666068, y: 3.37254901960784, size: 1 },
    //     { x: 334.147217235189, y: 3.56862745098039, size: 1 },
    //     { x: 334.793536804309, y: 3.45098039215686, size: 1 },
    //     { x: 335.439856373429, y: 3.72549019607843, size: 1 },
    //     { x: 336.086175942549, y: 3.56862745098039, size: 1 },
    //     { x: 336.73249551167, y: 3.68627450980392, size: 1 },
    //     { x: 337.37881508079, y: 3.52941176470588, size: 1 },
    //     { x: 338.02513464991, y: 3.49019607843137, size: 1 },
    //     { x: 338.671454219031, y: 3.68627450980392, size: 1 },
    //     { x: 339.317773788151, y: 3.52941176470588, size: 1 },
    //     { x: 339.964093357271, y: 3.76470588235294, size: 1 },
    //     { x: 340.610412926391, y: 3.6078431372549, size: 1 },
    //     { x: 341.256732495512, y: 3.64705882352941, size: 1 },
    //     { x: 341.903052064632, y: 3.41176470588235, size: 1 },
    //     { x: 342.549371633752, y: 3.45098039215686, size: 1 },
    //     { x: 343.195691202873, y: 3.49019607843137, size: 1 },
    //     { x: 343.842010771993, y: 3.45098039215686, size: 1 },
    //     { x: 344.488330341113, y: 3.76470588235294, size: 1 },
    //     { x: 345.134649910233, y: 3.45098039215686, size: 1 },
    //     { x: 345.780969479354, y: 3.68627450980392, size: 1 },
    //     { x: 346.427289048474, y: 3.52941176470588, size: 1 },
    //     { x: 347.073608617594, y: 3.80392156862745, size: 1 },
    //     { x: 347.719928186715, y: 3.45098039215686, size: 1 },
    //     { x: 348.366247755835, y: 3.45098039215686, size: 1 },
    //     { x: 349.012567324955, y: 3.64705882352941, size: 1 },
    //     { x: 349.658886894075, y: 3.41176470588235, size: 1 },
    //     { x: 350.305206463196, y: 3.37254901960784, size: 1 },
    //     { x: 350.951526032316, y: 3.56862745098039, size: 1 },
    //     { x: 351.597845601436, y: 3.45098039215686, size: 1 },
    //     { x: 352.244165170557, y: 2.90196078431373, size: 1 },
    //     { x: 352.890484739677, y: 3.64705882352941, size: 1 },
    //     { x: 353.536804308797, y: 3.76470588235294, size: 1 },
    //     { x: 354.183123877917, y: 3.72549019607843, size: 1 },
    //     { x: 354.829443447038, y: 3.80392156862745, size: 1 },
    //     { x: 355.475763016158, y: 3.52941176470588, size: 1 },
    //     { x: 356.122082585278, y: 3.68627450980392, size: 1 },
    //     { x: 356.768402154399, y: 3.52941176470588, size: 1 },
    //     { x: 357.414721723519, y: 3.80392156862745, size: 1 },
    //     { x: 358.061041292639, y: 3.6078431372549, size: 1 },
    //     { x: 358.707360861759, y: 3.52941176470588, size: 1 },
    //     { x: 359.35368043088, y: 3.84313725490196, size: 1 },
    //     { x: 0.648648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 3.89189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 4.54054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 5.18918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 8.43243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 9.72972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 11.6756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 13.6216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 14.2702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 16.2162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 16.8648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 17.5135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 18.1621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 20.1081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 24, y: 3.56862745098039, size: 1 },
    //     { x: 24.6486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 25.2972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 25.9459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 27.2432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 29.8378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 31.1351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 33.7297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 35.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 36.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 37.6216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 38.2702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 41.5135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 42.1621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 42.8108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 46.0540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 46.7027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 47.3513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 48, y: 3.56862745098039, size: 1 },
    //     { x: 48.6486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 49.2972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 49.9459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 50.5945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 51.2432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 51.8918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 52.5405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 55.1351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 57.0810810810811, y: 3.01960784313725, size: 1 },
    //     { x: 58.3783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 59.6756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 62.2702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 63.5675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 68.1081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 68.7567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 71.3513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 72.6486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 73.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 74.5945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 77.1891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 77.8378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 78.4864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 79.1351351351351, y: 2.94117647058824, size: 1 },
    //     { x: 82.3783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 83.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 83.6756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 84.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 86.9189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 92.1081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 92.7567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 95.3513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 97.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 98.5945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 99.2432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 99.8918918918919, y: 2.86274509803922, size: 1 },
    //     { x: 100.540540540541, y: 2.62745098039216, size: 1 },
    //     { x: 103.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 104.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 105.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 106.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 107.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 108.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 110.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 111.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 114.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 116.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 117.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 118.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 118.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 122.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 124.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 125.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 125.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 127.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 133.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 134.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 136.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 137.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 138.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 140.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 142.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 143.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 144, y: 3.29411764705882, size: 1 },
    //     { x: 144.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 145.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 149.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 150.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 151.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 153.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 156.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 156.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 158.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 158.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 160.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 163.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 164.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 166.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 167.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 168, y: 3.45098039215686, size: 1 },
    //     { x: 168.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 169.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 170.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 172.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 173.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 173.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 175.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 177.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 177.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 178.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 179.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 181.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 182.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 183.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 184.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 184.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 185.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 186.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 186.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 188.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 190.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 195.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 198.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 201.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 202.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 203.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 204.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 206.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 207.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 208.216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 208.864864864865, y: 2.86274509803922, size: 1 },
    //     { x: 214.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 215.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 216.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 218.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 219.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 219.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 220.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 221.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 223.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 223.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 227.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 227.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 228.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 228.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 229.621621621622, y: 2, size: 1 },
    //     { x: 230.27027027027, y: 2, size: 1 },
    //     { x: 230.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 233.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 235.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 236.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 238.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 240, y: 3.56862745098039, size: 1 },
    //     { x: 240.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 241.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 244.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 245.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 247.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 248.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 251.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 251.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 252.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 254.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 255.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 258.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 258.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 260.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 262.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 262.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 264, y: 3.45098039215686, size: 1 },
    //     { x: 264.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 265.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 265.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 269.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 271.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 272.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 273.081081081081, y: 2.82352941176471, size: 1 },
    //     { x: 273.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 275.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 278.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 281.513513513513, y: 3.72549019607843, size: 1 },
    //     { x: 282.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 284.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 287.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 288, y: 3.64705882352941, size: 1 },
    //     { x: 291.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 292.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 293.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 294.486486486487, y: 2.62745098039216, size: 1 },
    //     { x: 295.135135135135, y: 2.82352941176471, size: 1 },
    //     { x: 295.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 296.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 297.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 298.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 302.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 306.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 307.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 309.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 310.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 311.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 312, y: 3.56862745098039, size: 1 },
    //     { x: 313.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 314.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 315.891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 316.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 317.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 317.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 318.486486486487, y: 3.6078431372549, size: 1 },
    //     { x: 319.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 320.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 321.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 324.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 324.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 326.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 328.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 330.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 330.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 332.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 332.756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 335.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 336, y: 3.33333333333333, size: 1 },
    //     { x: 336.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 337.297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 337.945945945946, y: 1.68627450980392, size: 1 },
    //     { x: 338.594594594595, y: 1.41176470588235, size: 1 },
    //     { x: 340.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 341.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 343.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 344.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 347.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 348.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 348.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 349.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 350.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 351.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 354.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 354.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 355.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 358.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 358.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 7.12230215827338, y: 3.37254901960784, size: 1 },
    //     { x: 7.76978417266187, y: 3.37254901960784, size: 1 },
    //     { x: 13.5971223021583, y: 3.52941176470588, size: 1 },
    //     { x: 17.4820143884892, y: 3.45098039215686, size: 1 },
    //     { x: 19.4244604316547, y: 3.13725490196078, size: 1 },
    //     { x: 20.0719424460432, y: 2.94117647058824, size: 1 },
    //     { x: 40.7913669064748, y: 3.41176470588235, size: 1 },
    //     { x: 41.4388489208633, y: 3.33333333333333, size: 1 },
    //     { x: 47.2661870503597, y: 3.80392156862745, size: 1 },
    //     { x: 49.8561151079137, y: 3.33333333333333, size: 1 },
    //     { x: 55.0359712230216, y: 3.33333333333333, size: 1 },
    //     { x: 60.2158273381295, y: 3.33333333333333, size: 1 },
    //     { x: 63.4532374100719, y: 3.2156862745098, size: 1 },
    //     { x: 68.6330935251799, y: 3.64705882352941, size: 1 },
    //     { x: 78.3453237410072, y: 3.92156862745098, size: 1 },
    //     { x: 97.1223021582734, y: 3.76470588235294, size: 1 },
    //     { x: 108.776978417266, y: 3.56862745098039, size: 1 },
    //     { x: 109.424460431655, y: 3.72549019607843, size: 1 },
    //     { x: 112.661870503597, y: 3.49019607843137, size: 1 },
    //     { x: 121.079136690647, y: 3.37254901960784, size: 1 },
    //     { x: 121.726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 124.31654676259, y: 3.76470588235294, size: 1 },
    //     { x: 139.208633093525, y: 3.88235294117647, size: 1 },
    //     { x: 141.798561151079, y: 3.72549019607843, size: 1 },
    //     { x: 147.625899280576, y: 3.72549019607843, size: 1 },
    //     { x: 148.273381294964, y: 3.45098039215686, size: 1 },
    //     { x: 149.568345323741, y: 3.37254901960784, size: 1 },
    //     { x: 150.863309352518, y: 3.88235294117647, size: 1 },
    //     { x: 158.63309352518, y: 3.41176470588235, size: 1 },
    //     { x: 160.575539568345, y: 3.92156862745098, size: 1 },
    //     { x: 163.812949640288, y: 3.52941176470588, size: 1 },
    //     { x: 168.992805755396, y: 3.52941176470588, size: 1 },
    //     { x: 169.640287769784, y: 3.45098039215686, size: 1 },
    //     { x: 185.827338129496, y: 3.41176470588235, size: 1 },
    //     { x: 187.122302158273, y: 3.88235294117647, size: 1 },
    //     { x: 198.129496402878, y: 3.56862745098039, size: 1 },
    //     { x: 200.719424460432, y: 3.6078431372549, size: 1 },
    //     { x: 203.956834532374, y: 3.88235294117647, size: 1 },
    //     { x: 205.251798561151, y: 3.52941176470588, size: 1 },
    //     { x: 207.194244604317, y: 3.76470588235294, size: 1 },
    //     { x: 209.784172661871, y: 3.45098039215686, size: 1 },
    //     { x: 212.374100719424, y: 3.68627450980392, size: 1 },
    //     { x: 216.906474820144, y: 3.41176470588235, size: 1 },
    //     { x: 225.971223021583, y: 3.92156862745098, size: 1 },
    //     { x: 235.035971223022, y: 3.41176470588235, size: 1 },
    //     { x: 236.978417266187, y: 3.2156862745098, size: 1 },
    //     { x: 238.273381294964, y: 3.52941176470588, size: 1 },
    //     { x: 246.043165467626, y: 4, size: 1 },
    //     { x: 247.985611510791, y: 3.64705882352941, size: 1 },
    //     { x: 258.345323741007, y: 3.17647058823529, size: 1 },
    //     { x: 264.172661870504, y: 3.33333333333333, size: 1 },
    //     { x: 264.820143884892, y: 3.33333333333333, size: 1 },
    //     { x: 269.352517985611, y: 3.37254901960784, size: 1 },
    //     { x: 275.179856115108, y: 3.37254901960784, size: 1 },
    //     { x: 279.064748201439, y: 3.37254901960784, size: 1 },
    //     { x: 279.712230215827, y: 3.56862745098039, size: 1 },
    //     { x: 280.359712230216, y: 3.09803921568627, size: 1 },
    //     { x: 288.129496402878, y: 3.68627450980392, size: 1 },
    //     { x: 293.956834532374, y: 3.88235294117647, size: 1 },
    //     { x: 295.89928057554, y: 3.84313725490196, size: 1 },
    //     { x: 296.546762589928, y: 3.52941176470588, size: 1 },
    //     { x: 298.489208633094, y: 3.68627450980392, size: 1 },
    //     { x: 299.784172661871, y: 3.45098039215686, size: 1 },
    //     { x: 301.726618705036, y: 3.13725490196078, size: 1 },
    //     { x: 303.669064748201, y: 3.25490196078431, size: 1 },
    //     { x: 304.964028776978, y: 3.41176470588235, size: 1 },
    //     { x: 308.848920863309, y: 3.25490196078431, size: 1 },
    //     { x: 309.496402877698, y: 3.49019607843137, size: 1 },
    //     { x: 310.143884892086, y: 3.6078431372549, size: 1 },
    //     { x: 310.791366906475, y: 3.6078431372549, size: 1 },
    //     { x: 312.086330935252, y: 3.41176470588235, size: 1 },
    //     { x: 313.381294964029, y: 3.33333333333333, size: 1 },
    //     { x: 315.971223021583, y: 3.33333333333333, size: 1 },
    //     { x: 318.561151079137, y: 3.37254901960784, size: 1 },
    //     { x: 319.208633093525, y: 3.25490196078431, size: 1 },
    //     { x: 319.856115107914, y: 3.29411764705882, size: 1 },
    //     { x: 325.68345323741, y: 3.92156862745098, size: 1 },
    //     { x: 330.215827338129, y: 3.84313725490196, size: 1 },
    //     { x: 332.805755395683, y: 3.88235294117647, size: 1 },
    //     { x: 339.928057553957, y: 3.49019607843137, size: 1 },
    //     { x: 351.58273381295, y: 3.88235294117647, size: 1 },
    //     { x: 353.525179856115, y: 3.92156862745098, size: 1 },
    //     { x: 354.172661870504, y: 3.88235294117647, size: 1 },
    //     { x: 354.820143884892, y: 3.49019607843137, size: 1 },
    //     { x: 357.410071942446, y: 3.76470588235294, size: 1 },
    //     { x: 358.057553956835, y: 4, size: 1 },
    //     { x: 2.58992805755396, y: 3.80392156862745, size: 1 },
    //     { x: 7.12230215827338, y: 3.17647058823529, size: 1 },
    //     { x: 9.71223021582734, y: 3.84313725490196, size: 1 },
    //     { x: 11.0071942446043, y: 3.96078431372549, size: 1 },
    //     { x: 17.4820143884892, y: 3.88235294117647, size: 1 },
    //     { x: 25.8992805755396, y: 3.56862745098039, size: 1 },
    //     { x: 26.5467625899281, y: 3.29411764705882, size: 1 },
    //     { x: 27.841726618705, y: 2.94117647058824, size: 1 },
    //     { x: 28.4892086330935, y: 3.17647058823529, size: 1 },
    //     { x: 30.431654676259, y: 3.76470588235294, size: 1 },
    //     { x: 33.6690647482014, y: 3.80392156862745, size: 1 },
    //     { x: 36.9064748201439, y: 3.88235294117647, size: 1 },
    //     { x: 42.0863309352518, y: 3.84313725490196, size: 1 },
    //     { x: 45.9712230215827, y: 3.56862745098039, size: 1 },
    //     { x: 58.273381294964, y: 3.6078431372549, size: 1 },
    //     { x: 60.863309352518, y: 3.64705882352941, size: 1 },
    //     { x: 62.8057553956835, y: 3.92156862745098, size: 1 },
    //     { x: 63.4532374100719, y: 3.88235294117647, size: 1 },
    //     { x: 69.2805755395683, y: 3.84313725490196, size: 1 },
    //     { x: 71.8705035971223, y: 3.37254901960784, size: 1 },
    //     { x: 78.9928057553957, y: 3.52941176470588, size: 1 },
    //     { x: 89.3525179856115, y: 3.49019607843137, size: 1 },
    //     { x: 92.589928057554, y: 3.45098039215686, size: 1 },
    //     { x: 93.2374100719424, y: 3.33333333333333, size: 1 },
    //     { x: 103.597122302158, y: 3.37254901960784, size: 1 },
    //     { x: 104.244604316547, y: 3.76470588235294, size: 1 },
    //     { x: 113.956834532374, y: 3.56862745098039, size: 1 },
    //     { x: 114.604316546763, y: 3.33333333333333, size: 1 },
    //     { x: 115.251798561151, y: 3.33333333333333, size: 1 },
    //     { x: 121.079136690647, y: 3.84313725490196, size: 1 },
    //     { x: 127.553956834532, y: 3.41176470588235, size: 1 },
    //     { x: 130.143884892086, y: 3.45098039215686, size: 1 },
    //     { x: 133.381294964029, y: 3.64705882352941, size: 1 },
    //     { x: 135.971223021583, y: 3.2156862745098, size: 1 },
    //     { x: 136.618705035971, y: 3.33333333333333, size: 1 },
    //     { x: 142.446043165468, y: 3.25490196078431, size: 1 },
    //     { x: 145.035971223022, y: 3.64705882352941, size: 1 },
    //     { x: 150.215827338129, y: 3.33333333333333, size: 1 },
    //     { x: 154.10071942446, y: 3.41176470588235, size: 1 },
    //     { x: 154.748201438849, y: 3.29411764705882, size: 1 },
    //     { x: 156.043165467626, y: 3.80392156862745, size: 1 },
    //     { x: 157.338129496403, y: 3.33333333333333, size: 1 },
    //     { x: 158.63309352518, y: 3.29411764705882, size: 1 },
    //     { x: 159.280575539568, y: 3.52941176470588, size: 1 },
    //     { x: 160.575539568345, y: 3.29411764705882, size: 1 },
    //     { x: 161.223021582734, y: 3.29411764705882, size: 1 },
    //     { x: 164.460431654676, y: 3.29411764705882, size: 1 },
    //     { x: 168.345323741007, y: 3.29411764705882, size: 1 },
    //     { x: 170.287769784173, y: 3.41176470588235, size: 1 },
    //     { x: 172.877697841727, y: 3.41176470588235, size: 1 },
    //     { x: 174.172661870504, y: 3.37254901960784, size: 1 },
    //     { x: 175.467625899281, y: 3.17647058823529, size: 1 },
    //     { x: 176.115107913669, y: 3.37254901960784, size: 1 },
    //     { x: 180.647482014388, y: 3.96078431372549, size: 1 },
    //     { x: 183.237410071942, y: 3.88235294117647, size: 1 },
    //     { x: 187.122302158273, y: 3.56862745098039, size: 1 },
    //     { x: 193.597122302158, y: 3.72549019607843, size: 1 },
    //     { x: 195.539568345324, y: 3.96078431372549, size: 1 },
    //     { x: 200.719424460432, y: 3.13725490196078, size: 1 },
    //     { x: 202.661870503597, y: 3.09803921568627, size: 1 },
    //     { x: 203.309352517986, y: 3.2156862745098, size: 1 },
    //     { x: 203.956834532374, y: 3.37254901960784, size: 1 },
    //     { x: 206.546762589928, y: 3.05882352941176, size: 1 },
    //     { x: 207.194244604317, y: 3.29411764705882, size: 1 },
    //     { x: 207.841726618705, y: 3.09803921568627, size: 1 },
    //     { x: 208.489208633094, y: 3.13725490196078, size: 1 },
    //     { x: 211.726618705036, y: 3.01960784313725, size: 1 },
    //     { x: 212.374100719424, y: 3.17647058823529, size: 1 },
    //     { x: 213.669064748201, y: 3.17647058823529, size: 1 },
    //     { x: 214.31654676259, y: 3.05882352941176, size: 1 },
    //     { x: 216.258992805755, y: 3.2156862745098, size: 1 },
    //     { x: 217.553956834532, y: 3.6078431372549, size: 1 },
    //     { x: 218.201438848921, y: 3.13725490196078, size: 1 },
    //     { x: 222.086330935252, y: 3.41176470588235, size: 1 },
    //     { x: 223.381294964029, y: 3.37254901960784, size: 1 },
    //     { x: 225.323741007194, y: 3.2156862745098, size: 1 },
    //     { x: 227.913669064748, y: 3.25490196078431, size: 1 },
    //     { x: 229.208633093525, y: 3.25490196078431, size: 1 },
    //     { x: 229.856115107914, y: 3.29411764705882, size: 1 },
    //     { x: 230.503597122302, y: 3.2156862745098, size: 1 },
    //     { x: 234.388489208633, y: 3.17647058823529, size: 1 },
    //     { x: 237.625899280576, y: 3.33333333333333, size: 1 },
    //     { x: 238.920863309353, y: 3.29411764705882, size: 1 },
    //     { x: 240.863309352518, y: 3.2156862745098, size: 1 },
    //     { x: 241.510791366906, y: 3.17647058823529, size: 1 },
    //     { x: 243.453237410072, y: 3.37254901960784, size: 1 },
    //     { x: 244.10071942446, y: 3.37254901960784, size: 1 },
    //     { x: 244.748201438849, y: 3.17647058823529, size: 1 },
    //     { x: 247.985611510791, y: 3.49019607843137, size: 1 },
    //     { x: 252.517985611511, y: 3.37254901960784, size: 1 },
    //     { x: 253.165467625899, y: 3.49019607843137, size: 1 },
    //     { x: 255.755395683453, y: 3.45098039215686, size: 1 },
    //     { x: 258.992805755396, y: 3.33333333333333, size: 1 },
    //     { x: 263.525179856115, y: 3.41176470588235, size: 1 },
    //     { x: 266.115107913669, y: 3.17647058823529, size: 1 },
    //     { x: 268.705035971223, y: 3.76470588235294, size: 1 },
    //     { x: 275.179856115108, y: 3.45098039215686, size: 1 },
    //     { x: 277.122302158273, y: 3.45098039215686, size: 1 },
    //     { x: 286.834532374101, y: 3.2156862745098, size: 1 },
    //     { x: 287.482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 293.309352517986, y: 3.37254901960784, size: 1 },
    //     { x: 301.726618705036, y: 3.49019607843137, size: 1 },
    //     { x: 324.388489208633, y: 3.56862745098039, size: 1 },
    //     { x: 327.625899280576, y: 3.64705882352941, size: 1 },
    //     { x: 328.273381294964, y: 3.37254901960784, size: 1 },
    //     { x: 330.863309352518, y: 3.33333333333333, size: 1 },
    //     { x: 343.812949640288, y: 3.37254901960784, size: 1 },
    //     { x: 346.402877697842, y: 3.49019607843137, size: 1 },
    //     { x: 347.05035971223, y: 3.6078431372549, size: 1 },
    //     { x: 347.697841726619, y: 3.88235294117647, size: 1 },
    //     { x: 350.287769784173, y: 3.2156862745098, size: 1 },
    //     { x: 351.58273381295, y: 3.05882352941176, size: 1 },
    //     { x: 352.230215827338, y: 3.37254901960784, size: 1 },
    //     { x: 358.705035971223, y: 3.37254901960784, size: 1 },
    //     { x: 359.352517985611, y: 3.80392156862745, size: 1 },
    //     { x: 3.23741007194245, y: 3.80392156862745, size: 1 },
    //     { x: 4.53237410071942, y: 3.72549019607843, size: 1 },
    //     { x: 12.9496402877698, y: 3.17647058823529, size: 1 },
    //     { x: 15.5395683453237, y: 3.96078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 4.15686274509804, size: 1 },
    //     { x: 33.0215827338129, y: 3.41176470588235, size: 1 },
    //     { x: 38.2014388489209, y: 3.80392156862745, size: 1 },
    //     { x: 42.7338129496403, y: 3.84313725490196, size: 1 },
    //     { x: 45.3237410071942, y: 4, size: 1 },
    //     { x: 45.9712230215827, y: 3.84313725490196, size: 1 },
    //     { x: 51.1510791366906, y: 3.88235294117647, size: 1 },
    //     { x: 52.4460431654676, y: 4.07843137254902, size: 1 },
    //     { x: 58.273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 65.3956834532374, y: 3.33333333333333, size: 1 },
    //     { x: 75.1079136690647, y: 3.56862745098039, size: 1 },
    //     { x: 78.3453237410072, y: 3.29411764705882, size: 1 },
    //     { x: 99.0647482014388, y: 3.05882352941176, size: 1 },
    //     { x: 99.7122302158273, y: 2.90196078431373, size: 1 },
    //     { x: 100.359712230216, y: 2.62745098039216, size: 1 },
    //     { x: 104.244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 123.669064748201, y: 3.09803921568627, size: 1 },
    //     { x: 124.31654676259, y: 3.37254901960784, size: 1 },
    //     { x: 124.964028776978, y: 3.33333333333333, size: 1 },
    //     { x: 127.553956834532, y: 3.13725490196078, size: 1 },
    //     { x: 129.496402877698, y: 3.17647058823529, size: 1 },
    //     { x: 130.143884892086, y: 3.33333333333333, size: 1 },
    //     { x: 132.086330935252, y: 3.17647058823529, size: 1 },
    //     { x: 132.73381294964, y: 3.17647058823529, size: 1 },
    //     { x: 134.676258992806, y: 3.13725490196078, size: 1 },
    //     { x: 135.323741007194, y: 3.29411764705882, size: 1 },
    //     { x: 135.971223021583, y: 3.01960784313725, size: 1 },
    //     { x: 139.856115107914, y: 3.25490196078431, size: 1 },
    //     { x: 141.798561151079, y: 3.96078431372549, size: 1 },
    //     { x: 145.035971223022, y: 3.2156862745098, size: 1 },
    //     { x: 145.68345323741, y: 3.25490196078431, size: 1 },
    //     { x: 146.978417266187, y: 3.41176470588235, size: 1 },
    //     { x: 149.568345323741, y: 3.33333333333333, size: 1 },
    //     { x: 150.215827338129, y: 3.45098039215686, size: 1 },
    //     { x: 150.863309352518, y: 3.29411764705882, size: 1 },
    //     { x: 152.158273381295, y: 3.76470588235294, size: 1 },
    //     { x: 152.805755395683, y: 3.37254901960784, size: 1 },
    //     { x: 154.10071942446, y: 3.17647058823529, size: 1 },
    //     { x: 154.748201438849, y: 3.41176470588235, size: 1 },
    //     { x: 156.043165467626, y: 3.37254901960784, size: 1 },
    //     { x: 156.690647482014, y: 3.25490196078431, size: 1 },
    //     { x: 157.338129496403, y: 3.17647058823529, size: 1 },
    //     { x: 159.280575539568, y: 3.29411764705882, size: 1 },
    //     { x: 161.223021582734, y: 3.37254901960784, size: 1 },
    //     { x: 163.812949640288, y: 3.29411764705882, size: 1 },
    //     { x: 164.460431654676, y: 3.05882352941176, size: 1 },
    //     { x: 165.107913669065, y: 3.17647058823529, size: 1 },
    //     { x: 167.697841726619, y: 3.29411764705882, size: 1 },
    //     { x: 170.287769784173, y: 3.84313725490196, size: 1 },
    //     { x: 174.172661870504, y: 3.84313725490196, size: 1 },
    //     { x: 178.705035971223, y: 3.72549019607843, size: 1 },
    //     { x: 179.352517985612, y: 3.80392156862745, size: 1 },
    //     { x: 180, y: 3.80392156862745, size: 1 },
    //     { x: 182.589928057554, y: 3.84313725490196, size: 1 },
    //     { x: 183.884892086331, y: 3.84313725490196, size: 1 },
    //     { x: 202.661870503597, y: 3.52941176470588, size: 1 },
    //     { x: 203.309352517986, y: 3.96078431372549, size: 1 },
    //     { x: 205.89928057554, y: 3.49019607843137, size: 1 },
    //     { x: 207.841726618705, y: 3.05882352941176, size: 1 },
    //     { x: 210.431654676259, y: 3.80392156862745, size: 1 },
    //     { x: 217.553956834532, y: 3.80392156862745, size: 1 },
    //     { x: 218.201438848921, y: 3.72549019607843, size: 1 },
    //     { x: 220.143884892086, y: 3.68627450980392, size: 1 },
    //     { x: 228.561151079137, y: 3.45098039215686, size: 1 },
    //     { x: 229.208633093525, y: 3.13725490196078, size: 1 },
    //     { x: 229.856115107914, y: 3.09803921568627, size: 1 },
    //     { x: 234.388489208633, y: 3.88235294117647, size: 1 },
    //     { x: 235.68345323741, y: 3.92156862745098, size: 1 },
    //     { x: 241.510791366906, y: 3.64705882352941, size: 1 },
    //     { x: 246.690647482014, y: 3.6078431372549, size: 1 },
    //     { x: 253.165467625899, y: 3.6078431372549, size: 1 },
    //     { x: 253.812949640288, y: 3.84313725490196, size: 1 },
    //     { x: 255.755395683453, y: 3.76470588235294, size: 1 },
    //     { x: 266.115107913669, y: 3.76470588235294, size: 1 },
    //     { x: 273.237410071942, y: 3.29411764705882, size: 1 },
    //     { x: 273.884892086331, y: 3.41176470588235, size: 1 },
    //     { x: 280.359712230216, y: 3.37254901960784, size: 1 },
    //     { x: 281.654676258993, y: 3.52941176470588, size: 1 },
    //     { x: 285.539568345324, y: 3.37254901960784, size: 1 },
    //     { x: 289.424460431655, y: 3.33333333333333, size: 1 },
    //     { x: 295.251798561151, y: 3.01960784313725, size: 1 },
    //     { x: 295.89928057554, y: 3.13725490196078, size: 1 },
    //     { x: 296.546762589928, y: 3.13725490196078, size: 1 },
    //     { x: 297.194244604317, y: 3.41176470588235, size: 1 },
    //     { x: 299.784172661871, y: 3.09803921568627, size: 1 },
    //     { x: 300.431654676259, y: 3.17647058823529, size: 1 },
    //     { x: 301.079136690647, y: 3.13725490196078, size: 1 },
    //     { x: 301.726618705036, y: 3.17647058823529, size: 1 },
    //     { x: 303.021582733813, y: 3.2156862745098, size: 1 },
    //     { x: 304.31654676259, y: 3.2156862745098, size: 1 },
    //     { x: 305.611510791367, y: 3.29411764705882, size: 1 },
    //     { x: 306.258992805755, y: 3.33333333333333, size: 1 },
    //     { x: 310.143884892086, y: 3.33333333333333, size: 1 },
    //     { x: 310.791366906475, y: 3.2156862745098, size: 1 },
    //     { x: 312.086330935252, y: 3.17647058823529, size: 1 },
    //     { x: 315.323741007194, y: 2.90196078431373, size: 1 },
    //     { x: 315.971223021583, y: 2.90196078431373, size: 1 },
    //     { x: 325.035971223022, y: 3.6078431372549, size: 1 },
    //     { x: 325.68345323741, y: 3.96078431372549, size: 1 },
    //     { x: 330.863309352518, y: 3.72549019607843, size: 1 },
    //     { x: 335.395683453237, y: 3.41176470588235, size: 1 },
    //     { x: 345.755395683453, y: 3.64705882352941, size: 1 },
    //     { x: 347.05035971223, y: 3.80392156862745, size: 1 },
    //     { x: 358.705035971223, y: 3.17647058823529, size: 1 },
    //     { x: 0.648648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 5.18918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 6.48648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 7.13513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 7.78378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 9.72972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 10.3783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 11.6756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 12.3243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 12.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 14.9189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 15.5675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 16.2162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 18.8108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 20.1081081081081, y: 3.01960784313725, size: 1 },
    //     { x: 20.7567567567568, y: 2.86274509803922, size: 1 },
    //     { x: 22.0540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 22.7027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 24.6486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 25.9459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 26.5945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 27.2432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 27.8918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 29.1891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 33.7297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 35.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 35.6756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 37.6216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 38.2702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 38.9189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 40.2162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 40.8648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 41.5135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 42.1621621621622, y: 2.86274509803922, size: 1 },
    //     { x: 42.8108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 43.4594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 45.4054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 46.0540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 48, y: 3.80392156862745, size: 1 },
    //     { x: 49.2972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 50.5945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 53.1891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 56.4324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 59.6756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 60.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 61.6216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 62.2702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 62.9189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 63.5675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 64.2162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 68.1081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 69.4054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 70.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 71.3513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 72, y: 3.76470588235294, size: 1 },
    //     { x: 73.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 75.8918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 77.1891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 78.4864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 79.1351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 79.7837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 80.4324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 81.0810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 82.3783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 83.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 83.6756756756757, y: 4, size: 1 },
    //     { x: 87.5675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 88.2162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 88.8648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 89.5135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 90.1621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 92.7567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 95.3513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 97.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 99.8918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 100.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 102.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 103.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 104.432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 107.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 107.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 108.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 109.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 110.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 112.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 114.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 115.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 116.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 116.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 118.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 119.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 121.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 121.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 124.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 125.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 126.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 127.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 128.432432432432, y: 2.98039215686275, size: 1 },
    //     { x: 129.081081081081, y: 2.70588235294118, size: 1 },
    //     { x: 131.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 131.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 132.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 134.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 135.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 136.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 137.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 140.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 142.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 143.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 144, y: 3.96078431372549, size: 1 },
    //     { x: 145.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 145.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 148.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 149.837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 150.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 151.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 155.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 156.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 158.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 160.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 161.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 164.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 165.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 166.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 168, y: 3.56862745098039, size: 1 },
    //     { x: 169.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 170.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 171.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 171.891891891892, y: 2.74509803921569, size: 1 },
    //     { x: 173.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 176.432432432432, y: 4, size: 1 },
    //     { x: 178.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 179.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 181.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 182.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 182.918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 183.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 184.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 185.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 193.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 193.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 195.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 197.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 198.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 201.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 202.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 203.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 204.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 205.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 208.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 208.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 210.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 211.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 213.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 214.702702702703, y: 2.90196078431373, size: 1 },
    //     { x: 215.351351351351, y: 2.47058823529412, size: 1 },
    //     { x: 216, y: 3.52941176470588, size: 1 },
    //     { x: 216.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 217.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 221.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 225.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 226.378378378378, y: 4, size: 1 },
    //     { x: 227.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 228.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 230.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 234.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 234.810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 236.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 238.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 239.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 240, y: 3.88235294117647, size: 1 },
    //     { x: 241.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 243.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 246.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 247.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 249.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 251.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 251.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 252.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 252.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 254.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 255.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 256.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 257.513513513513, y: 3.33333333333333, size: 1 },
    //     { x: 258.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 258.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 260.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 262.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 264, y: 3.37254901960784, size: 1 },
    //     { x: 264.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 265.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 266.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 268.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 269.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 271.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 271.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 272.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 273.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 273.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 274.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 275.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 279.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 280.216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 280.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 281.513513513513, y: 3.56862745098039, size: 1 },
    //     { x: 282.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 282.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 284.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 291.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 291.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 292.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 293.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 295.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 299.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 299.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 300.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 303.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 304.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 306.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 307.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 308.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 310.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 312, y: 3.45098039215686, size: 1 },
    //     { x: 314.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 317.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 319.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 320.432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 321.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 323.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 323.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 324.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 326.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 328.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 328.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 330.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 332.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 334.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 337.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 339.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 339.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 340.540540540541, y: 3.68627450980392, size: 1 },
    //     { x: 342.486486486487, y: 3.72549019607843, size: 1 },
    //     { x: 343.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 344.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 345.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 346.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 347.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 347.675675675676, y: 3.6078431372549, size: 1 },
    //     { x: 348.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 350.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 350.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 352.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 353.513513513513, y: 3.52941176470588, size: 1 },
    //     { x: 355.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 356.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 357.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 5.8273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 6.47482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 9.06474820143885, y: 3.68627450980392, size: 1 },
    //     { x: 11.0071942446043, y: 3.64705882352941, size: 1 },
    //     { x: 11.6546762589928, y: 3.84313725490196, size: 1 },
    //     { x: 18.1294964028777, y: 3.80392156862745, size: 1 },
    //     { x: 25.8992805755396, y: 3.41176470588235, size: 1 },
    //     { x: 26.5467625899281, y: 3.52941176470588, size: 1 },
    //     { x: 27.1942446043165, y: 3.29411764705882, size: 1 },
    //     { x: 27.841726618705, y: 2.50980392156863, size: 1 },
    //     { x: 28.4892086330935, y: 2.66666666666667, size: 1 },
    //     { x: 31.0791366906475, y: 3.33333333333333, size: 1 },
    //     { x: 34.9640287769784, y: 3.45098039215686, size: 1 },
    //     { x: 36.9064748201439, y: 3.49019607843137, size: 1 },
    //     { x: 38.8489208633094, y: 3.25490196078431, size: 1 },
    //     { x: 44.0287769784173, y: 3.41176470588235, size: 1 },
    //     { x: 58.9208633093525, y: 3.80392156862745, size: 1 },
    //     { x: 61.5107913669065, y: 3.6078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 3.37254901960784, size: 1 },
    //     { x: 69.9280575539568, y: 3.41176470588235, size: 1 },
    //     { x: 80.9352517985612, y: 3.96078431372549, size: 1 },
    //     { x: 86.1151079136691, y: 3.25490196078431, size: 1 },
    //     { x: 92.589928057554, y: 3.49019607843137, size: 1 },
    //     { x: 95.8273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 99.7122302158273, y: 3.92156862745098, size: 1 },
    //     { x: 101.007194244604, y: 3.80392156862745, size: 1 },
    //     { x: 103.597122302158, y: 3.84313725490196, size: 1 },
    //     { x: 107.482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 110.719424460432, y: 3.92156862745098, size: 1 },
    //     { x: 113.956834532374, y: 3.17647058823529, size: 1 },
    //     { x: 114.604316546763, y: 3.09803921568627, size: 1 },
    //     { x: 124.964028776978, y: 3.84313725490196, size: 1 },
    //     { x: 134.028776978417, y: 3.76470588235294, size: 1 },
    //     { x: 136.618705035971, y: 3.37254901960784, size: 1 },
    //     { x: 145.035971223022, y: 3.80392156862745, size: 1 },
    //     { x: 146.330935251799, y: 3.92156862745098, size: 1 },
    //     { x: 150.863309352518, y: 3.84313725490196, size: 1 },
    //     { x: 156.690647482014, y: 2.90196078431373, size: 1 },
    //     { x: 157.338129496403, y: 1.49019607843137, size: 1 },
    //     { x: 157.985611510791, y: 1.6078431372549, size: 1 },
    //     { x: 158.63309352518, y: 1.56862745098039, size: 1 },
    //     { x: 159.280575539568, y: 1.64705882352941, size: 1 },
    //     { x: 159.928057553957, y: 3.33333333333333, size: 1 },
    //     { x: 161.223021582734, y: 3.41176470588235, size: 1 },
    //     { x: 161.870503597122, y: 3.13725490196078, size: 1 },
    //     { x: 162.517985611511, y: 3.13725490196078, size: 1 },
    //     { x: 166.402877697842, y: 2.98039215686275, size: 1 },
    //     { x: 167.05035971223, y: 2.94117647058824, size: 1 },
    //     { x: 172.877697841727, y: 2.7843137254902, size: 1 },
    //     { x: 174.820143884892, y: 3.41176470588235, size: 1 },
    //     { x: 176.762589928058, y: 3.25490196078431, size: 1 },
    //     { x: 177.410071942446, y: 3.09803921568627, size: 1 },
    //     { x: 178.057553956835, y: 3.09803921568627, size: 1 },
    //     { x: 178.705035971223, y: 2.66666666666667, size: 1 },
    //     { x: 179.352517985612, y: 1.49019607843137, size: 1 },
    //     { x: 180, y: 3.84313725490196, size: 1 },
    //     { x: 183.237410071942, y: 3.92156862745098, size: 1 },
    //     { x: 183.884892086331, y: 3.76470588235294, size: 1 },
    //     { x: 192.302158273381, y: 3.68627450980392, size: 1 },
    //     { x: 198.776978417266, y: 3.17647058823529, size: 1 },
    //     { x: 199.424460431655, y: 3.37254901960784, size: 1 },
    //     { x: 200.071942446043, y: 3.05882352941176, size: 1 },
    //     { x: 200.719424460432, y: 2.70588235294118, size: 1 },
    //     { x: 201.36690647482, y: 3.2156862745098, size: 1 },
    //     { x: 207.841726618705, y: 3.49019607843137, size: 1 },
    //     { x: 211.726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 216.258992805755, y: 3.49019607843137, size: 1 },
    //     { x: 221.438848920863, y: 3.05882352941176, size: 1 },
    //     { x: 222.086330935252, y: 2.7843137254902, size: 1 },
    //     { x: 222.73381294964, y: 2.70588235294118, size: 1 },
    //     { x: 224.676258992806, y: 3.29411764705882, size: 1 },
    //     { x: 228.561151079137, y: 3.64705882352941, size: 1 },
    //     { x: 234.388489208633, y: 3.45098039215686, size: 1 },
    //     { x: 242.158273381295, y: 3.13725490196078, size: 1 },
    //     { x: 242.805755395683, y: 3.25490196078431, size: 1 },
    //     { x: 243.453237410072, y: 2.3921568627451, size: 1 },
    //     { x: 244.10071942446, y: 2.27450980392157, size: 1 },
    //     { x: 244.748201438849, y: 3.41176470588235, size: 1 },
    //     { x: 245.395683453237, y: 3.25490196078431, size: 1 },
    //     { x: 246.043165467626, y: 3.37254901960784, size: 1 },
    //     { x: 247.338129496403, y: 3.29411764705882, size: 1 },
    //     { x: 248.63309352518, y: 3.29411764705882, size: 1 },
    //     { x: 249.928057553957, y: 3.33333333333333, size: 1 },
    //     { x: 251.223021582734, y: 3.33333333333333, size: 1 },
    //     { x: 252.517985611511, y: 3.29411764705882, size: 1 },
    //     { x: 256.402877697842, y: 3.37254901960784, size: 1 },
    //     { x: 262.877697841727, y: 3.49019607843137, size: 1 },
    //     { x: 263.525179856115, y: 3.09803921568627, size: 1 },
    //     { x: 264.172661870504, y: 3.13725490196078, size: 1 },
    //     { x: 264.820143884892, y: 2.90196078431373, size: 1 },
    //     { x: 265.467625899281, y: 1.96078431372549, size: 1 },
    //     { x: 268.057553956835, y: 3.88235294117647, size: 1 },
    //     { x: 298.489208633094, y: 3.92156862745098, size: 1 },
    //     { x: 301.079136690647, y: 3.52941176470588, size: 1 },
    //     { x: 303.021582733813, y: 3.92156862745098, size: 1 },
    //     { x: 303.669064748201, y: 3.49019607843137, size: 1 },
    //     { x: 308.848920863309, y: 3.80392156862745, size: 1 },
    //     { x: 312.086330935252, y: 3.52941176470588, size: 1 },
    //     { x: 320.503597122302, y: 4.03921568627451, size: 1 },
    //     { x: 323.741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 325.68345323741, y: 3.76470588235294, size: 1 },
    //     { x: 326.978417266187, y: 3.88235294117647, size: 1 },
    //     { x: 328.273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 331.510791366906, y: 3.80392156862745, size: 1 },
    //     { x: 337.985611510791, y: 3.25490196078431, size: 1 },
    //     { x: 339.280575539568, y: 3.45098039215686, size: 1 },
    //     { x: 340.575539568345, y: 3.33333333333333, size: 1 },
    //     { x: 342.517985611511, y: 3.49019607843137, size: 1 },
    //     { x: 350.287769784173, y: 3.37254901960784, size: 1 },
    //     { x: 351.58273381295, y: 3.80392156862745, size: 1 },
    //     { x: 354.820143884892, y: 3.80392156862745, size: 1 },
    //     { x: 356.115107913669, y: 3.80392156862745, size: 1 },
    //     { x: 4.53237410071942, y: 3.84313725490196, size: 1 },
    //     { x: 7.76978417266187, y: 3.80392156862745, size: 1 },
    //     { x: 16.1870503597122, y: 4.11764705882353, size: 1 },
    //     { x: 18.1294964028777, y: 3.92156862745098, size: 1 },
    //     { x: 29.136690647482, y: 3.84313725490196, size: 1 },
    //     { x: 31.726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 33.0215827338129, y: 3.2156862745098, size: 1 },
    //     { x: 33.6690647482014, y: 3.2156862745098, size: 1 },
    //     { x: 34.3165467625899, y: 3.17647058823529, size: 1 },
    //     { x: 34.9640287769784, y: 2.70588235294118, size: 1 },
    //     { x: 36.9064748201439, y: 3.72549019607843, size: 1 },
    //     { x: 41.4388489208633, y: 3.88235294117647, size: 1 },
    //     { x: 43.3812949640288, y: 3.84313725490196, size: 1 },
    //     { x: 63.4532374100719, y: 3.49019607843137, size: 1 },
    //     { x: 64.1007194244604, y: 3.37254901960784, size: 1 },
    //     { x: 67.3381294964029, y: 3.37254901960784, size: 1 },
    //     { x: 69.2805755395683, y: 3.45098039215686, size: 1 },
    //     { x: 74.4604316546763, y: 3.37254901960784, size: 1 },
    //     { x: 77.0503597122302, y: 3.56862745098039, size: 1 },
    //     { x: 86.1151079136691, y: 3.68627450980392, size: 1 },
    //     { x: 87.410071942446, y: 3.88235294117647, size: 1 },
    //     { x: 96.4748201438849, y: 3.68627450980392, size: 1 },
    //     { x: 104.892086330935, y: 3.76470588235294, size: 1 },
    //     { x: 106.187050359712, y: 3.76470588235294, size: 1 },
    //     { x: 108.129496402878, y: 3.52941176470588, size: 1 },
    //     { x: 117.841726618705, y: 3.84313725490196, size: 1 },
    //     { x: 132.086330935252, y: 3.68627450980392, size: 1 },
    //     { x: 140.503597122302, y: 3.80392156862745, size: 1 },
    //     { x: 141.151079136691, y: 3.80392156862745, size: 1 },
    //     { x: 151.510791366906, y: 3.92156862745098, size: 1 },
    //     { x: 152.805755395683, y: 3.64705882352941, size: 1 },
    //     { x: 161.223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 168.992805755396, y: 3.45098039215686, size: 1 },
    //     { x: 170.287769784173, y: 3.37254901960784, size: 1 },
    //     { x: 172.230215827338, y: 3.37254901960784, size: 1 },
    //     { x: 174.172661870504, y: 3.72549019607843, size: 1 },
    //     { x: 174.820143884892, y: 3.37254901960784, size: 1 },
    //     { x: 176.115107913669, y: 3.33333333333333, size: 1 },
    //     { x: 178.057553956835, y: 3.45098039215686, size: 1 },
    //     { x: 179.352517985612, y: 3.33333333333333, size: 1 },
    //     { x: 180.647482014388, y: 3.76470588235294, size: 1 },
    //     { x: 185.179856115108, y: 3.09803921568627, size: 1 },
    //     { x: 185.827338129496, y: 2.7843137254902, size: 1 },
    //     { x: 186.474820143885, y: 2.66666666666667, size: 1 },
    //     { x: 187.122302158273, y: 3.01960784313725, size: 1 },
    //     { x: 187.769784172662, y: 3.09803921568627, size: 1 },
    //     { x: 192.302158273381, y: 3.41176470588235, size: 1 },
    //     { x: 194.892086330935, y: 3.45098039215686, size: 1 },
    //     { x: 195.539568345324, y: 3.80392156862745, size: 1 },
    //     { x: 196.834532374101, y: 3.84313725490196, size: 1 },
    //     { x: 201.36690647482, y: 3.84313725490196, size: 1 },
    //     { x: 203.309352517986, y: 3.80392156862745, size: 1 },
    //     { x: 207.194244604317, y: 3.09803921568627, size: 1 },
    //     { x: 207.841726618705, y: 2.94117647058824, size: 1 },
    //     { x: 208.489208633094, y: 2.62745098039216, size: 1 },
    //     { x: 209.136690647482, y: 2.86274509803922, size: 1 },
    //     { x: 209.784172661871, y: 3.17647058823529, size: 1 },
    //     { x: 211.726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 213.669064748201, y: 3.84313725490196, size: 1 },
    //     { x: 218.201438848921, y: 3.33333333333333, size: 1 },
    //     { x: 222.086330935252, y: 3.64705882352941, size: 1 },
    //     { x: 229.856115107914, y: 3.92156862745098, size: 1 },
    //     { x: 241.510791366906, y: 3.92156862745098, size: 1 },
    //     { x: 248.63309352518, y: 3.88235294117647, size: 1 },
    //     { x: 249.928057553957, y: 3.29411764705882, size: 1 },
    //     { x: 250.575539568345, y: 2.98039215686275, size: 1 },
    //     { x: 251.223021582734, y: 3.05882352941176, size: 1 },
    //     { x: 258.345323741007, y: 3.72549019607843, size: 1 },
    //     { x: 271.294964028777, y: 3.45098039215686, size: 1 },
    //     { x: 271.942446043165, y: 3.05882352941176, size: 1 },
    //     { x: 273.237410071942, y: 3.45098039215686, size: 1 },
    //     { x: 290.071942446043, y: 3.33333333333333, size: 1 },
    //     { x: 291.36690647482, y: 3.41176470588235, size: 1 },
    //     { x: 292.661870503597, y: 3.41176470588235, size: 1 },
    //     { x: 293.956834532374, y: 2.7843137254902, size: 1 },
    //     { x: 295.251798561151, y: 3.80392156862745, size: 1 },
    //     { x: 295.89928057554, y: 4.11764705882353, size: 1 },
    //     { x: 301.726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 307.553956834532, y: 4.11764705882353, size: 1 },
    //     { x: 308.848920863309, y: 3.92156862745098, size: 1 },
    //     { x: 310.143884892086, y: 3.96078431372549, size: 1 },
    //     { x: 311.438848920863, y: 4.03921568627451, size: 1 },
    //     { x: 315.323741007194, y: 3.25490196078431, size: 1 },
    //     { x: 315.971223021583, y: 3.17647058823529, size: 1 },
    //     { x: 326.978417266187, y: 3.49019607843137, size: 1 },
    //     { x: 328.273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 339.928057553957, y: 3.92156862745098, size: 1 },
    //     { x: 350.935251798561, y: 3.76470588235294, size: 1 },
    //     { x: 358.057553956835, y: 3.29411764705882, size: 1 },
    //     { x: 0, y: 3.88235294117647, size: 1 },
    //     { x: 12.3021582733813, y: 3.68627450980392, size: 1 },
    //     { x: 13.5971223021583, y: 3.92156862745098, size: 1 },
    //     { x: 18.1294964028777, y: 3.45098039215686, size: 1 },
    //     { x: 20.7194244604317, y: 3.25490196078431, size: 1 },
    //     { x: 21.3669064748201, y: 3.56862745098039, size: 1 },
    //     { x: 22.0143884892086, y: 3.37254901960784, size: 1 },
    //     { x: 25.2517985611511, y: 3.92156862745098, size: 1 },
    //     { x: 27.841726618705, y: 3.45098039215686, size: 1 },
    //     { x: 31.0791366906475, y: 3.52941176470588, size: 1 },
    //     { x: 34.9640287769784, y: 3.92156862745098, size: 1 },
    //     { x: 36.2589928057554, y: 3.88235294117647, size: 1 },
    //     { x: 38.2014388489209, y: 3.49019607843137, size: 1 },
    //     { x: 47.9136690647482, y: 3.76470588235294, size: 1 },
    //     { x: 50.5035971223022, y: 3.49019607843137, size: 1 },
    //     { x: 53.0935251798561, y: 3.84313725490196, size: 1 },
    //     { x: 55.0359712230216, y: 3.76470588235294, size: 1 },
    //     { x: 57.6258992805755, y: 3.52941176470588, size: 1 },
    //     { x: 59.568345323741, y: 3.92156862745098, size: 1 },
    //     { x: 63.4532374100719, y: 3.17647058823529, size: 1 },
    //     { x: 77.6978417266187, y: 3.84313725490196, size: 1 },
    //     { x: 79.6402877697842, y: 3.41176470588235, size: 1 },
    //     { x: 95.8273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 102.94964028777, y: 4, size: 1 },
    //     { x: 117.194244604317, y: 3.88235294117647, size: 1 },
    //     { x: 122.374100719424, y: 3.80392156862745, size: 1 },
    //     { x: 128.848920863309, y: 3.17647058823529, size: 1 },
    //     { x: 129.496402877698, y: 2.90196078431373, size: 1 },
    //     { x: 131.438848920863, y: 3.37254901960784, size: 1 },
    //     { x: 143.741007194245, y: 3.80392156862745, size: 1 },
    //     { x: 144.388489208633, y: 3.45098039215686, size: 1 },
    //     { x: 149.568345323741, y: 3.05882352941176, size: 1 },
    //     { x: 151.510791366906, y: 3.05882352941176, size: 1 },
    //     { x: 156.690647482014, y: 3.80392156862745, size: 1 },
    //     { x: 157.985611510791, y: 3.84313725490196, size: 1 },
    //     { x: 158.63309352518, y: 3.56862745098039, size: 1 },
    //     { x: 161.223021582734, y: 3.49019607843137, size: 1 },
    //     { x: 163.812949640288, y: 3.88235294117647, size: 1 },
    //     { x: 165.755395683453, y: 4.03921568627451, size: 1 },
    //     { x: 168.992805755396, y: 3.37254901960784, size: 1 },
    //     { x: 169.640287769784, y: 3.25490196078431, size: 1 },
    //     { x: 170.287769784173, y: 3.17647058823529, size: 1 },
    //     { x: 170.935251798561, y: 2.3921568627451, size: 1 },
    //     { x: 171.58273381295, y: 2.66666666666667, size: 1 },
    //     { x: 172.230215827338, y: 2.7843137254902, size: 1 },
    //     { x: 172.877697841727, y: 2.82352941176471, size: 1 },
    //     { x: 181.294964028777, y: 3.72549019607843, size: 1 },
    //     { x: 184.532374100719, y: 3.6078431372549, size: 1 },
    //     { x: 186.474820143885, y: 3.76470588235294, size: 1 },
    //     { x: 191.007194244604, y: 3.25490196078431, size: 1 },
    //     { x: 196.187050359712, y: 3.92156862745098, size: 1 },
    //     { x: 198.129496402878, y: 3.92156862745098, size: 1 },
    //     { x: 202.014388489209, y: 3.92156862745098, size: 1 },
    //     { x: 209.784172661871, y: 3.84313725490196, size: 1 },
    //     { x: 211.726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 213.669064748201, y: 3.29411764705882, size: 1 },
    //     { x: 214.31654676259, y: 2.47058823529412, size: 1 },
    //     { x: 214.964028776978, y: 2.7843137254902, size: 1 },
    //     { x: 225.971223021583, y: 3.88235294117647, size: 1 },
    //     { x: 229.208633093525, y: 3.68627450980392, size: 1 },
    //     { x: 230.503597122302, y: 3.80392156862745, size: 1 },
    //     { x: 231.798561151079, y: 3.56862745098039, size: 1 },
    //     { x: 235.68345323741, y: 3.2156862745098, size: 1 },
    //     { x: 236.330935251799, y: 3.29411764705882, size: 1 },
    //     { x: 237.625899280576, y: 3.80392156862745, size: 1 },
    //     { x: 253.165467625899, y: 3.37254901960784, size: 1 },
    //     { x: 277.122302158273, y: 3.33333333333333, size: 1 },
    //     { x: 277.769784172662, y: 3.29411764705882, size: 1 },
    //     { x: 279.064748201439, y: 2.82352941176471, size: 1 },
    //     { x: 279.712230215827, y: 2.70588235294118, size: 1 },
    //     { x: 280.359712230216, y: 3.52941176470588, size: 1 },
    //     { x: 281.654676258993, y: 3.37254901960784, size: 1 },
    //     { x: 284.244604316547, y: 3.56862745098039, size: 1 },
    //     { x: 286.834532374101, y: 3.33333333333333, size: 1 },
    //     { x: 288.776978417266, y: 3.33333333333333, size: 1 },
    //     { x: 292.014388489209, y: 3.2156862745098, size: 1 },
    //     { x: 295.89928057554, y: 3.33333333333333, size: 1 },
    //     { x: 296.546762589928, y: 3.2156862745098, size: 1 },
    //     { x: 297.194244604317, y: 3.37254901960784, size: 1 },
    //     { x: 300.431654676259, y: 3.09803921568627, size: 1 },
    //     { x: 304.31654676259, y: 3.80392156862745, size: 1 },
    //     { x: 310.143884892086, y: 3.80392156862745, size: 1 },
    //     { x: 322.446043165468, y: 2.98039215686275, size: 1 },
    //     { x: 327.625899280576, y: 3.92156862745098, size: 1 },
    //     { x: 332.158273381295, y: 3.76470588235294, size: 1 },
    //     { x: 335.395683453237, y: 3.92156862745098, size: 1 },
    //     { x: 343.165467625899, y: 3.09803921568627, size: 1 },
    //     { x: 343.812949640288, y: 2.86274509803922, size: 1 },
    //     { x: 344.460431654676, y: 2.58823529411765, size: 1 },
    //     { x: 351.58273381295, y: 4, size: 1 },
    //     { x: 354.172661870504, y: 3.84313725490196, size: 1 },
    //     { x: 359.352517985611, y: 3.84313725490196, size: 1 },
    //     { x: 1.2972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 5.18918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 5.83783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 9.08108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 9.72972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 12.3243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 12.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 13.6216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 14.2702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 18.1621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 18.8108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 19.4594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 20.1081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 20.7567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 21.4054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 22.7027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 25.9459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 26.5945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 27.2432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 27.8918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 31.1351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 31.7837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 33.0810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 34.3783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 35.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 36.3243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 36.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 40.2162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 41.5135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 42.1621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 44.7567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 45.4054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 46.0540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 47.3513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 48.6486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 49.2972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 50.5945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 51.2432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 52.5405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 54.4864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 60.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 63.5675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 64.2162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 64.8648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 66.1621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 70.054054054054, y: 2.82352941176471, size: 1 },
    //     { x: 70.7027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 71.3513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 72.6486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 73.2972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 73.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 75.2432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 75.8918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 79.7837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 82.3783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 84.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 88.8648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 90.1621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 90.8108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 92.7567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 94.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 94.7027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 95.3513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 96, y: 3.45098039215686, size: 1 },
    //     { x: 98.5945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 101.837837837838, y: 4, size: 1 },
    //     { x: 105.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 107.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 108.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 109.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 111.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 112.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 112.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 113.513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 114.162162162162, y: 2.86274509803922, size: 1 },
    //     { x: 114.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 115.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 117.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 118.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 119.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 120, y: 3.56862745098039, size: 1 },
    //     { x: 120.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 121.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 123.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 125.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 127.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 127.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 128.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 130.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 132.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 132.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 133.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 134.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 134.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 135.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 137.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 138.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 138.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 140.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 142.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 142.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 145.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 145.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 147.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 147.891891891892, y: 3.6078431372549, size: 1 },
    //     { x: 149.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 149.837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 150.486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 152.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 154.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 156.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 156.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 157.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 158.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 160.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 162.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 162.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 164.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 164.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 167.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 168.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 170.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 173.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 173.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 175.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 175.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 176.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 177.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 178.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 179.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 180.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 180.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 182.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 186.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 186.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 187.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 188.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 190.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 192.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 193.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 193.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 195.243243243243, y: 4, size: 1 },
    //     { x: 196.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 197.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 198.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 199.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 199.783783783784, y: 2.74509803921569, size: 1 },
    //     { x: 200.432432432432, y: 2.62745098039216, size: 1 },
    //     { x: 201.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 203.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 204.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 205.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 207.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 208.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 208.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 209.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 214.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 215.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 216, y: 3.88235294117647, size: 1 },
    //     { x: 217.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 218.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 223.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 227.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 228.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 230.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 231.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 233.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 234.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 235.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 237.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 238.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 239.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 242.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 243.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 243.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 245.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 247.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 249.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 251.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 252.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 254.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 256.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 262.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 262.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 263.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 264.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 265.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 269.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 272.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 275.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 278.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 278.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 279.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 280.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 280.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 282.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 282.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 284.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 286.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 286.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 287.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 288.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 289.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 291.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 292.540540540541, y: 3.64705882352941, size: 1 },
    //     { x: 293.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 293.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 297.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 298.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 300.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 302.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 303.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 304.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 304.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 308.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 308.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 311.351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 312.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 313.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 313.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 314.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 315.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 317.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 319.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 319.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 320.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 321.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 323.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 326.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 327.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 328.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 329.513513513513, y: 3.17647058823529, size: 1 },
    //     { x: 330.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 332.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 334.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 335.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 336, y: 3.52941176470588, size: 1 },
    //     { x: 337.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 339.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 339.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 340.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 341.189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 341.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 343.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 344.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 345.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 346.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 348.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 348.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 349.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 350.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 351.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 352.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 353.513513513513, y: 3.68627450980392, size: 1 },
    //     { x: 358.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 359.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 13.5971223021583, y: 3.17647058823529, size: 1 },
    //     { x: 21.3669064748201, y: 3.64705882352941, size: 1 },
    //     { x: 33.0215827338129, y: 3.13725490196078, size: 1 },
    //     { x: 34.3165467625899, y: 3.01960784313725, size: 1 },
    //     { x: 50.5035971223022, y: 3.72549019607843, size: 1 },
    //     { x: 52.4460431654676, y: 4.03921568627451, size: 1 },
    //     { x: 53.7410071942446, y: 3.68627450980392, size: 1 },
    //     { x: 55.6834532374101, y: 3.13725490196078, size: 1 },
    //     { x: 56.3309352517986, y: 2.98039215686275, size: 1 },
    //     { x: 59.568345323741, y: 4.03921568627451, size: 1 },
    //     { x: 65.3956834532374, y: 3.84313725490196, size: 1 },
    //     { x: 77.6978417266187, y: 2.86274509803922, size: 1 },
    //     { x: 78.3453237410072, y: 2.66666666666667, size: 1 },
    //     { x: 99.0647482014388, y: 3.33333333333333, size: 1 },
    //     { x: 100.359712230216, y: 3.88235294117647, size: 1 },
    //     { x: 101.007194244604, y: 3.84313725490196, size: 1 },
    //     { x: 108.776978417266, y: 3.88235294117647, size: 1 },
    //     { x: 114.604316546763, y: 3.96078431372549, size: 1 },
    //     { x: 116.546762589928, y: 3.64705882352941, size: 1 },
    //     { x: 119.784172661871, y: 3.37254901960784, size: 1 },
    //     { x: 120.431654676259, y: 3.41176470588235, size: 1 },
    //     { x: 121.079136690647, y: 3.01960784313725, size: 1 },
    //     { x: 125.611510791367, y: 3.80392156862745, size: 1 },
    //     { x: 128.201438848921, y: 3.41176470588235, size: 1 },
    //     { x: 137.913669064748, y: 3.88235294117647, size: 1 },
    //     { x: 141.151079136691, y: 3.25490196078431, size: 1 },
    //     { x: 142.446043165468, y: 2.3921568627451, size: 1 },
    //     { x: 143.093525179856, y: 2.54901960784314, size: 1 },
    //     { x: 148.273381294964, y: 4.03921568627451, size: 1 },
    //     { x: 148.920863309353, y: 3.96078431372549, size: 1 },
    //     { x: 150.215827338129, y: 3.88235294117647, size: 1 },
    //     { x: 150.863309352518, y: 3.80392156862745, size: 1 },
    //     { x: 152.805755395683, y: 3.88235294117647, size: 1 },
    //     { x: 155.395683453237, y: 4.07843137254902, size: 1 },
    //     { x: 156.043165467626, y: 3.92156862745098, size: 1 },
    //     { x: 157.338129496403, y: 4.07843137254902, size: 1 },
    //     { x: 159.280575539568, y: 4.03921568627451, size: 1 },
    //     { x: 159.928057553957, y: 3.92156862745098, size: 1 },
    //     { x: 160.575539568345, y: 3.84313725490196, size: 1 },
    //     { x: 163.165467625899, y: 3.25490196078431, size: 1 },
    //     { x: 163.812949640288, y: 3.09803921568627, size: 1 },
    //     { x: 164.460431654676, y: 3.01960784313725, size: 1 },
    //     { x: 167.05035971223, y: 3.76470588235294, size: 1 },
    //     { x: 171.58273381295, y: 3.96078431372549, size: 1 },
    //     { x: 172.230215827338, y: 3.72549019607843, size: 1 },
    //     { x: 185.179856115108, y: 3.33333333333333, size: 1 },
    //     { x: 186.474820143885, y: 3.84313725490196, size: 1 },
    //     { x: 201.36690647482, y: 3.92156862745098, size: 1 },
    //     { x: 206.546762589928, y: 3.29411764705882, size: 1 },
    //     { x: 207.194244604317, y: 2.27450980392157, size: 1 },
    //     { x: 207.841726618705, y: 2.50980392156863, size: 1 },
    //     { x: 210.431654676259, y: 4.03921568627451, size: 1 },
    //     { x: 211.726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 212.374100719424, y: 3.88235294117647, size: 1 },
    //     { x: 213.021582733813, y: 4.31372549019608, size: 1 },
    //     { x: 213.669064748201, y: 4.03921568627451, size: 1 },
    //     { x: 214.31654676259, y: 4, size: 1 },
    //     { x: 214.964028776978, y: 3.92156862745098, size: 1 },
    //     { x: 215.611510791367, y: 3.92156862745098, size: 1 },
    //     { x: 216.906474820144, y: 3.92156862745098, size: 1 },
    //     { x: 218.201438848921, y: 3.92156862745098, size: 1 },
    //     { x: 218.848920863309, y: 4, size: 1 },
    //     { x: 219.496402877698, y: 4.23529411764706, size: 1 },
    //     { x: 220.791366906475, y: 3.88235294117647, size: 1 },
    //     { x: 222.086330935252, y: 4.19607843137255, size: 1 },
    //     { x: 222.73381294964, y: 3.80392156862745, size: 1 },
    //     { x: 223.381294964029, y: 3.84313725490196, size: 1 },
    //     { x: 224.028776978417, y: 3.96078431372549, size: 1 },
    //     { x: 224.676258992806, y: 3.92156862745098, size: 1 },
    //     { x: 225.323741007194, y: 4.07843137254902, size: 1 },
    //     { x: 225.971223021583, y: 3.96078431372549, size: 1 },
    //     { x: 226.618705035971, y: 3.88235294117647, size: 1 },
    //     { x: 227.26618705036, y: 3.72549019607843, size: 1 },
    //     { x: 231.151079136691, y: 3.92156862745098, size: 1 },
    //     { x: 233.741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 235.035971223022, y: 4.11764705882353, size: 1 },
    //     { x: 235.68345323741, y: 4.11764705882353, size: 1 },
    //     { x: 236.330935251799, y: 4.07843137254902, size: 1 },
    //     { x: 238.920863309353, y: 4.03921568627451, size: 1 },
    //     { x: 240.215827338129, y: 3.68627450980392, size: 1 },
    //     { x: 248.63309352518, y: 3.33333333333333, size: 1 },
    //     { x: 250.575539568345, y: 3.25490196078431, size: 1 },
    //     { x: 259.640287769784, y: 3.92156862745098, size: 1 },
    //     { x: 260.287769784173, y: 3.88235294117647, size: 1 },
    //     { x: 261.58273381295, y: 3.52941176470588, size: 1 },
    //     { x: 267.410071942446, y: 3.92156862745098, size: 1 },
    //     { x: 271.294964028777, y: 3.09803921568627, size: 1 },
    //     { x: 271.942446043165, y: 2.70588235294118, size: 1 },
    //     { x: 272.589928057554, y: 2.66666666666667, size: 1 },
    //     { x: 279.064748201439, y: 4, size: 1 },
    //     { x: 293.309352517986, y: 3.09803921568627, size: 1 },
    //     { x: 293.956834532374, y: 3.2156862745098, size: 1 },
    //     { x: 306.258992805755, y: 3.96078431372549, size: 1 },
    //     { x: 314.676258992806, y: 3.13725490196078, size: 1 },
    //     { x: 315.323741007194, y: 3.13725490196078, size: 1 },
    //     { x: 315.971223021583, y: 3.25490196078431, size: 1 },
    //     { x: 332.805755395683, y: 3.45098039215686, size: 1 },
    //     { x: 339.928057553957, y: 3.68627450980392, size: 1 },
    //     { x: 356.762589928058, y: 3.41176470588235, size: 1 },
    //     { x: 358.705035971223, y: 3.25490196078431, size: 1 },
    //     { x: 9.06474820143885, y: 3.76470588235294, size: 1 },
    //     { x: 11.6546762589928, y: 3.33333333333333, size: 1 },
    //     { x: 14.2446043165468, y: 4, size: 1 },
    //     { x: 19.4244604316547, y: 3.45098039215686, size: 1 },
    //     { x: 20.0719424460432, y: 3.29411764705882, size: 1 },
    //     { x: 24.6043165467626, y: 3.84313725490196, size: 1 },
    //     { x: 29.7841726618705, y: 3.76470588235294, size: 1 },
    //     { x: 38.2014388489209, y: 3.52941176470588, size: 1 },
    //     { x: 41.4388489208633, y: 3.25490196078431, size: 1 },
    //     { x: 45.9712230215827, y: 3.96078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 3.96078431372549, size: 1 },
    //     { x: 49.8561151079137, y: 4.15686274509804, size: 1 },
    //     { x: 55.0359712230216, y: 3.84313725490196, size: 1 },
    //     { x: 62.8057553956835, y: 2.82352941176471, size: 1 },
    //     { x: 63.4532374100719, y: 3.09803921568627, size: 1 },
    //     { x: 64.7482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 83.5251798561151, y: 3.09803921568627, size: 1 },
    //     { x: 84.1726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 85.4676258992806, y: 3.2156862745098, size: 1 },
    //     { x: 102.302158273381, y: 3.41176470588235, size: 1 },
    //     { x: 102.94964028777, y: 3.33333333333333, size: 1 },
    //     { x: 103.597122302158, y: 3.49019607843137, size: 1 },
    //     { x: 106.187050359712, y: 2.86274509803922, size: 1 },
    //     { x: 106.834532374101, y: 2.50980392156863, size: 1 },
    //     { x: 107.482014388489, y: 3.49019607843137, size: 1 },
    //     { x: 115.89928057554, y: 3.80392156862745, size: 1 },
    //     { x: 117.194244604317, y: 3.41176470588235, size: 1 },
    //     { x: 127.553956834532, y: 2.62745098039216, size: 1 },
    //     { x: 128.201438848921, y: 2.35294117647059, size: 1 },
    //     { x: 128.848920863309, y: 3.49019607843137, size: 1 },
    //     { x: 135.971223021583, y: 3.84313725490196, size: 1 },
    //     { x: 143.093525179856, y: 3.80392156862745, size: 1 },
    //     { x: 148.920863309353, y: 3.88235294117647, size: 1 },
    //     { x: 149.568345323741, y: 2.94117647058824, size: 1 },
    //     { x: 154.10071942446, y: 3.76470588235294, size: 1 },
    //     { x: 159.280575539568, y: 3.88235294117647, size: 1 },
    //     { x: 169.640287769784, y: 3.37254901960784, size: 1 },
    //     { x: 172.230215827338, y: 3.41176470588235, size: 1 },
    //     { x: 181.942446043165, y: 3.88235294117647, size: 1 },
    //     { x: 191.007194244604, y: 3.13725490196078, size: 1 },
    //     { x: 191.654676258993, y: 3.09803921568627, size: 1 },
    //     { x: 192.302158273381, y: 2.66666666666667, size: 1 },
    //     { x: 192.94964028777, y: 1.76470588235294, size: 1 },
    //     { x: 194.892086330935, y: 4, size: 1 },
    //     { x: 198.129496402878, y: 3.6078431372549, size: 1 },
    //     { x: 202.014388489209, y: 3.76470588235294, size: 1 },
    //     { x: 203.309352517986, y: 3.88235294117647, size: 1 },
    //     { x: 206.546762589928, y: 3.56862745098039, size: 1 },
    //     { x: 218.201438848921, y: 3.76470588235294, size: 1 },
    //     { x: 232.446043165468, y: 3.80392156862745, size: 1 },
    //     { x: 257.05035971223, y: 3.41176470588235, size: 1 },
    //     { x: 270, y: 3.76470588235294, size: 1 },
    //     { x: 277.769784172662, y: 3.13725490196078, size: 1 },
    //     { x: 279.064748201439, y: 3.80392156862745, size: 1 },
    //     { x: 281.007194244604, y: 3.37254901960784, size: 1 },
    //     { x: 290.719424460432, y: 3.25490196078431, size: 1 },
    //     { x: 292.014388489209, y: 3.52941176470588, size: 1 },
    //     { x: 293.956834532374, y: 3.84313725490196, size: 1 },
    //     { x: 296.546762589928, y: 3.41176470588235, size: 1 },
    //     { x: 303.021582733813, y: 3.76470588235294, size: 1 },
    //     { x: 308.848920863309, y: 3.88235294117647, size: 1 },
    //     { x: 315.323741007194, y: 3.68627450980392, size: 1 },
    //     { x: 319.856115107914, y: 3.56862745098039, size: 1 },
    //     { x: 320.503597122302, y: 3.25490196078431, size: 1 },
    //     { x: 321.151079136691, y: 3.13725490196078, size: 1 },
    //     { x: 321.798561151079, y: 2.86274509803922, size: 1 },
    //     { x: 322.446043165468, y: 2.58823529411765, size: 1 },
    //     { x: 331.510791366906, y: 3.92156862745098, size: 1 },
    //     { x: 333.453237410072, y: 3.84313725490196, size: 1 },
    //     { x: 334.10071942446, y: 3.92156862745098, size: 1 },
    //     { x: 334.748201438849, y: 3.96078431372549, size: 1 },
    //     { x: 336.043165467626, y: 3.6078431372549, size: 1 },
    //     { x: 339.928057553957, y: 3.80392156862745, size: 1 },
    //     { x: 343.812949640288, y: 3.80392156862745, size: 1 },
    //     { x: 344.460431654676, y: 3.56862745098039, size: 1 },
    //     { x: 350.935251798561, y: 3.33333333333333, size: 1 },
    //     { x: 352.230215827338, y: 3.41176470588235, size: 1 },
    //     { x: 354.820143884892, y: 3.41176470588235, size: 1 },
    //     { x: 358.057553956835, y: 3.37254901960784, size: 1 },
    //     { x: 1.29496402877698, y: 3.41176470588235, size: 1 },
    //     { x: 4.53237410071942, y: 3.25490196078431, size: 1 },
    //     { x: 5.8273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 18.7769784172662, y: 3.6078431372549, size: 1 },
    //     { x: 35.6115107913669, y: 3.56862745098039, size: 1 },
    //     { x: 42.7338129496403, y: 4.03921568627451, size: 1 },
    //     { x: 58.273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 60.863309352518, y: 3.88235294117647, size: 1 },
    //     { x: 95.8273381294964, y: 3.64705882352941, size: 1 },
    //     { x: 97.1223021582734, y: 3.96078431372549, size: 1 },
    //     { x: 104.892086330935, y: 3.96078431372549, size: 1 },
    //     { x: 113.956834532374, y: 3.33333333333333, size: 1 },
    //     { x: 117.194244604317, y: 3.96078431372549, size: 1 },
    //     { x: 127.553956834532, y: 3.92156862745098, size: 1 },
    //     { x: 134.676258992806, y: 3.37254901960784, size: 1 },
    //     { x: 148.273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 154.10071942446, y: 3.45098039215686, size: 1 },
    //     { x: 155.395683453237, y: 3.33333333333333, size: 1 },
    //     { x: 156.043165467626, y: 3.2156862745098, size: 1 },
    //     { x: 156.690647482014, y: 3.13725490196078, size: 1 },
    //     { x: 169.640287769784, y: 3.49019607843137, size: 1 },
    //     { x: 172.877697841727, y: 3.45098039215686, size: 1 },
    //     { x: 176.115107913669, y: 3.25490196078431, size: 1 },
    //     { x: 178.057553956835, y: 3.05882352941176, size: 1 },
    //     { x: 189.712230215827, y: 3.84313725490196, size: 1 },
    //     { x: 191.007194244604, y: 3.88235294117647, size: 1 },
    //     { x: 197.482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 198.776978417266, y: 3.25490196078431, size: 1 },
    //     { x: 199.424460431655, y: 2.54901960784314, size: 1 },
    //     { x: 200.071942446043, y: 2.54901960784314, size: 1 },
    //     { x: 200.719424460432, y: 3.88235294117647, size: 1 },
    //     { x: 203.309352517986, y: 3.84313725490196, size: 1 },
    //     { x: 203.956834532374, y: 3.84313725490196, size: 1 },
    //     { x: 205.251798561151, y: 4, size: 1 },
    //     { x: 206.546762589928, y: 4, size: 1 },
    //     { x: 207.194244604317, y: 3.92156862745098, size: 1 },
    //     { x: 207.841726618705, y: 3.80392156862745, size: 1 },
    //     { x: 208.489208633094, y: 4, size: 1 },
    //     { x: 209.136690647482, y: 3.96078431372549, size: 1 },
    //     { x: 209.784172661871, y: 3.88235294117647, size: 1 },
    //     { x: 210.431654676259, y: 4, size: 1 },
    //     { x: 211.079136690647, y: 4, size: 1 },
    //     { x: 213.021582733813, y: 3.84313725490196, size: 1 },
    //     { x: 214.31654676259, y: 3.92156862745098, size: 1 },
    //     { x: 214.964028776978, y: 3.80392156862745, size: 1 },
    //     { x: 217.553956834532, y: 3.96078431372549, size: 1 },
    //     { x: 218.201438848921, y: 3.80392156862745, size: 1 },
    //     { x: 220.791366906475, y: 3.01960784313725, size: 1 },
    //     { x: 221.438848920863, y: 3.13725490196078, size: 1 },
    //     { x: 225.971223021583, y: 3.80392156862745, size: 1 },
    //     { x: 241.510791366906, y: 3.33333333333333, size: 1 },
    //     { x: 243.453237410072, y: 3.2156862745098, size: 1 },
    //     { x: 260.935251798561, y: 3.80392156862745, size: 1 },
    //     { x: 262.877697841727, y: 3.72549019607843, size: 1 },
    //     { x: 264.172661870504, y: 3.25490196078431, size: 1 },
    //     { x: 276.474820143885, y: 3.29411764705882, size: 1 },
    //     { x: 285.539568345324, y: 3.01960784313725, size: 1 },
    //     { x: 286.187050359712, y: 2.86274509803922, size: 1 },
    //     { x: 286.834532374101, y: 3.37254901960784, size: 1 },
    //     { x: 301.726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 306.906474820144, y: 3.2156862745098, size: 1 },
    //     { x: 308.848920863309, y: 3.84313725490196, size: 1 },
    //     { x: 315.971223021583, y: 3.80392156862745, size: 1 },
    //     { x: 316.618705035971, y: 4.07843137254902, size: 1 },
    //     { x: 318.561151079137, y: 3.84313725490196, size: 1 },
    //     { x: 320.503597122302, y: 3.41176470588235, size: 1 },
    //     { x: 328.273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 328.920863309353, y: 3.25490196078431, size: 1 },
    //     { x: 337.338129496403, y: 3.33333333333333, size: 1 },
    //     { x: 339.928057553957, y: 3.76470588235294, size: 1 },
    //     { x: 348.992805755396, y: 3.29411764705882, size: 1 },
    //     { x: 350.287769784173, y: 3.13725490196078, size: 1 },
    //     { x: 350.935251798561, y: 3.13725490196078, size: 1 },
    //     { x: 356.115107913669, y: 3.84313725490196, size: 1 },
    //     { x: 357.410071942446, y: 3.92156862745098, size: 1 },
    //     { x: 7.76978417266187, y: 3.33333333333333, size: 1 },
    //     { x: 12.3021582733813, y: 3.05882352941176, size: 1 },
    //     { x: 22.0143884892086, y: 4.03921568627451, size: 1 },
    //     { x: 31.0791366906475, y: 3.41176470588235, size: 1 },
    //     { x: 32.3741007194245, y: 3.29411764705882, size: 1 },
    //     { x: 33.6690647482014, y: 3.01960784313725, size: 1 },
    //     { x: 34.3165467625899, y: 3.29411764705882, size: 1 },
    //     { x: 39.4964028776978, y: 3.6078431372549, size: 1 },
    //     { x: 47.9136690647482, y: 3.52941176470588, size: 1 },
    //     { x: 59.568345323741, y: 3.72549019607843, size: 1 },
    //     { x: 62.8057553956835, y: 3.88235294117647, size: 1 },
    //     { x: 71.2230215827338, y: 3.96078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 3.96078431372549, size: 1 },
    //     { x: 82.2302158273381, y: 3.49019607843137, size: 1 },
    //     { x: 86.1151079136691, y: 3.80392156862745, size: 1 },
    //     { x: 88.705035971223, y: 3.41176470588235, size: 1 },
    //     { x: 90, y: 3.37254901960784, size: 1 },
    //     { x: 97.1223021582734, y: 3.29411764705882, size: 1 },
    //     { x: 99.0647482014388, y: 2.94117647058824, size: 1 },
    //     { x: 104.244604316547, y: 3.52941176470588, size: 1 },
    //     { x: 112.661870503597, y: 3.56862745098039, size: 1 },
    //     { x: 115.89928057554, y: 3.96078431372549, size: 1 },
    //     { x: 118.489208633094, y: 3.41176470588235, size: 1 },
    //     { x: 123.021582733813, y: 3.52941176470588, size: 1 },
    //     { x: 140.503597122302, y: 3.33333333333333, size: 1 },
    //     { x: 143.093525179856, y: 3.76470588235294, size: 1 },
    //     { x: 147.625899280576, y: 4.07843137254902, size: 1 },
    //     { x: 154.748201438849, y: 3.64705882352941, size: 1 },
    //     { x: 162.517985611511, y: 3.41176470588235, size: 1 },
    //     { x: 163.165467625899, y: 3.01960784313725, size: 1 },
    //     { x: 164.460431654676, y: 3.33333333333333, size: 1 },
    //     { x: 165.755395683453, y: 3.33333333333333, size: 1 },
    //     { x: 168.992805755396, y: 4, size: 1 },
    //     { x: 171.58273381295, y: 3.37254901960784, size: 1 },
    //     { x: 179.352517985612, y: 3.41176470588235, size: 1 },
    //     { x: 180, y: 3.33333333333333, size: 1 },
    //     { x: 180.647482014388, y: 3.37254901960784, size: 1 },
    //     { x: 184.532374100719, y: 3.01960784313725, size: 1 },
    //     { x: 205.89928057554, y: 3.33333333333333, size: 1 },
    //     { x: 206.546762589928, y: 3.01960784313725, size: 1 },
    //     { x: 209.136690647482, y: 3.41176470588235, size: 1 },
    //     { x: 211.079136690647, y: 3.64705882352941, size: 1 },
    //     { x: 219.496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 222.73381294964, y: 3.41176470588235, size: 1 },
    //     { x: 223.381294964029, y: 3.49019607843137, size: 1 },
    //     { x: 231.151079136691, y: 3.45098039215686, size: 1 },
    //     { x: 232.446043165468, y: 3.88235294117647, size: 1 },
    //     { x: 245.395683453237, y: 3.49019607843137, size: 1 },
    //     { x: 246.043165467626, y: 3.84313725490196, size: 1 },
    //     { x: 253.812949640288, y: 3.33333333333333, size: 1 },
    //     { x: 257.697841726619, y: 3.33333333333333, size: 1 },
    //     { x: 263.525179856115, y: 3.84313725490196, size: 1 },
    //     { x: 266.762589928058, y: 3.72549019607843, size: 1 },
    //     { x: 279.712230215827, y: 3.88235294117647, size: 1 },
    //     { x: 286.187050359712, y: 3.92156862745098, size: 1 },
    //     { x: 294.604316546763, y: 3.96078431372549, size: 1 },
    //     { x: 309.496402877698, y: 3.88235294117647, size: 1 },
    //     { x: 314.676258992806, y: 3.01960784313725, size: 1 },
    //     { x: 315.323741007194, y: 3.2156862745098, size: 1 },
    //     { x: 316.618705035971, y: 3.41176470588235, size: 1 },
    //     { x: 321.151079136691, y: 3.80392156862745, size: 1 },
    //     { x: 333.453237410072, y: 3.80392156862745, size: 1 },
    //     { x: 336.690647482014, y: 3.41176470588235, size: 1 },
    //     { x: 356.115107913669, y: 3.37254901960784, size: 1 },
    //     { x: 357.410071942446, y: 2.98039215686275, size: 1 },
    //     { x: 358.057553956835, y: 3.17647058823529, size: 1 },
    //     { x: 359.352517985611, y: 3.56862745098039, size: 1 },
    //     { x: 0.648648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 2.59459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 3.24324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 3.89189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 5.18918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 7.78378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 12.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 16.8648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 20.1081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 22.7027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 23.3513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 24, y: 3.64705882352941, size: 1 },
    //     { x: 24.6486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 26.5945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 27.2432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 30.4864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 31.7837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 32.4324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 35.6756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 37.6216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 38.2702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 38.9189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 39.5675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 40.2162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 42.1621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 43.4594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 44.7567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 48, y: 3.25490196078431, size: 1 },
    //     { x: 48.6486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 54.4864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 55.7837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 56.4324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 57.7297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 60.3243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 61.6216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 62.2702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 62.9189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 64.2162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 66.1621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 66.8108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 73.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 77.8378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 80.4324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 81.7297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 83.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 83.6756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 84.3243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 84.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 85.6216216216216, y: 2.70588235294118, size: 1 },
    //     { x: 87.5675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 89.5135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 91.4594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 92.1081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 93.4054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 95.3513513513514, y: 4, size: 1 },
    //     { x: 97.2972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 97.945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 101.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 102.486486486486, y: 3.56862745098039, size: 1 },
    //     { x: 103.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 105.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 106.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 107.027027027027, y: 2.82352941176471, size: 1 },
    //     { x: 107.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 108.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 111.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 112.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 112.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 113.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 114.810810810811, y: 3.6078431372549, size: 1 },
    //     { x: 116.756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 118.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 120.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 121.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 121.945945945946, y: 4, size: 1 },
    //     { x: 123.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 128.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 130.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 131.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 131.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 132.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 132.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 134.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 136.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 141.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 142.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 144.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 151.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 152.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 154.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 155.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 155.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 156.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 156.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 164.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 168, y: 3.72549019607843, size: 1 },
    //     { x: 168.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 169.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 170.594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 171.243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 171.891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 172.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 173.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 174.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 175.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 175.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 177.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 177.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 178.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 180.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 180.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 182.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 183.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 184.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 190.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 190.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 192, y: 3.33333333333333, size: 1 },
    //     { x: 193.297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 198.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 199.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 199.783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 201.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 203.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 203.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 205.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 207.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 209.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 210.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 210.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 211.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 214.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 216, y: 3.49019607843137, size: 1 },
    //     { x: 217.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 217.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 218.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 219.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 221.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 225.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 227.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 227.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 228.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 228.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 229.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 231.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 232.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 234.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 234.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 235.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 236.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 240, y: 3.72549019607843, size: 1 },
    //     { x: 240.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 242.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 243.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 249.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 251.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 254.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 256.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 257.513513513513, y: 3.17647058823529, size: 1 },
    //     { x: 258.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 258.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 260.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 260.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 262.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 264, y: 3.52941176470588, size: 1 },
    //     { x: 267.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 269.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 269.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 271.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 273.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 273.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 275.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 276.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 276.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 277.621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 278.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 279.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 280.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 282.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 283.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 287.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 288, y: 3.88235294117647, size: 1 },
    //     { x: 289.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 292.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 293.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 296.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 297.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 297.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 298.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 299.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 300.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 300.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 301.621621621622, y: 2.70588235294118, size: 1 },
    //     { x: 302.27027027027, y: 2.74509803921569, size: 1 },
    //     { x: 302.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 304.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 305.513513513513, y: 3.72549019607843, size: 1 },
    //     { x: 308.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 309.405405405405, y: 4, size: 1 },
    //     { x: 310.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 312.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 313.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 314.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 315.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 315.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 317.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 317.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 319.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 321.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 321.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 322.378378378378, y: 2.58823529411765, size: 1 },
    //     { x: 323.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 323.675675675676, y: 3.01960784313725, size: 1 },
    //     { x: 324.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 326.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 327.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 328.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 328.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 330.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 331.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 339.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 341.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 343.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 343.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 344.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 345.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 348.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 351.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 354.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 357.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 358.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 0.647482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 3.88489208633094, y: 3.92156862745098, size: 1 },
    //     { x: 7.12230215827338, y: 3.45098039215686, size: 1 },
    //     { x: 9.71223021582734, y: 3.64705882352941, size: 1 },
    //     { x: 15.5395683453237, y: 3.80392156862745, size: 1 },
    //     { x: 23.9568345323741, y: 3.37254901960784, size: 1 },
    //     { x: 26.5467625899281, y: 3.13725490196078, size: 1 },
    //     { x: 32.3741007194245, y: 3.49019607843137, size: 1 },
    //     { x: 34.9640287769784, y: 3.49019607843137, size: 1 },
    //     { x: 40.7913669064748, y: 3.92156862745098, size: 1 },
    //     { x: 41.4388489208633, y: 3.80392156862745, size: 1 },
    //     { x: 44.6762589928058, y: 3.96078431372549, size: 1 },
    //     { x: 49.8561151079137, y: 3.41176470588235, size: 1 },
    //     { x: 53.0935251798561, y: 3.64705882352941, size: 1 },
    //     { x: 67.9856115107914, y: 3.88235294117647, size: 1 },
    //     { x: 69.9280575539568, y: 3.17647058823529, size: 1 },
    //     { x: 72.5179856115108, y: 3.45098039215686, size: 1 },
    //     { x: 77.0503597122302, y: 3.76470588235294, size: 1 },
    //     { x: 80.9352517985612, y: 3.6078431372549, size: 1 },
    //     { x: 92.589928057554, y: 2.98039215686275, size: 1 },
    //     { x: 93.2374100719424, y: 2.90196078431373, size: 1 },
    //     { x: 98.4172661870504, y: 3.41176470588235, size: 1 },
    //     { x: 101.007194244604, y: 3.6078431372549, size: 1 },
    //     { x: 112.661870503597, y: 2.47058823529412, size: 1 },
    //     { x: 113.309352517986, y: 2.31372549019608, size: 1 },
    //     { x: 113.956834532374, y: 2.23529411764706, size: 1 },
    //     { x: 114.604316546763, y: 2.70588235294118, size: 1 },
    //     { x: 115.251798561151, y: 3.2156862745098, size: 1 },
    //     { x: 115.89928057554, y: 3.49019607843137, size: 1 },
    //     { x: 117.194244604317, y: 3.84313725490196, size: 1 },
    //     { x: 118.489208633094, y: 4, size: 1 },
    //     { x: 123.021582733813, y: 3.88235294117647, size: 1 },
    //     { x: 126.258992805755, y: 3.76470588235294, size: 1 },
    //     { x: 160.575539568345, y: 3.96078431372549, size: 1 },
    //     { x: 176.115107913669, y: 3.45098039215686, size: 1 },
    //     { x: 176.762589928058, y: 3.33333333333333, size: 1 },
    //     { x: 177.410071942446, y: 3.17647058823529, size: 1 },
    //     { x: 178.057553956835, y: 3.01960784313725, size: 1 },
    //     { x: 181.294964028777, y: 3.88235294117647, size: 1 },
    //     { x: 193.597122302158, y: 4.07843137254902, size: 1 },
    //     { x: 195.539568345324, y: 3.84313725490196, size: 1 },
    //     { x: 200.719424460432, y: 3.45098039215686, size: 1 },
    //     { x: 203.956834532374, y: 3.41176470588235, size: 1 },
    //     { x: 221.438848920863, y: 3.37254901960784, size: 1 },
    //     { x: 234.388489208633, y: 3.41176470588235, size: 1 },
    //     { x: 235.68345323741, y: 3.80392156862745, size: 1 },
    //     { x: 238.273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 239.568345323741, y: 3.45098039215686, size: 1 },
    //     { x: 241.510791366906, y: 3.29411764705882, size: 1 },
    //     { x: 242.158273381295, y: 3.09803921568627, size: 1 },
    //     { x: 256.402877697842, y: 3.52941176470588, size: 1 },
    //     { x: 273.237410071942, y: 3.92156862745098, size: 1 },
    //     { x: 284.244604316547, y: 3.45098039215686, size: 1 },
    //     { x: 286.187050359712, y: 3.2156862745098, size: 1 },
    //     { x: 288.129496402878, y: 3.96078431372549, size: 1 },
    //     { x: 302.374100719424, y: 3.52941176470588, size: 1 },
    //     { x: 306.906474820144, y: 3.13725490196078, size: 1 },
    //     { x: 307.553956834532, y: 3.25490196078431, size: 1 },
    //     { x: 310.143884892086, y: 3.45098039215686, size: 1 },
    //     { x: 311.438848920863, y: 3.49019607843137, size: 1 },
    //     { x: 322.446043165468, y: 3.92156862745098, size: 1 },
    //     { x: 328.920863309353, y: 2.82352941176471, size: 1 },
    //     { x: 329.568345323741, y: 3.25490196078431, size: 1 },
    //     { x: 334.748201438849, y: 3.68627450980392, size: 1 },
    //     { x: 348.992805755396, y: 3.84313725490196, size: 1 },
    //     { x: 11.0071942446043, y: 3.09803921568627, size: 1 },
    //     { x: 11.6546762589928, y: 1.72549019607843, size: 1 },
    //     { x: 12.3021582733813, y: 0.666666666666667, size: 1 },
    //     { x: 12.9496402877698, y: 0.509803921568627, size: 1 },
    //     { x: 13.5971223021583, y: 0.901960784313726, size: 1 },
    //     { x: 14.2446043165468, y: 3.09803921568627, size: 1 },
    //     { x: 15.5395683453237, y: 3.45098039215686, size: 1 },
    //     { x: 16.1870503597122, y: 3.05882352941176, size: 1 },
    //     { x: 16.8345323741007, y: 2.90196078431373, size: 1 },
    //     { x: 21.3669064748201, y: 2.94117647058824, size: 1 },
    //     { x: 27.1942446043165, y: 2.74509803921569, size: 1 },
    //     { x: 33.6690647482014, y: 2.94117647058824, size: 1 },
    //     { x: 39.4964028776978, y: 4.03921568627451, size: 1 },
    //     { x: 53.7410071942446, y: 3.33333333333333, size: 1 },
    //     { x: 54.3884892086331, y: 2.98039215686275, size: 1 },
    //     { x: 55.0359712230216, y: 2.58823529411765, size: 1 },
    //     { x: 55.6834532374101, y: 2.23529411764706, size: 1 },
    //     { x: 56.3309352517986, y: 3.76470588235294, size: 1 },
    //     { x: 60.2158273381295, y: 3.41176470588235, size: 1 },
    //     { x: 65.3956834532374, y: 3.80392156862745, size: 1 },
    //     { x: 71.2230215827338, y: 3.84313725490196, size: 1 },
    //     { x: 76.4028776978417, y: 2.58823529411765, size: 1 },
    //     { x: 77.0503597122302, y: 2.50980392156863, size: 1 },
    //     { x: 80.9352517985612, y: 3.92156862745098, size: 1 },
    //     { x: 83.5251798561151, y: 3.96078431372549, size: 1 },
    //     { x: 86.7625899280576, y: 3.72549019607843, size: 1 },
    //     { x: 99.7122302158273, y: 3.45098039215686, size: 1 },
    //     { x: 119.784172661871, y: 3.17647058823529, size: 1 },
    //     { x: 120.431654676259, y: 2.94117647058824, size: 1 },
    //     { x: 139.208633093525, y: 3.33333333333333, size: 1 },
    //     { x: 139.856115107914, y: 3.2156862745098, size: 1 },
    //     { x: 145.035971223022, y: 3.37254901960784, size: 1 },
    //     { x: 153.453237410072, y: 3.6078431372549, size: 1 },
    //     { x: 161.223021582734, y: 3.13725490196078, size: 1 },
    //     { x: 161.870503597122, y: 3.33333333333333, size: 1 },
    //     { x: 162.517985611511, y: 3.2156862745098, size: 1 },
    //     { x: 163.165467625899, y: 2.7843137254902, size: 1 },
    //     { x: 166.402877697842, y: 3.88235294117647, size: 1 },
    //     { x: 170.287769784173, y: 4, size: 1 },
    //     { x: 171.58273381295, y: 3.88235294117647, size: 1 },
    //     { x: 172.230215827338, y: 3.92156862745098, size: 1 },
    //     { x: 172.877697841727, y: 3.88235294117647, size: 1 },
    //     { x: 174.820143884892, y: 4.27450980392157, size: 1 },
    //     { x: 178.705035971223, y: 3.92156862745098, size: 1 },
    //     { x: 180.647482014388, y: 4.19607843137255, size: 1 },
    //     { x: 183.237410071942, y: 3.25490196078431, size: 1 },
    //     { x: 183.884892086331, y: 3.25490196078431, size: 1 },
    //     { x: 184.532374100719, y: 2.62745098039216, size: 1 },
    //     { x: 185.179856115108, y: 2.74509803921569, size: 1 },
    //     { x: 185.827338129496, y: 3.33333333333333, size: 1 },
    //     { x: 186.474820143885, y: 4, size: 1 },
    //     { x: 190.359712230216, y: 3.37254901960784, size: 1 },
    //     { x: 192.94964028777, y: 3.45098039215686, size: 1 },
    //     { x: 193.597122302158, y: 3.33333333333333, size: 1 },
    //     { x: 197.482014388489, y: 3.45098039215686, size: 1 },
    //     { x: 199.424460431655, y: 3.33333333333333, size: 1 },
    //     { x: 202.014388489209, y: 3.33333333333333, size: 1 },
    //     { x: 213.021582733813, y: 3.76470588235294, size: 1 },
    //     { x: 225.971223021583, y: 3.29411764705882, size: 1 },
    //     { x: 226.618705035971, y: 2.98039215686275, size: 1 },
    //     { x: 227.26618705036, y: 3.01960784313725, size: 1 },
    //     { x: 227.913669064748, y: 1.96078431372549, size: 1 },
    //     { x: 238.920863309353, y: 3.37254901960784, size: 1 },
    //     { x: 247.338129496403, y: 3.41176470588235, size: 1 },
    //     { x: 247.985611510791, y: 3.17647058823529, size: 1 },
    //     { x: 249.280575539568, y: 2.19607843137255, size: 1 },
    //     { x: 249.928057553957, y: 2.35294117647059, size: 1 },
    //     { x: 250.575539568345, y: 4.03921568627451, size: 1 },
    //     { x: 262.230215827338, y: 3.96078431372549, size: 1 },
    //     { x: 263.525179856115, y: 3.92156862745098, size: 1 },
    //     { x: 264.820143884892, y: 3.76470588235294, size: 1 },
    //     { x: 270, y: 3.25490196078431, size: 1 },
    //     { x: 271.942446043165, y: 3.76470588235294, size: 1 },
    //     { x: 277.769784172662, y: 3.41176470588235, size: 1 },
    //     { x: 284.244604316547, y: 3.88235294117647, size: 1 },
    //     { x: 290.719424460432, y: 3.29411764705882, size: 1 },
    //     { x: 291.36690647482, y: 3.01960784313725, size: 1 },
    //     { x: 295.89928057554, y: 3.49019607843137, size: 1 },
    //     { x: 296.546762589928, y: 4, size: 1 },
    //     { x: 314.676258992806, y: 3.29411764705882, size: 1 },
    //     { x: 322.446043165468, y: 3.64705882352941, size: 1 },
    //     { x: 336.690647482014, y: 3.96078431372549, size: 1 },
    //     { x: 337.985611510791, y: 3.92156862745098, size: 1 },
    //     { x: 339.280575539568, y: 3.92156862745098, size: 1 },
    //     { x: 341.870503597122, y: 4.15686274509804, size: 1 },
    //     { x: 348.345323741007, y: 3.88235294117647, size: 1 },
    //     { x: 350.935251798561, y: 4, size: 1 },
    //     { x: 359.352517985611, y: 3.2156862745098, size: 1 },
    //     { x: 11.6546762589928, y: 3.92156862745098, size: 1 },
    //     { x: 12.9496402877698, y: 3.92156862745098, size: 1 },
    //     { x: 18.1294964028777, y: 3.33333333333333, size: 1 },
    //     { x: 18.7769784172662, y: 3.17647058823529, size: 1 },
    //     { x: 20.7194244604317, y: 3.13725490196078, size: 1 },
    //     { x: 28.4892086330935, y: 3.80392156862745, size: 1 },
    //     { x: 32.3741007194245, y: 3.92156862745098, size: 1 },
    //     { x: 37.5539568345324, y: 3.49019607843137, size: 1 },
    //     { x: 38.8489208633094, y: 3.33333333333333, size: 1 },
    //     { x: 40.7913669064748, y: 3.09803921568627, size: 1 },
    //     { x: 41.4388489208633, y: 3.13725490196078, size: 1 },
    //     { x: 42.0863309352518, y: 3.17647058823529, size: 1 },
    //     { x: 43.3812949640288, y: 3.41176470588235, size: 1 },
    //     { x: 45.3237410071942, y: 3.96078431372549, size: 1 },
    //     { x: 60.2158273381295, y: 3.45098039215686, size: 1 },
    //     { x: 62.158273381295, y: 2.82352941176471, size: 1 },
    //     { x: 62.8057553956835, y: 2.90196078431373, size: 1 },
    //     { x: 63.4532374100719, y: 2.70588235294118, size: 1 },
    //     { x: 64.1007194244604, y: 2.94117647058824, size: 1 },
    //     { x: 81.5827338129496, y: 3.37254901960784, size: 1 },
    //     { x: 83.5251798561151, y: 2.90196078431373, size: 1 },
    //     { x: 84.8201438848921, y: 3.13725490196078, size: 1 },
    //     { x: 85.4676258992806, y: 2.90196078431373, size: 1 },
    //     { x: 93.8848920863309, y: 3.84313725490196, size: 1 },
    //     { x: 95.1798561151079, y: 3.80392156862745, size: 1 },
    //     { x: 97.7697841726619, y: 3.96078431372549, size: 1 },
    //     { x: 124.964028776978, y: 4.03921568627451, size: 1 },
    //     { x: 127.553956834532, y: 3.25490196078431, size: 1 },
    //     { x: 134.028776978417, y: 3.92156862745098, size: 1 },
    //     { x: 149.568345323741, y: 3.72549019607843, size: 1 },
    //     { x: 150.215827338129, y: 3.37254901960784, size: 1 },
    //     { x: 156.043165467626, y: 3.72549019607843, size: 1 },
    //     { x: 162.517985611511, y: 3.29411764705882, size: 1 },
    //     { x: 163.165467625899, y: 4.15686274509804, size: 1 },
    //     { x: 169.640287769784, y: 3.2156862745098, size: 1 },
    //     { x: 170.287769784173, y: 3.2156862745098, size: 1 },
    //     { x: 176.762589928058, y: 3.72549019607843, size: 1 },
    //     { x: 178.057553956835, y: 3.41176470588235, size: 1 },
    //     { x: 185.827338129496, y: 3.45098039215686, size: 1 },
    //     { x: 207.194244604317, y: 3.37254901960784, size: 1 },
    //     { x: 211.079136690647, y: 3.88235294117647, size: 1 },
    //     { x: 211.726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 213.669064748201, y: 3.49019607843137, size: 1 },
    //     { x: 214.964028776978, y: 3.72549019607843, size: 1 },
    //     { x: 218.848920863309, y: 3.45098039215686, size: 1 },
    //     { x: 229.208633093525, y: 3.72549019607843, size: 1 },
    //     { x: 250.575539568345, y: 3.80392156862745, size: 1 },
    //     { x: 255.107913669065, y: 3.33333333333333, size: 1 },
    //     { x: 256.402877697842, y: 2.86274509803922, size: 1 },
    //     { x: 257.05035971223, y: 2.70588235294118, size: 1 },
    //     { x: 257.697841726619, y: 3.01960784313725, size: 1 },
    //     { x: 258.345323741007, y: 2.74509803921569, size: 1 },
    //     { x: 259.640287769784, y: 3.88235294117647, size: 1 },
    //     { x: 265.467625899281, y: 3.96078431372549, size: 1 },
    //     { x: 267.410071942446, y: 3.88235294117647, size: 1 },
    //     { x: 277.769784172662, y: 3.01960784313725, size: 1 },
    //     { x: 278.41726618705, y: 2.94117647058824, size: 1 },
    //     { x: 279.064748201439, y: 2.94117647058824, size: 1 },
    //     { x: 279.712230215827, y: 3.13725490196078, size: 1 },
    //     { x: 284.892086330935, y: 4, size: 1 },
    //     { x: 292.661870503597, y: 3.84313725490196, size: 1 },
    //     { x: 297.841726618705, y: 3.84313725490196, size: 1 },
    //     { x: 303.669064748201, y: 3.84313725490196, size: 1 },
    //     { x: 307.553956834532, y: 3.88235294117647, size: 1 },
    //     { x: 315.323741007194, y: 3.76470588235294, size: 1 },
    //     { x: 325.035971223022, y: 3.92156862745098, size: 1 },
    //     { x: 326.330935251799, y: 3.96078431372549, size: 1 },
    //     { x: 337.985611510791, y: 3.84313725490196, size: 1 },
    //     { x: 338.63309352518, y: 3.84313725490196, size: 1 },
    //     { x: 341.870503597122, y: 3.2156862745098, size: 1 },
    //     { x: 342.517985611511, y: 3.17647058823529, size: 1 },
    //     { x: 343.165467625899, y: 3.2156862745098, size: 1 },
    //     { x: 344.460431654676, y: 3.25490196078431, size: 1 },
    //     { x: 0.648648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 1.94594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 2.59459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 3.24324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 3.89189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 4.54054054054054, y: 2.86274509803922, size: 1 },
    //     { x: 5.18918918918919, y: 2.94117647058824, size: 1 },
    //     { x: 5.83783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 6.48648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 11.6756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 14.2702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 14.9189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 15.5675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 16.2162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 16.8648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 18.8108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 22.0540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 22.7027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 24, y: 3.33333333333333, size: 1 },
    //     { x: 26.5945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 27.2432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 27.8918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 31.1351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 33.0810810810811, y: 3.68627450980392, size: 1 },
    //     { x: 35.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 35.6756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 36.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 37.6216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 38.9189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 44.1081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 45.4054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 46.0540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 46.7027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 48.6486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 52.5405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 54.4864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 56.4324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 59.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 59.6756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 60.3243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 62.2702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 68.7567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 69.4054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 70.054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 70.7027027027027, y: 2.70588235294118, size: 1 },
    //     { x: 71.3513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 73.2972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 76.5405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 77.8378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 79.1351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 81.7297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 83.6756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 84.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 85.6216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 89.5135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 90.8108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 92.7567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 93.4054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 94.7027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 96.6486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 97.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 99.2432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 100.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 103.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 105.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 105.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 106.378378378378, y: 4, size: 1 },
    //     { x: 107.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 107.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 110.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 112.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 114.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 114.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 120, y: 3.52941176470588, size: 1 },
    //     { x: 121.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 121.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 123.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 124.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 125.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 135.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 138.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 140.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 141.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 142.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 142.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 144, y: 3.72549019607843, size: 1 },
    //     { x: 145.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 147.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 148.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 150.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 151.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 153.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 153.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 154.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 155.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 155.675675675676, y: 2.70588235294118, size: 1 },
    //     { x: 156.324324324324, y: 2.7843137254902, size: 1 },
    //     { x: 156.972972972973, y: 2.66666666666667, size: 1 },
    //     { x: 157.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 159.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 160.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 161.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 164.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 165.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 168, y: 4, size: 1 },
    //     { x: 175.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 175.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 177.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 179.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 183.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 185.513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 187.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 192.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 194.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 195.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 195.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 197.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 197.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 198.486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 199.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 199.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 200.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 202.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 203.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 203.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 204.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 205.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 206.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 206.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 208.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 210.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 210.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 212.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 214.054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 215.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 216.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 217.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 221.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 223.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 227.027027027027, y: 4, size: 1 },
    //     { x: 228.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 230.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 230.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 232.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 234.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 236.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 236.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 240, y: 3.84313725490196, size: 1 },
    //     { x: 241.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 243.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 246.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 247.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 252.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 253.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 254.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 256.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 259.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 261.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 262.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 263.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 266.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 267.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 269.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 275.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 276.972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 278.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 280.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 280.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 282.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 284.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 287.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 288.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 296.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 298.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 299.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 300.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 304.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 304.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 305.513513513513, y: 3.33333333333333, size: 1 },
    //     { x: 306.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 307.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 308.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 308.756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 310.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 310.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 314.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 319.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 321.72972972973, y: 4, size: 1 },
    //     { x: 323.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 324.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 324.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 325.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 327.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 328.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 328.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 329.513513513513, y: 2.86274509803922, size: 1 },
    //     { x: 330.162162162162, y: 2.70588235294118, size: 1 },
    //     { x: 330.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 333.405405405405, y: 3.56862745098039, size: 1 },
    //     { x: 334.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 337.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 339.243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 349.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 350.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 350.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 352.216216216216, y: 2.86274509803922, size: 1 },
    //     { x: 354.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 356.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 358.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 358.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 359.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 2.58992805755396, y: 3.45098039215686, size: 1 },
    //     { x: 14.8920863309353, y: 3.45098039215686, size: 1 },
    //     { x: 22.0143884892086, y: 3.29411764705882, size: 1 },
    //     { x: 23.3093525179856, y: 3.29411764705882, size: 1 },
    //     { x: 27.1942446043165, y: 3.49019607843137, size: 1 },
    //     { x: 28.4892086330935, y: 3.37254901960784, size: 1 },
    //     { x: 29.136690647482, y: 3.45098039215686, size: 1 },
    //     { x: 29.7841726618705, y: 3.25490196078431, size: 1 },
    //     { x: 36.9064748201439, y: 3.84313725490196, size: 1 },
    //     { x: 54.3884892086331, y: 3.25490196078431, size: 1 },
    //     { x: 55.6834532374101, y: 3.09803921568627, size: 1 },
    //     { x: 56.9784172661871, y: 3.05882352941176, size: 1 },
    //     { x: 63.4532374100719, y: 3.41176470588235, size: 1 },
    //     { x: 66.0431654676259, y: 3.17647058823529, size: 1 },
    //     { x: 66.6906474820144, y: 3.29411764705882, size: 1 },
    //     { x: 67.3381294964029, y: 3.33333333333333, size: 1 },
    //     { x: 69.9280575539568, y: 3.52941176470588, size: 1 },
    //     { x: 76.4028776978417, y: 2.98039215686275, size: 1 },
    //     { x: 77.6978417266187, y: 3.29411764705882, size: 1 },
    //     { x: 80.2877697841727, y: 3.25490196078431, size: 1 },
    //     { x: 90.6474820143885, y: 3.33333333333333, size: 1 },
    //     { x: 93.2374100719424, y: 3.29411764705882, size: 1 },
    //     { x: 93.8848920863309, y: 3.33333333333333, size: 1 },
    //     { x: 94.5323741007194, y: 3.33333333333333, size: 1 },
    //     { x: 95.8273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 97.1223021582734, y: 3.17647058823529, size: 1 },
    //     { x: 97.7697841726619, y: 2.98039215686275, size: 1 },
    //     { x: 98.4172661870504, y: 3.01960784313725, size: 1 },
    //     { x: 99.7122302158273, y: 3.05882352941176, size: 1 },
    //     { x: 100.359712230216, y: 3.09803921568627, size: 1 },
    //     { x: 106.187050359712, y: 3.37254901960784, size: 1 },
    //     { x: 121.726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 126.906474820144, y: 3.41176470588235, size: 1 },
    //     { x: 129.496402877698, y: 3.92156862745098, size: 1 },
    //     { x: 138.561151079137, y: 3.96078431372549, size: 1 },
    //     { x: 155.395683453237, y: 3.45098039215686, size: 1 },
    //     { x: 164.460431654676, y: 4.03921568627451, size: 1 },
    //     { x: 172.230215827338, y: 3.84313725490196, size: 1 },
    //     { x: 174.172661870504, y: 4.23529411764706, size: 1 },
    //     { x: 181.942446043165, y: 3.56862745098039, size: 1 },
    //     { x: 185.827338129496, y: 3.13725490196078, size: 1 },
    //     { x: 188.41726618705, y: 4, size: 1 },
    //     { x: 200.071942446043, y: 3.76470588235294, size: 1 },
    //     { x: 222.086330935252, y: 3.92156862745098, size: 1 },
    //     { x: 227.26618705036, y: 3.37254901960784, size: 1 },
    //     { x: 228.561151079137, y: 3.76470588235294, size: 1 },
    //     { x: 230.503597122302, y: 3.49019607843137, size: 1 },
    //     { x: 241.510791366906, y: 3.80392156862745, size: 1 },
    //     { x: 257.05035971223, y: 3.92156862745098, size: 1 },
    //     { x: 270.647482014389, y: 3.33333333333333, size: 1 },
    //     { x: 271.942446043165, y: 2.94117647058824, size: 1 },
    //     { x: 272.589928057554, y: 3.33333333333333, size: 1 },
    //     { x: 275.179856115108, y: 3.88235294117647, size: 1 },
    //     { x: 291.36690647482, y: 3.84313725490196, size: 1 },
    //     { x: 292.014388489209, y: 3.01960784313725, size: 1 },
    //     { x: 295.251798561151, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.52941176470588, size: 1 },
    //     { x: 331.510791366906, y: 3.41176470588235, size: 1 },
    //     { x: 336.043165467626, y: 2.98039215686275, size: 1 },
    //     { x: 336.690647482014, y: 2.90196078431373, size: 1 },
    //     { x: 337.338129496403, y: 3.05882352941176, size: 1 },
    //     { x: 337.985611510791, y: 3.37254901960784, size: 1 },
    //     { x: 344.460431654676, y: 3.49019607843137, size: 1 },
    //     { x: 345.107913669065, y: 3.37254901960784, size: 1 },
    //     { x: 346.402877697842, y: 3.45098039215686, size: 1 },
    //     { x: 348.992805755396, y: 3.49019607843137, size: 1 },
    //     { x: 353.525179856115, y: 3.68627450980392, size: 1 },
    //     { x: 10.3597122302158, y: 3.33333333333333, size: 1 },
    //     { x: 17.4820143884892, y: 3.6078431372549, size: 1 },
    //     { x: 20.0719424460432, y: 3.84313725490196, size: 1 },
    //     { x: 32.3741007194245, y: 4, size: 1 },
    //     { x: 38.8489208633094, y: 3.29411764705882, size: 1 },
    //     { x: 40.1438848920863, y: 3.05882352941176, size: 1 },
    //     { x: 40.7913669064748, y: 3.29411764705882, size: 1 },
    //     { x: 60.863309352518, y: 3.2156862745098, size: 1 },
    //     { x: 61.5107913669065, y: 2.94117647058824, size: 1 },
    //     { x: 62.158273381295, y: 3.05882352941176, size: 1 },
    //     { x: 62.8057553956835, y: 3.41176470588235, size: 1 },
    //     { x: 63.4532374100719, y: 3.80392156862745, size: 1 },
    //     { x: 83.5251798561151, y: 3.17647058823529, size: 1 },
    //     { x: 88.0575539568345, y: 3.96078431372549, size: 1 },
    //     { x: 89.3525179856115, y: 3.88235294117647, size: 1 },
    //     { x: 92.589928057554, y: 3.80392156862745, size: 1 },
    //     { x: 104.892086330935, y: 3.6078431372549, size: 1 },
    //     { x: 109.424460431655, y: 3.88235294117647, size: 1 },
    //     { x: 112.661870503597, y: 3.41176470588235, size: 1 },
    //     { x: 122.374100719424, y: 3.52941176470588, size: 1 },
    //     { x: 161.223021582734, y: 4, size: 1 },
    //     { x: 161.870503597122, y: 3.88235294117647, size: 1 },
    //     { x: 163.165467625899, y: 3.96078431372549, size: 1 },
    //     { x: 167.697841726619, y: 3.84313725490196, size: 1 },
    //     { x: 176.762589928058, y: 3.92156862745098, size: 1 },
    //     { x: 185.179856115108, y: 3.84313725490196, size: 1 },
    //     { x: 196.834532374101, y: 3.45098039215686, size: 1 },
    //     { x: 222.73381294964, y: 3.88235294117647, size: 1 },
    //     { x: 232.446043165468, y: 3.41176470588235, size: 1 },
    //     { x: 235.035971223022, y: 3.01960784313725, size: 1 },
    //     { x: 236.978417266187, y: 3.92156862745098, size: 1 },
    //     { x: 247.985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 251.870503597122, y: 3.45098039215686, size: 1 },
    //     { x: 255.755395683453, y: 3.01960784313725, size: 1 },
    //     { x: 256.402877697842, y: 2.82352941176471, size: 1 },
    //     { x: 257.05035971223, y: 2.90196078431373, size: 1 },
    //     { x: 257.697841726619, y: 2.86274509803922, size: 1 },
    //     { x: 258.345323741007, y: 3.13725490196078, size: 1 },
    //     { x: 260.935251798561, y: 3.88235294117647, size: 1 },
    //     { x: 266.762589928058, y: 3.96078431372549, size: 1 },
    //     { x: 273.237410071942, y: 3.52941176470588, size: 1 },
    //     { x: 277.769784172662, y: 2.7843137254902, size: 1 },
    //     { x: 278.41726618705, y: 3.09803921568627, size: 1 },
    //     { x: 283.597122302158, y: 3.41176470588235, size: 1 },
    //     { x: 299.784172661871, y: 3.25490196078431, size: 1 },
    //     { x: 307.553956834532, y: 3.92156862745098, size: 1 },
    //     { x: 314.028776978417, y: 3.96078431372549, size: 1 },
    //     { x: 315.323741007194, y: 3.84313725490196, size: 1 },
    //     { x: 319.208633093525, y: 3.13725490196078, size: 1 },
    //     { x: 319.856115107914, y: 3.25490196078431, size: 1 },
    //     { x: 320.503597122302, y: 2.7843137254902, size: 1 },
    //     { x: 321.151079136691, y: 2.62745098039216, size: 1 },
    //     { x: 340.575539568345, y: 3.25490196078431, size: 1 },
    //     { x: 341.223021582734, y: 3.33333333333333, size: 1 },
    //     { x: 342.517985611511, y: 3.01960784313725, size: 1 },
    //     { x: 343.165467625899, y: 3.33333333333333, size: 1 },
    //     { x: 346.402877697842, y: 3.80392156862745, size: 1 },
    //     { x: 1.94244604316547, y: 3.2156862745098, size: 1 },
    //     { x: 3.23741007194245, y: 3.29411764705882, size: 1 },
    //     { x: 3.88489208633094, y: 2.82352941176471, size: 1 },
    //     { x: 4.53237410071942, y: 2.62745098039216, size: 1 },
    //     { x: 5.17985611510791, y: 3.29411764705882, size: 1 },
    //     { x: 25.2517985611511, y: 2.62745098039216, size: 1 },
    //     { x: 25.8992805755396, y: 2.3921568627451, size: 1 },
    //     { x: 26.5467625899281, y: 3.41176470588235, size: 1 },
    //     { x: 38.2014388489209, y: 3.92156862745098, size: 1 },
    //     { x: 42.7338129496403, y: 3.37254901960784, size: 1 },
    //     { x: 43.3812949640288, y: 3.33333333333333, size: 1 },
    //     { x: 46.6187050359712, y: 2.94117647058824, size: 1 },
    //     { x: 47.2661870503597, y: 2.15686274509804, size: 1 },
    //     { x: 47.9136690647482, y: 2.94117647058824, size: 1 },
    //     { x: 53.7410071942446, y: 3.2156862745098, size: 1 },
    //     { x: 58.9208633093525, y: 3.41176470588235, size: 1 },
    //     { x: 66.6906474820144, y: 3.41176470588235, size: 1 },
    //     { x: 67.3381294964029, y: 3.01960784313725, size: 1 },
    //     { x: 68.6330935251799, y: 2.35294117647059, size: 1 },
    //     { x: 69.2805755395683, y: 2.19607843137255, size: 1 },
    //     { x: 81.5827338129496, y: 3.76470588235294, size: 1 },
    //     { x: 84.1726618705036, y: 3.76470588235294, size: 1 },
    //     { x: 84.8201438848921, y: 3.80392156862745, size: 1 },
    //     { x: 86.1151079136691, y: 3.88235294117647, size: 1 },
    //     { x: 91.294964028777, y: 3.45098039215686, size: 1 },
    //     { x: 100.359712230216, y: 4.03921568627451, size: 1 },
    //     { x: 101.654676258993, y: 3.33333333333333, size: 1 },
    //     { x: 108.129496402878, y: 3.37254901960784, size: 1 },
    //     { x: 109.424460431655, y: 3.41176470588235, size: 1 },
    //     { x: 124.31654676259, y: 3.88235294117647, size: 1 },
    //     { x: 127.553956834532, y: 3.80392156862745, size: 1 },
    //     { x: 130.791366906475, y: 3.96078431372549, size: 1 },
    //     { x: 163.165467625899, y: 3.41176470588235, size: 1 },
    //     { x: 165.107913669065, y: 4.03921568627451, size: 1 },
    //     { x: 174.820143884892, y: 3.17647058823529, size: 1 },
    //     { x: 175.467625899281, y: 3.09803921568627, size: 1 },
    //     { x: 176.115107913669, y: 2.94117647058824, size: 1 },
    //     { x: 176.762589928058, y: 2.47058823529412, size: 1 },
    //     { x: 185.179856115108, y: 3.96078431372549, size: 1 },
    //     { x: 189.064748201439, y: 3.96078431372549, size: 1 },
    //     { x: 191.007194244604, y: 3.84313725490196, size: 1 },
    //     { x: 196.834532374101, y: 3.13725490196078, size: 1 },
    //     { x: 205.89928057554, y: 3.72549019607843, size: 1 },
    //     { x: 221.438848920863, y: 3.96078431372549, size: 1 },
    //     { x: 222.086330935252, y: 3.76470588235294, size: 1 },
    //     { x: 231.798561151079, y: 3.29411764705882, size: 1 },
    //     { x: 247.985611510791, y: 3.37254901960784, size: 1 },
    //     { x: 249.280575539568, y: 3.29411764705882, size: 1 },
    //     { x: 249.928057553957, y: 3.25490196078431, size: 1 },
    //     { x: 252.517985611511, y: 3.33333333333333, size: 1 },
    //     { x: 253.812949640288, y: 3.52941176470588, size: 1 },
    //     { x: 255.755395683453, y: 3.25490196078431, size: 1 },
    //     { x: 258.992805755396, y: 3.37254901960784, size: 1 },
    //     { x: 259.640287769784, y: 3.6078431372549, size: 1 },
    //     { x: 265.467625899281, y: 3.17647058823529, size: 1 },
    //     { x: 266.762589928058, y: 3.29411764705882, size: 1 },
    //     { x: 269.352517985611, y: 3.09803921568627, size: 1 },
    //     { x: 270, y: 3.17647058823529, size: 1 },
    //     { x: 270.647482014389, y: 2.94117647058824, size: 1 },
    //     { x: 271.942446043165, y: 3.25490196078431, size: 1 },
    //     { x: 273.884892086331, y: 3.2156862745098, size: 1 },
    //     { x: 274.532374100719, y: 3.2156862745098, size: 1 },
    //     { x: 275.179856115108, y: 3.13725490196078, size: 1 },
    //     { x: 275.827338129496, y: 3.29411764705882, size: 1 },
    //     { x: 276.474820143885, y: 3.33333333333333, size: 1 },
    //     { x: 278.41726618705, y: 3.33333333333333, size: 1 },
    //     { x: 281.007194244604, y: 3.17647058823529, size: 1 },
    //     { x: 281.654676258993, y: 3.13725490196078, size: 1 },
    //     { x: 282.302158273381, y: 3.33333333333333, size: 1 },
    //     { x: 284.244604316547, y: 3.33333333333333, size: 1 },
    //     { x: 285.539568345324, y: 3.33333333333333, size: 1 },
    //     { x: 304.964028776978, y: 3.29411764705882, size: 1 },
    //     { x: 305.611510791367, y: 3.09803921568627, size: 1 },
    //     { x: 306.258992805755, y: 2.86274509803922, size: 1 },
    //     { x: 306.906474820144, y: 2.47058823529412, size: 1 },
    //     { x: 307.553956834532, y: 2.3921568627451, size: 1 },
    //     { x: 308.201438848921, y: 2.43137254901961, size: 1 },
    //     { x: 309.496402877698, y: 3.37254901960784, size: 1 },
    //     { x: 314.028776978417, y: 3.41176470588235, size: 1 },
    //     { x: 314.676258992806, y: 3.37254901960784, size: 1 },
    //     { x: 328.273381294964, y: 2.98039215686275, size: 1 },
    //     { x: 328.920863309353, y: 3.33333333333333, size: 1 },
    //     { x: 329.568345323741, y: 3.41176470588235, size: 1 },
    //     { x: 330.215827338129, y: 3.37254901960784, size: 1 },
    //     { x: 334.10071942446, y: 3.88235294117647, size: 1 },
    //     { x: 345.107913669065, y: 3.41176470588235, size: 1 },
    //     { x: 347.697841726619, y: 3.41176470588235, size: 1 },
    //     { x: 348.992805755396, y: 3.41176470588235, size: 1 },
    //     { x: 353.525179856115, y: 3.37254901960784, size: 1 },
    //     { x: 3.24324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 3.89189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 5.18918918918919, y: 3.6078431372549, size: 1 },
    //     { x: 6.48648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 9.08108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 9.72972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 10.3783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 11.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 11.6756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 12.3243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 12.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 17.5135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 18.1621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 20.7567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 21.4054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 22.7027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 24, y: 3.49019607843137, size: 1 },
    //     { x: 24.6486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 25.2972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 25.9459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 26.5945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 28.5405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 30.4864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 31.1351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 31.7837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 32.4324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 34.3783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 35.6756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 36.3243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 40.2162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 46.7027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 48.6486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 49.2972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 51.2432432432432, y: 3.6078431372549, size: 1 },
    //     { x: 53.1891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 53.8378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 54.4864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 55.7837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 57.0810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 58.3783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 60.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 62.9189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 64.2162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 68.1081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 68.7567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 69.4054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 70.7027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 73.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 74.5945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 75.2432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 79.1351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 79.7837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 82.3783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 83.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 83.6756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 84.3243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 85.6216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 86.2702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 86.9189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 87.5675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 88.2162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 89.5135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 92.1081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 96.6486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 97.2972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 101.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 104.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 105.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 106.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 107.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 108.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 111.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 112.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 113.513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 114.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 115.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 116.108108108108, y: 3.52941176470588, size: 1 },
    //     { x: 117.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 120, y: 3.45098039215686, size: 1 },
    //     { x: 123.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 127.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 128.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 129.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 129.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 130.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 131.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 132.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 133.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 134.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 134.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 140.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 140.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 142.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 144.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 148.540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 149.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 149.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 151.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 153.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 155.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 157.621621621622, y: 3.56862745098039, size: 1 },
    //     { x: 158.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 160.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 162.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 165.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 167.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 168, y: 3.80392156862745, size: 1 },
    //     { x: 171.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 173.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 174.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 175.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 176.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 177.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 179.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 180.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 182.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 182.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 183.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 184.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 185.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 186.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 190.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 191.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 193.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 193.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 195.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 201.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 203.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 203.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 206.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 206.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 208.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 210.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 210.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 212.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 212.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 214.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 216.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 217.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 219.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 222.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 223.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 225.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 227.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 227.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 230.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 232.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 238.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 238.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 239.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 240.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 241.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 242.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 243.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 243.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 244.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 246.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 247.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 247.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 248.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 250.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 254.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 258.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 259.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 260.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 264, y: 3.68627450980392, size: 1 },
    //     { x: 264.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 265.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 266.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 267.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 268.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 269.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 269.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 270.486486486487, y: 3.09803921568627, size: 1 },
    //     { x: 278.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 278.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 279.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 283.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 284.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 284.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 286.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 286.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 288, y: 3.84313725490196, size: 1 },
    //     { x: 288.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 289.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 290.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 293.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 294.486486486487, y: 3.45098039215686, size: 1 },
    //     { x: 295.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 296.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 297.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 299.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 300.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 303.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 304.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 307.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 308.756756756757, y: 4.19607843137255, size: 1 },
    //     { x: 310.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 311.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 312.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 313.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 313.945945945946, y: 2.90196078431373, size: 1 },
    //     { x: 316.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 317.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 319.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 319.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 321.72972972973, y: 3.6078431372549, size: 1 },
    //     { x: 324.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 324.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 331.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 333.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 334.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 334.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 335.351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 336, y: 3.29411764705882, size: 1 },
    //     { x: 336.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 337.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 338.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 342.486486486487, y: 3.80392156862745, size: 1 },
    //     { x: 343.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 345.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 347.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 349.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 350.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 351.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 353.513513513513, y: 3.41176470588235, size: 1 },
    //     { x: 354.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 354.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 356.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 357.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 3.23741007194245, y: 3.6078431372549, size: 1 },
    //     { x: 5.17985611510791, y: 3.88235294117647, size: 1 },
    //     { x: 7.76978417266187, y: 3.52941176470588, size: 1 },
    //     { x: 9.06474820143885, y: 3.88235294117647, size: 1 },
    //     { x: 16.1870503597122, y: 3.41176470588235, size: 1 },
    //     { x: 18.1294964028777, y: 2.86274509803922, size: 1 },
    //     { x: 18.7769784172662, y: 2.90196078431373, size: 1 },
    //     { x: 25.8992805755396, y: 3.96078431372549, size: 1 },
    //     { x: 81.5827338129496, y: 3.52941176470588, size: 1 },
    //     { x: 85.4676258992806, y: 3.88235294117647, size: 1 },
    //     { x: 89.3525179856115, y: 3.92156862745098, size: 1 },
    //     { x: 94.5323741007194, y: 3.84313725490196, size: 1 },
    //     { x: 97.7697841726619, y: 4.03921568627451, size: 1 },
    //     { x: 106.834532374101, y: 4, size: 1 },
    //     { x: 126.258992805755, y: 2.98039215686275, size: 1 },
    //     { x: 126.906474820144, y: 3.01960784313725, size: 1 },
    //     { x: 148.920863309353, y: 3.45098039215686, size: 1 },
    //     { x: 169.640287769784, y: 3.33333333333333, size: 1 },
    //     { x: 184.532374100719, y: 3.80392156862745, size: 1 },
    //     { x: 190.359712230216, y: 3.29411764705882, size: 1 },
    //     { x: 191.007194244604, y: 3.37254901960784, size: 1 },
    //     { x: 198.129496402878, y: 3.84313725490196, size: 1 },
    //     { x: 199.424460431655, y: 3.88235294117647, size: 1 },
    //     { x: 205.89928057554, y: 3.92156862745098, size: 1 },
    //     { x: 212.374100719424, y: 3.01960784313725, size: 1 },
    //     { x: 219.496402877698, y: 3.92156862745098, size: 1 },
    //     { x: 236.978417266187, y: 3.41176470588235, size: 1 },
    //     { x: 239.568345323741, y: 3.80392156862745, size: 1 },
    //     { x: 240.215827338129, y: 3.92156862745098, size: 1 },
    //     { x: 249.280575539568, y: 3.72549019607843, size: 1 },
    //     { x: 264.820143884892, y: 4.07843137254902, size: 1 },
    //     { x: 266.115107913669, y: 4.15686274509804, size: 1 },
    //     { x: 282.302158273381, y: 3.88235294117647, size: 1 },
    //     { x: 286.187050359712, y: 3.84313725490196, size: 1 },
    //     { x: 289.424460431655, y: 3.84313725490196, size: 1 },
    //     { x: 290.071942446043, y: 3.76470588235294, size: 1 },
    //     { x: 306.258992805755, y: 3.88235294117647, size: 1 },
    //     { x: 322.446043165468, y: 3.84313725490196, size: 1 },
    //     { x: 323.093525179856, y: 4, size: 1 },
    //     { x: 333.453237410072, y: 3.96078431372549, size: 1 },
    //     { x: 352.877697841727, y: 3.88235294117647, size: 1 },
    //     { x: 3.88489208633094, y: 2.98039215686275, size: 1 },
    //     { x: 24.6043165467626, y: 3.2156862745098, size: 1 },
    //     { x: 25.2517985611511, y: 3.17647058823529, size: 1 },
    //     { x: 27.1942446043165, y: 3.72549019607843, size: 1 },
    //     { x: 39.4964028776978, y: 3.80392156862745, size: 1 },
    //     { x: 53.7410071942446, y: 4.07843137254902, size: 1 },
    //     { x: 56.3309352517986, y: 3.96078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 3.41176470588235, size: 1 },
    //     { x: 66.6906474820144, y: 3.6078431372549, size: 1 },
    //     { x: 77.6978417266187, y: 3.88235294117647, size: 1 },
    //     { x: 97.1223021582734, y: 3.6078431372549, size: 1 },
    //     { x: 111.36690647482, y: 3.09803921568627, size: 1 },
    //     { x: 112.014388489209, y: 3.05882352941176, size: 1 },
    //     { x: 112.661870503597, y: 3.37254901960784, size: 1 },
    //     { x: 128.201438848921, y: 3.64705882352941, size: 1 },
    //     { x: 146.978417266187, y: 3.76470588235294, size: 1 },
    //     { x: 155.395683453237, y: 2.58823529411765, size: 1 },
    //     { x: 167.697841726619, y: 3.92156862745098, size: 1 },
    //     { x: 196.187050359712, y: 3.33333333333333, size: 1 },
    //     { x: 196.834532374101, y: 3.29411764705882, size: 1 },
    //     { x: 197.482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 198.129496402878, y: 2.58823529411765, size: 1 },
    //     { x: 216.906474820144, y: 3.80392156862745, size: 1 },
    //     { x: 220.791366906475, y: 3.80392156862745, size: 1 },
    //     { x: 238.920863309353, y: 3.41176470588235, size: 1 },
    //     { x: 240.215827338129, y: 3.37254901960784, size: 1 },
    //     { x: 240.863309352518, y: 3.25490196078431, size: 1 },
    //     { x: 247.338129496403, y: 3.80392156862745, size: 1 },
    //     { x: 247.985611510791, y: 3.96078431372549, size: 1 },
    //     { x: 250.575539568345, y: 3.64705882352941, size: 1 },
    //     { x: 254.460431654676, y: 4, size: 1 },
    //     { x: 255.755395683453, y: 3.88235294117647, size: 1 },
    //     { x: 260.935251798561, y: 3.13725490196078, size: 1 },
    //     { x: 261.58273381295, y: 3.17647058823529, size: 1 },
    //     { x: 262.230215827338, y: 3.01960784313725, size: 1 },
    //     { x: 262.877697841727, y: 3.09803921568627, size: 1 },
    //     { x: 263.525179856115, y: 2.98039215686275, size: 1 },
    //     { x: 279.064748201439, y: 3.84313725490196, size: 1 },
    //     { x: 280.359712230216, y: 3.88235294117647, size: 1 },
    //     { x: 282.94964028777, y: 3.37254901960784, size: 1 },
    //     { x: 283.597122302158, y: 2.98039215686275, size: 1 },
    //     { x: 284.244604316547, y: 2.62745098039216, size: 1 },
    //     { x: 284.892086330935, y: 2.35294117647059, size: 1 },
    //     { x: 294.604316546763, y: 3.92156862745098, size: 1 },
    //     { x: 300.431654676259, y: 3.96078431372549, size: 1 },
    //     { x: 306.258992805755, y: 3.25490196078431, size: 1 },
    //     { x: 325.68345323741, y: 3.25490196078431, size: 1 },
    //     { x: 326.330935251799, y: 3.2156862745098, size: 1 },
    //     { x: 327.625899280576, y: 2.27450980392157, size: 1 },
    //     { x: 332.805755395683, y: 3.92156862745098, size: 1 },
    //     { x: 348.992805755396, y: 3.33333333333333, size: 1 },
    //     { x: 9.71223021582734, y: 3.29411764705882, size: 1 },
    //     { x: 11.0071942446043, y: 2.62745098039216, size: 1 },
    //     { x: 11.6546762589928, y: 3.41176470588235, size: 1 },
    //     { x: 20.0719424460432, y: 3.92156862745098, size: 1 },
    //     { x: 35.6115107913669, y: 3.84313725490196, size: 1 },
    //     { x: 53.0935251798561, y: 3.13725490196078, size: 1 },
    //     { x: 53.7410071942446, y: 2.31372549019608, size: 1 },
    //     { x: 54.3884892086331, y: 2.27450980392157, size: 1 },
    //     { x: 61.5107913669065, y: 3.88235294117647, size: 1 },
    //     { x: 90.6474820143885, y: 3.80392156862745, size: 1 },
    //     { x: 95.1798561151079, y: 3.37254901960784, size: 1 },
    //     { x: 96.4748201438849, y: 3.2156862745098, size: 1 },
    //     { x: 97.7697841726619, y: 3.17647058823529, size: 1 },
    //     { x: 117.841726618705, y: 4, size: 1 },
    //     { x: 121.079136690647, y: 3.13725490196078, size: 1 },
    //     { x: 121.726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 122.374100719424, y: 3.25490196078431, size: 1 },
    //     { x: 126.258992805755, y: 3.25490196078431, size: 1 },
    //     { x: 129.496402877698, y: 3.41176470588235, size: 1 },
    //     { x: 130.143884892086, y: 3.17647058823529, size: 1 },
    //     { x: 132.086330935252, y: 3.13725490196078, size: 1 },
    //     { x: 132.73381294964, y: 3.37254901960784, size: 1 },
    //     { x: 134.028776978417, y: 3.33333333333333, size: 1 },
    //     { x: 135.323741007194, y: 3.2156862745098, size: 1 },
    //     { x: 137.913669064748, y: 3.25490196078431, size: 1 },
    //     { x: 139.856115107914, y: 2.90196078431373, size: 1 },
    //     { x: 140.503597122302, y: 3.05882352941176, size: 1 },
    //     { x: 162.517985611511, y: 3.33333333333333, size: 1 },
    //     { x: 183.237410071942, y: 3.09803921568627, size: 1 },
    //     { x: 183.884892086331, y: 2.74509803921569, size: 1 },
    //     { x: 200.071942446043, y: 3.80392156862745, size: 1 },
    //     { x: 204.604316546763, y: 3.29411764705882, size: 1 },
    //     { x: 205.89928057554, y: 3.25490196078431, size: 1 },
    //     { x: 206.546762589928, y: 3.17647058823529, size: 1 },
    //     { x: 207.194244604317, y: 3.05882352941176, size: 1 },
    //     { x: 209.136690647482, y: 3.29411764705882, size: 1 },
    //     { x: 211.079136690647, y: 3.17647058823529, size: 1 },
    //     { x: 212.374100719424, y: 3.33333333333333, size: 1 },
    //     { x: 213.021582733813, y: 3.17647058823529, size: 1 },
    //     { x: 214.964028776978, y: 3.25490196078431, size: 1 },
    //     { x: 215.611510791367, y: 3.33333333333333, size: 1 },
    //     { x: 216.258992805755, y: 3.17647058823529, size: 1 },
    //     { x: 216.906474820144, y: 3.17647058823529, size: 1 },
    //     { x: 217.553956834532, y: 3.33333333333333, size: 1 },
    //     { x: 223.381294964029, y: 3.2156862745098, size: 1 },
    //     { x: 224.028776978417, y: 3.17647058823529, size: 1 },
    //     { x: 225.323741007194, y: 2.94117647058824, size: 1 },
    //     { x: 225.971223021583, y: 3.05882352941176, size: 1 },
    //     { x: 226.618705035971, y: 1.6078431372549, size: 1 },
    //     { x: 227.26618705036, y: 1.45098039215686, size: 1 },
    //     { x: 227.913669064748, y: 1.56862745098039, size: 1 },
    //     { x: 228.561151079137, y: 1.17647058823529, size: 1 },
    //     { x: 231.151079136691, y: 2.86274509803922, size: 1 },
    //     { x: 235.68345323741, y: 3.01960784313725, size: 1 },
    //     { x: 236.330935251799, y: 3.01960784313725, size: 1 },
    //     { x: 241.510791366906, y: 3.37254901960784, size: 1 },
    //     { x: 242.158273381295, y: 2.82352941176471, size: 1 },
    //     { x: 242.805755395683, y: 3.29411764705882, size: 1 },
    //     { x: 244.748201438849, y: 3.33333333333333, size: 1 },
    //     { x: 245.395683453237, y: 3.33333333333333, size: 1 },
    //     { x: 246.690647482014, y: 3.2156862745098, size: 1 },
    //     { x: 247.338129496403, y: 3.13725490196078, size: 1 },
    //     { x: 247.985611510791, y: 2.11764705882353, size: 1 },
    //     { x: 248.63309352518, y: 2.35294117647059, size: 1 },
    //     { x: 270, y: 3.13725490196078, size: 1 },
    //     { x: 279.712230215827, y: 3.92156862745098, size: 1 },
    //     { x: 291.36690647482, y: 2.86274509803922, size: 1 },
    //     { x: 292.014388489209, y: 3.29411764705882, size: 1 },
    //     { x: 293.956834532374, y: 4, size: 1 },
    //     { x: 302.374100719424, y: 3.37254901960784, size: 1 },
    //     { x: 304.964028776978, y: 3.88235294117647, size: 1 },
    //     { x: 308.201438848921, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.05882352941176, size: 1 },
    //     { x: 312.086330935252, y: 2.98039215686275, size: 1 },
    //     { x: 312.73381294964, y: 1.68627450980392, size: 1 },
    //     { x: 313.381294964029, y: 1.64705882352941, size: 1 },
    //     { x: 316.618705035971, y: 3.2156862745098, size: 1 },
    //     { x: 321.151079136691, y: 3.84313725490196, size: 1 },
    //     { x: 324.388489208633, y: 3.33333333333333, size: 1 },
    //     { x: 326.330935251799, y: 3.37254901960784, size: 1 },
    //     { x: 328.273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 332.158273381295, y: 3.29411764705882, size: 1 },
    //     { x: 333.453237410072, y: 3.33333333333333, size: 1 },
    //     { x: 339.928057553957, y: 3.33333333333333, size: 1 },
    //     { x: 341.223021582734, y: 3.45098039215686, size: 1 },
    //     { x: 342.517985611511, y: 3.33333333333333, size: 1 },
    //     { x: 351.58273381295, y: 3.45098039215686, size: 1 },
    //     { x: 353.525179856115, y: 3.2156862745098, size: 1 },
    //     { x: 354.172661870504, y: 3.37254901960784, size: 1 },
    //     { x: 356.115107913669, y: 3.25490196078431, size: 1 },
    //     { x: 358.705035971223, y: 3.45098039215686, size: 1 },
    //     { x: 1.2972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 1.94594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 2.59459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 4.54054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 7.13513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 9.08108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 9.72972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 10.3783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 11.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 14.2702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 16.8648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 17.5135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 18.1621621621622, y: 2.94117647058824, size: 1 },
    //     { x: 20.1081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 21.4054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 27.8918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 28.5405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 29.1891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 31.7837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 33.7297297297297, y: 4.23529411764706, size: 1 },
    //     { x: 34.3783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 35.6756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 36.3243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 37.6216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 38.2702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 38.9189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 39.5675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 40.8648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 41.5135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 42.8108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 44.7567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 46.7027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 47.3513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 49.2972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 50.5945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 53.1891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 53.8378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 59.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 59.6756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 60.3243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 60.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 64.2162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 64.8648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 65.5135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 68.1081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 68.7567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 69.4054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 70.7027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 71.3513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 73.2972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 74.5945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 76.5405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 79.1351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 81.0810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 81.7297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 82.3783783783784, y: 2.70588235294118, size: 1 },
    //     { x: 83.027027027027, y: 2.62745098039216, size: 1 },
    //     { x: 83.6756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 84.3243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 84.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 86.2702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 86.9189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 89.5135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 90.1621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 92.1081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 94.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 94.7027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 97.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 99.2432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 100.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 101.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 102.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 103.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 103.783783783784, y: 2.58823529411765, size: 1 },
    //     { x: 104.432432432432, y: 2.62745098039216, size: 1 },
    //     { x: 105.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 107.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 108.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 110.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 111.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 112.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 113.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 114.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 116.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 121.297297297297, y: 4.07843137254902, size: 1 },
    //     { x: 123.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 124.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 125.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 127.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 129.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 129.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 134.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 136.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 136.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 138.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 140.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 141.405405405405, y: 3.64705882352941, size: 1 },
    //     { x: 142.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 143.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 145.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 145.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 147.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 148.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 149.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 153.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 158.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 158.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 159.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 161.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 162.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 164.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 167.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 168.648648648649, y: 3.68627450980392, size: 1 },
    //     { x: 169.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 171.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 173.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 176.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 178.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 180.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 181.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 183.567567567568, y: 4, size: 1 },
    //     { x: 184.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 191.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 194.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 197.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 201.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 206.27027027027, y: 4, size: 1 },
    //     { x: 207.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 209.513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 210.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 212.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 215.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 216, y: 3.76470588235294, size: 1 },
    //     { x: 216.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 217.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 218.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 221.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 225.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 227.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 228.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 229.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 230.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 232.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 232.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 233.513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 234.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 234.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 235.459459459459, y: 2.70588235294118, size: 1 },
    //     { x: 236.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 237.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 239.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 242.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 243.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 244.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 251.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 253.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 254.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 255.567567567568, y: 2.98039215686275, size: 1 },
    //     { x: 256.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 258.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 259.459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 265.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 267.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 267.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 268.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 271.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 273.72972972973, y: 4, size: 1 },
    //     { x: 275.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 276.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 276.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 277.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 280.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 282.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 284.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 285.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 286.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 288, y: 3.80392156862745, size: 1 },
    //     { x: 290.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 294.486486486487, y: 3.92156862745098, size: 1 },
    //     { x: 295.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 297.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 298.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 299.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 300.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 302.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 302.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 303.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 304.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 304.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 305.513513513513, y: 3.84313725490196, size: 1 },
    //     { x: 307.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 308.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 308.756756756757, y: 4, size: 1 },
    //     { x: 309.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 312.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 313.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 314.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 316.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 317.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 317.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 319.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 319.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 320.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 321.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 321.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 324.324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 324.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 326.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 327.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 328.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 329.513513513513, y: 3.64705882352941, size: 1 },
    //     { x: 338.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 339.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 341.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 343.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 343.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 345.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 347.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 352.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 358.702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 3.23741007194245, y: 3.01960784313725, size: 1 },
    //     { x: 3.88489208633094, y: 3.13725490196078, size: 1 },
    //     { x: 8.41726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 9.71223021582734, y: 3.80392156862745, size: 1 },
    //     { x: 17.4820143884892, y: 4, size: 1 },
    //     { x: 18.7769784172662, y: 3.76470588235294, size: 1 },
    //     { x: 25.2517985611511, y: 2.58823529411765, size: 1 },
    //     { x: 49.2086330935252, y: 3.80392156862745, size: 1 },
    //     { x: 67.9856115107914, y: 3.2156862745098, size: 1 },
    //     { x: 70.5755395683453, y: 3.92156862745098, size: 1 },
    //     { x: 71.8705035971223, y: 3.80392156862745, size: 1 },
    //     { x: 79.6402877697842, y: 3.92156862745098, size: 1 },
    //     { x: 81.5827338129496, y: 3.80392156862745, size: 1 },
    //     { x: 82.2302158273381, y: 4.03921568627451, size: 1 },
    //     { x: 83.5251798561151, y: 3.76470588235294, size: 1 },
    //     { x: 84.1726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 91.9424460431655, y: 3.88235294117647, size: 1 },
    //     { x: 96.4748201438849, y: 4.03921568627451, size: 1 },
    //     { x: 99.0647482014388, y: 4, size: 1 },
    //     { x: 99.7122302158273, y: 3.84313725490196, size: 1 },
    //     { x: 101.007194244604, y: 4.27450980392157, size: 1 },
    //     { x: 102.302158273381, y: 4.07843137254902, size: 1 },
    //     { x: 106.187050359712, y: 3.92156862745098, size: 1 },
    //     { x: 108.129496402878, y: 4, size: 1 },
    //     { x: 112.014388489209, y: 3.13725490196078, size: 1 },
    //     { x: 112.661870503597, y: 3.92156862745098, size: 1 },
    //     { x: 113.309352517986, y: 3.84313725490196, size: 1 },
    //     { x: 117.194244604317, y: 4.03921568627451, size: 1 },
    //     { x: 119.136690647482, y: 3.88235294117647, size: 1 },
    //     { x: 122.374100719424, y: 4, size: 1 },
    //     { x: 123.021582733813, y: 3.96078431372549, size: 1 },
    //     { x: 123.669064748201, y: 4, size: 1 },
    //     { x: 124.31654676259, y: 4, size: 1 },
    //     { x: 126.258992805755, y: 3.92156862745098, size: 1 },
    //     { x: 128.848920863309, y: 4.07843137254902, size: 1 },
    //     { x: 129.496402877698, y: 3.84313725490196, size: 1 },
    //     { x: 130.143884892086, y: 4, size: 1 },
    //     { x: 132.73381294964, y: 3.09803921568627, size: 1 },
    //     { x: 133.381294964029, y: 3.05882352941176, size: 1 },
    //     { x: 134.676258992806, y: 3.84313725490196, size: 1 },
    //     { x: 141.151079136691, y: 3.92156862745098, size: 1 },
    //     { x: 147.625899280576, y: 3.92156862745098, size: 1 },
    //     { x: 148.273381294964, y: 4, size: 1 },
    //     { x: 152.158273381295, y: 3.96078431372549, size: 1 },
    //     { x: 153.453237410072, y: 3.2156862745098, size: 1 },
    //     { x: 165.755395683453, y: 3.80392156862745, size: 1 },
    //     { x: 172.230215827338, y: 4.07843137254902, size: 1 },
    //     { x: 186.474820143885, y: 3.80392156862745, size: 1 },
    //     { x: 196.834532374101, y: 3.41176470588235, size: 1 },
    //     { x: 214.964028776978, y: 3.41176470588235, size: 1 },
    //     { x: 218.201438848921, y: 3.2156862745098, size: 1 },
    //     { x: 219.496402877698, y: 2.86274509803922, size: 1 },
    //     { x: 220.143884892086, y: 2.98039215686275, size: 1 },
    //     { x: 226.618705035971, y: 3.41176470588235, size: 1 },
    //     { x: 227.26618705036, y: 3.29411764705882, size: 1 },
    //     { x: 244.10071942446, y: 3.92156862745098, size: 1 },
    //     { x: 249.280575539568, y: 3.76470588235294, size: 1 },
    //     { x: 258.345323741007, y: 3.92156862745098, size: 1 },
    //     { x: 262.230215827338, y: 3.88235294117647, size: 1 },
    //     { x: 262.877697841727, y: 3.25490196078431, size: 1 },
    //     { x: 276.474820143885, y: 3.84313725490196, size: 1 },
    //     { x: 284.244604316547, y: 2.90196078431373, size: 1 },
    //     { x: 302.374100719424, y: 3.41176470588235, size: 1 },
    //     { x: 306.258992805755, y: 3.49019607843137, size: 1 },
    //     { x: 313.381294964029, y: 3.41176470588235, size: 1 },
    //     { x: 316.618705035971, y: 3.37254901960784, size: 1 },
    //     { x: 320.503597122302, y: 3.84313725490196, size: 1 },
    //     { x: 326.978417266187, y: 3.13725490196078, size: 1 },
    //     { x: 356.762589928058, y: 3.92156862745098, size: 1 },
    //     { x: 37.5539568345324, y: 3.72549019607843, size: 1 },
    //     { x: 52.4460431654676, y: 3.45098039215686, size: 1 },
    //     { x: 53.7410071942446, y: 3.09803921568627, size: 1 },
    //     { x: 60.863309352518, y: 3.37254901960784, size: 1 },
    //     { x: 66.6906474820144, y: 3.45098039215686, size: 1 },
    //     { x: 77.6978417266187, y: 3.92156862745098, size: 1 },
    //     { x: 83.5251798561151, y: 3.84313725490196, size: 1 },
    //     { x: 86.7625899280576, y: 3.84313725490196, size: 1 },
    //     { x: 94.5323741007194, y: 3.25490196078431, size: 1 },
    //     { x: 95.8273381294964, y: 3.09803921568627, size: 1 },
    //     { x: 96.4748201438849, y: 2.98039215686275, size: 1 },
    //     { x: 97.1223021582734, y: 2.7843137254902, size: 1 },
    //     { x: 113.956834532374, y: 3.84313725490196, size: 1 },
    //     { x: 117.841726618705, y: 3.13725490196078, size: 1 },
    //     { x: 119.784172661871, y: 3.2156862745098, size: 1 },
    //     { x: 121.079136690647, y: 3.33333333333333, size: 1 },
    //     { x: 128.848920863309, y: 3.29411764705882, size: 1 },
    //     { x: 139.856115107914, y: 2.98039215686275, size: 1 },
    //     { x: 140.503597122302, y: 2.7843137254902, size: 1 },
    //     { x: 152.158273381295, y: 3.29411764705882, size: 1 },
    //     { x: 157.338129496403, y: 3.41176470588235, size: 1 },
    //     { x: 159.928057553957, y: 3.29411764705882, size: 1 },
    //     { x: 161.223021582734, y: 3.09803921568627, size: 1 },
    //     { x: 161.870503597122, y: 2.82352941176471, size: 1 },
    //     { x: 164.460431654676, y: 3.41176470588235, size: 1 },
    //     { x: 167.697841726619, y: 3.37254901960784, size: 1 },
    //     { x: 174.172661870504, y: 3.25490196078431, size: 1 },
    //     { x: 174.820143884892, y: 3.45098039215686, size: 1 },
    //     { x: 183.884892086331, y: 3.37254901960784, size: 1 },
    //     { x: 186.474820143885, y: 3.45098039215686, size: 1 },
    //     { x: 189.064748201439, y: 3.29411764705882, size: 1 },
    //     { x: 195.539568345324, y: 3.41176470588235, size: 1 },
    //     { x: 201.36690647482, y: 3.37254901960784, size: 1 },
    //     { x: 225.971223021583, y: 2.82352941176471, size: 1 },
    //     { x: 226.618705035971, y: 2.82352941176471, size: 1 },
    //     { x: 247.985611510791, y: 3.09803921568627, size: 1 },
    //     { x: 251.223021582734, y: 3.92156862745098, size: 1 },
    //     { x: 263.525179856115, y: 3.88235294117647, size: 1 },
    //     { x: 268.705035971223, y: 3.13725490196078, size: 1 },
    //     { x: 269.352517985611, y: 2.47058823529412, size: 1 },
    //     { x: 270, y: 2.07843137254902, size: 1 },
    //     { x: 282.302158273381, y: 4.03921568627451, size: 1 },
    //     { x: 297.841726618705, y: 3.88235294117647, size: 1 },
    //     { x: 305.611510791367, y: 3.37254901960784, size: 1 },
    //     { x: 306.906474820144, y: 3.41176470588235, size: 1 },
    //     { x: 308.201438848921, y: 3.33333333333333, size: 1 },
    //     { x: 310.143884892086, y: 3.25490196078431, size: 1 },
    //     { x: 312.73381294964, y: 3.17647058823529, size: 1 },
    //     { x: 318.561151079137, y: 3.88235294117647, size: 1 },
    //     { x: 332.805755395683, y: 3.37254901960784, size: 1 },
    //     { x: 333.453237410072, y: 3.05882352941176, size: 1 },
    //     { x: 334.748201438849, y: 2.82352941176471, size: 1 },
    //     { x: 354.172661870504, y: 3.25490196078431, size: 1 },
    //     { x: 355.467625899281, y: 2.7843137254902, size: 1 },
    //     { x: 356.115107913669, y: 2.54901960784314, size: 1 },
    //     { x: 358.705035971223, y: 3.84313725490196, size: 1 },
    //     { x: 0.647482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 3.88489208633094, y: 3.41176470588235, size: 1 },
    //     { x: 5.8273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 16.8345323741007, y: 3.41176470588235, size: 1 },
    //     { x: 17.4820143884892, y: 3.01960784313725, size: 1 },
    //     { x: 18.1294964028777, y: 3.25490196078431, size: 1 },
    //     { x: 21.3669064748201, y: 3.84313725490196, size: 1 },
    //     { x: 22.0143884892086, y: 4.07843137254902, size: 1 },
    //     { x: 27.841726618705, y: 3.88235294117647, size: 1 },
    //     { x: 31.726618705036, y: 3.84313725490196, size: 1 },
    //     { x: 38.2014388489209, y: 3.25490196078431, size: 1 },
    //     { x: 38.8489208633094, y: 2.50980392156863, size: 1 },
    //     { x: 39.4964028776978, y: 2.58823529411765, size: 1 },
    //     { x: 42.7338129496403, y: 4, size: 1 },
    //     { x: 44.6762589928058, y: 4, size: 1 },
    //     { x: 48.5611510791367, y: 3.92156862745098, size: 1 },
    //     { x: 56.9784172661871, y: 3.45098039215686, size: 1 },
    //     { x: 60.2158273381295, y: 2.94117647058824, size: 1 },
    //     { x: 60.863309352518, y: 3.09803921568627, size: 1 },
    //     { x: 65.3956834532374, y: 4, size: 1 },
    //     { x: 81.5827338129496, y: 3.25490196078431, size: 1 },
    //     { x: 82.2302158273381, y: 3.2156862745098, size: 1 },
    //     { x: 82.8776978417266, y: 3.2156862745098, size: 1 },
    //     { x: 84.1726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 84.8201438848921, y: 3.37254901960784, size: 1 },
    //     { x: 86.1151079136691, y: 3.41176470588235, size: 1 },
    //     { x: 87.410071942446, y: 3.80392156862745, size: 1 },
    //     { x: 89.3525179856115, y: 3.41176470588235, size: 1 },
    //     { x: 90.6474820143885, y: 3.25490196078431, size: 1 },
    //     { x: 92.589928057554, y: 3.17647058823529, size: 1 },
    //     { x: 93.8848920863309, y: 3.17647058823529, size: 1 },
    //     { x: 94.5323741007194, y: 3.2156862745098, size: 1 },
    //     { x: 95.1798561151079, y: 3.29411764705882, size: 1 },
    //     { x: 95.8273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 97.7697841726619, y: 3.45098039215686, size: 1 },
    //     { x: 100.359712230216, y: 3.2156862745098, size: 1 },
    //     { x: 125.611510791367, y: 2.86274509803922, size: 1 },
    //     { x: 133.381294964029, y: 3.84313725490196, size: 1 },
    //     { x: 137.913669064748, y: 3.80392156862745, size: 1 },
    //     { x: 146.978417266187, y: 3.05882352941176, size: 1 },
    //     { x: 153.453237410072, y: 3.96078431372549, size: 1 },
    //     { x: 160.575539568345, y: 3.37254901960784, size: 1 },
    //     { x: 168.345323741007, y: 2.86274509803922, size: 1 },
    //     { x: 168.992805755396, y: 2.74509803921569, size: 1 },
    //     { x: 175.467625899281, y: 3.41176470588235, size: 1 },
    //     { x: 198.129496402878, y: 3.49019607843137, size: 1 },
    //     { x: 200.071942446043, y: 3.37254901960784, size: 1 },
    //     { x: 202.014388489209, y: 3.37254901960784, size: 1 },
    //     { x: 209.784172661871, y: 3.76470588235294, size: 1 },
    //     { x: 213.669064748201, y: 3.25490196078431, size: 1 },
    //     { x: 214.31654676259, y: 3.33333333333333, size: 1 },
    //     { x: 218.201438848921, y: 3.41176470588235, size: 1 },
    //     { x: 218.848920863309, y: 3.37254901960784, size: 1 },
    //     { x: 221.438848920863, y: 3.88235294117647, size: 1 },
    //     { x: 229.208633093525, y: 3.2156862745098, size: 1 },
    //     { x: 231.798561151079, y: 3.33333333333333, size: 1 },
    //     { x: 232.446043165468, y: 3.2156862745098, size: 1 },
    //     { x: 233.093525179856, y: 2.74509803921569, size: 1 },
    //     { x: 233.741007194245, y: 2.82352941176471, size: 1 },
    //     { x: 245.395683453237, y: 3.41176470588235, size: 1 },
    //     { x: 253.165467625899, y: 3.29411764705882, size: 1 },
    //     { x: 254.460431654676, y: 2.70588235294118, size: 1 },
    //     { x: 255.107913669065, y: 2.7843137254902, size: 1 },
    //     { x: 268.057553956835, y: 3.37254901960784, size: 1 },
    //     { x: 275.827338129496, y: 3.05882352941176, size: 1 },
    //     { x: 276.474820143885, y: 2.58823529411765, size: 1 },
    //     { x: 294.604316546763, y: 4, size: 1 },
    //     { x: 298.489208633094, y: 3.17647058823529, size: 1 },
    //     { x: 303.021582733813, y: 3.41176470588235, size: 1 },
    //     { x: 317.913669064748, y: 3.45098039215686, size: 1 },
    //     { x: 319.856115107914, y: 3.2156862745098, size: 1 },
    //     { x: 334.10071942446, y: 3.52941176470588, size: 1 },
    //     { x: 341.223021582734, y: 2.90196078431373, size: 1 },
    //     { x: 341.870503597122, y: 3.13725490196078, size: 1 },
    //     { x: 347.05035971223, y: 3.41176470588235, size: 1 },
    //     { x: 353.525179856115, y: 3.49019607843137, size: 1 },
    //     { x: 355.467625899281, y: 3.37254901960784, size: 1 },
    //     { x: 0.648648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 1.2972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 2.59459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 3.24324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 5.83783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 6.48648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 7.78378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 8.43243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 9.72972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 11.6756756756757, y: 3.6078431372549, size: 1 },
    //     { x: 13.6216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 14.9189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 16.8648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 17.5135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 22.0540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 24, y: 3.01960784313725, size: 1 },
    //     { x: 24.6486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 25.2972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 27.2432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 29.1891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 29.8378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 31.7837837837838, y: 3.64705882352941, size: 1 },
    //     { x: 32.4324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 33.7297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 35.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 35.6756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 36.3243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 36.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 38.2702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 39.5675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 44.1081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 45.4054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 46.0540540540541, y: 2.90196078431373, size: 1 },
    //     { x: 48, y: 3.84313725490196, size: 1 },
    //     { x: 49.2972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 50.5945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 51.2432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 51.8918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 54.4864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 56.4324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 59.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 59.6756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 62.2702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 64.8648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 67.4594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 68.1081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 68.7567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 73.2972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 74.5945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 75.8918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 77.1891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 77.8378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 78.4864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 79.1351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 79.7837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 81.0810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 83.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 83.6756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 86.2702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 86.9189189189189, y: 3.56862745098039, size: 1 },
    //     { x: 87.5675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 88.8648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 89.5135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 90.1621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 92.1081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 94.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 94.7027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 96, y: 3.56862745098039, size: 1 },
    //     { x: 97.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 98.5945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 102.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 104.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 106.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 107.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 107.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 108.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 108.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 110.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 114.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 114.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 116.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 116.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 120, y: 3.49019607843137, size: 1 },
    //     { x: 122.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 123.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 127.135135135135, y: 3.64705882352941, size: 1 },
    //     { x: 130.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 131.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 131.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 132.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 132.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 134.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 136.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 137.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 142.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 142.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 144, y: 3.6078431372549, size: 1 },
    //     { x: 148.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 152.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 153.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 153.72972972973, y: 2.47058823529412, size: 1 },
    //     { x: 154.378378378378, y: 2.31372549019608, size: 1 },
    //     { x: 155.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 157.621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 159.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 161.513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 163.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 166.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 166.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 168.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 169.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 169.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 173.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 175.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 175.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 176.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 179.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 183.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 188.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 190.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 192, y: 3.56862745098039, size: 1 },
    //     { x: 195.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 196.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 197.189189189189, y: 2.66666666666667, size: 1 },
    //     { x: 197.837837837838, y: 2.74509803921569, size: 1 },
    //     { x: 198.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 200.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 206.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 206.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 207.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 210.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 210.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 211.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 212.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 214.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 216, y: 3.92156862745098, size: 1 },
    //     { x: 217.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 217.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 218.594594594595, y: 2.62745098039216, size: 1 },
    //     { x: 219.243243243243, y: 2.35294117647059, size: 1 },
    //     { x: 223.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 224.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 225.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 228.324324324324, y: 3.6078431372549, size: 1 },
    //     { x: 234.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 235.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 236.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 238.054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 238.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 239.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 240, y: 3.05882352941176, size: 1 },
    //     { x: 240.648648648649, y: 2.66666666666667, size: 1 },
    //     { x: 241.297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 241.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 242.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 243.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 243.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 245.189189189189, y: 3.6078431372549, size: 1 },
    //     { x: 247.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 248.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 252.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 252.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 256.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 256.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 258.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 259.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 261.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 262.054054054054, y: 2.86274509803922, size: 1 },
    //     { x: 262.702702702703, y: 2.7843137254902, size: 1 },
    //     { x: 263.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 264, y: 3.76470588235294, size: 1 },
    //     { x: 265.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 269.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 274.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 277.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 278.918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 279.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 282.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 286.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 289.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 289.945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 291.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 292.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 302.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 302.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 303.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 304.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 304.864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 305.513513513513, y: 1.76470588235294, size: 1 },
    //     { x: 306.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 308.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 311.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 312.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 313.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 315.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 318.486486486487, y: 3.29411764705882, size: 1 },
    //     { x: 320.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 321.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 322.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 324.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 325.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 326.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 326.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 328.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 330.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 334.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 335.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 336, y: 3.80392156862745, size: 1 },
    //     { x: 336.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 338.594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 339.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 344.432432432432, y: 3.72549019607843, size: 1 },
    //     { x: 346.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 347.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 348.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 349.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 350.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 350.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 351.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 352.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 352.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 355.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 356.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 1.94244604316547, y: 3.29411764705882, size: 1 },
    //     { x: 3.88489208633094, y: 3.49019607843137, size: 1 },
    //     { x: 9.06474820143885, y: 3.01960784313725, size: 1 },
    //     { x: 32.3741007194245, y: 3.80392156862745, size: 1 },
    //     { x: 51.7985611510791, y: 3.2156862745098, size: 1 },
    //     { x: 52.4460431654676, y: 3.25490196078431, size: 1 },
    //     { x: 54.3884892086331, y: 3.41176470588235, size: 1 },
    //     { x: 56.3309352517986, y: 3.37254901960784, size: 1 },
    //     { x: 56.9784172661871, y: 3.37254901960784, size: 1 },
    //     { x: 73.8129496402878, y: 3.13725490196078, size: 1 },
    //     { x: 80.9352517985612, y: 3.33333333333333, size: 1 },
    //     { x: 87.410071942446, y: 3.45098039215686, size: 1 },
    //     { x: 94.5323741007194, y: 3.45098039215686, size: 1 },
    //     { x: 102.94964028777, y: 3.96078431372549, size: 1 },
    //     { x: 112.014388489209, y: 3.84313725490196, size: 1 },
    //     { x: 115.89928057554, y: 3.84313725490196, size: 1 },
    //     { x: 135.971223021583, y: 3.88235294117647, size: 1 },
    //     { x: 151.510791366906, y: 3.37254901960784, size: 1 },
    //     { x: 162.517985611511, y: 3.37254901960784, size: 1 },
    //     { x: 163.165467625899, y: 3.29411764705882, size: 1 },
    //     { x: 164.460431654676, y: 3.45098039215686, size: 1 },
    //     { x: 165.107913669065, y: 4.07843137254902, size: 1 },
    //     { x: 169.640287769784, y: 3.96078431372549, size: 1 },
    //     { x: 182.589928057554, y: 3.05882352941176, size: 1 },
    //     { x: 183.884892086331, y: 3.17647058823529, size: 1 },
    //     { x: 185.179856115108, y: 3.2156862745098, size: 1 },
    //     { x: 194.892086330935, y: 3.37254901960784, size: 1 },
    //     { x: 202.661870503597, y: 3.33333333333333, size: 1 },
    //     { x: 203.309352517986, y: 3.37254901960784, size: 1 },
    //     { x: 204.604316546763, y: 3.25490196078431, size: 1 },
    //     { x: 205.251798561151, y: 2.98039215686275, size: 1 },
    //     { x: 205.89928057554, y: 2.82352941176471, size: 1 },
    //     { x: 214.964028776978, y: 3.37254901960784, size: 1 },
    //     { x: 225.971223021583, y: 3.17647058823529, size: 1 },
    //     { x: 226.618705035971, y: 3.17647058823529, size: 1 },
    //     { x: 240.215827338129, y: 4, size: 1 },
    //     { x: 244.10071942446, y: 3.29411764705882, size: 1 },
    //     { x: 248.63309352518, y: 4.23529411764706, size: 1 },
    //     { x: 249.280575539568, y: 3.96078431372549, size: 1 },
    //     { x: 257.05035971223, y: 4.19607843137255, size: 1 },
    //     { x: 268.057553956835, y: 3.41176470588235, size: 1 },
    //     { x: 268.705035971223, y: 3.2156862745098, size: 1 },
    //     { x: 269.352517985611, y: 2.90196078431373, size: 1 },
    //     { x: 274.532374100719, y: 3.92156862745098, size: 1 },
    //     { x: 275.827338129496, y: 3.92156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.92156862745098, size: 1 },
    //     { x: 285.539568345324, y: 4, size: 1 },
    //     { x: 290.719424460432, y: 3.33333333333333, size: 1 },
    //     { x: 294.604316546763, y: 3.84313725490196, size: 1 },
    //     { x: 300.431654676259, y: 3.88235294117647, size: 1 },
    //     { x: 305.611510791367, y: 4.03921568627451, size: 1 },
    //     { x: 312.73381294964, y: 3.41176470588235, size: 1 },
    //     { x: 314.028776978417, y: 3.88235294117647, size: 1 },
    //     { x: 315.323741007194, y: 4.07843137254902, size: 1 },
    //     { x: 318.561151079137, y: 3.96078431372549, size: 1 },
    //     { x: 331.510791366906, y: 3.84313725490196, size: 1 },
    //     { x: 350.287769784173, y: 4.07843137254902, size: 1 },
    //     { x: 12.9496402877698, y: 3.49019607843137, size: 1 },
    //     { x: 13.5971223021583, y: 3.76470588235294, size: 1 },
    //     { x: 38.8489208633094, y: 3.09803921568627, size: 1 },
    //     { x: 39.4964028776978, y: 3.25490196078431, size: 1 },
    //     { x: 47.2661870503597, y: 3.41176470588235, size: 1 },
    //     { x: 52.4460431654676, y: 3.33333333333333, size: 1 },
    //     { x: 55.6834532374101, y: 3.45098039215686, size: 1 },
    //     { x: 56.3309352517986, y: 3.45098039215686, size: 1 },
    //     { x: 64.7482014388489, y: 4.03921568627451, size: 1 },
    //     { x: 73.1654676258993, y: 3.37254901960784, size: 1 },
    //     { x: 78.9928057553957, y: 3.37254901960784, size: 1 },
    //     { x: 85.4676258992806, y: 3.37254901960784, size: 1 },
    //     { x: 88.0575539568345, y: 3.84313725490196, size: 1 },
    //     { x: 91.294964028777, y: 3.96078431372549, size: 1 },
    //     { x: 105.539568345324, y: 3.96078431372549, size: 1 },
    //     { x: 115.251798561151, y: 3.84313725490196, size: 1 },
    //     { x: 119.136690647482, y: 3.84313725490196, size: 1 },
    //     { x: 120.431654676259, y: 3.88235294117647, size: 1 },
    //     { x: 133.381294964029, y: 3.92156862745098, size: 1 },
    //     { x: 135.971223021583, y: 3.96078431372549, size: 1 },
    //     { x: 137.26618705036, y: 4, size: 1 },
    //     { x: 143.093525179856, y: 3.92156862745098, size: 1 },
    //     { x: 167.697841726619, y: 3.2156862745098, size: 1 },
    //     { x: 168.345323741007, y: 3.17647058823529, size: 1 },
    //     { x: 189.712230215827, y: 3.33333333333333, size: 1 },
    //     { x: 192.302158273381, y: 3.25490196078431, size: 1 },
    //     { x: 196.187050359712, y: 3.2156862745098, size: 1 },
    //     { x: 198.129496402878, y: 3.2156862745098, size: 1 },
    //     { x: 201.36690647482, y: 3.29411764705882, size: 1 },
    //     { x: 208.489208633094, y: 3.33333333333333, size: 1 },
    //     { x: 211.726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 217.553956834532, y: 3.76470588235294, size: 1 },
    //     { x: 224.028776978417, y: 3.80392156862745, size: 1 },
    //     { x: 233.093525179856, y: 3.13725490196078, size: 1 },
    //     { x: 242.805755395683, y: 3.41176470588235, size: 1 },
    //     { x: 244.10071942446, y: 3.41176470588235, size: 1 },
    //     { x: 247.985611510791, y: 3.80392156862745, size: 1 },
    //     { x: 255.755395683453, y: 3.49019607843137, size: 1 },
    //     { x: 260.287769784173, y: 3.29411764705882, size: 1 },
    //     { x: 264.172661870504, y: 3.92156862745098, size: 1 },
    //     { x: 271.294964028777, y: 3.37254901960784, size: 1 },
    //     { x: 273.237410071942, y: 3.33333333333333, size: 1 },
    //     { x: 275.827338129496, y: 3.25490196078431, size: 1 },
    //     { x: 276.474820143885, y: 3.25490196078431, size: 1 },
    //     { x: 277.769784172662, y: 3.37254901960784, size: 1 },
    //     { x: 279.064748201439, y: 3.33333333333333, size: 1 },
    //     { x: 282.302158273381, y: 3.29411764705882, size: 1 },
    //     { x: 286.187050359712, y: 3.41176470588235, size: 1 },
    //     { x: 288.129496402878, y: 3.33333333333333, size: 1 },
    //     { x: 292.661870503597, y: 3.33333333333333, size: 1 },
    //     { x: 293.956834532374, y: 3.45098039215686, size: 1 },
    //     { x: 301.726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 312.086330935252, y: 3.96078431372549, size: 1 },
    //     { x: 319.208633093525, y: 3.88235294117647, size: 1 },
    //     { x: 319.856115107914, y: 3.33333333333333, size: 1 },
    //     { x: 334.10071942446, y: 3.45098039215686, size: 1 },
    //     { x: 336.043165467626, y: 3.29411764705882, size: 1 },
    //     { x: 337.985611510791, y: 3.45098039215686, size: 1 },
    //     { x: 340.575539568345, y: 3.45098039215686, size: 1 },
    //     { x: 341.223021582734, y: 3.37254901960784, size: 1 },
    //     { x: 352.230215827338, y: 3.88235294117647, size: 1 },
    //     { x: 356.762589928058, y: 3.84313725490196, size: 1 },
    //     { x: 1.29496402877698, y: 3.88235294117647, size: 1 },
    //     { x: 2.58992805755396, y: 3.29411764705882, size: 1 },
    //     { x: 7.76978417266187, y: 3.96078431372549, size: 1 },
    //     { x: 18.1294964028777, y: 3.76470588235294, size: 1 },
    //     { x: 27.1942446043165, y: 3.84313725490196, size: 1 },
    //     { x: 29.136690647482, y: 3.96078431372549, size: 1 },
    //     { x: 39.4964028776978, y: 4, size: 1 },
    //     { x: 44.0287769784173, y: 3.37254901960784, size: 1 },
    //     { x: 44.6762589928058, y: 3.29411764705882, size: 1 },
    //     { x: 45.3237410071942, y: 3.29411764705882, size: 1 },
    //     { x: 45.9712230215827, y: 3.2156862745098, size: 1 },
    //     { x: 46.6187050359712, y: 3.92156862745098, size: 1 },
    //     { x: 47.9136690647482, y: 3.92156862745098, size: 1 },
    //     { x: 71.2230215827338, y: 3.92156862745098, size: 1 },
    //     { x: 91.9424460431655, y: 3.29411764705882, size: 1 },
    //     { x: 99.0647482014388, y: 3.29411764705882, size: 1 },
    //     { x: 99.7122302158273, y: 3.29411764705882, size: 1 },
    //     { x: 103.597122302158, y: 3.41176470588235, size: 1 },
    //     { x: 116.546762589928, y: 3.84313725490196, size: 1 },
    //     { x: 142.446043165468, y: 3.88235294117647, size: 1 },
    //     { x: 143.741007194245, y: 3.37254901960784, size: 1 },
    //     { x: 152.805755395683, y: 3.80392156862745, size: 1 },
    //     { x: 178.057553956835, y: 3.88235294117647, size: 1 },
    //     { x: 196.834532374101, y: 3.05882352941176, size: 1 },
    //     { x: 197.482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 206.546762589928, y: 4.07843137254902, size: 1 },
    //     { x: 207.194244604317, y: 3.80392156862745, size: 1 },
    //     { x: 213.669064748201, y: 3.92156862745098, size: 1 },
    //     { x: 227.913669064748, y: 3.80392156862745, size: 1 },
    //     { x: 233.093525179856, y: 3.96078431372549, size: 1 },
    //     { x: 239.568345323741, y: 3.29411764705882, size: 1 },
    //     { x: 240.215827338129, y: 3.25490196078431, size: 1 },
    //     { x: 246.690647482014, y: 3.76470588235294, size: 1 },
    //     { x: 259.640287769784, y: 3.17647058823529, size: 1 },
    //     { x: 261.58273381295, y: 3.05882352941176, size: 1 },
    //     { x: 262.230215827338, y: 3.25490196078431, size: 1 },
    //     { x: 277.122302158273, y: 3.92156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.80392156862745, size: 1 },
    //     { x: 282.302158273381, y: 3.84313725490196, size: 1 },
    //     { x: 287.482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 288.776978417266, y: 3.88235294117647, size: 1 },
    //     { x: 290.719424460432, y: 3.92156862745098, size: 1 },
    //     { x: 304.31654676259, y: 3.41176470588235, size: 1 },
    //     { x: 311.438848920863, y: 3.80392156862745, size: 1 },
    //     { x: 312.73381294964, y: 3.33333333333333, size: 1 },
    //     { x: 326.330935251799, y: 3.13725490196078, size: 1 },
    //     { x: 328.273381294964, y: 3.80392156862745, size: 1 },
    //     { x: 354.172661870504, y: 3.80392156862745, size: 1 },
    //     { x: 16.1870503597122, y: 3.92156862745098, size: 1 },
    //     { x: 18.7769784172662, y: 3.92156862745098, size: 1 },
    //     { x: 22.6618705035971, y: 3.80392156862745, size: 1 },
    //     { x: 27.1942446043165, y: 3.92156862745098, size: 1 },
    //     { x: 31.726618705036, y: 3.45098039215686, size: 1 },
    //     { x: 44.0287769784173, y: 3.88235294117647, size: 1 },
    //     { x: 53.0935251798561, y: 3.25490196078431, size: 1 },
    //     { x: 58.9208633093525, y: 3.49019607843137, size: 1 },
    //     { x: 74.4604316546763, y: 3.05882352941176, size: 1 },
    //     { x: 75.1079136690647, y: 3.80392156862745, size: 1 },
    //     { x: 97.7697841726619, y: 3.76470588235294, size: 1 },
    //     { x: 99.0647482014388, y: 3.88235294117647, size: 1 },
    //     { x: 132.086330935252, y: 4, size: 1 },
    //     { x: 135.323741007194, y: 3.33333333333333, size: 1 },
    //     { x: 139.208633093525, y: 3.05882352941176, size: 1 },
    //     { x: 141.151079136691, y: 3.29411764705882, size: 1 },
    //     { x: 146.330935251799, y: 3.29411764705882, size: 1 },
    //     { x: 159.280575539568, y: 3.33333333333333, size: 1 },
    //     { x: 159.928057553957, y: 3.25490196078431, size: 1 },
    //     { x: 161.223021582734, y: 3.17647058823529, size: 1 },
    //     { x: 161.870503597122, y: 2.98039215686275, size: 1 },
    //     { x: 162.517985611511, y: 2.82352941176471, size: 1 },
    //     { x: 180.647482014388, y: 3.2156862745098, size: 1 },
    //     { x: 181.294964028777, y: 3.13725490196078, size: 1 },
    //     { x: 181.942446043165, y: 2.62745098039216, size: 1 },
    //     { x: 182.589928057554, y: 2.27450980392157, size: 1 },
    //     { x: 187.122302158273, y: 3.92156862745098, size: 1 },
    //     { x: 191.654676258993, y: 3.88235294117647, size: 1 },
    //     { x: 203.956834532374, y: 3.09803921568627, size: 1 },
    //     { x: 207.841726618705, y: 4.11764705882353, size: 1 },
    //     { x: 224.676258992806, y: 3.17647058823529, size: 1 },
    //     { x: 244.748201438849, y: 3.37254901960784, size: 1 },
    //     { x: 246.043165467626, y: 3.29411764705882, size: 1 },
    //     { x: 246.690647482014, y: 3.17647058823529, size: 1 },
    //     { x: 262.877697841727, y: 3.96078431372549, size: 1 },
    //     { x: 267.410071942446, y: 3.13725490196078, size: 1 },
    //     { x: 268.057553956835, y: 2.7843137254902, size: 1 },
    //     { x: 268.705035971223, y: 2.50980392156863, size: 1 },
    //     { x: 299.136690647482, y: 3.33333333333333, size: 1 },
    //     { x: 306.258992805755, y: 3.41176470588235, size: 1 },
    //     { x: 311.438848920863, y: 3.37254901960784, size: 1 },
    //     { x: 315.971223021583, y: 3.84313725490196, size: 1 },
    //     { x: 317.26618705036, y: 3.80392156862745, size: 1 },
    //     { x: 331.510791366906, y: 3.17647058823529, size: 1 },
    //     { x: 332.158273381295, y: 3.05882352941176, size: 1 },
    //     { x: 333.453237410072, y: 2.50980392156863, size: 1 },
    //     { x: 334.748201438849, y: 3.92156862745098, size: 1 },
    //     { x: 335.395683453237, y: 3.80392156862745, size: 1 },
    //     { x: 336.690647482014, y: 3.72549019607843, size: 1 },
    //     { x: 337.338129496403, y: 3.92156862745098, size: 1 },
    //     { x: 342.517985611511, y: 3.88235294117647, size: 1 },
    //     { x: 346.402877697842, y: 3.88235294117647, size: 1 },
    //     { x: 349.640287769784, y: 4.07843137254902, size: 1 },
    //     { x: 354.820143884892, y: 3.37254901960784, size: 1 },
    //     { x: 356.762589928058, y: 3.37254901960784, size: 1 },
    //     { x: 0.648648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 1.94594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 9.08108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 9.72972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 10.3783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 11.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 12.3243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 14.2702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 16.2162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 16.8648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 18.1621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 24, y: 3.76470588235294, size: 1 },
    //     { x: 25.2972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 32.4324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 33.7297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 36.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 38.2702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 41.5135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 44.1081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 45.4054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 49.9459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 51.8918918918919, y: 3.52941176470588, size: 1 },
    //     { x: 53.8378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 57.7297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 59.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 59.6756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 62.9189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 63.5675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 64.8648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 66.1621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 66.8108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 67.4594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 68.1081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 68.7567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 69.4054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 70.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 70.7027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 71.3513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 72.6486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 74.5945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 75.2432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 76.5405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 77.1891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 77.8378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 80.4324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 81.0810810810811, y: 1.37254901960784, size: 1 },
    //     { x: 81.7297297297297, y: 1.52941176470588, size: 1 },
    //     { x: 82.3783783783784, y: 1.33333333333333, size: 1 },
    //     { x: 83.027027027027, y: 1.17647058823529, size: 1 },
    //     { x: 84.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 85.6216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 86.2702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 88.8648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 89.5135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 90.1621621621622, y: 2.94117647058824, size: 1 },
    //     { x: 90.8108108108108, y: 2.94117647058824, size: 1 },
    //     { x: 94.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 96, y: 3.64705882352941, size: 1 },
    //     { x: 96.6486486486486, y: 2.82352941176471, size: 1 },
    //     { x: 97.2972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 99.2432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 99.8918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 101.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 101.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 102.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 103.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 105.72972972973, y: 3.68627450980392, size: 1 },
    //     { x: 107.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 107.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 110.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 113.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 115.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 118.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 120.648648648649, y: 4, size: 1 },
    //     { x: 122.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 123.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 123.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 124.540540540541, y: 1.76470588235294, size: 1 },
    //     { x: 127.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 129.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 130.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 131.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 131.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 134.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 138.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 144.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 145.945945945946, y: 1.88235294117647, size: 1 },
    //     { x: 146.594594594595, y: 1.88235294117647, size: 1 },
    //     { x: 147.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 151.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 155.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 155.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 156.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 156.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 158.27027027027, y: 3.56862745098039, size: 1 },
    //     { x: 158.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 160.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 162.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 162.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 164.108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 165.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 166.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 169.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 173.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 184.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 185.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 186.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 186.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 187.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 189.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 190.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 192, y: 3.49019607843137, size: 1 },
    //     { x: 192.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 195.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 195.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 197.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 199.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 201.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 205.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 206.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 207.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 208.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 212.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 214.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 215.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 216.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 218.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 221.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 222.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 225.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 226.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 227.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 234.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 235.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 236.756756756757, y: 4.23529411764706, size: 1 },
    //     { x: 237.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 238.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 241.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 243.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 243.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 245.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 247.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 248.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 250.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 251.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 252.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 253.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 254.27027027027, y: 2.54901960784314, size: 1 },
    //     { x: 259.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 260.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 262.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 262.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 265.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 270.486486486487, y: 3.6078431372549, size: 1 },
    //     { x: 271.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 271.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 274.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 275.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 275.675675675676, y: 1.92156862745098, size: 1 },
    //     { x: 276.324324324324, y: 2.03921568627451, size: 1 },
    //     { x: 276.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 282.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 283.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 284.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 286.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 287.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 290.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 291.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 294.486486486487, y: 3.49019607843137, size: 1 },
    //     { x: 296.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 297.081081081081, y: 2.3921568627451, size: 1 },
    //     { x: 297.72972972973, y: 2.15686274509804, size: 1 },
    //     { x: 300.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 301.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 304.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 306.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 307.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 310.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 316.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 317.189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 317.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 318.486486486487, y: 3.2156862745098, size: 1 },
    //     { x: 319.135135135135, y: 2.7843137254902, size: 1 },
    //     { x: 321.081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 326.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 328.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 328.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 336, y: 3.64705882352941, size: 1 },
    //     { x: 336.648648648649, y: 3.6078431372549, size: 1 },
    //     { x: 337.297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 337.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 338.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 340.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 347.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 357.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 358.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 3.23741007194245, y: 3.92156862745098, size: 1 },
    //     { x: 48.5611510791367, y: 3.37254901960784, size: 1 },
    //     { x: 76.4028776978417, y: 3.80392156862745, size: 1 },
    //     { x: 110.071942446043, y: 3.17647058823529, size: 1 },
    //     { x: 132.086330935252, y: 3.29411764705882, size: 1 },
    //     { x: 140.503597122302, y: 3.41176470588235, size: 1 },
    //     { x: 146.330935251799, y: 3.52941176470588, size: 1 },
    //     { x: 174.820143884892, y: 3.01960784313725, size: 1 },
    //     { x: 175.467625899281, y: 2.94117647058824, size: 1 },
    //     { x: 192.94964028777, y: 3.41176470588235, size: 1 },
    //     { x: 218.201438848921, y: 2.82352941176471, size: 1 },
    //     { x: 219.496402877698, y: 3.76470588235294, size: 1 },
    //     { x: 220.791366906475, y: 3.84313725490196, size: 1 },
    //     { x: 225.323741007194, y: 3.92156862745098, size: 1 },
    //     { x: 227.26618705036, y: 3.84313725490196, size: 1 },
    //     { x: 227.913669064748, y: 4.03921568627451, size: 1 },
    //     { x: 240.215827338129, y: 3.13725490196078, size: 1 },
    //     { x: 247.338129496403, y: 3.33333333333333, size: 1 },
    //     { x: 247.985611510791, y: 3.33333333333333, size: 1 },
    //     { x: 255.107913669065, y: 4, size: 1 },
    //     { x: 260.287769784173, y: 3.33333333333333, size: 1 },
    //     { x: 268.057553956835, y: 3.29411764705882, size: 1 },
    //     { x: 269.352517985611, y: 3.45098039215686, size: 1 },
    //     { x: 304.31654676259, y: 2.90196078431373, size: 1 },
    //     { x: 304.964028776978, y: 2.94117647058824, size: 1 },
    //     { x: 319.856115107914, y: 4, size: 1 },
    //     { x: 343.812949640288, y: 3.92156862745098, size: 1 },
    //     { x: 28.4892086330935, y: 3.41176470588235, size: 1 },
    //     { x: 30.431654676259, y: 3.29411764705882, size: 1 },
    //     { x: 31.726618705036, y: 3.01960784313725, size: 1 },
    //     { x: 33.0215827338129, y: 3.33333333333333, size: 1 },
    //     { x: 36.2589928057554, y: 3.80392156862745, size: 1 },
    //     { x: 51.7985611510791, y: 3.05882352941176, size: 1 },
    //     { x: 52.4460431654676, y: 2.94117647058824, size: 1 },
    //     { x: 53.0935251798561, y: 3.05882352941176, size: 1 },
    //     { x: 58.9208633093525, y: 3.37254901960784, size: 1 },
    //     { x: 62.8057553956835, y: 3.33333333333333, size: 1 },
    //     { x: 70.5755395683453, y: 3.25490196078431, size: 1 },
    //     { x: 72.5179856115108, y: 3.33333333333333, size: 1 },
    //     { x: 73.8129496402878, y: 3.33333333333333, size: 1 },
    //     { x: 78.9928057553957, y: 3.80392156862745, size: 1 },
    //     { x: 86.1151079136691, y: 3.72549019607843, size: 1 },
    //     { x: 95.8273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 102.94964028777, y: 3.49019607843137, size: 1 },
    //     { x: 111.36690647482, y: 4.03921568627451, size: 1 },
    //     { x: 117.194244604317, y: 3.2156862745098, size: 1 },
    //     { x: 139.856115107914, y: 3.37254901960784, size: 1 },
    //     { x: 141.151079136691, y: 3.17647058823529, size: 1 },
    //     { x: 142.446043165468, y: 3.13725490196078, size: 1 },
    //     { x: 144.388489208633, y: 3.29411764705882, size: 1 },
    //     { x: 146.330935251799, y: 3.17647058823529, size: 1 },
    //     { x: 152.805755395683, y: 3.29411764705882, size: 1 },
    //     { x: 159.280575539568, y: 3.37254901960784, size: 1 },
    //     { x: 161.223021582734, y: 3.2156862745098, size: 1 },
    //     { x: 165.755395683453, y: 3.29411764705882, size: 1 },
    //     { x: 167.05035971223, y: 3.33333333333333, size: 1 },
    //     { x: 168.345323741007, y: 3.2156862745098, size: 1 },
    //     { x: 173.525179856115, y: 3.29411764705882, size: 1 },
    //     { x: 174.820143884892, y: 3.29411764705882, size: 1 },
    //     { x: 177.410071942446, y: 3.33333333333333, size: 1 },
    //     { x: 178.057553956835, y: 3.29411764705882, size: 1 },
    //     { x: 180, y: 3.37254901960784, size: 1 },
    //     { x: 198.776978417266, y: 3.29411764705882, size: 1 },
    //     { x: 203.956834532374, y: 3.2156862745098, size: 1 },
    //     { x: 208.489208633094, y: 3.92156862745098, size: 1 },
    //     { x: 210.431654676259, y: 3.84313725490196, size: 1 },
    //     { x: 211.726618705036, y: 4.15686274509804, size: 1 },
    //     { x: 224.028776978417, y: 4.03921568627451, size: 1 },
    //     { x: 225.323741007194, y: 3.29411764705882, size: 1 },
    //     { x: 232.446043165468, y: 3.76470588235294, size: 1 },
    //     { x: 240.863309352518, y: 3.88235294117647, size: 1 },
    //     { x: 243.453237410072, y: 3.88235294117647, size: 1 },
    //     { x: 245.395683453237, y: 3.29411764705882, size: 1 },
    //     { x: 246.043165467626, y: 3.17647058823529, size: 1 },
    //     { x: 246.690647482014, y: 3.05882352941176, size: 1 },
    //     { x: 253.812949640288, y: 4.07843137254902, size: 1 },
    //     { x: 255.107913669065, y: 4.23529411764706, size: 1 },
    //     { x: 258.345323741007, y: 3.96078431372549, size: 1 },
    //     { x: 284.892086330935, y: 3.37254901960784, size: 1 },
    //     { x: 290.071942446043, y: 3.29411764705882, size: 1 },
    //     { x: 290.719424460432, y: 3.84313725490196, size: 1 },
    //     { x: 291.36690647482, y: 3.68627450980392, size: 1 },
    //     { x: 303.021582733813, y: 3.52941176470588, size: 1 },
    //     { x: 304.964028776978, y: 3.80392156862745, size: 1 },
    //     { x: 310.143884892086, y: 3.92156862745098, size: 1 },
    //     { x: 319.208633093525, y: 3.84313725490196, size: 1 },
    //     { x: 333.453237410072, y: 3.29411764705882, size: 1 },
    //     { x: 354.820143884892, y: 3.33333333333333, size: 1 },
    //     { x: 11.0071942446043, y: 3.37254901960784, size: 1 },
    //     { x: 16.1870503597122, y: 2.7843137254902, size: 1 },
    //     { x: 16.8345323741007, y: 3.05882352941176, size: 1 },
    //     { x: 36.9064748201439, y: 3.2156862745098, size: 1 },
    //     { x: 37.5539568345324, y: 3.29411764705882, size: 1 },
    //     { x: 38.2014388489209, y: 3.05882352941176, size: 1 },
    //     { x: 43.3812949640288, y: 3.49019607843137, size: 1 },
    //     { x: 58.9208633093525, y: 3.13725490196078, size: 1 },
    //     { x: 59.568345323741, y: 2.94117647058824, size: 1 },
    //     { x: 67.3381294964029, y: 3.41176470588235, size: 1 },
    //     { x: 67.9856115107914, y: 3.64705882352941, size: 1 },
    //     { x: 70.5755395683453, y: 3.37254901960784, size: 1 },
    //     { x: 77.6978417266187, y: 3.33333333333333, size: 1 },
    //     { x: 81.5827338129496, y: 3.09803921568627, size: 1 },
    //     { x: 87.410071942446, y: 3.33333333333333, size: 1 },
    //     { x: 102.302158273381, y: 3.25490196078431, size: 1 },
    //     { x: 102.94964028777, y: 3.25490196078431, size: 1 },
    //     { x: 129.496402877698, y: 3.33333333333333, size: 1 },
    //     { x: 143.741007194245, y: 3.2156862745098, size: 1 },
    //     { x: 145.68345323741, y: 2.94117647058824, size: 1 },
    //     { x: 156.043165467626, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 3.88235294117647, size: 1 },
    //     { x: 168.992805755396, y: 3.88235294117647, size: 1 },
    //     { x: 187.122302158273, y: 3.25490196078431, size: 1 },
    //     { x: 187.769784172662, y: 3.2156862745098, size: 1 },
    //     { x: 188.41726618705, y: 2.82352941176471, size: 1 },
    //     { x: 189.064748201439, y: 3.17647058823529, size: 1 },
    //     { x: 205.251798561151, y: 3.92156862745098, size: 1 },
    //     { x: 210.431654676259, y: 3.17647058823529, size: 1 },
    //     { x: 211.726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 216.906474820144, y: 3.88235294117647, size: 1 },
    //     { x: 227.913669064748, y: 3.2156862745098, size: 1 },
    //     { x: 232.446043165468, y: 3.25490196078431, size: 1 },
    //     { x: 251.870503597122, y: 3.25490196078431, size: 1 },
    //     { x: 253.165467625899, y: 3.2156862745098, size: 1 },
    //     { x: 261.58273381295, y: 3.84313725490196, size: 1 },
    //     { x: 266.762589928058, y: 3.80392156862745, size: 1 },
    //     { x: 270.647482014389, y: 3.80392156862745, size: 1 },
    //     { x: 275.179856115108, y: 3.01960784313725, size: 1 },
    //     { x: 282.302158273381, y: 3.41176470588235, size: 1 },
    //     { x: 284.244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 284.892086330935, y: 3.92156862745098, size: 1 },
    //     { x: 296.546762589928, y: 2.98039215686275, size: 1 },
    //     { x: 297.194244604317, y: 3.05882352941176, size: 1 },
    //     { x: 301.079136690647, y: 3.88235294117647, size: 1 },
    //     { x: 316.618705035971, y: 3.25490196078431, size: 1 },
    //     { x: 317.26618705036, y: 3.13725490196078, size: 1 },
    //     { x: 317.913669064748, y: 3.29411764705882, size: 1 },
    //     { x: 319.208633093525, y: 3.52941176470588, size: 1 },
    //     { x: 348.345323741007, y: 3.29411764705882, size: 1 },
    //     { x: 353.525179856115, y: 3.33333333333333, size: 1 },
    //     { x: 358.057553956835, y: 3.41176470588235, size: 1 },
    //     { x: 1.2972972972973, y: 2.86274509803922, size: 1 },
    //     { x: 1.94594594594595, y: 2.50980392156863, size: 1 },
    //     { x: 2.59459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 3.89189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 14.9189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 15.5675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 17.5135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 20.1081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 21.4054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 22.0540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 23.3513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 24.6486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 27.8918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 30.4864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 34.3783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 35.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 36.3243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 40.2162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 40.8648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 43.4594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 44.7567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 45.4054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 46.7027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 47.3513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 49.2972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 50.5945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 51.2432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 52.5405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 53.8378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 56.4324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 59.6756756756757, y: 3.56862745098039, size: 1 },
    //     { x: 60.3243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 61.6216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 64.8648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 66.1621621621622, y: 2.94117647058824, size: 1 },
    //     { x: 66.8108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 72.6486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 73.2972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 73.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 76.5405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 78.4864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 81.0810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 81.7297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 83.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 84.3243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 84.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 85.6216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 86.2702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 86.9189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 87.5675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 88.2162162162162, y: 2.90196078431373, size: 1 },
    //     { x: 90.1621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 90.8108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 92.1081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 93.4054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 95.3513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 96, y: 3.68627450980392, size: 1 },
    //     { x: 101.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 103.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 106.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 107.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 108.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 108.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 110.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 112.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 113.513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 114.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 114.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 115.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 116.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 117.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 120, y: 3.37254901960784, size: 1 },
    //     { x: 120.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 125.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 126.486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 127.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 131.027027027027, y: 2.82352941176471, size: 1 },
    //     { x: 131.675675675676, y: 2.82352941176471, size: 1 },
    //     { x: 132.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 133.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 135.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 136.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 138.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 138.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 149.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 151.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 151.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 152.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 156.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 162.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 162.810810810811, y: 3.64705882352941, size: 1 },
    //     { x: 164.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 164.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 166.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 169.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 170.594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 171.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 173.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 174.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 175.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 179.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 181.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 182.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 183.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 184.864864864865, y: 3.72549019607843, size: 1 },
    //     { x: 185.513513513514, y: 3.64705882352941, size: 1 },
    //     { x: 186.810810810811, y: 3.72549019607843, size: 1 },
    //     { x: 190.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 191.351351351351, y: 3.6078431372549, size: 1 },
    //     { x: 193.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 195.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 195.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 196.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 198.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 203.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 204.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 208.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 208.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 209.513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 210.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 212.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 214.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 215.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 217.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 217.945945945946, y: 2.98039215686275, size: 1 },
    //     { x: 218.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 219.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 220.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 221.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 221.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 223.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 229.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 230.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 232.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 232.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 236.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 237.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 239.351351351351, y: 2.82352941176471, size: 1 },
    //     { x: 241.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 242.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 243.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 244.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 245.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 246.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 250.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 252.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 253.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 254.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 254.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 255.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 256.216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 258.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 258.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 259.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 260.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 260.756756756757, y: 2.66666666666667, size: 1 },
    //     { x: 261.405405405405, y: 2.74509803921569, size: 1 },
    //     { x: 264, y: 3.72549019607843, size: 1 },
    //     { x: 267.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 270.486486486487, y: 3.76470588235294, size: 1 },
    //     { x: 272.432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 273.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 274.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 275.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 277.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 282.162162162162, y: 2.82352941176471, size: 1 },
    //     { x: 282.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 288, y: 3.45098039215686, size: 1 },
    //     { x: 288.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 289.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 289.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 290.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 293.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 293.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 296.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 297.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 297.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 302.27027027027, y: 3.49019607843137, size: 1 },
    //     { x: 302.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 303.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 304.216216216216, y: 2.74509803921569, size: 1 },
    //     { x: 304.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 306.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 306.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 308.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 318.486486486487, y: 3.88235294117647, size: 1 },
    //     { x: 323.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 324.324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 325.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 327.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 332.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 334.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 335.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 336, y: 3.88235294117647, size: 1 },
    //     { x: 336.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 337.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 337.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 341.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 342.486486486487, y: 3.76470588235294, size: 1 },
    //     { x: 343.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 345.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 347.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 348.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 348.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 350.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 351.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 352.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 354.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 356.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 358.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 8.41726618705036, y: 3.13725490196078, size: 1 },
    //     { x: 9.06474820143885, y: 2.70588235294118, size: 1 },
    //     { x: 9.71223021582734, y: 3.33333333333333, size: 1 },
    //     { x: 18.1294964028777, y: 3.84313725490196, size: 1 },
    //     { x: 20.0719424460432, y: 3.76470588235294, size: 1 },
    //     { x: 29.136690647482, y: 3.01960784313725, size: 1 },
    //     { x: 30.431654676259, y: 2.11764705882353, size: 1 },
    //     { x: 31.0791366906475, y: 2.31372549019608, size: 1 },
    //     { x: 31.726618705036, y: 3.41176470588235, size: 1 },
    //     { x: 34.3165467625899, y: 3.2156862745098, size: 1 },
    //     { x: 51.1510791366906, y: 3.17647058823529, size: 1 },
    //     { x: 51.7985611510791, y: 2.98039215686275, size: 1 },
    //     { x: 52.4460431654676, y: 2.62745098039216, size: 1 },
    //     { x: 62.158273381295, y: 3.33333333333333, size: 1 },
    //     { x: 71.8705035971223, y: 3.25490196078431, size: 1 },
    //     { x: 72.5179856115108, y: 3.13725490196078, size: 1 },
    //     { x: 73.1654676258993, y: 3.25490196078431, size: 1 },
    //     { x: 73.8129496402878, y: 2.66666666666667, size: 1 },
    //     { x: 77.0503597122302, y: 3.37254901960784, size: 1 },
    //     { x: 94.5323741007194, y: 3.01960784313725, size: 1 },
    //     { x: 95.1798561151079, y: 2.62745098039216, size: 1 },
    //     { x: 95.8273381294964, y: 2.82352941176471, size: 1 },
    //     { x: 105.539568345324, y: 4.19607843137255, size: 1 },
    //     { x: 116.546762589928, y: 2.90196078431373, size: 1 },
    //     { x: 117.194244604317, y: 2.86274509803922, size: 1 },
    //     { x: 126.906474820144, y: 3.96078431372549, size: 1 },
    //     { x: 136.618705035971, y: 3.09803921568627, size: 1 },
    //     { x: 137.26618705036, y: 3.2156862745098, size: 1 },
    //     { x: 137.913669064748, y: 3.13725490196078, size: 1 },
    //     { x: 138.561151079137, y: 1.49019607843137, size: 1 },
    //     { x: 139.208633093525, y: 3.25490196078431, size: 1 },
    //     { x: 148.920863309353, y: 3.25490196078431, size: 1 },
    //     { x: 158.63309352518, y: 3.37254901960784, size: 1 },
    //     { x: 161.870503597122, y: 4, size: 1 },
    //     { x: 165.755395683453, y: 3.88235294117647, size: 1 },
    //     { x: 166.402877697842, y: 3.37254901960784, size: 1 },
    //     { x: 180, y: 3.29411764705882, size: 1 },
    //     { x: 198.129496402878, y: 3.80392156862745, size: 1 },
    //     { x: 200.719424460432, y: 3.92156862745098, size: 1 },
    //     { x: 228.561151079137, y: 3.80392156862745, size: 1 },
    //     { x: 235.035971223022, y: 4.07843137254902, size: 1 },
    //     { x: 244.10071942446, y: 3.33333333333333, size: 1 },
    //     { x: 245.395683453237, y: 3.01960784313725, size: 1 },
    //     { x: 246.043165467626, y: 2.58823529411765, size: 1 },
    //     { x: 246.690647482014, y: 2.43137254901961, size: 1 },
    //     { x: 254.460431654676, y: 3.45098039215686, size: 1 },
    //     { x: 255.755395683453, y: 3.80392156862745, size: 1 },
    //     { x: 258.992805755396, y: 3.80392156862745, size: 1 },
    //     { x: 266.762589928058, y: 3.2156862745098, size: 1 },
    //     { x: 279.712230215827, y: 3.2156862745098, size: 1 },
    //     { x: 281.654676258993, y: 3.25490196078431, size: 1 },
    //     { x: 285.539568345324, y: 3.25490196078431, size: 1 },
    //     { x: 299.136690647482, y: 3.88235294117647, size: 1 },
    //     { x: 299.784172661871, y: 3.84313725490196, size: 1 },
    //     { x: 300.431654676259, y: 3.76470588235294, size: 1 },
    //     { x: 310.791366906475, y: 4, size: 1 },
    //     { x: 312.73381294964, y: 3.29411764705882, size: 1 },
    //     { x: 314.028776978417, y: 3.09803921568627, size: 1 },
    //     { x: 314.676258992806, y: 3.2156862745098, size: 1 },
    //     { x: 316.618705035971, y: 3.17647058823529, size: 1 },
    //     { x: 317.26618705036, y: 3.05882352941176, size: 1 },
    //     { x: 317.913669064748, y: 3.25490196078431, size: 1 },
    //     { x: 321.151079136691, y: 3.25490196078431, size: 1 },
    //     { x: 321.798561151079, y: 3.2156862745098, size: 1 },
    //     { x: 323.741007194245, y: 3.37254901960784, size: 1 },
    //     { x: 324.388489208633, y: 3.29411764705882, size: 1 },
    //     { x: 325.035971223022, y: 3.17647058823529, size: 1 },
    //     { x: 326.978417266187, y: 3.25490196078431, size: 1 },
    //     { x: 330.215827338129, y: 3.2156862745098, size: 1 },
    //     { x: 334.10071942446, y: 3.17647058823529, size: 1 },
    //     { x: 334.748201438849, y: 3.05882352941176, size: 1 },
    //     { x: 338.63309352518, y: 3.33333333333333, size: 1 },
    //     { x: 339.280575539568, y: 3.13725490196078, size: 1 },
    //     { x: 343.165467625899, y: 3.29411764705882, size: 1 },
    //     { x: 343.812949640288, y: 3.2156862745098, size: 1 },
    //     { x: 344.460431654676, y: 3.29411764705882, size: 1 },
    //     { x: 345.755395683453, y: 3.33333333333333, size: 1 },
    //     { x: 346.402877697842, y: 3.2156862745098, size: 1 },
    //     { x: 348.992805755396, y: 3.2156862745098, size: 1 },
    //     { x: 351.58273381295, y: 3.33333333333333, size: 1 },
    //     { x: 352.877697841727, y: 3.33333333333333, size: 1 },
    //     { x: 354.172661870504, y: 3.01960784313725, size: 1 },
    //     { x: 354.820143884892, y: 3.05882352941176, size: 1 },
    //     { x: 355.467625899281, y: 3.09803921568627, size: 1 },
    //     { x: 356.115107913669, y: 3.13725490196078, size: 1 },
    //     { x: 357.410071942446, y: 3.13725490196078, size: 1 },
    //     { x: 0, y: 3.17647058823529, size: 1 },
    //     { x: 1.29496402877698, y: 3.05882352941176, size: 1 },
    //     { x: 5.17985611510791, y: 3.41176470588235, size: 1 },
    //     { x: 5.8273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 6.47482014388489, y: 3.09803921568627, size: 1 },
    //     { x: 7.12230215827338, y: 3.2156862745098, size: 1 },
    //     { x: 8.41726618705036, y: 3.37254901960784, size: 1 },
    //     { x: 9.06474820143885, y: 3.29411764705882, size: 1 },
    //     { x: 11.0071942446043, y: 3.17647058823529, size: 1 },
    //     { x: 11.6546762589928, y: 3.2156862745098, size: 1 },
    //     { x: 12.9496402877698, y: 3.09803921568627, size: 1 },
    //     { x: 15.5395683453237, y: 3.05882352941176, size: 1 },
    //     { x: 16.1870503597122, y: 2.98039215686275, size: 1 },
    //     { x: 18.1294964028777, y: 3.2156862745098, size: 1 },
    //     { x: 19.4244604316547, y: 3.37254901960784, size: 1 },
    //     { x: 22.0143884892086, y: 3.25490196078431, size: 1 },
    //     { x: 22.6618705035971, y: 3.2156862745098, size: 1 },
    //     { x: 25.8992805755396, y: 3.17647058823529, size: 1 },
    //     { x: 27.1942446043165, y: 3.05882352941176, size: 1 },
    //     { x: 27.841726618705, y: 3.25490196078431, size: 1 },
    //     { x: 28.4892086330935, y: 3.25490196078431, size: 1 },
    //     { x: 29.136690647482, y: 3.2156862745098, size: 1 },
    //     { x: 29.7841726618705, y: 3.17647058823529, size: 1 },
    //     { x: 30.431654676259, y: 3.25490196078431, size: 1 },
    //     { x: 33.6690647482014, y: 3.29411764705882, size: 1 },
    //     { x: 36.2589928057554, y: 3.33333333333333, size: 1 },
    //     { x: 36.9064748201439, y: 3.13725490196078, size: 1 },
    //     { x: 37.5539568345324, y: 2.98039215686275, size: 1 },
    //     { x: 38.2014388489209, y: 3.01960784313725, size: 1 },
    //     { x: 40.1438848920863, y: 3.29411764705882, size: 1 },
    //     { x: 44.0287769784173, y: 3.2156862745098, size: 1 },
    //     { x: 45.3237410071942, y: 3.37254901960784, size: 1 },
    //     { x: 49.2086330935252, y: 3.05882352941176, size: 1 },
    //     { x: 51.1510791366906, y: 3.25490196078431, size: 1 },
    //     { x: 55.0359712230216, y: 2.94117647058824, size: 1 },
    //     { x: 55.6834532374101, y: 3.17647058823529, size: 1 },
    //     { x: 64.7482014388489, y: 4, size: 1 },
    //     { x: 67.3381294964029, y: 3.92156862745098, size: 1 },
    //     { x: 70.5755395683453, y: 4, size: 1 },
    //     { x: 73.8129496402878, y: 3.92156862745098, size: 1 },
    //     { x: 78.9928057553957, y: 3.2156862745098, size: 1 },
    //     { x: 80.2877697841727, y: 2.90196078431373, size: 1 },
    //     { x: 88.0575539568345, y: 3.88235294117647, size: 1 },
    //     { x: 90, y: 3.92156862745098, size: 1 },
    //     { x: 100.359712230216, y: 3.29411764705882, size: 1 },
    //     { x: 102.302158273381, y: 2.74509803921569, size: 1 },
    //     { x: 110.071942446043, y: 3.80392156862745, size: 1 },
    //     { x: 126.258992805755, y: 3.88235294117647, size: 1 },
    //     { x: 144.388489208633, y: 3.25490196078431, size: 1 },
    //     { x: 145.035971223022, y: 2.35294117647059, size: 1 },
    //     { x: 145.68345323741, y: 2.43137254901961, size: 1 },
    //     { x: 155.395683453237, y: 3.92156862745098, size: 1 },
    //     { x: 156.043165467626, y: 4, size: 1 },
    //     { x: 158.63309352518, y: 3.84313725490196, size: 1 },
    //     { x: 165.107913669065, y: 3.05882352941176, size: 1 },
    //     { x: 167.05035971223, y: 2.66666666666667, size: 1 },
    //     { x: 167.697841726619, y: 3.17647058823529, size: 1 },
    //     { x: 168.345323741007, y: 2.94117647058824, size: 1 },
    //     { x: 168.992805755396, y: 3.25490196078431, size: 1 },
    //     { x: 169.640287769784, y: 3.17647058823529, size: 1 },
    //     { x: 170.287769784173, y: 3.09803921568627, size: 1 },
    //     { x: 171.58273381295, y: 3.25490196078431, size: 1 },
    //     { x: 174.172661870504, y: 3.33333333333333, size: 1 },
    //     { x: 174.820143884892, y: 3.13725490196078, size: 1 },
    //     { x: 177.410071942446, y: 3.25490196078431, size: 1 },
    //     { x: 178.705035971223, y: 3.33333333333333, size: 1 },
    //     { x: 179.352517985612, y: 3.01960784313725, size: 1 },
    //     { x: 180.647482014388, y: 3.05882352941176, size: 1 },
    //     { x: 183.237410071942, y: 3.33333333333333, size: 1 },
    //     { x: 183.884892086331, y: 3.2156862745098, size: 1 },
    //     { x: 184.532374100719, y: 3.13725490196078, size: 1 },
    //     { x: 185.179856115108, y: 3.01960784313725, size: 1 },
    //     { x: 187.769784172662, y: 3.05882352941176, size: 1 },
    //     { x: 188.41726618705, y: 2.86274509803922, size: 1 },
    //     { x: 189.064748201439, y: 2.86274509803922, size: 1 },
    //     { x: 189.712230215827, y: 3.2156862745098, size: 1 },
    //     { x: 191.654676258993, y: 3.25490196078431, size: 1 },
    //     { x: 195.539568345324, y: 3.2156862745098, size: 1 },
    //     { x: 196.834532374101, y: 3.2156862745098, size: 1 },
    //     { x: 197.482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 199.424460431655, y: 3.25490196078431, size: 1 },
    //     { x: 200.071942446043, y: 3.09803921568627, size: 1 },
    //     { x: 200.719424460432, y: 3.29411764705882, size: 1 },
    //     { x: 201.36690647482, y: 3.33333333333333, size: 1 },
    //     { x: 202.014388489209, y: 3.17647058823529, size: 1 },
    //     { x: 202.661870503597, y: 3.13725490196078, size: 1 },
    //     { x: 203.309352517986, y: 3.25490196078431, size: 1 },
    //     { x: 205.89928057554, y: 3.13725490196078, size: 1 },
    //     { x: 209.784172661871, y: 3.2156862745098, size: 1 },
    //     { x: 211.079136690647, y: 3.01960784313725, size: 1 },
    //     { x: 212.374100719424, y: 3.05882352941176, size: 1 },
    //     { x: 216.906474820144, y: 3.33333333333333, size: 1 },
    //     { x: 217.553956834532, y: 3.05882352941176, size: 1 },
    //     { x: 218.201438848921, y: 3.05882352941176, size: 1 },
    //     { x: 219.496402877698, y: 3.33333333333333, size: 1 },
    //     { x: 220.791366906475, y: 3.33333333333333, size: 1 },
    //     { x: 222.086330935252, y: 2.90196078431373, size: 1 },
    //     { x: 223.381294964029, y: 3.17647058823529, size: 1 },
    //     { x: 224.028776978417, y: 2.90196078431373, size: 1 },
    //     { x: 227.26618705036, y: 3.17647058823529, size: 1 },
    //     { x: 227.913669064748, y: 3.17647058823529, size: 1 },
    //     { x: 228.561151079137, y: 3.17647058823529, size: 1 },
    //     { x: 234.388489208633, y: 3.80392156862745, size: 1 },
    //     { x: 235.68345323741, y: 3.76470588235294, size: 1 },
    //     { x: 244.10071942446, y: 3.88235294117647, size: 1 },
    //     { x: 253.165467625899, y: 3.05882352941176, size: 1 },
    //     { x: 253.812949640288, y: 3.01960784313725, size: 1 },
    //     { x: 257.697841726619, y: 3.80392156862745, size: 1 },
    //     { x: 276.474820143885, y: 3.92156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.88235294117647, size: 1 },
    //     { x: 290.071942446043, y: 3.92156862745098, size: 1 },
    //     { x: 292.661870503597, y: 3.88235294117647, size: 1 },
    //     { x: 295.251798561151, y: 3.29411764705882, size: 1 },
    //     { x: 300.431654676259, y: 3.84313725490196, size: 1 },
    //     { x: 303.021582733813, y: 4.07843137254902, size: 1 },
    //     { x: 305.611510791367, y: 3.88235294117647, size: 1 },
    //     { x: 306.258992805755, y: 4, size: 1 },
    //     { x: 306.906474820144, y: 3.92156862745098, size: 1 },
    //     { x: 308.201438848921, y: 4.15686274509804, size: 1 },
    //     { x: 311.438848920863, y: 4, size: 1 },
    //     { x: 312.73381294964, y: 3.84313725490196, size: 1 },
    //     { x: 314.028776978417, y: 3.76470588235294, size: 1 },
    //     { x: 317.913669064748, y: 3.05882352941176, size: 1 },
    //     { x: 318.561151079137, y: 2.94117647058824, size: 1 },
    //     { x: 330.215827338129, y: 3.96078431372549, size: 1 },
    //     { x: 337.985611510791, y: 3.29411764705882, size: 1 },
    //     { x: 339.280575539568, y: 2.7843137254902, size: 1 },
    //     { x: 339.928057553957, y: 2.3921568627451, size: 1 },
    //     { x: 359.352517985611, y: 2.94117647058824, size: 1 },
    //     { x: 0, y: 3.29411764705882, size: 1 },
    //     { x: 0.647482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 1.29496402877698, y: 2.3921568627451, size: 1 },
    //     { x: 9.71223021582734, y: 3.92156862745098, size: 1 },
    //     { x: 11.0071942446043, y: 4.03921568627451, size: 1 },
    //     { x: 22.6618705035971, y: 3.25490196078431, size: 1 },
    //     { x: 30.431654676259, y: 3.88235294117647, size: 1 },
    //     { x: 42.0863309352518, y: 3.33333333333333, size: 1 },
    //     { x: 51.1510791366906, y: 3.41176470588235, size: 1 },
    //     { x: 56.3309352517986, y: 3.49019607843137, size: 1 },
    //     { x: 64.1007194244604, y: 3.2156862745098, size: 1 },
    //     { x: 66.0431654676259, y: 3.09803921568627, size: 1 },
    //     { x: 66.6906474820144, y: 3.33333333333333, size: 1 },
    //     { x: 68.6330935251799, y: 3.49019607843137, size: 1 },
    //     { x: 71.2230215827338, y: 4, size: 1 },
    //     { x: 85.4676258992806, y: 3.33333333333333, size: 1 },
    //     { x: 86.7625899280576, y: 3.25490196078431, size: 1 },
    //     { x: 87.410071942446, y: 3.17647058823529, size: 1 },
    //     { x: 88.0575539568345, y: 3.01960784313725, size: 1 },
    //     { x: 108.776978417266, y: 2.7843137254902, size: 1 },
    //     { x: 109.424460431655, y: 2.7843137254902, size: 1 },
    //     { x: 130.143884892086, y: 3.01960784313725, size: 1 },
    //     { x: 130.791366906475, y: 3.01960784313725, size: 1 },
    //     { x: 150.863309352518, y: 3.41176470588235, size: 1 },
    //     { x: 173.525179856115, y: 3.05882352941176, size: 1 },
    //     { x: 174.172661870504, y: 3.09803921568627, size: 1 },
    //     { x: 178.057553956835, y: 3.84313725490196, size: 1 },
    //     { x: 189.064748201439, y: 4.11764705882353, size: 1 },
    //     { x: 193.597122302158, y: 3.41176470588235, size: 1 },
    //     { x: 198.776978417266, y: 4, size: 1 },
    //     { x: 205.89928057554, y: 3.84313725490196, size: 1 },
    //     { x: 210.431654676259, y: 3.88235294117647, size: 1 },
    //     { x: 216.906474820144, y: 3.01960784313725, size: 1 },
    //     { x: 221.438848920863, y: 4.03921568627451, size: 1 },
    //     { x: 222.73381294964, y: 4, size: 1 },
    //     { x: 224.028776978417, y: 4, size: 1 },
    //     { x: 224.676258992806, y: 4.07843137254902, size: 1 },
    //     { x: 229.208633093525, y: 3.92156862745098, size: 1 },
    //     { x: 260.287769784173, y: 2.74509803921569, size: 1 },
    //     { x: 262.877697841727, y: 4.03921568627451, size: 1 },
    //     { x: 265.467625899281, y: 3.92156862745098, size: 1 },
    //     { x: 266.115107913669, y: 4.19607843137255, size: 1 },
    //     { x: 268.705035971223, y: 4, size: 1 },
    //     { x: 269.352517985611, y: 4, size: 1 },
    //     { x: 270, y: 3.92156862745098, size: 1 },
    //     { x: 270.647482014389, y: 4.23529411764706, size: 1 },
    //     { x: 271.294964028777, y: 3.96078431372549, size: 1 },
    //     { x: 271.942446043165, y: 4, size: 1 },
    //     { x: 272.589928057554, y: 4.27450980392157, size: 1 },
    //     { x: 274.532374100719, y: 4.07843137254902, size: 1 },
    //     { x: 275.827338129496, y: 4.03921568627451, size: 1 },
    //     { x: 276.474820143885, y: 4, size: 1 },
    //     { x: 277.769784172662, y: 4.07843137254902, size: 1 },
    //     { x: 279.064748201439, y: 4.03921568627451, size: 1 },
    //     { x: 279.712230215827, y: 3.96078431372549, size: 1 },
    //     { x: 281.007194244604, y: 3.49019607843137, size: 1 },
    //     { x: 282.302158273381, y: 3.2156862745098, size: 1 },
    //     { x: 286.834532374101, y: 3.84313725490196, size: 1 },
    //     { x: 291.36690647482, y: 3.80392156862745, size: 1 },
    //     { x: 299.136690647482, y: 3.80392156862745, size: 1 },
    //     { x: 303.021582733813, y: 3.05882352941176, size: 1 },
    //     { x: 306.258992805755, y: 4.07843137254902, size: 1 },
    //     { x: 306.906474820144, y: 4.07843137254902, size: 1 },
    //     { x: 308.201438848921, y: 3.88235294117647, size: 1 },
    //     { x: 308.848920863309, y: 4.07843137254902, size: 1 },
    //     { x: 309.496402877698, y: 4.11764705882353, size: 1 },
    //     { x: 310.791366906475, y: 4.19607843137255, size: 1 },
    //     { x: 312.73381294964, y: 4, size: 1 },
    //     { x: 313.381294964029, y: 4.03921568627451, size: 1 },
    //     { x: 314.676258992806, y: 4, size: 1 },
    //     { x: 315.323741007194, y: 3.92156862745098, size: 1 },
    //     { x: 315.971223021583, y: 4.03921568627451, size: 1 },
    //     { x: 316.618705035971, y: 4.03921568627451, size: 1 },
    //     { x: 317.913669064748, y: 3.92156862745098, size: 1 },
    //     { x: 318.561151079137, y: 4.11764705882353, size: 1 },
    //     { x: 319.856115107914, y: 3.80392156862745, size: 1 },
    //     { x: 320.503597122302, y: 4, size: 1 },
    //     { x: 321.151079136691, y: 3.92156862745098, size: 1 },
    //     { x: 321.798561151079, y: 3.92156862745098, size: 1 },
    //     { x: 322.446043165468, y: 3.96078431372549, size: 1 },
    //     { x: 330.863309352518, y: 3.88235294117647, size: 1 },
    //     { x: 349.640287769784, y: 3.52941176470588, size: 1 },
    //     { x: 350.935251798561, y: 3.88235294117647, size: 1 },
    //     { x: 352.230215827338, y: 3.96078431372549, size: 1 },
    //     { x: 353.525179856115, y: 3.96078431372549, size: 1 },
    //     { x: 2.59459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 5.18918918918919, y: 4, size: 1 },
    //     { x: 5.83783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 6.48648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 7.13513513513514, y: 3.76470588235294, size: 1 },
    //     { x: 7.78378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 10.3783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 11.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 11.6756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 12.3243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 12.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 13.6216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 14.2702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 14.9189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 16.2162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 18.8108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 19.4594594594595, y: 4.15686274509804, size: 1 },
    //     { x: 20.1081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 20.7567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 21.4054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 22.0540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 22.7027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 25.2972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 26.5945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 27.2432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 29.8378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 31.7837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 36.3243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 39.5675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 40.8648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 41.5135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 42.8108108108108, y: 4, size: 1 },
    //     { x: 44.1081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 44.7567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 45.4054054054054, y: 4, size: 1 },
    //     { x: 46.0540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 47.3513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 48, y: 3.88235294117647, size: 1 },
    //     { x: 48.6486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 51.2432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 51.8918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 55.1351351351351, y: 3.68627450980392, size: 1 },
    //     { x: 56.4324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 60.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 62.9189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 63.5675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 66.8108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 67.4594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 68.7567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 72, y: 3.52941176470588, size: 1 },
    //     { x: 72.6486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 74.5945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 77.8378378378378, y: 4, size: 1 },
    //     { x: 78.4864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 79.1351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 80.4324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 81.7297297297297, y: 3.6078431372549, size: 1 },
    //     { x: 82.3783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 83.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 85.6216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 90.1621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 93.4054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 94.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 94.7027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 98.5945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 103.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 107.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 112.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 114.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 115.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 116.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 116.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 118.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 119.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 124.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 125.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 129.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 131.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 132.324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 132.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 134.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 136.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 136.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 137.513513513514, y: 2.66666666666667, size: 1 },
    //     { x: 138.162162162162, y: 2.35294117647059, size: 1 },
    //     { x: 139.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 143.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 144, y: 3.49019607843137, size: 1 },
    //     { x: 144.648648648649, y: 3.56862745098039, size: 1 },
    //     { x: 145.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 145.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 146.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 147.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 151.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 157.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 158.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 159.567567567568, y: 2.62745098039216, size: 1 },
    //     { x: 160.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 163.459459459459, y: 3.45098039215686, size: 1 },
    //     { x: 168.648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 171.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 171.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 172.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 173.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 174.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 175.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 175.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 177.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 179.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 179.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 180.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 180.972972972973, y: 2.7843137254902, size: 1 },
    //     { x: 181.621621621622, y: 2.74509803921569, size: 1 },
    //     { x: 186.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 190.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 199.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 200.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 202.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 203.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 204.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 205.621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 208.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 211.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 212.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 212.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 213.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 216.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 221.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 224.432432432432, y: 2.54901960784314, size: 1 },
    //     { x: 228.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 230.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 232.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 232.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 233.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 234.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 236.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 238.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 245.837837837838, y: 2.90196078431373, size: 1 },
    //     { x: 246.486486486486, y: 2.98039215686275, size: 1 },
    //     { x: 247.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 250.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 252.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 252.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 256.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 256.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 257.513513513513, y: 3.45098039215686, size: 1 },
    //     { x: 258.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 258.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 261.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 262.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 264.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 265.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 266.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 267.243243243243, y: 2.86274509803922, size: 1 },
    //     { x: 267.891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 268.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 271.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 271.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 272.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 275.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 283.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 284.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 286.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 289.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 289.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 290.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 291.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 293.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 294.486486486487, y: 3.88235294117647, size: 1 },
    //     { x: 297.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 299.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 303.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 306.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 308.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 310.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 311.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 312.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 314.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 315.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 315.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 316.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 319.135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 320.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 321.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 322.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 323.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 324.324324324324, y: 4, size: 1 },
    //     { x: 332.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 336, y: 3.41176470588235, size: 1 },
    //     { x: 337.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 340.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 350.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 352.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 352.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 353.513513513513, y: 3.17647058823529, size: 1 },
    //     { x: 355.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 356.108108108108, y: 3.72549019607843, size: 1 },
    //     { x: 359.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 1.29496402877698, y: 3.92156862745098, size: 1 },
    //     { x: 14.2446043165468, y: 3.17647058823529, size: 1 },
    //     { x: 14.8920863309353, y: 3.33333333333333, size: 1 },
    //     { x: 15.5395683453237, y: 2.82352941176471, size: 1 },
    //     { x: 36.2589928057554, y: 3.41176470588235, size: 1 },
    //     { x: 36.9064748201439, y: 2.94117647058824, size: 1 },
    //     { x: 37.5539568345324, y: 2.86274509803922, size: 1 },
    //     { x: 39.4964028776978, y: 3.96078431372549, size: 1 },
    //     { x: 40.1438848920863, y: 3.96078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 4, size: 1 },
    //     { x: 78.9928057553957, y: 3.25490196078431, size: 1 },
    //     { x: 79.6402877697842, y: 3.2156862745098, size: 1 },
    //     { x: 80.2877697841727, y: 2.3921568627451, size: 1 },
    //     { x: 80.9352517985612, y: 2.50980392156863, size: 1 },
    //     { x: 101.654676258993, y: 3.05882352941176, size: 1 },
    //     { x: 113.956834532374, y: 3.76470588235294, size: 1 },
    //     { x: 123.021582733813, y: 3.05882352941176, size: 1 },
    //     { x: 123.669064748201, y: 1.88235294117647, size: 1 },
    //     { x: 124.31654676259, y: 3.29411764705882, size: 1 },
    //     { x: 126.906474820144, y: 3.92156862745098, size: 1 },
    //     { x: 134.676258992806, y: 3.92156862745098, size: 1 },
    //     { x: 145.68345323741, y: 3.92156862745098, size: 1 },
    //     { x: 151.510791366906, y: 3.88235294117647, size: 1 },
    //     { x: 152.805755395683, y: 3.84313725490196, size: 1 },
    //     { x: 163.165467625899, y: 4, size: 1 },
    //     { x: 167.697841726619, y: 3.80392156862745, size: 1 },
    //     { x: 180.647482014388, y: 3.92156862745098, size: 1 },
    //     { x: 188.41726618705, y: 3.13725490196078, size: 1 },
    //     { x: 191.654676258993, y: 3.92156862745098, size: 1 },
    //     { x: 196.187050359712, y: 4.03921568627451, size: 1 },
    //     { x: 209.136690647482, y: 3.17647058823529, size: 1 },
    //     { x: 209.784172661871, y: 2.50980392156863, size: 1 },
    //     { x: 210.431654676259, y: 2.35294117647059, size: 1 },
    //     { x: 220.143884892086, y: 3.96078431372549, size: 1 },
    //     { x: 231.151079136691, y: 3.33333333333333, size: 1 },
    //     { x: 249.280575539568, y: 3.80392156862745, size: 1 },
    //     { x: 255.107913669065, y: 3.41176470588235, size: 1 },
    //     { x: 273.884892086331, y: 3.29411764705882, size: 1 },
    //     { x: 274.532374100719, y: 2.86274509803922, size: 1 },
    //     { x: 279.712230215827, y: 3.84313725490196, size: 1 },
    //     { x: 282.94964028777, y: 3.84313725490196, size: 1 },
    //     { x: 286.187050359712, y: 4.11764705882353, size: 1 },
    //     { x: 295.89928057554, y: 2.03921568627451, size: 1 },
    //     { x: 296.546762589928, y: 1.56862745098039, size: 1 },
    //     { x: 297.194244604317, y: 1.72549019607843, size: 1 },
    //     { x: 297.841726618705, y: 1.25490196078431, size: 1 },
    //     { x: 298.489208633094, y: 2.98039215686275, size: 1 },
    //     { x: 299.784172661871, y: 3.29411764705882, size: 1 },
    //     { x: 300.431654676259, y: 3.13725490196078, size: 1 },
    //     { x: 301.079136690647, y: 2.98039215686275, size: 1 },
    //     { x: 305.611510791367, y: 2.94117647058824, size: 1 },
    //     { x: 311.438848920863, y: 2.82352941176471, size: 1 },
    //     { x: 313.381294964029, y: 3.17647058823529, size: 1 },
    //     { x: 314.028776978417, y: 3.29411764705882, size: 1 },
    //     { x: 315.971223021583, y: 3.13725490196078, size: 1 },
    //     { x: 317.26618705036, y: 3.29411764705882, size: 1 },
    //     { x: 317.913669064748, y: 2.94117647058824, size: 1 },
    //     { x: 318.561151079137, y: 3.25490196078431, size: 1 },
    //     { x: 338.63309352518, y: 3.2156862745098, size: 1 },
    //     { x: 339.280575539568, y: 2.70588235294118, size: 1 },
    //     { x: 339.928057553957, y: 2.82352941176471, size: 1 },
    //     { x: 340.575539568345, y: 4, size: 1 },
    //     { x: 359.352517985611, y: 3.01960784313725, size: 1 },
    //     { x: 0, y: 3.41176470588235, size: 1 },
    //     { x: 0.647482014388489, y: 2.19607843137255, size: 1 },
    //     { x: 1.29496402877698, y: 2.15686274509804, size: 1 },
    //     { x: 21.3669064748201, y: 3.29411764705882, size: 1 },
    //     { x: 22.0143884892086, y: 2.94117647058824, size: 1 },
    //     { x: 22.6618705035971, y: 2.74509803921569, size: 1 },
    //     { x: 24.6043165467626, y: 3.49019607843137, size: 1 },
    //     { x: 44.0287769784173, y: 2.47058823529412, size: 1 },
    //     { x: 44.6762589928058, y: 2.54901960784314, size: 1 },
    //     { x: 47.2661870503597, y: 3.25490196078431, size: 1 },
    //     { x: 81.5827338129496, y: 4, size: 1 },
    //     { x: 87.410071942446, y: 3.29411764705882, size: 1 },
    //     { x: 88.0575539568345, y: 3.2156862745098, size: 1 },
    //     { x: 106.187050359712, y: 3.33333333333333, size: 1 },
    //     { x: 107.482014388489, y: 2.86274509803922, size: 1 },
    //     { x: 130.143884892086, y: 4.07843137254902, size: 1 },
    //     { x: 147.625899280576, y: 3.33333333333333, size: 1 },
    //     { x: 150.863309352518, y: 3.17647058823529, size: 1 },
    //     { x: 151.510791366906, y: 3.2156862745098, size: 1 },
    //     { x: 152.158273381295, y: 3.09803921568627, size: 1 },
    //     { x: 161.223021582734, y: 3.96078431372549, size: 1 },
    //     { x: 165.755395683453, y: 3.84313725490196, size: 1 },
    //     { x: 167.05035971223, y: 3.80392156862745, size: 1 },
    //     { x: 168.345323741007, y: 3.80392156862745, size: 1 },
    //     { x: 172.230215827338, y: 3.09803921568627, size: 1 },
    //     { x: 172.877697841727, y: 3.13725490196078, size: 1 },
    //     { x: 173.525179856115, y: 2.58823529411765, size: 1 },
    //     { x: 174.172661870504, y: 2.50980392156863, size: 1 },
    //     { x: 183.237410071942, y: 3.76470588235294, size: 1 },
    //     { x: 194.244604316547, y: 3.37254901960784, size: 1 },
    //     { x: 215.611510791367, y: 3.17647058823529, size: 1 },
    //     { x: 224.028776978417, y: 3.09803921568627, size: 1 },
    //     { x: 231.798561151079, y: 3.92156862745098, size: 1 },
    //     { x: 247.338129496403, y: 3.92156862745098, size: 1 },
    //     { x: 249.280575539568, y: 3.84313725490196, size: 1 },
    //     { x: 260.935251798561, y: 3.41176470588235, size: 1 },
    //     { x: 279.712230215827, y: 3.72549019607843, size: 1 },
    //     { x: 284.892086330935, y: 3.96078431372549, size: 1 },
    //     { x: 285.539568345324, y: 3.92156862745098, size: 1 },
    //     { x: 287.482014388489, y: 3.84313725490196, size: 1 },
    //     { x: 290.071942446043, y: 3.80392156862745, size: 1 },
    //     { x: 293.309352517986, y: 4.03921568627451, size: 1 },
    //     { x: 297.841726618705, y: 3.92156862745098, size: 1 },
    //     { x: 299.136690647482, y: 3.96078431372549, size: 1 },
    //     { x: 303.021582733813, y: 3.33333333333333, size: 1 },
    //     { x: 303.669064748201, y: 3.05882352941176, size: 1 },
    //     { x: 304.31654676259, y: 3.17647058823529, size: 1 },
    //     { x: 304.964028776978, y: 3.13725490196078, size: 1 },
    //     { x: 311.438848920863, y: 3.13725490196078, size: 1 },
    //     { x: 316.618705035971, y: 3.33333333333333, size: 1 },
    //     { x: 321.151079136691, y: 2.94117647058824, size: 1 },
    //     { x: 323.741007194245, y: 3.41176470588235, size: 1 },
    //     { x: 325.035971223022, y: 3.13725490196078, size: 1 },
    //     { x: 326.330935251799, y: 3.29411764705882, size: 1 },
    //     { x: 342.517985611511, y: 3.84313725490196, size: 1 },
    //     { x: 343.165467625899, y: 3.96078431372549, size: 1 },
    //     { x: 344.460431654676, y: 3.2156862745098, size: 1 },
    //     { x: 345.107913669065, y: 3.17647058823529, size: 1 },
    //     { x: 346.402877697842, y: 2.54901960784314, size: 1 },
    //     { x: 347.05035971223, y: 3.2156862745098, size: 1 },
    //     { x: 347.697841726619, y: 2.7843137254902, size: 1 },
    //     { x: 348.345323741007, y: 2.82352941176471, size: 1 },
    //     { x: 350.935251798561, y: 3.37254901960784, size: 1 },
    //     { x: 359.352517985611, y: 3.25490196078431, size: 1 },
    //     { x: 7.12230215827338, y: 3.29411764705882, size: 1 },
    //     { x: 7.76978417266187, y: 2.70588235294118, size: 1 },
    //     { x: 8.41726618705036, y: 2.90196078431373, size: 1 },
    //     { x: 9.06474820143885, y: 2.98039215686275, size: 1 },
    //     { x: 10.3597122302158, y: 4.11764705882353, size: 1 },
    //     { x: 11.6546762589928, y: 4, size: 1 },
    //     { x: 13.5971223021583, y: 4, size: 1 },
    //     { x: 14.8920863309353, y: 4.11764705882353, size: 1 },
    //     { x: 16.8345323741007, y: 3.84313725490196, size: 1 },
    //     { x: 17.4820143884892, y: 3.92156862745098, size: 1 },
    //     { x: 20.0719424460432, y: 4, size: 1 },
    //     { x: 21.3669064748201, y: 3.96078431372549, size: 1 },
    //     { x: 22.0143884892086, y: 4.19607843137255, size: 1 },
    //     { x: 25.8992805755396, y: 4.11764705882353, size: 1 },
    //     { x: 26.5467625899281, y: 4.03921568627451, size: 1 },
    //     { x: 30.431654676259, y: 3.17647058823529, size: 1 },
    //     { x: 50.5035971223022, y: 3.17647058823529, size: 1 },
    //     { x: 52.4460431654676, y: 3.92156862745098, size: 1 },
    //     { x: 53.0935251798561, y: 3.88235294117647, size: 1 },
    //     { x: 55.6834532374101, y: 3.96078431372549, size: 1 },
    //     { x: 57.6258992805755, y: 3.80392156862745, size: 1 },
    //     { x: 58.273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 60.2158273381295, y: 4.03921568627451, size: 1 },
    //     { x: 60.863309352518, y: 3.84313725490196, size: 1 },
    //     { x: 61.5107913669065, y: 4.03921568627451, size: 1 },
    //     { x: 62.8057553956835, y: 3.84313725490196, size: 1 },
    //     { x: 67.9856115107914, y: 4.27450980392157, size: 1 },
    //     { x: 69.9280575539568, y: 3.96078431372549, size: 1 },
    //     { x: 70.5755395683453, y: 3.45098039215686, size: 1 },
    //     { x: 71.2230215827338, y: 3.29411764705882, size: 1 },
    //     { x: 71.8705035971223, y: 3.2156862745098, size: 1 },
    //     { x: 72.5179856115108, y: 2.3921568627451, size: 1 },
    //     { x: 73.1654676258993, y: 2.47058823529412, size: 1 },
    //     { x: 73.8129496402878, y: 4, size: 1 },
    //     { x: 74.4604316546763, y: 3.96078431372549, size: 1 },
    //     { x: 75.7553956834532, y: 3.96078431372549, size: 1 },
    //     { x: 77.6978417266187, y: 4, size: 1 },
    //     { x: 78.3453237410072, y: 3.84313725490196, size: 1 },
    //     { x: 78.9928057553957, y: 4.03921568627451, size: 1 },
    //     { x: 82.2302158273381, y: 4, size: 1 },
    //     { x: 83.5251798561151, y: 4.11764705882353, size: 1 },
    //     { x: 84.1726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 84.8201438848921, y: 4, size: 1 },
    //     { x: 86.1151079136691, y: 4.07843137254902, size: 1 },
    //     { x: 87.410071942446, y: 4.15686274509804, size: 1 },
    //     { x: 90, y: 4.15686274509804, size: 1 },
    //     { x: 91.9424460431655, y: 3.96078431372549, size: 1 },
    //     { x: 92.589928057554, y: 3.29411764705882, size: 1 },
    //     { x: 93.2374100719424, y: 3.17647058823529, size: 1 },
    //     { x: 93.8848920863309, y: 2.82352941176471, size: 1 },
    //     { x: 94.5323741007194, y: 2.70588235294118, size: 1 },
    //     { x: 97.1223021582734, y: 3.88235294117647, size: 1 },
    //     { x: 99.0647482014388, y: 3.92156862745098, size: 1 },
    //     { x: 101.007194244604, y: 4, size: 1 },
    //     { x: 102.302158273381, y: 3.96078431372549, size: 1 },
    //     { x: 105.539568345324, y: 3.92156862745098, size: 1 },
    //     { x: 106.834532374101, y: 3.88235294117647, size: 1 },
    //     { x: 110.071942446043, y: 3.96078431372549, size: 1 },
    //     { x: 113.309352517986, y: 4, size: 1 },
    //     { x: 115.251798561151, y: 3.29411764705882, size: 1 },
    //     { x: 115.89928057554, y: 2.94117647058824, size: 1 },
    //     { x: 124.964028776978, y: 3.72549019607843, size: 1 },
    //     { x: 140.503597122302, y: 3.84313725490196, size: 1 },
    //     { x: 142.446043165468, y: 3.92156862745098, size: 1 },
    //     { x: 157.985611510791, y: 3.17647058823529, size: 1 },
    //     { x: 158.63309352518, y: 2.94117647058824, size: 1 },
    //     { x: 159.280575539568, y: 2.98039215686275, size: 1 },
    //     { x: 180, y: 3.17647058823529, size: 1 },
    //     { x: 180.647482014388, y: 2.94117647058824, size: 1 },
    //     { x: 189.064748201439, y: 3.88235294117647, size: 1 },
    //     { x: 190.359712230216, y: 4, size: 1 },
    //     { x: 197.482014388489, y: 3.96078431372549, size: 1 },
    //     { x: 202.014388489209, y: 3.13725490196078, size: 1 },
    //     { x: 203.956834532374, y: 3.17647058823529, size: 1 },
    //     { x: 204.604316546763, y: 3.13725490196078, size: 1 },
    //     { x: 205.251798561151, y: 3.29411764705882, size: 1 },
    //     { x: 208.489208633094, y: 3.17647058823529, size: 1 },
    //     { x: 209.136690647482, y: 3.2156862745098, size: 1 },
    //     { x: 212.374100719424, y: 3.37254901960784, size: 1 },
    //     { x: 214.964028776978, y: 3.2156862745098, size: 1 },
    //     { x: 219.496402877698, y: 3.17647058823529, size: 1 },
    //     { x: 220.143884892086, y: 3.25490196078431, size: 1 },
    //     { x: 220.791366906475, y: 3.2156862745098, size: 1 },
    //     { x: 221.438848920863, y: 3.29411764705882, size: 1 },
    //     { x: 228.561151079137, y: 4.03921568627451, size: 1 },
    //     { x: 246.690647482014, y: 4.03921568627451, size: 1 },
    //     { x: 249.280575539568, y: 3.88235294117647, size: 1 },
    //     { x: 257.05035971223, y: 3.96078431372549, size: 1 },
    //     { x: 271.942446043165, y: 3.88235294117647, size: 1 },
    //     { x: 279.712230215827, y: 3.45098039215686, size: 1 },
    //     { x: 288.129496402878, y: 3.29411764705882, size: 1 },
    //     { x: 292.014388489209, y: 3.84313725490196, size: 1 },
    //     { x: 293.309352517986, y: 3.84313725490196, size: 1 },
    //     { x: 293.956834532374, y: 3.80392156862745, size: 1 },
    //     { x: 296.546762589928, y: 3.88235294117647, size: 1 },
    //     { x: 298.489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 306.906474820144, y: 3.84313725490196, size: 1 },
    //     { x: 308.848920863309, y: 3.2156862745098, size: 1 },
    //     { x: 310.143884892086, y: 2.62745098039216, size: 1 },
    //     { x: 313.381294964029, y: 3.92156862745098, size: 1 },
    //     { x: 317.913669064748, y: 3.88235294117647, size: 1 },
    //     { x: 321.798561151079, y: 4, size: 1 },
    //     { x: 327.625899280576, y: 3.76470588235294, size: 1 },
    //     { x: 330.863309352518, y: 3.13725490196078, size: 1 },
    //     { x: 332.805755395683, y: 3.25490196078431, size: 1 },
    //     { x: 336.690647482014, y: 3.29411764705882, size: 1 },
    //     { x: 352.877697841727, y: 3.25490196078431, size: 1 },
    //     { x: 353.525179856115, y: 3.17647058823529, size: 1 },
    //     { x: 354.172661870504, y: 3.92156862745098, size: 1 },
    //     { x: 358.705035971223, y: 3.88235294117647, size: 1 },
    //     { x: 0.648648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 1.2972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 3.24324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 3.89189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 5.83783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 6.48648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 7.78378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 11.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 13.6216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 14.2702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 14.9189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 24, y: 3.92156862745098, size: 1 },
    //     { x: 29.8378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 31.1351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 32.4324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 33.0810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 34.3783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 35.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 35.6756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 36.3243243243243, y: 2.54901960784314, size: 1 },
    //     { x: 36.972972972973, y: 2.62745098039216, size: 1 },
    //     { x: 40.2162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 42.8108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 48, y: 3.52941176470588, size: 1 },
    //     { x: 49.9459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 55.1351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 56.4324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 57.7297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 58.3783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 60.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 61.6216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 64.2162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 66.8108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 67.4594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 74.5945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 75.8918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 78.4864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 79.1351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 80.4324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 84.3243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 88.8648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 89.5135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 90.8108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 92.1081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 93.4054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 99.2432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 99.8918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 101.837837837838, y: 2.54901960784314, size: 1 },
    //     { x: 102.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 105.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 109.621621621622, y: 3.6078431372549, size: 1 },
    //     { x: 110.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 112.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 117.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 118.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 120.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 121.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 122.594594594595, y: 2.94117647058824, size: 1 },
    //     { x: 123.243243243243, y: 2.70588235294118, size: 1 },
    //     { x: 125.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 126.486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 127.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 130.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 132.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 134.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 136.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 140.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 143.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 144, y: 3.33333333333333, size: 1 },
    //     { x: 144.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 145.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 151.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 153.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 154.378378378378, y: 4, size: 1 },
    //     { x: 156.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 159.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 160.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 160.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 161.513513513514, y: 4.11764705882353, size: 1 },
    //     { x: 165.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 166.054054054054, y: 2.82352941176471, size: 1 },
    //     { x: 166.702702702703, y: 2.7843137254902, size: 1 },
    //     { x: 171.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 180.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 183.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 184.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 185.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 186.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 187.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 188.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 190.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 190.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 194.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 199.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 201.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 202.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 204.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 205.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 208.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 209.513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 210.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 213.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 214.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 214.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 221.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 226.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 227.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 228.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 229.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 230.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 230.918918918919, y: 2.74509803921569, size: 1 },
    //     { x: 231.567567567568, y: 2.98039215686275, size: 1 },
    //     { x: 232.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 234.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 236.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 237.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 241.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 245.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 246.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 248.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 249.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 253.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 256.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 258.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 263.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 269.189189189189, y: 3.52941176470588, size: 1 },
    //     { x: 269.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 272.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 273.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 273.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 274.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 275.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 279.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 285.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 289.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 295.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 297.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 297.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 299.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 300.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 305.513513513513, y: 3.56862745098039, size: 1 },
    //     { x: 311.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 315.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 316.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 317.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 317.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 321.081081081081, y: 3.68627450980392, size: 1 },
    //     { x: 324.972972972973, y: 3.56862745098039, size: 1 },
    //     { x: 326.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 328.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 330.162162162162, y: 3.68627450980392, size: 1 },
    //     { x: 330.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 331.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 332.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 333.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 336, y: 3.76470588235294, size: 1 },
    //     { x: 337.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 337.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 341.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 341.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 347.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 348.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 351.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 352.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 354.162162162162, y: 4.19607843137255, size: 1 },
    //     { x: 359.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 16.1870503597122, y: 4, size: 1 },
    //     { x: 24.6043165467626, y: 3.96078431372549, size: 1 },
    //     { x: 47.2661870503597, y: 3.96078431372549, size: 1 },
    //     { x: 60.2158273381295, y: 3.72549019607843, size: 1 },
    //     { x: 64.7482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 65.3956834532374, y: 2.90196078431373, size: 1 },
    //     { x: 66.0431654676259, y: 2.82352941176471, size: 1 },
    //     { x: 79.6402877697842, y: 4, size: 1 },
    //     { x: 88.705035971223, y: 3.88235294117647, size: 1 },
    //     { x: 93.8848920863309, y: 3.76470588235294, size: 1 },
    //     { x: 94.5323741007194, y: 3.92156862745098, size: 1 },
    //     { x: 113.309352517986, y: 3.76470588235294, size: 1 },
    //     { x: 123.021582733813, y: 3.33333333333333, size: 1 },
    //     { x: 130.143884892086, y: 3.09803921568627, size: 1 },
    //     { x: 130.791366906475, y: 2.82352941176471, size: 1 },
    //     { x: 146.978417266187, y: 3.88235294117647, size: 1 },
    //     { x: 151.510791366906, y: 2.86274509803922, size: 1 },
    //     { x: 152.158273381295, y: 3.01960784313725, size: 1 },
    //     { x: 152.805755395683, y: 3.92156862745098, size: 1 },
    //     { x: 192.302158273381, y: 4.07843137254902, size: 1 },
    //     { x: 202.661870503597, y: 4, size: 1 },
    //     { x: 215.611510791367, y: 3.29411764705882, size: 1 },
    //     { x: 216.258992805755, y: 2.86274509803922, size: 1 },
    //     { x: 232.446043165468, y: 3.96078431372549, size: 1 },
    //     { x: 236.330935251799, y: 3.25490196078431, size: 1 },
    //     { x: 237.625899280576, y: 2.90196078431373, size: 1 },
    //     { x: 238.273381294964, y: 2.90196078431373, size: 1 },
    //     { x: 238.920863309353, y: 3.25490196078431, size: 1 },
    //     { x: 251.223021582734, y: 4.07843137254902, size: 1 },
    //     { x: 281.007194244604, y: 3.09803921568627, size: 1 },
    //     { x: 281.654676258993, y: 2.98039215686275, size: 1 },
    //     { x: 305.611510791367, y: 3.92156862745098, size: 1 },
    //     { x: 321.798561151079, y: 3.80392156862745, size: 1 },
    //     { x: 345.755395683453, y: 3.29411764705882, size: 1 },
    //     { x: 6.47482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 7.76978417266187, y: 3.05882352941176, size: 1 },
    //     { x: 27.841726618705, y: 3.29411764705882, size: 1 },
    //     { x: 29.7841726618705, y: 3.13725490196078, size: 1 },
    //     { x: 33.0215827338129, y: 3.45098039215686, size: 1 },
    //     { x: 49.2086330935252, y: 3.92156862745098, size: 1 },
    //     { x: 50.5035971223022, y: 3.13725490196078, size: 1 },
    //     { x: 76.4028776978417, y: 4.03921568627451, size: 1 },
    //     { x: 82.2302158273381, y: 3.88235294117647, size: 1 },
    //     { x: 88.0575539568345, y: 4.07843137254902, size: 1 },
    //     { x: 92.589928057554, y: 3.2156862745098, size: 1 },
    //     { x: 93.2374100719424, y: 3.2156862745098, size: 1 },
    //     { x: 115.89928057554, y: 3.41176470588235, size: 1 },
    //     { x: 122.374100719424, y: 3.76470588235294, size: 1 },
    //     { x: 124.31654676259, y: 3.96078431372549, size: 1 },
    //     { x: 134.676258992806, y: 3.80392156862745, size: 1 },
    //     { x: 137.26618705036, y: 3.09803921568627, size: 1 },
    //     { x: 147.625899280576, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 3.29411764705882, size: 1 },
    //     { x: 157.985611510791, y: 3.13725490196078, size: 1 },
    //     { x: 158.63309352518, y: 2.98039215686275, size: 1 },
    //     { x: 187.769784172662, y: 3.84313725490196, size: 1 },
    //     { x: 202.014388489209, y: 2.82352941176471, size: 1 },
    //     { x: 222.73381294964, y: 3.2156862745098, size: 1 },
    //     { x: 223.381294964029, y: 2.74509803921569, size: 1 },
    //     { x: 224.028776978417, y: 2.98039215686275, size: 1 },
    //     { x: 230.503597122302, y: 3.88235294117647, size: 1 },
    //     { x: 244.748201438849, y: 3.01960784313725, size: 1 },
    //     { x: 245.395683453237, y: 2.70588235294118, size: 1 },
    //     { x: 251.870503597122, y: 3.64705882352941, size: 1 },
    //     { x: 255.107913669065, y: 3.92156862745098, size: 1 },
    //     { x: 266.115107913669, y: 3.05882352941176, size: 1 },
    //     { x: 266.762589928058, y: 2.54901960784314, size: 1 },
    //     { x: 267.410071942446, y: 3.25490196078431, size: 1 },
    //     { x: 282.94964028777, y: 3.88235294117647, size: 1 },
    //     { x: 287.482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 288.129496402878, y: 2.11764705882353, size: 1 },
    //     { x: 288.776978417266, y: 2.19607843137255, size: 1 },
    //     { x: 292.661870503597, y: 3.80392156862745, size: 1 },
    //     { x: 295.89928057554, y: 3.45098039215686, size: 1 },
    //     { x: 308.201438848921, y: 3.13725490196078, size: 1 },
    //     { x: 309.496402877698, y: 3.09803921568627, size: 1 },
    //     { x: 310.143884892086, y: 3.01960784313725, size: 1 },
    //     { x: 312.73381294964, y: 3.92156862745098, size: 1 },
    //     { x: 330.863309352518, y: 4, size: 1 },
    //     { x: 346.402877697842, y: 4.03921568627451, size: 1 },
    //     { x: 352.230215827338, y: 3.33333333333333, size: 1 },
    //     { x: 352.877697841727, y: 2.62745098039216, size: 1 },
    //     { x: 353.525179856115, y: 2.66666666666667, size: 1 },
    //     { x: 359.352517985611, y: 3.88235294117647, size: 1 },
    //     { x: 2.58992805755396, y: 3.92156862745098, size: 1 },
    //     { x: 5.17985611510791, y: 3.92156862745098, size: 1 },
    //     { x: 12.9496402877698, y: 3.2156862745098, size: 1 },
    //     { x: 14.2446043165468, y: 3.05882352941176, size: 1 },
    //     { x: 14.8920863309353, y: 2.62745098039216, size: 1 },
    //     { x: 32.3741007194245, y: 3.37254901960784, size: 1 },
    //     { x: 35.6115107913669, y: 3.01960784313725, size: 1 },
    //     { x: 36.2589928057554, y: 2.15686274509804, size: 1 },
    //     { x: 44.6762589928058, y: 3.33333333333333, size: 1 },
    //     { x: 51.7985611510791, y: 3.80392156862745, size: 1 },
    //     { x: 56.3309352517986, y: 3.33333333333333, size: 1 },
    //     { x: 56.9784172661871, y: 3.29411764705882, size: 1 },
    //     { x: 57.6258992805755, y: 3.09803921568627, size: 1 },
    //     { x: 58.273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 58.9208633093525, y: 3.29411764705882, size: 1 },
    //     { x: 65.3956834532374, y: 3.29411764705882, size: 1 },
    //     { x: 77.0503597122302, y: 3.33333333333333, size: 1 },
    //     { x: 78.3453237410072, y: 3.09803921568627, size: 1 },
    //     { x: 78.9928057553957, y: 2.11764705882353, size: 1 },
    //     { x: 79.6402877697842, y: 1.2156862745098, size: 1 },
    //     { x: 91.294964028777, y: 3.80392156862745, size: 1 },
    //     { x: 99.7122302158273, y: 2.98039215686275, size: 1 },
    //     { x: 100.359712230216, y: 2.98039215686275, size: 1 },
    //     { x: 101.007194244604, y: 2.43137254901961, size: 1 },
    //     { x: 141.798561151079, y: 3.29411764705882, size: 1 },
    //     { x: 142.446043165468, y: 3.2156862745098, size: 1 },
    //     { x: 143.741007194245, y: 2.90196078431373, size: 1 },
    //     { x: 144.388489208633, y: 2.7843137254902, size: 1 },
    //     { x: 146.978417266187, y: 3.96078431372549, size: 1 },
    //     { x: 148.273381294964, y: 3.88235294117647, size: 1 },
    //     { x: 148.920863309353, y: 3.84313725490196, size: 1 },
    //     { x: 155.395683453237, y: 3.88235294117647, size: 1 },
    //     { x: 157.338129496403, y: 3.76470588235294, size: 1 },
    //     { x: 157.985611510791, y: 4, size: 1 },
    //     { x: 159.280575539568, y: 4, size: 1 },
    //     { x: 176.762589928058, y: 3.41176470588235, size: 1 },
    //     { x: 202.014388489209, y: 3.84313725490196, size: 1 },
    //     { x: 209.784172661871, y: 3.49019607843137, size: 1 },
    //     { x: 251.870503597122, y: 3.01960784313725, size: 1 },
    //     { x: 252.517985611511, y: 2.98039215686275, size: 1 },
    //     { x: 253.165467625899, y: 3.17647058823529, size: 1 },
    //     { x: 253.812949640288, y: 3.25490196078431, size: 1 },
    //     { x: 274.532374100719, y: 3.13725490196078, size: 1 },
    //     { x: 275.179856115108, y: 3.05882352941176, size: 1 },
    //     { x: 288.776978417266, y: 3.96078431372549, size: 1 },
    //     { x: 293.309352517986, y: 3.33333333333333, size: 1 },
    //     { x: 294.604316546763, y: 3.09803921568627, size: 1 },
    //     { x: 295.251798561151, y: 2.86274509803922, size: 1 },
    //     { x: 297.194244604317, y: 3.2156862745098, size: 1 },
    //     { x: 315.323741007194, y: 3.29411764705882, size: 1 },
    //     { x: 317.26618705036, y: 3.09803921568627, size: 1 },
    //     { x: 317.913669064748, y: 2.90196078431373, size: 1 },
    //     { x: 318.561151079137, y: 2.62745098039216, size: 1 },
    //     { x: 337.985611510791, y: 3.2156862745098, size: 1 },
    //     { x: 338.63309352518, y: 3.05882352941176, size: 1 },
    //     { x: 347.05035971223, y: 3.84313725490196, size: 1 },
    //     { x: 0, y: 2.82352941176471, size: 1 },
    //     { x: 0.647482014388489, y: 2.86274509803922, size: 1 },
    //     { x: 1.29496402877698, y: 3.29411764705882, size: 1 },
    //     { x: 1.94244604316547, y: 3.09803921568627, size: 1 },
    //     { x: 14.8920863309353, y: 4, size: 1 },
    //     { x: 15.5395683453237, y: 4.07843137254902, size: 1 },
    //     { x: 20.7194244604317, y: 3.01960784313725, size: 1 },
    //     { x: 21.3669064748201, y: 2.7843137254902, size: 1 },
    //     { x: 22.0143884892086, y: 2.62745098039216, size: 1 },
    //     { x: 64.7482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 65.3956834532374, y: 3.2156862745098, size: 1 },
    //     { x: 76.4028776978417, y: 3.88235294117647, size: 1 },
    //     { x: 150.863309352518, y: 2.98039215686275, size: 1 },
    //     { x: 151.510791366906, y: 2.94117647058824, size: 1 },
    //     { x: 152.805755395683, y: 3.13725490196078, size: 1 },
    //     { x: 157.985611510791, y: 3.92156862745098, size: 1 },
    //     { x: 173.525179856115, y: 2.94117647058824, size: 1 },
    //     { x: 179.352517985612, y: 3.92156862745098, size: 1 },
    //     { x: 194.244604316547, y: 3.25490196078431, size: 1 },
    //     { x: 215.611510791367, y: 3.13725490196078, size: 1 },
    //     { x: 235.68345323741, y: 3.25490196078431, size: 1 },
    //     { x: 236.978417266187, y: 3.17647058823529, size: 1 },
    //     { x: 237.625899280576, y: 3.01960784313725, size: 1 },
    //     { x: 240.215827338129, y: 3.45098039215686, size: 1 },
    //     { x: 257.05035971223, y: 3.17647058823529, size: 1 },
    //     { x: 262.230215827338, y: 3.29411764705882, size: 1 },
    //     { x: 263.525179856115, y: 3.37254901960784, size: 1 },
    //     { x: 291.36690647482, y: 3.96078431372549, size: 1 },
    //     { x: 315.971223021583, y: 3.92156862745098, size: 1 },
    //     { x: 325.035971223022, y: 3.88235294117647, size: 1 },
    //     { x: 326.978417266187, y: 3.92156862745098, size: 1 },
    //     { x: 330.863309352518, y: 4.11764705882353, size: 1 },
    //     { x: 332.158273381295, y: 4.15686274509804, size: 1 },
    //     { x: 333.453237410072, y: 3.88235294117647, size: 1 },
    //     { x: 336.690647482014, y: 3.92156862745098, size: 1 },
    //     { x: 337.985611510791, y: 3.96078431372549, size: 1 },
    //     { x: 339.280575539568, y: 4.03921568627451, size: 1 },
    //     { x: 344.460431654676, y: 3.17647058823529, size: 1 },
    //     { x: 345.107913669065, y: 2.50980392156863, size: 1 },
    //     { x: 345.755395683453, y: 2.7843137254902, size: 1 },
    //     { x: 346.402877697842, y: 2.7843137254902, size: 1 },
    //     { x: 347.05035971223, y: 2.50980392156863, size: 1 },
    //     { x: 1.2972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 3.24324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 12.3243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 12.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 14.2702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 15.5675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 20.7567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 23.3513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 25.9459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 26.5945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 33.0810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 33.7297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 35.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 40.2162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 48, y: 3.68627450980392, size: 1 },
    //     { x: 49.9459459459459, y: 3.01960784313725, size: 1 },
    //     { x: 50.5945945945946, y: 2.74509803921569, size: 1 },
    //     { x: 51.2432432432432, y: 2.90196078431373, size: 1 },
    //     { x: 51.8918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 52.5405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 57.0810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 59.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 61.6216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 62.9189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 72, y: 3.25490196078431, size: 1 },
    //     { x: 83.6756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 84.3243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 87.5675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 91.4594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 92.7567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 93.4054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 101.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 103.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 108.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 110.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 120, y: 3.72549019607843, size: 1 },
    //     { x: 120.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 121.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 122.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 126.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 127.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 128.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 130.378378378378, y: 3.64705882352941, size: 1 },
    //     { x: 132.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 135.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 136.216216216216, y: 2.58823529411765, size: 1 },
    //     { x: 136.864864864865, y: 2.47058823529412, size: 1 },
    //     { x: 142.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 146.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 147.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 150.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 151.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 158.918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 160.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 160.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 163.459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 164.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 164.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 165.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 169.297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 169.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 170.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 171.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 171.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 174.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 176.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 179.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 179.675675675676, y: 2.90196078431373, size: 1 },
    //     { x: 180.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 182.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 185.513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 186.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 186.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 188.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 188.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 190.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 191.351351351351, y: 3.52941176470588, size: 1 },
    //     { x: 193.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 193.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 195.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 197.189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 197.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 199.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 199.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 201.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 201.72972972973, y: 2.82352941176471, size: 1 },
    //     { x: 203.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 203.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 204.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 206.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 207.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 208.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 208.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 209.513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 210.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 212.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 212.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 216, y: 3.37254901960784, size: 1 },
    //     { x: 216.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 217.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 219.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 219.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 220.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 221.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 222.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 223.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 223.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 224.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 225.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 228.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 230.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 230.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 232.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 232.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 233.513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 234.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 238.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 240, y: 3.33333333333333, size: 1 },
    //     { x: 241.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 243.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 244.540540540541, y: 2.86274509803922, size: 1 },
    //     { x: 245.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 245.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 247.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 249.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 249.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 251.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 252.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 265.945945945946, y: 2.98039215686275, size: 1 },
    //     { x: 266.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 267.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 267.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 268.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 269.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 273.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 277.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 278.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 279.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 280.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 285.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 286.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 288, y: 3.33333333333333, size: 1 },
    //     { x: 291.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 291.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 294.486486486487, y: 3.33333333333333, size: 1 },
    //     { x: 295.135135135135, y: 3.52941176470588, size: 1 },
    //     { x: 295.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 296.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 298.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 299.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 299.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 301.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 302.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 302.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 303.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 304.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 308.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 308.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 309.405405405405, y: 2.90196078431373, size: 1 },
    //     { x: 310.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 310.702702702703, y: 3.6078431372549, size: 1 },
    //     { x: 315.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 317.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 318.486486486487, y: 3.41176470588235, size: 1 },
    //     { x: 323.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 324.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 326.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 327.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 328.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 330.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 331.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 334.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 338.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 343.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 345.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 346.378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 352.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 352.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 50.5035971223022, y: 3.41176470588235, size: 1 },
    //     { x: 57.6258992805755, y: 3.33333333333333, size: 1 },
    //     { x: 84.8201438848921, y: 3.29411764705882, size: 1 },
    //     { x: 90, y: 3.84313725490196, size: 1 },
    //     { x: 95.8273381294964, y: 3.41176470588235, size: 1 },
    //     { x: 100.359712230216, y: 3.13725490196078, size: 1 },
    //     { x: 101.007194244604, y: 3.17647058823529, size: 1 },
    //     { x: 102.302158273381, y: 3.2156862745098, size: 1 },
    //     { x: 116.546762589928, y: 3.29411764705882, size: 1 },
    //     { x: 122.374100719424, y: 2.74509803921569, size: 1 },
    //     { x: 123.021582733813, y: 3.13725490196078, size: 1 },
    //     { x: 128.201438848921, y: 3.29411764705882, size: 1 },
    //     { x: 131.438848920863, y: 3.33333333333333, size: 1 },
    //     { x: 141.798561151079, y: 3.33333333333333, size: 1 },
    //     { x: 143.741007194245, y: 2.82352941176471, size: 1 },
    //     { x: 144.388489208633, y: 2.98039215686275, size: 1 },
    //     { x: 199.424460431655, y: 3.92156862745098, size: 1 },
    //     { x: 203.309352517986, y: 3.33333333333333, size: 1 },
    //     { x: 207.841726618705, y: 3.25490196078431, size: 1 },
    //     { x: 214.31654676259, y: 3.29411764705882, size: 1 },
    //     { x: 214.964028776978, y: 3.17647058823529, size: 1 },
    //     { x: 219.496402877698, y: 3.29411764705882, size: 1 },
    //     { x: 222.086330935252, y: 3.25490196078431, size: 1 },
    //     { x: 235.035971223022, y: 3.88235294117647, size: 1 },
    //     { x: 237.625899280576, y: 3.84313725490196, size: 1 },
    //     { x: 249.280575539568, y: 3.92156862745098, size: 1 },
    //     { x: 252.517985611511, y: 3.05882352941176, size: 1 },
    //     { x: 253.165467625899, y: 3.41176470588235, size: 1 },
    //     { x: 254.460431654676, y: 3.25490196078431, size: 1 },
    //     { x: 256.402877697842, y: 3.41176470588235, size: 1 },
    //     { x: 257.697841726619, y: 3.25490196078431, size: 1 },
    //     { x: 264.820143884892, y: 3.29411764705882, size: 1 },
    //     { x: 266.115107913669, y: 3.37254901960784, size: 1 },
    //     { x: 268.705035971223, y: 3.17647058823529, size: 1 },
    //     { x: 275.179856115108, y: 3.2156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.2156862745098, size: 1 },
    //     { x: 287.482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 297.841726618705, y: 3.33333333333333, size: 1 },
    //     { x: 301.079136690647, y: 3.2156862745098, size: 1 },
    //     { x: 312.086330935252, y: 3.33333333333333, size: 1 },
    //     { x: 314.028776978417, y: 3.2156862745098, size: 1 },
    //     { x: 314.676258992806, y: 3.33333333333333, size: 1 },
    //     { x: 328.273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 336.690647482014, y: 3.37254901960784, size: 1 },
    //     { x: 337.985611510791, y: 2.3921568627451, size: 1 },
    //     { x: 338.63309352518, y: 2.31372549019608, size: 1 },
    //     { x: 359.352517985611, y: 2.74509803921569, size: 1 },
    //     { x: 0, y: 2.86274509803922, size: 1 },
    //     { x: 6.47482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 14.2446043165468, y: 3.33333333333333, size: 1 },
    //     { x: 25.2517985611511, y: 3.96078431372549, size: 1 },
    //     { x: 26.5467625899281, y: 3.88235294117647, size: 1 },
    //     { x: 31.0791366906475, y: 3.76470588235294, size: 1 },
    //     { x: 34.9640287769784, y: 3.96078431372549, size: 1 },
    //     { x: 38.8489208633094, y: 3.80392156862745, size: 1 },
    //     { x: 55.0359712230216, y: 3.88235294117647, size: 1 },
    //     { x: 64.7482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 67.9856115107914, y: 3.29411764705882, size: 1 },
    //     { x: 78.9928057553957, y: 3.45098039215686, size: 1 },
    //     { x: 86.1151079136691, y: 2.7843137254902, size: 1 },
    //     { x: 106.834532374101, y: 3.25490196078431, size: 1 },
    //     { x: 107.482014388489, y: 2.98039215686275, size: 1 },
    //     { x: 108.129496402878, y: 3.13725490196078, size: 1 },
    //     { x: 128.848920863309, y: 3.09803921568627, size: 1 },
    //     { x: 149.568345323741, y: 3.01960784313725, size: 1 },
    //     { x: 150.215827338129, y: 2.86274509803922, size: 1 },
    //     { x: 150.863309352518, y: 0.784313725490196, size: 1 },
    //     { x: 151.510791366906, y: 0.627450980392157, size: 1 },
    //     { x: 152.158273381295, y: 0.784313725490196, size: 1 },
    //     { x: 152.805755395683, y: 0.784313725490196, size: 1 },
    //     { x: 154.748201438849, y: 3.37254901960784, size: 1 },
    //     { x: 155.395683453237, y: 2.82352941176471, size: 1 },
    //     { x: 159.928057553957, y: 3.05882352941176, size: 1 },
    //     { x: 160.575539568345, y: 3.05882352941176, size: 1 },
    //     { x: 166.402877697842, y: 2.90196078431373, size: 1 },
    //     { x: 167.05035971223, y: 3.2156862745098, size: 1 },
    //     { x: 168.992805755396, y: 3.29411764705882, size: 1 },
    //     { x: 172.230215827338, y: 3.33333333333333, size: 1 },
    //     { x: 180, y: 3.96078431372549, size: 1 },
    //     { x: 182.589928057554, y: 3.92156862745098, size: 1 },
    //     { x: 194.244604316547, y: 3.01960784313725, size: 1 },
    //     { x: 200.719424460432, y: 3.41176470588235, size: 1 },
    //     { x: 214.31654676259, y: 3.25490196078431, size: 1 },
    //     { x: 236.978417266187, y: 2.94117647058824, size: 1 },
    //     { x: 237.625899280576, y: 2.7843137254902, size: 1 },
    //     { x: 258.345323741007, y: 2.58823529411765, size: 1 },
    //     { x: 258.992805755396, y: 2.74509803921569, size: 1 },
    //     { x: 260.935251798561, y: 3.29411764705882, size: 1 },
    //     { x: 268.057553956835, y: 4.03921568627451, size: 1 },
    //     { x: 278.41726618705, y: 3.17647058823529, size: 1 },
    //     { x: 279.064748201439, y: 3.41176470588235, size: 1 },
    //     { x: 279.712230215827, y: 2.94117647058824, size: 1 },
    //     { x: 280.359712230216, y: 2.35294117647059, size: 1 },
    //     { x: 284.244604316547, y: 4, size: 1 },
    //     { x: 290.719424460432, y: 3.88235294117647, size: 1 },
    //     { x: 300.431654676259, y: 3.05882352941176, size: 1 },
    //     { x: 301.079136690647, y: 2.90196078431373, size: 1 },
    //     { x: 301.726618705036, y: 2.11764705882353, size: 1 },
    //     { x: 302.374100719424, y: 2.23529411764706, size: 1 },
    //     { x: 321.798561151079, y: 3.13725490196078, size: 1 },
    //     { x: 323.093525179856, y: 2.07843137254902, size: 1 },
    //     { x: 323.741007194245, y: 2.23529411764706, size: 1 },
    //     { x: 338.63309352518, y: 4.03921568627451, size: 1 },
    //     { x: 352.877697841727, y: 3.37254901960784, size: 1 },
    //     { x: 4.53237410071942, y: 3.29411764705882, size: 1 },
    //     { x: 5.8273381294964, y: 2.94117647058824, size: 1 },
    //     { x: 6.47482014388489, y: 2.43137254901961, size: 1 },
    //     { x: 7.12230215827338, y: 2.31372549019608, size: 1 },
    //     { x: 21.3669064748201, y: 4, size: 1 },
    //     { x: 27.841726618705, y: 2.70588235294118, size: 1 },
    //     { x: 28.4892086330935, y: 2.62745098039216, size: 1 },
    //     { x: 37.5539568345324, y: 3.92156862745098, size: 1 },
    //     { x: 40.7913669064748, y: 3.88235294117647, size: 1 },
    //     { x: 44.6762589928058, y: 3.84313725490196, size: 1 },
    //     { x: 47.9136690647482, y: 3.25490196078431, size: 1 },
    //     { x: 48.5611510791367, y: 3.17647058823529, size: 1 },
    //     { x: 49.8561151079137, y: 2.66666666666667, size: 1 },
    //     { x: 50.5035971223022, y: 2.98039215686275, size: 1 },
    //     { x: 72.5179856115108, y: 4.07843137254902, size: 1 },
    //     { x: 90, y: 3.88235294117647, size: 1 },
    //     { x: 102.302158273381, y: 3.88235294117647, size: 1 },
    //     { x: 119.784172661871, y: 3.92156862745098, size: 1 },
    //     { x: 157.985611510791, y: 3.37254901960784, size: 1 },
    //     { x: 169.640287769784, y: 3.92156862745098, size: 1 },
    //     { x: 176.115107913669, y: 3.92156862745098, size: 1 },
    //     { x: 179.352517985612, y: 2.70588235294118, size: 1 },
    //     { x: 180, y: 2.7843137254902, size: 1 },
    //     { x: 181.294964028777, y: 2.82352941176471, size: 1 },
    //     { x: 187.122302158273, y: 3.96078431372549, size: 1 },
    //     { x: 200.719424460432, y: 3.17647058823529, size: 1 },
    //     { x: 201.36690647482, y: 3.01960784313725, size: 1 },
    //     { x: 202.014388489209, y: 2.90196078431373, size: 1 },
    //     { x: 202.661870503597, y: 2.82352941176471, size: 1 },
    //     { x: 207.841726618705, y: 3.88235294117647, size: 1 },
    //     { x: 222.086330935252, y: 3.29411764705882, size: 1 },
    //     { x: 222.73381294964, y: 3.13725490196078, size: 1 },
    //     { x: 223.381294964029, y: 3.29411764705882, size: 1 },
    //     { x: 240.215827338129, y: 4.07843137254902, size: 1 },
    //     { x: 242.158273381295, y: 3.25490196078431, size: 1 },
    //     { x: 242.805755395683, y: 3.17647058823529, size: 1 },
    //     { x: 244.10071942446, y: 3.05882352941176, size: 1 },
    //     { x: 286.834532374101, y: 3.13725490196078, size: 1 },
    //     { x: 287.482014388489, y: 2.82352941176471, size: 1 },
    //     { x: 298.489208633094, y: 3.96078431372549, size: 1 },
    //     { x: 301.726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 307.553956834532, y: 3.01960784313725, size: 1 },
    //     { x: 308.201438848921, y: 3.01960784313725, size: 1 },
    //     { x: 308.848920863309, y: 2.23529411764706, size: 1 },
    //     { x: 310.791366906475, y: 3.96078431372549, size: 1 },
    //     { x: 329.568345323741, y: 3.84313725490196, size: 1 },
    //     { x: 343.812949640288, y: 3.41176470588235, size: 1 },
    //     { x: 352.230215827338, y: 3.29411764705882, size: 1 },
    //     { x: 356.762589928058, y: 3.96078431372549, size: 1 },
    //     { x: 2.59459459459459, y: 4.11764705882353, size: 1 },
    //     { x: 4.54054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 5.83783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 8.43243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 11.6756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 12.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 14.9189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 17.5135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 18.1621621621622, y: 4, size: 1 },
    //     { x: 24, y: 3.72549019607843, size: 1 },
    //     { x: 27.2432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 29.1891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 34.3783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 35.6756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 37.6216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 38.9189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 45.4054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 49.2972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 51.8918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 53.1891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 53.8378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 56.4324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 57.0810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 57.7297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 58.3783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 59.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 62.9189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 64.2162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 64.8648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 65.5135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 66.8108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 68.1081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 70.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 70.7027027027027, y: 4, size: 1 },
    //     { x: 71.3513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 72.6486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 73.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 74.5945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 75.2432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 77.8378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 85.6216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 91.4594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 94.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 99.8918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 100.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 101.189189189189, y: 2.94117647058824, size: 1 },
    //     { x: 101.837837837838, y: 2.86274509803922, size: 1 },
    //     { x: 109.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 110.27027027027, y: 3.64705882352941, size: 1 },
    //     { x: 112.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 116.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 121.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 121.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 123.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 124.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 126.486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 136.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 144.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 151.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 164.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 164.756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 165.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 171.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 177.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 178.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 183.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 186.810810810811, y: 2.90196078431373, size: 1 },
    //     { x: 192, y: 3.41176470588235, size: 1 },
    //     { x: 195.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 199.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 201.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 207.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 208.216216216216, y: 2.70588235294118, size: 1 },
    //     { x: 211.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 212.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 214.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 215.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 216, y: 3.29411764705882, size: 1 },
    //     { x: 217.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 221.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 227.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 228.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 228.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 229.621621621622, y: 2.62745098039216, size: 1 },
    //     { x: 230.27027027027, y: 2.50980392156863, size: 1 },
    //     { x: 230.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 234.162162162162, y: 3.6078431372549, size: 1 },
    //     { x: 234.810810810811, y: 3.52941176470588, size: 1 },
    //     { x: 235.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 238.702702702703, y: 3.52941176470588, size: 1 },
    //     { x: 243.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 251.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 251.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 256.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 258.162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 258.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 260.108108108108, y: 4, size: 1 },
    //     { x: 261.405405405405, y: 4, size: 1 },
    //     { x: 268.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 269.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 271.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 273.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 273.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 276.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 280.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 287.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 289.297297297297, y: 3.56862745098039, size: 1 },
    //     { x: 294.486486486487, y: 2.94117647058824, size: 1 },
    //     { x: 295.783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 297.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 299.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 299.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 303.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 304.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 306.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 307.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 310.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 312, y: 3.29411764705882, size: 1 },
    //     { x: 312.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 313.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 314.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 315.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 316.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 320.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 321.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 323.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 325.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 326.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 328.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 328.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 329.513513513513, y: 3.52941176470588, size: 1 },
    //     { x: 330.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 330.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 332.108108108108, y: 3.64705882352941, size: 1 },
    //     { x: 332.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 333.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 335.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 342.486486486487, y: 3.45098039215686, size: 1 },
    //     { x: 343.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 344.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 345.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 352.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 357.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 358.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 358.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 359.351351351351, y: 2.82352941176471, size: 1 },
    //     { x: 0, y: 2.7843137254902, size: 1 },
    //     { x: 0.647482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 1.94244604316547, y: 3.41176470588235, size: 1 },
    //     { x: 3.23741007194245, y: 3.33333333333333, size: 1 },
    //     { x: 7.12230215827338, y: 3.33333333333333, size: 1 },
    //     { x: 23.9568345323741, y: 3.92156862745098, size: 1 },
    //     { x: 64.1007194244604, y: 3.13725490196078, size: 1 },
    //     { x: 64.7482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 88.0575539568345, y: 3.33333333333333, size: 1 },
    //     { x: 96.4748201438849, y: 3.33333333333333, size: 1 },
    //     { x: 98.4172661870504, y: 3.29411764705882, size: 1 },
    //     { x: 101.007194244604, y: 3.33333333333333, size: 1 },
    //     { x: 102.94964028777, y: 3.29411764705882, size: 1 },
    //     { x: 107.482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 108.129496402878, y: 3.29411764705882, size: 1 },
    //     { x: 117.841726618705, y: 3.33333333333333, size: 1 },
    //     { x: 128.848920863309, y: 2.90196078431373, size: 1 },
    //     { x: 134.676258992806, y: 3.25490196078431, size: 1 },
    //     { x: 141.798561151079, y: 3.25490196078431, size: 1 },
    //     { x: 145.035971223022, y: 3.29411764705882, size: 1 },
    //     { x: 147.625899280576, y: 3.29411764705882, size: 1 },
    //     { x: 150.215827338129, y: 3.29411764705882, size: 1 },
    //     { x: 163.812949640288, y: 3.2156862745098, size: 1 },
    //     { x: 170.287769784173, y: 3.45098039215686, size: 1 },
    //     { x: 174.172661870504, y: 3.80392156862745, size: 1 },
    //     { x: 192.302158273381, y: 3.37254901960784, size: 1 },
    //     { x: 192.94964028777, y: 3.05882352941176, size: 1 },
    //     { x: 193.597122302158, y: 3.01960784313725, size: 1 },
    //     { x: 194.244604316547, y: 2.94117647058824, size: 1 },
    //     { x: 202.661870503597, y: 3.84313725490196, size: 1 },
    //     { x: 214.964028776978, y: 2.66666666666667, size: 1 },
    //     { x: 215.611510791367, y: 2.54901960784314, size: 1 },
    //     { x: 229.208633093525, y: 3.33333333333333, size: 1 },
    //     { x: 235.68345323741, y: 3.29411764705882, size: 1 },
    //     { x: 236.330935251799, y: 3.33333333333333, size: 1 },
    //     { x: 236.978417266187, y: 2.58823529411765, size: 1 },
    //     { x: 237.625899280576, y: 3.2156862745098, size: 1 },
    //     { x: 245.395683453237, y: 3.88235294117647, size: 1 },
    //     { x: 264.820143884892, y: 3.2156862745098, size: 1 },
    //     { x: 267.410071942446, y: 3.33333333333333, size: 1 },
    //     { x: 275.179856115108, y: 3.25490196078431, size: 1 },
    //     { x: 279.712230215827, y: 3.05882352941176, size: 1 },
    //     { x: 280.359712230216, y: 3.2156862745098, size: 1 },
    //     { x: 301.079136690647, y: 3.33333333333333, size: 1 },
    //     { x: 319.208633093525, y: 3.45098039215686, size: 1 },
    //     { x: 322.446043165468, y: 3.2156862745098, size: 1 },
    //     { x: 323.093525179856, y: 2.35294117647059, size: 1 },
    //     { x: 323.741007194245, y: 2.70588235294118, size: 1 },
    //     { x: 338.63309352518, y: 3.96078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 2.86274509803922, size: 1 },
    //     { x: 69.9280575539568, y: 3.2156862745098, size: 1 },
    //     { x: 71.2230215827338, y: 2.86274509803922, size: 1 },
    //     { x: 87.410071942446, y: 3.84313725490196, size: 1 },
    //     { x: 92.589928057554, y: 3.13725490196078, size: 1 },
    //     { x: 93.2374100719424, y: 3.05882352941176, size: 1 },
    //     { x: 129.496402877698, y: 4.03921568627451, size: 1 },
    //     { x: 134.028776978417, y: 3.37254901960784, size: 1 },
    //     { x: 134.676258992806, y: 3.29411764705882, size: 1 },
    //     { x: 135.323741007194, y: 2.90196078431373, size: 1 },
    //     { x: 135.971223021583, y: 2.94117647058824, size: 1 },
    //     { x: 136.618705035971, y: 3.17647058823529, size: 1 },
    //     { x: 148.273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 155.395683453237, y: 3.09803921568627, size: 1 },
    //     { x: 157.338129496403, y: 2.90196078431373, size: 1 },
    //     { x: 158.63309352518, y: 2.86274509803922, size: 1 },
    //     { x: 159.280575539568, y: 2.54901960784314, size: 1 },
    //     { x: 178.705035971223, y: 2.94117647058824, size: 1 },
    //     { x: 179.352517985612, y: 3.09803921568627, size: 1 },
    //     { x: 200.071942446043, y: 3.33333333333333, size: 1 },
    //     { x: 200.719424460432, y: 3.2156862745098, size: 1 },
    //     { x: 222.086330935252, y: 3.17647058823529, size: 1 },
    //     { x: 222.73381294964, y: 3.29411764705882, size: 1 },
    //     { x: 225.971223021583, y: 3.25490196078431, size: 1 },
    //     { x: 228.561151079137, y: 3.25490196078431, size: 1 },
    //     { x: 231.798561151079, y: 3.25490196078431, size: 1 },
    //     { x: 233.741007194245, y: 3.29411764705882, size: 1 },
    //     { x: 235.035971223022, y: 3.33333333333333, size: 1 },
    //     { x: 236.978417266187, y: 3.33333333333333, size: 1 },
    //     { x: 264.820143884892, y: 3.01960784313725, size: 1 },
    //     { x: 276.474820143885, y: 3.80392156862745, size: 1 },
    //     { x: 286.834532374101, y: 2.98039215686275, size: 1 },
    //     { x: 288.776978417266, y: 3.17647058823529, size: 1 },
    //     { x: 294.604316546763, y: 3.41176470588235, size: 1 },
    //     { x: 299.784172661871, y: 3.2156862745098, size: 1 },
    //     { x: 300.431654676259, y: 3.25490196078431, size: 1 },
    //     { x: 301.726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 305.611510791367, y: 3.25490196078431, size: 1 },
    //     { x: 307.553956834532, y: 3.41176470588235, size: 1 },
    //     { x: 308.848920863309, y: 2.94117647058824, size: 1 },
    //     { x: 321.151079136691, y: 3.76470588235294, size: 1 },
    //     { x: 329.568345323741, y: 3.17647058823529, size: 1 },
    //     { x: 330.863309352518, y: 3.09803921568627, size: 1 },
    //     { x: 11.0071942446043, y: 3.2156862745098, size: 1 },
    //     { x: 12.3021582733813, y: 3.17647058823529, size: 1 },
    //     { x: 12.9496402877698, y: 2.7843137254902, size: 1 },
    //     { x: 13.5971223021583, y: 2.43137254901961, size: 1 },
    //     { x: 34.3165467625899, y: 3.25490196078431, size: 1 },
    //     { x: 35.6115107913669, y: 2.82352941176471, size: 1 },
    //     { x: 40.1438848920863, y: 3.41176470588235, size: 1 },
    //     { x: 41.4388489208633, y: 3.29411764705882, size: 1 },
    //     { x: 45.3237410071942, y: 3.33333333333333, size: 1 },
    //     { x: 47.9136690647482, y: 3.2156862745098, size: 1 },
    //     { x: 53.0935251798561, y: 3.29411764705882, size: 1 },
    //     { x: 56.3309352517986, y: 2.90196078431373, size: 1 },
    //     { x: 56.9784172661871, y: 2.86274509803922, size: 1 },
    //     { x: 59.568345323741, y: 3.17647058823529, size: 1 },
    //     { x: 62.158273381295, y: 3.25490196078431, size: 1 },
    //     { x: 67.3381294964029, y: 3.29411764705882, size: 1 },
    //     { x: 69.2805755395683, y: 3.33333333333333, size: 1 },
    //     { x: 71.2230215827338, y: 3.37254901960784, size: 1 },
    //     { x: 73.1654676258993, y: 3.33333333333333, size: 1 },
    //     { x: 75.1079136690647, y: 3.25490196078431, size: 1 },
    //     { x: 77.6978417266187, y: 2.7843137254902, size: 1 },
    //     { x: 78.3453237410072, y: 2.74509803921569, size: 1 },
    //     { x: 87.410071942446, y: 4.07843137254902, size: 1 },
    //     { x: 88.705035971223, y: 3.92156862745098, size: 1 },
    //     { x: 97.7697841726619, y: 3.2156862745098, size: 1 },
    //     { x: 104.244604316547, y: 3.29411764705882, size: 1 },
    //     { x: 106.187050359712, y: 3.29411764705882, size: 1 },
    //     { x: 112.661870503597, y: 3.17647058823529, size: 1 },
    //     { x: 113.956834532374, y: 3.2156862745098, size: 1 },
    //     { x: 115.89928057554, y: 3.2156862745098, size: 1 },
    //     { x: 116.546762589928, y: 3.41176470588235, size: 1 },
    //     { x: 121.079136690647, y: 3.2156862745098, size: 1 },
    //     { x: 137.913669064748, y: 3.84313725490196, size: 1 },
    //     { x: 142.446043165468, y: 2.70588235294118, size: 1 },
    //     { x: 143.093525179856, y: 2.70588235294118, size: 1 },
    //     { x: 163.165467625899, y: 3.37254901960784, size: 1 },
    //     { x: 163.812949640288, y: 2.86274509803922, size: 1 },
    //     { x: 164.460431654676, y: 2.03921568627451, size: 1 },
    //     { x: 175.467625899281, y: 3.88235294117647, size: 1 },
    //     { x: 194.244604316547, y: 3.96078431372549, size: 1 },
    //     { x: 200.071942446043, y: 3.92156862745098, size: 1 },
    //     { x: 213.021582733813, y: 3.80392156862745, size: 1 },
    //     { x: 215.611510791367, y: 3.56862745098039, size: 1 },
    //     { x: 222.73381294964, y: 3.84313725490196, size: 1 },
    //     { x: 241.510791366906, y: 3.96078431372549, size: 1 },
    //     { x: 245.395683453237, y: 3.96078431372549, size: 1 },
    //     { x: 250.575539568345, y: 3.33333333333333, size: 1 },
    //     { x: 268.705035971223, y: 3.41176470588235, size: 1 },
    //     { x: 300.431654676259, y: 4, size: 1 },
    //     { x: 314.028776978417, y: 3.13725490196078, size: 1 },
    //     { x: 328.920863309353, y: 3.41176470588235, size: 1 },
    //     { x: 335.395683453237, y: 3.33333333333333, size: 1 },
    //     { x: 336.043165467626, y: 3.37254901960784, size: 1 },
    //     { x: 1.2972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 1.94594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 5.18918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 11.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 16.2162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 16.8648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 19.4594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 26.5945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 27.8918918918919, y: 4.07843137254902, size: 1 },
    //     { x: 29.8378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 36.3243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 40.8648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 42.1621621621622, y: 3.68627450980392, size: 1 },
    //     { x: 50.5945945945946, y: 3.76470588235294, size: 1 },
    //     { x: 57.7297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 59.6756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 61.6216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 63.5675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 64.2162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 65.5135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 66.1621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 66.8108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 70.054054054054, y: 3.68627450980392, size: 1 },
    //     { x: 70.7027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 73.2972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 83.6756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 84.3243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 84.972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 85.6216216216216, y: 2.90196078431373, size: 1 },
    //     { x: 86.2702702702703, y: 2.74509803921569, size: 1 },
    //     { x: 86.9189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 93.4054054054054, y: 3.56862745098039, size: 1 },
    //     { x: 96, y: 3.88235294117647, size: 1 },
    //     { x: 97.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 99.8918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 103.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 106.378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 107.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 108.324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 119.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 121.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 122.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 123.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 126.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 128.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 134.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 135.567567567568, y: 3.64705882352941, size: 1 },
    //     { x: 136.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 140.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 141.405405405405, y: 3.6078431372549, size: 1 },
    //     { x: 144, y: 3.45098039215686, size: 1 },
    //     { x: 145.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 146.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 150.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 151.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 151.783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 152.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 155.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 158.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 161.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 166.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 169.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 171.243243243243, y: 2.43137254901961, size: 1 },
    //     { x: 171.891891891892, y: 2.82352941176471, size: 1 },
    //     { x: 172.540540540541, y: 2.43137254901961, size: 1 },
    //     { x: 173.189189189189, y: 2.82352941176471, size: 1 },
    //     { x: 174.486486486486, y: 3.72549019607843, size: 1 },
    //     { x: 175.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 177.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 180.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 181.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 184.216216216216, y: 3.45098039215686, size: 1 },
    //     { x: 184.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 189.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 192.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 193.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 194.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 196.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 204.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 214.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 215.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 220.540540540541, y: 3.52941176470588, size: 1 },
    //     { x: 222.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 226.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 227.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 236.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 236.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 237.405405405405, y: 4, size: 1 },
    //     { x: 241.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 247.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 248.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 249.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 252.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 259.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 260.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 261.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 267.243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 268.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 272.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 276.324324324324, y: 3.68627450980392, size: 1 },
    //     { x: 278.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 278.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 280.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 288, y: 3.41176470588235, size: 1 },
    //     { x: 290.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 293.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 295.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 297.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 298.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 299.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 300.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 301.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 302.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 302.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 303.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 307.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 309.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 315.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 317.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 320.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 321.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 322.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 323.027027027027, y: 2.86274509803922, size: 1 },
    //     { x: 323.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 324.324324324324, y: 3.76470588235294, size: 1 },
    //     { x: 328.864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 335.351351351351, y: 3.56862745098039, size: 1 },
    //     { x: 336, y: 3.84313725490196, size: 1 },
    //     { x: 343.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 344.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 351.567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 4.53237410071942, y: 3.2156862745098, size: 1 },
    //     { x: 5.8273381294964, y: 2.86274509803922, size: 1 },
    //     { x: 6.47482014388489, y: 2.7843137254902, size: 1 },
    //     { x: 44.6762589928058, y: 3.76470588235294, size: 1 },
    //     { x: 51.1510791366906, y: 3.01960784313725, size: 1 },
    //     { x: 51.7985611510791, y: 3.13725490196078, size: 1 },
    //     { x: 52.4460431654676, y: 3.2156862745098, size: 1 },
    //     { x: 56.3309352517986, y: 3.01960784313725, size: 1 },
    //     { x: 60.2158273381295, y: 3.09803921568627, size: 1 },
    //     { x: 61.5107913669065, y: 3.2156862745098, size: 1 },
    //     { x: 62.158273381295, y: 3.17647058823529, size: 1 },
    //     { x: 62.8057553956835, y: 3.05882352941176, size: 1 },
    //     { x: 64.1007194244604, y: 3.33333333333333, size: 1 },
    //     { x: 67.3381294964029, y: 3.09803921568627, size: 1 },
    //     { x: 70.5755395683453, y: 3.41176470588235, size: 1 },
    //     { x: 73.8129496402878, y: 3.96078431372549, size: 1 },
    //     { x: 75.7553956834532, y: 4, size: 1 },
    //     { x: 76.4028776978417, y: 3.96078431372549, size: 1 },
    //     { x: 77.0503597122302, y: 4, size: 1 },
    //     { x: 78.9928057553957, y: 3.92156862745098, size: 1 },
    //     { x: 82.2302158273381, y: 4.23529411764706, size: 1 },
    //     { x: 84.1726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 86.7625899280576, y: 4, size: 1 },
    //     { x: 87.410071942446, y: 4.11764705882353, size: 1 },
    //     { x: 90, y: 4.11764705882353, size: 1 },
    //     { x: 92.589928057554, y: 3.25490196078431, size: 1 },
    //     { x: 95.8273381294964, y: 4.07843137254902, size: 1 },
    //     { x: 96.4748201438849, y: 3.96078431372549, size: 1 },
    //     { x: 101.654676258993, y: 3.92156862745098, size: 1 },
    //     { x: 110.719424460432, y: 3.88235294117647, size: 1 },
    //     { x: 111.36690647482, y: 3.96078431372549, size: 1 },
    //     { x: 112.014388489209, y: 4.11764705882353, size: 1 },
    //     { x: 113.309352517986, y: 3.05882352941176, size: 1 },
    //     { x: 113.956834532374, y: 2.86274509803922, size: 1 },
    //     { x: 114.604316546763, y: 3.2156862745098, size: 1 },
    //     { x: 115.251798561151, y: 2.94117647058824, size: 1 },
    //     { x: 118.489208633094, y: 3.88235294117647, size: 1 },
    //     { x: 120.431654676259, y: 3.96078431372549, size: 1 },
    //     { x: 121.079136690647, y: 4, size: 1 },
    //     { x: 121.726618705036, y: 4, size: 1 },
    //     { x: 122.374100719424, y: 3.92156862745098, size: 1 },
    //     { x: 123.669064748201, y: 3.80392156862745, size: 1 },
    //     { x: 125.611510791367, y: 4.03921568627451, size: 1 },
    //     { x: 127.553956834532, y: 4, size: 1 },
    //     { x: 128.201438848921, y: 3.92156862745098, size: 1 },
    //     { x: 131.438848920863, y: 3.80392156862745, size: 1 },
    //     { x: 132.73381294964, y: 3.92156862745098, size: 1 },
    //     { x: 136.618705035971, y: 4, size: 1 },
    //     { x: 138.561151079137, y: 3.92156862745098, size: 1 },
    //     { x: 139.208633093525, y: 3.92156862745098, size: 1 },
    //     { x: 142.446043165468, y: 4, size: 1 },
    //     { x: 146.330935251799, y: 3.88235294117647, size: 1 },
    //     { x: 154.10071942446, y: 4.15686274509804, size: 1 },
    //     { x: 156.043165467626, y: 3.25490196078431, size: 1 },
    //     { x: 156.690647482014, y: 3.37254901960784, size: 1 },
    //     { x: 157.338129496403, y: 3.29411764705882, size: 1 },
    //     { x: 166.402877697842, y: 3.92156862745098, size: 1 },
    //     { x: 172.230215827338, y: 3.88235294117647, size: 1 },
    //     { x: 176.115107913669, y: 3.41176470588235, size: 1 },
    //     { x: 191.654676258993, y: 3.17647058823529, size: 1 },
    //     { x: 192.302158273381, y: 3.2156862745098, size: 1 },
    //     { x: 199.424460431655, y: 3.2156862745098, size: 1 },
    //     { x: 200.071942446043, y: 2.66666666666667, size: 1 },
    //     { x: 200.719424460432, y: 2.94117647058824, size: 1 },
    //     { x: 202.661870503597, y: 3.2156862745098, size: 1 },
    //     { x: 207.841726618705, y: 3.13725490196078, size: 1 },
    //     { x: 211.726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 218.201438848921, y: 3.29411764705882, size: 1 },
    //     { x: 223.381294964029, y: 3.09803921568627, size: 1 },
    //     { x: 226.618705035971, y: 3.2156862745098, size: 1 },
    //     { x: 227.913669064748, y: 3.13725490196078, size: 1 },
    //     { x: 229.856115107914, y: 3.05882352941176, size: 1 },
    //     { x: 233.741007194245, y: 3.17647058823529, size: 1 },
    //     { x: 234.388489208633, y: 3.01960784313725, size: 1 },
    //     { x: 238.920863309353, y: 3.13725490196078, size: 1 },
    //     { x: 240.215827338129, y: 3.29411764705882, size: 1 },
    //     { x: 244.748201438849, y: 3.2156862745098, size: 1 },
    //     { x: 246.690647482014, y: 3.09803921568627, size: 1 },
    //     { x: 247.338129496403, y: 3.05882352941176, size: 1 },
    //     { x: 251.870503597122, y: 3.2156862745098, size: 1 },
    //     { x: 254.460431654676, y: 3.2156862745098, size: 1 },
    //     { x: 255.107913669065, y: 3.29411764705882, size: 1 },
    //     { x: 255.755395683453, y: 3.17647058823529, size: 1 },
    //     { x: 256.402877697842, y: 3.13725490196078, size: 1 },
    //     { x: 257.697841726619, y: 3.2156862745098, size: 1 },
    //     { x: 258.345323741007, y: 3.29411764705882, size: 1 },
    //     { x: 260.287769784173, y: 3.2156862745098, size: 1 },
    //     { x: 261.58273381295, y: 3.29411764705882, size: 1 },
    //     { x: 262.230215827338, y: 3.2156862745098, size: 1 },
    //     { x: 277.122302158273, y: 3.2156862745098, size: 1 },
    //     { x: 279.712230215827, y: 3.25490196078431, size: 1 },
    //     { x: 281.654676258993, y: 3.2156862745098, size: 1 },
    //     { x: 286.834532374101, y: 3.09803921568627, size: 1 },
    //     { x: 287.482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 288.129496402878, y: 3.17647058823529, size: 1 },
    //     { x: 288.776978417266, y: 3.25490196078431, size: 1 },
    //     { x: 289.424460431655, y: 3.13725490196078, size: 1 },
    //     { x: 290.071942446043, y: 3.25490196078431, size: 1 },
    //     { x: 292.661870503597, y: 3.13725490196078, size: 1 },
    //     { x: 293.956834532374, y: 3.13725490196078, size: 1 },
    //     { x: 294.604316546763, y: 3.25490196078431, size: 1 },
    //     { x: 295.251798561151, y: 3.2156862745098, size: 1 },
    //     { x: 296.546762589928, y: 3.33333333333333, size: 1 },
    //     { x: 297.194244604317, y: 3.29411764705882, size: 1 },
    //     { x: 297.841726618705, y: 3.2156862745098, size: 1 },
    //     { x: 299.136690647482, y: 3.17647058823529, size: 1 },
    //     { x: 299.784172661871, y: 3.01960784313725, size: 1 },
    //     { x: 303.021582733813, y: 3.29411764705882, size: 1 },
    //     { x: 303.669064748201, y: 3.13725490196078, size: 1 },
    //     { x: 304.31654676259, y: 3.25490196078431, size: 1 },
    //     { x: 304.964028776978, y: 3.25490196078431, size: 1 },
    //     { x: 308.201438848921, y: 3.41176470588235, size: 1 },
    //     { x: 312.086330935252, y: 3.29411764705882, size: 1 },
    //     { x: 325.68345323741, y: 3.17647058823529, size: 1 },
    //     { x: 326.330935251799, y: 3.01960784313725, size: 1 },
    //     { x: 331.510791366906, y: 3.33333333333333, size: 1 },
    //     { x: 335.395683453237, y: 3.2156862745098, size: 1 },
    //     { x: 337.338129496403, y: 3.25490196078431, size: 1 },
    //     { x: 337.985611510791, y: 3.33333333333333, size: 1 },
    //     { x: 343.165467625899, y: 3.17647058823529, size: 1 },
    //     { x: 343.812949640288, y: 3.17647058823529, size: 1 },
    //     { x: 347.05035971223, y: 3.29411764705882, size: 1 },
    //     { x: 348.992805755396, y: 3.05882352941176, size: 1 },
    //     { x: 351.58273381295, y: 3.17647058823529, size: 1 },
    //     { x: 12.9496402877698, y: 2.74509803921569, size: 1 },
    //     { x: 13.5971223021583, y: 2.86274509803922, size: 1 },
    //     { x: 19.4244604316547, y: 3.41176470588235, size: 1 },
    //     { x: 37.5539568345324, y: 3.17647058823529, size: 1 },
    //     { x: 38.2014388489209, y: 3.29411764705882, size: 1 },
    //     { x: 47.2661870503597, y: 3.05882352941176, size: 1 },
    //     { x: 47.9136690647482, y: 3.33333333333333, size: 1 },
    //     { x: 53.0935251798561, y: 3.01960784313725, size: 1 },
    //     { x: 55.0359712230216, y: 3.2156862745098, size: 1 },
    //     { x: 56.3309352517986, y: 2.82352941176471, size: 1 },
    //     { x: 61.5107913669065, y: 4, size: 1 },
    //     { x: 81.5827338129496, y: 3.33333333333333, size: 1 },
    //     { x: 85.4676258992806, y: 3.13725490196078, size: 1 },
    //     { x: 86.7625899280576, y: 3.33333333333333, size: 1 },
    //     { x: 90, y: 3.01960784313725, size: 1 },
    //     { x: 92.589928057554, y: 3.33333333333333, size: 1 },
    //     { x: 95.1798561151079, y: 3.2156862745098, size: 1 },
    //     { x: 96.4748201438849, y: 3.17647058823529, size: 1 },
    //     { x: 121.079136690647, y: 3.05882352941176, size: 1 },
    //     { x: 143.093525179856, y: 3.25490196078431, size: 1 },
    //     { x: 143.741007194245, y: 3.05882352941176, size: 1 },
    //     { x: 144.388489208633, y: 3.01960784313725, size: 1 },
    //     { x: 145.035971223022, y: 3.01960784313725, size: 1 },
    //     { x: 146.330935251799, y: 2.94117647058824, size: 1 },
    //     { x: 146.978417266187, y: 3.2156862745098, size: 1 },
    //     { x: 149.568345323741, y: 3.13725490196078, size: 1 },
    //     { x: 150.215827338129, y: 3.2156862745098, size: 1 },
    //     { x: 153.453237410072, y: 3.13725490196078, size: 1 },
    //     { x: 159.280575539568, y: 3.01960784313725, size: 1 },
    //     { x: 160.575539568345, y: 3.01960784313725, size: 1 },
    //     { x: 163.812949640288, y: 3.25490196078431, size: 1 },
    //     { x: 177.410071942446, y: 3.88235294117647, size: 1 },
    //     { x: 181.942446043165, y: 3.92156862745098, size: 1 },
    //     { x: 186.474820143885, y: 3.29411764705882, size: 1 },
    //     { x: 187.769784172662, y: 3.29411764705882, size: 1 },
    //     { x: 196.187050359712, y: 3.29411764705882, size: 1 },
    //     { x: 209.136690647482, y: 3.45098039215686, size: 1 },
    //     { x: 253.812949640288, y: 3.17647058823529, size: 1 },
    //     { x: 273.237410071942, y: 3.01960784313725, size: 1 },
    //     { x: 274.532374100719, y: 2.94117647058824, size: 1 },
    //     { x: 277.769784172662, y: 3.25490196078431, size: 1 },
    //     { x: 279.712230215827, y: 3.29411764705882, size: 1 },
    //     { x: 280.359712230216, y: 3.13725490196078, size: 1 },
    //     { x: 281.007194244604, y: 3.25490196078431, size: 1 },
    //     { x: 282.302158273381, y: 3.01960784313725, size: 1 },
    //     { x: 283.597122302158, y: 3.17647058823529, size: 1 },
    //     { x: 285.539568345324, y: 3.09803921568627, size: 1 },
    //     { x: 286.187050359712, y: 3.13725490196078, size: 1 },
    //     { x: 288.129496402878, y: 3.37254901960784, size: 1 },
    //     { x: 288.776978417266, y: 3.13725490196078, size: 1 },
    //     { x: 289.424460431655, y: 3.17647058823529, size: 1 },
    //     { x: 290.071942446043, y: 3.2156862745098, size: 1 },
    //     { x: 290.719424460432, y: 3.13725490196078, size: 1 },
    //     { x: 294.604316546763, y: 3.33333333333333, size: 1 },
    //     { x: 296.546762589928, y: 3.01960784313725, size: 1 },
    //     { x: 305.611510791367, y: 3.2156862745098, size: 1 },
    //     { x: 306.258992805755, y: 3.13725490196078, size: 1 },
    //     { x: 308.201438848921, y: 3.09803921568627, size: 1 },
    //     { x: 310.143884892086, y: 3.05882352941176, size: 1 },
    //     { x: 311.438848920863, y: 3.25490196078431, size: 1 },
    //     { x: 323.741007194245, y: 3.96078431372549, size: 1 },
    //     { x: 324.388489208633, y: 3.84313725490196, size: 1 },
    //     { x: 358.057553956835, y: 2.94117647058824, size: 1 },
    //     { x: 359.352517985611, y: 2.7843137254902, size: 1 },
    //     { x: 0, y: 3.09803921568627, size: 1 },
    //     { x: 0.647482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 1.29496402877698, y: 3.33333333333333, size: 1 },
    //     { x: 4.53237410071942, y: 3.17647058823529, size: 1 },
    //     { x: 5.17985611510791, y: 3.05882352941176, size: 1 },
    //     { x: 5.8273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 6.47482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 9.71223021582734, y: 3.2156862745098, size: 1 },
    //     { x: 10.3597122302158, y: 3.25490196078431, size: 1 },
    //     { x: 12.3021582733813, y: 3.2156862745098, size: 1 },
    //     { x: 14.8920863309353, y: 3.09803921568627, size: 1 },
    //     { x: 15.5395683453237, y: 3.17647058823529, size: 1 },
    //     { x: 16.8345323741007, y: 3.17647058823529, size: 1 },
    //     { x: 44.6762589928058, y: 3.17647058823529, size: 1 },
    //     { x: 51.1510791366906, y: 3.84313725490196, size: 1 },
    //     { x: 54.3884892086331, y: 3.13725490196078, size: 1 },
    //     { x: 55.0359712230216, y: 3.25490196078431, size: 1 },
    //     { x: 59.568345323741, y: 3.29411764705882, size: 1 },
    //     { x: 62.8057553956835, y: 2.98039215686275, size: 1 },
    //     { x: 63.4532374100719, y: 2.82352941176471, size: 1 },
    //     { x: 71.2230215827338, y: 3.17647058823529, size: 1 },
    //     { x: 76.4028776978417, y: 3.13725490196078, size: 1 },
    //     { x: 80.2877697841727, y: 3.17647058823529, size: 1 },
    //     { x: 82.2302158273381, y: 3.13725490196078, size: 1 },
    //     { x: 84.1726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 84.8201438848921, y: 3.2156862745098, size: 1 },
    //     { x: 106.834532374101, y: 3.13725490196078, size: 1 },
    //     { x: 107.482014388489, y: 3.09803921568627, size: 1 },
    //     { x: 108.129496402878, y: 3.25490196078431, size: 1 },
    //     { x: 108.776978417266, y: 3.09803921568627, size: 1 },
    //     { x: 109.424460431655, y: 3.09803921568627, size: 1 },
    //     { x: 113.309352517986, y: 3.29411764705882, size: 1 },
    //     { x: 124.964028776978, y: 3.13725490196078, size: 1 },
    //     { x: 127.553956834532, y: 3.2156862745098, size: 1 },
    //     { x: 129.496402877698, y: 3.25490196078431, size: 1 },
    //     { x: 130.791366906475, y: 3.2156862745098, size: 1 },
    //     { x: 134.676258992806, y: 3.2156862745098, size: 1 },
    //     { x: 167.05035971223, y: 3.41176470588235, size: 1 },
    //     { x: 171.58273381295, y: 3.92156862745098, size: 1 },
    //     { x: 193.597122302158, y: 3.29411764705882, size: 1 },
    //     { x: 214.31654676259, y: 3.2156862745098, size: 1 },
    //     { x: 214.964028776978, y: 3.09803921568627, size: 1 },
    //     { x: 216.906474820144, y: 3.09803921568627, size: 1 },
    //     { x: 220.791366906475, y: 3.09803921568627, size: 1 },
    //     { x: 222.086330935252, y: 3.2156862745098, size: 1 },
    //     { x: 225.971223021583, y: 3.33333333333333, size: 1 },
    //     { x: 237.625899280576, y: 3.13725490196078, size: 1 },
    //     { x: 240.863309352518, y: 3.33333333333333, size: 1 },
    //     { x: 243.453237410072, y: 3.29411764705882, size: 1 },
    //     { x: 247.338129496403, y: 3.25490196078431, size: 1 },
    //     { x: 248.63309352518, y: 3.17647058823529, size: 1 },
    //     { x: 254.460431654676, y: 3.17647058823529, size: 1 },
    //     { x: 257.05035971223, y: 3.01960784313725, size: 1 },
    //     { x: 257.697841726619, y: 3.13725490196078, size: 1 },
    //     { x: 278.41726618705, y: 3.13725490196078, size: 1 },
    //     { x: 279.064748201439, y: 3.01960784313725, size: 1 },
    //     { x: 321.798561151079, y: 2.27450980392157, size: 1 },
    //     { x: 322.446043165468, y: 2.54901960784314, size: 1 },
    //     { x: 328.920863309353, y: 3.96078431372549, size: 1 },
    //     { x: 343.812949640288, y: 3.13725490196078, size: 1 },
    //     { x: 344.460431654676, y: 3.37254901960784, size: 1 },
    //     { x: 351.58273381295, y: 3.92156862745098, size: 1 },
    //     { x: 352.230215827338, y: 3.76470588235294, size: 1 },
    //     { x: 352.877697841727, y: 4.07843137254902, size: 1 },
    //     { x: 3.89189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 4.54054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 5.18918918918919, y: 1.96078431372549, size: 1 },
    //     { x: 5.83783783783784, y: 2.19607843137255, size: 1 },
    //     { x: 6.48648648648649, y: 2.15686274509804, size: 1 },
    //     { x: 7.13513513513514, y: 1.88235294117647, size: 1 },
    //     { x: 8.43243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 9.08108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 9.72972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 13.6216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 14.2702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 14.9189189189189, y: 2.94117647058824, size: 1 },
    //     { x: 16.2162162162162, y: 3.64705882352941, size: 1 },
    //     { x: 18.8108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 20.7567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 21.4054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 22.7027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 23.3513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 24.6486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 26.5945945945946, y: 2.98039215686275, size: 1 },
    //     { x: 27.2432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 37.6216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 38.9189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 44.1081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 53.8378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 55.7837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 67.4594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 68.7567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 70.054054054054, y: 2.66666666666667, size: 1 },
    //     { x: 70.7027027027027, y: 2.74509803921569, size: 1 },
    //     { x: 73.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 74.5945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 75.2432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 81.0810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 81.7297297297297, y: 4, size: 1 },
    //     { x: 82.3783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 83.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 84.972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 86.9189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 90.8108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 91.4594594594595, y: 2.15686274509804, size: 1 },
    //     { x: 92.1081081081081, y: 1.92156862745098, size: 1 },
    //     { x: 93.4054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 94.7027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 95.3513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 97.2972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 103.135135135135, y: 3.6078431372549, size: 1 },
    //     { x: 110.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 111.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 112.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 113.513513513514, y: 2.43137254901961, size: 1 },
    //     { x: 116.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 116.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 119.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 123.243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 123.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 125.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 127.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 129.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 134.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 139.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 141.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 142.054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 143.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 147.891891891892, y: 4, size: 1 },
    //     { x: 148.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 151.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 153.081081081081, y: 4, size: 1 },
    //     { x: 155.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 155.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 156.324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 156.972972972973, y: 2.70588235294118, size: 1 },
    //     { x: 159.567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 161.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 163.459459459459, y: 3.6078431372549, size: 1 },
    //     { x: 164.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 165.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 171.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 172.540540540541, y: 4.23529411764706, size: 1 },
    //     { x: 177.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 182.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 183.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 187.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 193.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 194.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 196.540540540541, y: 3.6078431372549, size: 1 },
    //     { x: 199.783783783784, y: 3.45098039215686, size: 1 },
    //     { x: 204.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 209.513513513514, y: 3.56862745098039, size: 1 },
    //     { x: 226.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 228.324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 232.864864864865, y: 3.6078431372549, size: 1 },
    //     { x: 233.513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 236.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 241.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 243.243243243243, y: 3.01960784313725, size: 1 },
    //     { x: 243.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 249.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 255.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 256.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 257.513513513513, y: 3.76470588235294, size: 1 },
    //     { x: 267.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 271.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 273.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 285.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 286.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 291.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 306.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 307.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 309.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 312, y: 3.49019607843137, size: 1 },
    //     { x: 324.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 327.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 336.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 339.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 343.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 346.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 347.675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 350.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 351.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 28.4892086330935, y: 3.92156862745098, size: 1 },
    //     { x: 34.3165467625899, y: 3.09803921568627, size: 1 },
    //     { x: 58.9208633093525, y: 3.88235294117647, size: 1 },
    //     { x: 76.4028776978417, y: 3.25490196078431, size: 1 },
    //     { x: 77.0503597122302, y: 3.09803921568627, size: 1 },
    //     { x: 77.6978417266187, y: 2.3921568627451, size: 1 },
    //     { x: 78.3453237410072, y: 2.3921568627451, size: 1 },
    //     { x: 78.9928057553957, y: 2.86274509803922, size: 1 },
    //     { x: 79.6402877697842, y: 2.86274509803922, size: 1 },
    //     { x: 86.7625899280576, y: 3.96078431372549, size: 1 },
    //     { x: 99.0647482014388, y: 3.13725490196078, size: 1 },
    //     { x: 121.079136690647, y: 2.70588235294118, size: 1 },
    //     { x: 143.741007194245, y: 3.92156862745098, size: 1 },
    //     { x: 169.640287769784, y: 4, size: 1 },
    //     { x: 173.525179856115, y: 3.96078431372549, size: 1 },
    //     { x: 207.194244604317, y: 2.86274509803922, size: 1 },
    //     { x: 215.611510791367, y: 3.80392156862745, size: 1 },
    //     { x: 221.438848920863, y: 3.80392156862745, size: 1 },
    //     { x: 224.676258992806, y: 3.72549019607843, size: 1 },
    //     { x: 227.913669064748, y: 3.29411764705882, size: 1 },
    //     { x: 228.561151079137, y: 2.90196078431373, size: 1 },
    //     { x: 229.208633093525, y: 3.29411764705882, size: 1 },
    //     { x: 231.798561151079, y: 3.88235294117647, size: 1 },
    //     { x: 244.748201438849, y: 4, size: 1 },
    //     { x: 246.043165467626, y: 3.88235294117647, size: 1 },
    //     { x: 250.575539568345, y: 3.13725490196078, size: 1 },
    //     { x: 253.165467625899, y: 3.92156862745098, size: 1 },
    //     { x: 253.812949640288, y: 3.92156862745098, size: 1 },
    //     { x: 255.107913669065, y: 4.19607843137255, size: 1 },
    //     { x: 256.402877697842, y: 3.92156862745098, size: 1 },
    //     { x: 257.05035971223, y: 4, size: 1 },
    //     { x: 258.992805755396, y: 3.92156862745098, size: 1 },
    //     { x: 259.640287769784, y: 4.03921568627451, size: 1 },
    //     { x: 262.230215827338, y: 4.07843137254902, size: 1 },
    //     { x: 264.172661870504, y: 3.96078431372549, size: 1 },
    //     { x: 264.820143884892, y: 3.96078431372549, size: 1 },
    //     { x: 268.705035971223, y: 3.84313725490196, size: 1 },
    //     { x: 289.424460431655, y: 3.41176470588235, size: 1 },
    //     { x: 325.035971223022, y: 3.80392156862745, size: 1 },
    //     { x: 336.690647482014, y: 3.05882352941176, size: 1 },
    //     { x: 337.338129496403, y: 2.94117647058824, size: 1 },
    //     { x: 337.985611510791, y: 2.98039215686275, size: 1 },
    //     { x: 338.63309352518, y: 2.94117647058824, size: 1 },
    //     { x: 339.928057553957, y: 4.03921568627451, size: 1 },
    //     { x: 349.640287769784, y: 4, size: 1 },
    //     { x: 350.287769784173, y: 3.84313725490196, size: 1 },
    //     { x: 355.467625899281, y: 3.96078431372549, size: 1 },
    //     { x: 358.057553956835, y: 3.09803921568627, size: 1 },
    //     { x: 19.4244604316547, y: 3.2156862745098, size: 1 },
    //     { x: 20.0719424460432, y: 3.2156862745098, size: 1 },
    //     { x: 31.726618705036, y: 3.80392156862745, size: 1 },
    //     { x: 40.7913669064748, y: 3.37254901960784, size: 1 },
    //     { x: 49.8561151079137, y: 3.84313725490196, size: 1 },
    //     { x: 62.158273381295, y: 3.92156862745098, size: 1 },
    //     { x: 63.4532374100719, y: 3.25490196078431, size: 1 },
    //     { x: 64.1007194244604, y: 3.88235294117647, size: 1 },
    //     { x: 71.2230215827338, y: 4.11764705882353, size: 1 },
    //     { x: 71.8705035971223, y: 3.96078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 4.19607843137255, size: 1 },
    //     { x: 74.4604316546763, y: 4, size: 1 },
    //     { x: 75.7553956834532, y: 3.80392156862745, size: 1 },
    //     { x: 76.4028776978417, y: 4.27450980392157, size: 1 },
    //     { x: 77.0503597122302, y: 3.84313725490196, size: 1 },
    //     { x: 78.3453237410072, y: 3.96078431372549, size: 1 },
    //     { x: 80.2877697841727, y: 3.96078431372549, size: 1 },
    //     { x: 80.9352517985612, y: 4.19607843137255, size: 1 },
    //     { x: 84.1726618705036, y: 2.82352941176471, size: 1 },
    //     { x: 84.8201438848921, y: 2.27450980392157, size: 1 },
    //     { x: 98.4172661870504, y: 4, size: 1 },
    //     { x: 126.906474820144, y: 3.33333333333333, size: 1 },
    //     { x: 145.68345323741, y: 4, size: 1 },
    //     { x: 148.273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 168.992805755396, y: 3.2156862745098, size: 1 },
    //     { x: 169.640287769784, y: 3.29411764705882, size: 1 },
    //     { x: 170.935251798561, y: 2.47058823529412, size: 1 },
    //     { x: 171.58273381295, y: 3.13725490196078, size: 1 },
    //     { x: 172.877697841727, y: 3.33333333333333, size: 1 },
    //     { x: 177.410071942446, y: 3.92156862745098, size: 1 },
    //     { x: 192.302158273381, y: 3.01960784313725, size: 1 },
    //     { x: 192.94964028777, y: 2.54901960784314, size: 1 },
    //     { x: 194.244604316547, y: 3.88235294117647, size: 1 },
    //     { x: 196.834532374101, y: 4, size: 1 },
    //     { x: 206.546762589928, y: 3.80392156862745, size: 1 },
    //     { x: 214.31654676259, y: 2.90196078431373, size: 1 },
    //     { x: 216.258992805755, y: 3.88235294117647, size: 1 },
    //     { x: 224.028776978417, y: 3.92156862745098, size: 1 },
    //     { x: 227.913669064748, y: 4, size: 1 },
    //     { x: 229.208633093525, y: 3.88235294117647, size: 1 },
    //     { x: 231.151079136691, y: 3.80392156862745, size: 1 },
    //     { x: 233.093525179856, y: 3.88235294117647, size: 1 },
    //     { x: 237.625899280576, y: 3.92156862745098, size: 1 },
    //     { x: 238.920863309353, y: 3.88235294117647, size: 1 },
    //     { x: 242.158273381295, y: 4.03921568627451, size: 1 },
    //     { x: 242.805755395683, y: 3.96078431372549, size: 1 },
    //     { x: 247.338129496403, y: 4.03921568627451, size: 1 },
    //     { x: 248.63309352518, y: 4.07843137254902, size: 1 },
    //     { x: 249.928057553957, y: 3.88235294117647, size: 1 },
    //     { x: 251.223021582734, y: 3.84313725490196, size: 1 },
    //     { x: 259.640287769784, y: 4, size: 1 },
    //     { x: 266.115107913669, y: 3.88235294117647, size: 1 },
    //     { x: 279.064748201439, y: 3.13725490196078, size: 1 },
    //     { x: 306.906474820144, y: 3.96078431372549, size: 1 },
    //     { x: 313.381294964029, y: 3.88235294117647, size: 1 },
    //     { x: 322.446043165468, y: 3.29411764705882, size: 1 },
    //     { x: 356.115107913669, y: 3.92156862745098, size: 1 },
    //     { x: 34.9640287769784, y: 3.88235294117647, size: 1 },
    //     { x: 40.1438848920863, y: 3.92156862745098, size: 1 },
    //     { x: 48.5611510791367, y: 3.2156862745098, size: 1 },
    //     { x: 51.7985611510791, y: 3.88235294117647, size: 1 },
    //     { x: 91.294964028777, y: 3.13725490196078, size: 1 },
    //     { x: 91.9424460431655, y: 2.98039215686275, size: 1 },
    //     { x: 95.8273381294964, y: 4, size: 1 },
    //     { x: 106.834532374101, y: 3.80392156862745, size: 1 },
    //     { x: 112.014388489209, y: 3.45098039215686, size: 1 },
    //     { x: 112.661870503597, y: 3.29411764705882, size: 1 },
    //     { x: 119.784172661871, y: 3.33333333333333, size: 1 },
    //     { x: 225.323741007194, y: 4.03921568627451, size: 1 },
    //     { x: 256.402877697842, y: 3.84313725490196, size: 1 },
    //     { x: 257.697841726619, y: 4.03921568627451, size: 1 },
    //     { x: 264.172661870504, y: 2.90196078431373, size: 1 },
    //     { x: 264.820143884892, y: 3.25490196078431, size: 1 },
    //     { x: 273.884892086331, y: 4, size: 1 },
    //     { x: 275.179856115108, y: 3.80392156862745, size: 1 },
    //     { x: 286.187050359712, y: 3.09803921568627, size: 1 },
    //     { x: 286.834532374101, y: 4.11764705882353, size: 1 },
    //     { x: 287.482014388489, y: 4.31372549019608, size: 1 },
    //     { x: 288.129496402878, y: 4, size: 1 },
    //     { x: 288.776978417266, y: 4.07843137254902, size: 1 },
    //     { x: 293.309352517986, y: 4, size: 1 },
    //     { x: 295.251798561151, y: 4, size: 1 },
    //     { x: 296.546762589928, y: 3.92156862745098, size: 1 },
    //     { x: 297.194244604317, y: 4, size: 1 },
    //     { x: 298.489208633094, y: 4, size: 1 },
    //     { x: 299.784172661871, y: 3.92156862745098, size: 1 },
    //     { x: 301.726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 303.021582733813, y: 3.96078431372549, size: 1 },
    //     { x: 303.669064748201, y: 3.88235294117647, size: 1 },
    //     { x: 304.31654676259, y: 4.03921568627451, size: 1 },
    //     { x: 308.848920863309, y: 4.11764705882353, size: 1 },
    //     { x: 310.143884892086, y: 4, size: 1 },
    //     { x: 313.381294964029, y: 4, size: 1 },
    //     { x: 314.028776978417, y: 3.84313725490196, size: 1 },
    //     { x: 315.971223021583, y: 4, size: 1 },
    //     { x: 316.618705035971, y: 4, size: 1 },
    //     { x: 319.856115107914, y: 3.96078431372549, size: 1 },
    //     { x: 324.388489208633, y: 3.92156862745098, size: 1 },
    //     { x: 325.68345323741, y: 4.15686274509804, size: 1 },
    //     { x: 332.158273381295, y: 4.03921568627451, size: 1 },
    //     { x: 337.338129496403, y: 3.80392156862745, size: 1 },
    //     { x: 352.230215827338, y: 4, size: 1 },
    //     { x: 358.705035971223, y: 4.15686274509804, size: 1 },
    //     { x: 0.648648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 3.89189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 4.54054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 5.18918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 6.48648648648649, y: 4, size: 1 },
    //     { x: 7.78378378378378, y: 3.76470588235294, size: 1 },
    //     { x: 9.08108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 11.6756756756757, y: 2.58823529411765, size: 1 },
    //     { x: 12.3243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 12.972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 13.6216216216216, y: 2.62745098039216, size: 1 },
    //     { x: 18.1621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 21.4054054054054, y: 3.64705882352941, size: 1 },
    //     { x: 23.3513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 25.9459459459459, y: 3.56862745098039, size: 1 },
    //     { x: 27.2432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 28.5405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 33.7297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 35.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 38.2702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 38.9189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 39.5675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 40.2162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 40.8648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 41.5135135135135, y: 4, size: 1 },
    //     { x: 44.1081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 46.7027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 47.3513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 48, y: 3.92156862745098, size: 1 },
    //     { x: 49.9459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 51.2432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 51.8918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 52.5405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 55.7837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 67.4594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 72, y: 3.56862745098039, size: 1 },
    //     { x: 72.6486486486486, y: 3.6078431372549, size: 1 },
    //     { x: 75.2432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 76.5405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 77.1891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 79.1351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 82.3783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 83.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 102.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 107.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 109.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 111.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 112.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 115.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 116.108108108108, y: 3.68627450980392, size: 1 },
    //     { x: 116.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 119.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 120, y: 3.33333333333333, size: 1 },
    //     { x: 120.648648648649, y: 2.94117647058824, size: 1 },
    //     { x: 121.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 122.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 124.540540540541, y: 4, size: 1 },
    //     { x: 125.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 125.837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 126.486486486486, y: 4.03921568627451, size: 1 },
    //     { x: 127.135135135135, y: 4, size: 1 },
    //     { x: 127.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 129.081081081081, y: 4.07843137254902, size: 1 },
    //     { x: 129.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 130.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 131.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 131.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 132.324324324324, y: 4, size: 1 },
    //     { x: 133.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 134.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 136.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 136.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 137.513513513514, y: 4.19607843137255, size: 1 },
    //     { x: 138.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 138.810810810811, y: 4, size: 1 },
    //     { x: 139.459459459459, y: 4.07843137254902, size: 1 },
    //     { x: 140.108108108108, y: 3.6078431372549, size: 1 },
    //     { x: 144.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 147.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 150.486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 157.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 160.864864864865, y: 3.68627450980392, size: 1 },
    //     { x: 161.513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 162.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 163.459459459459, y: 2.50980392156863, size: 1 },
    //     { x: 164.108108108108, y: 2.62745098039216, size: 1 },
    //     { x: 164.756756756757, y: 2.58823529411765, size: 1 },
    //     { x: 165.405405405405, y: 2.3921568627451, size: 1 },
    //     { x: 166.054054054054, y: 4, size: 1 },
    //     { x: 166.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 167.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 169.297297297297, y: 4.11764705882353, size: 1 },
    //     { x: 169.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 170.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 171.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 173.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 175.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 176.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 177.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 179.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 179.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 181.621621621622, y: 4.11764705882353, size: 1 },
    //     { x: 182.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 184.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 187.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 189.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 190.702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 191.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 192, y: 3.80392156862745, size: 1 },
    //     { x: 193.297297297297, y: 4, size: 1 },
    //     { x: 194.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 195.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 196.540540540541, y: 4, size: 1 },
    //     { x: 198.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 199.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 199.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 201.72972972973, y: 4.03921568627451, size: 1 },
    //     { x: 202.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 203.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 203.675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 206.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 207.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 208.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 209.513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 210.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 211.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 213.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 214.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 214.702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 215.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 216.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 217.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 219.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 220.540540540541, y: 4, size: 1 },
    //     { x: 222.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 223.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 225.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 228.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 229.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 233.513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 240, y: 3.45098039215686, size: 1 },
    //     { x: 247.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 248.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 249.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 249.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 250.378378378378, y: 2.62745098039216, size: 1 },
    //     { x: 252.972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 270.486486486487, y: 3.41176470588235, size: 1 },
    //     { x: 271.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 271.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 273.72972972973, y: 3.64705882352941, size: 1 },
    //     { x: 275.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 278.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 278.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 280.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 283.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 285.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 287.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 288.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 289.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 290.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 291.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 291.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 292.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 293.189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 299.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 301.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 308.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 310.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 310.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 313.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 314.594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 315.243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 315.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 316.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 317.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 319.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 322.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 326.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 326.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 329.513513513513, y: 3.80392156862745, size: 1 },
    //     { x: 331.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 332.108108108108, y: 4.15686274509804, size: 1 },
    //     { x: 332.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 334.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 335.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 336, y: 2.50980392156863, size: 1 },
    //     { x: 336.648648648649, y: 2.58823529411765, size: 1 },
    //     { x: 337.297297297297, y: 4.23529411764706, size: 1 },
    //     { x: 337.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 338.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 341.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 341.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 343.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 343.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 344.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 348.972972972973, y: 4.23529411764706, size: 1 },
    //     { x: 349.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 350.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 350.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 351.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 352.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 352.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 353.513513513513, y: 3.84313725490196, size: 1 },
    //     { x: 354.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 355.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 356.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 356.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 357.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 358.054054054054, y: 2.70588235294118, size: 1 },
    //     { x: 18.7769784172662, y: 3.05882352941176, size: 1 },
    //     { x: 19.4244604316547, y: 2, size: 1 },
    //     { x: 20.0719424460432, y: 1.92156862745098, size: 1 },
    //     { x: 31.726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 33.6690647482014, y: 4.19607843137255, size: 1 },
    //     { x: 40.7913669064748, y: 2.98039215686275, size: 1 },
    //     { x: 41.4388489208633, y: 2.3921568627451, size: 1 },
    //     { x: 43.3812949640288, y: 3.25490196078431, size: 1 },
    //     { x: 44.0287769784173, y: 3.25490196078431, size: 1 },
    //     { x: 48.5611510791367, y: 3.25490196078431, size: 1 },
    //     { x: 50.5035971223022, y: 3.33333333333333, size: 1 },
    //     { x: 54.3884892086331, y: 3.33333333333333, size: 1 },
    //     { x: 55.0359712230216, y: 3.09803921568627, size: 1 },
    //     { x: 61.5107913669065, y: 3.25490196078431, size: 1 },
    //     { x: 85.4676258992806, y: 3.84313725490196, size: 1 },
    //     { x: 95.8273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 104.244604316547, y: 3.25490196078431, size: 1 },
    //     { x: 152.158273381295, y: 3.88235294117647, size: 1 },
    //     { x: 165.107913669065, y: 3.84313725490196, size: 1 },
    //     { x: 170.935251798561, y: 2.19607843137255, size: 1 },
    //     { x: 191.007194244604, y: 3.29411764705882, size: 1 },
    //     { x: 191.654676258993, y: 2.86274509803922, size: 1 },
    //     { x: 192.302158273381, y: 2.43137254901961, size: 1 },
    //     { x: 192.94964028777, y: 3.33333333333333, size: 1 },
    //     { x: 213.669064748201, y: 3.88235294117647, size: 1 },
    //     { x: 230.503597122302, y: 3.92156862745098, size: 1 },
    //     { x: 238.273381294964, y: 4, size: 1 },
    //     { x: 284.892086330935, y: 3.2156862745098, size: 1 },
    //     { x: 286.187050359712, y: 3.17647058823529, size: 1 },
    //     { x: 289.424460431655, y: 3.25490196078431, size: 1 },
    //     { x: 299.784172661871, y: 2.43137254901961, size: 1 },
    //     { x: 300.431654676259, y: 1.92156862745098, size: 1 },
    //     { x: 301.079136690647, y: 2.70588235294118, size: 1 },
    //     { x: 301.726618705036, y: 2.66666666666667, size: 1 },
    //     { x: 320.503597122302, y: 3.2156862745098, size: 1 },
    //     { x: 321.798561151079, y: 3.01960784313725, size: 1 },
    //     { x: 322.446043165468, y: 3.13725490196078, size: 1 },
    //     { x: 323.093525179856, y: 2.98039215686275, size: 1 },
    //     { x: 323.741007194245, y: 3.25490196078431, size: 1 },
    //     { x: 325.035971223022, y: 3.2156862745098, size: 1 },
    //     { x: 327.625899280576, y: 3.33333333333333, size: 1 },
    //     { x: 341.223021582734, y: 3.25490196078431, size: 1 },
    //     { x: 343.165467625899, y: 3.37254901960784, size: 1 },
    //     { x: 343.812949640288, y: 3.25490196078431, size: 1 },
    //     { x: 0, y: 4, size: 1 },
    //     { x: 6.47482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 7.76978417266187, y: 3.29411764705882, size: 1 },
    //     { x: 11.6546762589928, y: 3.25490196078431, size: 1 },
    //     { x: 12.9496402877698, y: 3.25490196078431, size: 1 },
    //     { x: 13.5971223021583, y: 3.29411764705882, size: 1 },
    //     { x: 15.5395683453237, y: 3.33333333333333, size: 1 },
    //     { x: 21.3669064748201, y: 3.2156862745098, size: 1 },
    //     { x: 22.0143884892086, y: 3.17647058823529, size: 1 },
    //     { x: 23.3093525179856, y: 3.33333333333333, size: 1 },
    //     { x: 25.2517985611511, y: 3.2156862745098, size: 1 },
    //     { x: 27.1942446043165, y: 3.17647058823529, size: 1 },
    //     { x: 27.841726618705, y: 3.80392156862745, size: 1 },
    //     { x: 47.9136690647482, y: 3.09803921568627, size: 1 },
    //     { x: 61.5107913669065, y: 3.92156862745098, size: 1 },
    //     { x: 67.9856115107914, y: 2.98039215686275, size: 1 },
    //     { x: 68.6330935251799, y: 3.25490196078431, size: 1 },
    //     { x: 69.2805755395683, y: 2.47058823529412, size: 1 },
    //     { x: 69.9280575539568, y: 2.23529411764706, size: 1 },
    //     { x: 91.294964028777, y: 2.98039215686275, size: 1 },
    //     { x: 95.1798561151079, y: 3.92156862745098, size: 1 },
    //     { x: 112.661870503597, y: 3.01960784313725, size: 1 },
    //     { x: 113.309352517986, y: 2.90196078431373, size: 1 },
    //     { x: 131.438848920863, y: 4.15686274509804, size: 1 },
    //     { x: 154.10071942446, y: 3.33333333333333, size: 1 },
    //     { x: 154.748201438849, y: 3.33333333333333, size: 1 },
    //     { x: 156.043165467626, y: 2.74509803921569, size: 1 },
    //     { x: 197.482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 198.776978417266, y: 2.90196078431373, size: 1 },
    //     { x: 199.424460431655, y: 2.7843137254902, size: 1 },
    //     { x: 202.014388489209, y: 3.2156862745098, size: 1 },
    //     { x: 202.661870503597, y: 3.37254901960784, size: 1 },
    //     { x: 206.546762589928, y: 3.2156862745098, size: 1 },
    //     { x: 207.841726618705, y: 3.17647058823529, size: 1 },
    //     { x: 264.172661870504, y: 3.2156862745098, size: 1 },
    //     { x: 275.179856115108, y: 3.76470588235294, size: 1 },
    //     { x: 284.892086330935, y: 2.98039215686275, size: 1 },
    //     { x: 285.539568345324, y: 2.66666666666667, size: 1 },
    //     { x: 306.906474820144, y: 2.66666666666667, size: 1 },
    //     { x: 307.553956834532, y: 2.70588235294118, size: 1 },
    //     { x: 323.741007194245, y: 3.92156862745098, size: 1 },
    //     { x: 327.625899280576, y: 3.09803921568627, size: 1 },
    //     { x: 328.920863309353, y: 2.62745098039216, size: 1 },
    //     { x: 350.935251798561, y: 3.29411764705882, size: 1 },
    //     { x: 10.3597122302158, y: 3.13725490196078, size: 1 },
    //     { x: 11.0071942446043, y: 2.98039215686275, size: 1 },
    //     { x: 11.6546762589928, y: 2.50980392156863, size: 1 },
    //     { x: 12.3021582733813, y: 2.74509803921569, size: 1 },
    //     { x: 31.726618705036, y: 3.17647058823529, size: 1 },
    //     { x: 33.0215827338129, y: 2.43137254901961, size: 1 },
    //     { x: 33.6690647482014, y: 2.50980392156863, size: 1 },
    //     { x: 57.6258992805755, y: 3.37254901960784, size: 1 },
    //     { x: 77.0503597122302, y: 3.29411764705882, size: 1 },
    //     { x: 97.7697841726619, y: 3.33333333333333, size: 1 },
    //     { x: 119.784172661871, y: 3.13725490196078, size: 1 },
    //     { x: 120.431654676259, y: 3.17647058823529, size: 1 },
    //     { x: 137.26618705036, y: 3.88235294117647, size: 1 },
    //     { x: 150.863309352518, y: 3.92156862745098, size: 1 },
    //     { x: 177.410071942446, y: 3.37254901960784, size: 1 },
    //     { x: 181.294964028777, y: 3.96078431372549, size: 1 },
    //     { x: 227.26618705036, y: 2.98039215686275, size: 1 },
    //     { x: 271.294964028777, y: 3.33333333333333, size: 1 },
    //     { x: 292.014388489209, y: 3.13725490196078, size: 1 },
    //     { x: 309.496402877698, y: 3.92156862745098, size: 1 },
    //     { x: 356.762589928058, y: 3.05882352941176, size: 1 },
    //     { x: 1.94594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 6.48648648648649, y: 3.64705882352941, size: 1 },
    //     { x: 12.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 13.6216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 19.4594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 23.3513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 25.2972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 29.1891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 32.4324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 33.7297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 38.2702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 38.9189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 39.5675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 40.2162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 44.1081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 44.7567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 48, y: 3.72549019607843, size: 1 },
    //     { x: 51.2432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 51.8918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 60.3243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 60.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 65.5135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 77.1891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 77.8378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 78.4864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 81.7297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 82.3783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 83.6756756756757, y: 2.70588235294118, size: 1 },
    //     { x: 84.3243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 90.8108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 95.3513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 98.5945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 99.2432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 99.8918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 101.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 103.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 104.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 105.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 105.72972972973, y: 3.01960784313725, size: 1 },
    //     { x: 108.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 113.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 122.594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 126.486486486486, y: 2.90196078431373, size: 1 },
    //     { x: 127.135135135135, y: 2.43137254901961, size: 1 },
    //     { x: 127.783783783784, y: 3.64705882352941, size: 1 },
    //     { x: 131.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 139.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 141.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 145.297297297297, y: 3.68627450980392, size: 1 },
    //     { x: 147.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 148.540540540541, y: 2.70588235294118, size: 1 },
    //     { x: 149.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 151.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 159.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 164.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 166.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 168.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 169.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 173.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 180.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 188.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 189.405405405405, y: 3.45098039215686, size: 1 },
    //     { x: 191.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 192, y: 2.94117647058824, size: 1 },
    //     { x: 194.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 200.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 201.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 202.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 206.918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 213.405405405405, y: 2.58823529411765, size: 1 },
    //     { x: 226.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 227.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 230.27027027027, y: 3.6078431372549, size: 1 },
    //     { x: 233.513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 234.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 235.459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 236.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 246.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 247.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 248.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 249.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 251.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 255.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 256.216216216216, y: 2.7843137254902, size: 1 },
    //     { x: 256.864864864865, y: 2.15686274509804, size: 1 },
    //     { x: 264, y: 3.49019607843137, size: 1 },
    //     { x: 264.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 267.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 268.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 270.486486486487, y: 3.45098039215686, size: 1 },
    //     { x: 273.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 276.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 278.27027027027, y: 3.09803921568627, size: 1 },
    //     { x: 280.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 288, y: 3.76470588235294, size: 1 },
    //     { x: 289.297297297297, y: 3.72549019607843, size: 1 },
    //     { x: 293.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 295.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 297.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 298.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 299.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 300.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 305.513513513513, y: 3.41176470588235, size: 1 },
    //     { x: 309.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 313.945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 321.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 325.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 330.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 336, y: 3.45098039215686, size: 1 },
    //     { x: 336.648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 342.486486486487, y: 3.05882352941176, size: 1 },
    //     { x: 343.135135135135, y: 2.86274509803922, size: 1 },
    //     { x: 343.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 345.72972972973, y: 3.52941176470588, size: 1 },
    //     { x: 22.0143884892086, y: 3.49019607843137, size: 1 },
    //     { x: 46.6187050359712, y: 3.09803921568627, size: 1 },
    //     { x: 47.2661870503597, y: 3.29411764705882, size: 1 },
    //     { x: 47.9136690647482, y: 2.50980392156863, size: 1 },
    //     { x: 69.2805755395683, y: 2.98039215686275, size: 1 },
    //     { x: 69.9280575539568, y: 3.01960784313725, size: 1 },
    //     { x: 71.8705035971223, y: 3.13725490196078, size: 1 },
    //     { x: 72.5179856115108, y: 3.29411764705882, size: 1 },
    //     { x: 74.4604316546763, y: 3.13725490196078, size: 1 },
    //     { x: 75.7553956834532, y: 3.25490196078431, size: 1 },
    //     { x: 76.4028776978417, y: 3.2156862745098, size: 1 },
    //     { x: 82.8776978417266, y: 3.29411764705882, size: 1 },
    //     { x: 83.5251798561151, y: 3.25490196078431, size: 1 },
    //     { x: 86.1151079136691, y: 3.17647058823529, size: 1 },
    //     { x: 86.7625899280576, y: 3.2156862745098, size: 1 },
    //     { x: 108.776978417266, y: 3.29411764705882, size: 1 },
    //     { x: 110.719424460432, y: 3.2156862745098, size: 1 },
    //     { x: 112.014388489209, y: 3.01960784313725, size: 1 },
    //     { x: 112.661870503597, y: 2.86274509803922, size: 1 },
    //     { x: 113.309352517986, y: 3.2156862745098, size: 1 },
    //     { x: 120.431654676259, y: 3.45098039215686, size: 1 },
    //     { x: 134.028776978417, y: 2.62745098039216, size: 1 },
    //     { x: 134.676258992806, y: 2.70588235294118, size: 1 },
    //     { x: 155.395683453237, y: 2.74509803921569, size: 1 },
    //     { x: 156.043165467626, y: 2.94117647058824, size: 1 },
    //     { x: 158.63309352518, y: 3.92156862745098, size: 1 },
    //     { x: 175.467625899281, y: 3.25490196078431, size: 1 },
    //     { x: 197.482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 218.848920863309, y: 2.94117647058824, size: 1 },
    //     { x: 220.143884892086, y: 1.84313725490196, size: 1 },
    //     { x: 220.791366906475, y: 1.49019607843137, size: 1 },
    //     { x: 221.438848920863, y: 1.33333333333333, size: 1 },
    //     { x: 222.086330935252, y: 1.09803921568627, size: 1 },
    //     { x: 222.73381294964, y: 2.90196078431373, size: 1 },
    //     { x: 224.028776978417, y: 3.2156862745098, size: 1 },
    //     { x: 224.676258992806, y: 3.05882352941176, size: 1 },
    //     { x: 225.323741007194, y: 2.86274509803922, size: 1 },
    //     { x: 225.971223021583, y: 3.2156862745098, size: 1 },
    //     { x: 229.856115107914, y: 2.86274509803922, size: 1 },
    //     { x: 235.68345323741, y: 2.7843137254902, size: 1 },
    //     { x: 236.330935251799, y: 2.94117647058824, size: 1 },
    //     { x: 236.978417266187, y: 3.13725490196078, size: 1 },
    //     { x: 240.215827338129, y: 3.2156862745098, size: 1 },
    //     { x: 242.158273381295, y: 3.17647058823529, size: 1 },
    //     { x: 248.63309352518, y: 3.37254901960784, size: 1 },
    //     { x: 263.525179856115, y: 2.82352941176471, size: 1 },
    //     { x: 283.597122302158, y: 2.94117647058824, size: 1 },
    //     { x: 284.892086330935, y: 2.54901960784314, size: 1 },
    //     { x: 285.539568345324, y: 2.27450980392157, size: 1 },
    //     { x: 302.374100719424, y: 4.03921568627451, size: 1 },
    //     { x: 306.258992805755, y: 2.98039215686275, size: 1 },
    //     { x: 306.906474820144, y: 3.17647058823529, size: 1 },
    //     { x: 307.553956834532, y: 3.29411764705882, size: 1 },
    //     { x: 308.848920863309, y: 3.96078431372549, size: 1 },
    //     { x: 319.208633093525, y: 3.33333333333333, size: 1 },
    //     { x: 328.273381294964, y: 2.82352941176471, size: 1 },
    //     { x: 329.568345323741, y: 3.96078431372549, size: 1 },
    //     { x: 349.640287769784, y: 2.66666666666667, size: 1 },
    //     { x: 350.287769784173, y: 2.27450980392157, size: 1 },
    //     { x: 11.6546762589928, y: 2.82352941176471, size: 1 },
    //     { x: 22.0143884892086, y: 3.92156862745098, size: 1 },
    //     { x: 31.726618705036, y: 3.09803921568627, size: 1 },
    //     { x: 32.3741007194245, y: 3.01960784313725, size: 1 },
    //     { x: 33.0215827338129, y: 1.84313725490196, size: 1 },
    //     { x: 33.6690647482014, y: 2.11764705882353, size: 1 },
    //     { x: 54.3884892086331, y: 2.19607843137255, size: 1 },
    //     { x: 55.0359712230216, y: 2.15686274509804, size: 1 },
    //     { x: 74.4604316546763, y: 3.88235294117647, size: 1 },
    //     { x: 91.9424460431655, y: 3.37254901960784, size: 1 },
    //     { x: 96.4748201438849, y: 3.25490196078431, size: 1 },
    //     { x: 97.1223021582734, y: 3.01960784313725, size: 1 },
    //     { x: 97.7697841726619, y: 2.58823529411765, size: 1 },
    //     { x: 98.4172661870504, y: 2.50980392156863, size: 1 },
    //     { x: 99.7122302158273, y: 3.37254901960784, size: 1 },
    //     { x: 115.251798561151, y: 3.41176470588235, size: 1 },
    //     { x: 118.489208633094, y: 3.17647058823529, size: 1 },
    //     { x: 119.136690647482, y: 2.03921568627451, size: 1 },
    //     { x: 119.784172661871, y: 1.56862745098039, size: 1 },
    //     { x: 144.388489208633, y: 3.33333333333333, size: 1 },
    //     { x: 149.568345323741, y: 3.25490196078431, size: 1 },
    //     { x: 153.453237410072, y: 3.29411764705882, size: 1 },
    //     { x: 155.395683453237, y: 3.29411764705882, size: 1 },
    //     { x: 157.985611510791, y: 3.33333333333333, size: 1 },
    //     { x: 183.237410071942, y: 3.37254901960784, size: 1 },
    //     { x: 205.251798561151, y: 3.13725490196078, size: 1 },
    //     { x: 205.89928057554, y: 2.7843137254902, size: 1 },
    //     { x: 242.158273381295, y: 3.29411764705882, size: 1 },
    //     { x: 247.985611510791, y: 3.25490196078431, size: 1 },
    //     { x: 248.63309352518, y: 2.98039215686275, size: 1 },
    //     { x: 249.280575539568, y: 3.13725490196078, size: 1 },
    //     { x: 270, y: 3.2156862745098, size: 1 },
    //     { x: 270.647482014389, y: 3.09803921568627, size: 1 },
    //     { x: 291.36690647482, y: 3.29411764705882, size: 1 },
    //     { x: 292.014388489209, y: 2.82352941176471, size: 1 },
    //     { x: 292.661870503597, y: 2.98039215686275, size: 1 },
    //     { x: 303.669064748201, y: 3.33333333333333, size: 1 },
    //     { x: 312.086330935252, y: 3.05882352941176, size: 1 },
    //     { x: 314.028776978417, y: 2.82352941176471, size: 1 },
    //     { x: 330.215827338129, y: 3.92156862745098, size: 1 },
    //     { x: 335.395683453237, y: 2.94117647058824, size: 1 },
    //     { x: 356.762589928058, y: 2.58823529411765, size: 1 },
    //     { x: 357.410071942446, y: 2.47058823529412, size: 1 },
    //     { x: 40.1438848920863, y: 3.17647058823529, size: 1 },
    //     { x: 61.5107913669065, y: 2.82352941176471, size: 1 },
    //     { x: 62.158273381295, y: 2.74509803921569, size: 1 },
    //     { x: 95.8273381294964, y: 4.15686274509804, size: 1 },
    //     { x: 126.258992805755, y: 3.09803921568627, size: 1 },
    //     { x: 147.625899280576, y: 3.09803921568627, size: 1 },
    //     { x: 168.992805755396, y: 3.13725490196078, size: 1 },
    //     { x: 169.640287769784, y: 2.74509803921569, size: 1 },
    //     { x: 170.287769784173, y: 2.70588235294118, size: 1 },
    //     { x: 170.935251798561, y: 2.23529411764706, size: 1 },
    //     { x: 171.58273381295, y: 2.31372549019608, size: 1 },
    //     { x: 182.589928057554, y: 3.41176470588235, size: 1 },
    //     { x: 186.474820143885, y: 3.41176470588235, size: 1 },
    //     { x: 189.064748201439, y: 3.33333333333333, size: 1 },
    //     { x: 190.359712230216, y: 3.09803921568627, size: 1 },
    //     { x: 191.007194244604, y: 2.82352941176471, size: 1 },
    //     { x: 191.654676258993, y: 2.82352941176471, size: 1 },
    //     { x: 196.187050359712, y: 3.96078431372549, size: 1 },
    //     { x: 197.482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 202.661870503597, y: 3.25490196078431, size: 1 },
    //     { x: 213.021582733813, y: 3.05882352941176, size: 1 },
    //     { x: 219.496402877698, y: 3.13725490196078, size: 1 },
    //     { x: 225.971223021583, y: 3.13725490196078, size: 1 },
    //     { x: 227.26618705036, y: 3.2156862745098, size: 1 },
    //     { x: 231.798561151079, y: 3.2156862745098, size: 1 },
    //     { x: 233.741007194245, y: 3.13725490196078, size: 1 },
    //     { x: 245.395683453237, y: 3.92156862745098, size: 1 },
    //     { x: 254.460431654676, y: 3.33333333333333, size: 1 },
    //     { x: 255.107913669065, y: 3.09803921568627, size: 1 },
    //     { x: 255.755395683453, y: 3.05882352941176, size: 1 },
    //     { x: 256.402877697842, y: 3.2156862745098, size: 1 },
    //     { x: 266.762589928058, y: 3.33333333333333, size: 1 },
    //     { x: 271.942446043165, y: 3.37254901960784, size: 1 },
    //     { x: 277.122302158273, y: 2.90196078431373, size: 1 },
    //     { x: 277.769784172662, y: 2.98039215686275, size: 1 },
    //     { x: 290.071942446043, y: 3.88235294117647, size: 1 },
    //     { x: 318.561151079137, y: 3.33333333333333, size: 1 },
    //     { x: 319.208633093525, y: 3.17647058823529, size: 1 },
    //     { x: 319.856115107914, y: 3.05882352941176, size: 1 },
    //     { x: 320.503597122302, y: 3.09803921568627, size: 1 },
    //     { x: 321.151079136691, y: 3.05882352941176, size: 1 },
    //     { x: 340.575539568345, y: 3.29411764705882, size: 1 },
    //     { x: 341.870503597122, y: 2.94117647058824, size: 1 },
    //     { x: 342.517985611511, y: 2.90196078431373, size: 1 },
    //     { x: 4.54054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 7.13513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 11.6756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 12.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 20.1081081081081, y: 3.56862745098039, size: 1 },
    //     { x: 24, y: 3.2156862745098, size: 1 },
    //     { x: 24.6486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 25.2972972972973, y: 2.43137254901961, size: 1 },
    //     { x: 25.9459459459459, y: 2.47058823529412, size: 1 },
    //     { x: 29.1891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 29.8378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 31.7837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 33.0810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 33.7297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 34.3783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 35.6756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 36.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 39.5675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 40.8648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 44.1081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 49.2972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 49.9459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 55.7837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 57.7297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 58.3783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 60.3243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 63.5675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 72, y: 3.41176470588235, size: 1 },
    //     { x: 74.5945945945946, y: 3.68627450980392, size: 1 },
    //     { x: 75.2432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 75.8918918918919, y: 3.56862745098039, size: 1 },
    //     { x: 79.7837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 81.0810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 83.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 87.5675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 88.2162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 88.8648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 90.8108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 91.4594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 94.7027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 96.6486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 98.5945945945946, y: 3.64705882352941, size: 1 },
    //     { x: 103.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 107.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 111.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 116.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 118.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 123.243243243243, y: 3.52941176470588, size: 1 },
    //     { x: 129.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 133.621621621622, y: 2.74509803921569, size: 1 },
    //     { x: 134.27027027027, y: 3.01960784313725, size: 1 },
    //     { x: 134.918918918919, y: 2.54901960784314, size: 1 },
    //     { x: 135.567567567568, y: 2.50980392156863, size: 1 },
    //     { x: 137.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 139.459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 145.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 153.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 153.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 155.027027027027, y: 2.66666666666667, size: 1 },
    //     { x: 155.675675675676, y: 2.74509803921569, size: 1 },
    //     { x: 163.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 166.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 169.945945945946, y: 3.56862745098039, size: 1 },
    //     { x: 170.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 173.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 173.837837837838, y: 3.6078431372549, size: 1 },
    //     { x: 176.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 178.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 180.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 181.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 182.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 184.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 185.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 186.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 188.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 189.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 190.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 191.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 193.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 194.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 195.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 195.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 197.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 198.486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 204.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 212.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 217.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 218.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 219.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 219.891891891892, y: 2.66666666666667, size: 1 },
    //     { x: 220.540540540541, y: 2.54901960784314, size: 1 },
    //     { x: 223.783783783784, y: 3.68627450980392, size: 1 },
    //     { x: 225.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 225.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 240, y: 3.13725490196078, size: 1 },
    //     { x: 241.297297297297, y: 2.62745098039216, size: 1 },
    //     { x: 241.945945945946, y: 2.58823529411765, size: 1 },
    //     { x: 244.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 245.837837837838, y: 3.52941176470588, size: 1 },
    //     { x: 247.135135135135, y: 3.68627450980392, size: 1 },
    //     { x: 255.567567567568, y: 3.6078431372549, size: 1 },
    //     { x: 256.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 264, y: 3.33333333333333, size: 1 },
    //     { x: 276.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 288, y: 3.72549019607843, size: 1 },
    //     { x: 295.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 299.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 300.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 302.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 304.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 305.513513513513, y: 3.13725490196078, size: 1 },
    //     { x: 306.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 307.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 326.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 326.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 327.567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 328.216216216216, y: 2.43137254901961, size: 1 },
    //     { x: 330.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 332.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 333.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 334.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 347.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 348.324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 349.621621621622, y: 2.11764705882353, size: 1 },
    //     { x: 350.27027027027, y: 2.3921568627451, size: 1 },
    //     { x: 350.918918918919, y: 3.68627450980392, size: 1 },
    //     { x: 354.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 359.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 11.6546762589928, y: 2.94117647058824, size: 1 },
    //     { x: 33.0215827338129, y: 2.94117647058824, size: 1 },
    //     { x: 40.1438848920863, y: 3.80392156862745, size: 1 },
    //     { x: 53.7410071942446, y: 3.25490196078431, size: 1 },
    //     { x: 54.3884892086331, y: 3.01960784313725, size: 1 },
    //     { x: 75.7553956834532, y: 3.05882352941176, size: 1 },
    //     { x: 76.4028776978417, y: 3.05882352941176, size: 1 },
    //     { x: 97.1223021582734, y: 3.13725490196078, size: 1 },
    //     { x: 97.7697841726619, y: 3.01960784313725, size: 1 },
    //     { x: 101.654676258993, y: 3.88235294117647, size: 1 },
    //     { x: 108.776978417266, y: 3.37254901960784, size: 1 },
    //     { x: 116.546762589928, y: 3.88235294117647, size: 1 },
    //     { x: 119.136690647482, y: 2.86274509803922, size: 1 },
    //     { x: 119.784172661871, y: 2.82352941176471, size: 1 },
    //     { x: 121.079136690647, y: 3.25490196078431, size: 1 },
    //     { x: 124.964028776978, y: 3.37254901960784, size: 1 },
    //     { x: 140.503597122302, y: 3.13725490196078, size: 1 },
    //     { x: 160.575539568345, y: 3.25490196078431, size: 1 },
    //     { x: 161.870503597122, y: 3.17647058823529, size: 1 },
    //     { x: 190.359712230216, y: 3.33333333333333, size: 1 },
    //     { x: 205.251798561151, y: 2.90196078431373, size: 1 },
    //     { x: 210.431654676259, y: 3.25490196078431, size: 1 },
    //     { x: 213.021582733813, y: 3.09803921568627, size: 1 },
    //     { x: 249.280575539568, y: 2.86274509803922, size: 1 },
    //     { x: 270, y: 2.98039215686275, size: 1 },
    //     { x: 270.647482014389, y: 3.2156862745098, size: 1 },
    //     { x: 290.719424460432, y: 3.2156862745098, size: 1 },
    //     { x: 292.014388489209, y: 2.31372549019608, size: 1 },
    //     { x: 333.453237410072, y: 3.17647058823529, size: 1 },
    //     { x: 334.748201438849, y: 2.94117647058824, size: 1 },
    //     { x: 335.395683453237, y: 3.05882352941176, size: 1 },
    //     { x: 336.043165467626, y: 3.13725490196078, size: 1 },
    //     { x: 337.985611510791, y: 3.41176470588235, size: 1 },
    //     { x: 338.63309352518, y: 3.29411764705882, size: 1 },
    //     { x: 339.928057553957, y: 3.2156862745098, size: 1 },
    //     { x: 347.697841726619, y: 3.25490196078431, size: 1 },
    //     { x: 348.345323741007, y: 3.17647058823529, size: 1 },
    //     { x: 348.992805755396, y: 3.13725490196078, size: 1 },
    //     { x: 349.640287769784, y: 3.33333333333333, size: 1 },
    //     { x: 351.58273381295, y: 3.2156862745098, size: 1 },
    //     { x: 352.230215827338, y: 3.25490196078431, size: 1 },
    //     { x: 356.762589928058, y: 3.01960784313725, size: 1 },
    //     { x: 16.1870503597122, y: 3.37254901960784, size: 1 },
    //     { x: 17.4820143884892, y: 3.25490196078431, size: 1 },
    //     { x: 36.9064748201439, y: 3.37254901960784, size: 1 },
    //     { x: 40.1438848920863, y: 3.33333333333333, size: 1 },
    //     { x: 50.5035971223022, y: 4.11764705882353, size: 1 },
    //     { x: 104.244604316547, y: 3.01960784313725, size: 1 },
    //     { x: 104.892086330935, y: 2.70588235294118, size: 1 },
    //     { x: 112.661870503597, y: 3.88235294117647, size: 1 },
    //     { x: 115.251798561151, y: 3.92156862745098, size: 1 },
    //     { x: 115.89928057554, y: 3.92156862745098, size: 1 },
    //     { x: 119.136690647482, y: 3.76470588235294, size: 1 },
    //     { x: 125.611510791367, y: 3.09803921568627, size: 1 },
    //     { x: 145.035971223022, y: 3.33333333333333, size: 1 },
    //     { x: 145.68345323741, y: 3.17647058823529, size: 1 },
    //     { x: 146.330935251799, y: 3.2156862745098, size: 1 },
    //     { x: 147.625899280576, y: 2.54901960784314, size: 1 },
    //     { x: 148.273381294964, y: 2.54901960784314, size: 1 },
    //     { x: 167.697841726619, y: 2.98039215686275, size: 1 },
    //     { x: 168.992805755396, y: 2.31372549019608, size: 1 },
    //     { x: 169.640287769784, y: 2.11764705882353, size: 1 },
    //     { x: 170.287769784173, y: 3.13725490196078, size: 1 },
    //     { x: 170.935251798561, y: 3.33333333333333, size: 1 },
    //     { x: 190.359712230216, y: 2.98039215686275, size: 1 },
    //     { x: 191.007194244604, y: 1.52941176470588, size: 1 },
    //     { x: 208.489208633094, y: 3.80392156862745, size: 1 },
    //     { x: 218.201438848921, y: 3.84313725490196, size: 1 },
    //     { x: 220.791366906475, y: 4, size: 1 },
    //     { x: 233.093525179856, y: 3.09803921568627, size: 1 },
    //     { x: 241.510791366906, y: 3.84313725490196, size: 1 },
    //     { x: 242.158273381295, y: 3.88235294117647, size: 1 },
    //     { x: 254.460431654676, y: 3.29411764705882, size: 1 },
    //     { x: 271.294964028777, y: 3.92156862745098, size: 1 },
    //     { x: 295.89928057554, y: 3.2156862745098, size: 1 },
    //     { x: 304.31654676259, y: 3.92156862745098, size: 1 },
    //     { x: 306.258992805755, y: 3.84313725490196, size: 1 },
    //     { x: 318.561151079137, y: 3.09803921568627, size: 1 },
    //     { x: 320.503597122302, y: 3.13725490196078, size: 1 },
    //     { x: 323.093525179856, y: 3.2156862745098, size: 1 },
    //     { x: 327.625899280576, y: 3.25490196078431, size: 1 },
    //     { x: 332.158273381295, y: 3.37254901960784, size: 1 },
    //     { x: 347.05035971223, y: 3.96078431372549, size: 1 },
    //     { x: 13.5971223021583, y: 3.96078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 3.2156862745098, size: 1 },
    //     { x: 23.9568345323741, y: 3.09803921568627, size: 1 },
    //     { x: 25.2517985611511, y: 2.43137254901961, size: 1 },
    //     { x: 66.6906474820144, y: 3.09803921568627, size: 1 },
    //     { x: 130.791366906475, y: 3.80392156862745, size: 1 },
    //     { x: 158.63309352518, y: 3.80392156862745, size: 1 },
    //     { x: 165.107913669065, y: 4, size: 1 },
    //     { x: 170.287769784173, y: 3.96078431372549, size: 1 },
    //     { x: 178.705035971223, y: 3.37254901960784, size: 1 },
    //     { x: 184.532374100719, y: 4.03921568627451, size: 1 },
    //     { x: 196.834532374101, y: 3.33333333333333, size: 1 },
    //     { x: 198.129496402878, y: 3.29411764705882, size: 1 },
    //     { x: 212.374100719424, y: 4, size: 1 },
    //     { x: 239.568345323741, y: 3.41176470588235, size: 1 },
    //     { x: 240.863309352518, y: 3.17647058823529, size: 1 },
    //     { x: 242.158273381295, y: 3.92156862745098, size: 1 },
    //     { x: 242.805755395683, y: 3.33333333333333, size: 1 },
    //     { x: 262.877697841727, y: 3.2156862745098, size: 1 },
    //     { x: 277.769784172662, y: 4, size: 1 },
    //     { x: 280.359712230216, y: 3.92156862745098, size: 1 },
    //     { x: 284.244604316547, y: 2.82352941176471, size: 1 },
    //     { x: 284.892086330935, y: 3.17647058823529, size: 1 },
    //     { x: 288.129496402878, y: 3.84313725490196, size: 1 },
    //     { x: 291.36690647482, y: 3.88235294117647, size: 1 },
    //     { x: 326.978417266187, y: 3.01960784313725, size: 1 },
    //     { x: 330.215827338129, y: 3.29411764705882, size: 1 },
    //     { x: 345.107913669065, y: 3.33333333333333, size: 1 },
    //     { x: 350.287769784173, y: 4, size: 1 },
    //     { x: 6.48648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 7.13513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 7.78378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 8.43243243243243, y: 3.72549019607843, size: 1 },
    //     { x: 10.3783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 11.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 15.5675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 16.2162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 16.8648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 17.5135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 24, y: 3.84313725490196, size: 1 },
    //     { x: 25.2972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 25.9459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 32.4324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 34.3783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 39.5675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 46.0540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 51.8918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 53.1891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 53.8378378378378, y: 2.94117647058824, size: 1 },
    //     { x: 54.4864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 57.7297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 66.8108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 68.7567567567568, y: 3.72549019607843, size: 1 },
    //     { x: 70.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 71.3513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 73.2972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 79.7837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 81.7297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 85.6216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 92.7567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 97.2972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 98.5945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 99.2432432432432, y: 3.56862745098039, size: 1 },
    //     { x: 103.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 103.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 107.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 110.27027027027, y: 3.52941176470588, size: 1 },
    //     { x: 111.567567567568, y: 3.56862745098039, size: 1 },
    //     { x: 118.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 118.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 120.648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 121.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 121.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 122.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 123.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 124.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 127.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 129.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 130.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 131.675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 135.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 136.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 140.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 143.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 160.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 160.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 162.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 164.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 166.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 172.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 173.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 177.081081081081, y: 3.49019607843137, size: 1 },
    //     { x: 178.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 179.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 179.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 180.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 180.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 184.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 184.864864864865, y: 3.56862745098039, size: 1 },
    //     { x: 189.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 190.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 191.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 201.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 204.324324324324, y: 3.49019607843137, size: 1 },
    //     { x: 204.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 205.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 210.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 210.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 211.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 227.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 228.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 231.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 232.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 234.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 235.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 239.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 241.945945945946, y: 4.19607843137255, size: 1 },
    //     { x: 243.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 245.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 249.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 251.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 254.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 258.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 263.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 265.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 269.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 275.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 277.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 279.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 280.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 281.513513513513, y: 3.76470588235294, size: 1 },
    //     { x: 286.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 289.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 290.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 292.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 294.486486486487, y: 3.29411764705882, size: 1 },
    //     { x: 295.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 301.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 305.513513513513, y: 3.52941176470588, size: 1 },
    //     { x: 306.162162162162, y: 3.52941176470588, size: 1 },
    //     { x: 312.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 313.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 313.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 315.891891891892, y: 3.49019607843137, size: 1 },
    //     { x: 317.189189189189, y: 3.72549019607843, size: 1 },
    //     { x: 318.486486486487, y: 3.80392156862745, size: 1 },
    //     { x: 319.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 323.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 323.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 339.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 339.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 341.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 356.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 31.726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 39.4964028776978, y: 3.17647058823529, size: 1 },
    //     { x: 41.4388489208633, y: 4.03921568627451, size: 1 },
    //     { x: 46.6187050359712, y: 4, size: 1 },
    //     { x: 53.7410071942446, y: 4, size: 1 },
    //     { x: 104.892086330935, y: 3.01960784313725, size: 1 },
    //     { x: 125.611510791367, y: 3.2156862745098, size: 1 },
    //     { x: 126.258992805755, y: 3.17647058823529, size: 1 },
    //     { x: 132.73381294964, y: 3.88235294117647, size: 1 },
    //     { x: 144.388489208633, y: 4.07843137254902, size: 1 },
    //     { x: 147.625899280576, y: 2.90196078431373, size: 1 },
    //     { x: 151.510791366906, y: 3.84313725490196, size: 1 },
    //     { x: 269.352517985611, y: 3.88235294117647, size: 1 },
    //     { x: 277.122302158273, y: 2.66666666666667, size: 1 },
    //     { x: 318.561151079137, y: 3.17647058823529, size: 1 },
    //     { x: 319.856115107914, y: 3.13725490196078, size: 1 },
    //     { x: 341.870503597122, y: 3.01960784313725, size: 1 },
    //     { x: 7.76978417266187, y: 4, size: 1 },
    //     { x: 24.6043165467626, y: 2.3921568627451, size: 1 },
    //     { x: 25.2517985611511, y: 2.23529411764706, size: 1 },
    //     { x: 35.6115107913669, y: 3.76470588235294, size: 1 },
    //     { x: 45.9712230215827, y: 3.33333333333333, size: 1 },
    //     { x: 46.6187050359712, y: 3.01960784313725, size: 1 },
    //     { x: 49.8561151079137, y: 4.03921568627451, size: 1 },
    //     { x: 68.6330935251799, y: 3.33333333333333, size: 1 },
    //     { x: 82.8776978417266, y: 4, size: 1 },
    //     { x: 84.8201438848921, y: 3.84313725490196, size: 1 },
    //     { x: 110.071942446043, y: 3.25490196078431, size: 1 },
    //     { x: 110.719424460432, y: 2.82352941176471, size: 1 },
    //     { x: 111.36690647482, y: 2.74509803921569, size: 1 },
    //     { x: 132.086330935252, y: 3.33333333333333, size: 1 },
    //     { x: 132.73381294964, y: 3.05882352941176, size: 1 },
    //     { x: 133.381294964029, y: 3.13725490196078, size: 1 },
    //     { x: 154.748201438849, y: 2.82352941176471, size: 1 },
    //     { x: 173.525179856115, y: 3.84313725490196, size: 1 },
    //     { x: 185.827338129496, y: 4, size: 1 },
    //     { x: 198.129496402878, y: 3.01960784313725, size: 1 },
    //     { x: 218.848920863309, y: 2.7843137254902, size: 1 },
    //     { x: 219.496402877698, y: 2.98039215686275, size: 1 },
    //     { x: 220.143884892086, y: 3.05882352941176, size: 1 },
    //     { x: 222.73381294964, y: 3.33333333333333, size: 1 },
    //     { x: 230.503597122302, y: 3.37254901960784, size: 1 },
    //     { x: 233.093525179856, y: 3.17647058823529, size: 1 },
    //     { x: 236.978417266187, y: 3.29411764705882, size: 1 },
    //     { x: 262.230215827338, y: 3.13725490196078, size: 1 },
    //     { x: 262.877697841727, y: 2.90196078431373, size: 1 },
    //     { x: 278.41726618705, y: 3.88235294117647, size: 1 },
    //     { x: 284.244604316547, y: 3.37254901960784, size: 1 },
    //     { x: 286.187050359712, y: 4.07843137254902, size: 1 },
    //     { x: 304.964028776978, y: 3.05882352941176, size: 1 },
    //     { x: 340.575539568345, y: 3.92156862745098, size: 1 },
    //     { x: 348.345323741007, y: 2.98039215686275, size: 1 },
    //     { x: 0.647482014388489, y: 3.33333333333333, size: 1 },
    //     { x: 32.3741007194245, y: 3.13725490196078, size: 1 },
    //     { x: 52.4460431654676, y: 3.80392156862745, size: 1 },
    //     { x: 73.8129496402878, y: 3.05882352941176, size: 1 },
    //     { x: 74.4604316546763, y: 2.90196078431373, size: 1 },
    //     { x: 75.1079136690647, y: 1.96078431372549, size: 1 },
    //     { x: 75.7553956834532, y: 2.23529411764706, size: 1 },
    //     { x: 76.4028776978417, y: 2.3921568627451, size: 1 },
    //     { x: 77.0503597122302, y: 2.43137254901961, size: 1 },
    //     { x: 79.6402877697842, y: 2.90196078431373, size: 1 },
    //     { x: 90.6474820143885, y: 2.86274509803922, size: 1 },
    //     { x: 91.9424460431655, y: 3.25490196078431, size: 1 },
    //     { x: 95.1798561151079, y: 3.25490196078431, size: 1 },
    //     { x: 96.4748201438849, y: 2.70588235294118, size: 1 },
    //     { x: 97.1223021582734, y: 3.09803921568627, size: 1 },
    //     { x: 117.194244604317, y: 3.33333333333333, size: 1 },
    //     { x: 117.841726618705, y: 3.17647058823529, size: 1 },
    //     { x: 137.913669064748, y: 3.09803921568627, size: 1 },
    //     { x: 138.561151079137, y: 3.13725490196078, size: 1 },
    //     { x: 139.856115107914, y: 2.74509803921569, size: 1 },
    //     { x: 159.928057553957, y: 3.2156862745098, size: 1 },
    //     { x: 161.223021582734, y: 2.35294117647059, size: 1 },
    //     { x: 161.870503597122, y: 2.19607843137255, size: 1 },
    //     { x: 163.165467625899, y: 3.84313725490196, size: 1 },
    //     { x: 170.935251798561, y: 3.80392156862745, size: 1 },
    //     { x: 176.762589928058, y: 3.88235294117647, size: 1 },
    //     { x: 182.589928057554, y: 2.7843137254902, size: 1 },
    //     { x: 183.237410071942, y: 3.01960784313725, size: 1 },
    //     { x: 225.971223021583, y: 2.74509803921569, size: 1 },
    //     { x: 226.618705035971, y: 2.58823529411765, size: 1 },
    //     { x: 245.395683453237, y: 3.37254901960784, size: 1 },
    //     { x: 258.345323741007, y: 3.25490196078431, size: 1 },
    //     { x: 268.057553956835, y: 3.17647058823529, size: 1 },
    //     { x: 268.705035971223, y: 3.01960784313725, size: 1 },
    //     { x: 269.352517985611, y: 2.82352941176471, size: 1 },
    //     { x: 277.122302158273, y: 4.07843137254902, size: 1 },
    //     { x: 286.187050359712, y: 3.96078431372549, size: 1 },
    //     { x: 295.251798561151, y: 3.96078431372549, size: 1 },
    //     { x: 298.489208633094, y: 3.88235294117647, size: 1 },
    //     { x: 311.438848920863, y: 3.2156862745098, size: 1 },
    //     { x: 312.086330935252, y: 2.66666666666667, size: 1 },
    //     { x: 312.73381294964, y: 2.62745098039216, size: 1 },
    //     { x: 333.453237410072, y: 3.01960784313725, size: 1 },
    //     { x: 334.10071942446, y: 1.96078431372549, size: 1 },
    //     { x: 334.748201438849, y: 3.13725490196078, size: 1 },
    //     { x: 354.172661870504, y: 3.05882352941176, size: 1 },
    //     { x: 357.410071942446, y: 3.96078431372549, size: 1 },
    //     { x: 1.94244604316547, y: 4.15686274509804, size: 1 },
    //     { x: 3.88489208633094, y: 3.88235294117647, size: 1 },
    //     { x: 19.4244604316547, y: 4.07843137254902, size: 1 },
    //     { x: 22.6618705035971, y: 4.07843137254902, size: 1 },
    //     { x: 29.136690647482, y: 3.92156862745098, size: 1 },
    //     { x: 72.5179856115108, y: 4.03921568627451, size: 1 },
    //     { x: 80.9352517985612, y: 3.84313725490196, size: 1 },
    //     { x: 87.410071942446, y: 3.92156862745098, size: 1 },
    //     { x: 104.892086330935, y: 3.92156862745098, size: 1 },
    //     { x: 124.964028776978, y: 3.17647058823529, size: 1 },
    //     { x: 146.978417266187, y: 3.25490196078431, size: 1 },
    //     { x: 167.697841726619, y: 3.13725490196078, size: 1 },
    //     { x: 168.345323741007, y: 3.13725490196078, size: 1 },
    //     { x: 168.992805755396, y: 3.96078431372549, size: 1 },
    //     { x: 211.079136690647, y: 3.09803921568627, size: 1 },
    //     { x: 225.323741007194, y: 3.96078431372549, size: 1 },
    //     { x: 227.26618705036, y: 3.92156862745098, size: 1 },
    //     { x: 228.561151079137, y: 3.92156862745098, size: 1 },
    //     { x: 280.359712230216, y: 3.96078431372549, size: 1 },
    //     { x: 283.597122302158, y: 4.15686274509804, size: 1 },
    //     { x: 284.892086330935, y: 3.84313725490196, size: 1 },
    //     { x: 297.841726618705, y: 3.13725490196078, size: 1 },
    //     { x: 298.489208633094, y: 3.05882352941176, size: 1 },
    //     { x: 299.136690647482, y: 3.92156862745098, size: 1 },
    //     { x: 341.223021582734, y: 3.2156862745098, size: 1 },
    //     { x: 348.345323741007, y: 3.96078431372549, size: 1 },
    //     { x: 0.648648648648649, y: 4, size: 1 },
    //     { x: 2.59459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 8.43243243243243, y: 3.68627450980392, size: 1 },
    //     { x: 18.1621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 26.5945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 30.4864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 38.9189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 39.5675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 44.7567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 59.6756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 67.4594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 68.7567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 69.4054054054054, y: 3.52941176470588, size: 1 },
    //     { x: 86.2702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 88.2162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 92.1081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 110.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 112.216216216216, y: 3.52941176470588, size: 1 },
    //     { x: 117.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 123.891891891892, y: 3.56862745098039, size: 1 },
    //     { x: 129.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 129.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 131.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 140.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 149.189189189189, y: 3.68627450980392, size: 1 },
    //     { x: 152.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 153.72972972973, y: 3.05882352941176, size: 1 },
    //     { x: 154.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 158.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 160.216216216216, y: 3.64705882352941, size: 1 },
    //     { x: 162.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 165.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 168.648648648649, y: 4, size: 1 },
    //     { x: 170.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 171.891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 176.432432432432, y: 3.68627450980392, size: 1 },
    //     { x: 177.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 179.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 180.324324324324, y: 4, size: 1 },
    //     { x: 182.918918918919, y: 4, size: 1 },
    //     { x: 183.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 184.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 186.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 187.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 188.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 188.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 190.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 192, y: 4, size: 1 },
    //     { x: 192.648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 194.594594594595, y: 4, size: 1 },
    //     { x: 196.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 197.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 199.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 203.027027027027, y: 3.45098039215686, size: 1 },
    //     { x: 204.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 204.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 206.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 217.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 219.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 223.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 226.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 234.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 235.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 236.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 238.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 240, y: 3.17647058823529, size: 1 },
    //     { x: 240.648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 247.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 248.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 254.27027027027, y: 4, size: 1 },
    //     { x: 256.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 272.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 273.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 275.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 276.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 283.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 288.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 291.243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 293.189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 293.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 297.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 308.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 313.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 313.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 318.486486486487, y: 3.92156862745098, size: 1 },
    //     { x: 324.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 330.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 334.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 341.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 345.081081081081, y: 3.52941176470588, size: 1 },
    //     { x: 348.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 356.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 358.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 2.58992805755396, y: 3.84313725490196, size: 1 },
    //     { x: 10.3597122302158, y: 3.17647058823529, size: 1 },
    //     { x: 25.8992805755396, y: 3.88235294117647, size: 1 },
    //     { x: 31.0791366906475, y: 4, size: 1 },
    //     { x: 96.4748201438849, y: 3.29411764705882, size: 1 },
    //     { x: 97.1223021582734, y: 3.05882352941176, size: 1 },
    //     { x: 97.7697841726619, y: 3.25490196078431, size: 1 },
    //     { x: 110.071942446043, y: 3.88235294117647, size: 1 },
    //     { x: 139.208633093525, y: 2.94117647058824, size: 1 },
    //     { x: 139.856115107914, y: 2.7843137254902, size: 1 },
    //     { x: 145.035971223022, y: 3.88235294117647, size: 1 },
    //     { x: 162.517985611511, y: 3.96078431372549, size: 1 },
    //     { x: 173.525179856115, y: 4.03921568627451, size: 1 },
    //     { x: 187.122302158273, y: 4.27450980392157, size: 1 },
    //     { x: 194.892086330935, y: 3.92156862745098, size: 1 },
    //     { x: 219.496402877698, y: 3.88235294117647, size: 1 },
    //     { x: 224.028776978417, y: 3.25490196078431, size: 1 },
    //     { x: 225.323741007194, y: 3.25490196078431, size: 1 },
    //     { x: 225.971223021583, y: 2.90196078431373, size: 1 },
    //     { x: 247.985611510791, y: 3.05882352941176, size: 1 },
    //     { x: 290.719424460432, y: 3.09803921568627, size: 1 },
    //     { x: 295.251798561151, y: 4.07843137254902, size: 1 },
    //     { x: 310.791366906475, y: 3.09803921568627, size: 1 },
    //     { x: 312.086330935252, y: 3.09803921568627, size: 1 },
    //     { x: 323.741007194245, y: 4, size: 1 },
    //     { x: 324.388489208633, y: 3.96078431372549, size: 1 },
    //     { x: 328.920863309353, y: 3.92156862745098, size: 1 },
    //     { x: 332.158273381295, y: 3.25490196078431, size: 1 },
    //     { x: 338.63309352518, y: 3.41176470588235, size: 1 },
    //     { x: 345.107913669065, y: 3.88235294117647, size: 1 },
    //     { x: 355.467625899281, y: 3.13725490196078, size: 1 },
    //     { x: 357.410071942446, y: 3.29411764705882, size: 1 },
    //     { x: 358.057553956835, y: 3.33333333333333, size: 1 },
    //     { x: 12.3021582733813, y: 3.29411764705882, size: 1 },
    //     { x: 18.1294964028777, y: 3.37254901960784, size: 1 },
    //     { x: 25.2517985611511, y: 3.29411764705882, size: 1 },
    //     { x: 34.3165467625899, y: 3.33333333333333, size: 1 },
    //     { x: 37.5539568345324, y: 3.80392156862745, size: 1 },
    //     { x: 53.7410071942446, y: 3.92156862745098, size: 1 },
    //     { x: 61.5107913669065, y: 3.84313725490196, size: 1 },
    //     { x: 77.6978417266187, y: 3.80392156862745, size: 1 },
    //     { x: 91.294964028777, y: 3.92156862745098, size: 1 },
    //     { x: 105.539568345324, y: 3.88235294117647, size: 1 },
    //     { x: 113.956834532374, y: 4.03921568627451, size: 1 },
    //     { x: 115.251798561151, y: 3.96078431372549, size: 1 },
    //     { x: 119.784172661871, y: 3.88235294117647, size: 1 },
    //     { x: 125.611510791367, y: 3.88235294117647, size: 1 },
    //     { x: 135.323741007194, y: 3.92156862745098, size: 1 },
    //     { x: 135.971223021583, y: 3.92156862745098, size: 1 },
    //     { x: 145.68345323741, y: 3.33333333333333, size: 1 },
    //     { x: 146.330935251799, y: 2.90196078431373, size: 1 },
    //     { x: 168.345323741007, y: 3.33333333333333, size: 1 },
    //     { x: 171.58273381295, y: 3.84313725490196, size: 1 },
    //     { x: 183.884892086331, y: 3.92156862745098, size: 1 },
    //     { x: 194.892086330935, y: 3.33333333333333, size: 1 },
    //     { x: 198.776978417266, y: 3.92156862745098, size: 1 },
    //     { x: 200.071942446043, y: 3.25490196078431, size: 1 },
    //     { x: 211.726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 215.611510791367, y: 3.96078431372549, size: 1 },
    //     { x: 232.446043165468, y: 3.05882352941176, size: 1 },
    //     { x: 233.741007194245, y: 3.25490196078431, size: 1 },
    //     { x: 240.863309352518, y: 3.29411764705882, size: 1 },
    //     { x: 246.043165467626, y: 3.25490196078431, size: 1 },
    //     { x: 251.223021582734, y: 3.13725490196078, size: 1 },
    //     { x: 253.812949640288, y: 3.2156862745098, size: 1 },
    //     { x: 254.460431654676, y: 3.13725490196078, size: 1 },
    //     { x: 255.107913669065, y: 3.37254901960784, size: 1 },
    //     { x: 275.827338129496, y: 2.98039215686275, size: 1 },
    //     { x: 276.474820143885, y: 3.09803921568627, size: 1 },
    //     { x: 283.597122302158, y: 3.88235294117647, size: 1 },
    //     { x: 315.971223021583, y: 3.49019607843137, size: 1 },
    //     { x: 319.208633093525, y: 3.05882352941176, size: 1 },
    //     { x: 323.093525179856, y: 3.33333333333333, size: 1 },
    //     { x: 327.625899280576, y: 3.37254901960784, size: 1 },
    //     { x: 329.568345323741, y: 3.37254901960784, size: 1 },
    //     { x: 330.863309352518, y: 3.25490196078431, size: 1 },
    //     { x: 1.29496402877698, y: 3.2156862745098, size: 1 },
    //     { x: 1.94244604316547, y: 2.7843137254902, size: 1 },
    //     { x: 2.58992805755396, y: 2.94117647058824, size: 1 },
    //     { x: 12.3021582733813, y: 3.88235294117647, size: 1 },
    //     { x: 22.0143884892086, y: 2.98039215686275, size: 1 },
    //     { x: 23.3093525179856, y: 2.98039215686275, size: 1 },
    //     { x: 23.9568345323741, y: 1.56862745098039, size: 1 },
    //     { x: 24.6043165467626, y: 3.01960784313725, size: 1 },
    //     { x: 27.1942446043165, y: 3.37254901960784, size: 1 },
    //     { x: 28.4892086330935, y: 3.29411764705882, size: 1 },
    //     { x: 29.7841726618705, y: 3.37254901960784, size: 1 },
    //     { x: 45.3237410071942, y: 2.47058823529412, size: 1 },
    //     { x: 45.9712230215827, y: 2.3921568627451, size: 1 },
    //     { x: 91.294964028777, y: 3.2156862745098, size: 1 },
    //     { x: 101.654676258993, y: 3.25490196078431, size: 1 },
    //     { x: 106.187050359712, y: 3.2156862745098, size: 1 },
    //     { x: 108.129496402878, y: 3.17647058823529, size: 1 },
    //     { x: 108.776978417266, y: 3.05882352941176, size: 1 },
    //     { x: 109.424460431655, y: 2.90196078431373, size: 1 },
    //     { x: 110.071942446043, y: 2.27450980392157, size: 1 },
    //     { x: 110.719424460432, y: 2.7843137254902, size: 1 },
    //     { x: 116.546762589928, y: 3.33333333333333, size: 1 },
    //     { x: 121.726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 123.669064748201, y: 3.2156862745098, size: 1 },
    //     { x: 126.906474820144, y: 3.29411764705882, size: 1 },
    //     { x: 131.438848920863, y: 2.3921568627451, size: 1 },
    //     { x: 132.086330935252, y: 1.49019607843137, size: 1 },
    //     { x: 139.856115107914, y: 3.33333333333333, size: 1 },
    //     { x: 148.920863309353, y: 3.2156862745098, size: 1 },
    //     { x: 151.510791366906, y: 3.13725490196078, size: 1 },
    //     { x: 152.158273381295, y: 3.05882352941176, size: 1 },
    //     { x: 152.805755395683, y: 2.90196078431373, size: 1 },
    //     { x: 153.453237410072, y: 1.52941176470588, size: 1 },
    //     { x: 175.467625899281, y: 3.29411764705882, size: 1 },
    //     { x: 178.057553956835, y: 3.33333333333333, size: 1 },
    //     { x: 192.94964028777, y: 3.2156862745098, size: 1 },
    //     { x: 216.906474820144, y: 2.98039215686275, size: 1 },
    //     { x: 224.028776978417, y: 3.33333333333333, size: 1 },
    //     { x: 231.151079136691, y: 3.29411764705882, size: 1 },
    //     { x: 235.035971223022, y: 3.17647058823529, size: 1 },
    //     { x: 238.273381294964, y: 3.09803921568627, size: 1 },
    //     { x: 238.920863309353, y: 3.01960784313725, size: 1 },
    //     { x: 239.568345323741, y: 2.11764705882353, size: 1 },
    //     { x: 240.215827338129, y: 2.35294117647059, size: 1 },
    //     { x: 242.158273381295, y: 3.84313725490196, size: 1 },
    //     { x: 254.460431654676, y: 4.07843137254902, size: 1 },
    //     { x: 278.41726618705, y: 3.25490196078431, size: 1 },
    //     { x: 314.676258992806, y: 3.92156862745098, size: 1 },
    //     { x: 349.640287769784, y: 3.29411764705882, size: 1 },
    //     { x: 358.057553956835, y: 3.84313725490196, size: 1 },
    //     { x: 8.43243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 9.08108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 9.72972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 11.6756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 14.9189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 18.1621621621622, y: 3.45098039215686, size: 1 },
    //     { x: 22.0540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 27.2432432432432, y: 3.64705882352941, size: 1 },
    //     { x: 29.1891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 31.7837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 32.4324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 33.0810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 33.7297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 36.3243243243243, y: 4.07843137254902, size: 1 },
    //     { x: 50.5945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 51.8918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 52.5405405405405, y: 2.70588235294118, size: 1 },
    //     { x: 53.1891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 53.8378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 54.4864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 56.4324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 63.5675675675676, y: 3.72549019607843, size: 1 },
    //     { x: 67.4594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 72.6486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 73.2972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 73.945945945946, y: 2.7843137254902, size: 1 },
    //     { x: 74.5945945945946, y: 2.70588235294118, size: 1 },
    //     { x: 75.2432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 75.8918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 81.0810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 82.3783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 83.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 89.5135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 91.4594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 92.7567567567568, y: 3.52941176470588, size: 1 },
    //     { x: 101.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 110.918918918919, y: 4, size: 1 },
    //     { x: 116.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 117.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 127.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 132.972972972973, y: 4, size: 1 },
    //     { x: 138.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 139.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 144, y: 3.80392156862745, size: 1 },
    //     { x: 153.72972972973, y: 3.49019607843137, size: 1 },
    //     { x: 154.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 160.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 161.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 166.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 180.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 191.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 195.243243243243, y: 3.64705882352941, size: 1 },
    //     { x: 203.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 204.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 210.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 217.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 219.243243243243, y: 4, size: 1 },
    //     { x: 223.135135135135, y: 3.49019607843137, size: 1 },
    //     { x: 223.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 225.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 226.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 241.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 245.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 246.486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 247.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 247.783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 248.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 250.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 251.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 256.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 257.513513513513, y: 3.29411764705882, size: 1 },
    //     { x: 261.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 263.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 264.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 265.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 267.891891891892, y: 3.52941176470588, size: 1 },
    //     { x: 275.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 276.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 281.513513513513, y: 3.80392156862745, size: 1 },
    //     { x: 283.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 284.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 287.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 291.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 293.837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 294.486486486487, y: 3.64705882352941, size: 1 },
    //     { x: 300.972972972973, y: 3.52941176470588, size: 1 },
    //     { x: 304.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 305.513513513513, y: 3.92156862745098, size: 1 },
    //     { x: 313.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 316.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 318.486486486487, y: 3.72549019607843, size: 1 },
    //     { x: 321.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 323.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 329.513513513513, y: 3.84313725490196, size: 1 },
    //     { x: 337.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 342.486486486487, y: 3.92156862745098, size: 1 },
    //     { x: 345.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 345.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 348.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 353.513513513513, y: 3.25490196078431, size: 1 },
    //     { x: 354.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 354.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 355.459459459459, y: 2.70588235294118, size: 1 },
    //     { x: 11.0071942446043, y: 3.92156862745098, size: 1 },
    //     { x: 14.8920863309353, y: 3.84313725490196, size: 1 },
    //     { x: 29.7841726618705, y: 3.84313725490196, size: 1 },
    //     { x: 60.2158273381295, y: 2.98039215686275, size: 1 },
    //     { x: 88.705035971223, y: 3.2156862745098, size: 1 },
    //     { x: 89.3525179856115, y: 3.33333333333333, size: 1 },
    //     { x: 100.359712230216, y: 3.17647058823529, size: 1 },
    //     { x: 102.94964028777, y: 3.37254901960784, size: 1 },
    //     { x: 117.841726618705, y: 3.88235294117647, size: 1 },
    //     { x: 123.021582733813, y: 3.29411764705882, size: 1 },
    //     { x: 155.395683453237, y: 4, size: 1 },
    //     { x: 180, y: 3.2156862745098, size: 1 },
    //     { x: 202.014388489209, y: 4.11764705882353, size: 1 },
    //     { x: 213.669064748201, y: 3.2156862745098, size: 1 },
    //     { x: 240.215827338129, y: 3.88235294117647, size: 1 },
    //     { x: 244.748201438849, y: 3.92156862745098, size: 1 },
    //     { x: 246.043165467626, y: 3.80392156862745, size: 1 },
    //     { x: 306.906474820144, y: 3.88235294117647, size: 1 },
    //     { x: 317.26618705036, y: 3.33333333333333, size: 1 },
    //     { x: 319.208633093525, y: 2.82352941176471, size: 1 },
    //     { x: 341.223021582734, y: 3.17647058823529, size: 1 },
    //     { x: 343.812949640288, y: 3.05882352941176, size: 1 },
    //     { x: 346.402877697842, y: 3.29411764705882, size: 1 },
    //     { x: 358.705035971223, y: 3.09803921568627, size: 1 },
    //     { x: 1.94244604316547, y: 3.13725490196078, size: 1 },
    //     { x: 2.58992805755396, y: 3.33333333333333, size: 1 },
    //     { x: 3.88489208633094, y: 3.2156862745098, size: 1 },
    //     { x: 9.71223021582734, y: 3.25490196078431, size: 1 },
    //     { x: 20.7194244604317, y: 3.17647058823529, size: 1 },
    //     { x: 23.9568345323741, y: 3.25490196078431, size: 1 },
    //     { x: 45.3237410071942, y: 3.09803921568627, size: 1 },
    //     { x: 46.6187050359712, y: 3.80392156862745, size: 1 },
    //     { x: 99.0647482014388, y: 4.03921568627451, size: 1 },
    //     { x: 113.956834532374, y: 3.96078431372549, size: 1 },
    //     { x: 114.604316546763, y: 4.19607843137255, size: 1 },
    //     { x: 135.323741007194, y: 3.80392156862745, size: 1 },
    //     { x: 153.453237410072, y: 3.09803921568627, size: 1 },
    //     { x: 154.10071942446, y: 3.37254901960784, size: 1 },
    //     { x: 181.942446043165, y: 3.84313725490196, size: 1 },
    //     { x: 201.36690647482, y: 3.96078431372549, size: 1 },
    //     { x: 216.258992805755, y: 4.19607843137255, size: 1 },
    //     { x: 228.561151079137, y: 4, size: 1 },
    //     { x: 251.870503597122, y: 4, size: 1 },
    //     { x: 252.517985611511, y: 3.76470588235294, size: 1 },
    //     { x: 260.935251798561, y: 3.05882352941176, size: 1 },
    //     { x: 261.58273381295, y: 2.90196078431373, size: 1 },
    //     { x: 263.525179856115, y: 3.2156862745098, size: 1 },
    //     { x: 264.172661870504, y: 3.29411764705882, size: 1 },
    //     { x: 266.762589928058, y: 3.13725490196078, size: 1 },
    //     { x: 271.942446043165, y: 3.17647058823529, size: 1 },
    //     { x: 274.532374100719, y: 3.37254901960784, size: 1 },
    //     { x: 278.41726618705, y: 3.2156862745098, size: 1 },
    //     { x: 282.302158273381, y: 2.54901960784314, size: 1 },
    //     { x: 282.94964028777, y: 2.3921568627451, size: 1 },
    //     { x: 289.424460431655, y: 3.2156862745098, size: 1 },
    //     { x: 299.784172661871, y: 3.33333333333333, size: 1 },
    //     { x: 301.079136690647, y: 3.25490196078431, size: 1 },
    //     { x: 305.611510791367, y: 4.07843137254902, size: 1 },
    //     { x: 307.553956834532, y: 4.03921568627451, size: 1 },
    //     { x: 308.201438848921, y: 3.92156862745098, size: 1 },
    //     { x: 313.381294964029, y: 4.07843137254902, size: 1 },
    //     { x: 315.323741007194, y: 4.11764705882353, size: 1 },
    //     { x: 317.26618705036, y: 4.07843137254902, size: 1 },
    //     { x: 318.561151079137, y: 3.92156862745098, size: 1 },
    //     { x: 321.798561151079, y: 3.84313725490196, size: 1 },
    //     { x: 323.093525179856, y: 3.92156862745098, size: 1 },
    //     { x: 331.510791366906, y: 4, size: 1 },
    //     { x: 332.805755395683, y: 4, size: 1 },
    //     { x: 339.280575539568, y: 3.88235294117647, size: 1 },
    //     { x: 343.165467625899, y: 4.03921568627451, size: 1 },
    //     { x: 347.05035971223, y: 3.09803921568627, size: 1 },
    //     { x: 347.697841726619, y: 2.82352941176471, size: 1 },
    //     { x: 8.41726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 9.06474820143885, y: 3.09803921568627, size: 1 },
    //     { x: 29.136690647482, y: 3.37254901960784, size: 1 },
    //     { x: 29.7841726618705, y: 3.2156862745098, size: 1 },
    //     { x: 30.431654676259, y: 2.43137254901961, size: 1 },
    //     { x: 31.0791366906475, y: 2.3921568627451, size: 1 },
    //     { x: 42.7338129496403, y: 3.33333333333333, size: 1 },
    //     { x: 51.7985611510791, y: 3.25490196078431, size: 1 },
    //     { x: 72.5179856115108, y: 3.2156862745098, size: 1 },
    //     { x: 73.1654676258993, y: 3.2156862745098, size: 1 },
    //     { x: 73.8129496402878, y: 2.7843137254902, size: 1 },
    //     { x: 95.1798561151079, y: 3.09803921568627, size: 1 },
    //     { x: 113.309352517986, y: 3.96078431372549, size: 1 },
    //     { x: 116.546762589928, y: 3.17647058823529, size: 1 },
    //     { x: 117.194244604317, y: 3.25490196078431, size: 1 },
    //     { x: 159.280575539568, y: 3.25490196078431, size: 1 },
    //     { x: 159.928057553957, y: 3.09803921568627, size: 1 },
    //     { x: 181.294964028777, y: 3.2156862745098, size: 1 },
    //     { x: 181.942446043165, y: 3.25490196078431, size: 1 },
    //     { x: 224.676258992806, y: 2.90196078431373, size: 1 },
    //     { x: 225.323741007194, y: 3.13725490196078, size: 1 },
    //     { x: 231.151079136691, y: 3.25490196078431, size: 1 },
    //     { x: 246.043165467626, y: 2.98039215686275, size: 1 },
    //     { x: 248.63309352518, y: 3.80392156862745, size: 1 },
    //     { x: 268.057553956835, y: 3.84313725490196, size: 1 },
    //     { x: 287.482014388489, y: 3.37254901960784, size: 1 },
    //     { x: 288.776978417266, y: 2.66666666666667, size: 1 },
    //     { x: 289.424460431655, y: 1.29411764705882, size: 1 },
    //     { x: 290.071942446043, y: 1.29411764705882, size: 1 },
    //     { x: 290.719424460432, y: 1.33333333333333, size: 1 },
    //     { x: 291.36690647482, y: 1.49019607843137, size: 1 },
    //     { x: 298.489208633094, y: 3.01960784313725, size: 1 },
    //     { x: 299.136690647482, y: 2.98039215686275, size: 1 },
    //     { x: 304.964028776978, y: 2.90196078431373, size: 1 },
    //     { x: 305.611510791367, y: 3.05882352941176, size: 1 },
    //     { x: 308.201438848921, y: 3.29411764705882, size: 1 },
    //     { x: 310.791366906475, y: 2.3921568627451, size: 1 },
    //     { x: 311.438848920863, y: 2.35294117647059, size: 1 },
    //     { x: 330.863309352518, y: 3.29411764705882, size: 1 },
    //     { x: 331.510791366906, y: 3.2156862745098, size: 1 },
    //     { x: 332.805755395683, y: 2.50980392156863, size: 1 },
    //     { x: 341.223021582734, y: 4.07843137254902, size: 1 },
    //     { x: 346.402877697842, y: 4, size: 1 },
    //     { x: 354.172661870504, y: 2.54901960784314, size: 1 },
    //     { x: 354.820143884892, y: 2.66666666666667, size: 1 },
    //     { x: 3.24324324324324, y: 3.64705882352941, size: 1 },
    //     { x: 11.6756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 12.3243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 14.2702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 15.5675675675676, y: 4.03921568627451, size: 1 },
    //     { x: 22.0540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 23.3513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 28.5405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 36.3243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 37.6216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 38.2702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 38.9189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 41.5135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 44.1081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 45.4054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 49.2972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 54.4864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 57.7297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 58.3783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 59.6756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 72.6486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 74.5945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 75.8918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 76.5405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 77.8378378378378, y: 3.68627450980392, size: 1 },
    //     { x: 79.7837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 80.4324324324324, y: 3.56862745098039, size: 1 },
    //     { x: 81.0810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 87.5675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 100.540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 101.189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 102.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 103.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 103.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 105.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 109.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 110.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 117.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 120.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 121.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 122.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 126.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 128.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 132.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 136.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 139.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 140.756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 142.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 145.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 152.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 154.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 155.675675675676, y: 3.56862745098039, size: 1 },
    //     { x: 161.513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 166.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 170.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 171.891891891892, y: 3.64705882352941, size: 1 },
    //     { x: 174.486486486486, y: 3.68627450980392, size: 1 },
    //     { x: 176.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 178.378378378378, y: 4.07843137254902, size: 1 },
    //     { x: 188.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 189.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 190.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 192.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 195.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 195.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 198.486486486486, y: 3.45098039215686, size: 1 },
    //     { x: 200.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 207.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 213.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 217.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 227.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 227.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 229.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 234.162162162162, y: 4, size: 1 },
    //     { x: 234.810810810811, y: 4, size: 1 },
    //     { x: 238.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 240.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 241.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 244.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 245.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 246.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 248.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 250.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 251.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 257.513513513513, y: 3.92156862745098, size: 1 },
    //     { x: 258.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 258.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 260.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 262.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 265.297297297297, y: 4.31372549019608, size: 1 },
    //     { x: 265.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 266.594594594595, y: 4.07843137254902, size: 1 },
    //     { x: 267.243243243243, y: 4.35294117647059, size: 1 },
    //     { x: 273.081081081081, y: 4, size: 1 },
    //     { x: 275.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 277.621621621622, y: 4, size: 1 },
    //     { x: 278.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 280.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 281.513513513513, y: 3.92156862745098, size: 1 },
    //     { x: 282.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 282.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 283.459459459459, y: 4, size: 1 },
    //     { x: 284.756756756757, y: 3.68627450980392, size: 1 },
    //     { x: 285.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 286.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 288.648648648649, y: 3.72549019607843, size: 1 },
    //     { x: 289.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 291.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 291.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 292.540540540541, y: 4, size: 1 },
    //     { x: 293.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 297.081081081081, y: 2.86274509803922, size: 1 },
    //     { x: 297.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 299.675675675676, y: 4, size: 1 },
    //     { x: 300.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 300.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 302.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 303.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 304.864864864865, y: 4, size: 1 },
    //     { x: 305.513513513513, y: 3.96078431372549, size: 1 },
    //     { x: 306.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 307.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 308.756756756757, y: 3.64705882352941, size: 1 },
    //     { x: 310.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 312, y: 3.72549019607843, size: 1 },
    //     { x: 312.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 313.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 314.594594594595, y: 4, size: 1 },
    //     { x: 315.243243243243, y: 4, size: 1 },
    //     { x: 315.891891891892, y: 4, size: 1 },
    //     { x: 318.486486486487, y: 3.25490196078431, size: 1 },
    //     { x: 319.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 320.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 321.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 322.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 324.972972972973, y: 4, size: 1 },
    //     { x: 328.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 330.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 331.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 332.756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 335.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 336.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 338.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 339.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 340.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 342.486486486487, y: 3.41176470588235, size: 1 },
    //     { x: 343.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 343.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 348.972972972973, y: 4.03921568627451, size: 1 },
    //     { x: 349.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 356.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 356.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 357.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 358.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 2.58992805755396, y: 3.17647058823529, size: 1 },
    //     { x: 3.23741007194245, y: 3.13725490196078, size: 1 },
    //     { x: 3.88489208633094, y: 3.29411764705882, size: 1 },
    //     { x: 5.8273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 11.0071942446043, y: 4.15686274509804, size: 1 },
    //     { x: 12.3021582733813, y: 3.92156862745098, size: 1 },
    //     { x: 23.3093525179856, y: 2.90196078431373, size: 1 },
    //     { x: 23.9568345323741, y: 2.90196078431373, size: 1 },
    //     { x: 25.2517985611511, y: 2.86274509803922, size: 1 },
    //     { x: 29.7841726618705, y: 4.11764705882353, size: 1 },
    //     { x: 33.0215827338129, y: 3.96078431372549, size: 1 },
    //     { x: 33.6690647482014, y: 3.92156862745098, size: 1 },
    //     { x: 34.3165467625899, y: 4, size: 1 },
    //     { x: 59.568345323741, y: 3.88235294117647, size: 1 },
    //     { x: 60.863309352518, y: 4.03921568627451, size: 1 },
    //     { x: 66.6906474820144, y: 2.58823529411765, size: 1 },
    //     { x: 67.9856115107914, y: 2.70588235294118, size: 1 },
    //     { x: 68.6330935251799, y: 2.58823529411765, size: 1 },
    //     { x: 88.0575539568345, y: 3.17647058823529, size: 1 },
    //     { x: 88.705035971223, y: 3.13725490196078, size: 1 },
    //     { x: 89.3525179856115, y: 3.05882352941176, size: 1 },
    //     { x: 90, y: 3.2156862745098, size: 1 },
    //     { x: 98.4172661870504, y: 3.92156862745098, size: 1 },
    //     { x: 100.359712230216, y: 3.76470588235294, size: 1 },
    //     { x: 134.028776978417, y: 3.17647058823529, size: 1 },
    //     { x: 134.676258992806, y: 3.09803921568627, size: 1 },
    //     { x: 145.035971223022, y: 3.13725490196078, size: 1 },
    //     { x: 145.68345323741, y: 3.29411764705882, size: 1 },
    //     { x: 150.215827338129, y: 3.13725490196078, size: 1 },
    //     { x: 152.805755395683, y: 3.41176470588235, size: 1 },
    //     { x: 174.172661870504, y: 2.58823529411765, size: 1 },
    //     { x: 176.762589928058, y: 3.96078431372549, size: 1 },
    //     { x: 198.129496402878, y: 2.98039215686275, size: 1 },
    //     { x: 198.776978417266, y: 3.96078431372549, size: 1 },
    //     { x: 199.424460431655, y: 4.03921568627451, size: 1 },
    //     { x: 209.136690647482, y: 3.84313725490196, size: 1 },
    //     { x: 210.431654676259, y: 4.11764705882353, size: 1 },
    //     { x: 217.553956834532, y: 3.25490196078431, size: 1 },
    //     { x: 238.273381294964, y: 3.29411764705882, size: 1 },
    //     { x: 247.338129496403, y: 3.88235294117647, size: 1 },
    //     { x: 261.58273381295, y: 3.2156862745098, size: 1 },
    //     { x: 262.230215827338, y: 2.82352941176471, size: 1 },
    //     { x: 266.762589928058, y: 3.88235294117647, size: 1 },
    //     { x: 270, y: 3.80392156862745, size: 1 },
    //     { x: 282.302158273381, y: 2.86274509803922, size: 1 },
    //     { x: 283.597122302158, y: 3.05882352941176, size: 1 },
    //     { x: 285.539568345324, y: 3.96078431372549, size: 1 },
    //     { x: 287.482014388489, y: 3.96078431372549, size: 1 },
    //     { x: 290.071942446043, y: 3.96078431372549, size: 1 },
    //     { x: 295.89928057554, y: 3.96078431372549, size: 1 },
    //     { x: 296.546762589928, y: 3.96078431372549, size: 1 },
    //     { x: 301.079136690647, y: 4, size: 1 },
    //     { x: 317.26618705036, y: 4.11764705882353, size: 1 },
    //     { x: 319.856115107914, y: 3.84313725490196, size: 1 },
    //     { x: 323.741007194245, y: 3.33333333333333, size: 1 },
    //     { x: 328.920863309353, y: 3.88235294117647, size: 1 },
    //     { x: 337.985611510791, y: 4.03921568627451, size: 1 },
    //     { x: 347.05035971223, y: 3.05882352941176, size: 1 },
    //     { x: 348.345323741007, y: 2.7843137254902, size: 1 },
    //     { x: 348.992805755396, y: 2.3921568627451, size: 1 },
    //     { x: 20.0719424460432, y: 3.88235294117647, size: 1 },
    //     { x: 27.1942446043165, y: 3.96078431372549, size: 1 },
    //     { x: 33.0215827338129, y: 3.92156862745098, size: 1 },
    //     { x: 51.7985611510791, y: 2.90196078431373, size: 1 },
    //     { x: 52.4460431654676, y: 2.90196078431373, size: 1 },
    //     { x: 121.079136690647, y: 4.11764705882353, size: 1 },
    //     { x: 129.496402877698, y: 3.96078431372549, size: 1 },
    //     { x: 130.791366906475, y: 4.23529411764706, size: 1 },
    //     { x: 141.798561151079, y: 4, size: 1 },
    //     { x: 145.68345323741, y: 4.03921568627451, size: 1 },
    //     { x: 155.395683453237, y: 3.96078431372549, size: 1 },
    //     { x: 159.928057553957, y: 3.13725490196078, size: 1 },
    //     { x: 160.575539568345, y: 3.2156862745098, size: 1 },
    //     { x: 172.877697841727, y: 3.92156862745098, size: 1 },
    //     { x: 174.172661870504, y: 4.07843137254902, size: 1 },
    //     { x: 174.820143884892, y: 3.96078431372549, size: 1 },
    //     { x: 185.179856115108, y: 3.29411764705882, size: 1 },
    //     { x: 187.769784172662, y: 3.33333333333333, size: 1 },
    //     { x: 202.661870503597, y: 3.17647058823529, size: 1 },
    //     { x: 204.604316546763, y: 3.05882352941176, size: 1 },
    //     { x: 211.079136690647, y: 3.96078431372549, size: 1 },
    //     { x: 226.618705035971, y: 3.09803921568627, size: 1 },
    //     { x: 246.043165467626, y: 3.13725490196078, size: 1 },
    //     { x: 255.107913669065, y: 3.80392156862745, size: 1 },
    //     { x: 261.58273381295, y: 3.88235294117647, size: 1 },
    //     { x: 268.705035971223, y: 3.05882352941176, size: 1 },
    //     { x: 269.352517985611, y: 3.17647058823529, size: 1 },
    //     { x: 270, y: 3.29411764705882, size: 1 },
    //     { x: 275.827338129496, y: 3.88235294117647, size: 1 },
    //     { x: 286.834532374101, y: 3.96078431372549, size: 1 },
    //     { x: 288.129496402878, y: 3.2156862745098, size: 1 },
    //     { x: 290.071942446043, y: 3.17647058823529, size: 1 },
    //     { x: 297.841726618705, y: 3.25490196078431, size: 1 },
    //     { x: 302.374100719424, y: 3.25490196078431, size: 1 },
    //     { x: 306.258992805755, y: 3.29411764705882, size: 1 },
    //     { x: 312.086330935252, y: 3.2156862745098, size: 1 },
    //     { x: 330.863309352518, y: 4.03921568627451, size: 1 },
    //     { x: 334.10071942446, y: 3.96078431372549, size: 1 },
    //     { x: 335.395683453237, y: 4.03921568627451, size: 1 },
    //     { x: 336.690647482014, y: 4, size: 1 },
    //     { x: 339.928057553957, y: 3.88235294117647, size: 1 },
    //     { x: 340.575539568345, y: 4.03921568627451, size: 1 },
    //     { x: 341.870503597122, y: 3.96078431372549, size: 1 },
    //     { x: 345.755395683453, y: 3.88235294117647, size: 1 },
    //     { x: 353.525179856115, y: 3.09803921568627, size: 1 },
    //     { x: 354.172661870504, y: 3.17647058823529, size: 1 },
    //     { x: 354.820143884892, y: 2.94117647058824, size: 1 },
    //     { x: 355.467625899281, y: 3.25490196078431, size: 1 },
    //     { x: 356.115107913669, y: 2.98039215686275, size: 1 },
    //     { x: 20.7194244604317, y: 3.96078431372549, size: 1 },
    //     { x: 45.3237410071942, y: 3.88235294117647, size: 1 },
    //     { x: 60.2158273381295, y: 3.2156862745098, size: 1 },
    //     { x: 73.8129496402878, y: 3.88235294117647, size: 1 },
    //     { x: 83.5251798561151, y: 3.49019607843137, size: 1 },
    //     { x: 89.3525179856115, y: 4, size: 1 },
    //     { x: 90, y: 4.07843137254902, size: 1 },
    //     { x: 96.4748201438849, y: 3.84313725490196, size: 1 },
    //     { x: 101.654676258993, y: 3.09803921568627, size: 1 },
    //     { x: 102.302158273381, y: 3.29411764705882, size: 1 },
    //     { x: 102.94964028777, y: 3.01960784313725, size: 1 },
    //     { x: 106.187050359712, y: 3.96078431372549, size: 1 },
    //     { x: 114.604316546763, y: 4.03921568627451, size: 1 },
    //     { x: 123.669064748201, y: 2.90196078431373, size: 1 },
    //     { x: 124.31654676259, y: 3.09803921568627, size: 1 },
    //     { x: 124.964028776978, y: 2.90196078431373, size: 1 },
    //     { x: 125.611510791367, y: 3.01960784313725, size: 1 },
    //     { x: 146.330935251799, y: 3.09803921568627, size: 1 },
    //     { x: 146.978417266187, y: 2.98039215686275, size: 1 },
    //     { x: 166.402877697842, y: 3.17647058823529, size: 1 },
    //     { x: 194.244604316547, y: 3.2156862745098, size: 1 },
    //     { x: 214.31654676259, y: 3.41176470588235, size: 1 },
    //     { x: 260.287769784173, y: 3.84313725490196, size: 1 },
    //     { x: 269.352517985611, y: 3.84313725490196, size: 1 },
    //     { x: 277.769784172662, y: 4.03921568627451, size: 1 },
    //     { x: 281.654676258993, y: 4, size: 1 },
    //     { x: 297.194244604317, y: 3.25490196078431, size: 1 },
    //     { x: 298.489208633094, y: 3.33333333333333, size: 1 },
    //     { x: 308.201438848921, y: 3.96078431372549, size: 1 },
    //     { x: 317.913669064748, y: 3.2156862745098, size: 1 },
    //     { x: 347.697841726619, y: 3.33333333333333, size: 1 },
    //     { x: 0.648648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 1.2972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 1.94594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 3.24324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 3.89189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 12.3243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 17.5135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 18.1621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 20.7567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 22.0540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 22.7027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 23.3513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 24, y: 2.7843137254902, size: 1 },
    //     { x: 24.6486486486486, y: 2.74509803921569, size: 1 },
    //     { x: 25.2972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 27.8918918918919, y: 4, size: 1 },
    //     { x: 30.4864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 42.8108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 43.4594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 44.7567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 45.4054054054054, y: 2.50980392156863, size: 1 },
    //     { x: 46.0540540540541, y: 2.7843137254902, size: 1 },
    //     { x: 46.7027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 48.6486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 51.8918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 55.7837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 63.5675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 64.8648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 67.4594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 70.7027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 72.6486486486486, y: 3.64705882352941, size: 1 },
    //     { x: 77.8378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 78.4864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 83.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 87.5675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 96, y: 3.80392156862745, size: 1 },
    //     { x: 103.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 105.72972972973, y: 4.11764705882353, size: 1 },
    //     { x: 108.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 112.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 116.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 120, y: 3.88235294117647, size: 1 },
    //     { x: 123.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 125.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 129.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 130.378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 141.405405405405, y: 4, size: 1 },
    //     { x: 152.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 155.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 158.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 161.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 164.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 165.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 169.297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 169.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 170.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 173.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 174.486486486486, y: 3.52941176470588, size: 1 },
    //     { x: 176.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 178.378378378378, y: 3.49019607843137, size: 1 },
    //     { x: 181.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 190.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 195.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 195.891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 204.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 216, y: 3.33333333333333, size: 1 },
    //     { x: 216.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 217.297297297297, y: 2.74509803921569, size: 1 },
    //     { x: 217.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 218.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 224.432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 227.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 231.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 232.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 233.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 236.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 237.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 238.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 238.702702702703, y: 2.54901960784314, size: 1 },
    //     { x: 239.351351351351, y: 2.3921568627451, size: 1 },
    //     { x: 240, y: 3.68627450980392, size: 1 },
    //     { x: 241.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 245.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 252.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 253.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 260.108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 260.756756756757, y: 2.7843137254902, size: 1 },
    //     { x: 262.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 272.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 276.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 280.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 281.513513513513, y: 3.17647058823529, size: 1 },
    //     { x: 282.162162162162, y: 2.70588235294118, size: 1 },
    //     { x: 293.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 295.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 301.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 302.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 302.918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 303.567567567568, y: 2.35294117647059, size: 1 },
    //     { x: 304.216216216216, y: 2.66666666666667, size: 1 },
    //     { x: 323.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 324.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 325.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 326.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 327.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 328.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 328.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 330.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 332.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 332.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 333.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 334.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 336, y: 3.25490196078431, size: 1 },
    //     { x: 337.297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 337.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 339.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 339.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 343.135135135135, y: 3.45098039215686, size: 1 },
    //     { x: 343.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 349.621621621622, y: 3.64705882352941, size: 1 },
    //     { x: 353.513513513513, y: 3.76470588235294, size: 1 },
    //     { x: 31.726618705036, y: 3.29411764705882, size: 1 },
    //     { x: 32.3741007194245, y: 2.94117647058824, size: 1 },
    //     { x: 34.9640287769784, y: 3.2156862745098, size: 1 },
    //     { x: 38.2014388489209, y: 3.17647058823529, size: 1 },
    //     { x: 44.6762589928058, y: 2.98039215686275, size: 1 },
    //     { x: 46.6187050359712, y: 3.2156862745098, size: 1 },
    //     { x: 49.8561151079137, y: 3.25490196078431, size: 1 },
    //     { x: 53.0935251798561, y: 3.17647058823529, size: 1 },
    //     { x: 58.9208633093525, y: 3.17647058823529, size: 1 },
    //     { x: 60.2158273381295, y: 3.25490196078431, size: 1 },
    //     { x: 93.8848920863309, y: 3.01960784313725, size: 1 },
    //     { x: 94.5323741007194, y: 2.74509803921569, size: 1 },
    //     { x: 95.1798561151079, y: 2.43137254901961, size: 1 },
    //     { x: 114.604316546763, y: 3.25490196078431, size: 1 },
    //     { x: 136.618705035971, y: 3.13725490196078, size: 1 },
    //     { x: 137.26618705036, y: 3.17647058823529, size: 1 },
    //     { x: 137.913669064748, y: 3.33333333333333, size: 1 },
    //     { x: 141.798561151079, y: 3.2156862745098, size: 1 },
    //     { x: 143.741007194245, y: 3.13725490196078, size: 1 },
    //     { x: 148.273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 159.280575539568, y: 3.92156862745098, size: 1 },
    //     { x: 182.589928057554, y: 3.17647058823529, size: 1 },
    //     { x: 185.827338129496, y: 3.29411764705882, size: 1 },
    //     { x: 188.41726618705, y: 3.29411764705882, size: 1 },
    //     { x: 192.94964028777, y: 3.25490196078431, size: 1 },
    //     { x: 194.892086330935, y: 3.17647058823529, size: 1 },
    //     { x: 204.604316546763, y: 2.98039215686275, size: 1 },
    //     { x: 224.676258992806, y: 3.13725490196078, size: 1 },
    //     { x: 225.323741007194, y: 3.09803921568627, size: 1 },
    //     { x: 241.510791366906, y: 3.2156862745098, size: 1 },
    //     { x: 251.223021582734, y: 3.29411764705882, size: 1 },
    //     { x: 262.877697841727, y: 3.17647058823529, size: 1 },
    //     { x: 265.467625899281, y: 3.2156862745098, size: 1 },
    //     { x: 268.057553956835, y: 3.01960784313725, size: 1 },
    //     { x: 268.705035971223, y: 3.29411764705882, size: 1 },
    //     { x: 269.352517985611, y: 3.2156862745098, size: 1 },
    //     { x: 270.647482014389, y: 3.05882352941176, size: 1 },
    //     { x: 271.294964028777, y: 3.17647058823529, size: 1 },
    //     { x: 284.892086330935, y: 3.25490196078431, size: 1 },
    //     { x: 286.187050359712, y: 3.25490196078431, size: 1 },
    //     { x: 287.482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 293.956834532374, y: 3.92156862745098, size: 1 },
    //     { x: 310.791366906475, y: 2.90196078431373, size: 1 },
    //     { x: 311.438848920863, y: 2.98039215686275, size: 1 },
    //     { x: 312.086330935252, y: 2.86274509803922, size: 1 },
    //     { x: 312.73381294964, y: 3.01960784313725, size: 1 },
    //     { x: 321.798561151079, y: 3.09803921568627, size: 1 },
    //     { x: 323.093525179856, y: 3.29411764705882, size: 1 },
    //     { x: 324.388489208633, y: 3.25490196078431, size: 1 },
    //     { x: 327.625899280576, y: 3.17647058823529, size: 1 },
    //     { x: 358.057553956835, y: 3.92156862745098, size: 1 },
    //     { x: 1.94244604316547, y: 3.37254901960784, size: 1 },
    //     { x: 10.3597122302158, y: 3.2156862745098, size: 1 },
    //     { x: 48.5611510791367, y: 3.13725490196078, size: 1 },
    //     { x: 62.158273381295, y: 3.13725490196078, size: 1 },
    //     { x: 71.2230215827338, y: 3.13725490196078, size: 1 },
    //     { x: 77.6978417266187, y: 3.05882352941176, size: 1 },
    //     { x: 80.2877697841727, y: 3.05882352941176, size: 1 },
    //     { x: 80.9352517985612, y: 2.98039215686275, size: 1 },
    //     { x: 81.5827338129496, y: 2.90196078431373, size: 1 },
    //     { x: 82.2302158273381, y: 2.7843137254902, size: 1 },
    //     { x: 86.1151079136691, y: 3.2156862745098, size: 1 },
    //     { x: 91.9424460431655, y: 3.2156862745098, size: 1 },
    //     { x: 104.892086330935, y: 3.17647058823529, size: 1 },
    //     { x: 105.539568345324, y: 3.2156862745098, size: 1 },
    //     { x: 107.482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 109.424460431655, y: 3.33333333333333, size: 1 },
    //     { x: 114.604316546763, y: 3.17647058823529, size: 1 },
    //     { x: 123.021582733813, y: 3.25490196078431, size: 1 },
    //     { x: 124.964028776978, y: 2.94117647058824, size: 1 },
    //     { x: 125.611510791367, y: 3.25490196078431, size: 1 },
    //     { x: 126.906474820144, y: 3.25490196078431, size: 1 },
    //     { x: 135.323741007194, y: 3.17647058823529, size: 1 },
    //     { x: 135.971223021583, y: 3.29411764705882, size: 1 },
    //     { x: 143.093525179856, y: 3.33333333333333, size: 1 },
    //     { x: 145.035971223022, y: 2.74509803921569, size: 1 },
    //     { x: 145.68345323741, y: 2.98039215686275, size: 1 },
    //     { x: 152.805755395683, y: 3.2156862745098, size: 1 },
    //     { x: 153.453237410072, y: 3.25490196078431, size: 1 },
    //     { x: 156.043165467626, y: 3.17647058823529, size: 1 },
    //     { x: 161.870503597122, y: 3.2156862745098, size: 1 },
    //     { x: 162.517985611511, y: 3.25490196078431, size: 1 },
    //     { x: 168.345323741007, y: 2.82352941176471, size: 1 },
    //     { x: 201.36690647482, y: 3.80392156862745, size: 1 },
    //     { x: 226.618705035971, y: 3.25490196078431, size: 1 },
    //     { x: 233.093525179856, y: 3.37254901960784, size: 1 },
    //     { x: 274.532374100719, y: 3.01960784313725, size: 1 },
    //     { x: 280.359712230216, y: 3.25490196078431, size: 1 },
    //     { x: 281.007194244604, y: 3.01960784313725, size: 1 },
    //     { x: 281.654676258993, y: 3.33333333333333, size: 1 },
    //     { x: 285.539568345324, y: 3.29411764705882, size: 1 },
    //     { x: 286.187050359712, y: 3.29411764705882, size: 1 },
    //     { x: 286.834532374101, y: 3.17647058823529, size: 1 },
    //     { x: 287.482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 292.014388489209, y: 3.17647058823529, size: 1 },
    //     { x: 292.661870503597, y: 3.17647058823529, size: 1 },
    //     { x: 293.956834532374, y: 3.25490196078431, size: 1 },
    //     { x: 1.2972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 10.3783783783784, y: 3.6078431372549, size: 1 },
    //     { x: 22.0540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 42.8108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 43.4594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 44.7567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 46.0540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 47.3513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 49.2972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 52.5405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 55.1351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 57.0810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 64.8648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 65.5135135135135, y: 2.50980392156863, size: 1 },
    //     { x: 66.1621621621622, y: 2.43137254901961, size: 1 },
    //     { x: 66.8108108108108, y: 2.74509803921569, size: 1 },
    //     { x: 67.4594594594595, y: 2.74509803921569, size: 1 },
    //     { x: 70.7027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 79.7837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 86.9189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 90.1621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 99.8918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 101.189189189189, y: 3.64705882352941, size: 1 },
    //     { x: 105.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 108.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 121.945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 123.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 125.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 128.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 132.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 144.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 147.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 157.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 167.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 181.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 184.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 190.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 191.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 192, y: 4.35294117647059, size: 1 },
    //     { x: 195.243243243243, y: 2.62745098039216, size: 1 },
    //     { x: 195.891891891892, y: 2.62745098039216, size: 1 },
    //     { x: 200.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 206.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 208.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 212.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 214.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 215.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 216.648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 219.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 219.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 224.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 225.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 225.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 229.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 230.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 234.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 235.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 240.648648648649, y: 4, size: 1 },
    //     { x: 241.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 246.486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 248.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 249.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 252.972972972973, y: 3.6078431372549, size: 1 },
    //     { x: 260.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 260.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 262.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 268.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 270.486486486487, y: 3.88235294117647, size: 1 },
    //     { x: 274.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 278.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 280.216216216216, y: 3.76470588235294, size: 1 },
    //     { x: 283.459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 289.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 290.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 297.081081081081, y: 3.6078431372549, size: 1 },
    //     { x: 316.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 328.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 328.864864864865, y: 3.52941176470588, size: 1 },
    //     { x: 337.297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 338.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 352.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 356.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 12.9496402877698, y: 4, size: 1 },
    //     { x: 14.8920863309353, y: 3.92156862745098, size: 1 },
    //     { x: 19.4244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 20.7194244604317, y: 3.92156862745098, size: 1 },
    //     { x: 31.0791366906475, y: 3.13725490196078, size: 1 },
    //     { x: 33.0215827338129, y: 3.25490196078431, size: 1 },
    //     { x: 33.6690647482014, y: 3.25490196078431, size: 1 },
    //     { x: 58.273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 73.1654676258993, y: 3.17647058823529, size: 1 },
    //     { x: 78.3453237410072, y: 3.33333333333333, size: 1 },
    //     { x: 94.5323741007194, y: 2.98039215686275, size: 1 },
    //     { x: 95.8273381294964, y: 2.50980392156863, size: 1 },
    //     { x: 96.4748201438849, y: 2.90196078431373, size: 1 },
    //     { x: 97.1223021582734, y: 3.33333333333333, size: 1 },
    //     { x: 100.359712230216, y: 3.41176470588235, size: 1 },
    //     { x: 115.89928057554, y: 2.7843137254902, size: 1 },
    //     { x: 116.546762589928, y: 2.86274509803922, size: 1 },
    //     { x: 117.194244604317, y: 2.82352941176471, size: 1 },
    //     { x: 118.489208633094, y: 3.2156862745098, size: 1 },
    //     { x: 137.913669064748, y: 2.94117647058824, size: 1 },
    //     { x: 143.093525179856, y: 3.96078431372549, size: 1 },
    //     { x: 146.978417266187, y: 4.03921568627451, size: 1 },
    //     { x: 161.870503597122, y: 4.03921568627451, size: 1 },
    //     { x: 204.604316546763, y: 3.17647058823529, size: 1 },
    //     { x: 205.251798561151, y: 3.17647058823529, size: 1 },
    //     { x: 245.395683453237, y: 2.82352941176471, size: 1 },
    //     { x: 246.043165467626, y: 2.70588235294118, size: 1 },
    //     { x: 299.136690647482, y: 4, size: 1 },
    //     { x: 301.079136690647, y: 3.45098039215686, size: 1 },
    //     { x: 316.618705035971, y: 3.88235294117647, size: 1 },
    //     { x: 329.568345323741, y: 3.92156862745098, size: 1 },
    //     { x: 339.928057553957, y: 4.07843137254902, size: 1 },
    //     { x: 354.820143884892, y: 3.2156862745098, size: 1 },
    //     { x: 355.467625899281, y: 3.01960784313725, size: 1 },
    //     { x: 38.2014388489209, y: 2.94117647058824, size: 1 },
    //     { x: 56.9784172661871, y: 3.33333333333333, size: 1 },
    //     { x: 62.158273381295, y: 3.84313725490196, size: 1 },
    //     { x: 88.705035971223, y: 4.15686274509804, size: 1 },
    //     { x: 90, y: 4, size: 1 },
    //     { x: 91.294964028777, y: 4, size: 1 },
    //     { x: 95.8273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 101.654676258993, y: 2.50980392156863, size: 1 },
    //     { x: 102.302158273381, y: 2.82352941176471, size: 1 },
    //     { x: 102.94964028777, y: 2.47058823529412, size: 1 },
    //     { x: 103.597122302158, y: 2.74509803921569, size: 1 },
    //     { x: 123.021582733813, y: 3.01960784313725, size: 1 },
    //     { x: 142.446043165468, y: 3.29411764705882, size: 1 },
    //     { x: 144.388489208633, y: 2.03921568627451, size: 1 },
    //     { x: 145.035971223022, y: 2.15686274509804, size: 1 },
    //     { x: 145.68345323741, y: 2.82352941176471, size: 1 },
    //     { x: 146.978417266187, y: 3.01960784313725, size: 1 },
    //     { x: 148.920863309353, y: 3.09803921568627, size: 1 },
    //     { x: 149.568345323741, y: 2.98039215686275, size: 1 },
    //     { x: 154.10071942446, y: 2.90196078431373, size: 1 },
    //     { x: 159.928057553957, y: 2.94117647058824, size: 1 },
    //     { x: 165.755395683453, y: 3.37254901960784, size: 1 },
    //     { x: 185.827338129496, y: 4.03921568627451, size: 1 },
    //     { x: 188.41726618705, y: 2.70588235294118, size: 1 },
    //     { x: 208.489208633094, y: 3.2156862745098, size: 1 },
    //     { x: 209.136690647482, y: 2.7843137254902, size: 1 },
    //     { x: 209.784172661871, y: 2.70588235294118, size: 1 },
    //     { x: 210.431654676259, y: 3.13725490196078, size: 1 },
    //     { x: 217.553956834532, y: 2.98039215686275, size: 1 },
    //     { x: 221.438848920863, y: 3.2156862745098, size: 1 },
    //     { x: 251.870503597122, y: 3.13725490196078, size: 1 },
    //     { x: 252.517985611511, y: 2.58823529411765, size: 1 },
    //     { x: 253.165467625899, y: 2.31372549019608, size: 1 },
    //     { x: 268.705035971223, y: 3.80392156862745, size: 1 },
    //     { x: 273.884892086331, y: 2.19607843137255, size: 1 },
    //     { x: 274.532374100719, y: 1.80392156862745, size: 1 },
    //     { x: 295.251798561151, y: 3.05882352941176, size: 1 },
    //     { x: 295.89928057554, y: 2.66666666666667, size: 1 },
    //     { x: 312.086330935252, y: 4.35294117647059, size: 1 },
    //     { x: 315.971223021583, y: 3.2156862745098, size: 1 },
    //     { x: 337.338129496403, y: 3.29411764705882, size: 1 },
    //     { x: 338.63309352518, y: 3.25490196078431, size: 1 },
    //     { x: 339.280575539568, y: 3.25490196078431, size: 1 },
    //     { x: 339.928057553957, y: 3.13725490196078, size: 1 },
    //     { x: 345.755395683453, y: 3.17647058823529, size: 1 },
    //     { x: 350.935251798561, y: 3.25490196078431, size: 1 },
    //     { x: 355.467625899281, y: 3.17647058823529, size: 1 },
    //     { x: 356.115107913669, y: 3.17647058823529, size: 1 },
    //     { x: 358.057553956835, y: 3.13725490196078, size: 1 },
    //     { x: 21.3669064748201, y: 3.13725490196078, size: 1 },
    //     { x: 22.0143884892086, y: 2.35294117647059, size: 1 },
    //     { x: 22.6618705035971, y: 2.58823529411765, size: 1 },
    //     { x: 34.9640287769784, y: 4.07843137254902, size: 1 },
    //     { x: 40.7913669064748, y: 3.96078431372549, size: 1 },
    //     { x: 42.0863309352518, y: 3.09803921568627, size: 1 },
    //     { x: 64.1007194244604, y: 2.98039215686275, size: 1 },
    //     { x: 111.36690647482, y: 4.11764705882353, size: 1 },
    //     { x: 113.956834532374, y: 4.11764705882353, size: 1 },
    //     { x: 115.251798561151, y: 4.11764705882353, size: 1 },
    //     { x: 116.546762589928, y: 3.96078431372549, size: 1 },
    //     { x: 121.079136690647, y: 3.92156862745098, size: 1 },
    //     { x: 126.258992805755, y: 3.96078431372549, size: 1 },
    //     { x: 133.381294964029, y: 3.96078431372549, size: 1 },
    //     { x: 135.323741007194, y: 4.15686274509804, size: 1 },
    //     { x: 138.561151079137, y: 4.15686274509804, size: 1 },
    //     { x: 139.856115107914, y: 3.92156862745098, size: 1 },
    //     { x: 140.503597122302, y: 3.96078431372549, size: 1 },
    //     { x: 142.446043165468, y: 3.84313725490196, size: 1 },
    //     { x: 143.093525179856, y: 3.88235294117647, size: 1 },
    //     { x: 145.035971223022, y: 3.92156862745098, size: 1 },
    //     { x: 147.625899280576, y: 3.96078431372549, size: 1 },
    //     { x: 148.273381294964, y: 4.19607843137255, size: 1 },
    //     { x: 183.237410071942, y: 3.96078431372549, size: 1 },
    //     { x: 187.769784172662, y: 4, size: 1 },
    //     { x: 195.539568345324, y: 3.37254901960784, size: 1 },
    //     { x: 206.546762589928, y: 3.92156862745098, size: 1 },
    //     { x: 211.079136690647, y: 3.92156862745098, size: 1 },
    //     { x: 215.611510791367, y: 3.2156862745098, size: 1 },
    //     { x: 216.258992805755, y: 3.13725490196078, size: 1 },
    //     { x: 227.913669064748, y: 3.92156862745098, size: 1 },
    //     { x: 232.446043165468, y: 3.84313725490196, size: 1 },
    //     { x: 251.223021582734, y: 3.96078431372549, size: 1 },
    //     { x: 262.877697841727, y: 4, size: 1 },
    //     { x: 263.525179856115, y: 3.96078431372549, size: 1 },
    //     { x: 269.352517985611, y: 4.03921568627451, size: 1 },
    //     { x: 270.647482014389, y: 4.03921568627451, size: 1 },
    //     { x: 272.589928057554, y: 3.88235294117647, size: 1 },
    //     { x: 273.884892086331, y: 4.07843137254902, size: 1 },
    //     { x: 281.007194244604, y: 2.94117647058824, size: 1 },
    //     { x: 282.302158273381, y: 2.70588235294118, size: 1 },
    //     { x: 282.94964028777, y: 2.90196078431373, size: 1 },
    //     { x: 288.129496402878, y: 3.92156862745098, size: 1 },
    //     { x: 289.424460431655, y: 3.88235294117647, size: 1 },
    //     { x: 292.014388489209, y: 4.03921568627451, size: 1 },
    //     { x: 297.194244604317, y: 4.07843137254902, size: 1 },
    //     { x: 301.726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 302.374100719424, y: 2.82352941176471, size: 1 },
    //     { x: 303.021582733813, y: 2.3921568627451, size: 1 },
    //     { x: 303.669064748201, y: 2.54901960784314, size: 1 },
    //     { x: 304.31654676259, y: 2.70588235294118, size: 1 },
    //     { x: 314.676258992806, y: 3.96078431372549, size: 1 },
    //     { x: 317.913669064748, y: 3.84313725490196, size: 1 },
    //     { x: 321.798561151079, y: 3.96078431372549, size: 1 },
    //     { x: 334.10071942446, y: 4, size: 1 },
    //     { x: 341.223021582734, y: 3.80392156862745, size: 1 },
    //     { x: 348.992805755396, y: 4.03921568627451, size: 1 },
    //     { x: 350.287769784173, y: 4.03921568627451, size: 1 },
    //     { x: 354.172661870504, y: 4.15686274509804, size: 1 },
    //     { x: 356.115107913669, y: 3.96078431372549, size: 1 },
    //     { x: 356.762589928058, y: 4, size: 1 },
    //     { x: 0, y: 3.92156862745098, size: 1 },
    //     { x: 2.58992805755396, y: 4.03921568627451, size: 1 },
    //     { x: 3.23741007194245, y: 4, size: 1 },
    //     { x: 9.06474820143885, y: 3.92156862745098, size: 1 },
    //     { x: 23.3093525179856, y: 3.96078431372549, size: 1 },
    //     { x: 24.6043165467626, y: 4, size: 1 },
    //     { x: 36.2589928057554, y: 4.11764705882353, size: 1 },
    //     { x: 37.5539568345324, y: 4.07843137254902, size: 1 },
    //     { x: 40.1438848920863, y: 3.88235294117647, size: 1 },
    //     { x: 41.4388489208633, y: 3.92156862745098, size: 1 },
    //     { x: 42.0863309352518, y: 3.88235294117647, size: 1 },
    //     { x: 46.6187050359712, y: 3.88235294117647, size: 1 },
    //     { x: 50.5035971223022, y: 3.01960784313725, size: 1 },
    //     { x: 52.4460431654676, y: 3.17647058823529, size: 1 },
    //     { x: 54.3884892086331, y: 4, size: 1 },
    //     { x: 78.3453237410072, y: 4, size: 1 },
    //     { x: 85.4676258992806, y: 4.07843137254902, size: 1 },
    //     { x: 86.7625899280576, y: 4.03921568627451, size: 1 },
    //     { x: 87.410071942446, y: 3.96078431372549, size: 1 },
    //     { x: 89.3525179856115, y: 4.07843137254902, size: 1 },
    //     { x: 131.438848920863, y: 3.88235294117647, size: 1 },
    //     { x: 134.676258992806, y: 4.07843137254902, size: 1 },
    //     { x: 146.330935251799, y: 4, size: 1 },
    //     { x: 152.805755395683, y: 4.11764705882353, size: 1 },
    //     { x: 159.280575539568, y: 2.94117647058824, size: 1 },
    //     { x: 159.928057553957, y: 2.86274509803922, size: 1 },
    //     { x: 200.071942446043, y: 3.84313725490196, size: 1 },
    //     { x: 204.604316546763, y: 3.96078431372549, size: 1 },
    //     { x: 207.841726618705, y: 3.92156862745098, size: 1 },
    //     { x: 218.848920863309, y: 3.92156862745098, size: 1 },
    //     { x: 224.676258992806, y: 2.7843137254902, size: 1 },
    //     { x: 225.323741007194, y: 2.7843137254902, size: 1 },
    //     { x: 244.748201438849, y: 2.94117647058824, size: 1 },
    //     { x: 266.115107913669, y: 2.90196078431373, size: 1 },
    //     { x: 275.179856115108, y: 3.96078431372549, size: 1 },
    //     { x: 309.496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 310.143884892086, y: 3.17647058823529, size: 1 },
    //     { x: 344.460431654676, y: 3.96078431372549, size: 1 },
    //     { x: 353.525179856115, y: 3.25490196078431, size: 1 },
    //     { x: 2.59459459459459, y: 3.76470588235294, size: 1 },
    //     { x: 3.89189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 4.54054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 11.027027027027, y: 3.52941176470588, size: 1 },
    //     { x: 14.9189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 15.5675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 16.2162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 18.8108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 20.7567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 23.3513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 25.2972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 25.9459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 28.5405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 30.4864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 32.4324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 41.5135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 42.1621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 43.4594594594595, y: 3.64705882352941, size: 1 },
    //     { x: 47.3513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 53.8378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 54.4864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 55.1351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 55.7837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 59.6756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 67.4594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 79.1351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 80.4324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 81.0810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 81.7297297297297, y: 3.41176470588235, size: 1 },
    //     { x: 83.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 84.3243243243243, y: 3.56862745098039, size: 1 },
    //     { x: 86.2702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 98.5945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 100.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 101.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 101.837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 103.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 103.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 107.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 109.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 118.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 118.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 123.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 123.891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 124.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 125.837837837838, y: 4.11764705882353, size: 1 },
    //     { x: 126.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 128.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 129.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 131.675675675676, y: 4, size: 1 },
    //     { x: 132.972972972973, y: 4.03921568627451, size: 1 },
    //     { x: 135.567567567568, y: 4.07843137254902, size: 1 },
    //     { x: 136.864864864865, y: 4.23529411764706, size: 1 },
    //     { x: 137.513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 138.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 140.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 140.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 141.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 144, y: 2.94117647058824, size: 1 },
    //     { x: 145.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 146.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 147.243243243243, y: 4.15686274509804, size: 1 },
    //     { x: 149.837837837838, y: 3.72549019607843, size: 1 },
    //     { x: 152.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 155.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 155.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 156.324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 156.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 157.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 158.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 160.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 160.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 162.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 168, y: 3.29411764705882, size: 1 },
    //     { x: 169.297297297297, y: 4, size: 1 },
    //     { x: 176.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 184.216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 186.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 187.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 188.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 188.756756756757, y: 3.01960784313725, size: 1 },
    //     { x: 189.405405405405, y: 3.09803921568627, size: 1 },
    //     { x: 190.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 195.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 199.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 209.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 214.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 216, y: 3.96078431372549, size: 1 },
    //     { x: 216.648648648649, y: 4, size: 1 },
    //     { x: 217.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 218.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 219.243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 219.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 220.540540540541, y: 4.03921568627451, size: 1 },
    //     { x: 221.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 223.135135135135, y: 4, size: 1 },
    //     { x: 223.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 227.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 236.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 238.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 240.648648648649, y: 4.07843137254902, size: 1 },
    //     { x: 241.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 242.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 243.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 247.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 249.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 254.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 255.567567567568, y: 3.76470588235294, size: 1 },
    //     { x: 266.594594594595, y: 3.68627450980392, size: 1 },
    //     { x: 273.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 274.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 277.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 279.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 281.513513513513, y: 3.64705882352941, size: 1 },
    //     { x: 285.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 294.486486486487, y: 3.2156862745098, size: 1 },
    //     { x: 295.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 295.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 296.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 297.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 300.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 302.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 306.162162162162, y: 3.56862745098039, size: 1 },
    //     { x: 306.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 317.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 323.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 330.162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 331.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 332.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 333.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 339.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 348.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 353.513513513513, y: 3.80392156862745, size: 1 },
    //     { x: 358.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 358.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 0.647482014388489, y: 2.94117647058824, size: 1 },
    //     { x: 1.29496402877698, y: 3.25490196078431, size: 1 },
    //     { x: 11.0071942446043, y: 4.07843137254902, size: 1 },
    //     { x: 21.3669064748201, y: 3.05882352941176, size: 1 },
    //     { x: 22.0143884892086, y: 2.86274509803922, size: 1 },
    //     { x: 22.6618705035971, y: 2.86274509803922, size: 1 },
    //     { x: 23.3093525179856, y: 2.94117647058824, size: 1 },
    //     { x: 23.9568345323741, y: 2.98039215686275, size: 1 },
    //     { x: 36.2589928057554, y: 3.92156862745098, size: 1 },
    //     { x: 43.3812949640288, y: 2.70588235294118, size: 1 },
    //     { x: 44.0287769784173, y: 2.86274509803922, size: 1 },
    //     { x: 44.6762589928058, y: 2.74509803921569, size: 1 },
    //     { x: 45.3237410071942, y: 2.70588235294118, size: 1 },
    //     { x: 46.6187050359712, y: 3.41176470588235, size: 1 },
    //     { x: 76.4028776978417, y: 3.92156862745098, size: 1 },
    //     { x: 77.0503597122302, y: 3.92156862745098, size: 1 },
    //     { x: 81.5827338129496, y: 3.84313725490196, size: 1 },
    //     { x: 128.848920863309, y: 3.2156862745098, size: 1 },
    //     { x: 131.438848920863, y: 3.05882352941176, size: 1 },
    //     { x: 137.26618705036, y: 3.92156862745098, size: 1 },
    //     { x: 145.68345323741, y: 3.96078431372549, size: 1 },
    //     { x: 152.158273381295, y: 3.2156862745098, size: 1 },
    //     { x: 205.251798561151, y: 3.25490196078431, size: 1 },
    //     { x: 213.021582733813, y: 3.33333333333333, size: 1 },
    //     { x: 238.920863309353, y: 2.50980392156863, size: 1 },
    //     { x: 239.568345323741, y: 2.82352941176471, size: 1 },
    //     { x: 242.805755395683, y: 3.92156862745098, size: 1 },
    //     { x: 258.992805755396, y: 3.05882352941176, size: 1 },
    //     { x: 260.287769784173, y: 3.13725490196078, size: 1 },
    //     { x: 260.935251798561, y: 3.25490196078431, size: 1 },
    //     { x: 269.352517985611, y: 3.25490196078431, size: 1 },
    //     { x: 275.827338129496, y: 3.2156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.13725490196078, size: 1 },
    //     { x: 304.31654676259, y: 3.84313725490196, size: 1 },
    //     { x: 347.05035971223, y: 3.45098039215686, size: 1 },
    //     { x: 7.12230215827338, y: 3.01960784313725, size: 1 },
    //     { x: 29.136690647482, y: 3.05882352941176, size: 1 },
    //     { x: 30.431654676259, y: 3.13725490196078, size: 1 },
    //     { x: 36.2589928057554, y: 3.29411764705882, size: 1 },
    //     { x: 41.4388489208633, y: 3.2156862745098, size: 1 },
    //     { x: 58.9208633093525, y: 4, size: 1 },
    //     { x: 70.5755395683453, y: 3.29411764705882, size: 1 },
    //     { x: 71.2230215827338, y: 3.25490196078431, size: 1 },
    //     { x: 71.8705035971223, y: 2.74509803921569, size: 1 },
    //     { x: 72.5179856115108, y: 2.43137254901961, size: 1 },
    //     { x: 93.2374100719424, y: 2.62745098039216, size: 1 },
    //     { x: 93.8848920863309, y: 2.27450980392157, size: 1 },
    //     { x: 130.143884892086, y: 3.92156862745098, size: 1 },
    //     { x: 136.618705035971, y: 2.3921568627451, size: 1 },
    //     { x: 137.26618705036, y: 2.27450980392157, size: 1 },
    //     { x: 157.338129496403, y: 3.09803921568627, size: 1 },
    //     { x: 157.985611510791, y: 2.11764705882353, size: 1 },
    //     { x: 158.63309352518, y: 2.23529411764706, size: 1 },
    //     { x: 217.553956834532, y: 3.13725490196078, size: 1 },
    //     { x: 225.971223021583, y: 3.84313725490196, size: 1 },
    //     { x: 238.920863309353, y: 4.07843137254902, size: 1 },
    //     { x: 258.345323741007, y: 4, size: 1 },
    //     { x: 265.467625899281, y: 3.33333333333333, size: 1 },
    //     { x: 266.115107913669, y: 3.29411764705882, size: 1 },
    //     { x: 287.482014388489, y: 2.19607843137255, size: 1 },
    //     { x: 288.129496402878, y: 1.92156862745098, size: 1 },
    //     { x: 292.014388489209, y: 3.92156862745098, size: 1 },
    //     { x: 308.201438848921, y: 3.17647058823529, size: 1 },
    //     { x: 309.496402877698, y: 2.90196078431373, size: 1 },
    //     { x: 334.10071942446, y: 3.25490196078431, size: 1 },
    //     { x: 336.690647482014, y: 3.2156862745098, size: 1 },
    //     { x: 339.280575539568, y: 3.37254901960784, size: 1 },
    //     { x: 350.287769784173, y: 3.25490196078431, size: 1 },
    //     { x: 352.230215827338, y: 3.09803921568627, size: 1 },
    //     { x: 14.8920863309353, y: 3.88235294117647, size: 1 },
    //     { x: 35.6115107913669, y: 3.09803921568627, size: 1 },
    //     { x: 38.8489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 52.4460431654676, y: 3.96078431372549, size: 1 },
    //     { x: 58.273381294964, y: 3.09803921568627, size: 1 },
    //     { x: 58.9208633093525, y: 2.98039215686275, size: 1 },
    //     { x: 72.5179856115108, y: 3.92156862745098, size: 1 },
    //     { x: 78.3453237410072, y: 3.2156862745098, size: 1 },
    //     { x: 78.9928057553957, y: 2.98039215686275, size: 1 },
    //     { x: 90.6474820143885, y: 3.88235294117647, size: 1 },
    //     { x: 91.9424460431655, y: 4, size: 1 },
    //     { x: 100.359712230216, y: 3.25490196078431, size: 1 },
    //     { x: 121.079136690647, y: 3.29411764705882, size: 1 },
    //     { x: 123.021582733813, y: 2.98039215686275, size: 1 },
    //     { x: 123.669064748201, y: 2.98039215686275, size: 1 },
    //     { x: 124.31654676259, y: 3.05882352941176, size: 1 },
    //     { x: 128.848920863309, y: 3.25490196078431, size: 1 },
    //     { x: 176.762589928058, y: 3.84313725490196, size: 1 },
    //     { x: 186.474820143885, y: 2.7843137254902, size: 1 },
    //     { x: 187.122302158273, y: 2.82352941176471, size: 1 },
    //     { x: 187.769784172662, y: 2.86274509803922, size: 1 },
    //     { x: 207.194244604317, y: 3.2156862745098, size: 1 },
    //     { x: 211.726618705036, y: 3.09803921568627, size: 1 },
    //     { x: 222.086330935252, y: 3.09803921568627, size: 1 },
    //     { x: 231.798561151079, y: 3.96078431372549, size: 1 },
    //     { x: 236.978417266187, y: 4, size: 1 },
    //     { x: 258.345323741007, y: 3.88235294117647, size: 1 },
    //     { x: 279.064748201439, y: 4.07843137254902, size: 1 },
    //     { x: 293.956834532374, y: 3.29411764705882, size: 1 },
    //     { x: 294.604316546763, y: 3.17647058823529, size: 1 },
    //     { x: 315.971223021583, y: 3.29411764705882, size: 1 },
    //     { x: 323.093525179856, y: 3.17647058823529, size: 1 },
    //     { x: 325.035971223022, y: 3.25490196078431, size: 1 },
    //     { x: 328.273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 330.215827338129, y: 3.33333333333333, size: 1 },
    //     { x: 334.10071942446, y: 3.2156862745098, size: 1 },
    //     { x: 335.395683453237, y: 3.25490196078431, size: 1 },
    //     { x: 358.705035971223, y: 3.29411764705882, size: 1 },
    //     { x: 359.352517985611, y: 2.98039215686275, size: 1 },
    //     { x: 0, y: 2.90196078431373, size: 1 },
    //     { x: 42.7338129496403, y: 2.90196078431373, size: 1 },
    //     { x: 44.0287769784173, y: 3.05882352941176, size: 1 },
    //     { x: 44.6762589928058, y: 2.94117647058824, size: 1 },
    //     { x: 56.9784172661871, y: 3.96078431372549, size: 1 },
    //     { x: 85.4676258992806, y: 2.98039215686275, size: 1 },
    //     { x: 86.1151079136691, y: 2.90196078431373, size: 1 },
    //     { x: 86.7625899280576, y: 3.13725490196078, size: 1 },
    //     { x: 87.410071942446, y: 3.09803921568627, size: 1 },
    //     { x: 88.0575539568345, y: 3.09803921568627, size: 1 },
    //     { x: 101.007194244604, y: 3.92156862745098, size: 1 },
    //     { x: 107.482014388489, y: 2.7843137254902, size: 1 },
    //     { x: 108.129496402878, y: 2.98039215686275, size: 1 },
    //     { x: 108.776978417266, y: 3.13725490196078, size: 1 },
    //     { x: 123.021582733813, y: 4.03921568627451, size: 1 },
    //     { x: 128.848920863309, y: 2.82352941176471, size: 1 },
    //     { x: 163.165467625899, y: 3.33333333333333, size: 1 },
    //     { x: 171.58273381295, y: 3.29411764705882, size: 1 },
    //     { x: 172.230215827338, y: 2.90196078431373, size: 1 },
    //     { x: 172.877697841727, y: 2.70588235294118, size: 1 },
    //     { x: 173.525179856115, y: 2.82352941176471, size: 1 },
    //     { x: 174.172661870504, y: 2.47058823529412, size: 1 },
    //     { x: 193.597122302158, y: 2.74509803921569, size: 1 },
    //     { x: 194.244604316547, y: 3.33333333333333, size: 1 },
    //     { x: 194.892086330935, y: 3.25490196078431, size: 1 },
    //     { x: 199.424460431655, y: 3.96078431372549, size: 1 },
    //     { x: 200.719424460432, y: 4.07843137254902, size: 1 },
    //     { x: 202.661870503597, y: 4.07843137254902, size: 1 },
    //     { x: 203.309352517986, y: 4.03921568627451, size: 1 },
    //     { x: 204.604316546763, y: 3.88235294117647, size: 1 },
    //     { x: 205.251798561151, y: 4.03921568627451, size: 1 },
    //     { x: 207.194244604317, y: 4.07843137254902, size: 1 },
    //     { x: 207.841726618705, y: 4.27450980392157, size: 1 },
    //     { x: 211.726618705036, y: 4.07843137254902, size: 1 },
    //     { x: 213.021582733813, y: 4.07843137254902, size: 1 },
    //     { x: 214.964028776978, y: 2.90196078431373, size: 1 },
    //     { x: 215.611510791367, y: 2.70588235294118, size: 1 },
    //     { x: 239.568345323741, y: 4.07843137254902, size: 1 },
    //     { x: 246.690647482014, y: 3.92156862745098, size: 1 },
    //     { x: 253.165467625899, y: 3.88235294117647, size: 1 },
    //     { x: 264.820143884892, y: 4.11764705882353, size: 1 },
    //     { x: 288.776978417266, y: 4.03921568627451, size: 1 },
    //     { x: 310.791366906475, y: 4.03921568627451, size: 1 },
    //     { x: 341.870503597122, y: 3.41176470588235, size: 1 },
    //     { x: 3.24324324324324, y: 3.52941176470588, size: 1 },
    //     { x: 4.54054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 6.48648648648649, y: 2.70588235294118, size: 1 },
    //     { x: 7.13513513513514, y: 2.90196078431373, size: 1 },
    //     { x: 7.78378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 8.43243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 11.027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 27.2432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 29.8378378378378, y: 2.94117647058824, size: 1 },
    //     { x: 31.7837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 33.7297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 36.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 40.2162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 46.0540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 49.2972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 49.9459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 51.2432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 51.8918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 53.1891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 57.0810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 58.3783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 60.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 70.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 70.7027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 71.3513513513514, y: 2.86274509803922, size: 1 },
    //     { x: 72, y: 2.70588235294118, size: 1 },
    //     { x: 72.6486486486486, y: 2.62745098039216, size: 1 },
    //     { x: 73.2972972972973, y: 2.74509803921569, size: 1 },
    //     { x: 91.4594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 92.1081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 92.7567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 93.4054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 94.054054054054, y: 2.35294117647059, size: 1 },
    //     { x: 94.7027027027027, y: 2.3921568627451, size: 1 },
    //     { x: 100.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 103.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 109.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 114.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 116.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 118.054054054054, y: 3.6078431372549, size: 1 },
    //     { x: 131.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 134.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 136.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 137.513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 138.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 144, y: 3.84313725490196, size: 1 },
    //     { x: 147.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 151.135135135135, y: 4, size: 1 },
    //     { x: 151.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 152.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 158.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 160.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 162.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 162.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 163.459459459459, y: 4, size: 1 },
    //     { x: 164.756756756757, y: 4.07843137254902, size: 1 },
    //     { x: 166.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 168.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 173.189189189189, y: 4.03921568627451, size: 1 },
    //     { x: 175.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 176.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 177.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 179.027027027027, y: 2.47058823529412, size: 1 },
    //     { x: 179.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 180.324324324324, y: 2.90196078431373, size: 1 },
    //     { x: 180.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 193.945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 197.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 199.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 200.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 201.081081081081, y: 2.70588235294118, size: 1 },
    //     { x: 201.72972972973, y: 2.66666666666667, size: 1 },
    //     { x: 202.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 203.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 203.675675675676, y: 3.76470588235294, size: 1 },
    //     { x: 209.513513513514, y: 3.49019607843137, size: 1 },
    //     { x: 215.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 216, y: 3.72549019607843, size: 1 },
    //     { x: 218.594594594595, y: 3.76470588235294, size: 1 },
    //     { x: 219.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 219.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 227.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 230.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 238.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 243.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 244.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 245.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 251.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 252.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 282.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 285.405405405405, y: 3.68627450980392, size: 1 },
    //     { x: 286.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 286.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 289.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 295.135135135135, y: 4, size: 1 },
    //     { x: 296.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 297.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 299.675675675676, y: 3.64705882352941, size: 1 },
    //     { x: 304.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 304.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 308.756756756757, y: 2.66666666666667, size: 1 },
    //     { x: 309.405405405405, y: 2.58823529411765, size: 1 },
    //     { x: 310.054054054054, y: 2.86274509803922, size: 1 },
    //     { x: 310.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 311.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 312.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 320.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 321.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 325.621621621622, y: 3.49019607843137, size: 1 },
    //     { x: 326.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 328.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 329.513513513513, y: 3.37254901960784, size: 1 },
    //     { x: 331.459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 332.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 332.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 334.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 336.648648648649, y: 3.49019607843137, size: 1 },
    //     { x: 337.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 337.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 341.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 342.486486486487, y: 3.37254901960784, size: 1 },
    //     { x: 345.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 348.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 352.864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 354.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 356.108108108108, y: 3.56862745098039, size: 1 },
    //     { x: 47.9136690647482, y: 3.84313725490196, size: 1 },
    //     { x: 56.9784172661871, y: 2.94117647058824, size: 1 },
    //     { x: 57.6258992805755, y: 3.05882352941176, size: 1 },
    //     { x: 73.8129496402878, y: 4.03921568627451, size: 1 },
    //     { x: 80.9352517985612, y: 3.80392156862745, size: 1 },
    //     { x: 110.719424460432, y: 4, size: 1 },
    //     { x: 143.093525179856, y: 3.13725490196078, size: 1 },
    //     { x: 163.812949640288, y: 3.13725490196078, size: 1 },
    //     { x: 164.460431654676, y: 3.17647058823529, size: 1 },
    //     { x: 165.107913669065, y: 2.7843137254902, size: 1 },
    //     { x: 165.755395683453, y: 2.90196078431373, size: 1 },
    //     { x: 166.402877697842, y: 2.82352941176471, size: 1 },
    //     { x: 167.05035971223, y: 2.54901960784314, size: 1 },
    //     { x: 195.539568345324, y: 4.03921568627451, size: 1 },
    //     { x: 199.424460431655, y: 4, size: 1 },
    //     { x: 211.726618705036, y: 4.27450980392157, size: 1 },
    //     { x: 213.021582733813, y: 3.92156862745098, size: 1 },
    //     { x: 214.31654676259, y: 3.96078431372549, size: 1 },
    //     { x: 221.438848920863, y: 4.07843137254902, size: 1 },
    //     { x: 223.381294964029, y: 4.03921568627451, size: 1 },
    //     { x: 226.618705035971, y: 3.96078431372549, size: 1 },
    //     { x: 257.697841726619, y: 3.96078431372549, size: 1 },
    //     { x: 279.064748201439, y: 3.88235294117647, size: 1 },
    //     { x: 326.330935251799, y: 4, size: 1 },
    //     { x: 350.935251798561, y: 3.92156862745098, size: 1 },
    //     { x: 358.705035971223, y: 2.82352941176471, size: 1 },
    //     { x: 359.352517985611, y: 1.33333333333333, size: 1 },
    //     { x: 0, y: 1.13725490196078, size: 1 },
    //     { x: 0.647482014388489, y: 1.25490196078431, size: 1 },
    //     { x: 1.29496402877698, y: 1.25490196078431, size: 1 },
    //     { x: 8.41726618705036, y: 3.05882352941176, size: 1 },
    //     { x: 9.06474820143885, y: 3.13725490196078, size: 1 },
    //     { x: 14.2446043165468, y: 3.25490196078431, size: 1 },
    //     { x: 14.8920863309353, y: 2.86274509803922, size: 1 },
    //     { x: 16.1870503597122, y: 3.17647058823529, size: 1 },
    //     { x: 19.4244604316547, y: 3.17647058823529, size: 1 },
    //     { x: 20.7194244604317, y: 1.88235294117647, size: 1 },
    //     { x: 21.3669064748201, y: 2.11764705882353, size: 1 },
    //     { x: 43.3812949640288, y: 3.92156862745098, size: 1 },
    //     { x: 45.9712230215827, y: 4, size: 1 },
    //     { x: 52.4460431654676, y: 4, size: 1 },
    //     { x: 58.273381294964, y: 4, size: 1 },
    //     { x: 64.1007194244604, y: 2.15686274509804, size: 1 },
    //     { x: 84.8201438848921, y: 3.17647058823529, size: 1 },
    //     { x: 85.4676258992806, y: 2.15686274509804, size: 1 },
    //     { x: 86.1151079136691, y: 2, size: 1 },
    //     { x: 106.834532374101, y: 2.82352941176471, size: 1 },
    //     { x: 107.482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 119.784172661871, y: 4, size: 1 },
    //     { x: 178.057553956835, y: 4.27450980392157, size: 1 },
    //     { x: 264.172661870504, y: 3.88235294117647, size: 1 },
    //     { x: 271.294964028777, y: 3.84313725490196, size: 1 },
    //     { x: 284.244604316547, y: 4.11764705882353, size: 1 },
    //     { x: 303.021582733813, y: 2.62745098039216, size: 1 },
    //     { x: 304.31654676259, y: 2.43137254901961, size: 1 },
    //     { x: 306.258992805755, y: 3.17647058823529, size: 1 },
    //     { x: 306.906474820144, y: 3.05882352941176, size: 1 },
    //     { x: 307.553956834532, y: 2.90196078431373, size: 1 },
    //     { x: 308.201438848921, y: 2.62745098039216, size: 1 },
    //     { x: 308.848920863309, y: 2.66666666666667, size: 1 },
    //     { x: 309.496402877698, y: 2.62745098039216, size: 1 },
    //     { x: 310.791366906475, y: 3.05882352941176, size: 1 },
    //     { x: 312.086330935252, y: 2.50980392156863, size: 1 },
    //     { x: 312.73381294964, y: 2.74509803921569, size: 1 },
    //     { x: 313.381294964029, y: 2.50980392156863, size: 1 },
    //     { x: 314.676258992806, y: 2.50980392156863, size: 1 },
    //     { x: 315.323741007194, y: 2.62745098039216, size: 1 },
    //     { x: 315.971223021583, y: 2.43137254901961, size: 1 },
    //     { x: 316.618705035971, y: 2.98039215686275, size: 1 },
    //     { x: 317.26618705036, y: 3.25490196078431, size: 1 },
    //     { x: 317.913669064748, y: 3.17647058823529, size: 1 },
    //     { x: 318.561151079137, y: 2.66666666666667, size: 1 },
    //     { x: 319.208633093525, y: 2.74509803921569, size: 1 },
    //     { x: 319.856115107914, y: 2.50980392156863, size: 1 },
    //     { x: 320.503597122302, y: 2.62745098039216, size: 1 },
    //     { x: 321.151079136691, y: 3.88235294117647, size: 1 },
    //     { x: 345.755395683453, y: 2.82352941176471, size: 1 },
    //     { x: 354.172661870504, y: 4.11764705882353, size: 1 },
    //     { x: 358.705035971223, y: 3.96078431372549, size: 1 },
    //     { x: 1.94594594594595, y: 3.52941176470588, size: 1 },
    //     { x: 2.59459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 3.24324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 7.78378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 9.72972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 11.027027027027, y: 4, size: 1 },
    //     { x: 12.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 15.5675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 16.8648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 19.4594594594595, y: 4, size: 1 },
    //     { x: 21.4054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 25.2972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 27.8918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 28.5405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 29.1891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 29.8378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 32.4324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 45.4054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 50.5945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 55.1351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 58.3783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 63.5675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 66.1621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 70.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 70.7027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 71.3513513513514, y: 3.01960784313725, size: 1 },
    //     { x: 72, y: 3.01960784313725, size: 1 },
    //     { x: 72.6486486486486, y: 2.94117647058824, size: 1 },
    //     { x: 83.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 93.4054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 105.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 106.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 110.27027027027, y: 3.76470588235294, size: 1 },
    //     { x: 114.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 114.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 116.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 120, y: 3.80392156862745, size: 1 },
    //     { x: 127.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 135.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 137.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 142.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 147.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 147.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 148.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 151.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 153.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 153.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 154.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 156.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 178.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 179.027027027027, y: 3.56862745098039, size: 1 },
    //     { x: 179.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 181.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 184.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 195.891891891892, y: 3.76470588235294, size: 1 },
    //     { x: 199.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 201.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 217.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 220.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 224.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 228.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 231.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 236.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 243.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 244.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 249.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 255.567567567568, y: 4.11764705882353, size: 1 },
    //     { x: 257.513513513513, y: 4, size: 1 },
    //     { x: 261.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 267.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 267.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 271.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 282.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 284.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 286.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 287.351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 288, y: 3.29411764705882, size: 1 },
    //     { x: 291.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 297.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 300.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 305.513513513513, y: 3.29411764705882, size: 1 },
    //     { x: 309.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 312, y: 3.96078431372549, size: 1 },
    //     { x: 322.378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 323.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 330.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 332.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 332.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 339.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 346.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 350.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 352.216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 352.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 353.513513513513, y: 3.13725490196078, size: 1 },
    //     { x: 354.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 355.459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 356.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 359.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 14.8920863309353, y: 3.01960784313725, size: 1 },
    //     { x: 16.1870503597122, y: 3.25490196078431, size: 1 },
    //     { x: 16.8345323741007, y: 3.29411764705882, size: 1 },
    //     { x: 20.0719424460432, y: 3.17647058823529, size: 1 },
    //     { x: 35.6115107913669, y: 3.17647058823529, size: 1 },
    //     { x: 36.2589928057554, y: 3.25490196078431, size: 1 },
    //     { x: 36.9064748201439, y: 2.74509803921569, size: 1 },
    //     { x: 37.5539568345324, y: 3.09803921568627, size: 1 },
    //     { x: 58.9208633093525, y: 3.09803921568627, size: 1 },
    //     { x: 68.6330935251799, y: 3.80392156862745, size: 1 },
    //     { x: 122.374100719424, y: 3.17647058823529, size: 1 },
    //     { x: 124.964028776978, y: 3.25490196078431, size: 1 },
    //     { x: 134.028776978417, y: 3.09803921568627, size: 1 },
    //     { x: 138.561151079137, y: 3.05882352941176, size: 1 },
    //     { x: 143.741007194245, y: 3.25490196078431, size: 1 },
    //     { x: 164.460431654676, y: 2.98039215686275, size: 1 },
    //     { x: 165.107913669065, y: 3.09803921568627, size: 1 },
    //     { x: 167.697841726619, y: 4, size: 1 },
    //     { x: 168.345323741007, y: 4, size: 1 },
    //     { x: 178.705035971223, y: 3.96078431372549, size: 1 },
    //     { x: 183.237410071942, y: 4, size: 1 },
    //     { x: 189.712230215827, y: 3.41176470588235, size: 1 },
    //     { x: 191.654676258993, y: 3.33333333333333, size: 1 },
    //     { x: 231.151079136691, y: 3.17647058823529, size: 1 },
    //     { x: 246.690647482014, y: 3.96078431372549, size: 1 },
    //     { x: 249.928057553957, y: 3.41176470588235, size: 1 },
    //     { x: 251.223021582734, y: 3.01960784313725, size: 1 },
    //     { x: 251.870503597122, y: 2.98039215686275, size: 1 },
    //     { x: 294.604316546763, y: 3.05882352941176, size: 1 },
    //     { x: 295.251798561151, y: 3.17647058823529, size: 1 },
    //     { x: 310.143884892086, y: 3.88235294117647, size: 1 },
    //     { x: 334.748201438849, y: 3.29411764705882, size: 1 },
    //     { x: 337.338129496403, y: 3.09803921568627, size: 1 },
    //     { x: 337.985611510791, y: 2.7843137254902, size: 1 },
    //     { x: 338.63309352518, y: 2.86274509803922, size: 1 },
    //     { x: 339.280575539568, y: 3.01960784313725, size: 1 },
    //     { x: 339.928057553957, y: 2.98039215686275, size: 1 },
    //     { x: 354.172661870504, y: 3.29411764705882, size: 1 },
    //     { x: 356.762589928058, y: 3.17647058823529, size: 1 },
    //     { x: 358.705035971223, y: 3.2156862745098, size: 1 },
    //     { x: 359.352517985611, y: 3.29411764705882, size: 1 },
    //     { x: 22.6618705035971, y: 3.96078431372549, size: 1 },
    //     { x: 29.136690647482, y: 3.88235294117647, size: 1 },
    //     { x: 42.7338129496403, y: 3.25490196078431, size: 1 },
    //     { x: 51.7985611510791, y: 3.92156862745098, size: 1 },
    //     { x: 62.8057553956835, y: 4.03921568627451, size: 1 },
    //     { x: 93.2374100719424, y: 3.13725490196078, size: 1 },
    //     { x: 99.7122302158273, y: 3.13725490196078, size: 1 },
    //     { x: 108.129496402878, y: 2.70588235294118, size: 1 },
    //     { x: 108.776978417266, y: 2.62745098039216, size: 1 },
    //     { x: 157.985611510791, y: 3.29411764705882, size: 1 },
    //     { x: 184.532374100719, y: 3.25490196078431, size: 1 },
    //     { x: 202.661870503597, y: 3.92156862745098, size: 1 },
    //     { x: 209.136690647482, y: 4.07843137254902, size: 1 },
    //     { x: 210.431654676259, y: 3.92156862745098, size: 1 },
    //     { x: 218.848920863309, y: 3.88235294117647, size: 1 },
    //     { x: 257.697841726619, y: 3.05882352941176, size: 1 },
    //     { x: 259.640287769784, y: 2.98039215686275, size: 1 },
    //     { x: 301.079136690647, y: 3.05882352941176, size: 1 },
    //     { x: 302.374100719424, y: 3.2156862745098, size: 1 },
    //     { x: 303.021582733813, y: 3.25490196078431, size: 1 },
    //     { x: 345.107913669065, y: 3.29411764705882, size: 1 },
    //     { x: 345.755395683453, y: 2.54901960784314, size: 1 },
    //     { x: 346.402877697842, y: 2.58823529411765, size: 1 },
    //     { x: 352.877697841727, y: 3.2156862745098, size: 1 },
    //     { x: 354.820143884892, y: 3.17647058823529, size: 1 },
    //     { x: 356.115107913669, y: 3.33333333333333, size: 1 },
    //     { x: 1.29496402877698, y: 3.09803921568627, size: 1 },
    //     { x: 3.23741007194245, y: 3.17647058823529, size: 1 },
    //     { x: 7.76978417266187, y: 2.86274509803922, size: 1 },
    //     { x: 38.2014388489209, y: 3.33333333333333, size: 1 },
    //     { x: 59.568345323741, y: 3.25490196078431, size: 1 },
    //     { x: 70.5755395683453, y: 2.86274509803922, size: 1 },
    //     { x: 71.2230215827338, y: 2.66666666666667, size: 1 },
    //     { x: 72.5179856115108, y: 2.62745098039216, size: 1 },
    //     { x: 93.8848920863309, y: 2.86274509803922, size: 1 },
    //     { x: 94.5323741007194, y: 3.17647058823529, size: 1 },
    //     { x: 108.129496402878, y: 3.84313725490196, size: 1 },
    //     { x: 117.841726618705, y: 4.15686274509804, size: 1 },
    //     { x: 128.201438848921, y: 3.88235294117647, size: 1 },
    //     { x: 134.028776978417, y: 3.88235294117647, size: 1 },
    //     { x: 134.676258992806, y: 3.88235294117647, size: 1 },
    //     { x: 135.971223021583, y: 3.33333333333333, size: 1 },
    //     { x: 148.273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 154.10071942446, y: 3.2156862745098, size: 1 },
    //     { x: 170.287769784173, y: 3.25490196078431, size: 1 },
    //     { x: 199.424460431655, y: 3.17647058823529, size: 1 },
    //     { x: 202.014388489209, y: 2.98039215686275, size: 1 },
    //     { x: 205.251798561151, y: 3.88235294117647, size: 1 },
    //     { x: 223.381294964029, y: 3.13725490196078, size: 1 },
    //     { x: 241.510791366906, y: 3.25490196078431, size: 1 },
    //     { x: 243.453237410072, y: 3.09803921568627, size: 1 },
    //     { x: 244.10071942446, y: 2.98039215686275, size: 1 },
    //     { x: 253.812949640288, y: 3.88235294117647, size: 1 },
    //     { x: 256.402877697842, y: 3.88235294117647, size: 1 },
    //     { x: 286.187050359712, y: 2.82352941176471, size: 1 },
    //     { x: 286.834532374101, y: 2.90196078431373, size: 1 },
    //     { x: 287.482014388489, y: 2.74509803921569, size: 1 },
    //     { x: 288.129496402878, y: 2.7843137254902, size: 1 },
    //     { x: 308.848920863309, y: 2.58823529411765, size: 1 },
    //     { x: 310.143884892086, y: 2.66666666666667, size: 1 },
    //     { x: 329.568345323741, y: 3.2156862745098, size: 1 },
    //     { x: 330.215827338129, y: 2.90196078431373, size: 1 },
    //     { x: 350.287769784173, y: 3.33333333333333, size: 1 },
    //     { x: 350.935251798561, y: 2.43137254901961, size: 1 },
    //     { x: 351.58273381295, y: 1.84313725490196, size: 1 },
    //     { x: 10.3783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 11.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 11.6756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 12.3243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 12.972972972973, y: 1.92156862745098, size: 1 },
    //     { x: 20.7567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 22.7027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 27.2432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 27.8918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 31.1351351351351, y: 4, size: 1 },
    //     { x: 34.3783783783784, y: 2.3921568627451, size: 1 },
    //     { x: 35.027027027027, y: 2.54901960784314, size: 1 },
    //     { x: 35.6756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 48.6486486486486, y: 3.49019607843137, size: 1 },
    //     { x: 49.9459459459459, y: 3.68627450980392, size: 1 },
    //     { x: 55.7837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 58.3783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 62.2702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 65.5135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 67.4594594594595, y: 3.6078431372549, size: 1 },
    //     { x: 68.7567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 73.2972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 76.5405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 89.5135135135135, y: 3.56862745098039, size: 1 },
    //     { x: 105.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 108.972972972973, y: 4, size: 1 },
    //     { x: 109.621621621622, y: 4.15686274509804, size: 1 },
    //     { x: 110.918918918919, y: 4.19607843137255, size: 1 },
    //     { x: 112.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 115.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 117.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 118.054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 119.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 127.135135135135, y: 3.72549019607843, size: 1 },
    //     { x: 132.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 138.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 140.756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 146.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 149.837837837838, y: 3.49019607843137, size: 1 },
    //     { x: 156.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 162.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 162.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 163.459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 164.108108108108, y: 2.27450980392157, size: 1 },
    //     { x: 164.756756756757, y: 2.47058823529412, size: 1 },
    //     { x: 165.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 169.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 173.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 175.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 179.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 184.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 186.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 193.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 195.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 200.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 202.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 206.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 214.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 216, y: 3.84313725490196, size: 1 },
    //     { x: 218.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 223.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 223.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 227.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 234.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 252.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 265.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 270.486486486487, y: 3.84313725490196, size: 1 },
    //     { x: 275.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 293.837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 294.486486486487, y: 3.01960784313725, size: 1 },
    //     { x: 295.783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 309.405405405405, y: 3.52941176470588, size: 1 },
    //     { x: 312.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 313.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 314.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 315.243243243243, y: 2.82352941176471, size: 1 },
    //     { x: 315.891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 316.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 318.486486486487, y: 3.76470588235294, size: 1 },
    //     { x: 325.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 330.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 335.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 336.648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 337.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 337.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 338.594594594595, y: 2.7843137254902, size: 1 },
    //     { x: 339.243243243243, y: 2.7843137254902, size: 1 },
    //     { x: 348.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 352.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 354.162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 358.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 358.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 359.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 20.0719424460432, y: 3.25490196078431, size: 1 },
    //     { x: 43.3812949640288, y: 4, size: 1 },
    //     { x: 63.4532374100719, y: 2.98039215686275, size: 1 },
    //     { x: 67.9856115107914, y: 4, size: 1 },
    //     { x: 91.9424460431655, y: 3.84313725490196, size: 1 },
    //     { x: 92.589928057554, y: 3.92156862745098, size: 1 },
    //     { x: 109.424460431655, y: 3.17647058823529, size: 1 },
    //     { x: 112.661870503597, y: 3.09803921568627, size: 1 },
    //     { x: 114.604316546763, y: 3.29411764705882, size: 1 },
    //     { x: 124.964028776978, y: 3.09803921568627, size: 1 },
    //     { x: 132.086330935252, y: 3.88235294117647, size: 1 },
    //     { x: 174.820143884892, y: 3.25490196078431, size: 1 },
    //     { x: 175.467625899281, y: 3.33333333333333, size: 1 },
    //     { x: 177.410071942446, y: 3.29411764705882, size: 1 },
    //     { x: 180, y: 3.13725490196078, size: 1 },
    //     { x: 188.41726618705, y: 3.25490196078431, size: 1 },
    //     { x: 190.359712230216, y: 3.25490196078431, size: 1 },
    //     { x: 214.964028776978, y: 3.01960784313725, size: 1 },
    //     { x: 235.68345323741, y: 3.09803921568627, size: 1 },
    //     { x: 236.978417266187, y: 2.90196078431373, size: 1 },
    //     { x: 237.625899280576, y: 2.82352941176471, size: 1 },
    //     { x: 238.273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 267.410071942446, y: 4.03921568627451, size: 1 },
    //     { x: 282.302158273381, y: 3.25490196078431, size: 1 },
    //     { x: 282.94964028777, y: 3.33333333333333, size: 1 },
    //     { x: 286.834532374101, y: 3.25490196078431, size: 1 },
    //     { x: 297.841726618705, y: 3.09803921568627, size: 1 },
    //     { x: 321.798561151079, y: 2.98039215686275, size: 1 },
    //     { x: 322.446043165468, y: 2.70588235294118, size: 1 },
    //     { x: 323.093525179856, y: 2.90196078431373, size: 1 },
    //     { x: 323.741007194245, y: 3.01960784313725, size: 1 },
    //     { x: 324.388489208633, y: 3.09803921568627, size: 1 },
    //     { x: 333.453237410072, y: 3.2156862745098, size: 1 },
    //     { x: 336.043165467626, y: 3.2156862745098, size: 1 },
    //     { x: 24.6043165467626, y: 3.41176470588235, size: 1 },
    //     { x: 27.841726618705, y: 2.7843137254902, size: 1 },
    //     { x: 28.4892086330935, y: 3.05882352941176, size: 1 },
    //     { x: 29.136690647482, y: 2.90196078431373, size: 1 },
    //     { x: 84.1726618705036, y: 4, size: 1 },
    //     { x: 92.589928057554, y: 3.01960784313725, size: 1 },
    //     { x: 93.2374100719424, y: 2.98039215686275, size: 1 },
    //     { x: 93.8848920863309, y: 3.2156862745098, size: 1 },
    //     { x: 101.654676258993, y: 4, size: 1 },
    //     { x: 113.309352517986, y: 2.94117647058824, size: 1 },
    //     { x: 113.956834532374, y: 2.82352941176471, size: 1 },
    //     { x: 114.604316546763, y: 2.74509803921569, size: 1 },
    //     { x: 115.251798561151, y: 2.90196078431373, size: 1 },
    //     { x: 125.611510791367, y: 3.96078431372549, size: 1 },
    //     { x: 137.913669064748, y: 3.92156862745098, size: 1 },
    //     { x: 145.68345323741, y: 4.15686274509804, size: 1 },
    //     { x: 149.568345323741, y: 4, size: 1 },
    //     { x: 154.10071942446, y: 3.92156862745098, size: 1 },
    //     { x: 178.057553956835, y: 3.17647058823529, size: 1 },
    //     { x: 183.237410071942, y: 4.03921568627451, size: 1 },
    //     { x: 184.532374100719, y: 4, size: 1 },
    //     { x: 185.827338129496, y: 4.11764705882353, size: 1 },
    //     { x: 186.474820143885, y: 3.92156862745098, size: 1 },
    //     { x: 189.064748201439, y: 4.19607843137255, size: 1 },
    //     { x: 190.359712230216, y: 3.92156862745098, size: 1 },
    //     { x: 191.007194244604, y: 4, size: 1 },
    //     { x: 191.654676258993, y: 4.03921568627451, size: 1 },
    //     { x: 193.597122302158, y: 3.88235294117647, size: 1 },
    //     { x: 200.071942446043, y: 3.17647058823529, size: 1 },
    //     { x: 225.323741007194, y: 3.88235294117647, size: 1 },
    //     { x: 232.446043165468, y: 4, size: 1 },
    //     { x: 246.690647482014, y: 3.88235294117647, size: 1 },
    //     { x: 273.884892086331, y: 3.96078431372549, size: 1 },
    //     { x: 277.769784172662, y: 3.96078431372549, size: 1 },
    //     { x: 281.654676258993, y: 3.88235294117647, size: 1 },
    //     { x: 303.669064748201, y: 3.96078431372549, size: 1 },
    //     { x: 307.553956834532, y: 3.13725490196078, size: 1 },
    //     { x: 311.438848920863, y: 4.07843137254902, size: 1 },
    //     { x: 335.395683453237, y: 3.84313725490196, size: 1 },
    //     { x: 348.992805755396, y: 3.96078431372549, size: 1 },
    //     { x: 12.3021582733813, y: 2.98039215686275, size: 1 },
    //     { x: 14.2446043165468, y: 3.2156862745098, size: 1 },
    //     { x: 24.6043165467626, y: 3.88235294117647, size: 1 },
    //     { x: 34.9640287769784, y: 3.33333333333333, size: 1 },
    //     { x: 36.2589928057554, y: 3.37254901960784, size: 1 },
    //     { x: 47.2661870503597, y: 3.45098039215686, size: 1 },
    //     { x: 49.2086330935252, y: 3.84313725490196, size: 1 },
    //     { x: 53.0935251798561, y: 3.37254901960784, size: 1 },
    //     { x: 63.4532374100719, y: 3.33333333333333, size: 1 },
    //     { x: 114.604316546763, y: 4.07843137254902, size: 1 },
    //     { x: 131.438848920863, y: 3.84313725490196, size: 1 },
    //     { x: 168.992805755396, y: 4.03921568627451, size: 1 },
    //     { x: 189.712230215827, y: 3.92156862745098, size: 1 },
    //     { x: 194.892086330935, y: 3.96078431372549, size: 1 },
    //     { x: 249.928057553957, y: 3.05882352941176, size: 1 },
    //     { x: 250.575539568345, y: 3.05882352941176, size: 1 },
    //     { x: 251.870503597122, y: 3.29411764705882, size: 1 },
    //     { x: 253.812949640288, y: 3.80392156862745, size: 1 },
    //     { x: 262.230215827338, y: 3.92156862745098, size: 1 },
    //     { x: 271.942446043165, y: 3.09803921568627, size: 1 },
    //     { x: 293.309352517986, y: 3.01960784313725, size: 1 },
    //     { x: 293.956834532374, y: 2.98039215686275, size: 1 },
    //     { x: 294.604316546763, y: 2.43137254901961, size: 1 },
    //     { x: 295.251798561151, y: 2.62745098039216, size: 1 },
    //     { x: 314.676258992806, y: 2.66666666666667, size: 1 },
    //     { x: 0.648648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 8.43243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 16.2162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 18.1621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 19.4594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 33.7297297297297, y: 3.64705882352941, size: 1 },
    //     { x: 41.5135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 42.1621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 49.9459459459459, y: 3.72549019607843, size: 1 },
    //     { x: 57.0810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 62.2702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 79.7837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 80.4324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 88.2162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 92.7567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 101.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 104.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 105.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 106.378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 108.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 110.27027027027, y: 3.68627450980392, size: 1 },
    //     { x: 119.351351351351, y: 3.64705882352941, size: 1 },
    //     { x: 127.783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 128.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 135.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 149.189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 149.837837837838, y: 2.82352941176471, size: 1 },
    //     { x: 156.324324324324, y: 3.72549019607843, size: 1 },
    //     { x: 163.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 164.756756756757, y: 3.72549019607843, size: 1 },
    //     { x: 168, y: 3.52941176470588, size: 1 },
    //     { x: 170.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 171.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 175.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 185.513513513514, y: 3.52941176470588, size: 1 },
    //     { x: 188.108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 189.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 192.648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 193.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 197.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 197.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 198.486486486486, y: 4.03921568627451, size: 1 },
    //     { x: 199.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 199.783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 200.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 202.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 204.324324324324, y: 4.11764705882353, size: 1 },
    //     { x: 205.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 208.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 209.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 212.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 213.405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 214.054054054054, y: 0.823529411764706, size: 1 },
    //     { x: 214.702702702703, y: 0.862745098039216, size: 1 },
    //     { x: 215.351351351351, y: 1.09803921568627, size: 1 },
    //     { x: 216, y: 1.13725490196078, size: 1 },
    //     { x: 216.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 217.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 218.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 223.783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 229.621621621622, y: 2.7843137254902, size: 1 },
    //     { x: 230.27027027027, y: 3.09803921568627, size: 1 },
    //     { x: 230.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 231.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 232.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 233.513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 235.459459459459, y: 2.86274509803922, size: 1 },
    //     { x: 236.108108108108, y: 2.90196078431373, size: 1 },
    //     { x: 238.702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 242.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 245.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 246.486486486486, y: 4, size: 1 },
    //     { x: 256.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 257.513513513513, y: 2.94117647058824, size: 1 },
    //     { x: 258.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 259.459459459459, y: 4, size: 1 },
    //     { x: 273.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 277.621621621622, y: 3.05882352941176, size: 1 },
    //     { x: 278.918918918919, y: 2.31372549019608, size: 1 },
    //     { x: 279.567567567568, y: 2.58823529411765, size: 1 },
    //     { x: 282.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 299.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 299.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 300.324324324324, y: 2.47058823529412, size: 1 },
    //     { x: 300.972972972973, y: 2.47058823529412, size: 1 },
    //     { x: 312, y: 3.52941176470588, size: 1 },
    //     { x: 314.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 320.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 321.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 321.72972972973, y: 2.94117647058824, size: 1 },
    //     { x: 322.378378378378, y: 2.74509803921569, size: 1 },
    //     { x: 333.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 334.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 353.513513513513, y: 4.03921568627451, size: 1 },
    //     { x: 354.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 21.3669064748201, y: 4.03921568627451, size: 1 },
    //     { x: 66.0431654676259, y: 3.92156862745098, size: 1 },
    //     { x: 90, y: 3.29411764705882, size: 1 },
    //     { x: 90.6474820143885, y: 3.01960784313725, size: 1 },
    //     { x: 91.9424460431655, y: 2.54901960784314, size: 1 },
    //     { x: 129.496402877698, y: 3.88235294117647, size: 1 },
    //     { x: 133.381294964029, y: 2.98039215686275, size: 1 },
    //     { x: 150.863309352518, y: 3.96078431372549, size: 1 },
    //     { x: 172.877697841727, y: 4, size: 1 },
    //     { x: 174.172661870504, y: 4.03921568627451, size: 1 },
    //     { x: 174.820143884892, y: 3.92156862745098, size: 1 },
    //     { x: 192.302158273381, y: 4, size: 1 },
    //     { x: 234.388489208633, y: 3.29411764705882, size: 1 },
    //     { x: 257.05035971223, y: 4.03921568627451, size: 1 },
    //     { x: 264.172661870504, y: 3.05882352941176, size: 1 },
    //     { x: 264.820143884892, y: 3.05882352941176, size: 1 },
    //     { x: 265.467625899281, y: 2.98039215686275, size: 1 },
    //     { x: 266.115107913669, y: 2.7843137254902, size: 1 },
    //     { x: 289.424460431655, y: 3.45098039215686, size: 1 },
    //     { x: 329.568345323741, y: 2.50980392156863, size: 1 },
    //     { x: 330.215827338129, y: 2.54901960784314, size: 1 },
    //     { x: 330.863309352518, y: 2.70588235294118, size: 1 },
    //     { x: 331.510791366906, y: 3.25490196078431, size: 1 },
    //     { x: 350.287769784173, y: 3.01960784313725, size: 1 },
    //     { x: 350.935251798561, y: 2.86274509803922, size: 1 },
    //     { x: 4.53237410071942, y: 4, size: 1 },
    //     { x: 5.17985611510791, y: 3.96078431372549, size: 1 },
    //     { x: 5.8273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 19.4244604316547, y: 3.96078431372549, size: 1 },
    //     { x: 24.6043165467626, y: 4.15686274509804, size: 1 },
    //     { x: 67.3381294964029, y: 4.03921568627451, size: 1 },
    //     { x: 68.6330935251799, y: 4.15686274509804, size: 1 },
    //     { x: 99.0647482014388, y: 3.17647058823529, size: 1 },
    //     { x: 118.489208633094, y: 3.45098039215686, size: 1 },
    //     { x: 206.546762589928, y: 3.13725490196078, size: 1 },
    //     { x: 227.26618705036, y: 3.88235294117647, size: 1 },
    //     { x: 264.820143884892, y: 4.03921568627451, size: 1 },
    //     { x: 268.705035971223, y: 3.88235294117647, size: 1 },
    //     { x: 271.942446043165, y: 3.2156862745098, size: 1 },
    //     { x: 291.36690647482, y: 3.25490196078431, size: 1 },
    //     { x: 292.661870503597, y: 3.09803921568627, size: 1 },
    //     { x: 293.309352517986, y: 3.17647058823529, size: 1 },
    //     { x: 302.374100719424, y: 3.88235294117647, size: 1 },
    //     { x: 356.762589928058, y: 3.29411764705882, size: 1 },
    //     { x: 357.410071942446, y: 3.05882352941176, size: 1 },
    //     { x: 29.7841726618705, y: 4, size: 1 },
    //     { x: 34.9640287769784, y: 3.84313725490196, size: 1 },
    //     { x: 67.3381294964029, y: 3.96078431372549, size: 1 },
    //     { x: 71.2230215827338, y: 4.03921568627451, size: 1 },
    //     { x: 105.539568345324, y: 3.05882352941176, size: 1 },
    //     { x: 106.834532374101, y: 3.2156862745098, size: 1 },
    //     { x: 117.194244604317, y: 4.23529411764706, size: 1 },
    //     { x: 121.079136690647, y: 3.96078431372549, size: 1 },
    //     { x: 150.863309352518, y: 3.09803921568627, size: 1 },
    //     { x: 157.985611510791, y: 4.03921568627451, size: 1 },
    //     { x: 174.820143884892, y: 3.88235294117647, size: 1 },
    //     { x: 213.669064748201, y: 3.13725490196078, size: 1 },
    //     { x: 235.68345323741, y: 3.17647058823529, size: 1 },
    //     { x: 246.043165467626, y: 3.92156862745098, size: 1 },
    //     { x: 256.402877697842, y: 3.01960784313725, size: 1 },
    //     { x: 257.05035971223, y: 2.86274509803922, size: 1 },
    //     { x: 257.697841726619, y: 2.90196078431373, size: 1 },
    //     { x: 258.345323741007, y: 2.7843137254902, size: 1 },
    //     { x: 321.151079136691, y: 3.17647058823529, size: 1 },
    //     { x: 321.798561151079, y: 3.25490196078431, size: 1 },
    //     { x: 330.215827338129, y: 4.07843137254902, size: 1 },
    //     { x: 2.59459459459459, y: 3.64705882352941, size: 1 },
    //     { x: 3.24324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 4.54054054054054, y: 2.82352941176471, size: 1 },
    //     { x: 6.48648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 14.9189189189189, y: 4, size: 1 },
    //     { x: 16.2162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 19.4594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 25.9459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 48, y: 2.94117647058824, size: 1 },
    //     { x: 48.6486486486486, y: 2.86274509803922, size: 1 },
    //     { x: 49.9459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 51.2432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 53.1891891891892, y: 3.68627450980392, size: 1 },
    //     { x: 57.7297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 69.4054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 70.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 72.6486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 75.8918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 76.5405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 81.7297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 94.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 97.2972972972973, y: 3.68627450980392, size: 1 },
    //     { x: 100.540540540541, y: 4.03921568627451, size: 1 },
    //     { x: 103.135135135135, y: 4.11764705882353, size: 1 },
    //     { x: 109.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 125.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 128.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 133.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 141.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 154.378378378378, y: 3.56862745098039, size: 1 },
    //     { x: 156.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 157.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 166.054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 166.702702702703, y: 3.49019607843137, size: 1 },
    //     { x: 167.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 177.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 179.675675675676, y: 3.52941176470588, size: 1 },
    //     { x: 180.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 191.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 197.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 199.135135135135, y: 2.74509803921569, size: 1 },
    //     { x: 199.783783783784, y: 2.70588235294118, size: 1 },
    //     { x: 212.756756756757, y: 3.76470588235294, size: 1 },
    //     { x: 223.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 225.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 230.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 230.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 247.783783783784, y: 4, size: 1 },
    //     { x: 250.378378378378, y: 3.52941176470588, size: 1 },
    //     { x: 255.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 257.513513513513, y: 3.49019607843137, size: 1 },
    //     { x: 258.162162162162, y: 3.72549019607843, size: 1 },
    //     { x: 260.756756756757, y: 3.52941176470588, size: 1 },
    //     { x: 262.702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 265.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 267.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 270.486486486487, y: 3.92156862745098, size: 1 },
    //     { x: 280.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 289.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 300.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 302.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 306.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 307.459459459459, y: 2.82352941176471, size: 1 },
    //     { x: 308.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 308.756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 309.405405405405, y: 2.94117647058824, size: 1 },
    //     { x: 312.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 314.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 315.243243243243, y: 3.76470588235294, size: 1 },
    //     { x: 317.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 319.783783783784, y: 3.56862745098039, size: 1 },
    //     { x: 328.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 329.513513513513, y: 3.45098039215686, size: 1 },
    //     { x: 334.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 337.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 351.567567567568, y: 3.49019607843137, size: 1 },
    //     { x: 23.9568345323741, y: 3.17647058823529, size: 1 },
    //     { x: 25.8992805755396, y: 3.25490196078431, size: 1 },
    //     { x: 163.165467625899, y: 2.62745098039216, size: 1 },
    //     { x: 163.812949640288, y: 2.74509803921569, size: 1 },
    //     { x: 183.884892086331, y: 3.33333333333333, size: 1 },
    //     { x: 184.532374100719, y: 2.98039215686275, size: 1 },
    //     { x: 185.179856115108, y: 2.90196078431373, size: 1 },
    //     { x: 206.546762589928, y: 2.74509803921569, size: 1 },
    //     { x: 227.26618705036, y: 3.25490196078431, size: 1 },
    //     { x: 227.913669064748, y: 2.11764705882353, size: 1 },
    //     { x: 228.561151079137, y: 2.43137254901961, size: 1 },
    //     { x: 236.978417266187, y: 4.03921568627451, size: 1 },
    //     { x: 247.985611510791, y: 3.29411764705882, size: 1 },
    //     { x: 265.467625899281, y: 3.88235294117647, size: 1 },
    //     { x: 287.482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 292.661870503597, y: 2.47058823529412, size: 1 },
    //     { x: 293.309352517986, y: 2.35294117647059, size: 1 },
    //     { x: 317.26618705036, y: 4.03921568627451, size: 1 },
    //     { x: 327.625899280576, y: 4.23529411764706, size: 1 },
    //     { x: 343.812949640288, y: 3.88235294117647, size: 1 },
    //     { x: 356.115107913669, y: 3.2156862745098, size: 1 },
    //     { x: 357.410071942446, y: 3.09803921568627, size: 1 },
    //     { x: 358.057553956835, y: 2.7843137254902, size: 1 },
    //     { x: 7.76978417266187, y: 4.15686274509804, size: 1 },
    //     { x: 18.7769784172662, y: 2.74509803921569, size: 1 },
    //     { x: 19.4244604316547, y: 2.47058823529412, size: 1 },
    //     { x: 39.4964028776978, y: 3.09803921568627, size: 1 },
    //     { x: 40.1438848920863, y: 2.94117647058824, size: 1 },
    //     { x: 40.7913669064748, y: 2.11764705882353, size: 1 },
    //     { x: 41.4388489208633, y: 3.09803921568627, size: 1 },
    //     { x: 70.5755395683453, y: 3.88235294117647, size: 1 },
    //     { x: 89.3525179856115, y: 3.96078431372549, size: 1 },
    //     { x: 90.6474820143885, y: 4, size: 1 },
    //     { x: 101.007194244604, y: 4.03921568627451, size: 1 },
    //     { x: 131.438848920863, y: 4, size: 1 },
    //     { x: 149.568345323741, y: 3.17647058823529, size: 1 },
    //     { x: 150.215827338129, y: 3.17647058823529, size: 1 },
    //     { x: 170.287769784173, y: 2.7843137254902, size: 1 },
    //     { x: 170.935251798561, y: 3.13725490196078, size: 1 },
    //     { x: 172.230215827338, y: 3.13725490196078, size: 1 },
    //     { x: 191.654676258993, y: 2.98039215686275, size: 1 },
    //     { x: 192.94964028777, y: 2.90196078431373, size: 1 },
    //     { x: 196.834532374101, y: 3.88235294117647, size: 1 },
    //     { x: 200.071942446043, y: 3.96078431372549, size: 1 },
    //     { x: 226.618705035971, y: 3.29411764705882, size: 1 },
    //     { x: 235.035971223022, y: 2.82352941176471, size: 1 },
    //     { x: 235.68345323741, y: 2.94117647058824, size: 1 },
    //     { x: 246.043165467626, y: 3.96078431372549, size: 1 },
    //     { x: 256.402877697842, y: 2.94117647058824, size: 1 },
    //     { x: 257.05035971223, y: 2.7843137254902, size: 1 },
    //     { x: 257.697841726619, y: 2.94117647058824, size: 1 },
    //     { x: 258.345323741007, y: 3.05882352941176, size: 1 },
    //     { x: 262.230215827338, y: 3.33333333333333, size: 1 },
    //     { x: 277.769784172662, y: 2.58823529411765, size: 1 },
    //     { x: 278.41726618705, y: 2.31372549019608, size: 1 },
    //     { x: 279.064748201439, y: 2.47058823529412, size: 1 },
    //     { x: 279.712230215827, y: 2.35294117647059, size: 1 },
    //     { x: 280.359712230216, y: 3.29411764705882, size: 1 },
    //     { x: 332.158273381295, y: 3.92156862745098, size: 1 },
    //     { x: 20.7194244604317, y: 3.84313725490196, size: 1 },
    //     { x: 34.3165467625899, y: 3.88235294117647, size: 1 },
    //     { x: 71.2230215827338, y: 3.2156862745098, size: 1 },
    //     { x: 74.4604316546763, y: 3.92156862745098, size: 1 },
    //     { x: 90.6474820143885, y: 3.13725490196078, size: 1 },
    //     { x: 91.294964028777, y: 3.09803921568627, size: 1 },
    //     { x: 91.9424460431655, y: 2.74509803921569, size: 1 },
    //     { x: 92.589928057554, y: 2.7843137254902, size: 1 },
    //     { x: 99.0647482014388, y: 3.96078431372549, size: 1 },
    //     { x: 113.956834532374, y: 3.09803921568627, size: 1 },
    //     { x: 125.611510791367, y: 3.33333333333333, size: 1 },
    //     { x: 134.028776978417, y: 3.05882352941176, size: 1 },
    //     { x: 134.676258992806, y: 3.05882352941176, size: 1 },
    //     { x: 156.690647482014, y: 2.74509803921569, size: 1 },
    //     { x: 157.338129496403, y: 2.86274509803922, size: 1 },
    //     { x: 177.410071942446, y: 2.94117647058824, size: 1 },
    //     { x: 178.705035971223, y: 3.17647058823529, size: 1 },
    //     { x: 185.827338129496, y: 3.84313725490196, size: 1 },
    //     { x: 192.302158273381, y: 4.03921568627451, size: 1 },
    //     { x: 198.776978417266, y: 3.13725490196078, size: 1 },
    //     { x: 220.143884892086, y: 2.54901960784314, size: 1 },
    //     { x: 220.791366906475, y: 2.50980392156863, size: 1 },
    //     { x: 221.438848920863, y: 2.98039215686275, size: 1 },
    //     { x: 283.597122302158, y: 3.84313725490196, size: 1 },
    //     { x: 306.906474820144, y: 3.29411764705882, size: 1 },
    //     { x: 315.323741007194, y: 4, size: 1 },
    //     { x: 349.640287769784, y: 3.17647058823529, size: 1 },
    //     { x: 48.5611510791367, y: 3.96078431372549, size: 1 },
    //     { x: 63.4532374100719, y: 4.15686274509804, size: 1 },
    //     { x: 76.4028776978417, y: 3.29411764705882, size: 1 },
    //     { x: 85.4676258992806, y: 3.92156862745098, size: 1 },
    //     { x: 99.0647482014388, y: 3.01960784313725, size: 1 },
    //     { x: 118.489208633094, y: 3.05882352941176, size: 1 },
    //     { x: 119.136690647482, y: 3.01960784313725, size: 1 },
    //     { x: 119.784172661871, y: 2.86274509803922, size: 1 },
    //     { x: 126.258992805755, y: 3.29411764705882, size: 1 },
    //     { x: 183.884892086331, y: 3.01960784313725, size: 1 },
    //     { x: 204.604316546763, y: 4.35294117647059, size: 1 },
    //     { x: 227.26618705036, y: 3.09803921568627, size: 1 },
    //     { x: 229.208633093525, y: 3.96078431372549, size: 1 },
    //     { x: 233.741007194245, y: 3.92156862745098, size: 1 },
    //     { x: 326.978417266187, y: 4.03921568627451, size: 1 },
    //     { x: 334.748201438849, y: 3.09803921568627, size: 1 },
    //     { x: 5.83783783783784, y: 4, size: 1 },
    //     { x: 18.1621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 18.8108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 23.3513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 31.1351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 33.7297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 39.5675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 56.4324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 62.9189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 70.7027027027027, y: 3.6078431372549, size: 1 },
    //     { x: 74.5945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 82.3783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 83.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 83.6756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 95.3513513513514, y: 3.72549019607843, size: 1 },
    //     { x: 100.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 103.783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 104.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 105.081081081081, y: 2.7843137254902, size: 1 },
    //     { x: 105.72972972973, y: 2.82352941176471, size: 1 },
    //     { x: 106.378378378378, y: 2.54901960784314, size: 1 },
    //     { x: 107.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 117.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 122.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 123.243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 125.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 126.486486486486, y: 2.66666666666667, size: 1 },
    //     { x: 130.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 139.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 140.108108108108, y: 4.15686274509804, size: 1 },
    //     { x: 146.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 148.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 149.189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 155.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 160.216216216216, y: 3.56862745098039, size: 1 },
    //     { x: 168.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 169.297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 169.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 171.243243243243, y: 3.49019607843137, size: 1 },
    //     { x: 172.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 178.378378378378, y: 3.6078431372549, size: 1 },
    //     { x: 181.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 191.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 192, y: 3.29411764705882, size: 1 },
    //     { x: 193.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 195.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 200.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 201.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 212.756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 213.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 217.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 234.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 234.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 237.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 243.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 249.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 250.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 254.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 254.918918918919, y: 3.49019607843137, size: 1 },
    //     { x: 258.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 259.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 262.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 263.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 265.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 278.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 301.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 312.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 315.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 315.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 319.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 321.081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 323.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 323.675675675676, y: 4.11764705882353, size: 1 },
    //     { x: 324.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 337.945945945946, y: 3.52941176470588, size: 1 },
    //     { x: 350.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 353.513513513513, y: 3.45098039215686, size: 1 },
    //     { x: 358.054054054054, y: 3.72549019607843, size: 1 },
    //     { x: 22.0143884892086, y: 3.33333333333333, size: 1 },
    //     { x: 27.1942446043165, y: 3.25490196078431, size: 1 },
    //     { x: 34.3165467625899, y: 3.37254901960784, size: 1 },
    //     { x: 39.4964028776978, y: 3.33333333333333, size: 1 },
    //     { x: 44.0287769784173, y: 3.29411764705882, size: 1 },
    //     { x: 69.2805755395683, y: 1.25490196078431, size: 1 },
    //     { x: 69.9280575539568, y: 1.45098039215686, size: 1 },
    //     { x: 70.5755395683453, y: 1.41176470588235, size: 1 },
    //     { x: 71.2230215827338, y: 3.09803921568627, size: 1 },
    //     { x: 73.1654676258993, y: 3.09803921568627, size: 1 },
    //     { x: 73.8129496402878, y: 2.98039215686275, size: 1 },
    //     { x: 78.3453237410072, y: 2.86274509803922, size: 1 },
    //     { x: 84.1726618705036, y: 2.90196078431373, size: 1 },
    //     { x: 84.8201438848921, y: 2.90196078431373, size: 1 },
    //     { x: 85.4676258992806, y: 3.25490196078431, size: 1 },
    //     { x: 90.6474820143885, y: 2.7843137254902, size: 1 },
    //     { x: 133.381294964029, y: 3.29411764705882, size: 1 },
    //     { x: 153.453237410072, y: 2.98039215686275, size: 1 },
    //     { x: 154.748201438849, y: 3.01960784313725, size: 1 },
    //     { x: 155.395683453237, y: 1.88235294117647, size: 1 },
    //     { x: 176.115107913669, y: 3.05882352941176, size: 1 },
    //     { x: 176.762589928058, y: 1.96078431372549, size: 1 },
    //     { x: 177.410071942446, y: 1.96078431372549, size: 1 },
    //     { x: 191.007194244604, y: 4.11764705882353, size: 1 },
    //     { x: 194.892086330935, y: 4.19607843137255, size: 1 },
    //     { x: 198.776978417266, y: 3.33333333333333, size: 1 },
    //     { x: 223.381294964029, y: 4, size: 1 },
    //     { x: 296.546762589928, y: 4.03921568627451, size: 1 },
    //     { x: 306.258992805755, y: 2.54901960784314, size: 1 },
    //     { x: 306.906474820144, y: 2.50980392156863, size: 1 },
    //     { x: 347.697841726619, y: 3.09803921568627, size: 1 },
    //     { x: 16.8345323741007, y: 4, size: 1 },
    //     { x: 97.7697841726619, y: 3.09803921568627, size: 1 },
    //     { x: 124.31654676259, y: 4.03921568627451, size: 1 },
    //     { x: 137.913669064748, y: 4.03921568627451, size: 1 },
    //     { x: 139.856115107914, y: 3.17647058823529, size: 1 },
    //     { x: 140.503597122302, y: 2.86274509803922, size: 1 },
    //     { x: 141.798561151079, y: 3.05882352941176, size: 1 },
    //     { x: 142.446043165468, y: 2.98039215686275, size: 1 },
    //     { x: 164.460431654676, y: 3.96078431372549, size: 1 },
    //     { x: 183.884892086331, y: 3.13725490196078, size: 1 },
    //     { x: 208.489208633094, y: 3.45098039215686, size: 1 },
    //     { x: 227.26618705036, y: 3.13725490196078, size: 1 },
    //     { x: 246.690647482014, y: 3.37254901960784, size: 1 },
    //     { x: 247.985611510791, y: 3.2156862745098, size: 1 },
    //     { x: 249.928057553957, y: 2.98039215686275, size: 1 },
    //     { x: 335.395683453237, y: 2.86274509803922, size: 1 },
    //     { x: 336.043165467626, y: 2.94117647058824, size: 1 },
    //     { x: 336.690647482014, y: 3.09803921568627, size: 1 },
    //     { x: 356.115107913669, y: 2.74509803921569, size: 1 },
    //     { x: 356.762589928058, y: 2.70588235294118, size: 1 },
    //     { x: 357.410071942446, y: 3.2156862745098, size: 1 },
    //     { x: 358.705035971223, y: 3.33333333333333, size: 1 },
    //     { x: 3.89189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 18.8108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 19.4594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 20.1081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 20.7567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 24.6486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 34.3783783783784, y: 3.52941176470588, size: 1 },
    //     { x: 40.2162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 53.8378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 69.4054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 72, y: 3.88235294117647, size: 1 },
    //     { x: 84.3243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 114.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 114.810810810811, y: 4, size: 1 },
    //     { x: 118.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 119.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 121.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 125.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 126.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 129.081081081081, y: 3.64705882352941, size: 1 },
    //     { x: 147.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 148.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 188.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 196.540540540541, y: 4.11764705882353, size: 1 },
    //     { x: 201.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 203.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 204.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 212.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 221.837837837838, y: 3.76470588235294, size: 1 },
    //     { x: 231.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 240.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 252.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 253.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 254.27027027027, y: 3.84313725490196, size: 1 },
    //     { x: 256.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 276.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 276.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 277.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 289.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 297.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 298.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 299.027027027027, y: 2.47058823529412, size: 1 },
    //     { x: 299.675675675676, y: 2.54901960784314, size: 1 },
    //     { x: 300.324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 300.972972972973, y: 2.66666666666667, size: 1 },
    //     { x: 306.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 310.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 320.432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 321.081081081081, y: 3.01960784313725, size: 1 },
    //     { x: 323.675675675676, y: 3.68627450980392, size: 1 },
    //     { x: 325.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 328.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 341.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 342.486486486487, y: 3.33333333333333, size: 1 },
    //     { x: 344.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 352.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 357.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 7.12230215827338, y: 4, size: 1 },
    //     { x: 11.6546762589928, y: 3.80392156862745, size: 1 },
    //     { x: 25.8992805755396, y: 3.05882352941176, size: 1 },
    //     { x: 67.9856115107914, y: 3.17647058823529, size: 1 },
    //     { x: 69.2805755395683, y: 2.31372549019608, size: 1 },
    //     { x: 93.2374100719424, y: 3.88235294117647, size: 1 },
    //     { x: 98.4172661870504, y: 3.96078431372549, size: 1 },
    //     { x: 121.079136690647, y: 4.03921568627451, size: 1 },
    //     { x: 144.388489208633, y: 3.96078431372549, size: 1 },
    //     { x: 176.762589928058, y: 3.09803921568627, size: 1 },
    //     { x: 214.31654676259, y: 3.88235294117647, size: 1 },
    //     { x: 219.496402877698, y: 3.05882352941176, size: 1 },
    //     { x: 220.143884892086, y: 2.94117647058824, size: 1 },
    //     { x: 263.525179856115, y: 3.13725490196078, size: 1 },
    //     { x: 266.115107913669, y: 4, size: 1 },
    //     { x: 284.244604316547, y: 2.98039215686275, size: 1 },
    //     { x: 328.273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 11.0071942446043, y: 3.13725490196078, size: 1 },
    //     { x: 53.7410071942446, y: 3.13725490196078, size: 1 },
    //     { x: 60.863309352518, y: 3.80392156862745, size: 1 },
    //     { x: 119.136690647482, y: 3.13725490196078, size: 1 },
    //     { x: 157.338129496403, y: 3.2156862745098, size: 1 },
    //     { x: 183.884892086331, y: 2.86274509803922, size: 1 },
    //     { x: 220.143884892086, y: 3.84313725490196, size: 1 },
    //     { x: 236.330935251799, y: 3.92156862745098, size: 1 },
    //     { x: 266.115107913669, y: 3.92156862745098, size: 1 },
    //     { x: 356.115107913669, y: 2.58823529411765, size: 1 },
    //     { x: 356.762589928058, y: 2.7843137254902, size: 1 },
    //     { x: 17.4820143884892, y: 2.74509803921569, size: 1 },
    //     { x: 18.1294964028777, y: 1.84313725490196, size: 1 },
    //     { x: 38.2014388489209, y: 3.09803921568627, size: 1 },
    //     { x: 39.4964028776978, y: 2.90196078431373, size: 1 },
    //     { x: 60.863309352518, y: 2.62745098039216, size: 1 },
    //     { x: 82.2302158273381, y: 2.43137254901961, size: 1 },
    //     { x: 82.8776978417266, y: 2.35294117647059, size: 1 },
    //     { x: 92.589928057554, y: 4.23529411764706, size: 1 },
    //     { x: 103.597122302158, y: 2.82352941176471, size: 1 },
    //     { x: 104.244604316547, y: 1.96078431372549, size: 1 },
    //     { x: 130.791366906475, y: 3.92156862745098, size: 1 },
    //     { x: 143.741007194245, y: 4, size: 1 },
    //     { x: 145.035971223022, y: 4, size: 1 },
    //     { x: 165.107913669065, y: 3.96078431372549, size: 1 },
    //     { x: 170.287769784173, y: 3.33333333333333, size: 1 },
    //     { x: 172.877697841727, y: 3.80392156862745, size: 1 },
    //     { x: 228.561151079137, y: 3.84313725490196, size: 1 },
    //     { x: 229.856115107914, y: 3.96078431372549, size: 1 },
    //     { x: 233.741007194245, y: 2.50980392156863, size: 1 },
    //     { x: 345.107913669065, y: 4.03921568627451, size: 1 },
    //     { x: 347.05035971223, y: 3.92156862745098, size: 1 },
    //     { x: 358.057553956835, y: 3.96078431372549, size: 1 },
    //     { x: 359.352517985611, y: 4.07843137254902, size: 1 },
    //     { x: 12.9496402877698, y: 3.88235294117647, size: 1 },
    //     { x: 16.1870503597122, y: 3.96078431372549, size: 1 },
    //     { x: 18.1294964028777, y: 4, size: 1 },
    //     { x: 25.2517985611511, y: 3.01960784313725, size: 1 },
    //     { x: 33.0215827338129, y: 3.88235294117647, size: 1 },
    //     { x: 73.8129496402878, y: 4.11764705882353, size: 1 },
    //     { x: 93.2374100719424, y: 4, size: 1 },
    //     { x: 105.539568345324, y: 4, size: 1 },
    //     { x: 132.73381294964, y: 2.66666666666667, size: 1 },
    //     { x: 154.748201438849, y: 3.05882352941176, size: 1 },
    //     { x: 156.690647482014, y: 4.03921568627451, size: 1 },
    //     { x: 178.705035971223, y: 3.25490196078431, size: 1 },
    //     { x: 220.791366906475, y: 3.96078431372549, size: 1 },
    //     { x: 252.517985611511, y: 4, size: 1 },
    //     { x: 264.172661870504, y: 3.84313725490196, size: 1 },
    //     { x: 264.820143884892, y: 3.92156862745098, size: 1 },
    //     { x: 281.007194244604, y: 3.96078431372549, size: 1 },
    //     { x: 284.244604316547, y: 3.17647058823529, size: 1 },
    //     { x: 326.978417266187, y: 3.2156862745098, size: 1 },
    //     { x: 327.625899280576, y: 2.98039215686275, size: 1 },
    //     { x: 328.273381294964, y: 2.94117647058824, size: 1 },
    //     { x: 328.920863309353, y: 3.13725490196078, size: 1 },
    //     { x: 348.992805755396, y: 2.98039215686275, size: 1 },
    //     { x: 350.287769784173, y: 2.98039215686275, size: 1 },
    //     { x: 7.13513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 9.72972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 10.3783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 19.4594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 22.0540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 22.7027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 30.4864864864865, y: 3.49019607843137, size: 1 },
    //     { x: 31.1351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 31.7837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 32.4324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 33.0810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 33.7297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 35.027027027027, y: 3.72549019607843, size: 1 },
    //     { x: 53.1891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 53.8378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 58.3783783783784, y: 4, size: 1 },
    //     { x: 62.2702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 75.2432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 96.6486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 105.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 116.756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 118.702702702703, y: 2.98039215686275, size: 1 },
    //     { x: 122.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 127.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 131.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 159.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 169.945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 182.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 203.675675675676, y: 4.15686274509804, size: 1 },
    //     { x: 204.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 204.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 241.297297297297, y: 3.52941176470588, size: 1 },
    //     { x: 246.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 247.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 274.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 282.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 288.648648648649, y: 4, size: 1 },
    //     { x: 298.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 299.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 303.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 311.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 319.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 323.027027027027, y: 3.68627450980392, size: 1 },
    //     { x: 338.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 348.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 355.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 356.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 356.756756756757, y: 2.94117647058824, size: 1 },
    //     { x: 357.405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 358.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 0, y: 3.96078431372549, size: 1 },
    //     { x: 18.7769784172662, y: 3.09803921568627, size: 1 },
    //     { x: 34.3165467625899, y: 3.96078431372549, size: 1 },
    //     { x: 35.6115107913669, y: 4, size: 1 },
    //     { x: 38.8489208633094, y: 3.2156862745098, size: 1 },
    //     { x: 56.9784172661871, y: 4.03921568627451, size: 1 },
    //     { x: 65.3956834532374, y: 3.88235294117647, size: 1 },
    //     { x: 152.805755395683, y: 3.96078431372549, size: 1 },
    //     { x: 161.223021582734, y: 4.11764705882353, size: 1 },
    //     { x: 191.007194244604, y: 3.33333333333333, size: 1 },
    //     { x: 210.431654676259, y: 3.37254901960784, size: 1 },
    //     { x: 219.496402877698, y: 4, size: 1 },
    //     { x: 233.093525179856, y: 3.2156862745098, size: 1 },
    //     { x: 233.741007194245, y: 3.01960784313725, size: 1 },
    //     { x: 319.856115107914, y: 3.01960784313725, size: 1 },
    //     { x: 320.503597122302, y: 2.94117647058824, size: 1 },
    //     { x: 321.151079136691, y: 2.50980392156863, size: 1 },
    //     { x: 321.798561151079, y: 2.7843137254902, size: 1 },
    //     { x: 341.223021582734, y: 3.05882352941176, size: 1 },
    //     { x: 341.870503597122, y: 3.29411764705882, size: 1 },
    //     { x: 16.8345323741007, y: 3.92156862745098, size: 1 },
    //     { x: 24.6043165467626, y: 2.98039215686275, size: 1 },
    //     { x: 45.3237410071942, y: 3.13725490196078, size: 1 },
    //     { x: 45.9712230215827, y: 3.09803921568627, size: 1 },
    //     { x: 67.9856115107914, y: 2.94117647058824, size: 1 },
    //     { x: 153.453237410072, y: 3.92156862745098, size: 1 },
    //     { x: 213.021582733813, y: 4.23529411764706, size: 1 },
    //     { x: 218.201438848921, y: 3.25490196078431, size: 1 },
    //     { x: 248.63309352518, y: 4.03921568627451, size: 1 },
    //     { x: 282.94964028777, y: 2.94117647058824, size: 1 },
    //     { x: 283.597122302158, y: 1.37254901960784, size: 1 },
    //     { x: 284.244604316547, y: 1.13725490196078, size: 1 },
    //     { x: 284.892086330935, y: 1.2156862745098, size: 1 },
    //     { x: 285.539568345324, y: 0.823529411764706, size: 1 },
    //     { x: 288.129496402878, y: 2.86274509803922, size: 1 },
    //     { x: 299.136690647482, y: 2.82352941176471, size: 1 },
    //     { x: 304.964028776978, y: 2.82352941176471, size: 1 },
    //     { x: 305.611510791367, y: 2.74509803921569, size: 1 },
    //     { x: 326.330935251799, y: 2.82352941176471, size: 1 },
    //     { x: 347.697841726619, y: 3.29411764705882, size: 1 },
    //     { x: 352.877697841727, y: 4, size: 1 },
    //     { x: 3.89189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 7.78378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 8.43243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 9.72972972972973, y: 2.19607843137255, size: 1 },
    //     { x: 10.3783783783784, y: 2.19607843137255, size: 1 },
    //     { x: 14.9189189189189, y: 3.76470588235294, size: 1 },
    //     { x: 20.1081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 29.1891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 31.1351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 31.7837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 42.8108108108108, y: 3.76470588235294, size: 1 },
    //     { x: 51.8918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 52.5405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 53.1891891891892, y: 2.11764705882353, size: 1 },
    //     { x: 73.2972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 73.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 74.5945945945946, y: 2.54901960784314, size: 1 },
    //     { x: 75.2432432432432, y: 2.86274509803922, size: 1 },
    //     { x: 77.1891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 80.4324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 86.2702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 90.8108108108108, y: 4.15686274509804, size: 1 },
    //     { x: 101.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 106.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 110.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 114.162162162162, y: 3.84313725490196, size: 1 },
    //     { x: 116.756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 117.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 118.054054054054, y: 2.66666666666667, size: 1 },
    //     { x: 118.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 132.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 133.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 134.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 138.810810810811, y: 2.7843137254902, size: 1 },
    //     { x: 139.459459459459, y: 1.88235294117647, size: 1 },
    //     { x: 140.108108108108, y: 2.11764705882353, size: 1 },
    //     { x: 146.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 159.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 160.864864864865, y: 2.66666666666667, size: 1 },
    //     { x: 161.513513513514, y: 2.7843137254902, size: 1 },
    //     { x: 171.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 173.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 177.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 180.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 182.918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 184.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 187.459459459459, y: 3.52941176470588, size: 1 },
    //     { x: 194.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 236.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 256.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 269.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 269.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 277.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 279.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 286.702702702703, y: 4, size: 1 },
    //     { x: 287.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 289.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 291.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 292.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 301.621621621622, y: 4, size: 1 },
    //     { x: 306.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 309.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 311.351351351351, y: 3.45098039215686, size: 1 },
    //     { x: 312, y: 3.17647058823529, size: 1 },
    //     { x: 312.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 313.297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 313.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 314.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 320.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 330.810810810811, y: 4.03921568627451, size: 1 },
    //     { x: 334.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 335.351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 356.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 356.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 17.4820143884892, y: 2.98039215686275, size: 1 },
    //     { x: 18.1294964028777, y: 3.01960784313725, size: 1 },
    //     { x: 18.7769784172662, y: 2.94117647058824, size: 1 },
    //     { x: 19.4244604316547, y: 3.05882352941176, size: 1 },
    //     { x: 38.8489208633094, y: 2.98039215686275, size: 1 },
    //     { x: 39.4964028776978, y: 2.94117647058824, size: 1 },
    //     { x: 40.1438848920863, y: 2.58823529411765, size: 1 },
    //     { x: 40.7913669064748, y: 2.7843137254902, size: 1 },
    //     { x: 80.9352517985612, y: 3.17647058823529, size: 1 },
    //     { x: 82.2302158273381, y: 3.01960784313725, size: 1 },
    //     { x: 104.244604316547, y: 2.98039215686275, size: 1 },
    //     { x: 104.892086330935, y: 2.98039215686275, size: 1 },
    //     { x: 105.539568345324, y: 3.25490196078431, size: 1 },
    //     { x: 148.273381294964, y: 3.92156862745098, size: 1 },
    //     { x: 168.345323741007, y: 3.37254901960784, size: 1 },
    //     { x: 218.848920863309, y: 3.80392156862745, size: 1 },
    //     { x: 233.093525179856, y: 3.29411764705882, size: 1 },
    //     { x: 235.035971223022, y: 2.98039215686275, size: 1 },
    //     { x: 254.460431654676, y: 2.90196078431373, size: 1 },
    //     { x: 255.107913669065, y: 3.01960784313725, size: 1 },
    //     { x: 256.402877697842, y: 3.25490196078431, size: 1 },
    //     { x: 257.05035971223, y: 3.13725490196078, size: 1 },
    //     { x: 266.115107913669, y: 3.25490196078431, size: 1 },
    //     { x: 269.352517985611, y: 3.33333333333333, size: 1 },
    //     { x: 319.208633093525, y: 3.01960784313725, size: 1 },
    //     { x: 320.503597122302, y: 2.86274509803922, size: 1 },
    //     { x: 341.223021582734, y: 2.98039215686275, size: 1 },
    //     { x: 341.870503597122, y: 2.98039215686275, size: 1 },
    //     { x: 342.517985611511, y: 2.7843137254902, size: 1 },
    //     { x: 343.165467625899, y: 2.74509803921569, size: 1 },
    //     { x: 2.58992805755396, y: 2.54901960784314, size: 1 },
    //     { x: 3.23741007194245, y: 2.90196078431373, size: 1 },
    //     { x: 3.88489208633094, y: 2.43137254901961, size: 1 },
    //     { x: 4.53237410071942, y: 2.54901960784314, size: 1 },
    //     { x: 53.7410071942446, y: 3.88235294117647, size: 1 },
    //     { x: 68.6330935251799, y: 3.2156862745098, size: 1 },
    //     { x: 88.705035971223, y: 2.50980392156863, size: 1 },
    //     { x: 89.3525179856115, y: 2.86274509803922, size: 1 },
    //     { x: 110.719424460432, y: 2.98039215686275, size: 1 },
    //     { x: 111.36690647482, y: 3.13725490196078, size: 1 },
    //     { x: 112.661870503597, y: 3.13725490196078, size: 1 },
    //     { x: 132.086330935252, y: 2.58823529411765, size: 1 },
    //     { x: 132.73381294964, y: 2.98039215686275, size: 1 },
    //     { x: 133.381294964029, y: 2.47058823529412, size: 1 },
    //     { x: 134.028776978417, y: 2.74509803921569, size: 1 },
    //     { x: 175.467625899281, y: 3.96078431372549, size: 1 },
    //     { x: 184.532374100719, y: 3.92156862745098, size: 1 },
    //     { x: 196.187050359712, y: 3.25490196078431, size: 1 },
    //     { x: 197.482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 244.748201438849, y: 3.88235294117647, size: 1 },
    //     { x: 282.94964028777, y: 2.74509803921569, size: 1 },
    //     { x: 315.323741007194, y: 4.03921568627451, size: 1 },
    //     { x: 319.208633093525, y: 3.96078431372549, size: 1 },
    //     { x: 19.4244604316547, y: 4, size: 1 },
    //     { x: 31.0791366906475, y: 3.09803921568627, size: 1 },
    //     { x: 33.0215827338129, y: 3.17647058823529, size: 1 },
    //     { x: 52.4460431654676, y: 3.09803921568627, size: 1 },
    //     { x: 56.3309352517986, y: 3.92156862745098, size: 1 },
    //     { x: 59.568345323741, y: 3.84313725490196, size: 1 },
    //     { x: 113.309352517986, y: 4.07843137254902, size: 1 },
    //     { x: 115.251798561151, y: 4, size: 1 },
    //     { x: 128.848920863309, y: 4.03921568627451, size: 1 },
    //     { x: 132.73381294964, y: 4, size: 1 },
    //     { x: 148.920863309353, y: 4, size: 1 },
    //     { x: 170.287769784173, y: 4.07843137254902, size: 1 },
    //     { x: 181.942446043165, y: 3.2156862745098, size: 1 },
    //     { x: 196.834532374101, y: 3.96078431372549, size: 1 },
    //     { x: 249.928057553957, y: 3.96078431372549, size: 1 },
    //     { x: 291.36690647482, y: 3.05882352941176, size: 1 },
    //     { x: 305.611510791367, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 2.3921568627451, size: 1 },
    //     { x: 312.086330935252, y: 2.70588235294118, size: 1 },
    //     { x: 313.381294964029, y: 2.94117647058824, size: 1 },
    //     { x: 333.453237410072, y: 2.74509803921569, size: 1 },
    //     { x: 11.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 17.5135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 19.4594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 27.8918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 37.6216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 42.1621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 47.3513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 55.7837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 57.0810810810811, y: 4.03921568627451, size: 1 },
    //     { x: 59.6756756756757, y: 2.86274509803922, size: 1 },
    //     { x: 60.3243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 63.5675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 66.1621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 72, y: 3.45098039215686, size: 1 },
    //     { x: 73.2972972972973, y: 3.64705882352941, size: 1 },
    //     { x: 77.1891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 81.0810810810811, y: 2.86274509803922, size: 1 },
    //     { x: 81.7297297297297, y: 2.82352941176471, size: 1 },
    //     { x: 93.4054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 118.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 118.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 120.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 131.027027027027, y: 3.64705882352941, size: 1 },
    //     { x: 142.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 145.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 160.864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 162.162162162162, y: 4, size: 1 },
    //     { x: 166.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 168, y: 3.25490196078431, size: 1 },
    //     { x: 173.189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 189.405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 190.054054054054, y: 2.70588235294118, size: 1 },
    //     { x: 210.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 211.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 220.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 221.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 222.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 225.72972972973, y: 4.15686274509804, size: 1 },
    //     { x: 229.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 231.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 232.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 232.864864864865, y: 2.35294117647059, size: 1 },
    //     { x: 239.351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 240, y: 3.96078431372549, size: 1 },
    //     { x: 252.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 254.27027027027, y: 2.86274509803922, size: 1 },
    //     { x: 254.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 258.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 264.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 265.297297297297, y: 3.76470588235294, size: 1 },
    //     { x: 269.189189189189, y: 4.03921568627451, size: 1 },
    //     { x: 273.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 274.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 275.675675675676, y: 2.86274509803922, size: 1 },
    //     { x: 276.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 284.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 284.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 296.432432432432, y: 3.45098039215686, size: 1 },
    //     { x: 297.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 297.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 305.513513513513, y: 3.49019607843137, size: 1 },
    //     { x: 310.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 317.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 319.135135135135, y: 2.62745098039216, size: 1 },
    //     { x: 319.783783783784, y: 2.54901960784314, size: 1 },
    //     { x: 326.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 328.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 336, y: 3.92156862745098, size: 1 },
    //     { x: 349.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 353.513513513513, y: 3.92156862745098, size: 1 },
    //     { x: 354.810810810811, y: 3.56862745098039, size: 1 },
    //     { x: 356.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 358.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 23.3093525179856, y: 3.17647058823529, size: 1 },
    //     { x: 23.9568345323741, y: 2.35294117647059, size: 1 },
    //     { x: 24.6043165467626, y: 2.35294117647059, size: 1 },
    //     { x: 33.6690647482014, y: 3.84313725490196, size: 1 },
    //     { x: 45.3237410071942, y: 2.7843137254902, size: 1 },
    //     { x: 45.9712230215827, y: 2.86274509803922, size: 1 },
    //     { x: 66.0431654676259, y: 3.13725490196078, size: 1 },
    //     { x: 67.3381294964029, y: 2.15686274509804, size: 1 },
    //     { x: 87.410071942446, y: 3.05882352941176, size: 1 },
    //     { x: 88.705035971223, y: 2.27450980392157, size: 1 },
    //     { x: 89.3525179856115, y: 2.47058823529412, size: 1 },
    //     { x: 145.68345323741, y: 3.88235294117647, size: 1 },
    //     { x: 154.748201438849, y: 3.80392156862745, size: 1 },
    //     { x: 194.244604316547, y: 3.84313725490196, size: 1 },
    //     { x: 200.719424460432, y: 3.96078431372549, size: 1 },
    //     { x: 215.611510791367, y: 4, size: 1 },
    //     { x: 220.143884892086, y: 3.88235294117647, size: 1 },
    //     { x: 252.517985611511, y: 3.92156862745098, size: 1 },
    //     { x: 261.58273381295, y: 3.13725490196078, size: 1 },
    //     { x: 282.94964028777, y: 3.25490196078431, size: 1 },
    //     { x: 343.812949640288, y: 3.84313725490196, size: 1 },
    //     { x: 52.4460431654676, y: 2.98039215686275, size: 1 },
    //     { x: 55.6834532374101, y: 3.92156862745098, size: 1 },
    //     { x: 160.575539568345, y: 3.13725490196078, size: 1 },
    //     { x: 161.870503597122, y: 2.94117647058824, size: 1 },
    //     { x: 162.517985611511, y: 3.01960784313725, size: 1 },
    //     { x: 203.309352517986, y: 3.17647058823529, size: 1 },
    //     { x: 246.690647482014, y: 2.98039215686275, size: 1 },
    //     { x: 290.719424460432, y: 3.05882352941176, size: 1 },
    //     { x: 332.805755395683, y: 3.09803921568627, size: 1 },
    //     { x: 333.453237410072, y: 2.94117647058824, size: 1 },
    //     { x: 38.2014388489209, y: 3.13725490196078, size: 1 },
    //     { x: 78.9928057553957, y: 3.96078431372549, size: 1 },
    //     { x: 102.302158273381, y: 3.09803921568627, size: 1 },
    //     { x: 170.935251798561, y: 4.11764705882353, size: 1 },
    //     { x: 189.064748201439, y: 3.01960784313725, size: 1 },
    //     { x: 210.431654676259, y: 3.29411764705882, size: 1 },
    //     { x: 224.028776978417, y: 3.88235294117647, size: 1 },
    //     { x: 235.035971223022, y: 4, size: 1 },
    //     { x: 249.928057553957, y: 3.92156862745098, size: 1 },
    //     { x: 251.870503597122, y: 3.96078431372549, size: 1 },
    //     { x: 253.812949640288, y: 3.13725490196078, size: 1 },
    //     { x: 257.697841726619, y: 3.92156862745098, size: 1 },
    //     { x: 268.057553956835, y: 4.15686274509804, size: 1 },
    //     { x: 275.179856115108, y: 3.09803921568627, size: 1 },
    //     { x: 275.827338129496, y: 2.94117647058824, size: 1 },
    //     { x: 281.654676258993, y: 3.92156862745098, size: 1 },
    //     { x: 285.539568345324, y: 3.88235294117647, size: 1 },
    //     { x: 306.906474820144, y: 4.11764705882353, size: 1 },
    //     { x: 339.928057553957, y: 3.05882352941176, size: 1 },
    //     { x: 358.705035971223, y: 4.03921568627451, size: 1 },
    //     { x: 1.2972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 1.94594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 4.54054054054054, y: 3.76470588235294, size: 1 },
    //     { x: 7.78378378378378, y: 4, size: 1 },
    //     { x: 12.3243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 18.8108108108108, y: 4, size: 1 },
    //     { x: 21.4054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 22.0540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 23.3513513513514, y: 2.82352941176471, size: 1 },
    //     { x: 24.6486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 25.9459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 32.4324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 33.0810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 33.7297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 44.7567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 45.4054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 56.4324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 59.6756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 64.2162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 66.8108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 77.8378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 78.4864864864865, y: 3.76470588235294, size: 1 },
    //     { x: 86.9189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 87.5675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 88.2162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 95.3513513513514, y: 3.6078431372549, size: 1 },
    //     { x: 99.2432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 105.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 105.72972972973, y: 4, size: 1 },
    //     { x: 111.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 112.216216216216, y: 4, size: 1 },
    //     { x: 124.540540540541, y: 3.56862745098039, size: 1 },
    //     { x: 129.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 129.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 131.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 140.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 147.243243243243, y: 4, size: 1 },
    //     { x: 147.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 153.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 166.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 169.945945945946, y: 3.72549019607843, size: 1 },
    //     { x: 174.486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 175.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 175.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 191.351351351351, y: 4, size: 1 },
    //     { x: 192.648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 195.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 206.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 207.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 216, y: 3.41176470588235, size: 1 },
    //     { x: 217.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 221.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 227.675675675676, y: 4.03921568627451, size: 1 },
    //     { x: 228.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 238.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 240, y: 2.90196078431373, size: 1 },
    //     { x: 245.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 255.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 269.837837837838, y: 4, size: 1 },
    //     { x: 271.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 276.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 281.513513513513, y: 4.11764705882353, size: 1 },
    //     { x: 282.810810810811, y: 2.94117647058824, size: 1 },
    //     { x: 284.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 286.702702702703, y: 3.84313725490196, size: 1 },
    //     { x: 292.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 294.486486486487, y: 3.96078431372549, size: 1 },
    //     { x: 295.783783783784, y: 3.76470588235294, size: 1 },
    //     { x: 304.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 307.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 325.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 327.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 328.864864864865, y: 4, size: 1 },
    //     { x: 342.486486486487, y: 3.84313725490196, size: 1 },
    //     { x: 343.135135135135, y: 4.15686274509804, size: 1 },
    //     { x: 345.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 345.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 350.918918918919, y: 3.72549019607843, size: 1 },
    //     { x: 352.216216216216, y: 4.15686274509804, size: 1 },
    //     { x: 358.702702702703, y: 3.64705882352941, size: 1 },
    //     { x: 7.76978417266187, y: 3.25490196078431, size: 1 },
    //     { x: 9.06474820143885, y: 2.7843137254902, size: 1 },
    //     { x: 9.71223021582734, y: 2.90196078431373, size: 1 },
    //     { x: 52.4460431654676, y: 3.05882352941176, size: 1 },
    //     { x: 72.5179856115108, y: 3.25490196078431, size: 1 },
    //     { x: 73.8129496402878, y: 3.17647058823529, size: 1 },
    //     { x: 74.4604316546763, y: 3.01960784313725, size: 1 },
    //     { x: 95.1798561151079, y: 3.17647058823529, size: 1 },
    //     { x: 117.194244604317, y: 3.05882352941176, size: 1 },
    //     { x: 137.913669064748, y: 2.90196078431373, size: 1 },
    //     { x: 139.208633093525, y: 1.49019607843137, size: 1 },
    //     { x: 139.856115107914, y: 0.705882352941177, size: 1 },
    //     { x: 140.503597122302, y: 1.2156862745098, size: 1 },
    //     { x: 148.273381294964, y: 2.90196078431373, size: 1 },
    //     { x: 154.10071942446, y: 2.86274509803922, size: 1 },
    //     { x: 154.748201438849, y: 3.09803921568627, size: 1 },
    //     { x: 158.63309352518, y: 3.09803921568627, size: 1 },
    //     { x: 159.928057553957, y: 2.98039215686275, size: 1 },
    //     { x: 160.575539568345, y: 2.50980392156863, size: 1 },
    //     { x: 180.647482014388, y: 3.09803921568627, size: 1 },
    //     { x: 181.294964028777, y: 3.25490196078431, size: 1 },
    //     { x: 181.942446043165, y: 2.31372549019608, size: 1 },
    //     { x: 182.589928057554, y: 2.98039215686275, size: 1 },
    //     { x: 203.309352517986, y: 1.92156862745098, size: 1 },
    //     { x: 203.956834532374, y: 1.72549019607843, size: 1 },
    //     { x: 225.323741007194, y: 4, size: 1 },
    //     { x: 240.863309352518, y: 3.96078431372549, size: 1 },
    //     { x: 244.10071942446, y: 4.03921568627451, size: 1 },
    //     { x: 306.906474820144, y: 4, size: 1 },
    //     { x: 309.496402877698, y: 3.05882352941176, size: 1 },
    //     { x: 28.4892086330935, y: 4.07843137254902, size: 1 },
    //     { x: 57.6258992805755, y: 3.01960784313725, size: 1 },
    //     { x: 98.4172661870504, y: 4.11764705882353, size: 1 },
    //     { x: 116.546762589928, y: 3.92156862745098, size: 1 },
    //     { x: 139.856115107914, y: 3.88235294117647, size: 1 },
    //     { x: 150.215827338129, y: 4.07843137254902, size: 1 },
    //     { x: 170.935251798561, y: 4, size: 1 },
    //     { x: 188.41726618705, y: 2.98039215686275, size: 1 },
    //     { x: 189.064748201439, y: 3.09803921568627, size: 1 },
    //     { x: 192.94964028777, y: 4.19607843137255, size: 1 },
    //     { x: 209.136690647482, y: 3.92156862745098, size: 1 },
    //     { x: 237.625899280576, y: 3.96078431372549, size: 1 },
    //     { x: 240.863309352518, y: 4.23529411764706, size: 1 },
    //     { x: 250.575539568345, y: 3.92156862745098, size: 1 },
    //     { x: 253.165467625899, y: 2.82352941176471, size: 1 },
    //     { x: 253.812949640288, y: 2.43137254901961, size: 1 },
    //     { x: 256.402877697842, y: 4.03921568627451, size: 1 },
    //     { x: 271.942446043165, y: 4.03921568627451, size: 1 },
    //     { x: 272.589928057554, y: 3.84313725490196, size: 1 },
    //     { x: 275.827338129496, y: 3.09803921568627, size: 1 },
    //     { x: 298.489208633094, y: 4.03921568627451, size: 1 },
    //     { x: 339.928057553957, y: 3.09803921568627, size: 1 },
    //     { x: 42.7338129496403, y: 3.96078431372549, size: 1 },
    //     { x: 63.4532374100719, y: 4.11764705882353, size: 1 },
    //     { x: 109.424460431655, y: 2.94117647058824, size: 1 },
    //     { x: 133.381294964029, y: 4.03921568627451, size: 1 },
    //     { x: 134.028776978417, y: 3.96078431372549, size: 1 },
    //     { x: 138.561151079137, y: 4, size: 1 },
    //     { x: 146.330935251799, y: 4.19607843137255, size: 1 },
    //     { x: 164.460431654676, y: 3.92156862745098, size: 1 },
    //     { x: 165.755395683453, y: 4.15686274509804, size: 1 },
    //     { x: 171.58273381295, y: 4, size: 1 },
    //     { x: 194.244604316547, y: 3.29411764705882, size: 1 },
    //     { x: 195.539568345324, y: 2.98039215686275, size: 1 },
    //     { x: 196.187050359712, y: 2.82352941176471, size: 1 },
    //     { x: 204.604316546763, y: 3.92156862745098, size: 1 },
    //     { x: 238.273381294964, y: 3.33333333333333, size: 1 },
    //     { x: 242.805755395683, y: 4.15686274509804, size: 1 },
    //     { x: 257.697841726619, y: 3.88235294117647, size: 1 },
    //     { x: 295.89928057554, y: 4, size: 1 },
    //     { x: 312.73381294964, y: 3.96078431372549, size: 1 },
    //     { x: 317.26618705036, y: 3.96078431372549, size: 1 },
    //     { x: 325.68345323741, y: 3.05882352941176, size: 1 },
    //     { x: 346.402877697842, y: 3.37254901960784, size: 1 },
    //     { x: 9.72972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 25.9459459459459, y: 4.11764705882353, size: 1 },
    //     { x: 31.1351351351351, y: 3.09803921568627, size: 1 },
    //     { x: 31.7837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 49.2972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 50.5945945945946, y: 3.80392156862745, size: 1 },
    //     { x: 68.1081081081081, y: 4.07843137254902, size: 1 },
    //     { x: 69.4054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 73.2972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 79.7837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 95.3513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 108.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 112.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 121.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 127.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 136.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 138.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 138.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 140.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 144.648648648649, y: 4.07843137254902, size: 1 },
    //     { x: 147.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 148.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 158.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 160.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 160.864864864865, y: 2.98039215686275, size: 1 },
    //     { x: 161.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 162.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 162.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 169.945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 179.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 180.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 181.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 186.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 203.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 203.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 206.27027027027, y: 3.80392156862745, size: 1 },
    //     { x: 206.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 208.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 220.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 224.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 225.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 228.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 245.189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 245.837837837838, y: 2.82352941176471, size: 1 },
    //     { x: 246.486486486486, y: 2.86274509803922, size: 1 },
    //     { x: 251.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 256.216216216216, y: 4, size: 1 },
    //     { x: 258.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 262.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 266.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 267.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 267.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 268.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 276.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 283.459459459459, y: 3.80392156862745, size: 1 },
    //     { x: 292.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 300.324324324324, y: 4, size: 1 },
    //     { x: 308.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 310.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 311.351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 313.297297297297, y: 4, size: 1 },
    //     { x: 318.486486486487, y: 3.96078431372549, size: 1 },
    //     { x: 320.432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 321.72972972973, y: 4.15686274509804, size: 1 },
    //     { x: 329.513513513513, y: 3.96078431372549, size: 1 },
    //     { x: 330.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 331.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 332.756756756757, y: 2.74509803921569, size: 1 },
    //     { x: 333.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 352.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 15.5395683453237, y: 2.90196078431373, size: 1 },
    //     { x: 16.1870503597122, y: 3.13725490196078, size: 1 },
    //     { x: 38.2014388489209, y: 3.2156862745098, size: 1 },
    //     { x: 69.2805755395683, y: 3.92156862745098, size: 1 },
    //     { x: 79.6402877697842, y: 3.88235294117647, size: 1 },
    //     { x: 145.035971223022, y: 2.82352941176471, size: 1 },
    //     { x: 146.330935251799, y: 2.35294117647059, size: 1 },
    //     { x: 146.978417266187, y: 2.23529411764706, size: 1 },
    //     { x: 151.510791366906, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 4, size: 1 },
    //     { x: 167.05035971223, y: 3.29411764705882, size: 1 },
    //     { x: 186.474820143885, y: 3.33333333333333, size: 1 },
    //     { x: 231.151079136691, y: 3.05882352941176, size: 1 },
    //     { x: 253.165467625899, y: 2.3921568627451, size: 1 },
    //     { x: 253.812949640288, y: 2.70588235294118, size: 1 },
    //     { x: 274.532374100719, y: 2.98039215686275, size: 1 },
    //     { x: 275.179856115108, y: 2.98039215686275, size: 1 },
    //     { x: 14.2446043165468, y: 3.88235294117647, size: 1 },
    //     { x: 44.6762589928058, y: 3.13725490196078, size: 1 },
    //     { x: 53.7410071942446, y: 3.96078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 2.86274509803922, size: 1 },
    //     { x: 87.410071942446, y: 2.50980392156863, size: 1 },
    //     { x: 88.0575539568345, y: 2.58823529411765, size: 1 },
    //     { x: 108.776978417266, y: 2.3921568627451, size: 1 },
    //     { x: 109.424460431655, y: 2.11764705882353, size: 1 },
    //     { x: 143.741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 151.510791366906, y: 3.09803921568627, size: 1 },
    //     { x: 152.158273381295, y: 2.94117647058824, size: 1 },
    //     { x: 229.856115107914, y: 4.07843137254902, size: 1 },
    //     { x: 240.215827338129, y: 3.96078431372549, size: 1 },
    //     { x: 256.402877697842, y: 4.27450980392157, size: 1 },
    //     { x: 286.834532374101, y: 3.88235294117647, size: 1 },
    //     { x: 303.021582733813, y: 2.54901960784314, size: 1 },
    //     { x: 345.107913669065, y: 3.2156862745098, size: 1 },
    //     { x: 14.2446043165468, y: 3.92156862745098, size: 1 },
    //     { x: 22.6618705035971, y: 3.84313725490196, size: 1 },
    //     { x: 51.7985611510791, y: 3.29411764705882, size: 1 },
    //     { x: 61.5107913669065, y: 4.23529411764706, size: 1 },
    //     { x: 69.2805755395683, y: 4.07843137254902, size: 1 },
    //     { x: 106.187050359712, y: 4, size: 1 },
    //     { x: 116.546762589928, y: 3.13725490196078, size: 1 },
    //     { x: 117.194244604317, y: 2.7843137254902, size: 1 },
    //     { x: 117.841726618705, y: 2.62745098039216, size: 1 },
    //     { x: 119.136690647482, y: 4.11764705882353, size: 1 },
    //     { x: 125.611510791367, y: 4, size: 1 },
    //     { x: 137.26618705036, y: 3.33333333333333, size: 1 },
    //     { x: 159.280575539568, y: 3.2156862745098, size: 1 },
    //     { x: 180.647482014388, y: 2.7843137254902, size: 1 },
    //     { x: 181.294964028777, y: 2.86274509803922, size: 1 },
    //     { x: 246.043165467626, y: 3.05882352941176, size: 1 },
    //     { x: 255.107913669065, y: 4.11764705882353, size: 1 },
    //     { x: 326.978417266187, y: 3.96078431372549, size: 1 },
    //     { x: 15.5675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 16.2162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 16.8648648648649, y: 2.62745098039216, size: 1 },
    //     { x: 22.7027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 36.3243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 36.972972972973, y: 2.90196078431373, size: 1 },
    //     { x: 37.6216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 38.2702702702703, y: 2.94117647058824, size: 1 },
    //     { x: 47.3513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 69.4054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 71.3513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 88.2162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 116.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 123.243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 123.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 125.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 153.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 155.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 159.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 166.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 166.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 179.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 192, y: 3.72549019607843, size: 1 },
    //     { x: 198.486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 206.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 219.243243243243, y: 3.45098039215686, size: 1 },
    //     { x: 219.891891891892, y: 4.15686274509804, size: 1 },
    //     { x: 232.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 233.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 250.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 252.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 253.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 256.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 269.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 275.675675675676, y: 4.27450980392157, size: 1 },
    //     { x: 276.324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 276.972972972973, y: 4.19607843137255, size: 1 },
    //     { x: 277.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 278.27027027027, y: 4.19607843137255, size: 1 },
    //     { x: 278.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 280.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 281.513513513513, y: 4.19607843137255, size: 1 },
    //     { x: 282.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 283.459459459459, y: 4.19607843137255, size: 1 },
    //     { x: 284.108108108108, y: 4.19607843137255, size: 1 },
    //     { x: 284.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 287.351351351351, y: 4.03921568627451, size: 1 },
    //     { x: 288.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 289.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 291.243243243243, y: 4.07843137254902, size: 1 },
    //     { x: 291.891891891892, y: 4.07843137254902, size: 1 },
    //     { x: 292.540540540541, y: 4.15686274509804, size: 1 },
    //     { x: 293.189189189189, y: 4.23529411764706, size: 1 },
    //     { x: 293.837837837838, y: 4.19607843137255, size: 1 },
    //     { x: 295.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 319.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 321.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 329.513513513513, y: 3.88235294117647, size: 1 },
    //     { x: 339.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 339.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 0.647482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 1.29496402877698, y: 2.54901960784314, size: 1 },
    //     { x: 1.94244604316547, y: 2.98039215686275, size: 1 },
    //     { x: 2.58992805755396, y: 2.74509803921569, size: 1 },
    //     { x: 10.3597122302158, y: 3.92156862745098, size: 1 },
    //     { x: 35.6115107913669, y: 4.03921568627451, size: 1 },
    //     { x: 44.0287769784173, y: 2.07843137254902, size: 1 },
    //     { x: 44.6762589928058, y: 2.19607843137255, size: 1 },
    //     { x: 65.3956834532374, y: 3.01960784313725, size: 1 },
    //     { x: 71.2230215827338, y: 4.15686274509804, size: 1 },
    //     { x: 75.7553956834532, y: 4.07843137254902, size: 1 },
    //     { x: 89.3525179856115, y: 4.03921568627451, size: 1 },
    //     { x: 97.1223021582734, y: 4, size: 1 },
    //     { x: 112.014388489209, y: 4.07843137254902, size: 1 },
    //     { x: 135.971223021583, y: 4.03921568627451, size: 1 },
    //     { x: 137.26618705036, y: 3.96078431372549, size: 1 },
    //     { x: 172.877697841727, y: 3.2156862745098, size: 1 },
    //     { x: 173.525179856115, y: 2.90196078431373, size: 1 },
    //     { x: 174.172661870504, y: 3.17647058823529, size: 1 },
    //     { x: 174.820143884892, y: 3.05882352941176, size: 1 },
    //     { x: 175.467625899281, y: 2.98039215686275, size: 1 },
    //     { x: 216.906474820144, y: 3.25490196078431, size: 1 },
    //     { x: 217.553956834532, y: 3.17647058823529, size: 1 },
    //     { x: 247.338129496403, y: 3.96078431372549, size: 1 },
    //     { x: 253.812949640288, y: 4.15686274509804, size: 1 },
    //     { x: 266.115107913669, y: 4.03921568627451, size: 1 },
    //     { x: 277.769784172662, y: 3.84313725490196, size: 1 },
    //     { x: 289.424460431655, y: 4.07843137254902, size: 1 },
    //     { x: 291.36690647482, y: 4.15686274509804, size: 1 },
    //     { x: 28.4892086330935, y: 3.2156862745098, size: 1 },
    //     { x: 29.7841726618705, y: 2.94117647058824, size: 1 },
    //     { x: 30.431654676259, y: 2.86274509803922, size: 1 },
    //     { x: 31.0791366906475, y: 2.74509803921569, size: 1 },
    //     { x: 36.2589928057554, y: 3.84313725490196, size: 1 },
    //     { x: 93.8848920863309, y: 3.13725490196078, size: 1 },
    //     { x: 103.597122302158, y: 4.03921568627451, size: 1 },
    //     { x: 127.553956834532, y: 3.33333333333333, size: 1 },
    //     { x: 135.323741007194, y: 3.25490196078431, size: 1 },
    //     { x: 137.26618705036, y: 3.01960784313725, size: 1 },
    //     { x: 137.913669064748, y: 3.05882352941176, size: 1 },
    //     { x: 140.503597122302, y: 3.92156862745098, size: 1 },
    //     { x: 178.705035971223, y: 3.88235294117647, size: 1 },
    //     { x: 215.611510791367, y: 3.88235294117647, size: 1 },
    //     { x: 238.273381294964, y: 3.84313725490196, size: 1 },
    //     { x: 266.762589928058, y: 3.17647058823529, size: 1 },
    //     { x: 267.410071942446, y: 2.86274509803922, size: 1 },
    //     { x: 288.776978417266, y: 2.98039215686275, size: 1 },
    //     { x: 352.877697841727, y: 2.23529411764706, size: 1 },
    //     { x: 353.525179856115, y: 1.25490196078431, size: 1 },
    //     { x: 354.172661870504, y: 1.17647058823529, size: 1 },
    //     { x: 354.820143884892, y: 1.09803921568627, size: 1 },
    //     { x: 358.057553956835, y: 3.01960784313725, size: 1 },
    //     { x: 23.9568345323741, y: 3.88235294117647, size: 1 },
    //     { x: 36.2589928057554, y: 2.43137254901961, size: 1 },
    //     { x: 36.9064748201439, y: 2.35294117647059, size: 1 },
    //     { x: 57.6258992805755, y: 2.58823529411765, size: 1 },
    //     { x: 58.273381294964, y: 2.19607843137255, size: 1 },
    //     { x: 78.9928057553957, y: 2.94117647058824, size: 1 },
    //     { x: 79.6402877697842, y: 1.56862745098039, size: 1 },
    //     { x: 80.2877697841727, y: 3.13725490196078, size: 1 },
    //     { x: 90.6474820143885, y: 4.03921568627451, size: 1 },
    //     { x: 95.1798561151079, y: 3.84313725490196, size: 1 },
    //     { x: 165.107913669065, y: 3.2156862745098, size: 1 },
    //     { x: 185.827338129496, y: 3.25490196078431, size: 1 },
    //     { x: 251.870503597122, y: 2.62745098039216, size: 1 },
    //     { x: 252.517985611511, y: 2.31372549019608, size: 1 },
    //     { x: 266.115107913669, y: 3.96078431372549, size: 1 },
    //     { x: 272.589928057554, y: 3.17647058823529, size: 1 },
    //     { x: 284.892086330935, y: 3.88235294117647, size: 1 },
    //     { x: 328.920863309353, y: 3.29411764705882, size: 1 },
    //     { x: 346.402877697842, y: 3.92156862745098, size: 1 },
    //     { x: 28.4892086330935, y: 4, size: 1 },
    //     { x: 30.431654676259, y: 3.92156862745098, size: 1 },
    //     { x: 117.194244604317, y: 4, size: 1 },
    //     { x: 160.575539568345, y: 4, size: 1 },
    //     { x: 194.244604316547, y: 3.13725490196078, size: 1 },
    //     { x: 195.539568345324, y: 3.29411764705882, size: 1 },
    //     { x: 196.187050359712, y: 3.05882352941176, size: 1 },
    //     { x: 216.258992805755, y: 3.09803921568627, size: 1 },
    //     { x: 237.625899280576, y: 2.50980392156863, size: 1 },
    //     { x: 238.273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 238.920863309353, y: 2.98039215686275, size: 1 },
    //     { x: 239.568345323741, y: 2.7843137254902, size: 1 },
    //     { x: 281.007194244604, y: 3.05882352941176, size: 1 },
    //     { x: 281.654676258993, y: 3.09803921568627, size: 1 },
    //     { x: 303.021582733813, y: 3.13725490196078, size: 1 },
    //     { x: 323.741007194245, y: 2.7843137254902, size: 1 },
    //     { x: 324.388489208633, y: 2.98039215686275, size: 1 },
    //     { x: 342.517985611511, y: 3.29411764705882, size: 1 },
    //     { x: 6.48648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 9.08108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 24, y: 3.96078431372549, size: 1 },
    //     { x: 29.1891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 31.7837837837838, y: 3.41176470588235, size: 1 },
    //     { x: 40.8648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 49.9459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 52.5405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 69.4054054054054, y: 4, size: 1 },
    //     { x: 73.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 79.7837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 81.0810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 82.3783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 84.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 85.6216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 91.4594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 92.7567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 93.4054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 94.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 115.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 116.756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 119.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 123.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 128.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 135.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 136.864864864865, y: 2.7843137254902, size: 1 },
    //     { x: 137.513513513514, y: 3.01960784313725, size: 1 },
    //     { x: 146.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 163.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 166.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 167.351351351351, y: 3.72549019607843, size: 1 },
    //     { x: 171.243243243243, y: 3.6078431372549, size: 1 },
    //     { x: 176.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 179.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 198.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 203.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 213.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 218.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 223.135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 223.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 224.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 228.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 237.405405405405, y: 3.76470588235294, size: 1 },
    //     { x: 241.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 245.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 247.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 247.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 252.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 255.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 256.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 256.864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 257.513513513513, y: 3.2156862745098, size: 1 },
    //     { x: 258.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 258.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 259.459459459459, y: 3.01960784313725, size: 1 },
    //     { x: 261.405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 262.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 263.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 266.594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 275.675675675676, y: 3.49019607843137, size: 1 },
    //     { x: 284.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 284.756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 297.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 309.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 310.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 320.432432432432, y: 3.49019607843137, size: 1 },
    //     { x: 326.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 328.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 330.162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 330.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 352.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 354.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 359.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 1.29496402877698, y: 3.96078431372549, size: 1 },
    //     { x: 8.41726618705036, y: 3.88235294117647, size: 1 },
    //     { x: 14.2446043165468, y: 2.90196078431373, size: 1 },
    //     { x: 17.4820143884892, y: 4.03921568627451, size: 1 },
    //     { x: 42.0863309352518, y: 3.96078431372549, size: 1 },
    //     { x: 86.1151079136691, y: 4, size: 1 },
    //     { x: 97.7697841726619, y: 3.92156862745098, size: 1 },
    //     { x: 101.007194244604, y: 3.05882352941176, size: 1 },
    //     { x: 143.741007194245, y: 3.09803921568627, size: 1 },
    //     { x: 144.388489208633, y: 3.05882352941176, size: 1 },
    //     { x: 161.870503597122, y: 3.92156862745098, size: 1 },
    //     { x: 165.107913669065, y: 3.29411764705882, size: 1 },
    //     { x: 165.755395683453, y: 3.17647058823529, size: 1 },
    //     { x: 272.589928057554, y: 3.2156862745098, size: 1 },
    //     { x: 273.237410071942, y: 2.62745098039216, size: 1 },
    //     { x: 273.884892086331, y: 2.62745098039216, size: 1 },
    //     { x: 274.532374100719, y: 2.62745098039216, size: 1 },
    //     { x: 275.179856115108, y: 2.47058823529412, size: 1 },
    //     { x: 295.251798561151, y: 2.90196078431373, size: 1 },
    //     { x: 317.26618705036, y: 3.17647058823529, size: 1 },
    //     { x: 337.985611510791, y: 2.86274509803922, size: 1 },
    //     { x: 338.63309352518, y: 2.70588235294118, size: 1 },
    //     { x: 354.172661870504, y: 4.07843137254902, size: 1 },
    //     { x: 7.12230215827338, y: 3.88235294117647, size: 1 },
    //     { x: 42.7338129496403, y: 3.13725490196078, size: 1 },
    //     { x: 131.438848920863, y: 3.96078431372549, size: 1 },
    //     { x: 134.028776978417, y: 4.03921568627451, size: 1 },
    //     { x: 135.323741007194, y: 4, size: 1 },
    //     { x: 161.870503597122, y: 4.15686274509804, size: 1 },
    //     { x: 187.769784172662, y: 3.88235294117647, size: 1 },
    //     { x: 236.978417266187, y: 2.27450980392157, size: 1 },
    //     { x: 237.625899280576, y: 2.27450980392157, size: 1 },
    //     { x: 258.992805755396, y: 3.01960784313725, size: 1 },
    //     { x: 279.064748201439, y: 3.17647058823529, size: 1 },
    //     { x: 279.712230215827, y: 3.09803921568627, size: 1 },
    //     { x: 280.359712230216, y: 1.37254901960784, size: 1 },
    //     { x: 281.007194244604, y: 1.37254901960784, size: 1 },
    //     { x: 302.374100719424, y: 2.43137254901961, size: 1 },
    //     { x: 322.446043165468, y: 3.17647058823529, size: 1 },
    //     { x: 324.388489208633, y: 4.11764705882353, size: 1 },
    //     { x: 329.568345323741, y: 3.88235294117647, size: 1 },
    //     { x: 345.755395683453, y: 2.86274509803922, size: 1 },
    //     { x: 349.640287769784, y: 3.96078431372549, size: 1 },
    //     { x: 359.352517985611, y: 3.33333333333333, size: 1 },
    //     { x: 26.5467625899281, y: 2.7843137254902, size: 1 },
    //     { x: 27.1942446043165, y: 3.01960784313725, size: 1 },
    //     { x: 51.1510791366906, y: 3.92156862745098, size: 1 },
    //     { x: 51.7985611510791, y: 4, size: 1 },
    //     { x: 77.6978417266187, y: 4.03921568627451, size: 1 },
    //     { x: 90.6474820143885, y: 4.07843137254902, size: 1 },
    //     { x: 91.294964028777, y: 3.25490196078431, size: 1 },
    //     { x: 91.9424460431655, y: 3.09803921568627, size: 1 },
    //     { x: 112.014388489209, y: 4, size: 1 },
    //     { x: 113.956834532374, y: 2.94117647058824, size: 1 },
    //     { x: 114.604316546763, y: 2.47058823529412, size: 1 },
    //     { x: 115.251798561151, y: 2.70588235294118, size: 1 },
    //     { x: 157.338129496403, y: 3.05882352941176, size: 1 },
    //     { x: 157.985611510791, y: 2.7843137254902, size: 1 },
    //     { x: 270.647482014389, y: 3.88235294117647, size: 1 },
    //     { x: 352.230215827338, y: 3.01960784313725, size: 1 },
    //     { x: 352.877697841727, y: 3.13725490196078, size: 1 },
    //     { x: 11.6756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 12.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 13.6216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 14.2702702702703, y: 2.54901960784314, size: 1 },
    //     { x: 14.9189189189189, y: 2.70588235294118, size: 1 },
    //     { x: 15.5675675675676, y: 2.90196078431373, size: 1 },
    //     { x: 35.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 35.6756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 44.7567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 51.8918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 66.1621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 68.1081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 84.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 109.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 129.081081081081, y: 3.76470588235294, size: 1 },
    //     { x: 134.918918918919, y: 3.64705882352941, size: 1 },
    //     { x: 145.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 146.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 149.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 153.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 163.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 164.756756756757, y: 2.86274509803922, size: 1 },
    //     { x: 165.405405405405, y: 3.17647058823529, size: 1 },
    //     { x: 166.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 167.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 170.594594594595, y: 3.56862745098039, size: 1 },
    //     { x: 186.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 188.108108108108, y: 2.90196078431373, size: 1 },
    //     { x: 188.756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 189.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 192.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 193.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 199.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 207.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 208.216216216216, y: 2.3921568627451, size: 1 },
    //     { x: 208.864864864865, y: 2.74509803921569, size: 1 },
    //     { x: 209.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 210.162162162162, y: 2.82352941176471, size: 1 },
    //     { x: 230.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 238.702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 245.837837837838, y: 3.56862745098039, size: 1 },
    //     { x: 261.405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 264.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 271.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 273.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 273.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 282.810810810811, y: 3.76470588235294, size: 1 },
    //     { x: 289.945945945946, y: 4, size: 1 },
    //     { x: 302.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 312, y: 3.80392156862745, size: 1 },
    //     { x: 312.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 334.054054054054, y: 3.49019607843137, size: 1 },
    //     { x: 352.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 3.01960784313725, size: 1 },
    //     { x: 86.1151079136691, y: 3.09803921568627, size: 1 },
    //     { x: 86.7625899280576, y: 2.90196078431373, size: 1 },
    //     { x: 87.410071942446, y: 2.90196078431373, size: 1 },
    //     { x: 95.8273381294964, y: 4.03921568627451, size: 1 },
    //     { x: 129.496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 174.172661870504, y: 4, size: 1 },
    //     { x: 184.532374100719, y: 3.96078431372549, size: 1 },
    //     { x: 193.597122302158, y: 3.2156862745098, size: 1 },
    //     { x: 197.482014388489, y: 4.03921568627451, size: 1 },
    //     { x: 239.568345323741, y: 3.88235294117647, size: 1 },
    //     { x: 248.63309352518, y: 3.96078431372549, size: 1 },
    //     { x: 258.992805755396, y: 3.13725490196078, size: 1 },
    //     { x: 266.762589928058, y: 3.92156862745098, size: 1 },
    //     { x: 272.589928057554, y: 3.96078431372549, size: 1 },
    //     { x: 278.41726618705, y: 3.96078431372549, size: 1 },
    //     { x: 286.834532374101, y: 4.15686274509804, size: 1 },
    //     { x: 302.374100719424, y: 3.17647058823529, size: 1 },
    //     { x: 303.669064748201, y: 3.92156862745098, size: 1 },
    //     { x: 304.31654676259, y: 4, size: 1 },
    //     { x: 346.402877697842, y: 4.11764705882353, size: 1 },
    //     { x: 347.05035971223, y: 4, size: 1 },
    //     { x: 348.345323741007, y: 4.03921568627451, size: 1 },
    //     { x: 350.935251798561, y: 4.11764705882353, size: 1 },
    //     { x: 356.115107913669, y: 4.03921568627451, size: 1 },
    //     { x: 358.705035971223, y: 4, size: 1 },
    //     { x: 1.29496402877698, y: 4.3921568627451, size: 1 },
    //     { x: 1.94244604316547, y: 4.23529411764706, size: 1 },
    //     { x: 3.23741007194245, y: 4.07843137254902, size: 1 },
    //     { x: 7.12230215827338, y: 3.13725490196078, size: 1 },
    //     { x: 18.7769784172662, y: 4, size: 1 },
    //     { x: 28.4892086330935, y: 3.01960784313725, size: 1 },
    //     { x: 49.8561151079137, y: 3.17647058823529, size: 1 },
    //     { x: 66.6906474820144, y: 4, size: 1 },
    //     { x: 79.6402877697842, y: 3.96078431372549, size: 1 },
    //     { x: 88.0575539568345, y: 4, size: 1 },
    //     { x: 114.604316546763, y: 3.13725490196078, size: 1 },
    //     { x: 136.618705035971, y: 2.94117647058824, size: 1 },
    //     { x: 161.223021582734, y: 4.03921568627451, size: 1 },
    //     { x: 166.402877697842, y: 4.03921568627451, size: 1 },
    //     { x: 176.762589928058, y: 4.19607843137255, size: 1 },
    //     { x: 178.057553956835, y: 3.2156862745098, size: 1 },
    //     { x: 240.215827338129, y: 4.03921568627451, size: 1 },
    //     { x: 262.877697841727, y: 3.92156862745098, size: 1 },
    //     { x: 266.115107913669, y: 3.13725490196078, size: 1 },
    //     { x: 288.129496402878, y: 3.25490196078431, size: 1 },
    //     { x: 288.776978417266, y: 3.01960784313725, size: 1 },
    //     { x: 308.848920863309, y: 2.7843137254902, size: 1 },
    //     { x: 352.230215827338, y: 3.17647058823529, size: 1 },
    //     { x: 5.83783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 11.6756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 14.9189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 15.5675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 18.8108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 46.7027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 49.2972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 60.3243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 64.2162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 71.3513513513514, y: 3.68627450980392, size: 1 },
    //     { x: 75.2432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 97.2972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 99.2432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 99.8918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 103.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 109.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 112.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 112.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 116.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 143.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 149.837837837838, y: 4, size: 1 },
    //     { x: 150.486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 151.783783783784, y: 4.07843137254902, size: 1 },
    //     { x: 155.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 160.216216216216, y: 3.72549019607843, size: 1 },
    //     { x: 160.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 163.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 164.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 164.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 165.405405405405, y: 3.09803921568627, size: 1 },
    //     { x: 180.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 189.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 197.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 205.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 206.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 207.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 208.216216216216, y: 2.43137254901961, size: 1 },
    //     { x: 208.864864864865, y: 2.19607843137255, size: 1 },
    //     { x: 209.513513513514, y: 2.03921568627451, size: 1 },
    //     { x: 210.162162162162, y: 2, size: 1 },
    //     { x: 212.756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 213.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 217.297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 217.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 219.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 223.783783783784, y: 2.82352941176471, size: 1 },
    //     { x: 245.189189189189, y: 3.45098039215686, size: 1 },
    //     { x: 251.027027027027, y: 2.66666666666667, size: 1 },
    //     { x: 251.675675675676, y: 2.62745098039216, size: 1 },
    //     { x: 270.486486486487, y: 4, size: 1 },
    //     { x: 271.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 272.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 273.081081081081, y: 2.70588235294118, size: 1 },
    //     { x: 273.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 291.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 294.486486486487, y: 2.98039215686275, size: 1 },
    //     { x: 295.135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 301.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 304.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 310.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 312.648648648649, y: 4, size: 1 },
    //     { x: 316.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 317.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 319.135135135135, y: 3.76470588235294, size: 1 },
    //     { x: 321.72972972973, y: 3.72549019607843, size: 1 },
    //     { x: 326.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 329.513513513513, y: 4.03921568627451, size: 1 },
    //     { x: 336, y: 3.17647058823529, size: 1 },
    //     { x: 337.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 337.945945945946, y: 1.88235294117647, size: 1 },
    //     { x: 340.540540540541, y: 3.49019607843137, size: 1 },
    //     { x: 347.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 350.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 352.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 359.351351351351, y: 2.7843137254902, size: 1 },
    //     { x: 0, y: 2.74509803921569, size: 1 },
    //     { x: 4.53237410071942, y: 3.92156862745098, size: 1 },
    //     { x: 14.2446043165468, y: 3.96078431372549, size: 1 },
    //     { x: 42.0863309352518, y: 3.01960784313725, size: 1 },
    //     { x: 42.7338129496403, y: 2.94117647058824, size: 1 },
    //     { x: 43.3812949640288, y: 3.2156862745098, size: 1 },
    //     { x: 63.4532374100719, y: 3.01960784313725, size: 1 },
    //     { x: 64.1007194244604, y: 1.88235294117647, size: 1 },
    //     { x: 64.7482014388489, y: 1.92156862745098, size: 1 },
    //     { x: 129.496402877698, y: 2.98039215686275, size: 1 },
    //     { x: 193.597122302158, y: 3.05882352941176, size: 1 },
    //     { x: 226.618705035971, y: 3.92156862745098, size: 1 },
    //     { x: 238.273381294964, y: 2.82352941176471, size: 1 },
    //     { x: 238.920863309353, y: 3.2156862745098, size: 1 },
    //     { x: 258.345323741007, y: 2.98039215686275, size: 1 },
    //     { x: 258.992805755396, y: 3.09803921568627, size: 1 },
    //     { x: 259.640287769784, y: 2.90196078431373, size: 1 },
    //     { x: 270.647482014389, y: 3.92156862745098, size: 1 },
    //     { x: 271.294964028777, y: 4, size: 1 },
    //     { x: 274.532374100719, y: 3.84313725490196, size: 1 },
    //     { x: 311.438848920863, y: 3.92156862745098, size: 1 },
    //     { x: 312.086330935252, y: 3.92156862745098, size: 1 },
    //     { x: 323.741007194245, y: 3.13725490196078, size: 1 },
    //     { x: 341.870503597122, y: 3.92156862745098, size: 1 },
    //     { x: 344.460431654676, y: 2.74509803921569, size: 1 },
    //     { x: 345.107913669065, y: 2.7843137254902, size: 1 },
    //     { x: 346.402877697842, y: 2.47058823529412, size: 1 },
    //     { x: 347.05035971223, y: 2.94117647058824, size: 1 },
    //     { x: 7.12230215827338, y: 3.25490196078431, size: 1 },
    //     { x: 7.76978417266187, y: 3.88235294117647, size: 1 },
    //     { x: 49.8561151079137, y: 3.09803921568627, size: 1 },
    //     { x: 62.158273381295, y: 4.03921568627451, size: 1 },
    //     { x: 70.5755395683453, y: 3.05882352941176, size: 1 },
    //     { x: 121.726618705036, y: 3.96078431372549, size: 1 },
    //     { x: 141.151079136691, y: 3.96078431372549, size: 1 },
    //     { x: 179.352517985612, y: 3.2156862745098, size: 1 },
    //     { x: 194.244604316547, y: 4, size: 1 },
    //     { x: 200.071942446043, y: 3.01960784313725, size: 1 },
    //     { x: 200.719424460432, y: 2.82352941176471, size: 1 },
    //     { x: 203.956834532374, y: 4, size: 1 },
    //     { x: 222.086330935252, y: 2.82352941176471, size: 1 },
    //     { x: 227.913669064748, y: 3.33333333333333, size: 1 },
    //     { x: 243.453237410072, y: 3.05882352941176, size: 1 },
    //     { x: 244.10071942446, y: 3.01960784313725, size: 1 },
    //     { x: 264.820143884892, y: 3.13725490196078, size: 1 },
    //     { x: 265.467625899281, y: 1.64705882352941, size: 1 },
    //     { x: 279.064748201439, y: 4.11764705882353, size: 1 },
    //     { x: 295.89928057554, y: 4.15686274509804, size: 1 },
    //     { x: 317.913669064748, y: 4.07843137254902, size: 1 },
    //     { x: 330.215827338129, y: 2.7843137254902, size: 1 },
    //     { x: 28.4892086330935, y: 4.03921568627451, size: 1 },
    //     { x: 42.0863309352518, y: 3.92156862745098, size: 1 },
    //     { x: 47.9136690647482, y: 4, size: 1 },
    //     { x: 53.7410071942446, y: 4.15686274509804, size: 1 },
    //     { x: 56.9784172661871, y: 3.13725490196078, size: 1 },
    //     { x: 78.3453237410072, y: 3.01960784313725, size: 1 },
    //     { x: 88.705035971223, y: 3.96078431372549, size: 1 },
    //     { x: 115.89928057554, y: 4.03921568627451, size: 1 },
    //     { x: 121.079136690647, y: 2.94117647058824, size: 1 },
    //     { x: 121.726618705036, y: 2.98039215686275, size: 1 },
    //     { x: 128.848920863309, y: 3.92156862745098, size: 1 },
    //     { x: 142.446043165468, y: 2.74509803921569, size: 1 },
    //     { x: 157.338129496403, y: 4.03921568627451, size: 1 },
    //     { x: 185.827338129496, y: 2.82352941176471, size: 1 },
    //     { x: 186.474820143885, y: 2.86274509803922, size: 1 },
    //     { x: 196.834532374101, y: 4.03921568627451, size: 1 },
    //     { x: 197.482014388489, y: 4, size: 1 },
    //     { x: 250.575539568345, y: 2.19607843137255, size: 1 },
    //     { x: 251.223021582734, y: 2.58823529411765, size: 1 },
    //     { x: 260.935251798561, y: 4.03921568627451, size: 1 },
    //     { x: 271.294964028777, y: 4.03921568627451, size: 1 },
    //     { x: 315.323741007194, y: 3.09803921568627, size: 1 },
    //     { x: 0.648648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 5.18918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 9.08108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 10.3783783783784, y: 4, size: 1 },
    //     { x: 14.2702702702703, y: 3.72549019607843, size: 1 },
    //     { x: 15.5675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 19.4594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 20.1081081081081, y: 2.11764705882353, size: 1 },
    //     { x: 20.7567567567568, y: 2.11764705882353, size: 1 },
    //     { x: 25.9459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 26.5945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 36.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 40.2162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 41.5135135135135, y: 2.7843137254902, size: 1 },
    //     { x: 42.1621621621622, y: 2.94117647058824, size: 1 },
    //     { x: 47.3513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 48, y: 3.2156862745098, size: 1 },
    //     { x: 48.6486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 54.4864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 62.2702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 62.9189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 64.2162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 68.1081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 82.3783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 85.6216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 88.2162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 88.8648648648649, y: 3.52941176470588, size: 1 },
    //     { x: 99.2432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 104.432432432432, y: 3.52941176470588, size: 1 },
    //     { x: 105.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 107.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 115.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 127.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 128.432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 133.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 138.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 143.351351351351, y: 4, size: 1 },
    //     { x: 147.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 149.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 150.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 156.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 171.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 193.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 196.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 204.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 205.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 210.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 213.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 214.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 215.351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 216, y: 3.09803921568627, size: 1 },
    //     { x: 230.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 241.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 244.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 253.621621621622, y: 4, size: 1 },
    //     { x: 261.405405405405, y: 3.72549019607843, size: 1 },
    //     { x: 262.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 265.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 266.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 269.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 272.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 275.027027027027, y: 4.07843137254902, size: 1 },
    //     { x: 282.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 284.756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 297.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 299.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 299.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 321.72972972973, y: 3.37254901960784, size: 1 },
    //     { x: 322.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 323.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 329.513513513513, y: 3.29411764705882, size: 1 },
    //     { x: 347.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 347.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 354.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 356.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 358.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 19.4244604316547, y: 3.09803921568627, size: 1 },
    //     { x: 49.2086330935252, y: 3.13725490196078, size: 1 },
    //     { x: 49.8561151079137, y: 3.05882352941176, size: 1 },
    //     { x: 92.589928057554, y: 3.09803921568627, size: 1 },
    //     { x: 109.424460431655, y: 3.92156862745098, size: 1 },
    //     { x: 112.014388489209, y: 3.29411764705882, size: 1 },
    //     { x: 113.956834532374, y: 2.54901960784314, size: 1 },
    //     { x: 114.604316546763, y: 2.43137254901961, size: 1 },
    //     { x: 135.323741007194, y: 3.13725490196078, size: 1 },
    //     { x: 156.690647482014, y: 3.01960784313725, size: 1 },
    //     { x: 157.338129496403, y: 1.88235294117647, size: 1 },
    //     { x: 177.410071942446, y: 3.13725490196078, size: 1 },
    //     { x: 178.705035971223, y: 2.19607843137255, size: 1 },
    //     { x: 179.352517985612, y: 2, size: 1 },
    //     { x: 185.179856115108, y: 4.27450980392157, size: 1 },
    //     { x: 187.122302158273, y: 4, size: 1 },
    //     { x: 187.769784172662, y: 3.96078431372549, size: 1 },
    //     { x: 192.94964028777, y: 3.88235294117647, size: 1 },
    //     { x: 221.438848920863, y: 3.01960784313725, size: 1 },
    //     { x: 222.086330935252, y: 2.35294117647059, size: 1 },
    //     { x: 239.568345323741, y: 3.92156862745098, size: 1 },
    //     { x: 243.453237410072, y: 2.7843137254902, size: 1 },
    //     { x: 244.10071942446, y: 2.62745098039216, size: 1 },
    //     { x: 264.820143884892, y: 2.7843137254902, size: 1 },
    //     { x: 265.467625899281, y: 2.23529411764706, size: 1 },
    //     { x: 288.776978417266, y: 4, size: 1 },
    //     { x: 329.568345323741, y: 2.62745098039216, size: 1 },
    //     { x: 12.9496402877698, y: 2.23529411764706, size: 1 },
    //     { x: 13.5971223021583, y: 2.54901960784314, size: 1 },
    //     { x: 56.3309352517986, y: 3.17647058823529, size: 1 },
    //     { x: 176.762589928058, y: 3.2156862745098, size: 1 },
    //     { x: 203.309352517986, y: 4, size: 1 },
    //     { x: 206.546762589928, y: 3.25490196078431, size: 1 },
    //     { x: 209.136690647482, y: 2.90196078431373, size: 1 },
    //     { x: 222.73381294964, y: 3.96078431372549, size: 1 },
    //     { x: 229.208633093525, y: 3.01960784313725, size: 1 },
    //     { x: 229.856115107914, y: 3.13725490196078, size: 1 },
    //     { x: 230.503597122302, y: 3.13725490196078, size: 1 },
    //     { x: 271.294964028777, y: 3.25490196078431, size: 1 },
    //     { x: 271.942446043165, y: 2.43137254901961, size: 1 },
    //     { x: 272.589928057554, y: 2.47058823529412, size: 1 },
    //     { x: 273.237410071942, y: 1.56862745098039, size: 1 },
    //     { x: 301.079136690647, y: 4.07843137254902, size: 1 },
    //     { x: 302.374100719424, y: 4, size: 1 },
    //     { x: 304.31654676259, y: 3.96078431372549, size: 1 },
    //     { x: 315.323741007194, y: 3.17647058823529, size: 1 },
    //     { x: 321.151079136691, y: 3.96078431372549, size: 1 },
    //     { x: 330.863309352518, y: 4.07843137254902, size: 1 },
    //     { x: 358.057553956835, y: 3.2156862745098, size: 1 },
    //     { x: 56.9784172661871, y: 3.88235294117647, size: 1 },
    //     { x: 62.8057553956835, y: 3.17647058823529, size: 1 },
    //     { x: 82.8776978417266, y: 3.17647058823529, size: 1 },
    //     { x: 85.4676258992806, y: 3.17647058823529, size: 1 },
    //     { x: 103.597122302158, y: 4, size: 1 },
    //     { x: 106.187050359712, y: 3.05882352941176, size: 1 },
    //     { x: 106.834532374101, y: 3.09803921568627, size: 1 },
    //     { x: 119.136690647482, y: 3.2156862745098, size: 1 },
    //     { x: 128.201438848921, y: 3.33333333333333, size: 1 },
    //     { x: 130.791366906475, y: 4, size: 1 },
    //     { x: 139.856115107914, y: 4.07843137254902, size: 1 },
    //     { x: 148.920863309353, y: 3.13725490196078, size: 1 },
    //     { x: 149.568345323741, y: 2.86274509803922, size: 1 },
    //     { x: 152.158273381295, y: 4, size: 1 },
    //     { x: 170.935251798561, y: 2.7843137254902, size: 1 },
    //     { x: 171.58273381295, y: 3.09803921568627, size: 1 },
    //     { x: 207.841726618705, y: 4, size: 1 },
    //     { x: 245.395683453237, y: 4.07843137254902, size: 1 },
    //     { x: 253.812949640288, y: 3.96078431372549, size: 1 },
    //     { x: 257.697841726619, y: 2.98039215686275, size: 1 },
    //     { x: 327.625899280576, y: 4.03921568627451, size: 1 },
    //     { x: 334.748201438849, y: 4.27450980392157, size: 1 },
    //     { x: 335.395683453237, y: 4, size: 1 },
    //     { x: 343.165467625899, y: 3.25490196078431, size: 1 },
    //     { x: 344.460431654676, y: 2.94117647058824, size: 1 },
    //     { x: 345.107913669065, y: 3.01960784313725, size: 1 },
    //     { x: 345.755395683453, y: 3.2156862745098, size: 1 },
    //     { x: 346.402877697842, y: 3.13725490196078, size: 1 },
    //     { x: 7.12230215827338, y: 3.09803921568627, size: 1 },
    //     { x: 11.0071942446043, y: 3.88235294117647, size: 1 },
    //     { x: 23.3093525179856, y: 4.03921568627451, size: 1 },
    //     { x: 36.2589928057554, y: 3.96078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 3.09803921568627, size: 1 },
    //     { x: 51.1510791366906, y: 4, size: 1 },
    //     { x: 69.2805755395683, y: 3.17647058823529, size: 1 },
    //     { x: 69.9280575539568, y: 3.13725490196078, size: 1 },
    //     { x: 151.510791366906, y: 3.96078431372549, size: 1 },
    //     { x: 157.338129496403, y: 3.13725490196078, size: 1 },
    //     { x: 158.63309352518, y: 3.25490196078431, size: 1 },
    //     { x: 167.05035971223, y: 3.96078431372549, size: 1 },
    //     { x: 179.352517985612, y: 3.29411764705882, size: 1 },
    //     { x: 191.654676258993, y: 3.2156862745098, size: 1 },
    //     { x: 201.36690647482, y: 3.13725490196078, size: 1 },
    //     { x: 202.014388489209, y: 3.09803921568627, size: 1 },
    //     { x: 205.251798561151, y: 3.05882352941176, size: 1 },
    //     { x: 222.086330935252, y: 3.05882352941176, size: 1 },
    //     { x: 247.985611510791, y: 4.03921568627451, size: 1 },
    //     { x: 249.928057553957, y: 4, size: 1 },
    //     { x: 309.496402877698, y: 2.94117647058824, size: 1 },
    //     { x: 7.13513513513514, y: 3.80392156862745, size: 1 },
    //     { x: 12.3243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 14.2702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 24.6486486486486, y: 3.84313725490196, size: 1 },
    //     { x: 26.5945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 35.6756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 48.6486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 55.1351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 55.7837837837838, y: 2.74509803921569, size: 1 },
    //     { x: 56.4324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 57.0810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 66.1621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 75.2432432432432, y: 3.41176470588235, size: 1 },
    //     { x: 78.4864864864865, y: 2.90196078431373, size: 1 },
    //     { x: 79.1351351351351, y: 2.74509803921569, size: 1 },
    //     { x: 105.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 116.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 118.702702702703, y: 3.45098039215686, size: 1 },
    //     { x: 120, y: 2.98039215686275, size: 1 },
    //     { x: 120.648648648649, y: 2.70588235294118, size: 1 },
    //     { x: 121.297297297297, y: 2.86274509803922, size: 1 },
    //     { x: 121.945945945946, y: 2.70588235294118, size: 1 },
    //     { x: 122.594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 131.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 135.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 146.594594594595, y: 3.72549019607843, size: 1 },
    //     { x: 149.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 157.621621621622, y: 3.52941176470588, size: 1 },
    //     { x: 164.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 164.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 166.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 166.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 168, y: 3.41176470588235, size: 1 },
    //     { x: 181.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 182.27027027027, y: 3.45098039215686, size: 1 },
    //     { x: 183.567567567568, y: 3.68627450980392, size: 1 },
    //     { x: 186.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 195.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 199.135135135135, y: 3.41176470588235, size: 1 },
    //     { x: 205.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 206.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 210.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 216.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 218.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 220.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 227.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 228.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 229.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 230.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 253.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 257.513513513513, y: 3.88235294117647, size: 1 },
    //     { x: 260.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 266.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 274.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 276.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 280.216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 292.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 293.189189189189, y: 2.70588235294118, size: 1 },
    //     { x: 293.837837837838, y: 2.86274509803922, size: 1 },
    //     { x: 294.486486486487, y: 2.54901960784314, size: 1 },
    //     { x: 315.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 316.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 331.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 339.243243243243, y: 4, size: 1 },
    //     { x: 347.675675675676, y: 3.45098039215686, size: 1 },
    //     { x: 348.972972972973, y: 3.49019607843137, size: 1 },
    //     { x: 355.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 358.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 19.4244604316547, y: 3.25490196078431, size: 1 },
    //     { x: 20.7194244604317, y: 2.90196078431373, size: 1 },
    //     { x: 22.0143884892086, y: 3.09803921568627, size: 1 },
    //     { x: 41.4388489208633, y: 3.01960784313725, size: 1 },
    //     { x: 42.7338129496403, y: 2.98039215686275, size: 1 },
    //     { x: 43.3812949640288, y: 3.09803921568627, size: 1 },
    //     { x: 58.273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 62.8057553956835, y: 0.980392156862745, size: 1 },
    //     { x: 63.4532374100719, y: 1.2156862745098, size: 1 },
    //     { x: 64.1007194244604, y: 1.01960784313725, size: 1 },
    //     { x: 64.7482014388489, y: 1.09803921568627, size: 1 },
    //     { x: 67.3381294964029, y: 3.17647058823529, size: 1 },
    //     { x: 71.8705035971223, y: 2.94117647058824, size: 1 },
    //     { x: 72.5179856115108, y: 2.94117647058824, size: 1 },
    //     { x: 78.9928057553957, y: 3.13725490196078, size: 1 },
    //     { x: 84.1726618705036, y: 2.98039215686275, size: 1 },
    //     { x: 84.8201438848921, y: 2.62745098039216, size: 1 },
    //     { x: 106.187050359712, y: 2.90196078431373, size: 1 },
    //     { x: 127.553956834532, y: 2.98039215686275, size: 1 },
    //     { x: 128.201438848921, y: 2.7843137254902, size: 1 },
    //     { x: 148.920863309353, y: 2.82352941176471, size: 1 },
    //     { x: 149.568345323741, y: 2.82352941176471, size: 1 },
    //     { x: 170.287769784173, y: 2.98039215686275, size: 1 },
    //     { x: 170.935251798561, y: 2.82352941176471, size: 1 },
    //     { x: 171.58273381295, y: 3.17647058823529, size: 1 },
    //     { x: 192.302158273381, y: 2.50980392156863, size: 1 },
    //     { x: 207.194244604317, y: 3.88235294117647, size: 1 },
    //     { x: 214.31654676259, y: 2.86274509803922, size: 1 },
    //     { x: 229.856115107914, y: 4.35294117647059, size: 1 },
    //     { x: 274.532374100719, y: 4, size: 1 },
    //     { x: 277.769784172662, y: 3.09803921568627, size: 1 },
    //     { x: 278.41726618705, y: 2.03921568627451, size: 1 },
    //     { x: 279.064748201439, y: 1.80392156862745, size: 1 },
    //     { x: 284.244604316547, y: 4.35294117647059, size: 1 },
    //     { x: 299.136690647482, y: 3.01960784313725, size: 1 },
    //     { x: 299.784172661871, y: 3.05882352941176, size: 1 },
    //     { x: 300.431654676259, y: 2.27450980392157, size: 1 },
    //     { x: 337.338129496403, y: 3.88235294117647, size: 1 },
    //     { x: 49.8561151079137, y: 3.13725490196078, size: 1 },
    //     { x: 50.5035971223022, y: 3.09803921568627, size: 1 },
    //     { x: 58.9208633093525, y: 3.25490196078431, size: 1 },
    //     { x: 113.309352517986, y: 3.09803921568627, size: 1 },
    //     { x: 134.676258992806, y: 2.90196078431373, size: 1 },
    //     { x: 174.172661870504, y: 3.96078431372549, size: 1 },
    //     { x: 183.237410071942, y: 4.11764705882353, size: 1 },
    //     { x: 199.424460431655, y: 2.86274509803922, size: 1 },
    //     { x: 200.719424460432, y: 2.86274509803922, size: 1 },
    //     { x: 201.36690647482, y: 2.90196078431373, size: 1 },
    //     { x: 220.791366906475, y: 3.05882352941176, size: 1 },
    //     { x: 221.438848920863, y: 2.74509803921569, size: 1 },
    //     { x: 222.086330935252, y: 2.70588235294118, size: 1 },
    //     { x: 245.395683453237, y: 4.03921568627451, size: 1 },
    //     { x: 306.906474820144, y: 2.86274509803922, size: 1 },
    //     { x: 308.201438848921, y: 2.70588235294118, size: 1 },
    //     { x: 308.848920863309, y: 2.54901960784314, size: 1 },
    //     { x: 309.496402877698, y: 3.2156862745098, size: 1 },
    //     { x: 310.143884892086, y: 3.13725490196078, size: 1 },
    //     { x: 310.791366906475, y: 3.13725490196078, size: 1 },
    //     { x: 314.028776978417, y: 3.25490196078431, size: 1 },
    //     { x: 321.798561151079, y: 3.05882352941176, size: 1 },
    //     { x: 328.273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 328.920863309353, y: 2.86274509803922, size: 1 },
    //     { x: 329.568345323741, y: 2.82352941176471, size: 1 },
    //     { x: 349.640287769784, y: 3.92156862745098, size: 1 },
    //     { x: 350.287769784173, y: 2.90196078431373, size: 1 },
    //     { x: 356.762589928058, y: 4.03921568627451, size: 1 },
    //     { x: 5.18918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 7.13513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 7.78378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 12.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 13.6216216216216, y: 2.86274509803922, size: 1 },
    //     { x: 14.9189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 18.8108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 34.3783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 38.2702702702703, y: 3.41176470588235, size: 1 },
    //     { x: 55.1351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 55.7837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 58.3783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 59.6756756756757, y: 3.49019607843137, size: 1 },
    //     { x: 71.3513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 75.8918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 78.4864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 79.1351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 80.4324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 81.0810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 85.6216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 86.2702702702703, y: 3.76470588235294, size: 1 },
    //     { x: 90.8108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 91.4594594594595, y: 4, size: 1 },
    //     { x: 92.1081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 94.7027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 96, y: 3.92156862745098, size: 1 },
    //     { x: 96.6486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 97.2972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 97.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 99.8918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 118.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 139.459459459459, y: 3.49019607843137, size: 1 },
    //     { x: 148.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 151.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 153.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 153.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 155.675675675676, y: 4, size: 1 },
    //     { x: 177.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 206.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 212.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 227.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 228.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 231.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 232.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 235.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 242.594594594595, y: 4, size: 1 },
    //     { x: 244.540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 245.189189189189, y: 3.80392156862745, size: 1 },
    //     { x: 251.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 271.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 272.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 273.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 293.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 294.486486486487, y: 3.09803921568627, size: 1 },
    //     { x: 295.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 317.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 330.810810810811, y: 3.49019607843137, size: 1 },
    //     { x: 334.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 334.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 336.648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 337.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 337.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 340.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 342.486486486487, y: 4, size: 1 },
    //     { x: 344.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 357.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 358.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 358.702702702703, y: 2.74509803921569, size: 1 },
    //     { x: 359.351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 0, y: 2.66666666666667, size: 1 },
    //     { x: 0.647482014388489, y: 4, size: 1 },
    //     { x: 5.8273381294964, y: 4.27450980392157, size: 1 },
    //     { x: 22.0143884892086, y: 3.96078431372549, size: 1 },
    //     { x: 26.5467625899281, y: 3.92156862745098, size: 1 },
    //     { x: 37.5539568345324, y: 3.88235294117647, size: 1 },
    //     { x: 64.7482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 71.8705035971223, y: 4, size: 1 },
    //     { x: 81.5827338129496, y: 3.92156862745098, size: 1 },
    //     { x: 128.201438848921, y: 3.25490196078431, size: 1 },
    //     { x: 128.848920863309, y: 3.13725490196078, size: 1 },
    //     { x: 129.496402877698, y: 3.09803921568627, size: 1 },
    //     { x: 157.985611510791, y: 3.96078431372549, size: 1 },
    //     { x: 158.63309352518, y: 3.96078431372549, size: 1 },
    //     { x: 161.870503597122, y: 3.96078431372549, size: 1 },
    //     { x: 164.460431654676, y: 4.15686274509804, size: 1 },
    //     { x: 235.035971223022, y: 2.90196078431373, size: 1 },
    //     { x: 235.68345323741, y: 2.82352941176471, size: 1 },
    //     { x: 236.330935251799, y: 3.09803921568627, size: 1 },
    //     { x: 236.978417266187, y: 3.01960784313725, size: 1 },
    //     { x: 241.510791366906, y: 3.01960784313725, size: 1 },
    //     { x: 247.985611510791, y: 3.13725490196078, size: 1 },
    //     { x: 251.223021582734, y: 3.25490196078431, size: 1 },
    //     { x: 251.870503597122, y: 3.17647058823529, size: 1 },
    //     { x: 253.165467625899, y: 3.01960784313725, size: 1 },
    //     { x: 254.460431654676, y: 3.41176470588235, size: 1 },
    //     { x: 258.345323741007, y: 3.2156862745098, size: 1 },
    //     { x: 279.064748201439, y: 2.90196078431373, size: 1 },
    //     { x: 286.187050359712, y: 4, size: 1 },
    //     { x: 323.741007194245, y: 2.98039215686275, size: 1 },
    //     { x: 339.280575539568, y: 3.17647058823529, size: 1 },
    //     { x: 343.165467625899, y: 3.01960784313725, size: 1 },
    //     { x: 343.812949640288, y: 2.98039215686275, size: 1 },
    //     { x: 345.107913669065, y: 2.82352941176471, size: 1 },
    //     { x: 71.2230215827338, y: 2.98039215686275, size: 1 },
    //     { x: 89.3525179856115, y: 3.25490196078431, size: 1 },
    //     { x: 90.6474820143885, y: 3.05882352941176, size: 1 },
    //     { x: 91.9424460431655, y: 2.70588235294118, size: 1 },
    //     { x: 93.2374100719424, y: 2.7843137254902, size: 1 },
    //     { x: 107.482014388489, y: 3.41176470588235, size: 1 },
    //     { x: 113.309352517986, y: 3.17647058823529, size: 1 },
    //     { x: 134.028776978417, y: 2.90196078431373, size: 1 },
    //     { x: 134.676258992806, y: 2.66666666666667, size: 1 },
    //     { x: 135.323741007194, y: 2.86274509803922, size: 1 },
    //     { x: 147.625899280576, y: 3.25490196078431, size: 1 },
    //     { x: 152.158273381295, y: 3.25490196078431, size: 1 },
    //     { x: 178.057553956835, y: 3.25490196078431, size: 1 },
    //     { x: 198.776978417266, y: 2.82352941176471, size: 1 },
    //     { x: 199.424460431655, y: 3.09803921568627, size: 1 },
    //     { x: 200.071942446043, y: 2.90196078431373, size: 1 },
    //     { x: 205.89928057554, y: 3.29411764705882, size: 1 },
    //     { x: 262.877697841727, y: 3.33333333333333, size: 1 },
    //     { x: 264.820143884892, y: 2.98039215686275, size: 1 },
    //     { x: 265.467625899281, y: 2.86274509803922, size: 1 },
    //     { x: 266.115107913669, y: 3.2156862745098, size: 1 },
    //     { x: 290.071942446043, y: 4.11764705882353, size: 1 },
    //     { x: 349.640287769784, y: 3.13725490196078, size: 1 },
    //     { x: 350.287769784173, y: 2.11764705882353, size: 1 },
    //     { x: 350.935251798561, y: 2.11764705882353, size: 1 },
    //     { x: 351.58273381295, y: 1.92156862745098, size: 1 },
    //     { x: 352.230215827338, y: 2.15686274509804, size: 1 },
    //     { x: 11.6546762589928, y: 2.31372549019608, size: 1 },
    //     { x: 12.3021582733813, y: 2.47058823529412, size: 1 },
    //     { x: 12.9496402877698, y: 2.50980392156863, size: 1 },
    //     { x: 13.5971223021583, y: 2.58823529411765, size: 1 },
    //     { x: 33.0215827338129, y: 2.74509803921569, size: 1 },
    //     { x: 33.6690647482014, y: 2.74509803921569, size: 1 },
    //     { x: 36.9064748201439, y: 4.07843137254902, size: 1 },
    //     { x: 42.7338129496403, y: 4.11764705882353, size: 1 },
    //     { x: 49.8561151079137, y: 3.96078431372549, size: 1 },
    //     { x: 54.3884892086331, y: 3.05882352941176, size: 1 },
    //     { x: 55.0359712230216, y: 2.50980392156863, size: 1 },
    //     { x: 55.6834532374101, y: 3.25490196078431, size: 1 },
    //     { x: 76.4028776978417, y: 2.27450980392157, size: 1 },
    //     { x: 77.0503597122302, y: 2.3921568627451, size: 1 },
    //     { x: 119.784172661871, y: 2.11764705882353, size: 1 },
    //     { x: 141.151079136691, y: 2.86274509803922, size: 1 },
    //     { x: 158.63309352518, y: 4, size: 1 },
    //     { x: 161.223021582734, y: 3.33333333333333, size: 1 },
    //     { x: 161.870503597122, y: 3.01960784313725, size: 1 },
    //     { x: 162.517985611511, y: 2.15686274509804, size: 1 },
    //     { x: 163.165467625899, y: 2.15686274509804, size: 1 },
    //     { x: 170.287769784173, y: 4.03921568627451, size: 1 },
    //     { x: 182.589928057554, y: 3.2156862745098, size: 1 },
    //     { x: 183.237410071942, y: 2.82352941176471, size: 1 },
    //     { x: 183.884892086331, y: 2.98039215686275, size: 1 },
    //     { x: 184.532374100719, y: 1.96078431372549, size: 1 },
    //     { x: 221.438848920863, y: 4, size: 1 },
    //     { x: 226.618705035971, y: 3.13725490196078, size: 1 },
    //     { x: 227.913669064748, y: 2.47058823529412, size: 1 },
    //     { x: 283.597122302158, y: 3.2156862745098, size: 1 },
    //     { x: 13.6216216216216, y: 3.6078431372549, size: 1 },
    //     { x: 18.8108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 19.4594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 20.1081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 21.4054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 24.6486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 35.6756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 40.8648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 42.1621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 45.4054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 50.5945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 61.6216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 62.2702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 62.9189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 70.054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 85.6216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 104.432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 105.081081081081, y: 2.94117647058824, size: 1 },
    //     { x: 106.378378378378, y: 2.86274509803922, size: 1 },
    //     { x: 112.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 127.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 127.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 128.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 129.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 145.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 148.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 149.837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 150.486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 155.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 161.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 171.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 171.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 199.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 201.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 201.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 213.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 214.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 215.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 233.513513513514, y: 3.45098039215686, size: 1 },
    //     { x: 234.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 235.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 239.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 240, y: 3.37254901960784, size: 1 },
    //     { x: 247.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 256.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 256.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 266.594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 270.486486486487, y: 3.37254901960784, size: 1 },
    //     { x: 278.27027027027, y: 2.15686274509804, size: 1 },
    //     { x: 278.918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 279.567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 280.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 290.594594594595, y: 3.49019607843137, size: 1 },
    //     { x: 302.918918918919, y: 4, size: 1 },
    //     { x: 313.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 337.945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 341.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 343.135135135135, y: 2.54901960784314, size: 1 },
    //     { x: 343.783783783784, y: 2.7843137254902, size: 1 },
    //     { x: 344.432432432432, y: 2.74509803921569, size: 1 },
    //     { x: 345.081081081081, y: 2.98039215686275, size: 1 },
    //     { x: 18.1294964028777, y: 4.15686274509804, size: 1 },
    //     { x: 24.6043165467626, y: 3.29411764705882, size: 1 },
    //     { x: 25.8992805755396, y: 2.90196078431373, size: 1 },
    //     { x: 26.5467625899281, y: 3.09803921568627, size: 1 },
    //     { x: 27.1942446043165, y: 3.13725490196078, size: 1 },
    //     { x: 27.841726618705, y: 2.54901960784314, size: 1 },
    //     { x: 35.6115107913669, y: 3.88235294117647, size: 1 },
    //     { x: 69.2805755395683, y: 3.01960784313725, size: 1 },
    //     { x: 90.6474820143885, y: 2.58823529411765, size: 1 },
    //     { x: 91.294964028777, y: 2.82352941176471, size: 1 },
    //     { x: 112.661870503597, y: 2.70588235294118, size: 1 },
    //     { x: 154.748201438849, y: 3.25490196078431, size: 1 },
    //     { x: 180, y: 4.03921568627451, size: 1 },
    //     { x: 195.539568345324, y: 3.92156862745098, size: 1 },
    //     { x: 242.158273381295, y: 2.70588235294118, size: 1 },
    //     { x: 242.805755395683, y: 2.86274509803922, size: 1 },
    //     { x: 243.453237410072, y: 3.01960784313725, size: 1 },
    //     { x: 244.10071942446, y: 3.13725490196078, size: 1 },
    //     { x: 251.870503597122, y: 3.92156862745098, size: 1 },
    //     { x: 281.654676258993, y: 4.07843137254902, size: 1 },
    //     { x: 306.258992805755, y: 2.7843137254902, size: 1 },
    //     { x: 306.906474820144, y: 2.27450980392157, size: 1 },
    //     { x: 307.553956834532, y: 2.35294117647059, size: 1 },
    //     { x: 308.848920863309, y: 2.43137254901961, size: 1 },
    //     { x: 337.985611510791, y: 3.88235294117647, size: 1 },
    //     { x: 347.697841726619, y: 4.03921568627451, size: 1 },
    //     { x: 349.640287769784, y: 3.25490196078431, size: 1 },
    //     { x: 350.287769784173, y: 3.17647058823529, size: 1 },
    //     { x: 104.244604316547, y: 3.17647058823529, size: 1 },
    //     { x: 111.36690647482, y: 3.2156862745098, size: 1 },
    //     { x: 115.251798561151, y: 3.25490196078431, size: 1 },
    //     { x: 162.517985611511, y: 2.54901960784314, size: 1 },
    //     { x: 163.165467625899, y: 2.54901960784314, size: 1 },
    //     { x: 174.172661870504, y: 4.11764705882353, size: 1 },
    //     { x: 220.791366906475, y: 3.92156862745098, size: 1 },
    //     { x: 233.741007194245, y: 4.11764705882353, size: 1 },
    //     { x: 242.158273381295, y: 4.07843137254902, size: 1 },
    //     { x: 244.748201438849, y: 4.07843137254902, size: 1 },
    //     { x: 248.63309352518, y: 2.86274509803922, size: 1 },
    //     { x: 249.280575539568, y: 3.01960784313725, size: 1 },
    //     { x: 272.589928057554, y: 3.13725490196078, size: 1 },
    //     { x: 281.007194244604, y: 4, size: 1 },
    //     { x: 285.539568345324, y: 4.03921568627451, size: 1 },
    //     { x: 314.676258992806, y: 3.05882352941176, size: 1 },
    //     { x: 336.690647482014, y: 3.13725490196078, size: 1 },
    //     { x: 337.338129496403, y: 3.17647058823529, size: 1 },
    //     { x: 337.985611510791, y: 4.07843137254902, size: 1 },
    //     { x: 18.1294964028777, y: 2.98039215686275, size: 1 },
    //     { x: 18.7769784172662, y: 2.86274509803922, size: 1 },
    //     { x: 19.4244604316547, y: 2.66666666666667, size: 1 },
    //     { x: 20.0719424460432, y: 2.86274509803922, size: 1 },
    //     { x: 24.6043165467626, y: 3.92156862745098, size: 1 },
    //     { x: 25.8992805755396, y: 4.23529411764706, size: 1 },
    //     { x: 26.5467625899281, y: 4, size: 1 },
    //     { x: 31.0791366906475, y: 3.88235294117647, size: 1 },
    //     { x: 31.726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 35.6115107913669, y: 3.96078431372549, size: 1 },
    //     { x: 49.8561151079137, y: 3.88235294117647, size: 1 },
    //     { x: 127.553956834532, y: 3.96078431372549, size: 1 },
    //     { x: 145.035971223022, y: 3.96078431372549, size: 1 },
    //     { x: 148.273381294964, y: 3.09803921568627, size: 1 },
    //     { x: 156.690647482014, y: 3.92156862745098, size: 1 },
    //     { x: 192.302158273381, y: 2.98039215686275, size: 1 },
    //     { x: 234.388489208633, y: 3.2156862745098, size: 1 },
    //     { x: 257.697841726619, y: 3.17647058823529, size: 1 },
    //     { x: 276.474820143885, y: 3.05882352941176, size: 1 },
    //     { x: 277.122302158273, y: 2.3921568627451, size: 1 },
    //     { x: 277.769784172662, y: 0.980392156862745, size: 1 },
    //     { x: 278.41726618705, y: 1.01960784313725, size: 1 },
    //     { x: 279.064748201439, y: 1.17647058823529, size: 1 },
    //     { x: 279.712230215827, y: 2.98039215686275, size: 1 },
    //     { x: 282.302158273381, y: 2.98039215686275, size: 1 },
    //     { x: 292.661870503597, y: 2.90196078431373, size: 1 },
    //     { x: 293.309352517986, y: 2.94117647058824, size: 1 },
    //     { x: 295.89928057554, y: 3.29411764705882, size: 1 },
    //     { x: 297.194244604317, y: 3.01960784313725, size: 1 },
    //     { x: 297.841726618705, y: 2.98039215686275, size: 1 },
    //     { x: 299.136690647482, y: 2.62745098039216, size: 1 },
    //     { x: 299.784172661871, y: 2.74509803921569, size: 1 },
    //     { x: 300.431654676259, y: 1.96078431372549, size: 1 },
    //     { x: 301.079136690647, y: 2.11764705882353, size: 1 },
    //     { x: 303.021582733813, y: 4, size: 1 },
    //     { x: 320.503597122302, y: 3.17647058823529, size: 1 },
    //     { x: 321.151079136691, y: 3.01960784313725, size: 1 },
    //     { x: 341.870503597122, y: 1.88235294117647, size: 1 },
    //     { x: 342.517985611511, y: 1.45098039215686, size: 1 },
    //     { x: 3.23741007194245, y: 2.82352941176471, size: 1 },
    //     { x: 3.88489208633094, y: 2.62745098039216, size: 1 },
    //     { x: 23.3093525179856, y: 3.92156862745098, size: 1 },
    //     { x: 67.9856115107914, y: 3.25490196078431, size: 1 },
    //     { x: 68.6330935251799, y: 2.66666666666667, size: 1 },
    //     { x: 69.2805755395683, y: 3.25490196078431, size: 1 },
    //     { x: 132.086330935252, y: 3.2156862745098, size: 1 },
    //     { x: 154.748201438849, y: 2.7843137254902, size: 1 },
    //     { x: 155.395683453237, y: 3.05882352941176, size: 1 },
    //     { x: 207.841726618705, y: 3.96078431372549, size: 1 },
    //     { x: 292.661870503597, y: 4, size: 1 },
    //     { x: 327.625899280576, y: 2.70588235294118, size: 1 },
    //     { x: 334.10071942446, y: 4.07843137254902, size: 1 },
    //     { x: 345.755395683453, y: 3.92156862745098, size: 1 },
    //     { x: 348.345323741007, y: 3.05882352941176, size: 1 },
    //     { x: 349.640287769784, y: 2.90196078431373, size: 1 },
    //     { x: 350.935251798561, y: 3.17647058823529, size: 1 },
    //     { x: 7.13513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 9.08108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 9.72972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 10.3783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 11.027027027027, y: 2.50980392156863, size: 1 },
    //     { x: 14.9189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 24, y: 3.25490196078431, size: 1 },
    //     { x: 29.8378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 32.4324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 53.8378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 55.1351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 55.7837837837838, y: 3.05882352941176, size: 1 },
    //     { x: 58.3783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 59.6756756756757, y: 3.41176470588235, size: 1 },
    //     { x: 62.9189189189189, y: 4.03921568627451, size: 1 },
    //     { x: 75.2432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 75.8918918918919, y: 2.70588235294118, size: 1 },
    //     { x: 77.8378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 79.1351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 81.0810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 82.3783783783784, y: 4, size: 1 },
    //     { x: 86.2702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 86.9189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 91.4594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 93.4054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 102.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 105.081081081081, y: 3.72549019607843, size: 1 },
    //     { x: 119.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 122.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 124.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 132.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 138.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 144.648648648649, y: 3.45098039215686, size: 1 },
    //     { x: 146.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 150.486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 153.72972972973, y: 3.41176470588235, size: 1 },
    //     { x: 161.513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 166.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 169.945945945946, y: 3.6078431372549, size: 1 },
    //     { x: 170.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 179.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 212.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 217.297297297297, y: 3.45098039215686, size: 1 },
    //     { x: 217.945945945946, y: 3.49019607843137, size: 1 },
    //     { x: 221.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 225.72972972973, y: 3.45098039215686, size: 1 },
    //     { x: 229.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 235.459459459459, y: 4, size: 1 },
    //     { x: 236.108108108108, y: 3.49019607843137, size: 1 },
    //     { x: 240.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 246.486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 248.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 249.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 249.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 273.72972972973, y: 4.03921568627451, size: 1 },
    //     { x: 276.324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 276.972972972973, y: 4, size: 1 },
    //     { x: 277.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 280.216216216216, y: 3.68627450980392, size: 1 },
    //     { x: 284.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 286.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 287.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 289.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 290.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 291.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 291.891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 293.189189189189, y: 2.74509803921569, size: 1 },
    //     { x: 312, y: 3.2156862745098, size: 1 },
    //     { x: 312.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 313.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 315.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 333.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 335.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 336.648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 345.081081081081, y: 3.41176470588235, size: 1 },
    //     { x: 345.72972972973, y: 3.56862745098039, size: 1 },
    //     { x: 354.162162162162, y: 4.15686274509804, size: 1 },
    //     { x: 357.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 358.702702702703, y: 3.37254901960784, size: 1 },
    //     { x: 12.3021582733813, y: 4.11764705882353, size: 1 },
    //     { x: 12.9496402877698, y: 4.03921568627451, size: 1 },
    //     { x: 60.863309352518, y: 3.05882352941176, size: 1 },
    //     { x: 80.9352517985612, y: 3.25490196078431, size: 1 },
    //     { x: 82.8776978417266, y: 2.90196078431373, size: 1 },
    //     { x: 83.5251798561151, y: 3.05882352941176, size: 1 },
    //     { x: 84.1726618705036, y: 2.62745098039216, size: 1 },
    //     { x: 84.8201438848921, y: 2.70588235294118, size: 1 },
    //     { x: 126.906474820144, y: 3.13725490196078, size: 1 },
    //     { x: 137.913669064748, y: 3.2156862745098, size: 1 },
    //     { x: 154.10071942446, y: 4.07843137254902, size: 1 },
    //     { x: 159.280575539568, y: 3.96078431372549, size: 1 },
    //     { x: 168.345323741007, y: 3.01960784313725, size: 1 },
    //     { x: 168.992805755396, y: 3.09803921568627, size: 1 },
    //     { x: 169.640287769784, y: 3.13725490196078, size: 1 },
    //     { x: 175.467625899281, y: 4, size: 1 },
    //     { x: 228.561151079137, y: 3.96078431372549, size: 1 },
    //     { x: 238.273381294964, y: 3.96078431372549, size: 1 },
    //     { x: 260.287769784173, y: 4.07843137254902, size: 1 },
    //     { x: 292.014388489209, y: 4, size: 1 },
    //     { x: 293.309352517986, y: 4.19607843137255, size: 1 },
    //     { x: 320.503597122302, y: 3.29411764705882, size: 1 },
    //     { x: 322.446043165468, y: 3.09803921568627, size: 1 },
    //     { x: 324.388489208633, y: 4.15686274509804, size: 1 },
    //     { x: 326.978417266187, y: 4.27450980392157, size: 1 },
    //     { x: 329.568345323741, y: 4.07843137254902, size: 1 },
    //     { x: 337.985611510791, y: 4, size: 1 },
    //     { x: 342.517985611511, y: 2.98039215686275, size: 1 },
    //     { x: 343.165467625899, y: 3.13725490196078, size: 1 },
    //     { x: 343.812949640288, y: 2.94117647058824, size: 1 },
    //     { x: 357.410071942446, y: 4, size: 1 },
    //     { x: 3.23741007194245, y: 3.09803921568627, size: 1 },
    //     { x: 3.88489208633094, y: 2.47058823529412, size: 1 },
    //     { x: 4.53237410071942, y: 2.94117647058824, size: 1 },
    //     { x: 5.17985611510791, y: 2.86274509803922, size: 1 },
    //     { x: 25.8992805755396, y: 2.7843137254902, size: 1 },
    //     { x: 26.5467625899281, y: 2.43137254901961, size: 1 },
    //     { x: 27.1942446043165, y: 2.70588235294118, size: 1 },
    //     { x: 46.6187050359712, y: 3.13725490196078, size: 1 },
    //     { x: 56.9784172661871, y: 4.07843137254902, size: 1 },
    //     { x: 88.705035971223, y: 3.33333333333333, size: 1 },
    //     { x: 90, y: 2.86274509803922, size: 1 },
    //     { x: 90.6474820143885, y: 3.09803921568627, size: 1 },
    //     { x: 110.719424460432, y: 3.09803921568627, size: 1 },
    //     { x: 111.36690647482, y: 2.70588235294118, size: 1 },
    //     { x: 112.014388489209, y: 2.54901960784314, size: 1 },
    //     { x: 117.194244604317, y: 3.92156862745098, size: 1 },
    //     { x: 132.73381294964, y: 2.62745098039216, size: 1 },
    //     { x: 133.381294964029, y: 2.82352941176471, size: 1 },
    //     { x: 143.093525179856, y: 4, size: 1 },
    //     { x: 144.388489208633, y: 4, size: 1 },
    //     { x: 172.230215827338, y: 4.11764705882353, size: 1 },
    //     { x: 176.762589928058, y: 3.01960784313725, size: 1 },
    //     { x: 189.712230215827, y: 4, size: 1 },
    //     { x: 191.007194244604, y: 4.07843137254902, size: 1 },
    //     { x: 197.482014388489, y: 3.05882352941176, size: 1 },
    //     { x: 198.129496402878, y: 3.13725490196078, size: 1 },
    //     { x: 218.848920863309, y: 3.13725490196078, size: 1 },
    //     { x: 219.496402877698, y: 3.09803921568627, size: 1 },
    //     { x: 240.863309352518, y: 3.01960784313725, size: 1 },
    //     { x: 241.510791366906, y: 2.98039215686275, size: 1 },
    //     { x: 305.611510791367, y: 2.86274509803922, size: 1 },
    //     { x: 306.258992805755, y: 3.01960784313725, size: 1 },
    //     { x: 339.928057553957, y: 4, size: 1 },
    //     { x: 346.402877697842, y: 3.96078431372549, size: 1 },
    //     { x: 75.7553956834532, y: 2.86274509803922, size: 1 },
    //     { x: 117.841726618705, y: 3.25490196078431, size: 1 },
    //     { x: 124.964028776978, y: 3.88235294117647, size: 1 },
    //     { x: 134.028776978417, y: 4, size: 1 },
    //     { x: 139.208633093525, y: 3.2156862745098, size: 1 },
    //     { x: 140.503597122302, y: 3.01960784313725, size: 1 },
    //     { x: 161.870503597122, y: 2.86274509803922, size: 1 },
    //     { x: 183.237410071942, y: 3.13725490196078, size: 1 },
    //     { x: 204.604316546763, y: 2.27450980392157, size: 1 },
    //     { x: 205.251798561151, y: 2.31372549019608, size: 1 },
    //     { x: 225.971223021583, y: 2.58823529411765, size: 1 },
    //     { x: 226.618705035971, y: 2.70588235294118, size: 1 },
    //     { x: 270, y: 2.54901960784314, size: 1 },
    //     { x: 290.719424460432, y: 2.58823529411765, size: 1 },
    //     { x: 291.36690647482, y: 2.43137254901961, size: 1 },
    //     { x: 312.73381294964, y: 2.98039215686275, size: 1 },
    //     { x: 334.748201438849, y: 1.80392156862745, size: 1 },
    //     { x: 4.54054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 13.6216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 15.5675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 34.3783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 40.8648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 49.2972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 55.1351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 59.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 60.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 61.6216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 62.2702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 65.5135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 66.8108108108108, y: 4, size: 1 },
    //     { x: 67.4594594594595, y: 4, size: 1 },
    //     { x: 68.1081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 72, y: 3.84313725490196, size: 1 },
    //     { x: 73.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 75.8918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 77.8378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 78.4864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 80.4324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 81.0810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 81.7297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 82.3783783783784, y: 2.58823529411765, size: 1 },
    //     { x: 88.8648648648649, y: 3.41176470588235, size: 1 },
    //     { x: 90.8108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 94.7027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 105.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 108.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 112.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 121.297297297297, y: 4, size: 1 },
    //     { x: 123.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 125.189189189189, y: 2.03921568627451, size: 1 },
    //     { x: 125.837837837838, y: 2.3921568627451, size: 1 },
    //     { x: 126.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 151.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 155.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 155.675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 168, y: 3.37254901960784, size: 1 },
    //     { x: 171.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 172.540540540541, y: 3.80392156862745, size: 1 },
    //     { x: 175.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 187.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 214.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 224.432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 234.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 235.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 254.918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 255.567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 256.216216216216, y: 2.66666666666667, size: 1 },
    //     { x: 256.864864864865, y: 2.98039215686275, size: 1 },
    //     { x: 267.891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 275.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 276.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 278.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 285.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 293.837837837838, y: 3.68627450980392, size: 1 },
    //     { x: 298.378378378378, y: 2.90196078431373, size: 1 },
    //     { x: 299.027027027027, y: 2.7843137254902, size: 1 },
    //     { x: 299.675675675676, y: 2.62745098039216, size: 1 },
    //     { x: 300.324324324324, y: 2.62745098039216, size: 1 },
    //     { x: 319.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 319.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 320.432432432432, y: 2.43137254901961, size: 1 },
    //     { x: 321.081081081081, y: 2.31372549019608, size: 1 },
    //     { x: 321.72972972973, y: 2.3921568627451, size: 1 },
    //     { x: 322.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 327.567567567568, y: 3.45098039215686, size: 1 },
    //     { x: 328.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 340.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 341.837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 345.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 346.378378378378, y: 4, size: 1 },
    //     { x: 353.513513513513, y: 3.88235294117647, size: 1 },
    //     { x: 359.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 33.6690647482014, y: 3.96078431372549, size: 1 },
    //     { x: 93.8848920863309, y: 4, size: 1 },
    //     { x: 112.014388489209, y: 3.09803921568627, size: 1 },
    //     { x: 112.661870503597, y: 2.90196078431373, size: 1 },
    //     { x: 113.309352517986, y: 2.86274509803922, size: 1 },
    //     { x: 132.73381294964, y: 3.2156862745098, size: 1 },
    //     { x: 155.395683453237, y: 3.25490196078431, size: 1 },
    //     { x: 157.338129496403, y: 3.96078431372549, size: 1 },
    //     { x: 176.762589928058, y: 3.13725490196078, size: 1 },
    //     { x: 177.410071942446, y: 2.86274509803922, size: 1 },
    //     { x: 197.482014388489, y: 2.74509803921569, size: 1 },
    //     { x: 199.424460431655, y: 3.01960784313725, size: 1 },
    //     { x: 218.848920863309, y: 2.90196078431373, size: 1 },
    //     { x: 220.791366906475, y: 2.62745098039216, size: 1 },
    //     { x: 236.330935251799, y: 4.03921568627451, size: 1 },
    //     { x: 240.863309352518, y: 3.05882352941176, size: 1 },
    //     { x: 241.510791366906, y: 2.94117647058824, size: 1 },
    //     { x: 242.158273381295, y: 2.90196078431373, size: 1 },
    //     { x: 272.589928057554, y: 4.03921568627451, size: 1 },
    //     { x: 283.597122302158, y: 3.13725490196078, size: 1 },
    //     { x: 284.244604316547, y: 3.13725490196078, size: 1 },
    //     { x: 348.345323741007, y: 3.2156862745098, size: 1 },
    //     { x: 119.136690647482, y: 2.82352941176471, size: 1 },
    //     { x: 119.784172661871, y: 2.7843137254902, size: 1 },
    //     { x: 181.294964028777, y: 3.09803921568627, size: 1 },
    //     { x: 182.589928057554, y: 2.94117647058824, size: 1 },
    //     { x: 183.237410071942, y: 3.17647058823529, size: 1 },
    //     { x: 277.122302158273, y: 3.96078431372549, size: 1 },
    //     { x: 277.769784172662, y: 3.92156862745098, size: 1 },
    //     { x: 308.201438848921, y: 4.07843137254902, size: 1 },
    //     { x: 311.438848920863, y: 3.01960784313725, size: 1 },
    //     { x: 312.73381294964, y: 2.90196078431373, size: 1 },
    //     { x: 313.381294964029, y: 2.66666666666667, size: 1 },
    //     { x: 314.028776978417, y: 2.90196078431373, size: 1 },
    //     { x: 334.10071942446, y: 2.70588235294118, size: 1 },
    //     { x: 355.467625899281, y: 3.2156862745098, size: 1 },
    //     { x: 59.568345323741, y: 3.2156862745098, size: 1 },
    //     { x: 91.9424460431655, y: 4.15686274509804, size: 1 },
    //     { x: 95.8273381294964, y: 4.11764705882353, size: 1 },
    //     { x: 100.359712230216, y: 4.07843137254902, size: 1 },
    //     { x: 103.597122302158, y: 3.33333333333333, size: 1 },
    //     { x: 123.669064748201, y: 3.33333333333333, size: 1 },
    //     { x: 124.964028776978, y: 2.7843137254902, size: 1 },
    //     { x: 125.611510791367, y: 2.98039215686275, size: 1 },
    //     { x: 190.359712230216, y: 3.2156862745098, size: 1 },
    //     { x: 241.510791366906, y: 4, size: 1 },
    //     { x: 255.755395683453, y: 3.96078431372549, size: 1 },
    //     { x: 319.208633093525, y: 2.90196078431373, size: 1 },
    //     { x: 319.856115107914, y: 2.82352941176471, size: 1 },
    //     { x: 343.812949640288, y: 3.96078431372549, size: 1 },
    //     { x: 348.992805755396, y: 3.92156862745098, size: 1 },
    //     { x: 0.648648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 1.94594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 2.59459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 24, y: 3.37254901960784, size: 1 },
    //     { x: 24.6486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 33.0810810810811, y: 4.07843137254902, size: 1 },
    //     { x: 34.3783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 72.6486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 89.5135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 94.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 96.6486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 99.8918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 101.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 106.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 109.621621621622, y: 3.37254901960784, size: 1 },
    //     { x: 110.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 119.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 130.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 131.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 131.675675675676, y: 2.74509803921569, size: 1 },
    //     { x: 132.324324324324, y: 1.52941176470588, size: 1 },
    //     { x: 132.972972972973, y: 2.03921568627451, size: 1 },
    //     { x: 133.621621621622, y: 2.23529411764706, size: 1 },
    //     { x: 134.27027027027, y: 2.47058823529412, size: 1 },
    //     { x: 134.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 137.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 141.405405405405, y: 2.7843137254902, size: 1 },
    //     { x: 142.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 147.891891891892, y: 2.7843137254902, size: 1 },
    //     { x: 149.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 149.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 150.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 151.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 152.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 153.72972972973, y: 3.01960784313725, size: 1 },
    //     { x: 154.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 160.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 162.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 165.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 166.702702702703, y: 4.19607843137255, size: 1 },
    //     { x: 168.648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 169.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 171.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 174.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 175.135135135135, y: 2.47058823529412, size: 1 },
    //     { x: 175.783783783784, y: 1.84313725490196, size: 1 },
    //     { x: 183.567567567568, y: 4.15686274509804, size: 1 },
    //     { x: 195.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 197.189189189189, y: 2.54901960784314, size: 1 },
    //     { x: 198.486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 201.72972972973, y: 3.76470588235294, size: 1 },
    //     { x: 215.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 218.594594594595, y: 1.96078431372549, size: 1 },
    //     { x: 219.243243243243, y: 1.88235294117647, size: 1 },
    //     { x: 226.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 238.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 240.648648648649, y: 2.31372549019608, size: 1 },
    //     { x: 260.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 264.648648648649, y: 4.15686274509804, size: 1 },
    //     { x: 265.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 286.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 291.891891891892, y: 3.72549019607843, size: 1 },
    //     { x: 303.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 310.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 324.324324324324, y: 3.45098039215686, size: 1 },
    //     { x: 325.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 347.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 349.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 350.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 351.567567567568, y: 4, size: 1 },
    //     { x: 352.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 352.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 354.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 355.459459459459, y: 4.15686274509804, size: 1 },
    //     { x: 356.108108108108, y: 4.11764705882353, size: 1 },
    //     { x: 358.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 358.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 359.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 6.47482014388489, y: 4.03921568627451, size: 1 },
    //     { x: 8.41726618705036, y: 3.2156862745098, size: 1 },
    //     { x: 9.71223021582734, y: 2.58823529411765, size: 1 },
    //     { x: 10.3597122302158, y: 2.3921568627451, size: 1 },
    //     { x: 30.431654676259, y: 2.98039215686275, size: 1 },
    //     { x: 104.244604316547, y: 3.96078431372549, size: 1 },
    //     { x: 119.136690647482, y: 3.92156862745098, size: 1 },
    //     { x: 126.258992805755, y: 4, size: 1 },
    //     { x: 132.086330935252, y: 4.11764705882353, size: 1 },
    //     { x: 161.870503597122, y: 2.90196078431373, size: 1 },
    //     { x: 163.165467625899, y: 2.98039215686275, size: 1 },
    //     { x: 181.942446043165, y: 3.05882352941176, size: 1 },
    //     { x: 182.589928057554, y: 2.47058823529412, size: 1 },
    //     { x: 183.237410071942, y: 2.54901960784314, size: 1 },
    //     { x: 183.884892086331, y: 2.54901960784314, size: 1 },
    //     { x: 184.532374100719, y: 2.90196078431373, size: 1 },
    //     { x: 203.956834532374, y: 2.86274509803922, size: 1 },
    //     { x: 204.604316546763, y: 3.01960784313725, size: 1 },
    //     { x: 225.971223021583, y: 2.98039215686275, size: 1 },
    //     { x: 271.942446043165, y: 3.96078431372549, size: 1 },
    //     { x: 290.719424460432, y: 2.98039215686275, size: 1 },
    //     { x: 293.309352517986, y: 4.15686274509804, size: 1 },
    //     { x: 301.079136690647, y: 3.92156862745098, size: 1 },
    //     { x: 354.820143884892, y: 3.13725490196078, size: 1 },
    //     { x: 355.467625899281, y: 2.66666666666667, size: 1 },
    //     { x: 356.115107913669, y: 2.47058823529412, size: 1 },
    //     { x: 356.762589928058, y: 2.31372549019608, size: 1 },
    //     { x: 357.410071942446, y: 2.27450980392157, size: 1 },
    //     { x: 29.136690647482, y: 3.25490196078431, size: 1 },
    //     { x: 73.8129496402878, y: 3.29411764705882, size: 1 },
    //     { x: 102.302158273381, y: 4, size: 1 },
    //     { x: 104.244604316547, y: 3.13725490196078, size: 1 },
    //     { x: 104.892086330935, y: 3.25490196078431, size: 1 },
    //     { x: 146.330935251799, y: 3.01960784313725, size: 1 },
    //     { x: 147.625899280576, y: 2.74509803921569, size: 1 },
    //     { x: 148.273381294964, y: 2.58823529411765, size: 1 },
    //     { x: 166.402877697842, y: 3.09803921568627, size: 1 },
    //     { x: 167.05035971223, y: 3.01960784313725, size: 1 },
    //     { x: 167.697841726619, y: 2.70588235294118, size: 1 },
    //     { x: 168.345323741007, y: 2.7843137254902, size: 1 },
    //     { x: 168.992805755396, y: 2.62745098039216, size: 1 },
    //     { x: 169.640287769784, y: 2.86274509803922, size: 1 },
    //     { x: 178.705035971223, y: 4.07843137254902, size: 1 },
    //     { x: 189.064748201439, y: 3.13725490196078, size: 1 },
    //     { x: 189.712230215827, y: 2.47058823529412, size: 1 },
    //     { x: 211.079136690647, y: 2.98039215686275, size: 1 },
    //     { x: 211.726618705036, y: 3.13725490196078, size: 1 },
    //     { x: 275.827338129496, y: 2.50980392156863, size: 1 },
    //     { x: 276.474820143885, y: 2.74509803921569, size: 1 },
    //     { x: 297.841726618705, y: 3.37254901960784, size: 1 },
    //     { x: 306.906474820144, y: 4.15686274509804, size: 1 },
    //     { x: 327.625899280576, y: 3.96078431372549, size: 1 },
    //     { x: 30.431654676259, y: 4.15686274509804, size: 1 },
    //     { x: 31.0791366906475, y: 4.03921568627451, size: 1 },
    //     { x: 31.726618705036, y: 4, size: 1 },
    //     { x: 32.3741007194245, y: 3.96078431372549, size: 1 },
    //     { x: 35.6115107913669, y: 3.92156862745098, size: 1 },
    //     { x: 36.2589928057554, y: 4.07843137254902, size: 1 },
    //     { x: 41.4388489208633, y: 4, size: 1 },
    //     { x: 45.9712230215827, y: 3.05882352941176, size: 1 },
    //     { x: 67.3381294964029, y: 2.98039215686275, size: 1 },
    //     { x: 68.6330935251799, y: 2.7843137254902, size: 1 },
    //     { x: 152.158273381295, y: 3.17647058823529, size: 1 },
    //     { x: 153.453237410072, y: 3.05882352941176, size: 1 },
    //     { x: 154.10071942446, y: 3.05882352941176, size: 1 },
    //     { x: 171.58273381295, y: 4.03921568627451, size: 1 },
    //     { x: 174.820143884892, y: 2.50980392156863, size: 1 },
    //     { x: 175.467625899281, y: 2.47058823529412, size: 1 },
    //     { x: 176.115107913669, y: 2.82352941176471, size: 1 },
    //     { x: 176.762589928058, y: 2.62745098039216, size: 1 },
    //     { x: 199.424460431655, y: 4.19607843137255, size: 1 },
    //     { x: 207.194244604317, y: 4.03921568627451, size: 1 },
    //     { x: 211.079136690647, y: 4.11764705882353, size: 1 },
    //     { x: 218.201438848921, y: 2.74509803921569, size: 1 },
    //     { x: 239.568345323741, y: 3.01960784313725, size: 1 },
    //     { x: 243.453237410072, y: 4.15686274509804, size: 1 },
    //     { x: 260.935251798561, y: 2.98039215686275, size: 1 },
    //     { x: 261.58273381295, y: 2.82352941176471, size: 1 },
    //     { x: 292.661870503597, y: 3.96078431372549, size: 1 },
    //     { x: 294.604316546763, y: 4.03921568627451, size: 1 },
    //     { x: 324.388489208633, y: 3.2156862745098, size: 1 },
    //     { x: 326.330935251799, y: 2.90196078431373, size: 1 },
    //     { x: 2.59459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 10.3783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 12.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 18.1621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 30.4864864864865, y: 2.90196078431373, size: 1 },
    //     { x: 31.1351351351351, y: 2.47058823529412, size: 1 },
    //     { x: 31.7837837837838, y: 2.58823529411765, size: 1 },
    //     { x: 32.4324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 36.972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 53.1891891891892, y: 3.41176470588235, size: 1 },
    //     { x: 73.2972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 73.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 74.5945945945946, y: 2.98039215686275, size: 1 },
    //     { x: 80.4324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 88.2162162162162, y: 3.76470588235294, size: 1 },
    //     { x: 94.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 95.3513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 96, y: 3.33333333333333, size: 1 },
    //     { x: 114.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 117.405405405405, y: 2.86274509803922, size: 1 },
    //     { x: 118.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 133.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 137.513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 139.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 147.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 160.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 160.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 188.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 190.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 195.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 197.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 203.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 213.405405405405, y: 4, size: 1 },
    //     { x: 245.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 246.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 247.783783783784, y: 2.70588235294118, size: 1 },
    //     { x: 248.432432432432, y: 2.70588235294118, size: 1 },
    //     { x: 249.081081081081, y: 2.82352941176471, size: 1 },
    //     { x: 254.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 267.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 268.540540540541, y: 2.66666666666667, size: 1 },
    //     { x: 269.189189189189, y: 2.7843137254902, size: 1 },
    //     { x: 269.837837837838, y: 2.19607843137255, size: 1 },
    //     { x: 270.486486486487, y: 2.11764705882353, size: 1 },
    //     { x: 280.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 289.297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 289.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 302.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 332.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 333.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 334.054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 339.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 342.486486486487, y: 3.49019607843137, size: 1 },
    //     { x: 350.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 358.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 3.88489208633094, y: 3.96078431372549, size: 1 },
    //     { x: 14.8920863309353, y: 3.05882352941176, size: 1 },
    //     { x: 16.8345323741007, y: 2.70588235294118, size: 1 },
    //     { x: 79.6402877697842, y: 3.33333333333333, size: 1 },
    //     { x: 80.2877697841727, y: 3.29411764705882, size: 1 },
    //     { x: 80.9352517985612, y: 2.90196078431373, size: 1 },
    //     { x: 81.5827338129496, y: 2.86274509803922, size: 1 },
    //     { x: 102.302158273381, y: 3.17647058823529, size: 1 },
    //     { x: 102.94964028777, y: 2.54901960784314, size: 1 },
    //     { x: 103.597122302158, y: 2.50980392156863, size: 1 },
    //     { x: 124.964028776978, y: 3.05882352941176, size: 1 },
    //     { x: 145.035971223022, y: 2.98039215686275, size: 1 },
    //     { x: 145.68345323741, y: 2.90196078431373, size: 1 },
    //     { x: 146.330935251799, y: 1.68627450980392, size: 1 },
    //     { x: 167.697841726619, y: 2.94117647058824, size: 1 },
    //     { x: 187.769784172662, y: 3.13725490196078, size: 1 },
    //     { x: 189.064748201439, y: 2.7843137254902, size: 1 },
    //     { x: 189.712230215827, y: 2.03921568627451, size: 1 },
    //     { x: 231.151079136691, y: 3.13725490196078, size: 1 },
    //     { x: 234.388489208633, y: 3.92156862745098, size: 1 },
    //     { x: 236.978417266187, y: 3.96078431372549, size: 1 },
    //     { x: 274.532374100719, y: 3.17647058823529, size: 1 },
    //     { x: 297.194244604317, y: 2.62745098039216, size: 1 },
    //     { x: 297.841726618705, y: 2.54901960784314, size: 1 },
    //     { x: 311.438848920863, y: 3.88235294117647, size: 1 },
    //     { x: 9.71223021582734, y: 3.96078431372549, size: 1 },
    //     { x: 18.1294964028777, y: 4.07843137254902, size: 1 },
    //     { x: 20.0719424460432, y: 4.03921568627451, size: 1 },
    //     { x: 20.7194244604317, y: 4.03921568627451, size: 1 },
    //     { x: 43.3812949640288, y: 3.96078431372549, size: 1 },
    //     { x: 77.0503597122302, y: 3.96078431372549, size: 1 },
    //     { x: 82.8776978417266, y: 3.92156862745098, size: 1 },
    //     { x: 88.705035971223, y: 2.58823529411765, size: 1 },
    //     { x: 90, y: 2.90196078431373, size: 1 },
    //     { x: 110.071942446043, y: 3.13725490196078, size: 1 },
    //     { x: 111.36690647482, y: 3.05882352941176, size: 1 },
    //     { x: 112.014388489209, y: 2.98039215686275, size: 1 },
    //     { x: 130.791366906475, y: 3.09803921568627, size: 1 },
    //     { x: 132.086330935252, y: 2.74509803921569, size: 1 },
    //     { x: 133.381294964029, y: 3.09803921568627, size: 1 },
    //     { x: 176.115107913669, y: 4, size: 1 },
    //     { x: 177.410071942446, y: 4.07843137254902, size: 1 },
    //     { x: 180.647482014388, y: 4.03921568627451, size: 1 },
    //     { x: 181.294964028777, y: 4.23529411764706, size: 1 },
    //     { x: 182.589928057554, y: 4.03921568627451, size: 1 },
    //     { x: 183.237410071942, y: 4.07843137254902, size: 1 },
    //     { x: 188.41726618705, y: 4.19607843137255, size: 1 },
    //     { x: 206.546762589928, y: 4.03921568627451, size: 1 },
    //     { x: 207.841726618705, y: 4.03921568627451, size: 1 },
    //     { x: 223.381294964029, y: 3.96078431372549, size: 1 },
    //     { x: 224.676258992806, y: 3.96078431372549, size: 1 },
    //     { x: 261.58273381295, y: 2.94117647058824, size: 1 },
    //     { x: 262.877697841727, y: 3.01960784313725, size: 1 },
    //     { x: 270, y: 4, size: 1 },
    //     { x: 271.942446043165, y: 3.92156862745098, size: 1 },
    //     { x: 282.302158273381, y: 2.7843137254902, size: 1 },
    //     { x: 282.94964028777, y: 2.62745098039216, size: 1 },
    //     { x: 283.597122302158, y: 2.50980392156863, size: 1 },
    //     { x: 284.244604316547, y: 2.50980392156863, size: 1 },
    //     { x: 322.446043165468, y: 4.03921568627451, size: 1 },
    //     { x: 325.68345323741, y: 3.2156862745098, size: 1 },
    //     { x: 336.043165467626, y: 4, size: 1 },
    //     { x: 347.05035971223, y: 3.25490196078431, size: 1 },
    //     { x: 354.172661870504, y: 3.2156862745098, size: 1 },
    //     { x: 7.12230215827338, y: 3.05882352941176, size: 1 },
    //     { x: 9.06474820143885, y: 3.05882352941176, size: 1 },
    //     { x: 80.9352517985612, y: 4, size: 1 },
    //     { x: 91.9424460431655, y: 4.03921568627451, size: 1 },
    //     { x: 130.143884892086, y: 4.03921568627451, size: 1 },
    //     { x: 143.741007194245, y: 4.03921568627451, size: 1 },
    //     { x: 159.928057553957, y: 3.17647058823529, size: 1 },
    //     { x: 195.539568345324, y: 3.88235294117647, size: 1 },
    //     { x: 201.36690647482, y: 3.17647058823529, size: 1 },
    //     { x: 202.661870503597, y: 3.05882352941176, size: 1 },
    //     { x: 203.309352517986, y: 2.15686274509804, size: 1 },
    //     { x: 254.460431654676, y: 3.88235294117647, size: 1 },
    //     { x: 257.697841726619, y: 4, size: 1 },
    //     { x: 260.287769784173, y: 4.03921568627451, size: 1 },
    //     { x: 263.525179856115, y: 4.03921568627451, size: 1 },
    //     { x: 290.071942446043, y: 3.01960784313725, size: 1 },
    //     { x: 314.028776978417, y: 4.19607843137255, size: 1 },
    //     { x: 332.805755395683, y: 2.58823529411765, size: 1 },
    //     { x: 333.453237410072, y: 3.25490196078431, size: 1 },
    //     { x: 356.115107913669, y: 3.29411764705882, size: 1 },
    //     { x: 5.18918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 14.9189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 16.2162162162162, y: 2.90196078431373, size: 1 },
    //     { x: 21.4054054054054, y: 4, size: 1 },
    //     { x: 27.8918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 35.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 41.5135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 43.4594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 58.3783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 59.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 60.3243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 60.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 64.8648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 66.1621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 67.4594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 68.7567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 69.4054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 70.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 70.7027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 71.3513513513514, y: 4.19607843137255, size: 1 },
    //     { x: 76.5405405405405, y: 4, size: 1 },
    //     { x: 79.1351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 80.4324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 81.0810810810811, y: 2.90196078431373, size: 1 },
    //     { x: 84.972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 88.8648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 96, y: 3.84313725490196, size: 1 },
    //     { x: 96.6486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 103.783783783784, y: 3.72549019607843, size: 1 },
    //     { x: 113.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 136.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 138.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 145.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 145.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 165.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 166.702702702703, y: 2.90196078431373, size: 1 },
    //     { x: 167.351351351351, y: 2.3921568627451, size: 1 },
    //     { x: 178.378378378378, y: 4, size: 1 },
    //     { x: 188.756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 189.405405405405, y: 2.74509803921569, size: 1 },
    //     { x: 192.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 208.864864864865, y: 3.37254901960784, size: 1 },
    //     { x: 209.513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 210.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 211.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 213.405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 214.054054054054, y: 4.15686274509804, size: 1 },
    //     { x: 214.702702702703, y: 4.27450980392157, size: 1 },
    //     { x: 217.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 220.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 222.486486486486, y: 4, size: 1 },
    //     { x: 223.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 225.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 228.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 228.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 229.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 234.810810810811, y: 4.03921568627451, size: 1 },
    //     { x: 238.702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 239.351351351351, y: 4.11764705882353, size: 1 },
    //     { x: 240, y: 4.15686274509804, size: 1 },
    //     { x: 241.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 243.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 245.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 248.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 249.081081081081, y: 4, size: 1 },
    //     { x: 251.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 252.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 252.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 253.621621621622, y: 2.82352941176471, size: 1 },
    //     { x: 254.27027027027, y: 2.58823529411765, size: 1 },
    //     { x: 265.297297297297, y: 4.07843137254902, size: 1 },
    //     { x: 275.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 275.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 286.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 298.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 299.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 304.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 305.513513513513, y: 3.80392156862745, size: 1 },
    //     { x: 306.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 312, y: 3.84313725490196, size: 1 },
    //     { x: 313.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 314.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 315.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 322.378378378378, y: 3.72549019607843, size: 1 },
    //     { x: 339.891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 353.513513513513, y: 3.96078431372549, size: 1 },
    //     { x: 354.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 0, y: 3.05882352941176, size: 1 },
    //     { x: 1.94244604316547, y: 2.90196078431373, size: 1 },
    //     { x: 45.3237410071942, y: 2.98039215686275, size: 1 },
    //     { x: 47.2661870503597, y: 3.92156862745098, size: 1 },
    //     { x: 50.5035971223022, y: 4.07843137254902, size: 1 },
    //     { x: 56.3309352517986, y: 4.07843137254902, size: 1 },
    //     { x: 59.568345323741, y: 4, size: 1 },
    //     { x: 88.0575539568345, y: 2.90196078431373, size: 1 },
    //     { x: 88.705035971223, y: 2.66666666666667, size: 1 },
    //     { x: 98.4172661870504, y: 4.07843137254902, size: 1 },
    //     { x: 99.7122302158273, y: 4.03921568627451, size: 1 },
    //     { x: 106.187050359712, y: 4.03921568627451, size: 1 },
    //     { x: 131.438848920863, y: 2.54901960784314, size: 1 },
    //     { x: 132.086330935252, y: 2.98039215686275, size: 1 },
    //     { x: 152.805755395683, y: 2.98039215686275, size: 1 },
    //     { x: 201.36690647482, y: 3.88235294117647, size: 1 },
    //     { x: 220.143884892086, y: 4, size: 1 },
    //     { x: 224.028776978417, y: 4.07843137254902, size: 1 },
    //     { x: 224.676258992806, y: 4, size: 1 },
    //     { x: 225.971223021583, y: 4, size: 1 },
    //     { x: 235.68345323741, y: 4.03921568627451, size: 1 },
    //     { x: 302.374100719424, y: 3.09803921568627, size: 1 },
    //     { x: 303.669064748201, y: 3.09803921568627, size: 1 },
    //     { x: 304.964028776978, y: 3.09803921568627, size: 1 },
    //     { x: 347.05035971223, y: 1.72549019607843, size: 1 },
    //     { x: 347.697841726619, y: 1.72549019607843, size: 1 },
    //     { x: 348.345323741007, y: 1.6078431372549, size: 1 },
    //     { x: 348.992805755396, y: 1.64705882352941, size: 1 },
    //     { x: 351.58273381295, y: 3.09803921568627, size: 1 },
    //     { x: 356.762589928058, y: 2.86274509803922, size: 1 },
    //     { x: 2.58992805755396, y: 2.70588235294118, size: 1 },
    //     { x: 7.76978417266187, y: 3.2156862745098, size: 1 },
    //     { x: 8.41726618705036, y: 2.94117647058824, size: 1 },
    //     { x: 9.06474820143885, y: 2.62745098039216, size: 1 },
    //     { x: 27.841726618705, y: 3.96078431372549, size: 1 },
    //     { x: 29.136690647482, y: 3.29411764705882, size: 1 },
    //     { x: 31.0791366906475, y: 3.92156862745098, size: 1 },
    //     { x: 36.9064748201439, y: 3.92156862745098, size: 1 },
    //     { x: 41.4388489208633, y: 4.07843137254902, size: 1 },
    //     { x: 42.0863309352518, y: 4.07843137254902, size: 1 },
    //     { x: 44.0287769784173, y: 4.07843137254902, size: 1 },
    //     { x: 46.6187050359712, y: 4.07843137254902, size: 1 },
    //     { x: 48.5611510791367, y: 4, size: 1 },
    //     { x: 51.7985611510791, y: 2.66666666666667, size: 1 },
    //     { x: 52.4460431654676, y: 2.74509803921569, size: 1 },
    //     { x: 72.5179856115108, y: 2.98039215686275, size: 1 },
    //     { x: 73.1654676258993, y: 2.74509803921569, size: 1 },
    //     { x: 73.8129496402878, y: 1.96078431372549, size: 1 },
    //     { x: 95.1798561151079, y: 2.98039215686275, size: 1 },
    //     { x: 137.26618705036, y: 3.13725490196078, size: 1 },
    //     { x: 138.561151079137, y: 2.3921568627451, size: 1 },
    //     { x: 224.676258992806, y: 2.74509803921569, size: 1 },
    //     { x: 293.309352517986, y: 3.92156862745098, size: 1 },
    //     { x: 295.251798561151, y: 4.03921568627451, size: 1 },
    //     { x: 336.043165467626, y: 4.03921568627451, size: 1 },
    //     { x: 344.460431654676, y: 3.92156862745098, size: 1 },
    //     { x: 345.755395683453, y: 3.84313725490196, size: 1 },
    //     { x: 350.935251798561, y: 4.07843137254902, size: 1 },
    //     { x: 15.5395683453237, y: 3.25490196078431, size: 1 },
    //     { x: 36.9064748201439, y: 2.86274509803922, size: 1 },
    //     { x: 37.5539568345324, y: 2.82352941176471, size: 1 },
    //     { x: 38.8489208633094, y: 3.01960784313725, size: 1 },
    //     { x: 56.9784172661871, y: 3.25490196078431, size: 1 },
    //     { x: 58.273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 58.9208633093525, y: 2.94117647058824, size: 1 },
    //     { x: 59.568345323741, y: 2.90196078431373, size: 1 },
    //     { x: 60.863309352518, y: 2.82352941176471, size: 1 },
    //     { x: 101.654676258993, y: 2.98039215686275, size: 1 },
    //     { x: 102.302158273381, y: 2.86274509803922, size: 1 },
    //     { x: 102.94964028777, y: 2.90196078431373, size: 1 },
    //     { x: 103.597122302158, y: 2.62745098039216, size: 1 },
    //     { x: 123.021582733813, y: 3.2156862745098, size: 1 },
    //     { x: 123.669064748201, y: 2.94117647058824, size: 1 },
    //     { x: 145.035971223022, y: 3.17647058823529, size: 1 },
    //     { x: 151.510791366906, y: 4.07843137254902, size: 1 },
    //     { x: 153.453237410072, y: 4, size: 1 },
    //     { x: 163.165467625899, y: 4.03921568627451, size: 1 },
    //     { x: 210.431654676259, y: 3.09803921568627, size: 1 },
    //     { x: 214.964028776978, y: 4.03921568627451, size: 1 },
    //     { x: 275.179856115108, y: 3.17647058823529, size: 1 },
    //     { x: 335.395683453237, y: 3.96078431372549, size: 1 },
    //     { x: 339.280575539568, y: 2.98039215686275, size: 1 },
    //     { x: 339.928057553957, y: 2.86274509803922, size: 1 },
    //     { x: 340.575539568345, y: 2.82352941176471, size: 1 },
    //     { x: 0.647482014388489, y: 2.98039215686275, size: 1 },
    //     { x: 1.29496402877698, y: 2.94117647058824, size: 1 },
    //     { x: 1.94244604316547, y: 3.01960784313725, size: 1 },
    //     { x: 87.410071942446, y: 2.7843137254902, size: 1 },
    //     { x: 88.0575539568345, y: 3.05882352941176, size: 1 },
    //     { x: 159.928057553957, y: 3.96078431372549, size: 1 },
    //     { x: 163.165467625899, y: 4.11764705882353, size: 1 },
    //     { x: 175.467625899281, y: 2.90196078431373, size: 1 },
    //     { x: 192.94964028777, y: 3.29411764705882, size: 1 },
    //     { x: 194.892086330935, y: 3.09803921568627, size: 1 },
    //     { x: 195.539568345324, y: 2.94117647058824, size: 1 },
    //     { x: 196.187050359712, y: 2.98039215686275, size: 1 },
    //     { x: 196.834532374101, y: 2.74509803921569, size: 1 },
    //     { x: 216.906474820144, y: 2.62745098039216, size: 1 },
    //     { x: 217.553956834532, y: 2.15686274509804, size: 1 },
    //     { x: 218.201438848921, y: 2.43137254901961, size: 1 },
    //     { x: 218.848920863309, y: 2.35294117647059, size: 1 },
    //     { x: 282.94964028777, y: 3.29411764705882, size: 1 },
    //     { x: 303.021582733813, y: 2.82352941176471, size: 1 },
    //     { x: 303.669064748201, y: 2.94117647058824, size: 1 },
    //     { x: 304.964028776978, y: 2.98039215686275, size: 1 },
    //     { x: 336.690647482014, y: 3.25490196078431, size: 1 },
    //     { x: 354.172661870504, y: 3.96078431372549, size: 1 },
    //     { x: 6.48648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 29.1891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 30.4864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 31.1351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 44.1081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 48, y: 4, size: 1 },
    //     { x: 52.5405405405405, y: 3.01960784313725, size: 1 },
    //     { x: 53.1891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 57.7297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 60.972972972973, y: 3.76470588235294, size: 1 },
    //     { x: 62.2702702702703, y: 3.68627450980392, size: 1 },
    //     { x: 65.5135135135135, y: 4, size: 1 },
    //     { x: 73.945945945946, y: 2.70588235294118, size: 1 },
    //     { x: 74.5945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 91.4594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 94.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 101.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 116.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 144, y: 3.88235294117647, size: 1 },
    //     { x: 151.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 155.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 158.918918918919, y: 2.90196078431373, size: 1 },
    //     { x: 159.567567567568, y: 2.58823529411765, size: 1 },
    //     { x: 162.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 165.405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 179.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 180.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 180.972972972973, y: 2.70588235294118, size: 1 },
    //     { x: 201.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 204.972972972973, y: 4, size: 1 },
    //     { x: 208.216216216216, y: 4.15686274509804, size: 1 },
    //     { x: 208.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 209.513513513514, y: 4.19607843137255, size: 1 },
    //     { x: 210.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 219.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 223.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 226.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 227.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 230.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 234.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 236.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 243.243243243243, y: 4, size: 1 },
    //     { x: 247.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 258.810810810811, y: 3.45098039215686, size: 1 },
    //     { x: 267.243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 267.891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 277.621621621622, y: 3.76470588235294, size: 1 },
    //     { x: 288.648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 289.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 290.594594594595, y: 2.90196078431373, size: 1 },
    //     { x: 313.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 319.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 320.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 323.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 332.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 333.405405405405, y: 2.62745098039216, size: 1 },
    //     { x: 334.054054054054, y: 2.58823529411765, size: 1 },
    //     { x: 353.513513513513, y: 3.2156862745098, size: 1 },
    //     { x: 354.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 354.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 355.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 15.5395683453237, y: 2.70588235294118, size: 1 },
    //     { x: 38.8489208633094, y: 4, size: 1 },
    //     { x: 45.3237410071942, y: 4.23529411764706, size: 1 },
    //     { x: 64.1007194244604, y: 4, size: 1 },
    //     { x: 66.0431654676259, y: 4, size: 1 },
    //     { x: 80.2877697841727, y: 3.01960784313725, size: 1 },
    //     { x: 80.9352517985612, y: 2.74509803921569, size: 1 },
    //     { x: 81.5827338129496, y: 2.70588235294118, size: 1 },
    //     { x: 82.2302158273381, y: 2.66666666666667, size: 1 },
    //     { x: 101.654676258993, y: 2.86274509803922, size: 1 },
    //     { x: 102.302158273381, y: 2.7843137254902, size: 1 },
    //     { x: 103.597122302158, y: 3.13725490196078, size: 1 },
    //     { x: 145.035971223022, y: 2.62745098039216, size: 1 },
    //     { x: 145.68345323741, y: 3.13725490196078, size: 1 },
    //     { x: 187.769784172662, y: 2.94117647058824, size: 1 },
    //     { x: 230.503597122302, y: 3.33333333333333, size: 1 },
    //     { x: 231.151079136691, y: 2.94117647058824, size: 1 },
    //     { x: 253.165467625899, y: 2.98039215686275, size: 1 },
    //     { x: 273.884892086331, y: 3.17647058823529, size: 1 },
    //     { x: 274.532374100719, y: 3.05882352941176, size: 1 },
    //     { x: 317.26618705036, y: 2.3921568627451, size: 1 },
    //     { x: 317.913669064748, y: 2.3921568627451, size: 1 },
    //     { x: 339.280575539568, y: 2.47058823529412, size: 1 },
    //     { x: 9.06474820143885, y: 4.03921568627451, size: 1 },
    //     { x: 22.6618705035971, y: 2.03921568627451, size: 1 },
    //     { x: 44.0287769784173, y: 2.66666666666667, size: 1 },
    //     { x: 86.1151079136691, y: 3.13725490196078, size: 1 },
    //     { x: 86.7625899280576, y: 1.80392156862745, size: 1 },
    //     { x: 87.410071942446, y: 1.68627450980392, size: 1 },
    //     { x: 151.510791366906, y: 2.62745098039216, size: 1 },
    //     { x: 168.992805755396, y: 4.07843137254902, size: 1 },
    //     { x: 193.597122302158, y: 3.25490196078431, size: 1 },
    //     { x: 218.848920863309, y: 4.03921568627451, size: 1 },
    //     { x: 231.151079136691, y: 4.07843137254902, size: 1 },
    //     { x: 244.10071942446, y: 4, size: 1 },
    //     { x: 244.748201438849, y: 4.03921568627451, size: 1 },
    //     { x: 246.043165467626, y: 4.07843137254902, size: 1 },
    //     { x: 250.575539568345, y: 4, size: 1 },
    //     { x: 252.517985611511, y: 4.11764705882353, size: 1 },
    //     { x: 260.287769784173, y: 3.09803921568627, size: 1 },
    //     { x: 260.935251798561, y: 3.01960784313725, size: 1 },
    //     { x: 281.654676258993, y: 2.90196078431373, size: 1 },
    //     { x: 303.021582733813, y: 2.19607843137255, size: 1 },
    //     { x: 303.669064748201, y: 2.47058823529412, size: 1 },
    //     { x: 304.31654676259, y: 2.50980392156863, size: 1 },
    //     { x: 304.964028776978, y: 2.62745098039216, size: 1 },
    //     { x: 324.388489208633, y: 2.90196078431373, size: 1 },
    //     { x: 325.035971223022, y: 2.7843137254902, size: 1 },
    //     { x: 346.402877697842, y: 3.09803921568627, size: 1 },
    //     { x: 5.83783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 7.78378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 9.08108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 14.2702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 17.5135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 20.1081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 22.0540540540541, y: 4, size: 1 },
    //     { x: 24, y: 3.80392156862745, size: 1 },
    //     { x: 28.5405405405405, y: 3.41176470588235, size: 1 },
    //     { x: 29.1891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 29.8378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 33.0810810810811, y: 4.11764705882353, size: 1 },
    //     { x: 44.1081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 46.0540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 48.6486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 51.2432432432432, y: 2.7843137254902, size: 1 },
    //     { x: 55.7837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 70.7027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 72.6486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 73.2972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 111.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 115.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 125.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 136.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 136.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 137.513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 158.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 166.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 168.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 197.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 199.135135135135, y: 3.80392156862745, size: 1 },
    //     { x: 206.918918918919, y: 3.76470588235294, size: 1 },
    //     { x: 207.567567567568, y: 4.31372549019608, size: 1 },
    //     { x: 223.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 243.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 245.189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 245.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 247.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 267.243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 267.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 273.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 274.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 278.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 281.513513513513, y: 3.88235294117647, size: 1 },
    //     { x: 282.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 285.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 288.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 289.945945945946, y: 2.74509803921569, size: 1 },
    //     { x: 290.594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 295.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 308.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 309.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 310.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 311.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 317.837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 321.72972972973, y: 3.84313725490196, size: 1 },
    //     { x: 322.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 323.675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 324.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 325.621621621622, y: 4, size: 1 },
    //     { x: 328.216216216216, y: 4, size: 1 },
    //     { x: 334.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 334.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 339.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 341.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 343.135135135135, y: 4, size: 1 },
    //     { x: 343.783783783784, y: 4.19607843137255, size: 1 },
    //     { x: 349.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 355.459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 6.47482014388489, y: 3.96078431372549, size: 1 },
    //     { x: 7.12230215827338, y: 4.07843137254902, size: 1 },
    //     { x: 14.8920863309353, y: 2.94117647058824, size: 1 },
    //     { x: 15.5395683453237, y: 2.74509803921569, size: 1 },
    //     { x: 19.4244604316547, y: 3.84313725490196, size: 1 },
    //     { x: 37.5539568345324, y: 2.90196078431373, size: 1 },
    //     { x: 57.6258992805755, y: 3.13725490196078, size: 1 },
    //     { x: 58.273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 58.9208633093525, y: 3.2156862745098, size: 1 },
    //     { x: 101.007194244604, y: 3.29411764705882, size: 1 },
    //     { x: 101.654676258993, y: 2.82352941176471, size: 1 },
    //     { x: 103.597122302158, y: 3.05882352941176, size: 1 },
    //     { x: 145.68345323741, y: 2.74509803921569, size: 1 },
    //     { x: 146.330935251799, y: 2.86274509803922, size: 1 },
    //     { x: 162.517985611511, y: 3.92156862745098, size: 1 },
    //     { x: 167.05035971223, y: 3.05882352941176, size: 1 },
    //     { x: 188.41726618705, y: 3.2156862745098, size: 1 },
    //     { x: 252.517985611511, y: 3.17647058823529, size: 1 },
    //     { x: 255.755395683453, y: 3.92156862745098, size: 1 },
    //     { x: 258.992805755396, y: 3.96078431372549, size: 1 },
    //     { x: 318.561151079137, y: 3.13725490196078, size: 1 },
    //     { x: 319.208633093525, y: 3.2156862745098, size: 1 },
    //     { x: 0, y: 2.98039215686275, size: 1 },
    //     { x: 1.29496402877698, y: 2.90196078431373, size: 1 },
    //     { x: 1.94244604316547, y: 2.54901960784314, size: 1 },
    //     { x: 2.58992805755396, y: 2.35294117647059, size: 1 },
    //     { x: 30.431654676259, y: 3.84313725490196, size: 1 },
    //     { x: 80.2877697841727, y: 4.07843137254902, size: 1 },
    //     { x: 110.071942446043, y: 3.09803921568627, size: 1 },
    //     { x: 130.143884892086, y: 3.05882352941176, size: 1 },
    //     { x: 131.438848920863, y: 3.25490196078431, size: 1 },
    //     { x: 174.820143884892, y: 2.90196078431373, size: 1 },
    //     { x: 194.892086330935, y: 2.35294117647059, size: 1 },
    //     { x: 195.539568345324, y: 3.01960784313725, size: 1 },
    //     { x: 196.187050359712, y: 2.43137254901961, size: 1 },
    //     { x: 196.834532374101, y: 2.3921568627451, size: 1 },
    //     { x: 222.086330935252, y: 4.15686274509804, size: 1 },
    //     { x: 223.381294964029, y: 4.15686274509804, size: 1 },
    //     { x: 259.640287769784, y: 2.86274509803922, size: 1 },
    //     { x: 260.287769784173, y: 2.94117647058824, size: 1 },
    //     { x: 260.935251798561, y: 2.66666666666667, size: 1 },
    //     { x: 261.58273381295, y: 2.86274509803922, size: 1 },
    //     { x: 282.302158273381, y: 2.94117647058824, size: 1 },
    //     { x: 303.021582733813, y: 3.09803921568627, size: 1 },
    //     { x: 30.431654676259, y: 3.96078431372549, size: 1 },
    //     { x: 31.726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 45.3237410071942, y: 4.03921568627451, size: 1 },
    //     { x: 115.251798561151, y: 3.01960784313725, size: 1 },
    //     { x: 115.89928057554, y: 2.47058823529412, size: 1 },
    //     { x: 137.26618705036, y: 2.94117647058824, size: 1 },
    //     { x: 137.913669064748, y: 3.01960784313725, size: 1 },
    //     { x: 138.561151079137, y: 2.86274509803922, size: 1 },
    //     { x: 157.985611510791, y: 3.2156862745098, size: 1 },
    //     { x: 200.719424460432, y: 3.25490196078431, size: 1 },
    //     { x: 201.36690647482, y: 2.47058823529412, size: 1 },
    //     { x: 202.014388489209, y: 0.941176470588235, size: 1 },
    //     { x: 202.661870503597, y: 1.17647058823529, size: 1 },
    //     { x: 203.309352517986, y: 1.2156862745098, size: 1 },
    //     { x: 203.956834532374, y: 2.94117647058824, size: 1 },
    //     { x: 206.546762589928, y: 2.90196078431373, size: 1 },
    //     { x: 211.079136690647, y: 2.86274509803922, size: 1 },
    //     { x: 216.906474820144, y: 2.7843137254902, size: 1 },
    //     { x: 217.553956834532, y: 2.86274509803922, size: 1 },
    //     { x: 224.676258992806, y: 4.03921568627451, size: 1 },
    //     { x: 237.625899280576, y: 4, size: 1 },
    //     { x: 238.273381294964, y: 4.07843137254902, size: 1 },
    //     { x: 244.748201438849, y: 2.98039215686275, size: 1 },
    //     { x: 245.395683453237, y: 2.98039215686275, size: 1 },
    //     { x: 264.820143884892, y: 3.17647058823529, size: 1 },
    //     { x: 266.115107913669, y: 2.66666666666667, size: 1 },
    //     { x: 266.762589928058, y: 1.96078431372549, size: 1 },
    //     { x: 286.187050359712, y: 3.01960784313725, size: 1 },
    //     { x: 287.482014388489, y: 2.7843137254902, size: 1 },
    //     { x: 288.129496402878, y: 1.84313725490196, size: 1 },
    //     { x: 310.143884892086, y: 2.98039215686275, size: 1 },
    //     { x: 330.215827338129, y: 3.13725490196078, size: 1 },
    //     { x: 350.935251798561, y: 3.2156862745098, size: 1 },
    //     { x: 352.230215827338, y: 2.98039215686275, size: 1 },
    //     { x: 352.877697841727, y: 2.74509803921569, size: 1 },
    //     { x: 9.08108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 34.3783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 35.6756756756757, y: 2.31372549019608, size: 1 },
    //     { x: 36.3243243243243, y: 2.31372549019608, size: 1 },
    //     { x: 78.4864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 79.1351351351351, y: 2.47058823529412, size: 1 },
    //     { x: 88.8648648648649, y: 3.80392156862745, size: 1 },
    //     { x: 99.2432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 100.540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 108.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 110.918918918919, y: 3.45098039215686, size: 1 },
    //     { x: 121.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 124.540540540541, y: 3.45098039215686, size: 1 },
    //     { x: 142.054054054054, y: 3.45098039215686, size: 1 },
    //     { x: 144, y: 3.25490196078431, size: 1 },
    //     { x: 144.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 146.594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 147.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 151.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 155.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 155.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 186.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 187.459459459459, y: 3.41176470588235, size: 1 },
    //     { x: 210.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 224.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 229.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 230.27027027027, y: 3.01960784313725, size: 1 },
    //     { x: 231.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 232.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 251.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 251.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 252.324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 252.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 253.621621621622, y: 2.74509803921569, size: 1 },
    //     { x: 254.27027027027, y: 2.47058823529412, size: 1 },
    //     { x: 265.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 271.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 273.72972972973, y: 2.62745098039216, size: 1 },
    //     { x: 274.378378378378, y: 2.74509803921569, size: 1 },
    //     { x: 275.027027027027, y: 2.66666666666667, size: 1 },
    //     { x: 275.675675675676, y: 2.7843137254902, size: 1 },
    //     { x: 288.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 293.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 295.135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 295.783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 317.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 334.702702702703, y: 3.56862745098039, size: 1 },
    //     { x: 338.594594594595, y: 2.90196078431373, size: 1 },
    //     { x: 339.243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 343.783783783784, y: 3.41176470588235, size: 1 },
    //     { x: 351.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 84.8201438848921, y: 3.25490196078431, size: 1 },
    //     { x: 86.7625899280576, y: 2.86274509803922, size: 1 },
    //     { x: 151.510791366906, y: 3.29411764705882, size: 1 },
    //     { x: 167.697841726619, y: 3.33333333333333, size: 1 },
    //     { x: 174.172661870504, y: 3.05882352941176, size: 1 },
    //     { x: 174.820143884892, y: 2.98039215686275, size: 1 },
    //     { x: 194.244604316547, y: 2.86274509803922, size: 1 },
    //     { x: 195.539568345324, y: 2.66666666666667, size: 1 },
    //     { x: 196.187050359712, y: 2.94117647058824, size: 1 },
    //     { x: 233.741007194245, y: 3.88235294117647, size: 1 },
    //     { x: 236.978417266187, y: 3.05882352941176, size: 1 },
    //     { x: 275.827338129496, y: 3.33333333333333, size: 1 },
    //     { x: 281.654676258993, y: 2.86274509803922, size: 1 },
    //     { x: 312.086330935252, y: 4, size: 1 },
    //     { x: 72.5179856115108, y: 3.09803921568627, size: 1 },
    //     { x: 95.1798561151079, y: 4.07843137254902, size: 1 },
    //     { x: 108.776978417266, y: 3.96078431372549, size: 1 },
    //     { x: 110.719424460432, y: 3.96078431372549, size: 1 },
    //     { x: 114.604316546763, y: 3.05882352941176, size: 1 },
    //     { x: 117.194244604317, y: 2.90196078431373, size: 1 },
    //     { x: 136.618705035971, y: 2.82352941176471, size: 1 },
    //     { x: 137.26618705036, y: 2.98039215686275, size: 1 },
    //     { x: 157.985611510791, y: 2.94117647058824, size: 1 },
    //     { x: 163.812949640288, y: 3.33333333333333, size: 1 },
    //     { x: 208.489208633094, y: 3.25490196078431, size: 1 },
    //     { x: 224.028776978417, y: 3.05882352941176, size: 1 },
    //     { x: 224.676258992806, y: 2.98039215686275, size: 1 },
    //     { x: 288.776978417266, y: 2.58823529411765, size: 1 },
    //     { x: 289.424460431655, y: 2.74509803921569, size: 1 },
    //     { x: 290.071942446043, y: 2.90196078431373, size: 1 },
    //     { x: 309.496402877698, y: 3.33333333333333, size: 1 },
    //     { x: 341.223021582734, y: 3.88235294117647, size: 1 },
    //     { x: 57.6258992805755, y: 2.86274509803922, size: 1 },
    //     { x: 58.273381294964, y: 2.98039215686275, size: 1 },
    //     { x: 78.9928057553957, y: 3.17647058823529, size: 1 },
    //     { x: 122.374100719424, y: 3.09803921568627, size: 1 },
    //     { x: 123.021582733813, y: 2.90196078431373, size: 1 },
    //     { x: 124.31654676259, y: 3.17647058823529, size: 1 },
    //     { x: 143.741007194245, y: 2.98039215686275, size: 1 },
    //     { x: 165.755395683453, y: 3.2156862745098, size: 1 },
    //     { x: 178.705035971223, y: 4.11764705882353, size: 1 },
    //     { x: 187.769784172662, y: 2.7843137254902, size: 1 },
    //     { x: 209.136690647482, y: 3.05882352941176, size: 1 },
    //     { x: 210.431654676259, y: 2.70588235294118, size: 1 },
    //     { x: 229.856115107914, y: 2.58823529411765, size: 1 },
    //     { x: 230.503597122302, y: 2.54901960784314, size: 1 },
    //     { x: 292.014388489209, y: 3.88235294117647, size: 1 },
    //     { x: 358.705035971223, y: 3.13725490196078, size: 1 },
    //     { x: 359.352517985611, y: 3.05882352941176, size: 1 },
    //     { x: 22.6618705035971, y: 2.82352941176471, size: 1 },
    //     { x: 58.9208633093525, y: 4.03921568627451, size: 1 },
    //     { x: 85.4676258992806, y: 3.05882352941176, size: 1 },
    //     { x: 128.201438848921, y: 3.01960784313725, size: 1 },
    //     { x: 128.848920863309, y: 2.19607843137255, size: 1 },
    //     { x: 129.496402877698, y: 2.19607843137255, size: 1 },
    //     { x: 142.446043165468, y: 4.07843137254902, size: 1 },
    //     { x: 172.230215827338, y: 2.70588235294118, size: 1 },
    //     { x: 189.712230215827, y: 3.25490196078431, size: 1 },
    //     { x: 214.31654676259, y: 3.01960784313725, size: 1 },
    //     { x: 215.611510791367, y: 2.62745098039216, size: 1 },
    //     { x: 221.438848920863, y: 3.92156862745098, size: 1 },
    //     { x: 236.978417266187, y: 2.62745098039216, size: 1 },
    //     { x: 258.345323741007, y: 1.80392156862745, size: 1 },
    //     { x: 258.992805755396, y: 1.92156862745098, size: 1 },
    //     { x: 270, y: 3.09803921568627, size: 1 },
    //     { x: 272.589928057554, y: 3.09803921568627, size: 1 },
    //     { x: 282.94964028777, y: 3.2156862745098, size: 1 },
    //     { x: 287.482014388489, y: 3.13725490196078, size: 1 },
    //     { x: 297.194244604317, y: 3.17647058823529, size: 1 },
    //     { x: 298.489208633094, y: 3.13725490196078, size: 1 },
    //     { x: 342.517985611511, y: 3.25490196078431, size: 1 },
    //     { x: 344.460431654676, y: 2.98039215686275, size: 1 },
    //     { x: 347.05035971223, y: 3.13725490196078, size: 1 },
    //     { x: 350.935251798561, y: 3.05882352941176, size: 1 },
    //     { x: 356.762589928058, y: 3.09803921568627, size: 1 },
    //     { x: 1.2972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 1.94594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 2.59459459459459, y: 3.01960784313725, size: 1 },
    //     { x: 3.89189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 5.18918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 5.83783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 6.48648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 27.8918918918919, y: 2.31372549019608, size: 1 },
    //     { x: 28.5405405405405, y: 2, size: 1 },
    //     { x: 29.8378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 30.4864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 32.4324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 35.6756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 41.5135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 42.1621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 46.0540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 55.1351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 70.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 76.5405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 86.9189189189189, y: 3.41176470588235, size: 1 },
    //     { x: 109.621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 114.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 114.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 136.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 139.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 158.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 177.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 179.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 181.621621621622, y: 4, size: 1 },
    //     { x: 194.594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 199.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 201.081081081081, y: 3.01960784313725, size: 1 },
    //     { x: 201.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 202.378378378378, y: 2.70588235294118, size: 1 },
    //     { x: 203.027027027027, y: 2.66666666666667, size: 1 },
    //     { x: 221.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 222.486486486486, y: 2.94117647058824, size: 1 },
    //     { x: 223.135135135135, y: 2.70588235294118, size: 1 },
    //     { x: 224.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 225.081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 227.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 230.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 232.864864864865, y: 3.45098039215686, size: 1 },
    //     { x: 234.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 236.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 238.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 241.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 242.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 243.891891891892, y: 2.86274509803922, size: 1 },
    //     { x: 245.189189189189, y: 2.70588235294118, size: 1 },
    //     { x: 245.837837837838, y: 3.05882352941176, size: 1 },
    //     { x: 267.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 286.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 287.351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 288, y: 2.82352941176471, size: 1 },
    //     { x: 292.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 293.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 13.5971223021583, y: 2.7843137254902, size: 1 },
    //     { x: 14.2446043165468, y: 2.98039215686275, size: 1 },
    //     { x: 35.6115107913669, y: 3.25490196078431, size: 1 },
    //     { x: 36.2589928057554, y: 2.86274509803922, size: 1 },
    //     { x: 36.9064748201439, y: 2.98039215686275, size: 1 },
    //     { x: 37.5539568345324, y: 2.7843137254902, size: 1 },
    //     { x: 56.9784172661871, y: 2.70588235294118, size: 1 },
    //     { x: 57.6258992805755, y: 2.90196078431373, size: 1 },
    //     { x: 121.726618705036, y: 2.7843137254902, size: 1 },
    //     { x: 122.374100719424, y: 2.94117647058824, size: 1 },
    //     { x: 144.388489208633, y: 2.90196078431373, size: 1 },
    //     { x: 231.151079136691, y: 2.82352941176471, size: 1 },
    //     { x: 231.798561151079, y: 2.66666666666667, size: 1 },
    //     { x: 251.223021582734, y: 2.3921568627451, size: 1 },
    //     { x: 251.870503597122, y: 2.70588235294118, size: 1 },
    //     { x: 252.517985611511, y: 2.74509803921569, size: 1 },
    //     { x: 253.165467625899, y: 2.50980392156863, size: 1 },
    //     { x: 337.338129496403, y: 2.90196078431373, size: 1 },
    //     { x: 337.985611510791, y: 2.74509803921569, size: 1 },
    //     { x: 338.63309352518, y: 2.47058823529412, size: 1 },
    //     { x: 339.280575539568, y: 2.58823529411765, size: 1 },
    //     { x: 358.705035971223, y: 3.05882352941176, size: 1 },
    //     { x: 0, y: 3.01960784313725, size: 1 },
    //     { x: 1.94244604316547, y: 4, size: 1 },
    //     { x: 20.7194244604317, y: 3.05882352941176, size: 1 },
    //     { x: 21.3669064748201, y: 3.01960784313725, size: 1 },
    //     { x: 40.7913669064748, y: 4, size: 1 },
    //     { x: 64.1007194244604, y: 2.82352941176471, size: 1 },
    //     { x: 65.3956834532374, y: 3.17647058823529, size: 1 },
    //     { x: 66.0431654676259, y: 2.98039215686275, size: 1 },
    //     { x: 85.4676258992806, y: 2.74509803921569, size: 1 },
    //     { x: 86.7625899280576, y: 2.82352941176471, size: 1 },
    //     { x: 87.410071942446, y: 2.98039215686275, size: 1 },
    //     { x: 106.834532374101, y: 3.05882352941176, size: 1 },
    //     { x: 108.776978417266, y: 3.92156862745098, size: 1 },
    //     { x: 215.611510791367, y: 2.94117647058824, size: 1 },
    //     { x: 289.424460431655, y: 4.03921568627451, size: 1 },
    //     { x: 301.079136690647, y: 3.01960784313725, size: 1 },
    //     { x: 312.73381294964, y: 4.03921568627451, size: 1 },
    //     { x: 323.093525179856, y: 2.11764705882353, size: 1 },
    //     { x: 345.107913669065, y: 3.13725490196078, size: 1 },
    //     { x: 5.8273381294964, y: 3.25490196078431, size: 1 },
    //     { x: 49.2086330935252, y: 3.17647058823529, size: 1 },
    //     { x: 50.5035971223022, y: 2.86274509803922, size: 1 },
    //     { x: 70.5755395683453, y: 3.09803921568627, size: 1 },
    //     { x: 91.9424460431655, y: 2.90196078431373, size: 1 },
    //     { x: 93.8848920863309, y: 3.09803921568627, size: 1 },
    //     { x: 117.841726618705, y: 3.96078431372549, size: 1 },
    //     { x: 168.345323741007, y: 3.96078431372549, size: 1 },
    //     { x: 185.827338129496, y: 3.92156862745098, size: 1 },
    //     { x: 186.474820143885, y: 3.88235294117647, size: 1 },
    //     { x: 196.187050359712, y: 4, size: 1 },
    //     { x: 200.719424460432, y: 3.01960784313725, size: 1 },
    //     { x: 308.201438848921, y: 3.05882352941176, size: 1 },
    //     { x: 308.848920863309, y: 3.05882352941176, size: 1 },
    //     { x: 5.18918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 6.48648648648649, y: 3.76470588235294, size: 1 },
    //     { x: 12.3243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 24.6486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 33.0810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 35.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 36.3243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 40.2162162162162, y: 3.49019607843137, size: 1 },
    //     { x: 48.6486486486486, y: 3.76470588235294, size: 1 },
    //     { x: 55.1351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 55.7837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 56.4324324324324, y: 1.49019607843137, size: 1 },
    //     { x: 57.0810810810811, y: 1.17647058823529, size: 1 },
    //     { x: 57.7297297297297, y: 1.01960784313725, size: 1 },
    //     { x: 58.3783783783784, y: 1.2156862745098, size: 1 },
    //     { x: 60.972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 61.6216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 65.5135135135135, y: 2.82352941176471, size: 1 },
    //     { x: 66.1621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 72, y: 2.7843137254902, size: 1 },
    //     { x: 73.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 75.2432432432432, y: 3.37254901960784, size: 1 },
    //     { x: 75.8918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 77.1891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 77.8378378378378, y: 2.86274509803922, size: 1 },
    //     { x: 78.4864864864865, y: 2.82352941176471, size: 1 },
    //     { x: 86.9189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 97.2972972972973, y: 3.41176470588235, size: 1 },
    //     { x: 97.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 98.5945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 99.2432432432432, y: 2.98039215686275, size: 1 },
    //     { x: 103.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 104.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 111.567567567568, y: 4.11764705882353, size: 1 },
    //     { x: 112.864864864865, y: 4, size: 1 },
    //     { x: 118.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 119.351351351351, y: 3.49019607843137, size: 1 },
    //     { x: 120, y: 3.25490196078431, size: 1 },
    //     { x: 120.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 121.297297297297, y: 2.82352941176471, size: 1 },
    //     { x: 136.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 142.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 142.702702702703, y: 2.66666666666667, size: 1 },
    //     { x: 143.351351351351, y: 2.54901960784314, size: 1 },
    //     { x: 162.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 164.108108108108, y: 2.90196078431373, size: 1 },
    //     { x: 169.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 186.162162162162, y: 2.90196078431373, size: 1 },
    //     { x: 225.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 228.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 228.972972972973, y: 1.88235294117647, size: 1 },
    //     { x: 229.621621621622, y: 1.84313725490196, size: 1 },
    //     { x: 249.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 249.72972972973, y: 2.94117647058824, size: 1 },
    //     { x: 250.378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 251.027027027027, y: 2.03921568627451, size: 1 },
    //     { x: 273.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 282.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 286.054054054054, y: 3.80392156862745, size: 1 },
    //     { x: 293.837837837838, y: 2.82352941176471, size: 1 },
    //     { x: 310.702702702703, y: 4, size: 1 },
    //     { x: 324.324324324324, y: 3.84313725490196, size: 1 },
    //     { x: 328.216216216216, y: 4.11764705882353, size: 1 },
    //     { x: 330.162162162162, y: 4, size: 1 },
    //     { x: 337.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 338.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 348.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 355.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 5.17985611510791, y: 3.13725490196078, size: 1 },
    //     { x: 62.158273381295, y: 3.29411764705882, size: 1 },
    //     { x: 62.8057553956835, y: 3.25490196078431, size: 1 },
    //     { x: 64.7482014388489, y: 3.09803921568627, size: 1 },
    //     { x: 65.3956834532374, y: 3.05882352941176, size: 1 },
    //     { x: 86.1151079136691, y: 2.70588235294118, size: 1 },
    //     { x: 87.410071942446, y: 2.94117647058824, size: 1 },
    //     { x: 105.539568345324, y: 3.17647058823529, size: 1 },
    //     { x: 106.834532374101, y: 2.90196078431373, size: 1 },
    //     { x: 107.482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 108.129496402878, y: 2.54901960784314, size: 1 },
    //     { x: 108.776978417266, y: 2.47058823529412, size: 1 },
    //     { x: 179.352517985612, y: 4.03921568627451, size: 1 },
    //     { x: 192.94964028777, y: 2.94117647058824, size: 1 },
    //     { x: 193.597122302158, y: 3.17647058823529, size: 1 },
    //     { x: 194.244604316547, y: 3.09803921568627, size: 1 },
    //     { x: 277.769784172662, y: 3.17647058823529, size: 1 },
    //     { x: 281.654676258993, y: 3.01960784313725, size: 1 },
    //     { x: 343.812949640288, y: 3.09803921568627, size: 1 },
    //     { x: 344.460431654676, y: 2.86274509803922, size: 1 },
    //     { x: 345.107913669065, y: 3.05882352941176, size: 1 },
    //     { x: 13.5971223021583, y: 3.88235294117647, size: 1 },
    //     { x: 27.1942446043165, y: 3.09803921568627, size: 1 },
    //     { x: 49.2086330935252, y: 3.01960784313725, size: 1 },
    //     { x: 51.1510791366906, y: 2.98039215686275, size: 1 },
    //     { x: 70.5755395683453, y: 2.66666666666667, size: 1 },
    //     { x: 71.8705035971223, y: 2.90196078431373, size: 1 },
    //     { x: 94.5323741007194, y: 3.13725490196078, size: 1 },
    //     { x: 95.1798561151079, y: 4.03921568627451, size: 1 },
    //     { x: 110.071942446043, y: 3.29411764705882, size: 1 },
    //     { x: 135.323741007194, y: 2.94117647058824, size: 1 },
    //     { x: 135.971223021583, y: 3.09803921568627, size: 1 },
    //     { x: 136.618705035971, y: 2.62745098039216, size: 1 },
    //     { x: 137.26618705036, y: 2.70588235294118, size: 1 },
    //     { x: 138.561151079137, y: 3.88235294117647, size: 1 },
    //     { x: 143.093525179856, y: 4.03921568627451, size: 1 },
    //     { x: 146.330935251799, y: 3.96078431372549, size: 1 },
    //     { x: 156.690647482014, y: 2.82352941176471, size: 1 },
    //     { x: 265.467625899281, y: 2.70588235294118, size: 1 },
    //     { x: 266.115107913669, y: 2.70588235294118, size: 1 },
    //     { x: 266.762589928058, y: 2.7843137254902, size: 1 },
    //     { x: 296.546762589928, y: 4.07843137254902, size: 1 },
    //     { x: 329.568345323741, y: 2.94117647058824, size: 1 },
    //     { x: 330.215827338129, y: 2.98039215686275, size: 1 },
    //     { x: 330.863309352518, y: 2.47058823529412, size: 1 },
    //     { x: 331.510791366906, y: 2.90196078431373, size: 1 },
    //     { x: 74.4604316546763, y: 4.03921568627451, size: 1 },
    //     { x: 78.3453237410072, y: 3.17647058823529, size: 1 },
    //     { x: 99.7122302158273, y: 3.01960784313725, size: 1 },
    //     { x: 100.359712230216, y: 2.70588235294118, size: 1 },
    //     { x: 101.007194244604, y: 2.66666666666667, size: 1 },
    //     { x: 144.388489208633, y: 4.03921568627451, size: 1 },
    //     { x: 161.870503597122, y: 3.45098039215686, size: 1 },
    //     { x: 183.884892086331, y: 4.07843137254902, size: 1 },
    //     { x: 228.561151079137, y: 2.66666666666667, size: 1 },
    //     { x: 229.208633093525, y: 2.82352941176471, size: 1 },
    //     { x: 230.503597122302, y: 2.86274509803922, size: 1 },
    //     { x: 250.575539568345, y: 3.2156862745098, size: 1 },
    //     { x: 251.223021582734, y: 2.98039215686275, size: 1 },
    //     { x: 0, y: 3.25490196078431, size: 1 },
    //     { x: 41.5135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 42.8108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 43.4594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 55.1351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 64.2162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 64.8648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 84.3243243243243, y: 2.43137254901961, size: 1 },
    //     { x: 84.972972972973, y: 2.86274509803922, size: 1 },
    //     { x: 86.2702702702703, y: 2.70588235294118, size: 1 },
    //     { x: 99.8918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 106.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 127.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 127.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 143.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 172.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 173.189189189189, y: 4, size: 1 },
    //     { x: 174.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 175.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 179.027027027027, y: 4.11764705882353, size: 1 },
    //     { x: 180.324324324324, y: 4.11764705882353, size: 1 },
    //     { x: 180.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 182.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 184.216216216216, y: 4.07843137254902, size: 1 },
    //     { x: 185.513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 188.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 189.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 190.702702702703, y: 4, size: 1 },
    //     { x: 198.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 201.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 202.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 203.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 209.513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 214.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 222.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 224.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 235.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 236.108108108108, y: 2.58823529411765, size: 1 },
    //     { x: 236.756756756757, y: 2.82352941176471, size: 1 },
    //     { x: 237.405405405405, y: 2.74509803921569, size: 1 },
    //     { x: 254.27027027027, y: 4.07843137254902, size: 1 },
    //     { x: 255.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 256.864864864865, y: 3.01960784313725, size: 1 },
    //     { x: 258.162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 258.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 264, y: 3.96078431372549, size: 1 },
    //     { x: 265.297297297297, y: 3.80392156862745, size: 1 },
    //     { x: 273.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 275.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 275.675675675676, y: 3.41176470588235, size: 1 },
    //     { x: 292.540540540541, y: 3.72549019607843, size: 1 },
    //     { x: 296.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 300.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 302.27027027027, y: 4, size: 1 },
    //     { x: 311.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 321.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 322.378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 323.675675675676, y: 2.62745098039216, size: 1 },
    //     { x: 324.324324324324, y: 2.43137254901961, size: 1 },
    //     { x: 326.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 340.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 344.432432432432, y: 2.82352941176471, size: 1 },
    //     { x: 345.72972972973, y: 2.70588235294118, size: 1 },
    //     { x: 346.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 5.8273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 27.841726618705, y: 3.2156862745098, size: 1 },
    //     { x: 38.8489208633094, y: 3.96078431372549, size: 1 },
    //     { x: 48.5611510791367, y: 2.94117647058824, size: 1 },
    //     { x: 53.0935251798561, y: 3.92156862745098, size: 1 },
    //     { x: 55.6834532374101, y: 4, size: 1 },
    //     { x: 70.5755395683453, y: 3.01960784313725, size: 1 },
    //     { x: 91.9424460431655, y: 2.94117647058824, size: 1 },
    //     { x: 106.187050359712, y: 4.07843137254902, size: 1 },
    //     { x: 113.309352517986, y: 3.13725490196078, size: 1 },
    //     { x: 135.323741007194, y: 2.70588235294118, size: 1 },
    //     { x: 156.690647482014, y: 2.86274509803922, size: 1 },
    //     { x: 178.705035971223, y: 2.7843137254902, size: 1 },
    //     { x: 188.41726618705, y: 3.92156862745098, size: 1 },
    //     { x: 200.071942446043, y: 2.35294117647059, size: 1 },
    //     { x: 221.438848920863, y: 2.86274509803922, size: 1 },
    //     { x: 242.805755395683, y: 2.70588235294118, size: 1 },
    //     { x: 243.453237410072, y: 2.50980392156863, size: 1 },
    //     { x: 261.58273381295, y: 4.03921568627451, size: 1 },
    //     { x: 263.525179856115, y: 3.17647058823529, size: 1 },
    //     { x: 264.820143884892, y: 2.82352941176471, size: 1 },
    //     { x: 269.352517985611, y: 3.96078431372549, size: 1 },
    //     { x: 0.647482014388489, y: 3.96078431372549, size: 1 },
    //     { x: 56.3309352517986, y: 3.05882352941176, size: 1 },
    //     { x: 75.7553956834532, y: 4.03921568627451, size: 1 },
    //     { x: 92.589928057554, y: 3.96078431372549, size: 1 },
    //     { x: 143.093525179856, y: 2.98039215686275, size: 1 },
    //     { x: 173.525179856115, y: 4, size: 1 },
    //     { x: 207.194244604317, y: 3.13725490196078, size: 1 },
    //     { x: 251.223021582734, y: 3.17647058823529, size: 1 },
    //     { x: 276.474820143885, y: 3.96078431372549, size: 1 },
    //     { x: 340.575539568345, y: 3.96078431372549, size: 1 },
    //     { x: 347.697841726619, y: 4.23529411764706, size: 1 },
    //     { x: 358.057553956835, y: 2.58823529411765, size: 1 },
    //     { x: 358.705035971223, y: 2.70588235294118, size: 1 },
    //     { x: 359.352517985611, y: 2.66666666666667, size: 1 },
    //     { x: 3.88489208633094, y: 4, size: 1 },
    //     { x: 4.53237410071942, y: 4.15686274509804, size: 1 },
    //     { x: 20.0719424460432, y: 3.05882352941176, size: 1 },
    //     { x: 84.1726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 96.4748201438849, y: 4, size: 1 },
    //     { x: 127.553956834532, y: 2.90196078431373, size: 1 },
    //     { x: 128.201438848921, y: 3.2156862745098, size: 1 },
    //     { x: 128.848920863309, y: 2.98039215686275, size: 1 },
    //     { x: 156.690647482014, y: 3.96078431372549, size: 1 },
    //     { x: 192.302158273381, y: 2.82352941176471, size: 1 },
    //     { x: 193.597122302158, y: 2.50980392156863, size: 1 },
    //     { x: 194.244604316547, y: 2.66666666666667, size: 1 },
    //     { x: 350.935251798561, y: 3.96078431372549, size: 1 },
    //     { x: 4.54054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 5.18918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 8.43243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 27.2432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 29.1891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 42.8108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 49.2972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 55.7837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 61.6216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 90.8108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 91.4594594594595, y: 2.94117647058824, size: 1 },
    //     { x: 92.1081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 92.7567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 114.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 121.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 134.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 136.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 140.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 140.756756756757, y: 4.07843137254902, size: 1 },
    //     { x: 147.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 151.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 153.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 158.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 162.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 177.72972972973, y: 2.70588235294118, size: 1 },
    //     { x: 179.027027027027, y: 2.70588235294118, size: 1 },
    //     { x: 179.675675675676, y: 2.74509803921569, size: 1 },
    //     { x: 199.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 200.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 230.918918918919, y: 4.07843137254902, size: 1 },
    //     { x: 250.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 257.513513513513, y: 3.80392156862745, size: 1 },
    //     { x: 264, y: 2.7843137254902, size: 1 },
    //     { x: 264.648648648649, y: 2.7843137254902, size: 1 },
    //     { x: 265.297297297297, y: 2.66666666666667, size: 1 },
    //     { x: 265.945945945946, y: 2.7843137254902, size: 1 },
    //     { x: 286.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 287.351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 288, y: 3.17647058823529, size: 1 },
    //     { x: 306.162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 308.756756756757, y: 3.37254901960784, size: 1 },
    //     { x: 319.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 325.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 329.513513513513, y: 3.13725490196078, size: 1 },
    //     { x: 330.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 342.486486486487, y: 3.13725490196078, size: 1 },
    //     { x: 343.135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 347.675675675676, y: 3.37254901960784, size: 1 },
    //     { x: 350.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 351.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 352.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 352.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 356.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 34.9640287769784, y: 3.05882352941176, size: 1 },
    //     { x: 35.6115107913669, y: 3.13725490196078, size: 1 },
    //     { x: 55.0359712230216, y: 3.17647058823529, size: 1 },
    //     { x: 78.3453237410072, y: 3.05882352941176, size: 1 },
    //     { x: 78.9928057553957, y: 2.90196078431373, size: 1 },
    //     { x: 98.4172661870504, y: 3.17647058823529, size: 1 },
    //     { x: 163.812949640288, y: 2.90196078431373, size: 1 },
    //     { x: 164.460431654676, y: 3.09803921568627, size: 1 },
    //     { x: 227.913669064748, y: 3.01960784313725, size: 1 },
    //     { x: 228.561151079137, y: 2.98039215686275, size: 1 },
    //     { x: 251.223021582734, y: 2.90196078431373, size: 1 },
    //     { x: 251.870503597122, y: 2.7843137254902, size: 1 },
    //     { x: 271.294964028777, y: 1.41176470588235, size: 1 },
    //     { x: 271.942446043165, y: 1.49019607843137, size: 1 },
    //     { x: 272.589928057554, y: 1.17647058823529, size: 1 },
    //     { x: 273.237410071942, y: 1.01960784313725, size: 1 },
    //     { x: 281.007194244604, y: 2.86274509803922, size: 1 },
    //     { x: 286.834532374101, y: 2.74509803921569, size: 1 },
    //     { x: 292.014388489209, y: 3.25490196078431, size: 1 },
    //     { x: 293.309352517986, y: 2.62745098039216, size: 1 },
    //     { x: 293.956834532374, y: 2.90196078431373, size: 1 },
    //     { x: 294.604316546763, y: 2.35294117647059, size: 1 },
    //     { x: 336.690647482014, y: 3.17647058823529, size: 1 },
    //     { x: 358.057553956835, y: 2.90196078431373, size: 1 },
    //     { x: 10.3597122302158, y: 4, size: 1 },
    //     { x: 29.7841726618705, y: 4.03921568627451, size: 1 },
    //     { x: 40.7913669064748, y: 2.70588235294118, size: 1 },
    //     { x: 84.1726618705036, y: 2.86274509803922, size: 1 },
    //     { x: 105.539568345324, y: 2.74509803921569, size: 1 },
    //     { x: 127.553956834532, y: 3.05882352941176, size: 1 },
    //     { x: 148.920863309353, y: 2.66666666666667, size: 1 },
    //     { x: 170.287769784173, y: 2.19607843137255, size: 1 },
    //     { x: 170.935251798561, y: 2.62745098039216, size: 1 },
    //     { x: 191.007194244604, y: 3.09803921568627, size: 1 },
    //     { x: 191.654676258993, y: 2.54901960784314, size: 1 },
    //     { x: 192.302158273381, y: 2.54901960784314, size: 1 },
    //     { x: 279.712230215827, y: 2.74509803921569, size: 1 },
    //     { x: 280.359712230216, y: 2.66666666666667, size: 1 },
    //     { x: 281.654676258993, y: 3.96078431372549, size: 1 },
    //     { x: 284.244604316547, y: 4.03921568627451, size: 1 },
    //     { x: 286.834532374101, y: 4, size: 1 },
    //     { x: 288.776978417266, y: 3.92156862745098, size: 1 },
    //     { x: 299.136690647482, y: 3.2156862745098, size: 1 },
    //     { x: 323.093525179856, y: 3.01960784313725, size: 1 },
    //     { x: 342.517985611511, y: 3.2156862745098, size: 1 },
    //     { x: 4.53237410071942, y: 2.66666666666667, size: 1 },
    //     { x: 5.17985611510791, y: 2.98039215686275, size: 1 },
    //     { x: 6.47482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 90.6474820143885, y: 3.17647058823529, size: 1 },
    //     { x: 109.424460431655, y: 4.03921568627451, size: 1 },
    //     { x: 178.705035971223, y: 2.70588235294118, size: 1 },
    //     { x: 179.352517985612, y: 3.05882352941176, size: 1 },
    //     { x: 180.647482014388, y: 3.33333333333333, size: 1 },
    //     { x: 199.424460431655, y: 2.82352941176471, size: 1 },
    //     { x: 218.201438848921, y: 3.88235294117647, size: 1 },
    //     { x: 222.086330935252, y: 2.94117647058824, size: 1 },
    //     { x: 223.381294964029, y: 3.92156862745098, size: 1 },
    //     { x: 242.805755395683, y: 3.05882352941176, size: 1 },
    //     { x: 264.172661870504, y: 3.09803921568627, size: 1 },
    //     { x: 272.589928057554, y: 4.07843137254902, size: 1 },
    //     { x: 275.179856115108, y: 4, size: 1 },
    //     { x: 281.007194244604, y: 4.03921568627451, size: 1 },
    //     { x: 285.539568345324, y: 3.17647058823529, size: 1 },
    //     { x: 306.258992805755, y: 3.09803921568627, size: 1 },
    //     { x: 308.201438848921, y: 2.94117647058824, size: 1 },
    //     { x: 330.215827338129, y: 4, size: 1 },
    //     { x: 336.043165467626, y: 4.15686274509804, size: 1 },
    //     { x: 336.690647482014, y: 4.11764705882353, size: 1 },
    //     { x: 340.575539568345, y: 4.07843137254902, size: 1 },
    //     { x: 36.2589928057554, y: 4.03921568627451, size: 1 },
    //     { x: 37.5539568345324, y: 3.96078431372549, size: 1 },
    //     { x: 53.0935251798561, y: 3.09803921568627, size: 1 },
    //     { x: 55.0359712230216, y: 2.7843137254902, size: 1 },
    //     { x: 55.6834532374101, y: 3.2156862745098, size: 1 },
    //     { x: 133.381294964029, y: 3.88235294117647, size: 1 },
    //     { x: 142.446043165468, y: 3.05882352941176, size: 1 },
    //     { x: 164.460431654676, y: 3.13725490196078, size: 1 },
    //     { x: 205.89928057554, y: 2.98039215686275, size: 1 },
    //     { x: 207.194244604317, y: 2.98039215686275, size: 1 },
    //     { x: 207.841726618705, y: 2.7843137254902, size: 1 },
    //     { x: 227.26618705036, y: 2.86274509803922, size: 1 },
    //     { x: 227.913669064748, y: 2.70588235294118, size: 1 },
    //     { x: 234.388489208633, y: 3.96078431372549, size: 1 },
    //     { x: 254.460431654676, y: 3.96078431372549, size: 1 },
    //     { x: 283.597122302158, y: 3.96078431372549, size: 1 },
    //     { x: 315.323741007194, y: 2.94117647058824, size: 1 },
    //     { x: 345.755395683453, y: 3.96078431372549, size: 1 },
    //     { x: 18.1621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 20.1081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 22.0540540540541, y: 3.76470588235294, size: 1 },
    //     { x: 41.5135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 42.1621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 42.8108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 45.4054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 47.3513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 62.2702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 69.4054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 81.7297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 83.6756756756757, y: 2.86274509803922, size: 1 },
    //     { x: 84.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 96.6486486486486, y: 3.80392156862745, size: 1 },
    //     { x: 104.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 105.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 121.297297297297, y: 3.49019607843137, size: 1 },
    //     { x: 124.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 142.702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 149.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 157.621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 171.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 215.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 232.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 234.810810810811, y: 3.01960784313725, size: 1 },
    //     { x: 235.459459459459, y: 2.98039215686275, size: 1 },
    //     { x: 239.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 241.297297297297, y: 3.84313725490196, size: 1 },
    //     { x: 254.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 258.162162162162, y: 2.82352941176471, size: 1 },
    //     { x: 304.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 321.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 322.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 323.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 337.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 341.189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 342.486486486487, y: 3.01960784313725, size: 1 },
    //     { x: 343.783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 26.5467625899281, y: 2.90196078431373, size: 1 },
    //     { x: 47.2661870503597, y: 3.17647058823529, size: 1 },
    //     { x: 47.9136690647482, y: 3.13725490196078, size: 1 },
    //     { x: 70.5755395683453, y: 2.94117647058824, size: 1 },
    //     { x: 71.2230215827338, y: 2.70588235294118, size: 1 },
    //     { x: 189.064748201439, y: 3.84313725490196, size: 1 },
    //     { x: 190.359712230216, y: 3.96078431372549, size: 1 },
    //     { x: 191.654676258993, y: 3.96078431372549, size: 1 },
    //     { x: 194.244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 198.776978417266, y: 2.54901960784314, size: 1 },
    //     { x: 222.086330935252, y: 2.86274509803922, size: 1 },
    //     { x: 263.525179856115, y: 2.94117647058824, size: 1 },
    //     { x: 267.410071942446, y: 4, size: 1 },
    //     { x: 271.294964028777, y: 4.11764705882353, size: 1 },
    //     { x: 280.359712230216, y: 4, size: 1 },
    //     { x: 285.539568345324, y: 2.58823529411765, size: 1 },
    //     { x: 287.482014388489, y: 4, size: 1 },
    //     { x: 306.906474820144, y: 2.7843137254902, size: 1 },
    //     { x: 313.381294964029, y: 3.96078431372549, size: 1 },
    //     { x: 331.510791366906, y: 4.11764705882353, size: 1 },
    //     { x: 337.338129496403, y: 4.03921568627451, size: 1 },
    //     { x: 349.640287769784, y: 2.98039215686275, size: 1 },
    //     { x: 1.29496402877698, y: 4, size: 1 },
    //     { x: 11.0071942446043, y: 2.35294117647059, size: 1 },
    //     { x: 11.6546762589928, y: 2.3921568627451, size: 1 },
    //     { x: 26.5467625899281, y: 4.11764705882353, size: 1 },
    //     { x: 32.3741007194245, y: 3.05882352941176, size: 1 },
    //     { x: 33.0215827338129, y: 2.23529411764706, size: 1 },
    //     { x: 54.3884892086331, y: 2.58823529411765, size: 1 },
    //     { x: 55.0359712230216, y: 2.70588235294118, size: 1 },
    //     { x: 75.7553956834532, y: 2.90196078431373, size: 1 },
    //     { x: 185.827338129496, y: 2.94117647058824, size: 1 },
    //     { x: 194.892086330935, y: 4.11764705882353, size: 1 },
    //     { x: 249.928057553957, y: 2.94117647058824, size: 1 },
    //     { x: 250.575539568345, y: 2.86274509803922, size: 1 },
    //     { x: 324.388489208633, y: 4, size: 1 },
    //     { x: 358.057553956835, y: 2.82352941176471, size: 1 },
    //     { x: 16.1870503597122, y: 4.03921568627451, size: 1 },
    //     { x: 105.539568345324, y: 3.09803921568627, size: 1 },
    //     { x: 106.187050359712, y: 3.09803921568627, size: 1 },
    //     { x: 148.273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 149.568345323741, y: 3.2156862745098, size: 1 },
    //     { x: 203.956834532374, y: 3.92156862745098, size: 1 },
    //     { x: 262.230215827338, y: 4, size: 1 },
    //     { x: 264.820143884892, y: 4, size: 1 },
    //     { x: 300.431654676259, y: 2.94117647058824, size: 1 },
    //     { x: 322.446043165468, y: 2.86274509803922, size: 1 },
    //     { x: 341.223021582734, y: 3.13725490196078, size: 1 },
    //     { x: 341.870503597122, y: 3.05882352941176, size: 1 },
    //     { x: 12.972972972973, y: 4.11764705882353, size: 1 },
    //     { x: 17.5135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 25.2972972972973, y: 2.74509803921569, size: 1 },
    //     { x: 25.9459459459459, y: 2.82352941176471, size: 1 },
    //     { x: 37.6216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 68.7567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 88.2162162162162, y: 3.37254901960784, size: 1 },
    //     { x: 88.8648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 89.5135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 90.1621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 90.8108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 91.4594594594595, y: 2.7843137254902, size: 1 },
    //     { x: 92.1081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 148.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 181.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 185.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 203.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 217.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 241.297297297297, y: 2.74509803921569, size: 1 },
    //     { x: 241.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 242.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 243.243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 262.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 267.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 275.027027027027, y: 3.76470588235294, size: 1 },
    //     { x: 278.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 280.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 282.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 284.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 284.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 285.405405405405, y: 3.01960784313725, size: 1 },
    //     { x: 286.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 286.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 287.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 308.756756756757, y: 3.80392156862745, size: 1 },
    //     { x: 328.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 329.513513513513, y: 3.01960784313725, size: 1 },
    //     { x: 349.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 358.054054054054, y: 4, size: 1 },
    //     { x: 11.0071942446043, y: 2.47058823529412, size: 1 },
    //     { x: 12.3021582733813, y: 2.7843137254902, size: 1 },
    //     { x: 34.3165467625899, y: 3.13725490196078, size: 1 },
    //     { x: 54.3884892086331, y: 3.09803921568627, size: 1 },
    //     { x: 75.7553956834532, y: 3.09803921568627, size: 1 },
    //     { x: 166.402877697842, y: 4, size: 1 },
    //     { x: 176.762589928058, y: 4, size: 1 },
    //     { x: 179.352517985612, y: 4, size: 1 },
    //     { x: 185.827338129496, y: 2.98039215686275, size: 1 },
    //     { x: 266.762589928058, y: 4.11764705882353, size: 1 },
    //     { x: 270.647482014389, y: 2.98039215686275, size: 1 },
    //     { x: 271.294964028777, y: 2.66666666666667, size: 1 },
    //     { x: 283.597122302158, y: 3.92156862745098, size: 1 },
    //     { x: 333.453237410072, y: 4.07843137254902, size: 1 },
    //     { x: 345.107913669065, y: 4.19607843137255, size: 1 },
    //     { x: 356.115107913669, y: 2.90196078431373, size: 1 },
    //     { x: 17.4820143884892, y: 3.09803921568627, size: 1 },
    //     { x: 18.1294964028777, y: 3.09803921568627, size: 1 },
    //     { x: 27.1942446043165, y: 4, size: 1 },
    //     { x: 64.1007194244604, y: 3.96078431372549, size: 1 },
    //     { x: 69.9280575539568, y: 4.19607843137255, size: 1 },
    //     { x: 82.8776978417266, y: 2.98039215686275, size: 1 },
    //     { x: 109.424460431655, y: 3.96078431372549, size: 1 },
    //     { x: 125.611510791367, y: 2.19607843137255, size: 1 },
    //     { x: 126.258992805755, y: 1.49019607843137, size: 1 },
    //     { x: 126.906474820144, y: 1.92156862745098, size: 1 },
    //     { x: 127.553956834532, y: 2.15686274509804, size: 1 },
    //     { x: 128.201438848921, y: 3.05882352941176, size: 1 },
    //     { x: 130.791366906475, y: 2.7843137254902, size: 1 },
    //     { x: 135.323741007194, y: 2.82352941176471, size: 1 },
    //     { x: 141.151079136691, y: 2.74509803921569, size: 1 },
    //     { x: 141.798561151079, y: 2.82352941176471, size: 1 },
    //     { x: 201.36690647482, y: 4, size: 1 },
    //     { x: 233.093525179856, y: 3.05882352941176, size: 1 },
    //     { x: 233.741007194245, y: 2.66666666666667, size: 1 },
    //     { x: 234.388489208633, y: 2.54901960784314, size: 1 },
    //     { x: 277.122302158273, y: 2.70588235294118, size: 1 },
    //     { x: 297.841726618705, y: 3.05882352941176, size: 1 },
    //     { x: 298.489208633094, y: 2.35294117647059, size: 1 },
    //     { x: 299.136690647482, y: 2.47058823529412, size: 1 },
    //     { x: 306.258992805755, y: 3.92156862745098, size: 1 },
    //     { x: 319.856115107914, y: 2.43137254901961, size: 1 },
    //     { x: 320.503597122302, y: 2.15686274509804, size: 1 },
    //     { x: 3.23741007194245, y: 2.74509803921569, size: 1 },
    //     { x: 3.88489208633094, y: 2.86274509803922, size: 1 },
    //     { x: 24.6043165467626, y: 2.58823529411765, size: 1 },
    //     { x: 25.2517985611511, y: 2.50980392156863, size: 1 },
    //     { x: 138.561151079137, y: 4.07843137254902, size: 1 },
    //     { x: 239.568345323741, y: 3.37254901960784, size: 1 },
    //     { x: 241.510791366906, y: 3.13725490196078, size: 1 },
    //     { x: 262.230215827338, y: 2.7843137254902, size: 1 },
    //     { x: 284.244604316547, y: 3.2156862745098, size: 1 },
    //     { x: 285.539568345324, y: 2.86274509803922, size: 1 },
    //     { x: 307.553956834532, y: 3.96078431372549, size: 1 },
    //     { x: 328.920863309353, y: 3.09803921568627, size: 1 },
    //     { x: 348.345323741007, y: 3.13725490196078, size: 1 },
    //     { x: 349.640287769784, y: 3.09803921568627, size: 1 },
    //     { x: 9.72972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 10.3783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 11.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 33.0810810810811, y: 2.74509803921569, size: 1 },
    //     { x: 53.1891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 53.8378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 77.1891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 96.6486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 97.2972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 97.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 98.5945945945946, y: 2.90196078431373, size: 1 },
    //     { x: 99.8918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 107.027027027027, y: 4.07843137254902, size: 1 },
    //     { x: 111.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 118.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 118.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 119.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 125.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 141.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 142.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 145.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 161.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 162.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 162.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 163.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 182.918918918919, y: 2.90196078431373, size: 1 },
    //     { x: 184.864864864865, y: 2.82352941176471, size: 1 },
    //     { x: 185.513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 199.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 207.567567567568, y: 4.11764705882353, size: 1 },
    //     { x: 241.297297297297, y: 4, size: 1 },
    //     { x: 247.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 248.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 249.081081081081, y: 2.54901960784314, size: 1 },
    //     { x: 249.72972972973, y: 2.47058823529412, size: 1 },
    //     { x: 258.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 280.864864864865, y: 3.80392156862745, size: 1 },
    //     { x: 291.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 292.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 293.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 299.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 300.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 313.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 313.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 333.405405405405, y: 3.09803921568627, size: 1 },
    //     { x: 334.702702702703, y: 2.62745098039216, size: 1 },
    //     { x: 335.351351351351, y: 2.58823529411765, size: 1 },
    //     { x: 336, y: 2.98039215686275, size: 1 },
    //     { x: 336.648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 343.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 21.3669064748201, y: 3.92156862745098, size: 1 },
    //     { x: 22.6618705035971, y: 4.15686274509804, size: 1 },
    //     { x: 30.431654676259, y: 4.07843137254902, size: 1 },
    //     { x: 34.9640287769784, y: 4, size: 1 },
    //     { x: 36.9064748201439, y: 3.96078431372549, size: 1 },
    //     { x: 51.1510791366906, y: 4.11764705882353, size: 1 },
    //     { x: 55.6834532374101, y: 4.15686274509804, size: 1 },
    //     { x: 56.3309352517986, y: 4.03921568627451, size: 1 },
    //     { x: 56.9784172661871, y: 3.92156862745098, size: 1 },
    //     { x: 67.9856115107914, y: 4.23529411764706, size: 1 },
    //     { x: 70.5755395683453, y: 4.11764705882353, size: 1 },
    //     { x: 75.7553956834532, y: 4.15686274509804, size: 1 },
    //     { x: 125.611510791367, y: 2.7843137254902, size: 1 },
    //     { x: 126.258992805755, y: 3.05882352941176, size: 1 },
    //     { x: 211.726618705036, y: 3.17647058823529, size: 1 },
    //     { x: 212.374100719424, y: 3.09803921568627, size: 1 },
    //     { x: 218.201438848921, y: 4.03921568627451, size: 1 },
    //     { x: 229.208633093525, y: 4.03921568627451, size: 1 },
    //     { x: 230.503597122302, y: 4.11764705882353, size: 1 },
    //     { x: 234.388489208633, y: 3.05882352941176, size: 1 },
    //     { x: 235.035971223022, y: 2.74509803921569, size: 1 },
    //     { x: 235.68345323741, y: 2.74509803921569, size: 1 },
    //     { x: 53.0935251798561, y: 3.96078431372549, size: 1 },
    //     { x: 67.3381294964029, y: 3.13725490196078, size: 1 },
    //     { x: 90, y: 3.17647058823529, size: 1 },
    //     { x: 179.352517985612, y: 3.88235294117647, size: 1 },
    //     { x: 304.31654676259, y: 3.13725490196078, size: 1 },
    //     { x: 306.258992805755, y: 2.70588235294118, size: 1 },
    //     { x: 357.410071942446, y: 4.03921568627451, size: 1 },
    //     { x: 51.1510791366906, y: 3.29411764705882, size: 1 },
    //     { x: 53.0935251798561, y: 2.27450980392157, size: 1 },
    //     { x: 73.1654676258993, y: 3.13725490196078, size: 1 },
    //     { x: 74.4604316546763, y: 2.54901960784314, size: 1 },
    //     { x: 75.1079136690647, y: 2.54901960784314, size: 1 },
    //     { x: 82.2302158273381, y: 3.96078431372549, size: 1 },
    //     { x: 96.4748201438849, y: 3.13725490196078, size: 1 },
    //     { x: 117.841726618705, y: 2.7843137254902, size: 1 },
    //     { x: 118.489208633094, y: 2.66666666666667, size: 1 },
    //     { x: 139.208633093525, y: 2.54901960784314, size: 1 },
    //     { x: 139.856115107914, y: 2.31372549019608, size: 1 },
    //     { x: 159.280575539568, y: 3.13725490196078, size: 1 },
    //     { x: 160.575539568345, y: 2.86274509803922, size: 1 },
    //     { x: 161.223021582734, y: 2.62745098039216, size: 1 },
    //     { x: 203.309352517986, y: 3.05882352941176, size: 1 },
    //     { x: 203.956834532374, y: 2.90196078431373, size: 1 },
    //     { x: 204.604316546763, y: 1.88235294117647, size: 1 },
    //     { x: 209.136690647482, y: 4, size: 1 },
    //     { x: 219.496402877698, y: 4.07843137254902, size: 1 },
    //     { x: 224.028776978417, y: 3.01960784313725, size: 1 },
    //     { x: 224.676258992806, y: 2.86274509803922, size: 1 },
    //     { x: 225.971223021583, y: 1.56862745098039, size: 1 },
    //     { x: 268.057553956835, y: 3.09803921568627, size: 1 },
    //     { x: 268.705035971223, y: 2.74509803921569, size: 1 },
    //     { x: 269.352517985611, y: 2.43137254901961, size: 1 },
    //     { x: 312.086330935252, y: 2.31372549019608, size: 1 },
    //     { x: 312.73381294964, y: 2.35294117647059, size: 1 },
    //     { x: 1.94594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 11.027027027027, y: 3.80392156862745, size: 1 },
    //     { x: 16.2162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 17.5135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 18.1621621621622, y: 2.82352941176471, size: 1 },
    //     { x: 18.8108108108108, y: 2.90196078431373, size: 1 },
    //     { x: 38.9189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 53.8378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 63.5675675675676, y: 4.03921568627451, size: 1 },
    //     { x: 81.7297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 82.3783783783784, y: 3.49019607843137, size: 1 },
    //     { x: 89.5135135135135, y: 4, size: 1 },
    //     { x: 101.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 103.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 103.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 104.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 105.081081081081, y: 2.90196078431373, size: 1 },
    //     { x: 112.216216216216, y: 3.49019607843137, size: 1 },
    //     { x: 123.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 124.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 125.189189189189, y: 2.86274509803922, size: 1 },
    //     { x: 125.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 126.486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 127.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 145.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 147.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 154.378378378378, y: 3.45098039215686, size: 1 },
    //     { x: 166.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 169.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 169.945945945946, y: 2.7843137254902, size: 1 },
    //     { x: 174.486486486486, y: 4, size: 1 },
    //     { x: 175.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 178.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 179.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 182.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 184.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 188.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 190.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 190.702702702703, y: 2.66666666666667, size: 1 },
    //     { x: 191.351351351351, y: 2.7843137254902, size: 1 },
    //     { x: 192, y: 2.98039215686275, size: 1 },
    //     { x: 195.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 202.378378378378, y: 4.15686274509804, size: 1 },
    //     { x: 211.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 212.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 225.081081081081, y: 3.45098039215686, size: 1 },
    //     { x: 240, y: 3.92156862745098, size: 1 },
    //     { x: 249.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 252.972972972973, y: 3.45098039215686, size: 1 },
    //     { x: 254.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 276.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 309.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 336, y: 3.49019607843137, size: 1 },
    //     { x: 347.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 356.756756756757, y: 4, size: 1 },
    //     { x: 2.58992805755396, y: 3.2156862745098, size: 1 },
    //     { x: 3.88489208633094, y: 3.09803921568627, size: 1 },
    //     { x: 47.2661870503597, y: 4, size: 1 },
    //     { x: 64.7482014388489, y: 3.92156862745098, size: 1 },
    //     { x: 68.6330935251799, y: 3.13725490196078, size: 1 },
    //     { x: 89.3525179856115, y: 2.43137254901961, size: 1 },
    //     { x: 90, y: 2.82352941176471, size: 1 },
    //     { x: 107.482014388489, y: 3.96078431372549, size: 1 },
    //     { x: 110.719424460432, y: 3.05882352941176, size: 1 },
    //     { x: 135.323741007194, y: 3.88235294117647, size: 1 },
    //     { x: 262.230215827338, y: 2.94117647058824, size: 1 },
    //     { x: 263.525179856115, y: 3.05882352941176, size: 1 },
    //     { x: 304.964028776978, y: 3.2156862745098, size: 1 },
    //     { x: 327.625899280576, y: 2.94117647058824, size: 1 },
    //     { x: 328.273381294964, y: 3.09803921568627, size: 1 },
    //     { x: 349.640287769784, y: 2.86274509803922, size: 1 },
    //     { x: 350.287769784173, y: 2.86274509803922, size: 1 },
    //     { x: 9.71223021582734, y: 3.09803921568627, size: 1 },
    //     { x: 14.2446043165468, y: 4.11764705882353, size: 1 },
    //     { x: 74.4604316546763, y: 2.94117647058824, size: 1 },
    //     { x: 75.1079136690647, y: 3.09803921568627, size: 1 },
    //     { x: 76.4028776978417, y: 2.82352941176471, size: 1 },
    //     { x: 154.748201438849, y: 4.07843137254902, size: 1 },
    //     { x: 185.179856115108, y: 4.11764705882353, size: 1 },
    //     { x: 186.474820143885, y: 4.07843137254902, size: 1 },
    //     { x: 235.035971223022, y: 3.92156862745098, size: 1 },
    //     { x: 248.63309352518, y: 4, size: 1 },
    //     { x: 290.071942446043, y: 2.74509803921569, size: 1 },
    //     { x: 290.719424460432, y: 2.54901960784314, size: 1 },
    //     { x: 292.014388489209, y: 2.98039215686275, size: 1 },
    //     { x: 59.568345323741, y: 3.09803921568627, size: 1 },
    //     { x: 88.705035971223, y: 4, size: 1 },
    //     { x: 103.597122302158, y: 3.17647058823529, size: 1 },
    //     { x: 124.31654676259, y: 2.94117647058824, size: 1 },
    //     { x: 124.964028776978, y: 2.62745098039216, size: 1 },
    //     { x: 172.230215827338, y: 3.96078431372549, size: 1 },
    //     { x: 214.964028776978, y: 3.96078431372549, size: 1 },
    //     { x: 276.474820143885, y: 2.98039215686275, size: 1 },
    //     { x: 277.122302158273, y: 2.35294117647059, size: 1 },
    //     { x: 277.769784172662, y: 2.35294117647059, size: 1 },
    //     { x: 323.741007194245, y: 4.03921568627451, size: 1 },
    //     { x: 339.280575539568, y: 2.90196078431373, size: 1 },
    //     { x: 340.575539568345, y: 2.19607843137255, size: 1 },
    //     { x: 341.223021582734, y: 2.15686274509804, size: 1 },
    //     { x: 341.870503597122, y: 3.25490196078431, size: 1 },
    //     { x: 342.517985611511, y: 2.50980392156863, size: 1 },
    //     { x: 345.107913669065, y: 2.90196078431373, size: 1 },
    //     { x: 345.755395683453, y: 3.13725490196078, size: 1 },
    //     { x: 350.287769784173, y: 2.94117647058824, size: 1 },
    //     { x: 1.94244604316547, y: 3.05882352941176, size: 1 },
    //     { x: 42.7338129496403, y: 4.07843137254902, size: 1 },
    //     { x: 44.6762589928058, y: 3.25490196078431, size: 1 },
    //     { x: 45.3237410071942, y: 2.43137254901961, size: 1 },
    //     { x: 66.6906474820144, y: 2.7843137254902, size: 1 },
    //     { x: 67.3381294964029, y: 2.86274509803922, size: 1 },
    //     { x: 109.424460431655, y: 3.2156862745098, size: 1 },
    //     { x: 110.071942446043, y: 2.54901960784314, size: 1 },
    //     { x: 131.438848920863, y: 2.70588235294118, size: 1 },
    //     { x: 147.625899280576, y: 4.15686274509804, size: 1 },
    //     { x: 152.805755395683, y: 1.88235294117647, size: 1 },
    //     { x: 153.453237410072, y: 1.92156862745098, size: 1 },
    //     { x: 216.906474820144, y: 3.2156862745098, size: 1 },
    //     { x: 217.553956834532, y: 2.70588235294118, size: 1 },
    //     { x: 218.201438848921, y: 2.7843137254902, size: 1 },
    //     { x: 277.122302158273, y: 4.19607843137255, size: 1 },
    //     { x: 9.08108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 10.3783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 30.4864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 31.1351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 74.5945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 96, y: 3.29411764705882, size: 1 },
    //     { x: 101.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 103.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 104.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 129.081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 138.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 139.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 142.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 151.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 177.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 180.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 198.486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 203.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 204.972972972973, y: 4.11764705882353, size: 1 },
    //     { x: 206.918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 208.864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 209.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 211.459459459459, y: 4.11764705882353, size: 1 },
    //     { x: 214.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 216, y: 4, size: 1 },
    //     { x: 217.945945945946, y: 4, size: 1 },
    //     { x: 220.540540540541, y: 4.07843137254902, size: 1 },
    //     { x: 222.486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 236.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 238.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 253.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 254.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 258.162162162162, y: 3.88235294117647, size: 1 },
    //     { x: 258.810810810811, y: 4.07843137254902, size: 1 },
    //     { x: 259.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 260.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 260.756756756757, y: 4.07843137254902, size: 1 },
    //     { x: 267.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 275.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 289.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 289.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 290.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 291.243243243243, y: 2.62745098039216, size: 1 },
    //     { x: 323.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 339.243243243243, y: 4.11764705882353, size: 1 },
    //     { x: 341.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 349.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 354.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 355.459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 46.6187050359712, y: 4.03921568627451, size: 1 },
    //     { x: 56.3309352517986, y: 4, size: 1 },
    //     { x: 59.568345323741, y: 3.13725490196078, size: 1 },
    //     { x: 60.2158273381295, y: 3.01960784313725, size: 1 },
    //     { x: 73.8129496402878, y: 3.2156862745098, size: 1 },
    //     { x: 102.94964028777, y: 3.2156862745098, size: 1 },
    //     { x: 123.021582733813, y: 4, size: 1 },
    //     { x: 155.395683453237, y: 4.03921568627451, size: 1 },
    //     { x: 168.992805755396, y: 2.98039215686275, size: 1 },
    //     { x: 169.640287769784, y: 3.05882352941176, size: 1 },
    //     { x: 170.287769784173, y: 3.01960784313725, size: 1 },
    //     { x: 170.935251798561, y: 3.17647058823529, size: 1 },
    //     { x: 172.877697841727, y: 3.25490196078431, size: 1 },
    //     { x: 174.172661870504, y: 3.01960784313725, size: 1 },
    //     { x: 178.057553956835, y: 3.13725490196078, size: 1 },
    //     { x: 179.352517985612, y: 2.82352941176471, size: 1 },
    //     { x: 180, y: 3.05882352941176, size: 1 },
    //     { x: 181.294964028777, y: 2.90196078431373, size: 1 },
    //     { x: 181.942446043165, y: 2.82352941176471, size: 1 },
    //     { x: 186.474820143885, y: 3.09803921568627, size: 1 },
    //     { x: 187.769784172662, y: 3.17647058823529, size: 1 },
    //     { x: 189.712230215827, y: 2.90196078431373, size: 1 },
    //     { x: 194.892086330935, y: 4.23529411764706, size: 1 },
    //     { x: 204.604316546763, y: 4.03921568627451, size: 1 },
    //     { x: 210.431654676259, y: 2.62745098039216, size: 1 },
    //     { x: 211.079136690647, y: 2.7843137254902, size: 1 },
    //     { x: 211.726618705036, y: 2.62745098039216, size: 1 },
    //     { x: 212.374100719424, y: 2.47058823529412, size: 1 },
    //     { x: 233.093525179856, y: 2.90196078431373, size: 1 },
    //     { x: 234.388489208633, y: 2.7843137254902, size: 1 },
    //     { x: 247.985611510791, y: 4.07843137254902, size: 1 },
    //     { x: 268.705035971223, y: 4.03921568627451, size: 1 },
    //     { x: 278.41726618705, y: 3.92156862745098, size: 1 },
    //     { x: 280.359712230216, y: 4.03921568627451, size: 1 },
    //     { x: 284.892086330935, y: 4.07843137254902, size: 1 },
    //     { x: 318.561151079137, y: 2.98039215686275, size: 1 },
    //     { x: 319.208633093525, y: 3.09803921568627, size: 1 },
    //     { x: 23.3093525179856, y: 2.74509803921569, size: 1 },
    //     { x: 23.9568345323741, y: 2.70588235294118, size: 1 },
    //     { x: 66.6906474820144, y: 3.2156862745098, size: 1 },
    //     { x: 88.705035971223, y: 3.17647058823529, size: 1 },
    //     { x: 89.3525179856115, y: 2.7843137254902, size: 1 },
    //     { x: 109.424460431655, y: 2.98039215686275, size: 1 },
    //     { x: 132.73381294964, y: 3.96078431372549, size: 1 },
    //     { x: 133.381294964029, y: 4.11764705882353, size: 1 },
    //     { x: 134.676258992806, y: 4.15686274509804, size: 1 },
    //     { x: 137.913669064748, y: 4, size: 1 },
    //     { x: 140.503597122302, y: 4, size: 1 },
    //     { x: 141.151079136691, y: 4.15686274509804, size: 1 },
    //     { x: 142.446043165468, y: 4.11764705882353, size: 1 },
    //     { x: 145.035971223022, y: 4.15686274509804, size: 1 },
    //     { x: 154.748201438849, y: 4.27450980392157, size: 1 },
    //     { x: 162.517985611511, y: 4.07843137254902, size: 1 },
    //     { x: 163.812949640288, y: 4, size: 1 },
    //     { x: 165.755395683453, y: 4, size: 1 },
    //     { x: 167.05035971223, y: 4.07843137254902, size: 1 },
    //     { x: 181.294964028777, y: 4.03921568627451, size: 1 },
    //     { x: 182.589928057554, y: 3.96078431372549, size: 1 },
    //     { x: 222.73381294964, y: 4.03921568627451, size: 1 },
    //     { x: 227.26618705036, y: 4, size: 1 },
    //     { x: 253.165467625899, y: 4.03921568627451, size: 1 },
    //     { x: 341.870503597122, y: 4, size: 1 },
    //     { x: 343.812949640288, y: 4.03921568627451, size: 1 },
    //     { x: 346.402877697842, y: 3.25490196078431, size: 1 },
    //     { x: 347.697841726619, y: 2.90196078431373, size: 1 },
    //     { x: 7.13513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 8.43243243243243, y: 2.66666666666667, size: 1 },
    //     { x: 9.08108108108108, y: 2.74509803921569, size: 1 },
    //     { x: 30.4864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 31.1351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 38.2702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 43.4594594594595, y: 3.88235294117647, size: 1 },
    //     { x: 44.1081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 49.2972972972973, y: 3.72549019607843, size: 1 },
    //     { x: 97.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 103.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 111.567567567568, y: 4.23529411764706, size: 1 },
    //     { x: 112.216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 113.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 114.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 116.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 117.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 138.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 138.810810810811, y: 3.01960784313725, size: 1 },
    //     { x: 158.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 159.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 160.216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 160.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 161.513513513514, y: 2.86274509803922, size: 1 },
    //     { x: 162.162162162162, y: 2.66666666666667, size: 1 },
    //     { x: 209.513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 210.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 219.243243243243, y: 4.15686274509804, size: 1 },
    //     { x: 247.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 254.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 254.918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 256.216216216216, y: 4.11764705882353, size: 1 },
    //     { x: 256.864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 257.513513513513, y: 3.96078431372549, size: 1 },
    //     { x: 258.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 264, y: 3.88235294117647, size: 1 },
    //     { x: 265.297297297297, y: 4, size: 1 },
    //     { x: 267.243243243243, y: 3.41176470588235, size: 1 },
    //     { x: 268.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 274.378378378378, y: 3.92156862745098, size: 1 },
    //     { x: 276.324324324324, y: 4.11764705882353, size: 1 },
    //     { x: 280.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 281.513513513513, y: 3.84313725490196, size: 1 },
    //     { x: 289.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 296.432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 297.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 299.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 312, y: 3.05882352941176, size: 1 },
    //     { x: 323.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 324.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 332.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 333.405405405405, y: 2.82352941176471, size: 1 },
    //     { x: 338.594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 342.486486486487, y: 3.96078431372549, size: 1 },
    //     { x: 354.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 15.5395683453237, y: 3.09803921568627, size: 1 },
    //     { x: 16.1870503597122, y: 2.74509803921569, size: 1 },
    //     { x: 16.8345323741007, y: 3.2156862745098, size: 1 },
    //     { x: 37.5539568345324, y: 2.66666666666667, size: 1 },
    //     { x: 38.2014388489209, y: 2.82352941176471, size: 1 },
    //     { x: 58.273381294964, y: 3.2156862745098, size: 1 },
    //     { x: 59.568345323741, y: 2.62745098039216, size: 1 },
    //     { x: 81.5827338129496, y: 2.31372549019608, size: 1 },
    //     { x: 84.1726618705036, y: 4.07843137254902, size: 1 },
    //     { x: 91.9424460431655, y: 4.19607843137255, size: 1 },
    //     { x: 93.8848920863309, y: 4.07843137254902, size: 1 },
    //     { x: 94.5323741007194, y: 3.96078431372549, size: 1 },
    //     { x: 102.302158273381, y: 2.43137254901961, size: 1 },
    //     { x: 102.94964028777, y: 2.43137254901961, size: 1 },
    //     { x: 133.381294964029, y: 4, size: 1 },
    //     { x: 141.151079136691, y: 4.03921568627451, size: 1 },
    //     { x: 167.05035971223, y: 2.98039215686275, size: 1 },
    //     { x: 167.697841726619, y: 2.19607843137255, size: 1 },
    //     { x: 187.769784172662, y: 3.01960784313725, size: 1 },
    //     { x: 189.064748201439, y: 2.35294117647059, size: 1 },
    //     { x: 233.741007194245, y: 3.96078431372549, size: 1 },
    //     { x: 287.482014388489, y: 4.23529411764706, size: 1 },
    //     { x: 292.014388489209, y: 4.11764705882353, size: 1 },
    //     { x: 339.928057553957, y: 3.25490196078431, size: 1 },
    //     { x: 350.287769784173, y: 3.96078431372549, size: 1 },
    //     { x: 5.8273381294964, y: 4, size: 1 },
    //     { x: 6.47482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 32.3741007194245, y: 4.11764705882353, size: 1 },
    //     { x: 55.0359712230216, y: 3.96078431372549, size: 1 },
    //     { x: 56.9784172661871, y: 4.11764705882353, size: 1 },
    //     { x: 57.6258992805755, y: 4.03921568627451, size: 1 },
    //     { x: 69.2805755395683, y: 4.03921568627451, size: 1 },
    //     { x: 73.1654676258993, y: 4.07843137254902, size: 1 },
    //     { x: 101.007194244604, y: 3.96078431372549, size: 1 },
    //     { x: 106.187050359712, y: 4.15686274509804, size: 1 },
    //     { x: 110.071942446043, y: 3.01960784313725, size: 1 },
    //     { x: 111.36690647482, y: 3.01960784313725, size: 1 },
    //     { x: 115.89928057554, y: 4, size: 1 },
    //     { x: 116.546762589928, y: 4.03921568627451, size: 1 },
    //     { x: 121.726618705036, y: 3.92156862745098, size: 1 },
    //     { x: 122.374100719424, y: 4.11764705882353, size: 1 },
    //     { x: 125.611510791367, y: 4.07843137254902, size: 1 },
    //     { x: 130.791366906475, y: 3.13725490196078, size: 1 },
    //     { x: 134.028776978417, y: 4.11764705882353, size: 1 },
    //     { x: 143.741007194245, y: 3.96078431372549, size: 1 },
    //     { x: 154.748201438849, y: 4, size: 1 },
    //     { x: 159.928057553957, y: 4, size: 1 },
    //     { x: 163.165467625899, y: 4.07843137254902, size: 1 },
    //     { x: 167.697841726619, y: 4.03921568627451, size: 1 },
    //     { x: 181.942446043165, y: 3.96078431372549, size: 1 },
    //     { x: 198.129496402878, y: 4, size: 1 },
    //     { x: 200.071942446043, y: 4.03921568627451, size: 1 },
    //     { x: 217.553956834532, y: 3.01960784313725, size: 1 },
    //     { x: 218.848920863309, y: 2.74509803921569, size: 1 },
    //     { x: 219.496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 252.517985611511, y: 4.03921568627451, size: 1 },
    //     { x: 255.755395683453, y: 4.07843137254902, size: 1 },
    //     { x: 257.05035971223, y: 4.15686274509804, size: 1 },
    //     { x: 257.697841726619, y: 4.15686274509804, size: 1 },
    //     { x: 267.410071942446, y: 4.35294117647059, size: 1 },
    //     { x: 276.474820143885, y: 4.03921568627451, size: 1 },
    //     { x: 291.36690647482, y: 4.11764705882353, size: 1 },
    //     { x: 292.661870503597, y: 4.03921568627451, size: 1 },
    //     { x: 293.309352517986, y: 4.07843137254902, size: 1 },
    //     { x: 295.89928057554, y: 4.19607843137255, size: 1 },
    //     { x: 300.431654676259, y: 4.15686274509804, size: 1 },
    //     { x: 301.726618705036, y: 4, size: 1 },
    //     { x: 325.035971223022, y: 2.98039215686275, size: 1 },
    //     { x: 325.68345323741, y: 2.94117647058824, size: 1 },
    //     { x: 326.330935251799, y: 3.05882352941176, size: 1 },
    //     { x: 3.88489208633094, y: 4.03921568627451, size: 1 },
    //     { x: 15.5395683453237, y: 4, size: 1 },
    //     { x: 25.8992805755396, y: 3.92156862745098, size: 1 },
    //     { x: 95.1798561151079, y: 3.05882352941176, size: 1 },
    //     { x: 138.561151079137, y: 3.09803921568627, size: 1 },
    //     { x: 139.208633093525, y: 4.15686274509804, size: 1 },
    //     { x: 141.798561151079, y: 4.11764705882353, size: 1 },
    //     { x: 152.158273381295, y: 4.07843137254902, size: 1 },
    //     { x: 152.805755395683, y: 4.19607843137255, size: 1 },
    //     { x: 196.187050359712, y: 4.11764705882353, size: 1 },
    //     { x: 226.618705035971, y: 4, size: 1 },
    //     { x: 231.798561151079, y: 4, size: 1 },
    //     { x: 252.517985611511, y: 4.07843137254902, size: 1 },
    //     { x: 268.057553956835, y: 3.13725490196078, size: 1 },
    //     { x: 292.014388489209, y: 3.96078431372549, size: 1 },
    //     { x: 310.143884892086, y: 3.2156862745098, size: 1 },
    //     { x: 310.791366906475, y: 2.7843137254902, size: 1 },
    //     { x: 311.438848920863, y: 3.29411764705882, size: 1 },
    //     { x: 317.26618705036, y: 4, size: 1 },
    //     { x: 352.877697841727, y: 3.96078431372549, size: 1 },
    //     { x: 15.5675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 18.1621621621622, y: 3.72549019607843, size: 1 },
    //     { x: 31.1351351351351, y: 3.76470588235294, size: 1 },
    //     { x: 36.972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 37.6216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 38.9189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 40.2162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 44.1081081081081, y: 4, size: 1 },
    //     { x: 49.9459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 51.2432432432432, y: 3.76470588235294, size: 1 },
    //     { x: 53.1891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 54.4864864864865, y: 3.92156862745098, size: 1 },
    //     { x: 60.3243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 73.945945945946, y: 4, size: 1 },
    //     { x: 79.7837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 81.7297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 93.4054054054054, y: 4, size: 1 },
    //     { x: 97.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 101.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 102.486486486486, y: 2.90196078431373, size: 1 },
    //     { x: 117.405405405405, y: 3.49019607843137, size: 1 },
    //     { x: 123.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 123.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 147.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 149.189189189189, y: 4, size: 1 },
    //     { x: 155.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 157.621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 160.864864864865, y: 4, size: 1 },
    //     { x: 166.702702702703, y: 2.94117647058824, size: 1 },
    //     { x: 167.351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 168, y: 3.92156862745098, size: 1 },
    //     { x: 169.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 171.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 172.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 174.486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 177.081081081081, y: 4.11764705882353, size: 1 },
    //     { x: 177.72972972973, y: 3.88235294117647, size: 1 },
    //     { x: 178.378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 181.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 182.918918918919, y: 4.07843137254902, size: 1 },
    //     { x: 183.567567567568, y: 3.92156862745098, size: 1 },
    //     { x: 184.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 185.513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 188.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 188.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 194.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 210.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 210.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 236.756756756757, y: 4, size: 1 },
    //     { x: 239.351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 240.648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 243.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 249.72972972973, y: 4.19607843137255, size: 1 },
    //     { x: 251.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 267.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 268.540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 284.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 295.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 296.432432432432, y: 2.90196078431373, size: 1 },
    //     { x: 297.081081081081, y: 2.82352941176471, size: 1 },
    //     { x: 318.486486486487, y: 3.33333333333333, size: 1 },
    //     { x: 323.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 339.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 1.29496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 3.23741007194245, y: 2.98039215686275, size: 1 },
    //     { x: 22.6618705035971, y: 3.05882352941176, size: 1 },
    //     { x: 84.8201438848921, y: 3.96078431372549, size: 1 },
    //     { x: 136.618705035971, y: 3.96078431372549, size: 1 },
    //     { x: 141.151079136691, y: 4, size: 1 },
    //     { x: 142.446043165468, y: 3.96078431372549, size: 1 },
    //     { x: 174.172661870504, y: 2.74509803921569, size: 1 },
    //     { x: 195.539568345324, y: 1.84313725490196, size: 1 },
    //     { x: 196.187050359712, y: 2.35294117647059, size: 1 },
    //     { x: 196.834532374101, y: 2.19607843137255, size: 1 },
    //     { x: 197.482014388489, y: 2.11764705882353, size: 1 },
    //     { x: 200.071942446043, y: 3.13725490196078, size: 1 },
    //     { x: 204.604316546763, y: 2.82352941176471, size: 1 },
    //     { x: 205.251798561151, y: 2.94117647058824, size: 1 },
    //     { x: 232.446043165468, y: 3.92156862745098, size: 1 },
    //     { x: 260.287769784173, y: 2.35294117647059, size: 1 },
    //     { x: 260.935251798561, y: 2.35294117647059, size: 1 },
    //     { x: 263.525179856115, y: 4, size: 1 },
    //     { x: 282.302158273381, y: 2.35294117647059, size: 1 },
    //     { x: 303.021582733813, y: 2.90196078431373, size: 1 },
    //     { x: 303.669064748201, y: 2.58823529411765, size: 1 },
    //     { x: 325.035971223022, y: 2.43137254901961, size: 1 },
    //     { x: 329.568345323741, y: 4, size: 1 },
    //     { x: 332.158273381295, y: 4.19607843137255, size: 1 },
    //     { x: 340.575539568345, y: 4.11764705882353, size: 1 },
    //     { x: 5.17985611510791, y: 4, size: 1 },
    //     { x: 8.41726618705036, y: 3.25490196078431, size: 1 },
    //     { x: 13.5971223021583, y: 4.23529411764706, size: 1 },
    //     { x: 14.8920863309353, y: 4.03921568627451, size: 1 },
    //     { x: 29.7841726618705, y: 2.27450980392157, size: 1 },
    //     { x: 30.431654676259, y: 2.31372549019608, size: 1 },
    //     { x: 49.8561151079137, y: 4.11764705882353, size: 1 },
    //     { x: 50.5035971223022, y: 3.2156862745098, size: 1 },
    //     { x: 51.1510791366906, y: 2.94117647058824, size: 1 },
    //     { x: 51.7985611510791, y: 2.7843137254902, size: 1 },
    //     { x: 66.6906474820144, y: 3.96078431372549, size: 1 },
    //     { x: 72.5179856115108, y: 3.01960784313725, size: 1 },
    //     { x: 73.1654676258993, y: 2.66666666666667, size: 1 },
    //     { x: 93.8848920863309, y: 2.94117647058824, size: 1 },
    //     { x: 94.5323741007194, y: 1.96078431372549, size: 1 },
    //     { x: 95.1798561151079, y: 1.68627450980392, size: 1 },
    //     { x: 119.136690647482, y: 4.07843137254902, size: 1 },
    //     { x: 139.208633093525, y: 4, size: 1 },
    //     { x: 141.798561151079, y: 4.03921568627451, size: 1 },
    //     { x: 218.201438848921, y: 4.07843137254902, size: 1 },
    //     { x: 238.920863309353, y: 3.96078431372549, size: 1 },
    //     { x: 242.805755395683, y: 4.07843137254902, size: 1 },
    //     { x: 268.057553956835, y: 3.25490196078431, size: 1 },
    //     { x: 277.122302158273, y: 4, size: 1 },
    //     { x: 283.597122302158, y: 4, size: 1 },
    //     { x: 289.424460431655, y: 3.09803921568627, size: 1 },
    //     { x: 311.438848920863, y: 4.19607843137255, size: 1 },
    //     { x: 316.618705035971, y: 4.11764705882353, size: 1 },
    //     { x: 12.3021582733813, y: 4.03921568627451, size: 1 },
    //     { x: 38.2014388489209, y: 3.96078431372549, size: 1 },
    //     { x: 49.2086330935252, y: 4, size: 1 },
    //     { x: 53.0935251798561, y: 4.11764705882353, size: 1 },
    //     { x: 53.7410071942446, y: 4.11764705882353, size: 1 },
    //     { x: 54.3884892086331, y: 3.96078431372549, size: 1 },
    //     { x: 56.3309352517986, y: 4.15686274509804, size: 1 },
    //     { x: 75.1079136690647, y: 3.96078431372549, size: 1 },
    //     { x: 79.6402877697842, y: 3.09803921568627, size: 1 },
    //     { x: 92.589928057554, y: 4.07843137254902, size: 1 },
    //     { x: 103.597122302158, y: 3.96078431372549, size: 1 },
    //     { x: 124.964028776978, y: 4.07843137254902, size: 1 },
    //     { x: 127.553956834532, y: 4.07843137254902, size: 1 },
    //     { x: 166.402877697842, y: 3.2156862745098, size: 1 },
    //     { x: 169.640287769784, y: 4.23529411764706, size: 1 },
    //     { x: 172.877697841727, y: 4.03921568627451, size: 1 },
    //     { x: 202.014388489209, y: 4, size: 1 },
    //     { x: 229.208633093525, y: 4, size: 1 },
    //     { x: 248.63309352518, y: 3.92156862745098, size: 1 },
    //     { x: 289.424460431655, y: 4.11764705882353, size: 1 },
    //     { x: 295.251798561151, y: 3.25490196078431, size: 1 },
    //     { x: 295.89928057554, y: 3.01960784313725, size: 1 },
    //     { x: 301.726618705036, y: 4.19607843137255, size: 1 },
    //     { x: 306.258992805755, y: 4.11764705882353, size: 1 },
    //     { x: 307.553956834532, y: 4.15686274509804, size: 1 },
    //     { x: 309.496402877698, y: 4.07843137254902, size: 1 },
    //     { x: 320.503597122302, y: 3.96078431372549, size: 1 },
    //     { x: 331.510791366906, y: 4.19607843137255, size: 1 },
    //     { x: 332.158273381295, y: 3.96078431372549, size: 1 },
    //     { x: 358.057553956835, y: 4.03921568627451, size: 1 },
    //     { x: 7.13513513513514, y: 4, size: 1 },
    //     { x: 8.43243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 14.2702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 16.2162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 16.8648648648649, y: 4, size: 1 },
    //     { x: 18.8108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 20.7567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 22.0540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 22.7027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 27.2432432432432, y: 4, size: 1 },
    //     { x: 28.5405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 31.1351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 33.0810810810811, y: 4, size: 1 },
    //     { x: 36.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 40.8648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 43.4594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 46.0540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 46.7027027027027, y: 4, size: 1 },
    //     { x: 51.8918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 52.5405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 61.6216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 62.9189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 65.5135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 72, y: 4, size: 1 },
    //     { x: 84.3243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 99.2432432432432, y: 3.80392156862745, size: 1 },
    //     { x: 110.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 112.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 114.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 129.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 130.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 173.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 194.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 195.243243243243, y: 2.94117647058824, size: 1 },
    //     { x: 232.864864864865, y: 4.07843137254902, size: 1 },
    //     { x: 234.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 237.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 238.054054054054, y: 2.7843137254902, size: 1 },
    //     { x: 249.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 279.567567567568, y: 4, size: 1 },
    //     { x: 281.513513513513, y: 3.01960784313725, size: 1 },
    //     { x: 291.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 304.216216216216, y: 4, size: 1 },
    //     { x: 312, y: 3.92156862745098, size: 1 },
    //     { x: 322.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 350.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 2.58992805755396, y: 4.23529411764706, size: 1 },
    //     { x: 29.7841726618705, y: 2.86274509803922, size: 1 },
    //     { x: 38.2014388489209, y: 4.03921568627451, size: 1 },
    //     { x: 116.546762589928, y: 3.09803921568627, size: 1 },
    //     { x: 150.863309352518, y: 4.07843137254902, size: 1 },
    //     { x: 176.115107913669, y: 3.88235294117647, size: 1 },
    //     { x: 246.690647482014, y: 2.86274509803922, size: 1 },
    //     { x: 247.338129496403, y: 2.50980392156863, size: 1 },
    //     { x: 331.510791366906, y: 2.82352941176471, size: 1 },
    //     { x: 332.158273381295, y: 2.50980392156863, size: 1 },
    //     { x: 353.525179856115, y: 3.01960784313725, size: 1 },
    //     { x: 36.2589928057554, y: 3.01960784313725, size: 1 },
    //     { x: 79.6402877697842, y: 2.62745098039216, size: 1 },
    //     { x: 80.2877697841727, y: 2.94117647058824, size: 1 },
    //     { x: 122.374100719424, y: 2.86274509803922, size: 1 },
    //     { x: 123.021582733813, y: 2, size: 1 },
    //     { x: 139.208633093525, y: 4.23529411764706, size: 1 },
    //     { x: 144.388489208633, y: 2.74509803921569, size: 1 },
    //     { x: 145.035971223022, y: 2.7843137254902, size: 1 },
    //     { x: 165.755395683453, y: 2.74509803921569, size: 1 },
    //     { x: 166.402877697842, y: 2.70588235294118, size: 1 },
    //     { x: 187.769784172662, y: 2.62745098039216, size: 1 },
    //     { x: 209.136690647482, y: 2.07843137254902, size: 1 },
    //     { x: 209.784172661871, y: 2.31372549019608, size: 1 },
    //     { x: 213.021582733813, y: 4, size: 1 },
    //     { x: 216.906474820144, y: 4, size: 1 },
    //     { x: 252.517985611511, y: 2.23529411764706, size: 1 },
    //     { x: 317.26618705036, y: 2.50980392156863, size: 1 },
    //     { x: 338.63309352518, y: 2.62745098039216, size: 1 },
    //     { x: 0, y: 2.62745098039216, size: 1 },
    //     { x: 20.7194244604317, y: 2.94117647058824, size: 1 },
    //     { x: 22.0143884892086, y: 2.23529411764706, size: 1 },
    //     { x: 134.676258992806, y: 4.03921568627451, size: 1 },
    //     { x: 208.489208633094, y: 4.03921568627451, size: 1 },
    //     { x: 242.158273381295, y: 3.96078431372549, size: 1 },
    //     { x: 258.992805755396, y: 2.98039215686275, size: 1 },
    //     { x: 260.287769784173, y: 2.86274509803922, size: 1 },
    //     { x: 314.028776978417, y: 4.11764705882353, size: 1 },
    //     { x: 318.561151079137, y: 4, size: 1 },
    //     { x: 325.68345323741, y: 2.90196078431373, size: 1 },
    //     { x: 341.223021582734, y: 4, size: 1 },
    //     { x: 345.755395683453, y: 2.98039215686275, size: 1 },
    //     { x: 14.9189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 28.5405405405405, y: 3.01960784313725, size: 1 },
    //     { x: 93.4054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 94.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 108.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 117.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 119.351351351351, y: 4.03921568627451, size: 1 },
    //     { x: 121.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 127.135135135135, y: 4.23529411764706, size: 1 },
    //     { x: 129.72972972973, y: 3.80392156862745, size: 1 },
    //     { x: 132.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 139.459459459459, y: 3.84313725490196, size: 1 },
    //     { x: 140.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 143.351351351351, y: 4.03921568627451, size: 1 },
    //     { x: 144, y: 4.03921568627451, size: 1 },
    //     { x: 151.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 151.783783783784, y: 4.15686274509804, size: 1 },
    //     { x: 153.72972972973, y: 4, size: 1 },
    //     { x: 163.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 171.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 186.162162162162, y: 4.19607843137255, size: 1 },
    //     { x: 187.459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 190.054054054054, y: 4.11764705882353, size: 1 },
    //     { x: 192, y: 3.96078431372549, size: 1 },
    //     { x: 195.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 197.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 201.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 202.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 223.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 239.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 240.648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 267.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 271.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 289.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 290.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 291.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 291.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 294.486486486487, y: 4.07843137254902, size: 1 },
    //     { x: 296.432432432432, y: 4, size: 1 },
    //     { x: 297.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 298.378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 301.621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 302.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 310.054054054054, y: 2.66666666666667, size: 1 },
    //     { x: 310.702702702703, y: 2.82352941176471, size: 1 },
    //     { x: 311.351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 312, y: 2.70588235294118, size: 1 },
    //     { x: 331.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 332.108108108108, y: 2.82352941176471, size: 1 },
    //     { x: 332.756756756757, y: 2.70588235294118, size: 1 },
    //     { x: 333.405405405405, y: 2.94117647058824, size: 1 },
    //     { x: 352.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 353.513513513513, y: 3.09803921568627, size: 1 },
    //     { x: 0.647482014388489, y: 4.07843137254902, size: 1 },
    //     { x: 6.47482014388489, y: 4, size: 1 },
    //     { x: 11.6546762589928, y: 3.88235294117647, size: 1 },
    //     { x: 36.2589928057554, y: 2.7843137254902, size: 1 },
    //     { x: 36.9064748201439, y: 2.70588235294118, size: 1 },
    //     { x: 44.0287769784173, y: 4.15686274509804, size: 1 },
    //     { x: 75.1079136690647, y: 4, size: 1 },
    //     { x: 106.834532374101, y: 4.03921568627451, size: 1 },
    //     { x: 122.374100719424, y: 2.98039215686275, size: 1 },
    //     { x: 123.021582733813, y: 2.82352941176471, size: 1 },
    //     { x: 143.741007194245, y: 3.17647058823529, size: 1 },
    //     { x: 165.107913669065, y: 3.33333333333333, size: 1 },
    //     { x: 165.755395683453, y: 2.62745098039216, size: 1 },
    //     { x: 166.402877697842, y: 2.47058823529412, size: 1 },
    //     { x: 183.884892086331, y: 3.96078431372549, size: 1 },
    //     { x: 199.424460431655, y: 3.29411764705882, size: 1 },
    //     { x: 213.021582733813, y: 4.15686274509804, size: 1 },
    //     { x: 227.26618705036, y: 4.19607843137255, size: 1 },
    //     { x: 230.503597122302, y: 3.25490196078431, size: 1 },
    //     { x: 252.517985611511, y: 2.7843137254902, size: 1 },
    //     { x: 295.251798561151, y: 2.23529411764706, size: 1 },
    //     { x: 295.89928057554, y: 2.43137254901961, size: 1 },
    //     { x: 338.63309352518, y: 3.09803921568627, size: 1 },
    //     { x: 352.877697841727, y: 4.03921568627451, size: 1 },
    //     { x: 354.820143884892, y: 4.23529411764706, size: 1 },
    //     { x: 356.115107913669, y: 4.11764705882353, size: 1 },
    //     { x: 21.3669064748201, y: 3.25490196078431, size: 1 },
    //     { x: 22.0143884892086, y: 2.66666666666667, size: 1 },
    //     { x: 43.3812949640288, y: 3.01960784313725, size: 1 },
    //     { x: 64.7482014388489, y: 2.70588235294118, size: 1 },
    //     { x: 96.4748201438849, y: 3.92156862745098, size: 1 },
    //     { x: 106.834532374101, y: 3.17647058823529, size: 1 },
    //     { x: 108.129496402878, y: 2.74509803921569, size: 1 },
    //     { x: 120.431654676259, y: 4, size: 1 },
    //     { x: 130.143884892086, y: 3.13725490196078, size: 1 },
    //     { x: 165.755395683453, y: 3.96078431372549, size: 1 },
    //     { x: 236.330935251799, y: 3.2156862745098, size: 1 },
    //     { x: 237.625899280576, y: 3.05882352941176, size: 1 },
    //     { x: 238.273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 284.244604316547, y: 4.15686274509804, size: 1 },
    //     { x: 290.719424460432, y: 4.11764705882353, size: 1 },
    //     { x: 292.014388489209, y: 4.15686274509804, size: 1 },
    //     { x: 293.309352517986, y: 3.96078431372549, size: 1 },
    //     { x: 299.784172661871, y: 4.03921568627451, size: 1 },
    //     { x: 324.388489208633, y: 3.13725490196078, size: 1 },
    //     { x: 0.647482014388489, y: 4.19607843137255, size: 1 },
    //     { x: 7.12230215827338, y: 2.70588235294118, size: 1 },
    //     { x: 20.7194244604317, y: 4.07843137254902, size: 1 },
    //     { x: 49.8561151079137, y: 2.15686274509804, size: 1 },
    //     { x: 50.5035971223022, y: 1.41176470588235, size: 1 },
    //     { x: 51.1510791366906, y: 1.41176470588235, size: 1 },
    //     { x: 51.7985611510791, y: 0.784313725490196, size: 1 },
    //     { x: 59.568345323741, y: 2.98039215686275, size: 1 },
    //     { x: 114.604316546763, y: 2.86274509803922, size: 1 },
    //     { x: 115.251798561151, y: 3.17647058823529, size: 1 },
    //     { x: 135.971223021583, y: 3.17647058823529, size: 1 },
    //     { x: 136.618705035971, y: 2.23529411764706, size: 1 },
    //     { x: 157.985611510791, y: 2.74509803921569, size: 1 },
    //     { x: 158.63309352518, y: 2.66666666666667, size: 1 },
    //     { x: 189.064748201439, y: 4, size: 1 },
    //     { x: 207.841726618705, y: 3.2156862745098, size: 1 },
    //     { x: 222.73381294964, y: 3.01960784313725, size: 1 },
    //     { x: 223.381294964029, y: 2.70588235294118, size: 1 },
    //     { x: 250.575539568345, y: 4.15686274509804, size: 1 },
    //     { x: 266.115107913669, y: 2.82352941176471, size: 1 },
    //     { x: 288.129496402878, y: 2.82352941176471, size: 1 },
    //     { x: 309.496402877698, y: 2.23529411764706, size: 1 },
    //     { x: 330.863309352518, y: 2.23529411764706, size: 1 },
    //     { x: 28.5405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 35.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 35.6756756756757, y: 2.7843137254902, size: 1 },
    //     { x: 36.3243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 42.8108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 75.8918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 79.1351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 79.7837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 80.4324324324324, y: 2.66666666666667, size: 1 },
    //     { x: 98.5945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 100.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 108.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 114.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 121.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 122.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 147.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 153.081081081081, y: 4.03921568627451, size: 1 },
    //     { x: 186.810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 187.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 188.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 191.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 208.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 208.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 209.513513513514, y: 2.74509803921569, size: 1 },
    //     { x: 210.162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 248.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 274.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 275.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 288, y: 3.96078431372549, size: 1 },
    //     { x: 295.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 295.783783783784, y: 2.74509803921569, size: 1 },
    //     { x: 296.432432432432, y: 2.66666666666667, size: 1 },
    //     { x: 297.081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 308.108108108108, y: 3.84313725490196, size: 1 },
    //     { x: 347.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 357.405405405405, y: 4.15686274509804, size: 1 },
    //     { x: 10.3597122302158, y: 3.96078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 3.09803921568627, size: 1 },
    //     { x: 108.776978417266, y: 3.17647058823529, size: 1 },
    //     { x: 131.438848920863, y: 2.66666666666667, size: 1 },
    //     { x: 296.546762589928, y: 4.15686274509804, size: 1 },
    //     { x: 302.374100719424, y: 2.90196078431373, size: 1 },
    //     { x: 323.741007194245, y: 2.94117647058824, size: 1 },
    //     { x: 45.3237410071942, y: 3.92156862745098, size: 1 },
    //     { x: 58.9208633093525, y: 3.92156862745098, size: 1 },
    //     { x: 84.1726618705036, y: 4.11764705882353, size: 1 },
    //     { x: 88.0575539568345, y: 4.11764705882353, size: 1 },
    //     { x: 102.94964028777, y: 4.03921568627451, size: 1 },
    //     { x: 104.244604316547, y: 4.27450980392157, size: 1 },
    //     { x: 111.36690647482, y: 4.07843137254902, size: 1 },
    //     { x: 113.309352517986, y: 4.03921568627451, size: 1 },
    //     { x: 115.89928057554, y: 4.07843137254902, size: 1 },
    //     { x: 124.31654676259, y: 3.84313725490196, size: 1 },
    //     { x: 128.201438848921, y: 4, size: 1 },
    //     { x: 131.438848920863, y: 4.03921568627451, size: 1 },
    //     { x: 135.971223021583, y: 2.31372549019608, size: 1 },
    //     { x: 136.618705035971, y: 2.50980392156863, size: 1 },
    //     { x: 137.26618705036, y: 2.50980392156863, size: 1 },
    //     { x: 137.913669064748, y: 2.70588235294118, size: 1 },
    //     { x: 157.985611510791, y: 3.01960784313725, size: 1 },
    //     { x: 158.63309352518, y: 3.13725490196078, size: 1 },
    //     { x: 185.179856115108, y: 4.03921568627451, size: 1 },
    //     { x: 219.496402877698, y: 3.96078431372549, size: 1 },
    //     { x: 221.438848920863, y: 3.25490196078431, size: 1 },
    //     { x: 226.618705035971, y: 4.19607843137255, size: 1 },
    //     { x: 230.503597122302, y: 4, size: 1 },
    //     { x: 232.446043165468, y: 4.07843137254902, size: 1 },
    //     { x: 281.654676258993, y: 4.11764705882353, size: 1 },
    //     { x: 20.7567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 35.6756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 57.0810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 59.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 80.4324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 86.2702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 87.5675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 90.8108108108108, y: 4, size: 1 },
    //     { x: 91.4594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 93.4054054054054, y: 4.15686274509804, size: 1 },
    //     { x: 96.6486486486486, y: 3.92156862745098, size: 1 },
    //     { x: 97.2972972972973, y: 4.15686274509804, size: 1 },
    //     { x: 99.8918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 109.621621621622, y: 4, size: 1 },
    //     { x: 114.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 118.702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 121.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 121.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 125.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 125.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 133.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 140.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 144.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 145.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 183.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 192, y: 3.92156862745098, size: 1 },
    //     { x: 197.837837837838, y: 3.45098039215686, size: 1 },
    //     { x: 200.432432432432, y: 3.88235294117647, size: 1 },
    //     { x: 207.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 209.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 210.810810810811, y: 4, size: 1 },
    //     { x: 219.891891891892, y: 4.07843137254902, size: 1 },
    //     { x: 221.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 221.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 230.918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 232.216216216216, y: 3.80392156862745, size: 1 },
    //     { x: 232.864864864865, y: 4, size: 1 },
    //     { x: 236.756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 238.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 240, y: 4.03921568627451, size: 1 },
    //     { x: 241.945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 242.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 246.486486486486, y: 4.11764705882353, size: 1 },
    //     { x: 273.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 275.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 280.216216216216, y: 4.19607843137255, size: 1 },
    //     { x: 285.405405405405, y: 4, size: 1 },
    //     { x: 288.648648648649, y: 4.15686274509804, size: 1 },
    //     { x: 295.135135135135, y: 2.70588235294118, size: 1 },
    //     { x: 295.783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 296.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 297.72972972973, y: 4.11764705882353, size: 1 },
    //     { x: 302.27027027027, y: 4.03921568627451, size: 1 },
    //     { x: 304.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 308.108108108108, y: 4.11764705882353, size: 1 },
    //     { x: 309.405405405405, y: 4.07843137254902, size: 1 },
    //     { x: 315.891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 317.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 337.945945945946, y: 2.74509803921569, size: 1 },
    //     { x: 338.594594594595, y: 2.47058823529412, size: 1 },
    //     { x: 342.486486486487, y: 3.88235294117647, size: 1 },
    //     { x: 358.054054054054, y: 3.37254901960784, size: 1 },
    //     { x: 359.351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 43.3812949640288, y: 2.90196078431373, size: 1 },
    //     { x: 64.1007194244604, y: 3.05882352941176, size: 1 },
    //     { x: 81.5827338129496, y: 3.96078431372549, size: 1 },
    //     { x: 83.5251798561151, y: 4, size: 1 },
    //     { x: 110.719424460432, y: 4.07843137254902, size: 1 },
    //     { x: 114.604316546763, y: 4, size: 1 },
    //     { x: 115.251798561151, y: 4.03921568627451, size: 1 },
    //     { x: 125.611510791367, y: 4.15686274509804, size: 1 },
    //     { x: 126.258992805755, y: 4.03921568627451, size: 1 },
    //     { x: 129.496402877698, y: 2, size: 1 },
    //     { x: 135.971223021583, y: 4.07843137254902, size: 1 },
    //     { x: 136.618705035971, y: 4.07843137254902, size: 1 },
    //     { x: 139.856115107914, y: 4, size: 1 },
    //     { x: 141.151079136691, y: 4.11764705882353, size: 1 },
    //     { x: 145.035971223022, y: 4.07843137254902, size: 1 },
    //     { x: 146.330935251799, y: 4.15686274509804, size: 1 },
    //     { x: 150.863309352518, y: 3.13725490196078, size: 1 },
    //     { x: 157.338129496403, y: 3.92156862745098, size: 1 },
    //     { x: 169.640287769784, y: 4.07843137254902, size: 1 },
    //     { x: 172.230215827338, y: 2.15686274509804, size: 1 },
    //     { x: 172.877697841727, y: 2.23529411764706, size: 1 },
    //     { x: 180, y: 3.92156862745098, size: 1 },
    //     { x: 189.712230215827, y: 3.96078431372549, size: 1 },
    //     { x: 193.597122302158, y: 2.94117647058824, size: 1 },
    //     { x: 236.978417266187, y: 2.86274509803922, size: 1 },
    //     { x: 237.625899280576, y: 2.66666666666667, size: 1 },
    //     { x: 239.568345323741, y: 3.96078431372549, size: 1 },
    //     { x: 245.395683453237, y: 4, size: 1 },
    //     { x: 247.985611510791, y: 4.15686274509804, size: 1 },
    //     { x: 257.05035971223, y: 3.2156862745098, size: 1 },
    //     { x: 258.345323741007, y: 2.86274509803922, size: 1 },
    //     { x: 258.992805755396, y: 2.35294117647059, size: 1 },
    //     { x: 270.647482014389, y: 3.96078431372549, size: 1 },
    //     { x: 271.942446043165, y: 4.07843137254902, size: 1 },
    //     { x: 347.05035971223, y: 4.03921568627451, size: 1 },
    //     { x: 348.345323741007, y: 4.11764705882353, size: 1 },
    //     { x: 349.640287769784, y: 4.03921568627451, size: 1 },
    //     { x: 351.58273381295, y: 4.23529411764706, size: 1 },
    //     { x: 355.467625899281, y: 4.03921568627451, size: 1 },
    //     { x: 356.762589928058, y: 4.11764705882353, size: 1 },
    //     { x: 2.58992805755396, y: 4.19607843137255, size: 1 },
    //     { x: 4.53237410071942, y: 4.03921568627451, size: 1 },
    //     { x: 10.3597122302158, y: 4.15686274509804, size: 1 },
    //     { x: 20.7194244604317, y: 3.88235294117647, size: 1 },
    //     { x: 23.9568345323741, y: 4.03921568627451, size: 1 },
    //     { x: 28.4892086330935, y: 2.7843137254902, size: 1 },
    //     { x: 129.496402877698, y: 4.19607843137255, size: 1 },
    //     { x: 135.971223021583, y: 2.70588235294118, size: 1 },
    //     { x: 136.618705035971, y: 2.70588235294118, size: 1 },
    //     { x: 137.26618705036, y: 2.54901960784314, size: 1 },
    //     { x: 137.913669064748, y: 2.86274509803922, size: 1 },
    //     { x: 153.453237410072, y: 4.07843137254902, size: 1 },
    //     { x: 159.928057553957, y: 4.11764705882353, size: 1 },
    //     { x: 193.597122302158, y: 4.03921568627451, size: 1 },
    //     { x: 222.73381294964, y: 3.17647058823529, size: 1 },
    //     { x: 243.453237410072, y: 3.25490196078431, size: 1 },
    //     { x: 245.395683453237, y: 3.05882352941176, size: 1 },
    //     { x: 265.467625899281, y: 3.09803921568627, size: 1 },
    //     { x: 269.352517985611, y: 4.15686274509804, size: 1 },
    //     { x: 288.129496402878, y: 3.01960784313725, size: 1 },
    //     { x: 288.776978417266, y: 2.90196078431373, size: 1 },
    //     { x: 293.956834532374, y: 3.96078431372549, size: 1 },
    //     { x: 294.604316546763, y: 4.11764705882353, size: 1 },
    //     { x: 333.453237410072, y: 4.03921568627451, size: 1 },
    //     { x: 348.992805755396, y: 4.07843137254902, size: 1 },
    //     { x: 7.12230215827338, y: 3.96078431372549, size: 1 },
    //     { x: 23.3093525179856, y: 4, size: 1 },
    //     { x: 36.2589928057554, y: 2.70588235294118, size: 1 },
    //     { x: 56.9784172661871, y: 2.7843137254902, size: 1 },
    //     { x: 77.0503597122302, y: 3.17647058823529, size: 1 },
    //     { x: 78.3453237410072, y: 2.94117647058824, size: 1 },
    //     { x: 79.6402877697842, y: 3.17647058823529, size: 1 },
    //     { x: 93.8848920863309, y: 4.23529411764706, size: 1 },
    //     { x: 124.964028776978, y: 4, size: 1 },
    //     { x: 135.323741007194, y: 4.03921568627451, size: 1 },
    //     { x: 178.057553956835, y: 4.03921568627451, size: 1 },
    //     { x: 185.827338129496, y: 3.01960784313725, size: 1 },
    //     { x: 186.474820143885, y: 2.94117647058824, size: 1 },
    //     { x: 217.553956834532, y: 4, size: 1 },
    //     { x: 232.446043165468, y: 4.03921568627451, size: 1 },
    //     { x: 260.287769784173, y: 4.15686274509804, size: 1 },
    //     { x: 297.194244604317, y: 4.03921568627451, size: 1 },
    //     { x: 299.136690647482, y: 4.3921568627451, size: 1 },
    //     { x: 308.848920863309, y: 4.03921568627451, size: 1 },
    //     { x: 321.798561151079, y: 4.27450980392157, size: 1 },
    //     { x: 322.446043165468, y: 4, size: 1 },
    //     { x: 336.043165467626, y: 3.09803921568627, size: 1 },
    //     { x: 337.338129496403, y: 1.96078431372549, size: 1 },
    //     { x: 337.985611510791, y: 1.96078431372549, size: 1 },
    //     { x: 338.63309352518, y: 1.92156862745098, size: 1 },
    //     { x: 339.280575539568, y: 1.84313725490196, size: 1 },
    //     { x: 13.6216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 16.8648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 27.2432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 51.8918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 55.7837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 59.6756756756757, y: 4, size: 1 },
    //     { x: 62.9189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 63.5675675675676, y: 2.66666666666667, size: 1 },
    //     { x: 64.2162162162162, y: 2.66666666666667, size: 1 },
    //     { x: 64.8648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 78.4864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 81.7297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 85.6216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 86.2702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 86.9189189189189, y: 2.94117647058824, size: 1 },
    //     { x: 107.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 128.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 129.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 134.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 138.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 142.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 145.945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 146.594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 149.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 149.837837837838, y: 2.54901960784314, size: 1 },
    //     { x: 150.486486486486, y: 2.27450980392157, size: 1 },
    //     { x: 151.135135135135, y: 2.58823529411765, size: 1 },
    //     { x: 151.783783783784, y: 2.35294117647059, size: 1 },
    //     { x: 153.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 155.027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 157.621621621622, y: 4, size: 1 },
    //     { x: 159.567567567568, y: 4, size: 1 },
    //     { x: 160.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 161.513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 162.810810810811, y: 4.07843137254902, size: 1 },
    //     { x: 168, y: 3.88235294117647, size: 1 },
    //     { x: 168.648648648649, y: 4.11764705882353, size: 1 },
    //     { x: 219.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 228.324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 232.864864864865, y: 3.84313725490196, size: 1 },
    //     { x: 236.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 237.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 262.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 265.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 270.486486486487, y: 4.11764705882353, size: 1 },
    //     { x: 271.783783783784, y: 4, size: 1 },
    //     { x: 275.675675675676, y: 4, size: 1 },
    //     { x: 276.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 303.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 308.108108108108, y: 3.80392156862745, size: 1 },
    //     { x: 313.945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 317.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 323.027027027027, y: 2.62745098039216, size: 1 },
    //     { x: 323.675675675676, y: 2.50980392156863, size: 1 },
    //     { x: 324.324324324324, y: 2.70588235294118, size: 1 },
    //     { x: 324.972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 343.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 344.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 346.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 27.841726618705, y: 3.17647058823529, size: 1 },
    //     { x: 28.4892086330935, y: 3.09803921568627, size: 1 },
    //     { x: 93.2374100719424, y: 3.09803921568627, size: 1 },
    //     { x: 101.654676258993, y: 3.96078431372549, size: 1 },
    //     { x: 119.136690647482, y: 3.96078431372549, size: 1 },
    //     { x: 139.208633093525, y: 4.07843137254902, size: 1 },
    //     { x: 149.568345323741, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 3.09803921568627, size: 1 },
    //     { x: 222.73381294964, y: 3.09803921568627, size: 1 },
    //     { x: 266.115107913669, y: 2.3921568627451, size: 1 },
    //     { x: 266.762589928058, y: 2.58823529411765, size: 1 },
    //     { x: 267.410071942446, y: 2.7843137254902, size: 1 },
    //     { x: 270, y: 2.86274509803922, size: 1 },
    //     { x: 270.647482014389, y: 3.17647058823529, size: 1 },
    //     { x: 286.834532374101, y: 2.94117647058824, size: 1 },
    //     { x: 287.482014388489, y: 2.98039215686275, size: 1 },
    //     { x: 308.848920863309, y: 3.01960784313725, size: 1 },
    //     { x: 330.215827338129, y: 2.19607843137255, size: 1 },
    //     { x: 351.58273381295, y: 2.98039215686275, size: 1 },
    //     { x: 12.9496402877698, y: 2.94117647058824, size: 1 },
    //     { x: 13.5971223021583, y: 2.47058823529412, size: 1 },
    //     { x: 24.6043165467626, y: 4.31372549019608, size: 1 },
    //     { x: 30.431654676259, y: 4.03921568627451, size: 1 },
    //     { x: 31.726618705036, y: 4.07843137254902, size: 1 },
    //     { x: 33.6690647482014, y: 3.05882352941176, size: 1 },
    //     { x: 35.6115107913669, y: 3.05882352941176, size: 1 },
    //     { x: 55.6834532374101, y: 2.90196078431373, size: 1 },
    //     { x: 56.3309352517986, y: 2.43137254901961, size: 1 },
    //     { x: 56.9784172661871, y: 2.35294117647059, size: 1 },
    //     { x: 66.6906474820144, y: 4.07843137254902, size: 1 },
    //     { x: 67.9856115107914, y: 4.03921568627451, size: 1 },
    //     { x: 77.6978417266187, y: 2.07843137254902, size: 1 },
    //     { x: 78.3453237410072, y: 2.11764705882353, size: 1 },
    //     { x: 99.7122302158273, y: 2.74509803921569, size: 1 },
    //     { x: 120.431654676259, y: 3.01960784313725, size: 1 },
    //     { x: 121.079136690647, y: 1.76470588235294, size: 1 },
    //     { x: 121.726618705036, y: 1.96078431372549, size: 1 },
    //     { x: 142.446043165468, y: 3.01960784313725, size: 1 },
    //     { x: 143.093525179856, y: 2.7843137254902, size: 1 },
    //     { x: 272.589928057554, y: 3.05882352941176, size: 1 },
    //     { x: 304.964028776978, y: 3.96078431372549, size: 1 },
    //     { x: 318.561151079137, y: 4.03921568627451, size: 1 },
    //     { x: 41.4388489208633, y: 2.98039215686275, size: 1 },
    //     { x: 42.0863309352518, y: 2.74509803921569, size: 1 },
    //     { x: 42.7338129496403, y: 2.70588235294118, size: 1 },
    //     { x: 43.3812949640288, y: 3.17647058823529, size: 1 },
    //     { x: 108.129496402878, y: 3.2156862745098, size: 1 },
    //     { x: 112.014388489209, y: 3.96078431372549, size: 1 },
    //     { x: 122.374100719424, y: 4.23529411764706, size: 1 },
    //     { x: 150.215827338129, y: 2.74509803921569, size: 1 },
    //     { x: 150.863309352518, y: 2.70588235294118, size: 1 },
    //     { x: 195.539568345324, y: 4, size: 1 },
    //     { x: 235.68345323741, y: 2.98039215686275, size: 1 },
    //     { x: 237.625899280576, y: 2.94117647058824, size: 1 },
    //     { x: 358.705035971223, y: 3.92156862745098, size: 1 },
    //     { x: 0.648648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 2.59459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 3.24324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 18.8108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 25.9459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 27.2432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 27.8918918918919, y: 2.7843137254902, size: 1 },
    //     { x: 28.5405405405405, y: 2.86274509803922, size: 1 },
    //     { x: 29.1891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 42.1621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 48.6486486486486, y: 2.50980392156863, size: 1 },
    //     { x: 49.2972972972973, y: 2.43137254901961, size: 1 },
    //     { x: 49.9459459459459, y: 2.70588235294118, size: 1 },
    //     { x: 50.5945945945946, y: 2.90196078431373, size: 1 },
    //     { x: 72, y: 3.29411764705882, size: 1 },
    //     { x: 75.2432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 78.4864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 86.9189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 92.1081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 114.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 123.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 131.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 134.918918918919, y: 2.58823529411765, size: 1 },
    //     { x: 135.567567567568, y: 2.43137254901961, size: 1 },
    //     { x: 136.216216216216, y: 2.43137254901961, size: 1 },
    //     { x: 137.513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 147.891891891892, y: 3.80392156862745, size: 1 },
    //     { x: 156.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 157.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 158.27027027027, y: 2.86274509803922, size: 1 },
    //     { x: 166.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 178.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 180.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 190.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 199.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 200.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 205.621621621622, y: 3.80392156862745, size: 1 },
    //     { x: 212.756756756757, y: 4, size: 1 },
    //     { x: 215.351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 223.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 224.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 225.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 228.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 229.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 230.27027027027, y: 3.41176470588235, size: 1 },
    //     { x: 230.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 234.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 240, y: 3.2156862745098, size: 1 },
    //     { x: 264.648648648649, y: 2.94117647058824, size: 1 },
    //     { x: 265.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 265.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 266.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 271.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 276.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 281.513513513513, y: 3.25490196078431, size: 1 },
    //     { x: 282.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 286.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 287.351351351351, y: 3.09803921568627, size: 1 },
    //     { x: 339.243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 350.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 351.567567567568, y: 2.50980392156863, size: 1 },
    //     { x: 352.216216216216, y: 2.47058823529412, size: 1 },
    //     { x: 352.864864864865, y: 2.62745098039216, size: 1 },
    //     { x: 353.513513513513, y: 2.90196078431373, size: 1 },
    //     { x: 62.8057553956835, y: 4.07843137254902, size: 1 },
    //     { x: 66.6906474820144, y: 4.15686274509804, size: 1 },
    //     { x: 69.2805755395683, y: 4.15686274509804, size: 1 },
    //     { x: 74.4604316546763, y: 4.07843137254902, size: 1 },
    //     { x: 78.3453237410072, y: 2.90196078431373, size: 1 },
    //     { x: 78.9928057553957, y: 3.05882352941176, size: 1 },
    //     { x: 79.6402877697842, y: 2.82352941176471, size: 1 },
    //     { x: 130.791366906475, y: 4.11764705882353, size: 1 },
    //     { x: 206.546762589928, y: 3.09803921568627, size: 1 },
    //     { x: 207.194244604317, y: 2.47058823529412, size: 1 },
    //     { x: 207.841726618705, y: 2.15686274509804, size: 1 },
    //     { x: 208.489208633094, y: 2.58823529411765, size: 1 },
    //     { x: 209.136690647482, y: 2.50980392156863, size: 1 },
    //     { x: 244.748201438849, y: 3.96078431372549, size: 1 },
    //     { x: 281.654676258993, y: 4.15686274509804, size: 1 },
    //     { x: 293.309352517986, y: 2.47058823529412, size: 1 },
    //     { x: 293.956834532374, y: 2.43137254901961, size: 1 },
    //     { x: 314.676258992806, y: 3.25490196078431, size: 1 },
    //     { x: 315.971223021583, y: 3.09803921568627, size: 1 },
    //     { x: 336.690647482014, y: 2.70588235294118, size: 1 },
    //     { x: 337.338129496403, y: 2.7843137254902, size: 1 },
    //     { x: 42.0863309352518, y: 3.29411764705882, size: 1 },
    //     { x: 43.3812949640288, y: 2.94117647058824, size: 1 },
    //     { x: 44.0287769784173, y: 3.01960784313725, size: 1 },
    //     { x: 51.1510791366906, y: 3.2156862745098, size: 1 },
    //     { x: 55.0359712230216, y: 3.01960784313725, size: 1 },
    //     { x: 60.863309352518, y: 3.29411764705882, size: 1 },
    //     { x: 107.482014388489, y: 2.70588235294118, size: 1 },
    //     { x: 135.323741007194, y: 3.09803921568627, size: 1 },
    //     { x: 135.971223021583, y: 3.05882352941176, size: 1 },
    //     { x: 138.561151079137, y: 3.01960784313725, size: 1 },
    //     { x: 146.330935251799, y: 3.05882352941176, size: 1 },
    //     { x: 146.978417266187, y: 3.13725490196078, size: 1 },
    //     { x: 150.863309352518, y: 2.90196078431373, size: 1 },
    //     { x: 151.510791366906, y: 2.82352941176471, size: 1 },
    //     { x: 170.935251798561, y: 2.90196078431373, size: 1 },
    //     { x: 171.58273381295, y: 2.98039215686275, size: 1 },
    //     { x: 172.230215827338, y: 3.05882352941176, size: 1 },
    //     { x: 172.877697841727, y: 2.86274509803922, size: 1 },
    //     { x: 192.302158273381, y: 3.13725490196078, size: 1 },
    //     { x: 193.597122302158, y: 2.7843137254902, size: 1 },
    //     { x: 194.244604316547, y: 2.58823529411765, size: 1 },
    //     { x: 200.071942446043, y: 4.07843137254902, size: 1 },
    //     { x: 201.36690647482, y: 4.03921568627451, size: 1 },
    //     { x: 203.309352517986, y: 4.15686274509804, size: 1 },
    //     { x: 257.05035971223, y: 3.05882352941176, size: 1 },
    //     { x: 257.697841726619, y: 3.09803921568627, size: 1 },
    //     { x: 306.906474820144, y: 3.01960784313725, size: 1 },
    //     { x: 317.913669064748, y: 3.09803921568627, size: 1 },
    //     { x: 322.446043165468, y: 2.94117647058824, size: 1 },
    //     { x: 343.812949640288, y: 2.90196078431373, size: 1 },
    //     { x: 4.53237410071942, y: 2.90196078431373, size: 1 },
    //     { x: 5.17985611510791, y: 2.58823529411765, size: 1 },
    //     { x: 5.8273381294964, y: 2.98039215686275, size: 1 },
    //     { x: 26.5467625899281, y: 2.94117647058824, size: 1 },
    //     { x: 40.1438848920863, y: 4.11764705882353, size: 1 },
    //     { x: 65.3956834532374, y: 3.96078431372549, size: 1 },
    //     { x: 91.9424460431655, y: 2.82352941176471, size: 1 },
    //     { x: 110.719424460432, y: 4.03921568627451, size: 1 },
    //     { x: 172.230215827338, y: 4, size: 1 },
    //     { x: 187.769784172662, y: 4.19607843137255, size: 1 },
    //     { x: 192.94964028777, y: 4.07843137254902, size: 1 },
    //     { x: 220.791366906475, y: 2.66666666666667, size: 1 },
    //     { x: 221.438848920863, y: 2.7843137254902, size: 1 },
    //     { x: 307.553956834532, y: 2.86274509803922, size: 1 },
    //     { x: 309.496402877698, y: 2.70588235294118, size: 1 },
    //     { x: 328.920863309353, y: 2.50980392156863, size: 1 },
    //     { x: 330.215827338129, y: 2.50980392156863, size: 1 },
    //     { x: 330.863309352518, y: 2.3921568627451, size: 1 },
    //     { x: 334.10071942446, y: 4.03921568627451, size: 1 },
    //     { x: 344.460431654676, y: 4.11764705882353, size: 1 },
    //     { x: 9.72972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 16.2162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 23.3513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 24, y: 3.45098039215686, size: 1 },
    //     { x: 53.8378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 56.4324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 57.7297297297297, y: 4.11764705882353, size: 1 },
    //     { x: 59.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 61.6216216216216, y: 4, size: 1 },
    //     { x: 64.2162162162162, y: 4.19607843137255, size: 1 },
    //     { x: 65.5135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 66.1621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 66.8108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 68.1081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 72, y: 3.92156862745098, size: 1 },
    //     { x: 73.2972972972973, y: 4, size: 1 },
    //     { x: 73.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 76.5405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 77.1891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 107.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 108.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 113.513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 120, y: 2.82352941176471, size: 1 },
    //     { x: 120.648648648649, y: 2.66666666666667, size: 1 },
    //     { x: 125.189189189189, y: 4, size: 1 },
    //     { x: 129.081081081081, y: 4, size: 1 },
    //     { x: 140.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 142.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 143.351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 162.162162162162, y: 4.11764705882353, size: 1 },
    //     { x: 174.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 200.432432432432, y: 4, size: 1 },
    //     { x: 206.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 206.918918918919, y: 2.82352941176471, size: 1 },
    //     { x: 207.567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 208.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 210.162162162162, y: 3.80392156862745, size: 1 },
    //     { x: 228.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 230.27027027027, y: 2.58823529411765, size: 1 },
    //     { x: 273.72972972973, y: 4.07843137254902, size: 1 },
    //     { x: 275.027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 278.27027027027, y: 4.03921568627451, size: 1 },
    //     { x: 279.567567567568, y: 3.84313725490196, size: 1 },
    //     { x: 288, y: 3.92156862745098, size: 1 },
    //     { x: 289.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 293.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 294.486486486487, y: 3.13725490196078, size: 1 },
    //     { x: 295.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 315.243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 323.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 324.324324324324, y: 4.15686274509804, size: 1 },
    //     { x: 326.918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 327.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 328.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 331.459459459459, y: 4, size: 1 },
    //     { x: 332.756756756757, y: 4.11764705882353, size: 1 },
    //     { x: 333.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 345.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 348.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 348.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 350.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 20.0719424460432, y: 3.09803921568627, size: 1 },
    //     { x: 73.1654676258993, y: 4.03921568627451, size: 1 },
    //     { x: 129.496402877698, y: 4.11764705882353, size: 1 },
    //     { x: 159.928057553957, y: 3.41176470588235, size: 1 },
    //     { x: 192.94964028777, y: 3.09803921568627, size: 1 },
    //     { x: 198.129496402878, y: 4.03921568627451, size: 1 },
    //     { x: 203.956834532374, y: 4.03921568627451, size: 1 },
    //     { x: 204.604316546763, y: 4, size: 1 },
    //     { x: 279.064748201439, y: 2.98039215686275, size: 1 },
    //     { x: 290.071942446043, y: 4, size: 1 },
    //     { x: 304.964028776978, y: 4.03921568627451, size: 1 },
    //     { x: 28.4892086330935, y: 3.96078431372549, size: 1 },
    //     { x: 40.1438848920863, y: 4.07843137254902, size: 1 },
    //     { x: 264.172661870504, y: 2.7843137254902, size: 1 },
    //     { x: 264.820143884892, y: 2.70588235294118, size: 1 },
    //     { x: 265.467625899281, y: 2.74509803921569, size: 1 },
    //     { x: 285.539568345324, y: 2.94117647058824, size: 1 },
    //     { x: 341.870503597122, y: 4.19607843137255, size: 1 },
    //     { x: 345.755395683453, y: 4.07843137254902, size: 1 },
    //     { x: 350.287769784173, y: 2.70588235294118, size: 1 },
    //     { x: 350.935251798561, y: 2.58823529411765, size: 1 },
    //     { x: 11.6546762589928, y: 2.98039215686275, size: 1 },
    //     { x: 12.3021582733813, y: 2.90196078431373, size: 1 },
    //     { x: 12.9496402877698, y: 2.86274509803922, size: 1 },
    //     { x: 13.5971223021583, y: 3.05882352941176, size: 1 },
    //     { x: 119.784172661871, y: 1.6078431372549, size: 1 },
    //     { x: 120.431654676259, y: 1.80392156862745, size: 1 },
    //     { x: 121.079136690647, y: 1.80392156862745, size: 1 },
    //     { x: 121.726618705036, y: 1.76470588235294, size: 1 },
    //     { x: 129.496402877698, y: 2.94117647058824, size: 1 },
    //     { x: 135.971223021583, y: 2.98039215686275, size: 1 },
    //     { x: 148.273381294964, y: 4.07843137254902, size: 1 },
    //     { x: 163.165467625899, y: 3.09803921568627, size: 1 },
    //     { x: 184.532374100719, y: 2.94117647058824, size: 1 },
    //     { x: 185.179856115108, y: 2.86274509803922, size: 1 },
    //     { x: 206.546762589928, y: 2.31372549019608, size: 1 },
    //     { x: 249.280575539568, y: 2.50980392156863, size: 1 },
    //     { x: 249.928057553957, y: 2.74509803921569, size: 1 },
    //     { x: 271.294964028777, y: 2.94117647058824, size: 1 },
    //     { x: 286.834532374101, y: 4.3921568627451, size: 1 },
    //     { x: 291.36690647482, y: 3.17647058823529, size: 1 },
    //     { x: 292.661870503597, y: 2.86274509803922, size: 1 },
    //     { x: 293.309352517986, y: 2.98039215686275, size: 1 },
    //     { x: 299.136690647482, y: 3.05882352941176, size: 1 },
    //     { x: 314.676258992806, y: 2.90196078431373, size: 1 },
    //     { x: 335.395683453237, y: 2.7843137254902, size: 1 },
    //     { x: 336.043165467626, y: 2.86274509803922, size: 1 },
    //     { x: 356.762589928058, y: 2.94117647058824, size: 1 },
    //     { x: 357.410071942446, y: 2.50980392156863, size: 1 },
    //     { x: 19.4594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 20.7567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 26.5945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 27.2432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 28.5405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 42.8108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 52.5405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 54.4864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 96.6486486486486, y: 4, size: 1 },
    //     { x: 97.945945945946, y: 4, size: 1 },
    //     { x: 105.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 107.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 108.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 111.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 112.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 116.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 116.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 122.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 134.27027027027, y: 4.03921568627451, size: 1 },
    //     { x: 137.513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 148.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 149.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 151.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 152.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 155.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 156.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 158.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 160.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 162.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 162.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 163.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 164.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 164.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 166.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 167.351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 169.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 170.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 190.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 204.324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 219.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 221.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 224.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 225.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 225.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 226.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 227.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 227.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 230.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 232.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 235.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 239.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 240, y: 3.80392156862745, size: 1 },
    //     { x: 254.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 256.864864864865, y: 2.54901960784314, size: 1 },
    //     { x: 271.135135135135, y: 3.84313725490196, size: 1 },
    //     { x: 275.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 277.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 278.27027027027, y: 2.70588235294118, size: 1 },
    //     { x: 278.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 279.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 280.216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 280.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 284.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 284.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 286.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 291.891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 293.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 295.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 299.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 324.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 327.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 332.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 332.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 334.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 334.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 335.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 338.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 339.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 340.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 343.783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 62.158273381295, y: 4, size: 1 },
    //     { x: 101.654676258993, y: 3.13725490196078, size: 1 },
    //     { x: 157.338129496403, y: 2.7843137254902, size: 1 },
    //     { x: 164.460431654676, y: 3.2156862745098, size: 1 },
    //     { x: 198.776978417266, y: 2.86274509803922, size: 1 },
    //     { x: 220.791366906475, y: 2.98039215686275, size: 1 },
    //     { x: 249.928057553957, y: 4.03921568627451, size: 1 },
    //     { x: 288.129496402878, y: 3.13725490196078, size: 1 },
    //     { x: 293.309352517986, y: 3.13725490196078, size: 1 },
    //     { x: 297.841726618705, y: 3.17647058823529, size: 1 },
    //     { x: 328.273381294964, y: 2.86274509803922, size: 1 },
    //     { x: 72.5179856115108, y: 3.17647058823529, size: 1 },
    //     { x: 119.784172661871, y: 2.19607843137255, size: 1 },
    //     { x: 120.431654676259, y: 2.82352941176471, size: 1 },
    //     { x: 123.669064748201, y: 3.17647058823529, size: 1 },
    //     { x: 137.913669064748, y: 3.17647058823529, size: 1 },
    //     { x: 140.503597122302, y: 3.17647058823529, size: 1 },
    //     { x: 141.798561151079, y: 3.01960784313725, size: 1 },
    //     { x: 149.568345323741, y: 4.07843137254902, size: 1 },
    //     { x: 165.755395683453, y: 3.25490196078431, size: 1 },
    //     { x: 168.345323741007, y: 3.25490196078431, size: 1 },
    //     { x: 187.122302158273, y: 3.17647058823529, size: 1 },
    //     { x: 195.539568345324, y: 3.09803921568627, size: 1 },
    //     { x: 207.194244604317, y: 3.01960784313725, size: 1 },
    //     { x: 213.669064748201, y: 3.05882352941176, size: 1 },
    //     { x: 214.31654676259, y: 3.13725490196078, size: 1 },
    //     { x: 218.848920863309, y: 3.17647058823529, size: 1 },
    //     { x: 220.143884892086, y: 3.13725490196078, size: 1 },
    //     { x: 249.280575539568, y: 3.17647058823529, size: 1 },
    //     { x: 249.928057553957, y: 3.09803921568627, size: 1 },
    //     { x: 250.575539568345, y: 3.17647058823529, size: 1 },
    //     { x: 252.517985611511, y: 3.2156862745098, size: 1 },
    //     { x: 255.755395683453, y: 3.2156862745098, size: 1 },
    //     { x: 262.230215827338, y: 3.17647058823529, size: 1 },
    //     { x: 270.647482014389, y: 3.13725490196078, size: 1 },
    //     { x: 282.302158273381, y: 3.05882352941176, size: 1 },
    //     { x: 282.94964028777, y: 3.13725490196078, size: 1 },
    //     { x: 292.661870503597, y: 3.01960784313725, size: 1 },
    //     { x: 314.028776978417, y: 2.50980392156863, size: 1 },
    //     { x: 314.676258992806, y: 2.7843137254902, size: 1 },
    //     { x: 319.856115107914, y: 3.17647058823529, size: 1 },
    //     { x: 325.035971223022, y: 3.09803921568627, size: 1 },
    //     { x: 335.395683453237, y: 2.90196078431373, size: 1 },
    //     { x: 336.043165467626, y: 2.74509803921569, size: 1 },
    //     { x: 352.230215827338, y: 3.2156862745098, size: 1 },
    //     { x: 3.24324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 13.6216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 22.0540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 31.7837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 48, y: 3.33333333333333, size: 1 },
    //     { x: 62.2702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 64.8648648648649, y: 3.05882352941176, size: 1 },
    //     { x: 65.5135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 70.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 74.5945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 79.1351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 102.486486486486, y: 4.03921568627451, size: 1 },
    //     { x: 129.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 147.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 148.540540540541, y: 2.66666666666667, size: 1 },
    //     { x: 169.297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 170.594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 190.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 191.351351351351, y: 2.54901960784314, size: 1 },
    //     { x: 192, y: 2.43137254901961, size: 1 },
    //     { x: 228.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 238.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 239.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 252.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 256.216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 256.864864864865, y: 2.86274509803922, size: 1 },
    //     { x: 295.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 298.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 299.675675675676, y: 2.90196078431373, size: 1 },
    //     { x: 308.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 321.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 332.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 344.432432432432, y: 4.07843137254902, size: 1 },
    //     { x: 346.378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 348.972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 351.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 352.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 355.459459459459, y: 4.19607843137255, size: 1 },
    //     { x: 357.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 5.8273381294964, y: 4.03921568627451, size: 1 },
    //     { x: 6.47482014388489, y: 4.07843137254902, size: 1 },
    //     { x: 12.9496402877698, y: 4.11764705882353, size: 1 },
    //     { x: 16.1870503597122, y: 4.07843137254902, size: 1 },
    //     { x: 18.1294964028777, y: 4.03921568627451, size: 1 },
    //     { x: 18.7769784172662, y: 4.07843137254902, size: 1 },
    //     { x: 22.0143884892086, y: 4, size: 1 },
    //     { x: 25.8992805755396, y: 2.98039215686275, size: 1 },
    //     { x: 26.5467625899281, y: 2.86274509803922, size: 1 },
    //     { x: 29.136690647482, y: 4, size: 1 },
    //     { x: 29.7841726618705, y: 3.92156862745098, size: 1 },
    //     { x: 33.6690647482014, y: 4.03921568627451, size: 1 },
    //     { x: 37.5539568345324, y: 4, size: 1 },
    //     { x: 38.2014388489209, y: 4, size: 1 },
    //     { x: 47.9136690647482, y: 3.01960784313725, size: 1 },
    //     { x: 49.8561151079137, y: 4, size: 1 },
    //     { x: 50.5035971223022, y: 3.96078431372549, size: 1 },
    //     { x: 51.7985611510791, y: 4.23529411764706, size: 1 },
    //     { x: 55.0359712230216, y: 4.11764705882353, size: 1 },
    //     { x: 56.9784172661871, y: 4.19607843137255, size: 1 },
    //     { x: 60.2158273381295, y: 3.96078431372549, size: 1 },
    //     { x: 62.8057553956835, y: 4, size: 1 },
    //     { x: 66.6906474820144, y: 4.19607843137255, size: 1 },
    //     { x: 78.9928057553957, y: 4, size: 1 },
    //     { x: 112.661870503597, y: 2.3921568627451, size: 1 },
    //     { x: 134.028776978417, y: 2.82352941176471, size: 1 },
    //     { x: 140.503597122302, y: 4.23529411764706, size: 1 },
    //     { x: 144.388489208633, y: 4.27450980392157, size: 1 },
    //     { x: 146.330935251799, y: 4.03921568627451, size: 1 },
    //     { x: 152.158273381295, y: 4.03921568627451, size: 1 },
    //     { x: 152.805755395683, y: 4.15686274509804, size: 1 },
    //     { x: 161.870503597122, y: 4.07843137254902, size: 1 },
    //     { x: 163.812949640288, y: 4.27450980392157, size: 1 },
    //     { x: 166.402877697842, y: 4.19607843137255, size: 1 },
    //     { x: 167.697841726619, y: 4.07843137254902, size: 1 },
    //     { x: 169.640287769784, y: 4.03921568627451, size: 1 },
    //     { x: 177.410071942446, y: 2.62745098039216, size: 1 },
    //     { x: 198.776978417266, y: 2.7843137254902, size: 1 },
    //     { x: 200.719424460432, y: 4.11764705882353, size: 1 },
    //     { x: 203.956834532374, y: 4.15686274509804, size: 1 },
    //     { x: 205.251798561151, y: 4.07843137254902, size: 1 },
    //     { x: 206.546762589928, y: 4.15686274509804, size: 1 },
    //     { x: 211.079136690647, y: 4.07843137254902, size: 1 },
    //     { x: 212.374100719424, y: 4.03921568627451, size: 1 },
    //     { x: 214.964028776978, y: 4, size: 1 },
    //     { x: 216.258992805755, y: 4.15686274509804, size: 1 },
    //     { x: 216.906474820144, y: 4.07843137254902, size: 1 },
    //     { x: 220.143884892086, y: 2.74509803921569, size: 1 },
    //     { x: 220.791366906475, y: 2.58823529411765, size: 1 },
    //     { x: 237.625899280576, y: 3.25490196078431, size: 1 },
    //     { x: 242.158273381295, y: 2.74509803921569, size: 1 },
    //     { x: 242.805755395683, y: 3.13725490196078, size: 1 },
    //     { x: 249.928057553957, y: 3.17647058823529, size: 1 },
    //     { x: 263.525179856115, y: 2.74509803921569, size: 1 },
    //     { x: 264.172661870504, y: 2.66666666666667, size: 1 },
    //     { x: 297.841726618705, y: 3.96078431372549, size: 1 },
    //     { x: 323.741007194245, y: 3.88235294117647, size: 1 },
    //     { x: 47.2661870503597, y: 2.98039215686275, size: 1 },
    //     { x: 50.5035971223022, y: 3.25490196078431, size: 1 },
    //     { x: 68.6330935251799, y: 4, size: 1 },
    //     { x: 119.784172661871, y: 2.43137254901961, size: 1 },
    //     { x: 162.517985611511, y: 2.47058823529412, size: 1 },
    //     { x: 163.165467625899, y: 2.50980392156863, size: 1 },
    //     { x: 185.827338129496, y: 3.96078431372549, size: 1 },
    //     { x: 188.41726618705, y: 3.96078431372549, size: 1 },
    //     { x: 189.712230215827, y: 4.11764705882353, size: 1 },
    //     { x: 190.359712230216, y: 4.03921568627451, size: 1 },
    //     { x: 191.007194244604, y: 4.03921568627451, size: 1 },
    //     { x: 199.424460431655, y: 4.11764705882353, size: 1 },
    //     { x: 202.661870503597, y: 3.96078431372549, size: 1 },
    //     { x: 233.741007194245, y: 4.03921568627451, size: 1 },
    //     { x: 299.136690647482, y: 4.11764705882353, size: 1 },
    //     { x: 316.618705035971, y: 3.96078431372549, size: 1 },
    //     { x: 352.877697841727, y: 3.92156862745098, size: 1 },
    //     { x: 25.2517985611511, y: 3.09803921568627, size: 1 },
    //     { x: 32.3741007194245, y: 3.2156862745098, size: 1 },
    //     { x: 36.2589928057554, y: 3.05882352941176, size: 1 },
    //     { x: 113.956834532374, y: 4.15686274509804, size: 1 },
    //     { x: 119.784172661871, y: 4.15686274509804, size: 1 },
    //     { x: 218.201438848921, y: 3.96078431372549, size: 1 },
    //     { x: 255.755395683453, y: 2.86274509803922, size: 1 },
    //     { x: 257.05035971223, y: 3.09803921568627, size: 1 },
    //     { x: 279.064748201439, y: 2.70588235294118, size: 1 },
    //     { x: 304.964028776978, y: 4, size: 1 },
    //     { x: 308.201438848921, y: 4, size: 1 },
    //     { x: 310.791366906475, y: 4.07843137254902, size: 1 },
    //     { x: 311.438848920863, y: 3.96078431372549, size: 1 },
    //     { x: 315.971223021583, y: 4.19607843137255, size: 1 },
    //     { x: 5.18918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 10.3783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 15.5675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 16.8648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 17.5135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 18.8108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 20.7567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 21.4054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 29.1891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 46.7027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 51.2432432432432, y: 3.84313725490196, size: 1 },
    //     { x: 72, y: 3.96078431372549, size: 1 },
    //     { x: 76.5405405405405, y: 3.88235294117647, size: 1 },
    //     { x: 89.5135135135135, y: 3.37254901960784, size: 1 },
    //     { x: 90.1621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 91.4594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 105.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 112.216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 112.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 113.513513513514, y: 2.94117647058824, size: 1 },
    //     { x: 116.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 120.648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 133.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 134.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 134.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 135.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 153.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 155.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 156.324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 156.972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 178.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 179.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 182.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 184.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 188.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 189.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 191.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 193.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 219.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 220.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 221.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 241.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 241.945945945946, y: 2.74509803921569, size: 1 },
    //     { x: 242.594594594595, y: 2.62745098039216, size: 1 },
    //     { x: 243.243243243243, y: 2.70588235294118, size: 1 },
    //     { x: 255.567567567568, y: 3.41176470588235, size: 1 },
    //     { x: 295.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 295.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 300.324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 306.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 306.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 308.108108108108, y: 2.94117647058824, size: 1 },
    //     { x: 321.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 327.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 341.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 349.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 351.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 14.8920863309353, y: 3.96078431372549, size: 1 },
    //     { x: 17.4820143884892, y: 3.96078431372549, size: 1 },
    //     { x: 74.4604316546763, y: 3.29411764705882, size: 1 },
    //     { x: 75.7553956834532, y: 2.98039215686275, size: 1 },
    //     { x: 77.0503597122302, y: 3.05882352941176, size: 1 },
    //     { x: 98.4172661870504, y: 4.03921568627451, size: 1 },
    //     { x: 103.597122302158, y: 4.27450980392157, size: 1 },
    //     { x: 104.244604316547, y: 4.11764705882353, size: 1 },
    //     { x: 109.424460431655, y: 4, size: 1 },
    //     { x: 116.546762589928, y: 4.07843137254902, size: 1 },
    //     { x: 121.726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 122.374100719424, y: 4.07843137254902, size: 1 },
    //     { x: 126.258992805755, y: 4.19607843137255, size: 1 },
    //     { x: 128.848920863309, y: 4.11764705882353, size: 1 },
    //     { x: 131.438848920863, y: 4.11764705882353, size: 1 },
    //     { x: 132.086330935252, y: 4.03921568627451, size: 1 },
    //     { x: 135.323741007194, y: 3.96078431372549, size: 1 },
    //     { x: 137.26618705036, y: 4.15686274509804, size: 1 },
    //     { x: 150.863309352518, y: 4, size: 1 },
    //     { x: 152.805755395683, y: 4.03921568627451, size: 1 },
    //     { x: 154.10071942446, y: 3.96078431372549, size: 1 },
    //     { x: 162.517985611511, y: 2.66666666666667, size: 1 },
    //     { x: 163.165467625899, y: 2.86274509803922, size: 1 },
    //     { x: 163.812949640288, y: 2.94117647058824, size: 1 },
    //     { x: 164.460431654676, y: 2.82352941176471, size: 1 },
    //     { x: 165.107913669065, y: 4.43137254901961, size: 1 },
    //     { x: 166.402877697842, y: 4.31372549019608, size: 1 },
    //     { x: 172.877697841727, y: 4.07843137254902, size: 1 },
    //     { x: 174.820143884892, y: 4.07843137254902, size: 1 },
    //     { x: 175.467625899281, y: 4.11764705882353, size: 1 },
    //     { x: 179.352517985612, y: 4.15686274509804, size: 1 },
    //     { x: 181.294964028777, y: 4, size: 1 },
    //     { x: 184.532374100719, y: 3.2156862745098, size: 1 },
    //     { x: 185.179856115108, y: 4, size: 1 },
    //     { x: 194.244604316547, y: 4.23529411764706, size: 1 },
    //     { x: 198.776978417266, y: 4.07843137254902, size: 1 },
    //     { x: 202.014388489209, y: 3.96078431372549, size: 1 },
    //     { x: 202.661870503597, y: 4.03921568627451, size: 1 },
    //     { x: 209.136690647482, y: 4.03921568627451, size: 1 },
    //     { x: 211.726618705036, y: 4, size: 1 },
    //     { x: 216.258992805755, y: 4.03921568627451, size: 1 },
    //     { x: 216.906474820144, y: 4.15686274509804, size: 1 },
    //     { x: 222.086330935252, y: 4.03921568627451, size: 1 },
    //     { x: 228.561151079137, y: 3.05882352941176, size: 1 },
    //     { x: 248.63309352518, y: 3.13725490196078, size: 1 },
    //     { x: 253.165467625899, y: 4, size: 1 },
    //     { x: 258.992805755396, y: 4, size: 1 },
    //     { x: 260.935251798561, y: 4, size: 1 },
    //     { x: 261.58273381295, y: 4, size: 1 },
    //     { x: 288.129496402878, y: 3.88235294117647, size: 1 },
    //     { x: 289.424460431655, y: 3.96078431372549, size: 1 },
    //     { x: 290.071942446043, y: 3.13725490196078, size: 1 },
    //     { x: 292.014388489209, y: 2.62745098039216, size: 1 },
    //     { x: 292.661870503597, y: 2.82352941176471, size: 1 },
    //     { x: 297.841726618705, y: 4.07843137254902, size: 1 },
    //     { x: 314.028776978417, y: 3.05882352941176, size: 1 },
    //     { x: 321.798561151079, y: 4.03921568627451, size: 1 },
    //     { x: 334.748201438849, y: 2.11764705882353, size: 1 },
    //     { x: 335.395683453237, y: 1.64705882352941, size: 1 },
    //     { x: 336.043165467626, y: 2.15686274509804, size: 1 },
    //     { x: 337.338129496403, y: 2.66666666666667, size: 1 },
    //     { x: 339.928057553957, y: 2.90196078431373, size: 1 },
    //     { x: 350.935251798561, y: 3.01960784313725, size: 1 },
    //     { x: 352.230215827338, y: 3.13725490196078, size: 1 },
    //     { x: 353.525179856115, y: 3.13725490196078, size: 1 },
    //     { x: 358.057553956835, y: 4.31372549019608, size: 1 },
    //     { x: 2.58992805755396, y: 3.96078431372549, size: 1 },
    //     { x: 4.53237410071942, y: 4.23529411764706, size: 1 },
    //     { x: 9.06474820143885, y: 4, size: 1 },
    //     { x: 9.71223021582734, y: 4.03921568627451, size: 1 },
    //     { x: 10.3597122302158, y: 3.88235294117647, size: 1 },
    //     { x: 11.6546762589928, y: 4.11764705882353, size: 1 },
    //     { x: 12.9496402877698, y: 4.19607843137255, size: 1 },
    //     { x: 13.5971223021583, y: 4.11764705882353, size: 1 },
    //     { x: 14.8920863309353, y: 4.19607843137255, size: 1 },
    //     { x: 20.0719424460432, y: 4.07843137254902, size: 1 },
    //     { x: 22.0143884892086, y: 4.11764705882353, size: 1 },
    //     { x: 29.136690647482, y: 4.19607843137255, size: 1 },
    //     { x: 36.9064748201439, y: 4, size: 1 },
    //     { x: 39.4964028776978, y: 2.82352941176471, size: 1 },
    //     { x: 40.1438848920863, y: 2.82352941176471, size: 1 },
    //     { x: 61.5107913669065, y: 2.98039215686275, size: 1 },
    //     { x: 68.6330935251799, y: 4.03921568627451, size: 1 },
    //     { x: 69.9280575539568, y: 4.11764705882353, size: 1 },
    //     { x: 74.4604316546763, y: 4.27450980392157, size: 1 },
    //     { x: 104.244604316547, y: 2.90196078431373, size: 1 },
    //     { x: 104.892086330935, y: 2.82352941176471, size: 1 },
    //     { x: 125.611510791367, y: 3.17647058823529, size: 1 },
    //     { x: 126.258992805755, y: 1.96078431372549, size: 1 },
    //     { x: 147.625899280576, y: 2.43137254901961, size: 1 },
    //     { x: 148.273381294964, y: 2.43137254901961, size: 1 },
    //     { x: 168.992805755396, y: 2.58823529411765, size: 1 },
    //     { x: 169.640287769784, y: 2.66666666666667, size: 1 },
    //     { x: 189.712230215827, y: 3.01960784313725, size: 1 },
    //     { x: 191.007194244604, y: 2.03921568627451, size: 1 },
    //     { x: 212.374100719424, y: 2.98039215686275, size: 1 },
    //     { x: 256.402877697842, y: 3.33333333333333, size: 1 },
    //     { x: 282.302158273381, y: 4, size: 1 },
    //     { x: 292.014388489209, y: 4.07843137254902, size: 1 },
    //     { x: 294.604316546763, y: 3.88235294117647, size: 1 },
    //     { x: 301.079136690647, y: 3.96078431372549, size: 1 },
    //     { x: 339.280575539568, y: 3.96078431372549, size: 1 },
    //     { x: 4.53237410071942, y: 2.98039215686275, size: 1 },
    //     { x: 5.17985611510791, y: 3.01960784313725, size: 1 },
    //     { x: 46.6187050359712, y: 2.7843137254902, size: 1 },
    //     { x: 47.2661870503597, y: 2.58823529411765, size: 1 },
    //     { x: 51.7985611510791, y: 4.03921568627451, size: 1 },
    //     { x: 119.784172661871, y: 3.96078431372549, size: 1 },
    //     { x: 134.676258992806, y: 3.96078431372549, size: 1 },
    //     { x: 145.035971223022, y: 4.27450980392157, size: 1 },
    //     { x: 158.63309352518, y: 4.03921568627451, size: 1 },
    //     { x: 219.496402877698, y: 2.82352941176471, size: 1 },
    //     { x: 220.143884892086, y: 2.82352941176471, size: 1 },
    //     { x: 306.258992805755, y: 3.2156862745098, size: 1 },
    //     { x: 348.992805755396, y: 2.90196078431373, size: 1 },
    //     { x: 349.640287769784, y: 2.94117647058824, size: 1 },
    //     { x: 1.94594594594595, y: 3.45098039215686, size: 1 },
    //     { x: 11.6756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 12.3243243243243, y: 3.01960784313725, size: 1 },
    //     { x: 19.4594594594595, y: 3.33333333333333, size: 1 },
    //     { x: 53.1891891891892, y: 3.29411764705882, size: 1 },
    //     { x: 55.7837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 57.7297297297297, y: 4, size: 1 },
    //     { x: 63.5675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 64.8648648648649, y: 3.92156862745098, size: 1 },
    //     { x: 68.7567567567568, y: 4, size: 1 },
    //     { x: 72.6486486486486, y: 4.03921568627451, size: 1 },
    //     { x: 97.2972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 100.540540540541, y: 3.41176470588235, size: 1 },
    //     { x: 131.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 138.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 149.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 167.351351351351, y: 3.41176470588235, size: 1 },
    //     { x: 182.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 183.567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 203.675675675676, y: 3.84313725490196, size: 1 },
    //     { x: 210.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 249.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 270.486486486487, y: 3.2156862745098, size: 1 },
    //     { x: 271.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 271.783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 275.675675675676, y: 3.80392156862745, size: 1 },
    //     { x: 302.27027027027, y: 3.88235294117647, size: 1 },
    //     { x: 302.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 313.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 356.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 16.1870503597122, y: 3.29411764705882, size: 1 },
    //     { x: 19.4244604316547, y: 2.74509803921569, size: 1 },
    //     { x: 20.0719424460432, y: 2.74509803921569, size: 1 },
    //     { x: 60.863309352518, y: 2.7843137254902, size: 1 },
    //     { x: 61.5107913669065, y: 3.01960784313725, size: 1 },
    //     { x: 62.8057553956835, y: 3.09803921568627, size: 1 },
    //     { x: 80.2877697841727, y: 4.03921568627451, size: 1 },
    //     { x: 104.244604316547, y: 2.94117647058824, size: 1 },
    //     { x: 105.539568345324, y: 2.86274509803922, size: 1 },
    //     { x: 106.187050359712, y: 2.98039215686275, size: 1 },
    //     { x: 126.258992805755, y: 2.94117647058824, size: 1 },
    //     { x: 184.532374100719, y: 4.07843137254902, size: 1 },
    //     { x: 199.424460431655, y: 4.07843137254902, size: 1 },
    //     { x: 220.143884892086, y: 4.03921568627451, size: 1 },
    //     { x: 233.741007194245, y: 2.94117647058824, size: 1 },
    //     { x: 234.388489208633, y: 3.09803921568627, size: 1 },
    //     { x: 235.035971223022, y: 2.66666666666667, size: 1 },
    //     { x: 255.107913669065, y: 3.25490196078431, size: 1 },
    //     { x: 277.122302158273, y: 2.62745098039216, size: 1 },
    //     { x: 4.53237410071942, y: 3.96078431372549, size: 1 },
    //     { x: 5.17985611510791, y: 4.03921568627451, size: 1 },
    //     { x: 45.9712230215827, y: 3.92156862745098, size: 1 },
    //     { x: 101.007194244604, y: 4.07843137254902, size: 1 },
    //     { x: 112.661870503597, y: 4, size: 1 },
    //     { x: 133.381294964029, y: 3.01960784313725, size: 1 },
    //     { x: 260.287769784173, y: 3.05882352941176, size: 1 },
    //     { x: 262.230215827338, y: 1.92156862745098, size: 1 },
    //     { x: 262.877697841727, y: 2.03921568627451, size: 1 },
    //     { x: 305.611510791367, y: 2.62745098039216, size: 1 },
    //     { x: 327.625899280576, y: 2.66666666666667, size: 1 },
    //     { x: 348.345323741007, y: 2.66666666666667, size: 1 },
    //     { x: 348.992805755396, y: 2.11764705882353, size: 1 },
    //     { x: 1.2972972972973, y: 4, size: 1 },
    //     { x: 3.89189189189189, y: 4.03921568627451, size: 1 },
    //     { x: 26.5945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 31.7837837837838, y: 3.05882352941176, size: 1 },
    //     { x: 32.4324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 42.1621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 53.8378378378378, y: 2.62745098039216, size: 1 },
    //     { x: 54.4864864864865, y: 3.88235294117647, size: 1 },
    //     { x: 69.4054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 73.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 74.5945945945946, y: 2.94117647058824, size: 1 },
    //     { x: 75.2432432432432, y: 2.50980392156863, size: 1 },
    //     { x: 86.2702702702703, y: 3.80392156862745, size: 1 },
    //     { x: 95.3513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 96, y: 3.05882352941176, size: 1 },
    //     { x: 96.6486486486486, y: 2.43137254901961, size: 1 },
    //     { x: 97.2972972972973, y: 2.43137254901961, size: 1 },
    //     { x: 100.540540540541, y: 4, size: 1 },
    //     { x: 103.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 118.054054054054, y: 2.50980392156863, size: 1 },
    //     { x: 118.702702702703, y: 2.31372549019608, size: 1 },
    //     { x: 120.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 124.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 129.72972972973, y: 4, size: 1 },
    //     { x: 135.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 149.189189189189, y: 3.84313725490196, size: 1 },
    //     { x: 152.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 156.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 156.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 162.162162162162, y: 2.74509803921569, size: 1 },
    //     { x: 164.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 165.405405405405, y: 4.11764705882353, size: 1 },
    //     { x: 168, y: 4.19607843137255, size: 1 },
    //     { x: 171.891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 173.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 173.837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 179.027027027027, y: 4, size: 1 },
    //     { x: 182.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 183.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 186.162162162162, y: 4, size: 1 },
    //     { x: 232.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 249.72972972973, y: 4.03921568627451, size: 1 },
    //     { x: 250.378378378378, y: 4.07843137254902, size: 1 },
    //     { x: 252.324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 252.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 253.621621621622, y: 4.11764705882353, size: 1 },
    //     { x: 254.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 261.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 265.945945945946, y: 4, size: 1 },
    //     { x: 270.486486486487, y: 3.33333333333333, size: 1 },
    //     { x: 286.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 294.486486486487, y: 3.25490196078431, size: 1 },
    //     { x: 304.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 314.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 329.513513513513, y: 3.41176470588235, size: 1 },
    //     { x: 334.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 336.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 339.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 51.7985611510791, y: 3.96078431372549, size: 1 },
    //     { x: 60.863309352518, y: 2.98039215686275, size: 1 },
    //     { x: 62.8057553956835, y: 3.13725490196078, size: 1 },
    //     { x: 66.6906474820144, y: 3.17647058823529, size: 1 },
    //     { x: 74.4604316546763, y: 3.17647058823529, size: 1 },
    //     { x: 77.6978417266187, y: 3.13725490196078, size: 1 },
    //     { x: 88.705035971223, y: 4.27450980392157, size: 1 },
    //     { x: 99.0647482014388, y: 4.23529411764706, size: 1 },
    //     { x: 126.906474820144, y: 2.98039215686275, size: 1 },
    //     { x: 127.553956834532, y: 3.09803921568627, size: 1 },
    //     { x: 147.625899280576, y: 3.13725490196078, size: 1 },
    //     { x: 155.395683453237, y: 3.2156862745098, size: 1 },
    //     { x: 170.287769784173, y: 3.05882352941176, size: 1 },
    //     { x: 170.935251798561, y: 2.98039215686275, size: 1 },
    //     { x: 177.410071942446, y: 3.2156862745098, size: 1 },
    //     { x: 179.352517985612, y: 3.25490196078431, size: 1 },
    //     { x: 180, y: 3.25490196078431, size: 1 },
    //     { x: 180.647482014388, y: 3.17647058823529, size: 1 },
    //     { x: 181.294964028777, y: 3.05882352941176, size: 1 },
    //     { x: 191.007194244604, y: 2.66666666666667, size: 1 },
    //     { x: 191.654676258993, y: 2.7843137254902, size: 1 },
    //     { x: 193.597122302158, y: 3.13725490196078, size: 1 },
    //     { x: 242.158273381295, y: 3.2156862745098, size: 1 },
    //     { x: 244.10071942446, y: 3.17647058823529, size: 1 },
    //     { x: 246.043165467626, y: 3.09803921568627, size: 1 },
    //     { x: 247.338129496403, y: 3.17647058823529, size: 1 },
    //     { x: 276.474820143885, y: 2.90196078431373, size: 1 },
    //     { x: 277.122302158273, y: 2.94117647058824, size: 1 },
    //     { x: 317.913669064748, y: 4.03921568627451, size: 1 },
    //     { x: 331.510791366906, y: 3.09803921568627, size: 1 },
    //     { x: 14.8920863309353, y: 3.2156862745098, size: 1 },
    //     { x: 25.8992805755396, y: 2.94117647058824, size: 1 },
    //     { x: 26.5467625899281, y: 3.01960784313725, size: 1 },
    //     { x: 67.9856115107914, y: 2.7843137254902, size: 1 },
    //     { x: 69.2805755395683, y: 2.82352941176471, size: 1 },
    //     { x: 88.705035971223, y: 3.25490196078431, size: 1 },
    //     { x: 89.3525179856115, y: 3.09803921568627, size: 1 },
    //     { x: 90, y: 2.66666666666667, size: 1 },
    //     { x: 91.294964028777, y: 2.62745098039216, size: 1 },
    //     { x: 101.007194244604, y: 3.2156862745098, size: 1 },
    //     { x: 102.94964028777, y: 3.17647058823529, size: 1 },
    //     { x: 107.482014388489, y: 3.25490196078431, size: 1 },
    //     { x: 110.071942446043, y: 4.15686274509804, size: 1 },
    //     { x: 146.330935251799, y: 3.13725490196078, size: 1 },
    //     { x: 165.107913669065, y: 3.25490196078431, size: 1 },
    //     { x: 170.935251798561, y: 3.2156862745098, size: 1 },
    //     { x: 326.978417266187, y: 3.05882352941176, size: 1 },
    //     { x: 337.338129496403, y: 4.07843137254902, size: 1 },
    //     { x: 75.1079136690647, y: 3.01960784313725, size: 1 },
    //     { x: 101.007194244604, y: 4.15686274509804, size: 1 },
    //     { x: 109.424460431655, y: 4.07843137254902, size: 1 },
    //     { x: 146.978417266187, y: 4.23529411764706, size: 1 },
    //     { x: 147.625899280576, y: 4.23529411764706, size: 1 },
    //     { x: 153.453237410072, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 4.23529411764706, size: 1 },
    //     { x: 231.798561151079, y: 4.03921568627451, size: 1 },
    //     { x: 268.705035971223, y: 2.98039215686275, size: 1 },
    //     { x: 291.36690647482, y: 3.2156862745098, size: 1 },
    //     { x: 319.856115107914, y: 4.07843137254902, size: 1 },
    //     { x: 17.5135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 49.9459459459459, y: 3.88235294117647, size: 1 },
    //     { x: 51.8918918918919, y: 4, size: 1 },
    //     { x: 62.9189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 90.8108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 103.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 126.486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 134.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 186.810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 188.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 188.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 190.054054054054, y: 1.64705882352941, size: 1 },
    //     { x: 190.702702702703, y: 2.03921568627451, size: 1 },
    //     { x: 191.351351351351, y: 1.72549019607843, size: 1 },
    //     { x: 192, y: 1.49019607843137, size: 1 },
    //     { x: 193.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 194.594594594595, y: 2.7843137254902, size: 1 },
    //     { x: 195.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 199.135135135135, y: 2.90196078431373, size: 1 },
    //     { x: 199.783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 205.621621621622, y: 2.7843137254902, size: 1 },
    //     { x: 206.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 207.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 208.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 210.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 212.756756756757, y: 2.74509803921569, size: 1 },
    //     { x: 220.540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 228.972972972973, y: 4.11764705882353, size: 1 },
    //     { x: 232.864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 233.513513513514, y: 2.50980392156863, size: 1 },
    //     { x: 244.540540540541, y: 4, size: 1 },
    //     { x: 247.783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 248.432432432432, y: 4, size: 1 },
    //     { x: 253.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 254.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 254.918918918919, y: 2.86274509803922, size: 1 },
    //     { x: 257.513513513513, y: 4.11764705882353, size: 1 },
    //     { x: 258.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 265.945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 276.324324324324, y: 2.62745098039216, size: 1 },
    //     { x: 276.972972972973, y: 2.66666666666667, size: 1 },
    //     { x: 289.945945945946, y: 3.37254901960784, size: 1 },
    //     { x: 300.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 301.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 309.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 315.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 318.486486486487, y: 3.01960784313725, size: 1 },
    //     { x: 319.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 319.783783783784, y: 2.62745098039216, size: 1 },
    //     { x: 332.108108108108, y: 4.07843137254902, size: 1 },
    //     { x: 332.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 339.243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 340.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 341.189189189189, y: 2.62745098039216, size: 1 },
    //     { x: 341.837837837838, y: 2.43137254901961, size: 1 },
    //     { x: 343.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 347.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 348.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 359.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 0.647482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 2.58992805755396, y: 2.50980392156863, size: 1 },
    //     { x: 3.23741007194245, y: 2.58823529411765, size: 1 },
    //     { x: 23.9568345323741, y: 3.13725490196078, size: 1 },
    //     { x: 24.6043165467626, y: 2.74509803921569, size: 1 },
    //     { x: 46.6187050359712, y: 2.47058823529412, size: 1 },
    //     { x: 49.2086330935252, y: 3.2156862745098, size: 1 },
    //     { x: 60.2158273381295, y: 3.13725490196078, size: 1 },
    //     { x: 63.4532374100719, y: 3.13725490196078, size: 1 },
    //     { x: 67.9856115107914, y: 2.58823529411765, size: 1 },
    //     { x: 209.136690647482, y: 3.88235294117647, size: 1 },
    //     { x: 220.143884892086, y: 3.09803921568627, size: 1 },
    //     { x: 240.215827338129, y: 2.66666666666667, size: 1 },
    //     { x: 240.863309352518, y: 2.98039215686275, size: 1 },
    //     { x: 241.510791366906, y: 2.7843137254902, size: 1 },
    //     { x: 242.158273381295, y: 2.98039215686275, size: 1 },
    //     { x: 279.064748201439, y: 3.96078431372549, size: 1 },
    //     { x: 305.611510791367, y: 3.01960784313725, size: 1 },
    //     { x: 326.330935251799, y: 2.50980392156863, size: 1 },
    //     { x: 326.978417266187, y: 2.35294117647059, size: 1 },
    //     { x: 327.625899280576, y: 2.50980392156863, size: 1 },
    //     { x: 337.985611510791, y: 3.17647058823529, size: 1 },
    //     { x: 141.151079136691, y: 3.05882352941176, size: 1 },
    //     { x: 180.647482014388, y: 3.25490196078431, size: 1 },
    //     { x: 182.589928057554, y: 3.09803921568627, size: 1 },
    //     { x: 183.237410071942, y: 2.98039215686275, size: 1 },
    //     { x: 184.532374100719, y: 3.09803921568627, size: 1 },
    //     { x: 200.071942446043, y: 4.23529411764706, size: 1 },
    //     { x: 204.604316546763, y: 2.90196078431373, size: 1 },
    //     { x: 229.208633093525, y: 4.07843137254902, size: 1 },
    //     { x: 261.58273381295, y: 3.25490196078431, size: 1 },
    //     { x: 312.086330935252, y: 2.54901960784314, size: 1 },
    //     { x: 312.73381294964, y: 2.54901960784314, size: 1 },
    //     { x: 313.381294964029, y: 2.62745098039216, size: 1 },
    //     { x: 314.028776978417, y: 2.54901960784314, size: 1 },
    //     { x: 328.920863309353, y: 4.19607843137255, size: 1 },
    //     { x: 332.805755395683, y: 3.33333333333333, size: 1 },
    //     { x: 354.820143884892, y: 2.82352941176471, size: 1 },
    //     { x: 56.3309352517986, y: 3.13725490196078, size: 1 },
    //     { x: 59.568345323741, y: 3.01960784313725, size: 1 },
    //     { x: 85.4676258992806, y: 4, size: 1 },
    //     { x: 100.359712230216, y: 4, size: 1 },
    //     { x: 124.31654676259, y: 2.86274509803922, size: 1 },
    //     { x: 126.258992805755, y: 2.66666666666667, size: 1 },
    //     { x: 126.906474820144, y: 3.05882352941176, size: 1 },
    //     { x: 168.345323741007, y: 2.98039215686275, size: 1 },
    //     { x: 182.589928057554, y: 4.15686274509804, size: 1 },
    //     { x: 189.064748201439, y: 2.43137254901961, size: 1 },
    //     { x: 189.712230215827, y: 2.43137254901961, size: 1 },
    //     { x: 227.26618705036, y: 4.03921568627451, size: 1 },
    //     { x: 232.446043165468, y: 3.09803921568627, size: 1 },
    //     { x: 254.460431654676, y: 3.01960784313725, size: 1 },
    //     { x: 319.208633093525, y: 2.86274509803922, size: 1 },
    //     { x: 340.575539568345, y: 3.2156862745098, size: 1 },
    //     { x: 23.3513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 24, y: 2.98039215686275, size: 1 },
    //     { x: 24.6486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 25.9459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 36.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 49.2972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 59.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 66.1621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 66.8108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 84.3243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 88.2162162162162, y: 3.41176470588235, size: 1 },
    //     { x: 88.8648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 97.2972972972973, y: 3.80392156862745, size: 1 },
    //     { x: 109.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 110.27027027027, y: 3.01960784313725, size: 1 },
    //     { x: 129.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 131.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 132.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 142.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 151.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 156.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 177.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 181.621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 186.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 192.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 196.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 197.189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 245.837837837838, y: 3.80392156862745, size: 1 },
    //     { x: 256.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 260.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 261.405405405405, y: 2.90196078431373, size: 1 },
    //     { x: 262.054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 268.540540540541, y: 4.07843137254902, size: 1 },
    //     { x: 272.432432432432, y: 4, size: 1 },
    //     { x: 299.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 303.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 304.216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 304.864864864865, y: 2.70588235294118, size: 1 },
    //     { x: 305.513513513513, y: 3.01960784313725, size: 1 },
    //     { x: 307.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 308.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 310.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 324.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 326.27027027027, y: 2.94117647058824, size: 1 },
    //     { x: 326.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 346.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 347.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 347.675675675676, y: 2.43137254901961, size: 1 },
    //     { x: 348.324324324324, y: 2.54901960784314, size: 1 },
    //     { x: 9.71223021582734, y: 3.13725490196078, size: 1 },
    //     { x: 31.0791366906475, y: 3.01960784313725, size: 1 },
    //     { x: 31.726618705036, y: 2.98039215686275, size: 1 },
    //     { x: 53.0935251798561, y: 2.90196078431373, size: 1 },
    //     { x: 74.4604316546763, y: 2.82352941176471, size: 1 },
    //     { x: 96.4748201438849, y: 3.09803921568627, size: 1 },
    //     { x: 115.89928057554, y: 3.17647058823529, size: 1 },
    //     { x: 117.194244604317, y: 2.43137254901961, size: 1 },
    //     { x: 117.841726618705, y: 2.19607843137255, size: 1 },
    //     { x: 119.784172661871, y: 3.25490196078431, size: 1 },
    //     { x: 139.208633093525, y: 2.62745098039216, size: 1 },
    //     { x: 160.575539568345, y: 2.43137254901961, size: 1 },
    //     { x: 161.223021582734, y: 2.66666666666667, size: 1 },
    //     { x: 181.942446043165, y: 2.74509803921569, size: 1 },
    //     { x: 182.589928057554, y: 2.50980392156863, size: 1 },
    //     { x: 203.309352517986, y: 3.09803921568627, size: 1 },
    //     { x: 203.956834532374, y: 2.11764705882353, size: 1 },
    //     { x: 242.805755395683, y: 4, size: 1 },
    //     { x: 267.410071942446, y: 3.2156862745098, size: 1 },
    //     { x: 268.057553956835, y: 2.82352941176471, size: 1 },
    //     { x: 268.705035971223, y: 2.15686274509804, size: 1 },
    //     { x: 333.453237410072, y: 2.66666666666667, size: 1 },
    //     { x: 335.395683453237, y: 3.29411764705882, size: 1 },
    //     { x: 354.820143884892, y: 2.7843137254902, size: 1 },
    //     { x: 37.5539568345324, y: 3.01960784313725, size: 1 },
    //     { x: 38.2014388489209, y: 1.92156862745098, size: 1 },
    //     { x: 126.906474820144, y: 4.03921568627451, size: 1 },
    //     { x: 128.201438848921, y: 4.11764705882353, size: 1 },
    //     { x: 168.992805755396, y: 3.01960784313725, size: 1 },
    //     { x: 169.640287769784, y: 3.09803921568627, size: 1 },
    //     { x: 211.079136690647, y: 2.3921568627451, size: 1 },
    //     { x: 211.726618705036, y: 2.47058823529412, size: 1 },
    //     { x: 212.374100719424, y: 1.96078431372549, size: 1 },
    //     { x: 232.446043165468, y: 2.90196078431373, size: 1 },
    //     { x: 314.028776978417, y: 4.03921568627451, size: 1 },
    //     { x: 88.705035971223, y: 2.70588235294118, size: 1 },
    //     { x: 89.3525179856115, y: 2.94117647058824, size: 1 },
    //     { x: 101.654676258993, y: 4.03921568627451, size: 1 },
    //     { x: 129.496402877698, y: 3.13725490196078, size: 1 },
    //     { x: 131.438848920863, y: 2.19607843137255, size: 1 },
    //     { x: 132.73381294964, y: 2.90196078431373, size: 1 },
    //     { x: 133.381294964029, y: 2.62745098039216, size: 1 },
    //     { x: 143.093525179856, y: 3.17647058823529, size: 1 },
    //     { x: 144.388489208633, y: 3.17647058823529, size: 1 },
    //     { x: 187.122302158273, y: 4.03921568627451, size: 1 },
    //     { x: 196.187050359712, y: 3.01960784313725, size: 1 },
    //     { x: 198.129496402878, y: 3.96078431372549, size: 1 },
    //     { x: 203.956834532374, y: 4.07843137254902, size: 1 },
    //     { x: 233.741007194245, y: 4, size: 1 },
    //     { x: 260.935251798561, y: 2.82352941176471, size: 1 },
    //     { x: 261.58273381295, y: 2.74509803921569, size: 1 },
    //     { x: 262.877697841727, y: 2.70588235294118, size: 1 },
    //     { x: 273.884892086331, y: 4.15686274509804, size: 1 },
    //     { x: 275.827338129496, y: 4.15686274509804, size: 1 },
    //     { x: 282.94964028777, y: 2.82352941176471, size: 1 },
    //     { x: 283.597122302158, y: 3.33333333333333, size: 1 },
    //     { x: 342.517985611511, y: 3.92156862745098, size: 1 },
    //     { x: 8.43243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 9.72972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 10.3783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 16.8648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 18.1621621621622, y: 3.88235294117647, size: 1 },
    //     { x: 23.3513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 24, y: 4.11764705882353, size: 1 },
    //     { x: 26.5945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 29.1891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 53.8378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 64.8648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 65.5135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 66.1621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 90.8108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 97.2972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 115.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 116.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 120, y: 4.03921568627451, size: 1 },
    //     { x: 123.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 123.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 127.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 135.567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 136.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 138.162162162162, y: 2.7843137254902, size: 1 },
    //     { x: 138.810810810811, y: 2.70588235294118, size: 1 },
    //     { x: 139.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 140.108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 162.162162162162, y: 3.45098039215686, size: 1 },
    //     { x: 187.459459459459, y: 4, size: 1 },
    //     { x: 188.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 191.351351351351, y: 4.27450980392157, size: 1 },
    //     { x: 203.027027027027, y: 2.86274509803922, size: 1 },
    //     { x: 203.675675675676, y: 2.82352941176471, size: 1 },
    //     { x: 204.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 245.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 247.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 249.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 258.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 259.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 261.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 263.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 264, y: 3.2156862745098, size: 1 },
    //     { x: 271.783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 272.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 273.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 284.108108108108, y: 4, size: 1 },
    //     { x: 288, y: 3.13725490196078, size: 1 },
    //     { x: 288.648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 289.945945945946, y: 2.3921568627451, size: 1 },
    //     { x: 290.594594594595, y: 2.7843137254902, size: 1 },
    //     { x: 291.243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 291.891891891892, y: 2.66666666666667, size: 1 },
    //     { x: 312, y: 3.09803921568627, size: 1 },
    //     { x: 332.756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 333.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 334.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 345.081081081081, y: 3.37254901960784, size: 1 },
    //     { x: 345.72972972973, y: 3.33333333333333, size: 1 },
    //     { x: 350.918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 1.94244604316547, y: 3.96078431372549, size: 1 },
    //     { x: 5.8273381294964, y: 4.07843137254902, size: 1 },
    //     { x: 37.5539568345324, y: 2.94117647058824, size: 1 },
    //     { x: 40.1438848920863, y: 3.09803921568627, size: 1 },
    //     { x: 91.294964028777, y: 4.19607843137255, size: 1 },
    //     { x: 97.7697841726619, y: 4.07843137254902, size: 1 },
    //     { x: 99.7122302158273, y: 4, size: 1 },
    //     { x: 100.359712230216, y: 3.96078431372549, size: 1 },
    //     { x: 102.302158273381, y: 3.13725490196078, size: 1 },
    //     { x: 104.892086330935, y: 4, size: 1 },
    //     { x: 107.482014388489, y: 4.11764705882353, size: 1 },
    //     { x: 115.251798561151, y: 4.23529411764706, size: 1 },
    //     { x: 124.31654676259, y: 3.13725490196078, size: 1 },
    //     { x: 124.964028776978, y: 3.01960784313725, size: 1 },
    //     { x: 125.611510791367, y: 2.66666666666667, size: 1 },
    //     { x: 189.712230215827, y: 2.54901960784314, size: 1 },
    //     { x: 190.359712230216, y: 2.47058823529412, size: 1 },
    //     { x: 191.007194244604, y: 2.47058823529412, size: 1 },
    //     { x: 253.812949640288, y: 2.98039215686275, size: 1 },
    //     { x: 254.460431654676, y: 2.82352941176471, size: 1 },
    //     { x: 255.107913669065, y: 2.90196078431373, size: 1 },
    //     { x: 255.755395683453, y: 2.7843137254902, size: 1 },
    //     { x: 260.287769784173, y: 4, size: 1 },
    //     { x: 275.179856115108, y: 2.86274509803922, size: 1 },
    //     { x: 296.546762589928, y: 3.09803921568627, size: 1 },
    //     { x: 297.194244604317, y: 2.82352941176471, size: 1 },
    //     { x: 325.035971223022, y: 3.96078431372549, size: 1 },
    //     { x: 349.640287769784, y: 4.11764705882353, size: 1 },
    //     { x: 44.6762589928058, y: 2.43137254901961, size: 1 },
    //     { x: 45.9712230215827, y: 2.82352941176471, size: 1 },
    //     { x: 53.7410071942446, y: 2.86274509803922, size: 1 },
    //     { x: 54.3884892086331, y: 2.82352941176471, size: 1 },
    //     { x: 60.2158273381295, y: 2.7843137254902, size: 1 },
    //     { x: 60.863309352518, y: 2.90196078431373, size: 1 },
    //     { x: 66.0431654676259, y: 3.05882352941176, size: 1 },
    //     { x: 87.410071942446, y: 3.25490196078431, size: 1 },
    //     { x: 88.705035971223, y: 3.05882352941176, size: 1 },
    //     { x: 109.424460431655, y: 3.25490196078431, size: 1 },
    //     { x: 174.172661870504, y: 2.98039215686275, size: 1 },
    //     { x: 174.820143884892, y: 2.66666666666667, size: 1 },
    //     { x: 196.187050359712, y: 2.47058823529412, size: 1 },
    //     { x: 200.071942446043, y: 4.11764705882353, size: 1 },
    //     { x: 213.669064748201, y: 4, size: 1 },
    //     { x: 238.920863309353, y: 2.94117647058824, size: 1 },
    //     { x: 246.690647482014, y: 3.25490196078431, size: 1 },
    //     { x: 260.287769784173, y: 2.90196078431373, size: 1 },
    //     { x: 303.669064748201, y: 2.23529411764706, size: 1 },
    //     { x: 304.31654676259, y: 2.15686274509804, size: 1 },
    //     { x: 16.8648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 24.6486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 25.2972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 31.7837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 37.6216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 39.5675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 41.5135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 43.4594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 59.6756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 68.1081081081081, y: 4, size: 1 },
    //     { x: 73.2972972972973, y: 2.66666666666667, size: 1 },
    //     { x: 74.5945945945946, y: 2.62745098039216, size: 1 },
    //     { x: 75.2432432432432, y: 2.43137254901961, size: 1 },
    //     { x: 94.7027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 95.3513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 96, y: 2.90196078431373, size: 1 },
    //     { x: 96.6486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 110.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 138.162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 139.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 158.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 159.567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 160.216216216216, y: 2.58823529411765, size: 1 },
    //     { x: 160.864864864865, y: 2.74509803921569, size: 1 },
    //     { x: 180.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 181.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 182.27027027027, y: 2.98039215686275, size: 1 },
    //     { x: 182.918918918919, y: 2.86274509803922, size: 1 },
    //     { x: 183.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 222.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 224.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 225.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 226.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 238.054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 240, y: 4.19607843137255, size: 1 },
    //     { x: 243.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 272.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 289.297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 291.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 312.648648648649, y: 2.94117647058824, size: 1 },
    //     { x: 313.297297297297, y: 2.90196078431373, size: 1 },
    //     { x: 347.027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 355.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 356.108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 16.8345323741007, y: 2.98039215686275, size: 1 },
    //     { x: 18.1294964028777, y: 2.7843137254902, size: 1 },
    //     { x: 37.5539568345324, y: 3.2156862745098, size: 1 },
    //     { x: 58.9208633093525, y: 2.86274509803922, size: 1 },
    //     { x: 61.5107913669065, y: 3.05882352941176, size: 1 },
    //     { x: 80.2877697841727, y: 2.98039215686275, size: 1 },
    //     { x: 80.9352517985612, y: 3.09803921568627, size: 1 },
    //     { x: 81.5827338129496, y: 2.98039215686275, size: 1 },
    //     { x: 82.8776978417266, y: 2.66666666666667, size: 1 },
    //     { x: 147.625899280576, y: 2.98039215686275, size: 1 },
    //     { x: 188.41726618705, y: 3.05882352941176, size: 1 },
    //     { x: 259.640287769784, y: 4.11764705882353, size: 1 },
    //     { x: 277.122302158273, y: 2.98039215686275, size: 1 },
    //     { x: 297.194244604317, y: 3.13725490196078, size: 1 },
    //     { x: 325.035971223022, y: 4.15686274509804, size: 1 },
    //     { x: 23.9568345323741, y: 3.05882352941176, size: 1 },
    //     { x: 46.6187050359712, y: 3.29411764705882, size: 1 },
    //     { x: 63.4532374100719, y: 3.96078431372549, size: 1 },
    //     { x: 87.410071942446, y: 3.01960784313725, size: 1 },
    //     { x: 88.0575539568345, y: 3.13725490196078, size: 1 },
    //     { x: 93.8848920863309, y: 3.96078431372549, size: 1 },
    //     { x: 106.834532374101, y: 4.15686274509804, size: 1 },
    //     { x: 108.776978417266, y: 4, size: 1 },
    //     { x: 116.546762589928, y: 4.19607843137255, size: 1 },
    //     { x: 130.791366906475, y: 2.62745098039216, size: 1 },
    //     { x: 131.438848920863, y: 2.74509803921569, size: 1 },
    //     { x: 132.086330935252, y: 2.50980392156863, size: 1 },
    //     { x: 132.73381294964, y: 2.23529411764706, size: 1 },
    //     { x: 135.971223021583, y: 4.15686274509804, size: 1 },
    //     { x: 176.762589928058, y: 4.07843137254902, size: 1 },
    //     { x: 180.647482014388, y: 4.07843137254902, size: 1 },
    //     { x: 189.064748201439, y: 4.15686274509804, size: 1 },
    //     { x: 195.539568345324, y: 2.82352941176471, size: 1 },
    //     { x: 196.834532374101, y: 2.90196078431373, size: 1 },
    //     { x: 197.482014388489, y: 2.82352941176471, size: 1 },
    //     { x: 217.553956834532, y: 2.50980392156863, size: 1 },
    //     { x: 309.496402877698, y: 3.17647058823529, size: 1 },
    //     { x: 316.618705035971, y: 3.09803921568627, size: 1 },
    //     { x: 323.093525179856, y: 3.25490196078431, size: 1 },
    //     { x: 325.68345323741, y: 3.01960784313725, size: 1 },
    //     { x: 326.330935251799, y: 2.74509803921569, size: 1 },
    //     { x: 326.978417266187, y: 2.66666666666667, size: 1 },
    //     { x: 347.697841726619, y: 2.86274509803922, size: 1 },
    //     { x: 359.352517985611, y: 4.03921568627451, size: 1 },
    //     { x: 0.648648648648649, y: 4.07843137254902, size: 1 },
    //     { x: 1.2972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 3.24324324324324, y: 4, size: 1 },
    //     { x: 6.48648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 22.0540540540541, y: 3.84313725490196, size: 1 },
    //     { x: 31.1351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 57.7297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 74.5945945945946, y: 3.41176470588235, size: 1 },
    //     { x: 81.0810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 84.3243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 91.4594594594595, y: 3.41176470588235, size: 1 },
    //     { x: 112.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 115.459459459459, y: 3.37254901960784, size: 1 },
    //     { x: 116.756756756757, y: 2.94117647058824, size: 1 },
    //     { x: 138.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 158.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 159.567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 180.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 194.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 204.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 208.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 214.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 216.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 220.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 225.081081081081, y: 2.94117647058824, size: 1 },
    //     { x: 225.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 247.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 248.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 287.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 289.297297297297, y: 2.70588235294118, size: 1 },
    //     { x: 289.945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 291.243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 291.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 293.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 293.837837837838, y: 4, size: 1 },
    //     { x: 310.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 310.702702702703, y: 2.94117647058824, size: 1 },
    //     { x: 312, y: 2.90196078431373, size: 1 },
    //     { x: 312.648648648649, y: 2.74509803921569, size: 1 },
    //     { x: 347.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 354.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 7.12230215827338, y: 4.03921568627451, size: 1 },
    //     { x: 16.1870503597122, y: 2.31372549019608, size: 1 },
    //     { x: 29.7841726618705, y: 3.96078431372549, size: 1 },
    //     { x: 36.2589928057554, y: 2.98039215686275, size: 1 },
    //     { x: 36.9064748201439, y: 3.05882352941176, size: 1 },
    //     { x: 37.5539568345324, y: 2.19607843137255, size: 1 },
    //     { x: 58.9208633093525, y: 2.43137254901961, size: 1 },
    //     { x: 59.568345323741, y: 2.70588235294118, size: 1 },
    //     { x: 76.4028776978417, y: 4, size: 1 },
    //     { x: 80.9352517985612, y: 3.13725490196078, size: 1 },
    //     { x: 123.669064748201, y: 2.74509803921569, size: 1 },
    //     { x: 124.31654676259, y: 2.58823529411765, size: 1 },
    //     { x: 145.035971223022, y: 2.43137254901961, size: 1 },
    //     { x: 145.68345323741, y: 2.50980392156863, size: 1 },
    //     { x: 167.05035971223, y: 2.27450980392157, size: 1 },
    //     { x: 188.41726618705, y: 2.23529411764706, size: 1 },
    //     { x: 209.784172661871, y: 2.62745098039216, size: 1 },
    //     { x: 210.431654676259, y: 2.66666666666667, size: 1 },
    //     { x: 317.913669064748, y: 2.82352941176471, size: 1 },
    //     { x: 318.561151079137, y: 2.86274509803922, size: 1 },
    //     { x: 319.208633093525, y: 2.7843137254902, size: 1 },
    //     { x: 319.856115107914, y: 2.86274509803922, size: 1 },
    //     { x: 354.820143884892, y: 4.07843137254902, size: 1 },
    //     { x: 23.9568345323741, y: 2.94117647058824, size: 1 },
    //     { x: 24.6043165467626, y: 2.70588235294118, size: 1 },
    //     { x: 44.0287769784173, y: 2.7843137254902, size: 1 },
    //     { x: 64.1007194244604, y: 3.17647058823529, size: 1 },
    //     { x: 108.776978417266, y: 2.54901960784314, size: 1 },
    //     { x: 109.424460431655, y: 2.70588235294118, size: 1 },
    //     { x: 110.071942446043, y: 2.35294117647059, size: 1 },
    //     { x: 110.719424460432, y: 2.50980392156863, size: 1 },
    //     { x: 118.489208633094, y: 4.15686274509804, size: 1 },
    //     { x: 195.539568345324, y: 3.05882352941176, size: 1 },
    //     { x: 200.719424460432, y: 4, size: 1 },
    //     { x: 215.611510791367, y: 2.90196078431373, size: 1 },
    //     { x: 216.906474820144, y: 2.58823529411765, size: 1 },
    //     { x: 217.553956834532, y: 2.94117647058824, size: 1 },
    //     { x: 249.280575539568, y: 3.2156862745098, size: 1 },
    //     { x: 292.661870503597, y: 3.25490196078431, size: 1 },
    //     { x: 303.669064748201, y: 3.2156862745098, size: 1 },
    //     { x: 307.553956834532, y: 3.2156862745098, size: 1 },
    //     { x: 309.496402877698, y: 2.98039215686275, size: 1 },
    //     { x: 315.323741007194, y: 3.01960784313725, size: 1 },
    //     { x: 328.273381294964, y: 4.03921568627451, size: 1 },
    //     { x: 346.402877697842, y: 3.01960784313725, size: 1 },
    //     { x: 347.697841726619, y: 3.01960784313725, size: 1 },
    //     { x: 29.7841726618705, y: 3.05882352941176, size: 1 },
    //     { x: 54.3884892086331, y: 4.15686274509804, size: 1 },
    //     { x: 69.9280575539568, y: 4, size: 1 },
    //     { x: 72.5179856115108, y: 2.74509803921569, size: 1 },
    //     { x: 73.1654676258993, y: 2.94117647058824, size: 1 },
    //     { x: 73.8129496402878, y: 2.74509803921569, size: 1 },
    //     { x: 78.3453237410072, y: 4.07843137254902, size: 1 },
    //     { x: 95.1798561151079, y: 2.90196078431373, size: 1 },
    //     { x: 115.89928057554, y: 2.43137254901961, size: 1 },
    //     { x: 116.546762589928, y: 2.82352941176471, size: 1 },
    //     { x: 117.841726618705, y: 2.90196078431373, size: 1 },
    //     { x: 266.762589928058, y: 2.86274509803922, size: 1 },
    //     { x: 267.410071942446, y: 2.66666666666667, size: 1 },
    //     { x: 268.057553956835, y: 2.54901960784314, size: 1 },
    //     { x: 268.705035971223, y: 2.82352941176471, size: 1 },
    //     { x: 330.215827338129, y: 3.25490196078431, size: 1 },
    //     { x: 332.158273381295, y: 2.86274509803922, size: 1 },
    //     { x: 354.172661870504, y: 3.13725490196078, size: 1 },
    //     { x: 354.820143884892, y: 3.09803921568627, size: 1 },
    //     { x: 13.6216216216216, y: 3.41176470588235, size: 1 },
    //     { x: 18.8108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 31.7837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 48.6486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 58.3783783783784, y: 2.74509803921569, size: 1 },
    //     { x: 59.027027027027, y: 2.74509803921569, size: 1 },
    //     { x: 59.6756756756757, y: 2.66666666666667, size: 1 },
    //     { x: 60.3243243243243, y: 2.7843137254902, size: 1 },
    //     { x: 76.5405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 78.4864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 79.7837837837838, y: 2.94117647058824, size: 1 },
    //     { x: 80.4324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 83.6756756756757, y: 4.07843137254902, size: 1 },
    //     { x: 85.6216216216216, y: 3.88235294117647, size: 1 },
    //     { x: 88.8648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 90.8108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 98.5945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 99.2432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 101.837837837838, y: 2.90196078431373, size: 1 },
    //     { x: 144.648648648649, y: 2.7843137254902, size: 1 },
    //     { x: 145.297297297297, y: 2.70588235294118, size: 1 },
    //     { x: 145.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 147.891891891892, y: 4.15686274509804, size: 1 },
    //     { x: 175.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 180.972972972973, y: 4.15686274509804, size: 1 },
    //     { x: 188.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 191.351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 197.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 206.27027027027, y: 4.23529411764706, size: 1 },
    //     { x: 213.405405405405, y: 4.11764705882353, size: 1 },
    //     { x: 216.648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 217.297297297297, y: 4, size: 1 },
    //     { x: 226.378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 228.324324324324, y: 4, size: 1 },
    //     { x: 230.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 230.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 231.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 232.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 232.864864864865, y: 2.74509803921569, size: 1 },
    //     { x: 239.351351351351, y: 4, size: 1 },
    //     { x: 245.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 249.72972972973, y: 4, size: 1 },
    //     { x: 263.351351351351, y: 3.88235294117647, size: 1 },
    //     { x: 310.054054054054, y: 3.84313725490196, size: 1 },
    //     { x: 317.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 317.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 319.135135135135, y: 2.74509803921569, size: 1 },
    //     { x: 319.783783783784, y: 2.58823529411765, size: 1 },
    //     { x: 326.918918918919, y: 4, size: 1 },
    //     { x: 332.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 334.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 335.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 338.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 339.243243243243, y: 3.01960784313725, size: 1 },
    //     { x: 340.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 341.189189189189, y: 2.82352941176471, size: 1 },
    //     { x: 1.94244604316547, y: 3.25490196078431, size: 1 },
    //     { x: 3.23741007194245, y: 3.2156862745098, size: 1 },
    //     { x: 17.4820143884892, y: 3.2156862745098, size: 1 },
    //     { x: 24.6043165467626, y: 2.86274509803922, size: 1 },
    //     { x: 44.0287769784173, y: 2.82352941176471, size: 1 },
    //     { x: 44.6762589928058, y: 2.58823529411765, size: 1 },
    //     { x: 45.3237410071942, y: 3.05882352941176, size: 1 },
    //     { x: 66.6906474820144, y: 2.86274509803922, size: 1 },
    //     { x: 108.776978417266, y: 3.01960784313725, size: 1 },
    //     { x: 109.424460431655, y: 3.05882352941176, size: 1 },
    //     { x: 216.906474820144, y: 3.13725490196078, size: 1 },
    //     { x: 258.345323741007, y: 3.09803921568627, size: 1 },
    //     { x: 259.640287769784, y: 2.07843137254902, size: 1 },
    //     { x: 260.287769784173, y: 1.76470588235294, size: 1 },
    //     { x: 260.935251798561, y: 2.74509803921569, size: 1 },
    //     { x: 261.58273381295, y: 2.54901960784314, size: 1 },
    //     { x: 269.352517985611, y: 2.86274509803922, size: 1 },
    //     { x: 276.474820143885, y: 3.17647058823529, size: 1 },
    //     { x: 303.021582733813, y: 2, size: 1 },
    //     { x: 303.669064748201, y: 2.03921568627451, size: 1 },
    //     { x: 324.388489208633, y: 2.62745098039216, size: 1 },
    //     { x: 325.035971223022, y: 2.50980392156863, size: 1 },
    //     { x: 344.460431654676, y: 3.13725490196078, size: 1 },
    //     { x: 345.107913669065, y: 3.09803921568627, size: 1 },
    //     { x: 345.755395683453, y: 2.94117647058824, size: 1 },
    //     { x: 346.402877697842, y: 1.92156862745098, size: 1 },
    //     { x: 7.76978417266187, y: 3.13725490196078, size: 1 },
    //     { x: 29.136690647482, y: 2.94117647058824, size: 1 },
    //     { x: 29.7841726618705, y: 2.98039215686275, size: 1 },
    //     { x: 51.1510791366906, y: 2.54901960784314, size: 1 },
    //     { x: 67.3381294964029, y: 4.19607843137255, size: 1 },
    //     { x: 71.8705035971223, y: 3.09803921568627, size: 1 },
    //     { x: 73.1654676258993, y: 2.90196078431373, size: 1 },
    //     { x: 82.2302158273381, y: 4.15686274509804, size: 1 },
    //     { x: 93.8848920863309, y: 3.25490196078431, size: 1 },
    //     { x: 94.5323741007194, y: 2.35294117647059, size: 1 },
    //     { x: 122.374100719424, y: 3.96078431372549, size: 1 },
    //     { x: 123.669064748201, y: 3.96078431372549, size: 1 },
    //     { x: 135.971223021583, y: 3.13725490196078, size: 1 },
    //     { x: 136.618705035971, y: 2.98039215686275, size: 1 },
    //     { x: 158.63309352518, y: 2.54901960784314, size: 1 },
    //     { x: 161.870503597122, y: 3.25490196078431, size: 1 },
    //     { x: 288.129496402878, y: 2.98039215686275, size: 1 },
    //     { x: 288.776978417266, y: 2.82352941176471, size: 1 },
    //     { x: 297.841726618705, y: 4, size: 1 },
    //     { x: 312.086330935252, y: 2.7843137254902, size: 1 },
    //     { x: 331.510791366906, y: 3.05882352941176, size: 1 },
    //     { x: 332.158273381295, y: 2.7843137254902, size: 1 },
    //     { x: 332.805755395683, y: 2.98039215686275, size: 1 },
    //     { x: 333.453237410072, y: 2.98039215686275, size: 1 },
    //     { x: 343.812949640288, y: 4, size: 1 },
    //     { x: 352.230215827338, y: 3.05882352941176, size: 1 },
    //     { x: 352.877697841727, y: 2.94117647058824, size: 1 },
    //     { x: 354.172661870504, y: 2.58823529411765, size: 1 },
    //     { x: 354.820143884892, y: 2.31372549019608, size: 1 },
    //     { x: 1.2972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 2.59459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 6.48648648648649, y: 3.88235294117647, size: 1 },
    //     { x: 11.027027027027, y: 4.19607843137255, size: 1 },
    //     { x: 14.2702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 15.5675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 29.8378378378378, y: 3.84313725490196, size: 1 },
    //     { x: 57.7297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 60.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 72.6486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 74.5945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 90.1621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 102.486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 103.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 123.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 140.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 142.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 143.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 144, y: 3.05882352941176, size: 1 },
    //     { x: 144.648648648649, y: 2.50980392156863, size: 1 },
    //     { x: 145.297297297297, y: 2.74509803921569, size: 1 },
    //     { x: 145.945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 146.594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 164.756756756757, y: 3.45098039215686, size: 1 },
    //     { x: 168.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 169.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 172.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 173.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 173.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 177.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 177.72972972973, y: 3.01960784313725, size: 1 },
    //     { x: 182.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 183.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 185.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 231.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 232.216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 244.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 252.972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 253.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 272.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 275.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 275.675675675676, y: 2.66666666666667, size: 1 },
    //     { x: 276.324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 294.486486486487, y: 3.37254901960784, size: 1 },
    //     { x: 295.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 296.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 317.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 317.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 318.486486486487, y: 2.82352941176471, size: 1 },
    //     { x: 319.135135135135, y: 2.70588235294118, size: 1 },
    //     { x: 319.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 337.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 339.243243243243, y: 2.86274509803922, size: 1 },
    //     { x: 339.891891891892, y: 2.7843137254902, size: 1 },
    //     { x: 340.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 22.0143884892086, y: 3.05882352941176, size: 1 },
    //     { x: 22.6618705035971, y: 2.7843137254902, size: 1 },
    //     { x: 23.3093525179856, y: 2.3921568627451, size: 1 },
    //     { x: 23.9568345323741, y: 2.47058823529412, size: 1 },
    //     { x: 24.6043165467626, y: 3.13725490196078, size: 1 },
    //     { x: 77.0503597122302, y: 3.25490196078431, size: 1 },
    //     { x: 89.3525179856115, y: 3.17647058823529, size: 1 },
    //     { x: 90, y: 3.05882352941176, size: 1 },
    //     { x: 101.007194244604, y: 3.25490196078431, size: 1 },
    //     { x: 103.597122302158, y: 3.25490196078431, size: 1 },
    //     { x: 110.071942446043, y: 2.94117647058824, size: 1 },
    //     { x: 130.791366906475, y: 2.98039215686275, size: 1 },
    //     { x: 152.158273381295, y: 3.13725490196078, size: 1 },
    //     { x: 234.388489208633, y: 4.07843137254902, size: 1 },
    //     { x: 260.935251798561, y: 3.17647058823529, size: 1 },
    //     { x: 270.647482014389, y: 3.25490196078431, size: 1 },
    //     { x: 325.035971223022, y: 3.01960784313725, size: 1 },
    //     { x: 326.330935251799, y: 3.09803921568627, size: 1 },
    //     { x: 336.690647482014, y: 4.03921568627451, size: 1 },
    //     { x: 352.877697841727, y: 3.09803921568627, size: 1 },
    //     { x: 356.762589928058, y: 3.13725490196078, size: 1 },
    //     { x: 7.76978417266187, y: 3.17647058823529, size: 1 },
    //     { x: 72.5179856115108, y: 2.35294117647059, size: 1 },
    //     { x: 73.8129496402878, y: 2.86274509803922, size: 1 },
    //     { x: 74.4604316546763, y: 2.74509803921569, size: 1 },
    //     { x: 94.5323741007194, y: 2.90196078431373, size: 1 },
    //     { x: 95.8273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 159.280575539568, y: 3.05882352941176, size: 1 },
    //     { x: 162.517985611511, y: 3.09803921568627, size: 1 },
    //     { x: 166.402877697842, y: 3.13725490196078, size: 1 },
    //     { x: 173.525179856115, y: 3.2156862745098, size: 1 },
    //     { x: 175.467625899281, y: 3.2156862745098, size: 1 },
    //     { x: 176.115107913669, y: 3.17647058823529, size: 1 },
    //     { x: 201.36690647482, y: 3.05882352941176, size: 1 },
    //     { x: 202.014388489209, y: 2.62745098039216, size: 1 },
    //     { x: 202.661870503597, y: 2.58823529411765, size: 1 },
    //     { x: 203.309352517986, y: 2.90196078431373, size: 1 },
    //     { x: 227.913669064748, y: 3.96078431372549, size: 1 },
    //     { x: 231.151079136691, y: 4, size: 1 },
    //     { x: 234.388489208633, y: 4.23529411764706, size: 1 },
    //     { x: 245.395683453237, y: 2.74509803921569, size: 1 },
    //     { x: 246.690647482014, y: 3.13725490196078, size: 1 },
    //     { x: 14.8920863309353, y: 2.90196078431373, size: 1 },
    //     { x: 15.5395683453237, y: 2.94117647058824, size: 1 },
    //     { x: 16.1870503597122, y: 2.62745098039216, size: 1 },
    //     { x: 36.2589928057554, y: 2.82352941176471, size: 1 },
    //     { x: 38.2014388489209, y: 2.86274509803922, size: 1 },
    //     { x: 44.0287769784173, y: 4, size: 1 },
    //     { x: 145.68345323741, y: 3.01960784313725, size: 1 },
    //     { x: 166.402877697842, y: 2.7843137254902, size: 1 },
    //     { x: 167.05035971223, y: 2.7843137254902, size: 1 },
    //     { x: 167.697841726619, y: 2.86274509803922, size: 1 },
    //     { x: 188.41726618705, y: 4.03921568627451, size: 1 },
    //     { x: 192.302158273381, y: 3.96078431372549, size: 1 },
    //     { x: 201.36690647482, y: 4.07843137254902, size: 1 },
    //     { x: 203.309352517986, y: 4.07843137254902, size: 1 },
    //     { x: 205.89928057554, y: 4, size: 1 },
    //     { x: 209.136690647482, y: 2.98039215686275, size: 1 },
    //     { x: 216.906474820144, y: 3.96078431372549, size: 1 },
    //     { x: 217.553956834532, y: 4.15686274509804, size: 1 },
    //     { x: 227.26618705036, y: 3.96078431372549, size: 1 },
    //     { x: 229.856115107914, y: 3.2156862745098, size: 1 },
    //     { x: 230.503597122302, y: 2.98039215686275, size: 1 },
    //     { x: 245.395683453237, y: 4.23529411764706, size: 1 },
    //     { x: 251.870503597122, y: 2.82352941176471, size: 1 },
    //     { x: 252.517985611511, y: 2.86274509803922, size: 1 },
    //     { x: 273.237410071942, y: 2.98039215686275, size: 1 },
    //     { x: 273.884892086331, y: 2.70588235294118, size: 1 },
    //     { x: 323.093525179856, y: 3.96078431372549, size: 1 },
    //     { x: 329.568345323741, y: 4.11764705882353, size: 1 },
    //     { x: 337.985611510791, y: 2.90196078431373, size: 1 },
    //     { x: 21.4054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 22.0540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 26.5945945945946, y: 4.15686274509804, size: 1 },
    //     { x: 30.4864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 33.0810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 37.6216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 38.9189189189189, y: 4, size: 1 },
    //     { x: 40.2162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 42.1621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 42.8108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 43.4594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 48.6486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 58.3783783783784, y: 3.80392156862745, size: 1 },
    //     { x: 59.6756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 64.2162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 64.8648648648649, y: 2.7843137254902, size: 1 },
    //     { x: 73.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 86.2702702702703, y: 2.62745098039216, size: 1 },
    //     { x: 86.9189189189189, y: 2.3921568627451, size: 1 },
    //     { x: 94.7027027027027, y: 4, size: 1 },
    //     { x: 106.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 107.675675675676, y: 2.07843137254902, size: 1 },
    //     { x: 108.324324324324, y: 2.19607843137255, size: 1 },
    //     { x: 110.27027027027, y: 4.27450980392157, size: 1 },
    //     { x: 111.567567567568, y: 4.15686274509804, size: 1 },
    //     { x: 112.864864864865, y: 4.07843137254902, size: 1 },
    //     { x: 114.810810810811, y: 4.11764705882353, size: 1 },
    //     { x: 115.459459459459, y: 4.15686274509804, size: 1 },
    //     { x: 116.108108108108, y: 4.27450980392157, size: 1 },
    //     { x: 116.756756756757, y: 4.15686274509804, size: 1 },
    //     { x: 118.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 119.351351351351, y: 4.19607843137255, size: 1 },
    //     { x: 120, y: 4.23529411764706, size: 1 },
    //     { x: 121.297297297297, y: 4.27450980392157, size: 1 },
    //     { x: 121.945945945946, y: 4.35294117647059, size: 1 },
    //     { x: 124.540540540541, y: 4.23529411764706, size: 1 },
    //     { x: 125.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 125.837837837838, y: 4, size: 1 },
    //     { x: 126.486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 132.972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 148.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 150.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 152.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 153.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 154.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 172.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 190.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 196.540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 200.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 201.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 203.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 203.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 208.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 211.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 216, y: 2.86274509803922, size: 1 },
    //     { x: 216.648648648649, y: 2.94117647058824, size: 1 },
    //     { x: 253.621621621622, y: 3.84313725490196, size: 1 },
    //     { x: 281.513513513513, y: 3.33333333333333, size: 1 },
    //     { x: 282.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 298.378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 302.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 302.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 321.081081081081, y: 4, size: 1 },
    //     { x: 324.324324324324, y: 2.90196078431373, size: 1 },
    //     { x: 324.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 325.621621621622, y: 2.90196078431373, size: 1 },
    //     { x: 326.27027027027, y: 2.58823529411765, size: 1 },
    //     { x: 327.567567567568, y: 4, size: 1 },
    //     { x: 347.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 347.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 24.6043165467626, y: 4.07843137254902, size: 1 },
    //     { x: 29.136690647482, y: 3.09803921568627, size: 1 },
    //     { x: 30.431654676259, y: 3.09803921568627, size: 1 },
    //     { x: 31.0791366906475, y: 3.05882352941176, size: 1 },
    //     { x: 80.2877697841727, y: 4.15686274509804, size: 1 },
    //     { x: 94.5323741007194, y: 3.05882352941176, size: 1 },
    //     { x: 115.251798561151, y: 3.09803921568627, size: 1 },
    //     { x: 154.10071942446, y: 4.03921568627451, size: 1 },
    //     { x: 183.884892086331, y: 4, size: 1 },
    //     { x: 216.906474820144, y: 4.11764705882353, size: 1 },
    //     { x: 229.856115107914, y: 4.11764705882353, size: 1 },
    //     { x: 235.035971223022, y: 3.96078431372549, size: 1 },
    //     { x: 236.330935251799, y: 4, size: 1 },
    //     { x: 237.625899280576, y: 4.19607843137255, size: 1 },
    //     { x: 240.863309352518, y: 4.11764705882353, size: 1 },
    //     { x: 266.115107913669, y: 3.09803921568627, size: 1 },
    //     { x: 266.762589928058, y: 3.05882352941176, size: 1 },
    //     { x: 267.410071942446, y: 3.01960784313725, size: 1 },
    //     { x: 268.705035971223, y: 3.25490196078431, size: 1 },
    //     { x: 289.424460431655, y: 2.94117647058824, size: 1 },
    //     { x: 359.352517985611, y: 3.96078431372549, size: 1 },
    //     { x: 0, y: 4.11764705882353, size: 1 },
    //     { x: 1.29496402877698, y: 4.03921568627451, size: 1 },
    //     { x: 3.23741007194245, y: 3.96078431372549, size: 1 },
    //     { x: 13.5971223021583, y: 3.13725490196078, size: 1 },
    //     { x: 36.9064748201439, y: 3.01960784313725, size: 1 },
    //     { x: 123.669064748201, y: 3.05882352941176, size: 1 },
    //     { x: 174.820143884892, y: 4.03921568627451, size: 1 },
    //     { x: 178.057553956835, y: 3.96078431372549, size: 1 },
    //     { x: 178.705035971223, y: 4, size: 1 },
    //     { x: 230.503597122302, y: 3.09803921568627, size: 1 },
    //     { x: 231.798561151079, y: 3.05882352941176, size: 1 },
    //     { x: 260.287769784173, y: 3.92156862745098, size: 1 },
    //     { x: 295.89928057554, y: 3.09803921568627, size: 1 },
    //     { x: 353.525179856115, y: 4.07843137254902, size: 1 },
    //     { x: 354.820143884892, y: 4, size: 1 },
    //     { x: 21.3669064748201, y: 2.82352941176471, size: 1 },
    //     { x: 23.3093525179856, y: 2.50980392156863, size: 1 },
    //     { x: 108.129496402878, y: 3.01960784313725, size: 1 },
    //     { x: 108.776978417266, y: 2.86274509803922, size: 1 },
    //     { x: 109.424460431655, y: 2.74509803921569, size: 1 },
    //     { x: 135.971223021583, y: 4.11764705882353, size: 1 },
    //     { x: 156.043165467626, y: 4.19607843137255, size: 1 },
    //     { x: 215.611510791367, y: 2.98039215686275, size: 1 },
    //     { x: 303.669064748201, y: 2.90196078431373, size: 1 },
    //     { x: 324.388489208633, y: 3.05882352941176, size: 1 },
    //     { x: 345.107913669065, y: 2.98039215686275, size: 1 },
    //     { x: 346.402877697842, y: 2.82352941176471, size: 1 },
    //     { x: 19.4594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 23.3513513513514, y: 3.33333333333333, size: 1 },
    //     { x: 26.5945945945946, y: 3.45098039215686, size: 1 },
    //     { x: 35.6756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 50.5945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 51.2432432432432, y: 2.74509803921569, size: 1 },
    //     { x: 51.8918918918919, y: 2.70588235294118, size: 1 },
    //     { x: 53.1891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 62.9189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 80.4324324324324, y: 4.11764705882353, size: 1 },
    //     { x: 84.972972972973, y: 3.84313725490196, size: 1 },
    //     { x: 94.054054054054, y: 2.82352941176471, size: 1 },
    //     { x: 94.7027027027027, y: 2.66666666666667, size: 1 },
    //     { x: 96.6486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 103.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 114.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 114.810810810811, y: 1.84313725490196, size: 1 },
    //     { x: 115.459459459459, y: 2.50980392156863, size: 1 },
    //     { x: 116.108108108108, y: 2.66666666666667, size: 1 },
    //     { x: 116.756756756757, y: 2.62745098039216, size: 1 },
    //     { x: 119.351351351351, y: 2.82352941176471, size: 1 },
    //     { x: 120, y: 3.13725490196078, size: 1 },
    //     { x: 123.891891891892, y: 2.98039215686275, size: 1 },
    //     { x: 124.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 129.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 130.378378378378, y: 2.86274509803922, size: 1 },
    //     { x: 131.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 131.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 132.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 148.540540540541, y: 4.07843137254902, size: 1 },
    //     { x: 172.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 179.675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 194.594594594595, y: 3.80392156862745, size: 1 },
    //     { x: 201.081081081081, y: 2.74509803921569, size: 1 },
    //     { x: 201.72972972973, y: 2.94117647058824, size: 1 },
    //     { x: 206.918918918919, y: 4, size: 1 },
    //     { x: 212.756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 214.054054054054, y: 4.19607843137255, size: 1 },
    //     { x: 220.540540540541, y: 3.88235294117647, size: 1 },
    //     { x: 244.540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 252.324324324324, y: 4.15686274509804, size: 1 },
    //     { x: 252.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 254.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 261.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 263.351351351351, y: 3.80392156862745, size: 1 },
    //     { x: 267.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 271.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 274.378378378378, y: 3.37254901960784, size: 1 },
    //     { x: 277.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 279.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 282.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 283.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 287.351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 288, y: 2.7843137254902, size: 1 },
    //     { x: 304.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 309.405405405405, y: 2.66666666666667, size: 1 },
    //     { x: 312, y: 4.03921568627451, size: 1 },
    //     { x: 313.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 319.783783783784, y: 4.07843137254902, size: 1 },
    //     { x: 323.027027027027, y: 3.84313725490196, size: 1 },
    //     { x: 323.675675675676, y: 4.03921568627451, size: 1 },
    //     { x: 330.810810810811, y: 3.01960784313725, size: 1 },
    //     { x: 331.459459459459, y: 2.86274509803922, size: 1 },
    //     { x: 342.486486486487, y: 3.25490196078431, size: 1 },
    //     { x: 343.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 348.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 352.216216216216, y: 2.74509803921569, size: 1 },
    //     { x: 358.702702702703, y: 3.92156862745098, size: 1 },
    //     { x: 14.2446043165468, y: 2, size: 1 },
    //     { x: 34.9640287769784, y: 3.13725490196078, size: 1 },
    //     { x: 35.6115107913669, y: 2.15686274509804, size: 1 },
    //     { x: 36.2589928057554, y: 2.58823529411765, size: 1 },
    //     { x: 39.4964028776978, y: 4.07843137254902, size: 1 },
    //     { x: 41.4388489208633, y: 4.31372549019608, size: 1 },
    //     { x: 53.0935251798561, y: 4, size: 1 },
    //     { x: 54.3884892086331, y: 4.03921568627451, size: 1 },
    //     { x: 75.7553956834532, y: 4.23529411764706, size: 1 },
    //     { x: 144.388489208633, y: 2.86274509803922, size: 1 },
    //     { x: 166.402877697842, y: 3.96078431372549, size: 1 },
    //     { x: 168.345323741007, y: 4.03921568627451, size: 1 },
    //     { x: 229.856115107914, y: 2.70588235294118, size: 1 },
    //     { x: 231.151079136691, y: 2.70588235294118, size: 1 },
    //     { x: 231.798561151079, y: 2.58823529411765, size: 1 },
    //     { x: 246.690647482014, y: 4, size: 1 },
    //     { x: 251.870503597122, y: 3.05882352941176, size: 1 },
    //     { x: 266.762589928058, y: 4, size: 1 },
    //     { x: 337.985611510791, y: 3.05882352941176, size: 1 },
    //     { x: 338.63309352518, y: 3.01960784313725, size: 1 },
    //     { x: 359.352517985611, y: 3.17647058823529, size: 1 },
    //     { x: 55.6834532374101, y: 4.07843137254902, size: 1 },
    //     { x: 67.3381294964029, y: 4, size: 1 },
    //     { x: 150.215827338129, y: 4, size: 1 },
    //     { x: 193.597122302158, y: 2.98039215686275, size: 1 },
    //     { x: 209.784172661871, y: 4.15686274509804, size: 1 },
    //     { x: 214.964028776978, y: 2.94117647058824, size: 1 },
    //     { x: 268.057553956835, y: 4.07843137254902, size: 1 },
    //     { x: 291.36690647482, y: 4, size: 1 },
    //     { x: 302.374100719424, y: 3.01960784313725, size: 1 },
    //     { x: 303.021582733813, y: 3.17647058823529, size: 1 },
    //     { x: 323.093525179856, y: 2.86274509803922, size: 1 },
    //     { x: 324.388489208633, y: 2.86274509803922, size: 1 },
    //     { x: 9.08108108108108, y: 4.15686274509804, size: 1 },
    //     { x: 9.72972972972973, y: 4.11764705882353, size: 1 },
    //     { x: 15.5675675675676, y: 4, size: 1 },
    //     { x: 16.2162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 17.5135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 19.4594594594595, y: 4.07843137254902, size: 1 },
    //     { x: 24.6486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 38.2702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 45.4054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 50.5945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 51.2432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 51.8918918918919, y: 3.41176470588235, size: 1 },
    //     { x: 72, y: 3.17647058823529, size: 1 },
    //     { x: 79.7837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 92.7567567567568, y: 2.70588235294118, size: 1 },
    //     { x: 93.4054054054054, y: 2.66666666666667, size: 1 },
    //     { x: 94.054054054054, y: 2.62745098039216, size: 1 },
    //     { x: 94.7027027027027, y: 2.82352941176471, size: 1 },
    //     { x: 160.864864864865, y: 3.64705882352941, size: 1 },
    //     { x: 168.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 188.108108108108, y: 4, size: 1 },
    //     { x: 193.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 195.243243243243, y: 3.80392156862745, size: 1 },
    //     { x: 201.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 210.810810810811, y: 4.19607843137255, size: 1 },
    //     { x: 214.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 221.189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 222.486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 223.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 224.432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 228.972972972973, y: 4, size: 1 },
    //     { x: 267.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 271.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 276.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 289.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 291.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 308.756756756757, y: 2.94117647058824, size: 1 },
    //     { x: 309.405405405405, y: 2.62745098039216, size: 1 },
    //     { x: 313.297297297297, y: 4.07843137254902, size: 1 },
    //     { x: 317.189189189189, y: 4, size: 1 },
    //     { x: 320.432432432432, y: 4, size: 1 },
    //     { x: 321.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 321.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 330.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 331.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 332.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 356.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 11.0071942446043, y: 4.11764705882353, size: 1 },
    //     { x: 14.8920863309353, y: 2.98039215686275, size: 1 },
    //     { x: 35.6115107913669, y: 2.86274509803922, size: 1 },
    //     { x: 55.6834532374101, y: 4.03921568627451, size: 1 },
    //     { x: 64.1007194244604, y: 4.03921568627451, size: 1 },
    //     { x: 143.093525179856, y: 3.09803921568627, size: 1 },
    //     { x: 187.122302158273, y: 2.70588235294118, size: 1 },
    //     { x: 208.489208633094, y: 3.01960784313725, size: 1 },
    //     { x: 295.251798561151, y: 3.09803921568627, size: 1 },
    //     { x: 324.388489208633, y: 4.03921568627451, size: 1 },
    //     { x: 341.223021582734, y: 4.11764705882353, size: 1 },
    //     { x: 42.0863309352518, y: 2.23529411764706, size: 1 },
    //     { x: 42.7338129496403, y: 1.92156862745098, size: 1 },
    //     { x: 43.3812949640288, y: 2.47058823529412, size: 1 },
    //     { x: 44.0287769784173, y: 2.98039215686275, size: 1 },
    //     { x: 64.7482014388489, y: 4.07843137254902, size: 1 },
    //     { x: 66.6906474820144, y: 4.11764705882353, size: 1 },
    //     { x: 85.4676258992806, y: 3.01960784313725, size: 1 },
    //     { x: 86.1151079136691, y: 3.05882352941176, size: 1 },
    //     { x: 128.201438848921, y: 2.98039215686275, size: 1 },
    //     { x: 128.848920863309, y: 2.62745098039216, size: 1 },
    //     { x: 150.215827338129, y: 2.98039215686275, size: 1 },
    //     { x: 150.863309352518, y: 3.05882352941176, size: 1 },
    //     { x: 193.597122302158, y: 2.86274509803922, size: 1 },
    //     { x: 209.784172661871, y: 4.19607843137255, size: 1 },
    //     { x: 214.964028776978, y: 2.31372549019608, size: 1 },
    //     { x: 215.611510791367, y: 2.35294117647059, size: 1 },
    //     { x: 236.978417266187, y: 3.09803921568627, size: 1 },
    //     { x: 240.215827338129, y: 3.17647058823529, size: 1 },
    //     { x: 248.63309352518, y: 3.05882352941176, size: 1 },
    //     { x: 258.345323741007, y: 2.66666666666667, size: 1 },
    //     { x: 279.712230215827, y: 2.3921568627451, size: 1 },
    //     { x: 280.359712230216, y: 2.58823529411765, size: 1 },
    //     { x: 300.431654676259, y: 3.29411764705882, size: 1 },
    //     { x: 301.079136690647, y: 2.3921568627451, size: 1 },
    //     { x: 301.726618705036, y: 2.3921568627451, size: 1 },
    //     { x: 339.280575539568, y: 4, size: 1 },
    //     { x: 178.705035971223, y: 2.50980392156863, size: 1 },
    //     { x: 179.352517985612, y: 2.90196078431373, size: 1 },
    //     { x: 180.647482014388, y: 2.62745098039216, size: 1 },
    //     { x: 244.10071942446, y: 2.86274509803922, size: 1 },
    //     { x: 264.820143884892, y: 3.09803921568627, size: 1 },
    //     { x: 266.115107913669, y: 3.01960784313725, size: 1 },
    //     { x: 286.834532374101, y: 3.05882352941176, size: 1 },
    //     { x: 287.482014388489, y: 2.90196078431373, size: 1 },
    //     { x: 288.129496402878, y: 2.94117647058824, size: 1 },
    //     { x: 310.143884892086, y: 2.90196078431373, size: 1 },
    //     { x: 329.568345323741, y: 2.98039215686275, size: 1 },
    //     { x: 330.215827338129, y: 2.86274509803922, size: 1 },
    //     { x: 4.54054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 12.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 13.6216216216216, y: 2.74509803921569, size: 1 },
    //     { x: 14.9189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 32.4324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 34.3783783783784, y: 2.58823529411765, size: 1 },
    //     { x: 35.027027027027, y: 2.70588235294118, size: 1 },
    //     { x: 46.0540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 53.8378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 56.4324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 57.0810810810811, y: 3.05882352941176, size: 1 },
    //     { x: 57.7297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 58.3783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 77.8378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 78.4864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 121.297297297297, y: 3.37254901960784, size: 1 },
    //     { x: 123.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 126.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 127.135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 128.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 129.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 131.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 132.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 133.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 134.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 134.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 135.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 138.810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 139.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 142.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 144.648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 153.72972972973, y: 4.11764705882353, size: 1 },
    //     { x: 208.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 230.918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 251.027027027027, y: 2.62745098039216, size: 1 },
    //     { x: 251.675675675676, y: 2.70588235294118, size: 1 },
    //     { x: 252.972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 273.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 296.432432432432, y: 4.03921568627451, size: 1 },
    //     { x: 302.918918918919, y: 3.80392156862745, size: 1 },
    //     { x: 306.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 310.702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 316.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 320.432432432432, y: 4.07843137254902, size: 1 },
    //     { x: 326.27027027027, y: 4.07843137254902, size: 1 },
    //     { x: 331.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 335.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 339.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 358.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 359.351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 42.7338129496403, y: 2.82352941176471, size: 1 },
    //     { x: 86.1151079136691, y: 3.01960784313725, size: 1 },
    //     { x: 132.086330935252, y: 3.96078431372549, size: 1 },
    //     { x: 145.68345323741, y: 4.11764705882353, size: 1 },
    //     { x: 171.58273381295, y: 2.90196078431373, size: 1 },
    //     { x: 173.525179856115, y: 2.98039215686275, size: 1 },
    //     { x: 194.892086330935, y: 3.01960784313725, size: 1 },
    //     { x: 257.697841726619, y: 2.58823529411765, size: 1 },
    //     { x: 258.345323741007, y: 2.3921568627451, size: 1 },
    //     { x: 258.992805755396, y: 2.58823529411765, size: 1 },
    //     { x: 259.640287769784, y: 2.74509803921569, size: 1 },
    //     { x: 301.079136690647, y: 3.09803921568627, size: 1 },
    //     { x: 301.726618705036, y: 3.33333333333333, size: 1 },
    //     { x: 317.913669064748, y: 4.11764705882353, size: 1 },
    //     { x: 323.741007194245, y: 2.86274509803922, size: 1 },
    //     { x: 324.388489208633, y: 2.74509803921569, size: 1 },
    //     { x: 49.8561151079137, y: 2.98039215686275, size: 1 },
    //     { x: 51.1510791366906, y: 2.86274509803922, size: 1 },
    //     { x: 70.5755395683453, y: 2.3921568627451, size: 1 },
    //     { x: 71.2230215827338, y: 2.19607843137255, size: 1 },
    //     { x: 71.8705035971223, y: 2.3921568627451, size: 1 },
    //     { x: 72.5179856115108, y: 2.50980392156863, size: 1 },
    //     { x: 104.244604316547, y: 4.07843137254902, size: 1 },
    //     { x: 128.201438848921, y: 3.96078431372549, size: 1 },
    //     { x: 178.705035971223, y: 2.74509803921569, size: 1 },
    //     { x: 179.352517985612, y: 2.62745098039216, size: 1 },
    //     { x: 180, y: 2.66666666666667, size: 1 },
    //     { x: 180.647482014388, y: 2.3921568627451, size: 1 },
    //     { x: 200.071942446043, y: 2.82352941176471, size: 1 },
    //     { x: 213.021582733813, y: 4.03921568627451, size: 1 },
    //     { x: 329.568345323741, y: 2.15686274509804, size: 1 },
    //     { x: 330.215827338129, y: 2.11764705882353, size: 1 },
    //     { x: 330.863309352518, y: 2.50980392156863, size: 1 },
    //     { x: 331.510791366906, y: 2.7843137254902, size: 1 },
    //     { x: 334.10071942446, y: 3.09803921568627, size: 1 },
    //     { x: 338.63309352518, y: 2.90196078431373, size: 1 },
    //     { x: 345.755395683453, y: 3.01960784313725, size: 1 },
    //     { x: 348.345323741007, y: 3.25490196078431, size: 1 },
    //     { x: 34.3783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 35.027027027027, y: 2.7843137254902, size: 1 },
    //     { x: 55.1351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 55.7837837837838, y: 2.82352941176471, size: 1 },
    //     { x: 56.4324324324324, y: 2.82352941176471, size: 1 },
    //     { x: 77.8378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 86.2702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 90.8108108108108, y: 3.45098039215686, size: 1 },
    //     { x: 99.2432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 120.648648648649, y: 2.86274509803922, size: 1 },
    //     { x: 121.297297297297, y: 2.47058823529412, size: 1 },
    //     { x: 164.108108108108, y: 2.7843137254902, size: 1 },
    //     { x: 164.756756756757, y: 2.62745098039216, size: 1 },
    //     { x: 185.513513513514, y: 2.66666666666667, size: 1 },
    //     { x: 186.162162162162, y: 2.86274509803922, size: 1 },
    //     { x: 191.351351351351, y: 3.37254901960784, size: 1 },
    //     { x: 202.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 206.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 207.567567567568, y: 2.62745098039216, size: 1 },
    //     { x: 228.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 228.972972972973, y: 2.3921568627451, size: 1 },
    //     { x: 229.621621621622, y: 2.47058823529412, size: 1 },
    //     { x: 243.243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 251.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 297.081081081081, y: 4, size: 1 },
    //     { x: 299.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 301.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 302.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 336, y: 3.2156862745098, size: 1 },
    //     { x: 337.297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 338.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 339.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 349.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 354.810810810811, y: 3.41176470588235, size: 1 },
    //     { x: 358.702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 5.8273381294964, y: 3.05882352941176, size: 1 },
    //     { x: 47.2661870503597, y: 4.03921568627451, size: 1 },
    //     { x: 85.4676258992806, y: 3.09803921568627, size: 1 },
    //     { x: 106.834532374101, y: 2.86274509803922, size: 1 },
    //     { x: 128.848920863309, y: 3.01960784313725, size: 1 },
    //     { x: 130.143884892086, y: 2.98039215686275, size: 1 },
    //     { x: 157.985611510791, y: 4.07843137254902, size: 1 },
    //     { x: 167.697841726619, y: 3.96078431372549, size: 1 },
    //     { x: 192.94964028777, y: 3.01960784313725, size: 1 },
    //     { x: 193.597122302158, y: 2.82352941176471, size: 1 },
    //     { x: 215.611510791367, y: 3.05882352941176, size: 1 },
    //     { x: 238.920863309353, y: 4.15686274509804, size: 1 },
    //     { x: 246.043165467626, y: 4.11764705882353, size: 1 },
    //     { x: 258.345323741007, y: 2.90196078431373, size: 1 },
    //     { x: 280.359712230216, y: 3.17647058823529, size: 1 },
    //     { x: 3.88489208633094, y: 3.17647058823529, size: 1 },
    //     { x: 6.47482014388489, y: 2.90196078431373, size: 1 },
    //     { x: 7.12230215827338, y: 2.98039215686275, size: 1 },
    //     { x: 7.76978417266187, y: 3.01960784313725, size: 1 },
    //     { x: 91.9424460431655, y: 2.58823529411765, size: 1 },
    //     { x: 92.589928057554, y: 2.58823529411765, size: 1 },
    //     { x: 93.2374100719424, y: 2.66666666666667, size: 1 },
    //     { x: 93.8848920863309, y: 2.35294117647059, size: 1 },
    //     { x: 159.928057553957, y: 4.03921568627451, size: 1 },
    //     { x: 167.05035971223, y: 4.11764705882353, size: 1 },
    //     { x: 178.057553956835, y: 2.90196078431373, size: 1 },
    //     { x: 178.705035971223, y: 3.01960784313725, size: 1 },
    //     { x: 201.36690647482, y: 2.86274509803922, size: 1 },
    //     { x: 224.676258992806, y: 4.23529411764706, size: 1 },
    //     { x: 236.978417266187, y: 4.07843137254902, size: 1 },
    //     { x: 240.215827338129, y: 4.11764705882353, size: 1 },
    //     { x: 285.539568345324, y: 3.2156862745098, size: 1 },
    //     { x: 286.187050359712, y: 2.62745098039216, size: 1 },
    //     { x: 286.834532374101, y: 2.54901960784314, size: 1 },
    //     { x: 287.482014388489, y: 2.07843137254902, size: 1 },
    //     { x: 288.129496402878, y: 2.19607843137255, size: 1 },
    //     { x: 330.863309352518, y: 3.96078431372549, size: 1 },
    //     { x: 345.755395683453, y: 4, size: 1 },
    //     { x: 9.08108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 11.6756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 36.3243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 37.6216216216216, y: 4, size: 1 },
    //     { x: 47.3513513513514, y: 3.84313725490196, size: 1 },
    //     { x: 48, y: 3.96078431372549, size: 1 },
    //     { x: 56.4324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 97.2972972972973, y: 4, size: 1 },
    //     { x: 127.783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 134.918918918919, y: 4.07843137254902, size: 1 },
    //     { x: 143.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 144, y: 3.2156862745098, size: 1 },
    //     { x: 165.405405405405, y: 2.94117647058824, size: 1 },
    //     { x: 166.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 169.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 186.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 186.810810810811, y: 2.62745098039216, size: 1 },
    //     { x: 187.459459459459, y: 2.74509803921569, size: 1 },
    //     { x: 206.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 208.864864864865, y: 2.82352941176471, size: 1 },
    //     { x: 249.72972972973, y: 3.29411764705882, size: 1 },
    //     { x: 250.378378378378, y: 2.15686274509804, size: 1 },
    //     { x: 251.675675675676, y: 2.50980392156863, size: 1 },
    //     { x: 252.324324324324, y: 2.23529411764706, size: 1 },
    //     { x: 271.135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 271.783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 272.432432432432, y: 2.98039215686275, size: 1 },
    //     { x: 276.324324324324, y: 4, size: 1 },
    //     { x: 297.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 300.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 301.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 307.459459459459, y: 4, size: 1 },
    //     { x: 308.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 310.054054054054, y: 4.11764705882353, size: 1 },
    //     { x: 315.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 337.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 338.594594594595, y: 2.94117647058824, size: 1 },
    //     { x: 347.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 349.621621621622, y: 4, size: 1 },
    //     { x: 356.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 356.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 357.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 358.702702702703, y: 2.58823529411765, size: 1 },
    //     { x: 20.0719424460432, y: 2.7843137254902, size: 1 },
    //     { x: 59.568345323741, y: 4.07843137254902, size: 1 },
    //     { x: 60.863309352518, y: 3.96078431372549, size: 1 },
    //     { x: 75.1079136690647, y: 4.11764705882353, size: 1 },
    //     { x: 85.4676258992806, y: 2.86274509803922, size: 1 },
    //     { x: 150.215827338129, y: 3.09803921568627, size: 1 },
    //     { x: 150.863309352518, y: 3.01960784313725, size: 1 },
    //     { x: 214.31654676259, y: 2.82352941176471, size: 1 },
    //     { x: 282.302158273381, y: 4.07843137254902, size: 1 },
    //     { x: 286.834532374101, y: 3.92156862745098, size: 1 },
    //     { x: 301.079136690647, y: 2.94117647058824, size: 1 },
    //     { x: 326.978417266187, y: 4.11764705882353, size: 1 },
    //     { x: 336.043165467626, y: 3.92156862745098, size: 1 },
    //     { x: 341.223021582734, y: 4.03921568627451, size: 1 },
    //     { x: 343.812949640288, y: 2.66666666666667, size: 1 },
    //     { x: 30.431654676259, y: 3.2156862745098, size: 1 },
    //     { x: 48.5611510791367, y: 2.11764705882353, size: 1 },
    //     { x: 49.2086330935252, y: 2.07843137254902, size: 1 },
    //     { x: 69.2805755395683, y: 3.13725490196078, size: 1 },
    //     { x: 69.9280575539568, y: 2.27450980392157, size: 1 },
    //     { x: 70.5755395683453, y: 1.68627450980392, size: 1 },
    //     { x: 91.9424460431655, y: 2.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 2.35294117647059, size: 1 },
    //     { x: 180, y: 4.07843137254902, size: 1 },
    //     { x: 202.014388489209, y: 4.27450980392157, size: 1 },
    //     { x: 205.89928057554, y: 4.11764705882353, size: 1 },
    //     { x: 206.546762589928, y: 4.11764705882353, size: 1 },
    //     { x: 209.784172661871, y: 4.03921568627451, size: 1 },
    //     { x: 214.964028776978, y: 4.11764705882353, size: 1 },
    //     { x: 217.553956834532, y: 4.07843137254902, size: 1 },
    //     { x: 230.503597122302, y: 4.07843137254902, size: 1 },
    //     { x: 251.223021582734, y: 4.11764705882353, size: 1 },
    //     { x: 253.165467625899, y: 4.11764705882353, size: 1 },
    //     { x: 256.402877697842, y: 4.07843137254902, size: 1 },
    //     { x: 274.532374100719, y: 3.96078431372549, size: 1 },
    //     { x: 275.827338129496, y: 4.07843137254902, size: 1 },
    //     { x: 303.669064748201, y: 3.17647058823529, size: 1 },
    //     { x: 319.208633093525, y: 4.19607843137255, size: 1 },
    //     { x: 328.920863309353, y: 2.98039215686275, size: 1 },
    //     { x: 339.280575539568, y: 4.27450980392157, size: 1 },
    //     { x: 356.762589928058, y: 4.07843137254902, size: 1 },
    //     { x: 358.057553956835, y: 4.11764705882353, size: 1 },
    //     { x: 2.59459459459459, y: 4.23529411764706, size: 1 },
    //     { x: 3.24324324324324, y: 3.88235294117647, size: 1 },
    //     { x: 3.89189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 5.83783783783784, y: 3.88235294117647, size: 1 },
    //     { x: 6.48648648648649, y: 3.84313725490196, size: 1 },
    //     { x: 7.78378378378378, y: 3.96078431372549, size: 1 },
    //     { x: 8.43243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 9.08108108108108, y: 4.23529411764706, size: 1 },
    //     { x: 12.3243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 19.4594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 20.7567567567568, y: 4, size: 1 },
    //     { x: 23.3513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 28.5405405405405, y: 4.07843137254902, size: 1 },
    //     { x: 33.7297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 34.3783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 49.9459459459459, y: 4, size: 1 },
    //     { x: 55.7837837837838, y: 2.90196078431373, size: 1 },
    //     { x: 56.4324324324324, y: 2.98039215686275, size: 1 },
    //     { x: 57.0810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 77.1891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 82.3783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 83.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 84.3243243243243, y: 4, size: 1 },
    //     { x: 85.6216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 88.2162162162162, y: 4, size: 1 },
    //     { x: 92.7567567567568, y: 3.88235294117647, size: 1 },
    //     { x: 93.4054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 94.7027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 95.3513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 97.2972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 97.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 105.081081081081, y: 4.03921568627451, size: 1 },
    //     { x: 110.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 111.567567567568, y: 4, size: 1 },
    //     { x: 120.648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 121.945945945946, y: 2.98039215686275, size: 1 },
    //     { x: 124.540540540541, y: 4.07843137254902, size: 1 },
    //     { x: 132.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 141.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 142.054054054054, y: 2.90196078431373, size: 1 },
    //     { x: 142.702702702703, y: 2.74509803921569, size: 1 },
    //     { x: 143.351351351351, y: 2.7843137254902, size: 1 },
    //     { x: 144, y: 3.09803921568627, size: 1 },
    //     { x: 147.243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 165.405405405405, y: 3.84313725490196, size: 1 },
    //     { x: 180.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 182.918918918919, y: 3.84313725490196, size: 1 },
    //     { x: 201.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 210.162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 220.540540540541, y: 4.15686274509804, size: 1 },
    //     { x: 228.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 251.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 260.108108108108, y: 4.11764705882353, size: 1 },
    //     { x: 270.486486486487, y: 3.17647058823529, size: 1 },
    //     { x: 271.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 271.783783783784, y: 2.74509803921569, size: 1 },
    //     { x: 272.432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 273.081081081081, y: 2.62745098039216, size: 1 },
    //     { x: 273.72972972973, y: 2.86274509803922, size: 1 },
    //     { x: 293.837837837838, y: 2.98039215686275, size: 1 },
    //     { x: 295.135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 295.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 299.027027027027, y: 3.37254901960784, size: 1 },
    //     { x: 300.324324324324, y: 3.13725490196078, size: 1 },
    //     { x: 300.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 304.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 306.162162162162, y: 3.29411764705882, size: 1 },
    //     { x: 307.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 310.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 329.513513513513, y: 4, size: 1 },
    //     { x: 332.756756756757, y: 4, size: 1 },
    //     { x: 355.459459459459, y: 4, size: 1 },
    //     { x: 62.8057553956835, y: 3.01960784313725, size: 1 },
    //     { x: 63.4532374100719, y: 2.94117647058824, size: 1 },
    //     { x: 106.187050359712, y: 3.13725490196078, size: 1 },
    //     { x: 128.201438848921, y: 2.94117647058824, size: 1 },
    //     { x: 160.575539568345, y: 4.07843137254902, size: 1 },
    //     { x: 200.719424460432, y: 4.03921568627451, size: 1 },
    //     { x: 255.755395683453, y: 3.13725490196078, size: 1 },
    //     { x: 257.05035971223, y: 2.98039215686275, size: 1 },
    //     { x: 321.798561151079, y: 2.82352941176471, size: 1 },
    //     { x: 322.446043165468, y: 2.90196078431373, size: 1 },
    //     { x: 323.093525179856, y: 2.82352941176471, size: 1 },
    //     { x: 323.741007194245, y: 2.90196078431373, size: 1 },
    //     { x: 332.158273381295, y: 4, size: 1 },
    //     { x: 69.9280575539568, y: 2.7843137254902, size: 1 },
    //     { x: 70.5755395683453, y: 2.58823529411765, size: 1 },
    //     { x: 97.1223021582734, y: 3.37254901960784, size: 1 },
    //     { x: 118.489208633094, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 3.17647058823529, size: 1 },
    //     { x: 224.028776978417, y: 2.94117647058824, size: 1 },
    //     { x: 235.035971223022, y: 3.13725490196078, size: 1 },
    //     { x: 242.158273381295, y: 3.01960784313725, size: 1 },
    //     { x: 242.805755395683, y: 2.98039215686275, size: 1 },
    //     { x: 253.812949640288, y: 3.09803921568627, size: 1 },
    //     { x: 256.402877697842, y: 3.09803921568627, size: 1 },
    //     { x: 260.287769784173, y: 3.17647058823529, size: 1 },
    //     { x: 287.482014388489, y: 4.07843137254902, size: 1 },
    //     { x: 307.553956834532, y: 3.05882352941176, size: 1 },
    //     { x: 33.6690647482014, y: 2.86274509803922, size: 1 },
    //     { x: 93.8848920863309, y: 4.03921568627451, size: 1 },
    //     { x: 120.431654676259, y: 2.7843137254902, size: 1 },
    //     { x: 152.805755395683, y: 3.17647058823529, size: 1 },
    //     { x: 184.532374100719, y: 2.07843137254902, size: 1 },
    //     { x: 185.179856115108, y: 1.33333333333333, size: 1 },
    //     { x: 185.827338129496, y: 1.68627450980392, size: 1 },
    //     { x: 186.474820143885, y: 1.05882352941176, size: 1 },
    //     { x: 187.122302158273, y: 2.54901960784314, size: 1 },
    //     { x: 189.712230215827, y: 2.82352941176471, size: 1 },
    //     { x: 194.244604316547, y: 2.90196078431373, size: 1 },
    //     { x: 202.014388489209, y: 3.05882352941176, size: 1 },
    //     { x: 203.956834532374, y: 3.05882352941176, size: 1 },
    //     { x: 205.251798561151, y: 3.09803921568627, size: 1 },
    //     { x: 205.89928057554, y: 2.94117647058824, size: 1 },
    //     { x: 206.546762589928, y: 2.03921568627451, size: 1 },
    //     { x: 207.194244604317, y: 1.88235294117647, size: 1 },
    //     { x: 207.841726618705, y: 1.76470588235294, size: 1 },
    //     { x: 208.489208633094, y: 1.88235294117647, size: 1 },
    //     { x: 228.561151079137, y: 3.09803921568627, size: 1 },
    //     { x: 249.280575539568, y: 2.82352941176471, size: 1 },
    //     { x: 249.928057553957, y: 2.66666666666667, size: 1 },
    //     { x: 271.294964028777, y: 2.58823529411765, size: 1 },
    //     { x: 310.791366906475, y: 3.17647058823529, size: 1 },
    //     { x: 357.410071942446, y: 2.43137254901961, size: 1 },
    //     { x: 358.057553956835, y: 2.70588235294118, size: 1 },
    //     { x: 18.8108108108108, y: 2.94117647058824, size: 1 },
    //     { x: 19.4594594594595, y: 2.11764705882353, size: 1 },
    //     { x: 20.1081081081081, y: 2.86274509803922, size: 1 },
    //     { x: 20.7567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 23.3513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 25.9459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 26.5945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 29.8378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 35.6756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 36.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 38.2702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 39.5675675675676, y: 3.01960784313725, size: 1 },
    //     { x: 40.8648648648649, y: 2.70588235294118, size: 1 },
    //     { x: 61.6216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 62.2702702702703, y: 2.50980392156863, size: 1 },
    //     { x: 62.9189189189189, y: 2.58823529411765, size: 1 },
    //     { x: 83.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 83.6756756756757, y: 2.58823529411765, size: 1 },
    //     { x: 84.3243243243243, y: 1.37254901960784, size: 1 },
    //     { x: 98.5945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 131.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 133.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 141.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 142.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 144, y: 3.92156862745098, size: 1 },
    //     { x: 145.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 155.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 192, y: 3.13725490196078, size: 1 },
    //     { x: 192.648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 193.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 193.945945945946, y: 2.90196078431373, size: 1 },
    //     { x: 214.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 214.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 217.945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 233.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 234.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 235.459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 236.108108108108, y: 2.70588235294118, size: 1 },
    //     { x: 236.756756756757, y: 2.7843137254902, size: 1 },
    //     { x: 237.405405405405, y: 2.86274509803922, size: 1 },
    //     { x: 245.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 257.513513513513, y: 2.98039215686275, size: 1 },
    //     { x: 258.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 277.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 279.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 280.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 320.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 323.027027027027, y: 2.7843137254902, size: 1 },
    //     { x: 323.675675675676, y: 2.58823529411765, size: 1 },
    //     { x: 343.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 343.783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 344.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 345.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 351.567567567568, y: 4.11764705882353, size: 1 },
    //     { x: 5.17985611510791, y: 3.25490196078431, size: 1 },
    //     { x: 68.6330935251799, y: 3.17647058823529, size: 1 },
    //     { x: 69.9280575539568, y: 2.70588235294118, size: 1 },
    //     { x: 70.5755395683453, y: 2.50980392156863, size: 1 },
    //     { x: 71.2230215827338, y: 2.7843137254902, size: 1 },
    //     { x: 71.8705035971223, y: 2.66666666666667, size: 1 },
    //     { x: 91.294964028777, y: 2.90196078431373, size: 1 },
    //     { x: 91.9424460431655, y: 3.01960784313725, size: 1 },
    //     { x: 157.985611510791, y: 2.98039215686275, size: 1 },
    //     { x: 198.776978417266, y: 2.98039215686275, size: 1 },
    //     { x: 200.071942446043, y: 2.62745098039216, size: 1 },
    //     { x: 200.719424460432, y: 2.62745098039216, size: 1 },
    //     { x: 201.36690647482, y: 2.35294117647059, size: 1 },
    //     { x: 222.73381294964, y: 2.94117647058824, size: 1 },
    //     { x: 255.107913669065, y: 3.13725490196078, size: 1 },
    //     { x: 290.719424460432, y: 4.03921568627451, size: 1 },
    //     { x: 305.611510791367, y: 3.17647058823529, size: 1 },
    //     { x: 307.553956834532, y: 2.74509803921569, size: 1 },
    //     { x: 308.201438848921, y: 2.47058823529412, size: 1 },
    //     { x: 308.848920863309, y: 2.50980392156863, size: 1 },
    //     { x: 309.496402877698, y: 3.13725490196078, size: 1 },
    //     { x: 328.920863309353, y: 2.70588235294118, size: 1 },
    //     { x: 329.568345323741, y: 2.86274509803922, size: 1 },
    //     { x: 330.215827338129, y: 3.05882352941176, size: 1 },
    //     { x: 330.863309352518, y: 2.94117647058824, size: 1 },
    //     { x: 351.58273381295, y: 3.25490196078431, size: 1 },
    //     { x: 35.6115107913669, y: 2.90196078431373, size: 1 },
    //     { x: 121.079136690647, y: 2.90196078431373, size: 1 },
    //     { x: 141.151079136691, y: 2.82352941176471, size: 1 },
    //     { x: 142.446043165468, y: 2.86274509803922, size: 1 },
    //     { x: 143.093525179856, y: 2.90196078431373, size: 1 },
    //     { x: 162.517985611511, y: 3.05882352941176, size: 1 },
    //     { x: 163.165467625899, y: 2.35294117647059, size: 1 },
    //     { x: 164.460431654676, y: 2.35294117647059, size: 1 },
    //     { x: 228.561151079137, y: 2.86274509803922, size: 1 },
    //     { x: 229.208633093525, y: 2.58823529411765, size: 1 },
    //     { x: 229.856115107914, y: 2.94117647058824, size: 1 },
    //     { x: 249.928057553957, y: 2.58823529411765, size: 1 },
    //     { x: 250.575539568345, y: 2.74509803921569, size: 1 },
    //     { x: 251.223021582734, y: 2.43137254901961, size: 1 },
    //     { x: 271.294964028777, y: 3.13725490196078, size: 1 },
    //     { x: 20.1081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 20.7567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 83.6756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 84.3243243243243, y: 3.01960784313725, size: 1 },
    //     { x: 84.972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 105.081081081081, y: 3.09803921568627, size: 1 },
    //     { x: 106.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 129.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 157.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 170.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 171.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 171.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 172.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 190.702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 193.945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 213.405405405405, y: 2.62745098039216, size: 1 },
    //     { x: 214.054054054054, y: 2.74509803921569, size: 1 },
    //     { x: 214.702702702703, y: 2.98039215686275, size: 1 },
    //     { x: 215.351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 236.108108108108, y: 3.2156862745098, size: 1 },
    //     { x: 265.945945945946, y: 3.84313725490196, size: 1 },
    //     { x: 298.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 299.675675675676, y: 3.01960784313725, size: 1 },
    //     { x: 300.324324324324, y: 2.7843137254902, size: 1 },
    //     { x: 300.972972972973, y: 2.62745098039216, size: 1 },
    //     { x: 301.621621621622, y: 2.62745098039216, size: 1 },
    //     { x: 321.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 323.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 343.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 344.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 26.5467625899281, y: 2.62745098039216, size: 1 },
    //     { x: 27.841726618705, y: 2.31372549019608, size: 1 },
    //     { x: 28.4892086330935, y: 2.15686274509804, size: 1 },
    //     { x: 49.2086330935252, y: 4.07843137254902, size: 1 },
    //     { x: 57.6258992805755, y: 3.96078431372549, size: 1 },
    //     { x: 62.158273381295, y: 4.07843137254902, size: 1 },
    //     { x: 63.4532374100719, y: 4.07843137254902, size: 1 },
    //     { x: 64.7482014388489, y: 4.11764705882353, size: 1 },
    //     { x: 91.9424460431655, y: 2.86274509803922, size: 1 },
    //     { x: 92.589928057554, y: 2.70588235294118, size: 1 },
    //     { x: 93.2374100719424, y: 2.94117647058824, size: 1 },
    //     { x: 112.661870503597, y: 2.43137254901961, size: 1 },
    //     { x: 113.309352517986, y: 2.47058823529412, size: 1 },
    //     { x: 134.676258992806, y: 2.82352941176471, size: 1 },
    //     { x: 156.043165467626, y: 2.70588235294118, size: 1 },
    //     { x: 177.410071942446, y: 2.98039215686275, size: 1 },
    //     { x: 178.057553956835, y: 2.66666666666667, size: 1 },
    //     { x: 198.776978417266, y: 2.35294117647059, size: 1 },
    //     { x: 199.424460431655, y: 2.19607843137255, size: 1 },
    //     { x: 200.719424460432, y: 3.09803921568627, size: 1 },
    //     { x: 205.89928057554, y: 3.09803921568627, size: 1 },
    //     { x: 206.546762589928, y: 2.94117647058824, size: 1 },
    //     { x: 211.079136690647, y: 3.13725490196078, size: 1 },
    //     { x: 212.374100719424, y: 3.25490196078431, size: 1 },
    //     { x: 220.791366906475, y: 2.86274509803922, size: 1 },
    //     { x: 242.158273381295, y: 2, size: 1 },
    //     { x: 242.805755395683, y: 1.88235294117647, size: 1 },
    //     { x: 263.525179856115, y: 2.90196078431373, size: 1 },
    //     { x: 264.172661870504, y: 2.54901960784314, size: 1 },
    //     { x: 306.906474820144, y: 1.72549019607843, size: 1 },
    //     { x: 307.553956834532, y: 2.11764705882353, size: 1 },
    //     { x: 328.273381294964, y: 2.3921568627451, size: 1 },
    //     { x: 328.920863309353, y: 2.07843137254902, size: 1 },
    //     { x: 350.287769784173, y: 2.47058823529412, size: 1 },
    //     { x: 163.165467625899, y: 3.13725490196078, size: 1 },
    //     { x: 207.194244604317, y: 2.90196078431373, size: 1 },
    //     { x: 207.841726618705, y: 3.01960784313725, size: 1 },
    //     { x: 336.690647482014, y: 3.01960784313725, size: 1 },
    //     { x: 337.338129496403, y: 2.70588235294118, size: 1 },
    //     { x: 357.410071942446, y: 2.74509803921569, size: 1 },
    //     { x: 17.4820143884892, y: 3.17647058823529, size: 1 },
    //     { x: 83.5251798561151, y: 3.13725490196078, size: 1 },
    //     { x: 104.892086330935, y: 2.90196078431373, size: 1 },
    //     { x: 113.956834532374, y: 3.25490196078431, size: 1 },
    //     { x: 126.258992805755, y: 2.43137254901961, size: 1 },
    //     { x: 126.906474820144, y: 2.62745098039216, size: 1 },
    //     { x: 127.553956834532, y: 2.54901960784314, size: 1 },
    //     { x: 128.201438848921, y: 2.43137254901961, size: 1 },
    //     { x: 171.58273381295, y: 3.01960784313725, size: 1 },
    //     { x: 191.654676258993, y: 2.90196078431373, size: 1 },
    //     { x: 192.302158273381, y: 2.62745098039216, size: 1 },
    //     { x: 192.94964028777, y: 2.74509803921569, size: 1 },
    //     { x: 213.021582733813, y: 2.70588235294118, size: 1 },
    //     { x: 234.388489208633, y: 2.94117647058824, size: 1 },
    //     { x: 235.035971223022, y: 2.7843137254902, size: 1 },
    //     { x: 255.107913669065, y: 3.17647058823529, size: 1 },
    //     { x: 258.345323741007, y: 3.01960784313725, size: 1 },
    //     { x: 279.064748201439, y: 2.7843137254902, size: 1 },
    //     { x: 340.575539568345, y: 3.09803921568627, size: 1 },
    //     { x: 342.517985611511, y: 2.31372549019608, size: 1 },
    //     { x: 343.165467625899, y: 2.35294117647059, size: 1 },
    //     { x: 343.812949640288, y: 2.23529411764706, size: 1 },
    //     { x: 344.460431654676, y: 2.15686274509804, size: 1 },
    //     { x: 3.89189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 4.54054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 5.83783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 8.43243243243243, y: 3.29411764705882, size: 1 },
    //     { x: 9.08108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 10.3783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 16.8648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 25.9459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 27.2432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 27.8918918918919, y: 2.82352941176471, size: 1 },
    //     { x: 37.6216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 44.1081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 47.3513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 48.6486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 60.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 81.7297297297297, y: 3.33333333333333, size: 1 },
    //     { x: 90.1621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 92.1081081081081, y: 2.94117647058824, size: 1 },
    //     { x: 110.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 112.216216216216, y: 2.35294117647059, size: 1 },
    //     { x: 112.864864864865, y: 2.62745098039216, size: 1 },
    //     { x: 113.513513513514, y: 2.58823529411765, size: 1 },
    //     { x: 114.162162162162, y: 2.66666666666667, size: 1 },
    //     { x: 120.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 133.621621621622, y: 3.05882352941176, size: 1 },
    //     { x: 134.27027027027, y: 2.94117647058824, size: 1 },
    //     { x: 134.918918918919, y: 2.94117647058824, size: 1 },
    //     { x: 219.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 220.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 229.621621621622, y: 3.41176470588235, size: 1 },
    //     { x: 233.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 241.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 285.405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 288, y: 3.37254901960784, size: 1 },
    //     { x: 302.27027027027, y: 3.09803921568627, size: 1 },
    //     { x: 306.810810810811, y: 2.82352941176471, size: 1 },
    //     { x: 308.108108108108, y: 2.82352941176471, size: 1 },
    //     { x: 308.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 326.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 326.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 328.216216216216, y: 2.90196078431373, size: 1 },
    //     { x: 328.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 329.513513513513, y: 2.90196078431373, size: 1 },
    //     { x: 348.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 350.27027027027, y: 3.09803921568627, size: 1 },
    //     { x: 12.9496402877698, y: 3.13725490196078, size: 1 },
    //     { x: 33.0215827338129, y: 3.01960784313725, size: 1 },
    //     { x: 33.6690647482014, y: 3.13725490196078, size: 1 },
    //     { x: 34.3165467625899, y: 2.94117647058824, size: 1 },
    //     { x: 44.0287769784173, y: 3.13725490196078, size: 1 },
    //     { x: 46.6187050359712, y: 2.98039215686275, size: 1 },
    //     { x: 54.3884892086331, y: 2.90196078431373, size: 1 },
    //     { x: 55.0359712230216, y: 2.62745098039216, size: 1 },
    //     { x: 55.6834532374101, y: 3.05882352941176, size: 1 },
    //     { x: 60.863309352518, y: 3.17647058823529, size: 1 },
    //     { x: 75.1079136690647, y: 2.98039215686275, size: 1 },
    //     { x: 76.4028776978417, y: 3.01960784313725, size: 1 },
    //     { x: 77.0503597122302, y: 2.82352941176471, size: 1 },
    //     { x: 142.446043165468, y: 2.94117647058824, size: 1 },
    //     { x: 163.165467625899, y: 3.2156862745098, size: 1 },
    //     { x: 194.892086330935, y: 3.2156862745098, size: 1 },
    //     { x: 207.841726618705, y: 2.98039215686275, size: 1 },
    //     { x: 271.942446043165, y: 2.98039215686275, size: 1 },
    //     { x: 314.676258992806, y: 2.98039215686275, size: 1 },
    //     { x: 315.323741007194, y: 2.98039215686275, size: 1 },
    //     { x: 40.1438848920863, y: 2.15686274509804, size: 1 },
    //     { x: 40.7913669064748, y: 2.50980392156863, size: 1 },
    //     { x: 42.0863309352518, y: 2.47058823529412, size: 1 },
    //     { x: 45.3237410071942, y: 3.01960784313725, size: 1 },
    //     { x: 49.2086330935252, y: 2.74509803921569, size: 1 },
    //     { x: 55.6834532374101, y: 2.70588235294118, size: 1 },
    //     { x: 56.9784172661871, y: 3.01960784313725, size: 1 },
    //     { x: 61.5107913669065, y: 2.15686274509804, size: 1 },
    //     { x: 62.158273381295, y: 2.03921568627451, size: 1 },
    //     { x: 82.8776978417266, y: 3.13725490196078, size: 1 },
    //     { x: 83.5251798561151, y: 2.98039215686275, size: 1 },
    //     { x: 117.841726618705, y: 4.03921568627451, size: 1 },
    //     { x: 125.611510791367, y: 3.13725490196078, size: 1 },
    //     { x: 126.258992805755, y: 2.7843137254902, size: 1 },
    //     { x: 169.640287769784, y: 2.15686274509804, size: 1 },
    //     { x: 170.287769784173, y: 2.94117647058824, size: 1 },
    //     { x: 191.007194244604, y: 2.86274509803922, size: 1 },
    //     { x: 212.374100719424, y: 2.58823529411765, size: 1 },
    //     { x: 213.021582733813, y: 2.3921568627451, size: 1 },
    //     { x: 229.856115107914, y: 3.17647058823529, size: 1 },
    //     { x: 233.093525179856, y: 2.98039215686275, size: 1 },
    //     { x: 234.388489208633, y: 2.3921568627451, size: 1 },
    //     { x: 255.107913669065, y: 2.86274509803922, size: 1 },
    //     { x: 255.755395683453, y: 2, size: 1 },
    //     { x: 256.402877697842, y: 1.96078431372549, size: 1 },
    //     { x: 277.122302158273, y: 2.7843137254902, size: 1 },
    //     { x: 277.769784172662, y: 2.86274509803922, size: 1 },
    //     { x: 297.841726618705, y: 2.94117647058824, size: 1 },
    //     { x: 299.136690647482, y: 2.03921568627451, size: 1 },
    //     { x: 47.3513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 68.7567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 70.7027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 72.6486486486486, y: 3.41176470588235, size: 1 },
    //     { x: 111.567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 112.216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 113.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 131.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 135.567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 145.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 155.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 155.675675675676, y: 2.94117647058824, size: 1 },
    //     { x: 156.324324324324, y: 2.82352941176471, size: 1 },
    //     { x: 156.972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 175.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 196.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 197.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 198.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 199.135135135135, y: 2.82352941176471, size: 1 },
    //     { x: 199.783783783784, y: 2.82352941176471, size: 1 },
    //     { x: 200.432432432432, y: 2.54901960784314, size: 1 },
    //     { x: 202.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 211.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 221.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 233.513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 262.702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 263.351351351351, y: 2.7843137254902, size: 1 },
    //     { x: 264, y: 2.82352941176471, size: 1 },
    //     { x: 264.648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 265.297297297297, y: 2.86274509803922, size: 1 },
    //     { x: 283.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 284.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 284.756756756757, y: 2.70588235294118, size: 1 },
    //     { x: 286.054054054054, y: 2.7843137254902, size: 1 },
    //     { x: 290.594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 21.3669064748201, y: 4.07843137254902, size: 1 },
    //     { x: 33.0215827338129, y: 2.58823529411765, size: 1 },
    //     { x: 33.6690647482014, y: 2.62745098039216, size: 1 },
    //     { x: 34.9640287769784, y: 2.94117647058824, size: 1 },
    //     { x: 54.3884892086331, y: 2.7843137254902, size: 1 },
    //     { x: 55.0359712230216, y: 2.66666666666667, size: 1 },
    //     { x: 55.6834532374101, y: 2.74509803921569, size: 1 },
    //     { x: 56.3309352517986, y: 2.70588235294118, size: 1 },
    //     { x: 76.4028776978417, y: 3.17647058823529, size: 1 },
    //     { x: 77.0503597122302, y: 3.13725490196078, size: 1 },
    //     { x: 97.7697841726619, y: 2.90196078431373, size: 1 },
    //     { x: 151.510791366906, y: 3.17647058823529, size: 1 },
    //     { x: 183.884892086331, y: 2.82352941176471, size: 1 },
    //     { x: 205.251798561151, y: 3.01960784313725, size: 1 },
    //     { x: 205.89928057554, y: 2.66666666666667, size: 1 },
    //     { x: 206.546762589928, y: 2.82352941176471, size: 1 },
    //     { x: 207.194244604317, y: 2.58823529411765, size: 1 },
    //     { x: 227.26618705036, y: 2.82352941176471, size: 1 },
    //     { x: 227.913669064748, y: 2.86274509803922, size: 1 },
    //     { x: 229.208633093525, y: 2.74509803921569, size: 1 },
    //     { x: 248.63309352518, y: 2.27450980392157, size: 1 },
    //     { x: 249.280575539568, y: 2.31372549019608, size: 1 },
    //     { x: 314.028776978417, y: 3.01960784313725, size: 1 },
    //     { x: 19.4244604316547, y: 3.01960784313725, size: 1 },
    //     { x: 34.9640287769784, y: 4.03921568627451, size: 1 },
    //     { x: 39.4964028776978, y: 2.47058823529412, size: 1 },
    //     { x: 40.1438848920863, y: 2.07843137254902, size: 1 },
    //     { x: 40.7913669064748, y: 2.54901960784314, size: 1 },
    //     { x: 41.4388489208633, y: 2.58823529411765, size: 1 },
    //     { x: 104.892086330935, y: 2.7843137254902, size: 1 },
    //     { x: 126.258992805755, y: 2.86274509803922, size: 1 },
    //     { x: 126.906474820144, y: 3.09803921568627, size: 1 },
    //     { x: 127.553956834532, y: 2.66666666666667, size: 1 },
    //     { x: 205.251798561151, y: 4.11764705882353, size: 1 },
    //     { x: 213.021582733813, y: 2.82352941176471, size: 1 },
    //     { x: 213.669064748201, y: 2.82352941176471, size: 1 },
    //     { x: 214.964028776978, y: 3.13725490196078, size: 1 },
    //     { x: 345.107913669065, y: 4.11764705882353, size: 1 },
    //     { x: 1.94594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 2.59459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 3.24324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 11.6756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 16.8648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 19.4594594594595, y: 3.84313725490196, size: 1 },
    //     { x: 24.6486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 25.2972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 25.9459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 26.5945945945946, y: 2.66666666666667, size: 1 },
    //     { x: 27.2432432432432, y: 2.7843137254902, size: 1 },
    //     { x: 46.7027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 70.7027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 88.2162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 89.5135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 90.1621621621622, y: 3.29411764705882, size: 1 },
    //     { x: 90.8108108108108, y: 2.7843137254902, size: 1 },
    //     { x: 91.4594594594595, y: 2.50980392156863, size: 1 },
    //     { x: 92.1081081081081, y: 2.54901960784314, size: 1 },
    //     { x: 110.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 111.567567567568, y: 2.62745098039216, size: 1 },
    //     { x: 112.216216216216, y: 2.62745098039216, size: 1 },
    //     { x: 118.054054054054, y: 3.41176470588235, size: 1 },
    //     { x: 136.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 171.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 197.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 197.837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 198.486486486486, y: 2.94117647058824, size: 1 },
    //     { x: 218.594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 219.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 241.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 241.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 247.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 262.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 306.810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 323.027027027027, y: 3.49019607843137, size: 1 },
    //     { x: 326.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 327.567567567568, y: 2.98039215686275, size: 1 },
    //     { x: 328.216216216216, y: 2.86274509803922, size: 1 },
    //     { x: 346.378378378378, y: 3.80392156862745, size: 1 },
    //     { x: 11.0071942446043, y: 2.82352941176471, size: 1 },
    //     { x: 32.3741007194245, y: 2.74509803921569, size: 1 },
    //     { x: 33.0215827338129, y: 2.70588235294118, size: 1 },
    //     { x: 95.8273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 97.1223021582734, y: 2.54901960784314, size: 1 },
    //     { x: 97.7697841726619, y: 2.70588235294118, size: 1 },
    //     { x: 117.194244604317, y: 3.13725490196078, size: 1 },
    //     { x: 119.136690647482, y: 1.92156862745098, size: 1 },
    //     { x: 139.856115107914, y: 3.09803921568627, size: 1 },
    //     { x: 140.503597122302, y: 2.31372549019608, size: 1 },
    //     { x: 141.151079136691, y: 2.54901960784314, size: 1 },
    //     { x: 183.237410071942, y: 2.86274509803922, size: 1 },
    //     { x: 183.884892086331, y: 2.50980392156863, size: 1 },
    //     { x: 226.618705035971, y: 2.66666666666667, size: 1 },
    //     { x: 227.26618705036, y: 1.64705882352941, size: 1 },
    //     { x: 261.58273381295, y: 4.07843137254902, size: 1 },
    //     { x: 263.525179856115, y: 4.07843137254902, size: 1 },
    //     { x: 12.9496402877698, y: 4.07843137254902, size: 1 },
    //     { x: 40.1438848920863, y: 2.70588235294118, size: 1 },
    //     { x: 60.863309352518, y: 3.01960784313725, size: 1 },
    //     { x: 212.374100719424, y: 2.66666666666667, size: 1 },
    //     { x: 213.021582733813, y: 2.50980392156863, size: 1 },
    //     { x: 213.669064748201, y: 2.58823529411765, size: 1 },
    //     { x: 214.31654676259, y: 2.66666666666667, size: 1 },
    //     { x: 298.489208633094, y: 2.94117647058824, size: 1 },
    //     { x: 299.136690647482, y: 2.94117647058824, size: 1 },
    //     { x: 320.503597122302, y: 2.03921568627451, size: 1 },
    //     { x: 321.151079136691, y: 2.23529411764706, size: 1 },
    //     { x: 321.798561151079, y: 2.35294117647059, size: 1 },
    //     { x: 336.690647482014, y: 4.07843137254902, size: 1 },
    //     { x: 25.2517985611511, y: 3.13725490196078, size: 1 },
    //     { x: 30.431654676259, y: 4.11764705882353, size: 1 },
    //     { x: 42.0863309352518, y: 4, size: 1 },
    //     { x: 68.6330935251799, y: 2.86274509803922, size: 1 },
    //     { x: 91.9424460431655, y: 4.11764705882353, size: 1 },
    //     { x: 127.553956834532, y: 4.03921568627451, size: 1 },
    //     { x: 243.453237410072, y: 4, size: 1 },
    //     { x: 262.230215827338, y: 2.98039215686275, size: 1 },
    //     { x: 262.877697841727, y: 2.98039215686275, size: 1 },
    //     { x: 263.525179856115, y: 2.86274509803922, size: 1 },
    //     { x: 264.172661870504, y: 2.58823529411765, size: 1 },
    //     { x: 285.539568345324, y: 2.82352941176471, size: 1 },
    //     { x: 332.158273381295, y: 4.07843137254902, size: 1 },
    //     { x: 342.517985611511, y: 3.96078431372549, size: 1 },
    //     { x: 352.230215827338, y: 4.11764705882353, size: 1 },
    //     { x: 12.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 14.2702702702703, y: 4, size: 1 },
    //     { x: 21.4054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 36.972972972973, y: 4, size: 1 },
    //     { x: 76.5405405405405, y: 2.62745098039216, size: 1 },
    //     { x: 77.1891891891892, y: 2.7843137254902, size: 1 },
    //     { x: 91.4594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 106.378378378378, y: 3.41176470588235, size: 1 },
    //     { x: 113.513513513514, y: 3.41176470588235, size: 1 },
    //     { x: 121.297297297297, y: 3.96078431372549, size: 1 },
    //     { x: 142.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 142.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 145.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 151.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 153.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 154.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 155.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 158.918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 163.459459459459, y: 2.90196078431373, size: 1 },
    //     { x: 164.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 167.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 168, y: 3.09803921568627, size: 1 },
    //     { x: 168.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 174.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 175.135135135135, y: 3.29411764705882, size: 1 },
    //     { x: 175.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 176.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 178.378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 189.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 193.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 200.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 201.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 205.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 206.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 225.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 226.378378378378, y: 2.7843137254902, size: 1 },
    //     { x: 227.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 227.675675675676, y: 3.25490196078431, size: 1 },
    //     { x: 228.324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 256.216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 278.918918918919, y: 4, size: 1 },
    //     { x: 306.810810810811, y: 4.03921568627451, size: 1 },
    //     { x: 311.351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 313.297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 336, y: 2.54901960784314, size: 1 },
    //     { x: 345.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 356.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 61.5107913669065, y: 3.09803921568627, size: 1 },
    //     { x: 104.892086330935, y: 3.13725490196078, size: 1 },
    //     { x: 159.928057553957, y: 4.15686274509804, size: 1 },
    //     { x: 253.165467625899, y: 3.13725490196078, size: 1 },
    //     { x: 255.107913669065, y: 1.6078431372549, size: 1 },
    //     { x: 255.755395683453, y: 1.72549019607843, size: 1 },
    //     { x: 256.402877697842, y: 1.37254901960784, size: 1 },
    //     { x: 257.05035971223, y: 1.37254901960784, size: 1 },
    //     { x: 264.172661870504, y: 2.98039215686275, size: 1 },
    //     { x: 270.647482014389, y: 2.74509803921569, size: 1 },
    //     { x: 273.237410071942, y: 3.13725490196078, size: 1 },
    //     { x: 273.884892086331, y: 3.13725490196078, size: 1 },
    //     { x: 320.503597122302, y: 2.90196078431373, size: 1 },
    //     { x: 332.158273381295, y: 3.13725490196078, size: 1 },
    //     { x: 337.985611510791, y: 3.09803921568627, size: 1 },
    //     { x: 341.223021582734, y: 2.58823529411765, size: 1 },
    //     { x: 341.870503597122, y: 2.70588235294118, size: 1 },
    //     { x: 343.812949640288, y: 4.07843137254902, size: 1 },
    //     { x: 24.6043165467626, y: 2.31372549019608, size: 1 },
    //     { x: 45.9712230215827, y: 3.01960784313725, size: 1 },
    //     { x: 67.3381294964029, y: 3.05882352941176, size: 1 },
    //     { x: 67.9856115107914, y: 2.43137254901961, size: 1 },
    //     { x: 88.705035971223, y: 2.98039215686275, size: 1 },
    //     { x: 89.3525179856115, y: 2.19607843137255, size: 1 },
    //     { x: 90, y: 1.96078431372549, size: 1 },
    //     { x: 111.36690647482, y: 2.54901960784314, size: 1 },
    //     { x: 121.079136690647, y: 4.07843137254902, size: 1 },
    //     { x: 131.438848920863, y: 2.94117647058824, size: 1 },
    //     { x: 132.73381294964, y: 2.43137254901961, size: 1 },
    //     { x: 326.978417266187, y: 2.50980392156863, size: 1 },
    //     { x: 9.72972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 10.3783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 82.3783783783784, y: 4.03921568627451, size: 1 },
    //     { x: 84.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 101.189189189189, y: 4, size: 1 },
    //     { x: 118.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 119.351351351351, y: 4, size: 1 },
    //     { x: 136.864864864865, y: 4.07843137254902, size: 1 },
    //     { x: 137.513513513514, y: 4, size: 1 },
    //     { x: 160.864864864865, y: 3.25490196078431, size: 1 },
    //     { x: 161.513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 167.351351351351, y: 3.84313725490196, size: 1 },
    //     { x: 226.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 250.378378378378, y: 3.88235294117647, size: 1 },
    //     { x: 264, y: 3.92156862745098, size: 1 },
    //     { x: 266.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 269.837837837838, y: 2.94117647058824, size: 1 },
    //     { x: 291.243243243243, y: 2.7843137254902, size: 1 },
    //     { x: 292.540540540541, y: 2.35294117647059, size: 1 },
    //     { x: 293.189189189189, y: 2.58823529411765, size: 1 },
    //     { x: 300.324324324324, y: 3.80392156862745, size: 1 },
    //     { x: 313.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 334.054054054054, y: 2.70588235294118, size: 1 },
    //     { x: 334.702702702703, y: 2.82352941176471, size: 1 },
    //     { x: 347.027027027027, y: 3.41176470588235, size: 1 },
    //     { x: 356.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 36.2589928057554, y: 4.15686274509804, size: 1 },
    //     { x: 108.129496402878, y: 3.96078431372549, size: 1 },
    //     { x: 146.978417266187, y: 3.09803921568627, size: 1 },
    //     { x: 151.510791366906, y: 4.23529411764706, size: 1 },
    //     { x: 212.374100719424, y: 2.86274509803922, size: 1 },
    //     { x: 213.669064748201, y: 3.09803921568627, size: 1 },
    //     { x: 216.258992805755, y: 4, size: 1 },
    //     { x: 233.741007194245, y: 2.43137254901961, size: 1 },
    //     { x: 235.035971223022, y: 3.09803921568627, size: 1 },
    //     { x: 31.0791366906475, y: 3.2156862745098, size: 1 },
    //     { x: 47.2661870503597, y: 2.90196078431373, size: 1 },
    //     { x: 110.719424460432, y: 3.25490196078431, size: 1 },
    //     { x: 112.661870503597, y: 2.98039215686275, size: 1 },
    //     { x: 119.784172661871, y: 4.03921568627451, size: 1 },
    //     { x: 156.043165467626, y: 3.01960784313725, size: 1 },
    //     { x: 350.287769784173, y: 3.09803921568627, size: 1 },
    //     { x: 20.1081081081081, y: 3.88235294117647, size: 1 },
    //     { x: 52.5405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 53.1891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 123.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 182.27027027027, y: 2.90196078431373, size: 1 },
    //     { x: 182.918918918919, y: 2.11764705882353, size: 1 },
    //     { x: 186.162162162162, y: 4.07843137254902, size: 1 },
    //     { x: 190.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 195.891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 199.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 204.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 205.621621621622, y: 4.11764705882353, size: 1 },
    //     { x: 218.594594594595, y: 4, size: 1 },
    //     { x: 225.72972972973, y: 2.7843137254902, size: 1 },
    //     { x: 226.378378378378, y: 2.94117647058824, size: 1 },
    //     { x: 246.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 247.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 247.783783783784, y: 2.62745098039216, size: 1 },
    //     { x: 267.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 268.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 269.189189189189, y: 2.19607843137255, size: 1 },
    //     { x: 269.837837837838, y: 2.58823529411765, size: 1 },
    //     { x: 291.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 326.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 333.405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 334.054054054054, y: 2.03921568627451, size: 1 },
    //     { x: 334.702702702703, y: 2.23529411764706, size: 1 },
    //     { x: 338.594594594595, y: 4, size: 1 },
    //     { x: 355.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 16.8345323741007, y: 3.13725490196078, size: 1 },
    //     { x: 17.4820143884892, y: 2.66666666666667, size: 1 },
    //     { x: 38.2014388489209, y: 2.90196078431373, size: 1 },
    //     { x: 38.8489208633094, y: 2.15686274509804, size: 1 },
    //     { x: 39.4964028776978, y: 1.92156862745098, size: 1 },
    //     { x: 60.2158273381295, y: 2.86274509803922, size: 1 },
    //     { x: 60.863309352518, y: 2.50980392156863, size: 1 },
    //     { x: 97.1223021582734, y: 4.03921568627451, size: 1 },
    //     { x: 233.093525179856, y: 2.94117647058824, size: 1 },
    //     { x: 233.741007194245, y: 3.05882352941176, size: 1 },
    //     { x: 276.474820143885, y: 3.2156862745098, size: 1 },
    //     { x: 319.208633093525, y: 2.70588235294118, size: 1 },
    //     { x: 319.856115107914, y: 2.98039215686275, size: 1 },
    //     { x: 22.6618705035971, y: 4.03921568627451, size: 1 },
    //     { x: 161.223021582734, y: 3.25490196078431, size: 1 },
    //     { x: 240.215827338129, y: 3.09803921568627, size: 1 },
    //     { x: 267.410071942446, y: 3.17647058823529, size: 1 },
    //     { x: 325.035971223022, y: 4.03921568627451, size: 1 },
    //     { x: 11.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 28.5405405405405, y: 3.80392156862745, size: 1 },
    //     { x: 31.1351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 59.027027027027, y: 4.11764705882353, size: 1 },
    //     { x: 62.2702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 105.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 108.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 116.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 117.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 120, y: 3.96078431372549, size: 1 },
    //     { x: 126.486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 158.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 182.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 192.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 212.108108108108, y: 3.92156862745098, size: 1 },
    //     { x: 217.945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 219.891891891892, y: 4, size: 1 },
    //     { x: 225.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 226.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 247.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 269.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 283.459459459459, y: 4.11764705882353, size: 1 },
    //     { x: 303.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 304.864864864865, y: 3.33333333333333, size: 1 },
    //     { x: 310.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 337.297297297297, y: 4.07843137254902, size: 1 },
    //     { x: 341.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 357.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 12.9496402877698, y: 3.96078431372549, size: 1 },
    //     { x: 48.5611510791367, y: 4.03921568627451, size: 1 },
    //     { x: 297.841726618705, y: 3.01960784313725, size: 1 },
    //     { x: 303.021582733813, y: 4.03921568627451, size: 1 },
    //     { x: 340.575539568345, y: 3.13725490196078, size: 1 },
    //     { x: 341.223021582734, y: 2.74509803921569, size: 1 },
    //     { x: 351.58273381295, y: 4.03921568627451, size: 1 },
    //     { x: 23.9568345323741, y: 2.74509803921569, size: 1 },
    //     { x: 24.6043165467626, y: 2.82352941176471, size: 1 },
    //     { x: 66.6906474820144, y: 3.05882352941176, size: 1 },
    //     { x: 88.705035971223, y: 2.90196078431373, size: 1 },
    //     { x: 89.3525179856115, y: 2.90196078431373, size: 1 },
    //     { x: 110.719424460432, y: 1.56862745098039, size: 1 },
    //     { x: 111.36690647482, y: 1.52941176470588, size: 1 },
    //     { x: 112.014388489209, y: 1.49019607843137, size: 1 },
    //     { x: 112.661870503597, y: 2.66666666666667, size: 1 },
    //     { x: 131.438848920863, y: 2.98039215686275, size: 1 },
    //     { x: 132.086330935252, y: 2.54901960784314, size: 1 },
    //     { x: 153.453237410072, y: 2.86274509803922, size: 1 },
    //     { x: 154.10071942446, y: 2.47058823529412, size: 1 },
    //     { x: 174.820143884892, y: 2, size: 1 },
    //     { x: 175.467625899281, y: 1.80392156862745, size: 1 },
    //     { x: 218.848920863309, y: 3.01960784313725, size: 1 },
    //     { x: 246.690647482014, y: 4.23529411764706, size: 1 },
    //     { x: 247.985611510791, y: 4.19607843137255, size: 1 },
    //     { x: 261.58273381295, y: 4.11764705882353, size: 1 },
    //     { x: 273.237410071942, y: 4, size: 1 },
    //     { x: 279.712230215827, y: 4.07843137254902, size: 1 },
    //     { x: 347.697841726619, y: 2.43137254901961, size: 1 },
    //     { x: 1.94594594594595, y: 4, size: 1 },
    //     { x: 4.54054054054054, y: 4, size: 1 },
    //     { x: 22.7027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 40.2162162162162, y: 4.15686274509804, size: 1 },
    //     { x: 44.1081081081081, y: 4.07843137254902, size: 1 },
    //     { x: 44.7567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 46.0540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 46.7027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 59.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 79.1351351351351, y: 4, size: 1 },
    //     { x: 82.3783783783784, y: 3.84313725490196, size: 1 },
    //     { x: 92.1081081081081, y: 4, size: 1 },
    //     { x: 103.783783783784, y: 4, size: 1 },
    //     { x: 106.378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 139.459459459459, y: 2.94117647058824, size: 1 },
    //     { x: 150.486486486486, y: 4, size: 1 },
    //     { x: 182.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 182.918918918919, y: 2.7843137254902, size: 1 },
    //     { x: 192, y: 3.84313725490196, size: 1 },
    //     { x: 193.297297297297, y: 3.92156862745098, size: 1 },
    //     { x: 203.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 205.621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 206.27027027027, y: 3.72549019607843, size: 1 },
    //     { x: 208.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 210.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 212.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 223.135135135135, y: 3.92156862745098, size: 1 },
    //     { x: 226.378378378378, y: 4.11764705882353, size: 1 },
    //     { x: 241.297297297297, y: 4.15686274509804, size: 1 },
    //     { x: 247.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 247.783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 268.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 269.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 278.27027027027, y: 4, size: 1 },
    //     { x: 293.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 332.108108108108, y: 4, size: 1 },
    //     { x: 336.648648648649, y: 3.05882352941176, size: 1 },
    //     { x: 346.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 347.027027027027, y: 3.29411764705882, size: 1 },
    //     { x: 348.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 350.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 56.3309352517986, y: 4.11764705882353, size: 1 },
    //     { x: 82.8776978417266, y: 2.94117647058824, size: 1 },
    //     { x: 83.5251798561151, y: 2.74509803921569, size: 1 },
    //     { x: 85.4676258992806, y: 3.96078431372549, size: 1 },
    //     { x: 91.9424460431655, y: 4.07843137254902, size: 1 },
    //     { x: 103.597122302158, y: 3.01960784313725, size: 1 },
    //     { x: 104.892086330935, y: 2.66666666666667, size: 1 },
    //     { x: 196.834532374101, y: 3.17647058823529, size: 1 },
    //     { x: 214.964028776978, y: 4.07843137254902, size: 1 },
    //     { x: 254.460431654676, y: 2.47058823529412, size: 1 },
    //     { x: 255.107913669065, y: 2.62745098039216, size: 1 },
    //     { x: 308.848920863309, y: 3.13725490196078, size: 1 },
    //     { x: 59.568345323741, y: 4.11764705882353, size: 1 },
    //     { x: 90.6474820143885, y: 4.15686274509804, size: 1 },
    //     { x: 132.086330935252, y: 3.01960784313725, size: 1 },
    //     { x: 132.73381294964, y: 2.94117647058824, size: 1 },
    //     { x: 133.381294964029, y: 2.7843137254902, size: 1 },
    //     { x: 218.201438848921, y: 2.94117647058824, size: 1 },
    //     { x: 218.848920863309, y: 2.86274509803922, size: 1 },
    //     { x: 219.496402877698, y: 2.54901960784314, size: 1 },
    //     { x: 220.143884892086, y: 2.58823529411765, size: 1 },
    //     { x: 240.215827338129, y: 2.98039215686275, size: 1 },
    //     { x: 249.280575539568, y: 4.11764705882353, size: 1 },
    //     { x: 282.94964028777, y: 3.05882352941176, size: 1 },
    //     { x: 318.561151079137, y: 4.15686274509804, size: 1 },
    //     { x: 73.8129496402878, y: 3.01960784313725, size: 1 },
    //     { x: 74.4604316546763, y: 3.25490196078431, size: 1 },
    //     { x: 126.906474820144, y: 4.11764705882353, size: 1 },
    //     { x: 139.856115107914, y: 3.96078431372549, size: 1 },
    //     { x: 224.676258992806, y: 2.82352941176471, size: 1 },
    //     { x: 244.748201438849, y: 3.13725490196078, size: 1 },
    //     { x: 262.877697841727, y: 4.23529411764706, size: 1 },
    //     { x: 325.035971223022, y: 4.11764705882353, size: 1 },
    //     { x: 354.172661870504, y: 2.7843137254902, size: 1 },
    //     { x: 354.820143884892, y: 2.90196078431373, size: 1 },
    //     { x: 16.2162162162162, y: 2.7843137254902, size: 1 },
    //     { x: 25.2972972972973, y: 4, size: 1 },
    //     { x: 25.9459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 27.8918918918919, y: 3.92156862745098, size: 1 },
    //     { x: 37.6216216216216, y: 2.90196078431373, size: 1 },
    //     { x: 38.2702702702703, y: 2.70588235294118, size: 1 },
    //     { x: 48, y: 4.07843137254902, size: 1 },
    //     { x: 59.027027027027, y: 2.58823529411765, size: 1 },
    //     { x: 59.6756756756757, y: 1.84313725490196, size: 1 },
    //     { x: 81.0810810810811, y: 2.43137254901961, size: 1 },
    //     { x: 107.675675675676, y: 3.88235294117647, size: 1 },
    //     { x: 112.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 113.513513513514, y: 4, size: 1 },
    //     { x: 123.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 124.540540540541, y: 2.62745098039216, size: 1 },
    //     { x: 145.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 145.945945945946, y: 2.94117647058824, size: 1 },
    //     { x: 147.891891891892, y: 4.19607843137255, size: 1 },
    //     { x: 155.027027027027, y: 4.23529411764706, size: 1 },
    //     { x: 162.162162162162, y: 3.92156862745098, size: 1 },
    //     { x: 167.351351351351, y: 2.54901960784314, size: 1 },
    //     { x: 168, y: 2.66666666666667, size: 1 },
    //     { x: 188.756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 189.405405405405, y: 2.66666666666667, size: 1 },
    //     { x: 197.837837837838, y: 4, size: 1 },
    //     { x: 208.864864864865, y: 3.2156862745098, size: 1 },
    //     { x: 209.513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 210.810810810811, y: 2.70588235294118, size: 1 },
    //     { x: 211.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 271.783783783784, y: 3.37254901960784, size: 1 },
    //     { x: 274.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 275.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 275.675675675676, y: 2.70588235294118, size: 1 },
    //     { x: 288, y: 4, size: 1 },
    //     { x: 306.162162162162, y: 4.15686274509804, size: 1 },
    //     { x: 315.891891891892, y: 4.19607843137255, size: 1 },
    //     { x: 357.405405405405, y: 4, size: 1 },
    //     { x: 23.3093525179856, y: 3.13725490196078, size: 1 },
    //     { x: 45.3237410071942, y: 2.94117647058824, size: 1 },
    //     { x: 52.4460431654676, y: 4.11764705882353, size: 1 },
    //     { x: 53.7410071942446, y: 4.03921568627451, size: 1 },
    //     { x: 85.4676258992806, y: 4.03921568627451, size: 1 },
    //     { x: 111.36690647482, y: 4, size: 1 },
    //     { x: 136.618705035971, y: 4.03921568627451, size: 1 },
    //     { x: 152.805755395683, y: 2.86274509803922, size: 1 },
    //     { x: 153.453237410072, y: 2.82352941176471, size: 1 },
    //     { x: 174.820143884892, y: 2.74509803921569, size: 1 },
    //     { x: 222.086330935252, y: 3.96078431372549, size: 1 },
    //     { x: 235.68345323741, y: 3.96078431372549, size: 1 },
    //     { x: 257.05035971223, y: 4.07843137254902, size: 1 },
    //     { x: 260.935251798561, y: 2.50980392156863, size: 1 },
    //     { x: 270.647482014389, y: 4, size: 1 },
    //     { x: 282.302158273381, y: 2.3921568627451, size: 1 },
    //     { x: 282.94964028777, y: 2.27450980392157, size: 1 },
    //     { x: 309.496402877698, y: 3.96078431372549, size: 1 },
    //     { x: 325.68345323741, y: 3.13725490196078, size: 1 },
    //     { x: 20.0719424460432, y: 4.11764705882353, size: 1 },
    //     { x: 20.7194244604317, y: 4, size: 1 },
    //     { x: 27.1942446043165, y: 4.03921568627451, size: 1 },
    //     { x: 31.0791366906475, y: 2.35294117647059, size: 1 },
    //     { x: 51.7985611510791, y: 3.09803921568627, size: 1 },
    //     { x: 52.4460431654676, y: 2.47058823529412, size: 1 },
    //     { x: 55.6834532374101, y: 4.11764705882353, size: 1 },
    //     { x: 67.9856115107914, y: 4.07843137254902, size: 1 },
    //     { x: 71.8705035971223, y: 3.17647058823529, size: 1 },
    //     { x: 138.561151079137, y: 2.58823529411765, size: 1 },
    //     { x: 168.345323741007, y: 4.15686274509804, size: 1 },
    //     { x: 171.58273381295, y: 4.07843137254902, size: 1 },
    //     { x: 181.294964028777, y: 2.98039215686275, size: 1 },
    //     { x: 181.942446043165, y: 2.70588235294118, size: 1 },
    //     { x: 224.676258992806, y: 2.43137254901961, size: 1 },
    //     { x: 225.323741007194, y: 2.3921568627451, size: 1 },
    //     { x: 233.741007194245, y: 4.07843137254902, size: 1 },
    //     { x: 244.748201438849, y: 3.05882352941176, size: 1 },
    //     { x: 246.043165467626, y: 2.74509803921569, size: 1 },
    //     { x: 246.690647482014, y: 2.3921568627451, size: 1 },
    //     { x: 310.791366906475, y: 2.94117647058824, size: 1 },
    //     { x: 311.438848920863, y: 2.90196078431373, size: 1 },
    //     { x: 337.985611510791, y: 4.15686274509804, size: 1 },
    //     { x: 354.172661870504, y: 2.3921568627451, size: 1 },
    //     { x: 354.820143884892, y: 2.50980392156863, size: 1 },
    //     { x: 8.43243243243243, y: 4, size: 1 },
    //     { x: 26.5945945945946, y: 4, size: 1 },
    //     { x: 36.3243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 37.6216216216216, y: 2.58823529411765, size: 1 },
    //     { x: 59.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 59.6756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 73.2972972972973, y: 3.88235294117647, size: 1 },
    //     { x: 77.1891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 80.4324324324324, y: 2.43137254901961, size: 1 },
    //     { x: 81.0810810810811, y: 2.31372549019608, size: 1 },
    //     { x: 101.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 102.486486486486, y: 2.7843137254902, size: 1 },
    //     { x: 103.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 118.702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 123.243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 123.891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 145.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 150.486486486486, y: 4.07843137254902, size: 1 },
    //     { x: 167.351351351351, y: 2.62745098039216, size: 1 },
    //     { x: 195.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 210.162162162162, y: 2.58823529411765, size: 1 },
    //     { x: 210.810810810811, y: 2.58823529411765, size: 1 },
    //     { x: 232.216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 252.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 254.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 275.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 296.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 297.081081081081, y: 2.90196078431373, size: 1 },
    //     { x: 297.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 339.891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 340.540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 1.94244604316547, y: 2.62745098039216, size: 1 },
    //     { x: 23.3093525179856, y: 2.86274509803922, size: 1 },
    //     { x: 23.9568345323741, y: 2.82352941176471, size: 1 },
    //     { x: 66.6906474820144, y: 1.88235294117647, size: 1 },
    //     { x: 88.0575539568345, y: 2.7843137254902, size: 1 },
    //     { x: 88.705035971223, y: 2.94117647058824, size: 1 },
    //     { x: 129.496402877698, y: 3.2156862745098, size: 1 },
    //     { x: 146.978417266187, y: 4, size: 1 },
    //     { x: 152.805755395683, y: 2.7843137254902, size: 1 },
    //     { x: 153.453237410072, y: 2.62745098039216, size: 1 },
    //     { x: 173.525179856115, y: 3.17647058823529, size: 1 },
    //     { x: 174.820143884892, y: 2.70588235294118, size: 1 },
    //     { x: 260.935251798561, y: 2.94117647058824, size: 1 },
    //     { x: 262.230215827338, y: 4.11764705882353, size: 1 },
    //     { x: 268.057553956835, y: 4, size: 1 },
    //     { x: 282.94964028777, y: 2.98039215686275, size: 1 },
    //     { x: 304.31654676259, y: 2.86274509803922, size: 1 },
    //     { x: 325.68345323741, y: 1.76470588235294, size: 1 },
    //     { x: 326.330935251799, y: 1.76470588235294, size: 1 },
    //     { x: 326.978417266187, y: 1.92156862745098, size: 1 },
    //     { x: 327.625899280576, y: 2.31372549019608, size: 1 },
    //     { x: 334.748201438849, y: 2.98039215686275, size: 1 },
    //     { x: 347.05035971223, y: 2.35294117647059, size: 1 },
    //     { x: 347.697841726619, y: 2.47058823529412, size: 1 },
    //     { x: 9.06474820143885, y: 3.2156862745098, size: 1 },
    //     { x: 28.4892086330935, y: 3.13725490196078, size: 1 },
    //     { x: 30.431654676259, y: 2.90196078431373, size: 1 },
    //     { x: 39.4964028776978, y: 4.11764705882353, size: 1 },
    //     { x: 51.7985611510791, y: 2.47058823529412, size: 1 },
    //     { x: 52.4460431654676, y: 2.11764705882353, size: 1 },
    //     { x: 60.2158273381295, y: 4.15686274509804, size: 1 },
    //     { x: 73.8129496402878, y: 2.82352941176471, size: 1 },
    //     { x: 310.791366906475, y: 2.82352941176471, size: 1 },
    //     { x: 311.438848920863, y: 2.86274509803922, size: 1 },
    //     { x: 354.172661870504, y: 2.94117647058824, size: 1 },
    //     { x: 24.6486486486486, y: 4, size: 1 },
    //     { x: 36.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 59.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 80.4324324324324, y: 2.50980392156863, size: 1 },
    //     { x: 81.0810810810811, y: 2.3921568627451, size: 1 },
    //     { x: 90.1621621621622, y: 3.92156862745098, size: 1 },
    //     { x: 98.5945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 167.351351351351, y: 2.94117647058824, size: 1 },
    //     { x: 169.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 175.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 177.72972972973, y: 2.90196078431373, size: 1 },
    //     { x: 179.675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 180.324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 180.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 181.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 184.864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 185.513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 210.162162162162, y: 2.43137254901961, size: 1 },
    //     { x: 210.810810810811, y: 2.74509803921569, size: 1 },
    //     { x: 212.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 214.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 215.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 216, y: 3.17647058823529, size: 1 },
    //     { x: 216.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 217.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 221.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 221.837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 222.486486486486, y: 2.90196078431373, size: 1 },
    //     { x: 224.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 225.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 227.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 232.216216216216, y: 2.70588235294118, size: 1 },
    //     { x: 232.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 296.432432432432, y: 2.82352941176471, size: 1 },
    //     { x: 297.081081081081, y: 2.50980392156863, size: 1 },
    //     { x: 318.486486486487, y: 2.98039215686275, size: 1 },
    //     { x: 326.27027027027, y: 3.37254901960784, size: 1 },
    //     { x: 335.351351351351, y: 3.29411764705882, size: 1 },
    //     { x: 339.891891891892, y: 2.86274509803922, size: 1 },
    //     { x: 347.675675675676, y: 4, size: 1 },
    //     { x: 353.513513513513, y: 3.33333333333333, size: 1 },
    //     { x: 15.5395683453237, y: 4.03921568627451, size: 1 },
    //     { x: 23.3093525179856, y: 2.7843137254902, size: 1 },
    //     { x: 66.6906474820144, y: 2.82352941176471, size: 1 },
    //     { x: 67.9856115107914, y: 3.09803921568627, size: 1 },
    //     { x: 77.6978417266187, y: 3.17647058823529, size: 1 },
    //     { x: 78.3453237410072, y: 3.13725490196078, size: 1 },
    //     { x: 82.8776978417266, y: 3.01960784313725, size: 1 },
    //     { x: 84.8201438848921, y: 3.09803921568627, size: 1 },
    //     { x: 88.0575539568345, y: 2.82352941176471, size: 1 },
    //     { x: 89.3525179856115, y: 3.13725490196078, size: 1 },
    //     { x: 107.482014388489, y: 3.17647058823529, size: 1 },
    //     { x: 109.424460431655, y: 2.3921568627451, size: 1 },
    //     { x: 110.071942446043, y: 2.47058823529412, size: 1 },
    //     { x: 131.438848920863, y: 2.47058823529412, size: 1 },
    //     { x: 152.805755395683, y: 2.70588235294118, size: 1 },
    //     { x: 239.568345323741, y: 2.35294117647059, size: 1 },
    //     { x: 241.510791366906, y: 3.05882352941176, size: 1 },
    //     { x: 242.805755395683, y: 3.09803921568627, size: 1 },
    //     { x: 250.575539568345, y: 3.09803921568627, size: 1 },
    //     { x: 251.223021582734, y: 3.2156862745098, size: 1 },
    //     { x: 260.287769784173, y: 3.01960784313725, size: 1 },
    //     { x: 262.877697841727, y: 3.05882352941176, size: 1 },
    //     { x: 282.302158273381, y: 2.66666666666667, size: 1 },
    //     { x: 303.669064748201, y: 2.98039215686275, size: 1 },
    //     { x: 325.035971223022, y: 2.66666666666667, size: 1 },
    //     { x: 325.68345323741, y: 2.50980392156863, size: 1 },
    //     { x: 8.41726618705036, y: 3.09803921568627, size: 1 },
    //     { x: 51.7985611510791, y: 2.82352941176471, size: 1 },
    //     { x: 52.4460431654676, y: 2.7843137254902, size: 1 },
    //     { x: 55.0359712230216, y: 3.05882352941176, size: 1 },
    //     { x: 65.3956834532374, y: 3.25490196078431, size: 1 },
    //     { x: 68.6330935251799, y: 3.05882352941176, size: 1 },
    //     { x: 116.546762589928, y: 3.05882352941176, size: 1 },
    //     { x: 119.784172661871, y: 4.07843137254902, size: 1 },
    //     { x: 202.661870503597, y: 2.31372549019608, size: 1 },
    //     { x: 203.309352517986, y: 2.19607843137255, size: 1 },
    //     { x: 204.604316546763, y: 4.07843137254902, size: 1 },
    //     { x: 267.410071942446, y: 2.94117647058824, size: 1 },
    //     { x: 270, y: 3.96078431372549, size: 1 },
    //     { x: 310.791366906475, y: 2.70588235294118, size: 1 },
    //     { x: 332.805755395683, y: 2.94117647058824, size: 1 },
    //     { x: 353.525179856115, y: 2.82352941176471, size: 1 },
    //     { x: 15.5675675675676, y: 2.66666666666667, size: 1 },
    //     { x: 37.6216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 46.7027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 80.4324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 88.2162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 101.837837837838, y: 2.27450980392157, size: 1 },
    //     { x: 102.486486486486, y: 2.27450980392157, size: 1 },
    //     { x: 123.243243243243, y: 2.54901960784314, size: 1 },
    //     { x: 123.891891891892, y: 2.54901960784314, size: 1 },
    //     { x: 125.189189189189, y: 3.25490196078431, size: 1 },
    //     { x: 135.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 162.810810810811, y: 3.80392156862745, size: 1 },
    //     { x: 188.108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 190.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 199.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 201.081081081081, y: 3.29411764705882, size: 1 },
    //     { x: 296.432432432432, y: 2.11764705882353, size: 1 },
    //     { x: 297.081081081081, y: 2.03921568627451, size: 1 },
    //     { x: 317.837837837838, y: 2.27450980392157, size: 1 },
    //     { x: 318.486486486487, y: 2.31372549019608, size: 1 },
    //     { x: 332.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 339.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 29.7841726618705, y: 3.09803921568627, size: 1 },
    //     { x: 31.0791366906475, y: 3.25490196078431, size: 1 },
    //     { x: 40.7913669064748, y: 3.13725490196078, size: 1 },
    //     { x: 44.0287769784173, y: 3.09803921568627, size: 1 },
    //     { x: 44.6762589928058, y: 2.23529411764706, size: 1 },
    //     { x: 65.3956834532374, y: 2.98039215686275, size: 1 },
    //     { x: 66.0431654676259, y: 2, size: 1 },
    //     { x: 66.6906474820144, y: 2.11764705882353, size: 1 },
    //     { x: 87.410071942446, y: 2.82352941176471, size: 1 },
    //     { x: 88.0575539568345, y: 2.74509803921569, size: 1 },
    //     { x: 131.438848920863, y: 2.7843137254902, size: 1 },
    //     { x: 152.158273381295, y: 2.58823529411765, size: 1 },
    //     { x: 152.805755395683, y: 2.15686274509804, size: 1 },
    //     { x: 162.517985611511, y: 4.03921568627451, size: 1 },
    //     { x: 172.877697841727, y: 3.05882352941176, size: 1 },
    //     { x: 174.172661870504, y: 2.35294117647059, size: 1 },
    //     { x: 238.920863309353, y: 2.86274509803922, size: 1 },
    //     { x: 260.287769784173, y: 2.7843137254902, size: 1 },
    //     { x: 281.654676258993, y: 2.35294117647059, size: 1 },
    //     { x: 325.68345323741, y: 2.98039215686275, size: 1 },
    //     { x: 8.41726618705036, y: 2.50980392156863, size: 1 },
    //     { x: 51.1510791366906, y: 2.90196078431373, size: 1 },
    //     { x: 51.7985611510791, y: 2.74509803921569, size: 1 },
    //     { x: 82.8776978417266, y: 4.03921568627451, size: 1 },
    //     { x: 146.978417266187, y: 4.07843137254902, size: 1 },
    //     { x: 180.647482014388, y: 3.01960784313725, size: 1 },
    //     { x: 181.294964028777, y: 2.94117647058824, size: 1 },
    //     { x: 290.719424460432, y: 3.96078431372549, size: 1 },
    //     { x: 297.194244604317, y: 3.96078431372549, size: 1 },
    //     { x: 325.035971223022, y: 4, size: 1 },
    //     { x: 326.330935251799, y: 4.03921568627451, size: 1 },
    //     { x: 328.920863309353, y: 4.15686274509804, size: 1 },
    //     { x: 355.467625899281, y: 4, size: 1 },
    //     { x: 14.9189189189189, y: 2.98039215686275, size: 1 },
    //     { x: 15.5675675675676, y: 2.86274509803922, size: 1 },
    //     { x: 16.2162162162162, y: 2.86274509803922, size: 1 },
    //     { x: 16.8648648648649, y: 2.82352941176471, size: 1 },
    //     { x: 35.6756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 36.972972972973, y: 2.58823529411765, size: 1 },
    //     { x: 37.6216216216216, y: 2.19607843137255, size: 1 },
    //     { x: 38.2702702702703, y: 2.54901960784314, size: 1 },
    //     { x: 38.9189189189189, y: 2.50980392156863, size: 1 },
    //     { x: 79.7837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 99.8918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 100.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 101.837837837838, y: 2.66666666666667, size: 1 },
    //     { x: 102.486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 123.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 125.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 140.756756756757, y: 4, size: 1 },
    //     { x: 156.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 166.702702702703, y: 2.3921568627451, size: 1 },
    //     { x: 168, y: 2.58823529411765, size: 1 },
    //     { x: 168.648648648649, y: 2.23529411764706, size: 1 },
    //     { x: 189.405405405405, y: 4.07843137254902, size: 1 },
    //     { x: 190.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 197.189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 201.081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 209.513513513514, y: 2.94117647058824, size: 1 },
    //     { x: 234.162162162162, y: 4.15686274509804, size: 1 },
    //     { x: 238.054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 245.189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 276.324324324324, y: 2.94117647058824, size: 1 },
    //     { x: 285.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 296.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 339.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 2.58992805755396, y: 2.90196078431373, size: 1 },
    //     { x: 48.5611510791367, y: 4.07843137254902, size: 1 },
    //     { x: 68.6330935251799, y: 4.11764705882353, size: 1 },
    //     { x: 108.776978417266, y: 2.98039215686275, size: 1 },
    //     { x: 174.172661870504, y: 2.7843137254902, size: 1 },
    //     { x: 248.63309352518, y: 4.19607843137255, size: 1 },
    //     { x: 257.05035971223, y: 4.27450980392157, size: 1 },
    //     { x: 334.748201438849, y: 4, size: 1 },
    //     { x: 11.6546762589928, y: 3.17647058823529, size: 1 },
    //     { x: 20.7194244604317, y: 3.09803921568627, size: 1 },
    //     { x: 25.8992805755396, y: 3.09803921568627, size: 1 },
    //     { x: 53.0935251798561, y: 2.98039215686275, size: 1 },
    //     { x: 69.9280575539568, y: 3.29411764705882, size: 1 },
    //     { x: 104.244604316547, y: 4.03921568627451, size: 1 },
    //     { x: 159.280575539568, y: 2.7843137254902, size: 1 },
    //     { x: 159.928057553957, y: 2.66666666666667, size: 1 },
    //     { x: 160.575539568345, y: 2.66666666666667, size: 1 },
    //     { x: 161.223021582734, y: 2.90196078431373, size: 1 },
    //     { x: 180.647482014388, y: 1.88235294117647, size: 1 },
    //     { x: 181.294964028777, y: 1.80392156862745, size: 1 },
    //     { x: 181.942446043165, y: 2.7843137254902, size: 1 },
    //     { x: 182.589928057554, y: 2.58823529411765, size: 1 },
    //     { x: 185.179856115108, y: 3.13725490196078, size: 1 },
    //     { x: 189.712230215827, y: 2.94117647058824, size: 1 },
    //     { x: 190.359712230216, y: 2.86274509803922, size: 1 },
    //     { x: 196.187050359712, y: 2.74509803921569, size: 1 },
    //     { x: 196.834532374101, y: 3.01960784313725, size: 1 },
    //     { x: 246.043165467626, y: 2.86274509803922, size: 1 },
    //     { x: 250.575539568345, y: 3.96078431372549, size: 1 },
    //     { x: 266.762589928058, y: 3.09803921568627, size: 1 },
    //     { x: 310.143884892086, y: 2.27450980392157, size: 1 },
    //     { x: 310.791366906475, y: 2.50980392156863, size: 1 },
    //     { x: 311.438848920863, y: 2.62745098039216, size: 1 },
    //     { x: 312.086330935252, y: 2.43137254901961, size: 1 },
    //     { x: 328.920863309353, y: 4, size: 1 },
    //     { x: 352.877697841727, y: 3.05882352941176, size: 1 },
    //     { x: 14.8920863309353, y: 2.70588235294118, size: 1 },
    //     { x: 15.5395683453237, y: 2.66666666666667, size: 1 },
    //     { x: 36.2589928057554, y: 2.27450980392157, size: 1 },
    //     { x: 36.9064748201439, y: 2.07843137254902, size: 1 },
    //     { x: 58.273381294964, y: 2.54901960784314, size: 1 },
    //     { x: 154.748201438849, y: 3.96078431372549, size: 1 },
    //     { x: 167.05035971223, y: 3.09803921568627, size: 1 },
    //     { x: 167.697841726619, y: 3.05882352941176, size: 1 },
    //     { x: 209.784172661871, y: 2.90196078431373, size: 1 },
    //     { x: 210.431654676259, y: 2.86274509803922, size: 1 },
    //     { x: 230.503597122302, y: 2.43137254901961, size: 1 },
    //     { x: 231.151079136691, y: 2.15686274509804, size: 1 },
    //     { x: 231.798561151079, y: 2.86274509803922, size: 1 },
    //     { x: 232.446043165468, y: 2.62745098039216, size: 1 },
    //     { x: 235.035971223022, y: 4.03921568627451, size: 1 },
    //     { x: 243.453237410072, y: 4.11764705882353, size: 1 },
    //     { x: 244.748201438849, y: 4.11764705882353, size: 1 },
    //     { x: 249.280575539568, y: 4.15686274509804, size: 1 },
    //     { x: 257.697841726619, y: 4.07843137254902, size: 1 },
    //     { x: 1.2972972972973, y: 3.37254901960784, size: 1 },
    //     { x: 35.027027027027, y: 3.96078431372549, size: 1 },
    //     { x: 59.6756756756757, y: 4.11764705882353, size: 1 },
    //     { x: 60.3243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 64.8648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 65.5135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 66.1621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 66.8108108108108, y: 2.94117647058824, size: 1 },
    //     { x: 84.3243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 85.6216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 108.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 122.594594594595, y: 4.11764705882353, size: 1 },
    //     { x: 149.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 150.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 152.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 153.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 153.72972972973, y: 2.82352941176471, size: 1 },
    //     { x: 194.594594594595, y: 2.70588235294118, size: 1 },
    //     { x: 195.243243243243, y: 2.66666666666667, size: 1 },
    //     { x: 195.891891891892, y: 2.50980392156863, size: 1 },
    //     { x: 196.540540540541, y: 2.35294117647059, size: 1 },
    //     { x: 197.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 219.891891891892, y: 3.84313725490196, size: 1 },
    //     { x: 228.324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 243.891891891892, y: 3.45098039215686, size: 1 },
    //     { x: 260.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 264, y: 4.07843137254902, size: 1 },
    //     { x: 303.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 319.783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 324.324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 324.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 339.891891891892, y: 4.07843137254902, size: 1 },
    //     { x: 29.136690647482, y: 2.86274509803922, size: 1 },
    //     { x: 33.6690647482014, y: 4.07843137254902, size: 1 },
    //     { x: 40.1438848920863, y: 4.03921568627451, size: 1 },
    //     { x: 45.9712230215827, y: 4.07843137254902, size: 1 },
    //     { x: 46.6187050359712, y: 4.15686274509804, size: 1 },
    //     { x: 48.5611510791367, y: 4.27450980392157, size: 1 },
    //     { x: 55.0359712230216, y: 4.07843137254902, size: 1 },
    //     { x: 67.3381294964029, y: 4.15686274509804, size: 1 },
    //     { x: 121.726618705036, y: 4.07843137254902, size: 1 },
    //     { x: 150.863309352518, y: 4.23529411764706, size: 1 },
    //     { x: 202.014388489209, y: 3.01960784313725, size: 1 },
    //     { x: 202.661870503597, y: 2.90196078431373, size: 1 },
    //     { x: 203.309352517986, y: 2.86274509803922, size: 1 },
    //     { x: 254.460431654676, y: 4.03921568627451, size: 1 },
    //     { x: 290.719424460432, y: 3.17647058823529, size: 1 },
    //     { x: 296.546762589928, y: 3.25490196078431, size: 1 },
    //     { x: 331.510791366906, y: 3.01960784313725, size: 1 },
    //     { x: 1.94244604316547, y: 4.03921568627451, size: 1 },
    //     { x: 4.53237410071942, y: 4.07843137254902, size: 1 },
    //     { x: 9.06474820143885, y: 3.96078431372549, size: 1 },
    //     { x: 66.0431654676259, y: 4.07843137254902, size: 1 },
    //     { x: 101.007194244604, y: 2.90196078431373, size: 1 },
    //     { x: 122.374100719424, y: 3.13725490196078, size: 1 },
    //     { x: 181.942446043165, y: 4.11764705882353, size: 1 },
    //     { x: 295.251798561151, y: 2.94117647058824, size: 1 },
    //     { x: 295.89928057554, y: 2.7843137254902, size: 1 },
    //     { x: 321.798561151079, y: 4.07843137254902, size: 1 },
    //     { x: 347.697841726619, y: 4.07843137254902, size: 1 },
    //     { x: 15.5675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 22.0540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 43.4594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 48.6486486486486, y: 3.88235294117647, size: 1 },
    //     { x: 49.9459459459459, y: 4.19607843137255, size: 1 },
    //     { x: 51.2432432432432, y: 4.07843137254902, size: 1 },
    //     { x: 53.8378378378378, y: 4.07843137254902, size: 1 },
    //     { x: 55.1351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 55.7837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 56.4324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 60.972972972973, y: 4, size: 1 },
    //     { x: 62.2702702702703, y: 4, size: 1 },
    //     { x: 64.8648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 92.7567567567568, y: 4.11764705882353, size: 1 },
    //     { x: 102.486486486486, y: 4, size: 1 },
    //     { x: 108.324324324324, y: 2.7843137254902, size: 1 },
    //     { x: 108.972972972973, y: 3.01960784313725, size: 1 },
    //     { x: 151.135135135135, y: 2.74509803921569, size: 1 },
    //     { x: 151.783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 171.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 173.189189189189, y: 2.11764705882353, size: 1 },
    //     { x: 184.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 194.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 195.243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 201.72972972973, y: 4, size: 1 },
    //     { x: 236.108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 238.054054054054, y: 2.47058823529412, size: 1 },
    //     { x: 240.648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 245.837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 259.459459459459, y: 2.31372549019608, size: 1 },
    //     { x: 260.108108108108, y: 2.31372549019608, size: 1 },
    //     { x: 279.567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 280.864864864865, y: 2.66666666666667, size: 1 },
    //     { x: 281.513513513513, y: 2.70588235294118, size: 1 },
    //     { x: 289.297297297297, y: 4, size: 1 },
    //     { x: 291.243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 316.540540540541, y: 4.11764705882353, size: 1 },
    //     { x: 328.864864864865, y: 4.07843137254902, size: 1 },
    //     { x: 330.162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 333.405405405405, y: 4.07843137254902, size: 1 },
    //     { x: 345.72972972973, y: 2.98039215686275, size: 1 },
    //     { x: 346.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 7.76978417266187, y: 2.62745098039216, size: 1 },
    //     { x: 27.841726618705, y: 3.33333333333333, size: 1 },
    //     { x: 29.136690647482, y: 2.11764705882353, size: 1 },
    //     { x: 72.5179856115108, y: 4.23529411764706, size: 1 },
    //     { x: 75.1079136690647, y: 2.86274509803922, size: 1 },
    //     { x: 75.7553956834532, y: 2.70588235294118, size: 1 },
    //     { x: 78.3453237410072, y: 2.7843137254902, size: 1 },
    //     { x: 79.6402877697842, y: 2.70588235294118, size: 1 },
    //     { x: 80.9352517985612, y: 2.94117647058824, size: 1 },
    //     { x: 82.8776978417266, y: 2.82352941176471, size: 1 },
    //     { x: 86.1151079136691, y: 2.66666666666667, size: 1 },
    //     { x: 93.8848920863309, y: 2.7843137254902, size: 1 },
    //     { x: 94.5323741007194, y: 2.58823529411765, size: 1 },
    //     { x: 110.071942446043, y: 4.27450980392157, size: 1 },
    //     { x: 223.381294964029, y: 3.05882352941176, size: 1 },
    //     { x: 245.395683453237, y: 3.09803921568627, size: 1 },
    //     { x: 246.043165467626, y: 4.03921568627451, size: 1 },
    //     { x: 247.338129496403, y: 4, size: 1 },
    //     { x: 260.935251798561, y: 3.96078431372549, size: 1 },
    //     { x: 269.352517985611, y: 4.07843137254902, size: 1 },
    //     { x: 292.661870503597, y: 4.07843137254902, size: 1 },
    //     { x: 332.805755395683, y: 3.17647058823529, size: 1 },
    //     { x: 333.453237410072, y: 3.09803921568627, size: 1 },
    //     { x: 343.165467625899, y: 2.98039215686275, size: 1 },
    //     { x: 42.0863309352518, y: 4.15686274509804, size: 1 },
    //     { x: 93.2374100719424, y: 4.15686274509804, size: 1 },
    //     { x: 121.726618705036, y: 3.13725490196078, size: 1 },
    //     { x: 122.374100719424, y: 2.54901960784314, size: 1 },
    //     { x: 123.021582733813, y: 2.58823529411765, size: 1 },
    //     { x: 123.669064748201, y: 2.66666666666667, size: 1 },
    //     { x: 124.31654676259, y: 2.43137254901961, size: 1 },
    //     { x: 145.035971223022, y: 3.05882352941176, size: 1 },
    //     { x: 176.115107913669, y: 4.07843137254902, size: 1 },
    //     { x: 202.014388489209, y: 4.03921568627451, size: 1 },
    //     { x: 241.510791366906, y: 3.09803921568627, size: 1 },
    //     { x: 244.10071942446, y: 3.2156862745098, size: 1 },
    //     { x: 273.237410071942, y: 3.09803921568627, size: 1 },
    //     { x: 273.884892086331, y: 3.09803921568627, size: 1 },
    //     { x: 316.618705035971, y: 3.05882352941176, size: 1 },
    //     { x: 317.26618705036, y: 3.01960784313725, size: 1 },
    //     { x: 12.3243243243243, y: 3.88235294117647, size: 1 },
    //     { x: 21.4054054054054, y: 2.70588235294118, size: 1 },
    //     { x: 22.0540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 27.8918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 42.8108108108108, y: 2.82352941176471, size: 1 },
    //     { x: 59.027027027027, y: 4.03921568627451, size: 1 },
    //     { x: 62.9189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 63.5675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 64.2162162162162, y: 2.90196078431373, size: 1 },
    //     { x: 64.8648648648649, y: 2.07843137254902, size: 1 },
    //     { x: 79.7837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 86.9189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 87.5675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 90.1621621621622, y: 4.15686274509804, size: 1 },
    //     { x: 92.7567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 93.4054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 99.2432432432432, y: 4.11764705882353, size: 1 },
    //     { x: 101.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 105.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 107.675675675676, y: 2.50980392156863, size: 1 },
    //     { x: 108.324324324324, y: 2.50980392156863, size: 1 },
    //     { x: 139.459459459459, y: 4, size: 1 },
    //     { x: 151.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 194.594594594595, y: 2.86274509803922, size: 1 },
    //     { x: 207.567567567568, y: 4, size: 1 },
    //     { x: 216, y: 2.3921568627451, size: 1 },
    //     { x: 216.648648648649, y: 2.47058823529412, size: 1 },
    //     { x: 230.918918918919, y: 3.88235294117647, size: 1 },
    //     { x: 237.405405405405, y: 2.58823529411765, size: 1 },
    //     { x: 238.054054054054, y: 2.15686274509804, size: 1 },
    //     { x: 280.864864864865, y: 2.98039215686275, size: 1 },
    //     { x: 281.513513513513, y: 2.86274509803922, size: 1 },
    //     { x: 284.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 287.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 292.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 302.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 324.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 333.405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 345.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 346.378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 355.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 27.1942446043165, y: 3.2156862745098, size: 1 },
    //     { x: 29.136690647482, y: 2.66666666666667, size: 1 },
    //     { x: 93.8848920863309, y: 2.74509803921569, size: 1 },
    //     { x: 115.251798561151, y: 3.13725490196078, size: 1 },
    //     { x: 115.89928057554, y: 3.01960784313725, size: 1 },
    //     { x: 128.848920863309, y: 4, size: 1 },
    //     { x: 139.208633093525, y: 3.96078431372549, size: 1 },
    //     { x: 158.63309352518, y: 3.01960784313725, size: 1 },
    //     { x: 180, y: 2, size: 1 },
    //     { x: 180.647482014388, y: 2, size: 1 },
    //     { x: 201.36690647482, y: 2.82352941176471, size: 1 },
    //     { x: 275.827338129496, y: 4, size: 1 },
    //     { x: 352.877697841727, y: 3.01960784313725, size: 1 },
    //     { x: 0.647482014388489, y: 3.88235294117647, size: 1 },
    //     { x: 2.58992805755396, y: 4, size: 1 },
    //     { x: 3.88489208633094, y: 4.07843137254902, size: 1 },
    //     { x: 9.71223021582734, y: 4.07843137254902, size: 1 },
    //     { x: 14.8920863309353, y: 3.25490196078431, size: 1 },
    //     { x: 16.1870503597122, y: 4.35294117647059, size: 1 },
    //     { x: 35.6115107913669, y: 2.19607843137255, size: 1 },
    //     { x: 36.2589928057554, y: 1.76470588235294, size: 1 },
    //     { x: 36.9064748201439, y: 2.66666666666667, size: 1 },
    //     { x: 37.5539568345324, y: 2.70588235294118, size: 1 },
    //     { x: 38.2014388489209, y: 2.7843137254902, size: 1 },
    //     { x: 60.2158273381295, y: 4, size: 1 },
    //     { x: 100.359712230216, y: 2.35294117647059, size: 1 },
    //     { x: 101.007194244604, y: 2.58823529411765, size: 1 },
    //     { x: 121.726618705036, y: 3.09803921568627, size: 1 },
    //     { x: 122.374100719424, y: 1.49019607843137, size: 1 },
    //     { x: 143.741007194245, y: 2.70588235294118, size: 1 },
    //     { x: 229.856115107914, y: 2.15686274509804, size: 1 },
    //     { x: 230.503597122302, y: 1.72549019607843, size: 1 },
    //     { x: 235.68345323741, y: 4, size: 1 },
    //     { x: 237.625899280576, y: 4.03921568627451, size: 1 },
    //     { x: 251.870503597122, y: 2.27450980392157, size: 1 },
    //     { x: 273.237410071942, y: 2.70588235294118, size: 1 },
    //     { x: 273.884892086331, y: 2.82352941176471, size: 1 },
    //     { x: 282.94964028777, y: 4.03921568627451, size: 1 },
    //     { x: 293.956834532374, y: 4.07843137254902, size: 1 },
    //     { x: 294.604316546763, y: 4.23529411764706, size: 1 },
    //     { x: 295.89928057554, y: 4.07843137254902, size: 1 },
    //     { x: 301.726618705036, y: 4.03921568627451, size: 1 },
    //     { x: 305.611510791367, y: 4.11764705882353, size: 1 },
    //     { x: 310.143884892086, y: 4.07843137254902, size: 1 },
    //     { x: 313.381294964029, y: 4.11764705882353, size: 1 },
    //     { x: 0, y: 3.13725490196078, size: 1 },
    //     { x: 31.0791366906475, y: 3.96078431372549, size: 1 },
    //     { x: 45.3237410071942, y: 4.11764705882353, size: 1 },
    //     { x: 58.273381294964, y: 4.07843137254902, size: 1 },
    //     { x: 64.7482014388489, y: 2.90196078431373, size: 1 },
    //     { x: 78.9928057553957, y: 4.11764705882353, size: 1 },
    //     { x: 86.1151079136691, y: 2.19607843137255, size: 1 },
    //     { x: 128.848920863309, y: 2.50980392156863, size: 1 },
    //     { x: 129.496402877698, y: 1.64705882352941, size: 1 },
    //     { x: 172.230215827338, y: 1.45098039215686, size: 1 },
    //     { x: 172.877697841727, y: 1.52941176470588, size: 1 },
    //     { x: 222.086330935252, y: 4, size: 1 },
    //     { x: 228.561151079137, y: 4.15686274509804, size: 1 },
    //     { x: 230.503597122302, y: 4.03921568627451, size: 1 },
    //     { x: 266.115107913669, y: 4.11764705882353, size: 1 },
    //     { x: 6.48648648648649, y: 2.50980392156863, size: 1 },
    //     { x: 7.13513513513514, y: 2.47058823529412, size: 1 },
    //     { x: 7.78378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 9.72972972972973, y: 4.03921568627451, size: 1 },
    //     { x: 14.2702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 16.2162162162162, y: 4.11764705882353, size: 1 },
    //     { x: 28.5405405405405, y: 2.74509803921569, size: 1 },
    //     { x: 76.5405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 92.7567567567568, y: 3.37254901960784, size: 1 },
    //     { x: 97.2972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 108.972972972973, y: 4.19607843137255, size: 1 },
    //     { x: 121.945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 131.027027027027, y: 4.07843137254902, size: 1 },
    //     { x: 137.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 138.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 139.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 142.054054054054, y: 4, size: 1 },
    //     { x: 142.702702702703, y: 4, size: 1 },
    //     { x: 146.594594594595, y: 4.15686274509804, size: 1 },
    //     { x: 147.243243243243, y: 4.07843137254902, size: 1 },
    //     { x: 147.891891891892, y: 4.11764705882353, size: 1 },
    //     { x: 161.513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 182.27027027027, y: 3.25490196078431, size: 1 },
    //     { x: 184.216216216216, y: 3.92156862745098, size: 1 },
    //     { x: 186.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 222.486486486486, y: 3.17647058823529, size: 1 },
    //     { x: 223.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 225.081081081081, y: 3.84313725490196, size: 1 },
    //     { x: 240, y: 4, size: 1 },
    //     { x: 244.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 247.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 251.027027027027, y: 4.11764705882353, size: 1 },
    //     { x: 257.513513513513, y: 4.03921568627451, size: 1 },
    //     { x: 262.702702702703, y: 4.19607843137255, size: 1 },
    //     { x: 269.189189189189, y: 3.96078431372549, size: 1 },
    //     { x: 270.486486486487, y: 4.31372549019608, size: 1 },
    //     { x: 271.783783783784, y: 3.92156862745098, size: 1 },
    //     { x: 288, y: 2.94117647058824, size: 1 },
    //     { x: 293.189189189189, y: 4, size: 1 },
    //     { x: 295.135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 295.783783783784, y: 4, size: 1 },
    //     { x: 300.324324324324, y: 4.11764705882353, size: 1 },
    //     { x: 300.972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 314.594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 329.513513513513, y: 3.2156862745098, size: 1 },
    //     { x: 330.810810810811, y: 2.66666666666667, size: 1 },
    //     { x: 331.459459459459, y: 2.47058823529412, size: 1 },
    //     { x: 341.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 348.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 352.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 56.9784172661871, y: 2.98039215686275, size: 1 },
    //     { x: 57.6258992805755, y: 2.74509803921569, size: 1 },
    //     { x: 100.359712230216, y: 2.90196078431373, size: 1 },
    //     { x: 101.007194244604, y: 2.86274509803922, size: 1 },
    //     { x: 121.079136690647, y: 3.17647058823529, size: 1 },
    //     { x: 121.726618705036, y: 2.74509803921569, size: 1 },
    //     { x: 148.273381294964, y: 4.11764705882353, size: 1 },
    //     { x: 187.122302158273, y: 2.7843137254902, size: 1 },
    //     { x: 208.489208633094, y: 2.94117647058824, size: 1 },
    //     { x: 229.856115107914, y: 3.01960784313725, size: 1 },
    //     { x: 251.870503597122, y: 2.66666666666667, size: 1 },
    //     { x: 273.237410071942, y: 2.74509803921569, size: 1 },
    //     { x: 282.94964028777, y: 4.07843137254902, size: 1 },
    //     { x: 315.971223021583, y: 2.3921568627451, size: 1 },
    //     { x: 316.618705035971, y: 2.50980392156863, size: 1 },
    //     { x: 337.338129496403, y: 3.2156862745098, size: 1 },
    //     { x: 13.6216216216216, y: 3.84313725490196, size: 1 },
    //     { x: 14.9189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 21.4054054054054, y: 2.66666666666667, size: 1 },
    //     { x: 30.4864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 40.8648648648649, y: 3.33333333333333, size: 1 },
    //     { x: 42.8108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 64.2162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 66.8108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 71.3513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 84.3243243243243, y: 3.33333333333333, size: 1 },
    //     { x: 90.8108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 129.081081081081, y: 2.74509803921569, size: 1 },
    //     { x: 129.72972972973, y: 2.82352941176471, size: 1 },
    //     { x: 151.135135135135, y: 2.86274509803922, size: 1 },
    //     { x: 171.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 172.540540540541, y: 1.64705882352941, size: 1 },
    //     { x: 192, y: 3.17647058823529, size: 1 },
    //     { x: 193.297297297297, y: 2.86274509803922, size: 1 },
    //     { x: 193.945945945946, y: 2.15686274509804, size: 1 },
    //     { x: 194.594594594595, y: 2.03921568627451, size: 1 },
    //     { x: 213.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 218.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 219.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 221.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 223.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 229.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 232.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 233.513513513514, y: 3.01960784313725, size: 1 },
    //     { x: 234.162162162162, y: 2.94117647058824, size: 1 },
    //     { x: 258.810810810811, y: 2.86274509803922, size: 1 },
    //     { x: 267.891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 278.918918918919, y: 3.29411764705882, size: 1 },
    //     { x: 280.216216216216, y: 2.50980392156863, size: 1 },
    //     { x: 280.864864864865, y: 2.11764705882353, size: 1 },
    //     { x: 300.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 302.27027027027, y: 2.90196078431373, size: 1 },
    //     { x: 323.675675675676, y: 2.70588235294118, size: 1 },
    //     { x: 324.324324324324, y: 2.7843137254902, size: 1 },
    //     { x: 338.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 345.081081081081, y: 2.70588235294118, size: 1 },
    //     { x: 345.72972972973, y: 2.35294117647059, size: 1 },
    //     { x: 7.12230215827338, y: 2.74509803921569, size: 1 },
    //     { x: 71.8705035971223, y: 2.98039215686275, size: 1 },
    //     { x: 88.0575539568345, y: 3.92156862745098, size: 1 },
    //     { x: 201.36690647482, y: 2.54901960784314, size: 1 },
    //     { x: 236.330935251799, y: 2.90196078431373, size: 1 },
    //     { x: 239.568345323741, y: 3.13725490196078, size: 1 },
    //     { x: 240.215827338129, y: 2.7843137254902, size: 1 },
    //     { x: 244.10071942446, y: 3.09803921568627, size: 1 },
    //     { x: 246.043165467626, y: 3.01960784313725, size: 1 },
    //     { x: 247.338129496403, y: 3.09803921568627, size: 1 },
    //     { x: 255.755395683453, y: 2.98039215686275, size: 1 },
    //     { x: 258.992805755396, y: 3.17647058823529, size: 1 },
    //     { x: 13.5971223021583, y: 2.94117647058824, size: 1 },
    //     { x: 14.2446043165468, y: 2.74509803921569, size: 1 },
    //     { x: 31.726618705036, y: 4.11764705882353, size: 1 },
    //     { x: 35.6115107913669, y: 2.47058823529412, size: 1 },
    //     { x: 66.0431654676259, y: 4.11764705882353, size: 1 },
    //     { x: 100.359712230216, y: 2.27450980392157, size: 1 },
    //     { x: 165.107913669065, y: 2.86274509803922, size: 1 },
    //     { x: 186.474820143885, y: 2.98039215686275, size: 1 },
    //     { x: 208.489208633094, y: 2.90196078431373, size: 1 },
    //     { x: 273.237410071942, y: 2.94117647058824, size: 1 },
    //     { x: 294.604316546763, y: 2.74509803921569, size: 1 },
    //     { x: 315.971223021583, y: 2.58823529411765, size: 1 },
    //     { x: 316.618705035971, y: 2.62745098039216, size: 1 },
    //     { x: 337.338129496403, y: 3.13725490196078, size: 1 },
    //     { x: 345.107913669065, y: 3.96078431372549, size: 1 },
    //     { x: 359.352517985611, y: 2.90196078431373, size: 1 },
    //     { x: 36.3243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 42.1621621621622, y: 2.82352941176471, size: 1 },
    //     { x: 42.8108108108108, y: 2.3921568627451, size: 1 },
    //     { x: 58.3783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 64.2162162162162, y: 2.54901960784314, size: 1 },
    //     { x: 84.3243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 85.6216216216216, y: 2.43137254901961, size: 1 },
    //     { x: 86.2702702702703, y: 2.54901960784314, size: 1 },
    //     { x: 90.1621621621622, y: 4, size: 1 },
    //     { x: 125.189189189189, y: 4.07843137254902, size: 1 },
    //     { x: 149.837837837838, y: 3.37254901960784, size: 1 },
    //     { x: 150.486486486486, y: 2.54901960784314, size: 1 },
    //     { x: 151.135135135135, y: 2.50980392156863, size: 1 },
    //     { x: 171.891891891892, y: 2.62745098039216, size: 1 },
    //     { x: 172.540540540541, y: 2.74509803921569, size: 1 },
    //     { x: 192, y: 3.2156862745098, size: 1 },
    //     { x: 192.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 193.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 193.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 216, y: 3.13725490196078, size: 1 },
    //     { x: 225.081081081081, y: 4, size: 1 },
    //     { x: 260.756756756757, y: 4, size: 1 },
    //     { x: 280.216216216216, y: 2.70588235294118, size: 1 },
    //     { x: 280.864864864865, y: 2.7843137254902, size: 1 },
    //     { x: 301.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 302.27027027027, y: 2.62745098039216, size: 1 },
    //     { x: 323.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 345.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 354.162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 6.47482014388489, y: 2.82352941176471, size: 1 },
    //     { x: 7.12230215827338, y: 2.50980392156863, size: 1 },
    //     { x: 32.3741007194245, y: 4.03921568627451, size: 1 },
    //     { x: 133.381294964029, y: 4.07843137254902, size: 1 },
    //     { x: 136.618705035971, y: 2.90196078431373, size: 1 },
    //     { x: 157.985611510791, y: 2.54901960784314, size: 1 },
    //     { x: 179.352517985612, y: 2.86274509803922, size: 1 },
    //     { x: 180, y: 2.98039215686275, size: 1 },
    //     { x: 201.36690647482, y: 2.70588235294118, size: 1 },
    //     { x: 265.467625899281, y: 3.01960784313725, size: 1 },
    //     { x: 274.532374100719, y: 4.03921568627451, size: 1 },
    //     { x: 330.215827338129, y: 3.17647058823529, size: 1 },
    //     { x: 352.230215827338, y: 2.74509803921569, size: 1 },
    //     { x: 14.2446043165468, y: 2.27450980392157, size: 1 },
    //     { x: 33.0215827338129, y: 4.15686274509804, size: 1 },
    //     { x: 78.9928057553957, y: 2.47058823529412, size: 1 },
    //     { x: 193.597122302158, y: 4, size: 1 },
    //     { x: 207.841726618705, y: 2.35294117647059, size: 1 },
    //     { x: 208.489208633094, y: 2.27450980392157, size: 1 },
    //     { x: 229.856115107914, y: 2.82352941176471, size: 1 },
    //     { x: 251.223021582734, y: 1.29411764705882, size: 1 },
    //     { x: 251.870503597122, y: 1.76470588235294, size: 1 },
    //     { x: 252.517985611511, y: 1.45098039215686, size: 1 },
    //     { x: 253.165467625899, y: 1.33333333333333, size: 1 },
    //     { x: 266.762589928058, y: 2.98039215686275, size: 1 },
    //     { x: 294.604316546763, y: 2.90196078431373, size: 1 },
    //     { x: 314.028776978417, y: 3.33333333333333, size: 1 },
    //     { x: 337.985611510791, y: 3.01960784313725, size: 1 },
    //     { x: 359.352517985611, y: 2.50980392156863, size: 1 },
    //     { x: 20.7194244604317, y: 2.66666666666667, size: 1 },
    //     { x: 56.9784172661871, y: 4.23529411764706, size: 1 },
    //     { x: 63.4532374100719, y: 2.86274509803922, size: 1 },
    //     { x: 64.1007194244604, y: 2.7843137254902, size: 1 },
    //     { x: 107.482014388489, y: 2.35294117647059, size: 1 },
    //     { x: 117.194244604317, y: 4.07843137254902, size: 1 },
    //     { x: 128.848920863309, y: 2.47058823529412, size: 1 },
    //     { x: 139.856115107914, y: 4.03921568627451, size: 1 },
    //     { x: 150.215827338129, y: 2.3921568627451, size: 1 },
    //     { x: 153.453237410072, y: 4.11764705882353, size: 1 },
    //     { x: 299.784172661871, y: 3.13725490196078, size: 1 },
    //     { x: 301.726618705036, y: 2.03921568627451, size: 1 },
    //     { x: 302.374100719424, y: 4.07843137254902, size: 1 },
    //     { x: 322.446043165468, y: 3.01960784313725, size: 1 },
    //     { x: 323.093525179856, y: 3.13725490196078, size: 1 },
    //     { x: 342.517985611511, y: 3.09803921568627, size: 1 },
    //     { x: 344.460431654676, y: 1.88235294117647, size: 1 },
    //     { x: 354.172661870504, y: 4, size: 1 },
    //     { x: 5.83783783783784, y: 2.35294117647059, size: 1 },
    //     { x: 6.48648648648649, y: 2.66666666666667, size: 1 },
    //     { x: 57.0810810810811, y: 3.84313725490196, size: 1 },
    //     { x: 60.3243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 62.9189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 68.1081081081081, y: 3.80392156862745, size: 1 },
    //     { x: 70.7027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 113.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 118.702702702703, y: 4, size: 1 },
    //     { x: 127.783783783784, y: 4, size: 1 },
    //     { x: 140.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 157.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 171.243243243243, y: 3.84313725490196, size: 1 },
    //     { x: 187.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 188.108108108108, y: 3.88235294117647, size: 1 },
    //     { x: 200.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 201.081081081081, y: 2.90196078431373, size: 1 },
    //     { x: 201.72972972973, y: 2.86274509803922, size: 1 },
    //     { x: 202.378378378378, y: 2.82352941176471, size: 1 },
    //     { x: 203.675675675676, y: 3.96078431372549, size: 1 },
    //     { x: 206.27027027027, y: 4.11764705882353, size: 1 },
    //     { x: 214.054054054054, y: 4, size: 1 },
    //     { x: 221.837837837838, y: 2.66666666666667, size: 1 },
    //     { x: 222.486486486486, y: 2.66666666666667, size: 1 },
    //     { x: 240.648648648649, y: 3.37254901960784, size: 1 },
    //     { x: 243.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 243.891891891892, y: 2.66666666666667, size: 1 },
    //     { x: 244.540540540541, y: 3.2156862745098, size: 1 },
    //     { x: 264, y: 3.25490196078431, size: 1 },
    //     { x: 265.297297297297, y: 2.82352941176471, size: 1 },
    //     { x: 265.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 267.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 271.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 273.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 284.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 309.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 317.837837837838, y: 3.84313725490196, size: 1 },
    //     { x: 348.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 34.9640287769784, y: 2.7843137254902, size: 1 },
    //     { x: 56.3309352517986, y: 2.50980392156863, size: 1 },
    //     { x: 56.9784172661871, y: 2.50980392156863, size: 1 },
    //     { x: 143.093525179856, y: 3.05882352941176, size: 1 },
    //     { x: 164.460431654676, y: 2.86274509803922, size: 1 },
    //     { x: 165.107913669065, y: 2.90196078431373, size: 1 },
    //     { x: 216.906474820144, y: 4.27450980392157, size: 1 },
    //     { x: 229.208633093525, y: 3.09803921568627, size: 1 },
    //     { x: 250.575539568345, y: 3.01960784313725, size: 1 },
    //     { x: 315.323741007194, y: 2.66666666666667, size: 1 },
    //     { x: 315.971223021583, y: 2.82352941176471, size: 1 },
    //     { x: 337.338129496403, y: 2.74509803921569, size: 1 },
    //     { x: 25.2517985611511, y: 4.03921568627451, size: 1 },
    //     { x: 42.0863309352518, y: 3.13725490196078, size: 1 },
    //     { x: 64.1007194244604, y: 2.90196078431373, size: 1 },
    //     { x: 150.215827338129, y: 2.82352941176471, size: 1 },
    //     { x: 192.94964028777, y: 2.47058823529412, size: 1 },
    //     { x: 193.597122302158, y: 2.58823529411765, size: 1 },
    //     { x: 214.964028776978, y: 2.70588235294118, size: 1 },
    //     { x: 215.611510791367, y: 3.01960784313725, size: 1 },
    //     { x: 236.330935251799, y: 2.35294117647059, size: 1 },
    //     { x: 5.83783783783784, y: 2.82352941176471, size: 1 },
    //     { x: 12.972972972973, y: 4.03921568627451, size: 1 },
    //     { x: 27.2432432432432, y: 2.82352941176471, size: 1 },
    //     { x: 27.8918918918919, y: 2.47058823529412, size: 1 },
    //     { x: 28.5405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 30.4864864864865, y: 3.29411764705882, size: 1 },
    //     { x: 35.6756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 49.2972972972973, y: 2.54901960784314, size: 1 },
    //     { x: 52.5405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 94.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 95.3513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 98.5945945945946, y: 4, size: 1 },
    //     { x: 99.8918918918919, y: 4.11764705882353, size: 1 },
    //     { x: 105.72972972973, y: 4.07843137254902, size: 1 },
    //     { x: 113.513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 114.162162162162, y: 2.94117647058824, size: 1 },
    //     { x: 115.459459459459, y: 4, size: 1 },
    //     { x: 122.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 157.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 158.918918918919, y: 4.23529411764706, size: 1 },
    //     { x: 159.567567567568, y: 3.96078431372549, size: 1 },
    //     { x: 163.459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 164.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 165.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 169.297297297297, y: 4.03921568627451, size: 1 },
    //     { x: 170.594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 173.837837837838, y: 4, size: 1 },
    //     { x: 178.378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 179.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 185.513513513514, y: 3.96078431372549, size: 1 },
    //     { x: 192, y: 3.88235294117647, size: 1 },
    //     { x: 203.675675675676, y: 4, size: 1 },
    //     { x: 221.837837837838, y: 2.7843137254902, size: 1 },
    //     { x: 222.486486486486, y: 2.3921568627451, size: 1 },
    //     { x: 243.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 243.891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 260.756756756757, y: 4.15686274509804, size: 1 },
    //     { x: 264.648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 265.297297297297, y: 2.70588235294118, size: 1 },
    //     { x: 269.837837837838, y: 4.07843137254902, size: 1 },
    //     { x: 286.702702702703, y: 2.54901960784314, size: 1 },
    //     { x: 287.351351351351, y: 2.58823529411765, size: 1 },
    //     { x: 308.108108108108, y: 2.66666666666667, size: 1 },
    //     { x: 341.837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 348.972972972973, y: 4, size: 1 },
    //     { x: 352.216216216216, y: 3.96078431372549, size: 1 },
    //     { x: 359.351351351351, y: 4.03921568627451, size: 1 },
    //     { x: 77.6978417266187, y: 2.90196078431373, size: 1 },
    //     { x: 164.460431654676, y: 2.50980392156863, size: 1 },
    //     { x: 207.194244604317, y: 2.74509803921569, size: 1 },
    //     { x: 213.021582733813, y: 3.96078431372549, size: 1 },
    //     { x: 222.086330935252, y: 4.11764705882353, size: 1 },
    //     { x: 226.618705035971, y: 4.15686274509804, size: 1 },
    //     { x: 234.388489208633, y: 4.15686274509804, size: 1 },
    //     { x: 242.805755395683, y: 4.03921568627451, size: 1 },
    //     { x: 243.453237410072, y: 4.03921568627451, size: 1 },
    //     { x: 250.575539568345, y: 2.66666666666667, size: 1 },
    //     { x: 251.223021582734, y: 2.70588235294118, size: 1 },
    //     { x: 265.467625899281, y: 4, size: 1 },
    //     { x: 271.942446043165, y: 2.66666666666667, size: 1 },
    //     { x: 315.323741007194, y: 3.05882352941176, size: 1 },
    //     { x: 42.0863309352518, y: 2.86274509803922, size: 1 },
    //     { x: 93.2374100719424, y: 3.96078431372549, size: 1 },
    //     { x: 156.043165467626, y: 4.07843137254902, size: 1 },
    //     { x: 192.302158273381, y: 3.05882352941176, size: 1 },
    //     { x: 214.31654676259, y: 2.98039215686275, size: 1 },
    //     { x: 236.330935251799, y: 2.74509803921569, size: 1 },
    //     { x: 279.712230215827, y: 3.01960784313725, size: 1 },
    //     { x: 288.129496402878, y: 4.03921568627451, size: 1 },
    //     { x: 322.446043165468, y: 3.05882352941176, size: 1 },
    //     { x: 344.460431654676, y: 2.70588235294118, size: 1 },
    //     { x: 353.525179856115, y: 4.03921568627451, size: 1 },
    //     { x: 5.18918918918919, y: 2.62745098039216, size: 1 },
    //     { x: 5.83783783783784, y: 2.15686274509804, size: 1 },
    //     { x: 27.2432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 27.8918918918919, y: 3.01960784313725, size: 1 },
    //     { x: 48, y: 3.05882352941176, size: 1 },
    //     { x: 48.6486486486486, y: 2.98039215686275, size: 1 },
    //     { x: 49.2972972972973, y: 2.7843137254902, size: 1 },
    //     { x: 112.216216216216, y: 3.05882352941176, size: 1 },
    //     { x: 113.513513513514, y: 1.41176470588235, size: 1 },
    //     { x: 114.162162162162, y: 1.56862745098039, size: 1 },
    //     { x: 134.918918918919, y: 2.7843137254902, size: 1 },
    //     { x: 135.567567567568, y: 2.74509803921569, size: 1 },
    //     { x: 175.135135135135, y: 4.03921568627451, size: 1 },
    //     { x: 221.837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 243.243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 264.648648648649, y: 2.62745098039216, size: 1 },
    //     { x: 265.297297297297, y: 2.31372549019608, size: 1 },
    //     { x: 305.513513513513, y: 4, size: 1 },
    //     { x: 308.108108108108, y: 2.70588235294118, size: 1 },
    //     { x: 308.756756756757, y: 2.50980392156863, size: 1 },
    //     { x: 321.72972972973, y: 4.07843137254902, size: 1 },
    //     { x: 329.513513513513, y: 2.98039215686275, size: 1 },
    //     { x: 330.162162162162, y: 2.82352941176471, size: 1 },
    //     { x: 345.72972972973, y: 4, size: 1 },
    //     { x: 348.324324324324, y: 3.92156862745098, size: 1 },
    //     { x: 351.567567567568, y: 2.27450980392157, size: 1 },
    //     { x: 13.5971223021583, y: 3.2156862745098, size: 1 },
    //     { x: 34.3165467625899, y: 2.54901960784314, size: 1 },
    //     { x: 34.9640287769784, y: 2.54901960784314, size: 1 },
    //     { x: 88.705035971223, y: 4.03921568627451, size: 1 },
    //     { x: 99.0647482014388, y: 2.86274509803922, size: 1 },
    //     { x: 99.7122302158273, y: 2.7843137254902, size: 1 },
    //     { x: 121.079136690647, y: 2.7843137254902, size: 1 },
    //     { x: 143.093525179856, y: 2.58823529411765, size: 1 },
    //     { x: 164.460431654676, y: 2.90196078431373, size: 1 },
    //     { x: 174.820143884892, y: 4.11764705882353, size: 1 },
    //     { x: 207.194244604317, y: 2.50980392156863, size: 1 },
    //     { x: 207.841726618705, y: 2.66666666666667, size: 1 },
    //     { x: 271.942446043165, y: 2.82352941176471, size: 1 },
    //     { x: 315.323741007194, y: 2.86274509803922, size: 1 },
    //     { x: 358.705035971223, y: 2.86274509803922, size: 1 },
    //     { x: 20.0719424460432, y: 2.54901960784314, size: 1 },
    //     { x: 41.4388489208633, y: 2.86274509803922, size: 1 },
    //     { x: 62.8057553956835, y: 2.66666666666667, size: 1 },
    //     { x: 63.4532374100719, y: 2.62745098039216, size: 1 },
    //     { x: 106.187050359712, y: 1.41176470588235, size: 1 },
    //     { x: 106.834532374101, y: 1.49019607843137, size: 1 },
    //     { x: 107.482014388489, y: 1.84313725490196, size: 1 },
    //     { x: 108.129496402878, y: 1.52941176470588, size: 1 },
    //     { x: 110.719424460432, y: 3.17647058823529, size: 1 },
    //     { x: 115.251798561151, y: 3.05882352941176, size: 1 },
    //     { x: 121.726618705036, y: 2.86274509803922, size: 1 },
    //     { x: 122.374100719424, y: 3.05882352941176, size: 1 },
    //     { x: 126.258992805755, y: 3.2156862745098, size: 1 },
    //     { x: 126.906474820144, y: 3.2156862745098, size: 1 },
    //     { x: 127.553956834532, y: 2.27450980392157, size: 1 },
    //     { x: 128.201438848921, y: 2.11764705882353, size: 1 },
    //     { x: 164.460431654676, y: 4, size: 1 },
    //     { x: 170.935251798561, y: 2.31372549019608, size: 1 },
    //     { x: 171.58273381295, y: 2.35294117647059, size: 1 },
    //     { x: 192.94964028777, y: 2.31372549019608, size: 1 },
    //     { x: 214.31654676259, y: 2.50980392156863, size: 1 },
    //     { x: 217.553956834532, y: 4.03921568627451, size: 1 },
    //     { x: 277.122302158273, y: 3.17647058823529, size: 1 },
    //     { x: 343.812949640288, y: 2.50980392156863, size: 1 },
    //     { x: 113.309352517986, y: 2.98039215686275, size: 1 },
    //     { x: 134.676258992806, y: 2.43137254901961, size: 1 },
    //     { x: 135.323741007194, y: 2.62745098039216, size: 1 },
    //     { x: 156.043165467626, y: 2.82352941176471, size: 1 },
    //     { x: 178.057553956835, y: 2.74509803921569, size: 1 },
    //     { x: 264.172661870504, y: 2.82352941176471, size: 1 },
    //     { x: 286.187050359712, y: 3.05882352941176, size: 1 },
    //     { x: 317.913669064748, y: 4, size: 1 },
    //     { x: 329.568345323741, y: 2.7843137254902, size: 1 },
    //     { x: 33.7297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 43.4594594594595, y: 3.96078431372549, size: 1 },
    //     { x: 44.1081081081081, y: 4.03921568627451, size: 1 },
    //     { x: 50.5945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 77.1891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 79.1351351351351, y: 3.92156862745098, size: 1 },
    //     { x: 90.1621621621622, y: 4.03921568627451, size: 1 },
    //     { x: 97.2972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 98.5945945945946, y: 1.96078431372549, size: 1 },
    //     { x: 99.2432432432432, y: 2.15686274509804, size: 1 },
    //     { x: 120, y: 3.2156862745098, size: 1 },
    //     { x: 120.648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 142.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 158.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 163.459459459459, y: 2.82352941176471, size: 1 },
    //     { x: 164.108108108108, y: 2.66666666666667, size: 1 },
    //     { x: 166.054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 185.513513513514, y: 2.82352941176471, size: 1 },
    //     { x: 208.864864864865, y: 4, size: 1 },
    //     { x: 228.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 236.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 236.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 278.27027027027, y: 3.92156862745098, size: 1 },
    //     { x: 295.783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 314.594594594595, y: 2.66666666666667, size: 1 },
    //     { x: 315.243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 325.621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 334.702702702703, y: 3.09803921568627, size: 1 },
    //     { x: 335.351351351351, y: 3.2156862745098, size: 1 },
    //     { x: 336, y: 2.90196078431373, size: 1 },
    //     { x: 336.648648648649, y: 2.15686274509804, size: 1 },
    //     { x: 345.081081081081, y: 4, size: 1 },
    //     { x: 359.351351351351, y: 4, size: 1 },
    //     { x: 5.8273381294964, y: 4.19607843137255, size: 1 },
    //     { x: 15.5395683453237, y: 4.11764705882353, size: 1 },
    //     { x: 16.8345323741007, y: 3.96078431372549, size: 1 },
    //     { x: 27.841726618705, y: 4.15686274509804, size: 1 },
    //     { x: 29.136690647482, y: 4.03921568627451, size: 1 },
    //     { x: 34.3165467625899, y: 4.27450980392157, size: 1 },
    //     { x: 44.0287769784173, y: 4.11764705882353, size: 1 },
    //     { x: 49.2086330935252, y: 4.15686274509804, size: 1 },
    //     { x: 57.6258992805755, y: 4, size: 1 },
    //     { x: 80.9352517985612, y: 4.07843137254902, size: 1 },
    //     { x: 84.1726618705036, y: 3.17647058823529, size: 1 },
    //     { x: 214.31654676259, y: 2.94117647058824, size: 1 },
    //     { x: 235.68345323741, y: 2.11764705882353, size: 1 },
    //     { x: 257.05035971223, y: 2.62745098039216, size: 1 },
    //     { x: 258.345323741007, y: 4.11764705882353, size: 1 },
    //     { x: 262.877697841727, y: 4.11764705882353, size: 1 },
    //     { x: 263.525179856115, y: 4.19607843137255, size: 1 },
    //     { x: 270, y: 4.11764705882353, size: 1 },
    //     { x: 273.237410071942, y: 4.19607843137255, size: 1 },
    //     { x: 275.179856115108, y: 4.19607843137255, size: 1 },
    //     { x: 276.474820143885, y: 4.15686274509804, size: 1 },
    //     { x: 300.431654676259, y: 2.98039215686275, size: 1 },
    //     { x: 304.964028776978, y: 4.07843137254902, size: 1 },
    //     { x: 321.798561151079, y: 2.50980392156863, size: 1 },
    //     { x: 31.0791366906475, y: 4.07843137254902, size: 1 },
    //     { x: 32.3741007194245, y: 4.07843137254902, size: 1 },
    //     { x: 36.9064748201439, y: 4.03921568627451, size: 1 },
    //     { x: 91.294964028777, y: 2.94117647058824, size: 1 },
    //     { x: 112.661870503597, y: 3.2156862745098, size: 1 },
    //     { x: 120.431654676259, y: 4.03921568627451, size: 1 },
    //     { x: 156.043165467626, y: 2.66666666666667, size: 1 },
    //     { x: 220.791366906475, y: 2.90196078431373, size: 1 },
    //     { x: 221.438848920863, y: 3.09803921568627, size: 1 },
    //     { x: 236.330935251799, y: 3.96078431372549, size: 1 },
    //     { x: 264.172661870504, y: 2.94117647058824, size: 1 },
    //     { x: 343.165467625899, y: 4.19607843137255, size: 1 },
    //     { x: 11.6756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 12.3243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 33.0810810810811, y: 2.82352941176471, size: 1 },
    //     { x: 33.7297297297297, y: 1.96078431372549, size: 1 },
    //     { x: 55.1351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 62.2702702702703, y: 3.88235294117647, size: 1 },
    //     { x: 69.4054054054054, y: 3.92156862745098, size: 1 },
    //     { x: 77.1891891891892, y: 2.43137254901961, size: 1 },
    //     { x: 97.2972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 98.5945945945946, y: 2.47058823529412, size: 1 },
    //     { x: 118.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 120, y: 2.15686274509804, size: 1 },
    //     { x: 120.648648648649, y: 2.15686274509804, size: 1 },
    //     { x: 142.054054054054, y: 2.62745098039216, size: 1 },
    //     { x: 162.162162162162, y: 3.33333333333333, size: 1 },
    //     { x: 184.216216216216, y: 4.11764705882353, size: 1 },
    //     { x: 265.945945945946, y: 4.07843137254902, size: 1 },
    //     { x: 269.189189189189, y: 3.37254901960784, size: 1 },
    //     { x: 269.837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 270.486486486487, y: 3.13725490196078, size: 1 },
    //     { x: 271.135135135135, y: 2.62745098039216, size: 1 },
    //     { x: 271.783783783784, y: 2.47058823529412, size: 1 },
    //     { x: 300.972972972973, y: 4.07843137254902, size: 1 },
    //     { x: 40.7913669064748, y: 2.90196078431373, size: 1 },
    //     { x: 41.4388489208633, y: 2.94117647058824, size: 1 },
    //     { x: 84.8201438848921, y: 2.94117647058824, size: 1 },
    //     { x: 106.187050359712, y: 2.62745098039216, size: 1 },
    //     { x: 127.553956834532, y: 2.70588235294118, size: 1 },
    //     { x: 170.287769784173, y: 2.62745098039216, size: 1 },
    //     { x: 170.935251798561, y: 2.58823529411765, size: 1 },
    //     { x: 224.676258992806, y: 4.11764705882353, size: 1 },
    //     { x: 290.719424460432, y: 4, size: 1 },
    //     { x: 344.460431654676, y: 2.90196078431373, size: 1 },
    //     { x: 345.107913669065, y: 2.94117647058824, size: 1 },
    //     { x: 346.402877697842, y: 4.07843137254902, size: 1 },
    //     { x: 4.53237410071942, y: 3.09803921568627, size: 1 },
    //     { x: 5.8273381294964, y: 4.15686274509804, size: 1 },
    //     { x: 8.41726618705036, y: 4, size: 1 },
    //     { x: 33.6690647482014, y: 4, size: 1 },
    //     { x: 37.5539568345324, y: 4.03921568627451, size: 1 },
    //     { x: 47.9136690647482, y: 3.17647058823529, size: 1 },
    //     { x: 48.5611510791367, y: 2.82352941176471, size: 1 },
    //     { x: 61.5107913669065, y: 4.11764705882353, size: 1 },
    //     { x: 75.1079136690647, y: 4.07843137254902, size: 1 },
    //     { x: 91.294964028777, y: 3.05882352941176, size: 1 },
    //     { x: 113.956834532374, y: 4.19607843137255, size: 1 },
    //     { x: 131.438848920863, y: 4.07843137254902, size: 1 },
    //     { x: 137.913669064748, y: 4.07843137254902, size: 1 },
    //     { x: 165.755395683453, y: 4.07843137254902, size: 1 },
    //     { x: 210.431654676259, y: 4.07843137254902, size: 1 },
    //     { x: 306.906474820144, y: 2.90196078431373, size: 1 },
    //     { x: 307.553956834532, y: 2.94117647058824, size: 1 },
    //     { x: 337.338129496403, y: 3.96078431372549, size: 1 },
    //     { x: 7.13513513513514, y: 3.88235294117647, size: 1 },
    //     { x: 24, y: 4, size: 1 },
    //     { x: 38.9189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 40.8648648648649, y: 4, size: 1 },
    //     { x: 49.9459459459459, y: 4.07843137254902, size: 1 },
    //     { x: 51.2432432432432, y: 4, size: 1 },
    //     { x: 65.5135135135135, y: 3.96078431372549, size: 1 },
    //     { x: 76.5405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 119.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 120, y: 3.09803921568627, size: 1 },
    //     { x: 162.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 163.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 166.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 171.891891891892, y: 4.07843137254902, size: 1 },
    //     { x: 217.297297297297, y: 3.88235294117647, size: 1 },
    //     { x: 227.027027027027, y: 4.19607843137255, size: 1 },
    //     { x: 249.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 251.675675675676, y: 4, size: 1 },
    //     { x: 283.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 291.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 292.540540540541, y: 2.82352941176471, size: 1 },
    //     { x: 293.189189189189, y: 2.19607843137255, size: 1 },
    //     { x: 314.594594594595, y: 2.54901960784314, size: 1 },
    //     { x: 325.621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 336, y: 2.3921568627451, size: 1 },
    //     { x: 336.648648648649, y: 2.35294117647059, size: 1 },
    //     { x: 339.891891891892, y: 3.33333333333333, size: 1 },
    //     { x: 342.486486486487, y: 3.29411764705882, size: 1 },
    //     { x: 353.513513513513, y: 3.29411764705882, size: 1 },
    //     { x: 2.58992805755396, y: 4.07843137254902, size: 1 },
    //     { x: 41.4388489208633, y: 3.05882352941176, size: 1 },
    //     { x: 105.539568345324, y: 2.07843137254902, size: 1 },
    //     { x: 106.187050359712, y: 2.19607843137255, size: 1 },
    //     { x: 150.215827338129, y: 4.19607843137255, size: 1 },
    //     { x: 156.690647482014, y: 4.07843137254902, size: 1 },
    //     { x: 176.762589928058, y: 4.27450980392157, size: 1 },
    //     { x: 184.532374100719, y: 4.15686274509804, size: 1 },
    //     { x: 191.654676258993, y: 2.94117647058824, size: 1 },
    //     { x: 237.625899280576, y: 3.17647058823529, size: 1 },
    //     { x: 278.41726618705, y: 2.90196078431373, size: 1 },
    //     { x: 321.151079136691, y: 1.96078431372549, size: 1 },
    //     { x: 321.798561151079, y: 1.96078431372549, size: 1 },
    //     { x: 322.446043165468, y: 2.43137254901961, size: 1 },
    //     { x: 323.093525179856, y: 2.3921568627451, size: 1 },
    //     { x: 323.741007194245, y: 2.66666666666667, size: 1 },
    //     { x: 326.330935251799, y: 2.98039215686275, size: 1 },
    //     { x: 330.863309352518, y: 3.05882352941176, size: 1 },
    //     { x: 336.690647482014, y: 2.98039215686275, size: 1 },
    //     { x: 337.985611510791, y: 3.13725490196078, size: 1 },
    //     { x: 343.165467625899, y: 2.50980392156863, size: 1 },
    //     { x: 4.53237410071942, y: 2.3921568627451, size: 1 },
    //     { x: 5.17985611510791, y: 2.43137254901961, size: 1 },
    //     { x: 11.0071942446043, y: 3.05882352941176, size: 1 },
    //     { x: 22.6618705035971, y: 3.09803921568627, size: 1 },
    //     { x: 26.5467625899281, y: 2.82352941176471, size: 1 },
    //     { x: 47.9136690647482, y: 2.54901960784314, size: 1 },
    //     { x: 66.6906474820144, y: 4.03921568627451, size: 1 },
    //     { x: 128.848920863309, y: 4.31372549019608, size: 1 },
    //     { x: 198.776978417266, y: 2.66666666666667, size: 1 },
    //     { x: 306.906474820144, y: 2.58823529411765, size: 1 },
    //     { x: 307.553956834532, y: 2.98039215686275, size: 1 },
    //     { x: 329.568345323741, y: 3.09803921568627, size: 1 },
    //     { x: 11.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 11.6756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 12.3243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 33.0810810810811, y: 2.94117647058824, size: 1 },
    //     { x: 45.4054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 53.1891891891892, y: 3.17647058823529, size: 1 },
    //     { x: 54.4864864864865, y: 2.70588235294118, size: 1 },
    //     { x: 55.1351351351351, y: 2.11764705882353, size: 1 },
    //     { x: 75.2432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 75.8918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 76.5405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 79.7837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 86.2702702702703, y: 4.23529411764706, size: 1 },
    //     { x: 88.8648648648649, y: 4.15686274509804, size: 1 },
    //     { x: 97.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 98.5945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 127.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 128.432432432432, y: 4, size: 1 },
    //     { x: 129.72972972973, y: 4.03921568627451, size: 1 },
    //     { x: 131.675675675676, y: 4.03921568627451, size: 1 },
    //     { x: 132.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 136.216216216216, y: 4.11764705882353, size: 1 },
    //     { x: 155.027027027027, y: 4, size: 1 },
    //     { x: 167.351351351351, y: 4, size: 1 },
    //     { x: 169.945945945946, y: 4.19607843137255, size: 1 },
    //     { x: 173.837837837838, y: 4.15686274509804, size: 1 },
    //     { x: 174.486486486486, y: 3.96078431372549, size: 1 },
    //     { x: 179.675675675676, y: 3.92156862745098, size: 1 },
    //     { x: 184.216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 184.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 185.513513513514, y: 2.86274509803922, size: 1 },
    //     { x: 206.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 206.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 207.567567567568, y: 2.90196078431373, size: 1 },
    //     { x: 209.513513513514, y: 3.2156862745098, size: 1 },
    //     { x: 212.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 231.567567567568, y: 3.80392156862745, size: 1 },
    //     { x: 256.864864864865, y: 3.41176470588235, size: 1 },
    //     { x: 257.513513513513, y: 3.37254901960784, size: 1 },
    //     { x: 261.405405405405, y: 3.29411764705882, size: 1 },
    //     { x: 269.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 271.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 273.081081081081, y: 2.90196078431373, size: 1 },
    //     { x: 278.27027027027, y: 3.96078431372549, size: 1 },
    //     { x: 293.189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 313.945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 336, y: 2.43137254901961, size: 1 },
    //     { x: 343.783783783784, y: 3.29411764705882, size: 1 },
    //     { x: 347.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 358.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 359.351351351351, y: 2.90196078431373, size: 1 },
    //     { x: 18.7769784172662, y: 2.98039215686275, size: 1 },
    //     { x: 20.0719424460432, y: 2.98039215686275, size: 1 },
    //     { x: 47.9136690647482, y: 4.19607843137255, size: 1 },
    //     { x: 53.0935251798561, y: 4.03921568627451, size: 1 },
    //     { x: 54.3884892086331, y: 4.07843137254902, size: 1 },
    //     { x: 102.302158273381, y: 4.03921568627451, size: 1 },
    //     { x: 135.323741007194, y: 4.11764705882353, size: 1 },
    //     { x: 189.712230215827, y: 3.13725490196078, size: 1 },
    //     { x: 191.654676258993, y: 2.74509803921569, size: 1 },
    //     { x: 342.517985611511, y: 2.66666666666667, size: 1 },
    //     { x: 343.165467625899, y: 2.86274509803922, size: 1 },
    //     { x: 4.53237410071942, y: 3.01960784313725, size: 1 },
    //     { x: 25.8992805755396, y: 3.01960784313725, size: 1 },
    //     { x: 64.7482014388489, y: 3.2156862745098, size: 1 },
    //     { x: 90.6474820143885, y: 2.82352941176471, size: 1 },
    //     { x: 112.014388489209, y: 2.94117647058824, size: 1 },
    //     { x: 112.661870503597, y: 2.7843137254902, size: 1 },
    //     { x: 119.136690647482, y: 3.17647058823529, size: 1 },
    //     { x: 155.395683453237, y: 2.94117647058824, size: 1 },
    //     { x: 156.043165467626, y: 3.13725490196078, size: 1 },
    //     { x: 188.41726618705, y: 3.09803921568627, size: 1 },
    //     { x: 220.791366906475, y: 2.94117647058824, size: 1 },
    //     { x: 241.510791366906, y: 2.82352941176471, size: 1 },
    //     { x: 261.58273381295, y: 3.09803921568627, size: 1 },
    //     { x: 275.827338129496, y: 4.11764705882353, size: 1 },
    //     { x: 321.151079136691, y: 3.2156862745098, size: 1 },
    //     { x: 33.0215827338129, y: 2.54901960784314, size: 1 },
    //     { x: 34.3165467625899, y: 2.50980392156863, size: 1 },
    //     { x: 34.9640287769784, y: 2.50980392156863, size: 1 },
    //     { x: 39.4964028776978, y: 3.13725490196078, size: 1 },
    //     { x: 45.3237410071942, y: 3.17647058823529, size: 1 },
    //     { x: 141.798561151079, y: 4.07843137254902, size: 1 },
    //     { x: 205.251798561151, y: 2.70588235294118, size: 1 },
    //     { x: 205.89928057554, y: 2.50980392156863, size: 1 },
    //     { x: 227.26618705036, y: 2.58823529411765, size: 1 },
    //     { x: 248.63309352518, y: 2.66666666666667, size: 1 },
    //     { x: 249.280575539568, y: 2.58823529411765, size: 1 },
    //     { x: 285.539568345324, y: 4.11764705882353, size: 1 },
    //     { x: 286.187050359712, y: 4.03921568627451, size: 1 },
    //     { x: 304.31654676259, y: 4.11764705882353, size: 1 },
    //     { x: 310.143884892086, y: 4.03921568627451, size: 1 },
    //     { x: 331.510791366906, y: 3.96078431372549, size: 1 },
    //     { x: 334.748201438849, y: 2.7843137254902, size: 1 },
    //     { x: 335.395683453237, y: 2.19607843137255, size: 1 },
    //     { x: 5.18918918918919, y: 4.03921568627451, size: 1 },
    //     { x: 11.6756756756757, y: 4, size: 1 },
    //     { x: 13.6216216216216, y: 4, size: 1 },
    //     { x: 18.1621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 18.8108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 25.9459459459459, y: 4, size: 1 },
    //     { x: 38.2702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 39.5675675675676, y: 2.47058823529412, size: 1 },
    //     { x: 40.2162162162162, y: 2.47058823529412, size: 1 },
    //     { x: 49.9459459459459, y: 4.11764705882353, size: 1 },
    //     { x: 59.6756756756757, y: 3.01960784313725, size: 1 },
    //     { x: 60.3243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 61.6216216216216, y: 2.11764705882353, size: 1 },
    //     { x: 81.7297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 82.3783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 83.027027027027, y: 2.43137254901961, size: 1 },
    //     { x: 83.6756756756757, y: 2.19607843137255, size: 1 },
    //     { x: 102.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 103.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 125.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 126.486486486486, y: 2.43137254901961, size: 1 },
    //     { x: 136.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 155.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 156.324324324324, y: 3.37254901960784, size: 1 },
    //     { x: 167.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 171.243243243243, y: 4, size: 1 },
    //     { x: 171.891891891892, y: 4.23529411764706, size: 1 },
    //     { x: 186.162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 186.810810810811, y: 3.92156862745098, size: 1 },
    //     { x: 188.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 211.459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 212.756756756757, y: 2.86274509803922, size: 1 },
    //     { x: 213.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 241.945945945946, y: 4, size: 1 },
    //     { x: 245.189189189189, y: 4.11764705882353, size: 1 },
    //     { x: 252.324324324324, y: 3.96078431372549, size: 1 },
    //     { x: 259.459459459459, y: 3.96078431372549, size: 1 },
    //     { x: 267.891891891892, y: 3.92156862745098, size: 1 },
    //     { x: 270.486486486487, y: 4.03921568627451, size: 1 },
    //     { x: 275.027027027027, y: 4, size: 1 },
    //     { x: 277.621621621622, y: 2.47058823529412, size: 1 },
    //     { x: 278.27027027027, y: 2.54901960784314, size: 1 },
    //     { x: 280.216216216216, y: 4, size: 1 },
    //     { x: 280.864864864865, y: 3.96078431372549, size: 1 },
    //     { x: 283.459459459459, y: 4.03921568627451, size: 1 },
    //     { x: 284.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 288, y: 4.11764705882353, size: 1 },
    //     { x: 288.648648648649, y: 4.03921568627451, size: 1 },
    //     { x: 289.297297297297, y: 4.11764705882353, size: 1 },
    //     { x: 290.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 291.891891891892, y: 4.19607843137255, size: 1 },
    //     { x: 294.486486486487, y: 4, size: 1 },
    //     { x: 296.432432432432, y: 4.3921568627451, size: 1 },
    //     { x: 299.027027027027, y: 3.01960784313725, size: 1 },
    //     { x: 299.675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 304.864864864865, y: 4.11764705882353, size: 1 },
    //     { x: 308.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 309.405405405405, y: 4.11764705882353, size: 1 },
    //     { x: 315.243243243243, y: 4.03921568627451, size: 1 },
    //     { x: 317.837837837838, y: 3.88235294117647, size: 1 },
    //     { x: 332.108108108108, y: 4.19607843137255, size: 1 },
    //     { x: 332.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 342.486486486487, y: 2.82352941176471, size: 1 },
    //     { x: 343.135135135135, y: 2.82352941176471, size: 1 },
    //     { x: 11.6546762589928, y: 4.07843137254902, size: 1 },
    //     { x: 12.3021582733813, y: 4.07843137254902, size: 1 },
    //     { x: 13.5971223021583, y: 4.03921568627451, size: 1 },
    //     { x: 25.2517985611511, y: 3.25490196078431, size: 1 },
    //     { x: 34.3165467625899, y: 4.07843137254902, size: 1 },
    //     { x: 81.5827338129496, y: 4.03921568627451, size: 1 },
    //     { x: 91.9424460431655, y: 3.05882352941176, size: 1 },
    //     { x: 96.4748201438849, y: 3.05882352941176, size: 1 },
    //     { x: 130.791366906475, y: 3.05882352941176, size: 1 },
    //     { x: 198.129496402878, y: 3.17647058823529, size: 1 },
    //     { x: 284.892086330935, y: 2.90196078431373, size: 1 },
    //     { x: 306.258992805755, y: 2.94117647058824, size: 1 },
    //     { x: 327.625899280576, y: 3.05882352941176, size: 1 },
    //     { x: 343.812949640288, y: 4.11764705882353, size: 1 },
    //     { x: 11.0071942446043, y: 3.01960784313725, size: 1 },
    //     { x: 11.6546762589928, y: 2.7843137254902, size: 1 },
    //     { x: 21.3669064748201, y: 3.17647058823529, size: 1 },
    //     { x: 79.6402877697842, y: 3.13725490196078, size: 1 },
    //     { x: 82.8776978417266, y: 3.05882352941176, size: 1 },
    //     { x: 97.7697841726619, y: 2.74509803921569, size: 1 },
    //     { x: 98.4172661870504, y: 3.13725490196078, size: 1 },
    //     { x: 118.489208633094, y: 3.09803921568627, size: 1 },
    //     { x: 119.136690647482, y: 2.74509803921569, size: 1 },
    //     { x: 119.784172661871, y: 2.90196078431373, size: 1 },
    //     { x: 162.517985611511, y: 2.90196078431373, size: 1 },
    //     { x: 188.41726618705, y: 4.07843137254902, size: 1 },
    //     { x: 243.453237410072, y: 3.17647058823529, size: 1 },
    //     { x: 291.36690647482, y: 2.82352941176471, size: 1 },
    //     { x: 292.014388489209, y: 2.94117647058824, size: 1 },
    //     { x: 293.309352517986, y: 3.05882352941176, size: 1 },
    //     { x: 293.956834532374, y: 3.01960784313725, size: 1 },
    //     { x: 299.136690647482, y: 3.13725490196078, size: 1 },
    //     { x: 304.31654676259, y: 3.05882352941176, size: 1 },
    //     { x: 305.611510791367, y: 3.13725490196078, size: 1 },
    //     { x: 306.258992805755, y: 3.05882352941176, size: 1 },
    //     { x: 334.748201438849, y: 2.66666666666667, size: 1 },
    //     { x: 7.13513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 18.1621621621622, y: 2.74509803921569, size: 1 },
    //     { x: 39.5675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 40.2162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 42.1621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 45.4054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 48, y: 3.17647058823529, size: 1 },
    //     { x: 51.8918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 53.1891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 53.8378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 56.4324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 69.4054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 72, y: 3.2156862745098, size: 1 },
    //     { x: 75.8918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 77.1891891891892, y: 3.37254901960784, size: 1 },
    //     { x: 79.1351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 93.4054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 100.540540540541, y: 3.29411764705882, size: 1 },
    //     { x: 125.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 190.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 191.351351351351, y: 2.94117647058824, size: 1 },
    //     { x: 229.621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 231.567567567568, y: 4, size: 1 },
    //     { x: 237.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 238.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 240.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 242.594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 246.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 252.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 262.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 287.351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 322.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 330.810810810811, y: 4.07843137254902, size: 1 },
    //     { x: 338.594594594595, y: 3.2156862745098, size: 1 },
    //     { x: 354.810810810811, y: 3.88235294117647, size: 1 },
    //     { x: 3.88489208633094, y: 3.01960784313725, size: 1 },
    //     { x: 4.53237410071942, y: 2.70588235294118, size: 1 },
    //     { x: 27.841726618705, y: 2.98039215686275, size: 1 },
    //     { x: 29.136690647482, y: 3.17647058823529, size: 1 },
    //     { x: 33.6690647482014, y: 3.09803921568627, size: 1 },
    //     { x: 36.9064748201439, y: 3.17647058823529, size: 1 },
    //     { x: 42.7338129496403, y: 3.05882352941176, size: 1 },
    //     { x: 53.7410071942446, y: 3.05882352941176, size: 1 },
    //     { x: 77.0503597122302, y: 4.11764705882353, size: 1 },
    //     { x: 90.6474820143885, y: 2.98039215686275, size: 1 },
    //     { x: 93.8848920863309, y: 4.31372549019608, size: 1 },
    //     { x: 96.4748201438849, y: 4.07843137254902, size: 1 },
    //     { x: 97.7697841726619, y: 4.15686274509804, size: 1 },
    //     { x: 102.94964028777, y: 4.15686274509804, size: 1 },
    //     { x: 103.597122302158, y: 4.11764705882353, size: 1 },
    //     { x: 115.251798561151, y: 4.07843137254902, size: 1 },
    //     { x: 127.553956834532, y: 4.11764705882353, size: 1 },
    //     { x: 134.676258992806, y: 4.11764705882353, size: 1 },
    //     { x: 154.748201438849, y: 2.94117647058824, size: 1 },
    //     { x: 176.762589928058, y: 1.2156862745098, size: 1 },
    //     { x: 177.410071942446, y: 1.37254901960784, size: 1 },
    //     { x: 178.057553956835, y: 1.41176470588235, size: 1 },
    //     { x: 178.705035971223, y: 1.64705882352941, size: 1 },
    //     { x: 185.827338129496, y: 3.05882352941176, size: 1 },
    //     { x: 195.539568345324, y: 3.25490196078431, size: 1 },
    //     { x: 214.31654676259, y: 4.03921568627451, size: 1 },
    //     { x: 220.143884892086, y: 2.62745098039216, size: 1 },
    //     { x: 227.913669064748, y: 4.15686274509804, size: 1 },
    //     { x: 235.68345323741, y: 4.23529411764706, size: 1 },
    //     { x: 262.877697841727, y: 2.27450980392157, size: 1 },
    //     { x: 263.525179856115, y: 2.3921568627451, size: 1 },
    //     { x: 284.892086330935, y: 2.70588235294118, size: 1 },
    //     { x: 292.661870503597, y: 4.23529411764706, size: 1 },
    //     { x: 299.784172661871, y: 4.07843137254902, size: 1 },
    //     { x: 303.669064748201, y: 4.07843137254902, size: 1 },
    //     { x: 10.3597122302158, y: 3.05882352941176, size: 1 },
    //     { x: 11.0071942446043, y: 2.15686274509804, size: 1 },
    //     { x: 53.7410071942446, y: 2.62745098039216, size: 1 },
    //     { x: 54.3884892086331, y: 2.66666666666667, size: 1 },
    //     { x: 134.676258992806, y: 4, size: 1 },
    //     { x: 135.971223021583, y: 4, size: 1 },
    //     { x: 151.510791366906, y: 4.11764705882353, size: 1 },
    //     { x: 174.820143884892, y: 4, size: 1 },
    //     { x: 183.237410071942, y: 3.2156862745098, size: 1 },
    //     { x: 187.122302158273, y: 4.23529411764706, size: 1 },
    //     { x: 187.769784172662, y: 4.07843137254902, size: 1 },
    //     { x: 196.187050359712, y: 4.23529411764706, size: 1 },
    //     { x: 198.776978417266, y: 4.11764705882353, size: 1 },
    //     { x: 221.438848920863, y: 4.15686274509804, size: 1 },
    //     { x: 223.381294964029, y: 4.07843137254902, size: 1 },
    //     { x: 259.640287769784, y: 4.07843137254902, size: 1 },
    //     { x: 261.58273381295, y: 4.15686274509804, size: 1 },
    //     { x: 264.172661870504, y: 4.07843137254902, size: 1 },
    //     { x: 268.057553956835, y: 3.2156862745098, size: 1 },
    //     { x: 270, y: 2.70588235294118, size: 1 },
    //     { x: 291.36690647482, y: 2.94117647058824, size: 1 },
    //     { x: 313.381294964029, y: 2.35294117647059, size: 1 },
    //     { x: 336.690647482014, y: 4.15686274509804, size: 1 },
    //     { x: 21.4054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 22.7027027027027, y: 4.07843137254902, size: 1 },
    //     { x: 29.1891891891892, y: 4, size: 1 },
    //     { x: 31.7837837837838, y: 3.96078431372549, size: 1 },
    //     { x: 42.8108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 47.3513513513514, y: 3.92156862745098, size: 1 },
    //     { x: 49.2972972972973, y: 4, size: 1 },
    //     { x: 50.5945945945946, y: 3.92156862745098, size: 1 },
    //     { x: 52.5405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 74.5945945945946, y: 4, size: 1 },
    //     { x: 78.4864864864865, y: 4, size: 1 },
    //     { x: 80.4324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 83.6756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 84.972972972973, y: 4, size: 1 },
    //     { x: 85.6216216216216, y: 4, size: 1 },
    //     { x: 86.2702702702703, y: 4, size: 1 },
    //     { x: 92.1081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 99.2432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 101.189189189189, y: 3.92156862745098, size: 1 },
    //     { x: 108.324324324324, y: 4.07843137254902, size: 1 },
    //     { x: 108.972972972973, y: 4.03921568627451, size: 1 },
    //     { x: 110.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 120, y: 3.92156862745098, size: 1 },
    //     { x: 122.594594594595, y: 4.23529411764706, size: 1 },
    //     { x: 151.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 155.675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 166.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 173.189189189189, y: 3.88235294117647, size: 1 },
    //     { x: 187.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 242.594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 245.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 248.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 271.135135135135, y: 4.07843137254902, size: 1 },
    //     { x: 273.081081081081, y: 3.96078431372549, size: 1 },
    //     { x: 341.837837837838, y: 3.29411764705882, size: 1 },
    //     { x: 348.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 173.525179856115, y: 4.11764705882353, size: 1 },
    //     { x: 182.589928057554, y: 4.11764705882353, size: 1 },
    //     { x: 285.539568345324, y: 2.7843137254902, size: 1 },
    //     { x: 305.611510791367, y: 2.50980392156863, size: 1 },
    //     { x: 306.258992805755, y: 2.43137254901961, size: 1 },
    //     { x: 54.3884892086331, y: 2.74509803921569, size: 1 },
    //     { x: 75.7553956834532, y: 3.17647058823529, size: 1 },
    //     { x: 95.8273381294964, y: 3.17647058823529, size: 1 },
    //     { x: 118.489208633094, y: 2.98039215686275, size: 1 },
    //     { x: 119.136690647482, y: 2.66666666666667, size: 1 },
    //     { x: 183.237410071942, y: 3.05882352941176, size: 1 },
    //     { x: 226.618705035971, y: 2.86274509803922, size: 1 },
    //     { x: 229.856115107914, y: 4.15686274509804, size: 1 },
    //     { x: 232.446043165468, y: 4.35294117647059, size: 1 },
    //     { x: 236.978417266187, y: 4.11764705882353, size: 1 },
    //     { x: 291.36690647482, y: 2.90196078431373, size: 1 },
    //     { x: 5.83783783783784, y: 3.96078431372549, size: 1 },
    //     { x: 18.1621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 28.5405405405405, y: 4.03921568627451, size: 1 },
    //     { x: 38.9189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 60.972972972973, y: 2.90196078431373, size: 1 },
    //     { x: 104.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 105.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 107.027027027027, y: 3.33333333333333, size: 1 },
    //     { x: 125.837837837838, y: 2.98039215686275, size: 1 },
    //     { x: 141.405405405405, y: 3.37254901960784, size: 1 },
    //     { x: 147.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 147.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 168.648648648649, y: 2.43137254901961, size: 1 },
    //     { x: 169.297297297297, y: 2.15686274509804, size: 1 },
    //     { x: 177.081081081081, y: 3.92156862745098, size: 1 },
    //     { x: 190.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 190.702702702703, y: 2.58823529411765, size: 1 },
    //     { x: 212.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 233.513513513514, y: 2.3921568627451, size: 1 },
    //     { x: 234.162162162162, y: 2.43137254901961, size: 1 },
    //     { x: 237.405405405405, y: 3.92156862745098, size: 1 },
    //     { x: 253.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 254.27027027027, y: 3.01960784313725, size: 1 },
    //     { x: 254.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 255.567567567568, y: 2.03921568627451, size: 1 },
    //     { x: 276.972972972973, y: 2.58823529411765, size: 1 },
    //     { x: 277.621621621622, y: 2, size: 1 },
    //     { x: 290.594594594595, y: 4.07843137254902, size: 1 },
    //     { x: 297.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 318.486486486487, y: 3.17647058823529, size: 1 },
    //     { x: 334.054054054054, y: 4.03921568627451, size: 1 },
    //     { x: 44.0287769784173, y: 4.19607843137255, size: 1 },
    //     { x: 306.258992805755, y: 2.47058823529412, size: 1 },
    //     { x: 327.625899280576, y: 2.90196078431373, size: 1 },
    //     { x: 348.992805755396, y: 3.25490196078431, size: 1 },
    //     { x: 55.6834532374101, y: 2.82352941176471, size: 1 },
    //     { x: 96.4748201438849, y: 2.7843137254902, size: 1 },
    //     { x: 161.223021582734, y: 2.98039215686275, size: 1 },
    //     { x: 38.9189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 60.3243243243243, y: 3.25490196078431, size: 1 },
    //     { x: 60.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 101.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 103.783783783784, y: 2.70588235294118, size: 1 },
    //     { x: 104.432432432432, y: 2.74509803921569, size: 1 },
    //     { x: 125.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 126.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 127.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 147.243243243243, y: 2.86274509803922, size: 1 },
    //     { x: 168.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 212.108108108108, y: 4, size: 1 },
    //     { x: 233.513513513514, y: 3.37254901960784, size: 1 },
    //     { x: 234.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 255.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 310.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 86.1151079136691, y: 3.96078431372549, size: 1 },
    //     { x: 89.3525179856115, y: 2.66666666666667, size: 1 },
    //     { x: 90, y: 2.70588235294118, size: 1 },
    //     { x: 102.94964028777, y: 3.92156862745098, size: 1 },
    //     { x: 132.73381294964, y: 2.50980392156863, size: 1 },
    //     { x: 133.381294964029, y: 2.66666666666667, size: 1 },
    //     { x: 281.007194244604, y: 4.11764705882353, size: 1 },
    //     { x: 305.611510791367, y: 2.90196078431373, size: 1 },
    //     { x: 326.978417266187, y: 2.90196078431373, size: 1 },
    //     { x: 10.3783783783784, y: 2.82352941176471, size: 1 },
    //     { x: 30.4864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 31.1351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 31.7837837837838, y: 0.666666666666667, size: 1 },
    //     { x: 32.4324324324324, y: 0.470588235294118, size: 1 },
    //     { x: 33.0810810810811, y: 0.941176470588235, size: 1 },
    //     { x: 33.7297297297297, y: 1.05882352941176, size: 1 },
    //     { x: 40.8648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 41.5135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 47.3513513513514, y: 2.70588235294118, size: 1 },
    //     { x: 48, y: 2.98039215686275, size: 1 },
    //     { x: 50.5945945945946, y: 3.25490196078431, size: 1 },
    //     { x: 51.2432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 51.8918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 52.5405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 53.1891891891892, y: 2.07843137254902, size: 1 },
    //     { x: 53.8378378378378, y: 1.88235294117647, size: 1 },
    //     { x: 75.2432432432432, y: 2.82352941176471, size: 1 },
    //     { x: 96, y: 3.17647058823529, size: 1 },
    //     { x: 96.6486486486486, y: 2.86274509803922, size: 1 },
    //     { x: 97.2972972972973, y: 2.90196078431373, size: 1 },
    //     { x: 118.702702702703, y: 2.62745098039216, size: 1 },
    //     { x: 140.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 161.513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 162.162162162162, y: 2.70588235294118, size: 1 },
    //     { x: 181.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 182.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 182.918918918919, y: 2.66666666666667, size: 1 },
    //     { x: 183.567567567568, y: 2.58823529411765, size: 1 },
    //     { x: 193.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 197.837837837838, y: 3.25490196078431, size: 1 },
    //     { x: 203.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 203.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 204.324324324324, y: 2.94117647058824, size: 1 },
    //     { x: 204.972972972973, y: 2.31372549019608, size: 1 },
    //     { x: 205.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 227.027027027027, y: 2.74509803921569, size: 1 },
    //     { x: 228.324324324324, y: 4.19607843137255, size: 1 },
    //     { x: 230.27027027027, y: 4, size: 1 },
    //     { x: 230.918918918919, y: 4.23529411764706, size: 1 },
    //     { x: 238.702702702703, y: 3.96078431372549, size: 1 },
    //     { x: 247.783783783784, y: 2.43137254901961, size: 1 },
    //     { x: 248.432432432432, y: 2.66666666666667, size: 1 },
    //     { x: 251.675675675676, y: 4.19607843137255, size: 1 },
    //     { x: 254.27027027027, y: 4.31372549019608, size: 1 },
    //     { x: 256.216216216216, y: 4.07843137254902, size: 1 },
    //     { x: 256.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 258.162162162162, y: 4, size: 1 },
    //     { x: 259.459459459459, y: 4.07843137254902, size: 1 },
    //     { x: 260.756756756757, y: 3.96078431372549, size: 1 },
    //     { x: 261.405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 263.351351351351, y: 3.96078431372549, size: 1 },
    //     { x: 265.945945945946, y: 3.96078431372549, size: 1 },
    //     { x: 266.594594594595, y: 4, size: 1 },
    //     { x: 267.243243243243, y: 4.07843137254902, size: 1 },
    //     { x: 269.837837837838, y: 2.74509803921569, size: 1 },
    //     { x: 289.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 291.243243243243, y: 2.35294117647059, size: 1 },
    //     { x: 291.891891891892, y: 2.58823529411765, size: 1 },
    //     { x: 297.72972972973, y: 3.96078431372549, size: 1 },
    //     { x: 298.378378378378, y: 4.19607843137255, size: 1 },
    //     { x: 302.918918918919, y: 4.19607843137255, size: 1 },
    //     { x: 304.864864864865, y: 4.23529411764706, size: 1 },
    //     { x: 312.648648648649, y: 3.05882352941176, size: 1 },
    //     { x: 315.891891891892, y: 4.03921568627451, size: 1 },
    //     { x: 326.918918918919, y: 4.07843137254902, size: 1 },
    //     { x: 60.863309352518, y: 2.66666666666667, size: 1 },
    //     { x: 62.158273381295, y: 2.86274509803922, size: 1 },
    //     { x: 82.2302158273381, y: 2.86274509803922, size: 1 },
    //     { x: 147.625899280576, y: 3.01960784313725, size: 1 },
    //     { x: 216.906474820144, y: 4.03921568627451, size: 1 },
    //     { x: 225.971223021583, y: 4.03921568627451, size: 1 },
    //     { x: 233.741007194245, y: 2.90196078431373, size: 1 },
    //     { x: 238.920863309353, y: 3.92156862745098, size: 1 },
    //     { x: 239.568345323741, y: 4.11764705882353, size: 1 },
    //     { x: 249.280575539568, y: 4.07843137254902, size: 1 },
    //     { x: 271.942446043165, y: 4.15686274509804, size: 1 },
    //     { x: 273.237410071942, y: 4.07843137254902, size: 1 },
    //     { x: 284.892086330935, y: 4.03921568627451, size: 1 },
    //     { x: 286.834532374101, y: 4.07843137254902, size: 1 },
    //     { x: 289.424460431655, y: 3.92156862745098, size: 1 },
    //     { x: 301.726618705036, y: 4.11764705882353, size: 1 },
    //     { x: 307.553956834532, y: 4, size: 1 },
    //     { x: 328.273381294964, y: 4, size: 1 },
    //     { x: 338.63309352518, y: 4.11764705882353, size: 1 },
    //     { x: 350.935251798561, y: 4.03921568627451, size: 1 },
    //     { x: 154.10071942446, y: 2.94117647058824, size: 1 },
    //     { x: 305.611510791367, y: 2.7843137254902, size: 1 },
    //     { x: 53.0935251798561, y: 2.94117647058824, size: 1 },
    //     { x: 54.3884892086331, y: 2.86274509803922, size: 1 },
    //     { x: 123.669064748201, y: 4.07843137254902, size: 1 },
    //     { x: 206.546762589928, y: 3.96078431372549, size: 1 },
    //     { x: 233.093525179856, y: 4, size: 1 },
    //     { x: 234.388489208633, y: 4.03921568627451, size: 1 },
    //     { x: 243.453237410072, y: 4.19607843137255, size: 1 },
    //     { x: 244.748201438849, y: 4.23529411764706, size: 1 },
    //     { x: 319.208633093525, y: 4.07843137254902, size: 1 },
    //     { x: 14.2702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 17.5135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 21.4054054054054, y: 3.96078431372549, size: 1 },
    //     { x: 28.5405405405405, y: 3.96078431372549, size: 1 },
    //     { x: 29.1891891891892, y: 4.19607843137255, size: 1 },
    //     { x: 58.3783783783784, y: 3.33333333333333, size: 1 },
    //     { x: 64.2162162162162, y: 3.96078431372549, size: 1 },
    //     { x: 64.8648648648649, y: 4, size: 1 },
    //     { x: 71.3513513513514, y: 4, size: 1 },
    //     { x: 162.162162162162, y: 4.03921568627451, size: 1 },
    //     { x: 168, y: 3.13725490196078, size: 1 },
    //     { x: 197.837837837838, y: 4.07843137254902, size: 1 },
    //     { x: 232.864864864865, y: 2.82352941176471, size: 1 },
    //     { x: 233.513513513514, y: 2.70588235294118, size: 1 },
    //     { x: 254.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 275.027027027027, y: 3.92156862745098, size: 1 },
    //     { x: 280.216216216216, y: 4.03921568627451, size: 1 },
    //     { x: 319.783783783784, y: 2.82352941176471, size: 1 },
    //     { x: 340.540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 341.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 341.837837837838, y: 3.05882352941176, size: 1 },
    //     { x: 42.7338129496403, y: 3.17647058823529, size: 1 },
    //     { x: 45.9712230215827, y: 2.27450980392157, size: 1 },
    //     { x: 46.6187050359712, y: 2, size: 1 },
    //     { x: 100.359712230216, y: 4.11764705882353, size: 1 },
    //     { x: 154.10071942446, y: 2.7843137254902, size: 1 },
    //     { x: 175.467625899281, y: 2.74509803921569, size: 1 },
    //     { x: 176.115107913669, y: 2.70588235294118, size: 1 },
    //     { x: 178.705035971223, y: 3.05882352941176, size: 1 },
    //     { x: 190.359712230216, y: 3.17647058823529, size: 1 },
    //     { x: 196.834532374101, y: 2.82352941176471, size: 1 },
    //     { x: 218.848920863309, y: 2.50980392156863, size: 1 },
    //     { x: 308.848920863309, y: 3.09803921568627, size: 1 },
    //     { x: 312.73381294964, y: 3.09803921568627, size: 1 },
    //     { x: 313.381294964029, y: 3.09803921568627, size: 1 },
    //     { x: 326.978417266187, y: 3.09803921568627, size: 1 },
    //     { x: 348.345323741007, y: 2.70588235294118, size: 1 },
    //     { x: 95.8273381294964, y: 2.7843137254902, size: 1 },
    //     { x: 96.4748201438849, y: 2.74509803921569, size: 1 },
    //     { x: 117.841726618705, y: 3.05882352941176, size: 1 },
    //     { x: 209.784172661871, y: 3.05882352941176, size: 1 },
    //     { x: 249.280575539568, y: 3.09803921568627, size: 1 },
    //     { x: 291.36690647482, y: 3.13725490196078, size: 1 },
    //     { x: 339.928057553957, y: 3.17647058823529, size: 1 },
    //     { x: 341.870503597122, y: 3.17647058823529, size: 1 },
    //     { x: 2.58992805755396, y: 4.15686274509804, size: 1 },
    //     { x: 59.568345323741, y: 2.74509803921569, size: 1 },
    //     { x: 60.2158273381295, y: 2.90196078431373, size: 1 },
    //     { x: 81.5827338129496, y: 2.54901960784314, size: 1 },
    //     { x: 82.2302158273381, y: 2.62745098039216, size: 1 },
    //     { x: 83.5251798561151, y: 2.7843137254902, size: 1 },
    //     { x: 159.280575539568, y: 3.09803921568627, size: 1 },
    //     { x: 170.935251798561, y: 4.15686274509804, size: 1 },
    //     { x: 178.057553956835, y: 4.11764705882353, size: 1 },
    //     { x: 180, y: 4.11764705882353, size: 1 },
    //     { x: 213.021582733813, y: 2.74509803921569, size: 1 },
    //     { x: 232.446043165468, y: 2.82352941176471, size: 1 },
    //     { x: 341.870503597122, y: 2.82352941176471, size: 1 },
    //     { x: 342.517985611511, y: 3.05882352941176, size: 1 },
    //     { x: 1.94594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 2.59459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 24, y: 3.29411764705882, size: 1 },
    //     { x: 25.2972972972973, y: 3.96078431372549, size: 1 },
    //     { x: 36.3243243243243, y: 3.96078431372549, size: 1 },
    //     { x: 59.6756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 96, y: 4.03921568627451, size: 1 },
    //     { x: 100.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 132.324324324324, y: 2.94117647058824, size: 1 },
    //     { x: 133.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 134.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 137.513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 138.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 142.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 142.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 150.486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 153.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 153.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 154.378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 155.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 160.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 175.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 199.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 204.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 238.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 240, y: 2.98039215686275, size: 1 },
    //     { x: 260.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 261.405405405405, y: 2.50980392156863, size: 1 },
    //     { x: 262.054054054054, y: 2.58823529411765, size: 1 },
    //     { x: 262.702702702703, y: 2.47058823529412, size: 1 },
    //     { x: 263.351351351351, y: 2.35294117647059, size: 1 },
    //     { x: 284.756756756757, y: 3.88235294117647, size: 1 },
    //     { x: 286.702702702703, y: 4.07843137254902, size: 1 },
    //     { x: 288.648648648649, y: 4.19607843137255, size: 1 },
    //     { x: 290.594594594595, y: 4.11764705882353, size: 1 },
    //     { x: 295.783783783784, y: 4.07843137254902, size: 1 },
    //     { x: 300.324324324324, y: 4.03921568627451, size: 1 },
    //     { x: 302.27027027027, y: 4.11764705882353, size: 1 },
    //     { x: 316.540540540541, y: 3.92156862745098, size: 1 },
    //     { x: 322.378378378378, y: 4, size: 1 },
    //     { x: 356.108108108108, y: 4, size: 1 },
    //     { x: 31.0791366906475, y: 2.86274509803922, size: 1 },
    //     { x: 31.726618705036, y: 3.05882352941176, size: 1 },
    //     { x: 181.942446043165, y: 3.09803921568627, size: 1 },
    //     { x: 188.41726618705, y: 4.15686274509804, size: 1 },
    //     { x: 189.064748201439, y: 4.07843137254902, size: 1 },
    //     { x: 225.971223021583, y: 3.09803921568627, size: 1 },
    //     { x: 247.338129496403, y: 1.72549019607843, size: 1 },
    //     { x: 247.985611510791, y: 1.52941176470588, size: 1 },
    //     { x: 248.63309352518, y: 1.56862745098039, size: 1 },
    //     { x: 249.280575539568, y: 2.7843137254902, size: 1 },
    //     { x: 256.402877697842, y: 2.98039215686275, size: 1 },
    //     { x: 290.071942446043, y: 3.05882352941176, size: 1 },
    //     { x: 312.086330935252, y: 2.82352941176471, size: 1 },
    //     { x: 354.820143884892, y: 3.01960784313725, size: 1 },
    //     { x: 355.467625899281, y: 2.86274509803922, size: 1 },
    //     { x: 2.59459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 12.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 13.6216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 16.2162162162162, y: 2.74509803921569, size: 1 },
    //     { x: 16.8648648648649, y: 2.15686274509804, size: 1 },
    //     { x: 18.8108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 24.6486486486486, y: 4.11764705882353, size: 1 },
    //     { x: 27.2432432432432, y: 4.23529411764706, size: 1 },
    //     { x: 29.1891891891892, y: 4.11764705882353, size: 1 },
    //     { x: 29.8378378378378, y: 4.03921568627451, size: 1 },
    //     { x: 33.0810810810811, y: 4.03921568627451, size: 1 },
    //     { x: 33.7297297297297, y: 4, size: 1 },
    //     { x: 35.027027027027, y: 4, size: 1 },
    //     { x: 35.6756756756757, y: 4.03921568627451, size: 1 },
    //     { x: 36.3243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 37.6216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 38.2702702702703, y: 1.96078431372549, size: 1 },
    //     { x: 38.9189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 86.2702702702703, y: 4.03921568627451, size: 1 },
    //     { x: 102.486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 103.135135135135, y: 2.74509803921569, size: 1 },
    //     { x: 105.081081081081, y: 4, size: 1 },
    //     { x: 110.27027027027, y: 4.07843137254902, size: 1 },
    //     { x: 116.108108108108, y: 4, size: 1 },
    //     { x: 121.945945945946, y: 4.03921568627451, size: 1 },
    //     { x: 124.540540540541, y: 2.3921568627451, size: 1 },
    //     { x: 125.189189189189, y: 2.50980392156863, size: 1 },
    //     { x: 254.27027027027, y: 2.7843137254902, size: 1 },
    //     { x: 255.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 256.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 260.108108108108, y: 3.96078431372549, size: 1 },
    //     { x: 264.648648648649, y: 3.96078431372549, size: 1 },
    //     { x: 269.189189189189, y: 4, size: 1 },
    //     { x: 269.837837837838, y: 4.03921568627451, size: 1 },
    //     { x: 271.135135135135, y: 3.88235294117647, size: 1 },
    //     { x: 272.432432432432, y: 4.07843137254902, size: 1 },
    //     { x: 274.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 275.675675675676, y: 2.62745098039216, size: 1 },
    //     { x: 276.324324324324, y: 2.90196078431373, size: 1 },
    //     { x: 276.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 277.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 299.027027027027, y: 3.88235294117647, size: 1 },
    //     { x: 301.621621621622, y: 4.07843137254902, size: 1 },
    //     { x: 319.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 340.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 341.189189189189, y: 2.98039215686275, size: 1 },
    //     { x: 116.546762589928, y: 4, size: 1 },
    //     { x: 132.73381294964, y: 3.01960784313725, size: 1 },
    //     { x: 133.381294964029, y: 2.90196078431373, size: 1 },
    //     { x: 159.928057553957, y: 4.07843137254902, size: 1 },
    //     { x: 198.129496402878, y: 2.82352941176471, size: 1 },
    //     { x: 198.776978417266, y: 3.01960784313725, size: 1 },
    //     { x: 218.201438848921, y: 2.90196078431373, size: 1 },
    //     { x: 220.143884892086, y: 2.7843137254902, size: 1 },
    //     { x: 240.215827338129, y: 3.01960784313725, size: 1 },
    //     { x: 241.510791366906, y: 4.07843137254902, size: 1 },
    //     { x: 247.338129496403, y: 4.15686274509804, size: 1 },
    //     { x: 249.928057553957, y: 4.23529411764706, size: 1 },
    //     { x: 250.575539568345, y: 4.23529411764706, size: 1 },
    //     { x: 252.517985611511, y: 4.19607843137255, size: 1 },
    //     { x: 253.165467625899, y: 3.96078431372549, size: 1 },
    //     { x: 255.107913669065, y: 4.07843137254902, size: 1 },
    //     { x: 280.359712230216, y: 4.07843137254902, size: 1 },
    //     { x: 342.517985611511, y: 4.03921568627451, size: 1 },
    //     { x: 66.0431654676259, y: 4.03921568627451, size: 1 },
    //     { x: 129.496402877698, y: 4.07843137254902, size: 1 },
    //     { x: 140.503597122302, y: 2.98039215686275, size: 1 },
    //     { x: 207.194244604317, y: 4, size: 1 },
    //     { x: 215.611510791367, y: 4.07843137254902, size: 1 },
    //     { x: 226.618705035971, y: 4.03921568627451, size: 1 },
    //     { x: 238.920863309353, y: 4.19607843137255, size: 1 },
    //     { x: 288.776978417266, y: 3.09803921568627, size: 1 },
    //     { x: 290.719424460432, y: 2.50980392156863, size: 1 },
    //     { x: 291.36690647482, y: 2.58823529411765, size: 1 },
    //     { x: 292.014388489209, y: 2.7843137254902, size: 1 },
    //     { x: 16.2162162162162, y: 2.82352941176471, size: 1 },
    //     { x: 16.8648648648649, y: 2.86274509803922, size: 1 },
    //     { x: 38.2702702702703, y: 2.43137254901961, size: 1 },
    //     { x: 42.1621621621622, y: 3.96078431372549, size: 1 },
    //     { x: 49.9459459459459, y: 3.92156862745098, size: 1 },
    //     { x: 53.1891891891892, y: 3.96078431372549, size: 1 },
    //     { x: 53.8378378378378, y: 4.23529411764706, size: 1 },
    //     { x: 57.0810810810811, y: 4, size: 1 },
    //     { x: 59.6756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 81.0810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 83.6756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 124.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 189.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 195.243243243243, y: 3.13725490196078, size: 1 },
    //     { x: 201.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 210.810810810811, y: 2.62745098039216, size: 1 },
    //     { x: 211.459459459459, y: 2.82352941176471, size: 1 },
    //     { x: 212.108108108108, y: 2.62745098039216, size: 1 },
    //     { x: 232.216216216216, y: 2.27450980392157, size: 1 },
    //     { x: 232.864864864865, y: 2, size: 1 },
    //     { x: 236.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 242.594594594595, y: 4.03921568627451, size: 1 },
    //     { x: 247.783783783784, y: 4.31372549019608, size: 1 },
    //     { x: 250.378378378378, y: 4, size: 1 },
    //     { x: 271.135135135135, y: 3.33333333333333, size: 1 },
    //     { x: 275.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 297.081081081081, y: 2.62745098039216, size: 1 },
    //     { x: 318.486486486487, y: 3.05882352941176, size: 1 },
    //     { x: 323.675675675676, y: 4.19607843137255, size: 1 },
    //     { x: 332.108108108108, y: 4.03921568627451, size: 1 },
    //     { x: 336, y: 3.96078431372549, size: 1 },
    //     { x: 337.945945945946, y: 3.88235294117647, size: 1 },
    //     { x: 2.58992805755396, y: 3.05882352941176, size: 1 },
    //     { x: 23.9568345323741, y: 2.7843137254902, size: 1 },
    //     { x: 34.9640287769784, y: 4.15686274509804, size: 1 },
    //     { x: 55.0359712230216, y: 4, size: 1 },
    //     { x: 56.9784172661871, y: 4.15686274509804, size: 1 },
    //     { x: 62.158273381295, y: 3.96078431372549, size: 1 },
    //     { x: 69.9280575539568, y: 4.15686274509804, size: 1 },
    //     { x: 117.841726618705, y: 4.19607843137255, size: 1 },
    //     { x: 119.136690647482, y: 4.19607843137255, size: 1 },
    //     { x: 124.31654676259, y: 4.11764705882353, size: 1 },
    //     { x: 126.906474820144, y: 4.15686274509804, size: 1 },
    //     { x: 175.467625899281, y: 2.50980392156863, size: 1 },
    //     { x: 196.187050359712, y: 2.70588235294118, size: 1 },
    //     { x: 196.834532374101, y: 2.43137254901961, size: 1 },
    //     { x: 218.201438848921, y: 3.01960784313725, size: 1 },
    //     { x: 239.568345323741, y: 3.09803921568627, size: 1 },
    //     { x: 260.935251798561, y: 2.62745098039216, size: 1 },
    //     { x: 261.58273381295, y: 2.07843137254902, size: 1 },
    //     { x: 298.489208633094, y: 4.07843137254902, size: 1 },
    //     { x: 299.784172661871, y: 4.15686274509804, size: 1 },
    //     { x: 304.31654676259, y: 2.23529411764706, size: 1 },
    //     { x: 304.964028776978, y: 2.50980392156863, size: 1 },
    //     { x: 326.330935251799, y: 2.94117647058824, size: 1 },
    //     { x: 341.870503597122, y: 4.23529411764706, size: 1 },
    //     { x: 347.05035971223, y: 3.17647058823529, size: 1 },
    //     { x: 347.697841726619, y: 3.05882352941176, size: 1 },
    //     { x: 9.71223021582734, y: 2.62745098039216, size: 1 },
    //     { x: 30.431654676259, y: 2.58823529411765, size: 1 },
    //     { x: 31.0791366906475, y: 2.47058823529412, size: 1 },
    //     { x: 52.4460431654676, y: 2.70588235294118, size: 1 },
    //     { x: 73.1654676258993, y: 3.05882352941176, size: 1 },
    //     { x: 73.8129496402878, y: 1.88235294117647, size: 1 },
    //     { x: 74.4604316546763, y: 1.80392156862745, size: 1 },
    //     { x: 203.309352517986, y: 2.94117647058824, size: 1 },
    //     { x: 246.690647482014, y: 2.82352941176471, size: 1 },
    //     { x: 284.244604316547, y: 3.96078431372549, size: 1 },
    //     { x: 289.424460431655, y: 2.90196078431373, size: 1 },
    //     { x: 332.805755395683, y: 2.66666666666667, size: 1 },
    //     { x: 333.453237410072, y: 2.62745098039216, size: 1 },
    //     { x: 354.820143884892, y: 3.25490196078431, size: 1 },
    //     { x: 0.648648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 1.94594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 13.6216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 16.2162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 37.6216216216216, y: 2.7843137254902, size: 1 },
    //     { x: 59.6756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 110.27027027027, y: 4, size: 1 },
    //     { x: 124.540540540541, y: 3.96078431372549, size: 1 },
    //     { x: 143.351351351351, y: 4.07843137254902, size: 1 },
    //     { x: 144.648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 145.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 146.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 147.891891891892, y: 2.74509803921569, size: 1 },
    //     { x: 167.351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 168.648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 210.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 212.108108108108, y: 2.82352941176471, size: 1 },
    //     { x: 212.756756756757, y: 3.01960784313725, size: 1 },
    //     { x: 254.27027027027, y: 2.98039215686275, size: 1 },
    //     { x: 269.837837837838, y: 3.92156862745098, size: 1 },
    //     { x: 274.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 275.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 276.972972972973, y: 2.90196078431373, size: 1 },
    //     { x: 277.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 286.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 319.135135135135, y: 2.90196078431373, size: 1 },
    //     { x: 319.783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 339.891891891892, y: 3.13725490196078, size: 1 },
    //     { x: 340.540540540541, y: 2.66666666666667, size: 1 },
    //     { x: 111.36690647482, y: 2.66666666666667, size: 1 },
    //     { x: 112.014388489209, y: 2.7843137254902, size: 1 },
    //     { x: 131.438848920863, y: 2.82352941176471, size: 1 },
    //     { x: 132.086330935252, y: 3.05882352941176, size: 1 },
    //     { x: 156.043165467626, y: 4.15686274509804, size: 1 },
    //     { x: 196.187050359712, y: 3.13725490196078, size: 1 },
    //     { x: 260.935251798561, y: 2.90196078431373, size: 1 },
    //     { x: 278.41726618705, y: 4.07843137254902, size: 1 },
    //     { x: 304.31654676259, y: 2.94117647058824, size: 1 },
    //     { x: 29.136690647482, y: 4.07843137254902, size: 1 },
    //     { x: 33.0215827338129, y: 4.03921568627451, size: 1 },
    //     { x: 117.194244604317, y: 2.74509803921569, size: 1 },
    //     { x: 117.841726618705, y: 2.58823529411765, size: 1 },
    //     { x: 118.489208633094, y: 2.27450980392157, size: 1 },
    //     { x: 119.136690647482, y: 2.58823529411765, size: 1 },
    //     { x: 120.431654676259, y: 3.13725490196078, size: 1 },
    //     { x: 203.309352517986, y: 3.01960784313725, size: 1 },
    //     { x: 355.467625899281, y: 2.90196078431373, size: 1 },
    //     { x: 24.6486486486486, y: 4.03921568627451, size: 1 },
    //     { x: 57.7297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 59.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 91.4594594594595, y: 3.37254901960784, size: 1 },
    //     { x: 101.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 101.837837837838, y: 2.94117647058824, size: 1 },
    //     { x: 102.486486486486, y: 1.37254901960784, size: 1 },
    //     { x: 103.135135135135, y: 1.13725490196078, size: 1 },
    //     { x: 103.783783783784, y: 0.941176470588235, size: 1 },
    //     { x: 104.432432432432, y: 1.13725490196078, size: 1 },
    //     { x: 106.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 107.027027027027, y: 2.7843137254902, size: 1 },
    //     { x: 111.567567567568, y: 2.86274509803922, size: 1 },
    //     { x: 118.054054054054, y: 2.82352941176471, size: 1 },
    //     { x: 128.432432432432, y: 3.96078431372549, size: 1 },
    //     { x: 154.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 158.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 159.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 167.351351351351, y: 2.90196078431373, size: 1 },
    //     { x: 188.756756756757, y: 2.3921568627451, size: 1 },
    //     { x: 189.405405405405, y: 2.58823529411765, size: 1 },
    //     { x: 199.783783783784, y: 4.11764705882353, size: 1 },
    //     { x: 210.810810810811, y: 2.35294117647059, size: 1 },
    //     { x: 232.216216216216, y: 2.3921568627451, size: 1 },
    //     { x: 232.864864864865, y: 3.09803921568627, size: 1 },
    //     { x: 251.675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 252.324324324324, y: 3.33333333333333, size: 1 },
    //     { x: 253.621621621622, y: 2.86274509803922, size: 1 },
    //     { x: 269.837837837838, y: 4.15686274509804, size: 1 },
    //     { x: 300.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 302.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 318.486486486487, y: 2.54901960784314, size: 1 },
    //     { x: 319.135135135135, y: 2.27450980392157, size: 1 },
    //     { x: 322.378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 326.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 327.567567567568, y: 3.29411764705882, size: 1 },
    //     { x: 331.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 332.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 337.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 339.243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 339.891891891892, y: 2.54901960784314, size: 1 },
    //     { x: 340.540540540541, y: 2.58823529411765, size: 1 },
    //     { x: 356.756756756757, y: 3.92156862745098, size: 1 },
    //     { x: 153.453237410072, y: 2.66666666666667, size: 1 },
    //     { x: 154.10071942446, y: 2.66666666666667, size: 1 },
    //     { x: 155.395683453237, y: 2.98039215686275, size: 1 },
    //     { x: 157.985611510791, y: 3.25490196078431, size: 1 },
    //     { x: 163.812949640288, y: 3.01960784313725, size: 1 },
    //     { x: 170.935251798561, y: 3.09803921568627, size: 1 },
    //     { x: 172.230215827338, y: 3.01960784313725, size: 1 },
    //     { x: 174.820143884892, y: 2.86274509803922, size: 1 },
    //     { x: 230.503597122302, y: 3.05882352941176, size: 1 },
    //     { x: 285.539568345324, y: 3.13725490196078, size: 1 },
    //     { x: 290.071942446043, y: 3.09803921568627, size: 1 },
    //     { x: 307.553956834532, y: 3.09803921568627, size: 1 },
    //     { x: 311.438848920863, y: 3.17647058823529, size: 1 },
    //     { x: 352.877697841727, y: 3.17647058823529, size: 1 },
    //     { x: 354.172661870504, y: 3.09803921568627, size: 1 },
    //     { x: 359.352517985611, y: 3.09803921568627, size: 1 },
    //     { x: 5.17985611510791, y: 3.17647058823529, size: 1 },
    //     { x: 53.7410071942446, y: 2.98039215686275, size: 1 },
    //     { x: 94.5323741007194, y: 3.09803921568627, size: 1 },
    //     { x: 95.1798561151079, y: 2.54901960784314, size: 1 },
    //     { x: 95.8273381294964, y: 2.62745098039216, size: 1 },
    //     { x: 141.151079136691, y: 3.09803921568627, size: 1 },
    //     { x: 141.798561151079, y: 3.13725490196078, size: 1 },
    //     { x: 148.920863309353, y: 2.94117647058824, size: 1 },
    //     { x: 156.043165467626, y: 3.05882352941176, size: 1 },
    //     { x: 192.94964028777, y: 3.17647058823529, size: 1 },
    //     { x: 195.539568345324, y: 3.13725490196078, size: 1 },
    //     { x: 246.690647482014, y: 3.01960784313725, size: 1 },
    //     { x: 292.661870503597, y: 2.94117647058824, size: 1 },
    //     { x: 306.906474820144, y: 2.98039215686275, size: 1 },
    //     { x: 317.913669064748, y: 3.01960784313725, size: 1 },
    //     { x: 328.920863309353, y: 3.05882352941176, size: 1 },
    //     { x: 352.877697841727, y: 2.98039215686275, size: 1 },
    //     { x: 353.525179856115, y: 2.98039215686275, size: 1 },
    //     { x: 356.115107913669, y: 3.01960784313725, size: 1 },
    //     { x: 18.8108108108108, y: 3.33333333333333, size: 1 },
    //     { x: 19.4594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 21.4054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 22.7027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 24, y: 3.09803921568627, size: 1 },
    //     { x: 25.2972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 27.8918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 29.8378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 33.7297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 34.3783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 37.6216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 53.8378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 59.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 60.3243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 60.972972972973, y: 3.29411764705882, size: 1 },
    //     { x: 67.4594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 69.4054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 70.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 86.9189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 87.5675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 91.4594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 92.1081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 93.4054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 96.6486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 98.5945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 104.432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 107.675675675676, y: 3.33333333333333, size: 1 },
    //     { x: 108.972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 113.513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 114.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 120.648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 143.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 166.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 188.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 210.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 210.810810810811, y: 2.98039215686275, size: 1 },
    //     { x: 232.216216216216, y: 2.86274509803922, size: 1 },
    //     { x: 253.621621621622, y: 3.05882352941176, size: 1 },
    //     { x: 254.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 255.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 258.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 262.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 264.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 271.783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 272.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 275.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 275.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 296.432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 347.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 1.29496402877698, y: 2.7843137254902, size: 1 },
    //     { x: 1.94244604316547, y: 2.43137254901961, size: 1 },
    //     { x: 45.9712230215827, y: 2.98039215686275, size: 1 },
    //     { x: 61.5107913669065, y: 3.17647058823529, size: 1 },
    //     { x: 69.2805755395683, y: 3.09803921568627, size: 1 },
    //     { x: 75.1079136690647, y: 3.17647058823529, size: 1 },
    //     { x: 79.6402877697842, y: 3.05882352941176, size: 1 },
    //     { x: 88.0575539568345, y: 2.70588235294118, size: 1 },
    //     { x: 88.705035971223, y: 2.7843137254902, size: 1 },
    //     { x: 100.359712230216, y: 3.01960784313725, size: 1 },
    //     { x: 109.424460431655, y: 3.13725490196078, size: 1 },
    //     { x: 150.215827338129, y: 3.05882352941176, size: 1 },
    //     { x: 152.805755395683, y: 2.94117647058824, size: 1 },
    //     { x: 155.395683453237, y: 3.13725490196078, size: 1 },
    //     { x: 167.05035971223, y: 3.17647058823529, size: 1 },
    //     { x: 174.172661870504, y: 3.13725490196078, size: 1 },
    //     { x: 228.561151079137, y: 3.2156862745098, size: 1 },
    //     { x: 229.856115107914, y: 3.25490196078431, size: 1 },
    //     { x: 236.330935251799, y: 3.05882352941176, size: 1 },
    //     { x: 253.165467625899, y: 3.09803921568627, size: 1 },
    //     { x: 277.122302158273, y: 3.25490196078431, size: 1 },
    //     { x: 304.31654676259, y: 2.7843137254902, size: 1 },
    //     { x: 325.68345323741, y: 2.35294117647059, size: 1 },
    //     { x: 30.431654676259, y: 2.23529411764706, size: 1 },
    //     { x: 51.7985611510791, y: 2.27450980392157, size: 1 },
    //     { x: 73.1654676258993, y: 2.54901960784314, size: 1 },
    //     { x: 114.604316546763, y: 2.98039215686275, size: 1 },
    //     { x: 115.89928057554, y: 3.05882352941176, size: 1 },
    //     { x: 138.561151079137, y: 2.94117647058824, size: 1 },
    //     { x: 179.352517985612, y: 3.13725490196078, size: 1 },
    //     { x: 242.805755395683, y: 4.11764705882353, size: 1 },
    //     { x: 287.482014388489, y: 3.09803921568627, size: 1 },
    //     { x: 338.63309352518, y: 3.17647058823529, size: 1 },
    //     { x: 43.4594594594595, y: 3.17647058823529, size: 1 },
    //     { x: 44.1081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 50.5945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 55.7837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 58.3783783783784, y: 2.66666666666667, size: 1 },
    //     { x: 59.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 60.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 80.4324324324324, y: 2.70588235294118, size: 1 },
    //     { x: 81.0810810810811, y: 2.62745098039216, size: 1 },
    //     { x: 81.7297297297297, y: 2.50980392156863, size: 1 },
    //     { x: 82.3783783783784, y: 2.54901960784314, size: 1 },
    //     { x: 102.486486486486, y: 2.82352941176471, size: 1 },
    //     { x: 103.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 103.783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 104.432432432432, y: 3.25490196078431, size: 1 },
    //     { x: 108.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 121.945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 124.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 166.702702702703, y: 3.17647058823529, size: 1 },
    //     { x: 171.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 175.783783783784, y: 4, size: 1 },
    //     { x: 252.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 341.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 341.837837837838, y: 3.09803921568627, size: 1 },
    //     { x: 1.29496402877698, y: 2.86274509803922, size: 1 },
    //     { x: 1.94244604316547, y: 2.82352941176471, size: 1 },
    //     { x: 37.5539568345324, y: 3.25490196078431, size: 1 },
    //     { x: 58.9208633093525, y: 3.01960784313725, size: 1 },
    //     { x: 98.4172661870504, y: 3.09803921568627, size: 1 },
    //     { x: 99.7122302158273, y: 3.09803921568627, size: 1 },
    //     { x: 101.654676258993, y: 3.17647058823529, size: 1 },
    //     { x: 170.935251798561, y: 3.05882352941176, size: 1 },
    //     { x: 217.553956834532, y: 2.54901960784314, size: 1 },
    //     { x: 218.201438848921, y: 2.50980392156863, size: 1 },
    //     { x: 218.848920863309, y: 2.58823529411765, size: 1 },
    //     { x: 238.920863309353, y: 3.09803921568627, size: 1 },
    //     { x: 240.215827338129, y: 2.82352941176471, size: 1 },
    //     { x: 281.654676258993, y: 3.05882352941176, size: 1 },
    //     { x: 282.94964028777, y: 2.7843137254902, size: 1 },
    //     { x: 284.244604316547, y: 2.86274509803922, size: 1 },
    //     { x: 303.669064748201, y: 2.74509803921569, size: 1 },
    //     { x: 29.136690647482, y: 2.98039215686275, size: 1 },
    //     { x: 51.7985611510791, y: 2.94117647058824, size: 1 },
    //     { x: 62.158273381295, y: 4.11764705882353, size: 1 },
    //     { x: 115.89928057554, y: 2.82352941176471, size: 1 },
    //     { x: 116.546762589928, y: 2.66666666666667, size: 1 },
    //     { x: 137.26618705036, y: 3.25490196078431, size: 1 },
    //     { x: 179.352517985612, y: 3.17647058823529, size: 1 },
    //     { x: 181.294964028777, y: 2.31372549019608, size: 1 },
    //     { x: 202.661870503597, y: 2.98039215686275, size: 1 },
    //     { x: 288.776978417266, y: 2.94117647058824, size: 1 },
    //     { x: 289.424460431655, y: 3.01960784313725, size: 1 },
    //     { x: 310.143884892086, y: 2.94117647058824, size: 1 },
    //     { x: 310.791366906475, y: 2.86274509803922, size: 1 },
    //     { x: 0.648648648648649, y: 3.25490196078431, size: 1 },
    //     { x: 4.54054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 7.13513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 11.027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 14.9189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 58.3783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 79.7837837837838, y: 2.98039215686275, size: 1 },
    //     { x: 80.4324324324324, y: 2.23529411764706, size: 1 },
    //     { x: 81.0810810810811, y: 2.94117647058824, size: 1 },
    //     { x: 81.7297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 83.6756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 86.2702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 87.5675675675676, y: 3.17647058823529, size: 1 },
    //     { x: 88.2162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 91.4594594594595, y: 3.25490196078431, size: 1 },
    //     { x: 93.4054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 96.6486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 97.2972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 101.189189189189, y: 3.17647058823529, size: 1 },
    //     { x: 104.432432432432, y: 3.92156862745098, size: 1 },
    //     { x: 121.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 122.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 123.243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 123.891891891892, y: 2.82352941176471, size: 1 },
    //     { x: 144.648648648649, y: 2.86274509803922, size: 1 },
    //     { x: 145.297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 151.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 154.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 156.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 159.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 164.108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 165.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 166.702702702703, y: 2.74509803921569, size: 1 },
    //     { x: 167.351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 172.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 178.378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 183.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 184.216216216216, y: 3.09803921568627, size: 1 },
    //     { x: 184.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 185.513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 187.459459459459, y: 2.98039215686275, size: 1 },
    //     { x: 188.108108108108, y: 2.7843137254902, size: 1 },
    //     { x: 188.756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 201.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 231.567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 260.108108108108, y: 3.41176470588235, size: 1 },
    //     { x: 274.378378378378, y: 2.70588235294118, size: 1 },
    //     { x: 275.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 295.783783783784, y: 3.25490196078431, size: 1 },
    //     { x: 296.432432432432, y: 3.2156862745098, size: 1 },
    //     { x: 297.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 297.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 314.594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 317.189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 317.837837837838, y: 1.13725490196078, size: 1 },
    //     { x: 318.486486486487, y: 1.41176470588235, size: 1 },
    //     { x: 319.135135135135, y: 1.37254901960784, size: 1 },
    //     { x: 319.783783783784, y: 1.41176470588235, size: 1 },
    //     { x: 320.432432432432, y: 3.33333333333333, size: 1 },
    //     { x: 322.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 323.027027027027, y: 3.09803921568627, size: 1 },
    //     { x: 326.918918918919, y: 2.86274509803922, size: 1 },
    //     { x: 327.567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 333.405405405405, y: 2.70588235294118, size: 1 },
    //     { x: 337.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 339.891891891892, y: 2.66666666666667, size: 1 },
    //     { x: 350.918918918919, y: 3.37254901960784, size: 1 },
    //     { x: 354.162162162162, y: 3.01960784313725, size: 1 },
    //     { x: 358.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 0.647482014388489, y: 2.90196078431373, size: 1 },
    //     { x: 1.29496402877698, y: 2.74509803921569, size: 1 },
    //     { x: 23.3093525179856, y: 3.01960784313725, size: 1 },
    //     { x: 44.0287769784173, y: 2.74509803921569, size: 1 },
    //     { x: 66.0431654676259, y: 2.50980392156863, size: 1 },
    //     { x: 87.410071942446, y: 1.84313725490196, size: 1 },
    //     { x: 88.0575539568345, y: 1.96078431372549, size: 1 },
    //     { x: 88.705035971223, y: 3.09803921568627, size: 1 },
    //     { x: 90.6474820143885, y: 2.94117647058824, size: 1 },
    //     { x: 95.8273381294964, y: 2.98039215686275, size: 1 },
    //     { x: 101.007194244604, y: 3.09803921568627, size: 1 },
    //     { x: 152.158273381295, y: 2.98039215686275, size: 1 },
    //     { x: 152.805755395683, y: 2.82352941176471, size: 1 },
    //     { x: 173.525179856115, y: 2.19607843137255, size: 1 },
    //     { x: 174.172661870504, y: 2.19607843137255, size: 1 },
    //     { x: 186.474820143885, y: 4.03921568627451, size: 1 },
    //     { x: 249.280575539568, y: 3.05882352941176, size: 1 },
    //     { x: 324.388489208633, y: 3.01960784313725, size: 1 },
    //     { x: 7.76978417266187, y: 2.58823529411765, size: 1 },
    //     { x: 8.41726618705036, y: 2.43137254901961, size: 1 },
    //     { x: 25.8992805755396, y: 4, size: 1 },
    //     { x: 44.0287769784173, y: 4.03921568627451, size: 1 },
    //     { x: 51.1510791366906, y: 2.31372549019608, size: 1 },
    //     { x: 51.7985611510791, y: 2.35294117647059, size: 1 },
    //     { x: 73.1654676258993, y: 2.82352941176471, size: 1 },
    //     { x: 115.251798561151, y: 2.82352941176471, size: 1 },
    //     { x: 116.546762589928, y: 2.58823529411765, size: 1 },
    //     { x: 158.63309352518, y: 3.05882352941176, size: 1 },
    //     { x: 180.647482014388, y: 2.86274509803922, size: 1 },
    //     { x: 184.532374100719, y: 3.05882352941176, size: 1 },
    //     { x: 191.654676258993, y: 3.05882352941176, size: 1 },
    //     { x: 202.014388489209, y: 2.70588235294118, size: 1 },
    //     { x: 202.661870503597, y: 2.74509803921569, size: 1 },
    //     { x: 287.482014388489, y: 3.29411764705882, size: 1 },
    //     { x: 310.791366906475, y: 3.01960784313725, size: 1 },
    //     { x: 327.625899280576, y: 4.07843137254902, size: 1 },
    //     { x: 35.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 36.3243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 36.972972972973, y: 2.3921568627451, size: 1 },
    //     { x: 57.0810810810811, y: 3.25490196078431, size: 1 },
    //     { x: 58.3783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 111.567567567568, y: 4.03921568627451, size: 1 },
    //     { x: 121.945945945946, y: 3.2156862745098, size: 1 },
    //     { x: 123.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 126.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 144.648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 166.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 186.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 188.108108108108, y: 2.86274509803922, size: 1 },
    //     { x: 212.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 214.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 231.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 251.675675675676, y: 2.90196078431373, size: 1 },
    //     { x: 252.972972972973, y: 2.15686274509804, size: 1 },
    //     { x: 274.378378378378, y: 2.54901960784314, size: 1 },
    //     { x: 275.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 295.783783783784, y: 2.47058823529412, size: 1 },
    //     { x: 296.432432432432, y: 2.50980392156863, size: 1 },
    //     { x: 317.189189189189, y: 2.94117647058824, size: 1 },
    //     { x: 317.837837837838, y: 2.74509803921569, size: 1 },
    //     { x: 334.054054054054, y: 3.88235294117647, size: 1 },
    //     { x: 339.243243243243, y: 2.74509803921569, size: 1 },
    //     { x: 339.891891891892, y: 2.82352941176471, size: 1 },
    //     { x: 0.647482014388489, y: 2.66666666666667, size: 1 },
    //     { x: 18.1294964028777, y: 2.94117647058824, size: 1 },
    //     { x: 22.6618705035971, y: 2.66666666666667, size: 1 },
    //     { x: 33.6690647482014, y: 3.17647058823529, size: 1 },
    //     { x: 44.0287769784173, y: 2.31372549019608, size: 1 },
    //     { x: 44.6762589928058, y: 2.47058823529412, size: 1 },
    //     { x: 66.0431654676259, y: 2.70588235294118, size: 1 },
    //     { x: 67.3381294964029, y: 2.94117647058824, size: 1 },
    //     { x: 78.9928057553957, y: 3.09803921568627, size: 1 },
    //     { x: 119.136690647482, y: 3.05882352941176, size: 1 },
    //     { x: 130.143884892086, y: 2.7843137254902, size: 1 },
    //     { x: 130.791366906475, y: 2.47058823529412, size: 1 },
    //     { x: 134.028776978417, y: 2.86274509803922, size: 1 },
    //     { x: 139.208633093525, y: 3.01960784313725, size: 1 },
    //     { x: 142.446043165468, y: 3.09803921568627, size: 1 },
    //     { x: 143.741007194245, y: 2.94117647058824, size: 1 },
    //     { x: 144.388489208633, y: 3.09803921568627, size: 1 },
    //     { x: 148.920863309353, y: 3.05882352941176, size: 1 },
    //     { x: 158.63309352518, y: 3.17647058823529, size: 1 },
    //     { x: 166.402877697842, y: 3.01960784313725, size: 1 },
    //     { x: 173.525179856115, y: 2.11764705882353, size: 1 },
    //     { x: 174.172661870504, y: 2.3921568627451, size: 1 },
    //     { x: 194.892086330935, y: 2.90196078431373, size: 1 },
    //     { x: 195.539568345324, y: 2.70588235294118, size: 1 },
    //     { x: 216.258992805755, y: 2.98039215686275, size: 1 },
    //     { x: 216.906474820144, y: 2.35294117647059, size: 1 },
    //     { x: 217.553956834532, y: 2.82352941176471, size: 1 },
    //     { x: 237.625899280576, y: 2.98039215686275, size: 1 },
    //     { x: 238.273381294964, y: 2.66666666666667, size: 1 },
    //     { x: 238.920863309353, y: 2.70588235294118, size: 1 },
    //     { x: 259.640287769784, y: 2.70588235294118, size: 1 },
    //     { x: 260.287769784173, y: 2.47058823529412, size: 1 },
    //     { x: 282.302158273381, y: 3.13725490196078, size: 1 },
    //     { x: 303.669064748201, y: 2.70588235294118, size: 1 },
    //     { x: 344.460431654676, y: 3.01960784313725, size: 1 },
    //     { x: 346.402877697842, y: 2, size: 1 },
    //     { x: 7.76978417266187, y: 2.3921568627451, size: 1 },
    //     { x: 8.41726618705036, y: 2.11764705882353, size: 1 },
    //     { x: 92.589928057554, y: 3.05882352941176, size: 1 },
    //     { x: 94.5323741007194, y: 2.94117647058824, size: 1 },
    //     { x: 115.251798561151, y: 2.86274509803922, size: 1 },
    //     { x: 115.89928057554, y: 2.19607843137255, size: 1 },
    //     { x: 116.546762589928, y: 2.62745098039216, size: 1 },
    //     { x: 121.726618705036, y: 3.01960784313725, size: 1 },
    //     { x: 124.31654676259, y: 3.01960784313725, size: 1 },
    //     { x: 178.705035971223, y: 3.09803921568627, size: 1 },
    //     { x: 180.647482014388, y: 2.98039215686275, size: 1 },
    //     { x: 245.395683453237, y: 2.15686274509804, size: 1 },
    //     { x: 246.043165467626, y: 2.7843137254902, size: 1 },
    //     { x: 247.985611510791, y: 3.01960784313725, size: 1 },
    //     { x: 248.63309352518, y: 3.2156862745098, size: 1 },
    //     { x: 251.223021582734, y: 3.09803921568627, size: 1 },
    //     { x: 266.762589928058, y: 2.3921568627451, size: 1 },
    //     { x: 267.410071942446, y: 2.43137254901961, size: 1 },
    //     { x: 288.129496402878, y: 2.27450980392157, size: 1 },
    //     { x: 288.776978417266, y: 1.84313725490196, size: 1 },
    //     { x: 293.309352517986, y: 3.25490196078431, size: 1 },
    //     { x: 331.510791366906, y: 2.47058823529412, size: 1 },
    //     { x: 332.158273381295, y: 2.74509803921569, size: 1 },
    //     { x: 351.58273381295, y: 3.01960784313725, size: 1 },
    //     { x: 352.877697841727, y: 2.90196078431373, size: 1 },
    //     { x: 353.525179856115, y: 2.70588235294118, size: 1 },
    //     { x: 354.172661870504, y: 2.98039215686275, size: 1 },
    //     { x: 5.18918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 5.83783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 7.78378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 34.3783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 35.027027027027, y: 2.86274509803922, size: 1 },
    //     { x: 35.6756756756757, y: 2.94117647058824, size: 1 },
    //     { x: 36.972972972973, y: 2.43137254901961, size: 1 },
    //     { x: 64.2162162162162, y: 3.2156862745098, size: 1 },
    //     { x: 77.8378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 79.1351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 79.7837837837838, y: 2.54901960784314, size: 1 },
    //     { x: 94.7027027027027, y: 3.25490196078431, size: 1 },
    //     { x: 100.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 101.189189189189, y: 2.27450980392157, size: 1 },
    //     { x: 101.837837837838, y: 2.70588235294118, size: 1 },
    //     { x: 102.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 106.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 107.675675675676, y: 2.86274509803922, size: 1 },
    //     { x: 108.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 112.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 114.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 114.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 115.459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 121.945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 122.594594594595, y: 2.62745098039216, size: 1 },
    //     { x: 123.243243243243, y: 2.11764705882353, size: 1 },
    //     { x: 142.702702702703, y: 2.94117647058824, size: 1 },
    //     { x: 143.351351351351, y: 3.13725490196078, size: 1 },
    //     { x: 144, y: 2.7843137254902, size: 1 },
    //     { x: 144.648648648649, y: 1.68627450980392, size: 1 },
    //     { x: 190.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 198.486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 199.135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 206.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 207.567567567568, y: 3.33333333333333, size: 1 },
    //     { x: 214.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 217.297297297297, y: 3.09803921568627, size: 1 },
    //     { x: 220.540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 221.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 222.486486486486, y: 3.05882352941176, size: 1 },
    //     { x: 223.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 226.378378378378, y: 2.90196078431373, size: 1 },
    //     { x: 227.675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 230.918918918919, y: 2.94117647058824, size: 1 },
    //     { x: 238.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 271.135135135135, y: 4, size: 1 },
    //     { x: 272.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 273.081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 274.378378378378, y: 2.43137254901961, size: 1 },
    //     { x: 275.675675675676, y: 2.82352941176471, size: 1 },
    //     { x: 277.621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 278.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 278.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 279.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 281.513513513513, y: 2.94117647058824, size: 1 },
    //     { x: 282.162162162162, y: 2.90196078431373, size: 1 },
    //     { x: 282.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 284.108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 284.756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 285.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 286.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 287.351351351351, y: 3.17647058823529, size: 1 },
    //     { x: 288.648648648649, y: 2.86274509803922, size: 1 },
    //     { x: 291.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 291.891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 292.540540540541, y: 3.09803921568627, size: 1 },
    //     { x: 293.189189189189, y: 2.82352941176471, size: 1 },
    //     { x: 295.783783783784, y: 2.62745098039216, size: 1 },
    //     { x: 296.432432432432, y: 2.35294117647059, size: 1 },
    //     { x: 297.081081081081, y: 2.94117647058824, size: 1 },
    //     { x: 298.378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 299.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 302.918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 304.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 306.810810810811, y: 2.94117647058824, size: 1 },
    //     { x: 307.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 310.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 315.243243243243, y: 3.09803921568627, size: 1 },
    //     { x: 315.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 316.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 317.837837837838, y: 2.94117647058824, size: 1 },
    //     { x: 337.945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 338.594594594595, y: 2.82352941176471, size: 1 },
    //     { x: 339.243243243243, y: 2.31372549019608, size: 1 },
    //     { x: 339.891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 1.29496402877698, y: 2.70588235294118, size: 1 },
    //     { x: 21.3669064748201, y: 3.09803921568627, size: 1 },
    //     { x: 22.0143884892086, y: 2.7843137254902, size: 1 },
    //     { x: 22.6618705035971, y: 2.62745098039216, size: 1 },
    //     { x: 44.6762589928058, y: 2.90196078431373, size: 1 },
    //     { x: 50.5035971223022, y: 3.05882352941176, size: 1 },
    //     { x: 52.4460431654676, y: 3.01960784313725, size: 1 },
    //     { x: 56.3309352517986, y: 3.09803921568627, size: 1 },
    //     { x: 57.6258992805755, y: 3.17647058823529, size: 1 },
    //     { x: 86.7625899280576, y: 2.58823529411765, size: 1 },
    //     { x: 87.410071942446, y: 2.58823529411765, size: 1 },
    //     { x: 130.791366906475, y: 2.90196078431373, size: 1 },
    //     { x: 195.539568345324, y: 2.90196078431373, size: 1 },
    //     { x: 281.654676258993, y: 2.74509803921569, size: 1 },
    //     { x: 283.597122302158, y: 3.09803921568627, size: 1 },
    //     { x: 303.021582733813, y: 2.43137254901961, size: 1 },
    //     { x: 346.402877697842, y: 2.94117647058824, size: 1 },
    //     { x: 7.76978417266187, y: 2.43137254901961, size: 1 },
    //     { x: 29.7841726618705, y: 2.74509803921569, size: 1 },
    //     { x: 40.1438848920863, y: 3.13725490196078, size: 1 },
    //     { x: 42.0863309352518, y: 3.05882352941176, size: 1 },
    //     { x: 42.7338129496403, y: 3.09803921568627, size: 1 },
    //     { x: 48.5611510791367, y: 2.98039215686275, size: 1 },
    //     { x: 49.2086330935252, y: 2.90196078431373, size: 1 },
    //     { x: 50.5035971223022, y: 2.50980392156863, size: 1 },
    //     { x: 51.1510791366906, y: 2.19607843137255, size: 1 },
    //     { x: 72.5179856115108, y: 2.90196078431373, size: 1 },
    //     { x: 86.1151079136691, y: 2.86274509803922, size: 1 },
    //     { x: 89.3525179856115, y: 3.01960784313725, size: 1 },
    //     { x: 115.251798561151, y: 2.15686274509804, size: 1 },
    //     { x: 126.258992805755, y: 3.13725490196078, size: 1 },
    //     { x: 179.352517985612, y: 2.98039215686275, size: 1 },
    //     { x: 180, y: 2.58823529411765, size: 1 },
    //     { x: 180.647482014388, y: 2.27450980392157, size: 1 },
    //     { x: 244.748201438849, y: 2.86274509803922, size: 1 },
    //     { x: 245.395683453237, y: 2.86274509803922, size: 1 },
    //     { x: 287.482014388489, y: 2.94117647058824, size: 1 },
    //     { x: 288.129496402878, y: 2.66666666666667, size: 1 },
    //     { x: 288.776978417266, y: 2.3921568627451, size: 1 },
    //     { x: 294.604316546763, y: 3.01960784313725, size: 1 },
    //     { x: 330.863309352518, y: 2.7843137254902, size: 1 },
    //     { x: 332.158273381295, y: 2.66666666666667, size: 1 },
    //     { x: 337.338129496403, y: 2.98039215686275, size: 1 },
    //     { x: 339.280575539568, y: 3.09803921568627, size: 1 },
    //     { x: 352.877697841727, y: 2.43137254901961, size: 1 },
    //     { x: 353.525179856115, y: 2.35294117647059, size: 1 },
    //     { x: 14.2702702702703, y: 2.98039215686275, size: 1 },
    //     { x: 23.3513513513514, y: 4.07843137254902, size: 1 },
    //     { x: 35.6756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 36.3243243243243, y: 2.98039215686275, size: 1 },
    //     { x: 43.4594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 44.7567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 46.7027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 47.3513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 48.6486486486486, y: 3.13725490196078, size: 1 },
    //     { x: 59.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 59.6756756756757, y: 2.98039215686275, size: 1 },
    //     { x: 60.3243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 60.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 65.5135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 68.7567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 70.7027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 72.6486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 73.2972972972973, y: 2.98039215686275, size: 1 },
    //     { x: 75.8918918918919, y: 2.98039215686275, size: 1 },
    //     { x: 76.5405405405405, y: 2.94117647058824, size: 1 },
    //     { x: 77.1891891891892, y: 3.25490196078431, size: 1 },
    //     { x: 79.7837837837838, y: 2.74509803921569, size: 1 },
    //     { x: 90.1621621621622, y: 3.33333333333333, size: 1 },
    //     { x: 99.2432432432432, y: 3.29411764705882, size: 1 },
    //     { x: 100.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 101.189189189189, y: 2.50980392156863, size: 1 },
    //     { x: 104.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 105.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 108.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 109.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 112.864864864865, y: 3.01960784313725, size: 1 },
    //     { x: 125.189189189189, y: 2.98039215686275, size: 1 },
    //     { x: 129.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 129.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 136.216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 138.162162162162, y: 3.17647058823529, size: 1 },
    //     { x: 140.108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 142.054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 145.297297297297, y: 3.25490196078431, size: 1 },
    //     { x: 151.135135135135, y: 3.25490196078431, size: 1 },
    //     { x: 155.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 156.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 186.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 186.810810810811, y: 2.7843137254902, size: 1 },
    //     { x: 187.459459459459, y: 2.54901960784314, size: 1 },
    //     { x: 188.108108108108, y: 2.54901960784314, size: 1 },
    //     { x: 190.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 198.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 229.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 230.918918918919, y: 2.35294117647059, size: 1 },
    //     { x: 231.567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 232.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 236.108108108108, y: 3.29411764705882, size: 1 },
    //     { x: 237.405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 238.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 239.351351351351, y: 3.05882352941176, size: 1 },
    //     { x: 244.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 252.324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 252.972972972973, y: 2.70588235294118, size: 1 },
    //     { x: 273.72972972973, y: 2.82352941176471, size: 1 },
    //     { x: 294.486486486487, y: 2.90196078431373, size: 1 },
    //     { x: 317.189189189189, y: 2.74509803921569, size: 1 },
    //     { x: 317.837837837838, y: 2.50980392156863, size: 1 },
    //     { x: 319.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 319.783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 324.324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 325.621621621622, y: 2.94117647058824, size: 1 },
    //     { x: 327.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 328.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 329.513513513513, y: 3.09803921568627, size: 1 },
    //     { x: 330.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 331.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 334.702702702703, y: 3.01960784313725, size: 1 },
    //     { x: 336, y: 3.05882352941176, size: 1 },
    //     { x: 359.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 1.29496402877698, y: 3.17647058823529, size: 1 },
    //     { x: 25.8992805755396, y: 3.13725490196078, size: 1 },
    //     { x: 39.4964028776978, y: 2.98039215686275, size: 1 },
    //     { x: 43.3812949640288, y: 2.50980392156863, size: 1 },
    //     { x: 44.0287769784173, y: 2.3921568627451, size: 1 },
    //     { x: 86.7625899280576, y: 2.23529411764706, size: 1 },
    //     { x: 87.410071942446, y: 2.27450980392157, size: 1 },
    //     { x: 108.129496402878, y: 3.05882352941176, size: 1 },
    //     { x: 129.496402877698, y: 2.7843137254902, size: 1 },
    //     { x: 130.143884892086, y: 2.31372549019608, size: 1 },
    //     { x: 151.510791366906, y: 2.31372549019608, size: 1 },
    //     { x: 152.158273381295, y: 2.3921568627451, size: 1 },
    //     { x: 172.230215827338, y: 2.98039215686275, size: 1 },
    //     { x: 172.877697841727, y: 1.68627450980392, size: 1 },
    //     { x: 173.525179856115, y: 1.29411764705882, size: 1 },
    //     { x: 174.172661870504, y: 1.01960784313725, size: 1 },
    //     { x: 174.820143884892, y: 1.76470588235294, size: 1 },
    //     { x: 178.057553956835, y: 2.62745098039216, size: 1 },
    //     { x: 182.589928057554, y: 2.74509803921569, size: 1 },
    //     { x: 188.41726618705, y: 2.74509803921569, size: 1 },
    //     { x: 190.359712230216, y: 3.13725490196078, size: 1 },
    //     { x: 191.007194244604, y: 3.17647058823529, size: 1 },
    //     { x: 194.892086330935, y: 2.11764705882353, size: 1 },
    //     { x: 213.021582733813, y: 3.13725490196078, size: 1 },
    //     { x: 213.669064748201, y: 3.01960784313725, size: 1 },
    //     { x: 248.63309352518, y: 3.09803921568627, size: 1 },
    //     { x: 258.992805755396, y: 2.94117647058824, size: 1 },
    //     { x: 259.640287769784, y: 2.47058823529412, size: 1 },
    //     { x: 279.712230215827, y: 2.82352941176471, size: 1 },
    //     { x: 281.007194244604, y: 2.54901960784314, size: 1 },
    //     { x: 281.654676258993, y: 2.50980392156863, size: 1 },
    //     { x: 313.381294964029, y: 2.86274509803922, size: 1 },
    //     { x: 319.856115107914, y: 3.09803921568627, size: 1 },
    //     { x: 320.503597122302, y: 3.05882352941176, size: 1 },
    //     { x: 5.83783783783784, y: 3.17647058823529, size: 1 },
    //     { x: 11.027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 13.6216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 20.1081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 26.5945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 28.5405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 32.4324324324324, y: 3.2156862745098, size: 1 },
    //     { x: 48, y: 3.13725490196078, size: 1 },
    //     { x: 48.6486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 50.5945945945946, y: 2.19607843137255, size: 1 },
    //     { x: 51.2432432432432, y: 2.31372549019608, size: 1 },
    //     { x: 73.945945945946, y: 3.13725490196078, size: 1 },
    //     { x: 76.5405405405405, y: 3.09803921568627, size: 1 },
    //     { x: 86.2702702702703, y: 3.33333333333333, size: 1 },
    //     { x: 87.5675675675676, y: 3.29411764705882, size: 1 },
    //     { x: 88.8648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 92.1081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 107.675675675676, y: 3.2156862745098, size: 1 },
    //     { x: 110.918918918919, y: 3.2156862745098, size: 1 },
    //     { x: 111.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 140.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 140.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 149.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 156.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 162.162162162162, y: 2.94117647058824, size: 1 },
    //     { x: 162.810810810811, y: 3.29411764705882, size: 1 },
    //     { x: 164.756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 175.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 180.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 193.297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 202.378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 203.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 204.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 208.864864864865, y: 3.17647058823529, size: 1 },
    //     { x: 216.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 219.891891891892, y: 3.2156862745098, size: 1 },
    //     { x: 222.486486486486, y: 3.09803921568627, size: 1 },
    //     { x: 224.432432432432, y: 2.74509803921569, size: 1 },
    //     { x: 236.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 243.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 245.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 247.135135135135, y: 3.2156862745098, size: 1 },
    //     { x: 251.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 259.459459459459, y: 3.33333333333333, size: 1 },
    //     { x: 262.702702702703, y: 3.29411764705882, size: 1 },
    //     { x: 266.594594594595, y: 2.47058823529412, size: 1 },
    //     { x: 267.243243243243, y: 2.90196078431373, size: 1 },
    //     { x: 288.648648648649, y: 2.11764705882353, size: 1 },
    //     { x: 289.297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 301.621621621622, y: 3.17647058823529, size: 1 },
    //     { x: 303.567567567568, y: 3.25490196078431, size: 1 },
    //     { x: 306.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 308.108108108108, y: 3.25490196078431, size: 1 },
    //     { x: 309.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 310.054054054054, y: 2.58823529411765, size: 1 },
    //     { x: 310.702702702703, y: 2.70588235294118, size: 1 },
    //     { x: 321.72972972973, y: 3.25490196078431, size: 1 },
    //     { x: 326.918918918919, y: 3.25490196078431, size: 1 },
    //     { x: 330.162162162162, y: 2.94117647058824, size: 1 },
    //     { x: 331.459459459459, y: 2.54901960784314, size: 1 },
    //     { x: 332.108108108108, y: 1.96078431372549, size: 1 },
    //     { x: 338.594594594595, y: 3.05882352941176, size: 1 },
    //     { x: 343.135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 344.432432432432, y: 3.13725490196078, size: 1 },
    //     { x: 345.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 345.72972972973, y: 3.17647058823529, size: 1 },
    //     { x: 348.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 350.27027027027, y: 3.13725490196078, size: 1 },
    //     { x: 358.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 36.9064748201439, y: 2.58823529411765, size: 1 },
    //     { x: 70.5755395683453, y: 3.13725490196078, size: 1 },
    //     { x: 71.2230215827338, y: 3.05882352941176, size: 1 },
    //     { x: 72.5179856115108, y: 3.05882352941176, size: 1 },
    //     { x: 180.647482014388, y: 4, size: 1 },
    //     { x: 209.136690647482, y: 2.82352941176471, size: 1 },
    //     { x: 209.784172661871, y: 2.98039215686275, size: 1 },
    //     { x: 273.884892086331, y: 2.15686274509804, size: 1 },
    //     { x: 274.532374100719, y: 2.35294117647059, size: 1 },
    //     { x: 295.251798561151, y: 2.98039215686275, size: 1 },
    //     { x: 317.26618705036, y: 2.54901960784314, size: 1 },
    //     { x: 339.280575539568, y: 3.05882352941176, size: 1 },
    //     { x: 22.0143884892086, y: 2.74509803921569, size: 1 },
    //     { x: 86.7625899280576, y: 2.98039215686275, size: 1 },
    //     { x: 107.482014388489, y: 2.74509803921569, size: 1 },
    //     { x: 108.129496402878, y: 2, size: 1 },
    //     { x: 108.776978417266, y: 1.92156862745098, size: 1 },
    //     { x: 129.496402877698, y: 2.66666666666667, size: 1 },
    //     { x: 130.143884892086, y: 2.90196078431373, size: 1 },
    //     { x: 151.510791366906, y: 2.43137254901961, size: 1 },
    //     { x: 152.158273381295, y: 2.82352941176471, size: 1 },
    //     { x: 172.877697841727, y: 2.66666666666667, size: 1 },
    //     { x: 173.525179856115, y: 2.62745098039216, size: 1 },
    //     { x: 238.273381294964, y: 2.94117647058824, size: 1 },
    //     { x: 239.568345323741, y: 3.17647058823529, size: 1 },
    //     { x: 252.517985611511, y: 3.01960784313725, size: 1 },
    //     { x: 255.755395683453, y: 2.94117647058824, size: 1 },
    //     { x: 258.992805755396, y: 2.50980392156863, size: 1 },
    //     { x: 259.640287769784, y: 2.11764705882353, size: 1 },
    //     { x: 272.589928057554, y: 2.94117647058824, size: 1 },
    //     { x: 273.884892086331, y: 2.98039215686275, size: 1 },
    //     { x: 275.827338129496, y: 3.13725490196078, size: 1 },
    //     { x: 277.122302158273, y: 3.13725490196078, size: 1 },
    //     { x: 281.007194244604, y: 2.98039215686275, size: 1 },
    //     { x: 346.402877697842, y: 2.98039215686275, size: 1 },
    //     { x: 7.12230215827338, y: 1.49019607843137, size: 1 },
    //     { x: 7.76978417266187, y: 1.45098039215686, size: 1 },
    //     { x: 28.4892086330935, y: 2.47058823529412, size: 1 },
    //     { x: 29.136690647482, y: 2.74509803921569, size: 1 },
    //     { x: 71.8705035971223, y: 2.82352941176471, size: 1 },
    //     { x: 74.4604316546763, y: 3.09803921568627, size: 1 },
    //     { x: 77.6978417266187, y: 3.01960784313725, size: 1 },
    //     { x: 79.6402877697842, y: 3.25490196078431, size: 1 },
    //     { x: 91.9424460431655, y: 3.17647058823529, size: 1 },
    //     { x: 93.2374100719424, y: 2.70588235294118, size: 1 },
    //     { x: 93.8848920863309, y: 2.90196078431373, size: 1 },
    //     { x: 115.251798561151, y: 2.3921568627451, size: 1 },
    //     { x: 115.89928057554, y: 3.09803921568627, size: 1 },
    //     { x: 137.26618705036, y: 2.74509803921569, size: 1 },
    //     { x: 150.215827338129, y: 3.25490196078431, size: 1 },
    //     { x: 153.453237410072, y: 3.01960784313725, size: 1 },
    //     { x: 157.985611510791, y: 2.86274509803922, size: 1 },
    //     { x: 158.63309352518, y: 2.90196078431373, size: 1 },
    //     { x: 159.280575539568, y: 2.82352941176471, size: 1 },
    //     { x: 161.223021582734, y: 3.01960784313725, size: 1 },
    //     { x: 161.870503597122, y: 3.09803921568627, size: 1 },
    //     { x: 165.755395683453, y: 2.98039215686275, size: 1 },
    //     { x: 168.992805755396, y: 3.05882352941176, size: 1 },
    //     { x: 172.877697841727, y: 3.09803921568627, size: 1 },
    //     { x: 176.115107913669, y: 2.98039215686275, size: 1 },
    //     { x: 177.410071942446, y: 2.90196078431373, size: 1 },
    //     { x: 178.705035971223, y: 2.98039215686275, size: 1 },
    //     { x: 222.73381294964, y: 2.98039215686275, size: 1 },
    //     { x: 223.381294964029, y: 2.7843137254902, size: 1 },
    //     { x: 244.748201438849, y: 2.70588235294118, size: 1 },
    //     { x: 288.129496402878, y: 2.58823529411765, size: 1 },
    //     { x: 330.863309352518, y: 2.98039215686275, size: 1 },
    //     { x: 352.230215827338, y: 2.94117647058824, size: 1 },
    //     { x: 36.3243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 39.5675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 41.5135135135135, y: 3.17647058823529, size: 1 },
    //     { x: 42.8108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 54.4864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 55.1351351351351, y: 2.94117647058824, size: 1 },
    //     { x: 55.7837837837838, y: 3.17647058823529, size: 1 },
    //     { x: 57.0810810810811, y: 2.11764705882353, size: 1 },
    //     { x: 57.7297297297297, y: 1.88235294117647, size: 1 },
    //     { x: 63.5675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 64.2162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 64.8648648648649, y: 2.98039215686275, size: 1 },
    //     { x: 68.1081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 70.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 70.7027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 72, y: 2.90196078431373, size: 1 },
    //     { x: 73.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 74.5945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 75.2432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 76.5405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 77.1891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 77.8378378378378, y: 2.98039215686275, size: 1 },
    //     { x: 79.1351351351351, y: 1.84313725490196, size: 1 },
    //     { x: 79.7837837837838, y: 2.7843137254902, size: 1 },
    //     { x: 84.972972972973, y: 3.33333333333333, size: 1 },
    //     { x: 86.9189189189189, y: 3.49019607843137, size: 1 },
    //     { x: 100.540540540541, y: 2.86274509803922, size: 1 },
    //     { x: 101.189189189189, y: 2.62745098039216, size: 1 },
    //     { x: 117.405405405405, y: 3.33333333333333, size: 1 },
    //     { x: 120.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 121.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 122.594594594595, y: 2.54901960784314, size: 1 },
    //     { x: 165.405405405405, y: 2.90196078431373, size: 1 },
    //     { x: 166.054054054054, y: 2.98039215686275, size: 1 },
    //     { x: 186.810810810811, y: 2.58823529411765, size: 1 },
    //     { x: 187.459459459459, y: 2.70588235294118, size: 1 },
    //     { x: 208.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 210.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 222.486486486486, y: 3.25490196078431, size: 1 },
    //     { x: 223.783783783784, y: 3.2156862745098, size: 1 },
    //     { x: 225.72972972973, y: 3.09803921568627, size: 1 },
    //     { x: 227.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 228.972972972973, y: 3.2156862745098, size: 1 },
    //     { x: 230.27027027027, y: 2.27450980392157, size: 1 },
    //     { x: 230.918918918919, y: 2.3921568627451, size: 1 },
    //     { x: 231.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 233.513513513514, y: 2.94117647058824, size: 1 },
    //     { x: 234.162162162162, y: 3.13725490196078, size: 1 },
    //     { x: 236.108108108108, y: 2.98039215686275, size: 1 },
    //     { x: 236.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 238.702702702703, y: 2.98039215686275, size: 1 },
    //     { x: 243.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 247.135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 249.72972972973, y: 3.05882352941176, size: 1 },
    //     { x: 250.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 252.324324324324, y: 1.68627450980392, size: 1 },
    //     { x: 273.081081081081, y: 2.74509803921569, size: 1 },
    //     { x: 273.72972972973, y: 2.58823529411765, size: 1 },
    //     { x: 274.378378378378, y: 2.7843137254902, size: 1 },
    //     { x: 280.216216216216, y: 3.13725490196078, size: 1 },
    //     { x: 282.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 284.108108108108, y: 3.05882352941176, size: 1 },
    //     { x: 286.702702702703, y: 2.94117647058824, size: 1 },
    //     { x: 288, y: 3.25490196078431, size: 1 },
    //     { x: 293.189189189189, y: 3.09803921568627, size: 1 },
    //     { x: 297.081081081081, y: 3.01960784313725, size: 1 },
    //     { x: 300.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 302.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 304.216216216216, y: 3.33333333333333, size: 1 },
    //     { x: 306.162162162162, y: 3.05882352941176, size: 1 },
    //     { x: 306.810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 308.756756756757, y: 3.13725490196078, size: 1 },
    //     { x: 309.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 310.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 324.324324324324, y: 3.41176470588235, size: 1 },
    //     { x: 336.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 337.297297297297, y: 3.01960784313725, size: 1 },
    //     { x: 337.945945945946, y: 2.94117647058824, size: 1 },
    //     { x: 338.594594594595, y: 2.35294117647059, size: 1 },
    //     { x: 22.6618705035971, y: 3.13725490196078, size: 1 },
    //     { x: 86.1151079136691, y: 2.3921568627451, size: 1 },
    //     { x: 86.7625899280576, y: 2.35294117647059, size: 1 },
    //     { x: 129.496402877698, y: 2.70588235294118, size: 1 },
    //     { x: 130.143884892086, y: 2.50980392156863, size: 1 },
    //     { x: 151.510791366906, y: 3.01960784313725, size: 1 },
    //     { x: 172.877697841727, y: 2.43137254901961, size: 1 },
    //     { x: 194.892086330935, y: 2.58823529411765, size: 1 },
    //     { x: 302.374100719424, y: 3.13725490196078, size: 1 },
    //     { x: 28.4892086330935, y: 2.90196078431373, size: 1 },
    //     { x: 179.352517985612, y: 2.7843137254902, size: 1 },
    //     { x: 180, y: 2.50980392156863, size: 1 },
    //     { x: 328.920863309353, y: 3.01960784313725, size: 1 },
    //     { x: 330.863309352518, y: 2.35294117647059, size: 1 },
    //     { x: 332.158273381295, y: 3.01960784313725, size: 1 },
    //     { x: 25.2972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 25.9459459459459, y: 3.09803921568627, size: 1 },
    //     { x: 27.8918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 33.0810810810811, y: 3.17647058823529, size: 1 },
    //     { x: 35.6756756756757, y: 2.58823529411765, size: 1 },
    //     { x: 36.972972972973, y: 3.92156862745098, size: 1 },
    //     { x: 82.3783783783784, y: 3.05882352941176, size: 1 },
    //     { x: 84.972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 100.540540540541, y: 2.90196078431373, size: 1 },
    //     { x: 101.189189189189, y: 3.01960784313725, size: 1 },
    //     { x: 186.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 195.243243243243, y: 3.92156862745098, size: 1 },
    //     { x: 230.27027027027, y: 2.66666666666667, size: 1 },
    //     { x: 251.675675675676, y: 2.54901960784314, size: 1 },
    //     { x: 252.324324324324, y: 2.58823529411765, size: 1 },
    //     { x: 259.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 262.054054054054, y: 3.33333333333333, size: 1 },
    //     { x: 265.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 293.189189189189, y: 3.33333333333333, size: 1 },
    //     { x: 307.459459459459, y: 3.2156862745098, size: 1 },
    //     { x: 326.918918918919, y: 3.96078431372549, size: 1 },
    //     { x: 330.810810810811, y: 3.96078431372549, size: 1 },
    //     { x: 337.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 338.594594594595, y: 2.19607843137255, size: 1 },
    //     { x: 347.675675675676, y: 4.07843137254902, size: 1 },
    //     { x: 359.351351351351, y: 3.09803921568627, size: 1 },
    //     { x: 0, y: 2.54901960784314, size: 1 },
    //     { x: 86.1151079136691, y: 2.31372549019608, size: 1 },
    //     { x: 86.7625899280576, y: 2.47058823529412, size: 1 },
    //     { x: 150.863309352518, y: 2.62745098039216, size: 1 },
    //     { x: 194.244604316547, y: 2.70588235294118, size: 1 },
    //     { x: 209.784172661871, y: 4, size: 1 },
    //     { x: 258.992805755396, y: 2.7843137254902, size: 1 },
    //     { x: 301.726618705036, y: 2.70588235294118, size: 1 },
    //     { x: 302.374100719424, y: 2.35294117647059, size: 1 },
    //     { x: 323.741007194245, y: 2.62745098039216, size: 1 },
    //     { x: 27.1942446043165, y: 2.98039215686275, size: 1 },
    //     { x: 28.4892086330935, y: 1.84313725490196, size: 1 },
    //     { x: 29.136690647482, y: 1.80392156862745, size: 1 },
    //     { x: 29.7841726618705, y: 1.49019607843137, size: 1 },
    //     { x: 30.431654676259, y: 1.45098039215686, size: 1 },
    //     { x: 33.0215827338129, y: 2.7843137254902, size: 1 },
    //     { x: 38.2014388489209, y: 2.98039215686275, size: 1 },
    //     { x: 49.8561151079137, y: 1.68627450980392, size: 1 },
    //     { x: 50.5035971223022, y: 1.45098039215686, size: 1 },
    //     { x: 71.8705035971223, y: 2.47058823529412, size: 1 },
    //     { x: 93.2374100719424, y: 2.03921568627451, size: 1 },
    //     { x: 100.359712230216, y: 3.05882352941176, size: 1 },
    //     { x: 103.597122302158, y: 2.86274509803922, size: 1 },
    //     { x: 104.892086330935, y: 2.94117647058824, size: 1 },
    //     { x: 108.129496402878, y: 3.09803921568627, size: 1 },
    //     { x: 115.251798561151, y: 2.98039215686275, size: 1 },
    //     { x: 117.194244604317, y: 2.94117647058824, size: 1 },
    //     { x: 118.489208633094, y: 3.01960784313725, size: 1 },
    //     { x: 120.431654676259, y: 2.98039215686275, size: 1 },
    //     { x: 122.374100719424, y: 2.82352941176471, size: 1 },
    //     { x: 128.201438848921, y: 3.09803921568627, size: 1 },
    //     { x: 146.978417266187, y: 2.82352941176471, size: 1 },
    //     { x: 148.273381294964, y: 3.01960784313725, size: 1 },
    //     { x: 150.215827338129, y: 2.94117647058824, size: 1 },
    //     { x: 154.10071942446, y: 2.98039215686275, size: 1 },
    //     { x: 157.985611510791, y: 3.09803921568627, size: 1 },
    //     { x: 165.107913669065, y: 3.01960784313725, size: 1 },
    //     { x: 165.755395683453, y: 3.01960784313725, size: 1 },
    //     { x: 175.467625899281, y: 3.01960784313725, size: 1 },
    //     { x: 176.115107913669, y: 3.09803921568627, size: 1 },
    //     { x: 200.719424460432, y: 2.98039215686275, size: 1 },
    //     { x: 208.489208633094, y: 3.05882352941176, size: 1 },
    //     { x: 209.136690647482, y: 2.94117647058824, size: 1 },
    //     { x: 211.079136690647, y: 3.2156862745098, size: 1 },
    //     { x: 218.848920863309, y: 2.98039215686275, size: 1 },
    //     { x: 220.143884892086, y: 2.90196078431373, size: 1 },
    //     { x: 243.453237410072, y: 2.98039215686275, size: 1 },
    //     { x: 244.748201438849, y: 2.15686274509804, size: 1 },
    //     { x: 245.395683453237, y: 2.94117647058824, size: 1 },
    //     { x: 255.107913669065, y: 2.98039215686275, size: 1 },
    //     { x: 265.467625899281, y: 2.66666666666667, size: 1 },
    //     { x: 290.719424460432, y: 2.94117647058824, size: 1 },
    //     { x: 293.956834532374, y: 3.05882352941176, size: 1 },
    //     { x: 294.604316546763, y: 2.98039215686275, size: 1 },
    //     { x: 299.784172661871, y: 2.94117647058824, size: 1 },
    //     { x: 304.31654676259, y: 3.09803921568627, size: 1 },
    //     { x: 14.2702702702703, y: 2.70588235294118, size: 1 },
    //     { x: 55.1351351351351, y: 2.90196078431373, size: 1 },
    //     { x: 55.7837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 57.0810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 98.5945945945946, y: 3.17647058823529, size: 1 },
    //     { x: 99.8918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 104.432432432432, y: 4, size: 1 },
    //     { x: 121.297297297297, y: 3.05882352941176, size: 1 },
    //     { x: 121.945945945946, y: 3.01960784313725, size: 1 },
    //     { x: 122.594594594595, y: 2.70588235294118, size: 1 },
    //     { x: 123.243243243243, y: 3.2156862745098, size: 1 },
    //     { x: 125.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 128.432432432432, y: 3.17647058823529, size: 1 },
    //     { x: 130.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 133.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 138.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 140.756756756757, y: 3.17647058823529, size: 1 },
    //     { x: 143.351351351351, y: 2.62745098039216, size: 1 },
    //     { x: 144, y: 2.47058823529412, size: 1 },
    //     { x: 187.459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 214.702702702703, y: 3.25490196078431, size: 1 },
    //     { x: 226.378378378378, y: 3.2156862745098, size: 1 },
    //     { x: 251.027027027027, y: 3.2156862745098, size: 1 },
    //     { x: 263.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 264.648648648649, y: 3.29411764705882, size: 1 },
    //     { x: 97.7697841726619, y: 3.05882352941176, size: 1 },
    //     { x: 103.597122302158, y: 3.09803921568627, size: 1 },
    //     { x: 118.489208633094, y: 3.96078431372549, size: 1 },
    //     { x: 145.68345323741, y: 3.2156862745098, size: 1 },
    //     { x: 239.568345323741, y: 3.05882352941176, size: 1 },
    //     { x: 242.805755395683, y: 2.94117647058824, size: 1 },
    //     { x: 255.755395683453, y: 3.09803921568627, size: 1 },
    //     { x: 279.064748201439, y: 3.09803921568627, size: 1 },
    //     { x: 315.971223021583, y: 3.05882352941176, size: 1 },
    //     { x: 51.1510791366906, y: 2.47058823529412, size: 1 },
    //     { x: 128.201438848921, y: 4.03921568627451, size: 1 },
    //     { x: 156.690647482014, y: 3.05882352941176, size: 1 },
    //     { x: 157.338129496403, y: 2.07843137254902, size: 1 },
    //     { x: 157.985611510791, y: 1.88235294117647, size: 1 },
    //     { x: 158.63309352518, y: 1.84313725490196, size: 1 },
    //     { x: 159.280575539568, y: 1.80392156862745, size: 1 },
    //     { x: 200.719424460432, y: 2.90196078431373, size: 1 },
    //     { x: 204.604316546763, y: 3.09803921568627, size: 1 },
    //     { x: 244.10071942446, y: 2.74509803921569, size: 1 },
    //     { x: 329.568345323741, y: 3.01960784313725, size: 1 },
    //     { x: 8.43243243243243, y: 3.37254901960784, size: 1 },
    //     { x: 13.6216216216216, y: 2.7843137254902, size: 1 },
    //     { x: 57.0810810810811, y: 3.2156862745098, size: 1 },
    //     { x: 77.1891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 77.8378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 78.4864864864865, y: 2.62745098039216, size: 1 },
    //     { x: 79.1351351351351, y: 3.01960784313725, size: 1 },
    //     { x: 99.8918918918919, y: 2.58823529411765, size: 1 },
    //     { x: 100.540540540541, y: 2.54901960784314, size: 1 },
    //     { x: 105.72972972973, y: 3.2156862745098, size: 1 },
    //     { x: 108.324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 121.297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 121.945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 143.351351351351, y: 2.74509803921569, size: 1 },
    //     { x: 164.756756756757, y: 2.54901960784314, size: 1 },
    //     { x: 165.405405405405, y: 2.23529411764706, size: 1 },
    //     { x: 185.513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 186.162162162162, y: 2.7843137254902, size: 1 },
    //     { x: 192, y: 3.25490196078431, size: 1 },
    //     { x: 229.621621621622, y: 3.01960784313725, size: 1 },
    //     { x: 230.27027027027, y: 2.98039215686275, size: 1 },
    //     { x: 235.459459459459, y: 3.29411764705882, size: 1 },
    //     { x: 251.675675675676, y: 2.82352941176471, size: 1 },
    //     { x: 271.135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 272.432432432432, y: 2.74509803921569, size: 1 },
    //     { x: 273.081081081081, y: 1.96078431372549, size: 1 },
    //     { x: 275.675675675676, y: 3.13725490196078, size: 1 },
    //     { x: 276.324324324324, y: 3.05882352941176, size: 1 },
    //     { x: 278.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 279.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 286.054054054054, y: 3.2156862745098, size: 1 },
    //     { x: 287.351351351351, y: 2.90196078431373, size: 1 },
    //     { x: 290.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 291.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 291.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 293.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 295.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 302.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 305.513513513513, y: 3.09803921568627, size: 1 },
    //     { x: 311.351351351351, y: 3.33333333333333, size: 1 },
    //     { x: 313.945945945946, y: 3.29411764705882, size: 1 },
    //     { x: 316.540540540541, y: 2.58823529411765, size: 1 },
    //     { x: 318.486486486487, y: 3.13725490196078, size: 1 },
    //     { x: 319.135135135135, y: 3.09803921568627, size: 1 },
    //     { x: 321.72972972973, y: 3.13725490196078, size: 1 },
    //     { x: 328.864864864865, y: 2.98039215686275, size: 1 },
    //     { x: 329.513513513513, y: 3.25490196078431, size: 1 },
    //     { x: 337.297297297297, y: 2.82352941176471, size: 1 },
    //     { x: 337.945945945946, y: 2.3921568627451, size: 1 },
    //     { x: 19.4244604316547, y: 2.90196078431373, size: 1 },
    //     { x: 20.7194244604317, y: 2.23529411764706, size: 1 },
    //     { x: 21.3669064748201, y: 1.72549019607843, size: 1 },
    //     { x: 42.0863309352518, y: 2.62745098039216, size: 1 },
    //     { x: 42.7338129496403, y: 1.41176470588235, size: 1 },
    //     { x: 48.5611510791367, y: 3.05882352941176, size: 1 },
    //     { x: 50.5035971223022, y: 2.94117647058824, size: 1 },
    //     { x: 55.6834532374101, y: 2.94117647058824, size: 1 },
    //     { x: 56.9784172661871, y: 3.09803921568627, size: 1 },
    //     { x: 59.568345323741, y: 2.7843137254902, size: 1 },
    //     { x: 60.2158273381295, y: 3.05882352941176, size: 1 },
    //     { x: 61.5107913669065, y: 2.90196078431373, size: 1 },
    //     { x: 62.158273381295, y: 3.01960784313725, size: 1 },
    //     { x: 64.1007194244604, y: 2.62745098039216, size: 1 },
    //     { x: 64.7482014388489, y: 2.54901960784314, size: 1 },
    //     { x: 69.2805755395683, y: 3.05882352941176, size: 1 },
    //     { x: 69.9280575539568, y: 2.94117647058824, size: 1 },
    //     { x: 75.7553956834532, y: 3.01960784313725, size: 1 },
    //     { x: 76.4028776978417, y: 2.7843137254902, size: 1 },
    //     { x: 77.0503597122302, y: 3.01960784313725, size: 1 },
    //     { x: 77.6978417266187, y: 2.98039215686275, size: 1 },
    //     { x: 127.553956834532, y: 2.94117647058824, size: 1 },
    //     { x: 146.978417266187, y: 3.17647058823529, size: 1 },
    //     { x: 170.935251798561, y: 3.01960784313725, size: 1 },
    //     { x: 171.58273381295, y: 3.05882352941176, size: 1 },
    //     { x: 193.597122302158, y: 2.54901960784314, size: 1 },
    //     { x: 214.964028776978, y: 2.27450980392157, size: 1 },
    //     { x: 215.611510791367, y: 1.92156862745098, size: 1 },
    //     { x: 244.748201438849, y: 3.09803921568627, size: 1 },
    //     { x: 247.338129496403, y: 3.2156862745098, size: 1 },
    //     { x: 248.63309352518, y: 2.90196078431373, size: 1 },
    //     { x: 301.726618705036, y: 2.98039215686275, size: 1 },
    //     { x: 323.093525179856, y: 2.7843137254902, size: 1 },
    //     { x: 345.755395683453, y: 3.05882352941176, size: 1 },
    //     { x: 350.935251798561, y: 3.09803921568627, size: 1 },
    //     { x: 2.59459459459459, y: 2.94117647058824, size: 1 },
    //     { x: 3.24324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 3.89189189189189, y: 3.2156862745098, size: 1 },
    //     { x: 6.48648648648649, y: 2.86274509803922, size: 1 },
    //     { x: 7.13513513513514, y: 3.09803921568627, size: 1 },
    //     { x: 28.5405405405405, y: 2.98039215686275, size: 1 },
    //     { x: 29.1891891891892, y: 3.05882352941176, size: 1 },
    //     { x: 29.8378378378378, y: 2.90196078431373, size: 1 },
    //     { x: 31.7837837837838, y: 2.94117647058824, size: 1 },
    //     { x: 33.7297297297297, y: 2.98039215686275, size: 1 },
    //     { x: 34.3783783783784, y: 3.01960784313725, size: 1 },
    //     { x: 38.9189189189189, y: 2.98039215686275, size: 1 },
    //     { x: 39.5675675675676, y: 2.90196078431373, size: 1 },
    //     { x: 40.2162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 41.5135135135135, y: 2.86274509803922, size: 1 },
    //     { x: 44.7567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 45.4054054054054, y: 2.90196078431373, size: 1 },
    //     { x: 46.0540540540541, y: 3.05882352941176, size: 1 },
    //     { x: 46.7027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 49.9459459459459, y: 2.31372549019608, size: 1 },
    //     { x: 71.3513513513514, y: 2.90196078431373, size: 1 },
    //     { x: 92.7567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 94.054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 94.7027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 95.3513513513514, y: 2.90196078431373, size: 1 },
    //     { x: 96.6486486486486, y: 2.98039215686275, size: 1 },
    //     { x: 97.2972972972973, y: 3.25490196078431, size: 1 },
    //     { x: 98.5945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 99.2432432432432, y: 3.01960784313725, size: 1 },
    //     { x: 104.432432432432, y: 2.86274509803922, size: 1 },
    //     { x: 105.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 105.72972972973, y: 3.05882352941176, size: 1 },
    //     { x: 106.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 108.324324324324, y: 3.25490196078431, size: 1 },
    //     { x: 108.972972972973, y: 3.17647058823529, size: 1 },
    //     { x: 109.621621621622, y: 3.13725490196078, size: 1 },
    //     { x: 110.27027027027, y: 3.05882352941176, size: 1 },
    //     { x: 111.567567567568, y: 2.94117647058824, size: 1 },
    //     { x: 156.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 157.621621621622, y: 2.70588235294118, size: 1 },
    //     { x: 178.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 179.675675675676, y: 2.94117647058824, size: 1 },
    //     { x: 199.135135135135, y: 3.05882352941176, size: 1 },
    //     { x: 265.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 267.891891891892, y: 2.74509803921569, size: 1 },
    //     { x: 281.513513513513, y: 3.41176470588235, size: 1 },
    //     { x: 288, y: 2.70588235294118, size: 1 },
    //     { x: 306.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 310.054054054054, y: 3.01960784313725, size: 1 },
    //     { x: 311.351351351351, y: 2.90196078431373, size: 1 },
    //     { x: 316.540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 318.486486486487, y: 3.09803921568627, size: 1 },
    //     { x: 320.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 321.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 321.72972972973, y: 3.01960784313725, size: 1 },
    //     { x: 322.378378378378, y: 2.86274509803922, size: 1 },
    //     { x: 323.027027027027, y: 3.17647058823529, size: 1 },
    //     { x: 324.324324324324, y: 3.29411764705882, size: 1 },
    //     { x: 325.621621621622, y: 3.05882352941176, size: 1 },
    //     { x: 327.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 328.216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 330.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 14.2446043165468, y: 2.58823529411765, size: 1 },
    //     { x: 139.208633093525, y: 2.98039215686275, size: 1 },
    //     { x: 141.151079136691, y: 3.13725490196078, size: 1 },
    //     { x: 163.165467625899, y: 2.94117647058824, size: 1 },
    //     { x: 165.107913669065, y: 2.15686274509804, size: 1 },
    //     { x: 186.474820143885, y: 3.05882352941176, size: 1 },
    //     { x: 187.122302158273, y: 2.74509803921569, size: 1 },
    //     { x: 189.712230215827, y: 3.17647058823529, size: 1 },
    //     { x: 208.489208633094, y: 2.74509803921569, size: 1 },
    //     { x: 209.784172661871, y: 3.01960784313725, size: 1 },
    //     { x: 227.26618705036, y: 3.05882352941176, size: 1 },
    //     { x: 229.856115107914, y: 2.66666666666667, size: 1 },
    //     { x: 272.589928057554, y: 2.7843137254902, size: 1 },
    //     { x: 315.971223021583, y: 2.86274509803922, size: 1 },
    //     { x: 316.618705035971, y: 2.90196078431373, size: 1 },
    //     { x: 358.705035971223, y: 2.90196078431373, size: 1 },
    //     { x: 359.352517985611, y: 2.86274509803922, size: 1 },
    //     { x: 20.7194244604317, y: 2.98039215686275, size: 1 },
    //     { x: 21.3669064748201, y: 2.74509803921569, size: 1 },
    //     { x: 33.0215827338129, y: 3.05882352941176, size: 1 },
    //     { x: 85.4676258992806, y: 2.50980392156863, size: 1 },
    //     { x: 86.1151079136691, y: 2.47058823529412, size: 1 },
    //     { x: 86.7625899280576, y: 3.01960784313725, size: 1 },
    //     { x: 102.302158273381, y: 2.94117647058824, size: 1 },
    //     { x: 102.94964028777, y: 2.94117647058824, size: 1 },
    //     { x: 104.892086330935, y: 3.05882352941176, size: 1 },
    //     { x: 106.834532374101, y: 2.74509803921569, size: 1 },
    //     { x: 107.482014388489, y: 2.90196078431373, size: 1 },
    //     { x: 171.58273381295, y: 2.86274509803922, size: 1 },
    //     { x: 172.230215827338, y: 2.94117647058824, size: 1 },
    //     { x: 182.589928057554, y: 3.01960784313725, size: 1 },
    //     { x: 214.964028776978, y: 1.76470588235294, size: 1 },
    //     { x: 215.611510791367, y: 1.84313725490196, size: 1 },
    //     { x: 344.460431654676, y: 3.09803921568627, size: 1 },
    //     { x: 135.971223021583, y: 2.3921568627451, size: 1 },
    //     { x: 157.338129496403, y: 2.66666666666667, size: 1 },
    //     { x: 221.438848920863, y: 2.94117647058824, size: 1 },
    //     { x: 222.086330935252, y: 2.62745098039216, size: 1 },
    //     { x: 243.453237410072, y: 0.901960784313726, size: 1 },
    //     { x: 244.10071942446, y: 1.01960784313725, size: 1 },
    //     { x: 244.748201438849, y: 0.980392156862745, size: 1 },
    //     { x: 245.395683453237, y: 1.01960784313725, size: 1 },
    //     { x: 253.165467625899, y: 2.94117647058824, size: 1 },
    //     { x: 259.640287769784, y: 3.09803921568627, size: 1 },
    //     { x: 264.820143884892, y: 2.35294117647059, size: 1 },
    //     { x: 265.467625899281, y: 1.72549019607843, size: 1 },
    //     { x: 285.539568345324, y: 3.05882352941176, size: 1 },
    //     { x: 286.834532374101, y: 2.35294117647059, size: 1 },
    //     { x: 328.273381294964, y: 3.13725490196078, size: 1 },
    //     { x: 1.94594594594595, y: 3.92156862745098, size: 1 },
    //     { x: 12.972972972973, y: 2.58823529411765, size: 1 },
    //     { x: 34.3783783783784, y: 2.90196078431373, size: 1 },
    //     { x: 35.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 50.5945945945946, y: 4.19607843137255, size: 1 },
    //     { x: 55.7837837837838, y: 2.98039215686275, size: 1 },
    //     { x: 56.4324324324324, y: 2.58823529411765, size: 1 },
    //     { x: 77.1891891891892, y: 2.94117647058824, size: 1 },
    //     { x: 77.8378378378378, y: 2.07843137254902, size: 1 },
    //     { x: 78.4864864864865, y: 1.92156862745098, size: 1 },
    //     { x: 99.2432432432432, y: 2.58823529411765, size: 1 },
    //     { x: 120, y: 3.01960784313725, size: 1 },
    //     { x: 141.405405405405, y: 3.2156862745098, size: 1 },
    //     { x: 142.054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 142.702702702703, y: 1.92156862745098, size: 1 },
    //     { x: 143.351351351351, y: 1.72549019607843, size: 1 },
    //     { x: 228.972972972973, y: 3.05882352941176, size: 1 },
    //     { x: 272.432432432432, y: 2.54901960784314, size: 1 },
    //     { x: 273.081081081081, y: 2.27450980392157, size: 1 },
    //     { x: 293.837837837838, y: 2.43137254901961, size: 1 },
    //     { x: 294.486486486487, y: 2.35294117647059, size: 1 },
    //     { x: 301.621621621622, y: 4.11764705882353, size: 1 },
    //     { x: 303.567567567568, y: 4, size: 1 },
    //     { x: 304.864864864865, y: 4.03921568627451, size: 1 },
    //     { x: 305.513513513513, y: 4.19607843137255, size: 1 },
    //     { x: 310.054054054054, y: 4.07843137254902, size: 1 },
    //     { x: 312.648648648649, y: 4.31372549019608, size: 1 },
    //     { x: 334.054054054054, y: 4.11764705882353, size: 1 },
    //     { x: 337.297297297297, y: 2.62745098039216, size: 1 },
    //     { x: 337.945945945946, y: 2.50980392156863, size: 1 },
    //     { x: 358.702702702703, y: 2.50980392156863, size: 1 },
    //     { x: 359.351351351351, y: 1.64705882352941, size: 1 },
    //     { x: 20.7194244604317, y: 2.35294117647059, size: 1 },
    //     { x: 106.834532374101, y: 2.94117647058824, size: 1 },
    //     { x: 128.201438848921, y: 2.70588235294118, size: 1 },
    //     { x: 128.848920863309, y: 2.3921568627451, size: 1 },
    //     { x: 214.964028776978, y: 2.3921568627451, size: 1 },
    //     { x: 331.510791366906, y: 3.13725490196078, size: 1 },
    //     { x: 336.043165467626, y: 3.17647058823529, size: 1 },
    //     { x: 342.517985611511, y: 3.13725490196078, size: 1 },
    //     { x: 344.460431654676, y: 2.47058823529412, size: 1 },
    //     { x: 5.18918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 25.9459459459459, y: 3.13725490196078, size: 1 },
    //     { x: 27.8918918918919, y: 2.58823529411765, size: 1 },
    //     { x: 70.7027027027027, y: 2.50980392156863, size: 1 },
    //     { x: 71.3513513513514, y: 2.70588235294118, size: 1 },
    //     { x: 113.513513513514, y: 2.74509803921569, size: 1 },
    //     { x: 114.162162162162, y: 2.27450980392157, size: 1 },
    //     { x: 156.972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 178.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 179.027027027027, y: 2.50980392156863, size: 1 },
    //     { x: 179.675675675676, y: 3.09803921568627, size: 1 },
    //     { x: 197.837837837838, y: 3.13725490196078, size: 1 },
    //     { x: 198.486486486486, y: 3.33333333333333, size: 1 },
    //     { x: 199.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 200.432432432432, y: 2.94117647058824, size: 1 },
    //     { x: 201.081081081081, y: 3.05882352941176, size: 1 },
    //     { x: 286.702702702703, y: 2.66666666666667, size: 1 },
    //     { x: 287.351351351351, y: 2.31372549019608, size: 1 },
    //     { x: 334.054054054054, y: 4, size: 1 },
    //     { x: 52.4460431654676, y: 4.15686274509804, size: 1 },
    //     { x: 56.3309352517986, y: 2.47058823529412, size: 1 },
    //     { x: 56.9784172661871, y: 2.43137254901961, size: 1 },
    //     { x: 57.6258992805755, y: 2.43137254901961, size: 1 },
    //     { x: 100.359712230216, y: 2.7843137254902, size: 1 },
    //     { x: 143.093525179856, y: 2.35294117647059, size: 1 },
    //     { x: 185.827338129496, y: 2.86274509803922, size: 1 },
    //     { x: 186.474820143885, y: 2.90196078431373, size: 1 },
    //     { x: 251.870503597122, y: 2.86274509803922, size: 1 },
    //     { x: 252.517985611511, y: 2.3921568627451, size: 1 },
    //     { x: 315.971223021583, y: 2.70588235294118, size: 1 },
    //     { x: 359.352517985611, y: 3.13725490196078, size: 1 },
    //     { x: 37.5539568345324, y: 3.13725490196078, size: 1 },
    //     { x: 85.4676258992806, y: 2.94117647058824, size: 1 },
    //     { x: 86.7625899280576, y: 4.07843137254902, size: 1 },
    //     { x: 149.568345323741, y: 2.7843137254902, size: 1 },
    //     { x: 150.215827338129, y: 2.43137254901961, size: 1 },
    //     { x: 236.330935251799, y: 2.82352941176471, size: 1 },
    //     { x: 257.697841726619, y: 2.47058823529412, size: 1 },
    //     { x: 258.345323741007, y: 2.43137254901961, size: 1 },
    //     { x: 301.079136690647, y: 2.31372549019608, size: 1 },
    //     { x: 323.093525179856, y: 2.74509803921569, size: 1 },
    //     { x: 337.985611510791, y: 4.11764705882353, size: 1 },
    //     { x: 5.18918918918919, y: 3.33333333333333, size: 1 },
    //     { x: 5.83783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 26.5945945945946, y: 2.86274509803922, size: 1 },
    //     { x: 27.2432432432432, y: 1.96078431372549, size: 1 },
    //     { x: 27.8918918918919, y: 2.19607843137255, size: 1 },
    //     { x: 35.6756756756757, y: 4.07843137254902, size: 1 },
    //     { x: 48.6486486486486, y: 2.58823529411765, size: 1 },
    //     { x: 49.2972972972973, y: 2.50980392156863, size: 1 },
    //     { x: 70.7027027027027, y: 2.03921568627451, size: 1 },
    //     { x: 71.3513513513514, y: 2.98039215686275, size: 1 },
    //     { x: 88.8648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 90.8108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 135.567567567568, y: 2.7843137254902, size: 1 },
    //     { x: 136.216216216216, y: 3.01960784313725, size: 1 },
    //     { x: 140.756756756757, y: 3.33333333333333, size: 1 },
    //     { x: 200.432432432432, y: 2.98039215686275, size: 1 },
    //     { x: 201.081081081081, y: 3.25490196078431, size: 1 },
    //     { x: 205.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 211.459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 214.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 214.702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 220.540540540541, y: 3.25490196078431, size: 1 },
    //     { x: 222.486486486486, y: 3.37254901960784, size: 1 },
    //     { x: 228.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 238.702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 241.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 243.243243243243, y: 2.82352941176471, size: 1 },
    //     { x: 244.540540540541, y: 3.13725490196078, size: 1 },
    //     { x: 245.837837837838, y: 3.01960784313725, size: 1 },
    //     { x: 246.486486486486, y: 3.29411764705882, size: 1 },
    //     { x: 254.918918918919, y: 3.09803921568627, size: 1 },
    //     { x: 256.216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 260.756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 262.054054054054, y: 3.29411764705882, size: 1 },
    //     { x: 265.297297297297, y: 2.90196078431373, size: 1 },
    //     { x: 286.054054054054, y: 3.25490196078431, size: 1 },
    //     { x: 287.351351351351, y: 2.50980392156863, size: 1 },
    //     { x: 306.810810810811, y: 3.33333333333333, size: 1 },
    //     { x: 308.108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 328.216216216216, y: 3.25490196078431, size: 1 },
    //     { x: 329.513513513513, y: 3.05882352941176, size: 1 },
    //     { x: 330.162162162162, y: 2.74509803921569, size: 1 },
    //     { x: 342.486486486487, y: 3.09803921568627, size: 1 },
    //     { x: 346.378378378378, y: 3.33333333333333, size: 1 },
    //     { x: 34.9640287769784, y: 2.90196078431373, size: 1 },
    //     { x: 99.7122302158273, y: 2.66666666666667, size: 1 },
    //     { x: 164.460431654676, y: 2.70588235294118, size: 1 },
    //     { x: 209.136690647482, y: 3.09803921568627, size: 1 },
    //     { x: 229.208633093525, y: 2.35294117647059, size: 1 },
    //     { x: 271.942446043165, y: 2.11764705882353, size: 1 },
    //     { x: 272.589928057554, y: 2.35294117647059, size: 1 },
    //     { x: 315.323741007194, y: 2.7843137254902, size: 1 },
    //     { x: 315.971223021583, y: 2.66666666666667, size: 1 },
    //     { x: 358.705035971223, y: 2.62745098039216, size: 1 },
    //     { x: 85.4676258992806, y: 2.82352941176471, size: 1 },
    //     { x: 128.201438848921, y: 2.74509803921569, size: 1 },
    //     { x: 192.302158273381, y: 3.17647058823529, size: 1 },
    //     { x: 214.31654676259, y: 2.54901960784314, size: 1 },
    //     { x: 241.510791366906, y: 4.03921568627451, size: 1 },
    //     { x: 253.165467625899, y: 4.07843137254902, size: 1 },
    //     { x: 254.460431654676, y: 4.19607843137255, size: 1 },
    //     { x: 5.83783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 70.054054054054, y: 2.90196078431373, size: 1 },
    //     { x: 77.1891891891892, y: 3.88235294117647, size: 1 },
    //     { x: 156.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 164.756756756757, y: 3.84313725490196, size: 1 },
    //     { x: 178.378378378378, y: 2.94117647058824, size: 1 },
    //     { x: 179.675675675676, y: 2.66666666666667, size: 1 },
    //     { x: 180.324324324324, y: 2.74509803921569, size: 1 },
    //     { x: 200.432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 227.675675675676, y: 4, size: 1 },
    //     { x: 243.891891891892, y: 2.7843137254902, size: 1 },
    //     { x: 308.756756756757, y: 3.09803921568627, size: 1 },
    //     { x: 77.6978417266187, y: 2.62745098039216, size: 1 },
    //     { x: 78.3453237410072, y: 2.98039215686275, size: 1 },
    //     { x: 99.0647482014388, y: 2.3921568627451, size: 1 },
    //     { x: 99.7122302158273, y: 1.68627450980392, size: 1 },
    //     { x: 100.359712230216, y: 1.76470588235294, size: 1 },
    //     { x: 101.007194244604, y: 1.72549019607843, size: 1 },
    //     { x: 114.604316546763, y: 2.90196078431373, size: 1 },
    //     { x: 143.093525179856, y: 2.86274509803922, size: 1 },
    //     { x: 185.179856115108, y: 2.98039215686275, size: 1 },
    //     { x: 185.827338129496, y: 2.15686274509804, size: 1 },
    //     { x: 207.841726618705, y: 2.70588235294118, size: 1 },
    //     { x: 228.561151079137, y: 2.50980392156863, size: 1 },
    //     { x: 229.208633093525, y: 2.54901960784314, size: 1 },
    //     { x: 231.798561151079, y: 3.13725490196078, size: 1 },
    //     { x: 272.589928057554, y: 2.70588235294118, size: 1 },
    //     { x: 292.014388489209, y: 3.05882352941176, size: 1 },
    //     { x: 293.956834532374, y: 1.64705882352941, size: 1 },
    //     { x: 315.323741007194, y: 2.58823529411765, size: 1 },
    //     { x: 336.690647482014, y: 2.31372549019608, size: 1 },
    //     { x: 337.338129496403, y: 2.82352941176471, size: 1 },
    //     { x: 149.568345323741, y: 2.90196078431373, size: 1 },
    //     { x: 170.935251798561, y: 2.94117647058824, size: 1 },
    //     { x: 343.812949640288, y: 2.74509803921569, size: 1 },
    //     { x: 26.5945945945946, y: 3.09803921568627, size: 1 },
    //     { x: 71.3513513513514, y: 3.25490196078431, size: 1 },
    //     { x: 72, y: 3.13725490196078, size: 1 },
    //     { x: 107.675675675676, y: 4, size: 1 },
    //     { x: 138.162162162162, y: 3.09803921568627, size: 1 },
    //     { x: 156.324324324324, y: 2.86274509803922, size: 1 },
    //     { x: 156.972972972973, y: 2.7843137254902, size: 1 },
    //     { x: 158.27027027027, y: 3.33333333333333, size: 1 },
    //     { x: 172.540540540541, y: 4, size: 1 },
    //     { x: 202.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 206.27027027027, y: 3.29411764705882, size: 1 },
    //     { x: 208.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 213.405405405405, y: 3.25490196078431, size: 1 },
    //     { x: 217.297297297297, y: 3.29411764705882, size: 1 },
    //     { x: 223.135135135135, y: 3.13725490196078, size: 1 },
    //     { x: 223.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 239.351351351351, y: 3.09803921568627, size: 1 },
    //     { x: 240.648648648649, y: 3.09803921568627, size: 1 },
    //     { x: 243.891891891892, y: 2.90196078431373, size: 1 },
    //     { x: 245.189189189189, y: 3.13725490196078, size: 1 },
    //     { x: 246.486486486486, y: 3.01960784313725, size: 1 },
    //     { x: 247.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 249.081081081081, y: 3.13725490196078, size: 1 },
    //     { x: 250.378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 251.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 253.621621621622, y: 2.98039215686275, size: 1 },
    //     { x: 256.864864864865, y: 2.94117647058824, size: 1 },
    //     { x: 257.513513513513, y: 3.01960784313725, size: 1 },
    //     { x: 260.756756756757, y: 2.90196078431373, size: 1 },
    //     { x: 261.405405405405, y: 3.13725490196078, size: 1 },
    //     { x: 262.702702702703, y: 3.13725490196078, size: 1 },
    //     { x: 264.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 272.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 322.378378378378, y: 3.29411764705882, size: 1 },
    //     { x: 34.9640287769784, y: 3.17647058823529, size: 1 },
    //     { x: 48.5611510791367, y: 3.09803921568627, size: 1 },
    //     { x: 99.7122302158273, y: 2.94117647058824, size: 1 },
    //     { x: 196.834532374101, y: 3.09803921568627, size: 1 },
    //     { x: 274.532374100719, y: 3.09803921568627, size: 1 },
    //     { x: 284.892086330935, y: 3.05882352941176, size: 1 },
    //     { x: 16.8345323741007, y: 3.09803921568627, size: 1 },
    //     { x: 64.7482014388489, y: 3.01960784313725, size: 1 },
    //     { x: 84.1726618705036, y: 2.7843137254902, size: 1 },
    //     { x: 106.187050359712, y: 2.7843137254902, size: 1 },
    //     { x: 214.31654676259, y: 3.09803921568627, size: 1 },
    //     { x: 259.640287769784, y: 3.13725490196078, size: 1 },
    //     { x: 7.13513513513514, y: 3.05882352941176, size: 1 },
    //     { x: 7.78378378378378, y: 3.13725490196078, size: 1 },
    //     { x: 8.43243243243243, y: 3.05882352941176, size: 1 },
    //     { x: 11.027027027027, y: 3.05882352941176, size: 1 },
    //     { x: 13.6216216216216, y: 2.94117647058824, size: 1 },
    //     { x: 15.5675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 16.8648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 22.7027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 26.5945945945946, y: 2.23529411764706, size: 1 },
    //     { x: 27.2432432432432, y: 2.15686274509804, size: 1 },
    //     { x: 28.5405405405405, y: 3.09803921568627, size: 1 },
    //     { x: 29.1891891891892, y: 3.01960784313725, size: 1 },
    //     { x: 33.0810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 33.7297297297297, y: 3.13725490196078, size: 1 },
    //     { x: 38.2702702702703, y: 2.98039215686275, size: 1 },
    //     { x: 40.8648648648649, y: 3.05882352941176, size: 1 },
    //     { x: 42.8108108108108, y: 3.13725490196078, size: 1 },
    //     { x: 44.1081081081081, y: 3.17647058823529, size: 1 },
    //     { x: 44.7567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 46.0540540540541, y: 2.94117647058824, size: 1 },
    //     { x: 46.7027027027027, y: 3.13725490196078, size: 1 },
    //     { x: 48, y: 2.27450980392157, size: 1 },
    //     { x: 48.6486486486486, y: 1.80392156862745, size: 1 },
    //     { x: 68.1081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 70.054054054054, y: 2.50980392156863, size: 1 },
    //     { x: 71.3513513513514, y: 3.29411764705882, size: 1 },
    //     { x: 91.4594594594595, y: 3.01960784313725, size: 1 },
    //     { x: 94.054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 95.3513513513514, y: 3.13725490196078, size: 1 },
    //     { x: 99.2432432432432, y: 3.09803921568627, size: 1 },
    //     { x: 99.8918918918919, y: 2.94117647058824, size: 1 },
    //     { x: 103.783783783784, y: 3.09803921568627, size: 1 },
    //     { x: 108.324324324324, y: 2.94117647058824, size: 1 },
    //     { x: 134.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 138.162162162162, y: 4, size: 1 },
    //     { x: 156.324324324324, y: 1.49019607843137, size: 1 },
    //     { x: 156.972972972973, y: 1.25490196078431, size: 1 },
    //     { x: 158.27027027027, y: 3.17647058823529, size: 1 },
    //     { x: 159.567567567568, y: 3.05882352941176, size: 1 },
    //     { x: 160.216216216216, y: 2.98039215686275, size: 1 },
    //     { x: 164.108108108108, y: 3.09803921568627, size: 1 },
    //     { x: 169.945945945946, y: 2.82352941176471, size: 1 },
    //     { x: 173.837837837838, y: 3.05882352941176, size: 1 },
    //     { x: 175.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 176.432432432432, y: 3.05882352941176, size: 1 },
    //     { x: 177.72972972973, y: 1.92156862745098, size: 1 },
    //     { x: 178.378378378378, y: 1.84313725490196, size: 1 },
    //     { x: 193.945945945946, y: 4.11764705882353, size: 1 },
    //     { x: 202.378378378378, y: 3.01960784313725, size: 1 },
    //     { x: 210.810810810811, y: 3.13725490196078, size: 1 },
    //     { x: 211.459459459459, y: 3.17647058823529, size: 1 },
    //     { x: 216, y: 3.2156862745098, size: 1 },
    //     { x: 217.945945945946, y: 3.05882352941176, size: 1 },
    //     { x: 263.351351351351, y: 2.98039215686275, size: 1 },
    //     { x: 264.648648648649, y: 2.43137254901961, size: 1 },
    //     { x: 265.297297297297, y: 3.17647058823529, size: 1 },
    //     { x: 265.945945945946, y: 3.33333333333333, size: 1 },
    //     { x: 351.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 354.810810810811, y: 3.37254901960784, size: 1 },
    //     { x: 35.6115107913669, y: 4.11764705882353, size: 1 },
    //     { x: 77.0503597122302, y: 2.98039215686275, size: 1 },
    //     { x: 101.007194244604, y: 2.98039215686275, size: 1 },
    //     { x: 105.539568345324, y: 3.01960784313725, size: 1 },
    //     { x: 111.36690647482, y: 2.98039215686275, size: 1 },
    //     { x: 117.841726618705, y: 2.98039215686275, size: 1 },
    //     { x: 120.431654676259, y: 3.09803921568627, size: 1 },
    //     { x: 123.021582733813, y: 3.09803921568627, size: 1 },
    //     { x: 137.26618705036, y: 3.05882352941176, size: 1 },
    //     { x: 142.446043165468, y: 2.50980392156863, size: 1 },
    //     { x: 158.63309352518, y: 4.15686274509804, size: 1 },
    //     { x: 182.589928057554, y: 3.13725490196078, size: 1 },
    //     { x: 185.827338129496, y: 2.90196078431373, size: 1 },
    //     { x: 229.856115107914, y: 2.90196078431373, size: 1 },
    //     { x: 271.294964028777, y: 3.2156862745098, size: 1 },
    //     { x: 295.89928057554, y: 3.05882352941176, size: 1 },
    //     { x: 296.546762589928, y: 2.86274509803922, size: 1 },
    //     { x: 299.136690647482, y: 2.86274509803922, size: 1 },
    //     { x: 299.784172661871, y: 2.98039215686275, size: 1 },
    //     { x: 304.31654676259, y: 3.01960784313725, size: 1 },
    //     { x: 310.143884892086, y: 2.82352941176471, size: 1 },
    //     { x: 0.648648648648649, y: 3.13725490196078, size: 1 },
    //     { x: 3.24324324324324, y: 3.17647058823529, size: 1 },
    //     { x: 4.54054054054054, y: 3.17647058823529, size: 1 },
    //     { x: 6.48648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 9.08108108108108, y: 3.01960784313725, size: 1 },
    //     { x: 12.972972972973, y: 3.13725490196078, size: 1 },
    //     { x: 19.4594594594595, y: 2.86274509803922, size: 1 },
    //     { x: 20.1081081081081, y: 2.66666666666667, size: 1 },
    //     { x: 20.7567567567568, y: 2.82352941176471, size: 1 },
    //     { x: 21.4054054054054, y: 3.05882352941176, size: 1 },
    //     { x: 40.8648648648649, y: 2.94117647058824, size: 1 },
    //     { x: 41.5135135135135, y: 2.98039215686275, size: 1 },
    //     { x: 43.4594594594595, y: 2.98039215686275, size: 1 },
    //     { x: 44.7567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 52.5405405405405, y: 3.05882352941176, size: 1 },
    //     { x: 53.8378378378378, y: 3.05882352941176, size: 1 },
    //     { x: 55.1351351351351, y: 3.09803921568627, size: 1 },
    //     { x: 58.3783783783784, y: 2.98039215686275, size: 1 },
    //     { x: 61.6216216216216, y: 3.17647058823529, size: 1 },
    //     { x: 80.4324324324324, y: 4, size: 1 },
    //     { x: 105.081081081081, y: 3.2156862745098, size: 1 },
    //     { x: 105.72972972973, y: 2.74509803921569, size: 1 },
    //     { x: 106.378378378378, y: 2.62745098039216, size: 1 },
    //     { x: 107.027027027027, y: 2.90196078431373, size: 1 },
    //     { x: 113.513513513514, y: 3.17647058823529, size: 1 },
    //     { x: 118.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 118.702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 120.648648648649, y: 3.17647058823529, size: 1 },
    //     { x: 125.837837837838, y: 3.2156862745098, size: 1 },
    //     { x: 127.783783783784, y: 2.35294117647059, size: 1 },
    //     { x: 128.432432432432, y: 2.58823529411765, size: 1 },
    //     { x: 129.081081081081, y: 2.90196078431373, size: 1 },
    //     { x: 129.72972972973, y: 2.74509803921569, size: 1 },
    //     { x: 153.081081081081, y: 3.01960784313725, size: 1 },
    //     { x: 155.027027027027, y: 2.94117647058824, size: 1 },
    //     { x: 155.675675675676, y: 2.98039215686275, size: 1 },
    //     { x: 156.324324324324, y: 3.09803921568627, size: 1 },
    //     { x: 160.864864864865, y: 3.05882352941176, size: 1 },
    //     { x: 162.162162162162, y: 2.98039215686275, size: 1 },
    //     { x: 163.459459459459, y: 3.05882352941176, size: 1 },
    //     { x: 166.054054054054, y: 2.86274509803922, size: 1 },
    //     { x: 168, y: 2.94117647058824, size: 1 },
    //     { x: 196.540540540541, y: 3.37254901960784, size: 1 },
    //     { x: 214.054054054054, y: 3.09803921568627, size: 1 },
    //     { x: 278.918918918919, y: 3.05882352941176, size: 1 },
    //     { x: 279.567567567568, y: 2.98039215686275, size: 1 },
    //     { x: 300.972972972973, y: 3.09803921568627, size: 1 },
    //     { x: 322.378378378378, y: 2.3921568627451, size: 1 },
    //     { x: 323.027027027027, y: 2.58823529411765, size: 1 },
    //     { x: 323.675675675676, y: 2.54901960784314, size: 1 },
    //     { x: 324.324324324324, y: 2.35294117647059, size: 1 },
    //     { x: 343.783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 345.72972972973, y: 3.92156862745098, size: 1 },
    //     { x: 93.8848920863309, y: 2.98039215686275, size: 1 },
    //     { x: 102.94964028777, y: 2.98039215686275, size: 1 },
    //     { x: 113.309352517986, y: 2.82352941176471, size: 1 },
    //     { x: 113.956834532374, y: 2.7843137254902, size: 1 },
    //     { x: 221.438848920863, y: 2.70588235294118, size: 1 },
    //     { x: 243.453237410072, y: 2.90196078431373, size: 1 },
    //     { x: 308.201438848921, y: 2.90196078431373, size: 1 },
    //     { x: 12.3021582733813, y: 2.94117647058824, size: 1 },
    //     { x: 141.798561151079, y: 2.98039215686275, size: 1 },
    //     { x: 163.165467625899, y: 2.3921568627451, size: 1 },
    //     { x: 163.812949640288, y: 2.43137254901961, size: 1 },
    //     { x: 271.294964028777, y: 3.01960784313725, size: 1 },
    //     { x: 312.73381294964, y: 3.05882352941176, size: 1 },
    //     { x: 314.028776978417, y: 2.7843137254902, size: 1 },
    //     { x: 314.676258992806, y: 0.862745098039216, size: 1 },
    //     { x: 315.323741007194, y: 0.901960784313726, size: 1 },
    //     { x: 315.971223021583, y: 0.862745098039216, size: 1 },
    //     { x: 316.618705035971, y: 0.627450980392157, size: 1 },
    //     { x: 324.388489208633, y: 2.94117647058824, size: 1 },
    //     { x: 330.215827338129, y: 2.82352941176471, size: 1 },
    //     { x: 332.805755395683, y: 3.01960784313725, size: 1 },
    //     { x: 336.043165467626, y: 1.92156862745098, size: 1 },
    //     { x: 336.690647482014, y: 1.72549019607843, size: 1 },
    //     { x: 341.870503597122, y: 3.09803921568627, size: 1 },
    //     { x: 348.992805755396, y: 2.94117647058824, size: 1 },
    //     { x: 357.410071942446, y: 2.90196078431373, size: 1 },
    //     { x: 358.057553956835, y: 2.43137254901961, size: 1 },
    //     { x: 16.2162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 19.4594594594595, y: 2.62745098039216, size: 1 },
    //     { x: 40.8648648648649, y: 2.15686274509804, size: 1 },
    //     { x: 41.5135135135135, y: 2.23529411764706, size: 1 },
    //     { x: 62.2702702702703, y: 2.74509803921569, size: 1 },
    //     { x: 62.9189189189189, y: 2.35294117647059, size: 1 },
    //     { x: 64.8648648648649, y: 3.2156862745098, size: 1 },
    //     { x: 65.5135135135135, y: 2.86274509803922, size: 1 },
    //     { x: 81.7297297297297, y: 3.2156862745098, size: 1 },
    //     { x: 83.6756756756757, y: 3.2156862745098, size: 1 },
    //     { x: 84.3243243243243, y: 2, size: 1 },
    //     { x: 84.972972972973, y: 2.82352941176471, size: 1 },
    //     { x: 127.135135135135, y: 3.01960784313725, size: 1 },
    //     { x: 127.783783783784, y: 2.74509803921569, size: 1 },
    //     { x: 133.621621621622, y: 3.25490196078431, size: 1 },
    //     { x: 134.27027027027, y: 3.2156862745098, size: 1 },
    //     { x: 134.918918918919, y: 3.17647058823529, size: 1 },
    //     { x: 147.243243243243, y: 3.17647058823529, size: 1 },
    //     { x: 155.027027027027, y: 2.98039215686275, size: 1 },
    //     { x: 157.621621621622, y: 3.2156862745098, size: 1 },
    //     { x: 159.567567567568, y: 3.09803921568627, size: 1 },
    //     { x: 166.054054054054, y: 3.13725490196078, size: 1 },
    //     { x: 166.702702702703, y: 3.05882352941176, size: 1 },
    //     { x: 167.351351351351, y: 3.25490196078431, size: 1 },
    //     { x: 170.594594594595, y: 1.68627450980392, size: 1 },
    //     { x: 171.243243243243, y: 1.84313725490196, size: 1 },
    //     { x: 192, y: 2.50980392156863, size: 1 },
    //     { x: 192.648648648649, y: 2.62745098039216, size: 1 },
    //     { x: 222.486486486486, y: 3.2156862745098, size: 1 },
    //     { x: 230.918918918919, y: 3.13725490196078, size: 1 },
    //     { x: 231.567567567568, y: 3.13725490196078, size: 1 },
    //     { x: 232.864864864865, y: 2.98039215686275, size: 1 },
    //     { x: 260.108108108108, y: 3.37254901960784, size: 1 },
    //     { x: 322.378378378378, y: 3.25490196078431, size: 1 },
    //     { x: 343.783783783784, y: 2.94117647058824, size: 1 },
    //     { x: 119.136690647482, y: 3.09803921568627, size: 1 },
    //     { x: 205.89928057554, y: 3.01960784313725, size: 1 },
    //     { x: 206.546762589928, y: 2.98039215686275, size: 1 },
    //     { x: 210.431654676259, y: 2.98039215686275, size: 1 },
    //     { x: 214.964028776978, y: 3.05882352941176, size: 1 },
    //     { x: 216.258992805755, y: 3.05882352941176, size: 1 },
    //     { x: 218.201438848921, y: 3.09803921568627, size: 1 },
    //     { x: 330.863309352518, y: 2.90196078431373, size: 1 },
    //     { x: 352.230215827338, y: 2.7843137254902, size: 1 },
    //     { x: 34.9640287769784, y: 3.09803921568627, size: 1 },
    //     { x: 55.0359712230216, y: 2.82352941176471, size: 1 },
    //     { x: 56.3309352517986, y: 2.86274509803922, size: 1 },
    //     { x: 77.0503597122302, y: 2.94117647058824, size: 1 },
    //     { x: 121.079136690647, y: 2.86274509803922, size: 1 },
    //     { x: 121.726618705036, y: 2.94117647058824, size: 1 },
    //     { x: 143.093525179856, y: 2.82352941176471, size: 1 },
    //     { x: 184.532374100719, y: 2.82352941176471, size: 1 },
    //     { x: 185.179856115108, y: 2.94117647058824, size: 1 },
    //     { x: 186.474820143885, y: 3.01960784313725, size: 1 },
    //     { x: 187.122302158273, y: 3.09803921568627, size: 1 },
    //     { x: 228.561151079137, y: 2.82352941176471, size: 1 },
    //     { x: 229.208633093525, y: 2.70588235294118, size: 1 },
    //     { x: 229.856115107914, y: 2.50980392156863, size: 1 },
    //     { x: 249.928057553957, y: 2.50980392156863, size: 1 },
    //     { x: 250.575539568345, y: 2.50980392156863, size: 1 },
    //     { x: 251.223021582734, y: 2.66666666666667, size: 1 },
    //     { x: 263.525179856115, y: 3.25490196078431, size: 1 },
    //     { x: 357.410071942446, y: 2.70588235294118, size: 1 },
    //     { x: 0, y: 2.50980392156863, size: 1 },
    //     { x: 0.648648648648649, y: 2.90196078431373, size: 1 },
    //     { x: 1.2972972972973, y: 2.94117647058824, size: 1 },
    //     { x: 3.89189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 4.54054054054054, y: 2.94117647058824, size: 1 },
    //     { x: 8.43243243243243, y: 2.86274509803922, size: 1 },
    //     { x: 9.08108108108108, y: 2.94117647058824, size: 1 },
    //     { x: 9.72972972972973, y: 2.86274509803922, size: 1 },
    //     { x: 10.3783783783784, y: 2.86274509803922, size: 1 },
    //     { x: 11.6756756756757, y: 3.05882352941176, size: 1 },
    //     { x: 16.2162162162162, y: 2.94117647058824, size: 1 },
    //     { x: 20.1081081081081, y: 2.74509803921569, size: 1 },
    //     { x: 20.7567567567568, y: 3.01960784313725, size: 1 },
    //     { x: 40.8648648648649, y: 2.74509803921569, size: 1 },
    //     { x: 41.5135135135135, y: 2.43137254901961, size: 1 },
    //     { x: 42.8108108108108, y: 2.54901960784314, size: 1 },
    //     { x: 62.9189189189189, y: 3.05882352941176, size: 1 },
    //     { x: 105.081081081081, y: 3.33333333333333, size: 1 },
    //     { x: 171.243243243243, y: 2.86274509803922, size: 1 },
    //     { x: 172.540540540541, y: 2.82352941176471, size: 1 },
    //     { x: 194.594594594595, y: 3.09803921568627, size: 1 },
    //     { x: 195.891891891892, y: 3.09803921568627, size: 1 },
    //     { x: 196.540540540541, y: 3.17647058823529, size: 1 },
    //     { x: 202.378378378378, y: 3.09803921568627, size: 1 },
    //     { x: 204.324324324324, y: 3.01960784313725, size: 1 },
    //     { x: 206.27027027027, y: 2.86274509803922, size: 1 },
    //     { x: 209.513513513514, y: 3.01960784313725, size: 1 },
    //     { x: 256.864864864865, y: 2.66666666666667, size: 1 },
    //     { x: 280.216216216216, y: 3.37254901960784, size: 1 },
    //     { x: 290.594594594595, y: 3.29411764705882, size: 1 },
    //     { x: 322.378378378378, y: 2.90196078431373, size: 1 },
    //     { x: 342.486486486487, y: 3.2156862745098, size: 1 },
    //     { x: 343.135135135135, y: 2.94117647058824, size: 1 },
    //     { x: 134.676258992806, y: 2.94117647058824, size: 1 },
    //     { x: 224.676258992806, y: 3.01960784313725, size: 1 },
    //     { x: 228.561151079137, y: 2.94117647058824, size: 1 },
    //     { x: 231.798561151079, y: 2.82352941176471, size: 1 },
    //     { x: 233.741007194245, y: 2.98039215686275, size: 1 },
    //     { x: 235.035971223022, y: 2.86274509803922, size: 1 },
    //     { x: 236.330935251799, y: 3.13725490196078, size: 1 },
    //     { x: 238.920863309353, y: 2.82352941176471, size: 1 },
    //     { x: 239.568345323741, y: 2.98039215686275, size: 1 },
    //     { x: 240.863309352518, y: 3.09803921568627, size: 1 },
    //     { x: 242.158273381295, y: 1.76470588235294, size: 1 },
    //     { x: 242.805755395683, y: 1.41176470588235, size: 1 },
    //     { x: 264.172661870504, y: 2.15686274509804, size: 1 },
    //     { x: 286.187050359712, y: 2.90196078431373, size: 1 },
    //     { x: 328.273381294964, y: 2.66666666666667, size: 1 },
    //     { x: 328.920863309353, y: 1.6078431372549, size: 1 },
    //     { x: 330.215827338129, y: 3.09803921568627, size: 1 },
    //     { x: 332.158273381295, y: 3.09803921568627, size: 1 },
    //     { x: 334.748201438849, y: 2.86274509803922, size: 1 },
    //     { x: 339.928057553957, y: 2.94117647058824, size: 1 },
    //     { x: 340.575539568345, y: 2.98039215686275, size: 1 },
    //     { x: 341.223021582734, y: 2.94117647058824, size: 1 },
    //     { x: 347.05035971223, y: 2.90196078431373, size: 1 },
    //     { x: 347.697841726619, y: 3.13725490196078, size: 1 },
    //     { x: 350.935251798561, y: 2.74509803921569, size: 1 },
    //     { x: 49.8561151079137, y: 4.07843137254902, size: 1 },
    //     { x: 62.158273381295, y: 3.09803921568627, size: 1 },
    //     { x: 65.3956834532374, y: 3.13725490196078, size: 1 },
    //     { x: 69.2805755395683, y: 2.94117647058824, size: 1 },
    //     { x: 98.4172661870504, y: 1.88235294117647, size: 1 },
    //     { x: 99.0647482014388, y: 2.7843137254902, size: 1 },
    //     { x: 104.244604316547, y: 2.74509803921569, size: 1 },
    //     { x: 108.776978417266, y: 2.94117647058824, size: 1 },
    //     { x: 110.071942446043, y: 3.05882352941176, size: 1 },
    //     { x: 110.719424460432, y: 3.01960784313725, size: 1 },
    //     { x: 115.89928057554, y: 2.86274509803922, size: 1 },
    //     { x: 120.431654676259, y: 2.54901960784314, size: 1 },
    //     { x: 161.870503597122, y: 3.05882352941176, size: 1 },
    //     { x: 163.812949640288, y: 2.70588235294118, size: 1 },
    //     { x: 165.107913669065, y: 3.13725490196078, size: 1 },
    //     { x: 174.820143884892, y: 2.94117647058824, size: 1 },
    //     { x: 175.467625899281, y: 2.7843137254902, size: 1 },
    //     { x: 180.647482014388, y: 2.82352941176471, size: 1 },
    //     { x: 181.942446043165, y: 2.98039215686275, size: 1 },
    //     { x: 249.928057553957, y: 2.70588235294118, size: 1 },
    //     { x: 250.575539568345, y: 2.70588235294118, size: 1 },
    //     { x: 251.870503597122, y: 2.94117647058824, size: 1 },
    //     { x: 256.402877697842, y: 2.90196078431373, size: 1 },
    //     { x: 257.05035971223, y: 2.94117647058824, size: 1 },
    //     { x: 260.935251798561, y: 2.86274509803922, size: 1 },
    //     { x: 267.410071942446, y: 2.98039215686275, size: 1 },
    //     { x: 272.589928057554, y: 2.82352941176471, size: 1 },
    //     { x: 292.661870503597, y: 2.23529411764706, size: 1 },
    //     { x: 295.89928057554, y: 2.98039215686275, size: 1 },
    //     { x: 298.489208633094, y: 3.09803921568627, size: 1 },
    //     { x: 299.784172661871, y: 2.82352941176471, size: 1 },
    //     { x: 304.964028776978, y: 3.01960784313725, size: 1 },
    //     { x: 338.63309352518, y: 2.98039215686275, size: 1 },
    //     { x: 339.280575539568, y: 2.82352941176471, size: 1 },
    //     { x: 346.402877697842, y: 3.05882352941176, size: 1 },
    //     { x: 347.697841726619, y: 2.94117647058824, size: 1 },
    //     { x: 353.525179856115, y: 2.94117647058824, size: 1 },
    //     { x: 354.172661870504, y: 2.82352941176471, size: 1 },
    //     { x: 18.8108108108108, y: 2.82352941176471, size: 1 },
    //     { x: 19.4594594594595, y: 2.74509803921569, size: 1 },
    //     { x: 40.8648648648649, y: 3.01960784313725, size: 1 },
    //     { x: 127.135135135135, y: 2.66666666666667, size: 1 },
    //     { x: 127.783783783784, y: 2.58823529411765, size: 1 },
    //     { x: 128.432432432432, y: 2.47058823529412, size: 1 },
    //     { x: 129.081081081081, y: 2.54901960784314, size: 1 },
    //     { x: 148.540540540541, y: 3.01960784313725, size: 1 },
    //     { x: 162.810810810811, y: 4, size: 1 },
    //     { x: 170.594594594595, y: 3.13725490196078, size: 1 },
    //     { x: 256.864864864865, y: 2.58823529411765, size: 1 },
    //     { x: 257.513513513513, y: 2.90196078431373, size: 1 },
    //     { x: 258.810810810811, y: 2.70588235294118, size: 1 },
    //     { x: 269.837837837838, y: 3.33333333333333, size: 1 },
    //     { x: 278.27027027027, y: 3.01960784313725, size: 1 },
    //     { x: 280.864864864865, y: 3.13725490196078, size: 1 },
    //     { x: 282.162162162162, y: 3.25490196078431, size: 1 },
    //     { x: 282.810810810811, y: 3.09803921568627, size: 1 },
    //     { x: 283.459459459459, y: 3.25490196078431, size: 1 },
    //     { x: 285.405405405405, y: 2.86274509803922, size: 1 },
    //     { x: 289.945945945946, y: 2.90196078431373, size: 1 },
    //     { x: 291.891891891892, y: 2.7843137254902, size: 1 },
    //     { x: 292.540540540541, y: 2.98039215686275, size: 1 },
    //     { x: 321.72972972973, y: 2.90196078431373, size: 1 },
    //     { x: 323.027027027027, y: 2.70588235294118, size: 1 },
    //     { x: 341.189189189189, y: 3.29411764705882, size: 1 },
    //     { x: 344.432432432432, y: 4, size: 1 },
    //     { x: 98.4172661870504, y: 3.05882352941176, size: 1 },
    //     { x: 99.0647482014388, y: 3.09803921568627, size: 1 },
    //     { x: 102.94964028777, y: 2.86274509803922, size: 1 },
    //     { x: 108.129496402878, y: 2.82352941176471, size: 1 },
    //     { x: 328.273381294964, y: 2.74509803921569, size: 1 },
    //     { x: 330.215827338129, y: 2.94117647058824, size: 1 },
    //     { x: 351.58273381295, y: 2.90196078431373, size: 1 },
    //     { x: 33.0215827338129, y: 2.98039215686275, size: 1 },
    //     { x: 34.9640287769784, y: 2.86274509803922, size: 1 },
    //     { x: 76.4028776978417, y: 2.47058823529412, size: 1 },
    //     { x: 77.0503597122302, y: 2.66666666666667, size: 1 },
    //     { x: 98.4172661870504, y: 2.90196078431373, size: 1 },
    //     { x: 99.0647482014388, y: 2.98039215686275, size: 1 },
    //     { x: 162.517985611511, y: 2.7843137254902, size: 1 },
    //     { x: 205.89928057554, y: 3.17647058823529, size: 1 },
    //     { x: 229.208633093525, y: 2.90196078431373, size: 1 },
    //     { x: 292.014388489209, y: 3.09803921568627, size: 1 },
    //     { x: 7.13513513513514, y: 4.03921568627451, size: 1 },
    //     { x: 40.2162162162162, y: 2.74509803921569, size: 1 },
    //     { x: 61.6216216216216, y: 3.2156862745098, size: 1 },
    //     { x: 127.783783783784, y: 3.13725490196078, size: 1 },
    //     { x: 169.297297297297, y: 2.94117647058824, size: 1 },
    //     { x: 169.945945945946, y: 1.01960784313725, size: 1 },
    //     { x: 170.594594594595, y: 1.13725490196078, size: 1 },
    //     { x: 171.243243243243, y: 1.29411764705882, size: 1 },
    //     { x: 171.891891891892, y: 1.2156862745098, size: 1 },
    //     { x: 179.027027027027, y: 2.82352941176471, size: 1 },
    //     { x: 179.675675675676, y: 2.82352941176471, size: 1 },
    //     { x: 191.351351351351, y: 2.86274509803922, size: 1 },
    //     { x: 192, y: 2.62745098039216, size: 1 },
    //     { x: 213.405405405405, y: 2.03921568627451, size: 1 },
    //     { x: 219.243243243243, y: 4.11764705882353, size: 1 },
    //     { x: 234.810810810811, y: 2.43137254901961, size: 1 },
    //     { x: 235.459459459459, y: 2.31372549019608, size: 1 },
    //     { x: 236.756756756757, y: 3.29411764705882, size: 1 },
    //     { x: 255.567567567568, y: 3.17647058823529, size: 1 },
    //     { x: 256.216216216216, y: 2.62745098039216, size: 1 },
    //     { x: 256.864864864865, y: 2.03921568627451, size: 1 },
    //     { x: 278.27027027027, y: 2.7843137254902, size: 1 },
    //     { x: 305.513513513513, y: 3.25490196078431, size: 1 },
    //     { x: 346.378378378378, y: 3.17647058823529, size: 1 },
    //     { x: 178.057553956835, y: 2.94117647058824, size: 1 },
    //     { x: 284.892086330935, y: 2.94117647058824, size: 1 },
    //     { x: 50.5035971223022, y: 4, size: 1 },
    //     { x: 55.0359712230216, y: 2.86274509803922, size: 1 },
    //     { x: 152.805755395683, y: 3.09803921568627, size: 1 },
    //     { x: 162.517985611511, y: 1.92156862745098, size: 1 },
    //     { x: 163.165467625899, y: 2, size: 1 },
    //     { x: 163.812949640288, y: 2.15686274509804, size: 1 },
    //     { x: 164.460431654676, y: 2.15686274509804, size: 1 },
    //     { x: 183.884892086331, y: 2.90196078431373, size: 1 },
    //     { x: 184.532374100719, y: 2.58823529411765, size: 1 },
    //     { x: 185.179856115108, y: 2.58823529411765, size: 1 },
    //     { x: 185.827338129496, y: 2.70588235294118, size: 1 },
    //     { x: 316.618705035971, y: 3.01960784313725, size: 1 },
    //     { x: 320.503597122302, y: 2.98039215686275, size: 1 },
    //     { x: 321.798561151079, y: 2.94117647058824, size: 1 },
    //     { x: 332.805755395683, y: 3.05882352941176, size: 1 },
    //     { x: 18.1621621621622, y: 3.09803921568627, size: 1 },
    //     { x: 18.8108108108108, y: 3.17647058823529, size: 1 },
    //     { x: 40.2162162162162, y: 2.62745098039216, size: 1 },
    //     { x: 41.5135135135135, y: 2.66666666666667, size: 1 },
    //     { x: 42.1621621621622, y: 2.70588235294118, size: 1 },
    //     { x: 46.0540540540541, y: 3.33333333333333, size: 1 },
    //     { x: 62.2702702702703, y: 3.2156862745098, size: 1 },
    //     { x: 62.9189189189189, y: 2.90196078431373, size: 1 },
    //     { x: 63.5675675675676, y: 2.94117647058824, size: 1 },
    //     { x: 83.6756756756757, y: 3.25490196078431, size: 1 },
    //     { x: 184.216216216216, y: 3.29411764705882, size: 1 },
    //     { x: 255.567567567568, y: 3.2156862745098, size: 1 },
    //     { x: 299.675675675676, y: 3.05882352941176, size: 1 },
    //     { x: 300.972972972973, y: 2.98039215686275, size: 1 }
    // ];
    
    // const data3 = [
    //     { x: 0, y: 3.64705882352941, size: 1 },
    //     { x: 0.647482014388489, y: 3.72549019607843, size: 1 },
    //     { x: 1.29496402877698, y: 3.80392156862745, size: 1 },
    //     { x: 1.94244604316547, y: 3.92156862745098, size: 1 },
    //     { x: 2.58992805755396, y: 3.64705882352941, size: 1 },
    //     { x: 3.23741007194245, y: 3.84313725490196, size: 1 },
    //     { x: 3.88489208633094, y: 3.84313725490196, size: 1 },
    //     { x: 4.53237410071942, y: 3.76470588235294, size: 1 },
    //     { x: 5.17985611510791, y: 3.76470588235294, size: 1 },
    //     { x: 5.8273381294964, y: 3.72549019607843, size: 1 },
    //     { x: 6.47482014388489, y: 3.80392156862745, size: 1 },
    //     { x: 7.12230215827338, y: 3.80392156862745, size: 1 },
    //     { x: 7.76978417266187, y: 3.68627450980392, size: 1 },
    //     { x: 8.41726618705036, y: 3.68627450980392, size: 1 },
    //     { x: 9.06474820143885, y: 3.84313725490196, size: 1 },
    //     { x: 9.71223021582734, y: 3.72549019607843, size: 1 },
    //     { x: 10.3597122302158, y: 3.6078431372549, size: 1 },
    //     { x: 11.0071942446043, y: 3.29411764705882, size: 1 },
    //     { x: 11.6546762589928, y: 3.37254901960784, size: 1 },
    //     { x: 12.3021582733813, y: 3.33333333333333, size: 1 },
    //     { x: 12.9496402877698, y: 3.01960784313725, size: 1 },
    //     { x: 13.5971223021583, y: 3.09803921568627, size: 1 },
    //     { x: 14.2446043165468, y: 3.64705882352941, size: 1 },
    // ]